
      var $parcel$global = globalThis;
    



var $a5056a6656605403$exports = {};
/*! For license information please see widget.module.js.LICENSE.txt */ (()=>{
    var e1 = {
        406: (e1, t, n)=>{
            var i = n(494), r = {
                ease: i(.25, .1, .25, 1),
                easeIn: i(.42, 0, 1, 1),
                easeOut: i(0, 0, .58, 1),
                easeInOut: i(.42, 0, .58, 1),
                linear: i(0, 0, 1, 1)
            };
            function a() {}
            function s() {
                var e1 = new Set, t = new Set, n = 0;
                return {
                    next: i,
                    cancel: i,
                    clearAll: function() {
                        e1.clear(), t.clear(), cancelAnimationFrame(n), n = 0;
                    }
                };
                function i(e1) {
                    t.add(e1), n || (n = requestAnimationFrame(r));
                }
                function r() {
                    n = 0;
                    var i = t;
                    t = e1, (e1 = i).forEach(function(e1) {
                        e1();
                    }), e1.clear();
                }
            }
            e1.exports = function(e1, t, n) {
                var i = Object.create(null), s = Object.create(null), o = "function" == typeof (n = n || {}).easing ? n.easing : r[n.easing];
                o || (n.easing && console.warn("Unknown easing function in amator: " + n.easing), o = r.ease);
                var l = "function" == typeof n.step ? n.step : a, c = "function" == typeof n.done ? n.done : a, u = function(e1) {
                    if (!e1) return "undefined" != typeof window && window.requestAnimationFrame ? {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    } : {
                        next: function(e1) {
                            return setTimeout(e1, 1e3 / 60);
                        },
                        cancel: function(e1) {
                            return clearTimeout(e1);
                        }
                    };
                    if ("function" != typeof e1.next) throw new Error("Scheduler is supposed to have next(cb) function");
                    if ("function" != typeof e1.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
                    return e1;
                }(n.scheduler), h = Object.keys(t);
                h.forEach(function(n) {
                    i[n] = e1[n], s[n] = t[n] - e1[n];
                });
                var d, p = "number" == typeof n.duration ? n.duration : 400, f = Math.max(1, .06 * p), g = 0;
                return d = u.next(function t() {
                    var n = o(g / f);
                    g += 1, function(t) {
                        h.forEach(function(n) {
                            e1[n] = s[n] * t + i[n];
                        });
                    }(n), g <= f ? (d = u.next(t), l(e1)) : (d = 0, setTimeout(function() {
                        c(e1);
                    }, 0));
                }), {
                    cancel: function() {
                        u.cancel(d), d = 0;
                    }
                };
            }, e1.exports.makeAggregateRaf = s, e1.exports.sharedScheduler = s();
        },
        494: (e1)=>{
            var t = .1, n = "function" == typeof Float32Array;
            function i(e1, t) {
                return 1 - 3 * t + 3 * e1;
            }
            function r(e1, t) {
                return 3 * t - 6 * e1;
            }
            function a(e1) {
                return 3 * e1;
            }
            function s(e1, t, n) {
                return ((i(t, n) * e1 + r(t, n)) * e1 + a(t)) * e1;
            }
            function o(e1, t, n) {
                return 3 * i(t, n) * e1 * e1 + 2 * r(t, n) * e1 + a(t);
            }
            function l(e1) {
                return e1;
            }
            e1.exports = function(e1, i, r, a) {
                if (!(0 <= e1 && e1 <= 1 && 0 <= r && r <= 1)) throw new Error("bezier x values must be in [0, 1] range");
                if (e1 === i && r === a) return l;
                for(var c = n ? new Float32Array(11) : new Array(11), u = 0; u < 11; ++u)c[u] = s(u * t, e1, r);
                return function(n) {
                    return 0 === n ? 0 : 1 === n ? 1 : s(function(n) {
                        for(var i = 0, a = 1; 10 !== a && c[a] <= n; ++a)i += t;
                        --a;
                        var l = i + (n - c[a]) / (c[a + 1] - c[a]) * t, u = o(l, e1, r);
                        return u >= .001 ? function(e1, t, n, i) {
                            for(var r = 0; r < 4; ++r){
                                var a = o(t, n, i);
                                if (0 === a) return t;
                                t -= (s(t, n, i) - e1) / a;
                            }
                            return t;
                        }(n, l, e1, r) : 0 === u ? l : function(e1, t, n, i, r) {
                            var a, o, l = 0;
                            do (a = s(o = t + (n - t) / 2, i, r) - e1) > 0 ? n = o : t = o;
                            while (Math.abs(a) > 1e-7 && ++l < 10);
                            return o;
                        }(n, i, i + t, e1, r);
                    }(n), i, a);
                };
            };
        },
        89: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = [];
                return t.toString = function() {
                    return this.map(function(t) {
                        var n = "", i = void 0 !== t[5];
                        return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), i && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e1(t), i && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
                    }).join("");
                }, t.i = function(e1, n, i, r, a) {
                    "string" == typeof e1 && (e1 = [
                        [
                            null,
                            e1,
                            void 0
                        ]
                    ]);
                    var s = {};
                    if (i) for(var o = 0; o < this.length; o++){
                        var l = this[o][0];
                        null != l && (s[l] = !0);
                    }
                    for(var c = 0; c < e1.length; c++){
                        var u = [].concat(e1[c]);
                        i && s[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), n && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = n) : u[2] = n), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), t.push(u));
                    }
                }, t;
            };
        },
        492: (e1)=>{
            "use strict";
            e1.exports = function(e1, t) {
                return t || (t = {}), e1 ? (e1 = String(e1.__esModule ? e1.default : e1), /^['"].*['"]$/.test(e1) && (e1 = e1.slice(1, -1)), t.hash && (e1 += t.hash), /["'() \t\n]|(%20)/.test(e1) || t.needQuotes ? '"'.concat(e1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e1) : e1;
            };
        },
        248: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                return e1[1];
            };
        },
        657: (e1)=>{
            e1.exports = function(e1) {
                !function(e1) {
                    if (!e1) throw new Error("Eventify cannot use falsy object as events subject");
                    for(var t = [
                        "on",
                        "fire",
                        "off"
                    ], n = 0; n < t.length; ++n)if (e1.hasOwnProperty(t[n])) throw new Error("Subject cannot be eventified, since it already has property '" + t[n] + "'");
                }(e1);
                var t = function(e1) {
                    var t = Object.create(null);
                    return {
                        on: function(n, i, r) {
                            if ("function" != typeof i) throw new Error("callback is expected to be a function");
                            var a = t[n];
                            return a || (a = t[n] = []), a.push({
                                callback: i,
                                ctx: r
                            }), e1;
                        },
                        off: function(n, i) {
                            if (void 0 === n) return t = Object.create(null), e1;
                            if (t[n]) {
                                if ("function" != typeof i) delete t[n];
                                else for(var r = t[n], a = 0; a < r.length; ++a)r[a].callback === i && r.splice(a, 1);
                            }
                            return e1;
                        },
                        fire: function(n) {
                            var i, r = t[n];
                            if (!r) return e1;
                            arguments.length > 1 && (i = Array.prototype.splice.call(arguments, 1));
                            for(var a = 0; a < r.length; ++a){
                                var s = r[a];
                                s.callback.apply(s.ctx, i);
                            }
                            return e1;
                        }
                    };
                }(e1);
                return e1.on = t.on, e1.off = t.off, e1.fire = t.fire, e1;
            };
        },
        383: (e1)=>{
            "use strict";
            var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
            e1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var e1 = new String("abc");
                    if (e1[5] = "de", "5" === Object.getOwnPropertyNames(e1)[0]) return !1;
                    for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e1) {
                        return t[e1];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(e1) {
                        i[e1] = e1;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (e1) {
                    return !1;
                }
            }() ? Object.assign : function(e1, r) {
                for(var a, s, o = function(e1) {
                    if (null == e1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(e1);
                }(e1), l = 1; l < arguments.length; l++){
                    for(var c in a = Object(arguments[l]))n.call(a, c) && (o[c] = a[c]);
                    if (t) {
                        s = t(a);
                        for(var u = 0; u < s.length; u++)i.call(a, s[u]) && (o[s[u]] = a[s[u]]);
                    }
                }
                return o;
            };
        },
        300: (e1, t, n)=>{
            "use strict";
            var i = n(447), r = n(406), a = n(657), s = n(339), o = n(792), l = o(), c = o(!0), u = n(152), h = n(854), d = n(748);
            function p(e1, t) {
                var n = (t = t || {}).controller;
                if (n || (h.canAttach(e1) ? n = h(e1, t) : d.canAttach(e1) && (n = d(e1, t))), !n) throw new Error("Cannot create panzoom for the current type of dom element");
                var o = n.getOwner(), p = {
                    x: 0,
                    y: 0
                }, g = !1, v = new u;
                n.initTransform && n.initTransform(v);
                var y, x = "function" == typeof t.filterKey ? t.filterKey : m, b = "number" == typeof t.pinchSpeed ? t.pinchSpeed : 1, w = t.bounds, E = "number" == typeof t.maxZoom ? t.maxZoom : Number.POSITIVE_INFINITY, T = "number" == typeof t.minZoom ? t.minZoom : 0, S = "number" == typeof t.boundsPadding ? t.boundsPadding : .05, I = "number" == typeof t.zoomDoubleClickSpeed ? t.zoomDoubleClickSpeed : 1.75, N = t.beforeWheel || m, D = t.beforeMouseDown || m, _ = "number" == typeof t.zoomSpeed ? t.zoomSpeed : 1, C = f(t.transformOrigin), L = t.enableTextSelection ? c : l;
                !function(e1) {
                    var t = typeof e1;
                    if ("undefined" !== t && "boolean" !== t && !(A(e1.left) && A(e1.top) && A(e1.bottom) && A(e1.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }(w), t.autocenter && function() {
                    var e1, t, i = 0, r = 0, a = ae();
                    if (a) i = a.left, r = a.top, e1 = a.right - a.left, t = a.bottom - a.top;
                    else {
                        var s = o.getBoundingClientRect();
                        e1 = s.width, t = s.height;
                    }
                    var l = n.getBBox();
                    if (0 !== l.width && 0 !== l.height) {
                        var c = t / l.height, u = e1 / l.width, h = Math.min(u, c);
                        v.x = -(l.left + l.width / 2) * h + e1 / 2 + i, v.y = -(l.top + l.height / 2) * h + t / 2 + r, v.scale = h;
                    }
                }();
                var z, O, R, P, U, j, k, B, F, H, G = 0, V = 0, Q = 0, W = null, Y = new Date, X = !1, Z = !1;
                k = "smoothScroll" in t && !t.smoothScroll ? {
                    start: m,
                    stop: m,
                    cancel: m
                } : s(function() {
                    return {
                        x: v.x,
                        y: v.y
                    };
                }, function(e1, t) {
                    Le(), ne(e1, t);
                }, t.smoothScroll);
                var q = !1;
                ue();
                var K = {
                    dispose: function() {
                        he();
                    },
                    moveBy: ce,
                    moveTo: ne,
                    smoothMoveTo: function(e1, t) {
                        ce(e1 - v.x, t - v.y, !0);
                    },
                    centerOn: function(e1) {
                        var t = e1.ownerSVGElement;
                        if (!t) throw new Error("ui element is required to be within the scene");
                        var n = e1.getBoundingClientRect(), i = n.left + n.width / 2, r = n.top + n.height / 2, a = t.getBoundingClientRect();
                        ce(a.width / 2 - i, a.height / 2 - r, !0);
                    },
                    zoomTo: Ce,
                    zoomAbs: le,
                    smoothZoom: De,
                    smoothZoomAbs: function(e1, t, n) {
                        var i = {
                            scale: v.scale
                        }, a = {
                            scale: n
                        };
                        k.cancel(), Le(), F = r(i, a, {
                            step: function(n) {
                                le(e1, t, n.scale);
                            }
                        });
                    },
                    showRectangle: function(e1) {
                        var t = o.getBoundingClientRect(), n = te(t.width, t.height), i = e1.right - e1.left, r = e1.bottom - e1.top;
                        if (!Number.isFinite(i) || !Number.isFinite(r)) throw new Error("Invalid rectangle");
                        var a = n.x / i, s = n.y / r, l = Math.min(a, s);
                        v.x = -(e1.left + i / 2) * l + n.x / 2, v.y = -(e1.top + r / 2) * l + n.y / 2, v.scale = l;
                    },
                    pause: function() {
                        he(), q = !0;
                    },
                    resume: function() {
                        q && (ue(), q = !1);
                    },
                    isPaused: function() {
                        return q;
                    },
                    getTransform: function() {
                        return v;
                    },
                    getMinZoom: function() {
                        return T;
                    },
                    setMinZoom: function(e1) {
                        T = e1;
                    },
                    getMaxZoom: function() {
                        return E;
                    },
                    setMaxZoom: function(e1) {
                        E = e1;
                    },
                    getTransformOrigin: function() {
                        return C;
                    },
                    setTransformOrigin: function(e1) {
                        C = f(e1);
                    },
                    getZoomSpeed: function() {
                        return _;
                    },
                    setZoomSpeed: function(e1) {
                        if (!Number.isFinite(e1)) throw new Error("Zoom speed should be a number");
                        _ = e1;
                    }
                };
                a(K);
                var J = "number" == typeof t.initialX ? t.initialX : v.x, $ = "number" == typeof t.initialY ? t.initialY : v.y, ee = "number" == typeof t.initialZoom ? t.initialZoom : v.scale;
                return J == v.x && $ == v.y && ee == v.scale || le(J, $, ee), K;
                function te(e1, t) {
                    if (n.getScreenCTM) {
                        var i = n.getScreenCTM(), r = i.a, a = i.d, s = i.e, o = i.f;
                        p.x = e1 * r - s, p.y = t * a - o;
                    } else p.x = e1, p.y = t;
                    return p;
                }
                function ne(e1, t) {
                    v.x = e1, v.y = t, re(), Ue("pan"), se();
                }
                function ie(e1, t) {
                    ne(v.x + e1, v.y + t);
                }
                function re() {
                    var e1 = ae();
                    if (e1) {
                        var t, i, r, a, s = !1, o = (r = (t = n.getBBox()).left, a = t.top, {
                            left: (i = {
                                x: r * v.scale + v.x,
                                y: a * v.scale + v.y
                            }).x,
                            top: i.y,
                            right: t.width * v.scale + i.x,
                            bottom: t.height * v.scale + i.y
                        }), l = e1.left - o.right;
                        return l > 0 && (v.x += l, s = !0), (l = e1.right - o.left) < 0 && (v.x += l, s = !0), (l = e1.top - o.bottom) > 0 && (v.y += l, s = !0), (l = e1.bottom - o.top) < 0 && (v.y += l, s = !0), s;
                    }
                }
                function ae() {
                    if (w) {
                        if ("boolean" == typeof w) {
                            var e1 = o.getBoundingClientRect(), t = e1.width, n = e1.height;
                            return {
                                left: t * S,
                                top: n * S,
                                right: t * (1 - S),
                                bottom: n * (1 - S)
                            };
                        }
                        return w;
                    }
                }
                function se() {
                    g = !0, y = window.requestAnimationFrame(de);
                }
                function oe(e1, t, n) {
                    if (M(e1) || M(t) || M(n)) throw new Error("zoom requires valid numbers");
                    var i = v.scale * n;
                    if (i < T) {
                        if (v.scale === T) return;
                        n = T / v.scale;
                    }
                    if (i > E) {
                        if (v.scale === E) return;
                        n = E / v.scale;
                    }
                    var r = te(e1, t);
                    v.x = r.x - n * (r.x - v.x), v.y = r.y - n * (r.y - v.y), w && 1 === S && 1 === T ? (v.scale *= n, re()) : re() || (v.scale *= n), Ue("zoom"), se();
                }
                function le(e1, t, n) {
                    oe(e1, t, n / v.scale);
                }
                function ce(e1, t, n) {
                    if (!n) return ie(e1, t);
                    B && B.cancel();
                    var i = 0, a = 0;
                    B = r({
                        x: 0,
                        y: 0
                    }, {
                        x: e1,
                        y: t
                    }, {
                        step: function(e1) {
                            ie(e1.x - i, e1.y - a), i = e1.x, a = e1.y;
                        }
                    });
                }
                function ue() {
                    o.addEventListener("mousedown", be, {
                        passive: !1
                    }), o.addEventListener("dblclick", xe, {
                        passive: !1
                    }), o.addEventListener("touchstart", fe, {
                        passive: !1
                    }), o.addEventListener("keydown", pe, {
                        passive: !1
                    }), i.addWheelListener(o, Ie, {
                        passive: !1
                    }), se();
                }
                function he() {
                    i.removeWheelListener(o, Ie), o.removeEventListener("mousedown", be), o.removeEventListener("keydown", pe), o.removeEventListener("dblclick", xe), o.removeEventListener("touchstart", fe), y && (window.cancelAnimationFrame(y), y = 0), k.cancel(), Te(), Se(), L.release(), Re();
                }
                function de() {
                    g && (g = !1, n.applyTransform(v), Ue("transform"), y = 0);
                }
                function pe(e1) {
                    var t = 0, n = 0, i = 0;
                    if (38 === e1.keyCode ? n = 1 : 40 === e1.keyCode ? n = -1 : 37 === e1.keyCode ? t = 1 : 39 === e1.keyCode ? t = -1 : 189 === e1.keyCode || 109 === e1.keyCode ? i = 1 : 187 !== e1.keyCode && 107 !== e1.keyCode || (i = -1), !x(e1, t, n, i)) {
                        if (t || n) {
                            e1.preventDefault(), e1.stopPropagation();
                            var r = o.getBoundingClientRect();
                            ce(.05 * (a = Math.min(r.width, r.height)) * t, .05 * a * n);
                        }
                        if (i) {
                            var a, s = ze(100 * i);
                            Ce((a = C ? _e() : {
                                x: (l = o.getBoundingClientRect()).width / 2,
                                y: l.height / 2
                            }).x, a.y, s);
                        }
                        var l;
                    }
                }
                function fe(e1) {
                    if (function(e1) {
                        t.onTouch && !t.onTouch(e1) || (e1.stopPropagation(), e1.preventDefault());
                    }(e1), Ae(), 1 === e1.touches.length) return function(e1) {
                        V = new Date;
                        var t = Ne(e1.touches[0]);
                        z = t;
                        var n = te(t.x, t.y);
                        O = n.x, R = n.y, P = O, U = R, k.cancel(), ge();
                    }(e1, e1.touches[0]);
                    2 === e1.touches.length && (j = ye(e1.touches[0], e1.touches[1]), H = !0, ge());
                }
                function ge() {
                    X || (X = !0, document.addEventListener("touchmove", me), document.addEventListener("touchend", ve), document.addEventListener("touchcancel", ve));
                }
                function me(e1) {
                    if (1 === e1.touches.length) {
                        e1.stopPropagation();
                        var t = te((u = Ne(e1.touches[0])).x, u.y), n = t.x - O, i = t.y - R;
                        0 !== n && 0 !== i && Oe(), O = t.x, R = t.y, ce(n, i);
                    } else if (2 === e1.touches.length) {
                        H = !0;
                        var r = e1.touches[0], a = e1.touches[1], s = ye(r, a), o = 1 + (s / j - 1) * b, l = Ne(r), c = Ne(a);
                        if (O = (l.x + c.x) / 2, R = (l.y + c.y) / 2, C) {
                            var u = _e();
                            O = u.x, R = u.y;
                        }
                        Ce(O, R, o), j = s, e1.stopPropagation(), e1.preventDefault();
                    }
                }
                function Ae() {
                    Q && (clearTimeout(Q), Q = 0);
                }
                function Me(e1) {
                    if (t.onClick) {
                        Ae();
                        var n = O - P, i = R - U;
                        Math.sqrt(n * n + i * i) > 5 || (Q = setTimeout(function() {
                            Q = 0, t.onClick(e1);
                        }, 300));
                    }
                }
                function ve(e1) {
                    if (Ae(), e1.touches.length > 0) {
                        var t = te((n = Ne(e1.touches[0])).x, n.y);
                        O = t.x, R = t.y;
                    } else {
                        var n, i = new Date;
                        i - G < 300 ? C ? De((n = _e()).x, n.y, I) : De(z.x, z.y, I) : i - V < 200 && Me(e1), G = i, Re(), Se();
                    }
                }
                function ye(e1, t) {
                    var n = e1.clientX - t.clientX, i = e1.clientY - t.clientY;
                    return Math.sqrt(n * n + i * i);
                }
                function xe(e1) {
                    !function(e1) {
                        Ae(), t.onDoubleClick && !t.onDoubleClick(e1) || (e1.preventDefault(), e1.stopPropagation());
                    }(e1);
                    var n = Ne(e1);
                    C && (n = _e()), De(n.x, n.y, I);
                }
                function be(e1) {
                    if (Ae(), !D(e1)) {
                        if (W = e1, Y = new Date, X) return e1.stopPropagation(), !1;
                        if (1 === e1.button && null !== window.event || 0 === e1.button) {
                            k.cancel();
                            var t = Ne(e1), n = te(t.x, t.y);
                            return P = O = n.x, U = R = n.y, document.addEventListener("mousemove", we), document.addEventListener("mouseup", Ee), L.capture(e1.target || e1.srcElement), !1;
                        }
                    }
                }
                function we(e1) {
                    if (!X) {
                        Oe();
                        var t = Ne(e1), n = te(t.x, t.y), i = n.x - O, r = n.y - R;
                        O = n.x, R = n.y, ce(i, r);
                    }
                }
                function Ee() {
                    new Date - Y < 200 && Me(W), L.release(), Re(), Te();
                }
                function Te() {
                    document.removeEventListener("mousemove", we), document.removeEventListener("mouseup", Ee), Z = !1;
                }
                function Se() {
                    document.removeEventListener("touchmove", me), document.removeEventListener("touchend", ve), document.removeEventListener("touchcancel", ve), Z = !1, H = !1, X = !1;
                }
                function Ie(e1) {
                    if (!N(e1)) {
                        k.cancel();
                        var t = e1.deltaY;
                        e1.deltaMode > 0 && (t *= 100);
                        var n = ze(t);
                        if (1 !== n) {
                            var i = C ? _e() : Ne(e1);
                            Ce(i.x, i.y, n), e1.preventDefault();
                        }
                    }
                }
                function Ne(e1) {
                    var t = o.getBoundingClientRect();
                    return {
                        x: e1.clientX - t.left,
                        y: e1.clientY - t.top
                    };
                }
                function De(e1, t, n) {
                    var i = v.scale, a = {
                        scale: i
                    }, s = {
                        scale: n * i
                    };
                    k.cancel(), Le(), F = r(a, s, {
                        step: function(n) {
                            le(e1, t, n.scale);
                        },
                        done: Pe
                    });
                }
                function _e() {
                    var e1 = o.getBoundingClientRect();
                    return {
                        x: e1.width * C.x,
                        y: e1.height * C.y
                    };
                }
                function Ce(e1, t, n) {
                    return k.cancel(), Le(), oe(e1, t, n);
                }
                function Le() {
                    F && (F.cancel(), F = null);
                }
                function ze(e1) {
                    return 1 - Math.sign(e1) * Math.min(.25, Math.abs(_ * e1 / 128));
                }
                function Oe() {
                    Z || (Ue("panstart"), Z = !0, k.start());
                }
                function Re() {
                    Z && (H || k.stop(), Ue("panend"));
                }
                function Pe() {
                    Ue("zoomend");
                }
                function Ue(e1) {
                    K.fire(e1, K);
                }
            }
            function f(e1) {
                if (e1) return "object" == typeof e1 ? (A(e1.x) && A(e1.y) || g(e1), e1) : void g();
            }
            function g(e1) {
                throw console.error(e1), new Error([
                    "Cannot parse transform origin.",
                    "Some good examples:",
                    '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                    '  "top center" can be achieved with {x: 0.5, y: 0}',
                    '  "bottom right" can be achieved with {x: 1, y: 1}'
                ].join("\n"));
            }
            function m() {}
            function A(e1) {
                return Number.isFinite(e1);
            }
            function M(e1) {
                return Number.isNaN ? Number.isNaN(e1) : e1 != e1;
            }
            e1.exports = p, function() {
                if ("undefined" != typeof document) {
                    var e1 = document.getElementsByTagName("script");
                    if (e1) {
                        for(var t, n = 0; n < e1.length; ++n){
                            var i = e1[n];
                            if (i.src && i.src.match(/\bpanzoom(\.min)?\.js/)) {
                                t = i;
                                break;
                            }
                        }
                        if (t) {
                            var r = t.getAttribute("query");
                            if (r) {
                                var a = t.getAttribute("name") || "pz", s = Date.now();
                                !function e1() {
                                    var n = document.querySelector(r);
                                    if (!n) return Date.now() - s < 2e3 ? void setTimeout(e1, 100) : void console.error("Cannot find the panzoom element", a);
                                    var i = function(e1) {
                                        for(var t = e1.attributes, n = {}, i = 0; i < t.length; ++i){
                                            var r = o(t[i]);
                                            r && (n[r.name] = r.value);
                                        }
                                        return n;
                                    }(t);
                                    console.log(i), window[a] = p(n, i);
                                }();
                            }
                        }
                    }
                }
                function o(e1) {
                    if (e1.name && "p" === e1.name[0] && "z" === e1.name[1] && "-" === e1.name[2]) return {
                        name: e1.name.substr(3),
                        value: JSON.parse(e1.value)
                    };
                }
            }();
        },
        792: (e1)=>{
            function t(e1) {
                return e1.stopPropagation(), !1;
            }
            function n() {}
            e1.exports = function(e1) {
                if (e1) return {
                    capture: n,
                    release: n
                };
                var i, r, a, s = !1;
                return {
                    capture: function(e1) {
                        s = !0, r = window.document.onselectstart, a = window.document.ondragstart, window.document.onselectstart = t, (i = e1).ondragstart = t;
                    },
                    release: function() {
                        s && (s = !1, window.document.onselectstart = r, i && (i.ondragstart = a));
                    }
                };
            };
        },
        748: (e1)=>{
            function t(e1) {
                return e1 && e1.parentElement && e1.style;
            }
            e1.exports = function(e1, n) {
                if (!t(e1)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
                var i = e1.parentElement;
                return e1.scrollTop = 0, n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        return {
                            left: 0,
                            top: 0,
                            width: e1.clientWidth,
                            height: e1.clientHeight
                        };
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(t) {
                        e1.style.transformOrigin = "0 0 0", e1.style.transform = "matrix(" + t.scale + ", 0, 0, " + t.scale + ", " + t.x + ", " + t.y + ")";
                    }
                };
            }, e1.exports.canAttach = t;
        },
        339: (e1)=>{
            function t() {
                return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
            }
            function n() {
                return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function(e1) {
                    return setTimeout(e1, 16);
                };
            }
            e1.exports = function(e1, i, r) {
                "object" != typeof r && (r = {});
                var a, s, o, l, c, u, h, d, p, f, g = "number" == typeof r.minVelocity ? r.minVelocity : 5, m = "number" == typeof r.amplitude ? r.amplitude : .25, A = "function" == typeof r.cancelAnimationFrame ? r.cancelAnimationFrame : t(), M = "function" == typeof r.requestAnimationFrame ? r.requestAnimationFrame : n();
                return {
                    start: function() {
                        a = e1(), u = p = l = h = 0, s = new Date, A(o), A(f), o = M(v);
                    },
                    stop: function() {
                        A(o), A(f);
                        var t = e1();
                        c = t.x, d = t.y, s = Date.now(), (l < -g || l > g) && (c += u = m * l), (h < -g || h > g) && (d += p = m * h), f = M(y);
                    },
                    cancel: function() {
                        A(o), A(f);
                    }
                };
                function v() {
                    var t = Date.now(), n = t - s;
                    s = t;
                    var i = e1(), r = i.x - a.x, c = i.y - a.y;
                    a = i;
                    var u = 1e3 / (1 + n);
                    l = .8 * r * u + .2 * l, h = .8 * c * u + .2 * h, o = M(v);
                }
                function y() {
                    var e1 = Date.now() - s, t = !1, n = 0, r = 0;
                    u && ((n = -u * Math.exp(-e1 / 342)) > .5 || n < -0.5 ? t = !0 : n = u = 0), p && ((r = -p * Math.exp(-e1 / 342)) > .5 || r < -0.5 ? t = !0 : r = p = 0), t && (i(c + n, d + r), f = M(y));
                }
            };
        },
        854: (e1)=>{
            function t(e1) {
                return e1 && e1.ownerSVGElement && e1.getCTM;
            }
            e1.exports = function(e1, n) {
                if (!t(e1)) throw new Error("svg element is required for svg.panzoom to work");
                var i = e1.ownerSVGElement;
                if (!i) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                return n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        var t = e1.getBBox();
                        return {
                            left: t.x,
                            top: t.y,
                            width: t.width,
                            height: t.height
                        };
                    },
                    getScreenCTM: function() {
                        var e1 = i.getCTM();
                        return e1 || i.getScreenCTM();
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(t) {
                        e1.setAttribute("transform", "matrix(" + t.scale + " 0 0 " + t.scale + " " + t.x + " " + t.y + ")");
                    },
                    initTransform: function(t) {
                        var n = e1.getCTM();
                        null === n && (n = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix()), t.x = n.e, t.y = n.f, t.scale = n.a, i.removeAttributeNS(null, "viewBox");
                    }
                };
            }, e1.exports.canAttach = t;
        },
        152: (e1)=>{
            e1.exports = function() {
                this.x = 0, this.y = 0, this.scale = 1;
            };
        },
        230: (e1, t, n)=>{
            "use strict";
            var i = n(471), r = n(383), a = n(817);
            function s(e1) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!i) throw Error(s(227));
            var o = new Set, l = {};
            function c(e1, t) {
                u(e1, t), u(e1 + "Capture", t);
            }
            function u(e1, t) {
                for(l[e1] = t, e1 = 0; e1 < t.length; e1++)o.add(t[e1]);
            }
            var h = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = Object.prototype.hasOwnProperty, f = {}, g = {};
            function m(e1, t, n, i, r, a, s) {
                this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e1, this.type = t, this.sanitizeURL = a, this.removeEmptyString = s;
            }
            var A = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e1) {
                A[e1] = new m(e1, 0, !1, e1, null, !1, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(e1) {
                var t = e1[0];
                A[t] = new m(t, 1, !1, e1[1], null, !1, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 2, !1, e1.toLowerCase(), null, !1, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 2, !1, e1, null, !1, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e1) {
                A[e1] = new m(e1, 3, !1, e1.toLowerCase(), null, !1, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 3, !0, e1, null, !1, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 4, !1, e1, null, !1, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 6, !1, e1, null, !1, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 5, !1, e1.toLowerCase(), null, !1, !1);
            });
            var M = /[\-:]([a-z])/g;
            function v(e1) {
                return e1[1].toUpperCase();
            }
            function y(e1, t, n, i) {
                var r = A.hasOwnProperty(t) ? A[t] : null;
                (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function(e1, t, n, i) {
                    if (null == t || function(e1, t, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof t){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e1 = e1.toLowerCase().slice(0, 5)) && "aria-" !== e1);
                            default:
                                return !1;
                        }
                    }(e1, t, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !t;
                        case 4:
                            return !1 === t;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                    return !1;
                }(t, n, r, i) && (n = null), i || null === r ? function(e1) {
                    return !!p.call(g, e1) || !p.call(f, e1) && (d.test(e1) ? g[e1] = !0 : (f[e1] = !0, !1));
                }(t) && (null === n ? e1.removeAttribute(t) : e1.setAttribute(t, "" + n)) : r.mustUseProperty ? e1[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e1.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e1.setAttributeNS(i, t, n) : e1.setAttribute(t, n))));
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e1) {
                var t = e1.replace(M, v);
                A[t] = new m(t, 1, !1, e1, null, !1, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e1) {
                var t = e1.replace(M, v);
                A[t] = new m(t, 1, !1, e1, "http://www.w3.org/1999/xlink", !1, !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(e1) {
                var t = e1.replace(M, v);
                A[t] = new m(t, 1, !1, e1, "http://www.w3.org/XML/1998/namespace", !1, !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !1, !1);
            }), A.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(e1) {
                A[e1] = new m(e1, 1, !1, e1.toLowerCase(), null, !0, !0);
            });
            var x = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, b = 60103, w = 60106, E = 60107, T = 60108, S = 60114, I = 60109, N = 60110, D = 60112, _ = 60113, C = 60120, L = 60115, z = 60116, O = 60121, R = 60128, P = 60129, U = 60130, j = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var k = Symbol.for;
                b = k("react.element"), w = k("react.portal"), E = k("react.fragment"), T = k("react.strict_mode"), S = k("react.profiler"), I = k("react.provider"), N = k("react.context"), D = k("react.forward_ref"), _ = k("react.suspense"), C = k("react.suspense_list"), L = k("react.memo"), z = k("react.lazy"), O = k("react.block"), k("react.scope"), R = k("react.opaque.id"), P = k("react.debug_trace_mode"), U = k("react.offscreen"), j = k("react.legacy_hidden");
            }
            var B, F = "function" == typeof Symbol && Symbol.iterator;
            function H(e1) {
                return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = F && e1[F] || e1["@@iterator"]) ? e1 : null;
            }
            function G(e1) {
                if (void 0 === B) try {
                    throw Error();
                } catch (e1) {
                    var t = e1.stack.trim().match(/\n( *(at )?)/);
                    B = t && t[1] || "";
                }
                return "\n" + B + e1;
            }
            var V = !1;
            function Q(e1, t) {
                if (!e1 || V) return "";
                V = !0;
                var n = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (t) {
                        if (t = function() {
                            throw Error();
                        }, Object.defineProperty(t.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        }), "object" == typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(t, []);
                            } catch (e1) {
                                var i = e1;
                            }
                            Reflect.construct(e1, [], t);
                        } else {
                            try {
                                t.call();
                            } catch (e1) {
                                i = e1;
                            }
                            e1.call(t.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (e1) {
                            i = e1;
                        }
                        e1();
                    }
                } catch (e1) {
                    if (e1 && i && "string" == typeof e1.stack) {
                        for(var r = e1.stack.split("\n"), a = i.stack.split("\n"), s = r.length - 1, o = a.length - 1; 1 <= s && 0 <= o && r[s] !== a[o];)o--;
                        for(; 1 <= s && 0 <= o; s--, o--)if (r[s] !== a[o]) {
                            if (1 !== s || 1 !== o) do {
                                if (s--, 0 > --o || r[s] !== a[o]) return "\n" + r[s].replace(" at new ", " at ");
                            }while (1 <= s && 0 <= o);
                            break;
                        }
                    }
                } finally{
                    V = !1, Error.prepareStackTrace = n;
                }
                return (e1 = e1 ? e1.displayName || e1.name : "") ? G(e1) : "";
            }
            function W(e1) {
                switch(e1.tag){
                    case 5:
                        return G(e1.type);
                    case 16:
                        return G("Lazy");
                    case 13:
                        return G("Suspense");
                    case 19:
                        return G("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return Q(e1.type, !1);
                    case 11:
                        return Q(e1.type.render, !1);
                    case 22:
                        return Q(e1.type._render, !1);
                    case 1:
                        return Q(e1.type, !0);
                    default:
                        return "";
                }
            }
            function Y(e1) {
                if (null == e1) return null;
                if ("function" == typeof e1) return e1.displayName || e1.name || null;
                if ("string" == typeof e1) return e1;
                switch(e1){
                    case E:
                        return "Fragment";
                    case w:
                        return "Portal";
                    case S:
                        return "Profiler";
                    case T:
                        return "StrictMode";
                    case _:
                        return "Suspense";
                    case C:
                        return "SuspenseList";
                }
                if ("object" == typeof e1) switch(e1.$$typeof){
                    case N:
                        return (e1.displayName || "Context") + ".Consumer";
                    case I:
                        return (e1._context.displayName || "Context") + ".Provider";
                    case D:
                        var t = e1.render;
                        return t = t.displayName || t.name || "", e1.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
                    case L:
                        return Y(e1.type);
                    case O:
                        return Y(e1._render);
                    case z:
                        t = e1._payload, e1 = e1._init;
                        try {
                            return Y(e1(t));
                        } catch (e1) {}
                }
                return null;
            }
            function X(e1) {
                switch(typeof e1){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return e1;
                    default:
                        return "";
                }
            }
            function Z(e1) {
                var t = e1.type;
                return (e1 = e1.nodeName) && "input" === e1.toLowerCase() && ("checkbox" === t || "radio" === t);
            }
            function q(e1) {
                e1._valueTracker || (e1._valueTracker = function(e1) {
                    var t = Z(e1) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e1.constructor.prototype, t), i = "" + e1[t];
                    if (!e1.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                        var r = n.get, a = n.set;
                        return Object.defineProperty(e1, t, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(e1) {
                                i = "" + e1, a.call(this, e1);
                            }
                        }), Object.defineProperty(e1, t, {
                            enumerable: n.enumerable
                        }), {
                            getValue: function() {
                                return i;
                            },
                            setValue: function(e1) {
                                i = "" + e1;
                            },
                            stopTracking: function() {
                                e1._valueTracker = null, delete e1[t];
                            }
                        };
                    }
                }(e1));
            }
            function K(e1) {
                if (!e1) return !1;
                var t = e1._valueTracker;
                if (!t) return !0;
                var n = t.getValue(), i = "";
                return e1 && (i = Z(e1) ? e1.checked ? "true" : "false" : e1.value), (e1 = i) !== n && (t.setValue(e1), !0);
            }
            function J(e1) {
                if (void 0 === (e1 = e1 || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return e1.activeElement || e1.body;
                } catch (t) {
                    return e1.body;
                }
            }
            function $(e1, t) {
                var n = t.checked;
                return r({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != n ? n : e1._wrapperState.initialChecked
                });
            }
            function ee(e1, t) {
                var n = null == t.defaultValue ? "" : t.defaultValue, i = null != t.checked ? t.checked : t.defaultChecked;
                n = X(null != t.value ? t.value : n), e1._wrapperState = {
                    initialChecked: i,
                    initialValue: n,
                    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                };
            }
            function te(e1, t) {
                null != (t = t.checked) && y(e1, "checked", t, !1);
            }
            function ne(e1, t) {
                te(e1, t);
                var n = X(t.value), i = t.type;
                if (null != n) "number" === i ? (0 === n && "" === e1.value || e1.value != n) && (e1.value = "" + n) : e1.value !== "" + n && (e1.value = "" + n);
                else if ("submit" === i || "reset" === i) return void e1.removeAttribute("value");
                t.hasOwnProperty("value") ? re(e1, t.type, n) : t.hasOwnProperty("defaultValue") && re(e1, t.type, X(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e1.defaultChecked = !!t.defaultChecked);
            }
            function ie(e1, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var i = t.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
                    t = "" + e1._wrapperState.initialValue, n || t === e1.value || (e1.value = t), e1.defaultValue = t;
                }
                "" !== (n = e1.name) && (e1.name = ""), e1.defaultChecked = !!e1._wrapperState.initialChecked, "" !== n && (e1.name = n);
            }
            function re(e1, t, n) {
                "number" === t && J(e1.ownerDocument) === e1 || (null == n ? e1.defaultValue = "" + e1._wrapperState.initialValue : e1.defaultValue !== "" + n && (e1.defaultValue = "" + n));
            }
            function ae(e1, t) {
                return e1 = r({
                    children: void 0
                }, t), (t = function(e1) {
                    var t = "";
                    return i.Children.forEach(e1, function(e1) {
                        null != e1 && (t += e1);
                    }), t;
                }(t.children)) && (e1.children = t), e1;
            }
            function se(e1, t, n, i) {
                if (e1 = e1.options, t) {
                    t = {};
                    for(var r = 0; r < n.length; r++)t["$" + n[r]] = !0;
                    for(n = 0; n < e1.length; n++)r = t.hasOwnProperty("$" + e1[n].value), e1[n].selected !== r && (e1[n].selected = r), r && i && (e1[n].defaultSelected = !0);
                } else {
                    for(n = "" + X(n), t = null, r = 0; r < e1.length; r++){
                        if (e1[r].value === n) return e1[r].selected = !0, void (i && (e1[r].defaultSelected = !0));
                        null !== t || e1[r].disabled || (t = e1[r]);
                    }
                    null !== t && (t.selected = !0);
                }
            }
            function oe(e1, t) {
                if (null != t.dangerouslySetInnerHTML) throw Error(s(91));
                return r({}, t, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + e1._wrapperState.initialValue
                });
            }
            function le(e1, t) {
                var n = t.value;
                if (null == n) {
                    if (n = t.children, t = t.defaultValue, null != n) {
                        if (null != t) throw Error(s(92));
                        if (Array.isArray(n)) {
                            if (!(1 >= n.length)) throw Error(s(93));
                            n = n[0];
                        }
                        t = n;
                    }
                    null == t && (t = ""), n = t;
                }
                e1._wrapperState = {
                    initialValue: X(n)
                };
            }
            function ce(e1, t) {
                var n = X(t.value), i = X(t.defaultValue);
                null != n && ((n = "" + n) !== e1.value && (e1.value = n), null == t.defaultValue && e1.defaultValue !== n && (e1.defaultValue = n)), null != i && (e1.defaultValue = "" + i);
            }
            function ue(e1) {
                var t = e1.textContent;
                t === e1._wrapperState.initialValue && "" !== t && null !== t && (e1.value = t);
            }
            var he = {
                html: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function de(e1) {
                switch(e1){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function pe(e1, t) {
                return null == e1 || "http://www.w3.org/1999/xhtml" === e1 ? de(t) : "http://www.w3.org/2000/svg" === e1 && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e1;
            }
            var fe, ge, me = (ge = function(e1, t) {
                if (e1.namespaceURI !== he.svg || "innerHTML" in e1) e1.innerHTML = t;
                else {
                    for((fe = fe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = fe.firstChild; e1.firstChild;)e1.removeChild(e1.firstChild);
                    for(; t.firstChild;)e1.appendChild(t.firstChild);
                }
            }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e1, t, n, i) {
                MSApp.execUnsafeLocalFunction(function() {
                    return ge(e1, t);
                });
            } : ge);
            function Ae(e1, t) {
                if (t) {
                    var n = e1.firstChild;
                    if (n && n === e1.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
                }
                e1.textContent = t;
            }
            var Me = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, ve = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function ye(e1, t, n) {
                return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || Me.hasOwnProperty(e1) && Me[e1] ? ("" + t).trim() : t + "px";
            }
            function xe(e1, t) {
                for(var n in e1 = e1.style, t)if (t.hasOwnProperty(n)) {
                    var i = 0 === n.indexOf("--"), r = ye(n, t[n], i);
                    "float" === n && (n = "cssFloat"), i ? e1.setProperty(n, r) : e1[n] = r;
                }
            }
            Object.keys(Me).forEach(function(e1) {
                ve.forEach(function(t) {
                    t = t + e1.charAt(0).toUpperCase() + e1.substring(1), Me[t] = Me[e1];
                });
            });
            var be = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function we(e1, t) {
                if (t) {
                    if (be[e1] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(s(137, e1));
                    if (null != t.dangerouslySetInnerHTML) {
                        if (null != t.children) throw Error(s(60));
                        if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(s(61));
                    }
                    if (null != t.style && "object" != typeof t.style) throw Error(s(62));
                }
            }
            function Ee(e1, t) {
                if (-1 === e1.indexOf("-")) return "string" == typeof t.is;
                switch(e1){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            function Te(e1) {
                return (e1 = e1.target || e1.srcElement || window).correspondingUseElement && (e1 = e1.correspondingUseElement), 3 === e1.nodeType ? e1.parentNode : e1;
            }
            var Se = null, Ie = null, Ne = null;
            function De(e1) {
                if (e1 = nr(e1)) {
                    if ("function" != typeof Se) throw Error(s(280));
                    var t = e1.stateNode;
                    t && (t = rr(t), Se(e1.stateNode, e1.type, t));
                }
            }
            function _e(e1) {
                Ie ? Ne ? Ne.push(e1) : Ne = [
                    e1
                ] : Ie = e1;
            }
            function Ce() {
                if (Ie) {
                    var e1 = Ie, t = Ne;
                    if (Ne = Ie = null, De(e1), t) for(e1 = 0; e1 < t.length; e1++)De(t[e1]);
                }
            }
            function Le(e1, t) {
                return e1(t);
            }
            function ze(e1, t, n, i, r) {
                return e1(t, n, i, r);
            }
            function Oe() {}
            var Re = Le, Pe = !1, Ue = !1;
            function je() {
                null === Ie && null === Ne || (Oe(), Ce());
            }
            function ke(e1, t) {
                var n = e1.stateNode;
                if (null === n) return null;
                var i = rr(n);
                if (null === i) return null;
                n = i[t];
                e: switch(t){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (e1 = e1.type) || "input" === e1 || "select" === e1 || "textarea" === e1)), e1 = !i;
                        break e;
                    default:
                        e1 = !1;
                }
                if (e1) return null;
                if (n && "function" != typeof n) throw Error(s(231, t, typeof n));
                return n;
            }
            var Be = !1;
            if (h) try {
                var Fe = {};
                Object.defineProperty(Fe, "passive", {
                    get: function() {
                        Be = !0;
                    }
                }), window.addEventListener("test", Fe, Fe), window.removeEventListener("test", Fe, Fe);
            } catch (ge) {
                Be = !1;
            }
            function He(e1, t, n, i, r, a, s, o, l) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, c);
                } catch (e1) {
                    this.onError(e1);
                }
            }
            var Ge = !1, Ve = null, Qe = !1, We = null, Ye = {
                onError: function(e1) {
                    Ge = !0, Ve = e1;
                }
            };
            function Xe(e1, t, n, i, r, a, s, o, l) {
                Ge = !1, Ve = null, He.apply(Ye, arguments);
            }
            function Ze(e1) {
                var t = e1, n = e1;
                if (e1.alternate) for(; t.return;)t = t.return;
                else {
                    e1 = t;
                    do !!(1026 & (t = e1).flags) && (n = t.return), e1 = t.return;
                    while (e1);
                }
                return 3 === t.tag ? n : null;
            }
            function qe(e1) {
                if (13 === e1.tag) {
                    var t = e1.memoizedState;
                    if (null === t && null !== (e1 = e1.alternate) && (t = e1.memoizedState), null !== t) return t.dehydrated;
                }
                return null;
            }
            function Ke(e1) {
                if (Ze(e1) !== e1) throw Error(s(188));
            }
            function Je(e1) {
                if (e1 = function(e1) {
                    var t = e1.alternate;
                    if (!t) {
                        if (null === (t = Ze(e1))) throw Error(s(188));
                        return t !== e1 ? null : e1;
                    }
                    for(var n = e1, i = t;;){
                        var r = n.return;
                        if (null === r) break;
                        var a = r.alternate;
                        if (null === a) {
                            if (null !== (i = r.return)) {
                                n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === a.child) {
                            for(a = r.child; a;){
                                if (a === n) return Ke(r), e1;
                                if (a === i) return Ke(r), t;
                                a = a.sibling;
                            }
                            throw Error(s(188));
                        }
                        if (n.return !== i.return) n = r, i = a;
                        else {
                            for(var o = !1, l = r.child; l;){
                                if (l === n) {
                                    o = !0, n = r, i = a;
                                    break;
                                }
                                if (l === i) {
                                    o = !0, i = r, n = a;
                                    break;
                                }
                                l = l.sibling;
                            }
                            if (!o) {
                                for(l = a.child; l;){
                                    if (l === n) {
                                        o = !0, n = a, i = r;
                                        break;
                                    }
                                    if (l === i) {
                                        o = !0, i = a, n = r;
                                        break;
                                    }
                                    l = l.sibling;
                                }
                                if (!o) throw Error(s(189));
                            }
                        }
                        if (n.alternate !== i) throw Error(s(190));
                    }
                    if (3 !== n.tag) throw Error(s(188));
                    return n.stateNode.current === n ? e1 : t;
                }(e1), !e1) return null;
                for(var t = e1;;){
                    if (5 === t.tag || 6 === t.tag) return t;
                    if (t.child) t.child.return = t, t = t.child;
                    else {
                        if (t === e1) break;
                        for(; !t.sibling;){
                            if (!t.return || t.return === e1) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                }
                return null;
            }
            function $e(e1, t) {
                for(var n = e1.alternate; null !== t;){
                    if (t === e1 || t === n) return !0;
                    t = t.return;
                }
                return !1;
            }
            var et, tt, nt, it, rt = !1, at = [], st = null, ot = null, lt = null, ct = new Map, ut = new Map, ht = [], dt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
            function pt(e1, t, n, i, r) {
                return {
                    blockedOn: e1,
                    domEventName: t,
                    eventSystemFlags: 16 | n,
                    nativeEvent: r,
                    targetContainers: [
                        i
                    ]
                };
            }
            function ft(e1, t) {
                switch(e1){
                    case "focusin":
                    case "focusout":
                        st = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        ot = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        lt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ct.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        ut.delete(t.pointerId);
                }
            }
            function gt(e1, t, n, i, r, a) {
                return null === e1 || e1.nativeEvent !== a ? (e1 = pt(t, n, i, r, a), null !== t && null !== (t = nr(t)) && tt(t), e1) : (e1.eventSystemFlags |= i, t = e1.targetContainers, null !== r && -1 === t.indexOf(r) && t.push(r), e1);
            }
            function mt(e1) {
                var t = tr(e1.target);
                if (null !== t) {
                    var n = Ze(t);
                    if (null !== n) {
                        if (13 === (t = n.tag)) {
                            if (null !== (t = qe(n))) return e1.blockedOn = t, void it(e1.lanePriority, function() {
                                a.unstable_runWithPriority(e1.priority, function() {
                                    nt(n);
                                });
                            });
                        } else if (3 === t && n.stateNode.hydrate) return void (e1.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                    }
                }
                e1.blockedOn = null;
            }
            function At(e1) {
                if (null !== e1.blockedOn) return !1;
                for(var t = e1.targetContainers; 0 < t.length;){
                    var n = Jt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                    if (null !== n) return null !== (t = nr(n)) && tt(t), e1.blockedOn = n, !1;
                    t.shift();
                }
                return !0;
            }
            function Mt(e1, t, n) {
                At(e1) && n.delete(t);
            }
            function vt() {
                for(rt = !1; 0 < at.length;){
                    var e1 = at[0];
                    if (null !== e1.blockedOn) {
                        null !== (e1 = nr(e1.blockedOn)) && et(e1);
                        break;
                    }
                    for(var t = e1.targetContainers; 0 < t.length;){
                        var n = Jt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                        if (null !== n) {
                            e1.blockedOn = n;
                            break;
                        }
                        t.shift();
                    }
                    null === e1.blockedOn && at.shift();
                }
                null !== st && At(st) && (st = null), null !== ot && At(ot) && (ot = null), null !== lt && At(lt) && (lt = null), ct.forEach(Mt), ut.forEach(Mt);
            }
            function yt(e1, t) {
                e1.blockedOn === t && (e1.blockedOn = null, rt || (rt = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, vt)));
            }
            function xt(e1) {
                function t(t) {
                    return yt(t, e1);
                }
                if (0 < at.length) {
                    yt(at[0], e1);
                    for(var n = 1; n < at.length; n++){
                        var i = at[n];
                        i.blockedOn === e1 && (i.blockedOn = null);
                    }
                }
                for(null !== st && yt(st, e1), null !== ot && yt(ot, e1), null !== lt && yt(lt, e1), ct.forEach(t), ut.forEach(t), n = 0; n < ht.length; n++)(i = ht[n]).blockedOn === e1 && (i.blockedOn = null);
                for(; 0 < ht.length && null === (n = ht[0]).blockedOn;)mt(n), null === n.blockedOn && ht.shift();
            }
            function bt(e1, t) {
                var n = {};
                return n[e1.toLowerCase()] = t.toLowerCase(), n["Webkit" + e1] = "webkit" + t, n["Moz" + e1] = "moz" + t, n;
            }
            var wt = {
                animationend: bt("Animation", "AnimationEnd"),
                animationiteration: bt("Animation", "AnimationIteration"),
                animationstart: bt("Animation", "AnimationStart"),
                transitionend: bt("Transition", "TransitionEnd")
            }, Et = {}, Tt = {};
            function St(e1) {
                if (Et[e1]) return Et[e1];
                if (!wt[e1]) return e1;
                var t, n = wt[e1];
                for(t in n)if (n.hasOwnProperty(t) && t in Tt) return Et[e1] = n[t];
                return e1;
            }
            h && (Tt = document.createElement("div").style, "AnimationEvent" in window || (delete wt.animationend.animation, delete wt.animationiteration.animation, delete wt.animationstart.animation), "TransitionEvent" in window || delete wt.transitionend.transition);
            var It = St("animationend"), Nt = St("animationiteration"), Dt = St("animationstart"), _t = St("transitionend"), Ct = new Map, Lt = new Map, zt = [
                "abort",
                "abort",
                It,
                "animationEnd",
                Nt,
                "animationIteration",
                Dt,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                _t,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function Ot(e1, t) {
                for(var n = 0; n < e1.length; n += 2){
                    var i = e1[n], r = e1[n + 1];
                    r = "on" + (r[0].toUpperCase() + r.slice(1)), Lt.set(i, t), Ct.set(i, r), c(r, [
                        i
                    ]);
                }
            }
            (0, a.unstable_now)();
            var Rt = 8;
            function Pt(e1) {
                if (1 & e1) return Rt = 15, 1;
                if (2 & e1) return Rt = 14, 2;
                if (4 & e1) return Rt = 13, 4;
                var t = 24 & e1;
                return 0 !== t ? (Rt = 12, t) : 32 & e1 ? (Rt = 11, 32) : 0 != (t = 192 & e1) ? (Rt = 10, t) : 256 & e1 ? (Rt = 9, 256) : 0 != (t = 3584 & e1) ? (Rt = 8, t) : 4096 & e1 ? (Rt = 7, 4096) : 0 != (t = 4186112 & e1) ? (Rt = 6, t) : 0 != (t = 62914560 & e1) ? (Rt = 5, t) : 67108864 & e1 ? (Rt = 4, 67108864) : 134217728 & e1 ? (Rt = 3, 134217728) : 0 != (t = 805306368 & e1) ? (Rt = 2, t) : 1073741824 & e1 ? (Rt = 1, 1073741824) : (Rt = 8, e1);
            }
            function Ut(e1, t) {
                var n = e1.pendingLanes;
                if (0 === n) return Rt = 0;
                var i = 0, r = 0, a = e1.expiredLanes, s = e1.suspendedLanes, o = e1.pingedLanes;
                if (0 !== a) i = a, r = Rt = 15;
                else if (0 != (a = 134217727 & n)) {
                    var l = a & ~s;
                    0 !== l ? (i = Pt(l), r = Rt) : 0 != (o &= a) && (i = Pt(o), r = Rt);
                } else 0 != (a = n & ~s) ? (i = Pt(a), r = Rt) : 0 !== o && (i = Pt(o), r = Rt);
                if (0 === i) return 0;
                if (i = n & ((0 > (i = 31 - Gt(i)) ? 0 : 1 << i) << 1) - 1, 0 !== t && t !== i && !(t & s)) {
                    if (Pt(t), r <= Rt) return t;
                    Rt = r;
                }
                if (0 !== (t = e1.entangledLanes)) for(e1 = e1.entanglements, t &= i; 0 < t;)r = 1 << (n = 31 - Gt(t)), i |= e1[n], t &= ~r;
                return i;
            }
            function jt(e1) {
                return 0 != (e1 = -1073741825 & e1.pendingLanes) ? e1 : 1073741824 & e1 ? 1073741824 : 0;
            }
            function kt(e1, t) {
                switch(e1){
                    case 15:
                        return 1;
                    case 14:
                        return 2;
                    case 12:
                        return 0 === (e1 = Bt(24 & ~t)) ? kt(10, t) : e1;
                    case 10:
                        return 0 === (e1 = Bt(192 & ~t)) ? kt(8, t) : e1;
                    case 8:
                        return 0 === (e1 = Bt(3584 & ~t)) && 0 === (e1 = Bt(4186112 & ~t)) && (e1 = 512), e1;
                    case 2:
                        return 0 === (t = Bt(805306368 & ~t)) && (t = 268435456), t;
                }
                throw Error(s(358, e1));
            }
            function Bt(e1) {
                return e1 & -e1;
            }
            function Ft(e1) {
                for(var t = [], n = 0; 31 > n; n++)t.push(e1);
                return t;
            }
            function Ht(e1, t, n) {
                e1.pendingLanes |= t;
                var i = t - 1;
                e1.suspendedLanes &= i, e1.pingedLanes &= i, (e1 = e1.eventTimes)[t = 31 - Gt(t)] = n;
            }
            var Gt = Math.clz32 ? Math.clz32 : function(e1) {
                return 0 === e1 ? 32 : 31 - (Vt(e1) / Qt | 0) | 0;
            }, Vt = Math.log, Qt = Math.LN2, Wt = a.unstable_UserBlockingPriority, Yt = a.unstable_runWithPriority, Xt = !0;
            function Zt(e1, t, n, i) {
                Pe || Oe();
                var r = Kt, a = Pe;
                Pe = !0;
                try {
                    ze(r, e1, t, n, i);
                } finally{
                    (Pe = a) || je();
                }
            }
            function qt(e1, t, n, i) {
                Yt(Wt, Kt.bind(null, e1, t, n, i));
            }
            function Kt(e1, t, n, i) {
                var r;
                if (Xt) {
                    if ((r = !(4 & t)) && 0 < at.length && -1 < dt.indexOf(e1)) e1 = pt(null, e1, t, n, i), at.push(e1);
                    else {
                        var a = Jt(e1, t, n, i);
                        if (null === a) r && ft(e1, i);
                        else {
                            if (r) {
                                if (-1 < dt.indexOf(e1)) return e1 = pt(a, e1, t, n, i), void at.push(e1);
                                if (function(e1, t, n, i, r) {
                                    switch(t){
                                        case "focusin":
                                            return st = gt(st, e1, t, n, i, r), !0;
                                        case "dragenter":
                                            return ot = gt(ot, e1, t, n, i, r), !0;
                                        case "mouseover":
                                            return lt = gt(lt, e1, t, n, i, r), !0;
                                        case "pointerover":
                                            var a = r.pointerId;
                                            return ct.set(a, gt(ct.get(a) || null, e1, t, n, i, r)), !0;
                                        case "gotpointercapture":
                                            return a = r.pointerId, ut.set(a, gt(ut.get(a) || null, e1, t, n, i, r)), !0;
                                    }
                                    return !1;
                                }(a, e1, t, n, i)) return;
                                ft(e1, i);
                            }
                            Oi(e1, t, i, null, n);
                        }
                    }
                }
            }
            function Jt(e1, t, n, i) {
                var r = Te(i);
                if (null !== (r = tr(r))) {
                    var a = Ze(r);
                    if (null === a) r = null;
                    else {
                        var s = a.tag;
                        if (13 === s) {
                            if (null !== (r = qe(a))) return r;
                            r = null;
                        } else if (3 === s) {
                            if (a.stateNode.hydrate) return 3 === a.tag ? a.stateNode.containerInfo : null;
                            r = null;
                        } else a !== r && (r = null);
                    }
                }
                return Oi(e1, t, i, r, n), null;
            }
            var $t = null, en = null, tn = null;
            function nn() {
                if (tn) return tn;
                var e1, t, n = en, i = n.length, r = "value" in $t ? $t.value : $t.textContent, a = r.length;
                for(e1 = 0; e1 < i && n[e1] === r[e1]; e1++);
                var s = i - e1;
                for(t = 1; t <= s && n[i - t] === r[a - t]; t++);
                return tn = r.slice(e1, 1 < t ? 1 - t : void 0);
            }
            function rn(e1) {
                var t = e1.keyCode;
                return "charCode" in e1 ? 0 === (e1 = e1.charCode) && 13 === t && (e1 = 13) : e1 = t, 10 === e1 && (e1 = 13), 32 <= e1 || 13 === e1 ? e1 : 0;
            }
            function an() {
                return !0;
            }
            function sn() {
                return !1;
            }
            function on(e1) {
                function t(t, n, i, r, a) {
                    for(var s in this._reactName = t, this._targetInst = i, this.type = n, this.nativeEvent = r, this.target = a, this.currentTarget = null, e1)e1.hasOwnProperty(s) && (t = e1[s], this[s] = t ? t(r) : r[s]);
                    return this.isDefaultPrevented = (null != r.defaultPrevented ? r.defaultPrevented : !1 === r.returnValue) ? an : sn, this.isPropagationStopped = sn, this;
                }
                return r(t.prototype, {
                    preventDefault: function() {
                        this.defaultPrevented = !0;
                        var e1 = this.nativeEvent;
                        e1 && (e1.preventDefault ? e1.preventDefault() : "unknown" != typeof e1.returnValue && (e1.returnValue = !1), this.isDefaultPrevented = an);
                    },
                    stopPropagation: function() {
                        var e1 = this.nativeEvent;
                        e1 && (e1.stopPropagation ? e1.stopPropagation() : "unknown" != typeof e1.cancelBubble && (e1.cancelBubble = !0), this.isPropagationStopped = an);
                    },
                    persist: function() {},
                    isPersistent: an
                }), t;
            }
            var ln, cn, un, hn = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function(e1) {
                    return e1.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0
            }, dn = on(hn), pn = r({}, hn, {
                view: 0,
                detail: 0
            }), fn = on(pn), gn = r({}, pn, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: In,
                button: 0,
                buttons: 0,
                relatedTarget: function(e1) {
                    return void 0 === e1.relatedTarget ? e1.fromElement === e1.srcElement ? e1.toElement : e1.fromElement : e1.relatedTarget;
                },
                movementX: function(e1) {
                    return "movementX" in e1 ? e1.movementX : (e1 !== un && (un && "mousemove" === e1.type ? (ln = e1.screenX - un.screenX, cn = e1.screenY - un.screenY) : cn = ln = 0, un = e1), ln);
                },
                movementY: function(e1) {
                    return "movementY" in e1 ? e1.movementY : cn;
                }
            }), mn = on(gn), An = on(r({}, gn, {
                dataTransfer: 0
            })), Mn = on(r({}, pn, {
                relatedTarget: 0
            })), vn = on(r({}, hn, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), yn = r({}, hn, {
                clipboardData: function(e1) {
                    return "clipboardData" in e1 ? e1.clipboardData : window.clipboardData;
                }
            }), xn = on(yn), bn = on(r({}, hn, {
                data: 0
            })), wn = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, En = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, Tn = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function Sn(e1) {
                var t = this.nativeEvent;
                return t.getModifierState ? t.getModifierState(e1) : !!(e1 = Tn[e1]) && !!t[e1];
            }
            function In() {
                return Sn;
            }
            var Nn = r({}, pn, {
                key: function(e1) {
                    if (e1.key) {
                        var t = wn[e1.key] || e1.key;
                        if ("Unidentified" !== t) return t;
                    }
                    return "keypress" === e1.type ? 13 === (e1 = rn(e1)) ? "Enter" : String.fromCharCode(e1) : "keydown" === e1.type || "keyup" === e1.type ? En[e1.keyCode] || "Unidentified" : "";
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: In,
                charCode: function(e1) {
                    return "keypress" === e1.type ? rn(e1) : 0;
                },
                keyCode: function(e1) {
                    return "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                },
                which: function(e1) {
                    return "keypress" === e1.type ? rn(e1) : "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                }
            }), Dn = on(Nn), _n = on(r({}, gn, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Cn = on(r({}, pn, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: In
            })), Ln = on(r({}, hn, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), zn = r({}, gn, {
                deltaX: function(e1) {
                    return "deltaX" in e1 ? e1.deltaX : "wheelDeltaX" in e1 ? -e1.wheelDeltaX : 0;
                },
                deltaY: function(e1) {
                    return "deltaY" in e1 ? e1.deltaY : "wheelDeltaY" in e1 ? -e1.wheelDeltaY : "wheelDelta" in e1 ? -e1.wheelDelta : 0;
                },
                deltaZ: 0,
                deltaMode: 0
            }), On = on(zn), Rn = [
                9,
                13,
                27,
                32
            ], Pn = h && "CompositionEvent" in window, Un = null;
            h && "documentMode" in document && (Un = document.documentMode);
            var jn = h && "TextEvent" in window && !Un, kn = h && (!Pn || Un && 8 < Un && 11 >= Un), Bn = String.fromCharCode(32), Fn = !1;
            function Hn(e1, t) {
                switch(e1){
                    case "keyup":
                        return -1 !== Rn.indexOf(t.keyCode);
                    case "keydown":
                        return 229 !== t.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Gn(e1) {
                return "object" == typeof (e1 = e1.detail) && "data" in e1 ? e1.data : null;
            }
            var Vn = !1, Qn = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function Wn(e1) {
                var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                return "input" === t ? !!Qn[e1.type] : "textarea" === t;
            }
            function Yn(e1, t, n, i) {
                _e(i), 0 < (t = Pi(t, "onChange")).length && (n = new dn("onChange", "change", null, n, i), e1.push({
                    event: n,
                    listeners: t
                }));
            }
            var Xn = null, Zn = null;
            function qn(e1) {
                Ni(e1, 0);
            }
            function Kn(e1) {
                if (K(ir(e1))) return e1;
            }
            function Jn(e1, t) {
                if ("change" === e1) return t;
            }
            var $n = !1;
            if (h) {
                var ei;
                if (h) {
                    var ti = "oninput" in document;
                    if (!ti) {
                        var ni = document.createElement("div");
                        ni.setAttribute("oninput", "return;"), ti = "function" == typeof ni.oninput;
                    }
                    ei = ti;
                } else ei = !1;
                $n = ei && (!document.documentMode || 9 < document.documentMode);
            }
            function ii() {
                Xn && (Xn.detachEvent("onpropertychange", ri), Zn = Xn = null);
            }
            function ri(e1) {
                if ("value" === e1.propertyName && Kn(Zn)) {
                    var t = [];
                    if (Yn(t, Zn, e1, Te(e1)), e1 = qn, Pe) e1(t);
                    else {
                        Pe = !0;
                        try {
                            Le(e1, t);
                        } finally{
                            Pe = !1, je();
                        }
                    }
                }
            }
            function ai(e1, t, n) {
                "focusin" === e1 ? (ii(), Zn = n, (Xn = t).attachEvent("onpropertychange", ri)) : "focusout" === e1 && ii();
            }
            function si(e1) {
                if ("selectionchange" === e1 || "keyup" === e1 || "keydown" === e1) return Kn(Zn);
            }
            function oi(e1, t) {
                if ("click" === e1) return Kn(t);
            }
            function li(e1, t) {
                if ("input" === e1 || "change" === e1) return Kn(t);
            }
            var ci = "function" == typeof Object.is ? Object.is : function(e1, t) {
                return e1 === t && (0 !== e1 || 1 / e1 == 1 / t) || e1 != e1 && t != t;
            }, ui = Object.prototype.hasOwnProperty;
            function hi(e1, t) {
                if (ci(e1, t)) return !0;
                if ("object" != typeof e1 || null === e1 || "object" != typeof t || null === t) return !1;
                var n = Object.keys(e1), i = Object.keys(t);
                if (n.length !== i.length) return !1;
                for(i = 0; i < n.length; i++)if (!ui.call(t, n[i]) || !ci(e1[n[i]], t[n[i]])) return !1;
                return !0;
            }
            function di(e1) {
                for(; e1 && e1.firstChild;)e1 = e1.firstChild;
                return e1;
            }
            function pi(e1, t) {
                var n, i = di(e1);
                for(e1 = 0; i;){
                    if (3 === i.nodeType) {
                        if (n = e1 + i.textContent.length, e1 <= t && n >= t) return {
                            node: i,
                            offset: t - e1
                        };
                        e1 = n;
                    }
                    e: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break e;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = di(i);
                }
            }
            function fi(e1, t) {
                return !(!e1 || !t) && (e1 === t || (!e1 || 3 !== e1.nodeType) && (t && 3 === t.nodeType ? fi(e1, t.parentNode) : "contains" in e1 ? e1.contains(t) : !!e1.compareDocumentPosition && !!(16 & e1.compareDocumentPosition(t))));
            }
            function gi() {
                for(var e1 = window, t = J(); t instanceof e1.HTMLIFrameElement;){
                    try {
                        var n = "string" == typeof t.contentWindow.location.href;
                    } catch (e1) {
                        n = !1;
                    }
                    if (!n) break;
                    t = J((e1 = t.contentWindow).document);
                }
                return t;
            }
            function mi(e1) {
                var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                return t && ("input" === t && ("text" === e1.type || "search" === e1.type || "tel" === e1.type || "url" === e1.type || "password" === e1.type) || "textarea" === t || "true" === e1.contentEditable);
            }
            var Ai = h && "documentMode" in document && 11 >= document.documentMode, Mi = null, vi = null, yi = null, xi = !1;
            function bi(e1, t, n) {
                var i = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
                xi || null == Mi || Mi !== J(i) || (i = "selectionStart" in (i = Mi) && mi(i) ? {
                    start: i.selectionStart,
                    end: i.selectionEnd
                } : {
                    anchorNode: (i = (i.ownerDocument && i.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: i.anchorOffset,
                    focusNode: i.focusNode,
                    focusOffset: i.focusOffset
                }, yi && hi(yi, i) || (yi = i, 0 < (i = Pi(vi, "onSelect")).length && (t = new dn("onSelect", "select", null, t, n), e1.push({
                    event: t,
                    listeners: i
                }), t.target = Mi)));
            }
            Ot("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Ot("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Ot(zt, 2);
            for(var wi = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Ei = 0; Ei < wi.length; Ei++)Lt.set(wi[Ei], 0);
            u("onMouseEnter", [
                "mouseout",
                "mouseover"
            ]), u("onMouseLeave", [
                "mouseout",
                "mouseover"
            ]), u("onPointerEnter", [
                "pointerout",
                "pointerover"
            ]), u("onPointerLeave", [
                "pointerout",
                "pointerover"
            ]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", [
                "compositionend",
                "keypress",
                "textInput",
                "paste"
            ]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var Ti = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Si = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ti));
            function Ii(e1, t, n) {
                var i = e1.type || "unknown-event";
                e1.currentTarget = n, function(e1, t, n, i, r, a, o, l, c) {
                    if (Xe.apply(this, arguments), Ge) {
                        if (!Ge) throw Error(s(198));
                        var u = Ve;
                        Ge = !1, Ve = null, Qe || (Qe = !0, We = u);
                    }
                }(i, t, void 0, e1), e1.currentTarget = null;
            }
            function Ni(e1, t) {
                t = !!(4 & t);
                for(var n = 0; n < e1.length; n++){
                    var i = e1[n], r = i.event;
                    i = i.listeners;
                    e: {
                        var a = void 0;
                        if (t) for(var s = i.length - 1; 0 <= s; s--){
                            var o = i[s], l = o.instance, c = o.currentTarget;
                            if (o = o.listener, l !== a && r.isPropagationStopped()) break e;
                            Ii(r, o, c), a = l;
                        }
                        else for(s = 0; s < i.length; s++){
                            if (l = (o = i[s]).instance, c = o.currentTarget, o = o.listener, l !== a && r.isPropagationStopped()) break e;
                            Ii(r, o, c), a = l;
                        }
                    }
                }
                if (Qe) throw e1 = We, Qe = !1, We = null, e1;
            }
            function Di(e1, t) {
                var n = ar(t), i = e1 + "__bubble";
                n.has(i) || (zi(t, e1, 2, !1), n.add(i));
            }
            var _i = "_reactListening" + Math.random().toString(36).slice(2);
            function Ci(e1) {
                e1[_i] || (e1[_i] = !0, o.forEach(function(t) {
                    Si.has(t) || Li(t, !1, e1, null), Li(t, !0, e1, null);
                }));
            }
            function Li(e1, t, n, i) {
                var r = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, a = n;
                if ("selectionchange" === e1 && 9 !== n.nodeType && (a = n.ownerDocument), null !== i && !t && Si.has(e1)) {
                    if ("scroll" !== e1) return;
                    r |= 2, a = i;
                }
                var s = ar(a), o = e1 + "__" + (t ? "capture" : "bubble");
                s.has(o) || (t && (r |= 4), zi(a, e1, r, t), s.add(o));
            }
            function zi(e1, t, n, i) {
                var r = Lt.get(t);
                switch(void 0 === r ? 2 : r){
                    case 0:
                        r = Zt;
                        break;
                    case 1:
                        r = qt;
                        break;
                    default:
                        r = Kt;
                }
                n = r.bind(null, t, n, e1), r = void 0, !Be || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (r = !0), i ? void 0 !== r ? e1.addEventListener(t, n, {
                    capture: !0,
                    passive: r
                }) : e1.addEventListener(t, n, !0) : void 0 !== r ? e1.addEventListener(t, n, {
                    passive: r
                }) : e1.addEventListener(t, n, !1);
            }
            function Oi(e1, t, n, i, r) {
                var a = i;
                if (!(1 & t || 2 & t || null === i)) e: for(;;){
                    if (null === i) return;
                    var s = i.tag;
                    if (3 === s || 4 === s) {
                        var o = i.stateNode.containerInfo;
                        if (o === r || 8 === o.nodeType && o.parentNode === r) break;
                        if (4 === s) for(s = i.return; null !== s;){
                            var l = s.tag;
                            if ((3 === l || 4 === l) && ((l = s.stateNode.containerInfo) === r || 8 === l.nodeType && l.parentNode === r)) return;
                            s = s.return;
                        }
                        for(; null !== o;){
                            if (null === (s = tr(o))) return;
                            if (5 === (l = s.tag) || 6 === l) {
                                i = a = s;
                                continue e;
                            }
                            o = o.parentNode;
                        }
                    }
                    i = i.return;
                }
                !function(e1, t, n) {
                    if (Ue) return e1();
                    Ue = !0;
                    try {
                        return Re(e1, t, n);
                    } finally{
                        Ue = !1, je();
                    }
                }(function() {
                    var i = a, r = Te(n), s = [];
                    e: {
                        var o = Ct.get(e1);
                        if (void 0 !== o) {
                            var l = dn, c = e1;
                            switch(e1){
                                case "keypress":
                                    if (0 === rn(n)) break e;
                                case "keydown":
                                case "keyup":
                                    l = Dn;
                                    break;
                                case "focusin":
                                    c = "focus", l = Mn;
                                    break;
                                case "focusout":
                                    c = "blur", l = Mn;
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    l = Mn;
                                    break;
                                case "click":
                                    if (2 === n.button) break e;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    l = mn;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    l = An;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    l = Cn;
                                    break;
                                case It:
                                case Nt:
                                case Dt:
                                    l = vn;
                                    break;
                                case _t:
                                    l = Ln;
                                    break;
                                case "scroll":
                                    l = fn;
                                    break;
                                case "wheel":
                                    l = On;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    l = xn;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    l = _n;
                            }
                            var u = !!(4 & t), h = !u && "scroll" === e1, d = u ? null !== o ? o + "Capture" : null : o;
                            u = [];
                            for(var p, f = i; null !== f;){
                                var g = (p = f).stateNode;
                                if (5 === p.tag && null !== g && (p = g, null !== d && null != (g = ke(f, d)) && u.push(Ri(f, g, p))), h) break;
                                f = f.return;
                            }
                            0 < u.length && (o = new l(o, c, null, n, r), s.push({
                                event: o,
                                listeners: u
                            }));
                        }
                    }
                    if (!(7 & t)) {
                        if (l = "mouseout" === e1 || "pointerout" === e1, (!(o = "mouseover" === e1 || "pointerover" === e1) || 16 & t || !(c = n.relatedTarget || n.fromElement) || !tr(c) && !c[$i]) && (l || o) && (o = r.window === r ? r : (o = r.ownerDocument) ? o.defaultView || o.parentWindow : window, l ? (l = i, null !== (c = (c = n.relatedTarget || n.toElement) ? tr(c) : null) && (c !== (h = Ze(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = i), l !== c)) {
                            if (u = mn, g = "onMouseLeave", d = "onMouseEnter", f = "mouse", "pointerout" !== e1 && "pointerover" !== e1 || (u = _n, g = "onPointerLeave", d = "onPointerEnter", f = "pointer"), h = null == l ? o : ir(l), p = null == c ? o : ir(c), (o = new u(g, f + "leave", l, n, r)).target = h, o.relatedTarget = p, g = null, tr(r) === i && ((u = new u(d, f + "enter", c, n, r)).target = p, u.relatedTarget = h, g = u), h = g, l && c) e: {
                                for(d = c, f = 0, p = u = l; p; p = Ui(p))f++;
                                for(p = 0, g = d; g; g = Ui(g))p++;
                                for(; 0 < f - p;)u = Ui(u), f--;
                                for(; 0 < p - f;)d = Ui(d), p--;
                                for(; f--;){
                                    if (u === d || null !== d && u === d.alternate) break e;
                                    u = Ui(u), d = Ui(d);
                                }
                                u = null;
                            }
                            else u = null;
                            null !== l && ji(s, o, l, u, !1), null !== c && null !== h && ji(s, h, c, u, !0);
                        }
                        if ("select" === (l = (o = i ? ir(i) : window).nodeName && o.nodeName.toLowerCase()) || "input" === l && "file" === o.type) var m = Jn;
                        else if (Wn(o)) {
                            if ($n) m = li;
                            else {
                                m = si;
                                var A = ai;
                            }
                        } else (l = o.nodeName) && "input" === l.toLowerCase() && ("checkbox" === o.type || "radio" === o.type) && (m = oi);
                        switch(m && (m = m(e1, i)) ? Yn(s, m, n, r) : (A && A(e1, o, i), "focusout" === e1 && (A = o._wrapperState) && A.controlled && "number" === o.type && re(o, "number", o.value)), A = i ? ir(i) : window, e1){
                            case "focusin":
                                (Wn(A) || "true" === A.contentEditable) && (Mi = A, vi = i, yi = null);
                                break;
                            case "focusout":
                                yi = vi = Mi = null;
                                break;
                            case "mousedown":
                                xi = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                xi = !1, bi(s, n, r);
                                break;
                            case "selectionchange":
                                if (Ai) break;
                            case "keydown":
                            case "keyup":
                                bi(s, n, r);
                        }
                        var M;
                        if (Pn) e: {
                            switch(e1){
                                case "compositionstart":
                                    var v = "onCompositionStart";
                                    break e;
                                case "compositionend":
                                    v = "onCompositionEnd";
                                    break e;
                                case "compositionupdate":
                                    v = "onCompositionUpdate";
                                    break e;
                            }
                            v = void 0;
                        }
                        else Vn ? Hn(e1, n) && (v = "onCompositionEnd") : "keydown" === e1 && 229 === n.keyCode && (v = "onCompositionStart");
                        v && (kn && "ko" !== n.locale && (Vn || "onCompositionStart" !== v ? "onCompositionEnd" === v && Vn && (M = nn()) : (en = "value" in ($t = r) ? $t.value : $t.textContent, Vn = !0)), 0 < (A = Pi(i, v)).length && (v = new bn(v, e1, null, n, r), s.push({
                            event: v,
                            listeners: A
                        }), (M || null !== (M = Gn(n))) && (v.data = M))), (M = jn ? function(e1, t) {
                            switch(e1){
                                case "compositionend":
                                    return Gn(t);
                                case "keypress":
                                    return 32 !== t.which ? null : (Fn = !0, Bn);
                                case "textInput":
                                    return (e1 = t.data) === Bn && Fn ? null : e1;
                                default:
                                    return null;
                            }
                        }(e1, n) : function(e1, t) {
                            if (Vn) return "compositionend" === e1 || !Pn && Hn(e1, t) ? (e1 = nn(), tn = en = $t = null, Vn = !1, e1) : null;
                            switch(e1){
                                case "paste":
                                default:
                                    return null;
                                case "keypress":
                                    if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                        if (t.char && 1 < t.char.length) return t.char;
                                        if (t.which) return String.fromCharCode(t.which);
                                    }
                                    return null;
                                case "compositionend":
                                    return kn && "ko" !== t.locale ? null : t.data;
                            }
                        }(e1, n)) && 0 < (i = Pi(i, "onBeforeInput")).length && (r = new bn("onBeforeInput", "beforeinput", null, n, r), s.push({
                            event: r,
                            listeners: i
                        }), r.data = M);
                    }
                    Ni(s, t);
                });
            }
            function Ri(e1, t, n) {
                return {
                    instance: e1,
                    listener: t,
                    currentTarget: n
                };
            }
            function Pi(e1, t) {
                for(var n = t + "Capture", i = []; null !== e1;){
                    var r = e1, a = r.stateNode;
                    5 === r.tag && null !== a && (r = a, null != (a = ke(e1, n)) && i.unshift(Ri(e1, a, r)), null != (a = ke(e1, t)) && i.push(Ri(e1, a, r))), e1 = e1.return;
                }
                return i;
            }
            function Ui(e1) {
                if (null === e1) return null;
                do e1 = e1.return;
                while (e1 && 5 !== e1.tag);
                return e1 || null;
            }
            function ji(e1, t, n, i, r) {
                for(var a = t._reactName, s = []; null !== n && n !== i;){
                    var o = n, l = o.alternate, c = o.stateNode;
                    if (null !== l && l === i) break;
                    5 === o.tag && null !== c && (o = c, r ? null != (l = ke(n, a)) && s.unshift(Ri(n, l, o)) : r || null != (l = ke(n, a)) && s.push(Ri(n, l, o))), n = n.return;
                }
                0 !== s.length && e1.push({
                    event: t,
                    listeners: s
                });
            }
            function ki() {}
            var Bi = null, Fi = null;
            function Hi(e1, t) {
                switch(e1){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!t.autoFocus;
                }
                return !1;
            }
            function Gi(e1, t) {
                return "textarea" === e1 || "option" === e1 || "noscript" === e1 || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
            }
            var Vi = "function" == typeof setTimeout ? setTimeout : void 0, Qi = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function Wi(e1) {
                (1 === e1.nodeType || 9 === e1.nodeType && null != (e1 = e1.body)) && (e1.textContent = "");
            }
            function Yi(e1) {
                for(; null != e1; e1 = e1.nextSibling){
                    var t = e1.nodeType;
                    if (1 === t || 3 === t) break;
                }
                return e1;
            }
            function Xi(e1) {
                e1 = e1.previousSibling;
                for(var t = 0; e1;){
                    if (8 === e1.nodeType) {
                        var n = e1.data;
                        if ("$" === n || "$!" === n || "$?" === n) {
                            if (0 === t) return e1;
                            t--;
                        } else "/$" === n && t++;
                    }
                    e1 = e1.previousSibling;
                }
                return null;
            }
            var Zi = 0, qi = Math.random().toString(36).slice(2), Ki = "__reactFiber$" + qi, Ji = "__reactProps$" + qi, $i = "__reactContainer$" + qi, er = "__reactEvents$" + qi;
            function tr(e1) {
                var t = e1[Ki];
                if (t) return t;
                for(var n = e1.parentNode; n;){
                    if (t = n[$i] || n[Ki]) {
                        if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e1 = Xi(e1); null !== e1;){
                            if (n = e1[Ki]) return n;
                            e1 = Xi(e1);
                        }
                        return t;
                    }
                    n = (e1 = n).parentNode;
                }
                return null;
            }
            function nr(e1) {
                return !(e1 = e1[Ki] || e1[$i]) || 5 !== e1.tag && 6 !== e1.tag && 13 !== e1.tag && 3 !== e1.tag ? null : e1;
            }
            function ir(e1) {
                if (5 === e1.tag || 6 === e1.tag) return e1.stateNode;
                throw Error(s(33));
            }
            function rr(e1) {
                return e1[Ji] || null;
            }
            function ar(e1) {
                var t = e1[er];
                return void 0 === t && (t = e1[er] = new Set), t;
            }
            var sr = [], or = -1;
            function lr(e1) {
                return {
                    current: e1
                };
            }
            function cr(e1) {
                0 > or || (e1.current = sr[or], sr[or] = null, or--);
            }
            function ur(e1, t) {
                or++, sr[or] = e1.current, e1.current = t;
            }
            var hr = {}, dr = lr(hr), pr = lr(!1), fr = hr;
            function gr(e1, t) {
                var n = e1.type.contextTypes;
                if (!n) return hr;
                var i = e1.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
                var r, a = {};
                for(r in n)a[r] = t[r];
                return i && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e1.__reactInternalMemoizedMaskedChildContext = a), a;
            }
            function mr(e1) {
                return null != e1.childContextTypes;
            }
            function Ar() {
                cr(pr), cr(dr);
            }
            function Mr(e1, t, n) {
                if (dr.current !== hr) throw Error(s(168));
                ur(dr, t), ur(pr, n);
            }
            function vr(e1, t, n) {
                var i = e1.stateNode;
                if (e1 = t.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var a in i = i.getChildContext())if (!(a in e1)) throw Error(s(108, Y(t) || "Unknown", a));
                return r({}, n, i);
            }
            function yr(e1) {
                return e1 = (e1 = e1.stateNode) && e1.__reactInternalMemoizedMergedChildContext || hr, fr = dr.current, ur(dr, e1), ur(pr, pr.current), !0;
            }
            function xr(e1, t, n) {
                var i = e1.stateNode;
                if (!i) throw Error(s(169));
                n ? (e1 = vr(e1, t, fr), i.__reactInternalMemoizedMergedChildContext = e1, cr(pr), cr(dr), ur(dr, e1)) : cr(pr), ur(pr, n);
            }
            var br = null, wr = null, Er = a.unstable_runWithPriority, Tr = a.unstable_scheduleCallback, Sr = a.unstable_cancelCallback, Ir = a.unstable_shouldYield, Nr = a.unstable_requestPaint, Dr = a.unstable_now, _r = a.unstable_getCurrentPriorityLevel, Cr = a.unstable_ImmediatePriority, Lr = a.unstable_UserBlockingPriority, zr = a.unstable_NormalPriority, Or = a.unstable_LowPriority, Rr = a.unstable_IdlePriority, Pr = {}, Ur = void 0 !== Nr ? Nr : function() {}, jr = null, kr = null, Br = !1, Fr = Dr(), Hr = 1e4 > Fr ? Dr : function() {
                return Dr() - Fr;
            };
            function Gr() {
                switch(_r()){
                    case Cr:
                        return 99;
                    case Lr:
                        return 98;
                    case zr:
                        return 97;
                    case Or:
                        return 96;
                    case Rr:
                        return 95;
                    default:
                        throw Error(s(332));
                }
            }
            function Vr(e1) {
                switch(e1){
                    case 99:
                        return Cr;
                    case 98:
                        return Lr;
                    case 97:
                        return zr;
                    case 96:
                        return Or;
                    case 95:
                        return Rr;
                    default:
                        throw Error(s(332));
                }
            }
            function Qr(e1, t) {
                return e1 = Vr(e1), Er(e1, t);
            }
            function Wr(e1, t, n) {
                return e1 = Vr(e1), Tr(e1, t, n);
            }
            function Yr() {
                if (null !== kr) {
                    var e1 = kr;
                    kr = null, Sr(e1);
                }
                Xr();
            }
            function Xr() {
                if (!Br && null !== jr) {
                    Br = !0;
                    var e1 = 0;
                    try {
                        var t = jr;
                        Qr(99, function() {
                            for(; e1 < t.length; e1++){
                                var n = t[e1];
                                do n = n(!0);
                                while (null !== n);
                            }
                        }), jr = null;
                    } catch (t) {
                        throw null !== jr && (jr = jr.slice(e1 + 1)), Tr(Cr, Yr), t;
                    } finally{
                        Br = !1;
                    }
                }
            }
            var Zr = x.ReactCurrentBatchConfig;
            function qr(e1, t) {
                if (e1 && e1.defaultProps) {
                    for(var n in t = r({}, t), e1 = e1.defaultProps)void 0 === t[n] && (t[n] = e1[n]);
                    return t;
                }
                return t;
            }
            var Kr = lr(null), Jr = null, $r = null, ea = null;
            function ta() {
                ea = $r = Jr = null;
            }
            function na(e1) {
                var t = Kr.current;
                cr(Kr), e1.type._context._currentValue = t;
            }
            function ia(e1, t) {
                for(; null !== e1;){
                    var n = e1.alternate;
                    if ((e1.childLanes & t) === t) {
                        if (null === n || (n.childLanes & t) === t) break;
                        n.childLanes |= t;
                    } else e1.childLanes |= t, null !== n && (n.childLanes |= t);
                    e1 = e1.return;
                }
            }
            function ra(e1, t) {
                Jr = e1, ea = $r = null, null !== (e1 = e1.dependencies) && null !== e1.firstContext && (!!(e1.lanes & t) && (Rs = !0), e1.firstContext = null);
            }
            function aa(e1, t) {
                if (ea !== e1 && !1 !== t && 0 !== t) {
                    if ("number" == typeof t && 1073741823 !== t || (ea = e1, t = 1073741823), t = {
                        context: e1,
                        observedBits: t,
                        next: null
                    }, null === $r) {
                        if (null === Jr) throw Error(s(308));
                        $r = t, Jr.dependencies = {
                            lanes: 0,
                            firstContext: t,
                            responders: null
                        };
                    } else $r = $r.next = t;
                }
                return e1._currentValue;
            }
            var sa = !1;
            function oa(e1) {
                e1.updateQueue = {
                    baseState: e1.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function la(e1, t) {
                e1 = e1.updateQueue, t.updateQueue === e1 && (t.updateQueue = {
                    baseState: e1.baseState,
                    firstBaseUpdate: e1.firstBaseUpdate,
                    lastBaseUpdate: e1.lastBaseUpdate,
                    shared: e1.shared,
                    effects: e1.effects
                });
            }
            function ca(e1, t) {
                return {
                    eventTime: e1,
                    lane: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function ua(e1, t) {
                if (null !== (e1 = e1.updateQueue)) {
                    var n = (e1 = e1.shared).pending;
                    null === n ? t.next = t : (t.next = n.next, n.next = t), e1.pending = t;
                }
            }
            function ha(e1, t) {
                var n = e1.updateQueue, i = e1.alternate;
                if (null !== i && n === (i = i.updateQueue)) {
                    var r = null, a = null;
                    if (null !== (n = n.firstBaseUpdate)) {
                        do {
                            var s = {
                                eventTime: n.eventTime,
                                lane: n.lane,
                                tag: n.tag,
                                payload: n.payload,
                                callback: n.callback,
                                next: null
                            };
                            null === a ? r = a = s : a = a.next = s, n = n.next;
                        }while (null !== n);
                        null === a ? r = a = t : a = a.next = t;
                    } else r = a = t;
                    return n = {
                        baseState: i.baseState,
                        firstBaseUpdate: r,
                        lastBaseUpdate: a,
                        shared: i.shared,
                        effects: i.effects
                    }, void (e1.updateQueue = n);
                }
                null === (e1 = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e1.next = t, n.lastBaseUpdate = t;
            }
            function da(e1, t, n, i) {
                var a = e1.updateQueue;
                sa = !1;
                var s = a.firstBaseUpdate, o = a.lastBaseUpdate, l = a.shared.pending;
                if (null !== l) {
                    a.shared.pending = null;
                    var c = l, u = c.next;
                    c.next = null, null === o ? s = u : o.next = u, o = c;
                    var h = e1.alternate;
                    if (null !== h) {
                        var d = (h = h.updateQueue).lastBaseUpdate;
                        d !== o && (null === d ? h.firstBaseUpdate = u : d.next = u, h.lastBaseUpdate = c);
                    }
                }
                if (null !== s) {
                    for(d = a.baseState, o = 0, h = u = c = null;;){
                        l = s.lane;
                        var p = s.eventTime;
                        if ((i & l) === l) {
                            null !== h && (h = h.next = {
                                eventTime: p,
                                lane: 0,
                                tag: s.tag,
                                payload: s.payload,
                                callback: s.callback,
                                next: null
                            });
                            e: {
                                var f = e1, g = s;
                                switch(l = t, p = n, g.tag){
                                    case 1:
                                        if ("function" == typeof (f = g.payload)) {
                                            d = f.call(p, d, l);
                                            break e;
                                        }
                                        d = f;
                                        break e;
                                    case 3:
                                        f.flags = -4097 & f.flags | 64;
                                    case 0:
                                        if (null == (l = "function" == typeof (f = g.payload) ? f.call(p, d, l) : f)) break e;
                                        d = r({}, d, l);
                                        break e;
                                    case 2:
                                        sa = !0;
                                }
                            }
                            null !== s.callback && (e1.flags |= 32, null === (l = a.effects) ? a.effects = [
                                s
                            ] : l.push(s));
                        } else p = {
                            eventTime: p,
                            lane: l,
                            tag: s.tag,
                            payload: s.payload,
                            callback: s.callback,
                            next: null
                        }, null === h ? (u = h = p, c = d) : h = h.next = p, o |= l;
                        if (null === (s = s.next)) {
                            if (null === (l = a.shared.pending)) break;
                            s = l.next, l.next = null, a.lastBaseUpdate = l, a.shared.pending = null;
                        }
                    }
                    null === h && (c = d), a.baseState = c, a.firstBaseUpdate = u, a.lastBaseUpdate = h, ko |= o, e1.lanes = o, e1.memoizedState = d;
                }
            }
            function pa(e1, t, n) {
                if (e1 = t.effects, t.effects = null, null !== e1) for(t = 0; t < e1.length; t++){
                    var i = e1[t], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = n, "function" != typeof r) throw Error(s(191, r));
                        r.call(i);
                    }
                }
            }
            var fa = (new i.Component).refs;
            function ga(e1, t, n, i) {
                n = null == (n = n(i, t = e1.memoizedState)) ? t : r({}, t, n), e1.memoizedState = n, 0 === e1.lanes && (e1.updateQueue.baseState = n);
            }
            var ma = {
                isMounted: function(e1) {
                    return !!(e1 = e1._reactInternals) && Ze(e1) === e1;
                },
                enqueueSetState: function(e1, t, n) {
                    e1 = e1._reactInternals;
                    var i = ul(), r = hl(e1), a = ca(i, r);
                    a.payload = t, null != n && (a.callback = n), ua(e1, a), dl(e1, r, i);
                },
                enqueueReplaceState: function(e1, t, n) {
                    e1 = e1._reactInternals;
                    var i = ul(), r = hl(e1), a = ca(i, r);
                    a.tag = 1, a.payload = t, null != n && (a.callback = n), ua(e1, a), dl(e1, r, i);
                },
                enqueueForceUpdate: function(e1, t) {
                    e1 = e1._reactInternals;
                    var n = ul(), i = hl(e1), r = ca(n, i);
                    r.tag = 2, null != t && (r.callback = t), ua(e1, r), dl(e1, i, n);
                }
            };
            function Aa(e1, t, n, i, r, a, s) {
                return "function" == typeof (e1 = e1.stateNode).shouldComponentUpdate ? e1.shouldComponentUpdate(i, a, s) : !(t.prototype && t.prototype.isPureReactComponent && hi(n, i) && hi(r, a));
            }
            function Ma(e1, t, n) {
                var i = !1, r = hr, a = t.contextType;
                return "object" == typeof a && null !== a ? a = aa(a) : (r = mr(t) ? fr : dr.current, a = (i = null != (i = t.contextTypes)) ? gr(e1, r) : hr), t = new t(n, a), e1.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = ma, e1.stateNode = t, t._reactInternals = e1, i && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e1.__reactInternalMemoizedMaskedChildContext = a), t;
            }
            function va(e1, t, n, i) {
                e1 = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e1 && ma.enqueueReplaceState(t, t.state, null);
            }
            function ya(e1, t, n, i) {
                var r = e1.stateNode;
                r.props = n, r.state = e1.memoizedState, r.refs = fa, oa(e1);
                var a = t.contextType;
                "object" == typeof a && null !== a ? r.context = aa(a) : (a = mr(t) ? fr : dr.current, r.context = gr(e1, a)), da(e1, n, r, i), r.state = e1.memoizedState, "function" == typeof (a = t.getDerivedStateFromProps) && (ga(e1, t, a, n), r.state = e1.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && ma.enqueueReplaceState(r, r.state, null), da(e1, n, r, i), r.state = e1.memoizedState), "function" == typeof r.componentDidMount && (e1.flags |= 4);
            }
            var xa = Array.isArray;
            function ba(e1, t, n) {
                if (null !== (e1 = n.ref) && "function" != typeof e1 && "object" != typeof e1) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(s(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(s(147, e1));
                        var r = "" + e1;
                        return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : (t = function(e1) {
                            var t = i.refs;
                            t === fa && (t = i.refs = {}), null === e1 ? delete t[r] : t[r] = e1;
                        }, t._stringRef = r, t);
                    }
                    if ("string" != typeof e1) throw Error(s(284));
                    if (!n._owner) throw Error(s(290, e1));
                }
                return e1;
            }
            function wa(e1, t) {
                if ("textarea" !== e1.type) throw Error(s(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t));
            }
            function Ea(e1) {
                function t(t, n) {
                    if (e1) {
                        var i = t.lastEffect;
                        null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.flags = 8;
                    }
                }
                function n(n, i) {
                    if (!e1) return null;
                    for(; null !== i;)t(n, i), i = i.sibling;
                    return null;
                }
                function i(e1, t) {
                    for(e1 = new Map; null !== t;)null !== t.key ? e1.set(t.key, t) : e1.set(t.index, t), t = t.sibling;
                    return e1;
                }
                function r(e1, t) {
                    return (e1 = Vl(e1, t)).index = 0, e1.sibling = null, e1;
                }
                function a(t, n, i) {
                    return t.index = i, e1 ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.flags = 2, n) : i : (t.flags = 2, n) : n;
                }
                function o(t) {
                    return e1 && null === t.alternate && (t.flags = 2), t;
                }
                function l(e1, t, n, i) {
                    return null === t || 6 !== t.tag ? ((t = Xl(n, e1.mode, i)).return = e1, t) : ((t = r(t, n)).return = e1, t);
                }
                function c(e1, t, n, i) {
                    return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = ba(e1, t, n), i.return = e1, i) : ((i = Ql(n.type, n.key, n.props, null, e1.mode, i)).ref = ba(e1, t, n), i.return = e1, i);
                }
                function u(e1, t, n, i) {
                    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Zl(n, e1.mode, i)).return = e1, t) : ((t = r(t, n.children || [])).return = e1, t);
                }
                function h(e1, t, n, i, a) {
                    return null === t || 7 !== t.tag ? ((t = Wl(n, e1.mode, i, a)).return = e1, t) : ((t = r(t, n)).return = e1, t);
                }
                function d(e1, t, n) {
                    if ("string" == typeof t || "number" == typeof t) return (t = Xl("" + t, e1.mode, n)).return = e1, t;
                    if ("object" == typeof t && null !== t) {
                        switch(t.$$typeof){
                            case b:
                                return (n = Ql(t.type, t.key, t.props, null, e1.mode, n)).ref = ba(e1, null, t), n.return = e1, n;
                            case w:
                                return (t = Zl(t, e1.mode, n)).return = e1, t;
                        }
                        if (xa(t) || H(t)) return (t = Wl(t, e1.mode, n, null)).return = e1, t;
                        wa(e1, t);
                    }
                    return null;
                }
                function p(e1, t, n, i) {
                    var r = null !== t ? t.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : l(e1, t, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case b:
                                return n.key === r ? n.type === E ? h(e1, t, n.props.children, i, r) : c(e1, t, n, i) : null;
                            case w:
                                return n.key === r ? u(e1, t, n, i) : null;
                        }
                        if (xa(n) || H(n)) return null !== r ? null : h(e1, t, n, i, null);
                        wa(e1, n);
                    }
                    return null;
                }
                function f(e1, t, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return l(t, e1 = e1.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case b:
                                return e1 = e1.get(null === i.key ? n : i.key) || null, i.type === E ? h(t, e1, i.props.children, r, i.key) : c(t, e1, i, r);
                            case w:
                                return u(t, e1 = e1.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (xa(i) || H(i)) return h(t, e1 = e1.get(n) || null, i, r, null);
                        wa(t, i);
                    }
                    return null;
                }
                function g(r, s, o, l) {
                    for(var c = null, u = null, h = s, g = s = 0, m = null; null !== h && g < o.length; g++){
                        h.index > g ? (m = h, h = null) : m = h.sibling;
                        var A = p(r, h, o[g], l);
                        if (null === A) {
                            null === h && (h = m);
                            break;
                        }
                        e1 && h && null === A.alternate && t(r, h), s = a(A, s, g), null === u ? c = A : u.sibling = A, u = A, h = m;
                    }
                    if (g === o.length) return n(r, h), c;
                    if (null === h) {
                        for(; g < o.length; g++)null !== (h = d(r, o[g], l)) && (s = a(h, s, g), null === u ? c = h : u.sibling = h, u = h);
                        return c;
                    }
                    for(h = i(r, h); g < o.length; g++)null !== (m = f(h, r, g, o[g], l)) && (e1 && null !== m.alternate && h.delete(null === m.key ? g : m.key), s = a(m, s, g), null === u ? c = m : u.sibling = m, u = m);
                    return e1 && h.forEach(function(e1) {
                        return t(r, e1);
                    }), c;
                }
                function m(r, o, l, c) {
                    var u = H(l);
                    if ("function" != typeof u) throw Error(s(150));
                    if (null == (l = u.call(l))) throw Error(s(151));
                    for(var h = u = null, g = o, m = o = 0, A = null, M = l.next(); null !== g && !M.done; m++, M = l.next()){
                        g.index > m ? (A = g, g = null) : A = g.sibling;
                        var v = p(r, g, M.value, c);
                        if (null === v) {
                            null === g && (g = A);
                            break;
                        }
                        e1 && g && null === v.alternate && t(r, g), o = a(v, o, m), null === h ? u = v : h.sibling = v, h = v, g = A;
                    }
                    if (M.done) return n(r, g), u;
                    if (null === g) {
                        for(; !M.done; m++, M = l.next())null !== (M = d(r, M.value, c)) && (o = a(M, o, m), null === h ? u = M : h.sibling = M, h = M);
                        return u;
                    }
                    for(g = i(r, g); !M.done; m++, M = l.next())null !== (M = f(g, r, m, M.value, c)) && (e1 && null !== M.alternate && g.delete(null === M.key ? m : M.key), o = a(M, o, m), null === h ? u = M : h.sibling = M, h = M);
                    return e1 && g.forEach(function(e1) {
                        return t(r, e1);
                    }), u;
                }
                return function(e1, i, a, l) {
                    var c = "object" == typeof a && null !== a && a.type === E && null === a.key;
                    c && (a = a.props.children);
                    var u = "object" == typeof a && null !== a;
                    if (u) switch(a.$$typeof){
                        case b:
                            e: {
                                for(u = a.key, c = i; null !== c;){
                                    if (c.key === u) {
                                        if (7 === c.tag) {
                                            if (a.type === E) {
                                                n(e1, c.sibling), (i = r(c, a.props.children)).return = e1, e1 = i;
                                                break e;
                                            }
                                        } else if (c.elementType === a.type) {
                                            n(e1, c.sibling), (i = r(c, a.props)).ref = ba(e1, c, a), i.return = e1, e1 = i;
                                            break e;
                                        }
                                        n(e1, c);
                                        break;
                                    }
                                    t(e1, c), c = c.sibling;
                                }
                                a.type === E ? ((i = Wl(a.props.children, e1.mode, l, a.key)).return = e1, e1 = i) : ((l = Ql(a.type, a.key, a.props, null, e1.mode, l)).ref = ba(e1, i, a), l.return = e1, e1 = l);
                            }
                            return o(e1);
                        case w:
                            e: {
                                for(c = a.key; null !== i;){
                                    if (i.key === c) {
                                        if (4 === i.tag && i.stateNode.containerInfo === a.containerInfo && i.stateNode.implementation === a.implementation) {
                                            n(e1, i.sibling), (i = r(i, a.children || [])).return = e1, e1 = i;
                                            break e;
                                        }
                                        n(e1, i);
                                        break;
                                    }
                                    t(e1, i), i = i.sibling;
                                }
                                (i = Zl(a, e1.mode, l)).return = e1, e1 = i;
                            }
                            return o(e1);
                    }
                    if ("string" == typeof a || "number" == typeof a) return a = "" + a, null !== i && 6 === i.tag ? (n(e1, i.sibling), (i = r(i, a)).return = e1, e1 = i) : (n(e1, i), (i = Xl(a, e1.mode, l)).return = e1, e1 = i), o(e1);
                    if (xa(a)) return g(e1, i, a, l);
                    if (H(a)) return m(e1, i, a, l);
                    if (u && wa(e1, a), void 0 === a && !c) switch(e1.tag){
                        case 1:
                        case 22:
                        case 0:
                        case 11:
                        case 15:
                            throw Error(s(152, Y(e1.type) || "Component"));
                    }
                    return n(e1, i);
                };
            }
            var Ta = Ea(!0), Sa = Ea(!1), Ia = {}, Na = lr(Ia), Da = lr(Ia), _a = lr(Ia);
            function Ca(e1) {
                if (e1 === Ia) throw Error(s(174));
                return e1;
            }
            function La(e1, t) {
                switch(ur(_a, t), ur(Da, e1), ur(Na, Ia), e1 = t.nodeType){
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : pe(null, "");
                        break;
                    default:
                        t = pe(t = (e1 = 8 === e1 ? t.parentNode : t).namespaceURI || null, e1 = e1.tagName);
                }
                cr(Na), ur(Na, t);
            }
            function za() {
                cr(Na), cr(Da), cr(_a);
            }
            function Oa(e1) {
                Ca(_a.current);
                var t = Ca(Na.current), n = pe(t, e1.type);
                t !== n && (ur(Da, e1), ur(Na, n));
            }
            function Ra(e1) {
                Da.current === e1 && (cr(Na), cr(Da));
            }
            var Pa = lr(0);
            function Ua(e1) {
                for(var t = e1; null !== t;){
                    if (13 === t.tag) {
                        var n = t.memoizedState;
                        if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
                    } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                        if (64 & t.flags) return t;
                    } else if (null !== t.child) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === e1) break;
                    for(; null === t.sibling;){
                        if (null === t.return || t.return === e1) return null;
                        t = t.return;
                    }
                    t.sibling.return = t.return, t = t.sibling;
                }
                return null;
            }
            var ja = null, ka = null, Ba = !1;
            function Fa(e1, t) {
                var n = Hl(5, null, null, 0);
                n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e1, n.flags = 8, null !== e1.lastEffect ? (e1.lastEffect.nextEffect = n, e1.lastEffect = n) : e1.firstEffect = e1.lastEffect = n;
            }
            function Ha(e1, t) {
                switch(e1.tag){
                    case 5:
                        var n = e1.type;
                        return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e1.stateNode = t, !0);
                    case 6:
                        return null !== (t = "" === e1.pendingProps || 3 !== t.nodeType ? null : t) && (e1.stateNode = t, !0);
                    default:
                        return !1;
                }
            }
            function Ga(e1) {
                if (Ba) {
                    var t = ka;
                    if (t) {
                        var n = t;
                        if (!Ha(e1, t)) {
                            if (!(t = Yi(n.nextSibling)) || !Ha(e1, t)) return e1.flags = -1025 & e1.flags | 2, Ba = !1, void (ja = e1);
                            Fa(ja, n);
                        }
                        ja = e1, ka = Yi(t.firstChild);
                    } else e1.flags = -1025 & e1.flags | 2, Ba = !1, ja = e1;
                }
            }
            function Va(e1) {
                for(e1 = e1.return; null !== e1 && 5 !== e1.tag && 3 !== e1.tag && 13 !== e1.tag;)e1 = e1.return;
                ja = e1;
            }
            function Qa(e1) {
                if (e1 !== ja) return !1;
                if (!Ba) return Va(e1), Ba = !0, !1;
                var t = e1.type;
                if (5 !== e1.tag || "head" !== t && "body" !== t && !Gi(t, e1.memoizedProps)) for(t = ka; t;)Fa(e1, t), t = Yi(t.nextSibling);
                if (Va(e1), 13 === e1.tag) {
                    if (!(e1 = null !== (e1 = e1.memoizedState) ? e1.dehydrated : null)) throw Error(s(317));
                    e: {
                        for(e1 = e1.nextSibling, t = 0; e1;){
                            if (8 === e1.nodeType) {
                                var n = e1.data;
                                if ("/$" === n) {
                                    if (0 === t) {
                                        ka = Yi(e1.nextSibling);
                                        break e;
                                    }
                                    t--;
                                } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                            }
                            e1 = e1.nextSibling;
                        }
                        ka = null;
                    }
                } else ka = ja ? Yi(e1.stateNode.nextSibling) : null;
                return !0;
            }
            function Wa() {
                ka = ja = null, Ba = !1;
            }
            var Ya = [];
            function Xa() {
                for(var e1 = 0; e1 < Ya.length; e1++)Ya[e1]._workInProgressVersionPrimary = null;
                Ya.length = 0;
            }
            var Za = x.ReactCurrentDispatcher, qa = x.ReactCurrentBatchConfig, Ka = 0, Ja = null, $a = null, es = null, ts = !1, ns = !1;
            function is() {
                throw Error(s(321));
            }
            function rs(e1, t) {
                if (null === t) return !1;
                for(var n = 0; n < t.length && n < e1.length; n++)if (!ci(e1[n], t[n])) return !1;
                return !0;
            }
            function as(e1, t, n, i, r, a) {
                if (Ka = a, Ja = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Za.current = null === e1 || null === e1.memoizedState ? Cs : Ls, e1 = n(i, r), ns) {
                    a = 0;
                    do {
                        if (ns = !1, !(25 > a)) throw Error(s(301));
                        a += 1, es = $a = null, t.updateQueue = null, Za.current = zs, e1 = n(i, r);
                    }while (ns);
                }
                if (Za.current = _s, t = null !== $a && null !== $a.next, Ka = 0, es = $a = Ja = null, ts = !1, t) throw Error(s(300));
                return e1;
            }
            function ss() {
                var e1 = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === es ? Ja.memoizedState = es = e1 : es = es.next = e1, es;
            }
            function os() {
                if (null === $a) {
                    var e1 = Ja.alternate;
                    e1 = null !== e1 ? e1.memoizedState : null;
                } else e1 = $a.next;
                var t = null === es ? Ja.memoizedState : es.next;
                if (null !== t) es = t, $a = e1;
                else {
                    if (null === e1) throw Error(s(310));
                    e1 = {
                        memoizedState: ($a = e1).memoizedState,
                        baseState: $a.baseState,
                        baseQueue: $a.baseQueue,
                        queue: $a.queue,
                        next: null
                    }, null === es ? Ja.memoizedState = es = e1 : es = es.next = e1;
                }
                return es;
            }
            function ls(e1, t) {
                return "function" == typeof t ? t(e1) : t;
            }
            function cs(e1) {
                var t = os(), n = t.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = e1;
                var i = $a, r = i.baseQueue, a = n.pending;
                if (null !== a) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = a.next, a.next = o;
                    }
                    i.baseQueue = r = a, n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var l = o = a = null, c = r;
                    do {
                        var u = c.lane;
                        if ((Ka & u) === u) null !== l && (l = l.next = {
                            lane: 0,
                            action: c.action,
                            eagerReducer: c.eagerReducer,
                            eagerState: c.eagerState,
                            next: null
                        }), i = c.eagerReducer === e1 ? c.eagerState : e1(i, c.action);
                        else {
                            var h = {
                                lane: u,
                                action: c.action,
                                eagerReducer: c.eagerReducer,
                                eagerState: c.eagerState,
                                next: null
                            };
                            null === l ? (o = l = h, a = i) : l = l.next = h, Ja.lanes |= u, ko |= u;
                        }
                        c = c.next;
                    }while (null !== c && c !== r);
                    null === l ? a = i : l.next = o, ci(i, t.memoizedState) || (Rs = !0), t.memoizedState = i, t.baseState = a, t.baseQueue = l, n.lastRenderedState = i;
                }
                return [
                    t.memoizedState,
                    n.dispatch
                ];
            }
            function us(e1) {
                var t = os(), n = t.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = e1;
                var i = n.dispatch, r = n.pending, a = t.memoizedState;
                if (null !== r) {
                    n.pending = null;
                    var o = r = r.next;
                    do a = e1(a, o.action), o = o.next;
                    while (o !== r);
                    ci(a, t.memoizedState) || (Rs = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), n.lastRenderedState = a;
                }
                return [
                    a,
                    i
                ];
            }
            function hs(e1, t, n) {
                var i = t._getVersion;
                i = i(t._source);
                var r = t._workInProgressVersionPrimary;
                if (null !== r ? e1 = r === i : (e1 = e1.mutableReadLanes, (e1 = (Ka & e1) === e1) && (t._workInProgressVersionPrimary = i, Ya.push(t))), e1) return n(t._source);
                throw Ya.push(t), Error(s(350));
            }
            function ds(e1, t, n, i) {
                var r = Co;
                if (null === r) throw Error(s(349));
                var a = t._getVersion, o = a(t._source), l = Za.current, c = l.useState(function() {
                    return hs(r, t, n);
                }), u = c[1], h = c[0];
                c = es;
                var d = e1.memoizedState, p = d.refs, f = p.getSnapshot, g = d.source;
                d = d.subscribe;
                var m = Ja;
                return e1.memoizedState = {
                    refs: p,
                    source: t,
                    subscribe: i
                }, l.useEffect(function() {
                    p.getSnapshot = n, p.setSnapshot = u;
                    var e1 = a(t._source);
                    if (!ci(o, e1)) {
                        e1 = n(t._source), ci(h, e1) || (u(e1), e1 = hl(m), r.mutableReadLanes |= e1 & r.pendingLanes), e1 = r.mutableReadLanes, r.entangledLanes |= e1;
                        for(var i = r.entanglements, s = e1; 0 < s;){
                            var l = 31 - Gt(s), c = 1 << l;
                            i[l] |= e1, s &= ~c;
                        }
                    }
                }, [
                    n,
                    t,
                    i
                ]), l.useEffect(function() {
                    return i(t._source, function() {
                        var e1 = p.getSnapshot, n = p.setSnapshot;
                        try {
                            n(e1(t._source));
                            var i = hl(m);
                            r.mutableReadLanes |= i & r.pendingLanes;
                        } catch (e1) {
                            n(function() {
                                throw e1;
                            });
                        }
                    });
                }, [
                    t,
                    i
                ]), ci(f, n) && ci(g, t) && ci(d, i) || ((e1 = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: h
                }).dispatch = u = Ds.bind(null, Ja, e1), c.queue = e1, c.baseQueue = null, h = hs(r, t, n), c.memoizedState = c.baseState = h), h;
            }
            function ps(e1, t, n) {
                return ds(os(), e1, t, n);
            }
            function fs(e1) {
                var t = ss();
                return "function" == typeof e1 && (e1 = e1()), t.memoizedState = t.baseState = e1, e1 = (e1 = t.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: e1
                }).dispatch = Ds.bind(null, Ja, e1), [
                    t.memoizedState,
                    e1
                ];
            }
            function gs(e1, t, n, i) {
                return e1 = {
                    tag: e1,
                    create: t,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (t = Ja.updateQueue) ? (t = {
                    lastEffect: null
                }, Ja.updateQueue = t, t.lastEffect = e1.next = e1) : null === (n = t.lastEffect) ? t.lastEffect = e1.next = e1 : (i = n.next, n.next = e1, e1.next = i, t.lastEffect = e1), e1;
            }
            function ms(e1) {
                return e1 = {
                    current: e1
                }, ss().memoizedState = e1;
            }
            function As() {
                return os().memoizedState;
            }
            function Ms(e1, t, n, i) {
                var r = ss();
                Ja.flags |= e1, r.memoizedState = gs(1 | t, n, void 0, void 0 === i ? null : i);
            }
            function vs(e1, t, n, i) {
                var r = os();
                i = void 0 === i ? null : i;
                var a = void 0;
                if (null !== $a) {
                    var s = $a.memoizedState;
                    if (a = s.destroy, null !== i && rs(i, s.deps)) return void gs(t, n, a, i);
                }
                Ja.flags |= e1, r.memoizedState = gs(1 | t, n, a, i);
            }
            function ys(e1, t) {
                return Ms(516, 4, e1, t);
            }
            function xs(e1, t) {
                return vs(516, 4, e1, t);
            }
            function bs(e1, t) {
                return vs(4, 2, e1, t);
            }
            function ws(e1, t) {
                return "function" == typeof t ? (e1 = e1(), t(e1), function() {
                    t(null);
                }) : null != t ? (e1 = e1(), t.current = e1, function() {
                    t.current = null;
                }) : void 0;
            }
            function Es(e1, t, n) {
                return n = null != n ? n.concat([
                    e1
                ]) : null, vs(4, 2, ws.bind(null, t, e1), n);
            }
            function Ts() {}
            function Ss(e1, t) {
                var n = os();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && rs(t, i[1]) ? i[0] : (n.memoizedState = [
                    e1,
                    t
                ], e1);
            }
            function Is(e1, t) {
                var n = os();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && rs(t, i[1]) ? i[0] : (e1 = e1(), n.memoizedState = [
                    e1,
                    t
                ], e1);
            }
            function Ns(e1, t) {
                var n = Gr();
                Qr(98 > n ? 98 : n, function() {
                    e1(!0);
                }), Qr(97 < n ? 97 : n, function() {
                    var n = qa.transition;
                    qa.transition = 1;
                    try {
                        e1(!1), t();
                    } finally{
                        qa.transition = n;
                    }
                });
            }
            function Ds(e1, t, n) {
                var i = ul(), r = hl(e1), a = {
                    lane: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, s = t.pending;
                if (null === s ? a.next = a : (a.next = s.next, s.next = a), t.pending = a, s = e1.alternate, e1 === Ja || null !== s && s === Ja) ns = ts = !0;
                else {
                    if (0 === e1.lanes && (null === s || 0 === s.lanes) && null !== (s = t.lastRenderedReducer)) try {
                        var o = t.lastRenderedState, l = s(o, n);
                        if (a.eagerReducer = s, a.eagerState = l, ci(l, o)) return;
                    } catch (e1) {}
                    dl(e1, r, i);
                }
            }
            var _s = {
                readContext: aa,
                useCallback: is,
                useContext: is,
                useEffect: is,
                useImperativeHandle: is,
                useLayoutEffect: is,
                useMemo: is,
                useReducer: is,
                useRef: is,
                useState: is,
                useDebugValue: is,
                useDeferredValue: is,
                useTransition: is,
                useMutableSource: is,
                useOpaqueIdentifier: is,
                unstable_isNewReconciler: !1
            }, Cs = {
                readContext: aa,
                useCallback: function(e1, t) {
                    return ss().memoizedState = [
                        e1,
                        void 0 === t ? null : t
                    ], e1;
                },
                useContext: aa,
                useEffect: ys,
                useImperativeHandle: function(e1, t, n) {
                    return n = null != n ? n.concat([
                        e1
                    ]) : null, Ms(4, 2, ws.bind(null, t, e1), n);
                },
                useLayoutEffect: function(e1, t) {
                    return Ms(4, 2, e1, t);
                },
                useMemo: function(e1, t) {
                    var n = ss();
                    return t = void 0 === t ? null : t, e1 = e1(), n.memoizedState = [
                        e1,
                        t
                    ], e1;
                },
                useReducer: function(e1, t, n) {
                    var i = ss();
                    return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e1 = (e1 = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: e1,
                        lastRenderedState: t
                    }).dispatch = Ds.bind(null, Ja, e1), [
                        i.memoizedState,
                        e1
                    ];
                },
                useRef: ms,
                useState: fs,
                useDebugValue: Ts,
                useDeferredValue: function(e1) {
                    var t = fs(e1), n = t[0], i = t[1];
                    return ys(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = fs(!1), t = e1[0];
                    return ms(e1 = Ns.bind(null, e1[1])), [
                        e1,
                        t
                    ];
                },
                useMutableSource: function(e1, t, n) {
                    var i = ss();
                    return i.memoizedState = {
                        refs: {
                            getSnapshot: t,
                            setSnapshot: null
                        },
                        source: e1,
                        subscribe: n
                    }, ds(i, e1, t, n);
                },
                useOpaqueIdentifier: function() {
                    if (Ba) {
                        var e1 = !1, t = function(e1) {
                            return {
                                $$typeof: R,
                                toString: e1,
                                valueOf: e1
                            };
                        }(function() {
                            throw e1 || (e1 = !0, n("r:" + (Zi++).toString(36))), Error(s(355));
                        }), n = fs(t)[1];
                        return !(2 & Ja.mode) && (Ja.flags |= 516, gs(5, function() {
                            n("r:" + (Zi++).toString(36));
                        }, void 0, null)), t;
                    }
                    return fs(t = "r:" + (Zi++).toString(36)), t;
                },
                unstable_isNewReconciler: !1
            }, Ls = {
                readContext: aa,
                useCallback: Ss,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Es,
                useLayoutEffect: bs,
                useMemo: Is,
                useReducer: cs,
                useRef: As,
                useState: function() {
                    return cs(ls);
                },
                useDebugValue: Ts,
                useDeferredValue: function(e1) {
                    var t = cs(ls), n = t[0], i = t[1];
                    return xs(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = cs(ls)[0];
                    return [
                        As().current,
                        e1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return cs(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, zs = {
                readContext: aa,
                useCallback: Ss,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: Es,
                useLayoutEffect: bs,
                useMemo: Is,
                useReducer: us,
                useRef: As,
                useState: function() {
                    return us(ls);
                },
                useDebugValue: Ts,
                useDeferredValue: function(e1) {
                    var t = us(ls), n = t[0], i = t[1];
                    return xs(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = us(ls)[0];
                    return [
                        As().current,
                        e1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return us(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Os = x.ReactCurrentOwner, Rs = !1;
            function Ps(e1, t, n, i) {
                t.child = null === e1 ? Sa(t, null, n, i) : Ta(t, e1.child, n, i);
            }
            function Us(e1, t, n, i, r) {
                n = n.render;
                var a = t.ref;
                return ra(t, r), i = as(e1, t, n, i, a, r), null === e1 || Rs ? (t.flags |= 1, Ps(e1, t, i, r), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -517, e1.lanes &= ~r, no(e1, t, r));
            }
            function js(e1, t, n, i, r, a) {
                if (null === e1) {
                    var s = n.type;
                    return "function" != typeof s || Gl(s) || void 0 !== s.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e1 = Ql(n.type, null, i, t, t.mode, a)).ref = t.ref, e1.return = t, t.child = e1) : (t.tag = 15, t.type = s, ks(e1, t, s, i, r, a));
                }
                return s = e1.child, r & a || (r = s.memoizedProps, !(n = null !== (n = n.compare) ? n : hi)(r, i) || e1.ref !== t.ref) ? (t.flags |= 1, (e1 = Vl(s, i)).ref = t.ref, e1.return = t, t.child = e1) : no(e1, t, a);
            }
            function ks(e1, t, n, i, r, a) {
                if (null !== e1 && hi(e1.memoizedProps, i) && e1.ref === t.ref) {
                    if (Rs = !1, !(a & r)) return t.lanes = e1.lanes, no(e1, t, a);
                    16384 & e1.flags && (Rs = !0);
                }
                return Hs(e1, t, n, i, a);
            }
            function Bs(e1, t, n) {
                var i = t.pendingProps, r = i.children, a = null !== e1 ? e1.memoizedState : null;
                if ("hidden" === i.mode || "unstable-defer-without-hiding" === i.mode) {
                    if (4 & t.mode) {
                        if (!(1073741824 & n)) return e1 = null !== a ? a.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                            baseLanes: e1
                        }, yl(0, e1), null;
                        t.memoizedState = {
                            baseLanes: 0
                        }, yl(0, null !== a ? a.baseLanes : n);
                    } else t.memoizedState = {
                        baseLanes: 0
                    }, yl(0, n);
                } else null !== a ? (i = a.baseLanes | n, t.memoizedState = null) : i = n, yl(0, i);
                return Ps(e1, t, r, n), t.child;
            }
            function Fs(e1, t) {
                var n = t.ref;
                (null === e1 && null !== n || null !== e1 && e1.ref !== n) && (t.flags |= 128);
            }
            function Hs(e1, t, n, i, r) {
                var a = mr(n) ? fr : dr.current;
                return a = gr(t, a), ra(t, r), n = as(e1, t, n, i, a, r), null === e1 || Rs ? (t.flags |= 1, Ps(e1, t, n, r), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -517, e1.lanes &= ~r, no(e1, t, r));
            }
            function Gs(e1, t, n, i, r) {
                if (mr(n)) {
                    var a = !0;
                    yr(t);
                } else a = !1;
                if (ra(t, r), null === t.stateNode) null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), Ma(t, n, i), ya(t, n, i, r), i = !0;
                else if (null === e1) {
                    var s = t.stateNode, o = t.memoizedProps;
                    s.props = o;
                    var l = s.context, c = n.contextType;
                    c = "object" == typeof c && null !== c ? aa(c) : gr(t, c = mr(n) ? fr : dr.current);
                    var u = n.getDerivedStateFromProps, h = "function" == typeof u || "function" == typeof s.getSnapshotBeforeUpdate;
                    h || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== i || l !== c) && va(t, s, i, c), sa = !1;
                    var d = t.memoizedState;
                    s.state = d, da(t, i, s, r), l = t.memoizedState, o !== i || d !== l || pr.current || sa ? ("function" == typeof u && (ga(t, n, u, i), l = t.memoizedState), (o = sa || Aa(t, n, o, i, d, l, c)) ? (h || "function" != typeof s.UNSAFE_componentWillMount && "function" != typeof s.componentWillMount || ("function" == typeof s.componentWillMount && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && s.UNSAFE_componentWillMount()), "function" == typeof s.componentDidMount && (t.flags |= 4)) : ("function" == typeof s.componentDidMount && (t.flags |= 4), t.memoizedProps = i, t.memoizedState = l), s.props = i, s.state = l, s.context = c, i = o) : ("function" == typeof s.componentDidMount && (t.flags |= 4), i = !1);
                } else {
                    s = t.stateNode, la(e1, t), o = t.memoizedProps, c = t.type === t.elementType ? o : qr(t.type, o), s.props = c, h = t.pendingProps, d = s.context, l = "object" == typeof (l = n.contextType) && null !== l ? aa(l) : gr(t, l = mr(n) ? fr : dr.current);
                    var p = n.getDerivedStateFromProps;
                    (u = "function" == typeof p || "function" == typeof s.getSnapshotBeforeUpdate) || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== h || d !== l) && va(t, s, i, l), sa = !1, d = t.memoizedState, s.state = d, da(t, i, s, r);
                    var f = t.memoizedState;
                    o !== h || d !== f || pr.current || sa ? ("function" == typeof p && (ga(t, n, p, i), f = t.memoizedState), (c = sa || Aa(t, n, c, i, d, f, l)) ? (u || "function" != typeof s.UNSAFE_componentWillUpdate && "function" != typeof s.componentWillUpdate || ("function" == typeof s.componentWillUpdate && s.componentWillUpdate(i, f, l), "function" == typeof s.UNSAFE_componentWillUpdate && s.UNSAFE_componentWillUpdate(i, f, l)), "function" == typeof s.componentDidUpdate && (t.flags |= 4), "function" == typeof s.getSnapshotBeforeUpdate && (t.flags |= 256)) : ("function" != typeof s.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 256), t.memoizedProps = i, t.memoizedState = f), s.props = i, s.state = f, s.context = l, i = c) : ("function" != typeof s.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 256), i = !1);
                }
                return Vs(e1, t, n, i, a, r);
            }
            function Vs(e1, t, n, i, r, a) {
                Fs(e1, t);
                var s = !!(64 & t.flags);
                if (!i && !s) return r && xr(t, n, !1), no(e1, t, a);
                i = t.stateNode, Os.current = t;
                var o = s && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return t.flags |= 1, null !== e1 && s ? (t.child = Ta(t, e1.child, null, a), t.child = Ta(t, null, o, a)) : Ps(e1, t, o, a), t.memoizedState = i.state, r && xr(t, n, !0), t.child;
            }
            function Qs(e1) {
                var t = e1.stateNode;
                t.pendingContext ? Mr(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Mr(0, t.context, !1), La(e1, t.containerInfo);
            }
            var Ws, Ys, Xs, Zs, qs = {
                dehydrated: null,
                retryLane: 0
            };
            function Ks(e1, t, n) {
                var i, r = t.pendingProps, a = Pa.current, s = !1;
                return (i = !!(64 & t.flags)) || (i = (null === e1 || null !== e1.memoizedState) && !!(2 & a)), i ? (s = !0, t.flags &= -65) : null !== e1 && null === e1.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (a |= 1), ur(Pa, 1 & a), null === e1 ? (void 0 !== r.fallback && Ga(t), e1 = r.children, a = r.fallback, s ? (e1 = Js(t, e1, a, n), t.child.memoizedState = {
                    baseLanes: n
                }, t.memoizedState = qs, e1) : "number" == typeof r.unstable_expectedLoadTime ? (e1 = Js(t, e1, a, n), t.child.memoizedState = {
                    baseLanes: n
                }, t.memoizedState = qs, t.lanes = 33554432, e1) : ((n = Yl({
                    mode: "visible",
                    children: e1
                }, t.mode, n, null)).return = t, t.child = n)) : (e1.memoizedState, s ? (r = function(e1, t, n, i, r) {
                    var a = t.mode, s = e1.child;
                    e1 = s.sibling;
                    var o = {
                        mode: "hidden",
                        children: n
                    };
                    return 2 & a || t.child === s ? n = Vl(s, o) : ((n = t.child).childLanes = 0, n.pendingProps = o, null !== (s = n.lastEffect) ? (t.firstEffect = n.firstEffect, t.lastEffect = s, s.nextEffect = null) : t.firstEffect = t.lastEffect = null), null !== e1 ? i = Vl(e1, i) : (i = Wl(i, a, r, null)).flags |= 2, i.return = t, n.return = t, n.sibling = i, t.child = n, i;
                }(e1, t, r.children, r.fallback, n), s = t.child, a = e1.child.memoizedState, s.memoizedState = null === a ? {
                    baseLanes: n
                } : {
                    baseLanes: a.baseLanes | n
                }, s.childLanes = e1.childLanes & ~n, t.memoizedState = qs, r) : (n = function(e1, t, n, i) {
                    var r = e1.child;
                    return e1 = r.sibling, n = Vl(r, {
                        mode: "visible",
                        children: n
                    }), !(2 & t.mode) && (n.lanes = i), n.return = t, n.sibling = null, null !== e1 && (e1.nextEffect = null, e1.flags = 8, t.firstEffect = t.lastEffect = e1), t.child = n;
                }(e1, t, r.children, n), t.memoizedState = null, n));
            }
            function Js(e1, t, n, i) {
                var r = e1.mode, a = e1.child;
                return t = {
                    mode: "hidden",
                    children: t
                }, 2 & r || null === a ? a = Yl(t, r, 0, null) : (a.childLanes = 0, a.pendingProps = t), n = Wl(n, r, i, null), a.return = e1, n.return = e1, a.sibling = n, e1.child = a, n;
            }
            function $s(e1, t) {
                e1.lanes |= t;
                var n = e1.alternate;
                null !== n && (n.lanes |= t), ia(e1.return, t);
            }
            function eo(e1, t, n, i, r, a) {
                var s = e1.memoizedState;
                null === s ? e1.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailMode: r,
                    lastEffect: a
                } : (s.isBackwards = t, s.rendering = null, s.renderingStartTime = 0, s.last = i, s.tail = n, s.tailMode = r, s.lastEffect = a);
            }
            function to(e1, t, n) {
                var i = t.pendingProps, r = i.revealOrder, a = i.tail;
                if (Ps(e1, t, i.children, n), 2 & (i = Pa.current)) i = 1 & i | 2, t.flags |= 64;
                else {
                    if (null !== e1 && 64 & e1.flags) e: for(e1 = t.child; null !== e1;){
                        if (13 === e1.tag) null !== e1.memoizedState && $s(e1, n);
                        else if (19 === e1.tag) $s(e1, n);
                        else if (null !== e1.child) {
                            e1.child.return = e1, e1 = e1.child;
                            continue;
                        }
                        if (e1 === t) break e;
                        for(; null === e1.sibling;){
                            if (null === e1.return || e1.return === t) break e;
                            e1 = e1.return;
                        }
                        e1.sibling.return = e1.return, e1 = e1.sibling;
                    }
                    i &= 1;
                }
                if (ur(Pa, i), 2 & t.mode) switch(r){
                    case "forwards":
                        for(n = t.child, r = null; null !== n;)null !== (e1 = n.alternate) && null === Ua(e1) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), eo(t, !1, r, n, a, t.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = t.child, t.child = null; null !== r;){
                            if (null !== (e1 = r.alternate) && null === Ua(e1)) {
                                t.child = r;
                                break;
                            }
                            e1 = r.sibling, r.sibling = n, n = r, r = e1;
                        }
                        eo(t, !0, n, null, a, t.lastEffect);
                        break;
                    case "together":
                        eo(t, !1, null, null, void 0, t.lastEffect);
                        break;
                    default:
                        t.memoizedState = null;
                }
                else t.memoizedState = null;
                return t.child;
            }
            function no(e1, t, n) {
                if (null !== e1 && (t.dependencies = e1.dependencies), ko |= t.lanes, n & t.childLanes) {
                    if (null !== e1 && t.child !== e1.child) throw Error(s(153));
                    if (null !== t.child) {
                        for(n = Vl(e1 = t.child, e1.pendingProps), t.child = n, n.return = t; null !== e1.sibling;)e1 = e1.sibling, (n = n.sibling = Vl(e1, e1.pendingProps)).return = t;
                        n.sibling = null;
                    }
                    return t.child;
                }
                return null;
            }
            function io(e1, t) {
                if (!Ba) switch(e1.tailMode){
                    case "hidden":
                        t = e1.tail;
                        for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                        null === n ? e1.tail = null : n.sibling = null;
                        break;
                    case "collapsed":
                        n = e1.tail;
                        for(var i = null; null !== n;)null !== n.alternate && (i = n), n = n.sibling;
                        null === i ? t || null === e1.tail ? e1.tail = null : e1.tail.sibling = null : i.sibling = null;
                }
            }
            function ro(e1, t, n) {
                var i = t.pendingProps;
                switch(t.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                    case 17:
                        return mr(t.type) && Ar(), null;
                    case 3:
                        return za(), cr(pr), cr(dr), Xa(), (i = t.stateNode).pendingContext && (i.context = i.pendingContext, i.pendingContext = null), null !== e1 && null !== e1.child || (Qa(t) ? t.flags |= 4 : i.hydrate || (t.flags |= 256)), Ys(t), null;
                    case 5:
                        Ra(t);
                        var a = Ca(_a.current);
                        if (n = t.type, null !== e1 && null != t.stateNode) Xs(e1, t, n, i, a), e1.ref !== t.ref && (t.flags |= 128);
                        else {
                            if (!i) {
                                if (null === t.stateNode) throw Error(s(166));
                                return null;
                            }
                            if (e1 = Ca(Na.current), Qa(t)) {
                                i = t.stateNode, n = t.type;
                                var o = t.memoizedProps;
                                switch(i[Ki] = t, i[Ji] = o, n){
                                    case "dialog":
                                        Di("cancel", i), Di("close", i);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Di("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(e1 = 0; e1 < Ti.length; e1++)Di(Ti[e1], i);
                                        break;
                                    case "source":
                                        Di("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Di("error", i), Di("load", i);
                                        break;
                                    case "details":
                                        Di("toggle", i);
                                        break;
                                    case "input":
                                        ee(i, o), Di("invalid", i);
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Di("invalid", i);
                                        break;
                                    case "textarea":
                                        le(i, o), Di("invalid", i);
                                }
                                for(var c in we(n, o), e1 = null, o)o.hasOwnProperty(c) && (a = o[c], "children" === c ? "string" == typeof a ? i.textContent !== a && (e1 = [
                                    "children",
                                    a
                                ]) : "number" == typeof a && i.textContent !== "" + a && (e1 = [
                                    "children",
                                    "" + a
                                ]) : l.hasOwnProperty(c) && null != a && "onScroll" === c && Di("scroll", i));
                                switch(n){
                                    case "input":
                                        q(i), ie(i, o, !0);
                                        break;
                                    case "textarea":
                                        q(i), ue(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = ki);
                                }
                                i = e1, t.updateQueue = i, null !== i && (t.flags |= 4);
                            } else {
                                switch(c = 9 === a.nodeType ? a : a.ownerDocument, e1 === he.html && (e1 = de(n)), e1 === he.html ? "script" === n ? ((e1 = c.createElement("div")).innerHTML = "<script><\/script>", e1 = e1.removeChild(e1.firstChild)) : "string" == typeof i.is ? e1 = c.createElement(n, {
                                    is: i.is
                                }) : (e1 = c.createElement(n), "select" === n && (c = e1, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : e1 = c.createElementNS(e1, n), e1[Ki] = t, e1[Ji] = i, Ws(e1, t, !1, !1), t.stateNode = e1, c = Ee(n, i), n){
                                    case "dialog":
                                        Di("cancel", e1), Di("close", e1), a = i;
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Di("load", e1), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ti.length; a++)Di(Ti[a], e1);
                                        a = i;
                                        break;
                                    case "source":
                                        Di("error", e1), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Di("error", e1), Di("load", e1), a = i;
                                        break;
                                    case "details":
                                        Di("toggle", e1), a = i;
                                        break;
                                    case "input":
                                        ee(e1, i), a = $(e1, i), Di("invalid", e1);
                                        break;
                                    case "option":
                                        a = ae(e1, i);
                                        break;
                                    case "select":
                                        e1._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Di("invalid", e1);
                                        break;
                                    case "textarea":
                                        le(e1, i), a = oe(e1, i), Di("invalid", e1);
                                        break;
                                    default:
                                        a = i;
                                }
                                we(n, a);
                                var u = a;
                                for(o in u)if (u.hasOwnProperty(o)) {
                                    var h = u[o];
                                    "style" === o ? xe(e1, h) : "dangerouslySetInnerHTML" === o ? null != (h = h ? h.__html : void 0) && me(e1, h) : "children" === o ? "string" == typeof h ? ("textarea" !== n || "" !== h) && Ae(e1, h) : "number" == typeof h && Ae(e1, "" + h) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (l.hasOwnProperty(o) ? null != h && "onScroll" === o && Di("scroll", e1) : null != h && y(e1, o, h, c));
                                }
                                switch(n){
                                    case "input":
                                        q(e1), ie(e1, i, !1);
                                        break;
                                    case "textarea":
                                        q(e1), ue(e1);
                                        break;
                                    case "option":
                                        null != i.value && e1.setAttribute("value", "" + X(i.value));
                                        break;
                                    case "select":
                                        e1.multiple = !!i.multiple, null != (o = i.value) ? se(e1, !!i.multiple, o, !1) : null != i.defaultValue && se(e1, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (e1.onclick = ki);
                                }
                                Hi(n, i) && (t.flags |= 4);
                            }
                            null !== t.ref && (t.flags |= 128);
                        }
                        return null;
                    case 6:
                        if (e1 && null != t.stateNode) Zs(e1, t, e1.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === t.stateNode) throw Error(s(166));
                            n = Ca(_a.current), Ca(Na.current), Qa(t) ? (i = t.stateNode, n = t.memoizedProps, i[Ki] = t, i.nodeValue !== n && (t.flags |= 4)) : ((i = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ki] = t, t.stateNode = i);
                        }
                        return null;
                    case 13:
                        return cr(Pa), i = t.memoizedState, 64 & t.flags ? (t.lanes = n, t) : (i = null !== i, n = !1, null === e1 ? void 0 !== t.memoizedProps.fallback && Qa(t) : n = null !== e1.memoizedState, i && !n && 2 & t.mode && (null === e1 && !0 !== t.memoizedProps.unstable_avoidThisFallback || 1 & Pa.current ? 0 === Po && (Po = 3) : (0 !== Po && 3 !== Po || (Po = 4), null === Co || !(134217727 & ko) && !(134217727 & Bo) || ml(Co, zo))), (i || n) && (t.flags |= 4), null);
                    case 4:
                        return za(), Ys(t), null === e1 && Ci(t.stateNode.containerInfo), null;
                    case 10:
                        return na(t), null;
                    case 19:
                        if (cr(Pa), null === (i = t.memoizedState)) return null;
                        if (o = !!(64 & t.flags), null === (c = i.rendering)) {
                            if (o) io(i, !1);
                            else {
                                if (0 !== Po || null !== e1 && 64 & e1.flags) for(e1 = t.child; null !== e1;){
                                    if (null !== (c = Ua(e1))) {
                                        for(t.flags |= 64, io(i, !1), null !== (o = c.updateQueue) && (t.updateQueue = o, t.flags |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = n, n = t.child; null !== n;)e1 = i, (o = n).flags &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childLanes = 0, o.lanes = e1, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = c.childLanes, o.lanes = c.lanes, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, o.type = c.type, e1 = c.dependencies, o.dependencies = null === e1 ? null : {
                                            lanes: e1.lanes,
                                            firstContext: e1.firstContext
                                        }), n = n.sibling;
                                        return ur(Pa, 1 & Pa.current | 2), t.child;
                                    }
                                    e1 = e1.sibling;
                                }
                                null !== i.tail && Hr() > Vo && (t.flags |= 64, o = !0, io(i, !1), t.lanes = 33554432);
                            }
                        } else {
                            if (!o) {
                                if (null !== (e1 = Ua(c))) {
                                    if (t.flags |= 64, o = !0, null !== (n = e1.updateQueue) && (t.updateQueue = n, t.flags |= 4), io(i, !0), null === i.tail && "hidden" === i.tailMode && !c.alternate && !Ba) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
                                } else 2 * Hr() - i.renderingStartTime > Vo && 1073741824 !== n && (t.flags |= 64, o = !0, io(i, !1), t.lanes = 33554432);
                            }
                            i.isBackwards ? (c.sibling = t.child, t.child = c) : (null !== (n = i.last) ? n.sibling = c : t.child = c, i.last = c);
                        }
                        return null !== i.tail ? (n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = Hr(), n.sibling = null, t = Pa.current, ur(Pa, o ? 1 & t | 2 : 1 & t), n) : null;
                    case 23:
                    case 24:
                        return xl(), null !== e1 && null !== e1.memoizedState != (null !== t.memoizedState) && "unstable-defer-without-hiding" !== i.mode && (t.flags |= 4), null;
                }
                throw Error(s(156, t.tag));
            }
            function ao(e1) {
                switch(e1.tag){
                    case 1:
                        mr(e1.type) && Ar();
                        var t = e1.flags;
                        return 4096 & t ? (e1.flags = -4097 & t | 64, e1) : null;
                    case 3:
                        if (za(), cr(pr), cr(dr), Xa(), 64 & (t = e1.flags)) throw Error(s(285));
                        return e1.flags = -4097 & t | 64, e1;
                    case 5:
                        return Ra(e1), null;
                    case 13:
                        return cr(Pa), 4096 & (t = e1.flags) ? (e1.flags = -4097 & t | 64, e1) : null;
                    case 19:
                        return cr(Pa), null;
                    case 4:
                        return za(), null;
                    case 10:
                        return na(e1), null;
                    case 23:
                    case 24:
                        return xl(), null;
                    default:
                        return null;
                }
            }
            function so(e1, t) {
                try {
                    var n = "", i = t;
                    do n += W(i), i = i.return;
                    while (i);
                    var r = n;
                } catch (e1) {
                    r = "\nError generating stack: " + e1.message + "\n" + e1.stack;
                }
                return {
                    value: e1,
                    source: t,
                    stack: r
                };
            }
            function oo(e1, t) {
                try {
                    console.error(t.value);
                } catch (e1) {
                    setTimeout(function() {
                        throw e1;
                    });
                }
            }
            Ws = function(e1, t) {
                for(var n = t.child; null !== n;){
                    if (5 === n.tag || 6 === n.tag) e1.appendChild(n.stateNode);
                    else if (4 !== n.tag && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === t) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === t) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }, Ys = function() {}, Xs = function(e1, t, n, i) {
                var a = e1.memoizedProps;
                if (a !== i) {
                    e1 = t.stateNode, Ca(Na.current);
                    var s, o = null;
                    switch(n){
                        case "input":
                            a = $(e1, a), i = $(e1, i), o = [];
                            break;
                        case "option":
                            a = ae(e1, a), i = ae(e1, i), o = [];
                            break;
                        case "select":
                            a = r({}, a, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), o = [];
                            break;
                        case "textarea":
                            a = oe(e1, a), i = oe(e1, i), o = [];
                            break;
                        default:
                            "function" != typeof a.onClick && "function" == typeof i.onClick && (e1.onclick = ki);
                    }
                    for(h in we(n, i), n = null, a)if (!i.hasOwnProperty(h) && a.hasOwnProperty(h) && null != a[h]) {
                        if ("style" === h) {
                            var c = a[h];
                            for(s in c)c.hasOwnProperty(s) && (n || (n = {}), n[s] = "");
                        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (l.hasOwnProperty(h) ? o || (o = []) : (o = o || []).push(h, null));
                    }
                    for(h in i){
                        var u = i[h];
                        if (c = null != a ? a[h] : void 0, i.hasOwnProperty(h) && u !== c && (null != u || null != c)) {
                            if ("style" === h) {
                                if (c) {
                                    for(s in c)!c.hasOwnProperty(s) || u && u.hasOwnProperty(s) || (n || (n = {}), n[s] = "");
                                    for(s in u)u.hasOwnProperty(s) && c[s] !== u[s] && (n || (n = {}), n[s] = u[s]);
                                } else n || (o || (o = []), o.push(h, n)), n = u;
                            } else "dangerouslySetInnerHTML" === h ? (u = u ? u.__html : void 0, c = c ? c.__html : void 0, null != u && c !== u && (o = o || []).push(h, u)) : "children" === h ? "string" != typeof u && "number" != typeof u || (o = o || []).push(h, "" + u) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (l.hasOwnProperty(h) ? (null != u && "onScroll" === h && Di("scroll", e1), o || c === u || (o = [])) : "object" == typeof u && null !== u && u.$$typeof === R ? u.toString() : (o = o || []).push(h, u));
                        }
                    }
                    n && (o = o || []).push("style", n);
                    var h = o;
                    (t.updateQueue = h) && (t.flags |= 4);
                }
            }, Zs = function(e1, t, n, i) {
                n !== i && (t.flags |= 4);
            };
            var lo = "function" == typeof WeakMap ? WeakMap : Map;
            function co(e1, t, n) {
                (n = ca(-1, n)).tag = 3, n.payload = {
                    element: null
                };
                var i = t.value;
                return n.callback = function() {
                    Xo || (Xo = !0, Zo = i), oo(0, t);
                }, n;
            }
            function uo(e1, t, n) {
                (n = ca(-1, n)).tag = 3;
                var i = e1.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = t.value;
                    n.payload = function() {
                        return oo(0, t), i(r);
                    };
                }
                var a = e1.stateNode;
                return null !== a && "function" == typeof a.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === qo ? qo = new Set([
                        this
                    ]) : qo.add(this), oo(0, t));
                    var e1 = t.stack;
                    this.componentDidCatch(t.value, {
                        componentStack: null !== e1 ? e1 : ""
                    });
                }), n;
            }
            var ho = "function" == typeof WeakSet ? WeakSet : Set;
            function po(e1) {
                var t = e1.ref;
                if (null !== t) {
                    if ("function" == typeof t) try {
                        t(null);
                    } catch (t) {
                        jl(e1, t);
                    }
                    else t.current = null;
                }
            }
            function fo(e1, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                    case 1:
                        if (256 & t.flags && null !== e1) {
                            var n = e1.memoizedProps, i = e1.memoizedState;
                            t = (e1 = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : qr(t.type, n), i), e1.__reactInternalSnapshotBeforeUpdate = t;
                        }
                        return;
                    case 3:
                        return void (256 & t.flags && Wi(t.stateNode.containerInfo));
                }
                throw Error(s(163));
            }
            function go(e1, t, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                            e1 = t = t.next;
                            do {
                                if (!(3 & ~e1.tag)) {
                                    var i = e1.create;
                                    e1.destroy = i();
                                }
                                e1 = e1.next;
                            }while (e1 !== t);
                        }
                        if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                            e1 = t = t.next;
                            do {
                                var r = e1;
                                i = r.next, 4 & (r = r.tag) && 1 & r && (Rl(n, e1), Ol(n, e1)), e1 = i;
                            }while (e1 !== t);
                        }
                        return;
                    case 1:
                        return e1 = n.stateNode, 4 & n.flags && (null === t ? e1.componentDidMount() : (i = n.elementType === n.type ? t.memoizedProps : qr(n.type, t.memoizedProps), e1.componentDidUpdate(i, t.memoizedState, e1.__reactInternalSnapshotBeforeUpdate))), void (null !== (t = n.updateQueue) && pa(n, t, e1));
                    case 3:
                        if (null !== (t = n.updateQueue)) {
                            if (e1 = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                case 1:
                                    e1 = n.child.stateNode;
                            }
                            pa(n, t, e1);
                        }
                        return;
                    case 5:
                        return e1 = n.stateNode, void (null === t && 4 & n.flags && Hi(n.type, n.memoizedProps) && e1.focus());
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                    case 23:
                    case 24:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && xt(n)))));
                }
                throw Error(s(163));
            }
            function mo(e1, t) {
                for(var n = e1;;){
                    if (5 === n.tag) {
                        var i = n.stateNode;
                        if (t) "function" == typeof (i = i.style).setProperty ? i.setProperty("display", "none", "important") : i.display = "none";
                        else {
                            i = n.stateNode;
                            var r = n.memoizedProps.style;
                            r = null != r && r.hasOwnProperty("display") ? r.display : null, i.style.display = ye("display", r);
                        }
                    } else if (6 === n.tag) n.stateNode.nodeValue = t ? "" : n.memoizedProps;
                    else if ((23 !== n.tag && 24 !== n.tag || null === n.memoizedState || n === e1) && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === e1) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === e1) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }
            function Ao(e1, t) {
                if (wr && "function" == typeof wr.onCommitFiberUnmount) try {
                    wr.onCommitFiberUnmount(br, t);
                } catch (e1) {}
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (e1 = t.updateQueue) && null !== (e1 = e1.lastEffect)) {
                            var n = e1 = e1.next;
                            do {
                                var i = n, r = i.destroy;
                                if (i = i.tag, void 0 !== r) {
                                    if (4 & i) Rl(t, n);
                                    else {
                                        i = t;
                                        try {
                                            r();
                                        } catch (e1) {
                                            jl(i, e1);
                                        }
                                    }
                                }
                                n = n.next;
                            }while (n !== e1);
                        }
                        break;
                    case 1:
                        if (po(t), "function" == typeof (e1 = t.stateNode).componentWillUnmount) try {
                            e1.props = t.memoizedProps, e1.state = t.memoizedState, e1.componentWillUnmount();
                        } catch (e1) {
                            jl(t, e1);
                        }
                        break;
                    case 5:
                        po(t);
                        break;
                    case 4:
                        wo(e1, t);
                }
            }
            function Mo(e1) {
                e1.alternate = null, e1.child = null, e1.dependencies = null, e1.firstEffect = null, e1.lastEffect = null, e1.memoizedProps = null, e1.memoizedState = null, e1.pendingProps = null, e1.return = null, e1.updateQueue = null;
            }
            function vo(e1) {
                return 5 === e1.tag || 3 === e1.tag || 4 === e1.tag;
            }
            function yo(e1) {
                e: {
                    for(var t = e1.return; null !== t;){
                        if (vo(t)) break e;
                        t = t.return;
                    }
                    throw Error(s(160));
                }
                var n = t;
                switch(t = n.stateNode, n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        t = t.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(s(161));
                }
                16 & n.flags && (Ae(t, ""), n.flags &= -17);
                e: t: for(n = e1;;){
                    for(; null === n.sibling;){
                        if (null === n.return || vo(n.return)) {
                            n = null;
                            break e;
                        }
                        n = n.return;
                    }
                    for(n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;){
                        if (2 & n.flags) continue t;
                        if (null === n.child || 4 === n.tag) continue t;
                        n.child.return = n, n = n.child;
                    }
                    if (!(2 & n.flags)) {
                        n = n.stateNode;
                        break e;
                    }
                }
                i ? xo(e1, n, t) : bo(e1, n, t);
            }
            function xo(e1, t, n) {
                var i = e1.tag, r = 5 === i || 6 === i;
                if (r) e1 = r ? e1.stateNode : e1.stateNode.instance, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e1, t) : n.insertBefore(e1, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e1, n) : (t = n).appendChild(e1), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = ki));
                else if (4 !== i && null !== (e1 = e1.child)) for(xo(e1, t, n), e1 = e1.sibling; null !== e1;)xo(e1, t, n), e1 = e1.sibling;
            }
            function bo(e1, t, n) {
                var i = e1.tag, r = 5 === i || 6 === i;
                if (r) e1 = r ? e1.stateNode : e1.stateNode.instance, t ? n.insertBefore(e1, t) : n.appendChild(e1);
                else if (4 !== i && null !== (e1 = e1.child)) for(bo(e1, t, n), e1 = e1.sibling; null !== e1;)bo(e1, t, n), e1 = e1.sibling;
            }
            function wo(e1, t) {
                for(var n, i, r = t, a = !1;;){
                    if (!a) {
                        a = r.return;
                        e: for(;;){
                            if (null === a) throw Error(s(160));
                            switch(n = a.stateNode, a.tag){
                                case 5:
                                    i = !1;
                                    break e;
                                case 3:
                                case 4:
                                    n = n.containerInfo, i = !0;
                                    break e;
                            }
                            a = a.return;
                        }
                        a = !0;
                    }
                    if (5 === r.tag || 6 === r.tag) {
                        e: for(var o = e1, l = r, c = l;;)if (Ao(o, c), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
                        else {
                            if (c === l) break e;
                            for(; null === c.sibling;){
                                if (null === c.return || c.return === l) break e;
                                c = c.return;
                            }
                            c.sibling.return = c.return, c = c.sibling;
                        }
                        i ? (o = n, l = r.stateNode, 8 === o.nodeType ? o.parentNode.removeChild(l) : o.removeChild(l)) : n.removeChild(r.stateNode);
                    } else if (4 === r.tag) {
                        if (null !== r.child) {
                            n = r.stateNode.containerInfo, i = !0, r.child.return = r, r = r.child;
                            continue;
                        }
                    } else if (Ao(e1, r), null !== r.child) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === t) break;
                    for(; null === r.sibling;){
                        if (null === r.return || r.return === t) return;
                        4 === (r = r.return).tag && (a = !1);
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
            }
            function Eo(e1, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        var n = t.updateQueue;
                        if (null !== (n = null !== n ? n.lastEffect : null)) {
                            var i = n = n.next;
                            do !(3 & ~i.tag) && (e1 = i.destroy, i.destroy = void 0, void 0 !== e1 && e1()), i = i.next;
                            while (i !== n);
                        }
                        return;
                    case 1:
                    case 12:
                    case 17:
                        return;
                    case 5:
                        if (null != (n = t.stateNode)) {
                            i = t.memoizedProps;
                            var r = null !== e1 ? e1.memoizedProps : i;
                            e1 = t.type;
                            var a = t.updateQueue;
                            if (t.updateQueue = null, null !== a) {
                                for(n[Ji] = i, "input" === e1 && "radio" === i.type && null != i.name && te(n, i), Ee(e1, r), t = Ee(e1, i), r = 0; r < a.length; r += 2){
                                    var o = a[r], l = a[r + 1];
                                    "style" === o ? xe(n, l) : "dangerouslySetInnerHTML" === o ? me(n, l) : "children" === o ? Ae(n, l) : y(n, o, l, t);
                                }
                                switch(e1){
                                    case "input":
                                        ne(n, i);
                                        break;
                                    case "textarea":
                                        ce(n, i);
                                        break;
                                    case "select":
                                        e1 = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (a = i.value) ? se(n, !!i.multiple, a, !1) : e1 !== !!i.multiple && (null != i.defaultValue ? se(n, !!i.multiple, i.defaultValue, !0) : se(n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === t.stateNode) throw Error(s(162));
                        return void (t.stateNode.nodeValue = t.memoizedProps);
                    case 3:
                        return void ((n = t.stateNode).hydrate && (n.hydrate = !1, xt(n.containerInfo)));
                    case 13:
                        return null !== t.memoizedState && (Go = Hr(), mo(t.child, !0)), void To(t);
                    case 19:
                        return void To(t);
                    case 23:
                    case 24:
                        return void mo(t, null !== t.memoizedState);
                }
                throw Error(s(163));
            }
            function To(e1) {
                var t = e1.updateQueue;
                if (null !== t) {
                    e1.updateQueue = null;
                    var n = e1.stateNode;
                    null === n && (n = e1.stateNode = new ho), t.forEach(function(t) {
                        var i = Bl.bind(null, e1, t);
                        n.has(t) || (n.add(t), t.then(i, i));
                    });
                }
            }
            function So(e1, t) {
                return null !== e1 && (null === (e1 = e1.memoizedState) || null !== e1.dehydrated) && null !== (t = t.memoizedState) && null === t.dehydrated;
            }
            var Io = Math.ceil, No = x.ReactCurrentDispatcher, Do = x.ReactCurrentOwner, _o = 0, Co = null, Lo = null, zo = 0, Oo = 0, Ro = lr(0), Po = 0, Uo = null, jo = 0, ko = 0, Bo = 0, Fo = 0, Ho = null, Go = 0, Vo = 1 / 0;
            function Qo() {
                Vo = Hr() + 500;
            }
            var Wo, Yo = null, Xo = !1, Zo = null, qo = null, Ko = !1, Jo = null, $o = 90, el = [], tl = [], nl = null, il = 0, rl = null, al = -1, sl = 0, ol = 0, ll = null, cl = !1;
            function ul() {
                return 48 & _o ? Hr() : -1 !== al ? al : al = Hr();
            }
            function hl(e1) {
                if (!(2 & (e1 = e1.mode))) return 1;
                if (!(4 & e1)) return 99 === Gr() ? 1 : 2;
                if (0 === sl && (sl = jo), 0 !== Zr.transition) {
                    0 !== ol && (ol = null !== Ho ? Ho.pendingLanes : 0), e1 = sl;
                    var t = 4186112 & ~ol;
                    return 0 == (t &= -t) && 0 == (t = (e1 = 4186112 & ~e1) & -e1) && (t = 8192), t;
                }
                return e1 = Gr(), e1 = kt(4 & _o && 98 === e1 ? 12 : e1 = function(e1) {
                    switch(e1){
                        case 99:
                            return 15;
                        case 98:
                            return 10;
                        case 97:
                        case 96:
                            return 8;
                        case 95:
                            return 2;
                        default:
                            return 0;
                    }
                }(e1), sl);
            }
            function dl(e1, t, n) {
                if (50 < il) throw il = 0, rl = null, Error(s(185));
                if (null === (e1 = pl(e1, t))) return null;
                Ht(e1, t, n), e1 === Co && (Bo |= t, 4 === Po && ml(e1, zo));
                var i = Gr();
                1 === t ? 8 & _o && !(48 & _o) ? Al(e1) : (fl(e1, n), 0 === _o && (Qo(), Yr())) : (!(4 & _o) || 98 !== i && 99 !== i || (null === nl ? nl = new Set([
                    e1
                ]) : nl.add(e1)), fl(e1, n)), Ho = e1;
            }
            function pl(e1, t) {
                e1.lanes |= t;
                var n = e1.alternate;
                for(null !== n && (n.lanes |= t), n = e1, e1 = e1.return; null !== e1;)e1.childLanes |= t, null !== (n = e1.alternate) && (n.childLanes |= t), n = e1, e1 = e1.return;
                return 3 === n.tag ? n.stateNode : null;
            }
            function fl(e1, t) {
                for(var n = e1.callbackNode, i = e1.suspendedLanes, r = e1.pingedLanes, a = e1.expirationTimes, o = e1.pendingLanes; 0 < o;){
                    var l = 31 - Gt(o), c = 1 << l, u = a[l];
                    if (-1 === u) {
                        if (!(c & i) || c & r) {
                            u = t, Pt(c);
                            var h = Rt;
                            a[l] = 10 <= h ? u + 250 : 6 <= h ? u + 5e3 : -1;
                        }
                    } else u <= t && (e1.expiredLanes |= c);
                    o &= ~c;
                }
                if (i = Ut(e1, e1 === Co ? zo : 0), t = Rt, 0 === i) null !== n && (n !== Pr && Sr(n), e1.callbackNode = null, e1.callbackPriority = 0);
                else {
                    if (null !== n) {
                        if (e1.callbackPriority === t) return;
                        n !== Pr && Sr(n);
                    }
                    15 === t ? (n = Al.bind(null, e1), null === jr ? (jr = [
                        n
                    ], kr = Tr(Cr, Xr)) : jr.push(n), n = Pr) : 14 === t ? n = Wr(99, Al.bind(null, e1)) : (n = function(e1) {
                        switch(e1){
                            case 15:
                            case 14:
                                return 99;
                            case 13:
                            case 12:
                            case 11:
                            case 10:
                                return 98;
                            case 9:
                            case 8:
                            case 7:
                            case 6:
                            case 4:
                            case 5:
                                return 97;
                            case 3:
                            case 2:
                            case 1:
                                return 95;
                            case 0:
                                return 90;
                            default:
                                throw Error(s(358, e1));
                        }
                    }(t), n = Wr(n, gl.bind(null, e1))), e1.callbackPriority = t, e1.callbackNode = n;
                }
            }
            function gl(e1) {
                if (al = -1, ol = sl = 0, 48 & _o) throw Error(s(327));
                var t = e1.callbackNode;
                if (zl() && e1.callbackNode !== t) return null;
                var n = Ut(e1, e1 === Co ? zo : 0);
                if (0 === n) return null;
                var i = n, r = _o;
                _o |= 16;
                var a = El();
                for(Co === e1 && zo === i || (Qo(), bl(e1, i));;)try {
                    Il();
                    break;
                } catch (t) {
                    wl(e1, t);
                }
                if (ta(), No.current = a, _o = r, null !== Lo ? i = 0 : (Co = null, zo = 0, i = Po), jo & Bo) bl(e1, 0);
                else if (0 !== i) {
                    if (2 === i && (_o |= 64, e1.hydrate && (e1.hydrate = !1, Wi(e1.containerInfo)), 0 !== (n = jt(e1)) && (i = Tl(e1, n))), 1 === i) throw t = Uo, bl(e1, 0), ml(e1, n), fl(e1, Hr()), t;
                    switch(e1.finishedWork = e1.current.alternate, e1.finishedLanes = n, i){
                        case 0:
                        case 1:
                            throw Error(s(345));
                        case 2:
                        case 5:
                            _l(e1);
                            break;
                        case 3:
                            if (ml(e1, n), (62914560 & n) === n && 10 < (i = Go + 500 - Hr())) {
                                if (0 !== Ut(e1, 0)) break;
                                if (((r = e1.suspendedLanes) & n) !== n) {
                                    ul(), e1.pingedLanes |= e1.suspendedLanes & r;
                                    break;
                                }
                                e1.timeoutHandle = Vi(_l.bind(null, e1), i);
                                break;
                            }
                            _l(e1);
                            break;
                        case 4:
                            if (ml(e1, n), (4186112 & n) === n) break;
                            for(i = e1.eventTimes, r = -1; 0 < n;){
                                var o = 31 - Gt(n);
                                a = 1 << o, (o = i[o]) > r && (r = o), n &= ~a;
                            }
                            if (n = r, 10 < (n = (120 > (n = Hr() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * Io(n / 1960)) - n)) {
                                e1.timeoutHandle = Vi(_l.bind(null, e1), n);
                                break;
                            }
                            _l(e1);
                            break;
                        default:
                            throw Error(s(329));
                    }
                }
                return fl(e1, Hr()), e1.callbackNode === t ? gl.bind(null, e1) : null;
            }
            function ml(e1, t) {
                for(t &= ~Fo, t &= ~Bo, e1.suspendedLanes |= t, e1.pingedLanes &= ~t, e1 = e1.expirationTimes; 0 < t;){
                    var n = 31 - Gt(t), i = 1 << n;
                    e1[n] = -1, t &= ~i;
                }
            }
            function Al(e1) {
                if (48 & _o) throw Error(s(327));
                if (zl(), e1 === Co && e1.expiredLanes & zo) {
                    var t = zo, n = Tl(e1, t);
                    jo & Bo && (n = Tl(e1, t = Ut(e1, t)));
                } else n = Tl(e1, t = Ut(e1, 0));
                if (0 !== e1.tag && 2 === n && (_o |= 64, e1.hydrate && (e1.hydrate = !1, Wi(e1.containerInfo)), 0 !== (t = jt(e1)) && (n = Tl(e1, t))), 1 === n) throw n = Uo, bl(e1, 0), ml(e1, t), fl(e1, Hr()), n;
                return e1.finishedWork = e1.current.alternate, e1.finishedLanes = t, _l(e1), fl(e1, Hr()), null;
            }
            function Ml(e1, t) {
                var n = _o;
                _o |= 1;
                try {
                    return e1(t);
                } finally{
                    0 === (_o = n) && (Qo(), Yr());
                }
            }
            function vl(e1, t) {
                var n = _o;
                _o &= -2, _o |= 8;
                try {
                    return e1(t);
                } finally{
                    0 === (_o = n) && (Qo(), Yr());
                }
            }
            function yl(e1, t) {
                ur(Ro, Oo), Oo |= t, jo |= t;
            }
            function xl() {
                Oo = Ro.current, cr(Ro);
            }
            function bl(e1, t) {
                e1.finishedWork = null, e1.finishedLanes = 0;
                var n = e1.timeoutHandle;
                if (-1 !== n && (e1.timeoutHandle = -1, Qi(n)), null !== Lo) for(n = Lo.return; null !== n;){
                    var i = n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            za(), cr(pr), cr(dr), Xa();
                            break;
                        case 5:
                            Ra(i);
                            break;
                        case 4:
                            za();
                            break;
                        case 13:
                        case 19:
                            cr(Pa);
                            break;
                        case 10:
                            na(i);
                            break;
                        case 23:
                        case 24:
                            xl();
                    }
                    n = n.return;
                }
                Co = e1, Lo = Vl(e1.current, null), zo = Oo = jo = t, Po = 0, Uo = null, Fo = Bo = ko = 0;
            }
            function wl(e1, t) {
                for(;;){
                    var n = Lo;
                    try {
                        if (ta(), Za.current = _s, ts) {
                            for(var i = Ja.memoizedState; null !== i;){
                                var r = i.queue;
                                null !== r && (r.pending = null), i = i.next;
                            }
                            ts = !1;
                        }
                        if (Ka = 0, es = $a = Ja = null, ns = !1, Do.current = null, null === n || null === n.return) {
                            Po = 1, Uo = t, Lo = null;
                            break;
                        }
                        e: {
                            var a = e1, s = n.return, o = n, l = t;
                            if (t = zo, o.flags |= 2048, o.firstEffect = o.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                                var c = l;
                                if (!(2 & o.mode)) {
                                    var u = o.alternate;
                                    u ? (o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.lanes = u.lanes) : (o.updateQueue = null, o.memoizedState = null);
                                }
                                var h = !!(1 & Pa.current), d = s;
                                do {
                                    var p;
                                    if (p = 13 === d.tag) {
                                        var f = d.memoizedState;
                                        if (null !== f) p = null !== f.dehydrated;
                                        else {
                                            var g = d.memoizedProps;
                                            p = void 0 !== g.fallback && (!0 !== g.unstable_avoidThisFallback || !h);
                                        }
                                    }
                                    if (p) {
                                        var m = d.updateQueue;
                                        if (null === m) {
                                            var A = new Set;
                                            A.add(c), d.updateQueue = A;
                                        } else m.add(c);
                                        if (!(2 & d.mode)) {
                                            if (d.flags |= 64, o.flags |= 16384, o.flags &= -2981, 1 === o.tag) {
                                                if (null === o.alternate) o.tag = 17;
                                                else {
                                                    var M = ca(-1, 1);
                                                    M.tag = 2, ua(o, M);
                                                }
                                            }
                                            o.lanes |= 1;
                                            break e;
                                        }
                                        l = void 0, o = t;
                                        var v = a.pingCache;
                                        if (null === v ? (v = a.pingCache = new lo, l = new Set, v.set(c, l)) : void 0 === (l = v.get(c)) && (l = new Set, v.set(c, l)), !l.has(o)) {
                                            l.add(o);
                                            var y = kl.bind(null, a, c, o);
                                            c.then(y, y);
                                        }
                                        d.flags |= 4096, d.lanes = t;
                                        break e;
                                    }
                                    d = d.return;
                                }while (null !== d);
                                l = Error((Y(o.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                            }
                            5 !== Po && (Po = 2), l = so(l, o), d = s;
                            do {
                                switch(d.tag){
                                    case 3:
                                        a = l, d.flags |= 4096, t &= -t, d.lanes |= t, ha(d, co(0, a, t));
                                        break e;
                                    case 1:
                                        a = l;
                                        var x = d.type, b = d.stateNode;
                                        if (!(64 & d.flags || "function" != typeof x.getDerivedStateFromError && (null === b || "function" != typeof b.componentDidCatch || null !== qo && qo.has(b)))) {
                                            d.flags |= 4096, t &= -t, d.lanes |= t, ha(d, uo(d, a, t));
                                            break e;
                                        }
                                }
                                d = d.return;
                            }while (null !== d);
                        }
                        Dl(n);
                    } catch (e1) {
                        t = e1, Lo === n && null !== n && (Lo = n = n.return);
                        continue;
                    }
                    break;
                }
            }
            function El() {
                var e1 = No.current;
                return No.current = _s, null === e1 ? _s : e1;
            }
            function Tl(e1, t) {
                var n = _o;
                _o |= 16;
                var i = El();
                for(Co === e1 && zo === t || bl(e1, t);;)try {
                    Sl();
                    break;
                } catch (t) {
                    wl(e1, t);
                }
                if (ta(), _o = n, No.current = i, null !== Lo) throw Error(s(261));
                return Co = null, zo = 0, Po;
            }
            function Sl() {
                for(; null !== Lo;)Nl(Lo);
            }
            function Il() {
                for(; null !== Lo && !Ir();)Nl(Lo);
            }
            function Nl(e1) {
                var t = Wo(e1.alternate, e1, Oo);
                e1.memoizedProps = e1.pendingProps, null === t ? Dl(e1) : Lo = t, Do.current = null;
            }
            function Dl(e1) {
                var t = e1;
                do {
                    var n = t.alternate;
                    if (e1 = t.return, 2048 & t.flags) {
                        if (null !== (n = ao(t))) return n.flags &= 2047, void (Lo = n);
                        null !== e1 && (e1.firstEffect = e1.lastEffect = null, e1.flags |= 2048);
                    } else {
                        if (null !== (n = ro(n, t, Oo))) return void (Lo = n);
                        if (24 !== (n = t).tag && 23 !== n.tag || null === n.memoizedState || 1073741824 & Oo || !(4 & n.mode)) {
                            for(var i = 0, r = n.child; null !== r;)i |= r.lanes | r.childLanes, r = r.sibling;
                            n.childLanes = i;
                        }
                        null !== e1 && !(2048 & e1.flags) && (null === e1.firstEffect && (e1.firstEffect = t.firstEffect), null !== t.lastEffect && (null !== e1.lastEffect && (e1.lastEffect.nextEffect = t.firstEffect), e1.lastEffect = t.lastEffect), 1 < t.flags && (null !== e1.lastEffect ? e1.lastEffect.nextEffect = t : e1.firstEffect = t, e1.lastEffect = t));
                    }
                    if (null !== (t = t.sibling)) return void (Lo = t);
                    Lo = t = e1;
                }while (null !== t);
                0 === Po && (Po = 5);
            }
            function _l(e1) {
                var t = Gr();
                return Qr(99, Cl.bind(null, e1, t)), null;
            }
            function Cl(e1, t) {
                do zl();
                while (null !== Jo);
                if (48 & _o) throw Error(s(327));
                var n = e1.finishedWork;
                if (null === n) return null;
                if (e1.finishedWork = null, e1.finishedLanes = 0, n === e1.current) throw Error(s(177));
                e1.callbackNode = null;
                var i = n.lanes | n.childLanes, r = i, a = e1.pendingLanes & ~r;
                e1.pendingLanes = r, e1.suspendedLanes = 0, e1.pingedLanes = 0, e1.expiredLanes &= r, e1.mutableReadLanes &= r, e1.entangledLanes &= r, r = e1.entanglements;
                for(var o = e1.eventTimes, l = e1.expirationTimes; 0 < a;){
                    var c = 31 - Gt(a), u = 1 << c;
                    r[c] = 0, o[c] = -1, l[c] = -1, a &= ~u;
                }
                if (null !== nl && !(24 & i) && nl.has(e1) && nl.delete(e1), e1 === Co && (Lo = Co = null, zo = 0), 1 < n.flags ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
                    if (r = _o, _o |= 32, Do.current = null, Bi = Xt, mi(o = gi())) {
                        if ("selectionStart" in o) l = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else e: if (l = (l = o.ownerDocument) && l.defaultView || window, (u = l.getSelection && l.getSelection()) && 0 !== u.rangeCount) {
                            l = u.anchorNode, a = u.anchorOffset, c = u.focusNode, u = u.focusOffset;
                            try {
                                l.nodeType, c.nodeType;
                            } catch (e1) {
                                l = null;
                                break e;
                            }
                            var h = 0, d = -1, p = -1, f = 0, g = 0, m = o, A = null;
                            t: for(;;){
                                for(var M; m !== l || 0 !== a && 3 !== m.nodeType || (d = h + a), m !== c || 0 !== u && 3 !== m.nodeType || (p = h + u), 3 === m.nodeType && (h += m.nodeValue.length), null !== (M = m.firstChild);)A = m, m = M;
                                for(;;){
                                    if (m === o) break t;
                                    if (A === l && ++f === a && (d = h), A === c && ++g === u && (p = h), null !== (M = m.nextSibling)) break;
                                    A = (m = A).parentNode;
                                }
                                m = M;
                            }
                            l = -1 === d || -1 === p ? null : {
                                start: d,
                                end: p
                            };
                        } else l = null;
                        l = l || {
                            start: 0,
                            end: 0
                        };
                    } else l = null;
                    Fi = {
                        focusedElem: o,
                        selectionRange: l
                    }, Xt = !1, ll = null, cl = !1, Yo = i;
                    do try {
                        Ll();
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        jl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    ll = null, Yo = i;
                    do try {
                        for(o = e1; null !== Yo;){
                            var v = Yo.flags;
                            if (16 & v && Ae(Yo.stateNode, ""), 128 & v) {
                                var y = Yo.alternate;
                                if (null !== y) {
                                    var x = y.ref;
                                    null !== x && ("function" == typeof x ? x(null) : x.current = null);
                                }
                            }
                            switch(1038 & v){
                                case 2:
                                    yo(Yo), Yo.flags &= -3;
                                    break;
                                case 6:
                                    yo(Yo), Yo.flags &= -3, Eo(Yo.alternate, Yo);
                                    break;
                                case 1024:
                                    Yo.flags &= -1025;
                                    break;
                                case 1028:
                                    Yo.flags &= -1025, Eo(Yo.alternate, Yo);
                                    break;
                                case 4:
                                    Eo(Yo.alternate, Yo);
                                    break;
                                case 8:
                                    wo(o, l = Yo);
                                    var b = l.alternate;
                                    Mo(l), null !== b && Mo(b);
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        jl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    if (x = Fi, y = gi(), v = x.focusedElem, o = x.selectionRange, y !== v && v && v.ownerDocument && fi(v.ownerDocument.documentElement, v)) {
                        null !== o && mi(v) && (y = o.start, void 0 === (x = o.end) && (x = y), "selectionStart" in v ? (v.selectionStart = y, v.selectionEnd = Math.min(x, v.value.length)) : (x = (y = v.ownerDocument || document) && y.defaultView || window).getSelection && (x = x.getSelection(), l = v.textContent.length, b = Math.min(o.start, l), o = void 0 === o.end ? b : Math.min(o.end, l), !x.extend && b > o && (l = o, o = b, b = l), l = pi(v, b), a = pi(v, o), l && a && (1 !== x.rangeCount || x.anchorNode !== l.node || x.anchorOffset !== l.offset || x.focusNode !== a.node || x.focusOffset !== a.offset) && ((y = y.createRange()).setStart(l.node, l.offset), x.removeAllRanges(), b > o ? (x.addRange(y), x.extend(a.node, a.offset)) : (y.setEnd(a.node, a.offset), x.addRange(y))))), y = [];
                        for(x = v; x = x.parentNode;)1 === x.nodeType && y.push({
                            element: x,
                            left: x.scrollLeft,
                            top: x.scrollTop
                        });
                        for("function" == typeof v.focus && v.focus(), v = 0; v < y.length; v++)(x = y[v]).element.scrollLeft = x.left, x.element.scrollTop = x.top;
                    }
                    Xt = !!Bi, Fi = Bi = null, e1.current = n, Yo = i;
                    do try {
                        for(v = e1; null !== Yo;){
                            var w = Yo.flags;
                            if (36 & w && go(v, Yo.alternate, Yo), 128 & w) {
                                y = void 0;
                                var E = Yo.ref;
                                if (null !== E) {
                                    var T = Yo.stateNode;
                                    Yo.tag, y = T, "function" == typeof E ? E(y) : E.current = y;
                                }
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        jl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    Yo = null, Ur(), _o = r;
                } else e1.current = n;
                if (Ko) Ko = !1, Jo = e1, $o = t;
                else for(Yo = i; null !== Yo;)t = Yo.nextEffect, Yo.nextEffect = null, 8 & Yo.flags && ((w = Yo).sibling = null, w.stateNode = null), Yo = t;
                if (0 === (i = e1.pendingLanes) && (qo = null), 1 === i ? e1 === rl ? il++ : (il = 0, rl = e1) : il = 0, n = n.stateNode, wr && "function" == typeof wr.onCommitFiberRoot) try {
                    wr.onCommitFiberRoot(br, n, void 0, !(64 & ~n.current.flags));
                } catch (e1) {}
                if (fl(e1, Hr()), Xo) throw Xo = !1, e1 = Zo, Zo = null, e1;
                return 8 & _o || Yr(), null;
            }
            function Ll() {
                for(; null !== Yo;){
                    var e1 = Yo.alternate;
                    cl || null === ll || (8 & Yo.flags ? $e(Yo, ll) && (cl = !0) : 13 === Yo.tag && So(e1, Yo) && $e(Yo, ll) && (cl = !0));
                    var t = Yo.flags;
                    256 & t && fo(e1, Yo), !(512 & t) || Ko || (Ko = !0, Wr(97, function() {
                        return zl(), null;
                    })), Yo = Yo.nextEffect;
                }
            }
            function zl() {
                if (90 !== $o) {
                    var e1 = 97 < $o ? 97 : $o;
                    return $o = 90, Qr(e1, Pl);
                }
                return !1;
            }
            function Ol(e1, t) {
                el.push(t, e1), Ko || (Ko = !0, Wr(97, function() {
                    return zl(), null;
                }));
            }
            function Rl(e1, t) {
                tl.push(t, e1), Ko || (Ko = !0, Wr(97, function() {
                    return zl(), null;
                }));
            }
            function Pl() {
                if (null === Jo) return !1;
                var e1 = Jo;
                if (Jo = null, 48 & _o) throw Error(s(331));
                var t = _o;
                _o |= 32;
                var n = tl;
                tl = [];
                for(var i = 0; i < n.length; i += 2){
                    var r = n[i], a = n[i + 1], o = r.destroy;
                    if (r.destroy = void 0, "function" == typeof o) try {
                        o();
                    } catch (e1) {
                        if (null === a) throw Error(s(330));
                        jl(a, e1);
                    }
                }
                for(n = el, el = [], i = 0; i < n.length; i += 2){
                    r = n[i], a = n[i + 1];
                    try {
                        var l = r.create;
                        r.destroy = l();
                    } catch (e1) {
                        if (null === a) throw Error(s(330));
                        jl(a, e1);
                    }
                }
                for(l = e1.current.firstEffect; null !== l;)e1 = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = e1;
                return _o = t, Yr(), !0;
            }
            function Ul(e1, t, n) {
                ua(e1, t = co(0, t = so(n, t), 1)), t = ul(), null !== (e1 = pl(e1, 1)) && (Ht(e1, 1, t), fl(e1, t));
            }
            function jl(e1, t) {
                if (3 === e1.tag) Ul(e1, e1, t);
                else for(var n = e1.return; null !== n;){
                    if (3 === n.tag) {
                        Ul(n, e1, t);
                        break;
                    }
                    if (1 === n.tag) {
                        var i = n.stateNode;
                        if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) {
                            var r = uo(n, e1 = so(t, e1), 1);
                            if (ua(n, r), r = ul(), null !== (n = pl(n, 1))) Ht(n, 1, r), fl(n, r);
                            else if ("function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) try {
                                i.componentDidCatch(t, e1);
                            } catch (e1) {}
                            break;
                        }
                    }
                    n = n.return;
                }
            }
            function kl(e1, t, n) {
                var i = e1.pingCache;
                null !== i && i.delete(t), t = ul(), e1.pingedLanes |= e1.suspendedLanes & n, Co === e1 && (zo & n) === n && (4 === Po || 3 === Po && (62914560 & zo) === zo && 500 > Hr() - Go ? bl(e1, 0) : Fo |= n), fl(e1, t);
            }
            function Bl(e1, t) {
                var n = e1.stateNode;
                null !== n && n.delete(t), 0 == (t = 0) && (2 & (t = e1.mode) ? 4 & t ? (0 === sl && (sl = jo), 0 === (t = Bt(62914560 & ~sl)) && (t = 4194304)) : t = 99 === Gr() ? 1 : 2 : t = 1), n = ul(), null !== (e1 = pl(e1, t)) && (Ht(e1, t, n), fl(e1, n));
            }
            function Fl(e1, t, n, i) {
                this.tag = e1, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function Hl(e1, t, n, i) {
                return new Fl(e1, t, n, i);
            }
            function Gl(e1) {
                return !(!(e1 = e1.prototype) || !e1.isReactComponent);
            }
            function Vl(e1, t) {
                var n = e1.alternate;
                return null === n ? ((n = Hl(e1.tag, t, e1.key, e1.mode)).elementType = e1.elementType, n.type = e1.type, n.stateNode = e1.stateNode, n.alternate = e1, e1.alternate = n) : (n.pendingProps = t, n.type = e1.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = e1.childLanes, n.lanes = e1.lanes, n.child = e1.child, n.memoizedProps = e1.memoizedProps, n.memoizedState = e1.memoizedState, n.updateQueue = e1.updateQueue, t = e1.dependencies, n.dependencies = null === t ? null : {
                    lanes: t.lanes,
                    firstContext: t.firstContext
                }, n.sibling = e1.sibling, n.index = e1.index, n.ref = e1.ref, n;
            }
            function Ql(e1, t, n, i, r, a) {
                var o = 2;
                if (i = e1, "function" == typeof e1) Gl(e1) && (o = 1);
                else if ("string" == typeof e1) o = 5;
                else e: switch(e1){
                    case E:
                        return Wl(n.children, r, a, t);
                    case P:
                        o = 8, r |= 16;
                        break;
                    case T:
                        o = 8, r |= 1;
                        break;
                    case S:
                        return (e1 = Hl(12, n, t, 8 | r)).elementType = S, e1.type = S, e1.lanes = a, e1;
                    case _:
                        return (e1 = Hl(13, n, t, r)).type = _, e1.elementType = _, e1.lanes = a, e1;
                    case C:
                        return (e1 = Hl(19, n, t, r)).elementType = C, e1.lanes = a, e1;
                    case U:
                        return Yl(n, r, a, t);
                    case j:
                        return (e1 = Hl(24, n, t, r)).elementType = j, e1.lanes = a, e1;
                    default:
                        if ("object" == typeof e1 && null !== e1) switch(e1.$$typeof){
                            case I:
                                o = 10;
                                break e;
                            case N:
                                o = 9;
                                break e;
                            case D:
                                o = 11;
                                break e;
                            case L:
                                o = 14;
                                break e;
                            case z:
                                o = 16, i = null;
                                break e;
                            case O:
                                o = 22;
                                break e;
                        }
                        throw Error(s(130, null == e1 ? e1 : typeof e1, ""));
                }
                return (t = Hl(o, n, t, r)).elementType = e1, t.type = i, t.lanes = a, t;
            }
            function Wl(e1, t, n, i) {
                return (e1 = Hl(7, e1, i, t)).lanes = n, e1;
            }
            function Yl(e1, t, n, i) {
                return (e1 = Hl(23, e1, i, t)).elementType = U, e1.lanes = n, e1;
            }
            function Xl(e1, t, n) {
                return (e1 = Hl(6, e1, null, t)).lanes = n, e1;
            }
            function Zl(e1, t, n) {
                return (t = Hl(4, null !== e1.children ? e1.children : [], e1.key, t)).lanes = n, t.stateNode = {
                    containerInfo: e1.containerInfo,
                    pendingChildren: null,
                    implementation: e1.implementation
                }, t;
            }
            function ql(e1, t, n) {
                this.tag = t, this.containerInfo = e1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Ft(0), this.expirationTimes = Ft(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ft(0), this.mutableSourceEagerHydrationData = null;
            }
            function Kl(e1, t, n, i) {
                var r = t.current, a = ul(), o = hl(r);
                e: if (n) {
                    t: {
                        if (Ze(n = n._reactInternals) !== n || 1 !== n.tag) throw Error(s(170));
                        var l = n;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break t;
                                case 1:
                                    if (mr(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break t;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(s(171));
                    }
                    if (1 === n.tag) {
                        var c = n.type;
                        if (mr(c)) {
                            n = vr(n, c, l);
                            break e;
                        }
                    }
                    n = l;
                } else n = hr;
                return null === t.context ? t.context = n : t.pendingContext = n, (t = ca(a, o)).payload = {
                    element: e1
                }, null !== (i = void 0 === i ? null : i) && (t.callback = i), ua(r, t), dl(r, o, a), o;
            }
            function Jl(e1) {
                return (e1 = e1.current).child ? (e1.child.tag, e1.child.stateNode) : null;
            }
            function $l(e1, t) {
                if (null !== (e1 = e1.memoizedState) && null !== e1.dehydrated) {
                    var n = e1.retryLane;
                    e1.retryLane = 0 !== n && n < t ? n : t;
                }
            }
            function ec(e1, t) {
                $l(e1, t), (e1 = e1.alternate) && $l(e1, t);
            }
            function tc(e1, t, n) {
                var i = null != n && null != n.hydrationOptions && n.hydrationOptions.mutableSources || null;
                if (n = new ql(e1, t, null != n && !0 === n.hydrate), t = Hl(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), n.current = t, t.stateNode = n, oa(t), e1[$i] = n.current, Ci(8 === e1.nodeType ? e1.parentNode : e1), i) for(e1 = 0; e1 < i.length; e1++){
                    var r = (t = i[e1])._getVersion;
                    r = r(t._source), null == n.mutableSourceEagerHydrationData ? n.mutableSourceEagerHydrationData = [
                        t,
                        r
                    ] : n.mutableSourceEagerHydrationData.push(t, r);
                }
                this._internalRoot = n;
            }
            function nc(e1) {
                return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType && (8 !== e1.nodeType || " react-mount-point-unstable " !== e1.nodeValue));
            }
            function ic(e1, t, n, i, r) {
                var a = n._reactRootContainer;
                if (a) {
                    var s = a._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var e1 = Jl(s);
                            o.call(e1);
                        };
                    }
                    Kl(t, s, e1, r);
                } else {
                    if (a = n._reactRootContainer = function(e1, t) {
                        if (t || (t = !(!(t = e1 ? 9 === e1.nodeType ? e1.documentElement : e1.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for(var n; n = e1.lastChild;)e1.removeChild(n);
                        return new tc(e1, 0, t ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), s = a._internalRoot, "function" == typeof r) {
                        var l = r;
                        r = function() {
                            var e1 = Jl(s);
                            l.call(e1);
                        };
                    }
                    vl(function() {
                        Kl(t, s, e1, r);
                    });
                }
                return Jl(s);
            }
            function rc(e1, t) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!nc(t)) throw Error(s(200));
                return function(e1, t, n) {
                    var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                    return {
                        $$typeof: w,
                        key: null == i ? null : "" + i,
                        children: e1,
                        containerInfo: t,
                        implementation: n
                    };
                }(e1, t, null, n);
            }
            Wo = function(e1, t, n) {
                var i = t.lanes;
                if (null !== e1) {
                    if (e1.memoizedProps !== t.pendingProps || pr.current) Rs = !0;
                    else {
                        if (!(n & i)) {
                            switch(Rs = !1, t.tag){
                                case 3:
                                    Qs(t), Wa();
                                    break;
                                case 5:
                                    Oa(t);
                                    break;
                                case 1:
                                    mr(t.type) && yr(t);
                                    break;
                                case 4:
                                    La(t, t.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = t.memoizedProps.value;
                                    var r = t.type._context;
                                    ur(Kr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== t.memoizedState) return n & t.child.childLanes ? Ks(e1, t, n) : (ur(Pa, 1 & Pa.current), null !== (t = no(e1, t, n)) ? t.sibling : null);
                                    ur(Pa, 1 & Pa.current);
                                    break;
                                case 19:
                                    if (i = !!(n & t.childLanes), 64 & e1.flags) {
                                        if (i) return to(e1, t, n);
                                        t.flags |= 64;
                                    }
                                    if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null, r.lastEffect = null), ur(Pa, Pa.current), i) break;
                                    return null;
                                case 23:
                                case 24:
                                    return t.lanes = 0, Bs(e1, t, n);
                            }
                            return no(e1, t, n);
                        }
                        Rs = !!(16384 & e1.flags);
                    }
                } else Rs = !1;
                switch(t.lanes = 0, t.tag){
                    case 2:
                        if (i = t.type, null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), e1 = t.pendingProps, r = gr(t, dr.current), ra(t, n), r = as(null, t, i, e1, r, n), t.flags |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, mr(i)) {
                                var a = !0;
                                yr(t);
                            } else a = !1;
                            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oa(t);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && ga(t, i, o, e1), r.updater = ma, t.stateNode = r, r._reactInternals = t, ya(t, i, e1, n), t = Vs(null, t, i, !0, a, n);
                        } else t.tag = 0, Ps(null, t, r, n), t = t.child;
                        return t;
                    case 16:
                        r = t.elementType;
                        e: {
                            switch(null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), e1 = t.pendingProps, r = (a = r._init)(r._payload), t.type = r, a = t.tag = function(e1) {
                                if ("function" == typeof e1) return Gl(e1) ? 1 : 0;
                                if (null != e1) {
                                    if ((e1 = e1.$$typeof) === D) return 11;
                                    if (e1 === L) return 14;
                                }
                                return 2;
                            }(r), e1 = qr(r, e1), a){
                                case 0:
                                    t = Hs(null, t, r, e1, n);
                                    break e;
                                case 1:
                                    t = Gs(null, t, r, e1, n);
                                    break e;
                                case 11:
                                    t = Us(null, t, r, e1, n);
                                    break e;
                                case 14:
                                    t = js(null, t, r, qr(r.type, e1), i, n);
                                    break e;
                            }
                            throw Error(s(306, r, ""));
                        }
                        return t;
                    case 0:
                        return i = t.type, r = t.pendingProps, Hs(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 1:
                        return i = t.type, r = t.pendingProps, Gs(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 3:
                        if (Qs(t), i = t.updateQueue, null === e1 || null === i) throw Error(s(282));
                        if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, la(e1, t), da(t, i, null, n), (i = t.memoizedState.element) === r) Wa(), t = no(e1, t, n);
                        else {
                            if ((a = (r = t.stateNode).hydrate) && (ka = Yi(t.stateNode.containerInfo.firstChild), ja = t, a = Ba = !0), a) {
                                if (null != (e1 = r.mutableSourceEagerHydrationData)) for(r = 0; r < e1.length; r += 2)(a = e1[r])._workInProgressVersionPrimary = e1[r + 1], Ya.push(a);
                                for(n = Sa(t, null, i, n), t.child = n; n;)n.flags = -3 & n.flags | 1024, n = n.sibling;
                            } else Ps(e1, t, i, n), Wa();
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return Oa(t), null === e1 && Ga(t), i = t.type, r = t.pendingProps, a = null !== e1 ? e1.memoizedProps : null, o = r.children, Gi(i, r) ? o = null : null !== a && Gi(i, a) && (t.flags |= 16), Fs(e1, t), Ps(e1, t, o, n), t.child;
                    case 6:
                        return null === e1 && Ga(t), null;
                    case 13:
                        return Ks(e1, t, n);
                    case 4:
                        return La(t, t.stateNode.containerInfo), i = t.pendingProps, null === e1 ? t.child = Ta(t, null, i, n) : Ps(e1, t, i, n), t.child;
                    case 11:
                        return i = t.type, r = t.pendingProps, Us(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 7:
                        return Ps(e1, t, t.pendingProps, n), t.child;
                    case 8:
                    case 12:
                        return Ps(e1, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            i = t.type._context, r = t.pendingProps, o = t.memoizedProps, a = r.value;
                            var l = t.type._context;
                            if (ur(Kr, l._currentValue), l._currentValue = a, null !== o) {
                                if (l = o.value, 0 == (a = ci(l, a) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(l, a) : 1073741823))) {
                                    if (o.children === r.children && !pr.current) {
                                        t = no(e1, t, n);
                                        break e;
                                    }
                                } else for(null !== (l = t.child) && (l.return = t); null !== l;){
                                    var c = l.dependencies;
                                    if (null !== c) {
                                        o = l.child;
                                        for(var u = c.firstContext; null !== u;){
                                            if (u.context === i && u.observedBits & a) {
                                                1 === l.tag && ((u = ca(-1, n & -n)).tag = 2, ua(l, u)), l.lanes |= n, null !== (u = l.alternate) && (u.lanes |= n), ia(l.return, n), c.lanes |= n;
                                                break;
                                            }
                                            u = u.next;
                                        }
                                    } else o = 10 === l.tag && l.type === t.type ? null : l.child;
                                    if (null !== o) o.return = l;
                                    else for(o = l; null !== o;){
                                        if (o === t) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (l = o.sibling)) {
                                            l.return = o.return, o = l;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    l = o;
                                }
                            }
                            Ps(e1, t, r.children, n), t = t.child;
                        }
                        return t;
                    case 9:
                        return r = t.type, i = (a = t.pendingProps).children, ra(t, n), i = i(r = aa(r, a.unstable_observedBits)), t.flags |= 1, Ps(e1, t, i, n), t.child;
                    case 14:
                        return a = qr(r = t.type, t.pendingProps), js(e1, t, r, a = qr(r.type, a), i, n);
                    case 15:
                        return ks(e1, t, t.type, t.pendingProps, i, n);
                    case 17:
                        return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : qr(i, r), null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), t.tag = 1, mr(i) ? (e1 = !0, yr(t)) : e1 = !1, ra(t, n), Ma(t, i, r), ya(t, i, r, n), Vs(null, t, i, !0, e1, n);
                    case 19:
                        return to(e1, t, n);
                    case 23:
                    case 24:
                        return Bs(e1, t, n);
                }
                throw Error(s(156, t.tag));
            }, tc.prototype.render = function(e1) {
                Kl(e1, this._internalRoot, null, null);
            }, tc.prototype.unmount = function() {
                var e1 = this._internalRoot, t = e1.containerInfo;
                Kl(null, e1, null, function() {
                    t[$i] = null;
                });
            }, et = function(e1) {
                13 === e1.tag && (dl(e1, 4, ul()), ec(e1, 4));
            }, tt = function(e1) {
                13 === e1.tag && (dl(e1, 67108864, ul()), ec(e1, 67108864));
            }, nt = function(e1) {
                if (13 === e1.tag) {
                    var t = ul(), n = hl(e1);
                    dl(e1, n, t), ec(e1, n);
                }
            }, it = function(e1, t) {
                return t();
            }, Se = function(e1, t, n) {
                switch(t){
                    case "input":
                        if (ne(e1, n), t = n.name, "radio" === n.type && null != t) {
                            for(n = e1; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                var i = n[t];
                                if (i !== e1 && i.form === e1.form) {
                                    var r = rr(i);
                                    if (!r) throw Error(s(90));
                                    K(i), ne(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ce(e1, n);
                        break;
                    case "select":
                        null != (t = n.value) && se(e1, !!n.multiple, t, !1);
                }
            }, Le = Ml, ze = function(e1, t, n, i, r) {
                var a = _o;
                _o |= 4;
                try {
                    return Qr(98, e1.bind(null, t, n, i, r));
                } finally{
                    0 === (_o = a) && (Qo(), Yr());
                }
            }, Oe = function() {
                !(49 & _o) && (function() {
                    if (null !== nl) {
                        var e1 = nl;
                        nl = null, e1.forEach(function(e1) {
                            e1.expiredLanes |= 24 & e1.pendingLanes, fl(e1, Hr());
                        });
                    }
                    Yr();
                }(), zl());
            }, Re = function(e1, t) {
                var n = _o;
                _o |= 2;
                try {
                    return e1(t);
                } finally{
                    0 === (_o = n) && (Qo(), Yr());
                }
            };
            var ac = {
                Events: [
                    nr,
                    ir,
                    rr,
                    _e,
                    Ce,
                    zl,
                    {
                        current: !1
                    }
                ]
            }, sc = {
                findFiberByHostInstance: tr,
                bundleType: 0,
                version: "17.0.2",
                rendererPackageName: "react-dom"
            }, oc = {
                bundleType: sc.bundleType,
                version: sc.version,
                rendererPackageName: sc.rendererPackageName,
                rendererConfig: sc.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: x.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(e1) {
                    return null === (e1 = Je(e1)) ? null : e1.stateNode;
                },
                findFiberByHostInstance: sc.findFiberByHostInstance || function() {
                    return null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            };
            if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                var lc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (!lc.isDisabled && lc.supportsFiber) try {
                    br = lc.inject(oc), wr = lc;
                } catch (ge) {}
            }
            t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ac, t.createPortal = rc, t.findDOMNode = function(e1) {
                if (null == e1) return null;
                if (1 === e1.nodeType) return e1;
                var t = e1._reactInternals;
                if (void 0 === t) {
                    if ("function" == typeof e1.render) throw Error(s(188));
                    throw Error(s(268, Object.keys(e1)));
                }
                return null === (e1 = Je(t)) ? null : e1.stateNode;
            }, t.flushSync = function(e1, t) {
                var n = _o;
                if (48 & n) return e1(t);
                _o |= 1;
                try {
                    if (e1) return Qr(99, e1.bind(null, t));
                } finally{
                    _o = n, Yr();
                }
            }, t.hydrate = function(e1, t, n) {
                if (!nc(t)) throw Error(s(200));
                return ic(null, e1, t, !0, n);
            }, t.render = function(e1, t, n) {
                if (!nc(t)) throw Error(s(200));
                return ic(null, e1, t, !1, n);
            }, t.unmountComponentAtNode = function(e1) {
                if (!nc(e1)) throw Error(s(40));
                return !!e1._reactRootContainer && (vl(function() {
                    ic(null, null, e1, !1, function() {
                        e1._reactRootContainer = null, e1[$i] = null;
                    });
                }), !0);
            }, t.unstable_batchedUpdates = Ml, t.unstable_createPortal = function(e1, t) {
                return rc(e1, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, t.unstable_renderSubtreeIntoContainer = function(e1, t, n, i) {
                if (!nc(n)) throw Error(s(200));
                if (null == e1 || void 0 === e1._reactInternals) throw Error(s(38));
                return ic(e1, t, n, !1, i);
            }, t.version = "17.0.2";
        },
        834: (e1, t, n)=>{
            "use strict";
            !function e1() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e1);
                } catch (e1) {
                    console.error(e1);
                }
            }(), e1.exports = n(230);
        },
        534: (e1, t, n)=>{
            "use strict";
            var i = n(383), r = 60103, a = 60106;
            t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
            var s = 60109, o = 60110, l = 60112;
            t.Suspense = 60113;
            var c = 60115, u = 60116;
            if ("function" == typeof Symbol && Symbol.for) {
                var h = Symbol.for;
                r = h("react.element"), a = h("react.portal"), t.Fragment = h("react.fragment"), t.StrictMode = h("react.strict_mode"), t.Profiler = h("react.profiler"), s = h("react.provider"), o = h("react.context"), l = h("react.forward_ref"), t.Suspense = h("react.suspense"), c = h("react.memo"), u = h("react.lazy");
            }
            var d = "function" == typeof Symbol && Symbol.iterator;
            function p(e1) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var f = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, g = {};
            function m(e1, t, n) {
                this.props = e1, this.context = t, this.refs = g, this.updater = n || f;
            }
            function A() {}
            function M(e1, t, n) {
                this.props = e1, this.context = t, this.refs = g, this.updater = n || f;
            }
            m.prototype.isReactComponent = {}, m.prototype.setState = function(e1, t) {
                if ("object" != typeof e1 && "function" != typeof e1 && null != e1) throw Error(p(85));
                this.updater.enqueueSetState(this, e1, t, "setState");
            }, m.prototype.forceUpdate = function(e1) {
                this.updater.enqueueForceUpdate(this, e1, "forceUpdate");
            }, A.prototype = m.prototype;
            var v = M.prototype = new A;
            v.constructor = M, i(v, m.prototype), v.isPureReactComponent = !0;
            var y = {
                current: null
            }, x = Object.prototype.hasOwnProperty, b = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function w(e1, t, n) {
                var i, a = {}, s = null, o = null;
                if (null != t) for(i in void 0 !== t.ref && (o = t.ref), void 0 !== t.key && (s = "" + t.key), t)x.call(t, i) && !b.hasOwnProperty(i) && (a[i] = t[i]);
                var l = arguments.length - 2;
                if (1 === l) a.children = n;
                else if (1 < l) {
                    for(var c = Array(l), u = 0; u < l; u++)c[u] = arguments[u + 2];
                    a.children = c;
                }
                if (e1 && e1.defaultProps) for(i in l = e1.defaultProps)void 0 === a[i] && (a[i] = l[i]);
                return {
                    $$typeof: r,
                    type: e1,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: y.current
                };
            }
            function E(e1) {
                return "object" == typeof e1 && null !== e1 && e1.$$typeof === r;
            }
            var T = /\/+/g;
            function S(e1, t) {
                return "object" == typeof e1 && null !== e1 && null != e1.key ? function(e1) {
                    var t = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + e1.replace(/[=:]/g, function(e1) {
                        return t[e1];
                    });
                }("" + e1.key) : t.toString(36);
            }
            function I(e1, t, n, i, s) {
                var o = typeof e1;
                "undefined" !== o && "boolean" !== o || (e1 = null);
                var l = !1;
                if (null === e1) l = !0;
                else switch(o){
                    case "string":
                    case "number":
                        l = !0;
                        break;
                    case "object":
                        switch(e1.$$typeof){
                            case r:
                            case a:
                                l = !0;
                        }
                }
                if (l) return s = s(l = e1), e1 = "" === i ? "." + S(l, 0) : i, Array.isArray(s) ? (n = "", null != e1 && (n = e1.replace(T, "$&/") + "/"), I(s, t, n, "", function(e1) {
                    return e1;
                })) : null != s && (E(s) && (s = function(e1, t) {
                    return {
                        $$typeof: r,
                        type: e1.type,
                        key: t,
                        ref: e1.ref,
                        props: e1.props,
                        _owner: e1._owner
                    };
                }(s, n + (!s.key || l && l.key === s.key ? "" : ("" + s.key).replace(T, "$&/") + "/") + e1)), t.push(s)), 1;
                if (l = 0, i = "" === i ? "." : i + ":", Array.isArray(e1)) for(var c = 0; c < e1.length; c++){
                    var u = i + S(o = e1[c], c);
                    l += I(o, t, n, u, s);
                }
                else if (u = function(e1) {
                    return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = d && e1[d] || e1["@@iterator"]) ? e1 : null;
                }(e1), "function" == typeof u) for(e1 = u.call(e1), c = 0; !(o = e1.next()).done;)l += I(o = o.value, t, n, u = i + S(o, c++), s);
                else if ("object" === o) throw t = "" + e1, Error(p(31, "[object Object]" === t ? "object with keys {" + Object.keys(e1).join(", ") + "}" : t));
                return l;
            }
            function N(e1, t, n) {
                if (null == e1) return e1;
                var i = [], r = 0;
                return I(e1, i, "", "", function(e1) {
                    return t.call(n, e1, r++);
                }), i;
            }
            function D(e1) {
                if (-1 === e1._status) {
                    var t = e1._result;
                    t = t(), e1._status = 0, e1._result = t, t.then(function(t) {
                        0 === e1._status && (t = t.default, e1._status = 1, e1._result = t);
                    }, function(t) {
                        0 === e1._status && (e1._status = 2, e1._result = t);
                    });
                }
                if (1 === e1._status) return e1._result;
                throw e1._result;
            }
            var _ = {
                current: null
            };
            function C() {
                var e1 = _.current;
                if (null === e1) throw Error(p(321));
                return e1;
            }
            var L = {
                ReactCurrentDispatcher: _,
                ReactCurrentBatchConfig: {
                    transition: 0
                },
                ReactCurrentOwner: y,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            t.Children = {
                map: N,
                forEach: function(e1, t, n) {
                    N(e1, function() {
                        t.apply(this, arguments);
                    }, n);
                },
                count: function(e1) {
                    var t = 0;
                    return N(e1, function() {
                        t++;
                    }), t;
                },
                toArray: function(e1) {
                    return N(e1, function(e1) {
                        return e1;
                    }) || [];
                },
                only: function(e1) {
                    if (!E(e1)) throw Error(p(143));
                    return e1;
                }
            }, t.Component = m, t.PureComponent = M, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L, t.cloneElement = function(e1, t, n) {
                if (null == e1) throw Error(p(267, e1));
                var a = i({}, e1.props), s = e1.key, o = e1.ref, l = e1._owner;
                if (null != t) {
                    if (void 0 !== t.ref && (o = t.ref, l = y.current), void 0 !== t.key && (s = "" + t.key), e1.type && e1.type.defaultProps) var c = e1.type.defaultProps;
                    for(u in t)x.call(t, u) && !b.hasOwnProperty(u) && (a[u] = void 0 === t[u] && void 0 !== c ? c[u] : t[u]);
                }
                var u = arguments.length - 2;
                if (1 === u) a.children = n;
                else if (1 < u) {
                    c = Array(u);
                    for(var h = 0; h < u; h++)c[h] = arguments[h + 2];
                    a.children = c;
                }
                return {
                    $$typeof: r,
                    type: e1.type,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: l
                };
            }, t.createContext = function(e1, t) {
                return void 0 === t && (t = null), (e1 = {
                    $$typeof: o,
                    _calculateChangedBits: t,
                    _currentValue: e1,
                    _currentValue2: e1,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: s,
                    _context: e1
                }, e1.Consumer = e1;
            }, t.createElement = w, t.createFactory = function(e1) {
                var t = w.bind(null, e1);
                return t.type = e1, t;
            }, t.createRef = function() {
                return {
                    current: null
                };
            }, t.forwardRef = function(e1) {
                return {
                    $$typeof: l,
                    render: e1
                };
            }, t.isValidElement = E, t.lazy = function(e1) {
                return {
                    $$typeof: u,
                    _payload: {
                        _status: -1,
                        _result: e1
                    },
                    _init: D
                };
            }, t.memo = function(e1, t) {
                return {
                    $$typeof: c,
                    type: e1,
                    compare: void 0 === t ? null : t
                };
            }, t.useCallback = function(e1, t) {
                return C().useCallback(e1, t);
            }, t.useContext = function(e1, t) {
                return C().useContext(e1, t);
            }, t.useDebugValue = function() {}, t.useEffect = function(e1, t) {
                return C().useEffect(e1, t);
            }, t.useImperativeHandle = function(e1, t, n) {
                return C().useImperativeHandle(e1, t, n);
            }, t.useLayoutEffect = function(e1, t) {
                return C().useLayoutEffect(e1, t);
            }, t.useMemo = function(e1, t) {
                return C().useMemo(e1, t);
            }, t.useReducer = function(e1, t, n) {
                return C().useReducer(e1, t, n);
            }, t.useRef = function(e1) {
                return C().useRef(e1);
            }, t.useState = function(e1) {
                return C().useState(e1);
            }, t.version = "17.0.2";
        },
        471: (e1, t, n)=>{
            "use strict";
            e1.exports = n(534);
        },
        582: (e1, t)=>{
            "use strict";
            var n, i, r, a;
            if ("object" == typeof performance && "function" == typeof performance.now) {
                var s = performance;
                t.unstable_now = function() {
                    return s.now();
                };
            } else {
                var o = Date, l = o.now();
                t.unstable_now = function() {
                    return o.now() - l;
                };
            }
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, u = null, h = function() {
                    if (null !== c) try {
                        var e1 = t.unstable_now();
                        c(!0, e1), c = null;
                    } catch (e1) {
                        throw setTimeout(h, 0), e1;
                    }
                };
                n = function(e1) {
                    null !== c ? setTimeout(n, 0, e1) : (c = e1, setTimeout(h, 0));
                }, i = function(e1, t) {
                    u = setTimeout(e1, t);
                }, r = function() {
                    clearTimeout(u);
                }, t.unstable_shouldYield = function() {
                    return !1;
                }, a = t.unstable_forceFrameRate = function() {};
            } else {
                var d = window.setTimeout, p = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var f = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof f && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
                }
                var g = !1, m = null, A = -1, M = 5, v = 0;
                t.unstable_shouldYield = function() {
                    return t.unstable_now() >= v;
                }, a = function() {}, t.unstable_forceFrameRate = function(e1) {
                    0 > e1 || 125 < e1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : M = 0 < e1 ? Math.floor(1e3 / e1) : 5;
                };
                var y = new MessageChannel, x = y.port2;
                y.port1.onmessage = function() {
                    if (null !== m) {
                        var e1 = t.unstable_now();
                        v = e1 + M;
                        try {
                            m(!0, e1) ? x.postMessage(null) : (g = !1, m = null);
                        } catch (e1) {
                            throw x.postMessage(null), e1;
                        }
                    } else g = !1;
                }, n = function(e1) {
                    m = e1, g || (g = !0, x.postMessage(null));
                }, i = function(e1, n) {
                    A = d(function() {
                        e1(t.unstable_now());
                    }, n);
                }, r = function() {
                    p(A), A = -1;
                };
            }
            function b(e1, t) {
                var n = e1.length;
                e1.push(t);
                e: for(;;){
                    var i = n - 1 >>> 1, r = e1[i];
                    if (!(void 0 !== r && 0 < T(r, t))) break e;
                    e1[i] = t, e1[n] = r, n = i;
                }
            }
            function w(e1) {
                return void 0 === (e1 = e1[0]) ? null : e1;
            }
            function E(e1) {
                var t = e1[0];
                if (void 0 !== t) {
                    var n = e1.pop();
                    if (n !== t) {
                        e1[0] = n;
                        e: for(var i = 0, r = e1.length; i < r;){
                            var a = 2 * (i + 1) - 1, s = e1[a], o = a + 1, l = e1[o];
                            if (void 0 !== s && 0 > T(s, n)) void 0 !== l && 0 > T(l, s) ? (e1[i] = l, e1[o] = n, i = o) : (e1[i] = s, e1[a] = n, i = a);
                            else {
                                if (!(void 0 !== l && 0 > T(l, n))) break e;
                                e1[i] = l, e1[o] = n, i = o;
                            }
                        }
                    }
                    return t;
                }
                return null;
            }
            function T(e1, t) {
                var n = e1.sortIndex - t.sortIndex;
                return 0 !== n ? n : e1.id - t.id;
            }
            var S = [], I = [], N = 1, D = null, _ = 3, C = !1, L = !1, z = !1;
            function O(e1) {
                for(var t = w(I); null !== t;){
                    if (null === t.callback) E(I);
                    else {
                        if (!(t.startTime <= e1)) break;
                        E(I), t.sortIndex = t.expirationTime, b(S, t);
                    }
                    t = w(I);
                }
            }
            function R(e1) {
                if (z = !1, O(e1), !L) {
                    if (null !== w(S)) L = !0, n(P);
                    else {
                        var t = w(I);
                        null !== t && i(R, t.startTime - e1);
                    }
                }
            }
            function P(e1, n) {
                L = !1, z && (z = !1, r()), C = !0;
                var a = _;
                try {
                    for(O(n), D = w(S); null !== D && (!(D.expirationTime > n) || e1 && !t.unstable_shouldYield());){
                        var s = D.callback;
                        if ("function" == typeof s) {
                            D.callback = null, _ = D.priorityLevel;
                            var o = s(D.expirationTime <= n);
                            n = t.unstable_now(), "function" == typeof o ? D.callback = o : D === w(S) && E(S), O(n);
                        } else E(S);
                        D = w(S);
                    }
                    if (null !== D) var l = !0;
                    else {
                        var c = w(I);
                        null !== c && i(R, c.startTime - n), l = !1;
                    }
                    return l;
                } finally{
                    D = null, _ = a, C = !1;
                }
            }
            var U = a;
            t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e1) {
                e1.callback = null;
            }, t.unstable_continueExecution = function() {
                L || C || (L = !0, n(P));
            }, t.unstable_getCurrentPriorityLevel = function() {
                return _;
            }, t.unstable_getFirstCallbackNode = function() {
                return w(S);
            }, t.unstable_next = function(e1) {
                switch(_){
                    case 1:
                    case 2:
                    case 3:
                        var t = 3;
                        break;
                    default:
                        t = _;
                }
                var n = _;
                _ = t;
                try {
                    return e1();
                } finally{
                    _ = n;
                }
            }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = U, t.unstable_runWithPriority = function(e1, t) {
                switch(e1){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        e1 = 3;
                }
                var n = _;
                _ = e1;
                try {
                    return t();
                } finally{
                    _ = n;
                }
            }, t.unstable_scheduleCallback = function(e1, a, s) {
                var o = t.unstable_now();
                switch(s = "object" == typeof s && null !== s && "number" == typeof (s = s.delay) && 0 < s ? o + s : o, e1){
                    case 1:
                        var l = -1;
                        break;
                    case 2:
                        l = 250;
                        break;
                    case 5:
                        l = 1073741823;
                        break;
                    case 4:
                        l = 1e4;
                        break;
                    default:
                        l = 5e3;
                }
                return e1 = {
                    id: N++,
                    callback: a,
                    priorityLevel: e1,
                    startTime: s,
                    expirationTime: l = s + l,
                    sortIndex: -1
                }, s > o ? (e1.sortIndex = s, b(I, e1), null === w(S) && e1 === w(I) && (z ? r() : z = !0, i(R, s - o))) : (e1.sortIndex = l, b(S, e1), L || C || (L = !0, n(P))), e1;
            }, t.unstable_wrapCallback = function(e1) {
                var t = _;
                return function() {
                    var n = _;
                    _ = t;
                    try {
                        return e1.apply(this, arguments);
                    } finally{
                        _ = n;
                    }
                };
            };
        },
        817: (e1, t, n)=>{
            "use strict";
            e1.exports = n(582);
        },
        229: function(e1, t, n) {
            var i;
            !function(r, a) {
                "use strict";
                var s = "function", o = "undefined", l = "object", c = "string", u = "major", h = "model", d = "name", p = "type", f = "vendor", g = "version", m = "architecture", A = "console", M = "mobile", v = "tablet", y = "smarttv", x = "wearable", b = "embedded", w = "Amazon", E = "Apple", T = "ASUS", S = "BlackBerry", I = "Browser", N = "Chrome", D = "Firefox", _ = "Google", C = "Huawei", L = "LG", z = "Microsoft", O = "Motorola", R = "Opera", P = "Samsung", U = "Sharp", j = "Sony", k = "Xiaomi", B = "Zebra", F = "Facebook", H = "Chromium OS", G = "Mac OS", V = function(e1) {
                    for(var t = {}, n = 0; n < e1.length; n++)t[e1[n].toUpperCase()] = e1[n];
                    return t;
                }, Q = function(e1, t) {
                    return typeof e1 === c && -1 !== W(t).indexOf(W(e1));
                }, W = function(e1) {
                    return e1.toLowerCase();
                }, Y = function(e1, t) {
                    if (typeof e1 === c) return e1 = e1.replace(/^\s\s*/, ""), typeof t === o ? e1 : e1.substring(0, 500);
                }, X = function(e1, t) {
                    for(var n, i, r, o, c, u, h = 0; h < t.length && !c;){
                        var d = t[h], p = t[h + 1];
                        for(n = i = 0; n < d.length && !c && d[n];)if (c = d[n++].exec(e1)) for(r = 0; r < p.length; r++)u = c[++i], typeof (o = p[r]) === l && o.length > 0 ? 2 === o.length ? typeof o[1] == s ? this[o[0]] = o[1].call(this, u) : this[o[0]] = o[1] : 3 === o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? this[o[0]] = u ? u.replace(o[1], o[2]) : a : this[o[0]] = u ? o[1].call(this, u, o[2]) : a : 4 === o.length && (this[o[0]] = u ? o[3].call(this, u.replace(o[1], o[2])) : a) : this[o] = u || a;
                        h += 2;
                    }
                }, Z = function(e1, t) {
                    for(var n in t)if (typeof t[n] === l && t[n].length > 0) {
                        for(var i = 0; i < t[n].length; i++)if (Q(t[n][i], e1)) return "?" === n ? a : n;
                    } else if (Q(t[n], e1)) return "?" === n ? a : n;
                    return e1;
                }, q = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, K = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                R + " Mini"
                            ]
                        ],
                        [
                            /\bop(?:rg)?x\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                R + " GX"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                R
                            ]
                        ],
                        [
                            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Baidu"
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                            /(heytap|ovi)browser\/([\d\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /\bddg\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "DuckDuckGo"
                            ]
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "UC" + I
                            ]
                        ],
                        [
                            /microm.+\bqbcore\/([\w\.]+)/i,
                            /\bqbcore\/([\w\.]+).+microm/i,
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            g,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /ya(?:search)?browser\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /slbrowser\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Smart Lenovo " + I
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure " + I
                            ],
                            g
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                D + " Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                R + " Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                R + " Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "MIUI " + I
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                D
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 " + I
                            ]
                        ],
                        [
                            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 " + I
                            ],
                            g
                        ],
                        [
                            /samsungbrowser\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                P + " Internet"
                            ]
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            g
                        ],
                        [
                            /metasr[\/ ]?([\d\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Sogou Explorer"
                            ]
                        ],
                        [
                            /(sogou)mo\w+\/([\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Sogou Mobile"
                            ],
                            g
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /(lbbrowser)/i,
                            /\[(linkedin)app\]/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                F
                            ],
                            g
                        ],
                        [
                            /(Klarna)\/([\w\.]+)/i,
                            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(alipay)client\/([\w\.]+)/i,
                            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            g,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "TikTok"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            g,
                            [
                                d,
                                N + " Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                N + " WebView"
                            ],
                            g
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Android " + I
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            g,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                g,
                                Z,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            g
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            g,
                            [
                                d,
                                D + " Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i,
                            /panasonic;(viera)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /(cobalt)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                g,
                                /master.|lts./,
                                ""
                            ]
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                m,
                                W
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                m,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                m,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                m,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                m,
                                /ower/,
                                "",
                                W
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                m,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                m,
                                W
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(macintosh);/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(opd2\d{3}a?) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Vivo"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Realme"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            h,
                            [
                                f,
                                O
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Lenovo"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                "Nokia"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                "Xperia Tablet"
                            ],
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OnePlus"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                h,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            h,
                            f,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                S
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "HTC"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                        ],
                        [
                            f,
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Acer"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Meizu"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Ulefone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kobo)\s(ereader|touch)/i,
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Fairphone"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "AT&T"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Siemens"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "RCA"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Dell"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Verizon"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Barnes & Noble"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NuVision"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Zeki"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                f,
                                "Dragon Touch"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Insignia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NextBook"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                f,
                                "Voice"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                f,
                                "LvTel"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            h,
                            [
                                f,
                                "Essential"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Envizen"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "MachSpeed"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Rotor"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                h,
                                /\./g,
                                " "
                            ],
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            f,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                h,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            f,
                            [
                                h,
                                E + " TV"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                h,
                                N + "cast"
                            ],
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+aft(\w+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i,
                            /(aquos-tv[\w ]+)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(bravia[\w ]+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(mitv-\w{5}) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /Hbbtv.*(technisat) (.*);/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                        ],
                        [
                            [
                                f,
                                Y
                            ],
                            [
                                h,
                                Y
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            h,
                            [
                                f,
                                _
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(quest( \d| pro)?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                F
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /(aeobc)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                b
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i,
                            /\b(libweb)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            g,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                        ],
                        [
                            d,
                            [
                                g,
                                Z,
                                q
                            ]
                        ],
                        [
                            /windows nt 6\.2; (arm)/i,
                            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                g,
                                Z,
                                q
                            ],
                            [
                                d,
                                "Windows"
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                g,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                G
                            ],
                            [
                                g,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                        ],
                        [
                            g,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            g,
                            [
                                d,
                                S
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                D + " OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                "watchOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            g,
                            [
                                d,
                                N + "cast"
                            ]
                        ],
                        [
                            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                        ],
                        [
                            [
                                d,
                                H
                            ],
                            g
                        ],
                        [
                            /panasonic;(viera)/i,
                            /(netrange)mmh/i,
                            /(nettv)\/(\d+\.[\w\.]+)/i,
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            g
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            g
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            g
                        ]
                    ]
                }, J = function(e1, t) {
                    if (typeof e1 === l && (t = e1, e1 = a), !(this instanceof J)) return new J(e1, t).getResult();
                    var n = typeof r !== o && r.navigator ? r.navigator : a, i = e1 || (n && n.userAgent ? n.userAgent : ""), A = n && n.userAgentData ? n.userAgentData : a, y = t ? function(e1, t) {
                        var n = {};
                        for(var i in e1)t[i] && t[i].length % 2 == 0 ? n[i] = t[i].concat(e1[i]) : n[i] = e1[i];
                        return n;
                    }(K, t) : K, x = n && n.userAgent == i;
                    return this.getBrowser = function() {
                        var e1, t = {};
                        return t[d] = a, t[g] = a, X.call(t, i, y.browser), t[u] = typeof (e1 = t[g]) === c ? e1.replace(/[^\d\.]/g, "").split(".")[0] : a, x && n && n.brave && typeof n.brave.isBrave == s && (t[d] = "Brave"), t;
                    }, this.getCPU = function() {
                        var e1 = {};
                        return e1[m] = a, X.call(e1, i, y.cpu), e1;
                    }, this.getDevice = function() {
                        var e1 = {};
                        return e1[f] = a, e1[h] = a, e1[p] = a, X.call(e1, i, y.device), x && !e1[p] && A && A.mobile && (e1[p] = M), x && "Macintosh" == e1[h] && n && typeof n.standalone !== o && n.maxTouchPoints && n.maxTouchPoints > 2 && (e1[h] = "iPad", e1[p] = v), e1;
                    }, this.getEngine = function() {
                        var e1 = {};
                        return e1[d] = a, e1[g] = a, X.call(e1, i, y.engine), e1;
                    }, this.getOS = function() {
                        var e1 = {};
                        return e1[d] = a, e1[g] = a, X.call(e1, i, y.os), x && !e1[d] && A && A.platform && "Unknown" != A.platform && (e1[d] = A.platform.replace(/chrome os/i, H).replace(/macos/i, G)), e1;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return i;
                    }, this.setUA = function(e1) {
                        return i = typeof e1 === c && e1.length > 500 ? Y(e1, 500) : e1, this;
                    }, this.setUA(i), this;
                };
                J.VERSION = "1.0.38", J.BROWSER = V([
                    d,
                    g,
                    u
                ]), J.CPU = V([
                    m
                ]), J.DEVICE = V([
                    h,
                    f,
                    p,
                    A,
                    M,
                    y,
                    v,
                    x,
                    b
                ]), J.ENGINE = J.OS = V([
                    d,
                    g
                ]), typeof t !== o ? (e1.exports && (t = e1.exports = J), t.UAParser = J) : n.amdO ? (i = (function() {
                    return J;
                }).call(t, n, t, e1)) === a || (e1.exports = i) : typeof r !== o && (r.UAParser = J);
                var $ = typeof r !== o && (r.jQuery || r.Zepto);
                if ($ && !$.ua) {
                    var ee = new J;
                    $.ua = ee.getResult(), $.ua.get = function() {
                        return ee.getUA();
                    }, $.ua.set = function(e1) {
                        ee.setUA(e1);
                        var t = ee.getResult();
                        for(var n in t)$.ua[n] = t[n];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        447: (e1)=>{
            function t(e1, t, n) {
                e1.addEventListener("wheel", t, n);
            }
            e1.exports = t, e1.exports.addWheelListener = t, e1.exports.removeWheelListener = function(e1, t, n) {
                e1.removeEventListener("wheel", t, n);
            };
        },
        132: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>M
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a), o = n(492), l = n.n(o), c = new URL(n(425), n.b), u = new URL(n(943), n.b), h = new URL(n(88), n.b), d = new URL(n(562), n.b), p = s()(r()), f = l()(c), g = l()(u), m = l()(h), A = l()(d);
            p.push([
                e1.id,
                `@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${f}) format("woff2");unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${g}) format("woff2");unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${m}) format("woff2");unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:"Roboto Flex";font-style:normal;font-weight:100 1000;font-stretch:100%;font-display:swap;src:url(${A}) format("woff2");unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}.widget-application .widget-tab-buttons{position:absolute;z-index:3;right:45px;bottom:34px;display:flex;align-items:center;justify-content:flex-end;row-gap:28px}.widget-application--mobile.widget-application .widget-tab-buttons{row-gap:8px;bottom:20px;right:20px}.widget-application .widget-tab-button{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:60px;height:60px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#ededed;margin-left:24px}.widget-application--mobile.widget-application .widget-tab-button{margin-left:10px;width:44px;height:44px}.widget-application .widget-tab-button--active{background-color:var(--main-color) !important;color:var(--main-text)}.widget-application .widget-tab-button--active img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-button img{width:100%;height:100%}.widget-application--three.widget-application--standard .widget-tab-buttons{flex-direction:column;row-gap:28px;bottom:120px;right:30px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab-buttons{bottom:120px;right:30px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab-buttons{flex-direction:row;row-gap:10px;bottom:24px;right:21px}.widget-application--three.widget-application--standard .widget-tab-buttons .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab-buttons .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab-buttons .widget-tab-button{font-size:17px;line-height:23px;width:44px;height:44px}.widget-application .widget-tab{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px}.widget-application--smallMobile.widget-application .widget-tab{padding:60px 20px}.widget-application .widget-tab--rotation{padding:0 !important}.widget-application .widget-tab--plan{padding:0 !important}.widget-application .widget-tab--panorama~.widget-tab-buttons button{background-color:#fff}.widget-application .widget-tab-menu{position:absolute;z-index:3;left:15px;top:15px;max-height:100%;overflow-y:auto;padding-bottom:30px}.widget-application .widget-tab-menu__wallpapers{display:flex;flex-wrap:wrap;align-items:flex-start;margin-top:10px;width:100%}.widget-application .widget-tab-menu__wallpapers img{width:30px;height:30px;display:block;object-fit:cover;cursor:pointer;margin-right:10px;margin-block-end:10px}.widget-application .widget-tab-menu ul{list-style-type:none}.widget-application .widget-tab-menu ul li{color:#413e3e;background-color:var(--main-color);padding:5px 15px;border-radius:10px;font-size:.7rem;border:none;cursor:pointer;margin-bottom:15px;width:200px;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab-menu ul li label{display:flex;cursor:inherit;width:100%}.widget-application .widget-tab-menu ul li input[type=color]{cursor:pointer;margin-left:auto;width:50px;height:20px;border:0;border-radius:5px}.widget-application .widget-tab-menu ul li input[type=color]::-webkit-color-swatch-wrapper{display:none !important}.widget-application .widget-tab-menu ul li input[type=file]{display:none}.widget-application .widget-tab-menu ul li:nth-child(1){position:relative}.widget-application .widget-tab-menu ul li:nth-child(1)::after{--bar-width: 2px;content:"";width:20px;height:15px;display:block;background:repeating-linear-gradient(180deg, #000000, #000000 var(--bar-width), rgba(0, 0, 0, 0) var(--bar-width), rgba(0, 0, 0, 0) calc(var(--bar-width) * 3));position:absolute;right:10px;top:50%;transform:translateY(-50%)}.widget-application .widget-instructions{position:absolute;z-index:3;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:cover}.widget-application .widget-instructions__content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;background-color:rgba(234,234,234,.85);border-radius:20px;overflow:hidden;width:400px;max-width:calc(100% - 60px);padding:36px 30px 30px 30px;backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-instructions__content{width:280px;padding:26px 20px 20px 20px}.widget-application .widget-instructions__steps{display:flex;align-items:flex-start;justify-content:center}.widget-application .widget-instructions__step{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 15px}.widget-application--tablet.widget-application .widget-instructions__step{margin:0 10px}.widget-application .widget-instructions__step img{display:block;width:52px;height:80px;object-fit:contain;object-position:center}.widget-application--mobile.widget-application .widget-instructions__step img{width:40px;height:60px}.widget-application--smallMobile.widget-application .widget-instructions__step img{width:35px}.widget-application .widget-instructions__step p{color:#413e3e;font-size:20px;font-weight:700;text-align:center;margin-top:10px;max-width:130px}.widget-application--tablet.widget-application .widget-instructions__step p{font-size:18px;max-width:115px}.widget-application--mobile.widget-application .widget-instructions__step p{font-size:16px}.widget-application--smallMobile.widget-application .widget-instructions__step p{font-size:14px}.widget-application .widget-instructions__hint p{color:#413e3e;font-weight:700;text-align:center;margin-top:1.5em;font-size:14px}.widget-application--tablet.widget-application .widget-instructions__hint p{font-size:12px}.widget-application--mobile.widget-application .widget-instructions__hint p{font-size:10px}.widget-application--smallMobile.widget-application .widget-instructions__hint p{font-size:8px}.widget-application .widget-instructions button{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;height:44px;padding:0 33px;border-radius:52px;background-color:var(--main-color);color:var(--main-text);font-size:24px;font-weight:700;text-transform:uppercase;margin:25px auto 0 auto}.widget-application .widget-instructions button:disabled{opacity:.75;cursor:not-allowed}.widget-application--tablet.widget-application .widget-instructions button{font-size:18px;height:40px}.widget-application--mobile.widget-application .widget-instructions button{font-size:16px;height:35px}.widget-application--smallMobile.widget-application .widget-instructions button{font-size:14px;height:26px;padding:0 25px}.widget-application .widget-tab__panorama{width:100%;height:100%;position:absolute;left:0;top:0;z-index:2}.widget-application .widget-tab__panorama-overlay{position:relative;width:100%;height:100%;overflow:hidden;background:#fff !important}.widget-application .widget-tab__panorama-overlay *{display:none}.widget-application .widget-tab__panorama-overlay canvas{display:block !important;touch-action:none !important}.widget-application .widget-tab__panorama-overlay .cursor{position:absolute;display:none;width:32px;height:32px;border-radius:50%;pointer-events:none;transform:translate(-50%, -50%);z-index:10}.widget-application .widget-tab__panorama-overlay .cursor img{display:block;width:100%;height:100%;z-index:10}.widget-application .widget-tab__panorama-overlay .cursor .circle{animation:circlePulse 1s infinite}.widget-application .widget-tab__panorama-overlay .cursor .pointer{animation:pointerPulse 1s infinite}.widget-application .widget-tab__panorama-enter-vr{position:absolute;left:50%;bottom:50px;transform:translateX(-50%);z-index:3;padding:10px 15px;border-radius:10px;border:2px solid #000;background-color:#fff;font-size:16px;font-weight:600;cursor:pointer}.widget-application .widget-tab__panorama-enter-vr:disabled{opacity:.5}.widget-application .widget-tab__panorama-controls{position:absolute;z-index:2;left:50%;bottom:35px;display:flex;align-items:center;justify-content:center;padding:8px;border-radius:38px;background-color:rgba(0,0,0,.2);transform:translateX(-50%);backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-tab__panorama-controls{padding:5px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls{bottom:30px}.widget-application .widget-tab__panorama-controls-container{position:absolute;left:50%;bottom:35px;display:flex;column-gap:5px;transform:translateX(-50%)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container{bottom:84px;left:unset;right:20px;transform:translateX(0)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-container{bottom:120px}.widget-application .widget-tab__panorama-controls-container>div{position:unset;left:unset;bottom:unset;padding:5px;transform:translateX(0)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container>div{padding:4px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:40px;height:40px;margin-right:11px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:34px;height:34px;margin-right:9px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:22px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:32px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:37px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--ruler img{width:32px;height:32px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--ruler img{width:42px;height:42px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--ruler-active img{width:18px;height:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--ruler-active img{width:42px;height:42px}.widget-application .widget-tab__panorama-controls-button{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:55px;height:55px;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;margin-right:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button{width:44px;height:44px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button{margin-right:10px;width:33px;height:33px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button{width:26px;height:26px}.widget-application .widget-tab__panorama-controls-button:disabled{background-color:#e6e6e6;cursor:not-allowed}.widget-application .widget-tab__panorama-controls-button:disabled img{filter:invert(100%) saturate(0)}.widget-application .widget-tab__panorama-controls-button img{display:block}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.7)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.52)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.45)}.widget-application .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-button--bareshell{display:flex;align-items:center;column-gap:10px;padding:11px 9px 9px 8px;background:none;border:none;cursor:pointer}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell{column-gap:7px;padding:8px 8px 8px 6px}.widget-application .widget-tab__panorama-controls-button--bareshell .checked{right:calc(100% - 2px);transform:translateX(-100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:15px;font-weight:700;line-height:20px;color:#fff}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:13px;line-height:17px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch{position:relative;width:34px;height:19px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox:checked+.widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{right:calc(100% - 2px);transform:translateX(100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;width:34px;height:19px;background-color:#fff;border-radius:20px;border:1px solid #fff;transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{content:"";position:absolute;top:1px;right:1px;width:14px;height:14px;border-radius:45px;transition:.2s;background:#413e3e}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{width:12px;height:12px}.widget-application .widget-tab__panorama-controls-button span{font-size:23px;font-weight:700;line-height:120%;letter-spacing:-0.12em}.widget-application .widget-tab__panorama-close-map{z-index:4}.widget-application .widget-tab__panorama-map{position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__panorama-map::before{content:"";position:absolute;z-index:-1;left:50%;top:50%;transform:translate(-50%, -50%);width:100%;height:100%;border-radius:inherit;background-color:#fff}.widget-application--tablet.widget-application .widget-tab__panorama-map{left:35px;transform:scale(0.6);transform-origin:0 100%}.widget-application--mobile.widget-application .widget-tab__panorama-map{left:20px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--mobile.widget-application .widget-tab__panorama-map--bottom{bottom:20px}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled::after{content:"";position:absolute;z-index:-2;left:50%;top:50%;transform:translate(-50%, -50%);width:100vw;height:100vh;background-color:rgba(196,196,196,.8)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled svg path:active{opacity:.3 !important}.widget-application--mobile.widget-application .widget-tab__panorama-map--scaled{transform:scale(1) translate(-50%, 50%)}.widget-application .widget-tab__panorama-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-map canvas{width:200px;border-radius:unset;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map-image{position:absolute;left:0;top:0;z-index:-1;display:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map svg{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);width:200px;height:calc(100% - 16px);z-index:3;display:block;border-radius:inherit}.widget-application .widget-tab__panorama-map svg path{opacity:0;fill:var(--main-color);cursor:pointer}.widget-application .widget-tab__panorama-map svg path:hover{opacity:.3}.widget-application .widget-tab__panorama-map__fov{--x: 0;--y: 0;--rotate: 0;position:absolute;left:calc(var(--x) + 8px);top:calc(var(--y) + 8px);width:16px;height:16px;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad));transform-origin:50% 50%;z-index:4;pointer-events:none}.widget-application .widget-tab__panorama-map__fov-direction{border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application .widget-tab__panorama-map__fov-dot{position:relative;z-index:5;width:100%;height:100%;background-color:var(--main-color);border-radius:50%;border:2px solid var(--main-color);box-shadow:inset 0 0 0 2px #fff}.widget-application .widget-tab__panorama-top-view-map{cursor:pointer;position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map{left:35px;transform:scale(0.6);transform-origin:0 100%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-top-view-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map--bottom{bottom:91px}.widget-application .widget-tab__panorama-top-view-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-top-view-map .display-wrapper{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas.hidden,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img.hidden{display:none}.widget-application .widget-tab__panorama-top-view-map .camera{opacity:.8;display:block;position:absolute;width:8px;height:8px;background:radial-gradient(var(--main-color) 0%, var(--main-color) 30%, transparent 45%, transparent 50%, var(--main-color) 70%);border-radius:50%;transform:translate(-50%, -50%);pointer-events:none;transition:background 200ms,opacity 200ms,width 200ms,height 200ms}.widget-application .widget-tab__panorama-top-view-map .camera--current{--rotate: 0;width:16px;height:16px;opacity:1;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad))}.widget-application .widget-tab__panorama-top-view-map .camera--current::before{content:"";border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application--custom .widget-tab__panorama-controls-container{bottom:34px}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container{bottom:34px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container{right:unset;left:50%;bottom:20px;transform:translateX(-53%)}.widget-application--custom .widget-tab__panorama-controls-container>div{padding:8px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container>div{padding:4px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:53px;height:53px}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:53px;height:53px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:27px;height:27px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:44px;height:44px;transform:scale(1)}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:44px;height:44px;transform:scale(1)}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:15px;height:15px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale img{width:35px;height:35px}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale img{width:35px;height:35px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale img{width:18px;height:18px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale-x05{width:53px !important;height:53px !important}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale-x05{width:53px !important;height:53px !important}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--scale-x05{width:26px;height:26px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--furniture img{width:53px;height:53px}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--furniture img{width:53px;height:53px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--furniture img{width:26px;height:26px}.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--rotation img{width:37px;height:37px}.widget-application--tablet.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--rotation img{width:37px;height:37px}.widget-application--mobile.widget-application--custom .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button--rotation img{width:19px;height:19px}.widget-application--smallMobile.widget-application--custom .widget-tab-button{width:36px !important;height:36px !important}.map-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0);z-index:3;display:none}.map-overlay--visible{display:block}@keyframes circlePulse{0%{transform:scale(1)}50%{transform:scale(1.56)}100%{transform:scale(1)}}@keyframes pointerPulse{0%{transform:scale(1)}50%{transform:scale(0.75)}100%{transform:scale(1)}}.widget-application .widget-tab__rotation{width:100%;height:100%}.widget-application .widget-tab__rotation-start{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;position:absolute;left:50%;bottom:35px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;padding:0 25px 0 10px;background-color:#eaeaea;border-radius:38px;height:72px;width:202px}.widget-application--tablet.widget-application .widget-tab__rotation-start{height:60px;width:166px;padding:0 20px 0 8px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__rotation-start{height:44px;width:115px;padding:0 10px 0 6px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start{height:36px;width:85px;padding:0 8px 0 6px;bottom:30px}.widget-application .widget-tab__rotation-start-icon{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:#fff;margin-right:18px;padding:10px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon{padding:7px;margin-right:15px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon{margin-right:7px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon{padding:6px;margin-right:5px}.widget-application .widget-tab__rotation-start-icon img{display:block;position:relative;top:2px;width:34px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon img{width:30px;top:1px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon img{width:19px;top:0}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon img{width:15px}.widget-application .widget-tab__rotation-start span{font-size:24px;font-weight:700;color:#413e3e;text-transform:uppercase;width:100%;display:block;text-align:center;position:relative;top:1px}.widget-application--tablet.widget-application .widget-tab__rotation-start span{font-size:20px}.widget-application--mobile.widget-application .widget-tab__rotation-start span{font-size:14px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start span{font-size:10px;top:0}.widget-application .widget-tab__isometry{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__isometry-container{width:100%;height:calc(100% - 290px);position:relative;background-image:none;margin-top:20px}.widget-application--mobile.widget-application .widget-tab__isometry-container{height:400px;width:400px;max-height:calc(100vw - 22px);max-width:calc(100vw - 22px);margin:45px auto 0 auto}.widget-application--smallMobile.widget-application .widget-tab__isometry-container{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 60px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application--mobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 22px);max-height:100%}.widget-application .widget-tab__isometry-container img.active{opacity:1}.widget-application .widget-tab__threesixty{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__threesixty-container{width:100% !important;height:calc(100% - 270px) !important;position:relative;background-image:none !important}.widget-application--mobile.widget-application .widget-tab__threesixty-container{margin-top:96px;height:calc(100% - 312px)}.widget-application .widget-tab__threesixty-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 60px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application--mobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 22px);max-height:100%}.widget-application .widget-tab__threesixty-container img.active{opacity:1}.widget-application .widget-tab__threesixty--active{cursor:move}.widget-application--smallMobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-shader{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100vh - 270px);max-height:calc(100vh - 270px);width:600px;height:600px;object-fit:contain}.widget-application--mobile.widget-application .widget-tab__isometry-shader{max-width:100%;max-height:100%}.widget-application .widget-tab__isometry-shader canvas{position:absolute;width:100% !important;height:100% !important}.widget-application .widget-tab__isometry .hidden{display:none}.widget-application .widget-tab__isometry-arrows{position:absolute;z-index:3;left:50%;bottom:211px;transform:translateX(-50%);height:36px;display:flex;align-items:center;justify-content:center}.widget-application--mobile.widget-application .widget-tab__isometry-arrows{bottom:162px;height:30px}.widget-application .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:16px;letter-spacing:.1em;color:#413e3e;display:block;margin:0 5px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows span{font-size:14px;line-height:18px;letter-spacing:0;margin:0 2px}.widget-application .widget-tab__isometry-arrow{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:5px}.widget-application .widget-tab__isometry-arrow img{width:16px}.widget-application .widget-tab__isometry-buttons{position:absolute;z-index:3;left:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab__isometry-buttons{left:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__isometry-buttons{left:22px;bottom:22px}.widget-application .widget-tab__isometry-button{outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#ededed;margin-top:40px}.widget-application--tablet.widget-application .widget-tab__isometry-button{margin-top:20px;width:60px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-button{margin-top:10px;width:44px;height:44px}.widget-application .widget-tab__isometry-button img{display:block;width:50px}.widget-application--tablet.widget-application .widget-tab__isometry-button img{width:40px}.widget-application--mobile.widget-application .widget-tab__isometry-button img{width:30px}.widget-application--standard .widget-tab__isometry-arrows{bottom:35px;height:72px}.widget-application--tablet.widget-application--standard .widget-tab__isometry-arrows{height:60px}.widget-application--mobile.widget-application--standard .widget-tab__isometry-arrows{bottom:22px;height:44px}.widget-application--smallMobile.widget-application--standard .widget-tab__isometry-arrows{bottom:100px;height:36px}.widget-application--standard .widget-tab__isometry-arrows::before{content:"";position:absolute;left:50%;top:50%;width:calc(100% + 30px);height:100%;transform:translate(-50%, -50%);background-color:#eaeaea;z-index:-1;border-radius:60px}.widget-application--tablet.widget-application--standard .widget-tab__isometry-arrows::before{border-radius:32px}.widget-application--mobile.widget-application--standard .widget-tab__isometry-arrows::before{width:calc(100% + 15px);border-radius:30px}.widget-application--standard .widget-tab__isometry-arrows span{font-size:28px;font-weight:700;margin:0 9px}.widget-application--tablet.widget-application--standard .widget-tab__isometry-arrows span{font-size:22px;letter-spacing:.05em}.widget-application--mobile.widget-application--standard .widget-tab__isometry-arrows span{font-size:17px;margin:0 3px}.widget-application--standard .widget-tab__isometry-arrow img{width:32px}.widget-application--tablet.widget-application--standard .widget-tab__isometry-arrow img{width:24px}.widget-application--mobile.widget-application--standard .widget-tab__isometry-arrow img{width:18px}.widget-application--two .widget-tab-buttons{right:44px}.widget-application--tablet.widget-application--two .widget-tab-buttons{right:35px}.widget-application--mobile.widget-application--two .widget-tab-buttons{right:22px}.widget-application--two .widget-tab-button{width:72px;height:72px;margin-left:40px}.widget-application--tablet.widget-application--two .widget-tab-button{width:60px;height:60px;margin-left:20px}.widget-application--mobile.widget-application--two .widget-tab-button{width:44px;height:44px;margin-left:10px}.widget-application--three.widget-application--standard .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab__isometry-arrows{height:42px;bottom:180px}.widget-application--three.widget-application--standard .widget-tab__isometry-arrows::before{content:"";position:absolute;left:50%;top:50%;width:calc(100% + 30px);height:100%;transform:translate(-50%, -50%);background-color:#eaeaea;z-index:-1;border-radius:60px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab__isometry-arrows::before{border-radius:32px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab__isometry-arrows::before{width:calc(100% + 15px);border-radius:30px}.widget-application--three.widget-application--standard .widget-tab__isometry-arrows span{font-size:14px;line-height:18px;font-weight:700;margin:0 2px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab__isometry-arrows span{font-size:14px;line-height:18px;font-weight:700;margin:0 2px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab__isometry-arrows span{font-size:14px;line-height:18px;font-weight:700;margin:0 2px}.widget-application--three.widget-application--standard .widget-tab__isometry-arrow img{width:16px}.widget-application--tablet.widget-application--three.widget-application--standard .widget-tab__isometry-arrow img{width:16px}.widget-application--mobile.widget-application--three.widget-application--standard .widget-tab__isometry-arrow img{width:16px}.widget-application .widget-loader{display:block;position:relative;width:80px;height:80px}.widget-application .widget-loader--absolute{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}.widget-application .widget-loader--sm{transform:translate(-50%, -50%) scale(0.75)}.widget-application .widget-loader div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:var(--main-color);animation-timing-function:cubic-bezier(0, 1, 1, 0)}.widget-application .widget-loader div:nth-child(1){left:8px;animation:widget-loader-1 .6s infinite}.widget-application .widget-loader div:nth-child(2){left:8px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(3){left:32px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(4){left:56px;animation:widget-loader-3 .6s infinite}@keyframes widget-loader-1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes widget-loader-3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes widget-loader-2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}.widget-application .widget-watermark-button{position:absolute;right:4px;bottom:4px;z-index:1000}.widget-application--tablet.widget-application .widget-watermark-button{right:3px;bottom:2px}.widget-application--mobile.widget-application .widget-watermark-button{right:2px}.widget-application--smallMobile.widget-application .widget-watermark-button{right:13px;bottom:8px}.widget-application .widget-watermark-button a{font-size:18px;line-height:90%;color:#000;opacity:.5}.widget-application--tablet.widget-application .widget-watermark-button a{font-size:15px}.widget-application--mobile.widget-application .widget-watermark-button a{font-size:10px}.widget-application--smallMobile.widget-application .widget-watermark-button a{font-size:9px}.widget-application .widget-watermark-button a span{font-weight:100;font-size:inherit;line-height:90%;color:inherit}.widget-application .floors-select{position:absolute;top:47px;left:50%;background:none;height:37px;border:none;transform:translateX(-50%);cursor:pointer;white-space:nowrap;overflow-x:visible;z-index:3}.widget-application .floors-select--text{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:28px;line-height:36px;font-weight:700;border-bottom:1px #413e3e solid;padding:0 2px}.widget-application--tablet.widget-application .floors-select--text{font-size:24px;line-height:32px}.widget-application--mobile.widget-application .floors-select--text{font-size:20px;line-height:28px}.widget-application .floors-select--text:hover{border-bottom:1px #000 solid}.widget-application .floors-select--block{display:flex;flex-direction:column;background:#fff;margin-top:7px;border-radius:6px;-moz-box-shadow:0 0 2px 2px rgba(0,0,0,.2);-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.2);box-shadow:0 0 2px 2px rgba(0,0,0,.2);overflow:hidden}.widget-application .floors-select--block-item{font-size:20px;text-align:center;line-height:40px}.widget-application--tablet.widget-application .floors-select--block-item{font-size:18px}.widget-application--mobile.widget-application .floors-select--block-item{font-size:16px}.widget-application .floors-select--block-item:active{background:linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)}.widget-application .floors-select--block-item--active{background:var(--main-color)}.widget-application .widget-tab-rooms{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;position:absolute;bottom:118px;width:100%;max-width:100%;height:69px;overflow-x:scroll;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.widget-application--mobile.widget-application .widget-tab-rooms{bottom:88px;height:50px}.widget-application .widget-tab-rooms::-webkit-scrollbar{width:0;display:none}.widget-application .widget-tab-rooms-container{display:flex;column-gap:22px}.widget-application--mobile.widget-application .widget-tab-rooms-container{column-gap:10px}.widget-application .widget-tab-rooms-item{position:relative;flex-shrink:0;display:flex;flex-direction:column;align-items:center;background:#fff;width:93px;height:69px;padding:4px 3px;border:2px solid var(--main-color);border-radius:12px;cursor:pointer}.widget-application--mobile.widget-application .widget-tab-rooms-item{width:68px;height:50px;padding:2px 0;border-radius:9px}.widget-application .widget-tab-rooms-item:first-child{margin-left:45px}.widget-application--mobile.widget-application .widget-tab-rooms-item:first-child{margin-left:20px}.widget-application .widget-tab-rooms-item:last-child::after{content:"";position:absolute;right:-45px;top:0;width:30px;height:1px}.widget-application--mobile.widget-application .widget-tab-rooms-item:last-child::after{right:-20px;width:20px}.widget-application .widget-tab-rooms-item-img{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;height:26px !important;width:46px !important}.widget-application--mobile.widget-application .widget-tab-rooms-item-img{height:19px !important;width:34px !important}.widget-application .widget-tab-rooms-item-type{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:12px;font-weight:700;line-height:11px;text-align:center;color:rgba(65,62,62,.5);margin-top:3px}.widget-application--mobile.widget-application .widget-tab-rooms-item-type{font-size:9px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-area{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:10px;font-weight:700;line-height:12px;word-spacing:-1px;text-align:center;color:#413e3e;margin-top:4px}.widget-application--mobile.widget-application .widget-tab-rooms-item-area{font-size:7px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-active{background:var(--main-color)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-type{color:#fff}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-area{color:#fff}.widget-application .widget-tab-rooms-switch{position:fixed;bottom:34px;left:45px;width:85px;height:44px}.widget-application--mobile.widget-application .widget-tab-rooms-switch{bottom:20px;left:20px;width:56px;height:29px}.widget-application .widget-tab-rooms-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab-rooms-switch-checkbox:checked+.widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{right:100%;transform:translateX(100%)}.widget-application .widget-tab-rooms-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;cursor:pointer;background:var(--main-color);width:85px;height:44px;border-radius:30px;border:3px solid var(--main-color);transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab-rooms-switch-label{width:56px;height:29px;border-radius:20px;border:2px solid var(--main-color)}.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{position:absolute;top:0;right:0;font-size:18px;font-weight:700;line-height:38px;letter-spacing:-0.03em;color:var(--main-color);width:71px;height:38px;text-align:center;border-radius:30px;transition:.2s;background:#fff}.widget-application--mobile.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{font-size:12px;line-height:25px;width:47px;height:25px;border-radius:20px}.widget-application--standard .widget-tab-rooms{bottom:20px}.widget-application--standard .widget-tab-rooms-switch{bottom:119px}.widget-application .panel{position:fixed;top:0;left:0;width:100%;height:100%;z-index:2;pointer-events:none}.widget-application .panel-sidebar{position:absolute;bottom:221px;right:0;z-index:3;pointer-events:auto}.widget-application--tablet.widget-application .panel-sidebar{bottom:calc(50% - 197px)}.widget-application--mobile.widget-application .panel-sidebar{bottom:187px}.widget-application .panel-sidebar-select{display:flex;flex-direction:column;row-gap:6px;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none}.widget-application .panel-sidebar-select::-webkit-scrollbar{width:0;height:0}.widget-application .panel-sidebar-select-wrapper{position:absolute;top:0;right:59px;display:none;background:#f5f5f5;width:86px;max-height:calc(100% - 63px);border:8px solid #f5f5f5;border-radius:4px 0 0 4px;overflow:hidden}.widget-application--mobile.widget-application .panel-sidebar-select-wrapper{right:43px;width:76px;max-height:calc(100% - 46px);border:6px solid #f5f5f5}.widget-application .panel-sidebar-select-wrapper-visible{display:block}.widget-application .panel-sidebar-select-wrapper-visible~.panel-sidebar-menu{border-radius:0 0 0 5px;box-shadow:unset !important}.widget-application--mobile.widget-application .panel-sidebar-select-wrapper-visible~.panel-sidebar-menu{border-radius:0 0 0 4px}.widget-application .panel-sidebar-select-item{font-size:16px;font-weight:700;line-height:19px;color:#413e3e;padding:4px 5px;cursor:pointer}.widget-application--mobile.widget-application .panel-sidebar-select-item{font-size:12px;line-height:14px}.widget-application .panel-sidebar-select-item:hover{color:var(--main-color)}.widget-application .panel-sidebar-select-item-active{color:var(--main-color)}.widget-application .panel-sidebar-menu{position:relative;right:0;display:none;flex-direction:column;background:#fff;box-shadow:-1.35px 0px 8.12px 0px rgba(114,114,114,.2509803922);border-radius:5px 0 0 5px;row-gap:6px;padding:8px}.widget-application--mobile.widget-application .panel-sidebar-menu{box-shadow:-1px 0px 6px 0px rgba(114,114,114,.2509803922);border-radius:4px 0 0 4px;row-gap:5px;padding:6px}.widget-application .panel-sidebar-menu-visible{display:flex}.widget-application .panel-sidebar-menu-item{width:44px;height:44px;background:#fff;border:none;cursor:pointer;box-shadow:none;z-index:2}.widget-application--mobile.widget-application .panel-sidebar-menu-item{width:32px;height:32px}.widget-application .panel-sidebar-menu-item:nth-last-child(1){padding:11px}.widget-application--mobile.widget-application .panel-sidebar-menu-item:nth-last-child(1){padding:8px}.widget-application .panel-sidebar-menu-item:nth-last-child(1) img{width:22px;height:22px}.widget-application--mobile.widget-application .panel-sidebar-menu-item:nth-last-child(1) img{width:16px;height:16px}.widget-application .panel-sidebar-menu-item:hover img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-item img{position:relative;width:44px;height:44px;object-fit:contain}.widget-application--mobile.widget-application .panel-sidebar-menu-item img{width:32px;height:32px}.widget-application .panel-sidebar-menu-item-active img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-line{width:44px;height:1px;background:#ededed;margin:5px 0}.widget-application--mobile.widget-application .panel-sidebar-menu-line{width:32px;margin:3px 0}.widget-application .panel-sidebar-menu-toggle{position:absolute;bottom:0;right:0;display:none;align-items:center;justify-content:center;width:22px;height:60px;background:#fff;box-shadow:-1.35px 0px 8.12px 0px rgba(114,114,114,.2509803922);border-radius:5px 0 0 5px;border:none;cursor:pointer}.widget-application--mobile.widget-application .panel-sidebar-menu-toggle{width:16px;height:44px;box-shadow:-1px 0px 6px 0px rgba(114,114,114,.2509803922);border-radius:4px 0 0 4px}.widget-application .panel-sidebar-menu-toggle:hover img{filter:invert(67%) sepia(17%) saturate(5617%) hue-rotate(2deg) brightness(105%) contrast(105%)}.widget-application .panel-sidebar-menu-toggle-visible{display:flex}.widget-application .panel-sidebar-menu-toggle img{width:22px;height:22px}.widget-application--mobile.widget-application .panel-sidebar-menu-toggle img{width:16px;height:16px}.widget-application--custom .panel-sidebar{bottom:300px}.widget-application--tablet.widget-application--custom .panel-sidebar{bottom:300px}.widget-application--mobile.widget-application--custom .panel-sidebar{bottom:187px}.widget-error-page{display:flex;align-items:center;justify-content:space-between;padding:100px 200px;width:100%}@media screen and (max-width: 1100px){.widget-error-page{padding:100px 80px}}@media screen and (max-width: 670px){.widget-error-page{flex-direction:column}}@media screen and (max-width: 1100px){.widget-error-page img{width:285px}}.widget-error-page-left{max-width:520px}@media screen and (max-width: 1100px){.widget-error-page-left{max-width:300px}}.widget-error-page-title{font-size:64px;line-height:64px;margin-bottom:40px;font-weight:800;font-family:"Roboto Flex",sans-serif}@media screen and (max-width: 1100px){.widget-error-page-title{font-size:36px;line-height:36px;margin-bottom:20px}}.widget-error-page-subtitle{font-size:24px;line-height:33px;font-weight:400;color:#000;opacity:50%;font-family:"Roboto Flex",sans-serif}@media screen and (max-width: 1100px){.widget-error-page-subtitle{font-size:16px;line-height:22px}}@media screen and (max-width: 670px){.widget-error-page-subtitle{margin-bottom:120px}}.widget-application{--main-color: #FFA900;--main-text: #413E3E;width:100%;height:100%;flex:none;overflow:hidden;position:relative;z-index:1;background-color:#fff;font-size:20px}.widget-application *,.widget-application *:before,.widget-application *:after{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:"Roboto Flex",monospace;text-decoration:none;font-weight:700;color:#413e3e;outline:none;padding:0;margin:0;box-sizing:border-box;-webkit-box-sizing:border-box;scrollbar-width:none}.widget-application .widget-logo{position:absolute;left:45px;top:30px;z-index:3}.widget-application--tablet.widget-application .widget-logo{left:36px;top:39px}.widget-application--mobile.widget-application .widget-logo{left:23px;top:24px}.widget-application--smallMobile.widget-application .widget-logo{left:23px;top:21px}.widget-application .widget-logo img{display:block;width:82px;height:82px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-logo img{width:58px;height:58px}.widget-application--mobile.widget-application .widget-logo img{width:36px;height:36px}.widget-application--smallMobile.widget-application .widget-logo img{width:28px;height:28px}.widget-application .widget-tab__panorama-close-map{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-tab__panorama-close-map{right:30px;top:35px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map{padding:5px;right:22px;top:20px}.widget-application .widget-tab__panorama-close-map img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-tab__panorama-close-map img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-tab__panorama-close-map img{width:26px;height:26px}.widget-application .widget-enter-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-enter-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-enter-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-enter-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-enter-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-enter-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-enter-fullscreen img{width:26px;height:26px}.widget-application .widget-exit-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;outline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-exit-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-exit-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-exit-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-exit-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-exit-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-exit-fullscreen img{width:26px;height:26px}`,
                ""
            ]);
            const M = p;
        },
        72: (e1)=>{
            "use strict";
            var t = [];
            function n(e1) {
                for(var n = -1, i = 0; i < t.length; i++)if (t[i].identifier === e1) {
                    n = i;
                    break;
                }
                return n;
            }
            function i(e1, i) {
                for(var a = {}, s = [], o = 0; o < e1.length; o++){
                    var l = e1[o], c = i.base ? l[0] + i.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                    a[c] = u + 1;
                    var d = n(h), p = {
                        css: l[1],
                        media: l[2],
                        sourceMap: l[3],
                        supports: l[4],
                        layer: l[5]
                    };
                    if (-1 !== d) t[d].references++, t[d].updater(p);
                    else {
                        var f = r(p, i);
                        i.byIndex = o, t.splice(o, 0, {
                            identifier: h,
                            updater: f,
                            references: 1
                        });
                    }
                    s.push(h);
                }
                return s;
            }
            function r(e1, t) {
                var n = t.domAPI(t);
                return n.update(e1), function(t) {
                    if (t) {
                        if (t.css === e1.css && t.media === e1.media && t.sourceMap === e1.sourceMap && t.supports === e1.supports && t.layer === e1.layer) return;
                        n.update(e1 = t);
                    } else n.remove();
                };
            }
            e1.exports = function(e1, r) {
                var a = i(e1 = e1 || [], r = r || {});
                return function(e1) {
                    e1 = e1 || [];
                    for(var s = 0; s < a.length; s++){
                        var o = n(a[s]);
                        t[o].references--;
                    }
                    for(var l = i(e1, r), c = 0; c < a.length; c++){
                        var u = n(a[c]);
                        0 === t[u].references && (t[u].updater(), t.splice(u, 1));
                    }
                    a = l;
                };
            };
        },
        659: (e1)=>{
            "use strict";
            var t = {};
            e1.exports = function(e1, n) {
                var i = function(e1) {
                    if (void 0 === t[e1]) {
                        var n = document.querySelector(e1);
                        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                            n = n.contentDocument.head;
                        } catch (e1) {
                            n = null;
                        }
                        t[e1] = n;
                    }
                    return t[e1];
                }(e1);
                if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                i.appendChild(n);
            };
        },
        540: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = document.createElement("style");
                return e1.setAttributes(t, e1.attributes), e1.insert(t, e1.options), t;
            };
        },
        56: (e1, t, n)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = n.nc;
                t && e1.setAttribute("nonce", t);
            };
        },
        825: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                if ("undefined" == typeof document) return {
                    update: function() {},
                    remove: function() {}
                };
                var t = e1.insertStyleElement(e1);
                return {
                    update: function(n) {
                        !function(e1, t, n) {
                            var i = "";
                            n.supports && (i += "@supports (".concat(n.supports, ") {")), n.media && (i += "@media ".concat(n.media, " {"));
                            var r = void 0 !== n.layer;
                            r && (i += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), i += n.css, r && (i += "}"), n.media && (i += "}"), n.supports && (i += "}");
                            var a = n.sourceMap;
                            a && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), t.styleTagTransform(i, e1, t.options);
                        }(t, e1, n);
                    },
                    remove: function() {
                        !function(e1) {
                            if (null === e1.parentNode) return !1;
                            e1.parentNode.removeChild(e1);
                        }(t);
                    }
                };
            };
        },
        113: (e1)=>{
            "use strict";
            e1.exports = function(e1, t) {
                if (t.styleSheet) t.styleSheet.cssText = e1;
                else {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                    t.appendChild(document.createTextNode(e1));
                }
            };
        },
        512: (e1)=>{
            "use strict";
            e1.exports = function(e1, t, n, i) {
                var r = self || window;
                try {
                    try {
                        var a;
                        try {
                            a = new r.Blob([
                                e1
                            ]);
                        } catch (t) {
                            (a = new (r.BlobBuilder || r.WebKitBlobBuilder || r.MozBlobBuilder || r.MSBlobBuilder)).append(e1), a = a.getBlob();
                        }
                        var s = r.URL || r.webkitURL, o = s.createObjectURL(a), l = new r[t](o, n);
                        return s.revokeObjectURL(o), l;
                    } catch (i) {
                        return new r[t]("data:application/javascript,".concat(encodeURIComponent(e1)), n);
                    }
                } catch (e1) {
                    if (!i) throw Error("Inline worker is not supported");
                    return new r[t](i, n);
                }
            };
        },
        425: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        943: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        88: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        562: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        }
    }, t = {};
    function n(i) {
        var r = t[i];
        if (void 0 !== r) return r.exports;
        var a = t[i] = {
            id: i,
            exports: {}
        };
        return e1[i].call(a.exports, a, a.exports, n), a.exports;
    }
    n.m = e1, n.amdO = {}, n.n = (e1)=>{
        var t = e1 && e1.__esModule ? ()=>e1.default : ()=>e1;
        return n.d(t, {
            a: t
        }), t;
    }, n.d = (e1, t)=>{
        for(var i in t)n.o(t, i) && !n.o(e1, i) && Object.defineProperty(e1, i, {
            enumerable: !0,
            get: t[i]
        });
    }, n.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e1) {
            if ("object" == typeof window) return window;
        }
    }(), n.o = (e1, t)=>Object.prototype.hasOwnProperty.call(e1, t), n.r = (e1)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e1, "__esModule", {
            value: !0
        });
    }, n.b = document.baseURI || self.location.href, n.nc = void 0;
    var i = {};
    (()=>{
        "use strict";
        n.r(i), n.d(i, {
            ApiStore: ()=>Fi,
            Widget: ()=>bR,
            rotationModes: ()=>qi
        });
        var e1 = {};
        n.r(e1), n.d(e1, {
            ACESFilmicToneMapping: ()=>ta,
            AddEquation: ()=>yr,
            AddOperation: ()=>qr,
            AdditiveAnimationBlendMode: ()=>Os,
            AdditiveBlending: ()=>mr,
            AlphaFormat: ()=>Ra,
            AlwaysCompare: ()=>wo,
            AlwaysDepth: ()=>Fr,
            AlwaysStencilFunc: ()=>go,
            AmbientLight: ()=>kA,
            AnimationAction: ()=>NM,
            AnimationClip: ()=>cA,
            AnimationLoader: ()=>MA,
            AnimationMixer: ()=>_M,
            AnimationObjectGroup: ()=>IM,
            AnimationUtils: ()=>qm,
            ArcCurve: ()=>gg,
            ArrayCamera: ()=>Up,
            ArrowHelper: ()=>xv,
            AttachedBindMode: ()=>ia,
            Audio: ()=>dM,
            AudioAnalyser: ()=>MM,
            AudioContext: ()=>$A,
            AudioListener: ()=>hM,
            AudioLoader: ()=>eM,
            AxesHelper: ()=>bv,
            BackSide: ()=>hr,
            BasicDepthPacking: ()=>Bs,
            BasicShadowMap: ()=>sr,
            Bone: ()=>Df,
            BooleanKeyframeTrack: ()=>nA,
            Box2: ()=>HM,
            Box3: ()=>Rl,
            Box3Helper: ()=>mv,
            BoxGeometry: ()=>Wu,
            BoxHelper: ()=>gv,
            BufferAttribute: ()=>lu,
            BufferGeometry: ()=>Su,
            BufferGeometryLoader: ()=>WA,
            ByteType: ()=>Ta,
            Cache: ()=>hA,
            Camera: ()=>Ju,
            CameraHelper: ()=>dv,
            CanvasTexture: ()=>dg,
            CapsuleGeometry: ()=>Pg,
            CatmullRomCurve3: ()=>xg,
            CineonToneMapping: ()=>ea,
            CircleGeometry: ()=>Ug,
            ClampToEdgeWrapping: ()=>da,
            Clock: ()=>aM,
            Color: ()=>qc,
            ColorKeyframeTrack: ()=>iA,
            ColorManagement: ()=>pl,
            CompressedArrayTexture: ()=>ug,
            CompressedCubeTexture: ()=>hg,
            CompressedTexture: ()=>cg,
            CompressedTextureLoader: ()=>vA,
            ConeGeometry: ()=>kg,
            ConstantAlphaFactor: ()=>jr,
            ConstantColorFactor: ()=>Pr,
            CubeCamera: ()=>th,
            CubeReflectionMapping: ()=>sa,
            CubeRefractionMapping: ()=>oa,
            CubeTexture: ()=>nh,
            CubeTextureLoader: ()=>xA,
            CubeUVReflectionMapping: ()=>ua,
            CubicBezierCurve: ()=>Tg,
            CubicBezierCurve3: ()=>Sg,
            CubicInterpolant: ()=>Jm,
            CullFaceBack: ()=>ir,
            CullFaceFront: ()=>rr,
            CullFaceFrontBack: ()=>ar,
            CullFaceNone: ()=>nr,
            Curve: ()=>pg,
            CurvePath: ()=>zg,
            CustomBlending: ()=>vr,
            CustomToneMapping: ()=>na,
            CylinderGeometry: ()=>jg,
            Cylindrical: ()=>BM,
            Data3DTexture: ()=>Nl,
            DataArrayTexture: ()=>Sl,
            DataTexture: ()=>_f,
            DataTextureLoader: ()=>bA,
            DataUtils: ()=>au,
            DecrementStencilOp: ()=>io,
            DecrementWrapStencilOp: ()=>ao,
            DefaultLoadingManager: ()=>pA,
            DepthFormat: ()=>ka,
            DepthStencilFormat: ()=>Ba,
            DepthTexture: ()=>Fp,
            DetachedBindMode: ()=>ra,
            DirectionalLight: ()=>jA,
            DirectionalLightHelper: ()=>cv,
            DiscreteInterpolant: ()=>eA,
            DisplayP3ColorSpace: ()=>Ys,
            DodecahedronGeometry: ()=>Fg,
            DoubleSide: ()=>dr,
            DstAlphaFactor: ()=>Cr,
            DstColorFactor: ()=>zr,
            DynamicCopyUsage: ()=>Co,
            DynamicDrawUsage: ()=>To,
            DynamicReadUsage: ()=>No,
            EdgesGeometry: ()=>Wg,
            EllipseCurve: ()=>fg,
            EqualCompare: ()=>Mo,
            EqualDepth: ()=>Vr,
            EqualStencilFunc: ()=>co,
            EquirectangularReflectionMapping: ()=>la,
            EquirectangularRefractionMapping: ()=>ca,
            Euler: ()=>Mc,
            EventDispatcher: ()=>jo,
            ExtrudeGeometry: ()=>xm,
            FileLoader: ()=>AA,
            Float16BufferAttribute: ()=>mu,
            Float32BufferAttribute: ()=>Au,
            Float64BufferAttribute: ()=>Mu,
            FloatType: ()=>_a,
            Fog: ()=>Xp,
            FogExp2: ()=>Yp,
            FramebufferTexture: ()=>lg,
            FrontSide: ()=>ur,
            Frustum: ()=>uh,
            GLBufferAttribute: ()=>RM,
            GLSL1: ()=>zo,
            GLSL3: ()=>Oo,
            GreaterCompare: ()=>yo,
            GreaterDepth: ()=>Wr,
            GreaterEqualCompare: ()=>bo,
            GreaterEqualDepth: ()=>Qr,
            GreaterEqualStencilFunc: ()=>fo,
            GreaterStencilFunc: ()=>ho,
            GridHelper: ()=>rv,
            Group: ()=>jp,
            HalfFloatType: ()=>Ca,
            HemisphereLight: ()=>TA,
            HemisphereLightHelper: ()=>iv,
            IcosahedronGeometry: ()=>wm,
            ImageBitmapLoader: ()=>KA,
            ImageLoader: ()=>yA,
            ImageUtils: ()=>Al,
            IncrementStencilOp: ()=>no,
            IncrementWrapStencilOp: ()=>ro,
            InstancedBufferAttribute: ()=>Of,
            InstancedBufferGeometry: ()=>QA,
            InstancedInterleavedBuffer: ()=>OM,
            InstancedMesh: ()=>Hf,
            Int16BufferAttribute: ()=>du,
            Int32BufferAttribute: ()=>fu,
            Int8BufferAttribute: ()=>cu,
            IntType: ()=>Na,
            InterleavedBuffer: ()=>qp,
            InterleavedBufferAttribute: ()=>Jp,
            Interpolant: ()=>Km,
            InterpolateDiscrete: ()=>Is,
            InterpolateLinear: ()=>Ns,
            InterpolateSmooth: ()=>Ds,
            InvertStencilOp: ()=>so,
            KeepStencilOp: ()=>eo,
            KeyframeTrack: ()=>tA,
            LOD: ()=>Mf,
            LatheGeometry: ()=>Rg,
            Layers: ()=>vc,
            LessCompare: ()=>Ao,
            LessDepth: ()=>Hr,
            LessEqualCompare: ()=>vo,
            LessEqualDepth: ()=>Gr,
            LessEqualStencilFunc: ()=>uo,
            LessStencilFunc: ()=>lo,
            Light: ()=>EA,
            LightProbe: ()=>HA,
            Line: ()=>Zf,
            Line3: ()=>QM,
            LineBasicMaterial: ()=>Gf,
            LineCurve: ()=>Ig,
            LineCurve3: ()=>Ng,
            LineDashedMaterial: ()=>Vm,
            LineLoop: ()=>$f,
            LineSegments: ()=>Jf,
            LinearDisplayP3ColorSpace: ()=>Xs,
            LinearEncoding: ()=>js,
            LinearFilter: ()=>va,
            LinearInterpolant: ()=>$m,
            LinearMipMapLinearFilter: ()=>wa,
            LinearMipMapNearestFilter: ()=>xa,
            LinearMipmapLinearFilter: ()=>ba,
            LinearMipmapNearestFilter: ()=>ya,
            LinearSRGBColorSpace: ()=>Ws,
            LinearToneMapping: ()=>Jr,
            LinearTransfer: ()=>Zs,
            Loader: ()=>fA,
            LoaderUtils: ()=>VA,
            LoadingManager: ()=>dA,
            LoopOnce: ()=>Es,
            LoopPingPong: ()=>Ss,
            LoopRepeat: ()=>Ts,
            LuminanceAlphaFormat: ()=>ja,
            LuminanceFormat: ()=>Ua,
            MOUSE: ()=>er,
            Material: ()=>$c,
            MaterialLoader: ()=>GA,
            MathUtils: ()=>Jo,
            Matrix3: ()=>el,
            Matrix4: ()=>lc,
            MaxEquation: ()=>Er,
            Mesh: ()=>Vu,
            MeshBasicMaterial: ()=>eu,
            MeshDepthMaterial: ()=>Cp,
            MeshDistanceMaterial: ()=>Lp,
            MeshLambertMaterial: ()=>Hm,
            MeshMatcapMaterial: ()=>Gm,
            MeshNormalMaterial: ()=>Fm,
            MeshPhongMaterial: ()=>km,
            MeshPhysicalMaterial: ()=>jm,
            MeshStandardMaterial: ()=>Um,
            MeshToonMaterial: ()=>Bm,
            MinEquation: ()=>wr,
            MirroredRepeatWrapping: ()=>pa,
            MixOperation: ()=>Zr,
            MultiplyBlending: ()=>Mr,
            MultiplyOperation: ()=>Xr,
            NearestFilter: ()=>fa,
            NearestMipMapLinearFilter: ()=>Ma,
            NearestMipMapNearestFilter: ()=>ma,
            NearestMipmapLinearFilter: ()=>Aa,
            NearestMipmapNearestFilter: ()=>ga,
            NeverCompare: ()=>mo,
            NeverDepth: ()=>Br,
            NeverStencilFunc: ()=>oo,
            NoBlending: ()=>fr,
            NoColorSpace: ()=>Vs,
            NoToneMapping: ()=>Kr,
            NormalAnimationBlendMode: ()=>zs,
            NormalBlending: ()=>gr,
            NotEqualCompare: ()=>xo,
            NotEqualDepth: ()=>Yr,
            NotEqualStencilFunc: ()=>po,
            NumberKeyframeTrack: ()=>rA,
            Object3D: ()=>zc,
            ObjectLoader: ()=>YA,
            ObjectSpaceNormalMap: ()=>Gs,
            OctahedronGeometry: ()=>Em,
            OneFactor: ()=>Sr,
            OneMinusConstantAlphaFactor: ()=>kr,
            OneMinusConstantColorFactor: ()=>Ur,
            OneMinusDstAlphaFactor: ()=>Lr,
            OneMinusDstColorFactor: ()=>Or,
            OneMinusSrcAlphaFactor: ()=>_r,
            OneMinusSrcColorFactor: ()=>Nr,
            OrthographicCamera: ()=>Eh,
            P3Primaries: ()=>Js,
            PCFShadowMap: ()=>or,
            PCFSoftShadowMap: ()=>lr,
            PMREMGenerator: ()=>Oh,
            Path: ()=>Og,
            PerspectiveCamera: ()=>$u,
            Plane: ()=>oh,
            PlaneGeometry: ()=>ph,
            PlaneHelper: ()=>Av,
            PointLight: ()=>PA,
            PointLightHelper: ()=>$M,
            Points: ()=>ag,
            PointsMaterial: ()=>eg,
            PolarGridHelper: ()=>av,
            PolyhedronGeometry: ()=>Bg,
            PositionalAudio: ()=>AM,
            PropertyBinding: ()=>SM,
            PropertyMixer: ()=>vM,
            QuadraticBezierCurve: ()=>Dg,
            QuadraticBezierCurve3: ()=>_g,
            Quaternion: ()=>Cl,
            QuaternionKeyframeTrack: ()=>sA,
            QuaternionLinearInterpolant: ()=>aA,
            RED_GREEN_RGTC2_Format: ()=>bs,
            RED_RGTC1_Format: ()=>ys,
            REVISION: ()=>$i,
            RGBADepthPacking: ()=>Fs,
            RGBAFormat: ()=>Pa,
            RGBAIntegerFormat: ()=>Qa,
            RGBA_ASTC_10x10_Format: ()=>fs,
            RGBA_ASTC_10x5_Format: ()=>hs,
            RGBA_ASTC_10x6_Format: ()=>ds,
            RGBA_ASTC_10x8_Format: ()=>ps,
            RGBA_ASTC_12x10_Format: ()=>gs,
            RGBA_ASTC_12x12_Format: ()=>ms,
            RGBA_ASTC_4x4_Format: ()=>is,
            RGBA_ASTC_5x4_Format: ()=>rs,
            RGBA_ASTC_5x5_Format: ()=>as,
            RGBA_ASTC_6x5_Format: ()=>ss,
            RGBA_ASTC_6x6_Format: ()=>os,
            RGBA_ASTC_8x5_Format: ()=>ls,
            RGBA_ASTC_8x6_Format: ()=>cs,
            RGBA_ASTC_8x8_Format: ()=>us,
            RGBA_BPTC_Format: ()=>As,
            RGBA_ETC2_EAC_Format: ()=>ns,
            RGBA_PVRTC_2BPPV1_Format: ()=>$a,
            RGBA_PVRTC_4BPPV1_Format: ()=>Ja,
            RGBA_S3TC_DXT1_Format: ()=>Ya,
            RGBA_S3TC_DXT3_Format: ()=>Xa,
            RGBA_S3TC_DXT5_Format: ()=>Za,
            RGB_BPTC_SIGNED_Format: ()=>Ms,
            RGB_BPTC_UNSIGNED_Format: ()=>vs,
            RGB_ETC1_Format: ()=>es,
            RGB_ETC2_Format: ()=>ts,
            RGB_PVRTC_2BPPV1_Format: ()=>Ka,
            RGB_PVRTC_4BPPV1_Format: ()=>qa,
            RGB_S3TC_DXT1_Format: ()=>Wa,
            RGFormat: ()=>Ga,
            RGIntegerFormat: ()=>Va,
            RawShaderMaterial: ()=>Pm,
            Ray: ()=>oc,
            Raycaster: ()=>PM,
            Rec709Primaries: ()=>Ks,
            RectAreaLight: ()=>BA,
            RedFormat: ()=>Fa,
            RedIntegerFormat: ()=>Ha,
            ReinhardToneMapping: ()=>$r,
            RenderTarget: ()=>El,
            RepeatWrapping: ()=>ha,
            ReplaceStencilOp: ()=>to,
            ReverseSubtractEquation: ()=>br,
            RingGeometry: ()=>Tm,
            SIGNED_RED_GREEN_RGTC2_Format: ()=>ws,
            SIGNED_RED_RGTC1_Format: ()=>xs,
            SRGBColorSpace: ()=>Qs,
            SRGBTransfer: ()=>qs,
            Scene: ()=>Zp,
            ShaderChunk: ()=>fh,
            ShaderLib: ()=>mh,
            ShaderMaterial: ()=>Ku,
            ShadowMaterial: ()=>Rm,
            Shape: ()=>Yg,
            ShapeGeometry: ()=>Sm,
            ShapePath: ()=>wv,
            ShapeUtils: ()=>Mm,
            ShortType: ()=>Sa,
            Skeleton: ()=>zf,
            SkeletonHelper: ()=>KM,
            SkinnedMesh: ()=>Nf,
            Source: ()=>vl,
            Sphere: ()=>$l,
            SphereGeometry: ()=>Im,
            Spherical: ()=>kM,
            SphericalHarmonics3: ()=>FA,
            SplineCurve: ()=>Cg,
            SpotLight: ()=>CA,
            SpotLightHelper: ()=>YM,
            Sprite: ()=>ff,
            SpriteMaterial: ()=>$p,
            SrcAlphaFactor: ()=>Dr,
            SrcAlphaSaturateFactor: ()=>Rr,
            SrcColorFactor: ()=>Ir,
            StaticCopyUsage: ()=>_o,
            StaticDrawUsage: ()=>Eo,
            StaticReadUsage: ()=>Io,
            StereoCamera: ()=>rM,
            StreamCopyUsage: ()=>Lo,
            StreamDrawUsage: ()=>So,
            StreamReadUsage: ()=>Do,
            StringKeyframeTrack: ()=>oA,
            SubtractEquation: ()=>xr,
            SubtractiveBlending: ()=>Ar,
            TOUCH: ()=>tr,
            TangentSpaceNormalMap: ()=>Hs,
            TetrahedronGeometry: ()=>Nm,
            Texture: ()=>bl,
            TextureLoader: ()=>wA,
            TorusGeometry: ()=>Dm,
            TorusKnotGeometry: ()=>_m,
            Triangle: ()=>Qc,
            TriangleFanDrawMode: ()=>Us,
            TriangleStripDrawMode: ()=>Ps,
            TrianglesDrawMode: ()=>Rs,
            TubeGeometry: ()=>Cm,
            TwoPassDoubleSide: ()=>pr,
            UVMapping: ()=>aa,
            Uint16BufferAttribute: ()=>pu,
            Uint32BufferAttribute: ()=>gu,
            Uint8BufferAttribute: ()=>uu,
            Uint8ClampedBufferAttribute: ()=>hu,
            Uniform: ()=>CM,
            UniformsGroup: ()=>zM,
            UniformsLib: ()=>gh,
            UniformsUtils: ()=>qu,
            UnsignedByteType: ()=>Ea,
            UnsignedInt248Type: ()=>Oa,
            UnsignedIntType: ()=>Da,
            UnsignedShort4444Type: ()=>La,
            UnsignedShort5551Type: ()=>za,
            UnsignedShortType: ()=>Ia,
            VSMShadowMap: ()=>cr,
            Vector2: ()=>$o,
            Vector3: ()=>Ll,
            Vector4: ()=>wl,
            VectorKeyframeTrack: ()=>lA,
            VideoTexture: ()=>og,
            WebGL1Renderer: ()=>Wp,
            WebGL3DRenderTarget: ()=>Dl,
            WebGLArrayRenderTarget: ()=>Il,
            WebGLCoordinateSystem: ()=>Po,
            WebGLCubeRenderTarget: ()=>ih,
            WebGLMultipleRenderTargets: ()=>_l,
            WebGLRenderTarget: ()=>Tl,
            WebGLRenderer: ()=>Qp,
            WebGLUtils: ()=>Pp,
            WebGPUCoordinateSystem: ()=>Uo,
            WireframeGeometry: ()=>Lm,
            WrapAroundEnding: ()=>Ls,
            ZeroCurvatureEnding: ()=>_s,
            ZeroFactor: ()=>Tr,
            ZeroSlopeEnding: ()=>Cs,
            ZeroStencilOp: ()=>$s,
            _SRGBAFormat: ()=>Ro,
            createCanvasElement: ()=>sl,
            sRGBEncoding: ()=>ks
        });
        var t = n(471), r = n(72), a = n.n(r), s = n(825), o = n.n(s), l = n(659), c = n.n(l), u = n(56), h = n.n(u), d = n(540), p = n.n(d), f = n(113), g = n.n(f), m = n(132), A = {};
        function M(e1) {
            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
            throw new Error("number" == typeof e1 ? "[MobX] minified error nr: " + e1 + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e1);
        }
        A.styleTagTransform = g(), A.setAttributes = h(), A.insert = c().bind(null, "head"), A.domAPI = o(), A.insertStyleElement = p(), a()(m.A, A), m.A && m.A.locals && m.A.locals;
        var v = {};
        function y() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : "undefined" != typeof self ? self : v;
        }
        var x = Object.assign, b = Object.getOwnPropertyDescriptor, w = Object.defineProperty, E = Object.prototype, T = [];
        Object.freeze(T);
        var S = {};
        Object.freeze(S);
        var I = "undefined" != typeof Proxy, N = Object.toString();
        function D() {
            I || M("Proxy not available");
        }
        function _(e1) {
            var t = !1;
            return function() {
                if (!t) return t = !0, e1.apply(this, arguments);
            };
        }
        var C = function() {};
        function L(e1) {
            return "function" == typeof e1;
        }
        function z(e1) {
            switch(typeof e1){
                case "string":
                case "symbol":
                case "number":
                    return !0;
            }
            return !1;
        }
        function O(e1) {
            return null !== e1 && "object" == typeof e1;
        }
        function R(e1) {
            if (!O(e1)) return !1;
            var t = Object.getPrototypeOf(e1);
            if (null == t) return !0;
            var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n.toString() === N;
        }
        function P(e1) {
            var t = null == e1 ? void 0 : e1.constructor;
            return !!t && ("GeneratorFunction" === t.name || "GeneratorFunction" === t.displayName);
        }
        function U(e1, t, n) {
            w(e1, t, {
                enumerable: !1,
                writable: !0,
                configurable: !0,
                value: n
            });
        }
        function j(e1, t, n) {
            w(e1, t, {
                enumerable: !1,
                writable: !1,
                configurable: !0,
                value: n
            });
        }
        function k(e1, t) {
            var n = "isMobX" + e1;
            return t.prototype[n] = !0, function(e1) {
                return O(e1) && !0 === e1[n];
            };
        }
        function B(e1) {
            return null != e1 && "[object Map]" === Object.prototype.toString.call(e1);
        }
        function F(e1) {
            return null != e1 && "[object Set]" === Object.prototype.toString.call(e1);
        }
        var H = void 0 !== Object.getOwnPropertySymbols, G = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : H ? function(e1) {
            return Object.getOwnPropertyNames(e1).concat(Object.getOwnPropertySymbols(e1));
        } : Object.getOwnPropertyNames;
        function V(e1) {
            return null === e1 ? null : "object" == typeof e1 ? "" + e1 : e1;
        }
        function Q(e1, t) {
            return E.hasOwnProperty.call(e1, t);
        }
        var W = Object.getOwnPropertyDescriptors || function(e1) {
            var t = {};
            return G(e1).forEach(function(n) {
                t[n] = b(e1, n);
            }), t;
        };
        function Y(e1, t) {
            return !!(e1 & t);
        }
        function X(e1, t, n) {
            return n ? e1 |= t : e1 &= ~t, e1;
        }
        function Z(e1, t) {
            (null == t || t > e1.length) && (t = e1.length);
            for(var n = 0, i = Array(t); n < t; n++)i[n] = e1[n];
            return i;
        }
        function q(e1, t) {
            for(var n = 0; n < t.length; n++){
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, ne(i.key), i);
            }
        }
        function K(e1, t, n) {
            return t && q(e1.prototype, t), n && q(e1, n), Object.defineProperty(e1, "prototype", {
                writable: !1
            }), e1;
        }
        function J(e1, t) {
            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
            if (n) return (n = n.call(e1)).next.bind(n);
            if (Array.isArray(e1) || (n = function(e1, t) {
                if (e1) {
                    if ("string" == typeof e1) return Z(e1, t);
                    var n = ({}).toString.call(e1).slice(8, -1);
                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Z(e1, t) : void 0;
                }
            }(e1)) || t && e1 && "number" == typeof e1.length) {
                n && (e1 = n);
                var i = 0;
                return function() {
                    return i >= e1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e1[i++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function $() {
            return $ = Object.assign ? Object.assign.bind() : function(e1) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var i in n)({}).hasOwnProperty.call(n, i) && (e1[i] = n[i]);
                }
                return e1;
            }, $.apply(null, arguments);
        }
        function ee(e1, t) {
            e1.prototype = Object.create(t.prototype), e1.prototype.constructor = e1, te(e1, t);
        }
        function te(e1, t) {
            return te = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                return e1.__proto__ = t, e1;
            }, te(e1, t);
        }
        function ne(e1) {
            var t = function(e1) {
                if ("object" != typeof e1 || !e1) return e1;
                var t = e1[Symbol.toPrimitive];
                if (void 0 !== t) {
                    var n = t.call(e1, "string");
                    if ("object" != typeof n) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e1);
            }(e1);
            return "symbol" == typeof t ? t : t + "";
        }
        var ie = Symbol("mobx-stored-annotations");
        function re(e1) {
            return Object.assign(function(t, n) {
                if (se(n)) return e1.decorate_20223_(t, n);
                ae(t, n, e1);
            }, e1);
        }
        function ae(e1, t, n) {
            Q(e1, ie) || U(e1, ie, $({}, e1[ie])), function(e1) {
                return e1.annotationType_ === fe;
            }(n) || (e1[ie][t] = n);
        }
        function se(e1) {
            return "object" == typeof e1 && "string" == typeof e1.kind;
        }
        var oe = Symbol("mobx administration"), le = function() {
            function e1(e1) {
                void 0 === e1 && (e1 = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = new Set, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ht.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e1;
            }
            var t = e1.prototype;
            return t.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(e1) {
                    return e1();
                });
            }, t.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(e1) {
                    return e1();
                });
            }, t.reportObserved = function() {
                return zt(this);
            }, t.reportChanged = function() {
                Ct(), Ot(this), Lt();
            }, t.toString = function() {
                return this.name_;
            }, K(e1, [
                {
                    key: "isBeingObserved",
                    get: function() {
                        return Y(this.flags_, e1.isBeingObservedMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isBeingObservedMask_, t);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return Y(this.flags_, e1.isPendingUnobservationMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isPendingUnobservationMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return Y(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        le.isBeingObservedMask_ = 1, le.isPendingUnobservationMask_ = 2, le.diffValueMask_ = 4;
        var ce = k("Atom", le);
        function ue(e1, t, n) {
            void 0 === t && (t = C), void 0 === n && (n = C);
            var i = new le(e1);
            return t !== C && tn(Jt, i, t, undefined), n !== C && en(i, n), i;
        }
        var he = {
            identity: function(e1, t) {
                return e1 === t;
            },
            structural: function(e1, t) {
                return mi(e1, t);
            },
            default: function(e1, t) {
                return Object.is ? Object.is(e1, t) : e1 === t ? 0 !== e1 || 1 / e1 == 1 / t : e1 != e1 && t != t;
            },
            shallow: function(e1, t) {
                return mi(e1, t, 1);
            }
        };
        function de(e1, t, n) {
            return fn(e1) ? e1 : Array.isArray(e1) ? Ke.array(e1, {
                name: n
            }) : R(e1) ? Ke.object(e1, void 0, {
                name: n
            }) : B(e1) ? Ke.map(e1, {
                name: n
            }) : F(e1) ? Ke.set(e1, {
                name: n
            }) : "function" != typeof e1 || qt(e1) || pn(e1) ? e1 : P(e1) ? hn(e1) : Zt(n, e1);
        }
        function pe(e1) {
            return e1;
        }
        var fe = "override";
        function ge(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: me,
                extend_: Ae,
                decorate_20223_: Me
            };
        }
        function me(e1, t, n, i) {
            var r;
            if (null != (r = this.options_) && r.bound) return null === this.extend_(e1, t, n, !1) ? 0 : 1;
            if (i === e1.target_) return null === this.extend_(e1, t, n, !1) ? 0 : 2;
            if (qt(n.value)) return 1;
            var a = ve(e1, this, t, n, !1);
            return w(i, t, a), 2;
        }
        function Ae(e1, t, n, i) {
            var r = ve(e1, this, t, n);
            return e1.defineProperty_(t, r, i);
        }
        function Me(e1, t) {
            var n = t.kind, i = t.name, r = t.addInitializer, a = this;
            if ("field" != n) {
                var s, o, l, c, u, h;
                if ("method" == n) return qt(e1) || (o = e1, e1 = st(null != (l = null == (c = a.options_) ? void 0 : c.name) ? l : i.toString(), o, null != (u = null == (h = a.options_) ? void 0 : h.autoAction) && u)), null != (s = this.options_) && s.bound && r(function() {
                    var e1 = this, t = e1[i].bind(e1);
                    t.isMobxAction = !0, e1[i] = t;
                }), e1;
                M("Cannot apply '" + a.annotationType_ + "' to '" + String(i) + "' (kind: " + n + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
            } else r(function() {
                ae(this, i, a);
            });
        }
        function ve(e1, t, n, i, r) {
            var a, s, o, l, c, u, h, d;
            void 0 === r && (r = Nt.safeDescriptors), d = i, t.annotationType_, d.value;
            var p, f = i.value;
            return null != (a = t.options_) && a.bound && (f = f.bind(null != (p = e1.proxy_) ? p : e1.target_)), {
                value: st(null != (s = null == (o = t.options_) ? void 0 : o.name) ? s : n.toString(), f, null != (l = null == (c = t.options_) ? void 0 : c.autoAction) && l, null != (u = t.options_) && u.bound ? null != (h = e1.proxy_) ? h : e1.target_ : void 0),
                configurable: !r || e1.isPlainObject_,
                enumerable: !1,
                writable: !r
            };
        }
        function ye(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: xe,
                extend_: be,
                decorate_20223_: we
            };
        }
        function xe(e1, t, n, i) {
            var r;
            if (i === e1.target_) return null === this.extend_(e1, t, n, !1) ? 0 : 2;
            if (null != (r = this.options_) && r.bound && (!Q(e1.target_, t) || !pn(e1.target_[t])) && null === this.extend_(e1, t, n, !1)) return 0;
            if (pn(n.value)) return 1;
            var a = Ee(e1, this, 0, n, !1, !1);
            return w(i, t, a), 2;
        }
        function be(e1, t, n, i) {
            var r, a = Ee(e1, this, 0, n, null == (r = this.options_) ? void 0 : r.bound);
            return e1.defineProperty_(t, a, i);
        }
        function we(e1, t) {
            var n, i = t.name, r = t.addInitializer;
            return pn(e1) || (e1 = hn(e1)), null != (n = this.options_) && n.bound && r(function() {
                var e1 = this, t = e1[i].bind(e1);
                t.isMobXFlow = !0, e1[i] = t;
            }), e1;
        }
        function Ee(e1, t, n, i, r, a) {
            var s;
            void 0 === a && (a = Nt.safeDescriptors), s = i, t.annotationType_, s.value;
            var o, l = i.value;
            return pn(l) || (l = hn(l)), r && ((l = l.bind(null != (o = e1.proxy_) ? o : e1.target_)).isMobXFlow = !0), {
                value: l,
                configurable: !a || e1.isPlainObject_,
                enumerable: !1,
                writable: !a
            };
        }
        function Te(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: Se,
                extend_: Ie,
                decorate_20223_: Ne
            };
        }
        function Se(e1, t, n) {
            return null === this.extend_(e1, t, n, !1) ? 0 : 1;
        }
        function Ie(e1, t, n, i) {
            var r;
            return r = n, this.annotationType_, r.get, e1.defineComputedProperty_(t, $({}, this.options_, {
                get: n.get,
                set: n.set
            }), i);
        }
        function Ne(e1, t) {
            var n = this, i = t.name;
            return (0, t.addInitializer)(function() {
                var t = Zn(this)[oe], r = $({}, n.options_, {
                    get: e1,
                    context: this
                });
                r.name || (r.name = "ObservableObject." + i.toString()), t.values_.set(i, new ut(r));
            }), function() {
                return this[oe].getObservablePropValue_(i);
            };
        }
        function De(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: _e,
                extend_: Ce,
                decorate_20223_: Le
            };
        }
        function _e(e1, t, n) {
            return null === this.extend_(e1, t, n, !1) ? 0 : 1;
        }
        function Ce(e1, t, n, i) {
            var r, a;
            return this.annotationType_, e1.defineObservableProperty_(t, n.value, null != (r = null == (a = this.options_) ? void 0 : a.enhancer) ? r : de, i);
        }
        function Le(e1, t) {
            var n = this, i = t.kind, r = t.name, a = new WeakSet;
            function s(e1, t) {
                var i, s, o = Zn(e1)[oe], l = new ct(t, null != (i = null == (s = n.options_) ? void 0 : s.enhancer) ? i : de, "ObservableObject." + r.toString(), !1);
                o.values_.set(r, l), a.add(e1);
            }
            if ("accessor" == i) return {
                get: function() {
                    return a.has(this) || s(this, e1.get.call(this)), this[oe].getObservablePropValue_(r);
                },
                set: function(e1) {
                    return a.has(this) || s(this, e1), this[oe].setObservablePropValue_(r, e1);
                },
                init: function(e1) {
                    return a.has(this) || s(this, e1), e1;
                }
            };
        }
        var ze = "true", Oe = Re();
        function Re(e1) {
            return {
                annotationType_: ze,
                options_: e1,
                make_: Pe,
                extend_: Ue,
                decorate_20223_: je
            };
        }
        function Pe(e1, t, n, i) {
            var r, a, s, o;
            if (n.get) return tt.make_(e1, t, n, i);
            if (n.set) {
                var l = st(t.toString(), n.set);
                return i === e1.target_ ? null === e1.defineProperty_(t, {
                    configurable: !Nt.safeDescriptors || e1.isPlainObject_,
                    set: l
                }) ? 0 : 2 : (w(i, t, {
                    configurable: !0,
                    set: l
                }), 2);
            }
            if (i !== e1.target_ && "function" == typeof n.value) return P(n.value) ? (null != (o = this.options_) && o.autoBind ? hn.bound : hn).make_(e1, t, n, i) : (null != (s = this.options_) && s.autoBind ? Zt.bound : Zt).make_(e1, t, n, i);
            var c, u = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? Ke.ref : Ke;
            return "function" == typeof n.value && null != (a = this.options_) && a.autoBind && (n.value = n.value.bind(null != (c = e1.proxy_) ? c : e1.target_)), u.make_(e1, t, n, i);
        }
        function Ue(e1, t, n, i) {
            var r, a, s;
            return n.get ? tt.extend_(e1, t, n, i) : n.set ? e1.defineProperty_(t, {
                configurable: !Nt.safeDescriptors || e1.isPlainObject_,
                set: st(t.toString(), n.set)
            }, i) : ("function" == typeof n.value && null != (r = this.options_) && r.autoBind && (n.value = n.value.bind(null != (s = e1.proxy_) ? s : e1.target_)), (!1 === (null == (a = this.options_) ? void 0 : a.deep) ? Ke.ref : Ke).extend_(e1, t, n, i));
        }
        function je(e1, t) {
            M("'" + this.annotationType_ + "' cannot be used as a decorator");
        }
        var ke = {
            deep: !0,
            name: void 0,
            defaultDecorator: void 0,
            proxy: !0
        };
        function Be(e1) {
            return e1 || ke;
        }
        Object.freeze(ke);
        var Fe = De("observable"), He = De("observable.ref", {
            enhancer: pe
        }), Ge = De("observable.shallow", {
            enhancer: function(e1, t, n) {
                return null == e1 || Jn(e1) || Un(e1) || Hn(e1) || Qn(e1) ? e1 : Array.isArray(e1) ? Ke.array(e1, {
                    name: n,
                    deep: !1
                }) : R(e1) ? Ke.object(e1, void 0, {
                    name: n,
                    deep: !1
                }) : B(e1) ? Ke.map(e1, {
                    name: n,
                    deep: !1
                }) : F(e1) ? Ke.set(e1, {
                    name: n,
                    deep: !1
                }) : void 0;
            }
        }), Ve = De("observable.struct", {
            enhancer: function(e1, t) {
                return mi(e1, t) ? t : e1;
            }
        }), Qe = re(Fe);
        function We(e1) {
            var t, n, i;
            return !0 === e1.deep ? de : !1 === e1.deep ? pe : (t = e1.defaultDecorator) && null != (n = null == (i = t.options_) ? void 0 : i.enhancer) ? n : de;
        }
        function Ye(e1, t, n) {
            return se(t) ? Fe.decorate_20223_(e1, t) : z(t) ? void ae(e1, t, Fe) : fn(e1) ? e1 : R(e1) ? Ke.object(e1, t, n) : Array.isArray(e1) ? Ke.array(e1, t) : B(e1) ? Ke.map(e1, t) : F(e1) ? Ke.set(e1, t) : "object" == typeof e1 && null !== e1 ? e1 : Ke.box(e1, t);
        }
        x(Ye, Qe);
        var Xe, Ze, qe = {
            box: function(e1, t) {
                var n = Be(t);
                return new ct(e1, We(n), n.name, !0, n.equals);
            },
            array: function(e1, t) {
                var n = Be(t);
                return (!1 === Nt.useProxies || !1 === n.proxy ? ui : _n)(e1, We(n), n.name);
            },
            map: function(e1, t) {
                var n = Be(t);
                return new Fn(e1, We(n), n.name);
            },
            set: function(e1, t) {
                var n = Be(t);
                return new Vn(e1, We(n), n.name);
            },
            object: function(e1, t, n) {
                return fi(function() {
                    return an(!1 === Nt.useProxies || !1 === (null == n ? void 0 : n.proxy) ? Zn({}, n) : function(e1, t) {
                        var n, i;
                        return D(), null != (i = (n = (e1 = Zn(e1, t))[oe]).proxy_) ? i : n.proxy_ = new Proxy(e1, An);
                    }({}, n), e1, t);
                });
            },
            ref: re(He),
            shallow: re(Ge),
            deep: Qe,
            struct: re(Ve)
        }, Ke = x(Ye, qe), Je = "computed", $e = Te(Je), et = Te("computed.struct", {
            equals: he.structural
        }), tt = function(e1, t) {
            if (se(t)) return $e.decorate_20223_(e1, t);
            if (z(t)) return ae(e1, t, $e);
            if (R(e1)) return re(Te(Je, e1));
            var n = R(t) ? t : {};
            return n.get = e1, n.name || (n.name = e1.name || ""), new ut(n);
        };
        Object.assign(tt, $e), tt.struct = re(et);
        var nt = 0, it = 1, rt = null != (Xe = null == (Ze = b(function() {}, "name")) ? void 0 : Ze.configurable) && Xe, at = {
            value: "action",
            configurable: !0,
            writable: !1,
            enumerable: !1
        };
        function st(e1, t, n, i) {
            function r() {
                return function(e1, t, n, i, r) {
                    var a = function(e1, t) {
                        var n = !1, i = 0, r = Nt.trackingDerivation, a = !t || !r;
                        Ct();
                        var s = Nt.allowStateChanges;
                        a && (yt(), s = ot(!0));
                        var o = {
                            runAsAction_: a,
                            prevDerivation_: r,
                            prevAllowStateChanges_: s,
                            prevAllowStateReads_: bt(!0),
                            notifySpy_: n,
                            startTime_: i,
                            actionId_: it++,
                            parentActionId_: nt
                        };
                        return nt = o.actionId_, o;
                    }(0, t);
                    try {
                        return n.apply(i, r);
                    } catch (e1) {
                        throw a.error_ = e1, e1;
                    } finally{
                        !function(e1) {
                            nt !== e1.actionId_ && M(30), nt = e1.parentActionId_, void 0 !== e1.error_ && (Nt.suppressReactionErrors = !0), lt(e1.prevAllowStateChanges_), wt(e1.prevAllowStateReads_), Lt(), e1.runAsAction_ && xt(e1.prevDerivation_), Nt.suppressReactionErrors = !1;
                        }(a);
                    }
                }(0, n, t, i || this, arguments);
            }
            return void 0 === n && (n = !1), r.isMobxAction = !0, r.toString = function() {
                return t.toString();
            }, rt && (at.value = e1, w(r, "name", at)), r;
        }
        function ot(e1) {
            var t = Nt.allowStateChanges;
            return Nt.allowStateChanges = e1, t;
        }
        function lt(e1) {
            Nt.allowStateChanges = e1;
        }
        var ct = function(e1) {
            function t(t, n, i, r, a) {
                var s;
                return void 0 === i && (i = "ObservableValue"), void 0 === r && (r = !0), void 0 === a && (a = he.default), (s = e1.call(this, i) || this).enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = n, s.name_ = i, s.equals = a, s.value_ = n(t, void 0, i), s;
            }
            ee(t, e1);
            var n = t.prototype;
            return n.dehanceValue = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, n.set = function(e1) {
                this.value_, (e1 = this.prepareNewValue_(e1)) !== Nt.UNCHANGED && this.setNewValue_(e1);
            }, n.prepareNewValue_ = function(e1) {
                if (Mn(this)) {
                    var t = yn(this, {
                        object: this,
                        type: In,
                        newValue: e1
                    });
                    if (!t) return Nt.UNCHANGED;
                    e1 = t.newValue;
                }
                return e1 = this.enhancer(e1, this.value_, this.name_), this.equals(this.value_, e1) ? Nt.UNCHANGED : e1;
            }, n.setNewValue_ = function(e1) {
                var t = this.value_;
                this.value_ = e1, this.reportChanged(), xn(this) && wn(this, {
                    type: In,
                    object: this,
                    newValue: e1,
                    oldValue: t
                });
            }, n.get = function() {
                return this.reportObserved(), this.dehanceValue(this.value_);
            }, n.intercept_ = function(e1) {
                return vn(this, e1);
            }, n.observe_ = function(e1, t) {
                return t && e1({
                    observableKind: "value",
                    debugObjectName: this.name_,
                    object: this,
                    type: In,
                    newValue: this.value_,
                    oldValue: void 0
                }), bn(this, e1);
            }, n.raw = function() {
                return this.value_;
            }, n.toJSON = function() {
                return this.get();
            }, n.toString = function() {
                return this.name_ + "[" + this.value_ + "]";
            }, n.valueOf = function() {
                return V(this.get());
            }, n[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, t;
        }(le), ut = function() {
            function e1(e1) {
                this.dependenciesState_ = ht.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = new Set, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ht.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new ft(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = dt.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e1.get || M(31), this.derivation = e1.get, this.name_ = e1.name || "ComputedValue", e1.set && (this.setter_ = st("ComputedValue-setter", e1.set)), this.equals_ = e1.equals || (e1.compareStructural || e1.struct ? he.structural : he.default), this.scope_ = e1.context, this.requiresReaction_ = e1.requiresReaction, this.keepAlive_ = !!e1.keepAlive;
            }
            var t = e1.prototype;
            return t.onBecomeStale_ = function() {
                var e1;
                (e1 = this).lowestObserverState_ === ht.UP_TO_DATE_ && (e1.lowestObserverState_ = ht.POSSIBLY_STALE_, e1.observers_.forEach(function(e1) {
                    e1.dependenciesState_ === ht.UP_TO_DATE_ && (e1.dependenciesState_ = ht.POSSIBLY_STALE_, e1.onBecomeStale_());
                }));
            }, t.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(e1) {
                    return e1();
                });
            }, t.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(e1) {
                    return e1();
                });
            }, t.get = function() {
                if (this.isComputing && M(32, this.name_, this.derivation), 0 !== Nt.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                    if (zt(this), mt(this)) {
                        var e1 = Nt.trackingContext;
                        this.keepAlive_ && !e1 && (Nt.trackingContext = this), this.trackAndCompute() && (t = this).lowestObserverState_ !== ht.STALE_ && (t.lowestObserverState_ = ht.STALE_, t.observers_.forEach(function(e1) {
                            e1.dependenciesState_ === ht.POSSIBLY_STALE_ ? e1.dependenciesState_ = ht.STALE_ : e1.dependenciesState_ === ht.UP_TO_DATE_ && (t.lowestObserverState_ = ht.UP_TO_DATE_);
                        })), Nt.trackingContext = e1;
                    }
                } else mt(this) && (this.warnAboutUntrackedRead_(), Ct(), this.value_ = this.computeValue_(!1), Lt());
                var t, n = this.value_;
                if (gt(n)) throw n.cause;
                return n;
            }, t.set = function(e1) {
                if (this.setter_) {
                    this.isRunningSetter && M(33, this.name_), this.isRunningSetter = !0;
                    try {
                        this.setter_.call(this.scope_, e1);
                    } finally{
                        this.isRunningSetter = !1;
                    }
                } else M(34, this.name_);
            }, t.trackAndCompute = function() {
                var e1 = this.value_, t = this.dependenciesState_ === ht.NOT_TRACKING_, n = this.computeValue_(!0), i = t || gt(e1) || gt(n) || !this.equals_(e1, n);
                return i && (this.value_ = n), i;
            }, t.computeValue_ = function(e1) {
                this.isComputing = !0;
                var t, n = ot(!1);
                if (e1) t = At(this, this.derivation, this.scope_);
                else if (!0 === Nt.disableErrorBoundaries) t = this.derivation.call(this.scope_);
                else try {
                    t = this.derivation.call(this.scope_);
                } catch (e1) {
                    t = new ft(e1);
                }
                return lt(n), this.isComputing = !1, t;
            }, t.suspend_ = function() {
                this.keepAlive_ || (Mt(this), this.value_ = void 0);
            }, t.observe_ = function(e1, t) {
                var n = this, i = !0, r = void 0;
                return function(e1, t) {
                    var n, i, r, a;
                    void 0 === t && (t = S);
                    var s, o = null != (n = null == (i = t) ? void 0 : i.name) ? n : "Autorun";
                    if (t.scheduler || t.delay) {
                        var l = function(e1) {
                            return e1.scheduler ? e1.scheduler : e1.delay ? function(t) {
                                return setTimeout(t, e1.delay);
                            } : Kt;
                        }(t), c = !1;
                        s = new Rt(o, function() {
                            c || (c = !0, l(function() {
                                c = !1, s.isDisposed || s.track(u);
                            }));
                        }, t.onError, t.requiresObservable);
                    } else s = new Rt(o, function() {
                        this.track(u);
                    }, t.onError, t.requiresObservable);
                    function u() {
                        e1(s);
                    }
                    return null != (r = t) && null != (r = r.signal) && r.aborted || s.schedule_(), s.getDisposer_(null == (a = t) ? void 0 : a.signal);
                }(function() {
                    var a = n.get();
                    if (!i || t) {
                        var s = yt();
                        e1({
                            observableKind: "computed",
                            debugObjectName: n.name_,
                            type: In,
                            object: n,
                            newValue: a,
                            oldValue: r
                        }), xt(s);
                    }
                    i = !1, r = a;
                });
            }, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
                return this.name_ + "[" + this.derivation.toString() + "]";
            }, t.valueOf = function() {
                return V(this.get());
            }, t[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, K(e1, [
                {
                    key: "isComputing",
                    get: function() {
                        return Y(this.flags_, e1.isComputingMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isComputingMask_, t);
                    }
                },
                {
                    key: "isRunningSetter",
                    get: function() {
                        return Y(this.flags_, e1.isRunningSetterMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isRunningSetterMask_, t);
                    }
                },
                {
                    key: "isBeingObserved",
                    get: function() {
                        return Y(this.flags_, e1.isBeingObservedMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isBeingObservedMask_, t);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return Y(this.flags_, e1.isPendingUnobservationMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isPendingUnobservationMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return Y(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        ut.isComputingMask_ = 1, ut.isRunningSetterMask_ = 2, ut.isBeingObservedMask_ = 4, ut.isPendingUnobservationMask_ = 8, ut.diffValueMask_ = 16;
        var ht, dt, pt = k("ComputedValue", ut);
        !function(e1) {
            e1[e1.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e1[e1.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e1[e1.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e1[e1.STALE_ = 2] = "STALE_";
        }(ht || (ht = {})), function(e1) {
            e1[e1.NONE = 0] = "NONE", e1[e1.LOG = 1] = "LOG", e1[e1.BREAK = 2] = "BREAK";
        }(dt || (dt = {}));
        var ft = function(e1) {
            this.cause = void 0, this.cause = e1;
        };
        function gt(e1) {
            return e1 instanceof ft;
        }
        function mt(e1) {
            switch(e1.dependenciesState_){
                case ht.UP_TO_DATE_:
                    return !1;
                case ht.NOT_TRACKING_:
                case ht.STALE_:
                    return !0;
                case ht.POSSIBLY_STALE_:
                    for(var t = bt(!0), n = yt(), i = e1.observing_, r = i.length, a = 0; a < r; a++){
                        var s = i[a];
                        if (pt(s)) {
                            if (Nt.disableErrorBoundaries) s.get();
                            else try {
                                s.get();
                            } catch (e1) {
                                return xt(n), wt(t), !0;
                            }
                            if (e1.dependenciesState_ === ht.STALE_) return xt(n), wt(t), !0;
                        }
                    }
                    return Et(e1), xt(n), wt(t), !1;
            }
        }
        function At(e1, t, n) {
            var i = bt(!0);
            Et(e1), e1.newObserving_ = new Array(0 === e1.runId_ ? 100 : e1.observing_.length), e1.unboundDepsCount_ = 0, e1.runId_ = ++Nt.runId;
            var r, a = Nt.trackingDerivation;
            if (Nt.trackingDerivation = e1, Nt.inBatch++, !0 === Nt.disableErrorBoundaries) r = t.call(n);
            else try {
                r = t.call(n);
            } catch (e1) {
                r = new ft(e1);
            }
            return Nt.inBatch--, Nt.trackingDerivation = a, function(e1) {
                for(var t = e1.observing_, n = e1.observing_ = e1.newObserving_, i = ht.UP_TO_DATE_, r = 0, a = e1.unboundDepsCount_, s = 0; s < a; s++){
                    var o = n[s];
                    0 === o.diffValue && (o.diffValue = 1, r !== s && (n[r] = o), r++), o.dependenciesState_ > i && (i = o.dependenciesState_);
                }
                for(n.length = r, e1.newObserving_ = null, a = t.length; a--;){
                    var l = t[a];
                    0 === l.diffValue && Dt(l, e1), l.diffValue = 0;
                }
                for(; r--;){
                    var c = n[r];
                    1 === c.diffValue && (c.diffValue = 0, h = e1, (u = c).observers_.add(h), u.lowestObserverState_ > h.dependenciesState_ && (u.lowestObserverState_ = h.dependenciesState_));
                }
                var u, h;
                i !== ht.UP_TO_DATE_ && (e1.dependenciesState_ = i, e1.onBecomeStale_());
            }(e1), wt(i), r;
        }
        function Mt(e1) {
            var t = e1.observing_;
            e1.observing_ = [];
            for(var n = t.length; n--;)Dt(t[n], e1);
            e1.dependenciesState_ = ht.NOT_TRACKING_;
        }
        function vt(e1) {
            var t = yt();
            try {
                return e1();
            } finally{
                xt(t);
            }
        }
        function yt() {
            var e1 = Nt.trackingDerivation;
            return Nt.trackingDerivation = null, e1;
        }
        function xt(e1) {
            Nt.trackingDerivation = e1;
        }
        function bt(e1) {
            var t = Nt.allowStateReads;
            return Nt.allowStateReads = e1, t;
        }
        function wt(e1) {
            Nt.allowStateReads = e1;
        }
        function Et(e1) {
            if (e1.dependenciesState_ !== ht.UP_TO_DATE_) {
                e1.dependenciesState_ = ht.UP_TO_DATE_;
                for(var t = e1.observing_, n = t.length; n--;)t[n].lowestObserverState_ = ht.UP_TO_DATE_;
            }
        }
        var Tt = function() {
            this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
        }, St = !0, It = !1, Nt = function() {
            var e1 = y();
            return e1.__mobxInstanceCount > 0 && !e1.__mobxGlobals && (St = !1), e1.__mobxGlobals && e1.__mobxGlobals.version !== (new Tt).version && (St = !1), St ? e1.__mobxGlobals ? (e1.__mobxInstanceCount += 1, e1.__mobxGlobals.UNCHANGED || (e1.__mobxGlobals.UNCHANGED = {}), e1.__mobxGlobals) : (e1.__mobxInstanceCount = 1, e1.__mobxGlobals = new Tt) : (setTimeout(function() {
                It || M(35);
            }, 1), new Tt);
        }();
        function Dt(e1, t) {
            e1.observers_.delete(t), 0 === e1.observers_.size && _t(e1);
        }
        function _t(e1) {
            !1 === e1.isPendingUnobservation && (e1.isPendingUnobservation = !0, Nt.pendingUnobservations.push(e1));
        }
        function Ct() {
            Nt.inBatch++;
        }
        function Lt() {
            if (0 == --Nt.inBatch) {
                jt();
                for(var e1 = Nt.pendingUnobservations, t = 0; t < e1.length; t++){
                    var n = e1[t];
                    n.isPendingUnobservation = !1, 0 === n.observers_.size && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof ut && n.suspend_());
                }
                Nt.pendingUnobservations = [];
            }
        }
        function zt(e1) {
            var t = Nt.trackingDerivation;
            return null !== t ? (t.runId_ !== e1.lastAccessedBy_ && (e1.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e1, !e1.isBeingObserved && Nt.trackingContext && (e1.isBeingObserved = !0, e1.onBO())), e1.isBeingObserved) : (0 === e1.observers_.size && Nt.inBatch > 0 && _t(e1), !1);
        }
        function Ot(e1) {
            e1.lowestObserverState_ !== ht.STALE_ && (e1.lowestObserverState_ = ht.STALE_, e1.observers_.forEach(function(e1) {
                e1.dependenciesState_ === ht.UP_TO_DATE_ && e1.onBecomeStale_(), e1.dependenciesState_ = ht.STALE_;
            }));
        }
        var Rt = function() {
            function e1(e1, t, n, i) {
                void 0 === e1 && (e1 = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = ht.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = dt.NONE, this.name_ = e1, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = i;
            }
            var t = e1.prototype;
            return t.onBecomeStale_ = function() {
                this.schedule_();
            }, t.schedule_ = function() {
                this.isScheduled || (this.isScheduled = !0, Nt.pendingReactions.push(this), jt());
            }, t.runReaction_ = function() {
                if (!this.isDisposed) {
                    Ct(), this.isScheduled = !1;
                    var e1 = Nt.trackingContext;
                    if (Nt.trackingContext = this, mt(this)) {
                        this.isTrackPending = !0;
                        try {
                            this.onInvalidate_();
                        } catch (e1) {
                            this.reportExceptionInDerivation_(e1);
                        }
                    }
                    Nt.trackingContext = e1, Lt();
                }
            }, t.track = function(e1) {
                if (!this.isDisposed) {
                    Ct(), this.isRunning = !0;
                    var t = Nt.trackingContext;
                    Nt.trackingContext = this;
                    var n = At(this, e1, void 0);
                    Nt.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && Mt(this), gt(n) && this.reportExceptionInDerivation_(n.cause), Lt();
                }
            }, t.reportExceptionInDerivation_ = function(e1) {
                var t = this;
                if (this.errorHandler_) this.errorHandler_(e1, this);
                else {
                    if (Nt.disableErrorBoundaries) throw e1;
                    var n = "[mobx] uncaught error in '" + this + "'";
                    Nt.suppressReactionErrors || console.error(n, e1), Nt.globalReactionErrorHandlers.forEach(function(n) {
                        return n(e1, t);
                    });
                }
            }, t.dispose = function() {
                this.isDisposed || (this.isDisposed = !0, this.isRunning || (Ct(), Mt(this), Lt()));
            }, t.getDisposer_ = function(e1) {
                var t = this, n = function n() {
                    t.dispose(), null == e1 || null == e1.removeEventListener || e1.removeEventListener("abort", n);
                };
                return null == e1 || null == e1.addEventListener || e1.addEventListener("abort", n), n[oe] = this, n;
            }, t.toString = function() {
                return "Reaction[" + this.name_ + "]";
            }, t.trace = function(e1) {
                void 0 === e1 && (e1 = !1);
            }, K(e1, [
                {
                    key: "isDisposed",
                    get: function() {
                        return Y(this.flags_, e1.isDisposedMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isDisposedMask_, t);
                    }
                },
                {
                    key: "isScheduled",
                    get: function() {
                        return Y(this.flags_, e1.isScheduledMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isScheduledMask_, t);
                    }
                },
                {
                    key: "isTrackPending",
                    get: function() {
                        return Y(this.flags_, e1.isTrackPendingMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isTrackPendingMask_, t);
                    }
                },
                {
                    key: "isRunning",
                    get: function() {
                        return Y(this.flags_, e1.isRunningMask_);
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.isRunningMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return Y(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = X(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        Rt.isDisposedMask_ = 1, Rt.isScheduledMask_ = 2, Rt.isTrackPendingMask_ = 4, Rt.isRunningMask_ = 8, Rt.diffValueMask_ = 16;
        var Pt = 100, Ut = function(e1) {
            return e1();
        };
        function jt() {
            Nt.inBatch > 0 || Nt.isRunningReactions || Ut(kt);
        }
        function kt() {
            Nt.isRunningReactions = !0;
            for(var e1 = Nt.pendingReactions, t = 0; e1.length > 0;){
                ++t === Pt && (console.error("[mobx] cycle in reaction: " + e1[0]), e1.splice(0));
                for(var n = e1.splice(0), i = 0, r = n.length; i < r; i++)n[i].runReaction_();
            }
            Nt.isRunningReactions = !1;
        }
        var Bt = k("Reaction", Rt), Ft = "action", Ht = "autoAction", Gt = ge(Ft), Vt = ge("action.bound", {
            bound: !0
        }), Qt = ge(Ht, {
            autoAction: !0
        }), Wt = ge("autoAction.bound", {
            autoAction: !0,
            bound: !0
        });
        function Yt(e1) {
            return function(t, n) {
                return L(t) ? st(t.name || "<unnamed action>", t, e1) : L(n) ? st(t, n, e1) : se(n) ? (e1 ? Qt : Gt).decorate_20223_(t, n) : z(n) ? ae(t, n, e1 ? Qt : Gt) : z(t) ? re(ge(e1 ? Ht : Ft, {
                    name: t,
                    autoAction: e1
                })) : void 0;
            };
        }
        var Xt = Yt(!1);
        Object.assign(Xt, Gt);
        var Zt = Yt(!0);
        function qt(e1) {
            return L(e1) && !0 === e1.isMobxAction;
        }
        Object.assign(Zt, Qt), Xt.bound = re(Vt), Zt.bound = re(Wt);
        var Kt = function(e1) {
            return e1();
        };
        var Jt = "onBO", $t = "onBUO";
        function en(e1, t, n) {
            return tn($t, e1, t, n);
        }
        function tn(e1, t, n, i) {
            var r = "function" == typeof i ? hi(t, n) : hi(t), a = L(i) ? i : n, s = e1 + "L";
            return r[s] ? r[s].add(a) : r[s] = new Set([
                a
            ]), function() {
                var e1 = r[s];
                e1 && (e1.delete(a), 0 === e1.size && delete r[s]);
            };
        }
        var nn = "always";
        function rn(e1) {
            !0 === e1.isolateGlobalState && function() {
                if ((Nt.pendingReactions.length || Nt.inBatch || Nt.isRunningReactions) && M(36), It = !0, St) {
                    var e1 = y();
                    0 == --e1.__mobxInstanceCount && (e1.__mobxGlobals = void 0), Nt = new Tt;
                }
            }();
            var t, n, i = e1.useProxies, r = e1.enforceActions;
            if (void 0 !== i && (Nt.useProxies = i === nn || "never" !== i && "undefined" != typeof Proxy), "ifavailable" === i && (Nt.verifyProxies = !0), void 0 !== r) {
                var a = r === nn ? nn : "observed" === r;
                Nt.enforceActions = a, Nt.allowStateChanges = !0 !== a && a !== nn;
            }
            [
                "computedRequiresReaction",
                "reactionRequiresObservable",
                "observableRequiresReaction",
                "disableErrorBoundaries",
                "safeDescriptors"
            ].forEach(function(t) {
                t in e1 && (Nt[t] = !!e1[t]);
            }), Nt.allowStateReads = !Nt.observableRequiresReaction, e1.reactionScheduler && (t = e1.reactionScheduler, n = Ut, Ut = function(e1) {
                return t(function() {
                    return n(e1);
                });
            });
        }
        function an(e1, t, n, i) {
            var r = W(t);
            return fi(function() {
                var t = Zn(e1, i)[oe];
                G(r).forEach(function(e1) {
                    t.extend_(e1, r[e1], !n || !(e1 in n) || n[e1]);
                });
            }), e1;
        }
        function sn(e1) {
            var t, n = {
                name: e1.name_
            };
            return e1.observing_ && e1.observing_.length > 0 && (n.dependencies = (t = e1.observing_, Array.from(new Set(t))).map(sn)), n;
        }
        var on = 0;
        function ln() {
            this.message = "FLOW_CANCELLED";
        }
        ln.prototype = Object.create(Error.prototype);
        var cn = ye("flow"), un = ye("flow.bound", {
            bound: !0
        }), hn = Object.assign(function(e1, t) {
            if (se(t)) return cn.decorate_20223_(e1, t);
            if (z(t)) return ae(e1, t, cn);
            var n = e1, i = n.name || "<unnamed flow>", r = function() {
                var e1, t = arguments, r = ++on, a = Xt(i + " - runid: " + r + " - init", n).apply(this, t), s = void 0, o = new Promise(function(t, n) {
                    var o = 0;
                    function l(e1) {
                        var t;
                        s = void 0;
                        try {
                            t = Xt(i + " - runid: " + r + " - yield " + o++, a.next).call(a, e1);
                        } catch (e1) {
                            return n(e1);
                        }
                        u(t);
                    }
                    function c(e1) {
                        var t;
                        s = void 0;
                        try {
                            t = Xt(i + " - runid: " + r + " - yield " + o++, a.throw).call(a, e1);
                        } catch (e1) {
                            return n(e1);
                        }
                        u(t);
                    }
                    function u(e1) {
                        if (!L(null == e1 ? void 0 : e1.then)) return e1.done ? t(e1.value) : (s = Promise.resolve(e1.value)).then(l, c);
                        e1.then(u, n);
                    }
                    e1 = n, l(void 0);
                });
                return o.cancel = Xt(i + " - runid: " + r + " - cancel", function() {
                    try {
                        s && dn(s);
                        var t = a.return(void 0), n = Promise.resolve(t.value);
                        n.then(C, C), dn(n), e1(new ln);
                    } catch (t) {
                        e1(t);
                    }
                }), o;
            };
            return r.isMobXFlow = !0, r;
        }, cn);
        function dn(e1) {
            L(e1.cancel) && e1.cancel();
        }
        function pn(e1) {
            return !0 === (null == e1 ? void 0 : e1.isMobXFlow);
        }
        function fn(e1) {
            return function(e1, t) {
                return !!e1 && (void 0 !== t ? !!Jn(e1) && e1[oe].values_.has(t) : Jn(e1) || !!e1[oe] || ce(e1) || Bt(e1) || pt(e1));
            }(e1);
        }
        function gn(e1, t) {
            void 0 === t && (t = void 0), Ct();
            try {
                return e1.apply(t);
            } finally{
                Lt();
            }
        }
        function mn(e1) {
            return e1[oe];
        }
        hn.bound = re(un);
        var An = {
            has: function(e1, t) {
                return mn(e1).has_(t);
            },
            get: function(e1, t) {
                return mn(e1).get_(t);
            },
            set: function(e1, t, n) {
                var i;
                return !!z(t) && (null == (i = mn(e1).set_(t, n, !0)) || i);
            },
            deleteProperty: function(e1, t) {
                var n;
                return !!z(t) && (null == (n = mn(e1).delete_(t, !0)) || n);
            },
            defineProperty: function(e1, t, n) {
                var i;
                return null == (i = mn(e1).defineProperty_(t, n)) || i;
            },
            ownKeys: function(e1) {
                return mn(e1).ownKeys_();
            },
            preventExtensions: function(e1) {
                M(13);
            }
        };
        function Mn(e1) {
            return void 0 !== e1.interceptors_ && e1.interceptors_.length > 0;
        }
        function vn(e1, t) {
            var n = e1.interceptors_ || (e1.interceptors_ = []);
            return n.push(t), _(function() {
                var e1 = n.indexOf(t);
                -1 !== e1 && n.splice(e1, 1);
            });
        }
        function yn(e1, t) {
            var n = yt();
            try {
                for(var i = [].concat(e1.interceptors_ || []), r = 0, a = i.length; r < a && ((t = i[r](t)) && !t.type && M(14), t); r++);
                return t;
            } finally{
                xt(n);
            }
        }
        function xn(e1) {
            return void 0 !== e1.changeListeners_ && e1.changeListeners_.length > 0;
        }
        function bn(e1, t) {
            var n = e1.changeListeners_ || (e1.changeListeners_ = []);
            return n.push(t), _(function() {
                var e1 = n.indexOf(t);
                -1 !== e1 && n.splice(e1, 1);
            });
        }
        function wn(e1, t) {
            var n = yt(), i = e1.changeListeners_;
            if (i) {
                for(var r = 0, a = (i = i.slice()).length; r < a; r++)i[r](t);
                xt(n);
            }
        }
        var En = Symbol("mobx-keys");
        function Tn(e1, t, n) {
            return R(e1) ? an(e1, e1, t, n) : (fi(function() {
                var i = Zn(e1, n)[oe];
                if (!e1[En]) {
                    var r = Object.getPrototypeOf(e1), a = new Set([].concat(G(e1), G(r)));
                    a.delete("constructor"), a.delete(oe), U(r, En, a);
                }
                e1[En].forEach(function(e1) {
                    return i.make_(e1, !t || !(e1 in t) || t[e1]);
                });
            }), e1);
        }
        var Sn = "splice", In = "update", Nn = {
            get: function(e1, t) {
                var n = e1[oe];
                return t === oe ? n : "length" === t ? n.getArrayLength_() : "string" != typeof t || isNaN(t) ? Q(Cn, t) ? Cn[t] : e1[t] : n.get_(parseInt(t));
            },
            set: function(e1, t, n) {
                var i = e1[oe];
                return "length" === t && i.setArrayLength_(n), "symbol" == typeof t || isNaN(t) ? e1[t] = n : i.set_(parseInt(t), n), !0;
            },
            preventExtensions: function() {
                M(15);
            }
        }, Dn = function() {
            function e1(e1, t, n, i) {
                void 0 === e1 && (e1 = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = i, this.atom_ = new le(e1), this.enhancer_ = function(e1, n) {
                    return t(e1, n, "ObservableArray[..]");
                };
            }
            var t = e1.prototype;
            return t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.dehanceValues_ = function(e1) {
                return void 0 !== this.dehancer && e1.length > 0 ? e1.map(this.dehancer) : e1;
            }, t.intercept_ = function(e1) {
                return vn(this, e1);
            }, t.observe_ = function(e1, t) {
                return void 0 === t && (t = !1), t && e1({
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: "splice",
                    index: 0,
                    added: this.values_.slice(),
                    addedCount: this.values_.length,
                    removed: [],
                    removedCount: 0
                }), bn(this, e1);
            }, t.getArrayLength_ = function() {
                return this.atom_.reportObserved(), this.values_.length;
            }, t.setArrayLength_ = function(e1) {
                ("number" != typeof e1 || isNaN(e1) || e1 < 0) && M("Out of range: " + e1);
                var t = this.values_.length;
                if (e1 !== t) {
                    if (e1 > t) {
                        for(var n = new Array(e1 - t), i = 0; i < e1 - t; i++)n[i] = void 0;
                        this.spliceWithArray_(t, 0, n);
                    } else this.spliceWithArray_(e1, t - e1);
                }
            }, t.updateArrayLength_ = function(e1, t) {
                e1 !== this.lastKnownLength_ && M(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && ci(e1 + t + 1);
            }, t.spliceWithArray_ = function(e1, t, n) {
                var i = this;
                this.atom_;
                var r = this.values_.length;
                if (void 0 === e1 ? e1 = 0 : e1 > r ? e1 = r : e1 < 0 && (e1 = Math.max(0, r + e1)), t = 1 === arguments.length ? r - e1 : null == t ? 0 : Math.max(0, Math.min(t, r - e1)), void 0 === n && (n = T), Mn(this)) {
                    var a = yn(this, {
                        object: this.proxy_,
                        type: Sn,
                        index: e1,
                        removedCount: t,
                        added: n
                    });
                    if (!a) return T;
                    t = a.removedCount, n = a.added;
                }
                if (n = 0 === n.length ? n : n.map(function(e1) {
                    return i.enhancer_(e1, void 0);
                }), this.legacyMode_) {
                    var s = n.length - t;
                    this.updateArrayLength_(r, s);
                }
                var o = this.spliceItemsIntoValues_(e1, t, n);
                return 0 === t && 0 === n.length || this.notifyArraySplice_(e1, n, o), this.dehanceValues_(o);
            }, t.spliceItemsIntoValues_ = function(e1, t, n) {
                var i;
                if (n.length < 1e4) return (i = this.values_).splice.apply(i, [
                    e1,
                    t
                ].concat(n));
                var r = this.values_.slice(e1, e1 + t), a = this.values_.slice(e1 + t);
                this.values_.length += n.length - t;
                for(var s = 0; s < n.length; s++)this.values_[e1 + s] = n[s];
                for(var o = 0; o < a.length; o++)this.values_[e1 + n.length + o] = a[o];
                return r;
            }, t.notifyArrayChildUpdate_ = function(e1, t, n) {
                var i = !this.owned_ && !1, r = xn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    type: In,
                    debugObjectName: this.atom_.name_,
                    index: e1,
                    newValue: t,
                    oldValue: n
                } : null;
                this.atom_.reportChanged(), r && wn(this, a);
            }, t.notifyArraySplice_ = function(e1, t, n) {
                var i = !this.owned_ && !1, r = xn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: Sn,
                    index: e1,
                    removed: n,
                    added: t,
                    removedCount: n.length,
                    addedCount: t.length
                } : null;
                this.atom_.reportChanged(), r && wn(this, a);
            }, t.get_ = function(e1) {
                if (!(this.legacyMode_ && e1 >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e1]);
                console.warn("[mobx] Out of bounds read: " + e1);
            }, t.set_ = function(e1, t) {
                var n = this.values_;
                if (this.legacyMode_ && e1 > n.length && M(17, e1, n.length), e1 < n.length) {
                    this.atom_;
                    var i = n[e1];
                    if (Mn(this)) {
                        var r = yn(this, {
                            type: In,
                            object: this.proxy_,
                            index: e1,
                            newValue: t
                        });
                        if (!r) return;
                        t = r.newValue;
                    }
                    (t = this.enhancer_(t, i)) !== i && (n[e1] = t, this.notifyArrayChildUpdate_(e1, t, i));
                } else {
                    for(var a = new Array(e1 + 1 - n.length), s = 0; s < a.length - 1; s++)a[s] = void 0;
                    a[a.length - 1] = t, this.spliceWithArray_(n.length, 0, a);
                }
            }, e1;
        }();
        function _n(e1, t, n, i) {
            return void 0 === n && (n = "ObservableArray"), void 0 === i && (i = !1), D(), fi(function() {
                var r = new Dn(n, t, i, !1);
                j(r.values_, oe, r);
                var a = new Proxy(r.values_, Nn);
                return r.proxy_ = a, e1 && e1.length && r.spliceWithArray_(0, 0, e1), a;
            });
        }
        var Cn = {
            clear: function() {
                return this.splice(0);
            },
            replace: function(e1) {
                var t = this[oe];
                return t.spliceWithArray_(0, t.values_.length, e1);
            },
            toJSON: function() {
                return this.slice();
            },
            splice: function(e1, t) {
                for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)i[r - 2] = arguments[r];
                var a = this[oe];
                switch(arguments.length){
                    case 0:
                        return [];
                    case 1:
                        return a.spliceWithArray_(e1);
                    case 2:
                        return a.spliceWithArray_(e1, t);
                }
                return a.spliceWithArray_(e1, t, i);
            },
            spliceWithArray: function(e1, t, n) {
                return this[oe].spliceWithArray_(e1, t, n);
            },
            push: function() {
                for(var e1 = this[oe], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                return e1.spliceWithArray_(e1.values_.length, 0, n), e1.values_.length;
            },
            pop: function() {
                return this.splice(Math.max(this[oe].values_.length - 1, 0), 1)[0];
            },
            shift: function() {
                return this.splice(0, 1)[0];
            },
            unshift: function() {
                for(var e1 = this[oe], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                return e1.spliceWithArray_(0, 0, n), e1.values_.length;
            },
            reverse: function() {
                return Nt.trackingDerivation && M(37, "reverse"), this.replace(this.slice().reverse()), this;
            },
            sort: function() {
                Nt.trackingDerivation && M(37, "sort");
                var e1 = this.slice();
                return e1.sort.apply(e1, arguments), this.replace(e1), this;
            },
            remove: function(e1) {
                var t = this[oe], n = t.dehanceValues_(t.values_).indexOf(e1);
                return n > -1 && (this.splice(n, 1), !0);
            }
        };
        function Ln(e1, t) {
            "function" == typeof Array.prototype[e1] && (Cn[e1] = t(e1));
        }
        function zn(e1) {
            return function() {
                var t = this[oe];
                t.atom_.reportObserved();
                var n = t.dehanceValues_(t.values_);
                return n[e1].apply(n, arguments);
            };
        }
        function On(e1) {
            return function(t, n) {
                var i = this, r = this[oe];
                return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[e1](function(e1, r) {
                    return t.call(n, e1, r, i);
                });
            };
        }
        function Rn(e1) {
            return function() {
                var t = this, n = this[oe];
                n.atom_.reportObserved();
                var i = n.dehanceValues_(n.values_), r = arguments[0];
                return arguments[0] = function(e1, n, i) {
                    return r(e1, n, i, t);
                }, i[e1].apply(i, arguments);
            };
        }
        Ln("at", zn), Ln("concat", zn), Ln("flat", zn), Ln("includes", zn), Ln("indexOf", zn), Ln("join", zn), Ln("lastIndexOf", zn), Ln("slice", zn), Ln("toString", zn), Ln("toLocaleString", zn), Ln("toSorted", zn), Ln("toSpliced", zn), Ln("with", zn), Ln("every", On), Ln("filter", On), Ln("find", On), Ln("findIndex", On), Ln("findLast", On), Ln("findLastIndex", On), Ln("flatMap", On), Ln("forEach", On), Ln("map", On), Ln("some", On), Ln("toReversed", On), Ln("reduce", Rn), Ln("reduceRight", Rn);
        var Pn = k("ObservableArrayAdministration", Dn);
        function Un(e1) {
            return O(e1) && Pn(e1[oe]);
        }
        var jn = {}, kn = "add", Bn = "delete", Fn = function() {
            function e1(e1, t, n) {
                var i = this;
                void 0 === t && (t = de), void 0 === n && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[oe] = jn, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, L(Map) || M(18), fi(function() {
                    i.keysAtom_ = ue("ObservableMap.keys()"), i.data_ = new Map, i.hasMap_ = new Map, e1 && i.merge(e1);
                });
            }
            var t = e1.prototype;
            return t.has_ = function(e1) {
                return this.data_.has(e1);
            }, t.has = function(e1) {
                var t = this;
                if (!Nt.trackingDerivation) return this.has_(e1);
                var n = this.hasMap_.get(e1);
                if (!n) {
                    var i = n = new ct(this.has_(e1), pe, "ObservableMap.key?", !1);
                    this.hasMap_.set(e1, i), en(i, function() {
                        return t.hasMap_.delete(e1);
                    });
                }
                return n.get();
            }, t.set = function(e1, t) {
                var n = this.has_(e1);
                if (Mn(this)) {
                    var i = yn(this, {
                        type: n ? In : kn,
                        object: this,
                        newValue: t,
                        name: e1
                    });
                    if (!i) return this;
                    t = i.newValue;
                }
                return n ? this.updateValue_(e1, t) : this.addValue_(e1, t), this;
            }, t.delete = function(e1) {
                var t = this;
                if (this.keysAtom_, Mn(this) && !yn(this, {
                    type: Bn,
                    object: this,
                    name: e1
                })) return !1;
                if (this.has_(e1)) {
                    var n = xn(this), i = n ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Bn,
                        object: this,
                        oldValue: this.data_.get(e1).value_,
                        name: e1
                    } : null;
                    return gn(function() {
                        var n;
                        t.keysAtom_.reportChanged(), null == (n = t.hasMap_.get(e1)) || n.setNewValue_(!1), t.data_.get(e1).setNewValue_(void 0), t.data_.delete(e1);
                    }), n && wn(this, i), !0;
                }
                return !1;
            }, t.updateValue_ = function(e1, t) {
                var n = this.data_.get(e1);
                if ((t = n.prepareNewValue_(t)) !== Nt.UNCHANGED) {
                    var i = xn(this), r = i ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: In,
                        object: this,
                        oldValue: n.value_,
                        name: e1,
                        newValue: t
                    } : null;
                    n.setNewValue_(t), i && wn(this, r);
                }
            }, t.addValue_ = function(e1, t) {
                var n = this;
                this.keysAtom_, gn(function() {
                    var i, r = new ct(t, n.enhancer_, "ObservableMap.key", !1);
                    n.data_.set(e1, r), t = r.value_, null == (i = n.hasMap_.get(e1)) || i.setNewValue_(!0), n.keysAtom_.reportChanged();
                });
                var i = xn(this), r = i ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: kn,
                    object: this,
                    name: e1,
                    newValue: t
                } : null;
                i && wn(this, r);
            }, t.get = function(e1) {
                return this.has(e1) ? this.dehanceValue_(this.data_.get(e1).get()) : this.dehanceValue_(void 0);
            }, t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.keys = function() {
                return this.keysAtom_.reportObserved(), this.data_.keys();
            }, t.values = function() {
                var e1 = this, t = this.keys();
                return vi({
                    next: function() {
                        var n = t.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : e1.get(r)
                        };
                    }
                });
            }, t.entries = function() {
                var e1 = this, t = this.keys();
                return vi({
                    next: function() {
                        var n = t.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : [
                                r,
                                e1.get(r)
                            ]
                        };
                    }
                });
            }, t[Symbol.iterator] = function() {
                return this.entries();
            }, t.forEach = function(e1, t) {
                for(var n, i = J(this); !(n = i()).done;){
                    var r = n.value, a = r[0], s = r[1];
                    e1.call(t, s, a, this);
                }
            }, t.merge = function(e1) {
                var t = this;
                return Hn(e1) && (e1 = new Map(e1)), gn(function() {
                    var n, i, r;
                    R(e1) ? (function(e1) {
                        var t = Object.keys(e1);
                        if (!H) return t;
                        var n = Object.getOwnPropertySymbols(e1);
                        return n.length ? [].concat(t, n.filter(function(t) {
                            return E.propertyIsEnumerable.call(e1, t);
                        })) : t;
                    })(e1).forEach(function(n) {
                        return t.set(n, e1[n]);
                    }) : Array.isArray(e1) ? e1.forEach(function(e1) {
                        var n = e1[0], i = e1[1];
                        return t.set(n, i);
                    }) : B(e1) ? (n = e1, i = Object.getPrototypeOf(n), r = Object.getPrototypeOf(i), null !== Object.getPrototypeOf(r) && M(19, e1), e1.forEach(function(e1, n) {
                        return t.set(n, e1);
                    })) : null != e1 && M(20, e1);
                }), this;
            }, t.clear = function() {
                var e1 = this;
                gn(function() {
                    vt(function() {
                        for(var t, n = J(e1.keys()); !(t = n()).done;){
                            var i = t.value;
                            e1.delete(i);
                        }
                    });
                });
            }, t.replace = function(e1) {
                var t = this;
                return gn(function() {
                    for(var n, i = function(e1) {
                        if (B(e1) || Hn(e1)) return e1;
                        if (Array.isArray(e1)) return new Map(e1);
                        if (R(e1)) {
                            var t = new Map;
                            for(var n in e1)t.set(n, e1[n]);
                            return t;
                        }
                        return M(21, e1);
                    }(e1), r = new Map, a = !1, s = J(t.data_.keys()); !(n = s()).done;){
                        var o = n.value;
                        if (!i.has(o)) {
                            if (t.delete(o)) a = !0;
                            else {
                                var l = t.data_.get(o);
                                r.set(o, l);
                            }
                        }
                    }
                    for(var c, u = J(i.entries()); !(c = u()).done;){
                        var h = c.value, d = h[0], p = h[1], f = t.data_.has(d);
                        if (t.set(d, p), t.data_.has(d)) {
                            var g = t.data_.get(d);
                            r.set(d, g), f || (a = !0);
                        }
                    }
                    if (!a) {
                        if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
                        else for(var m = t.data_.keys(), A = r.keys(), v = m.next(), y = A.next(); !v.done;){
                            if (v.value !== y.value) {
                                t.keysAtom_.reportChanged();
                                break;
                            }
                            v = m.next(), y = A.next();
                        }
                    }
                    t.data_ = r;
                }), this;
            }, t.toString = function() {
                return "[object ObservableMap]";
            }, t.toJSON = function() {
                return Array.from(this);
            }, t.observe_ = function(e1, t) {
                return bn(this, e1);
            }, t.intercept_ = function(e1) {
                return vn(this, e1);
            }, K(e1, [
                {
                    key: "size",
                    get: function() {
                        return this.keysAtom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Map";
                    }
                }
            ]);
        }(), Hn = k("ObservableMap", Fn), Gn = {}, Vn = function() {
            function e1(e1, t, n) {
                var i = this;
                void 0 === t && (t = de), void 0 === n && (n = "ObservableSet"), this.name_ = void 0, this[oe] = Gn, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, L(Set) || M(22), this.enhancer_ = function(e1, i) {
                    return t(e1, i, n);
                }, fi(function() {
                    i.atom_ = ue(i.name_), e1 && i.replace(e1);
                });
            }
            var t = e1.prototype;
            return t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.clear = function() {
                var e1 = this;
                gn(function() {
                    vt(function() {
                        for(var t, n = J(e1.data_.values()); !(t = n()).done;){
                            var i = t.value;
                            e1.delete(i);
                        }
                    });
                });
            }, t.forEach = function(e1, t) {
                for(var n, i = J(this); !(n = i()).done;){
                    var r = n.value;
                    e1.call(t, r, r, this);
                }
            }, t.add = function(e1) {
                var t = this;
                if (this.atom_, Mn(this) && !yn(this, {
                    type: kn,
                    object: this,
                    newValue: e1
                })) return this;
                if (!this.has(e1)) {
                    gn(function() {
                        t.data_.add(t.enhancer_(e1, void 0)), t.atom_.reportChanged();
                    });
                    var n = xn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: kn,
                        object: this,
                        newValue: e1
                    } : null;
                    n && wn(this, i);
                }
                return this;
            }, t.delete = function(e1) {
                var t = this;
                if (Mn(this) && !yn(this, {
                    type: Bn,
                    object: this,
                    oldValue: e1
                })) return !1;
                if (this.has(e1)) {
                    var n = xn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Bn,
                        object: this,
                        oldValue: e1
                    } : null;
                    return gn(function() {
                        t.atom_.reportChanged(), t.data_.delete(e1);
                    }), n && wn(this, i), !0;
                }
                return !1;
            }, t.has = function(e1) {
                return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e1));
            }, t.entries = function() {
                var e1 = 0, t = Array.from(this.keys()), n = Array.from(this.values());
                return vi({
                    next: function() {
                        var i = e1;
                        return e1 += 1, i < n.length ? {
                            value: [
                                t[i],
                                n[i]
                            ],
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, t.keys = function() {
                return this.values();
            }, t.values = function() {
                this.atom_.reportObserved();
                var e1 = this, t = 0, n = Array.from(this.data_.values());
                return vi({
                    next: function() {
                        return t < n.length ? {
                            value: e1.dehanceValue_(n[t++]),
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, t.intersection = function(e1) {
                return F(e1) ? e1.intersection(this) : new Set(this).intersection(e1);
            }, t.union = function(e1) {
                return F(e1) ? e1.union(this) : new Set(this).union(e1);
            }, t.difference = function(e1) {
                return new Set(this).difference(e1);
            }, t.symmetricDifference = function(e1) {
                return F(e1) ? e1.symmetricDifference(this) : new Set(this).symmetricDifference(e1);
            }, t.isSubsetOf = function(e1) {
                return new Set(this).isSubsetOf(e1);
            }, t.isSupersetOf = function(e1) {
                return new Set(this).isSupersetOf(e1);
            }, t.isDisjointFrom = function(e1) {
                return F(e1) ? e1.isDisjointFrom(this) : new Set(this).isDisjointFrom(e1);
            }, t.replace = function(e1) {
                var t = this;
                return Qn(e1) && (e1 = new Set(e1)), gn(function() {
                    Array.isArray(e1) || F(e1) ? (t.clear(), e1.forEach(function(e1) {
                        return t.add(e1);
                    })) : null != e1 && M("Cannot initialize set from " + e1);
                }), this;
            }, t.observe_ = function(e1, t) {
                return bn(this, e1);
            }, t.intercept_ = function(e1) {
                return vn(this, e1);
            }, t.toJSON = function() {
                return Array.from(this);
            }, t.toString = function() {
                return "[object ObservableSet]";
            }, t[Symbol.iterator] = function() {
                return this.values();
            }, K(e1, [
                {
                    key: "size",
                    get: function() {
                        return this.atom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Set";
                    }
                }
            ]);
        }(), Qn = k("ObservableSet", Vn), Wn = Object.create(null), Yn = "remove", Xn = function() {
            function e1(e1, t, n, i) {
                void 0 === t && (t = new Map), void 0 === i && (i = Oe), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = e1, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = i, this.keysAtom_ = new le("ObservableObject.keys"), this.isPlainObject_ = R(this.target_);
            }
            var t = e1.prototype;
            return t.getObservablePropValue_ = function(e1) {
                return this.values_.get(e1).get();
            }, t.setObservablePropValue_ = function(e1, t) {
                var n = this.values_.get(e1);
                if (n instanceof ut) return n.set(t), !0;
                if (Mn(this)) {
                    var i = yn(this, {
                        type: In,
                        object: this.proxy_ || this.target_,
                        name: e1,
                        newValue: t
                    });
                    if (!i) return null;
                    t = i.newValue;
                }
                if ((t = n.prepareNewValue_(t)) !== Nt.UNCHANGED) {
                    var r = xn(this), a = r ? {
                        type: In,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        oldValue: n.value_,
                        name: e1,
                        newValue: t
                    } : null;
                    n.setNewValue_(t), r && wn(this, a);
                }
                return !0;
            }, t.get_ = function(e1) {
                return Nt.trackingDerivation && !Q(this.target_, e1) && this.has_(e1), this.target_[e1];
            }, t.set_ = function(e1, t, n) {
                return void 0 === n && (n = !1), Q(this.target_, e1) ? this.values_.has(e1) ? this.setObservablePropValue_(e1, t) : n ? Reflect.set(this.target_, e1, t) : (this.target_[e1] = t, !0) : this.extend_(e1, {
                    value: t,
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                }, this.defaultAnnotation_, n);
            }, t.has_ = function(e1) {
                if (!Nt.trackingDerivation) return e1 in this.target_;
                this.pendingKeys_ || (this.pendingKeys_ = new Map);
                var t = this.pendingKeys_.get(e1);
                return t || (t = new ct(e1 in this.target_, pe, "ObservableObject.key?", !1), this.pendingKeys_.set(e1, t)), t.get();
            }, t.make_ = function(e1, t) {
                if (!0 === t && (t = this.defaultAnnotation_), !1 !== t) {
                    if (!(e1 in this.target_)) {
                        var n;
                        if (null != (n = this.target_[ie]) && n[e1]) return;
                        M(1, t.annotationType_, this.name_ + "." + e1.toString());
                    }
                    for(var i = this.target_; i && i !== E;){
                        var r = b(i, e1);
                        if (r) {
                            var a = t.make_(this, e1, r, i);
                            if (0 === a) return;
                            if (1 === a) break;
                        }
                        i = Object.getPrototypeOf(i);
                    }
                    $n(this, 0, e1);
                }
            }, t.extend_ = function(e1, t, n, i) {
                if (void 0 === i && (i = !1), !0 === n && (n = this.defaultAnnotation_), !1 === n) return this.defineProperty_(e1, t, i);
                var r = n.extend_(this, e1, t, i);
                return r && $n(this, 0, e1), r;
            }, t.defineProperty_ = function(e1, t, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    Ct();
                    var i = this.delete_(e1);
                    if (!i) return i;
                    if (Mn(this)) {
                        var r = yn(this, {
                            object: this.proxy_ || this.target_,
                            name: e1,
                            type: kn,
                            newValue: t.value
                        });
                        if (!r) return null;
                        var a = r.newValue;
                        t.value !== a && (t = $({}, t, {
                            value: a
                        }));
                    }
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, e1, t)) return !1;
                    } else w(this.target_, e1, t);
                    this.notifyPropertyAddition_(e1, t.value);
                } finally{
                    Lt();
                }
                return !0;
            }, t.defineObservableProperty_ = function(e1, t, n, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    Ct();
                    var r = this.delete_(e1);
                    if (!r) return r;
                    if (Mn(this)) {
                        var a = yn(this, {
                            object: this.proxy_ || this.target_,
                            name: e1,
                            type: kn,
                            newValue: t
                        });
                        if (!a) return null;
                        t = a.newValue;
                    }
                    var s = Kn(e1), o = {
                        configurable: !Nt.safeDescriptors || this.isPlainObject_,
                        enumerable: !0,
                        get: s.get,
                        set: s.set
                    };
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, e1, o)) return !1;
                    } else w(this.target_, e1, o);
                    var l = new ct(t, n, "ObservableObject.key", !1);
                    this.values_.set(e1, l), this.notifyPropertyAddition_(e1, l.value_);
                } finally{
                    Lt();
                }
                return !0;
            }, t.defineComputedProperty_ = function(e1, t, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    Ct();
                    var i = this.delete_(e1);
                    if (!i) return i;
                    if (Mn(this) && !yn(this, {
                        object: this.proxy_ || this.target_,
                        name: e1,
                        type: kn,
                        newValue: void 0
                    })) return null;
                    t.name || (t.name = "ObservableObject.key"), t.context = this.proxy_ || this.target_;
                    var r = Kn(e1), a = {
                        configurable: !Nt.safeDescriptors || this.isPlainObject_,
                        enumerable: !1,
                        get: r.get,
                        set: r.set
                    };
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, e1, a)) return !1;
                    } else w(this.target_, e1, a);
                    this.values_.set(e1, new ut(t)), this.notifyPropertyAddition_(e1, void 0);
                } finally{
                    Lt();
                }
                return !0;
            }, t.delete_ = function(e1, t) {
                if (void 0 === t && (t = !1), this.keysAtom_, !Q(this.target_, e1)) return !0;
                if (Mn(this) && !yn(this, {
                    object: this.proxy_ || this.target_,
                    name: e1,
                    type: Yn
                })) return null;
                try {
                    var n;
                    Ct();
                    var i, r = xn(this), a = this.values_.get(e1), s = void 0;
                    if (!a && r && (s = null == (i = b(this.target_, e1)) ? void 0 : i.value), t) {
                        if (!Reflect.deleteProperty(this.target_, e1)) return !1;
                    } else delete this.target_[e1];
                    if (a && (this.values_.delete(e1), a instanceof ct && (s = a.value_), Ot(a)), this.keysAtom_.reportChanged(), null == (n = this.pendingKeys_) || null == (n = n.get(e1)) || n.set(e1 in this.target_), r) {
                        var o = {
                            type: Yn,
                            observableKind: "object",
                            object: this.proxy_ || this.target_,
                            debugObjectName: this.name_,
                            oldValue: s,
                            name: e1
                        };
                        r && wn(this, o);
                    }
                } finally{
                    Lt();
                }
                return !0;
            }, t.observe_ = function(e1, t) {
                return bn(this, e1);
            }, t.intercept_ = function(e1) {
                return vn(this, e1);
            }, t.notifyPropertyAddition_ = function(e1, t) {
                var n, i = xn(this);
                if (i) {
                    var r = i ? {
                        type: kn,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        name: e1,
                        newValue: t
                    } : null;
                    i && wn(this, r);
                }
                null == (n = this.pendingKeys_) || null == (n = n.get(e1)) || n.set(!0), this.keysAtom_.reportChanged();
            }, t.ownKeys_ = function() {
                return this.keysAtom_.reportObserved(), G(this.target_);
            }, t.keys_ = function() {
                return this.keysAtom_.reportObserved(), Object.keys(this.target_);
            }, e1;
        }();
        function Zn(e1, t) {
            var n;
            if (Q(e1, oe)) return e1;
            var i = null != (n = null == t ? void 0 : t.name) ? n : "ObservableObject", r = new Xn(e1, new Map, String(i), function(e1) {
                var t;
                return e1 ? null != (t = e1.defaultDecorator) ? t : Re(e1) : void 0;
            }(t));
            return U(e1, oe, r), e1;
        }
        var qn = k("ObservableObjectAdministration", Xn);
        function Kn(e1) {
            return Wn[e1] || (Wn[e1] = {
                get: function() {
                    return this[oe].getObservablePropValue_(e1);
                },
                set: function(t) {
                    return this[oe].setObservablePropValue_(e1, t);
                }
            });
        }
        function Jn(e1) {
            return !!O(e1) && qn(e1[oe]);
        }
        function $n(e1, t, n) {
            var i;
            null == (i = e1.target_[ie]) || delete i[n];
        }
        var ei, ti, ni = oi(0), ii = function() {
            var e1 = !1, t = {};
            return Object.defineProperty(t, "0", {
                set: function() {
                    e1 = !0;
                }
            }), Object.create(t)[0] = 1, !1 === e1;
        }(), ri = 0, ai = function() {};
        ei = ai, ti = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(ei.prototype, ti) : void 0 !== ei.prototype.__proto__ ? ei.prototype.__proto__ = ti : ei.prototype = ti;
        var si = function(e1) {
            function t(t, n, i, r) {
                var a;
                return void 0 === i && (i = "ObservableArray"), void 0 === r && (r = !1), a = e1.call(this) || this, fi(function() {
                    var e1 = new Dn(i, n, r, !0);
                    e1.proxy_ = a, j(a, oe, e1), t && t.length && a.spliceWithArray(0, 0, t), ii && Object.defineProperty(a, "0", ni);
                }), a;
            }
            ee(t, e1);
            var n = t.prototype;
            return n.concat = function() {
                this[oe].atom_.reportObserved();
                for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                return Array.prototype.concat.apply(this.slice(), t.map(function(e1) {
                    return Un(e1) ? e1.slice() : e1;
                }));
            }, n[Symbol.iterator] = function() {
                var e1 = this, t = 0;
                return vi({
                    next: function() {
                        return t < e1.length ? {
                            value: e1[t++],
                            done: !1
                        } : {
                            done: !0,
                            value: void 0
                        };
                    }
                });
            }, K(t, [
                {
                    key: "length",
                    get: function() {
                        return this[oe].getArrayLength_();
                    },
                    set: function(e1) {
                        this[oe].setArrayLength_(e1);
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Array";
                    }
                }
            ]);
        }(ai);
        function oi(e1) {
            return {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this[oe].get_(e1);
                },
                set: function(t) {
                    this[oe].set_(e1, t);
                }
            };
        }
        function li(e1) {
            w(si.prototype, "" + e1, oi(e1));
        }
        function ci(e1) {
            if (e1 > ri) {
                for(var t = ri; t < e1 + 100; t++)li(t);
                ri = e1;
            }
        }
        function ui(e1, t, n) {
            return new si(e1, t, n);
        }
        function hi(e1, t) {
            if ("object" == typeof e1 && null !== e1) {
                if (Un(e1)) return void 0 !== t && M(23), e1[oe].atom_;
                if (Qn(e1)) return e1.atom_;
                if (Hn(e1)) {
                    if (void 0 === t) return e1.keysAtom_;
                    var n = e1.data_.get(t) || e1.hasMap_.get(t);
                    return n || M(25, t, pi(e1)), n;
                }
                if (Jn(e1)) {
                    if (!t) return M(26);
                    var i = e1[oe].values_.get(t);
                    return i || M(27, t, pi(e1)), i;
                }
                if (ce(e1) || pt(e1) || Bt(e1)) return e1;
            } else if (L(e1) && Bt(e1[oe])) return e1[oe];
            M(28);
        }
        function di(e1, t) {
            return e1 || M(29), void 0 !== t ? di(hi(e1, t)) : ce(e1) || pt(e1) || Bt(e1) || Hn(e1) || Qn(e1) ? e1 : e1[oe] ? e1[oe] : void M(24, e1);
        }
        function pi(e1, t) {
            var n;
            if (void 0 !== t) n = hi(e1, t);
            else {
                if (qt(e1)) return e1.name;
                n = Jn(e1) || Hn(e1) || Qn(e1) ? di(e1) : hi(e1);
            }
            return n.name_;
        }
        function fi(e1) {
            var t = yt(), n = ot(!0);
            Ct();
            try {
                return e1();
            } finally{
                Lt(), lt(n), xt(t);
            }
        }
        Object.entries(Cn).forEach(function(e1) {
            var t = e1[0], n = e1[1];
            "concat" !== t && U(si.prototype, t, n);
        }), ci(1e3);
        var gi = E.toString;
        function mi(e1, t, n) {
            return void 0 === n && (n = -1), Ai(e1, t, n);
        }
        function Ai(e1, t, n, i, r) {
            if (e1 === t) return 0 !== e1 || 1 / e1 == 1 / t;
            if (null == e1 || null == t) return !1;
            if (e1 != e1) return t != t;
            var a = typeof e1;
            if ("function" !== a && "object" !== a && "object" != typeof t) return !1;
            var s = gi.call(e1);
            if (s !== gi.call(t)) return !1;
            switch(s){
                case "[object RegExp]":
                case "[object String]":
                    return "" + e1 == "" + t;
                case "[object Number]":
                    return +e1 != +e1 ? +t != +t : 0 == +e1 ? 1 / +e1 == 1 / t : +e1 == +t;
                case "[object Date]":
                case "[object Boolean]":
                    return +e1 == +t;
                case "[object Symbol]":
                    return "undefined" != typeof Symbol && Symbol.valueOf.call(e1) === Symbol.valueOf.call(t);
                case "[object Map]":
                case "[object Set]":
                    n >= 0 && n++;
            }
            e1 = Mi(e1), t = Mi(t);
            var o = "[object Array]" === s;
            if (!o) {
                if ("object" != typeof e1 || "object" != typeof t) return !1;
                var l = e1.constructor, c = t.constructor;
                if (l !== c && !(L(l) && l instanceof l && L(c) && c instanceof c) && "constructor" in e1 && "constructor" in t) return !1;
            }
            if (0 === n) return !1;
            n < 0 && (n = -1), r = r || [];
            for(var u = (i = i || []).length; u--;)if (i[u] === e1) return r[u] === t;
            if (i.push(e1), r.push(t), o) {
                if ((u = e1.length) !== t.length) return !1;
                for(; u--;)if (!Ai(e1[u], t[u], n - 1, i, r)) return !1;
            } else {
                var h, d = Object.keys(e1);
                if (u = d.length, Object.keys(t).length !== u) return !1;
                for(; u--;)if (!Q(t, h = d[u]) || !Ai(e1[h], t[h], n - 1, i, r)) return !1;
            }
            return i.pop(), r.pop(), !0;
        }
        function Mi(e1) {
            return Un(e1) ? e1.slice() : B(e1) || Hn(e1) || F(e1) || Qn(e1) ? Array.from(e1.entries()) : e1;
        }
        function vi(e1) {
            return e1[Symbol.iterator] = yi, e1;
        }
        function yi() {
            return this;
        }
        [
            "Symbol",
            "Map",
            "Set"
        ].forEach(function(e1) {
            void 0 === y()[e1] && M("MobX requires global '" + e1 + "' to be available or polyfilled");
        }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
            spy: function(e1) {
                return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
            },
            extras: {
                getDebugName: pi
            },
            $mobx: oe
        });
        var xi = n(834);
        const bi = JSON.parse('{"create-points":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","delete-points":"\u0423\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","research-plan":"\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","rotate-plan":"\u0412\u0440\u0430\u0449\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","ok":"Ok","ruler-ok":"Ok","made-by-link":"https://hart-estate.ru/","made-by-text":"hart-estate.ru","instructions-hint-text":"","floor":"$0 \u044D\u0442\u0430\u0436","titleNotFoundPage":"404 \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430","subtitleNotFoundPage":"\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u044D\u0442\u0430 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.","titleServerErrorPage":"500 \u0412\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430","subtitleServerErrorPage":"\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435, \u0438 \u043C\u044B \u043D\u0435 \u0441\u043C\u043E\u0433\u043B\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438\u043B\u0438 \u0432\u0435\u0440\u043D\u0438\u0442\u0435\u0441\u044C \u043F\u043E\u0437\u0436\u0435."}'), wi = JSON.parse('{"create-points":"Create a point","delete-points":"Remove point","research-plan":"Research plan","rotate-plan":"Rotate plan","ok":"Ok","ruler-ok":"Ok","made-by-link":"https://getfloorplan.com/","made-by-text":"getfloorplan.com","instructions-hint-text":"","floor":"$0 floor","floorNumberEndings":{"1":"1st","2":"2nd","3":"3d","rest":"th"},"titleNotFoundPage":"404 Page Not Found","subtitleNotFoundPage":"Unfortunately, this layout could not be found. Please try a different link or return to the homepage.","titleServerErrorPage":"500 Internal Server Error","subtitleServerErrorPage":"An error occurred on the server, and we were unable to load the layout. Please try refreshing the page or come back later."}'), Ei = JSON.parse('{"research-plan":"klicken","rotate-plan":"drehen","ok":"Ok","ruler-ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 boden","floorNumberEndings":{"rest":""}}'), Ti = JSON.parse('{"research-plan":"Explora el dise\xf1o","rotate-plan":"Girar dise\xf1o","rotate":"Comenzar","stop":"Detener","plan":"Disposici\xf3n","off":"Apagar","on":"Encender","ok":"Ok","ruler-ok":"Ok","menu":"Men\xfa","wasd":"WASD","view-from-above":"Vista desde arriba","free-camera":"Revisi\xf3n gratuita","shadows":"Oscuridad","hide-walls":"Ocultar paredes","show-walls":"Mostrar paredes","hide-doors":"Ocultar puertas","show-doors":"Mostrar puertas","material":"Material","texture":"Textura","color":"Color","wall-color":"Color de la pared","wall-texture":"Textura de la pared","upload-wall-texture":"Textura de la pared de carga","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 piso"}'), Si = JSON.parse('{"create-points":"\u8A08\u6E2C\u958B\u59CB","delete-points":"\u78BA\u5B9A","research-plan":"\u30BF\u30C3\u30D7\u3057\u3066\u79FB\u52D5","rotate-plan":"\u30C9\u30E9\u30C3\u30B0\u3067\u79FB\u52D5","ok":"Ok","ruler-ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 \u968E"}');
        function Ii(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const Ni = new class {
            constructor(){
                Ii(this, "availableLocales", [
                    "ru",
                    "en",
                    "de",
                    "es",
                    "ja"
                ]), Ii(this, "locales", {
                    ru: bi,
                    en: wi,
                    de: Ei,
                    es: Ti,
                    ja: Si
                }), Ii(this, "currentLocale", "en"), Ii(this, "getLocaleText", (e1)=>this.localeData[e1]), Ii(this, "setCurrentLocale", (e1)=>{
                    this.availableLocales.some((t)=>t === e1) && (this.currentLocale = e1);
                }), Tn(this);
            }
            get localeData() {
                return this.locales[this.currentLocale];
            }
        }, Di = Ni;
        function _i(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const Ci = new class {
            constructor(){
                _i(this, "controlsVisible", !0), _i(this, "currentFloorIndex", 0), _i(this, "configParams", null), _i(this, "isPanoramaTourReady", !1), _i(this, "listeners", {
                    resize: []
                }), Tn(this);
            }
            get primaryCameraPointId() {
                if (!this.config.json) return null;
                const e1 = this.config.json.Floors[this.currentFloorIndex];
                if (this.config.primaryCameraPointId && e1.CameraPoints.some((e1)=>{
                    let { ID: t } = e1;
                    return t === this.config.primaryCameraPointId;
                })) return this.config.primaryCameraPointId;
                const t = e1.PrimaryCameraPointId || null, n = this.config.json.Meta?.PrimaryCameraPointId || null;
                return t || n;
            }
            get initialPanoramaRoomId() {
                if (!this.config.json) return null;
                const { Rooms: e1 } = this.config.json.Floors[this.currentFloorIndex].Units[0], t = [
                    ...e1
                ].sort((e1, t)=>t.Area - e1.Area), n = t.find((e1)=>{
                    let { Type: t } = e1;
                    return "Living" === t;
                }), i = t[0];
                return n?.ID || i?.ID || null;
            }
            get config() {
                return this.getFloorConfig(this.currentFloorIndex);
            }
            get prevFloorIndex() {
                const e1 = this.currentFloorIndex - 1;
                return e1 < 0 ? this.configParams.floors.length - 1 : e1;
            }
            get nextFloorIndex() {
                return (this.currentFloorIndex + 1) % this.configParams.floors.length;
            }
            get dictionaryOverrides() {
                return this.configParams?.dictionaryOverrides ?? {};
            }
            get autoRotatePanarama() {
                return this.configParams.autoRotate;
            }
            get instructionVisible() {
                return this.configParams.instructionVisible;
            }
            get scales() {
                return this.config.scales;
            }
            get isMultiFloor() {
                return this.config.floors.length > 1;
            }
            getFloorConfig(e1) {
                const t = this.getFloorParamByKey("original_plan_img", e1), n = this.getFloorParamByKey("styled_plan_img", e1), i = this.getFloorParamByKey("original_plans_img", e1), r = this.getFloorParamByKey("top_view_img", e1), a = this.getFloorParamByKey("panorama", e1), s = this.getFloorParamByKey("rotate", e1);
                return {
                    ...this.configParams,
                    originalPlans: i,
                    planImage: n || t,
                    rotationData: s,
                    panoramaData: a,
                    topViewImage: r
                };
            }
            setCurrentFloorIndex(e1) {
                this.currentFloorIndex = e1;
            }
            setPrevFloorIndex() {
                this.setCurrentFloorIndex(this.prevFloorIndex);
            }
            setNextFloorIndex() {
                this.setCurrentFloorIndex(this.nextFloorIndex);
            }
            setPanoramaTourReady() {
                this.isPanoramaTourReady || (this.isPanoramaTourReady = !0, performance.mark("panorama tour is ready"));
            }
            getFloorParamByKey(e1, t) {
                const n = this.configParams?.floors?.[t];
                return n ? n[e1] : null;
            }
            isTabIncluded(e1) {
                return this.config.tabs.find((t)=>t === e1);
            }
            setConfig(e1) {
                this.configParams = e1, Di.setCurrentLocale(e1.locale), this.dispatchEvent("resize", {
                    width: e1.width,
                    height: e1.height
                });
            }
            hideControls() {
                this.controlsVisible = !1;
            }
            showControls() {
                this.controlsVisible = !0;
            }
            addEventListener(e1, t) {
                this.listeners[e1] && this.listeners[e1].push(t);
            }
            dispatchEvent(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.listeners[e1] && this.listeners[e1].forEach((e1)=>e1(t));
            }
        }, Li = 3.280839895, zi = (e1)=>{
            e1.preventDefault();
        }, Oi = async (e1)=>{
            const t = new Promise((t)=>{
                const n = new Image;
                n.onload = ()=>t(n), n.src = e1;
            });
            return await t;
        }, Ri = (e1, t, n, i, r, a)=>{
            let s = a;
            i < 2 * s && (s = i / 2), r < 2 * a && (s = r / 2), e1.beginPath(), e1.moveTo(t + s, n), e1.arcTo(t + i, n, t + i, n + r, s), e1.arcTo(t + i, n + r, t, n + r, s), e1.arcTo(t, n + r, t, n, s), e1.arcTo(t, n, t + i, n, s), e1.closePath();
        }, Pi = function(e1) {
            let t = Ci.dictionaryOverrides?.[e1] ?? Di.getLocaleText(e1);
            for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)i[r - 1] = arguments[r];
            return Ci.config.floorNumberEndingsVisible && "floor" === e1 ? i.reduce((e1, t, n)=>e1.replaceAll(`$${n}`, ((e1)=>Ci.dictionaryOverrides?.floorNumberEndings?.[e1] ? Ci.dictionaryOverrides.floorNumberEndings[e1] : Di.getLocaleText("floorNumberEndings")[e1] ?? e1 + Di.getLocaleText("floorNumberEndings").rest)(t)), t) : i.reduce((e1, t, n)=>e1.replaceAll(`$${n}`, t), t);
        }, Ui = (e1)=>{
            const t = Math.floor(e1 * Li), n = 12 * (e1 * Li - t);
            return `${t}'${Math.round(n)}"`;
        }, ji = function(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 100;
            return new Promise((i)=>{
                const r = setInterval(()=>{
                    e1() || (clearInterval(r), i(t));
                }, n);
            });
        }, ki = (e1)=>{
            let { errorType: n } = e1;
            const i = {
                404: {
                    title: Pi("titleNotFoundPage"),
                    subtitle: Pi("subtitleNotFoundPage"),
                    image: "data:image/png;base64,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"
                },
                500: {
                    title: Pi("titleServerErrorPage"),
                    subtitle: Pi("subtitleServerErrorPage"),
                    image: "data:image/png;base64,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"
                }
            }, { title: r, subtitle: a, image: s } = i[n] || i[500];
            return t.createElement("div", {
                className: "widget-error-page"
            }, t.createElement("div", {
                className: "widget-error-page-left"
            }, t.createElement("h1", {
                className: "widget-error-page-title"
            }, r), t.createElement("p", {
                className: "widget-error-page-subtitle"
            }, a)), t.createElement("img", {
                src: s,
                alt: "Error img"
            }));
        };
        function Bi(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const Fi = class {
            constructor(e1){
                Bi(this, "API_URL", null), Bi(this, "getBrandingData", (e1)=>e1 ? {
                        name: e1.company_name,
                        url: e1.company_url
                    } : null), Bi(this, "getParsedData", async (e1)=>{
                    const t = await this.loadJson(e1.json.value), n = this.getBrandingData(e1.widget_branding), i = e1.original_plans_img || [], r = e1.styled_plan_img || [], a = e1.floors.map((e1, t)=>({
                            ...e1,
                            original_plan_img: r[t] ?? i[t] ?? null
                        })), s = e1.capabilities;
                    return {
                        raw: e1,
                        parsed: {
                            locale: e1.widget_branding?.widget_language || "en",
                            logo: e1.widget_branding?.logo_path || null,
                            floors: a,
                            branding: n,
                            json: t,
                            capabilities: s
                        }
                    };
                }), Bi(this, "loadFurnitureData", async ()=>{
                    const e1 = `${this.API_URL}/api/furniture`, t = await fetch(e1);
                    return await t.json();
                }), Bi(this, "loadCrmWidgetData", async (e1)=>{
                    if (!e1) return null;
                    const t = `${this.API_URL}/api/crm/plans/${e1}/widget`, n = {
                        "Widget-Version": "3.7.3"
                    };
                    try {
                        const e1 = await fetch(t, {
                            headers: n
                        });
                        if (!e1.ok) return e1.status >= 500 ? this.showServerErrorPage() : this.showNotFoundPage(), null;
                        const i = await e1.json();
                        return this.getParsedData(i);
                    } catch (e1) {
                        return this.showServerErrorPage(), null;
                    }
                }), Bi(this, "loadWidgetData", async (e1)=>{
                    const t = `${this.API_URL}/api/plans/${e1}/v3/widget`, n = {
                        "Widget-Version": "3.7.3"
                    };
                    try {
                        const e1 = await fetch(t, {
                            headers: n
                        });
                        if (!e1.ok) return e1.status >= 500 ? this.showServerErrorPage() : this.showNotFoundPage(), null;
                        const i = await e1.json();
                        return this.getParsedData(i);
                    } catch (e1) {
                        return this.showServerErrorPage(), null;
                    }
                }), Bi(this, "showNotFoundPage", ()=>{
                    const e1 = document.querySelector(".widget-container");
                    xi.render(t.createElement(ki, {
                        errorType: "404"
                    }), e1);
                }), Bi(this, "showServerErrorPage", ()=>{
                    const e1 = document.querySelector(".widget-container");
                    xi.render(t.createElement(ki, {
                        errorType: "500"
                    }), e1);
                }), Bi(this, "loadEditorData", async (e1, t)=>{
                    const n = `${this.API_URL}/api/plans/${e1}/editor?token=${t}`, i = await fetch(n);
                    return await i.json();
                }), Bi(this, "loadPanoramaData", async (e1)=>{
                    const t = `${this.API_URL}/api/plans/${e1}/panorama`, n = await fetch(t);
                    return await n.json();
                }), Bi(this, "loadJson", async (e1)=>{
                    const t = await fetch(e1);
                    return await t.json();
                }), Tn(this), this.API_URL = e1;
            }
        }, Hi = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ], Gi = (()=>{
            if ("undefined" == typeof document) return !1;
            const e1 = Hi[0], t = {};
            for (const n of Hi){
                const i = n?.[1];
                if (i in document) {
                    for (const [i, r] of n.entries())t[e1[i]] = r;
                    return t;
                }
            }
            return !1;
        })(), Vi = {
            change: Gi.fullscreenchange,
            error: Gi.fullscreenerror
        };
        let Qi = {
            request () {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.documentElement, t = arguments.length > 1 ? arguments[1] : void 0;
                return new Promise((n, i)=>{
                    const r = ()=>{
                        Qi.off("change", r), n();
                    };
                    Qi.on("change", r);
                    const a = e1[Gi.requestFullscreen](t);
                    a instanceof Promise && a.then(r).catch(i);
                });
            },
            exit: ()=>new Promise((e1, t)=>{
                    if (!Qi.isFullscreen) return void e1();
                    const n = ()=>{
                        Qi.off("change", n), e1();
                    };
                    Qi.on("change", n);
                    const i = document[Gi.exitFullscreen]();
                    i instanceof Promise && i.then(n).catch(t);
                }),
            toggle: (e1, t)=>Qi.isFullscreen ? Qi.exit() : Qi.request(e1, t),
            onchange (e1) {
                Qi.on("change", e1);
            },
            onerror (e1) {
                Qi.on("error", e1);
            },
            on (e1, t) {
                const n = Vi[e1];
                n && document.addEventListener(n, t, !1);
            },
            off (e1, t) {
                const n = Vi[e1];
                n && document.removeEventListener(n, t, !1);
            },
            raw: Gi
        };
        Object.defineProperties(Qi, {
            isFullscreen: {
                get: ()=>Boolean(document[Gi.fullscreenElement])
            },
            element: {
                enumerable: !0,
                get: ()=>document[Gi.fullscreenElement] ?? void 0
            },
            isEnabled: {
                enumerable: !0,
                get: ()=>Boolean(document[Gi.fullscreenEnabled])
            }
        }), Gi || (Qi = {
            isEnabled: !1
        });
        const Wi = Qi;
        function Yi(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const Xi = new class {
            constructor(){
                Yi(this, "enabled", Wi.isEnabled), Yi(this, "active", !1), Yi(this, "element", null), Yi(this, "width", null), Yi(this, "height", null), Tn(this);
            }
            init() {
                this.element = document.querySelector("#widget-application"), this.enabled && (this.resize(Ci.config), Wi.on("change", ()=>{
                    setTimeout(()=>{
                        this.active = Wi.isFullscreen, this.active ? Ci.setConfig({
                            ...Ci.config,
                            width: window.innerWidth,
                            height: window.innerHeight
                        }) : Ci.setConfig({
                            ...Ci.config,
                            width: this.width,
                            height: this.height
                        });
                    }, 100);
                }));
            }
            async enter() {
                return await Wi.request(this.element);
            }
            async exit() {
                return await Wi.exit();
            }
            resize(e1) {
                let { width: t, height: n } = e1;
                this.width = t, this.height = n;
            }
        }, Zi = Xi, qi = {
            DEFAULT: 0,
            THREESIXTY: 1
        }, Ki = {
            tabs: [
                "rotation",
                "area",
                "panorama"
            ],
            logo: null,
            logoUrl: null,
            width: 1920,
            height: 1080,
            resizable: !0,
            rotationMode: qi.DEFAULT,
            floors: [],
            panoramaFov: 75,
            preloadPerPanoramaCount: 3,
            forcePreloadNonCached: !0,
            enablePreloadMasks: !0,
            forceTopViewOnMap: !1,
            topViewResolutionUpscale: 2,
            enableCameraTransitionBetweenPanoramas: !1,
            enableCameraRotationBetweenPanoramas: !0,
            primaryCameraPointId: null,
            json: null,
            locale: "en",
            API_URL: "https://backend.estate.hart-digital.com",
            branding: null,
            colors: {
                main: "#FFA900",
                mainText: "#413E3E"
            },
            panoramaIcons: {
                spot: "data:image/png;base64,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",
                interactiveSpot: "data:image/png;base64,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",
                door: "data:image/png;base64,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"
            },
            dictionaryOverrides: null,
            instructionVisible: !0,
            autoRotate: !1,
            scales: [
                "x1",
                "x05"
            ],
            enableGyroscope: !0,
            scaleButtonType: "img",
            availableRotationSteps: [
                "carousel",
                "plan",
                "topView"
            ],
            floorNumberEndingsVisible: !1,
            designType: "sidebar",
            bottombarContent: [
                "scale",
                "rotation",
                "furniture"
            ],
            sidebarContent: [
                "floors",
                "ruler"
            ],
            tabsButtonsDesign: "three",
            enablePointHoverVisibility: !1,
            enableDoorVisibility: !1,
            pointHoverScale: 1,
            cursorType: "pointer",
            enableCursorPulse: !0,
            integrations: {},
            movementType: "interroom",
            defaultLinkOptions: {},
            fadeOptions: {},
            rulerOptions: {},
            linkOptions: {}
        }, Ji = Ki, $i = "158", er = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
        }, tr = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
        }, nr = 0, ir = 1, rr = 2, ar = 3, sr = 0, or = 1, lr = 2, cr = 3, ur = 0, hr = 1, dr = 2, pr = 2, fr = 0, gr = 1, mr = 2, Ar = 3, Mr = 4, vr = 5, yr = 100, xr = 101, br = 102, wr = 103, Er = 104, Tr = 200, Sr = 201, Ir = 202, Nr = 203, Dr = 204, _r = 205, Cr = 206, Lr = 207, zr = 208, Or = 209, Rr = 210, Pr = 211, Ur = 212, jr = 213, kr = 214, Br = 0, Fr = 1, Hr = 2, Gr = 3, Vr = 4, Qr = 5, Wr = 6, Yr = 7, Xr = 0, Zr = 1, qr = 2, Kr = 0, Jr = 1, $r = 2, ea = 3, ta = 4, na = 5, ia = "attached", ra = "detached", aa = 300, sa = 301, oa = 302, la = 303, ca = 304, ua = 306, ha = 1e3, da = 1001, pa = 1002, fa = 1003, ga = 1004, ma = 1004, Aa = 1005, Ma = 1005, va = 1006, ya = 1007, xa = 1007, ba = 1008, wa = 1008, Ea = 1009, Ta = 1010, Sa = 1011, Ia = 1012, Na = 1013, Da = 1014, _a = 1015, Ca = 1016, La = 1017, za = 1018, Oa = 1020, Ra = 1021, Pa = 1023, Ua = 1024, ja = 1025, ka = 1026, Ba = 1027, Fa = 1028, Ha = 1029, Ga = 1030, Va = 1031, Qa = 1033, Wa = 33776, Ya = 33777, Xa = 33778, Za = 33779, qa = 35840, Ka = 35841, Ja = 35842, $a = 35843, es = 36196, ts = 37492, ns = 37496, is = 37808, rs = 37809, as = 37810, ss = 37811, os = 37812, ls = 37813, cs = 37814, us = 37815, hs = 37816, ds = 37817, ps = 37818, fs = 37819, gs = 37820, ms = 37821, As = 36492, Ms = 36494, vs = 36495, ys = 36283, xs = 36284, bs = 36285, ws = 36286, Es = 2200, Ts = 2201, Ss = 2202, Is = 2300, Ns = 2301, Ds = 2302, _s = 2400, Cs = 2401, Ls = 2402, zs = 2500, Os = 2501, Rs = 0, Ps = 1, Us = 2, js = 3e3, ks = 3001, Bs = 3200, Fs = 3201, Hs = 0, Gs = 1, Vs = "", Qs = "srgb", Ws = "srgb-linear", Ys = "display-p3", Xs = "display-p3-linear", Zs = "linear", qs = "srgb", Ks = "rec709", Js = "p3", $s = 0, eo = 7680, to = 7681, no = 7682, io = 7683, ro = 34055, ao = 34056, so = 5386, oo = 512, lo = 513, co = 514, uo = 515, ho = 516, po = 517, fo = 518, go = 519, mo = 512, Ao = 513, Mo = 514, vo = 515, yo = 516, xo = 517, bo = 518, wo = 519, Eo = 35044, To = 35048, So = 35040, Io = 35045, No = 35049, Do = 35041, _o = 35046, Co = 35050, Lo = 35042, zo = "100", Oo = "300 es", Ro = 1035, Po = 2e3, Uo = 2001;
        class jo {
            addEventListener(e1, t) {
                void 0 === this._listeners && (this._listeners = {});
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                if (void 0 === this._listeners) return !1;
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                if (void 0 === this._listeners) return;
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            dispatchEvent(e1) {
                if (void 0 === this._listeners) return;
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                    e1.target = null;
                }
            }
        }
        const ko = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        let Bo = 1234567;
        const Fo = Math.PI / 180, Ho = 180 / Math.PI;
        function Go() {
            const e1 = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
            return (ko[255 & e1] + ko[e1 >> 8 & 255] + ko[e1 >> 16 & 255] + ko[e1 >> 24 & 255] + "-" + ko[255 & t] + ko[t >> 8 & 255] + "-" + ko[t >> 16 & 15 | 64] + ko[t >> 24 & 255] + "-" + ko[63 & n | 128] + ko[n >> 8 & 255] + "-" + ko[n >> 16 & 255] + ko[n >> 24 & 255] + ko[255 & i] + ko[i >> 8 & 255] + ko[i >> 16 & 255] + ko[i >> 24 & 255]).toLowerCase();
        }
        function Vo(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        function Qo(e1, t) {
            return (e1 % t + t) % t;
        }
        function Wo(e1, t, n) {
            return (1 - n) * e1 + n * t;
        }
        function Yo(e1) {
            return !(e1 & e1 - 1) && 0 !== e1;
        }
        function Xo(e1) {
            return Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
        }
        function Zo(e1) {
            return Math.pow(2, Math.floor(Math.log(e1) / Math.LN2));
        }
        function qo(e1, t) {
            switch(t.constructor){
                case Float32Array:
                    return e1;
                case Uint32Array:
                    return e1 / 4294967295;
                case Uint16Array:
                    return e1 / 65535;
                case Uint8Array:
                    return e1 / 255;
                case Int32Array:
                    return Math.max(e1 / 2147483647, -1);
                case Int16Array:
                    return Math.max(e1 / 32767, -1);
                case Int8Array:
                    return Math.max(e1 / 127, -1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        function Ko(e1, t) {
            switch(t.constructor){
                case Float32Array:
                    return e1;
                case Uint32Array:
                    return Math.round(4294967295 * e1);
                case Uint16Array:
                    return Math.round(65535 * e1);
                case Uint8Array:
                    return Math.round(255 * e1);
                case Int32Array:
                    return Math.round(2147483647 * e1);
                case Int16Array:
                    return Math.round(32767 * e1);
                case Int8Array:
                    return Math.round(127 * e1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        const Jo = {
            DEG2RAD: Fo,
            RAD2DEG: Ho,
            generateUUID: Go,
            clamp: Vo,
            euclideanModulo: Qo,
            mapLinear: function(e1, t, n, i, r) {
                return i + (e1 - t) * (r - i) / (n - t);
            },
            inverseLerp: function(e1, t, n) {
                return e1 !== t ? (n - e1) / (t - e1) : 0;
            },
            lerp: Wo,
            damp: function(e1, t, n, i) {
                return Wo(e1, t, 1 - Math.exp(-n * i));
            },
            pingpong: function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return t - Math.abs(Qo(e1, 2 * t) - t);
            },
            smoothstep: function(e1, t, n) {
                return e1 <= t ? 0 : e1 >= n ? 1 : (e1 = (e1 - t) / (n - t)) * e1 * (3 - 2 * e1);
            },
            smootherstep: function(e1, t, n) {
                return e1 <= t ? 0 : e1 >= n ? 1 : (e1 = (e1 - t) / (n - t)) * e1 * e1 * (e1 * (6 * e1 - 15) + 10);
            },
            randInt: function(e1, t) {
                return e1 + Math.floor(Math.random() * (t - e1 + 1));
            },
            randFloat: function(e1, t) {
                return e1 + Math.random() * (t - e1);
            },
            randFloatSpread: function(e1) {
                return e1 * (.5 - Math.random());
            },
            seededRandom: function(e1) {
                void 0 !== e1 && (Bo = e1);
                let t = Bo += 1831565813;
                return t = Math.imul(t ^ t >>> 15, 1 | t), t ^= t + Math.imul(t ^ t >>> 7, 61 | t), ((t ^ t >>> 14) >>> 0) / 4294967296;
            },
            degToRad: function(e1) {
                return e1 * Fo;
            },
            radToDeg: function(e1) {
                return e1 * Ho;
            },
            isPowerOfTwo: Yo,
            ceilPowerOfTwo: Xo,
            floorPowerOfTwo: Zo,
            setQuaternionFromProperEuler: function(e1, t, n, i, r) {
                const a = Math.cos, s = Math.sin, o = a(n / 2), l = s(n / 2), c = a((t + i) / 2), u = s((t + i) / 2), h = a((t - i) / 2), d = s((t - i) / 2), p = a((i - t) / 2), f = s((i - t) / 2);
                switch(r){
                    case "XYX":
                        e1.set(o * u, l * h, l * d, o * c);
                        break;
                    case "YZY":
                        e1.set(l * d, o * u, l * h, o * c);
                        break;
                    case "ZXZ":
                        e1.set(l * h, l * d, o * u, o * c);
                        break;
                    case "XZX":
                        e1.set(o * u, l * f, l * p, o * c);
                        break;
                    case "YXY":
                        e1.set(l * p, o * u, l * f, o * c);
                        break;
                    case "ZYZ":
                        e1.set(l * f, l * p, o * u, o * c);
                        break;
                    default:
                        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
                }
            },
            normalize: Ko,
            denormalize: qo
        };
        class $o {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                $o.prototype.isVector2 = !0, this.x = e1, this.y = t;
            }
            get width() {
                return this.x;
            }
            set width(e1) {
                this.x = e1;
            }
            get height() {
                return this.y;
            }
            set height(e1) {
                this.y = e1;
            }
            set(e1, t) {
                return this.x = e1, this.y = t, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this;
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = e1.elements;
                return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y;
            }
            cross(e1) {
                return this.x * e1.y - this.y * e1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(Vo(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y;
                return t * t + n * n;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this;
            }
            rotateAround(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = this.x - e1.x, a = this.y - e1.y;
                return this.x = r * n - a * i + e1.x, this.y = r * i + a * n + e1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class el {
            constructor(e1, t, n, i, r, a, s, o, l){
                el.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l);
            }
            set(e1, t, n, i, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = e1, c[1] = i, c[2] = s, c[3] = t, c[4] = r, c[5] = o, c[6] = n, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(e1) {
                const t = e1.elements;
                return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[3], o = n[6], l = n[1], c = n[4], u = n[7], h = n[2], d = n[5], p = n[8], f = i[0], g = i[3], m = i[6], A = i[1], M = i[4], v = i[7], y = i[2], x = i[5], b = i[8];
                return r[0] = a * f + s * A + o * y, r[3] = a * g + s * M + o * x, r[6] = a * m + s * v + o * b, r[1] = l * f + c * A + u * y, r[4] = l * g + c * M + u * x, r[7] = l * m + c * v + u * b, r[2] = h * f + d * A + p * y, r[5] = h * g + d * M + p * x, r[8] = h * m + d * v + p * b, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[3] *= e1, t[6] *= e1, t[1] *= e1, t[4] *= e1, t[7] *= e1, t[2] *= e1, t[5] *= e1, t[8] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
                return t * a * c - t * s * l - n * r * c + n * s * o + i * r * l - i * a * o;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = t * u + n * h + i * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return e1[0] = u * f, e1[1] = (i * l - c * n) * f, e1[2] = (s * n - i * a) * f, e1[3] = h * f, e1[4] = (c * t - i * o) * f, e1[5] = (i * r - s * t) * f, e1[6] = d * f, e1[7] = (n * o - l * t) * f, e1[8] = (a * t - n * r) * f, this;
            }
            transpose() {
                let e1;
                const t = this.elements;
                return e1 = t[1], t[1] = t[3], t[3] = e1, e1 = t[2], t[2] = t[6], t[6] = e1, e1 = t[5], t[5] = t[7], t[7] = e1, this;
            }
            getNormalMatrix(e1) {
                return this.setFromMatrix4(e1).invert().transpose();
            }
            transposeIntoArray(e1) {
                const t = this.elements;
                return e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8], this;
            }
            setUvTransform(e1, t, n, i, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(n * o, n * l, -n * (o * a + l * s) + a + e1, -i * l, i * o, -i * (-l * a + o * s) + s + t, 0, 0, 1), this;
            }
            scale(e1, t) {
                return this.premultiply(tl.makeScale(e1, t)), this;
            }
            rotate(e1) {
                return this.premultiply(tl.makeRotation(-e1)), this;
            }
            translate(e1, t) {
                return this.premultiply(tl.makeTranslation(e1, t)), this;
            }
            makeTranslation(e1, t) {
                return e1.isVector2 ? this.set(1, 0, e1.x, 0, 1, e1.y, 0, 0, 1) : this.set(1, 0, e1, 0, 1, t, 0, 0, 1), this;
            }
            makeRotation(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
            }
            makeScale(e1, t) {
                return this.set(e1, 0, 0, 0, t, 0, 0, 0, 1), this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 9; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 9; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const tl = new el;
        function nl(e1) {
            for(let t = e1.length - 1; t >= 0; --t)if (e1[t] >= 65535) return !0;
            return !1;
        }
        const il = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
        };
        function rl(e1, t) {
            return new il[e1](t);
        }
        function al(e1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", e1);
        }
        function sl() {
            const e1 = al("canvas");
            return e1.style.display = "block", e1;
        }
        const ol = {};
        function ll(e1) {
            e1 in ol || (ol[e1] = !0, console.warn(e1));
        }
        const cl = (new el).set(.8224621, .177538, 0, .0331941, .9668058, 0, .0170827, .0723974, .9105199), ul = (new el).set(1.2249401, -0.2249404, 0, -0.0420569, 1.0420571, 0, -0.0196376, -0.0786361, 1.0982735), hl = {
            [Ws]: {
                transfer: Zs,
                primaries: Ks,
                toReference: (e1)=>e1,
                fromReference: (e1)=>e1
            },
            [Qs]: {
                transfer: qs,
                primaries: Ks,
                toReference: (e1)=>e1.convertSRGBToLinear(),
                fromReference: (e1)=>e1.convertLinearToSRGB()
            },
            [Xs]: {
                transfer: Zs,
                primaries: Js,
                toReference: (e1)=>e1.applyMatrix3(ul),
                fromReference: (e1)=>e1.applyMatrix3(cl)
            },
            [Ys]: {
                transfer: qs,
                primaries: Js,
                toReference: (e1)=>e1.convertSRGBToLinear().applyMatrix3(ul),
                fromReference: (e1)=>e1.applyMatrix3(cl).convertLinearToSRGB()
            }
        }, dl = new Set([
            Ws,
            Xs
        ]), pl = {
            enabled: !0,
            _workingColorSpace: Ws,
            get legacyMode () {
                return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
            },
            set legacyMode (e){
                console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !e;
            },
            get workingColorSpace () {
                return this._workingColorSpace;
            },
            set workingColorSpace (e){
                if (!dl.has(e)) throw new Error(`Unsupported working color space, "${e}".`);
                this._workingColorSpace = e;
            },
            convert: function(e1, t, n) {
                if (!1 === this.enabled || t === n || !t || !n) return e1;
                const i = hl[t].toReference;
                return (0, hl[n].fromReference)(i(e1));
            },
            fromWorkingColorSpace: function(e1, t) {
                return this.convert(e1, this._workingColorSpace, t);
            },
            toWorkingColorSpace: function(e1, t) {
                return this.convert(e1, t, this._workingColorSpace);
            },
            getPrimaries: function(e1) {
                return hl[e1].primaries;
            },
            getTransfer: function(e1) {
                return e1 === Vs ? Zs : hl[e1].transfer;
            }
        };
        function fl(e1) {
            return e1 < .04045 ? .0773993808 * e1 : Math.pow(.9478672986 * e1 + .0521327014, 2.4);
        }
        function gl(e1) {
            return e1 < .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, .41666) - .055;
        }
        let ml;
        class Al {
            static getDataURL(e1) {
                if (/^data:/i.test(e1.src)) return e1.src;
                if ("undefined" == typeof HTMLCanvasElement) return e1.src;
                let t;
                if (e1 instanceof HTMLCanvasElement) t = e1;
                else {
                    void 0 === ml && (ml = al("canvas")), ml.width = e1.width, ml.height = e1.height;
                    const n = ml.getContext("2d");
                    e1 instanceof ImageData ? n.putImageData(e1, 0, 0) : n.drawImage(e1, 0, 0, e1.width, e1.height), t = ml;
                }
                return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e1), t.toDataURL("image/jpeg", .6)) : t.toDataURL("image/png");
            }
            static sRGBToLinear(e1) {
                if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                    const t = al("canvas");
                    t.width = e1.width, t.height = e1.height;
                    const n = t.getContext("2d");
                    n.drawImage(e1, 0, 0, e1.width, e1.height);
                    const i = n.getImageData(0, 0, e1.width, e1.height), r = i.data;
                    for(let e1 = 0; e1 < r.length; e1++)r[e1] = 255 * fl(r[e1] / 255);
                    return n.putImageData(i, 0, 0), t;
                }
                if (e1.data) {
                    const t = e1.data.slice(0);
                    for(let e1 = 0; e1 < t.length; e1++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e1] = Math.floor(255 * fl(t[e1] / 255)) : t[e1] = fl(t[e1]);
                    return {
                        data: t,
                        width: e1.width,
                        height: e1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e1;
            }
        }
        let Ml = 0;
        class vl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: Ml++
                }), this.uuid = Go(), this.data = e1, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.images[this.uuid]) return e1.images[this.uuid];
                const n = {
                    uuid: this.uuid,
                    url: ""
                }, i = this.data;
                if (null !== i) {
                    let e1;
                    if (Array.isArray(i)) {
                        e1 = [];
                        for(let t = 0, n = i.length; t < n; t++)i[t].isDataTexture ? e1.push(yl(i[t].image)) : e1.push(yl(i[t]));
                    } else e1 = yl(i);
                    n.url = e1;
                }
                return t || (e1.images[this.uuid] = n), n;
            }
        }
        function yl(e1) {
            return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap ? Al.getDataURL(e1) : e1.data ? {
                data: Array.from(e1.data),
                width: e1.width,
                height: e1.height,
                type: e1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let xl = 0;
        class bl extends jo {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : bl.DEFAULT_IMAGE, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : bl.DEFAULT_MAPPING, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : da, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : da, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : va, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : ba, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Pa, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : Ea, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : bl.DEFAULT_ANISOTROPY, c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : Vs;
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: xl++
                }), this.uuid = Go(), this.name = "", this.source = new vl(e1), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new $o(0, 0), this.repeat = new $o(1, 1), this.center = new $o(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new el, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (ll("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === ks ? Qs : Vs), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(e1) {
                void 0 === e1 && (e1 = null), this.source.data = e1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.name = e1.name, this.source = e1.source, this.mipmaps = e1.mipmaps.slice(0), this.mapping = e1.mapping, this.channel = e1.channel, this.wrapS = e1.wrapS, this.wrapT = e1.wrapT, this.magFilter = e1.magFilter, this.minFilter = e1.minFilter, this.anisotropy = e1.anisotropy, this.format = e1.format, this.internalFormat = e1.internalFormat, this.type = e1.type, this.offset.copy(e1.offset), this.repeat.copy(e1.repeat), this.center.copy(e1.center), this.rotation = e1.rotation, this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrix.copy(e1.matrix), this.generateMipmaps = e1.generateMipmaps, this.premultiplyAlpha = e1.premultiplyAlpha, this.flipY = e1.flipY, this.unpackAlignment = e1.unpackAlignment, this.colorSpace = e1.colorSpace, this.userData = JSON.parse(JSON.stringify(e1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.textures[this.uuid]) return e1.textures[this.uuid];
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(e1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e1.textures[this.uuid] = n), n;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(e1) {
                if (this.mapping !== aa) return e1;
                if (e1.applyMatrix3(this.matrix), e1.x < 0 || e1.x > 1) switch(this.wrapS){
                    case ha:
                        e1.x = e1.x - Math.floor(e1.x);
                        break;
                    case da:
                        e1.x = e1.x < 0 ? 0 : 1;
                        break;
                    case pa:
                        1 === Math.abs(Math.floor(e1.x) % 2) ? e1.x = Math.ceil(e1.x) - e1.x : e1.x = e1.x - Math.floor(e1.x);
                }
                if (e1.y < 0 || e1.y > 1) switch(this.wrapT){
                    case ha:
                        e1.y = e1.y - Math.floor(e1.y);
                        break;
                    case da:
                        e1.y = e1.y < 0 ? 0 : 1;
                        break;
                    case pa:
                        1 === Math.abs(Math.floor(e1.y) % 2) ? e1.y = Math.ceil(e1.y) - e1.y : e1.y = e1.y - Math.floor(e1.y);
                }
                return this.flipY && (e1.y = 1 - e1.y), e1;
            }
            set needsUpdate(e1) {
                !0 === e1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return ll("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === Qs ? ks : js;
            }
            set encoding(e1) {
                ll("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e1 === ks ? Qs : Vs;
            }
        }
        bl.DEFAULT_IMAGE = null, bl.DEFAULT_MAPPING = aa, bl.DEFAULT_ANISOTROPY = 1;
        class wl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                wl.prototype.isVector4 = !0, this.x = e1, this.y = t, this.z = n, this.w = i;
            }
            get width() {
                return this.z;
            }
            set width(e1) {
                this.z = e1;
            }
            get height() {
                return this.w;
            }
            set height(e1) {
                this.w = e1;
            }
            set(e1, t, n, i) {
                return this.x = e1, this.y = t, this.z = n, this.w = i, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this.w = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setW(e1) {
                return this.w = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    case 3:
                        this.w = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this.w = void 0 !== e1.w ? e1.w : 1, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this.w += e1.w, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this.w += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this.w = e1.w + t.w, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this.w += e1.w * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this.w -= e1.w, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this.w -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this.w = e1.w - t.w, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this.w *= e1.w, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this.w *= e1, this;
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = this.w, a = e1.elements;
                return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            setAxisAngleFromQuaternion(e1) {
                this.w = 2 * Math.acos(e1.w);
                const t = Math.sqrt(1 - e1.w * e1.w);
                return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e1.x / t, this.y = e1.y / t, this.z = e1.z / t), this;
            }
            setAxisAngleFromRotationMatrix(e1) {
                let t, n, i, r;
                const a = .01, s = .1, o = e1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], g = o[6], m = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - g) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + g) < s && Math.abs(l + d + m - 3) < s) return this.set(1, 0, 0, 0), this;
                    t = Math.PI;
                    const e1 = (l + 1) / 2, o = (d + 1) / 2, A = (m + 1) / 2, M = (c + h) / 4, v = (u + f) / 4, y = (p + g) / 4;
                    return e1 > o && e1 > A ? e1 < a ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(e1), i = M / n, r = v / n) : o > A ? o < a ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = M / i, r = y / i) : A < a ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(A), n = v / r, i = y / r), this.set(n, i, r, t), this;
                }
                let A = Math.sqrt((g - p) * (g - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(A) < .001 && (A = 1), this.x = (g - p) / A, this.y = (u - f) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + m - 1) / 2), this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this.w = Math.min(this.w, e1.w), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this.w = Math.max(this.w, e1.w), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this.w = Math.max(e1.w, Math.min(t.w, this.w)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this.w = Math.max(e1, Math.min(t, this.w)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z + this.w * e1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this.w += (e1.w - this.w) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this.w = e1.w + (t.w - e1.w) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z && e1.w === this.w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this.w = e1[t + 3], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1[t + 3] = this.w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this.w = e1.getW(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        class El extends jo {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                super(), this.isRenderTarget = !0, this.width = e1, this.height = t, this.depth = 1, this.scissor = new wl(0, 0, e1, t), this.scissorTest = !1, this.viewport = new wl(0, 0, e1, t);
                const i = {
                    width: e1,
                    height: t,
                    depth: 1
                };
                void 0 !== n.encoding && (ll("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), n.colorSpace = n.encoding === ks ? Qs : Vs), n = Object.assign({
                    generateMipmaps: !1,
                    internalFormat: null,
                    minFilter: va,
                    depthBuffer: !0,
                    stencilBuffer: !1,
                    depthTexture: null,
                    samples: 0
                }, n), this.texture = new bl(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = n.generateMipmaps, this.texture.internalFormat = n.internalFormat, this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.depthTexture = n.depthTexture, this.samples = n.samples;
            }
            setSize(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                this.width === e1 && this.height === t && this.depth === n || (this.width = e1, this.height = t, this.depth = n, this.texture.image.width = e1, this.texture.image.height = t, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, e1, t), this.scissor.set(0, 0, e1, t);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.width = e1.width, this.height = e1.height, this.depth = e1.depth, this.scissor.copy(e1.scissor), this.scissorTest = e1.scissorTest, this.viewport.copy(e1.viewport), this.texture = e1.texture.clone(), this.texture.isRenderTargetTexture = !0;
                const t = Object.assign({}, e1.texture.image);
                return this.texture.source = new vl(t), this.depthBuffer = e1.depthBuffer, this.stencilBuffer = e1.stencilBuffer, null !== e1.depthTexture && (this.depthTexture = e1.depthTexture.clone()), this.samples = e1.samples, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Tl extends El {
            constructor(){
                super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}), this.isWebGLRenderTarget = !0;
            }
        }
        class Sl extends bl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(null), this.isDataArrayTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n,
                    depth: i
                }, this.magFilter = fa, this.minFilter = fa, this.wrapR = da, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Il extends Tl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isWebGLArrayRenderTarget = !0, this.depth = n, this.texture = new Sl(null, e1, t, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Nl extends bl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(null), this.isData3DTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n,
                    depth: i
                }, this.magFilter = fa, this.minFilter = fa, this.wrapR = da, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Dl extends Tl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isWebGL3DRenderTarget = !0, this.depth = n, this.texture = new Nl(null, e1, t, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class _l extends Tl {
            constructor(){
                let e1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}), this.isWebGLMultipleRenderTargets = !0;
                const t = this.texture;
                this.texture = [];
                for(let n = 0; n < e1; n++)this.texture[n] = t.clone(), this.texture[n].isRenderTargetTexture = !0;
            }
            setSize(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                if (this.width !== e1 || this.height !== t || this.depth !== n) {
                    this.width = e1, this.height = t, this.depth = n;
                    for(let i = 0, r = this.texture.length; i < r; i++)this.texture[i].image.width = e1, this.texture[i].image.height = t, this.texture[i].image.depth = n;
                    this.dispose();
                }
                this.viewport.set(0, 0, e1, t), this.scissor.set(0, 0, e1, t);
            }
            copy(e1) {
                this.dispose(), this.width = e1.width, this.height = e1.height, this.depth = e1.depth, this.scissor.copy(e1.scissor), this.scissorTest = e1.scissorTest, this.viewport.copy(e1.viewport), this.depthBuffer = e1.depthBuffer, this.stencilBuffer = e1.stencilBuffer, null !== e1.depthTexture && (this.depthTexture = e1.depthTexture.clone()), this.texture.length = 0;
                for(let t = 0, n = e1.texture.length; t < n; t++)this.texture[t] = e1.texture[t].clone(), this.texture[t].isRenderTargetTexture = !0;
                return this;
            }
        }
        class Cl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                this.isQuaternion = !0, this._x = e1, this._y = t, this._z = n, this._w = i;
            }
            static slerpFlat(e1, t, n, i, r, a, s) {
                let o = n[i + 0], l = n[i + 1], c = n[i + 2], u = n[i + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return e1[t + 0] = o, e1[t + 1] = l, e1[t + 2] = c, void (e1[t + 3] = u);
                if (1 === s) return e1[t + 0] = h, e1[t + 1] = d, e1[t + 2] = p, void (e1[t + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let e1 = 1 - s;
                    const t = o * h + l * d + c * p + u * f, n = t >= 0 ? 1 : -1, i = 1 - t * t;
                    if (i > Number.EPSILON) {
                        const r = Math.sqrt(i), a = Math.atan2(r, t * n);
                        e1 = Math.sin(e1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * n;
                    if (o = o * e1 + h * r, l = l * e1 + d * r, c = c * e1 + p * r, u = u * e1 + f * r, e1 === 1 - s) {
                        const e1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= e1, l *= e1, c *= e1, u *= e1;
                    }
                }
                e1[t] = o, e1[t + 1] = l, e1[t + 2] = c, e1[t + 3] = u;
            }
            static multiplyQuaternionsFlat(e1, t, n, i, r, a) {
                const s = n[i], o = n[i + 1], l = n[i + 2], c = n[i + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return e1[t] = s * p + c * u + o * d - l * h, e1[t + 1] = o * p + c * h + l * u - s * d, e1[t + 2] = l * p + c * d + s * h - o * u, e1[t + 3] = c * p - s * u - o * h - l * d, e1;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(e1) {
                this._w = e1, this._onChangeCallback();
            }
            set(e1, t, n, i) {
                return this._x = e1, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(e1) {
                return this._x = e1.x, this._y = e1.y, this._z = e1.z, this._w = e1.w, this._onChangeCallback(), this;
            }
            setFromEuler(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._order, s = Math.cos, o = Math.sin, l = s(n / 2), c = s(i / 2), u = s(r / 2), h = o(n / 2), d = o(i / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== t && this._onChangeCallback(), this;
            }
            setFromAxisAngle(e1, t) {
                const n = t / 2, i = Math.sin(n);
                return this._x = e1.x * i, this._y = e1.y * i, this._z = e1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                const t = e1.elements, n = t[0], i = t[4], r = t[8], a = t[1], s = t[5], o = t[9], l = t[2], c = t[6], u = t[10], h = n + s + u;
                if (h > 0) {
                    const e1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / e1, this._x = (c - o) * e1, this._y = (r - l) * e1, this._z = (a - i) * e1;
                } else if (n > s && n > u) {
                    const e1 = 2 * Math.sqrt(1 + n - s - u);
                    this._w = (c - o) / e1, this._x = .25 * e1, this._y = (i + a) / e1, this._z = (r + l) / e1;
                } else if (s > u) {
                    const e1 = 2 * Math.sqrt(1 + s - n - u);
                    this._w = (r - l) / e1, this._x = (i + a) / e1, this._y = .25 * e1, this._z = (o + c) / e1;
                } else {
                    const e1 = 2 * Math.sqrt(1 + u - n - s);
                    this._w = (a - i) / e1, this._x = (r + l) / e1, this._y = (o + c) / e1, this._z = .25 * e1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(e1, t) {
                let n = e1.dot(t) + 1;
                return n < Number.EPSILON ? (n = 0, Math.abs(e1.x) > Math.abs(e1.z) ? (this._x = -e1.y, this._y = e1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e1.z, this._z = e1.y, this._w = n)) : (this._x = e1.y * t.z - e1.z * t.y, this._y = e1.z * t.x - e1.x * t.z, this._z = e1.x * t.y - e1.y * t.x, this._w = n), this.normalize();
            }
            angleTo(e1) {
                return 2 * Math.acos(Math.abs(Vo(this.dot(e1), -1, 1)));
            }
            rotateTowards(e1, t) {
                const n = this.angleTo(e1);
                if (0 === n) return this;
                const i = Math.min(1, t / n);
                return this.slerp(e1, i), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(e1) {
                return this._x * e1._x + this._y * e1._y + this._z * e1._z + this._w * e1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let e1 = this.length();
                return 0 === e1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e1 = 1 / e1, this._x = this._x * e1, this._y = this._y * e1, this._z = this._z * e1, this._w = this._w * e1), this._onChangeCallback(), this;
            }
            multiply(e1) {
                return this.multiplyQuaternions(this, e1);
            }
            premultiply(e1) {
                return this.multiplyQuaternions(e1, this);
            }
            multiplyQuaternions(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._w, s = t._x, o = t._y, l = t._z, c = t._w;
                return this._x = n * c + a * s + i * l - r * o, this._y = i * c + a * o + r * s - n * l, this._z = r * c + a * l + n * o - i * s, this._w = a * c - n * s - i * o - r * l, this._onChangeCallback(), this;
            }
            slerp(e1, t) {
                if (0 === t) return this;
                if (1 === t) return this.copy(e1);
                const n = this._x, i = this._y, r = this._z, a = this._w;
                let s = a * e1._w + n * e1._x + i * e1._y + r * e1._z;
                if (s < 0 ? (this._w = -e1._w, this._x = -e1._x, this._y = -e1._y, this._z = -e1._z, s = -s) : this.copy(e1), s >= 1) return this._w = a, this._x = n, this._y = i, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const e1 = 1 - t;
                    return this._w = e1 * a + t * this._w, this._x = e1 * n + t * this._x, this._y = e1 * i + t * this._y, this._z = e1 * r + t * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - t) * c) / l, h = Math.sin(t * c) / l;
                return this._w = a * u + this._w * h, this._x = n * u + this._x * h, this._y = i * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(e1, t, n) {
                return this.copy(e1).slerp(t, n);
            }
            random() {
                const e1 = Math.random(), t = Math.sqrt(1 - e1), n = Math.sqrt(e1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(t * Math.cos(i), n * Math.sin(r), n * Math.cos(r), t * Math.sin(i));
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._w === this._w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this._x = e1[t], this._y = e1[t + 1], this._z = e1[t + 2], this._w = e1[t + 3], this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this._x = e1.getX(t), this._y = e1.getY(t), this._z = e1.getZ(t), this._w = e1.getW(t), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class Ll {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                Ll.prototype.isVector3 = !0, this.x = e1, this.y = t, this.z = n;
            }
            set(e1, t, n) {
                return void 0 === n && (n = this.z), this.x = e1, this.y = t, this.z = n, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this;
            }
            multiplyVectors(e1, t) {
                return this.x = e1.x * t.x, this.y = e1.y * t.y, this.z = e1.z * t.z, this;
            }
            applyEuler(e1) {
                return this.applyQuaternion(Ol.setFromEuler(e1));
            }
            applyAxisAngle(e1, t) {
                return this.applyQuaternion(Ol.setFromAxisAngle(e1, t));
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
            }
            applyNormalMatrix(e1) {
                return this.applyMatrix3(e1).normalize();
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements, a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
                return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a, this;
            }
            applyQuaternion(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.x, a = e1.y, s = e1.z, o = e1.w, l = 2 * (a * i - s * n), c = 2 * (s * t - r * i), u = 2 * (r * n - a * t);
                return this.x = t + o * l + a * u - s * c, this.y = n + o * c + s * l - r * u, this.z = i + o * u + r * c - a * l, this;
            }
            project(e1) {
                return this.applyMatrix4(e1.matrixWorldInverse).applyMatrix4(e1.projectionMatrix);
            }
            unproject(e1) {
                return this.applyMatrix4(e1.projectionMatrixInverse).applyMatrix4(e1.matrixWorld);
            }
            transformDirection(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this;
            }
            cross(e1) {
                return this.crossVectors(this, e1);
            }
            crossVectors(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = t.x, s = t.y, o = t.z;
                return this.x = i * o - r * s, this.y = r * a - n * o, this.z = n * s - i * a, this;
            }
            projectOnVector(e1) {
                const t = e1.lengthSq();
                if (0 === t) return this.set(0, 0, 0);
                const n = e1.dot(this) / t;
                return this.copy(e1).multiplyScalar(n);
            }
            projectOnPlane(e1) {
                return zl.copy(this).projectOnVector(e1), this.sub(zl);
            }
            reflect(e1) {
                return this.sub(zl.copy(e1).multiplyScalar(2 * this.dot(e1)));
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(Vo(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y, i = this.z - e1.z;
                return t * t + n * n + i * i;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y) + Math.abs(this.z - e1.z);
            }
            setFromSpherical(e1) {
                return this.setFromSphericalCoords(e1.radius, e1.phi, e1.theta);
            }
            setFromSphericalCoords(e1, t, n) {
                const i = Math.sin(t) * e1;
                return this.x = i * Math.sin(n), this.y = Math.cos(t) * e1, this.z = i * Math.cos(n), this;
            }
            setFromCylindrical(e1) {
                return this.setFromCylindricalCoords(e1.radius, e1.theta, e1.y);
            }
            setFromCylindricalCoords(e1, t, n) {
                return this.x = e1 * Math.sin(t), this.y = n, this.z = e1 * Math.cos(t), this;
            }
            setFromMatrixPosition(e1) {
                const t = e1.elements;
                return this.x = t[12], this.y = t[13], this.z = t[14], this;
            }
            setFromMatrixScale(e1) {
                const t = this.setFromMatrixColumn(e1, 0).length(), n = this.setFromMatrixColumn(e1, 1).length(), i = this.setFromMatrixColumn(e1, 2).length();
                return this.x = t, this.y = n, this.z = i, this;
            }
            setFromMatrixColumn(e1, t) {
                return this.fromArray(e1.elements, 4 * t);
            }
            setFromMatrix3Column(e1, t) {
                return this.fromArray(e1.elements, 3 * t);
            }
            setFromEuler(e1) {
                return this.x = e1._x, this.y = e1._y, this.z = e1._z, this;
            }
            setFromColor(e1) {
                return this.x = e1.r, this.y = e1.g, this.z = e1.b, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const e1 = 2 * (Math.random() - .5), t = Math.random() * Math.PI * 2, n = Math.sqrt(1 - e1 ** 2);
                return this.x = n * Math.cos(t), this.y = n * Math.sin(t), this.z = e1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const zl = new Ll, Ol = new Cl;
        class Rl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll(1 / 0, 1 / 0, 1 / 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll(-1 / 0, -1 / 0, -1 / 0);
                this.isBox3 = !0, this.min = e1, this.max = t;
            }
            set(e1, t) {
                return this.min.copy(e1), this.max.copy(t), this;
            }
            setFromArray(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t += 3)this.expandByPoint(Ul.fromArray(e1, t));
                return this;
            }
            setFromBufferAttribute(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.count; t < n; t++)this.expandByPoint(Ul.fromBufferAttribute(e1, t));
                return this;
            }
            setFromPoints(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t++)this.expandByPoint(e1[t]);
                return this;
            }
            setFromCenterAndSize(e1, t) {
                const n = Ul.copy(t).multiplyScalar(.5);
                return this.min.copy(e1).sub(n), this.max.copy(e1).add(n), this;
            }
            setFromObject(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.makeEmpty(), this.expandByObject(e1, t);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.min.copy(e1.min), this.max.copy(e1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
            getCenter(e1) {
                return this.isEmpty() ? e1.set(0, 0, 0) : e1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(e1) {
                return this.isEmpty() ? e1.set(0, 0, 0) : e1.subVectors(this.max, this.min);
            }
            expandByPoint(e1) {
                return this.min.min(e1), this.max.max(e1), this;
            }
            expandByVector(e1) {
                return this.min.sub(e1), this.max.add(e1), this;
            }
            expandByScalar(e1) {
                return this.min.addScalar(-e1), this.max.addScalar(e1), this;
            }
            expandByObject(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                e1.updateWorldMatrix(!1, !1);
                const n = e1.geometry;
                if (void 0 !== n) {
                    const i = n.getAttribute("position");
                    if (!0 === t && void 0 !== i && !0 !== e1.isInstancedMesh) for(let t = 0, n = i.count; t < n; t++)!0 === e1.isMesh ? e1.getVertexPosition(t, Ul) : Ul.fromBufferAttribute(i, t), Ul.applyMatrix4(e1.matrixWorld), this.expandByPoint(Ul);
                    else void 0 !== e1.boundingBox ? (null === e1.boundingBox && e1.computeBoundingBox(), jl.copy(e1.boundingBox)) : (null === n.boundingBox && n.computeBoundingBox(), jl.copy(n.boundingBox)), jl.applyMatrix4(e1.matrixWorld), this.union(jl);
                }
                const i = e1.children;
                for(let e1 = 0, n = i.length; e1 < n; e1++)this.expandByObject(i[e1], t);
                return this;
            }
            containsPoint(e1) {
                return !(e1.x < this.min.x || e1.x > this.max.x || e1.y < this.min.y || e1.y > this.max.y || e1.z < this.min.z || e1.z > this.max.z);
            }
            containsBox(e1) {
                return this.min.x <= e1.min.x && e1.max.x <= this.max.x && this.min.y <= e1.min.y && e1.max.y <= this.max.y && this.min.z <= e1.min.z && e1.max.z <= this.max.z;
            }
            getParameter(e1, t) {
                return t.set((e1.x - this.min.x) / (this.max.x - this.min.x), (e1.y - this.min.y) / (this.max.y - this.min.y), (e1.z - this.min.z) / (this.max.z - this.min.z));
            }
            intersectsBox(e1) {
                return !(e1.max.x < this.min.x || e1.min.x > this.max.x || e1.max.y < this.min.y || e1.min.y > this.max.y || e1.max.z < this.min.z || e1.min.z > this.max.z);
            }
            intersectsSphere(e1) {
                return this.clampPoint(e1.center, Ul), Ul.distanceToSquared(e1.center) <= e1.radius * e1.radius;
            }
            intersectsPlane(e1) {
                let t, n;
                return e1.normal.x > 0 ? (t = e1.normal.x * this.min.x, n = e1.normal.x * this.max.x) : (t = e1.normal.x * this.max.x, n = e1.normal.x * this.min.x), e1.normal.y > 0 ? (t += e1.normal.y * this.min.y, n += e1.normal.y * this.max.y) : (t += e1.normal.y * this.max.y, n += e1.normal.y * this.min.y), e1.normal.z > 0 ? (t += e1.normal.z * this.min.z, n += e1.normal.z * this.max.z) : (t += e1.normal.z * this.max.z, n += e1.normal.z * this.min.z), t <= -e1.constant && n >= -e1.constant;
            }
            intersectsTriangle(e1) {
                if (this.isEmpty()) return !1;
                this.getCenter(Ql), Wl.subVectors(this.max, Ql), kl.subVectors(e1.a, Ql), Bl.subVectors(e1.b, Ql), Fl.subVectors(e1.c, Ql), Hl.subVectors(Bl, kl), Gl.subVectors(Fl, Bl), Vl.subVectors(kl, Fl);
                let t = [
                    0,
                    -Hl.z,
                    Hl.y,
                    0,
                    -Gl.z,
                    Gl.y,
                    0,
                    -Vl.z,
                    Vl.y,
                    Hl.z,
                    0,
                    -Hl.x,
                    Gl.z,
                    0,
                    -Gl.x,
                    Vl.z,
                    0,
                    -Vl.x,
                    -Hl.y,
                    Hl.x,
                    0,
                    -Gl.y,
                    Gl.x,
                    0,
                    -Vl.y,
                    Vl.x,
                    0
                ];
                return !!Zl(t, kl, Bl, Fl, Wl) && (t = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], !!Zl(t, kl, Bl, Fl, Wl) && (Yl.crossVectors(Hl, Gl), t = [
                    Yl.x,
                    Yl.y,
                    Yl.z
                ], Zl(t, kl, Bl, Fl, Wl)));
            }
            clampPoint(e1, t) {
                return t.copy(e1).clamp(this.min, this.max);
            }
            distanceToPoint(e1) {
                return this.clampPoint(e1, Ul).distanceTo(e1);
            }
            getBoundingSphere(e1) {
                return this.isEmpty() ? e1.makeEmpty() : (this.getCenter(e1.center), e1.radius = .5 * this.getSize(Ul).length()), e1;
            }
            intersect(e1) {
                return this.min.max(e1.min), this.max.min(e1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(e1) {
                return this.min.min(e1.min), this.max.max(e1.max), this;
            }
            applyMatrix4(e1) {
                return this.isEmpty() || (Pl[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e1), Pl[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e1), Pl[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e1), Pl[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e1), Pl[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e1), Pl[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e1), Pl[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e1), Pl[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e1), this.setFromPoints(Pl)), this;
            }
            translate(e1) {
                return this.min.add(e1), this.max.add(e1), this;
            }
            equals(e1) {
                return e1.min.equals(this.min) && e1.max.equals(this.max);
            }
        }
        const Pl = [
            new Ll,
            new Ll,
            new Ll,
            new Ll,
            new Ll,
            new Ll,
            new Ll,
            new Ll
        ], Ul = new Ll, jl = new Rl, kl = new Ll, Bl = new Ll, Fl = new Ll, Hl = new Ll, Gl = new Ll, Vl = new Ll, Ql = new Ll, Wl = new Ll, Yl = new Ll, Xl = new Ll;
        function Zl(e1, t, n, i, r) {
            for(let a = 0, s = e1.length - 3; a <= s; a += 3){
                Xl.fromArray(e1, a);
                const s = r.x * Math.abs(Xl.x) + r.y * Math.abs(Xl.y) + r.z * Math.abs(Xl.z), o = t.dot(Xl), l = n.dot(Xl), c = i.dot(Xl);
                if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
            }
            return !0;
        }
        const ql = new Rl, Kl = new Ll, Jl = new Ll;
        class $l {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                this.center = e1, this.radius = t;
            }
            set(e1, t) {
                return this.center.copy(e1), this.radius = t, this;
            }
            setFromPoints(e1, t) {
                const n = this.center;
                void 0 !== t ? n.copy(t) : ql.setFromPoints(e1).getCenter(n);
                let i = 0;
                for(let t = 0, r = e1.length; t < r; t++)i = Math.max(i, n.distanceToSquared(e1[t]));
                return this.radius = Math.sqrt(i), this;
            }
            copy(e1) {
                return this.center.copy(e1.center), this.radius = e1.radius, this;
            }
            isEmpty() {
                return this.radius < 0;
            }
            makeEmpty() {
                return this.center.set(0, 0, 0), this.radius = -1, this;
            }
            containsPoint(e1) {
                return e1.distanceToSquared(this.center) <= this.radius * this.radius;
            }
            distanceToPoint(e1) {
                return e1.distanceTo(this.center) - this.radius;
            }
            intersectsSphere(e1) {
                const t = this.radius + e1.radius;
                return e1.center.distanceToSquared(this.center) <= t * t;
            }
            intersectsBox(e1) {
                return e1.intersectsSphere(this);
            }
            intersectsPlane(e1) {
                return Math.abs(e1.distanceToPoint(this.center)) <= this.radius;
            }
            clampPoint(e1, t) {
                const n = this.center.distanceToSquared(e1);
                return t.copy(e1), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
            }
            getBoundingBox(e1) {
                return this.isEmpty() ? (e1.makeEmpty(), e1) : (e1.set(this.center, this.center), e1.expandByScalar(this.radius), e1);
            }
            applyMatrix4(e1) {
                return this.center.applyMatrix4(e1), this.radius = this.radius * e1.getMaxScaleOnAxis(), this;
            }
            translate(e1) {
                return this.center.add(e1), this;
            }
            expandByPoint(e1) {
                if (this.isEmpty()) return this.center.copy(e1), this.radius = 0, this;
                Kl.subVectors(e1, this.center);
                const t = Kl.lengthSq();
                if (t > this.radius * this.radius) {
                    const e1 = Math.sqrt(t), n = .5 * (e1 - this.radius);
                    this.center.addScaledVector(Kl, n / e1), this.radius += n;
                }
                return this;
            }
            union(e1) {
                return e1.isEmpty() ? this : this.isEmpty() ? (this.copy(e1), this) : (!0 === this.center.equals(e1.center) ? this.radius = Math.max(this.radius, e1.radius) : (Jl.subVectors(e1.center, this.center).setLength(e1.radius), this.expandByPoint(Kl.copy(e1.center).add(Jl)), this.expandByPoint(Kl.copy(e1.center).sub(Jl))), this);
            }
            equals(e1) {
                return e1.center.equals(this.center) && e1.radius === this.radius;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const ec = new Ll, tc = new Ll, nc = new Ll, ic = new Ll, rc = new Ll, ac = new Ll, sc = new Ll;
        class oc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll(0, 0, -1);
                this.origin = e1, this.direction = t;
            }
            set(e1, t) {
                return this.origin.copy(e1), this.direction.copy(t), this;
            }
            copy(e1) {
                return this.origin.copy(e1.origin), this.direction.copy(e1.direction), this;
            }
            at(e1, t) {
                return t.copy(this.origin).addScaledVector(this.direction, e1);
            }
            lookAt(e1) {
                return this.direction.copy(e1).sub(this.origin).normalize(), this;
            }
            recast(e1) {
                return this.origin.copy(this.at(e1, ec)), this;
            }
            closestPointToPoint(e1, t) {
                t.subVectors(e1, this.origin);
                const n = t.dot(this.direction);
                return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
            }
            distanceToPoint(e1) {
                return Math.sqrt(this.distanceSqToPoint(e1));
            }
            distanceSqToPoint(e1) {
                const t = ec.subVectors(e1, this.origin).dot(this.direction);
                return t < 0 ? this.origin.distanceToSquared(e1) : (ec.copy(this.origin).addScaledVector(this.direction, t), ec.distanceToSquared(e1));
            }
            distanceSqToSegment(e1, t, n, i) {
                tc.copy(e1).add(t).multiplyScalar(.5), nc.copy(t).sub(e1).normalize(), ic.copy(this.origin).sub(tc);
                const r = .5 * e1.distanceTo(t), a = -this.direction.dot(nc), s = ic.dot(this.direction), o = -ic.dot(nc), l = ic.lengthSq(), c = Math.abs(1 - a * a);
                let u, h, d, p;
                if (c > 0) {
                    if (u = a * o - s, h = a * s - o, p = r * c, u >= 0) {
                        if (h >= -p) {
                            if (h <= p) {
                                const e1 = 1 / c;
                                u *= e1, h *= e1, d = u * (u + a * h + 2 * s) + h * (a * u + h + 2 * o) + l;
                            } else h = r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                        } else h = -r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                    } else h <= -p ? (u = Math.max(0, -(-a * r + s)), h = u > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-r, -o), r), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(a * r + s)), h = u > 0 ? r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l);
                } else h = a > 0 ? -r : r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                return n && n.copy(this.origin).addScaledVector(this.direction, u), i && i.copy(tc).addScaledVector(nc, h), d;
            }
            intersectSphere(e1, t) {
                ec.subVectors(e1.center, this.origin);
                const n = ec.dot(this.direction), i = ec.dot(ec) - n * n, r = e1.radius * e1.radius;
                if (i > r) return null;
                const a = Math.sqrt(r - i), s = n - a, o = n + a;
                return o < 0 ? null : s < 0 ? this.at(o, t) : this.at(s, t);
            }
            intersectsSphere(e1) {
                return this.distanceSqToPoint(e1.center) <= e1.radius * e1.radius;
            }
            distanceToPlane(e1) {
                const t = e1.normal.dot(this.direction);
                if (0 === t) return 0 === e1.distanceToPoint(this.origin) ? 0 : null;
                const n = -(this.origin.dot(e1.normal) + e1.constant) / t;
                return n >= 0 ? n : null;
            }
            intersectPlane(e1, t) {
                const n = this.distanceToPlane(e1);
                return null === n ? null : this.at(n, t);
            }
            intersectsPlane(e1) {
                const t = e1.distanceToPoint(this.origin);
                return 0 === t || e1.normal.dot(this.direction) * t < 0;
            }
            intersectBox(e1, t) {
                let n, i, r, a, s, o;
                const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
                return l >= 0 ? (n = (e1.min.x - h.x) * l, i = (e1.max.x - h.x) * l) : (n = (e1.max.x - h.x) * l, i = (e1.min.x - h.x) * l), c >= 0 ? (r = (e1.min.y - h.y) * c, a = (e1.max.y - h.y) * c) : (r = (e1.max.y - h.y) * c, a = (e1.min.y - h.y) * c), n > a || r > i ? null : ((r > n || isNaN(n)) && (n = r), (a < i || isNaN(i)) && (i = a), u >= 0 ? (s = (e1.min.z - h.z) * u, o = (e1.max.z - h.z) * u) : (s = (e1.max.z - h.z) * u, o = (e1.min.z - h.z) * u), n > o || s > i ? null : ((s > n || n != n) && (n = s), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, t)));
            }
            intersectsBox(e1) {
                return null !== this.intersectBox(e1, ec);
            }
            intersectTriangle(e1, t, n, i, r) {
                rc.subVectors(t, e1), ac.subVectors(n, e1), sc.crossVectors(rc, ac);
                let a, s = this.direction.dot(sc);
                if (s > 0) {
                    if (i) return null;
                    a = 1;
                } else {
                    if (!(s < 0)) return null;
                    a = -1, s = -s;
                }
                ic.subVectors(this.origin, e1);
                const o = a * this.direction.dot(ac.crossVectors(ic, ac));
                if (o < 0) return null;
                const l = a * this.direction.dot(rc.cross(ic));
                if (l < 0) return null;
                if (o + l > s) return null;
                const c = -a * ic.dot(sc);
                return c < 0 ? null : this.at(c / s, r);
            }
            applyMatrix4(e1) {
                return this.origin.applyMatrix4(e1), this.direction.transformDirection(e1), this;
            }
            equals(e1) {
                return e1.origin.equals(this.origin) && e1.direction.equals(this.direction);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class lc {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g){
                lc.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g);
            }
            set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g) {
                const m = this.elements;
                return m[0] = e1, m[4] = t, m[8] = n, m[12] = i, m[1] = r, m[5] = a, m[9] = s, m[13] = o, m[2] = l, m[6] = c, m[10] = u, m[14] = h, m[3] = d, m[7] = p, m[11] = f, m[15] = g, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new lc).fromArray(this.elements);
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
            }
            copyPosition(e1) {
                const t = this.elements, n = e1.elements;
                return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
            }
            setFromMatrix3(e1) {
                const t = e1.elements;
                return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(e1, t, n) {
                return this.set(e1.x, t.x, n.x, 0, e1.y, t.y, n.y, 0, e1.z, t.z, n.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(e1) {
                const t = this.elements, n = e1.elements, i = 1 / cc.setFromMatrixColumn(e1, 0).length(), r = 1 / cc.setFromMatrixColumn(e1, 1).length(), a = 1 / cc.setFromMatrixColumn(e1, 2).length();
                return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromEuler(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z, a = Math.cos(n), s = Math.sin(n), o = Math.cos(i), l = Math.sin(i), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = -o * u, t[8] = l, t[1] = n + i * l, t[5] = e1 - r * l, t[9] = -s * o, t[2] = r - e1 * l, t[6] = i + n * l, t[10] = a * o;
                } else if ("YXZ" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 + r * s, t[4] = i * s - n, t[8] = a * l, t[1] = a * u, t[5] = a * c, t[9] = -s, t[2] = n * s - i, t[6] = r + e1 * s, t[10] = a * o;
                } else if ("ZXY" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 - r * s, t[4] = -a * u, t[8] = i + n * s, t[1] = n + i * s, t[5] = a * c, t[9] = r - e1 * s, t[2] = -a * l, t[6] = s, t[10] = a * o;
                } else if ("ZYX" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = i * l - n, t[8] = e1 * l + r, t[1] = o * u, t[5] = r * l + e1, t[9] = n * l - i, t[2] = -l, t[6] = s * o, t[10] = a * o;
                } else if ("YZX" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = r - e1 * u, t[8] = i * u + n, t[1] = u, t[5] = a * c, t[9] = -s * c, t[2] = -l * c, t[6] = n * u + i, t[10] = e1 - r * u;
                } else if ("XZY" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = -u, t[8] = l * c, t[1] = e1 * u + r, t[5] = a * c, t[9] = n * u - i, t[2] = i * u - n, t[6] = s * c, t[10] = r * u + e1;
                }
                return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromQuaternion(e1) {
                return this.compose(hc, e1, dc);
            }
            lookAt(e1, t, n) {
                const i = this.elements;
                return gc.subVectors(e1, t), 0 === gc.lengthSq() && (gc.z = 1), gc.normalize(), pc.crossVectors(n, gc), 0 === pc.lengthSq() && (1 === Math.abs(n.z) ? gc.x += 1e-4 : gc.z += 1e-4, gc.normalize(), pc.crossVectors(n, gc)), pc.normalize(), fc.crossVectors(gc, pc), i[0] = pc.x, i[4] = fc.x, i[8] = gc.x, i[1] = pc.y, i[5] = fc.y, i[9] = gc.y, i[2] = pc.z, i[6] = fc.z, i[10] = gc.z, this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[4], o = n[8], l = n[12], c = n[1], u = n[5], h = n[9], d = n[13], p = n[2], f = n[6], g = n[10], m = n[14], A = n[3], M = n[7], v = n[11], y = n[15], x = i[0], b = i[4], w = i[8], E = i[12], T = i[1], S = i[5], I = i[9], N = i[13], D = i[2], _ = i[6], C = i[10], L = i[14], z = i[3], O = i[7], R = i[11], P = i[15];
                return r[0] = a * x + s * T + o * D + l * z, r[4] = a * b + s * S + o * _ + l * O, r[8] = a * w + s * I + o * C + l * R, r[12] = a * E + s * N + o * L + l * P, r[1] = c * x + u * T + h * D + d * z, r[5] = c * b + u * S + h * _ + d * O, r[9] = c * w + u * I + h * C + d * R, r[13] = c * E + u * N + h * L + d * P, r[2] = p * x + f * T + g * D + m * z, r[6] = p * b + f * S + g * _ + m * O, r[10] = p * w + f * I + g * C + m * R, r[14] = p * E + f * N + g * L + m * P, r[3] = A * x + M * T + v * D + y * z, r[7] = A * b + M * S + v * _ + y * O, r[11] = A * w + M * I + v * C + y * R, r[15] = A * E + M * N + v * L + y * P, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[4] *= e1, t[8] *= e1, t[12] *= e1, t[1] *= e1, t[5] *= e1, t[9] *= e1, t[13] *= e1, t[2] *= e1, t[6] *= e1, t[10] *= e1, t[14] *= e1, t[3] *= e1, t[7] *= e1, t[11] *= e1, t[15] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[4], i = e1[8], r = e1[12], a = e1[1], s = e1[5], o = e1[9], l = e1[13], c = e1[2], u = e1[6], h = e1[10], d = e1[14];
                return e1[3] * (+r * o * u - i * l * u - r * s * h + n * l * h + i * s * d - n * o * d) + e1[7] * (+t * o * d - t * l * h + r * a * h - i * a * d + i * l * c - r * o * c) + e1[11] * (+t * l * u - t * s * d - r * a * u + n * a * d + r * s * c - n * l * c) + e1[15] * (-i * s * c - t * o * u + t * s * h + i * a * u - n * a * h + n * o * c);
            }
            transpose() {
                const e1 = this.elements;
                let t;
                return t = e1[1], e1[1] = e1[4], e1[4] = t, t = e1[2], e1[2] = e1[8], e1[8] = t, t = e1[6], e1[6] = e1[9], e1[9] = t, t = e1[3], e1[3] = e1[12], e1[12] = t, t = e1[7], e1[7] = e1[13], e1[13] = t, t = e1[11], e1[11] = e1[14], e1[14] = t, this;
            }
            setPosition(e1, t, n) {
                const i = this.elements;
                return e1.isVector3 ? (i[12] = e1.x, i[13] = e1.y, i[14] = e1.z) : (i[12] = e1, i[13] = t, i[14] = n), this;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], d = e1[11], p = e1[12], f = e1[13], g = e1[14], m = e1[15], A = u * g * l - f * h * l + f * o * d - s * g * d - u * o * m + s * h * m, M = p * h * l - c * g * l - p * o * d + a * g * d + c * o * m - a * h * m, v = c * f * l - p * u * l + p * s * d - a * f * d - c * s * m + a * u * m, y = p * u * o - c * f * o - p * s * h + a * f * h + c * s * g - a * u * g, x = t * A + n * M + i * v + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const b = 1 / x;
                return e1[0] = A * b, e1[1] = (f * h * r - u * g * r - f * i * d + n * g * d + u * i * m - n * h * m) * b, e1[2] = (s * g * r - f * o * r + f * i * l - n * g * l - s * i * m + n * o * m) * b, e1[3] = (u * o * r - s * h * r - u * i * l + n * h * l + s * i * d - n * o * d) * b, e1[4] = M * b, e1[5] = (c * g * r - p * h * r + p * i * d - t * g * d - c * i * m + t * h * m) * b, e1[6] = (p * o * r - a * g * r - p * i * l + t * g * l + a * i * m - t * o * m) * b, e1[7] = (a * h * r - c * o * r + c * i * l - t * h * l - a * i * d + t * o * d) * b, e1[8] = v * b, e1[9] = (p * u * r - c * f * r - p * n * d + t * f * d + c * n * m - t * u * m) * b, e1[10] = (a * f * r - p * s * r + p * n * l - t * f * l - a * n * m + t * s * m) * b, e1[11] = (c * s * r - a * u * r - c * n * l + t * u * l + a * n * d - t * s * d) * b, e1[12] = y * b, e1[13] = (c * f * i - p * u * i + p * n * h - t * f * h - c * n * g + t * u * g) * b, e1[14] = (p * s * i - a * f * i - p * n * o + t * f * o + a * n * g - t * s * g) * b, e1[15] = (a * u * i - c * s * i + c * n * o - t * u * o - a * n * h + t * s * h) * b, this;
            }
            scale(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z;
                return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const e1 = this.elements, t = e1[0] * e1[0] + e1[1] * e1[1] + e1[2] * e1[2], n = e1[4] * e1[4] + e1[5] * e1[5] + e1[6] * e1[6], i = e1[8] * e1[8] + e1[9] * e1[9] + e1[10] * e1[10];
                return Math.sqrt(Math.max(t, n, i));
            }
            makeTranslation(e1, t, n) {
                return e1.isVector3 ? this.set(1, 0, 0, e1.x, 0, 1, 0, e1.y, 0, 0, 1, e1.z, 0, 0, 0, 1) : this.set(1, 0, 0, e1, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
            }
            makeRotationX(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = 1 - n, a = e1.x, s = e1.y, o = e1.z, l = r * a, c = r * s;
                return this.set(l * a + n, l * s - i * o, l * o + i * s, 0, l * s + i * o, c * s + n, c * o - i * a, 0, l * o - i * s, c * o + i * a, r * o * o + n, 0, 0, 0, 0, 1), this;
            }
            makeScale(e1, t, n) {
                return this.set(e1, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            }
            makeShear(e1, t, n, i, r, a) {
                return this.set(1, n, r, 0, e1, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this;
            }
            compose(e1, t, n) {
                const i = this.elements, r = t._x, a = t._y, s = t._z, o = t._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, g = a * u, m = s * u, A = o * l, M = o * c, v = o * u, y = n.x, x = n.y, b = n.z;
                return i[0] = (1 - (f + m)) * y, i[1] = (d + v) * y, i[2] = (p - M) * y, i[3] = 0, i[4] = (d - v) * x, i[5] = (1 - (h + m)) * x, i[6] = (g + A) * x, i[7] = 0, i[8] = (p + M) * b, i[9] = (g - A) * b, i[10] = (1 - (h + f)) * b, i[11] = 0, i[12] = e1.x, i[13] = e1.y, i[14] = e1.z, i[15] = 1, this;
            }
            decompose(e1, t, n) {
                const i = this.elements;
                let r = cc.set(i[0], i[1], i[2]).length();
                const a = cc.set(i[4], i[5], i[6]).length(), s = cc.set(i[8], i[9], i[10]).length();
                this.determinant() < 0 && (r = -r), e1.x = i[12], e1.y = i[13], e1.z = i[14], uc.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return uc.elements[0] *= o, uc.elements[1] *= o, uc.elements[2] *= o, uc.elements[4] *= l, uc.elements[5] *= l, uc.elements[6] *= l, uc.elements[8] *= c, uc.elements[9] *= c, uc.elements[10] *= c, t.setFromRotationMatrix(uc), n.x = r, n.y = a, n.z = s, this;
            }
            makePerspective(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Po;
                const o = this.elements, l = 2 * r / (t - e1), c = 2 * r / (n - i), u = (t + e1) / (t - e1), h = (n + i) / (n - i);
                let d, p;
                if (s === Po) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (s !== Uo) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Po;
                const o = this.elements, l = 1 / (t - e1), c = 1 / (n - i), u = 1 / (a - r), h = (t + e1) * l, d = (n + i) * c;
                let p, f;
                if (s === Po) p = (a + r) * u, f = -2 * u;
                else {
                    if (s !== Uo) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 16; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 16; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1[t + 9] = n[9], e1[t + 10] = n[10], e1[t + 11] = n[11], e1[t + 12] = n[12], e1[t + 13] = n[13], e1[t + 14] = n[14], e1[t + 15] = n[15], e1;
            }
        }
        const cc = new Ll, uc = new lc, hc = new Ll(0, 0, 0), dc = new Ll(1, 1, 1), pc = new Ll, fc = new Ll, gc = new Ll, mc = new lc, Ac = new Cl;
        class Mc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Mc.DEFAULT_ORDER;
                this.isEuler = !0, this._x = e1, this._y = t, this._z = n, this._order = i;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get order() {
                return this._order;
            }
            set order(e1) {
                this._order = e1, this._onChangeCallback();
            }
            set(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this._order;
                return this._x = e1, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
            copy(e1) {
                return this._x = e1._x, this._y = e1._y, this._z = e1._z, this._order = e1._order, this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._order, n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                const i = e1.elements, r = i[0], a = i[4], s = i[8], o = i[1], l = i[5], c = i[9], u = i[2], h = i[6], d = i[10];
                switch(t){
                    case "XYZ":
                        this._y = Math.asin(Vo(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(h, l), this._z = 0);
                        break;
                    case "YXZ":
                        this._x = Math.asin(-Vo(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                        break;
                    case "ZXY":
                        this._x = Math.asin(Vo(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                        break;
                    case "ZYX":
                        this._y = Math.asin(-Vo(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-a, l));
                        break;
                    case "YZX":
                        this._z = Math.asin(Vo(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(s, d));
                        break;
                    case "XZY":
                        this._z = Math.asin(-Vo(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
                        break;
                    default:
                        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
                }
                return this._order = t, !0 === n && this._onChangeCallback(), this;
            }
            setFromQuaternion(e1, t, n) {
                return mc.makeRotationFromQuaternion(e1), this.setFromRotationMatrix(mc, t, n);
            }
            setFromVector3(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._order;
                return this.set(e1.x, e1.y, e1.z, t);
            }
            reorder(e1) {
                return Ac.setFromEuler(this), this.setFromQuaternion(Ac, e1);
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._order === this._order;
            }
            fromArray(e1) {
                return this._x = e1[0], this._y = e1[1], this._z = e1[2], void 0 !== e1[3] && (this._order = e1[3]), this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._order, e1;
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._order;
            }
        }
        Mc.DEFAULT_ORDER = "XYZ";
        class vc {
            constructor(){
                this.mask = 1;
            }
            set(e1) {
                this.mask = 1 << e1 >>> 0;
            }
            enable(e1) {
                this.mask |= 1 << e1;
            }
            enableAll() {
                this.mask = -1;
            }
            toggle(e1) {
                this.mask ^= 1 << e1;
            }
            disable(e1) {
                this.mask &= ~(1 << e1);
            }
            disableAll() {
                this.mask = 0;
            }
            test(e1) {
                return !!(this.mask & e1.mask);
            }
            isEnabled(e1) {
                return !!(this.mask & 1 << e1);
            }
        }
        let yc = 0;
        const xc = new Ll, bc = new Cl, wc = new lc, Ec = new Ll, Tc = new Ll, Sc = new Ll, Ic = new Cl, Nc = new Ll(1, 0, 0), Dc = new Ll(0, 1, 0), _c = new Ll(0, 0, 1), Cc = {
            type: "added"
        }, Lc = {
            type: "removed"
        };
        class zc extends jo {
            constructor(){
                super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                    value: yc++
                }), this.uuid = Go(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = zc.DEFAULT_UP.clone();
                const e1 = new Ll, t = new Mc, n = new Cl, i = new Ll(1, 1, 1);
                t._onChange(function() {
                    n.setFromEuler(t, !1);
                }), n._onChange(function() {
                    t.setFromQuaternion(n, void 0, !1);
                }), Object.defineProperties(this, {
                    position: {
                        configurable: !0,
                        enumerable: !0,
                        value: e1
                    },
                    rotation: {
                        configurable: !0,
                        enumerable: !0,
                        value: t
                    },
                    quaternion: {
                        configurable: !0,
                        enumerable: !0,
                        value: n
                    },
                    scale: {
                        configurable: !0,
                        enumerable: !0,
                        value: i
                    },
                    modelViewMatrix: {
                        value: new lc
                    },
                    normalMatrix: {
                        value: new el
                    }
                }), this.matrix = new lc, this.matrixWorld = new lc, this.matrixAutoUpdate = zc.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = zc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new vc, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
            }
            onBeforeRender() {}
            onAfterRender() {}
            applyMatrix4(e1) {
                this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e1), this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
            applyQuaternion(e1) {
                return this.quaternion.premultiply(e1), this;
            }
            setRotationFromAxisAngle(e1, t) {
                this.quaternion.setFromAxisAngle(e1, t);
            }
            setRotationFromEuler(e1) {
                this.quaternion.setFromEuler(e1, !0);
            }
            setRotationFromMatrix(e1) {
                this.quaternion.setFromRotationMatrix(e1);
            }
            setRotationFromQuaternion(e1) {
                this.quaternion.copy(e1);
            }
            rotateOnAxis(e1, t) {
                return bc.setFromAxisAngle(e1, t), this.quaternion.multiply(bc), this;
            }
            rotateOnWorldAxis(e1, t) {
                return bc.setFromAxisAngle(e1, t), this.quaternion.premultiply(bc), this;
            }
            rotateX(e1) {
                return this.rotateOnAxis(Nc, e1);
            }
            rotateY(e1) {
                return this.rotateOnAxis(Dc, e1);
            }
            rotateZ(e1) {
                return this.rotateOnAxis(_c, e1);
            }
            translateOnAxis(e1, t) {
                return xc.copy(e1).applyQuaternion(this.quaternion), this.position.add(xc.multiplyScalar(t)), this;
            }
            translateX(e1) {
                return this.translateOnAxis(Nc, e1);
            }
            translateY(e1) {
                return this.translateOnAxis(Dc, e1);
            }
            translateZ(e1) {
                return this.translateOnAxis(_c, e1);
            }
            localToWorld(e1) {
                return this.updateWorldMatrix(!0, !1), e1.applyMatrix4(this.matrixWorld);
            }
            worldToLocal(e1) {
                return this.updateWorldMatrix(!0, !1), e1.applyMatrix4(wc.copy(this.matrixWorld).invert());
            }
            lookAt(e1, t, n) {
                e1.isVector3 ? Ec.copy(e1) : Ec.set(e1, t, n);
                const i = this.parent;
                this.updateWorldMatrix(!0, !1), Tc.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? wc.lookAt(Tc, Ec, this.up) : wc.lookAt(Ec, Tc, this.up), this.quaternion.setFromRotationMatrix(wc), i && (wc.extractRotation(i.matrixWorld), bc.setFromRotationMatrix(wc), this.quaternion.premultiply(bc.invert()));
            }
            add(e1) {
                if (arguments.length > 1) {
                    for(let e1 = 0; e1 < arguments.length; e1++)this.add(arguments[e1]);
                    return this;
                }
                return e1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e1), this) : (e1 && e1.isObject3D ? (null !== e1.parent && e1.parent.remove(e1), e1.parent = this, this.children.push(e1), e1.dispatchEvent(Cc)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e1), this);
            }
            remove(e1) {
                if (arguments.length > 1) {
                    for(let e1 = 0; e1 < arguments.length; e1++)this.remove(arguments[e1]);
                    return this;
                }
                const t = this.children.indexOf(e1);
                return -1 !== t && (e1.parent = null, this.children.splice(t, 1), e1.dispatchEvent(Lc)), this;
            }
            removeFromParent() {
                const e1 = this.parent;
                return null !== e1 && e1.remove(this), this;
            }
            clear() {
                return this.remove(...this.children);
            }
            attach(e1) {
                return this.updateWorldMatrix(!0, !1), wc.copy(this.matrixWorld).invert(), null !== e1.parent && (e1.parent.updateWorldMatrix(!0, !1), wc.multiply(e1.parent.matrixWorld)), e1.applyMatrix4(wc), this.add(e1), e1.updateWorldMatrix(!1, !0), this;
            }
            getObjectById(e1) {
                return this.getObjectByProperty("id", e1);
            }
            getObjectByName(e1) {
                return this.getObjectByProperty("name", e1);
            }
            getObjectByProperty(e1, t) {
                if (this[e1] === t) return this;
                for(let n = 0, i = this.children.length; n < i; n++){
                    const i = this.children[n].getObjectByProperty(e1, t);
                    if (void 0 !== i) return i;
                }
            }
            getObjectsByProperty(e1, t) {
                let n = [];
                this[e1] === t && n.push(this);
                for(let i = 0, r = this.children.length; i < r; i++){
                    const r = this.children[i].getObjectsByProperty(e1, t);
                    r.length > 0 && (n = n.concat(r));
                }
                return n;
            }
            getWorldPosition(e1) {
                return this.updateWorldMatrix(!0, !1), e1.setFromMatrixPosition(this.matrixWorld);
            }
            getWorldQuaternion(e1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Tc, e1, Sc), e1;
            }
            getWorldScale(e1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Tc, Ic, e1), e1;
            }
            getWorldDirection(e1) {
                this.updateWorldMatrix(!0, !1);
                const t = this.matrixWorld.elements;
                return e1.set(t[8], t[9], t[10]).normalize();
            }
            raycast() {}
            traverse(e1) {
                e1(this);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++)t[n].traverse(e1);
            }
            traverseVisible(e1) {
                if (!1 === this.visible) return;
                e1(this);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++)t[n].traverseVisible(e1);
            }
            traverseAncestors(e1) {
                const t = this.parent;
                null !== t && (e1(t), t.traverseAncestors(e1));
            }
            updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            }
            updateMatrixWorld(e1) {
                this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e1 = !0);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n];
                    !0 !== i.matrixWorldAutoUpdate && !0 !== e1 || i.updateMatrixWorld(e1);
                }
            }
            updateWorldMatrix(e1, t) {
                const n = this.parent;
                if (!0 === e1 && null !== n && !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === t) {
                    const e1 = this.children;
                    for(let t = 0, n = e1.length; t < n; t++){
                        const n = e1[t];
                        !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!1, !0);
                    }
                }
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1, n = {};
                t && (e1 = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                }, n.metadata = {
                    version: 4.6,
                    type: "Object",
                    generator: "Object3D.toJSON"
                });
                const i = {};
                function r(t, n) {
                    return void 0 === t[n.uuid] && (t[n.uuid] = n.toJSON(e1)), n.uuid;
                }
                if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (i.environment = this.environment.toJSON(e1).uuid);
                else if (this.isMesh || this.isLine || this.isPoints) {
                    i.geometry = r(e1.geometries, this.geometry);
                    const t = this.geometry.parameters;
                    if (void 0 !== t && void 0 !== t.shapes) {
                        const n = t.shapes;
                        if (Array.isArray(n)) for(let t = 0, i = n.length; t < i; t++){
                            const i = n[t];
                            r(e1.shapes, i);
                        }
                        else r(e1.shapes, n);
                    }
                }
                if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(e1.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                    if (Array.isArray(this.material)) {
                        const t = [];
                        for(let n = 0, i = this.material.length; n < i; n++)t.push(r(e1.materials, this.material[n]));
                        i.material = t;
                    } else i.material = r(e1.materials, this.material);
                }
                if (this.children.length > 0) {
                    i.children = [];
                    for(let t = 0; t < this.children.length; t++)i.children.push(this.children[t].toJSON(e1).object);
                }
                if (this.animations.length > 0) {
                    i.animations = [];
                    for(let t = 0; t < this.animations.length; t++){
                        const n = this.animations[t];
                        i.animations.push(r(e1.animations, n));
                    }
                }
                if (t) {
                    const t = a(e1.geometries), i = a(e1.materials), r = a(e1.textures), s = a(e1.images), o = a(e1.shapes), l = a(e1.skeletons), c = a(e1.animations), u = a(e1.nodes);
                    t.length > 0 && (n.geometries = t), i.length > 0 && (n.materials = i), r.length > 0 && (n.textures = r), s.length > 0 && (n.images = s), o.length > 0 && (n.shapes = o), l.length > 0 && (n.skeletons = l), c.length > 0 && (n.animations = c), u.length > 0 && (n.nodes = u);
                }
                return n.object = i, n;
                function a(e1) {
                    const t = [];
                    for(const n in e1){
                        const i = e1[n];
                        delete i.metadata, t.push(i);
                    }
                    return t;
                }
            }
            clone(e1) {
                return (new this.constructor).copy(this, e1);
            }
            copy(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                if (this.name = e1.name, this.up.copy(e1.up), this.position.copy(e1.position), this.rotation.order = e1.rotation.order, this.quaternion.copy(e1.quaternion), this.scale.copy(e1.scale), this.matrix.copy(e1.matrix), this.matrixWorld.copy(e1.matrixWorld), this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e1.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = e1.matrixWorldAutoUpdate, this.layers.mask = e1.layers.mask, this.visible = e1.visible, this.castShadow = e1.castShadow, this.receiveShadow = e1.receiveShadow, this.frustumCulled = e1.frustumCulled, this.renderOrder = e1.renderOrder, this.animations = e1.animations.slice(), this.userData = JSON.parse(JSON.stringify(e1.userData)), !0 === t) for(let t = 0; t < e1.children.length; t++){
                    const n = e1.children[t];
                    this.add(n.clone());
                }
                return this;
            }
        }
        zc.DEFAULT_UP = new Ll(0, 1, 0), zc.DEFAULT_MATRIX_AUTO_UPDATE = !0, zc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
        const Oc = new Ll, Rc = new Ll, Pc = new Ll, Uc = new Ll, jc = new Ll, kc = new Ll, Bc = new Ll, Fc = new Ll, Hc = new Ll, Gc = new Ll;
        let Vc = !1;
        class Qc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Ll;
                this.a = e1, this.b = t, this.c = n;
            }
            static getNormal(e1, t, n, i) {
                i.subVectors(n, t), Oc.subVectors(e1, t), i.cross(Oc);
                const r = i.lengthSq();
                return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
            }
            static getBarycoord(e1, t, n, i, r) {
                Oc.subVectors(i, t), Rc.subVectors(n, t), Pc.subVectors(e1, t);
                const a = Oc.dot(Oc), s = Oc.dot(Rc), o = Oc.dot(Pc), l = Rc.dot(Rc), c = Rc.dot(Pc), u = a * l - s * s;
                if (0 === u) return r.set(-2, -1, -1);
                const h = 1 / u, d = (l * o - s * c) * h, p = (a * c - s * o) * h;
                return r.set(1 - d - p, p, d);
            }
            static containsPoint(e1, t, n, i) {
                return this.getBarycoord(e1, t, n, i, Uc), Uc.x >= 0 && Uc.y >= 0 && Uc.x + Uc.y <= 1;
            }
            static getUV(e1, t, n, i, r, a, s, o) {
                return !1 === Vc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Vc = !0), this.getInterpolation(e1, t, n, i, r, a, s, o);
            }
            static getInterpolation(e1, t, n, i, r, a, s, o) {
                return this.getBarycoord(e1, t, n, i, Uc), o.setScalar(0), o.addScaledVector(r, Uc.x), o.addScaledVector(a, Uc.y), o.addScaledVector(s, Uc.z), o;
            }
            static isFrontFacing(e1, t, n, i) {
                return Oc.subVectors(n, t), Rc.subVectors(e1, t), Oc.cross(Rc).dot(i) < 0;
            }
            set(e1, t, n) {
                return this.a.copy(e1), this.b.copy(t), this.c.copy(n), this;
            }
            setFromPointsAndIndices(e1, t, n, i) {
                return this.a.copy(e1[t]), this.b.copy(e1[n]), this.c.copy(e1[i]), this;
            }
            setFromAttributeAndIndices(e1, t, n, i) {
                return this.a.fromBufferAttribute(e1, t), this.b.fromBufferAttribute(e1, n), this.c.fromBufferAttribute(e1, i), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.a.copy(e1.a), this.b.copy(e1.b), this.c.copy(e1.c), this;
            }
            getArea() {
                return Oc.subVectors(this.c, this.b), Rc.subVectors(this.a, this.b), .5 * Oc.cross(Rc).length();
            }
            getMidpoint(e1) {
                return e1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
            getNormal(e1) {
                return Qc.getNormal(this.a, this.b, this.c, e1);
            }
            getPlane(e1) {
                return e1.setFromCoplanarPoints(this.a, this.b, this.c);
            }
            getBarycoord(e1, t) {
                return Qc.getBarycoord(e1, this.a, this.b, this.c, t);
            }
            getUV(e1, t, n, i, r) {
                return !1 === Vc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Vc = !0), Qc.getInterpolation(e1, this.a, this.b, this.c, t, n, i, r);
            }
            getInterpolation(e1, t, n, i, r) {
                return Qc.getInterpolation(e1, this.a, this.b, this.c, t, n, i, r);
            }
            containsPoint(e1) {
                return Qc.containsPoint(e1, this.a, this.b, this.c);
            }
            isFrontFacing(e1) {
                return Qc.isFrontFacing(this.a, this.b, this.c, e1);
            }
            intersectsBox(e1) {
                return e1.intersectsTriangle(this);
            }
            closestPointToPoint(e1, t) {
                const n = this.a, i = this.b, r = this.c;
                let a, s;
                jc.subVectors(i, n), kc.subVectors(r, n), Fc.subVectors(e1, n);
                const o = jc.dot(Fc), l = kc.dot(Fc);
                if (o <= 0 && l <= 0) return t.copy(n);
                Hc.subVectors(e1, i);
                const c = jc.dot(Hc), u = kc.dot(Hc);
                if (c >= 0 && u <= c) return t.copy(i);
                const h = o * u - c * l;
                if (h <= 0 && o >= 0 && c <= 0) return a = o / (o - c), t.copy(n).addScaledVector(jc, a);
                Gc.subVectors(e1, r);
                const d = jc.dot(Gc), p = kc.dot(Gc);
                if (p >= 0 && d <= p) return t.copy(r);
                const f = d * l - o * p;
                if (f <= 0 && l >= 0 && p <= 0) return s = l / (l - p), t.copy(n).addScaledVector(kc, s);
                const g = c * p - d * u;
                if (g <= 0 && u - c >= 0 && d - p >= 0) return Bc.subVectors(r, i), s = (u - c) / (u - c + (d - p)), t.copy(i).addScaledVector(Bc, s);
                const m = 1 / (g + f + h);
                return a = f * m, s = h * m, t.copy(n).addScaledVector(jc, a).addScaledVector(kc, s);
            }
            equals(e1) {
                return e1.a.equals(this.a) && e1.b.equals(this.b) && e1.c.equals(this.c);
            }
        }
        const Wc = {
            aliceblue: 15792383,
            antiquewhite: 16444375,
            aqua: 65535,
            aquamarine: 8388564,
            azure: 15794175,
            beige: 16119260,
            bisque: 16770244,
            black: 0,
            blanchedalmond: 16772045,
            blue: 255,
            blueviolet: 9055202,
            brown: 10824234,
            burlywood: 14596231,
            cadetblue: 6266528,
            chartreuse: 8388352,
            chocolate: 13789470,
            coral: 16744272,
            cornflowerblue: 6591981,
            cornsilk: 16775388,
            crimson: 14423100,
            cyan: 65535,
            darkblue: 139,
            darkcyan: 35723,
            darkgoldenrod: 12092939,
            darkgray: 11119017,
            darkgreen: 25600,
            darkgrey: 11119017,
            darkkhaki: 12433259,
            darkmagenta: 9109643,
            darkolivegreen: 5597999,
            darkorange: 16747520,
            darkorchid: 10040012,
            darkred: 9109504,
            darksalmon: 15308410,
            darkseagreen: 9419919,
            darkslateblue: 4734347,
            darkslategray: 3100495,
            darkslategrey: 3100495,
            darkturquoise: 52945,
            darkviolet: 9699539,
            deeppink: 16716947,
            deepskyblue: 49151,
            dimgray: 6908265,
            dimgrey: 6908265,
            dodgerblue: 2003199,
            firebrick: 11674146,
            floralwhite: 16775920,
            forestgreen: 2263842,
            fuchsia: 16711935,
            gainsboro: 14474460,
            ghostwhite: 16316671,
            gold: 16766720,
            goldenrod: 14329120,
            gray: 8421504,
            green: 32768,
            greenyellow: 11403055,
            grey: 8421504,
            honeydew: 15794160,
            hotpink: 16738740,
            indianred: 13458524,
            indigo: 4915330,
            ivory: 16777200,
            khaki: 15787660,
            lavender: 15132410,
            lavenderblush: 16773365,
            lawngreen: 8190976,
            lemonchiffon: 16775885,
            lightblue: 11393254,
            lightcoral: 15761536,
            lightcyan: 14745599,
            lightgoldenrodyellow: 16448210,
            lightgray: 13882323,
            lightgreen: 9498256,
            lightgrey: 13882323,
            lightpink: 16758465,
            lightsalmon: 16752762,
            lightseagreen: 2142890,
            lightskyblue: 8900346,
            lightslategray: 7833753,
            lightslategrey: 7833753,
            lightsteelblue: 11584734,
            lightyellow: 16777184,
            lime: 65280,
            limegreen: 3329330,
            linen: 16445670,
            magenta: 16711935,
            maroon: 8388608,
            mediumaquamarine: 6737322,
            mediumblue: 205,
            mediumorchid: 12211667,
            mediumpurple: 9662683,
            mediumseagreen: 3978097,
            mediumslateblue: 8087790,
            mediumspringgreen: 64154,
            mediumturquoise: 4772300,
            mediumvioletred: 13047173,
            midnightblue: 1644912,
            mintcream: 16121850,
            mistyrose: 16770273,
            moccasin: 16770229,
            navajowhite: 16768685,
            navy: 128,
            oldlace: 16643558,
            olive: 8421376,
            olivedrab: 7048739,
            orange: 16753920,
            orangered: 16729344,
            orchid: 14315734,
            palegoldenrod: 15657130,
            palegreen: 10025880,
            paleturquoise: 11529966,
            palevioletred: 14381203,
            papayawhip: 16773077,
            peachpuff: 16767673,
            peru: 13468991,
            pink: 16761035,
            plum: 14524637,
            powderblue: 11591910,
            purple: 8388736,
            rebeccapurple: 6697881,
            red: 16711680,
            rosybrown: 12357519,
            royalblue: 4286945,
            saddlebrown: 9127187,
            salmon: 16416882,
            sandybrown: 16032864,
            seagreen: 3050327,
            seashell: 16774638,
            sienna: 10506797,
            silver: 12632256,
            skyblue: 8900331,
            slateblue: 6970061,
            slategray: 7372944,
            slategrey: 7372944,
            snow: 16775930,
            springgreen: 65407,
            steelblue: 4620980,
            tan: 13808780,
            teal: 32896,
            thistle: 14204888,
            tomato: 16737095,
            turquoise: 4251856,
            violet: 15631086,
            wheat: 16113331,
            white: 16777215,
            whitesmoke: 16119285,
            yellow: 16776960,
            yellowgreen: 10145074
        }, Yc = {
            h: 0,
            s: 0,
            l: 0
        }, Xc = {
            h: 0,
            s: 0,
            l: 0
        };
        function Zc(e1, t, n) {
            return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e1 + 6 * (t - e1) * n : n < .5 ? t : n < 2 / 3 ? e1 + 6 * (t - e1) * (2 / 3 - n) : e1;
        }
        class qc {
            constructor(e1, t, n){
                return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e1, t, n);
            }
            set(e1, t, n) {
                if (void 0 === t && void 0 === n) {
                    const t = e1;
                    t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t);
                } else this.setRGB(e1, t, n);
                return this;
            }
            setScalar(e1) {
                return this.r = e1, this.g = e1, this.b = e1, this;
            }
            setHex(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qs;
                return e1 = Math.floor(e1), this.r = (e1 >> 16 & 255) / 255, this.g = (e1 >> 8 & 255) / 255, this.b = (255 & e1) / 255, pl.toWorkingColorSpace(this, t), this;
            }
            setRGB(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : pl.workingColorSpace;
                return this.r = e1, this.g = t, this.b = n, pl.toWorkingColorSpace(this, i), this;
            }
            setHSL(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : pl.workingColorSpace;
                if (e1 = Qo(e1, 1), t = Vo(t, 0, 1), n = Vo(n, 0, 1), 0 === t) this.r = this.g = this.b = n;
                else {
                    const i = n <= .5 ? n * (1 + t) : n + t - n * t, r = 2 * n - i;
                    this.r = Zc(r, i, e1 + 1 / 3), this.g = Zc(r, i, e1), this.b = Zc(r, i, e1 - 1 / 3);
                }
                return pl.toWorkingColorSpace(this, i), this;
            }
            setStyle(e1) {
                let t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qs;
                function i(t) {
                    void 0 !== t && parseFloat(t) < 1 && console.warn("THREE.Color: Alpha component of " + e1 + " will be ignored.");
                }
                if (t = /^(\w+)\(([^\)]*)\)/.exec(e1)) {
                    let r;
                    const a = t[1], s = t[2];
                    switch(a){
                        case "rgb":
                        case "rgba":
                            if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, n);
                            if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, n);
                            break;
                        case "hsl":
                        case "hsla":
                            if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, n);
                            break;
                        default:
                            console.warn("THREE.Color: Unknown color model " + e1);
                    }
                } else if (t = /^\#([A-Fa-f\d]+)$/.exec(e1)) {
                    const i = t[1], r = i.length;
                    if (3 === r) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, n);
                    if (6 === r) return this.setHex(parseInt(i, 16), n);
                    console.warn("THREE.Color: Invalid hex color " + e1);
                } else if (e1 && e1.length > 0) return this.setColorName(e1, n);
                return this;
            }
            setColorName(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Qs;
                const n = Wc[e1.toLowerCase()];
                return void 0 !== n ? this.setHex(n, t) : console.warn("THREE.Color: Unknown color " + e1), this;
            }
            clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
            copy(e1) {
                return this.r = e1.r, this.g = e1.g, this.b = e1.b, this;
            }
            copySRGBToLinear(e1) {
                return this.r = fl(e1.r), this.g = fl(e1.g), this.b = fl(e1.b), this;
            }
            copyLinearToSRGB(e1) {
                return this.r = gl(e1.r), this.g = gl(e1.g), this.b = gl(e1.b), this;
            }
            convertSRGBToLinear() {
                return this.copySRGBToLinear(this), this;
            }
            convertLinearToSRGB() {
                return this.copyLinearToSRGB(this), this;
            }
            getHex() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Qs;
                return pl.fromWorkingColorSpace(Kc.copy(this), e1), 65536 * Math.round(Vo(255 * Kc.r, 0, 255)) + 256 * Math.round(Vo(255 * Kc.g, 0, 255)) + Math.round(Vo(255 * Kc.b, 0, 255));
            }
            getHexString() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Qs;
                return ("000000" + this.getHex(e1).toString(16)).slice(-6);
            }
            getHSL(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pl.workingColorSpace;
                pl.fromWorkingColorSpace(Kc.copy(this), t);
                const n = Kc.r, i = Kc.g, r = Kc.b, a = Math.max(n, i, r), s = Math.min(n, i, r);
                let o, l;
                const c = (s + a) / 2;
                if (s === a) o = 0, l = 0;
                else {
                    const e1 = a - s;
                    switch(l = c <= .5 ? e1 / (a + s) : e1 / (2 - a - s), a){
                        case n:
                            o = (i - r) / e1 + (i < r ? 6 : 0);
                            break;
                        case i:
                            o = (r - n) / e1 + 2;
                            break;
                        case r:
                            o = (n - i) / e1 + 4;
                    }
                    o /= 6;
                }
                return e1.h = o, e1.s = l, e1.l = c, e1;
            }
            getRGB(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pl.workingColorSpace;
                return pl.fromWorkingColorSpace(Kc.copy(this), t), e1.r = Kc.r, e1.g = Kc.g, e1.b = Kc.b, e1;
            }
            getStyle() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Qs;
                pl.fromWorkingColorSpace(Kc.copy(this), e1);
                const t = Kc.r, n = Kc.g, i = Kc.b;
                return e1 !== Qs ? `color(${e1} ${t.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})` : `rgb(${Math.round(255 * t)},${Math.round(255 * n)},${Math.round(255 * i)})`;
            }
            offsetHSL(e1, t, n) {
                return this.getHSL(Yc), this.setHSL(Yc.h + e1, Yc.s + t, Yc.l + n);
            }
            add(e1) {
                return this.r += e1.r, this.g += e1.g, this.b += e1.b, this;
            }
            addColors(e1, t) {
                return this.r = e1.r + t.r, this.g = e1.g + t.g, this.b = e1.b + t.b, this;
            }
            addScalar(e1) {
                return this.r += e1, this.g += e1, this.b += e1, this;
            }
            sub(e1) {
                return this.r = Math.max(0, this.r - e1.r), this.g = Math.max(0, this.g - e1.g), this.b = Math.max(0, this.b - e1.b), this;
            }
            multiply(e1) {
                return this.r *= e1.r, this.g *= e1.g, this.b *= e1.b, this;
            }
            multiplyScalar(e1) {
                return this.r *= e1, this.g *= e1, this.b *= e1, this;
            }
            lerp(e1, t) {
                return this.r += (e1.r - this.r) * t, this.g += (e1.g - this.g) * t, this.b += (e1.b - this.b) * t, this;
            }
            lerpColors(e1, t, n) {
                return this.r = e1.r + (t.r - e1.r) * n, this.g = e1.g + (t.g - e1.g) * n, this.b = e1.b + (t.b - e1.b) * n, this;
            }
            lerpHSL(e1, t) {
                this.getHSL(Yc), e1.getHSL(Xc);
                const n = Wo(Yc.h, Xc.h, t), i = Wo(Yc.s, Xc.s, t), r = Wo(Yc.l, Xc.l, t);
                return this.setHSL(n, i, r), this;
            }
            setFromVector3(e1) {
                return this.r = e1.x, this.g = e1.y, this.b = e1.z, this;
            }
            applyMatrix3(e1) {
                const t = this.r, n = this.g, i = this.b, r = e1.elements;
                return this.r = r[0] * t + r[3] * n + r[6] * i, this.g = r[1] * t + r[4] * n + r[7] * i, this.b = r[2] * t + r[5] * n + r[8] * i, this;
            }
            equals(e1) {
                return e1.r === this.r && e1.g === this.g && e1.b === this.b;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.r = e1[t], this.g = e1[t + 1], this.b = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.r, e1[t + 1] = this.g, e1[t + 2] = this.b, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.r = e1.getX(t), this.g = e1.getY(t), this.b = e1.getZ(t), this;
            }
            toJSON() {
                return this.getHex();
            }
            *[Symbol.iterator]() {
                yield this.r, yield this.g, yield this.b;
            }
        }
        const Kc = new qc;
        qc.NAMES = Wc;
        let Jc = 0;
        class $c extends jo {
            constructor(){
                super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                    value: Jc++
                }), this.uuid = Go(), this.name = "", this.type = "Material", this.blending = gr, this.side = ur, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Dr, this.blendDst = _r, this.blendEquation = yr, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new qc(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Gr, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = go, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = eo, this.stencilZFail = eo, this.stencilZPass = eo, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
            }
            get alphaTest() {
                return this._alphaTest;
            }
            set alphaTest(e1) {
                this._alphaTest > 0 != e1 > 0 && this.version++, this._alphaTest = e1;
            }
            onBuild() {}
            onBeforeRender() {}
            onBeforeCompile() {}
            customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
            setValues(e1) {
                if (void 0 !== e1) for(const t in e1){
                    const n = e1[t];
                    if (void 0 === n) {
                        console.warn(`THREE.Material: parameter '${t}' has value of undefined.`);
                        continue;
                    }
                    const i = this[t];
                    void 0 !== i ? i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n : console.warn(`THREE.Material: '${t}' is not a property of THREE.${this.type}.`);
                }
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                t && (e1 = {
                    textures: {},
                    images: {}
                });
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Material",
                        generator: "Material.toJSON"
                    }
                };
                function i(e1) {
                    const t = [];
                    for(const n in e1){
                        const i = e1[n];
                        delete i.metadata, t.push(i);
                    }
                    return t;
                }
                if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e1).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (n.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (n.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e1).uuid), void 0 !== this.anisotropy && (n.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e1).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e1).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e1).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e1).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e1).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e1).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e1).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e1).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e1).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e1).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e1).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e1).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e1).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e1).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== gr && (n.blending = this.blending), this.side !== ur && (n.side = this.side), !0 === this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = !0), this.blendSrc !== Dr && (n.blendSrc = this.blendSrc), this.blendDst !== _r && (n.blendDst = this.blendDst), this.blendEquation !== yr && (n.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (n.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (n.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (n.blendAlpha = this.blendAlpha), this.depthFunc !== Gr && (n.depthFunc = this.depthFunc), !1 === this.depthTest && (n.depthTest = this.depthTest), !1 === this.depthWrite && (n.depthWrite = this.depthWrite), !1 === this.colorWrite && (n.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== go && (n.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (n.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== eo && (n.stencilFail = this.stencilFail), this.stencilZFail !== eo && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== eo && (n.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (n.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaHash && (n.alphaHash = !0), !0 === this.alphaToCoverage && (n.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = !0), !0 === this.forceSinglePass && (n.forceSinglePass = !0), !0 === this.wireframe && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = !0), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), !1 === this.fog && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData), t) {
                    const t = i(e1.textures), r = i(e1.images);
                    t.length > 0 && (n.textures = t), r.length > 0 && (n.images = r);
                }
                return n;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.name = e1.name, this.blending = e1.blending, this.side = e1.side, this.vertexColors = e1.vertexColors, this.opacity = e1.opacity, this.transparent = e1.transparent, this.blendSrc = e1.blendSrc, this.blendDst = e1.blendDst, this.blendEquation = e1.blendEquation, this.blendSrcAlpha = e1.blendSrcAlpha, this.blendDstAlpha = e1.blendDstAlpha, this.blendEquationAlpha = e1.blendEquationAlpha, this.blendColor.copy(e1.blendColor), this.blendAlpha = e1.blendAlpha, this.depthFunc = e1.depthFunc, this.depthTest = e1.depthTest, this.depthWrite = e1.depthWrite, this.stencilWriteMask = e1.stencilWriteMask, this.stencilFunc = e1.stencilFunc, this.stencilRef = e1.stencilRef, this.stencilFuncMask = e1.stencilFuncMask, this.stencilFail = e1.stencilFail, this.stencilZFail = e1.stencilZFail, this.stencilZPass = e1.stencilZPass, this.stencilWrite = e1.stencilWrite;
                const t = e1.clippingPlanes;
                let n = null;
                if (null !== t) {
                    const e1 = t.length;
                    n = new Array(e1);
                    for(let i = 0; i !== e1; ++i)n[i] = t[i].clone();
                }
                return this.clippingPlanes = n, this.clipIntersection = e1.clipIntersection, this.clipShadows = e1.clipShadows, this.shadowSide = e1.shadowSide, this.colorWrite = e1.colorWrite, this.precision = e1.precision, this.polygonOffset = e1.polygonOffset, this.polygonOffsetFactor = e1.polygonOffsetFactor, this.polygonOffsetUnits = e1.polygonOffsetUnits, this.dithering = e1.dithering, this.alphaTest = e1.alphaTest, this.alphaHash = e1.alphaHash, this.alphaToCoverage = e1.alphaToCoverage, this.premultipliedAlpha = e1.premultipliedAlpha, this.forceSinglePass = e1.forceSinglePass, this.visible = e1.visible, this.toneMapped = e1.toneMapped, this.userData = JSON.parse(JSON.stringify(e1.userData)), this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
        }
        class eu extends $c {
            constructor(e1){
                super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new qc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Xr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.fog = e1.fog, this;
            }
        }
        const tu = nu();
        function nu() {
            const e1 = new ArrayBuffer(4), t = new Float32Array(e1), n = new Uint32Array(e1), i = new Uint32Array(512), r = new Uint32Array(512);
            for(let e1 = 0; e1 < 256; ++e1){
                const t = e1 - 127;
                t < -27 ? (i[e1] = 0, i[256 | e1] = 32768, r[e1] = 24, r[256 | e1] = 24) : t < -14 ? (i[e1] = 1024 >> -t - 14, i[256 | e1] = 1024 >> -t - 14 | 32768, r[e1] = -t - 1, r[256 | e1] = -t - 1) : t <= 15 ? (i[e1] = t + 15 << 10, i[256 | e1] = t + 15 << 10 | 32768, r[e1] = 13, r[256 | e1] = 13) : t < 128 ? (i[e1] = 31744, i[256 | e1] = 64512, r[e1] = 24, r[256 | e1] = 24) : (i[e1] = 31744, i[256 | e1] = 64512, r[e1] = 13, r[256 | e1] = 13);
            }
            const a = new Uint32Array(2048), s = new Uint32Array(64), o = new Uint32Array(64);
            for(let e1 = 1; e1 < 1024; ++e1){
                let t = e1 << 13, n = 0;
                for(; !(8388608 & t);)t <<= 1, n -= 8388608;
                t &= -8388609, n += 947912704, a[e1] = t | n;
            }
            for(let e1 = 1024; e1 < 2048; ++e1)a[e1] = 939524096 + (e1 - 1024 << 13);
            for(let e1 = 1; e1 < 31; ++e1)s[e1] = e1 << 23;
            s[31] = 1199570944, s[32] = 2147483648;
            for(let e1 = 33; e1 < 63; ++e1)s[e1] = 2147483648 + (e1 - 32 << 23);
            s[63] = 3347054592;
            for(let e1 = 1; e1 < 64; ++e1)32 !== e1 && (o[e1] = 1024);
            return {
                floatView: t,
                uint32View: n,
                baseTable: i,
                shiftTable: r,
                mantissaTable: a,
                exponentTable: s,
                offsetTable: o
            };
        }
        function iu(e1) {
            Math.abs(e1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), e1 = Vo(e1, -65504, 65504), tu.floatView[0] = e1;
            const t = tu.uint32View[0], n = t >> 23 & 511;
            return tu.baseTable[n] + ((8388607 & t) >> tu.shiftTable[n]);
        }
        function ru(e1) {
            const t = e1 >> 10;
            return tu.uint32View[0] = tu.mantissaTable[tu.offsetTable[t] + (1023 & e1)] + tu.exponentTable[t], tu.floatView[0];
        }
        const au = {
            toHalfFloat: iu,
            fromHalfFloat: ru
        }, su = new Ll, ou = new $o;
        class lu {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (Array.isArray(e1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                this.isBufferAttribute = !0, this.name = "", this.array = e1, this.itemSize = t, this.count = void 0 !== e1 ? e1.length / t : 0, this.normalized = n, this.usage = Eo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.gpuType = _a, this.version = 0;
            }
            onUploadCallback() {}
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            copy(e1) {
                return this.name = e1.name, this.array = new e1.array.constructor(e1.array), this.itemSize = e1.itemSize, this.count = e1.count, this.normalized = e1.normalized, this.usage = e1.usage, this.gpuType = e1.gpuType, this;
            }
            copyAt(e1, t, n) {
                e1 *= this.itemSize, n *= t.itemSize;
                for(let i = 0, r = this.itemSize; i < r; i++)this.array[e1 + i] = t.array[n + i];
                return this;
            }
            copyArray(e1) {
                return this.array.set(e1), this;
            }
            applyMatrix3(e1) {
                if (2 === this.itemSize) for(let t = 0, n = this.count; t < n; t++)ou.fromBufferAttribute(this, t), ou.applyMatrix3(e1), this.setXY(t, ou.x, ou.y);
                else if (3 === this.itemSize) for(let t = 0, n = this.count; t < n; t++)su.fromBufferAttribute(this, t), su.applyMatrix3(e1), this.setXYZ(t, su.x, su.y, su.z);
                return this;
            }
            applyMatrix4(e1) {
                for(let t = 0, n = this.count; t < n; t++)su.fromBufferAttribute(this, t), su.applyMatrix4(e1), this.setXYZ(t, su.x, su.y, su.z);
                return this;
            }
            applyNormalMatrix(e1) {
                for(let t = 0, n = this.count; t < n; t++)su.fromBufferAttribute(this, t), su.applyNormalMatrix(e1), this.setXYZ(t, su.x, su.y, su.z);
                return this;
            }
            transformDirection(e1) {
                for(let t = 0, n = this.count; t < n; t++)su.fromBufferAttribute(this, t), su.transformDirection(e1), this.setXYZ(t, su.x, su.y, su.z);
                return this;
            }
            set(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.array.set(e1, t), this;
            }
            getComponent(e1, t) {
                let n = this.array[e1 * this.itemSize + t];
                return this.normalized && (n = qo(n, this.array)), n;
            }
            setComponent(e1, t, n) {
                return this.normalized && (n = Ko(n, this.array)), this.array[e1 * this.itemSize + t] = n, this;
            }
            getX(e1) {
                let t = this.array[e1 * this.itemSize];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setX(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize] = t, this;
            }
            getY(e1) {
                let t = this.array[e1 * this.itemSize + 1];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setY(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 1] = t, this;
            }
            getZ(e1) {
                let t = this.array[e1 * this.itemSize + 2];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setZ(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 2] = t, this;
            }
            getW(e1) {
                let t = this.array[e1 * this.itemSize + 3];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setW(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 3] = t, this;
            }
            setXY(e1, t, n) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this;
            }
            setXYZ(e1, t, n, i) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this.array[e1 + 2] = i, this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this.array[e1 + 2] = i, this.array[e1 + 3] = r, this;
            }
            onUpload(e1) {
                return this.onUploadCallback = e1, this;
            }
            clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
            toJSON() {
                const e1 = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                return "" !== this.name && (e1.name = this.name), this.usage !== Eo && (e1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (e1.updateRange = this.updateRange), e1;
            }
        }
        class cu extends lu {
            constructor(e1, t, n){
                super(new Int8Array(e1), t, n);
            }
        }
        class uu extends lu {
            constructor(e1, t, n){
                super(new Uint8Array(e1), t, n);
            }
        }
        class hu extends lu {
            constructor(e1, t, n){
                super(new Uint8ClampedArray(e1), t, n);
            }
        }
        class du extends lu {
            constructor(e1, t, n){
                super(new Int16Array(e1), t, n);
            }
        }
        class pu extends lu {
            constructor(e1, t, n){
                super(new Uint16Array(e1), t, n);
            }
        }
        class fu extends lu {
            constructor(e1, t, n){
                super(new Int32Array(e1), t, n);
            }
        }
        class gu extends lu {
            constructor(e1, t, n){
                super(new Uint32Array(e1), t, n);
            }
        }
        class mu extends lu {
            constructor(e1, t, n){
                super(new Uint16Array(e1), t, n), this.isFloat16BufferAttribute = !0;
            }
            getX(e1) {
                let t = ru(this.array[e1 * this.itemSize]);
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setX(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize] = iu(t), this;
            }
            getY(e1) {
                let t = ru(this.array[e1 * this.itemSize + 1]);
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setY(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 1] = iu(t), this;
            }
            getZ(e1) {
                let t = ru(this.array[e1 * this.itemSize + 2]);
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setZ(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 2] = iu(t), this;
            }
            getW(e1) {
                let t = ru(this.array[e1 * this.itemSize + 3]);
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setW(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.array[e1 * this.itemSize + 3] = iu(t), this;
            }
            setXY(e1, t, n) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array)), this.array[e1 + 0] = iu(t), this.array[e1 + 1] = iu(n), this;
            }
            setXYZ(e1, t, n, i) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.array[e1 + 0] = iu(t), this.array[e1 + 1] = iu(n), this.array[e1 + 2] = iu(i), this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 *= this.itemSize, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.array[e1 + 0] = iu(t), this.array[e1 + 1] = iu(n), this.array[e1 + 2] = iu(i), this.array[e1 + 3] = iu(r), this;
            }
        }
        class Au extends lu {
            constructor(e1, t, n){
                super(new Float32Array(e1), t, n);
            }
        }
        class Mu extends lu {
            constructor(e1, t, n){
                super(new Float64Array(e1), t, n);
            }
        }
        let vu = 0;
        const yu = new lc, xu = new zc, bu = new Ll, wu = new Rl, Eu = new Rl, Tu = new Ll;
        class Su extends jo {
            constructor(){
                super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                    value: vu++
                }), this.uuid = Go(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                    start: 0,
                    count: 1 / 0
                }, this.userData = {};
            }
            getIndex() {
                return this.index;
            }
            setIndex(e1) {
                return Array.isArray(e1) ? this.index = new (nl(e1) ? gu : pu)(e1, 1) : this.index = e1, this;
            }
            getAttribute(e1) {
                return this.attributes[e1];
            }
            setAttribute(e1, t) {
                return this.attributes[e1] = t, this;
            }
            deleteAttribute(e1) {
                return delete this.attributes[e1], this;
            }
            hasAttribute(e1) {
                return void 0 !== this.attributes[e1];
            }
            addGroup(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                this.groups.push({
                    start: e1,
                    count: t,
                    materialIndex: n
                });
            }
            clearGroups() {
                this.groups = [];
            }
            setDrawRange(e1, t) {
                this.drawRange.start = e1, this.drawRange.count = t;
            }
            applyMatrix4(e1) {
                const t = this.attributes.position;
                void 0 !== t && (t.applyMatrix4(e1), t.needsUpdate = !0);
                const n = this.attributes.normal;
                if (void 0 !== n) {
                    const t = (new el).getNormalMatrix(e1);
                    n.applyNormalMatrix(t), n.needsUpdate = !0;
                }
                const i = this.attributes.tangent;
                return void 0 !== i && (i.transformDirection(e1), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            }
            applyQuaternion(e1) {
                return yu.makeRotationFromQuaternion(e1), this.applyMatrix4(yu), this;
            }
            rotateX(e1) {
                return yu.makeRotationX(e1), this.applyMatrix4(yu), this;
            }
            rotateY(e1) {
                return yu.makeRotationY(e1), this.applyMatrix4(yu), this;
            }
            rotateZ(e1) {
                return yu.makeRotationZ(e1), this.applyMatrix4(yu), this;
            }
            translate(e1, t, n) {
                return yu.makeTranslation(e1, t, n), this.applyMatrix4(yu), this;
            }
            scale(e1, t, n) {
                return yu.makeScale(e1, t, n), this.applyMatrix4(yu), this;
            }
            lookAt(e1) {
                return xu.lookAt(e1), xu.updateMatrix(), this.applyMatrix4(xu.matrix), this;
            }
            center() {
                return this.computeBoundingBox(), this.boundingBox.getCenter(bu).negate(), this.translate(bu.x, bu.y, bu.z), this;
            }
            setFromPoints(e1) {
                const t = [];
                for(let n = 0, i = e1.length; n < i; n++){
                    const i = e1[n];
                    t.push(i.x, i.y, i.z || 0);
                }
                return this.setAttribute("position", new Au(t, 3)), this;
            }
            computeBoundingBox() {
                null === this.boundingBox && (this.boundingBox = new Rl);
                const e1 = this.attributes.position, t = this.morphAttributes.position;
                if (e1 && e1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new Ll(-1 / 0, -1 / 0, -1 / 0), new Ll(1 / 0, 1 / 0, 1 / 0));
                if (void 0 !== e1) {
                    if (this.boundingBox.setFromBufferAttribute(e1), t) for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        wu.setFromBufferAttribute(n), this.morphTargetsRelative ? (Tu.addVectors(this.boundingBox.min, wu.min), this.boundingBox.expandByPoint(Tu), Tu.addVectors(this.boundingBox.max, wu.max), this.boundingBox.expandByPoint(Tu)) : (this.boundingBox.expandByPoint(wu.min), this.boundingBox.expandByPoint(wu.max));
                    }
                } else this.boundingBox.makeEmpty();
                (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
            computeBoundingSphere() {
                null === this.boundingSphere && (this.boundingSphere = new $l);
                const e1 = this.attributes.position, t = this.morphAttributes.position;
                if (e1 && e1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new Ll, 1 / 0);
                if (e1) {
                    const n = this.boundingSphere.center;
                    if (wu.setFromBufferAttribute(e1), t) for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        Eu.setFromBufferAttribute(n), this.morphTargetsRelative ? (Tu.addVectors(wu.min, Eu.min), wu.expandByPoint(Tu), Tu.addVectors(wu.max, Eu.max), wu.expandByPoint(Tu)) : (wu.expandByPoint(Eu.min), wu.expandByPoint(Eu.max));
                    }
                    wu.getCenter(n);
                    let i = 0;
                    for(let t = 0, r = e1.count; t < r; t++)Tu.fromBufferAttribute(e1, t), i = Math.max(i, n.distanceToSquared(Tu));
                    if (t) for(let r = 0, a = t.length; r < a; r++){
                        const a = t[r], s = this.morphTargetsRelative;
                        for(let t = 0, r = a.count; t < r; t++)Tu.fromBufferAttribute(a, t), s && (bu.fromBufferAttribute(e1, t), Tu.add(bu)), i = Math.max(i, n.distanceToSquared(Tu));
                    }
                    this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
            computeTangents() {
                const e1 = this.index, t = this.attributes;
                if (null === e1 || void 0 === t.position || void 0 === t.normal || void 0 === t.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                const n = e1.array, i = t.position.array, r = t.normal.array, a = t.uv.array, s = i.length / 3;
                !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new lu(new Float32Array(4 * s), 4));
                const o = this.getAttribute("tangent").array, l = [], c = [];
                for(let e1 = 0; e1 < s; e1++)l[e1] = new Ll, c[e1] = new Ll;
                const u = new Ll, h = new Ll, d = new Ll, p = new $o, f = new $o, g = new $o, m = new Ll, A = new Ll;
                function M(e1, t, n) {
                    u.fromArray(i, 3 * e1), h.fromArray(i, 3 * t), d.fromArray(i, 3 * n), p.fromArray(a, 2 * e1), f.fromArray(a, 2 * t), g.fromArray(a, 2 * n), h.sub(u), d.sub(u), f.sub(p), g.sub(p);
                    const r = 1 / (f.x * g.y - g.x * f.y);
                    isFinite(r) && (m.copy(h).multiplyScalar(g.y).addScaledVector(d, -f.y).multiplyScalar(r), A.copy(d).multiplyScalar(f.x).addScaledVector(h, -g.x).multiplyScalar(r), l[e1].add(m), l[t].add(m), l[n].add(m), c[e1].add(A), c[t].add(A), c[n].add(A));
                }
                let v = this.groups;
                0 === v.length && (v = [
                    {
                        start: 0,
                        count: n.length
                    }
                ]);
                for(let e1 = 0, t = v.length; e1 < t; ++e1){
                    const t = v[e1], i = t.start;
                    for(let e1 = i, r = i + t.count; e1 < r; e1 += 3)M(n[e1 + 0], n[e1 + 1], n[e1 + 2]);
                }
                const y = new Ll, x = new Ll, b = new Ll, w = new Ll;
                function E(e1) {
                    b.fromArray(r, 3 * e1), w.copy(b);
                    const t = l[e1];
                    y.copy(t), y.sub(b.multiplyScalar(b.dot(t))).normalize(), x.crossVectors(w, t);
                    const n = x.dot(c[e1]) < 0 ? -1 : 1;
                    o[4 * e1] = y.x, o[4 * e1 + 1] = y.y, o[4 * e1 + 2] = y.z, o[4 * e1 + 3] = n;
                }
                for(let e1 = 0, t = v.length; e1 < t; ++e1){
                    const t = v[e1], i = t.start;
                    for(let e1 = i, r = i + t.count; e1 < r; e1 += 3)E(n[e1 + 0]), E(n[e1 + 1]), E(n[e1 + 2]);
                }
            }
            computeVertexNormals() {
                const e1 = this.index, t = this.getAttribute("position");
                if (void 0 !== t) {
                    let n = this.getAttribute("normal");
                    if (void 0 === n) n = new lu(new Float32Array(3 * t.count), 3), this.setAttribute("normal", n);
                    else for(let e1 = 0, t = n.count; e1 < t; e1++)n.setXYZ(e1, 0, 0, 0);
                    const i = new Ll, r = new Ll, a = new Ll, s = new Ll, o = new Ll, l = new Ll, c = new Ll, u = new Ll;
                    if (e1) for(let h = 0, d = e1.count; h < d; h += 3){
                        const d = e1.getX(h + 0), p = e1.getX(h + 1), f = e1.getX(h + 2);
                        i.fromBufferAttribute(t, d), r.fromBufferAttribute(t, p), a.fromBufferAttribute(t, f), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), s.fromBufferAttribute(n, d), o.fromBufferAttribute(n, p), l.fromBufferAttribute(n, f), s.add(c), o.add(c), l.add(c), n.setXYZ(d, s.x, s.y, s.z), n.setXYZ(p, o.x, o.y, o.z), n.setXYZ(f, l.x, l.y, l.z);
                    }
                    else for(let e1 = 0, s = t.count; e1 < s; e1 += 3)i.fromBufferAttribute(t, e1 + 0), r.fromBufferAttribute(t, e1 + 1), a.fromBufferAttribute(t, e1 + 2), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), n.setXYZ(e1 + 0, c.x, c.y, c.z), n.setXYZ(e1 + 1, c.x, c.y, c.z), n.setXYZ(e1 + 2, c.x, c.y, c.z);
                    this.normalizeNormals(), n.needsUpdate = !0;
                }
            }
            normalizeNormals() {
                const e1 = this.attributes.normal;
                for(let t = 0, n = e1.count; t < n; t++)Tu.fromBufferAttribute(e1, t), Tu.normalize(), e1.setXYZ(t, Tu.x, Tu.y, Tu.z);
            }
            toNonIndexed() {
                function e1(e1, t) {
                    const n = e1.array, i = e1.itemSize, r = e1.normalized, a = new n.constructor(t.length * i);
                    let s = 0, o = 0;
                    for(let r = 0, l = t.length; r < l; r++){
                        s = e1.isInterleavedBufferAttribute ? t[r] * e1.data.stride + e1.offset : t[r] * i;
                        for(let e1 = 0; e1 < i; e1++)a[o++] = n[s++];
                    }
                    return new lu(a, i, r);
                }
                if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                const t = new Su, n = this.index.array, i = this.attributes;
                for(const r in i){
                    const a = e1(i[r], n);
                    t.setAttribute(r, a);
                }
                const r = this.morphAttributes;
                for(const i in r){
                    const a = [], s = r[i];
                    for(let t = 0, i = s.length; t < i; t++){
                        const i = e1(s[t], n);
                        a.push(i);
                    }
                    t.morphAttributes[i] = a;
                }
                t.morphTargetsRelative = this.morphTargetsRelative;
                const a = this.groups;
                for(let e1 = 0, n = a.length; e1 < n; e1++){
                    const n = a[e1];
                    t.addGroup(n.start, n.count, n.materialIndex);
                }
                return t;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "BufferGeometry",
                        generator: "BufferGeometry.toJSON"
                    }
                };
                if (e1.uuid = this.uuid, e1.type = this.type, "" !== this.name && (e1.name = this.name), Object.keys(this.userData).length > 0 && (e1.userData = this.userData), void 0 !== this.parameters) {
                    const t = this.parameters;
                    for(const n in t)void 0 !== t[n] && (e1[n] = t[n]);
                    return e1;
                }
                e1.data = {
                    attributes: {}
                };
                const t = this.index;
                null !== t && (e1.data.index = {
                    type: t.array.constructor.name,
                    array: Array.prototype.slice.call(t.array)
                });
                const n = this.attributes;
                for(const t in n){
                    const i = n[t];
                    e1.data.attributes[t] = i.toJSON(e1.data);
                }
                const i = {};
                let r = !1;
                for(const t in this.morphAttributes){
                    const n = this.morphAttributes[t], a = [];
                    for(let t = 0, i = n.length; t < i; t++){
                        const i = n[t];
                        a.push(i.toJSON(e1.data));
                    }
                    a.length > 0 && (i[t] = a, r = !0);
                }
                r && (e1.data.morphAttributes = i, e1.data.morphTargetsRelative = this.morphTargetsRelative);
                const a = this.groups;
                a.length > 0 && (e1.data.groups = JSON.parse(JSON.stringify(a)));
                const s = this.boundingSphere;
                return null !== s && (e1.data.boundingSphere = {
                    center: s.center.toArray(),
                    radius: s.radius
                }), e1;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                const t = {};
                this.name = e1.name;
                const n = e1.index;
                null !== n && this.setIndex(n.clone(t));
                const i = e1.attributes;
                for(const e1 in i){
                    const n = i[e1];
                    this.setAttribute(e1, n.clone(t));
                }
                const r = e1.morphAttributes;
                for(const e1 in r){
                    const n = [], i = r[e1];
                    for(let e1 = 0, r = i.length; e1 < r; e1++)n.push(i[e1].clone(t));
                    this.morphAttributes[e1] = n;
                }
                this.morphTargetsRelative = e1.morphTargetsRelative;
                const a = e1.groups;
                for(let e1 = 0, t = a.length; e1 < t; e1++){
                    const t = a[e1];
                    this.addGroup(t.start, t.count, t.materialIndex);
                }
                const s = e1.boundingBox;
                null !== s && (this.boundingBox = s.clone());
                const o = e1.boundingSphere;
                return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = e1.drawRange.start, this.drawRange.count = e1.drawRange.count, this.userData = e1.userData, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        const Iu = new lc, Nu = new oc, Du = new $l, _u = new Ll, Cu = new Ll, Lu = new Ll, zu = new Ll, Ou = new Ll, Ru = new Ll, Pu = new $o, Uu = new $o, ju = new $o, ku = new Ll, Bu = new Ll, Fu = new Ll, Hu = new Ll, Gu = new Ll;
        class Vu extends zc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Su, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new eu;
                super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), void 0 !== e1.morphTargetInfluences && (this.morphTargetInfluences = e1.morphTargetInfluences.slice()), void 0 !== e1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, e1.morphTargetDictionary)), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
            getVertexPosition(e1, t) {
                const n = this.geometry, i = n.attributes.position, r = n.morphAttributes.position, a = n.morphTargetsRelative;
                t.fromBufferAttribute(i, e1);
                const s = this.morphTargetInfluences;
                if (r && s) {
                    Ru.set(0, 0, 0);
                    for(let n = 0, i = r.length; n < i; n++){
                        const i = s[n], o = r[n];
                        0 !== i && (Ou.fromBufferAttribute(o, e1), a ? Ru.addScaledVector(Ou, i) : Ru.addScaledVector(Ou.sub(t), i));
                    }
                    t.add(Ru);
                }
                return t;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.material, r = this.matrixWorld;
                if (void 0 !== i) {
                    if (null === n.boundingSphere && n.computeBoundingSphere(), Du.copy(n.boundingSphere), Du.applyMatrix4(r), Nu.copy(e1.ray).recast(e1.near), !1 === Du.containsPoint(Nu.origin)) {
                        if (null === Nu.intersectSphere(Du, _u)) return;
                        if (Nu.origin.distanceToSquared(_u) > (e1.far - e1.near) ** 2) return;
                    }
                    Iu.copy(r).invert(), Nu.copy(e1.ray).applyMatrix4(Iu), null !== n.boundingBox && !1 === Nu.intersectsBox(n.boundingBox) || this._computeIntersections(e1, t, Nu);
                }
            }
            _computeIntersections(e1, t, n) {
                let i;
                const r = this.geometry, a = this.material, s = r.index, o = r.attributes.position, l = r.attributes.uv, c = r.attributes.uv1, u = r.attributes.normal, h = r.groups, d = r.drawRange;
                if (null !== s) {
                    if (Array.isArray(a)) for(let r = 0, o = h.length; r < o; r++){
                        const o = h[r], p = a[o.materialIndex];
                        for(let r = Math.max(o.start, d.start), a = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); r < a; r += 3)i = Qu(this, p, e1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = o.materialIndex, t.push(i));
                    }
                    else for(let r = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); r < o; r += 3)i = Qu(this, a, e1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), t.push(i));
                } else if (void 0 !== o) {
                    if (Array.isArray(a)) for(let r = 0, s = h.length; r < s; r++){
                        const s = h[r], p = a[s.materialIndex];
                        for(let r = Math.max(s.start, d.start), a = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); r < a; r += 3)i = Qu(this, p, e1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = s.materialIndex, t.push(i));
                    }
                    else for(let r = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); r < s; r += 3)i = Qu(this, a, e1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), t.push(i));
                }
            }
        }
        function Qu(e1, t, n, i, r, a, s, o, l, c) {
            e1.getVertexPosition(o, Cu), e1.getVertexPosition(l, Lu), e1.getVertexPosition(c, zu);
            const u = function(e1, t, n, i, r, a, s, o) {
                let l;
                if (l = t.side === hr ? i.intersectTriangle(s, a, r, !0, o) : i.intersectTriangle(r, a, s, t.side === ur, o), null === l) return null;
                Gu.copy(o), Gu.applyMatrix4(e1.matrixWorld);
                const c = n.ray.origin.distanceTo(Gu);
                return c < n.near || c > n.far ? null : {
                    distance: c,
                    point: Gu.clone(),
                    object: e1
                };
            }(e1, t, n, i, Cu, Lu, zu, Hu);
            if (u) {
                r && (Pu.fromBufferAttribute(r, o), Uu.fromBufferAttribute(r, l), ju.fromBufferAttribute(r, c), u.uv = Qc.getInterpolation(Hu, Cu, Lu, zu, Pu, Uu, ju, new $o)), a && (Pu.fromBufferAttribute(a, o), Uu.fromBufferAttribute(a, l), ju.fromBufferAttribute(a, c), u.uv1 = Qc.getInterpolation(Hu, Cu, Lu, zu, Pu, Uu, ju, new $o), u.uv2 = u.uv1), s && (ku.fromBufferAttribute(s, o), Bu.fromBufferAttribute(s, l), Fu.fromBufferAttribute(s, c), u.normal = Qc.getInterpolation(Hu, Cu, Lu, zu, ku, Bu, Fu, new Ll), u.normal.dot(i.direction) > 0 && u.normal.multiplyScalar(-1));
                const e1 = {
                    a: o,
                    b: l,
                    c: c,
                    normal: new Ll,
                    materialIndex: 0
                };
                Qc.getNormal(Cu, Lu, zu, e1.normal), u.face = e1;
            }
            return u;
        }
        class Wu extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1;
                super(), this.type = "BoxGeometry", this.parameters = {
                    width: e1,
                    height: t,
                    depth: n,
                    widthSegments: i,
                    heightSegments: r,
                    depthSegments: a
                };
                const s = this;
                i = Math.floor(i), r = Math.floor(r), a = Math.floor(a);
                const o = [], l = [], c = [], u = [];
                let h = 0, d = 0;
                function p(e1, t, n, i, r, a, p, f, g, m, A) {
                    const M = a / g, v = p / m, y = a / 2, x = p / 2, b = f / 2, w = g + 1, E = m + 1;
                    let T = 0, S = 0;
                    const I = new Ll;
                    for(let a = 0; a < E; a++){
                        const s = a * v - x;
                        for(let o = 0; o < w; o++){
                            const h = o * M - y;
                            I[e1] = h * i, I[t] = s * r, I[n] = b, l.push(I.x, I.y, I.z), I[e1] = 0, I[t] = 0, I[n] = f > 0 ? 1 : -1, c.push(I.x, I.y, I.z), u.push(o / g), u.push(1 - a / m), T += 1;
                        }
                    }
                    for(let e1 = 0; e1 < m; e1++)for(let t = 0; t < g; t++){
                        const n = h + t + w * e1, i = h + t + w * (e1 + 1), r = h + (t + 1) + w * (e1 + 1), a = h + (t + 1) + w * e1;
                        o.push(n, i, a), o.push(i, r, a), S += 6;
                    }
                    s.addGroup(d, S, A), d += S, h += T;
                }
                p("z", "y", "x", -1, -1, n, t, e1, a, r, 0), p("z", "y", "x", 1, -1, n, t, -e1, a, r, 1), p("x", "z", "y", 1, 1, e1, n, t, i, a, 2), p("x", "z", "y", 1, -1, e1, n, -t, i, a, 3), p("x", "y", "z", 1, -1, e1, t, n, i, r, 4), p("x", "y", "z", -1, -1, e1, t, -n, i, r, 5), this.setIndex(o), this.setAttribute("position", new Au(l, 3)), this.setAttribute("normal", new Au(c, 3)), this.setAttribute("uv", new Au(u, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Wu(e1.width, e1.height, e1.depth, e1.widthSegments, e1.heightSegments, e1.depthSegments);
            }
        }
        function Yu(e1) {
            const t = {};
            for(const n in e1){
                t[n] = {};
                for(const i in e1[n]){
                    const r = e1[n][i];
                    r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[n][i] = null) : t[n][i] = r.clone() : Array.isArray(r) ? t[n][i] = r.slice() : t[n][i] = r;
                }
            }
            return t;
        }
        function Xu(e1) {
            const t = {};
            for(let n = 0; n < e1.length; n++){
                const i = Yu(e1[n]);
                for(const e1 in i)t[e1] = i[e1];
            }
            return t;
        }
        function Zu(e1) {
            return null === e1.getRenderTarget() ? e1.outputColorSpace : pl.workingColorSpace;
        }
        const qu = {
            clone: Yu,
            merge: Xu
        };
        class Ku extends $c {
            constructor(e1){
                super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                    derivatives: !1,
                    fragDepth: !1,
                    drawBuffers: !1,
                    shaderTextureLOD: !1
                }, this.defaultAttributeValues = {
                    color: [
                        1,
                        1,
                        1
                    ],
                    uv: [
                        0,
                        0
                    ],
                    uv1: [
                        0,
                        0
                    ]
                }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== e1 && this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.fragmentShader = e1.fragmentShader, this.vertexShader = e1.vertexShader, this.uniforms = Yu(e1.uniforms), this.uniformsGroups = function(e1) {
                    const t = [];
                    for(let n = 0; n < e1.length; n++)t.push(e1[n].clone());
                    return t;
                }(e1.uniformsGroups), this.defines = Object.assign({}, e1.defines), this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.fog = e1.fog, this.lights = e1.lights, this.clipping = e1.clipping, this.extensions = Object.assign({}, e1.extensions), this.glslVersion = e1.glslVersion, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                t.glslVersion = this.glslVersion, t.uniforms = {};
                for(const n in this.uniforms){
                    const i = this.uniforms[n].value;
                    i && i.isTexture ? t.uniforms[n] = {
                        type: "t",
                        value: i.toJSON(e1).uuid
                    } : i && i.isColor ? t.uniforms[n] = {
                        type: "c",
                        value: i.getHex()
                    } : i && i.isVector2 ? t.uniforms[n] = {
                        type: "v2",
                        value: i.toArray()
                    } : i && i.isVector3 ? t.uniforms[n] = {
                        type: "v3",
                        value: i.toArray()
                    } : i && i.isVector4 ? t.uniforms[n] = {
                        type: "v4",
                        value: i.toArray()
                    } : i && i.isMatrix3 ? t.uniforms[n] = {
                        type: "m3",
                        value: i.toArray()
                    } : i && i.isMatrix4 ? t.uniforms[n] = {
                        type: "m4",
                        value: i.toArray()
                    } : t.uniforms[n] = {
                        value: i
                    };
                }
                Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
                const n = {};
                for(const e1 in this.extensions)!0 === this.extensions[e1] && (n[e1] = !0);
                return Object.keys(n).length > 0 && (t.extensions = n), t;
            }
        }
        class Ju extends zc {
            constructor(){
                super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new lc, this.projectionMatrix = new lc, this.projectionMatrixInverse = new lc, this.coordinateSystem = Po;
            }
            copy(e1, t) {
                return super.copy(e1, t), this.matrixWorldInverse.copy(e1.matrixWorldInverse), this.projectionMatrix.copy(e1.projectionMatrix), this.projectionMatrixInverse.copy(e1.projectionMatrixInverse), this.coordinateSystem = e1.coordinateSystem, this;
            }
            getWorldDirection(e1) {
                return super.getWorldDirection(e1).negate();
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            updateWorldMatrix(e1, t) {
                super.updateWorldMatrix(e1, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class $u extends Ju {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 50, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2e3;
                super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e1, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.fov = e1.fov, this.zoom = e1.zoom, this.near = e1.near, this.far = e1.far, this.focus = e1.focus, this.aspect = e1.aspect, this.view = null === e1.view ? null : Object.assign({}, e1.view), this.filmGauge = e1.filmGauge, this.filmOffset = e1.filmOffset, this;
            }
            setFocalLength(e1) {
                const t = .5 * this.getFilmHeight() / e1;
                this.fov = 2 * Ho * Math.atan(t), this.updateProjectionMatrix();
            }
            getFocalLength() {
                const e1 = Math.tan(.5 * Fo * this.fov);
                return .5 * this.getFilmHeight() / e1;
            }
            getEffectiveFOV() {
                return 2 * Ho * Math.atan(Math.tan(.5 * Fo * this.fov) / this.zoom);
            }
            getFilmWidth() {
                return this.filmGauge * Math.min(this.aspect, 1);
            }
            getFilmHeight() {
                return this.filmGauge / Math.max(this.aspect, 1);
            }
            setViewOffset(e1, t, n, i, r, a) {
                this.aspect = e1 / t, null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const e1 = this.near;
                let t = e1 * Math.tan(.5 * Fo * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, r = -0.5 * i;
                const a = this.view;
                if (null !== this.view && this.view.enabled) {
                    const e1 = a.fullWidth, s = a.fullHeight;
                    r += a.offsetX * i / e1, t -= a.offsetY * n / s, i *= a.width / e1, n *= a.height / s;
                }
                const s = this.filmOffset;
                0 !== s && (r += e1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, t, t - n, e1, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
            }
        }
        const eh = -90;
        class th extends zc {
            constructor(e1, t, n){
                super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                const i = new $u(eh, 1, e1, t);
                i.layers = this.layers, this.add(i);
                const r = new $u(eh, 1, e1, t);
                r.layers = this.layers, this.add(r);
                const a = new $u(eh, 1, e1, t);
                a.layers = this.layers, this.add(a);
                const s = new $u(eh, 1, e1, t);
                s.layers = this.layers, this.add(s);
                const o = new $u(eh, 1, e1, t);
                o.layers = this.layers, this.add(o);
                const l = new $u(eh, 1, e1, t);
                l.layers = this.layers, this.add(l);
            }
            updateCoordinateSystem() {
                const e1 = this.coordinateSystem, t = this.children.concat(), [n, i, r, a, s, o] = t;
                for (const e1 of t)this.remove(e1);
                if (e1 === Po) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
                else {
                    if (e1 !== Uo) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e1);
                    n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
                }
                for (const e1 of t)this.add(e1), e1.updateMatrixWorld();
            }
            update(e1, t) {
                null === this.parent && this.updateMatrixWorld();
                const { renderTarget: n, activeMipmapLevel: i } = this;
                this.coordinateSystem !== e1.coordinateSystem && (this.coordinateSystem = e1.coordinateSystem, this.updateCoordinateSystem());
                const [r, a, s, o, l, c] = this.children, u = e1.getRenderTarget(), h = e1.getActiveCubeFace(), d = e1.getActiveMipmapLevel(), p = e1.xr.enabled;
                e1.xr.enabled = !1;
                const f = n.texture.generateMipmaps;
                n.texture.generateMipmaps = !1, e1.setRenderTarget(n, 0, i), e1.render(t, r), e1.setRenderTarget(n, 1, i), e1.render(t, a), e1.setRenderTarget(n, 2, i), e1.render(t, s), e1.setRenderTarget(n, 3, i), e1.render(t, o), e1.setRenderTarget(n, 4, i), e1.render(t, l), n.texture.generateMipmaps = f, e1.setRenderTarget(n, 5, i), e1.render(t, c), e1.setRenderTarget(u, h, d), e1.xr.enabled = p, n.texture.needsPMREMUpdate = !0;
            }
        }
        class nh extends bl {
            constructor(e1, t, n, i, r, a, s, o, l, c){
                super(e1 = void 0 !== e1 ? e1 : [], t = void 0 !== t ? t : sa, n, i, r, a, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
            }
            get images() {
                return this.image;
            }
            set images(e1) {
                this.image = e1;
            }
        }
        class ih extends Tl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                super(e1, e1, t), this.isWebGLCubeRenderTarget = !0;
                const n = {
                    width: e1,
                    height: e1,
                    depth: 1
                }, i = [
                    n,
                    n,
                    n,
                    n,
                    n,
                    n
                ];
                void 0 !== t.encoding && (ll("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), t.colorSpace = t.encoding === ks ? Qs : Vs), this.texture = new nh(i, t.mapping, t.wrapS, t.wrapT, t.magFilter, t.minFilter, t.format, t.type, t.anisotropy, t.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== t.generateMipmaps && t.generateMipmaps, this.texture.minFilter = void 0 !== t.minFilter ? t.minFilter : va;
            }
            fromEquirectangularTexture(e1, t) {
                this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
                const n = {
                    tEquirect: {
                        value: null
                    }
                }, i = "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t", r = "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t", a = new Wu(5, 5, 5), s = new Ku({
                    name: "CubemapFromEquirect",
                    uniforms: Yu(n),
                    vertexShader: i,
                    fragmentShader: r,
                    side: hr,
                    blending: fr
                });
                s.uniforms.tEquirect.value = t;
                const o = new Vu(a, s), l = t.minFilter;
                return t.minFilter === ba && (t.minFilter = va), new th(1, 10, this).update(e1, o), t.minFilter = l, o.geometry.dispose(), o.material.dispose(), this;
            }
            clear(e1, t, n, i) {
                const r = e1.getRenderTarget();
                for(let r = 0; r < 6; r++)e1.setRenderTarget(this, r), e1.clear(t, n, i);
                e1.setRenderTarget(r);
            }
        }
        const rh = new Ll, ah = new Ll, sh = new el;
        class oh {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll(1, 0, 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                this.isPlane = !0, this.normal = e1, this.constant = t;
            }
            set(e1, t) {
                return this.normal.copy(e1), this.constant = t, this;
            }
            setComponents(e1, t, n, i) {
                return this.normal.set(e1, t, n), this.constant = i, this;
            }
            setFromNormalAndCoplanarPoint(e1, t) {
                return this.normal.copy(e1), this.constant = -t.dot(this.normal), this;
            }
            setFromCoplanarPoints(e1, t, n) {
                const i = rh.subVectors(n, t).cross(ah.subVectors(e1, t)).normalize();
                return this.setFromNormalAndCoplanarPoint(i, e1), this;
            }
            copy(e1) {
                return this.normal.copy(e1.normal), this.constant = e1.constant, this;
            }
            normalize() {
                const e1 = 1 / this.normal.length();
                return this.normal.multiplyScalar(e1), this.constant *= e1, this;
            }
            negate() {
                return this.constant *= -1, this.normal.negate(), this;
            }
            distanceToPoint(e1) {
                return this.normal.dot(e1) + this.constant;
            }
            distanceToSphere(e1) {
                return this.distanceToPoint(e1.center) - e1.radius;
            }
            projectPoint(e1, t) {
                return t.copy(e1).addScaledVector(this.normal, -this.distanceToPoint(e1));
            }
            intersectLine(e1, t) {
                const n = e1.delta(rh), i = this.normal.dot(n);
                if (0 === i) return 0 === this.distanceToPoint(e1.start) ? t.copy(e1.start) : null;
                const r = -(e1.start.dot(this.normal) + this.constant) / i;
                return r < 0 || r > 1 ? null : t.copy(e1.start).addScaledVector(n, r);
            }
            intersectsLine(e1) {
                const t = this.distanceToPoint(e1.start), n = this.distanceToPoint(e1.end);
                return t < 0 && n > 0 || n < 0 && t > 0;
            }
            intersectsBox(e1) {
                return e1.intersectsPlane(this);
            }
            intersectsSphere(e1) {
                return e1.intersectsPlane(this);
            }
            coplanarPoint(e1) {
                return e1.copy(this.normal).multiplyScalar(-this.constant);
            }
            applyMatrix4(e1, t) {
                const n = t || sh.getNormalMatrix(e1), i = this.coplanarPoint(rh).applyMatrix4(e1), r = this.normal.applyMatrix3(n).normalize();
                return this.constant = -i.dot(r), this;
            }
            translate(e1) {
                return this.constant -= e1.dot(this.normal), this;
            }
            equals(e1) {
                return e1.normal.equals(this.normal) && e1.constant === this.constant;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const lh = new $l, ch = new Ll;
        class uh {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new oh, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new oh, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new oh, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new oh, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : new oh, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : new oh;
                this.planes = [
                    e1,
                    t,
                    n,
                    i,
                    r,
                    a
                ];
            }
            set(e1, t, n, i, r, a) {
                const s = this.planes;
                return s[0].copy(e1), s[1].copy(t), s[2].copy(n), s[3].copy(i), s[4].copy(r), s[5].copy(a), this;
            }
            copy(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++)t[n].copy(e1.planes[n]);
                return this;
            }
            setFromProjectionMatrix(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Po;
                const n = this.planes, i = e1.elements, r = i[0], a = i[1], s = i[2], o = i[3], l = i[4], c = i[5], u = i[6], h = i[7], d = i[8], p = i[9], f = i[10], g = i[11], m = i[12], A = i[13], M = i[14], v = i[15];
                if (n[0].setComponents(o - r, h - l, g - d, v - m).normalize(), n[1].setComponents(o + r, h + l, g + d, v + m).normalize(), n[2].setComponents(o + a, h + c, g + p, v + A).normalize(), n[3].setComponents(o - a, h - c, g - p, v - A).normalize(), n[4].setComponents(o - s, h - u, g - f, v - M).normalize(), t === Po) n[5].setComponents(o + s, h + u, g + f, v + M).normalize();
                else {
                    if (t !== Uo) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
                    n[5].setComponents(s, u, f, M).normalize();
                }
                return this;
            }
            intersectsObject(e1) {
                if (void 0 !== e1.boundingSphere) null === e1.boundingSphere && e1.computeBoundingSphere(), lh.copy(e1.boundingSphere).applyMatrix4(e1.matrixWorld);
                else {
                    const t = e1.geometry;
                    null === t.boundingSphere && t.computeBoundingSphere(), lh.copy(t.boundingSphere).applyMatrix4(e1.matrixWorld);
                }
                return this.intersectsSphere(lh);
            }
            intersectsSprite(e1) {
                return lh.center.set(0, 0, 0), lh.radius = .7071067811865476, lh.applyMatrix4(e1.matrixWorld), this.intersectsSphere(lh);
            }
            intersectsSphere(e1) {
                const t = this.planes, n = e1.center, i = -e1.radius;
                for(let e1 = 0; e1 < 6; e1++)if (t[e1].distanceToPoint(n) < i) return !1;
                return !0;
            }
            intersectsBox(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++){
                    const i = t[n];
                    if (ch.x = i.normal.x > 0 ? e1.max.x : e1.min.x, ch.y = i.normal.y > 0 ? e1.max.y : e1.min.y, ch.z = i.normal.z > 0 ? e1.max.z : e1.min.z, i.distanceToPoint(ch) < 0) return !1;
                }
                return !0;
            }
            containsPoint(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++)if (t[n].distanceToPoint(e1) < 0) return !1;
                return !0;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        function hh() {
            let e1 = null, t = !1, n = null, i = null;
            function r(t, a) {
                n(t, a), i = e1.requestAnimationFrame(r);
            }
            return {
                start: function() {
                    !0 !== t && null !== n && (i = e1.requestAnimationFrame(r), t = !0);
                },
                stop: function() {
                    e1.cancelAnimationFrame(i), t = !1;
                },
                setAnimationLoop: function(e1) {
                    n = e1;
                },
                setContext: function(t) {
                    e1 = t;
                }
            };
        }
        function dh(e1, t) {
            const n = t.isWebGL2, i = new WeakMap;
            return {
                get: function(e1) {
                    return e1.isInterleavedBufferAttribute && (e1 = e1.data), i.get(e1);
                },
                remove: function(t) {
                    t.isInterleavedBufferAttribute && (t = t.data);
                    const n = i.get(t);
                    n && (e1.deleteBuffer(n.buffer), i.delete(t));
                },
                update: function(t, r) {
                    if (t.isGLBufferAttribute) {
                        const e1 = i.get(t);
                        return void ((!e1 || e1.version < t.version) && i.set(t, {
                            buffer: t.buffer,
                            type: t.type,
                            bytesPerElement: t.elementSize,
                            version: t.version
                        }));
                    }
                    t.isInterleavedBufferAttribute && (t = t.data);
                    const a = i.get(t);
                    void 0 === a ? i.set(t, function(t, i) {
                        const r = t.array, a = t.usage, s = e1.createBuffer();
                        let o;
                        if (e1.bindBuffer(i, s), e1.bufferData(i, r, a), t.onUploadCallback(), r instanceof Float32Array) o = e1.FLOAT;
                        else if (r instanceof Uint16Array) {
                            if (t.isFloat16BufferAttribute) {
                                if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                                o = e1.HALF_FLOAT;
                            } else o = e1.UNSIGNED_SHORT;
                        } else if (r instanceof Int16Array) o = e1.SHORT;
                        else if (r instanceof Uint32Array) o = e1.UNSIGNED_INT;
                        else if (r instanceof Int32Array) o = e1.INT;
                        else if (r instanceof Int8Array) o = e1.BYTE;
                        else if (r instanceof Uint8Array) o = e1.UNSIGNED_BYTE;
                        else {
                            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                            o = e1.UNSIGNED_BYTE;
                        }
                        return {
                            buffer: s,
                            type: o,
                            bytesPerElement: r.BYTES_PER_ELEMENT,
                            version: t.version
                        };
                    }(t, r)) : a.version < t.version && (function(t, i, r) {
                        const a = i.array, s = i.updateRange;
                        e1.bindBuffer(r, t), -1 === s.count ? e1.bufferSubData(r, 0, a) : (n ? e1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a, s.offset, s.count) : e1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a.subarray(s.offset, s.offset + s.count)), s.count = -1), i.onUploadCallback();
                    }(a.buffer, t, r), a.version = t.version);
                }
            };
        }
        class ph extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(), this.type = "PlaneGeometry", this.parameters = {
                    width: e1,
                    height: t,
                    widthSegments: n,
                    heightSegments: i
                };
                const r = e1 / 2, a = t / 2, s = Math.floor(n), o = Math.floor(i), l = s + 1, c = o + 1, u = e1 / s, h = t / o, d = [], p = [], f = [], g = [];
                for(let e1 = 0; e1 < c; e1++){
                    const t = e1 * h - a;
                    for(let n = 0; n < l; n++){
                        const i = n * u - r;
                        p.push(i, -t, 0), f.push(0, 0, 1), g.push(n / s), g.push(1 - e1 / o);
                    }
                }
                for(let e1 = 0; e1 < o; e1++)for(let t = 0; t < s; t++){
                    const n = t + l * e1, i = t + l * (e1 + 1), r = t + 1 + l * (e1 + 1), a = t + 1 + l * e1;
                    d.push(n, i, a), d.push(i, r, a);
                }
                this.setIndex(d), this.setAttribute("position", new Au(p, 3)), this.setAttribute("normal", new Au(f, 3)), this.setAttribute("uv", new Au(g, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new ph(e1.width, e1.height, e1.widthSegments, e1.heightSegments);
            }
        }
        const fh = {
            alphahash_fragment: "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
            alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif",
            alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
            alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
            alphatest_fragment: "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
            alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
            aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
            aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
            begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif",
            beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
            bsdfs: "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
            iridescence_fragment: "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
            bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
            clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
            clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
            clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
            clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
            color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
            color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
            color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
            color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
            common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
            cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
            defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
            displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
            displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
            emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
            emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
            colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
            colorspace_pars_fragment: "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n\tvec3( 0.8224621, 0.177538, 0.0 ),\n\tvec3( 0.0331941, 0.9668058, 0.0 ),\n\tvec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.2249401, - 0.2249404, 0.0 ),\n\tvec3( - 0.0420569, 1.0420571, 0.0 ),\n\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn sRGBTransferOETF( value );\n}",
            envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
            envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
            envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
            envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
            envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
            envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
            fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
            fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
            fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
            fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
            gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
            lightmap_fragment: "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
            lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
            lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
            lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
            lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
            lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
            lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
            lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
            lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
            lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tanisotropyV /= material.anisotropy;\n\tmaterial.anisotropy = saturate( material.anisotropy );\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
            lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
            lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
            lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
            lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
            logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
            logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
            logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
            logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
            map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
            map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
            map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
            map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
            metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
            metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
            morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
            morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif",
            morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif",
            morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif",
            normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
            normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
            normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
            normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
            normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
            normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
            clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
            clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
            clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
            iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
            opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
            packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}",
            premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
            project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
            dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
            dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
            roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
            roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
            shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
            shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
            shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
            shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
            skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
            skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif",
            skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
            skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
            specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
            specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
            tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
            tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
            transmission_fragment: "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
            transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
            uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
            uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
            uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
            worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
            background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
            background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
            backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
            backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
            cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
            cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
            depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
            depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
            distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
            distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
            equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
            equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
            linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
            linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
            meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
            meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
            meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
            meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
            meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
            meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
            meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
            meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
            meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
            points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
            points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
            shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
            shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}",
            sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
            sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}"
        }, gh = {
            common: {
                diffuse: {
                    value: new qc(16777215)
                },
                opacity: {
                    value: 1
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new el
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                }
            },
            specularmap: {
                specularMap: {
                    value: null
                },
                specularMapTransform: {
                    value: new el
                }
            },
            envmap: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                },
                reflectivity: {
                    value: 1
                },
                ior: {
                    value: 1.5
                },
                refractionRatio: {
                    value: .98
                }
            },
            aomap: {
                aoMap: {
                    value: null
                },
                aoMapIntensity: {
                    value: 1
                },
                aoMapTransform: {
                    value: new el
                }
            },
            lightmap: {
                lightMap: {
                    value: null
                },
                lightMapIntensity: {
                    value: 1
                },
                lightMapTransform: {
                    value: new el
                }
            },
            bumpmap: {
                bumpMap: {
                    value: null
                },
                bumpMapTransform: {
                    value: new el
                },
                bumpScale: {
                    value: 1
                }
            },
            normalmap: {
                normalMap: {
                    value: null
                },
                normalMapTransform: {
                    value: new el
                },
                normalScale: {
                    value: new $o(1, 1)
                }
            },
            displacementmap: {
                displacementMap: {
                    value: null
                },
                displacementMapTransform: {
                    value: new el
                },
                displacementScale: {
                    value: 1
                },
                displacementBias: {
                    value: 0
                }
            },
            emissivemap: {
                emissiveMap: {
                    value: null
                },
                emissiveMapTransform: {
                    value: new el
                }
            },
            metalnessmap: {
                metalnessMap: {
                    value: null
                },
                metalnessMapTransform: {
                    value: new el
                }
            },
            roughnessmap: {
                roughnessMap: {
                    value: null
                },
                roughnessMapTransform: {
                    value: new el
                }
            },
            gradientmap: {
                gradientMap: {
                    value: null
                }
            },
            fog: {
                fogDensity: {
                    value: 25e-5
                },
                fogNear: {
                    value: 1
                },
                fogFar: {
                    value: 2e3
                },
                fogColor: {
                    value: new qc(16777215)
                }
            },
            lights: {
                ambientLightColor: {
                    value: []
                },
                lightProbe: {
                    value: []
                },
                directionalLights: {
                    value: [],
                    properties: {
                        direction: {},
                        color: {}
                    }
                },
                directionalLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                directionalShadowMap: {
                    value: []
                },
                directionalShadowMatrix: {
                    value: []
                },
                spotLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        direction: {},
                        distance: {},
                        coneCos: {},
                        penumbraCos: {},
                        decay: {}
                    }
                },
                spotLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                spotLightMap: {
                    value: []
                },
                spotShadowMap: {
                    value: []
                },
                spotLightMatrix: {
                    value: []
                },
                pointLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        decay: {},
                        distance: {}
                    }
                },
                pointLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {},
                        shadowCameraNear: {},
                        shadowCameraFar: {}
                    }
                },
                pointShadowMap: {
                    value: []
                },
                pointShadowMatrix: {
                    value: []
                },
                hemisphereLights: {
                    value: [],
                    properties: {
                        direction: {},
                        skyColor: {},
                        groundColor: {}
                    }
                },
                rectAreaLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        width: {},
                        height: {}
                    }
                },
                ltc_1: {
                    value: null
                },
                ltc_2: {
                    value: null
                }
            },
            points: {
                diffuse: {
                    value: new qc(16777215)
                },
                opacity: {
                    value: 1
                },
                size: {
                    value: 1
                },
                scale: {
                    value: 1
                },
                map: {
                    value: null
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                },
                uvTransform: {
                    value: new el
                }
            },
            sprite: {
                diffuse: {
                    value: new qc(16777215)
                },
                opacity: {
                    value: 1
                },
                center: {
                    value: new $o(.5, .5)
                },
                rotation: {
                    value: 0
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new el
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new el
                },
                alphaTest: {
                    value: 0
                }
            }
        }, mh = {
            basic: {
                uniforms: Xu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.fog
                ]),
                vertexShader: fh.meshbasic_vert,
                fragmentShader: fh.meshbasic_frag
            },
            lambert: {
                uniforms: Xu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new qc(0)
                        }
                    }
                ]),
                vertexShader: fh.meshlambert_vert,
                fragmentShader: fh.meshlambert_frag
            },
            phong: {
                uniforms: Xu([
                    gh.common,
                    gh.specularmap,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new qc(0)
                        },
                        specular: {
                            value: new qc(1118481)
                        },
                        shininess: {
                            value: 30
                        }
                    }
                ]),
                vertexShader: fh.meshphong_vert,
                fragmentShader: fh.meshphong_frag
            },
            standard: {
                uniforms: Xu([
                    gh.common,
                    gh.envmap,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.roughnessmap,
                    gh.metalnessmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new qc(0)
                        },
                        roughness: {
                            value: 1
                        },
                        metalness: {
                            value: 0
                        },
                        envMapIntensity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: fh.meshphysical_vert,
                fragmentShader: fh.meshphysical_frag
            },
            toon: {
                uniforms: Xu([
                    gh.common,
                    gh.aomap,
                    gh.lightmap,
                    gh.emissivemap,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.gradientmap,
                    gh.fog,
                    gh.lights,
                    {
                        emissive: {
                            value: new qc(0)
                        }
                    }
                ]),
                vertexShader: fh.meshtoon_vert,
                fragmentShader: fh.meshtoon_frag
            },
            matcap: {
                uniforms: Xu([
                    gh.common,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    gh.fog,
                    {
                        matcap: {
                            value: null
                        }
                    }
                ]),
                vertexShader: fh.meshmatcap_vert,
                fragmentShader: fh.meshmatcap_frag
            },
            points: {
                uniforms: Xu([
                    gh.points,
                    gh.fog
                ]),
                vertexShader: fh.points_vert,
                fragmentShader: fh.points_frag
            },
            dashed: {
                uniforms: Xu([
                    gh.common,
                    gh.fog,
                    {
                        scale: {
                            value: 1
                        },
                        dashSize: {
                            value: 1
                        },
                        totalSize: {
                            value: 2
                        }
                    }
                ]),
                vertexShader: fh.linedashed_vert,
                fragmentShader: fh.linedashed_frag
            },
            depth: {
                uniforms: Xu([
                    gh.common,
                    gh.displacementmap
                ]),
                vertexShader: fh.depth_vert,
                fragmentShader: fh.depth_frag
            },
            normal: {
                uniforms: Xu([
                    gh.common,
                    gh.bumpmap,
                    gh.normalmap,
                    gh.displacementmap,
                    {
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: fh.meshnormal_vert,
                fragmentShader: fh.meshnormal_frag
            },
            sprite: {
                uniforms: Xu([
                    gh.sprite,
                    gh.fog
                ]),
                vertexShader: fh.sprite_vert,
                fragmentShader: fh.sprite_frag
            },
            background: {
                uniforms: {
                    uvTransform: {
                        value: new el
                    },
                    t2D: {
                        value: null
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: fh.background_vert,
                fragmentShader: fh.background_frag
            },
            backgroundCube: {
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    },
                    backgroundBlurriness: {
                        value: 0
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: fh.backgroundCube_vert,
                fragmentShader: fh.backgroundCube_frag
            },
            cube: {
                uniforms: {
                    tCube: {
                        value: null
                    },
                    tFlip: {
                        value: -1
                    },
                    opacity: {
                        value: 1
                    }
                },
                vertexShader: fh.cube_vert,
                fragmentShader: fh.cube_frag
            },
            equirect: {
                uniforms: {
                    tEquirect: {
                        value: null
                    }
                },
                vertexShader: fh.equirect_vert,
                fragmentShader: fh.equirect_frag
            },
            distanceRGBA: {
                uniforms: Xu([
                    gh.common,
                    gh.displacementmap,
                    {
                        referencePosition: {
                            value: new Ll
                        },
                        nearDistance: {
                            value: 1
                        },
                        farDistance: {
                            value: 1e3
                        }
                    }
                ]),
                vertexShader: fh.distanceRGBA_vert,
                fragmentShader: fh.distanceRGBA_frag
            },
            shadow: {
                uniforms: Xu([
                    gh.lights,
                    gh.fog,
                    {
                        color: {
                            value: new qc(0)
                        },
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: fh.shadow_vert,
                fragmentShader: fh.shadow_frag
            }
        };
        mh.physical = {
            uniforms: Xu([
                mh.standard.uniforms,
                {
                    clearcoat: {
                        value: 0
                    },
                    clearcoatMap: {
                        value: null
                    },
                    clearcoatMapTransform: {
                        value: new el
                    },
                    clearcoatNormalMap: {
                        value: null
                    },
                    clearcoatNormalMapTransform: {
                        value: new el
                    },
                    clearcoatNormalScale: {
                        value: new $o(1, 1)
                    },
                    clearcoatRoughness: {
                        value: 0
                    },
                    clearcoatRoughnessMap: {
                        value: null
                    },
                    clearcoatRoughnessMapTransform: {
                        value: new el
                    },
                    iridescence: {
                        value: 0
                    },
                    iridescenceMap: {
                        value: null
                    },
                    iridescenceMapTransform: {
                        value: new el
                    },
                    iridescenceIOR: {
                        value: 1.3
                    },
                    iridescenceThicknessMinimum: {
                        value: 100
                    },
                    iridescenceThicknessMaximum: {
                        value: 400
                    },
                    iridescenceThicknessMap: {
                        value: null
                    },
                    iridescenceThicknessMapTransform: {
                        value: new el
                    },
                    sheen: {
                        value: 0
                    },
                    sheenColor: {
                        value: new qc(0)
                    },
                    sheenColorMap: {
                        value: null
                    },
                    sheenColorMapTransform: {
                        value: new el
                    },
                    sheenRoughness: {
                        value: 1
                    },
                    sheenRoughnessMap: {
                        value: null
                    },
                    sheenRoughnessMapTransform: {
                        value: new el
                    },
                    transmission: {
                        value: 0
                    },
                    transmissionMap: {
                        value: null
                    },
                    transmissionMapTransform: {
                        value: new el
                    },
                    transmissionSamplerSize: {
                        value: new $o
                    },
                    transmissionSamplerMap: {
                        value: null
                    },
                    thickness: {
                        value: 0
                    },
                    thicknessMap: {
                        value: null
                    },
                    thicknessMapTransform: {
                        value: new el
                    },
                    attenuationDistance: {
                        value: 0
                    },
                    attenuationColor: {
                        value: new qc(0)
                    },
                    specularColor: {
                        value: new qc(1, 1, 1)
                    },
                    specularColorMap: {
                        value: null
                    },
                    specularColorMapTransform: {
                        value: new el
                    },
                    specularIntensity: {
                        value: 1
                    },
                    specularIntensityMap: {
                        value: null
                    },
                    specularIntensityMapTransform: {
                        value: new el
                    },
                    anisotropyVector: {
                        value: new $o
                    },
                    anisotropyMap: {
                        value: null
                    },
                    anisotropyMapTransform: {
                        value: new el
                    }
                }
            ]),
            vertexShader: fh.meshphysical_vert,
            fragmentShader: fh.meshphysical_frag
        };
        const Ah = {
            r: 0,
            b: 0,
            g: 0
        };
        function Mh(e1, t, n, i, r, a, s) {
            const o = new qc(0);
            let l, c, u = !0 === a ? 0 : 1, h = null, d = 0, p = null;
            function f(t, n) {
                t.getRGB(Ah, Zu(e1)), i.buffers.color.setClear(Ah.r, Ah.g, Ah.b, n, s);
            }
            return {
                getClearColor: function() {
                    return o;
                },
                setClearColor: function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                    o.set(e1), u = t, f(o, u);
                },
                getClearAlpha: function() {
                    return u;
                },
                setClearAlpha: function(e1) {
                    u = e1, f(o, u);
                },
                render: function(a, g) {
                    let m = !1, A = !0 === g.isScene ? g.background : null;
                    A && A.isTexture && (A = (g.backgroundBlurriness > 0 ? n : t).get(A)), null === A ? f(o, u) : A && A.isColor && (f(A, 1), m = !0);
                    const M = e1.xr.getEnvironmentBlendMode();
                    "additive" === M ? i.buffers.color.setClear(0, 0, 0, 1, s) : "alpha-blend" === M && i.buffers.color.setClear(0, 0, 0, 0, s), (e1.autoClear || m) && e1.clear(e1.autoClearColor, e1.autoClearDepth, e1.autoClearStencil), A && (A.isCubeTexture || A.mapping === ua) ? (void 0 === c && (c = new Vu(new Wu(1, 1, 1), new Ku({
                        name: "BackgroundCubeMaterial",
                        uniforms: Yu(mh.backgroundCube.uniforms),
                        vertexShader: mh.backgroundCube.vertexShader,
                        fragmentShader: mh.backgroundCube.fragmentShader,
                        side: hr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(e1, t, n) {
                        this.matrixWorld.copyPosition(n.matrixWorld);
                    }, Object.defineProperty(c.material, "envMap", {
                        get: function() {
                            return this.uniforms.envMap.value;
                        }
                    }), r.update(c)), c.material.uniforms.envMap.value = A, c.material.uniforms.flipEnvMap.value = A.isCubeTexture && !1 === A.isRenderTargetTexture ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = g.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = g.backgroundIntensity, c.material.toneMapped = pl.getTransfer(A.colorSpace) !== qs, h === A && d === A.version && p === e1.toneMapping || (c.material.needsUpdate = !0, h = A, d = A.version, p = e1.toneMapping), c.layers.enableAll(), a.unshift(c, c.geometry, c.material, 0, 0, null)) : A && A.isTexture && (void 0 === l && (l = new Vu(new ph(2, 2), new Ku({
                        name: "BackgroundMaterial",
                        uniforms: Yu(mh.background.uniforms),
                        vertexShader: mh.background.vertexShader,
                        fragmentShader: mh.background.fragmentShader,
                        side: ur,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
                        get: function() {
                            return this.uniforms.t2D.value;
                        }
                    }), r.update(l)), l.material.uniforms.t2D.value = A, l.material.uniforms.backgroundIntensity.value = g.backgroundIntensity, l.material.toneMapped = pl.getTransfer(A.colorSpace) !== qs, !0 === A.matrixAutoUpdate && A.updateMatrix(), l.material.uniforms.uvTransform.value.copy(A.matrix), h === A && d === A.version && p === e1.toneMapping || (l.material.needsUpdate = !0, h = A, d = A.version, p = e1.toneMapping), l.layers.enableAll(), a.unshift(l, l.geometry, l.material, 0, 0, null));
                }
            };
        }
        function vh(e1, t, n, i) {
            const r = e1.getParameter(e1.MAX_VERTEX_ATTRIBS), a = i.isWebGL2 ? null : t.get("OES_vertex_array_object"), s = i.isWebGL2 || null !== a, o = {}, l = p(null);
            let c = l, u = !1;
            function h(t) {
                return i.isWebGL2 ? e1.bindVertexArray(t) : a.bindVertexArrayOES(t);
            }
            function d(t) {
                return i.isWebGL2 ? e1.deleteVertexArray(t) : a.deleteVertexArrayOES(t);
            }
            function p(e1) {
                const t = [], n = [], i = [];
                for(let e1 = 0; e1 < r; e1++)t[e1] = 0, n[e1] = 0, i[e1] = 0;
                return {
                    geometry: null,
                    program: null,
                    wireframe: !1,
                    newAttributes: t,
                    enabledAttributes: n,
                    attributeDivisors: i,
                    object: e1,
                    attributes: {},
                    index: null
                };
            }
            function f() {
                const e1 = c.newAttributes;
                for(let t = 0, n = e1.length; t < n; t++)e1[t] = 0;
            }
            function g(e1) {
                m(e1, 0);
            }
            function m(n, r) {
                const a = c.newAttributes, s = c.enabledAttributes, o = c.attributeDivisors;
                a[n] = 1, 0 === s[n] && (e1.enableVertexAttribArray(n), s[n] = 1), o[n] !== r && ((i.isWebGL2 ? e1 : t.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r);
            }
            function A() {
                const t = c.newAttributes, n = c.enabledAttributes;
                for(let i = 0, r = n.length; i < r; i++)n[i] !== t[i] && (e1.disableVertexAttribArray(i), n[i] = 0);
            }
            function M(t, n, i, r, a, s, o) {
                !0 === o ? e1.vertexAttribIPointer(t, n, i, a, s) : e1.vertexAttribPointer(t, n, i, r, a, s);
            }
            function v() {
                y(), u = !0, c !== l && (c = l, h(c.object));
            }
            function y() {
                l.geometry = null, l.program = null, l.wireframe = !1;
            }
            return {
                setup: function(r, l, d, v, y) {
                    let x = !1;
                    if (s) {
                        const t = function(t, n, r) {
                            const s = !0 === r.wireframe;
                            let l = o[t.id];
                            void 0 === l && (l = {}, o[t.id] = l);
                            let c = l[n.id];
                            void 0 === c && (c = {}, l[n.id] = c);
                            let u = c[s];
                            return void 0 === u && (u = p(i.isWebGL2 ? e1.createVertexArray() : a.createVertexArrayOES()), c[s] = u), u;
                        }(v, d, l);
                        c !== t && (c = t, h(c.object)), x = function(e1, t, n, i) {
                            const r = c.attributes, a = t.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const t in o)if (o[t].location >= 0) {
                                const n = r[t];
                                let i = a[t];
                                if (void 0 === i && ("instanceMatrix" === t && e1.instanceMatrix && (i = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (i = e1.instanceColor)), void 0 === n) return !0;
                                if (n.attribute !== i) return !0;
                                if (i && n.data !== i.data) return !0;
                                s++;
                            }
                            return c.attributesNum !== s || c.index !== i;
                        }(r, v, d, y), x && function(e1, t, n, i) {
                            const r = {}, a = t.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const t in o)if (o[t].location >= 0) {
                                let n = a[t];
                                void 0 === n && ("instanceMatrix" === t && e1.instanceMatrix && (n = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (n = e1.instanceColor));
                                const i = {};
                                i.attribute = n, n && n.data && (i.data = n.data), r[t] = i, s++;
                            }
                            c.attributes = r, c.attributesNum = s, c.index = i;
                        }(r, v, d, y);
                    } else {
                        const e1 = !0 === l.wireframe;
                        c.geometry === v.id && c.program === d.id && c.wireframe === e1 || (c.geometry = v.id, c.program = d.id, c.wireframe = e1, x = !0);
                    }
                    null !== y && n.update(y, e1.ELEMENT_ARRAY_BUFFER), (x || u) && (u = !1, function(r, a, s, o) {
                        if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === t.get("ANGLE_instanced_arrays")) return;
                        f();
                        const l = o.attributes, c = s.getAttributes(), u = a.defaultAttributeValues;
                        for(const t in c){
                            const a = c[t];
                            if (a.location >= 0) {
                                let s = l[t];
                                if (void 0 === s && ("instanceMatrix" === t && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === t && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                                    const t = s.normalized, l = s.itemSize, c = n.get(s);
                                    if (void 0 === c) continue;
                                    const u = c.buffer, h = c.type, d = c.bytesPerElement, p = !0 === i.isWebGL2 && (h === e1.INT || h === e1.UNSIGNED_INT || s.gpuType === Na);
                                    if (s.isInterleavedBufferAttribute) {
                                        const n = s.data, i = n.stride, c = s.offset;
                                        if (n.isInstancedInterleavedBuffer) {
                                            for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1, n.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = n.meshPerAttribute * n.count);
                                        } else for(let e1 = 0; e1 < a.locationSize; e1++)g(a.location + e1);
                                        e1.bindBuffer(e1.ARRAY_BUFFER, u);
                                        for(let e1 = 0; e1 < a.locationSize; e1++)M(a.location + e1, l / a.locationSize, h, t, i * d, (c + l / a.locationSize * e1) * d, p);
                                    } else {
                                        if (s.isInstancedBufferAttribute) {
                                            for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1, s.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                        } else for(let e1 = 0; e1 < a.locationSize; e1++)g(a.location + e1);
                                        e1.bindBuffer(e1.ARRAY_BUFFER, u);
                                        for(let e1 = 0; e1 < a.locationSize; e1++)M(a.location + e1, l / a.locationSize, h, t, l * d, l / a.locationSize * e1 * d, p);
                                    }
                                } else if (void 0 !== u) {
                                    const n = u[t];
                                    if (void 0 !== n) switch(n.length){
                                        case 2:
                                            e1.vertexAttrib2fv(a.location, n);
                                            break;
                                        case 3:
                                            e1.vertexAttrib3fv(a.location, n);
                                            break;
                                        case 4:
                                            e1.vertexAttrib4fv(a.location, n);
                                            break;
                                        default:
                                            e1.vertexAttrib1fv(a.location, n);
                                    }
                                }
                            }
                        }
                        A();
                    }(r, l, d, v), null !== y && e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, n.get(y).buffer));
                },
                reset: v,
                resetDefaultState: y,
                dispose: function() {
                    v();
                    for(const e1 in o){
                        const t = o[e1];
                        for(const e1 in t){
                            const n = t[e1];
                            for(const e1 in n)d(n[e1].object), delete n[e1];
                            delete t[e1];
                        }
                        delete o[e1];
                    }
                },
                releaseStatesOfGeometry: function(e1) {
                    if (void 0 === o[e1.id]) return;
                    const t = o[e1.id];
                    for(const e1 in t){
                        const n = t[e1];
                        for(const e1 in n)d(n[e1].object), delete n[e1];
                        delete t[e1];
                    }
                    delete o[e1.id];
                },
                releaseStatesOfProgram: function(e1) {
                    for(const t in o){
                        const n = o[t];
                        if (void 0 === n[e1.id]) continue;
                        const i = n[e1.id];
                        for(const e1 in i)d(i[e1].object), delete i[e1];
                        delete n[e1.id];
                    }
                },
                initAttributes: f,
                enableAttribute: g,
                disableUnusedAttributes: A
            };
        }
        function yh(e1, t, n, i) {
            const r = i.isWebGL2;
            let a;
            this.setMode = function(e1) {
                a = e1;
            }, this.render = function(t, i) {
                e1.drawArrays(a, t, i), n.update(i, a, 1);
            }, this.renderInstances = function(i, s, o) {
                if (0 === o) return;
                let l, c;
                if (r) l = e1, c = "drawArraysInstanced";
                else if (l = t.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                l[c](a, i, s, o), n.update(s, a, o);
            };
        }
        function xh(e1, t, n) {
            let i;
            function r(t) {
                if ("highp" === t) {
                    if (e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.HIGH_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.HIGH_FLOAT).precision > 0) return "highp";
                    t = "mediump";
                }
                return "mediump" === t && e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.MEDIUM_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
            }
            const a = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === e1.constructor.name;
            let s = void 0 !== n.precision ? n.precision : "highp";
            const o = r(s);
            o !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
            const l = a || t.has("WEBGL_draw_buffers"), c = !0 === n.logarithmicDepthBuffer, u = e1.getParameter(e1.MAX_TEXTURE_IMAGE_UNITS), h = e1.getParameter(e1.MAX_VERTEX_TEXTURE_IMAGE_UNITS), d = e1.getParameter(e1.MAX_TEXTURE_SIZE), p = e1.getParameter(e1.MAX_CUBE_MAP_TEXTURE_SIZE), f = e1.getParameter(e1.MAX_VERTEX_ATTRIBS), g = e1.getParameter(e1.MAX_VERTEX_UNIFORM_VECTORS), m = e1.getParameter(e1.MAX_VARYING_VECTORS), A = e1.getParameter(e1.MAX_FRAGMENT_UNIFORM_VECTORS), M = h > 0, v = a || t.has("OES_texture_float");
            return {
                isWebGL2: a,
                drawBuffers: l,
                getMaxAnisotropy: function() {
                    if (void 0 !== i) return i;
                    if (!0 === t.has("EXT_texture_filter_anisotropic")) {
                        const n = t.get("EXT_texture_filter_anisotropic");
                        i = e1.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                    } else i = 0;
                    return i;
                },
                getMaxPrecision: r,
                precision: s,
                logarithmicDepthBuffer: c,
                maxTextures: u,
                maxVertexTextures: h,
                maxTextureSize: d,
                maxCubemapSize: p,
                maxAttributes: f,
                maxVertexUniforms: g,
                maxVaryings: m,
                maxFragmentUniforms: A,
                vertexTextures: M,
                floatFragmentTextures: v,
                floatVertexTextures: M && v,
                maxSamples: a ? e1.getParameter(e1.MAX_SAMPLES) : 0
            };
        }
        function bh(e1) {
            const t = this;
            let n = null, i = 0, r = !1, a = !1;
            const s = new oh, o = new el, l = {
                value: null,
                needsUpdate: !1
            };
            function c(e1, n, i, r) {
                const a = null !== e1 ? e1.length : 0;
                let c = null;
                if (0 !== a) {
                    if (c = l.value, !0 !== r || null === c) {
                        const t = i + 4 * a, r = n.matrixWorldInverse;
                        o.getNormalMatrix(r), (null === c || c.length < t) && (c = new Float32Array(t));
                        for(let t = 0, n = i; t !== a; ++t, n += 4)s.copy(e1[t]).applyMatrix4(r, o), s.normal.toArray(c, n), c[n + 3] = s.constant;
                    }
                    l.value = c, l.needsUpdate = !0;
                }
                return t.numPlanes = a, t.numIntersection = 0, c;
            }
            this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e1, t) {
                const n = 0 !== e1.length || t || 0 !== i || r;
                return r = t, i = e1.length, n;
            }, this.beginShadows = function() {
                a = !0, c(null);
            }, this.endShadows = function() {
                a = !1;
            }, this.setGlobalState = function(e1, t) {
                n = c(e1, t, 0);
            }, this.setState = function(s, o, u) {
                const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, f = e1.get(s);
                if (!r || null === h || 0 === h.length || a && !p) a ? c(null) : (l.value !== n && (l.value = n, l.needsUpdate = i > 0), t.numPlanes = i, t.numIntersection = 0);
                else {
                    const e1 = a ? 0 : i, t = 4 * e1;
                    let r = f.clippingState || null;
                    l.value = r, r = c(h, o, t, u);
                    for(let e1 = 0; e1 !== t; ++e1)r[e1] = n[e1];
                    f.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += e1;
                }
            };
        }
        function wh(e1) {
            let t = new WeakMap;
            function n(e1, t) {
                return t === la ? e1.mapping = sa : t === ca && (e1.mapping = oa), e1;
            }
            function i(e1) {
                const n = e1.target;
                n.removeEventListener("dispose", i);
                const r = t.get(n);
                void 0 !== r && (t.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                        const a = r.mapping;
                        if (a === la || a === ca) {
                            if (t.has(r)) return n(t.get(r).texture, r.mapping);
                            {
                                const a = r.image;
                                if (a && a.height > 0) {
                                    const s = new ih(a.height / 2);
                                    return s.fromEquirectangularTexture(e1, r), t.set(r, s), r.addEventListener("dispose", i), n(s.texture, r.mapping);
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    t = new WeakMap;
                }
            };
        }
        class Eh extends Ju {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : -1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : .1, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2e3;
                super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e1, this.right = t, this.top = n, this.bottom = i, this.near = r, this.far = a, this.updateProjectionMatrix();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.left = e1.left, this.right = e1.right, this.top = e1.top, this.bottom = e1.bottom, this.near = e1.near, this.far = e1.far, this.zoom = e1.zoom, this.view = null === e1.view ? null : Object.assign({}, e1.view), this;
            }
            setViewOffset(e1, t, n, i, r, a) {
                null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const e1 = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
                let r = n - e1, a = n + e1, s = i + t, o = i - t;
                if (null !== this.view && this.view.enabled) {
                    const e1 = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    r += e1 * this.view.offsetX, a = r + e1 * this.view.width, s -= t * this.view.offsetY, o = s - t * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
            }
        }
        const Th = [
            .125,
            .215,
            .35,
            .446,
            .526,
            .582
        ], Sh = new Eh, Ih = new qc;
        let Nh = null, Dh = 0, _h = 0;
        const Ch = (1 + Math.sqrt(5)) / 2, Lh = 1 / Ch, zh = [
            new Ll(1, 1, 1),
            new Ll(-1, 1, 1),
            new Ll(1, 1, -1),
            new Ll(-1, 1, -1),
            new Ll(0, Ch, Lh),
            new Ll(0, Ch, -Lh),
            new Ll(Lh, 0, Ch),
            new Ll(-Lh, 0, Ch),
            new Ll(Ch, Lh, 0),
            new Ll(-Ch, Lh, 0)
        ];
        class Oh {
            constructor(e1){
                this._renderer = e1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
            }
            fromScene(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 100;
                Nh = this._renderer.getRenderTarget(), Dh = this._renderer.getActiveCubeFace(), _h = this._renderer.getActiveMipmapLevel(), this._setSize(256);
                const r = this._allocateTargets();
                return r.depthBuffer = !0, this._sceneToCubeUV(e1, n, i, r), t > 0 && this._blur(r, 0, 0, t), this._applyPMREM(r), this._cleanup(r), r;
            }
            fromEquirectangular(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                return this._fromTexture(e1, t);
            }
            fromCubemap(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                return this._fromTexture(e1, t);
            }
            compileCubemapShader() {
                null === this._cubemapMaterial && (this._cubemapMaterial = jh(), this._compileMaterial(this._cubemapMaterial));
            }
            compileEquirectangularShader() {
                null === this._equirectMaterial && (this._equirectMaterial = Uh(), this._compileMaterial(this._equirectMaterial));
            }
            dispose() {
                this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
            }
            _setSize(e1) {
                this._lodMax = Math.floor(Math.log2(e1)), this._cubeSize = Math.pow(2, this._lodMax);
            }
            _dispose() {
                null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                for(let e1 = 0; e1 < this._lodPlanes.length; e1++)this._lodPlanes[e1].dispose();
            }
            _cleanup(e1) {
                this._renderer.setRenderTarget(Nh, Dh, _h), e1.scissorTest = !1, Ph(e1, 0, 0, e1.width, e1.height);
            }
            _fromTexture(e1, t) {
                e1.mapping === sa || e1.mapping === oa ? this._setSize(0 === e1.image.length ? 16 : e1.image[0].width || e1.image[0].image.width) : this._setSize(e1.image.width / 4), Nh = this._renderer.getRenderTarget(), Dh = this._renderer.getActiveCubeFace(), _h = this._renderer.getActiveMipmapLevel();
                const n = t || this._allocateTargets();
                return this._textureToCubeUV(e1, n), this._applyPMREM(n), this._cleanup(n), n;
            }
            _allocateTargets() {
                const e1 = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
                    magFilter: va,
                    minFilter: va,
                    generateMipmaps: !1,
                    type: Ca,
                    format: Pa,
                    colorSpace: Ws,
                    depthBuffer: !1
                }, i = Rh(e1, t, n);
                if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== e1 || this._pingPongRenderTarget.height !== t) {
                    null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = Rh(e1, t, n);
                    const { _lodMax: i } = this;
                    ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(e1) {
                        const t = [], n = [], i = [];
                        let r = e1;
                        const a = e1 - 4 + 1 + Th.length;
                        for(let s = 0; s < a; s++){
                            const a = Math.pow(2, r);
                            n.push(a);
                            let o = 1 / a;
                            s > e1 - 4 ? o = Th[s - e1 + 4 - 1] : 0 === s && (o = 0), i.push(o);
                            const l = 1 / (a - 2), c = -l, u = 1 + l, h = [
                                c,
                                c,
                                u,
                                c,
                                u,
                                u,
                                c,
                                c,
                                u,
                                u,
                                c,
                                u
                            ], d = 6, p = 6, f = 3, g = 2, m = 1, A = new Float32Array(f * p * d), M = new Float32Array(g * p * d), v = new Float32Array(m * p * d);
                            for(let e1 = 0; e1 < d; e1++){
                                const t = e1 % 3 * 2 / 3 - 1, n = e1 > 2 ? 0 : -1, i = [
                                    t,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n + 1,
                                    0,
                                    t,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n + 1,
                                    0,
                                    t,
                                    n + 1,
                                    0
                                ];
                                A.set(i, f * p * e1), M.set(h, g * p * e1);
                                const r = [
                                    e1,
                                    e1,
                                    e1,
                                    e1,
                                    e1,
                                    e1
                                ];
                                v.set(r, m * p * e1);
                            }
                            const y = new Su;
                            y.setAttribute("position", new lu(A, f)), y.setAttribute("uv", new lu(M, g)), y.setAttribute("faceIndex", new lu(v, m)), t.push(y), r > 4 && r--;
                        }
                        return {
                            lodPlanes: t,
                            sizeLods: n,
                            sigmas: i
                        };
                    }(i)), this._blurMaterial = function(e1, t, n) {
                        const i = new Float32Array(20), r = new Ll(0, 1, 0);
                        return new Ku({
                            name: "SphericalGaussianBlur",
                            defines: {
                                n: 20,
                                CUBEUV_TEXEL_WIDTH: 1 / t,
                                CUBEUV_TEXEL_HEIGHT: 1 / n,
                                CUBEUV_MAX_MIP: `${e1}.0`
                            },
                            uniforms: {
                                envMap: {
                                    value: null
                                },
                                samples: {
                                    value: 1
                                },
                                weights: {
                                    value: i
                                },
                                latitudinal: {
                                    value: !1
                                },
                                dTheta: {
                                    value: 0
                                },
                                mipInt: {
                                    value: 0
                                },
                                poleAxis: {
                                    value: r
                                }
                            },
                            vertexShader: "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t",
                            fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                            blending: fr,
                            depthTest: !1,
                            depthWrite: !1
                        });
                    }(i, e1, t);
                }
                return i;
            }
            _compileMaterial(e1) {
                const t = new Vu(this._lodPlanes[0], e1);
                this._renderer.compile(t, Sh);
            }
            _sceneToCubeUV(e1, t, n, i) {
                const r = new $u(90, 1, t, n), a = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ], s = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ], o = this._renderer, l = o.autoClear, c = o.toneMapping;
                o.getClearColor(Ih), o.toneMapping = Kr, o.autoClear = !1;
                const u = new eu({
                    name: "PMREM.Background",
                    side: hr,
                    depthWrite: !1,
                    depthTest: !1
                }), h = new Vu(new Wu, u);
                let d = !1;
                const p = e1.background;
                p ? p.isColor && (u.color.copy(p), e1.background = null, d = !0) : (u.color.copy(Ih), d = !0);
                for(let t = 0; t < 6; t++){
                    const n = t % 3;
                    0 === n ? (r.up.set(0, a[t], 0), r.lookAt(s[t], 0, 0)) : 1 === n ? (r.up.set(0, 0, a[t]), r.lookAt(0, s[t], 0)) : (r.up.set(0, a[t], 0), r.lookAt(0, 0, s[t]));
                    const l = this._cubeSize;
                    Ph(i, n * l, t > 2 ? l : 0, l, l), o.setRenderTarget(i), d && o.render(h, r), o.render(e1, r);
                }
                h.geometry.dispose(), h.material.dispose(), o.toneMapping = c, o.autoClear = l, e1.background = p;
            }
            _textureToCubeUV(e1, t) {
                const n = this._renderer, i = e1.mapping === sa || e1.mapping === oa;
                i ? (null === this._cubemapMaterial && (this._cubemapMaterial = jh()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === e1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = Uh());
                const r = i ? this._cubemapMaterial : this._equirectMaterial, a = new Vu(this._lodPlanes[0], r);
                r.uniforms.envMap.value = e1;
                const s = this._cubeSize;
                Ph(t, 0, 0, 3 * s, 2 * s), n.setRenderTarget(t), n.render(a, Sh);
            }
            _applyPMREM(e1) {
                const t = this._renderer, n = t.autoClear;
                t.autoClear = !1;
                for(let t = 1; t < this._lodPlanes.length; t++){
                    const n = Math.sqrt(this._sigmas[t] * this._sigmas[t] - this._sigmas[t - 1] * this._sigmas[t - 1]), i = zh[(t - 1) % zh.length];
                    this._blur(e1, t - 1, t, n, i);
                }
                t.autoClear = n;
            }
            _blur(e1, t, n, i, r) {
                const a = this._pingPongRenderTarget;
                this._halfBlur(e1, a, t, n, i, "latitudinal", r), this._halfBlur(a, e1, n, n, i, "longitudinal", r);
            }
            _halfBlur(e1, t, n, i, r, a, s) {
                const o = this._renderer, l = this._blurMaterial;
                "latitudinal" !== a && "longitudinal" !== a && console.error("blur direction must be either latitudinal or longitudinal!");
                const c = new Vu(this._lodPlanes[i], l), u = l.uniforms, h = this._sizeLods[n] - 1, d = isFinite(r) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = r / d, f = isFinite(r) ? 1 + Math.floor(3 * p) : 20;
                f > 20 && console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${f} samples when the maximum is set to 20`);
                const g = [];
                let m = 0;
                for(let e1 = 0; e1 < 20; ++e1){
                    const t = e1 / p, n = Math.exp(-t * t / 2);
                    g.push(n), 0 === e1 ? m += n : e1 < f && (m += 2 * n);
                }
                for(let e1 = 0; e1 < g.length; e1++)g[e1] = g[e1] / m;
                u.envMap.value = e1.texture, u.samples.value = f, u.weights.value = g, u.latitudinal.value = "latitudinal" === a, s && (u.poleAxis.value = s);
                const { _lodMax: A } = this;
                u.dTheta.value = d, u.mipInt.value = A - n;
                const M = this._sizeLods[i];
                Ph(t, 3 * M * (i > A - 4 ? i - A + 4 : 0), 4 * (this._cubeSize - M), 3 * M, 2 * M), o.setRenderTarget(t), o.render(c, Sh);
            }
        }
        function Rh(e1, t, n) {
            const i = new Tl(e1, t, n);
            return i.texture.mapping = ua, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
        }
        function Ph(e1, t, n, i, r) {
            e1.viewport.set(t, n, i, r), e1.scissor.set(t, n, i, r);
        }
        function Uh() {
            return new Ku({
                name: "EquirectangularToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    }
                },
                vertexShader: "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t",
                fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
                blending: fr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function jh() {
            return new Ku({
                name: "CubemapToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    }
                },
                vertexShader: "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t",
                fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
                blending: fr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function kh(e1) {
            let t = new WeakMap, n = null;
            function i(e1) {
                const n = e1.target;
                n.removeEventListener("dispose", i);
                const r = t.get(n);
                void 0 !== r && (t.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture) {
                        const a = r.mapping, s = a === la || a === ca, o = a === sa || a === oa;
                        if (s || o) {
                            if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                                r.needsPMREMUpdate = !1;
                                let i = t.get(r);
                                return null === n && (n = new Oh(e1)), i = s ? n.fromEquirectangular(r, i) : n.fromCubemap(r, i), t.set(r, i), i.texture;
                            }
                            if (t.has(r)) return t.get(r).texture;
                            {
                                const a = r.image;
                                if (s && a && a.height > 0 || o && a && function(e1) {
                                    let t = 0;
                                    for(let n = 0; n < 6; n++)void 0 !== e1[n] && t++;
                                    return 6 === t;
                                }(a)) {
                                    null === n && (n = new Oh(e1));
                                    const a = s ? n.fromEquirectangular(r) : n.fromCubemap(r);
                                    return t.set(r, a), r.addEventListener("dispose", i), a.texture;
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    t = new WeakMap, null !== n && (n.dispose(), n = null);
                }
            };
        }
        function Bh(e1) {
            const t = {};
            function n(n) {
                if (void 0 !== t[n]) return t[n];
                let i;
                switch(n){
                    case "WEBGL_depth_texture":
                        i = e1.getExtension("WEBGL_depth_texture") || e1.getExtension("MOZ_WEBGL_depth_texture") || e1.getExtension("WEBKIT_WEBGL_depth_texture");
                        break;
                    case "EXT_texture_filter_anisotropic":
                        i = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                        break;
                    case "WEBGL_compressed_texture_s3tc":
                        i = e1.getExtension("WEBGL_compressed_texture_s3tc") || e1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || e1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                        break;
                    case "WEBGL_compressed_texture_pvrtc":
                        i = e1.getExtension("WEBGL_compressed_texture_pvrtc") || e1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                        break;
                    default:
                        i = e1.getExtension(n);
                }
                return t[n] = i, i;
            }
            return {
                has: function(e1) {
                    return null !== n(e1);
                },
                init: function(e1) {
                    e1.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
                },
                get: function(e1) {
                    const t = n(e1);
                    return null === t && console.warn("THREE.WebGLRenderer: " + e1 + " extension not supported."), t;
                }
            };
        }
        function Fh(e1, t, n, i) {
            const r = {}, a = new WeakMap;
            function s(e1) {
                const o = e1.target;
                null !== o.index && t.remove(o.index);
                for(const e1 in o.attributes)t.remove(o.attributes[e1]);
                for(const e1 in o.morphAttributes){
                    const n = o.morphAttributes[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++)t.remove(n[e1]);
                }
                o.removeEventListener("dispose", s), delete r[o.id];
                const l = a.get(o);
                l && (t.remove(l), a.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
            }
            function o(e1) {
                const n = [], i = e1.index, r = e1.attributes.position;
                let s = 0;
                if (null !== i) {
                    const e1 = i.array;
                    s = i.version;
                    for(let t = 0, i = e1.length; t < i; t += 3){
                        const i = e1[t + 0], r = e1[t + 1], a = e1[t + 2];
                        n.push(i, r, r, a, a, i);
                    }
                } else {
                    if (void 0 === r) return;
                    {
                        const e1 = r.array;
                        s = r.version;
                        for(let t = 0, i = e1.length / 3 - 1; t < i; t += 3){
                            const e1 = t + 0, i = t + 1, r = t + 2;
                            n.push(e1, i, i, r, r, e1);
                        }
                    }
                }
                const o = new (nl(n) ? gu : pu)(n, 1);
                o.version = s;
                const l = a.get(e1);
                l && t.remove(l), a.set(e1, o);
            }
            return {
                get: function(e1, t) {
                    return !0 === r[t.id] || (t.addEventListener("dispose", s), r[t.id] = !0, n.memory.geometries++), t;
                },
                update: function(n) {
                    const i = n.attributes;
                    for(const n in i)t.update(i[n], e1.ARRAY_BUFFER);
                    const r = n.morphAttributes;
                    for(const n in r){
                        const i = r[n];
                        for(let n = 0, r = i.length; n < r; n++)t.update(i[n], e1.ARRAY_BUFFER);
                    }
                },
                getWireframeAttribute: function(e1) {
                    const t = a.get(e1);
                    if (t) {
                        const n = e1.index;
                        null !== n && t.version < n.version && o(e1);
                    } else o(e1);
                    return a.get(e1);
                }
            };
        }
        function Hh(e1, t, n, i) {
            const r = i.isWebGL2;
            let a, s, o;
            this.setMode = function(e1) {
                a = e1;
            }, this.setIndex = function(e1) {
                s = e1.type, o = e1.bytesPerElement;
            }, this.render = function(t, i) {
                e1.drawElements(a, i, s, t * o), n.update(i, a, 1);
            }, this.renderInstances = function(i, l, c) {
                if (0 === c) return;
                let u, h;
                if (r) u = e1, h = "drawElementsInstanced";
                else if (u = t.get("ANGLE_instanced_arrays"), h = "drawElementsInstancedANGLE", null === u) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                u[h](a, l, s, i * o, c), n.update(l, a, c);
            };
        }
        function Gh(e1) {
            const t = {
                frame: 0,
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0
            };
            return {
                memory: {
                    geometries: 0,
                    textures: 0
                },
                render: t,
                programs: null,
                autoReset: !0,
                reset: function() {
                    t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
                },
                update: function(n, i, r) {
                    switch(t.calls++, i){
                        case e1.TRIANGLES:
                            t.triangles += r * (n / 3);
                            break;
                        case e1.LINES:
                            t.lines += r * (n / 2);
                            break;
                        case e1.LINE_STRIP:
                            t.lines += r * (n - 1);
                            break;
                        case e1.LINE_LOOP:
                            t.lines += r * n;
                            break;
                        case e1.POINTS:
                            t.points += r * n;
                            break;
                        default:
                            console.error("THREE.WebGLInfo: Unknown draw mode:", i);
                    }
                }
            };
        }
        function Vh(e1, t) {
            return e1[0] - t[0];
        }
        function Qh(e1, t) {
            return Math.abs(t[1]) - Math.abs(e1[1]);
        }
        function Wh(e1, t, n) {
            const i = {}, r = new Float32Array(8), a = new WeakMap, s = new wl, o = [];
            for(let e1 = 0; e1 < 8; e1++)o[e1] = [
                e1,
                0
            ];
            return {
                update: function(l, c, u) {
                    const h = l.morphTargetInfluences;
                    if (!0 === t.isWebGL2) {
                        const d = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = void 0 !== d ? d.length : 0;
                        let f = a.get(c);
                        if (void 0 === f || f.count !== p) {
                            void 0 !== f && f.texture.dispose();
                            const A = void 0 !== c.morphAttributes.position, M = void 0 !== c.morphAttributes.normal, v = void 0 !== c.morphAttributes.color, y = c.morphAttributes.position || [], x = c.morphAttributes.normal || [], b = c.morphAttributes.color || [];
                            let w = 0;
                            !0 === A && (w = 1), !0 === M && (w = 2), !0 === v && (w = 3);
                            let E = c.attributes.position.count * w, T = 1;
                            E > t.maxTextureSize && (T = Math.ceil(E / t.maxTextureSize), E = t.maxTextureSize);
                            const S = new Float32Array(E * T * 4 * p), I = new Sl(S, E, T, p);
                            I.type = _a, I.needsUpdate = !0;
                            const N = 4 * w;
                            for(let _ = 0; _ < p; _++){
                                const C = y[_], L = x[_], z = b[_], O = E * T * 4 * _;
                                for(let R = 0; R < C.count; R++){
                                    const P = R * N;
                                    !0 === A && (s.fromBufferAttribute(C, R), S[O + P + 0] = s.x, S[O + P + 1] = s.y, S[O + P + 2] = s.z, S[O + P + 3] = 0), !0 === M && (s.fromBufferAttribute(L, R), S[O + P + 4] = s.x, S[O + P + 5] = s.y, S[O + P + 6] = s.z, S[O + P + 7] = 0), !0 === v && (s.fromBufferAttribute(z, R), S[O + P + 8] = s.x, S[O + P + 9] = s.y, S[O + P + 10] = s.z, S[O + P + 11] = 4 === z.itemSize ? s.w : 1);
                                }
                            }
                            function D() {
                                I.dispose(), a.delete(c), c.removeEventListener("dispose", D);
                            }
                            f = {
                                count: p,
                                texture: I,
                                size: new $o(E, T)
                            }, a.set(c, f), c.addEventListener("dispose", D);
                        }
                        let g = 0;
                        for(let U = 0; U < h.length; U++)g += h[U];
                        const m = c.morphTargetsRelative ? 1 : 1 - g;
                        u.getUniforms().setValue(e1, "morphTargetBaseInfluence", m), u.getUniforms().setValue(e1, "morphTargetInfluences", h), u.getUniforms().setValue(e1, "morphTargetsTexture", f.texture, n), u.getUniforms().setValue(e1, "morphTargetsTextureSize", f.size);
                    } else {
                        const j = void 0 === h ? 0 : h.length;
                        let k = i[c.id];
                        if (void 0 === k || k.length !== j) {
                            k = [];
                            for(let V = 0; V < j; V++)k[V] = [
                                V,
                                0
                            ];
                            i[c.id] = k;
                        }
                        for(let Q = 0; Q < j; Q++){
                            const W = k[Q];
                            W[0] = Q, W[1] = h[Q];
                        }
                        k.sort(Qh);
                        for(let Y = 0; Y < 8; Y++)Y < j && k[Y][1] ? (o[Y][0] = k[Y][0], o[Y][1] = k[Y][1]) : (o[Y][0] = Number.MAX_SAFE_INTEGER, o[Y][1] = 0);
                        o.sort(Vh);
                        const B = c.morphAttributes.position, F = c.morphAttributes.normal;
                        let H = 0;
                        for(let X = 0; X < 8; X++){
                            const Z = o[X], q = Z[0], K = Z[1];
                            q !== Number.MAX_SAFE_INTEGER && K ? (B && c.getAttribute("morphTarget" + X) !== B[q] && c.setAttribute("morphTarget" + X, B[q]), F && c.getAttribute("morphNormal" + X) !== F[q] && c.setAttribute("morphNormal" + X, F[q]), r[X] = K, H += K) : (B && !0 === c.hasAttribute("morphTarget" + X) && c.deleteAttribute("morphTarget" + X), F && !0 === c.hasAttribute("morphNormal" + X) && c.deleteAttribute("morphNormal" + X), r[X] = 0);
                        }
                        const G = c.morphTargetsRelative ? 1 : 1 - H;
                        u.getUniforms().setValue(e1, "morphTargetBaseInfluence", G), u.getUniforms().setValue(e1, "morphTargetInfluences", r);
                    }
                }
            };
        }
        function Yh(e1, t, n, i) {
            let r = new WeakMap;
            function a(e1) {
                const t = e1.target;
                t.removeEventListener("dispose", a), n.remove(t.instanceMatrix), null !== t.instanceColor && n.remove(t.instanceColor);
            }
            return {
                update: function(s) {
                    const o = i.render.frame, l = s.geometry, c = t.get(s, l);
                    if (r.get(c) !== o && (t.update(c), r.set(c, o)), s.isInstancedMesh && (!1 === s.hasEventListener("dispose", a) && s.addEventListener("dispose", a), r.get(s) !== o && (n.update(s.instanceMatrix, e1.ARRAY_BUFFER), null !== s.instanceColor && n.update(s.instanceColor, e1.ARRAY_BUFFER), r.set(s, o))), s.isSkinnedMesh) {
                        const e1 = s.skeleton;
                        r.get(e1) !== o && (e1.update(), r.set(e1, o));
                    }
                    return c;
                },
                dispose: function() {
                    r = new WeakMap;
                }
            };
        }
        const Xh = new bl, Zh = new Sl, qh = new Nl, Kh = new nh, Jh = [], $h = [], ed = new Float32Array(16), td = new Float32Array(9), nd = new Float32Array(4);
        function id(e1, t, n) {
            const i = e1[0];
            if (i <= 0 || i > 0) return e1;
            const r = t * n;
            let a = Jh[r];
            if (void 0 === a && (a = new Float32Array(r), Jh[r] = a), 0 !== t) {
                i.toArray(a, 0);
                for(let i = 1, r = 0; i !== t; ++i)r += n, e1[i].toArray(a, r);
            }
            return a;
        }
        function rd(e1, t) {
            if (e1.length !== t.length) return !1;
            for(let n = 0, i = e1.length; n < i; n++)if (e1[n] !== t[n]) return !1;
            return !0;
        }
        function ad(e1, t) {
            for(let n = 0, i = t.length; n < i; n++)e1[n] = t[n];
        }
        function sd(e1, t) {
            let n = $h[t];
            void 0 === n && (n = new Int32Array(t), $h[t] = n);
            for(let i = 0; i !== t; ++i)n[i] = e1.allocateTextureUnit();
            return n;
        }
        function od(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1f(this.addr, t), n[0] = t);
        }
        function ld(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2fv(this.addr, t), ad(n, t);
            }
        }
        function cd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else if (void 0 !== t.r) n[0] === t.r && n[1] === t.g && n[2] === t.b || (e1.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);
            else {
                if (rd(n, t)) return;
                e1.uniform3fv(this.addr, t), ad(n, t);
            }
        }
        function ud(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4fv(this.addr, t), ad(n, t);
            }
        }
        function hd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix2fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                nd.set(i), e1.uniformMatrix2fv(this.addr, !1, nd), ad(n, i);
            }
        }
        function dd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix3fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                td.set(i), e1.uniformMatrix3fv(this.addr, !1, td), ad(n, i);
            }
        }
        function pd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix4fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                ed.set(i), e1.uniformMatrix4fv(this.addr, !1, ed), ad(n, i);
            }
        }
        function fd(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1i(this.addr, t), n[0] = t);
        }
        function gd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2i(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2iv(this.addr, t), ad(n, t);
            }
        }
        function md(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3i(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else {
                if (rd(n, t)) return;
                e1.uniform3iv(this.addr, t), ad(n, t);
            }
        }
        function Ad(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4i(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4iv(this.addr, t), ad(n, t);
            }
        }
        function Md(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1ui(this.addr, t), n[0] = t);
        }
        function vd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2ui(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2uiv(this.addr, t), ad(n, t);
            }
        }
        function yd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3ui(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else {
                if (rd(n, t)) return;
                e1.uniform3uiv(this.addr, t), ad(n, t);
            }
        }
        function xd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4uiv(this.addr, t), ad(n, t);
            }
        }
        function bd(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(t || Xh, r);
        }
        function wd(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(t || qh, r);
        }
        function Ed(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(t || Kh, r);
        }
        function Td(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(t || Zh, r);
        }
        function Sd(e1, t) {
            e1.uniform1fv(this.addr, t);
        }
        function Id(e1, t) {
            const n = id(t, this.size, 2);
            e1.uniform2fv(this.addr, n);
        }
        function Nd(e1, t) {
            const n = id(t, this.size, 3);
            e1.uniform3fv(this.addr, n);
        }
        function Dd(e1, t) {
            const n = id(t, this.size, 4);
            e1.uniform4fv(this.addr, n);
        }
        function _d(e1, t) {
            const n = id(t, this.size, 4);
            e1.uniformMatrix2fv(this.addr, !1, n);
        }
        function Cd(e1, t) {
            const n = id(t, this.size, 9);
            e1.uniformMatrix3fv(this.addr, !1, n);
        }
        function Ld(e1, t) {
            const n = id(t, this.size, 16);
            e1.uniformMatrix4fv(this.addr, !1, n);
        }
        function zd(e1, t) {
            e1.uniform1iv(this.addr, t);
        }
        function Od(e1, t) {
            e1.uniform2iv(this.addr, t);
        }
        function Rd(e1, t) {
            e1.uniform3iv(this.addr, t);
        }
        function Pd(e1, t) {
            e1.uniform4iv(this.addr, t);
        }
        function Ud(e1, t) {
            e1.uniform1uiv(this.addr, t);
        }
        function jd(e1, t) {
            e1.uniform2uiv(this.addr, t);
        }
        function kd(e1, t) {
            e1.uniform3uiv(this.addr, t);
        }
        function Bd(e1, t) {
            e1.uniform4uiv(this.addr, t);
        }
        function Fd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture2D(t[e1] || Xh, a[e1]);
        }
        function Hd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture3D(t[e1] || qh, a[e1]);
        }
        function Gd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTextureCube(t[e1] || Kh, a[e1]);
        }
        function Vd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture2DArray(t[e1] || Zh, a[e1]);
        }
        class Qd {
            constructor(e1, t, n){
                this.id = e1, this.addr = n, this.cache = [], this.setValue = function(e1) {
                    switch(e1){
                        case 5126:
                            return od;
                        case 35664:
                            return ld;
                        case 35665:
                            return cd;
                        case 35666:
                            return ud;
                        case 35674:
                            return hd;
                        case 35675:
                            return dd;
                        case 35676:
                            return pd;
                        case 5124:
                        case 35670:
                            return fd;
                        case 35667:
                        case 35671:
                            return gd;
                        case 35668:
                        case 35672:
                            return md;
                        case 35669:
                        case 35673:
                            return Ad;
                        case 5125:
                            return Md;
                        case 36294:
                            return vd;
                        case 36295:
                            return yd;
                        case 36296:
                            return xd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return bd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return wd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Ed;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Td;
                    }
                }(t.type);
            }
        }
        class Wd {
            constructor(e1, t, n){
                this.id = e1, this.addr = n, this.cache = [], this.size = t.size, this.setValue = function(e1) {
                    switch(e1){
                        case 5126:
                            return Sd;
                        case 35664:
                            return Id;
                        case 35665:
                            return Nd;
                        case 35666:
                            return Dd;
                        case 35674:
                            return _d;
                        case 35675:
                            return Cd;
                        case 35676:
                            return Ld;
                        case 5124:
                        case 35670:
                            return zd;
                        case 35667:
                        case 35671:
                            return Od;
                        case 35668:
                        case 35672:
                            return Rd;
                        case 35669:
                        case 35673:
                            return Pd;
                        case 5125:
                            return Ud;
                        case 36294:
                            return jd;
                        case 36295:
                            return kd;
                        case 36296:
                            return Bd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return Fd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return Hd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Gd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Vd;
                    }
                }(t.type);
            }
        }
        class Yd {
            constructor(e1){
                this.id = e1, this.seq = [], this.map = {};
            }
            setValue(e1, t, n) {
                const i = this.seq;
                for(let r = 0, a = i.length; r !== a; ++r){
                    const a = i[r];
                    a.setValue(e1, t[a.id], n);
                }
            }
        }
        const Xd = /(\w+)(\])?(\[|\.)?/g;
        function Zd(e1, t) {
            e1.seq.push(t), e1.map[t.id] = t;
        }
        function qd(e1, t, n) {
            const i = e1.name, r = i.length;
            for(Xd.lastIndex = 0;;){
                const a = Xd.exec(i), s = Xd.lastIndex;
                let o = a[1];
                const l = "]" === a[2], c = a[3];
                if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === r) {
                    Zd(n, void 0 === c ? new Qd(o, e1, t) : new Wd(o, e1, t));
                    break;
                }
                {
                    let e1 = n.map[o];
                    void 0 === e1 && (e1 = new Yd(o), Zd(n, e1)), n = e1;
                }
            }
        }
        class Kd {
            constructor(e1, t){
                this.seq = [], this.map = {};
                const n = e1.getProgramParameter(t, e1.ACTIVE_UNIFORMS);
                for(let i = 0; i < n; ++i){
                    const n = e1.getActiveUniform(t, i);
                    qd(n, e1.getUniformLocation(t, n.name), this);
                }
            }
            setValue(e1, t, n, i) {
                const r = this.map[t];
                void 0 !== r && r.setValue(e1, n, i);
            }
            setOptional(e1, t, n) {
                const i = t[n];
                void 0 !== i && this.setValue(e1, n, i);
            }
            static upload(e1, t, n, i) {
                for(let r = 0, a = t.length; r !== a; ++r){
                    const a = t[r], s = n[a.id];
                    !1 !== s.needsUpdate && a.setValue(e1, s.value, i);
                }
            }
            static seqWithValue(e1, t) {
                const n = [];
                for(let i = 0, r = e1.length; i !== r; ++i){
                    const r = e1[i];
                    r.id in t && n.push(r);
                }
                return n;
            }
        }
        function Jd(e1, t, n) {
            const i = e1.createShader(t);
            return e1.shaderSource(i, n), e1.compileShader(i), i;
        }
        const $d = 37297;
        let ep = 0;
        function tp(e1, t, n) {
            const i = e1.getShaderParameter(t, e1.COMPILE_STATUS), r = e1.getShaderInfoLog(t).trim();
            if (i && "" === r) return "";
            const a = /ERROR: 0:(\d+)/.exec(r);
            if (a) {
                const i = parseInt(a[1]);
                return n.toUpperCase() + "\n\n" + r + "\n\n" + function(e1, t) {
                    const n = e1.split("\n"), i = [], r = Math.max(t - 6, 0), a = Math.min(t + 6, n.length);
                    for(let e1 = r; e1 < a; e1++){
                        const r = e1 + 1;
                        i.push(`${r === t ? ">" : " "} ${r}: ${n[e1]}`);
                    }
                    return i.join("\n");
                }(e1.getShaderSource(t), i);
            }
            return r;
        }
        function np(e1, t) {
            const n = function(e1) {
                const t = pl.getPrimaries(pl.workingColorSpace), n = pl.getPrimaries(e1);
                let i;
                switch(t === n ? i = "" : t === Js && n === Ks ? i = "LinearDisplayP3ToLinearSRGB" : t === Ks && n === Js && (i = "LinearSRGBToLinearDisplayP3"), e1){
                    case Ws:
                    case Xs:
                        return [
                            i,
                            "LinearTransferOETF"
                        ];
                    case Qs:
                    case Ys:
                        return [
                            i,
                            "sRGBTransferOETF"
                        ];
                    default:
                        return console.warn("THREE.WebGLProgram: Unsupported color space:", e1), [
                            i,
                            "LinearTransferOETF"
                        ];
                }
            }(t);
            return `vec4 ${e1}( vec4 value ) { return ${n[0]}( ${n[1]}( value ) ); }`;
        }
        function ip(e1, t) {
            let n;
            switch(t){
                case Jr:
                    n = "Linear";
                    break;
                case $r:
                    n = "Reinhard";
                    break;
                case ea:
                    n = "OptimizedCineon";
                    break;
                case ta:
                    n = "ACESFilmic";
                    break;
                case na:
                    n = "Custom";
                    break;
                default:
                    console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), n = "Linear";
            }
            return "vec3 " + e1 + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
        }
        function rp(e1) {
            return "" !== e1;
        }
        function ap(e1, t) {
            const n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
            return e1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
        }
        function sp(e1, t) {
            return e1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
        }
        const op = /^[ \t]*#include +<([\w\d./]+)>/gm;
        function lp(e1) {
            return e1.replace(op, up);
        }
        const cp = new Map([
            [
                "encodings_fragment",
                "colorspace_fragment"
            ],
            [
                "encodings_pars_fragment",
                "colorspace_pars_fragment"
            ],
            [
                "output_fragment",
                "opaque_fragment"
            ]
        ]);
        function up(e1, t) {
            let n = fh[t];
            if (void 0 === n) {
                const e1 = cp.get(t);
                if (void 0 === e1) throw new Error("Can not resolve #include <" + t + ">");
                n = fh[e1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, e1);
            }
            return lp(n);
        }
        const hp = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
        function dp(e1) {
            return e1.replace(hp, pp);
        }
        function pp(e1, t, n, i) {
            let r = "";
            for(let e1 = parseInt(t); e1 < parseInt(n); e1++)r += i.replace(/\[\s*i\s*\]/g, "[ " + e1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, e1);
            return r;
        }
        function fp(e1) {
            let t = "precision " + e1.precision + " float;\nprecision " + e1.precision + " int;";
            return "highp" === e1.precision ? t += "\n#define HIGH_PRECISION" : "mediump" === e1.precision ? t += "\n#define MEDIUM_PRECISION" : "lowp" === e1.precision && (t += "\n#define LOW_PRECISION"), t;
        }
        function gp(e1, t, n, i) {
            const r = e1.getContext(), a = n.defines;
            let s = n.vertexShader, o = n.fragmentShader;
            const l = function(e1) {
                let t = "SHADOWMAP_TYPE_BASIC";
                return e1.shadowMapType === or ? t = "SHADOWMAP_TYPE_PCF" : e1.shadowMapType === lr ? t = "SHADOWMAP_TYPE_PCF_SOFT" : e1.shadowMapType === cr && (t = "SHADOWMAP_TYPE_VSM"), t;
            }(n), c = function(e1) {
                let t = "ENVMAP_TYPE_CUBE";
                if (e1.envMap) switch(e1.envMapMode){
                    case sa:
                    case oa:
                        t = "ENVMAP_TYPE_CUBE";
                        break;
                    case ua:
                        t = "ENVMAP_TYPE_CUBE_UV";
                }
                return t;
            }(n), u = function(e1) {
                let t = "ENVMAP_MODE_REFLECTION";
                return e1.envMap && e1.envMapMode === oa && (t = "ENVMAP_MODE_REFRACTION"), t;
            }(n), h = function(e1) {
                let t = "ENVMAP_BLENDING_NONE";
                if (e1.envMap) switch(e1.combine){
                    case Xr:
                        t = "ENVMAP_BLENDING_MULTIPLY";
                        break;
                    case Zr:
                        t = "ENVMAP_BLENDING_MIX";
                        break;
                    case qr:
                        t = "ENVMAP_BLENDING_ADD";
                }
                return t;
            }(n), d = function(e1) {
                const t = e1.envMapCubeUVHeight;
                if (null === t) return null;
                const n = Math.log2(t) - 2, i = 1 / t;
                return {
                    texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
                    texelHeight: i,
                    maxMip: n
                };
            }(n), p = n.isWebGL2 ? "" : function(e1) {
                return [
                    e1.extensionDerivatives || e1.envMapCubeUVHeight || e1.bumpMap || e1.normalMapTangentSpace || e1.clearcoatNormalMap || e1.flatShading || "physical" === e1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
                    (e1.extensionFragDepth || e1.logarithmicDepthBuffer) && e1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
                    e1.extensionDrawBuffers && e1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
                    (e1.extensionShaderTextureLOD || e1.envMap || e1.transmission) && e1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
                ].filter(rp).join("\n");
            }(n), f = function(e1) {
                const t = [];
                for(const n in e1){
                    const i = e1[n];
                    !1 !== i && t.push("#define " + n + " " + i);
                }
                return t.join("\n");
            }(a), g = r.createProgram();
            let m, A, M = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
            n.isRawShaderMaterial ? (m = [
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(rp).join("\n"), m.length > 0 && (m += "\n"), A = [
                p,
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(rp).join("\n"), A.length > 0 && (A += "\n")) : (m = [
                fp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.instancing ? "#define USE_INSTANCING" : "",
                n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + u : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.mapUv ? "#define MAP_UV " + n.mapUv : "",
                n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
                n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
                n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
                n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
                n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
                n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
                n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
                n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
                n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
                n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
                n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
                n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
                n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
                n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
                n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
                n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
                n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
                n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
                n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
                n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
                n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
                n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.skinning ? "#define USE_SKINNING" : "",
                n.morphTargets ? "#define USE_MORPHTARGETS" : "",
                n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "",
                n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 modelMatrix;",
                "uniform mat4 modelViewMatrix;",
                "uniform mat4 projectionMatrix;",
                "uniform mat4 viewMatrix;",
                "uniform mat3 normalMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                "#ifdef USE_INSTANCING",
                "\tattribute mat4 instanceMatrix;",
                "#endif",
                "#ifdef USE_INSTANCING_COLOR",
                "\tattribute vec3 instanceColor;",
                "#endif",
                "attribute vec3 position;",
                "attribute vec3 normal;",
                "attribute vec2 uv;",
                "#ifdef USE_UV1",
                "\tattribute vec2 uv1;",
                "#endif",
                "#ifdef USE_UV2",
                "\tattribute vec2 uv2;",
                "#endif",
                "#ifdef USE_UV3",
                "\tattribute vec2 uv3;",
                "#endif",
                "#ifdef USE_TANGENT",
                "\tattribute vec4 tangent;",
                "#endif",
                "#if defined( USE_COLOR_ALPHA )",
                "\tattribute vec4 color;",
                "#elif defined( USE_COLOR )",
                "\tattribute vec3 color;",
                "#endif",
                "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
                "\tattribute vec3 morphTarget0;",
                "\tattribute vec3 morphTarget1;",
                "\tattribute vec3 morphTarget2;",
                "\tattribute vec3 morphTarget3;",
                "\t#ifdef USE_MORPHNORMALS",
                "\t\tattribute vec3 morphNormal0;",
                "\t\tattribute vec3 morphNormal1;",
                "\t\tattribute vec3 morphNormal2;",
                "\t\tattribute vec3 morphNormal3;",
                "\t#else",
                "\t\tattribute vec3 morphTarget4;",
                "\t\tattribute vec3 morphTarget5;",
                "\t\tattribute vec3 morphTarget6;",
                "\t\tattribute vec3 morphTarget7;",
                "\t#endif",
                "#endif",
                "#ifdef USE_SKINNING",
                "\tattribute vec4 skinIndex;",
                "\tattribute vec4 skinWeight;",
                "#endif",
                "\n"
            ].filter(rp).join("\n"), A = [
                p,
                fp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.matcap ? "#define USE_MATCAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + c : "",
                n.envMap ? "#define " + u : "",
                n.envMap ? "#define " + h : "",
                d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
                d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
                d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoat ? "#define USE_CLEARCOAT" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescence ? "#define USE_IRIDESCENCE" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaTest ? "#define USE_ALPHATEST" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.sheen ? "#define USE_SHEEN" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.gradientMap ? "#define USE_GRADIENTMAP" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 viewMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                n.toneMapping !== Kr ? "#define TONE_MAPPING" : "",
                n.toneMapping !== Kr ? fh.tonemapping_pars_fragment : "",
                n.toneMapping !== Kr ? ip("toneMapping", n.toneMapping) : "",
                n.dithering ? "#define DITHERING" : "",
                n.opaque ? "#define OPAQUE" : "",
                fh.colorspace_pars_fragment,
                np("linearToOutputTexel", n.outputColorSpace),
                n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
                "\n"
            ].filter(rp).join("\n")), s = lp(s), s = ap(s, n), s = sp(s, n), o = lp(o), o = ap(o, n), o = sp(o, n), s = dp(s), o = dp(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (M = "#version 300 es\n", m = [
                "precision mediump sampler2DArray;",
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") + "\n" + m, A = [
                "precision mediump sampler2DArray;",
                "#define varying in",
                n.glslVersion === Oo ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                n.glslVersion === Oo ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") + "\n" + A);
            const v = M + m + s, y = M + A + o, x = Jd(r, r.VERTEX_SHADER, v), b = Jd(r, r.FRAGMENT_SHADER, y);
            function w(t) {
                if (e1.debug.checkShaderErrors) {
                    const n = r.getProgramInfoLog(g).trim(), i = r.getShaderInfoLog(x).trim(), a = r.getShaderInfoLog(b).trim();
                    let s = !0, o = !0;
                    if (!1 === r.getProgramParameter(g, r.LINK_STATUS)) {
                        if (s = !1, "function" == typeof e1.debug.onShaderError) e1.debug.onShaderError(r, g, x, b);
                        else {
                            const e1 = tp(r, x, "vertex"), t = tp(r, b, "fragment");
                            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(g, r.VALIDATE_STATUS) + "\n\nProgram Info Log: " + n + "\n" + e1 + "\n" + t);
                        }
                    } else "" !== n ? console.warn("THREE.WebGLProgram: Program Info Log:", n) : "" !== i && "" !== a || (o = !1);
                    o && (t.diagnostics = {
                        runnable: s,
                        programLog: n,
                        vertexShader: {
                            log: i,
                            prefix: m
                        },
                        fragmentShader: {
                            log: a,
                            prefix: A
                        }
                    });
                }
                r.deleteShader(x), r.deleteShader(b), E = new Kd(r, g), T = function(e1, t) {
                    const n = {}, i = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
                    for(let r = 0; r < i; r++){
                        const i = e1.getActiveAttrib(t, r), a = i.name;
                        let s = 1;
                        i.type === e1.FLOAT_MAT2 && (s = 2), i.type === e1.FLOAT_MAT3 && (s = 3), i.type === e1.FLOAT_MAT4 && (s = 4), n[a] = {
                            type: i.type,
                            location: e1.getAttribLocation(t, a),
                            locationSize: s
                        };
                    }
                    return n;
                }(r, g);
            }
            let E, T;
            r.attachShader(g, x), r.attachShader(g, b), void 0 !== n.index0AttributeName ? r.bindAttribLocation(g, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(g, 0, "position"), r.linkProgram(g), this.getUniforms = function() {
                return void 0 === E && w(this), E;
            }, this.getAttributes = function() {
                return void 0 === T && w(this), T;
            };
            let S = !1 === n.rendererExtensionParallelShaderCompile;
            return this.isReady = function() {
                return !1 === S && (S = r.getProgramParameter(g, $d)), S;
            }, this.destroy = function() {
                i.releaseStatesOfProgram(this), r.deleteProgram(g), this.program = void 0;
            }, this.type = n.shaderType, this.name = n.shaderName, this.id = ep++, this.cacheKey = t, this.usedTimes = 1, this.program = g, this.vertexShader = x, this.fragmentShader = b, this;
        }
        let mp = 0;
        class Ap {
            constructor(){
                this.shaderCache = new Map, this.materialCache = new Map;
            }
            update(e1) {
                const t = e1.vertexShader, n = e1.fragmentShader, i = this._getShaderStage(t), r = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e1);
                return !1 === a.has(i) && (a.add(i), i.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
            }
            remove(e1) {
                const t = this.materialCache.get(e1);
                for (const e1 of t)e1.usedTimes--, 0 === e1.usedTimes && this.shaderCache.delete(e1.code);
                return this.materialCache.delete(e1), this;
            }
            getVertexShaderID(e1) {
                return this._getShaderStage(e1.vertexShader).id;
            }
            getFragmentShaderID(e1) {
                return this._getShaderStage(e1.fragmentShader).id;
            }
            dispose() {
                this.shaderCache.clear(), this.materialCache.clear();
            }
            _getShaderCacheForMaterial(e1) {
                const t = this.materialCache;
                let n = t.get(e1);
                return void 0 === n && (n = new Set, t.set(e1, n)), n;
            }
            _getShaderStage(e1) {
                const t = this.shaderCache;
                let n = t.get(e1);
                return void 0 === n && (n = new Mp(e1), t.set(e1, n)), n;
            }
        }
        class Mp {
            constructor(e1){
                this.id = mp++, this.code = e1, this.usedTimes = 0;
            }
        }
        function vp(e1, t, n, i, r, a, s) {
            const o = new vc, l = new Ap, c = [], u = r.isWebGL2, h = r.logarithmicDepthBuffer, d = r.vertexTextures;
            let p = r.precision;
            const f = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "toon",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                MeshMatcapMaterial: "matcap",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
            };
            function g(e1) {
                return 0 === e1 ? "uv" : `uv${e1}`;
            }
            return {
                getParameters: function(a, o, c, m, A) {
                    const M = m.fog, v = A.geometry, y = a.isMeshStandardMaterial ? m.environment : null, x = (a.isMeshStandardMaterial ? n : t).get(a.envMap || y), b = x && x.mapping === ua ? x.image.height : null, w = f[a.type];
                    null !== a.precision && (p = r.getMaxPrecision(a.precision), p !== a.precision && console.warn("THREE.WebGLProgram.getParameters:", a.precision, "not supported, using", p, "instead."));
                    const E = v.morphAttributes.position || v.morphAttributes.normal || v.morphAttributes.color, T = void 0 !== E ? E.length : 0;
                    let S, I, N, D, _ = 0;
                    if (void 0 !== v.morphAttributes.position && (_ = 1), void 0 !== v.morphAttributes.normal && (_ = 2), void 0 !== v.morphAttributes.color && (_ = 3), w) {
                        const e1 = mh[w];
                        S = e1.vertexShader, I = e1.fragmentShader;
                    } else S = a.vertexShader, I = a.fragmentShader, l.update(a), N = l.getVertexShaderID(a), D = l.getFragmentShaderID(a);
                    const C = e1.getRenderTarget(), L = !0 === A.isInstancedMesh, z = !!a.map, O = !!a.matcap, R = !!x, P = !!a.aoMap, U = !!a.lightMap, j = !!a.bumpMap, k = !!a.normalMap, B = !!a.displacementMap, F = !!a.emissiveMap, H = !!a.metalnessMap, G = !!a.roughnessMap, V = a.anisotropy > 0, Q = a.clearcoat > 0, W = a.iridescence > 0, Y = a.sheen > 0, X = a.transmission > 0, Z = V && !!a.anisotropyMap, q = Q && !!a.clearcoatMap, K = Q && !!a.clearcoatNormalMap, J = Q && !!a.clearcoatRoughnessMap, $ = W && !!a.iridescenceMap, ee = W && !!a.iridescenceThicknessMap, te = Y && !!a.sheenColorMap, ne = Y && !!a.sheenRoughnessMap, ie = !!a.specularMap, re = !!a.specularColorMap, ae = !!a.specularIntensityMap, se = X && !!a.transmissionMap, oe = X && !!a.thicknessMap, le = !!a.gradientMap, ce = !!a.alphaMap, ue = a.alphaTest > 0, he = !!a.alphaHash, de = !!a.extensions, pe = !!v.attributes.uv1, fe = !!v.attributes.uv2, ge = !!v.attributes.uv3;
                    let me = Kr;
                    return a.toneMapped && (null !== C && !0 !== C.isXRRenderTarget || (me = e1.toneMapping)), {
                        isWebGL2: u,
                        shaderID: w,
                        shaderType: a.type,
                        shaderName: a.name,
                        vertexShader: S,
                        fragmentShader: I,
                        defines: a.defines,
                        customVertexShaderID: N,
                        customFragmentShaderID: D,
                        isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                        glslVersion: a.glslVersion,
                        precision: p,
                        instancing: L,
                        instancingColor: L && null !== A.instanceColor,
                        supportsVertexTextures: d,
                        outputColorSpace: null === C ? e1.outputColorSpace : !0 === C.isXRRenderTarget ? C.texture.colorSpace : Ws,
                        map: z,
                        matcap: O,
                        envMap: R,
                        envMapMode: R && x.mapping,
                        envMapCubeUVHeight: b,
                        aoMap: P,
                        lightMap: U,
                        bumpMap: j,
                        normalMap: k,
                        displacementMap: d && B,
                        emissiveMap: F,
                        normalMapObjectSpace: k && a.normalMapType === Gs,
                        normalMapTangentSpace: k && a.normalMapType === Hs,
                        metalnessMap: H,
                        roughnessMap: G,
                        anisotropy: V,
                        anisotropyMap: Z,
                        clearcoat: Q,
                        clearcoatMap: q,
                        clearcoatNormalMap: K,
                        clearcoatRoughnessMap: J,
                        iridescence: W,
                        iridescenceMap: $,
                        iridescenceThicknessMap: ee,
                        sheen: Y,
                        sheenColorMap: te,
                        sheenRoughnessMap: ne,
                        specularMap: ie,
                        specularColorMap: re,
                        specularIntensityMap: ae,
                        transmission: X,
                        transmissionMap: se,
                        thicknessMap: oe,
                        gradientMap: le,
                        opaque: !1 === a.transparent && a.blending === gr,
                        alphaMap: ce,
                        alphaTest: ue,
                        alphaHash: he,
                        combine: a.combine,
                        mapUv: z && g(a.map.channel),
                        aoMapUv: P && g(a.aoMap.channel),
                        lightMapUv: U && g(a.lightMap.channel),
                        bumpMapUv: j && g(a.bumpMap.channel),
                        normalMapUv: k && g(a.normalMap.channel),
                        displacementMapUv: B && g(a.displacementMap.channel),
                        emissiveMapUv: F && g(a.emissiveMap.channel),
                        metalnessMapUv: H && g(a.metalnessMap.channel),
                        roughnessMapUv: G && g(a.roughnessMap.channel),
                        anisotropyMapUv: Z && g(a.anisotropyMap.channel),
                        clearcoatMapUv: q && g(a.clearcoatMap.channel),
                        clearcoatNormalMapUv: K && g(a.clearcoatNormalMap.channel),
                        clearcoatRoughnessMapUv: J && g(a.clearcoatRoughnessMap.channel),
                        iridescenceMapUv: $ && g(a.iridescenceMap.channel),
                        iridescenceThicknessMapUv: ee && g(a.iridescenceThicknessMap.channel),
                        sheenColorMapUv: te && g(a.sheenColorMap.channel),
                        sheenRoughnessMapUv: ne && g(a.sheenRoughnessMap.channel),
                        specularMapUv: ie && g(a.specularMap.channel),
                        specularColorMapUv: re && g(a.specularColorMap.channel),
                        specularIntensityMapUv: ae && g(a.specularIntensityMap.channel),
                        transmissionMapUv: se && g(a.transmissionMap.channel),
                        thicknessMapUv: oe && g(a.thicknessMap.channel),
                        alphaMapUv: ce && g(a.alphaMap.channel),
                        vertexTangents: !!v.attributes.tangent && (k || V),
                        vertexColors: a.vertexColors,
                        vertexAlphas: !0 === a.vertexColors && !!v.attributes.color && 4 === v.attributes.color.itemSize,
                        vertexUv1s: pe,
                        vertexUv2s: fe,
                        vertexUv3s: ge,
                        pointsUvs: !0 === A.isPoints && !!v.attributes.uv && (z || ce),
                        fog: !!M,
                        useFog: !0 === a.fog,
                        fogExp2: M && M.isFogExp2,
                        flatShading: !0 === a.flatShading,
                        sizeAttenuation: !0 === a.sizeAttenuation,
                        logarithmicDepthBuffer: h,
                        skinning: !0 === A.isSkinnedMesh,
                        morphTargets: void 0 !== v.morphAttributes.position,
                        morphNormals: void 0 !== v.morphAttributes.normal,
                        morphColors: void 0 !== v.morphAttributes.color,
                        morphTargetsCount: T,
                        morphTextureStride: _,
                        numDirLights: o.directional.length,
                        numPointLights: o.point.length,
                        numSpotLights: o.spot.length,
                        numSpotLightMaps: o.spotLightMap.length,
                        numRectAreaLights: o.rectArea.length,
                        numHemiLights: o.hemi.length,
                        numDirLightShadows: o.directionalShadowMap.length,
                        numPointLightShadows: o.pointShadowMap.length,
                        numSpotLightShadows: o.spotShadowMap.length,
                        numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
                        numLightProbes: o.numLightProbes,
                        numClippingPlanes: s.numPlanes,
                        numClipIntersection: s.numIntersection,
                        dithering: a.dithering,
                        shadowMapEnabled: e1.shadowMap.enabled && c.length > 0,
                        shadowMapType: e1.shadowMap.type,
                        toneMapping: me,
                        useLegacyLights: e1._useLegacyLights,
                        decodeVideoTexture: z && !0 === a.map.isVideoTexture && pl.getTransfer(a.map.colorSpace) === qs,
                        premultipliedAlpha: a.premultipliedAlpha,
                        doubleSided: a.side === dr,
                        flipSided: a.side === hr,
                        useDepthPacking: a.depthPacking >= 0,
                        depthPacking: a.depthPacking || 0,
                        index0AttributeName: a.index0AttributeName,
                        extensionDerivatives: de && !0 === a.extensions.derivatives,
                        extensionFragDepth: de && !0 === a.extensions.fragDepth,
                        extensionDrawBuffers: de && !0 === a.extensions.drawBuffers,
                        extensionShaderTextureLOD: de && !0 === a.extensions.shaderTextureLOD,
                        rendererExtensionFragDepth: u || i.has("EXT_frag_depth"),
                        rendererExtensionDrawBuffers: u || i.has("WEBGL_draw_buffers"),
                        rendererExtensionShaderTextureLod: u || i.has("EXT_shader_texture_lod"),
                        rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                        customProgramCacheKey: a.customProgramCacheKey()
                    };
                },
                getProgramCacheKey: function(t) {
                    const n = [];
                    if (t.shaderID ? n.push(t.shaderID) : (n.push(t.customVertexShaderID), n.push(t.customFragmentShaderID)), void 0 !== t.defines) for(const e1 in t.defines)n.push(e1), n.push(t.defines[e1]);
                    return !1 === t.isRawShaderMaterial && (function(e1, t) {
                        e1.push(t.precision), e1.push(t.outputColorSpace), e1.push(t.envMapMode), e1.push(t.envMapCubeUVHeight), e1.push(t.mapUv), e1.push(t.alphaMapUv), e1.push(t.lightMapUv), e1.push(t.aoMapUv), e1.push(t.bumpMapUv), e1.push(t.normalMapUv), e1.push(t.displacementMapUv), e1.push(t.emissiveMapUv), e1.push(t.metalnessMapUv), e1.push(t.roughnessMapUv), e1.push(t.anisotropyMapUv), e1.push(t.clearcoatMapUv), e1.push(t.clearcoatNormalMapUv), e1.push(t.clearcoatRoughnessMapUv), e1.push(t.iridescenceMapUv), e1.push(t.iridescenceThicknessMapUv), e1.push(t.sheenColorMapUv), e1.push(t.sheenRoughnessMapUv), e1.push(t.specularMapUv), e1.push(t.specularColorMapUv), e1.push(t.specularIntensityMapUv), e1.push(t.transmissionMapUv), e1.push(t.thicknessMapUv), e1.push(t.combine), e1.push(t.fogExp2), e1.push(t.sizeAttenuation), e1.push(t.morphTargetsCount), e1.push(t.morphAttributeCount), e1.push(t.numDirLights), e1.push(t.numPointLights), e1.push(t.numSpotLights), e1.push(t.numSpotLightMaps), e1.push(t.numHemiLights), e1.push(t.numRectAreaLights), e1.push(t.numDirLightShadows), e1.push(t.numPointLightShadows), e1.push(t.numSpotLightShadows), e1.push(t.numSpotLightShadowsWithMaps), e1.push(t.numLightProbes), e1.push(t.shadowMapType), e1.push(t.toneMapping), e1.push(t.numClippingPlanes), e1.push(t.numClipIntersection), e1.push(t.depthPacking);
                    }(n, t), function(e1, t) {
                        o.disableAll(), t.isWebGL2 && o.enable(0), t.supportsVertexTextures && o.enable(1), t.instancing && o.enable(2), t.instancingColor && o.enable(3), t.matcap && o.enable(4), t.envMap && o.enable(5), t.normalMapObjectSpace && o.enable(6), t.normalMapTangentSpace && o.enable(7), t.clearcoat && o.enable(8), t.iridescence && o.enable(9), t.alphaTest && o.enable(10), t.vertexColors && o.enable(11), t.vertexAlphas && o.enable(12), t.vertexUv1s && o.enable(13), t.vertexUv2s && o.enable(14), t.vertexUv3s && o.enable(15), t.vertexTangents && o.enable(16), t.anisotropy && o.enable(17), t.alphaHash && o.enable(18), e1.push(o.mask), o.disableAll(), t.fog && o.enable(0), t.useFog && o.enable(1), t.flatShading && o.enable(2), t.logarithmicDepthBuffer && o.enable(3), t.skinning && o.enable(4), t.morphTargets && o.enable(5), t.morphNormals && o.enable(6), t.morphColors && o.enable(7), t.premultipliedAlpha && o.enable(8), t.shadowMapEnabled && o.enable(9), t.useLegacyLights && o.enable(10), t.doubleSided && o.enable(11), t.flipSided && o.enable(12), t.useDepthPacking && o.enable(13), t.dithering && o.enable(14), t.transmission && o.enable(15), t.sheen && o.enable(16), t.opaque && o.enable(17), t.pointsUvs && o.enable(18), t.decodeVideoTexture && o.enable(19), e1.push(o.mask);
                    }(n, t), n.push(e1.outputColorSpace)), n.push(t.customProgramCacheKey), n.join();
                },
                getUniforms: function(e1) {
                    const t = f[e1.type];
                    let n;
                    if (t) {
                        const e1 = mh[t];
                        n = qu.clone(e1.uniforms);
                    } else n = e1.uniforms;
                    return n;
                },
                acquireProgram: function(t, n) {
                    let i;
                    for(let e1 = 0, t = c.length; e1 < t; e1++){
                        const t = c[e1];
                        if (t.cacheKey === n) {
                            i = t, ++i.usedTimes;
                            break;
                        }
                    }
                    return void 0 === i && (i = new gp(e1, n, t, a), c.push(i)), i;
                },
                releaseProgram: function(e1) {
                    if (0 == --e1.usedTimes) {
                        const t = c.indexOf(e1);
                        c[t] = c[c.length - 1], c.pop(), e1.destroy();
                    }
                },
                releaseShaderCache: function(e1) {
                    l.remove(e1);
                },
                programs: c,
                dispose: function() {
                    l.dispose();
                }
            };
        }
        function yp() {
            let e1 = new WeakMap;
            return {
                get: function(t) {
                    let n = e1.get(t);
                    return void 0 === n && (n = {}, e1.set(t, n)), n;
                },
                remove: function(t) {
                    e1.delete(t);
                },
                update: function(t, n, i) {
                    e1.get(t)[n] = i;
                },
                dispose: function() {
                    e1 = new WeakMap;
                }
            };
        }
        function xp(e1, t) {
            return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.material.id !== t.material.id ? e1.material.id - t.material.id : e1.z !== t.z ? e1.z - t.z : e1.id - t.id;
        }
        function bp(e1, t) {
            return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.z !== t.z ? t.z - e1.z : e1.id - t.id;
        }
        function wp() {
            const e1 = [];
            let t = 0;
            const n = [], i = [], r = [];
            function a(n, i, r, a, s, o) {
                let l = e1[t];
                return void 0 === l ? (l = {
                    id: n.id,
                    object: n,
                    geometry: i,
                    material: r,
                    groupOrder: a,
                    renderOrder: n.renderOrder,
                    z: s,
                    group: o
                }, e1[t] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = s, l.group = o), t++, l;
            }
            return {
                opaque: n,
                transmissive: i,
                transparent: r,
                init: function() {
                    t = 0, n.length = 0, i.length = 0, r.length = 0;
                },
                push: function(e1, t, s, o, l, c) {
                    const u = a(e1, t, s, o, l, c);
                    s.transmission > 0 ? i.push(u) : !0 === s.transparent ? r.push(u) : n.push(u);
                },
                unshift: function(e1, t, s, o, l, c) {
                    const u = a(e1, t, s, o, l, c);
                    s.transmission > 0 ? i.unshift(u) : !0 === s.transparent ? r.unshift(u) : n.unshift(u);
                },
                finish: function() {
                    for(let n = t, i = e1.length; n < i; n++){
                        const t = e1[n];
                        if (null === t.id) break;
                        t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
                    }
                },
                sort: function(e1, t) {
                    n.length > 1 && n.sort(e1 || xp), i.length > 1 && i.sort(t || bp), r.length > 1 && r.sort(t || bp);
                }
            };
        }
        function Ep() {
            let e1 = new WeakMap;
            return {
                get: function(t, n) {
                    const i = e1.get(t);
                    let r;
                    return void 0 === i ? (r = new wp, e1.set(t, [
                        r
                    ])) : n >= i.length ? (r = new wp, i.push(r)) : r = i[n], r;
                },
                dispose: function() {
                    e1 = new WeakMap;
                }
            };
        }
        function Tp() {
            const e1 = {};
            return {
                get: function(t) {
                    if (void 0 !== e1[t.id]) return e1[t.id];
                    let n;
                    switch(t.type){
                        case "DirectionalLight":
                            n = {
                                direction: new Ll,
                                color: new qc
                            };
                            break;
                        case "SpotLight":
                            n = {
                                position: new Ll,
                                direction: new Ll,
                                color: new qc,
                                distance: 0,
                                coneCos: 0,
                                penumbraCos: 0,
                                decay: 0
                            };
                            break;
                        case "PointLight":
                            n = {
                                position: new Ll,
                                color: new qc,
                                distance: 0,
                                decay: 0
                            };
                            break;
                        case "HemisphereLight":
                            n = {
                                direction: new Ll,
                                skyColor: new qc,
                                groundColor: new qc
                            };
                            break;
                        case "RectAreaLight":
                            n = {
                                color: new qc,
                                position: new Ll,
                                halfWidth: new Ll,
                                halfHeight: new Ll
                            };
                    }
                    return e1[t.id] = n, n;
                }
            };
        }
        let Sp = 0;
        function Ip(e1, t) {
            return (t.castShadow ? 2 : 0) - (e1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e1.map ? 1 : 0);
        }
        function Np(e1, t) {
            const n = new Tp, i = function() {
                const e1 = {};
                return {
                    get: function(t) {
                        if (void 0 !== e1[t.id]) return e1[t.id];
                        let n;
                        switch(t.type){
                            case "DirectionalLight":
                            case "SpotLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new $o
                                };
                                break;
                            case "PointLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new $o,
                                    shadowCameraNear: 1,
                                    shadowCameraFar: 1e3
                                };
                        }
                        return e1[t.id] = n, n;
                    }
                };
            }(), r = {
                version: 0,
                hash: {
                    directionalLength: -1,
                    pointLength: -1,
                    spotLength: -1,
                    rectAreaLength: -1,
                    hemiLength: -1,
                    numDirectionalShadows: -1,
                    numPointShadows: -1,
                    numSpotShadows: -1,
                    numSpotMaps: -1,
                    numLightProbes: -1
                },
                ambient: [
                    0,
                    0,
                    0
                ],
                probe: [],
                directional: [],
                directionalShadow: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotLightMap: [],
                spotShadow: [],
                spotShadowMap: [],
                spotLightMatrix: [],
                rectArea: [],
                rectAreaLTC1: null,
                rectAreaLTC2: null,
                point: [],
                pointShadow: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: [],
                numSpotLightShadowsWithMaps: 0,
                numLightProbes: 0
            };
            for(let e1 = 0; e1 < 9; e1++)r.probe.push(new Ll);
            const a = new Ll, s = new lc, o = new lc;
            return {
                setup: function(a, s) {
                    let o = 0, l = 0, c = 0;
                    for(let e1 = 0; e1 < 9; e1++)r.probe[e1].set(0, 0, 0);
                    let u = 0, h = 0, d = 0, p = 0, f = 0, g = 0, m = 0, A = 0, M = 0, v = 0, y = 0;
                    a.sort(Ip);
                    const x = !0 === s ? Math.PI : 1;
                    for(let e1 = 0, t = a.length; e1 < t; e1++){
                        const t = a[e1], s = t.color, b = t.intensity, w = t.distance, E = t.shadow && t.shadow.map ? t.shadow.map.texture : null;
                        if (t.isAmbientLight) o += s.r * b * x, l += s.g * b * x, c += s.b * b * x;
                        else if (t.isLightProbe) {
                            for(let e1 = 0; e1 < 9; e1++)r.probe[e1].addScaledVector(t.sh.coefficients[e1], b);
                            y++;
                        } else if (t.isDirectionalLight) {
                            const e1 = n.get(t);
                            if (e1.color.copy(t.color).multiplyScalar(t.intensity * x), t.castShadow) {
                                const e1 = t.shadow, n = i.get(t);
                                n.shadowBias = e1.bias, n.shadowNormalBias = e1.normalBias, n.shadowRadius = e1.radius, n.shadowMapSize = e1.mapSize, r.directionalShadow[u] = n, r.directionalShadowMap[u] = E, r.directionalShadowMatrix[u] = t.shadow.matrix, g++;
                            }
                            r.directional[u] = e1, u++;
                        } else if (t.isSpotLight) {
                            const e1 = n.get(t);
                            e1.position.setFromMatrixPosition(t.matrixWorld), e1.color.copy(s).multiplyScalar(b * x), e1.distance = w, e1.coneCos = Math.cos(t.angle), e1.penumbraCos = Math.cos(t.angle * (1 - t.penumbra)), e1.decay = t.decay, r.spot[d] = e1;
                            const a = t.shadow;
                            if (t.map && (r.spotLightMap[M] = t.map, M++, a.updateMatrices(t), t.castShadow && v++), r.spotLightMatrix[d] = a.matrix, t.castShadow) {
                                const e1 = i.get(t);
                                e1.shadowBias = a.bias, e1.shadowNormalBias = a.normalBias, e1.shadowRadius = a.radius, e1.shadowMapSize = a.mapSize, r.spotShadow[d] = e1, r.spotShadowMap[d] = E, A++;
                            }
                            d++;
                        } else if (t.isRectAreaLight) {
                            const e1 = n.get(t);
                            e1.color.copy(s).multiplyScalar(b), e1.halfWidth.set(.5 * t.width, 0, 0), e1.halfHeight.set(0, .5 * t.height, 0), r.rectArea[p] = e1, p++;
                        } else if (t.isPointLight) {
                            const e1 = n.get(t);
                            if (e1.color.copy(t.color).multiplyScalar(t.intensity * x), e1.distance = t.distance, e1.decay = t.decay, t.castShadow) {
                                const e1 = t.shadow, n = i.get(t);
                                n.shadowBias = e1.bias, n.shadowNormalBias = e1.normalBias, n.shadowRadius = e1.radius, n.shadowMapSize = e1.mapSize, n.shadowCameraNear = e1.camera.near, n.shadowCameraFar = e1.camera.far, r.pointShadow[h] = n, r.pointShadowMap[h] = E, r.pointShadowMatrix[h] = t.shadow.matrix, m++;
                            }
                            r.point[h] = e1, h++;
                        } else if (t.isHemisphereLight) {
                            const e1 = n.get(t);
                            e1.skyColor.copy(t.color).multiplyScalar(b * x), e1.groundColor.copy(t.groundColor).multiplyScalar(b * x), r.hemi[f] = e1, f++;
                        }
                    }
                    p > 0 && (t.isWebGL2 || !0 === e1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = gh.LTC_FLOAT_1, r.rectAreaLTC2 = gh.LTC_FLOAT_2) : !0 === e1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = gh.LTC_HALF_1, r.rectAreaLTC2 = gh.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
                    const b = r.hash;
                    b.directionalLength === u && b.pointLength === h && b.spotLength === d && b.rectAreaLength === p && b.hemiLength === f && b.numDirectionalShadows === g && b.numPointShadows === m && b.numSpotShadows === A && b.numSpotMaps === M && b.numLightProbes === y || (r.directional.length = u, r.spot.length = d, r.rectArea.length = p, r.point.length = h, r.hemi.length = f, r.directionalShadow.length = g, r.directionalShadowMap.length = g, r.pointShadow.length = m, r.pointShadowMap.length = m, r.spotShadow.length = A, r.spotShadowMap.length = A, r.directionalShadowMatrix.length = g, r.pointShadowMatrix.length = m, r.spotLightMatrix.length = A + M - v, r.spotLightMap.length = M, r.numSpotLightShadowsWithMaps = v, r.numLightProbes = y, b.directionalLength = u, b.pointLength = h, b.spotLength = d, b.rectAreaLength = p, b.hemiLength = f, b.numDirectionalShadows = g, b.numPointShadows = m, b.numSpotShadows = A, b.numSpotMaps = M, b.numLightProbes = y, r.version = Sp++);
                },
                setupView: function(e1, t) {
                    let n = 0, i = 0, l = 0, c = 0, u = 0;
                    const h = t.matrixWorldInverse;
                    for(let t = 0, d = e1.length; t < d; t++){
                        const d = e1[t];
                        if (d.isDirectionalLight) {
                            const e1 = r.directional[n];
                            e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), n++;
                        } else if (d.isSpotLight) {
                            const e1 = r.spot[l];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), l++;
                        } else if (d.isRectAreaLight) {
                            const e1 = r.rectArea[c];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), o.identity(), s.copy(d.matrixWorld), s.premultiply(h), o.extractRotation(s), e1.halfWidth.set(.5 * d.width, 0, 0), e1.halfHeight.set(0, .5 * d.height, 0), e1.halfWidth.applyMatrix4(o), e1.halfHeight.applyMatrix4(o), c++;
                        } else if (d.isPointLight) {
                            const e1 = r.point[i];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), i++;
                        } else if (d.isHemisphereLight) {
                            const e1 = r.hemi[u];
                            e1.direction.setFromMatrixPosition(d.matrixWorld), e1.direction.transformDirection(h), u++;
                        }
                    }
                },
                state: r
            };
        }
        function Dp(e1, t) {
            const n = new Np(e1, t), i = [], r = [];
            return {
                init: function() {
                    i.length = 0, r.length = 0;
                },
                state: {
                    lightsArray: i,
                    shadowsArray: r,
                    lights: n
                },
                setupLights: function(e1) {
                    n.setup(i, e1);
                },
                setupLightsView: function(e1) {
                    n.setupView(i, e1);
                },
                pushLight: function(e1) {
                    i.push(e1);
                },
                pushShadow: function(e1) {
                    r.push(e1);
                }
            };
        }
        function _p(e1, t) {
            let n = new WeakMap;
            return {
                get: function(i) {
                    let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const a = n.get(i);
                    let s;
                    return void 0 === a ? (s = new Dp(e1, t), n.set(i, [
                        s
                    ])) : r >= a.length ? (s = new Dp(e1, t), a.push(s)) : s = a[r], s;
                },
                dispose: function() {
                    n = new WeakMap;
                }
            };
        }
        class Cp extends $c {
            constructor(e1){
                super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = Bs, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.depthPacking = e1.depthPacking, this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this;
            }
        }
        class Lp extends $c {
            constructor(e1){
                super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this;
            }
        }
        function zp(e1, t, n) {
            let i = new uh;
            const r = new $o, a = new $o, s = new wl, o = new Cp({
                depthPacking: Fs
            }), l = new Lp, c = {}, u = n.maxTextureSize, h = {
                [ur]: hr,
                [hr]: ur,
                [dr]: dr
            }, d = new Ku({
                defines: {
                    VSM_SAMPLES: 8
                },
                uniforms: {
                    shadow_pass: {
                        value: null
                    },
                    resolution: {
                        value: new $o
                    },
                    radius: {
                        value: 4
                    }
                },
                vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
                fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
            }), p = d.clone();
            p.defines.HORIZONTAL_PASS = 1;
            const f = new Su;
            f.setAttribute("position", new lu(new Float32Array([
                -1,
                -1,
                .5,
                3,
                -1,
                .5,
                -1,
                3,
                .5
            ]), 3));
            const g = new Vu(f, d), m = this;
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = or;
            let A = this.type;
            function M(n, i) {
                const a = t.update(g);
                d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === n.mapPass && (n.mapPass = new Tl(r.x, r.y)), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, e1.setRenderTarget(n.mapPass), e1.clear(), e1.renderBufferDirect(i, null, a, d, g, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, e1.setRenderTarget(n.map), e1.clear(), e1.renderBufferDirect(i, null, a, p, g, null);
            }
            function v(t, n, i, r) {
                let a = null;
                const s = !0 === i.isPointLight ? t.customDistanceMaterial : t.customDepthMaterial;
                if (void 0 !== s) a = s;
                else if (a = !0 === i.isPointLight ? l : o, e1.localClippingEnabled && !0 === n.clipShadows && Array.isArray(n.clippingPlanes) && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0) {
                    const e1 = a.uuid, t = n.uuid;
                    let i = c[e1];
                    void 0 === i && (i = {}, c[e1] = i);
                    let r = i[t];
                    void 0 === r && (r = a.clone(), i[t] = r), a = r;
                }
                return a.visible = n.visible, a.wireframe = n.wireframe, a.side = r === cr ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : h[n.side], a.alphaMap = n.alphaMap, a.alphaTest = n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, !0 === i.isPointLight && !0 === a.isMeshDistanceMaterial && (e1.properties.get(a).light = i), a;
            }
            function y(n, r, a, s, o) {
                if (!1 === n.visible) return;
                if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && o === cr) && (!n.frustumCulled || i.intersectsObject(n))) {
                    n.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, n.matrixWorld);
                    const i = t.update(n), r = n.material;
                    if (Array.isArray(r)) {
                        const t = i.groups;
                        for(let l = 0, c = t.length; l < c; l++){
                            const c = t[l], u = r[c.materialIndex];
                            if (u && u.visible) {
                                const t = v(n, u, s, o);
                                e1.renderBufferDirect(a, null, i, t, n, c);
                            }
                        }
                    } else if (r.visible) {
                        const t = v(n, r, s, o);
                        e1.renderBufferDirect(a, null, i, t, n, null);
                    }
                }
                const l = n.children;
                for(let e1 = 0, t = l.length; e1 < t; e1++)y(l[e1], r, a, s, o);
            }
            this.render = function(t, n, o) {
                if (!1 === m.enabled) return;
                if (!1 === m.autoUpdate && !1 === m.needsUpdate) return;
                if (0 === t.length) return;
                const l = e1.getRenderTarget(), c = e1.getActiveCubeFace(), h = e1.getActiveMipmapLevel(), d = e1.state;
                d.setBlending(fr), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
                const p = A !== cr && this.type === cr, f = A === cr && this.type !== cr;
                for(let l = 0, c = t.length; l < c; l++){
                    const c = t[l], h = c.shadow;
                    if (void 0 === h) {
                        console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                        continue;
                    }
                    if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
                    r.copy(h.mapSize);
                    const g = h.getFrameExtents();
                    if (r.multiply(g), a.copy(h.mapSize), (r.x > u || r.y > u) && (r.x > u && (a.x = Math.floor(u / g.x), r.x = a.x * g.x, h.mapSize.x = a.x), r.y > u && (a.y = Math.floor(u / g.y), r.y = a.y * g.y, h.mapSize.y = a.y)), null === h.map || !0 === p || !0 === f) {
                        const e1 = this.type !== cr ? {
                            minFilter: fa,
                            magFilter: fa
                        } : {};
                        null !== h.map && h.map.dispose(), h.map = new Tl(r.x, r.y, e1), h.map.texture.name = c.name + ".shadowMap", h.camera.updateProjectionMatrix();
                    }
                    e1.setRenderTarget(h.map), e1.clear();
                    const m = h.getViewportCount();
                    for(let e1 = 0; e1 < m; e1++){
                        const t = h.getViewport(e1);
                        s.set(a.x * t.x, a.y * t.y, a.x * t.z, a.y * t.w), d.viewport(s), h.updateMatrices(c, e1), i = h.getFrustum(), y(n, o, h.camera, c, this.type);
                    }
                    !0 !== h.isPointLightShadow && this.type === cr && M(h, o), h.needsUpdate = !1;
                }
                A = this.type, m.needsUpdate = !1, e1.setRenderTarget(l, c, h);
            };
        }
        function Op(e1, t, n) {
            const i = n.isWebGL2, r = new function() {
                let t = !1;
                const n = new wl;
                let i = null;
                const r = new wl(0, 0, 0, 0);
                return {
                    setMask: function(n) {
                        i === n || t || (e1.colorMask(n, n, n, n), i = n);
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t, i, a, s, o) {
                        !0 === o && (t *= s, i *= s, a *= s), n.set(t, i, a, s), !1 === r.equals(n) && (e1.clearColor(t, i, a, s), r.copy(n));
                    },
                    reset: function() {
                        t = !1, i = null, r.set(-1, 0, 0, 0);
                    }
                };
            }, a = new function() {
                let t = !1, n = null, i = null, r = null;
                return {
                    setTest: function(t) {
                        t ? H(e1.DEPTH_TEST) : G(e1.DEPTH_TEST);
                    },
                    setMask: function(i) {
                        n === i || t || (e1.depthMask(i), n = i);
                    },
                    setFunc: function(t) {
                        if (i !== t) {
                            switch(t){
                                case Br:
                                    e1.depthFunc(e1.NEVER);
                                    break;
                                case Fr:
                                    e1.depthFunc(e1.ALWAYS);
                                    break;
                                case Hr:
                                    e1.depthFunc(e1.LESS);
                                    break;
                                case Gr:
                                    e1.depthFunc(e1.LEQUAL);
                                    break;
                                case Vr:
                                    e1.depthFunc(e1.EQUAL);
                                    break;
                                case Qr:
                                    e1.depthFunc(e1.GEQUAL);
                                    break;
                                case Wr:
                                    e1.depthFunc(e1.GREATER);
                                    break;
                                case Yr:
                                    e1.depthFunc(e1.NOTEQUAL);
                                    break;
                                default:
                                    e1.depthFunc(e1.LEQUAL);
                            }
                            i = t;
                        }
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t) {
                        r !== t && (e1.clearDepth(t), r = t);
                    },
                    reset: function() {
                        t = !1, n = null, i = null, r = null;
                    }
                };
            }, s = new function() {
                let t = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                return {
                    setTest: function(n) {
                        t || (n ? H(e1.STENCIL_TEST) : G(e1.STENCIL_TEST));
                    },
                    setMask: function(i) {
                        n === i || t || (e1.stencilMask(i), n = i);
                    },
                    setFunc: function(t, n, s) {
                        i === t && r === n && a === s || (e1.stencilFunc(t, n, s), i = t, r = n, a = s);
                    },
                    setOp: function(t, n, i) {
                        s === t && o === n && l === i || (e1.stencilOp(t, n, i), s = t, o = n, l = i);
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t) {
                        c !== t && (e1.clearStencil(t), c = t);
                    },
                    reset: function() {
                        t = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                    }
                };
            }, o = new WeakMap, l = new WeakMap;
            let c = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, g = null, m = null, A = null, M = null, v = null, y = null, x = null, b = new qc(0, 0, 0), w = 0, E = !1, T = null, S = null, I = null, N = null, D = null;
            const _ = e1.getParameter(e1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
            let C = !1, L = 0;
            const z = e1.getParameter(e1.VERSION);
            -1 !== z.indexOf("WebGL") ? (L = parseFloat(/^WebGL (\d)/.exec(z)[1]), C = L >= 1) : -1 !== z.indexOf("OpenGL ES") && (L = parseFloat(/^OpenGL ES (\d)/.exec(z)[1]), C = L >= 2);
            let O = null, R = {};
            const P = e1.getParameter(e1.SCISSOR_BOX), U = e1.getParameter(e1.VIEWPORT), j = (new wl).fromArray(P), k = (new wl).fromArray(U);
            function B(t, n, r, a) {
                const s = new Uint8Array(4), o = e1.createTexture();
                e1.bindTexture(t, o), e1.texParameteri(t, e1.TEXTURE_MIN_FILTER, e1.NEAREST), e1.texParameteri(t, e1.TEXTURE_MAG_FILTER, e1.NEAREST);
                for(let o = 0; o < r; o++)!i || t !== e1.TEXTURE_3D && t !== e1.TEXTURE_2D_ARRAY ? e1.texImage2D(n + o, 0, e1.RGBA, 1, 1, 0, e1.RGBA, e1.UNSIGNED_BYTE, s) : e1.texImage3D(n, 0, e1.RGBA, 1, 1, a, 0, e1.RGBA, e1.UNSIGNED_BYTE, s);
                return o;
            }
            const F = {};
            function H(t) {
                !0 !== c[t] && (e1.enable(t), c[t] = !0);
            }
            function G(t) {
                !1 !== c[t] && (e1.disable(t), c[t] = !1);
            }
            F[e1.TEXTURE_2D] = B(e1.TEXTURE_2D, e1.TEXTURE_2D, 1), F[e1.TEXTURE_CUBE_MAP] = B(e1.TEXTURE_CUBE_MAP, e1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), i && (F[e1.TEXTURE_2D_ARRAY] = B(e1.TEXTURE_2D_ARRAY, e1.TEXTURE_2D_ARRAY, 1, 1), F[e1.TEXTURE_3D] = B(e1.TEXTURE_3D, e1.TEXTURE_3D, 1, 1)), r.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), H(e1.DEPTH_TEST), a.setFunc(Gr), Y(!1), X(ir), H(e1.CULL_FACE), W(fr);
            const V = {
                [yr]: e1.FUNC_ADD,
                [xr]: e1.FUNC_SUBTRACT,
                [br]: e1.FUNC_REVERSE_SUBTRACT
            };
            if (i) V[wr] = e1.MIN, V[Er] = e1.MAX;
            else {
                const e1 = t.get("EXT_blend_minmax");
                null !== e1 && (V[wr] = e1.MIN_EXT, V[Er] = e1.MAX_EXT);
            }
            const Q = {
                [Tr]: e1.ZERO,
                [Sr]: e1.ONE,
                [Ir]: e1.SRC_COLOR,
                [Dr]: e1.SRC_ALPHA,
                [Rr]: e1.SRC_ALPHA_SATURATE,
                [zr]: e1.DST_COLOR,
                [Cr]: e1.DST_ALPHA,
                [Nr]: e1.ONE_MINUS_SRC_COLOR,
                [_r]: e1.ONE_MINUS_SRC_ALPHA,
                [Or]: e1.ONE_MINUS_DST_COLOR,
                [Lr]: e1.ONE_MINUS_DST_ALPHA,
                [Pr]: e1.CONSTANT_COLOR,
                [Ur]: e1.ONE_MINUS_CONSTANT_COLOR,
                [jr]: e1.CONSTANT_ALPHA,
                [kr]: e1.ONE_MINUS_CONSTANT_ALPHA
            };
            function W(t, n, i, r, a, s, o, l, c, u) {
                if (t !== fr) {
                    if (!1 === f && (H(e1.BLEND), f = !0), t === vr) a = a || n, s = s || i, o = o || r, n === m && a === v || (e1.blendEquationSeparate(V[n], V[a]), m = n, v = a), i === A && r === M && s === y && o === x || (e1.blendFuncSeparate(Q[i], Q[r], Q[s], Q[o]), A = i, M = r, y = s, x = o), !1 !== l.equals(b) && c === w || (e1.blendColor(l.r, l.g, l.b, c), b.copy(l), w = c), g = t, E = !1;
                    else if (t !== g || u !== E) {
                        if (m === yr && v === yr || (e1.blendEquation(e1.FUNC_ADD), m = yr, v = yr), u) switch(t){
                            case gr:
                                e1.blendFuncSeparate(e1.ONE, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case mr:
                                e1.blendFunc(e1.ONE, e1.ONE);
                                break;
                            case Ar:
                                e1.blendFuncSeparate(e1.ZERO, e1.ONE_MINUS_SRC_COLOR, e1.ZERO, e1.ONE);
                                break;
                            case Mr:
                                e1.blendFuncSeparate(e1.ZERO, e1.SRC_COLOR, e1.ZERO, e1.SRC_ALPHA);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", t);
                        }
                        else switch(t){
                            case gr:
                                e1.blendFuncSeparate(e1.SRC_ALPHA, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case mr:
                                e1.blendFunc(e1.SRC_ALPHA, e1.ONE);
                                break;
                            case Ar:
                                e1.blendFuncSeparate(e1.ZERO, e1.ONE_MINUS_SRC_COLOR, e1.ZERO, e1.ONE);
                                break;
                            case Mr:
                                e1.blendFunc(e1.ZERO, e1.SRC_COLOR);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", t);
                        }
                        A = null, M = null, y = null, x = null, b.set(0, 0, 0), w = 0, g = t, E = u;
                    }
                } else !0 === f && (G(e1.BLEND), f = !1);
            }
            function Y(t) {
                T !== t && (t ? e1.frontFace(e1.CW) : e1.frontFace(e1.CCW), T = t);
            }
            function X(t) {
                t !== nr ? (H(e1.CULL_FACE), t !== S && (t === ir ? e1.cullFace(e1.BACK) : t === rr ? e1.cullFace(e1.FRONT) : e1.cullFace(e1.FRONT_AND_BACK))) : G(e1.CULL_FACE), S = t;
            }
            function Z(t, n, i) {
                t ? (H(e1.POLYGON_OFFSET_FILL), N === n && D === i || (e1.polygonOffset(n, i), N = n, D = i)) : G(e1.POLYGON_OFFSET_FILL);
            }
            return {
                buffers: {
                    color: r,
                    depth: a,
                    stencil: s
                },
                enable: H,
                disable: G,
                bindFramebuffer: function(t, n) {
                    return u[t] !== n && (e1.bindFramebuffer(t, n), u[t] = n, i && (t === e1.DRAW_FRAMEBUFFER && (u[e1.FRAMEBUFFER] = n), t === e1.FRAMEBUFFER && (u[e1.DRAW_FRAMEBUFFER] = n)), !0);
                },
                drawBuffers: function(i, r) {
                    let a = d, s = !1;
                    if (i) {
                        if (a = h.get(r), void 0 === a && (a = [], h.set(r, a)), i.isWebGLMultipleRenderTargets) {
                            const t = i.texture;
                            if (a.length !== t.length || a[0] !== e1.COLOR_ATTACHMENT0) {
                                for(let n = 0, i = t.length; n < i; n++)a[n] = e1.COLOR_ATTACHMENT0 + n;
                                a.length = t.length, s = !0;
                            }
                        } else a[0] !== e1.COLOR_ATTACHMENT0 && (a[0] = e1.COLOR_ATTACHMENT0, s = !0);
                    } else a[0] !== e1.BACK && (a[0] = e1.BACK, s = !0);
                    s && (n.isWebGL2 ? e1.drawBuffers(a) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(a));
                },
                useProgram: function(t) {
                    return p !== t && (e1.useProgram(t), p = t, !0);
                },
                setBlending: W,
                setMaterial: function(t, n) {
                    t.side === dr ? G(e1.CULL_FACE) : H(e1.CULL_FACE);
                    let i = t.side === hr;
                    n && (i = !i), Y(i), t.blending === gr && !1 === t.transparent ? W(fr) : W(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), a.setFunc(t.depthFunc), a.setTest(t.depthTest), a.setMask(t.depthWrite), r.setMask(t.colorWrite);
                    const o = t.stencilWrite;
                    s.setTest(o), o && (s.setMask(t.stencilWriteMask), s.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), s.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), Z(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? H(e1.SAMPLE_ALPHA_TO_COVERAGE) : G(e1.SAMPLE_ALPHA_TO_COVERAGE);
                },
                setFlipSided: Y,
                setCullFace: X,
                setLineWidth: function(t) {
                    t !== I && (C && e1.lineWidth(t), I = t);
                },
                setPolygonOffset: Z,
                setScissorTest: function(t) {
                    t ? H(e1.SCISSOR_TEST) : G(e1.SCISSOR_TEST);
                },
                activeTexture: function(t) {
                    void 0 === t && (t = e1.TEXTURE0 + _ - 1), O !== t && (e1.activeTexture(t), O = t);
                },
                bindTexture: function(t, n, i) {
                    void 0 === i && (i = null === O ? e1.TEXTURE0 + _ - 1 : O);
                    let r = R[i];
                    void 0 === r && (r = {
                        type: void 0,
                        texture: void 0
                    }, R[i] = r), r.type === t && r.texture === n || (O !== i && (e1.activeTexture(i), O = i), e1.bindTexture(t, n || F[t]), r.type = t, r.texture = n);
                },
                unbindTexture: function() {
                    const t = R[O];
                    void 0 !== t && void 0 !== t.type && (e1.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
                },
                compressedTexImage2D: function() {
                    try {
                        e1.compressedTexImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexImage3D: function() {
                    try {
                        e1.compressedTexImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texImage2D: function() {
                    try {
                        e1.texImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texImage3D: function() {
                    try {
                        e1.texImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                updateUBOMapping: function(t, n) {
                    let i = l.get(n);
                    void 0 === i && (i = new WeakMap, l.set(n, i));
                    let r = i.get(t);
                    void 0 === r && (r = e1.getUniformBlockIndex(n, t.name), i.set(t, r));
                },
                uniformBlockBinding: function(t, n) {
                    const i = l.get(n).get(t);
                    o.get(n) !== i && (e1.uniformBlockBinding(n, i, t.__bindingPointIndex), o.set(n, i));
                },
                texStorage2D: function() {
                    try {
                        e1.texStorage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texStorage3D: function() {
                    try {
                        e1.texStorage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texSubImage2D: function() {
                    try {
                        e1.texSubImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texSubImage3D: function() {
                    try {
                        e1.texSubImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexSubImage2D: function() {
                    try {
                        e1.compressedTexSubImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexSubImage3D: function() {
                    try {
                        e1.compressedTexSubImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                scissor: function(t) {
                    !1 === j.equals(t) && (e1.scissor(t.x, t.y, t.z, t.w), j.copy(t));
                },
                viewport: function(t) {
                    !1 === k.equals(t) && (e1.viewport(t.x, t.y, t.z, t.w), k.copy(t));
                },
                reset: function() {
                    e1.disable(e1.BLEND), e1.disable(e1.CULL_FACE), e1.disable(e1.DEPTH_TEST), e1.disable(e1.POLYGON_OFFSET_FILL), e1.disable(e1.SCISSOR_TEST), e1.disable(e1.STENCIL_TEST), e1.disable(e1.SAMPLE_ALPHA_TO_COVERAGE), e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO), e1.blendFuncSeparate(e1.ONE, e1.ZERO, e1.ONE, e1.ZERO), e1.blendColor(0, 0, 0, 0), e1.colorMask(!0, !0, !0, !0), e1.clearColor(0, 0, 0, 0), e1.depthMask(!0), e1.depthFunc(e1.LESS), e1.clearDepth(1), e1.stencilMask(4294967295), e1.stencilFunc(e1.ALWAYS, 0, 4294967295), e1.stencilOp(e1.KEEP, e1.KEEP, e1.KEEP), e1.clearStencil(0), e1.cullFace(e1.BACK), e1.frontFace(e1.CCW), e1.polygonOffset(0, 0), e1.activeTexture(e1.TEXTURE0), e1.bindFramebuffer(e1.FRAMEBUFFER, null), !0 === i && (e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), e1.bindFramebuffer(e1.READ_FRAMEBUFFER, null)), e1.useProgram(null), e1.lineWidth(1), e1.scissor(0, 0, e1.canvas.width, e1.canvas.height), e1.viewport(0, 0, e1.canvas.width, e1.canvas.height), c = {}, O = null, R = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, g = null, m = null, A = null, M = null, v = null, y = null, x = null, b = new qc(0, 0, 0), w = 0, E = !1, T = null, S = null, I = null, N = null, D = null, j.set(0, 0, e1.canvas.width, e1.canvas.height), k.set(0, 0, e1.canvas.width, e1.canvas.height), r.reset(), a.reset(), s.reset();
                }
            };
        }
        function Rp(e1, t, n, i, r, a, s) {
            const o = r.isWebGL2, l = r.maxTextures, c = r.maxCubemapSize, u = r.maxTextureSize, h = r.maxSamples, d = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, p = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), f = new WeakMap;
            let g;
            const m = new WeakMap;
            let A = !1;
            try {
                A = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
            } catch (e1) {}
            function M(e1, t) {
                return A ? new OffscreenCanvas(e1, t) : al("canvas");
            }
            function v(e1, t, n, i) {
                let r = 1;
                if ((e1.width > i || e1.height > i) && (r = i / Math.max(e1.width, e1.height)), r < 1 || !0 === t) {
                    if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                        const i = t ? Zo : Math.floor, a = i(r * e1.width), s = i(r * e1.height);
                        void 0 === g && (g = M(a, s));
                        const o = n ? M(a, s) : g;
                        return o.width = a, o.height = s, o.getContext("2d").drawImage(e1, 0, 0, a, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + e1.width + "x" + e1.height + ") to (" + a + "x" + s + ")."), o;
                    }
                    return "data" in e1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + e1.width + "x" + e1.height + ")."), e1;
                }
                return e1;
            }
            function y(e1) {
                return Yo(e1.width) && Yo(e1.height);
            }
            function x(e1, t) {
                return e1.generateMipmaps && t && e1.minFilter !== fa && e1.minFilter !== va;
            }
            function b(t) {
                e1.generateMipmap(t);
            }
            function w(n, i, r, a) {
                let s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                if (!1 === o) return i;
                if (null !== n) {
                    if (void 0 !== e1[n]) return e1[n];
                    console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
                }
                let l = i;
                if (i === e1.RED && (r === e1.FLOAT && (l = e1.R32F), r === e1.HALF_FLOAT && (l = e1.R16F), r === e1.UNSIGNED_BYTE && (l = e1.R8)), i === e1.RED_INTEGER && (r === e1.UNSIGNED_BYTE && (l = e1.R8UI), r === e1.UNSIGNED_SHORT && (l = e1.R16UI), r === e1.UNSIGNED_INT && (l = e1.R32UI), r === e1.BYTE && (l = e1.R8I), r === e1.SHORT && (l = e1.R16I), r === e1.INT && (l = e1.R32I)), i === e1.RG && (r === e1.FLOAT && (l = e1.RG32F), r === e1.HALF_FLOAT && (l = e1.RG16F), r === e1.UNSIGNED_BYTE && (l = e1.RG8)), i === e1.RGBA) {
                    const t = s ? Zs : pl.getTransfer(a);
                    r === e1.FLOAT && (l = e1.RGBA32F), r === e1.HALF_FLOAT && (l = e1.RGBA16F), r === e1.UNSIGNED_BYTE && (l = t === qs ? e1.SRGB8_ALPHA8 : e1.RGBA8), r === e1.UNSIGNED_SHORT_4_4_4_4 && (l = e1.RGBA4), r === e1.UNSIGNED_SHORT_5_5_5_1 && (l = e1.RGB5_A1);
                }
                return l !== e1.R16F && l !== e1.R32F && l !== e1.RG16F && l !== e1.RG32F && l !== e1.RGBA16F && l !== e1.RGBA32F || t.get("EXT_color_buffer_float"), l;
            }
            function E(e1, t, n) {
                return !0 === x(e1, n) || e1.isFramebufferTexture && e1.minFilter !== fa && e1.minFilter !== va ? Math.log2(Math.max(t.width, t.height)) + 1 : void 0 !== e1.mipmaps && e1.mipmaps.length > 0 ? e1.mipmaps.length : e1.isCompressedTexture && Array.isArray(e1.image) ? t.mipmaps.length : 1;
            }
            function T(t) {
                return t === fa || t === ga || t === Aa ? e1.NEAREST : e1.LINEAR;
            }
            function S(e1) {
                const t = e1.target;
                t.removeEventListener("dispose", S), function(e1) {
                    const t = i.get(e1);
                    if (void 0 === t.__webglInit) return;
                    const n = e1.source, r = m.get(n);
                    if (r) {
                        const i = r[t.__cacheKey];
                        i.usedTimes--, 0 === i.usedTimes && N(e1), 0 === Object.keys(r).length && m.delete(n);
                    }
                    i.remove(e1);
                }(t), t.isVideoTexture && f.delete(t);
            }
            function I(t) {
                const n = t.target;
                n.removeEventListener("dispose", I), function(t) {
                    const n = t.texture, r = i.get(t), a = i.get(n);
                    if (void 0 !== a.__webglTexture && (e1.deleteTexture(a.__webglTexture), s.memory.textures--), t.depthTexture && t.depthTexture.dispose(), t.isWebGLCubeRenderTarget) for(let t = 0; t < 6; t++){
                        if (Array.isArray(r.__webglFramebuffer[t])) for(let n = 0; n < r.__webglFramebuffer[t].length; n++)e1.deleteFramebuffer(r.__webglFramebuffer[t][n]);
                        else e1.deleteFramebuffer(r.__webglFramebuffer[t]);
                        r.__webglDepthbuffer && e1.deleteRenderbuffer(r.__webglDepthbuffer[t]);
                    }
                    else {
                        if (Array.isArray(r.__webglFramebuffer)) for(let t = 0; t < r.__webglFramebuffer.length; t++)e1.deleteFramebuffer(r.__webglFramebuffer[t]);
                        else e1.deleteFramebuffer(r.__webglFramebuffer);
                        if (r.__webglDepthbuffer && e1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && e1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for(let t = 0; t < r.__webglColorRenderbuffer.length; t++)r.__webglColorRenderbuffer[t] && e1.deleteRenderbuffer(r.__webglColorRenderbuffer[t]);
                        r.__webglDepthRenderbuffer && e1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
                    }
                    if (t.isWebGLMultipleRenderTargets) for(let t = 0, r = n.length; t < r; t++){
                        const r = i.get(n[t]);
                        r.__webglTexture && (e1.deleteTexture(r.__webglTexture), s.memory.textures--), i.remove(n[t]);
                    }
                    i.remove(n), i.remove(t);
                }(n);
            }
            function N(t) {
                const n = i.get(t);
                e1.deleteTexture(n.__webglTexture);
                const r = t.source;
                delete m.get(r)[n.__cacheKey], s.memory.textures--;
            }
            let D = 0;
            function _(t, r) {
                const a = i.get(t);
                if (t.isVideoTexture && function(e1) {
                    const t = s.render.frame;
                    f.get(e1) !== t && (f.set(e1, t), e1.update());
                }(t), !1 === t.isRenderTargetTexture && t.version > 0 && a.__version !== t.version) {
                    const e1 = t.image;
                    if (null === e1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                    else {
                        if (!1 !== e1.complete) return void P(a, t, r);
                        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                    }
                }
                n.bindTexture(e1.TEXTURE_2D, a.__webglTexture, e1.TEXTURE0 + r);
            }
            const C = {
                [ha]: e1.REPEAT,
                [da]: e1.CLAMP_TO_EDGE,
                [pa]: e1.MIRRORED_REPEAT
            }, L = {
                [fa]: e1.NEAREST,
                [ga]: e1.NEAREST_MIPMAP_NEAREST,
                [Aa]: e1.NEAREST_MIPMAP_LINEAR,
                [va]: e1.LINEAR,
                [ya]: e1.LINEAR_MIPMAP_NEAREST,
                [ba]: e1.LINEAR_MIPMAP_LINEAR
            }, z = {
                [mo]: e1.NEVER,
                [wo]: e1.ALWAYS,
                [Ao]: e1.LESS,
                [vo]: e1.LEQUAL,
                [Mo]: e1.EQUAL,
                [bo]: e1.GEQUAL,
                [yo]: e1.GREATER,
                [xo]: e1.NOTEQUAL
            };
            function O(n, a, s) {
                if (s ? (e1.texParameteri(n, e1.TEXTURE_WRAP_S, C[a.wrapS]), e1.texParameteri(n, e1.TEXTURE_WRAP_T, C[a.wrapT]), n !== e1.TEXTURE_3D && n !== e1.TEXTURE_2D_ARRAY || e1.texParameteri(n, e1.TEXTURE_WRAP_R, C[a.wrapR]), e1.texParameteri(n, e1.TEXTURE_MAG_FILTER, L[a.magFilter]), e1.texParameteri(n, e1.TEXTURE_MIN_FILTER, L[a.minFilter])) : (e1.texParameteri(n, e1.TEXTURE_WRAP_S, e1.CLAMP_TO_EDGE), e1.texParameteri(n, e1.TEXTURE_WRAP_T, e1.CLAMP_TO_EDGE), n !== e1.TEXTURE_3D && n !== e1.TEXTURE_2D_ARRAY || e1.texParameteri(n, e1.TEXTURE_WRAP_R, e1.CLAMP_TO_EDGE), a.wrapS === da && a.wrapT === da || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), e1.texParameteri(n, e1.TEXTURE_MAG_FILTER, T(a.magFilter)), e1.texParameteri(n, e1.TEXTURE_MIN_FILTER, T(a.minFilter)), a.minFilter !== fa && a.minFilter !== va && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), a.compareFunction && (e1.texParameteri(n, e1.TEXTURE_COMPARE_MODE, e1.COMPARE_REF_TO_TEXTURE), e1.texParameteri(n, e1.TEXTURE_COMPARE_FUNC, z[a.compareFunction])), !0 === t.has("EXT_texture_filter_anisotropic")) {
                    const s = t.get("EXT_texture_filter_anisotropic");
                    if (a.magFilter === fa) return;
                    if (a.minFilter !== Aa && a.minFilter !== ba) return;
                    if (a.type === _a && !1 === t.has("OES_texture_float_linear")) return;
                    if (!1 === o && a.type === Ca && !1 === t.has("OES_texture_half_float_linear")) return;
                    (a.anisotropy > 1 || i.get(a).__currentAnisotropy) && (e1.texParameterf(n, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, r.getMaxAnisotropy())), i.get(a).__currentAnisotropy = a.anisotropy);
                }
            }
            function R(t, n) {
                let i = !1;
                void 0 === t.__webglInit && (t.__webglInit = !0, n.addEventListener("dispose", S));
                const r = n.source;
                let a = m.get(r);
                void 0 === a && (a = {}, m.set(r, a));
                const o = function(e1) {
                    const t = [];
                    return t.push(e1.wrapS), t.push(e1.wrapT), t.push(e1.wrapR || 0), t.push(e1.magFilter), t.push(e1.minFilter), t.push(e1.anisotropy), t.push(e1.internalFormat), t.push(e1.format), t.push(e1.type), t.push(e1.generateMipmaps), t.push(e1.premultiplyAlpha), t.push(e1.flipY), t.push(e1.unpackAlignment), t.push(e1.colorSpace), t.join();
                }(n);
                if (o !== t.__cacheKey) {
                    void 0 === a[o] && (a[o] = {
                        texture: e1.createTexture(),
                        usedTimes: 0
                    }, s.memory.textures++, i = !0), a[o].usedTimes++;
                    const r = a[t.__cacheKey];
                    void 0 !== r && (a[t.__cacheKey].usedTimes--, 0 === r.usedTimes && N(n)), t.__cacheKey = o, t.__webglTexture = a[o].texture;
                }
                return i;
            }
            function P(t, r, s) {
                let l = e1.TEXTURE_2D;
                (r.isDataArrayTexture || r.isCompressedArrayTexture) && (l = e1.TEXTURE_2D_ARRAY), r.isData3DTexture && (l = e1.TEXTURE_3D);
                const c = R(t, r), h = r.source;
                n.bindTexture(l, t.__webglTexture, e1.TEXTURE0 + s);
                const d = i.get(h);
                if (h.version !== d.__version || !0 === c) {
                    n.activeTexture(e1.TEXTURE0 + s);
                    const t = pl.getPrimaries(pl.workingColorSpace), i = r.colorSpace === Vs ? null : pl.getPrimaries(r.colorSpace), p = r.colorSpace === Vs || t === i ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, r.flipY), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), e1.pixelStorei(e1.UNPACK_ALIGNMENT, r.unpackAlignment), e1.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, p);
                    const f = function(e1) {
                        return !o && (e1.wrapS !== da || e1.wrapT !== da || e1.minFilter !== fa && e1.minFilter !== va);
                    }(r) && !1 === y(r.image);
                    let g = v(r.image, f, !1, u);
                    g = H(r, g);
                    const m = y(g) || o, A = a.convert(r.format, r.colorSpace);
                    let M, T = a.convert(r.type), S = w(r.internalFormat, A, T, r.colorSpace, r.isVideoTexture);
                    O(l, r, m);
                    const I = r.mipmaps, N = o && !0 !== r.isVideoTexture, D = void 0 === d.__version || !0 === c, _ = E(r, g, m);
                    if (r.isDepthTexture) S = e1.DEPTH_COMPONENT, o ? S = r.type === _a ? e1.DEPTH_COMPONENT32F : r.type === Da ? e1.DEPTH_COMPONENT24 : r.type === Oa ? e1.DEPTH24_STENCIL8 : e1.DEPTH_COMPONENT16 : r.type === _a && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === ka && S === e1.DEPTH_COMPONENT && r.type !== Ia && r.type !== Da && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = Da, T = a.convert(r.type)), r.format === Ba && S === e1.DEPTH_COMPONENT && (S = e1.DEPTH_STENCIL, r.type !== Oa && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = Oa, T = a.convert(r.type))), D && (N ? n.texStorage2D(e1.TEXTURE_2D, 1, S, g.width, g.height) : n.texImage2D(e1.TEXTURE_2D, 0, S, g.width, g.height, 0, A, T, null));
                    else if (r.isDataTexture) {
                        if (I.length > 0 && m) {
                            N && D && n.texStorage2D(e1.TEXTURE_2D, _, S, I[0].width, I[0].height);
                            for(let t = 0, i = I.length; t < i; t++)M = I[t], N ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, M.width, M.height, A, T, M.data) : n.texImage2D(e1.TEXTURE_2D, t, S, M.width, M.height, 0, A, T, M.data);
                            r.generateMipmaps = !1;
                        } else N ? (D && n.texStorage2D(e1.TEXTURE_2D, _, S, g.width, g.height), n.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, g.width, g.height, A, T, g.data)) : n.texImage2D(e1.TEXTURE_2D, 0, S, g.width, g.height, 0, A, T, g.data);
                    } else if (r.isCompressedTexture) {
                        if (r.isCompressedArrayTexture) {
                            N && D && n.texStorage3D(e1.TEXTURE_2D_ARRAY, _, S, I[0].width, I[0].height, g.depth);
                            for(let t = 0, i = I.length; t < i; t++)M = I[t], r.format !== Pa ? null !== A ? N ? n.compressedTexSubImage3D(e1.TEXTURE_2D_ARRAY, t, 0, 0, 0, M.width, M.height, g.depth, A, M.data, 0, 0) : n.compressedTexImage3D(e1.TEXTURE_2D_ARRAY, t, S, M.width, M.height, g.depth, 0, M.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : N ? n.texSubImage3D(e1.TEXTURE_2D_ARRAY, t, 0, 0, 0, M.width, M.height, g.depth, A, T, M.data) : n.texImage3D(e1.TEXTURE_2D_ARRAY, t, S, M.width, M.height, g.depth, 0, A, T, M.data);
                        } else {
                            N && D && n.texStorage2D(e1.TEXTURE_2D, _, S, I[0].width, I[0].height);
                            for(let t = 0, i = I.length; t < i; t++)M = I[t], r.format !== Pa ? null !== A ? N ? n.compressedTexSubImage2D(e1.TEXTURE_2D, t, 0, 0, M.width, M.height, A, M.data) : n.compressedTexImage2D(e1.TEXTURE_2D, t, S, M.width, M.height, 0, M.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : N ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, M.width, M.height, A, T, M.data) : n.texImage2D(e1.TEXTURE_2D, t, S, M.width, M.height, 0, A, T, M.data);
                        }
                    } else if (r.isDataArrayTexture) N ? (D && n.texStorage3D(e1.TEXTURE_2D_ARRAY, _, S, g.width, g.height, g.depth), n.texSubImage3D(e1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, g.width, g.height, g.depth, A, T, g.data)) : n.texImage3D(e1.TEXTURE_2D_ARRAY, 0, S, g.width, g.height, g.depth, 0, A, T, g.data);
                    else if (r.isData3DTexture) N ? (D && n.texStorage3D(e1.TEXTURE_3D, _, S, g.width, g.height, g.depth), n.texSubImage3D(e1.TEXTURE_3D, 0, 0, 0, 0, g.width, g.height, g.depth, A, T, g.data)) : n.texImage3D(e1.TEXTURE_3D, 0, S, g.width, g.height, g.depth, 0, A, T, g.data);
                    else if (r.isFramebufferTexture) {
                        if (D) {
                            if (N) n.texStorage2D(e1.TEXTURE_2D, _, S, g.width, g.height);
                            else {
                                let t = g.width, i = g.height;
                                for(let r = 0; r < _; r++)n.texImage2D(e1.TEXTURE_2D, r, S, t, i, 0, A, T, null), t >>= 1, i >>= 1;
                            }
                        }
                    } else if (I.length > 0 && m) {
                        N && D && n.texStorage2D(e1.TEXTURE_2D, _, S, I[0].width, I[0].height);
                        for(let t = 0, i = I.length; t < i; t++)M = I[t], N ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, A, T, M) : n.texImage2D(e1.TEXTURE_2D, t, S, A, T, M);
                        r.generateMipmaps = !1;
                    } else N ? (D && n.texStorage2D(e1.TEXTURE_2D, _, S, g.width, g.height), n.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, A, T, g)) : n.texImage2D(e1.TEXTURE_2D, 0, S, A, T, g);
                    x(r, m) && b(l), d.__version = h.version, r.onUpdate && r.onUpdate(r);
                }
                t.__version = r.version;
            }
            function U(t, r, s, o, l, c) {
                const u = a.convert(s.format, s.colorSpace), h = a.convert(s.type), p = w(s.internalFormat, u, h, s.colorSpace);
                if (!i.get(r).__hasExternalTextures) {
                    const t = Math.max(1, r.width >> c), i = Math.max(1, r.height >> c);
                    l === e1.TEXTURE_3D || l === e1.TEXTURE_2D_ARRAY ? n.texImage3D(l, c, p, t, i, r.depth, 0, u, h, null) : n.texImage2D(l, c, p, t, i, 0, u, h, null);
                }
                n.bindFramebuffer(e1.FRAMEBUFFER, t), F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, 0, B(r)) : (l === e1.TEXTURE_2D || l >= e1.TEXTURE_CUBE_MAP_POSITIVE_X && l <= e1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e1.framebufferTexture2D(e1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, c), n.bindFramebuffer(e1.FRAMEBUFFER, null);
            }
            function j(t, n, i) {
                if (e1.bindRenderbuffer(e1.RENDERBUFFER, t), n.depthBuffer && !n.stencilBuffer) {
                    let r = !0 === o ? e1.DEPTH_COMPONENT24 : e1.DEPTH_COMPONENT16;
                    if (i || F(n)) {
                        const t = n.depthTexture;
                        t && t.isDepthTexture && (t.type === _a ? r = e1.DEPTH_COMPONENT32F : t.type === Da && (r = e1.DEPTH_COMPONENT24));
                        const i = B(n);
                        F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, i, r, n.width, n.height) : e1.renderbufferStorageMultisample(e1.RENDERBUFFER, i, r, n.width, n.height);
                    } else e1.renderbufferStorage(e1.RENDERBUFFER, r, n.width, n.height);
                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t);
                } else if (n.depthBuffer && n.stencilBuffer) {
                    const r = B(n);
                    i && !1 === F(n) ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, r, e1.DEPTH24_STENCIL8, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, r, e1.DEPTH24_STENCIL8, n.width, n.height) : e1.renderbufferStorage(e1.RENDERBUFFER, e1.DEPTH_STENCIL, n.width, n.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.RENDERBUFFER, t);
                } else {
                    const t = !0 === n.isWebGLMultipleRenderTargets ? n.texture : [
                        n.texture
                    ];
                    for(let r = 0; r < t.length; r++){
                        const s = t[r], o = a.convert(s.format, s.colorSpace), l = a.convert(s.type), c = w(s.internalFormat, o, l, s.colorSpace), u = B(n);
                        i && !1 === F(n) ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, u, c, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, u, c, n.width, n.height) : e1.renderbufferStorage(e1.RENDERBUFFER, c, n.width, n.height);
                    }
                }
                e1.bindRenderbuffer(e1.RENDERBUFFER, null);
            }
            function k(t) {
                const r = i.get(t), a = !0 === t.isWebGLCubeRenderTarget;
                if (t.depthTexture && !r.__autoAllocateDepthBuffer) {
                    if (a) throw new Error("target.depthTexture not supported in Cube render targets");
                    !function(t, r) {
                        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (n.bindFramebuffer(e1.FRAMEBUFFER, t), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), _(r.depthTexture, 0);
                        const a = i.get(r.depthTexture).__webglTexture, s = B(r);
                        if (r.depthTexture.format === ka) F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, a, 0, s) : e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, a, 0);
                        else {
                            if (r.depthTexture.format !== Ba) throw new Error("Unknown depthTexture format");
                            F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.TEXTURE_2D, a, 0, s) : e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.TEXTURE_2D, a, 0);
                        }
                    }(r.__webglFramebuffer, t);
                } else if (a) {
                    r.__webglDepthbuffer = [];
                    for(let i = 0; i < 6; i++)n.bindFramebuffer(e1.FRAMEBUFFER, r.__webglFramebuffer[i]), r.__webglDepthbuffer[i] = e1.createRenderbuffer(), j(r.__webglDepthbuffer[i], t, !1);
                } else n.bindFramebuffer(e1.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = e1.createRenderbuffer(), j(r.__webglDepthbuffer, t, !1);
                n.bindFramebuffer(e1.FRAMEBUFFER, null);
            }
            function B(e1) {
                return Math.min(h, e1.samples);
            }
            function F(e1) {
                const n = i.get(e1);
                return o && e1.samples > 0 && !0 === t.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
            }
            function H(e1, n) {
                const i = e1.colorSpace, r = e1.format, a = e1.type;
                return !0 === e1.isCompressedTexture || !0 === e1.isVideoTexture || e1.format === Ro || i !== Ws && i !== Vs && (pl.getTransfer(i) === qs ? !1 === o ? !0 === t.has("EXT_sRGB") && r === Pa ? (e1.format = Ro, e1.minFilter = va, e1.generateMipmaps = !1) : n = Al.sRGBToLinear(n) : r === Pa && a === Ea || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", i)), n;
            }
            this.allocateTextureUnit = function() {
                const e1 = D;
                return e1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + e1 + " texture units while this GPU supports only " + l), D += 1, e1;
            }, this.resetTextureUnits = function() {
                D = 0;
            }, this.setTexture2D = _, this.setTexture2DArray = function(t, r) {
                const a = i.get(t);
                t.version > 0 && a.__version !== t.version ? P(a, t, r) : n.bindTexture(e1.TEXTURE_2D_ARRAY, a.__webglTexture, e1.TEXTURE0 + r);
            }, this.setTexture3D = function(t, r) {
                const a = i.get(t);
                t.version > 0 && a.__version !== t.version ? P(a, t, r) : n.bindTexture(e1.TEXTURE_3D, a.__webglTexture, e1.TEXTURE0 + r);
            }, this.setTextureCube = function(t, r) {
                const s = i.get(t);
                t.version > 0 && s.__version !== t.version ? function(t, r, s) {
                    if (6 !== r.image.length) return;
                    const l = R(t, r), u = r.source;
                    n.bindTexture(e1.TEXTURE_CUBE_MAP, t.__webglTexture, e1.TEXTURE0 + s);
                    const h = i.get(u);
                    if (u.version !== h.__version || !0 === l) {
                        n.activeTexture(e1.TEXTURE0 + s);
                        const t = pl.getPrimaries(pl.workingColorSpace), i = r.colorSpace === Vs ? null : pl.getPrimaries(r.colorSpace), d = r.colorSpace === Vs || t === i ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                        e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, r.flipY), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), e1.pixelStorei(e1.UNPACK_ALIGNMENT, r.unpackAlignment), e1.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
                        const p = r.isCompressedTexture || r.image[0].isCompressedTexture, f = r.image[0] && r.image[0].isDataTexture, g = [];
                        for(let e1 = 0; e1 < 6; e1++)g[e1] = p || f ? f ? r.image[e1].image : r.image[e1] : v(r.image[e1], !1, !0, c), g[e1] = H(r, g[e1]);
                        const m = g[0], A = y(m) || o, M = a.convert(r.format, r.colorSpace), T = a.convert(r.type), S = w(r.internalFormat, M, T, r.colorSpace), I = o && !0 !== r.isVideoTexture, N = void 0 === h.__version || !0 === l;
                        let D, _ = E(r, m, A);
                        if (O(e1.TEXTURE_CUBE_MAP, r, A), p) {
                            I && N && n.texStorage2D(e1.TEXTURE_CUBE_MAP, _, S, m.width, m.height);
                            for(let t = 0; t < 6; t++){
                                D = g[t].mipmaps;
                                for(let i = 0; i < D.length; i++){
                                    const a = D[i];
                                    r.format !== Pa ? null !== M ? I ? n.compressedTexSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, 0, 0, a.width, a.height, M, a.data) : n.compressedTexImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, S, a.width, a.height, 0, a.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : I ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, 0, 0, a.width, a.height, M, T, a.data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, S, a.width, a.height, 0, M, T, a.data);
                                }
                            }
                        } else {
                            D = r.mipmaps, I && N && (D.length > 0 && _++, n.texStorage2D(e1.TEXTURE_CUBE_MAP, _, S, g[0].width, g[0].height));
                            for(let t = 0; t < 6; t++)if (f) {
                                I ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, g[t].width, g[t].height, M, T, g[t].data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, S, g[t].width, g[t].height, 0, M, T, g[t].data);
                                for(let i = 0; i < D.length; i++){
                                    const r = D[i].image[t].image;
                                    I ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, 0, 0, r.width, r.height, M, T, r.data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, S, r.width, r.height, 0, M, T, r.data);
                                }
                            } else {
                                I ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, M, T, g[t]) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, S, M, T, g[t]);
                                for(let i = 0; i < D.length; i++){
                                    const r = D[i];
                                    I ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, 0, 0, M, T, r.image[t]) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, S, M, T, r.image[t]);
                                }
                            }
                        }
                        x(r, A) && b(e1.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
                    }
                    t.__version = r.version;
                }(s, t, r) : n.bindTexture(e1.TEXTURE_CUBE_MAP, s.__webglTexture, e1.TEXTURE0 + r);
            }, this.rebindTextures = function(t, n, r) {
                const a = i.get(t);
                void 0 !== n && U(a.__webglFramebuffer, t, t.texture, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, 0), void 0 !== r && k(t);
            }, this.setupRenderTarget = function(t) {
                const l = t.texture, c = i.get(t), u = i.get(l);
                t.addEventListener("dispose", I), !0 !== t.isWebGLMultipleRenderTargets && (void 0 === u.__webglTexture && (u.__webglTexture = e1.createTexture()), u.__version = l.version, s.memory.textures++);
                const h = !0 === t.isWebGLCubeRenderTarget, d = !0 === t.isWebGLMultipleRenderTargets, p = y(t) || o;
                if (h) {
                    c.__webglFramebuffer = [];
                    for(let t = 0; t < 6; t++)if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer[t] = [];
                        for(let n = 0; n < l.mipmaps.length; n++)c.__webglFramebuffer[t][n] = e1.createFramebuffer();
                    } else c.__webglFramebuffer[t] = e1.createFramebuffer();
                } else {
                    if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer = [];
                        for(let t = 0; t < l.mipmaps.length; t++)c.__webglFramebuffer[t] = e1.createFramebuffer();
                    } else c.__webglFramebuffer = e1.createFramebuffer();
                    if (d) {
                        if (r.drawBuffers) {
                            const n = t.texture;
                            for(let t = 0, r = n.length; t < r; t++){
                                const r = i.get(n[t]);
                                void 0 === r.__webglTexture && (r.__webglTexture = e1.createTexture(), s.memory.textures++);
                            }
                        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
                    }
                    if (o && t.samples > 0 && !1 === F(t)) {
                        const i = d ? l : [
                            l
                        ];
                        c.__webglMultisampledFramebuffer = e1.createFramebuffer(), c.__webglColorRenderbuffer = [], n.bindFramebuffer(e1.FRAMEBUFFER, c.__webglMultisampledFramebuffer);
                        for(let n = 0; n < i.length; n++){
                            const r = i[n];
                            c.__webglColorRenderbuffer[n] = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                            const s = a.convert(r.format, r.colorSpace), o = a.convert(r.type), l = w(r.internalFormat, s, o, r.colorSpace, !0 === t.isXRRenderTarget), u = B(t);
                            e1.renderbufferStorageMultisample(e1.RENDERBUFFER, u, l, t.width, t.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + n, e1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                        }
                        e1.bindRenderbuffer(e1.RENDERBUFFER, null), t.depthBuffer && (c.__webglDepthRenderbuffer = e1.createRenderbuffer(), j(c.__webglDepthRenderbuffer, t, !0)), n.bindFramebuffer(e1.FRAMEBUFFER, null);
                    }
                }
                if (h) {
                    n.bindTexture(e1.TEXTURE_CUBE_MAP, u.__webglTexture), O(e1.TEXTURE_CUBE_MAP, l, p);
                    for(let n = 0; n < 6; n++)if (o && l.mipmaps && l.mipmaps.length > 0) for(let i = 0; i < l.mipmaps.length; i++)U(c.__webglFramebuffer[n][i], t, l, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + n, i);
                    else U(c.__webglFramebuffer[n], t, l, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0);
                    x(l, p) && b(e1.TEXTURE_CUBE_MAP), n.unbindTexture();
                } else if (d) {
                    const r = t.texture;
                    for(let a = 0, s = r.length; a < s; a++){
                        const s = r[a], o = i.get(s);
                        n.bindTexture(e1.TEXTURE_2D, o.__webglTexture), O(e1.TEXTURE_2D, s, p), U(c.__webglFramebuffer, t, s, e1.COLOR_ATTACHMENT0 + a, e1.TEXTURE_2D, 0), x(s, p) && b(e1.TEXTURE_2D);
                    }
                    n.unbindTexture();
                } else {
                    let i = e1.TEXTURE_2D;
                    if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (o ? i = t.isWebGL3DRenderTarget ? e1.TEXTURE_3D : e1.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(i, u.__webglTexture), O(i, l, p), o && l.mipmaps && l.mipmaps.length > 0) for(let n = 0; n < l.mipmaps.length; n++)U(c.__webglFramebuffer[n], t, l, e1.COLOR_ATTACHMENT0, i, n);
                    else U(c.__webglFramebuffer, t, l, e1.COLOR_ATTACHMENT0, i, 0);
                    x(l, p) && b(i), n.unbindTexture();
                }
                t.depthBuffer && k(t);
            }, this.updateRenderTargetMipmap = function(t) {
                const r = y(t) || o, a = !0 === t.isWebGLMultipleRenderTargets ? t.texture : [
                    t.texture
                ];
                for(let s = 0, o = a.length; s < o; s++){
                    const o = a[s];
                    if (x(o, r)) {
                        const r = t.isWebGLCubeRenderTarget ? e1.TEXTURE_CUBE_MAP : e1.TEXTURE_2D, a = i.get(o).__webglTexture;
                        n.bindTexture(r, a), b(r), n.unbindTexture();
                    }
                }
            }, this.updateMultisampleRenderTarget = function(t) {
                if (o && t.samples > 0 && !1 === F(t)) {
                    const r = t.isWebGLMultipleRenderTargets ? t.texture : [
                        t.texture
                    ], a = t.width, s = t.height;
                    let o = e1.COLOR_BUFFER_BIT;
                    const l = [], c = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, u = i.get(t), h = !0 === t.isWebGLMultipleRenderTargets;
                    if (h) for(let t = 0; t < r.length; t++)n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, null), n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, null, 0);
                    n.bindFramebuffer(e1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer), n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                    for(let n = 0; n < r.length; n++){
                        l.push(e1.COLOR_ATTACHMENT0 + n), t.depthBuffer && l.push(c);
                        const d = void 0 !== u.__ignoreDepthValues && u.__ignoreDepthValues;
                        if (!1 === d && (t.depthBuffer && (o |= e1.DEPTH_BUFFER_BIT), t.stencilBuffer && (o |= e1.STENCIL_BUFFER_BIT)), h && e1.framebufferRenderbuffer(e1.READ_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, u.__webglColorRenderbuffer[n]), !0 === d && (e1.invalidateFramebuffer(e1.READ_FRAMEBUFFER, [
                            c
                        ]), e1.invalidateFramebuffer(e1.DRAW_FRAMEBUFFER, [
                            c
                        ])), h) {
                            const t = i.get(r[n]).__webglTexture;
                            e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t, 0);
                        }
                        e1.blitFramebuffer(0, 0, a, s, 0, 0, a, s, o, e1.NEAREST), p && e1.invalidateFramebuffer(e1.READ_FRAMEBUFFER, l);
                    }
                    if (n.bindFramebuffer(e1.READ_FRAMEBUFFER, null), n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), h) for(let t = 0; t < r.length; t++){
                        n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, u.__webglColorRenderbuffer[t]);
                        const a = i.get(r[t]).__webglTexture;
                        n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, a, 0);
                    }
                    n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                }
            }, this.setupDepthRenderbuffer = k, this.setupFrameBufferTexture = U, this.useMultisampledRTT = F;
        }
        function Pp(e1, t, n) {
            const i = n.isWebGL2;
            return {
                convert: function(n) {
                    let r, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Vs;
                    const s = pl.getTransfer(a);
                    if (n === Ea) return e1.UNSIGNED_BYTE;
                    if (n === La) return e1.UNSIGNED_SHORT_4_4_4_4;
                    if (n === za) return e1.UNSIGNED_SHORT_5_5_5_1;
                    if (n === Ta) return e1.BYTE;
                    if (n === Sa) return e1.SHORT;
                    if (n === Ia) return e1.UNSIGNED_SHORT;
                    if (n === Na) return e1.INT;
                    if (n === Da) return e1.UNSIGNED_INT;
                    if (n === _a) return e1.FLOAT;
                    if (n === Ca) return i ? e1.HALF_FLOAT : (r = t.get("OES_texture_half_float"), null !== r ? r.HALF_FLOAT_OES : null);
                    if (n === Ra) return e1.ALPHA;
                    if (n === Pa) return e1.RGBA;
                    if (n === Ua) return e1.LUMINANCE;
                    if (n === ja) return e1.LUMINANCE_ALPHA;
                    if (n === ka) return e1.DEPTH_COMPONENT;
                    if (n === Ba) return e1.DEPTH_STENCIL;
                    if (n === Ro) return r = t.get("EXT_sRGB"), null !== r ? r.SRGB_ALPHA_EXT : null;
                    if (n === Fa) return e1.RED;
                    if (n === Ha) return e1.RED_INTEGER;
                    if (n === Ga) return e1.RG;
                    if (n === Va) return e1.RG_INTEGER;
                    if (n === Qa) return e1.RGBA_INTEGER;
                    if (n === Wa || n === Ya || n === Xa || n === Za) {
                        if (s === qs) {
                            if (r = t.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
                            if (n === Wa) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                            if (n === Ya) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                            if (n === Xa) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                            if (n === Za) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        } else {
                            if (r = t.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
                            if (n === Wa) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
                            if (n === Ya) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                            if (n === Xa) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                            if (n === Za) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                        }
                    }
                    if (n === qa || n === Ka || n === Ja || n === $a) {
                        if (r = t.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
                        if (n === qa) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                        if (n === Ka) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                        if (n === Ja) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                        if (n === $a) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                    }
                    if (n === es) return r = t.get("WEBGL_compressed_texture_etc1"), null !== r ? r.COMPRESSED_RGB_ETC1_WEBGL : null;
                    if (n === ts || n === ns) {
                        if (r = t.get("WEBGL_compressed_texture_etc"), null === r) return null;
                        if (n === ts) return s === qs ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
                        if (n === ns) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
                    }
                    if (n === is || n === rs || n === as || n === ss || n === os || n === ls || n === cs || n === us || n === hs || n === ds || n === ps || n === fs || n === gs || n === ms) {
                        if (r = t.get("WEBGL_compressed_texture_astc"), null === r) return null;
                        if (n === is) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
                        if (n === rs) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
                        if (n === as) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
                        if (n === ss) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
                        if (n === os) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
                        if (n === ls) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
                        if (n === cs) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
                        if (n === us) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
                        if (n === hs) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
                        if (n === ds) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
                        if (n === ps) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
                        if (n === fs) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
                        if (n === gs) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
                        if (n === ms) return s === qs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
                    }
                    if (n === As || n === Ms || n === vs) {
                        if (r = t.get("EXT_texture_compression_bptc"), null === r) return null;
                        if (n === As) return s === qs ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                        if (n === Ms) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                        if (n === vs) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                    }
                    if (n === ys || n === xs || n === bs || n === ws) {
                        if (r = t.get("EXT_texture_compression_rgtc"), null === r) return null;
                        if (n === As) return r.COMPRESSED_RED_RGTC1_EXT;
                        if (n === xs) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                        if (n === bs) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
                        if (n === ws) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                    }
                    return n === Oa ? i ? e1.UNSIGNED_INT_24_8 : (r = t.get("WEBGL_depth_texture"), null !== r ? r.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== e1[n] ? e1[n] : null;
                }
            };
        }
        class Up extends $u {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                super(), this.isArrayCamera = !0, this.cameras = e1;
            }
        }
        class jp extends zc {
            constructor(){
                super(), this.isGroup = !0, this.type = "Group";
            }
        }
        const kp = {
            type: "move"
        };
        class Bp {
            constructor(){
                this._targetRay = null, this._grip = null, this._hand = null;
            }
            getHandSpace() {
                return null === this._hand && (this._hand = new jp, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                    pinching: !1
                }), this._hand;
            }
            getTargetRaySpace() {
                return null === this._targetRay && (this._targetRay = new jp, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Ll, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Ll), this._targetRay;
            }
            getGripSpace() {
                return null === this._grip && (this._grip = new jp, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Ll, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Ll), this._grip;
            }
            dispatchEvent(e1) {
                return null !== this._targetRay && this._targetRay.dispatchEvent(e1), null !== this._grip && this._grip.dispatchEvent(e1), null !== this._hand && this._hand.dispatchEvent(e1), this;
            }
            connect(e1) {
                if (e1 && e1.hand) {
                    const t = this._hand;
                    if (t) for (const n of e1.hand.values())this._getHandJoint(t, n);
                }
                return this.dispatchEvent({
                    type: "connected",
                    data: e1
                }), this;
            }
            disconnect(e1) {
                return this.dispatchEvent({
                    type: "disconnected",
                    data: e1
                }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
            }
            update(e1, t, n) {
                let i = null, r = null, a = null;
                const s = this._targetRay, o = this._grip, l = this._hand;
                if (e1 && "visible-blurred" !== t.session.visibilityState) {
                    if (l && e1.hand) {
                        a = !0;
                        for (const i of e1.hand.values()){
                            const e1 = t.getJointPose(i, n), r = this._getHandJoint(l, i);
                            null !== e1 && (r.matrix.fromArray(e1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = e1.radius), r.visible = null !== e1;
                        }
                        const i = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], s = i.position.distanceTo(r.position), o = .02, c = .005;
                        l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                            type: "pinchend",
                            handedness: e1.handedness,
                            target: this
                        })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                            type: "pinchstart",
                            handedness: e1.handedness,
                            target: this
                        }));
                    } else null !== o && e1.gripSpace && (r = t.getPose(e1.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
                    null !== s && (i = t.getPose(e1.targetRaySpace, n), null === i && null !== r && (i = r), null !== i && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(kp)));
                }
                return null !== s && (s.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== a), this;
            }
            _getHandJoint(e1, t) {
                if (void 0 === e1.joints[t.jointName]) {
                    const n = new jp;
                    n.matrixAutoUpdate = !1, n.visible = !1, e1.joints[t.jointName] = n, e1.add(n);
                }
                return e1.joints[t.jointName];
            }
        }
        class Fp extends bl {
            constructor(e1, t, n, i, r, a, s, o, l, c){
                if ((c = void 0 !== c ? c : ka) !== ka && c !== Ba) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                void 0 === n && c === ka && (n = Da), void 0 === n && c === Ba && (n = Oa), super(null, i, r, a, s, o, c, n, l), this.isDepthTexture = !0, this.image = {
                    width: e1,
                    height: t
                }, this.magFilter = void 0 !== s ? s : fa, this.minFilter = void 0 !== o ? o : fa, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
            }
            copy(e1) {
                return super.copy(e1), this.compareFunction = e1.compareFunction, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return null !== this.compareFunction && (t.compareFunction = this.compareFunction), t;
            }
        }
        class Hp extends jo {
            constructor(e1, t){
                super();
                const n = this;
                let i = null, r = 1, a = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
                const f = t.getContextAttributes();
                let g = null, m = null;
                const A = [], M = [], v = new $u;
                v.layers.enable(1), v.viewport = new wl;
                const y = new $u;
                y.layers.enable(2), y.viewport = new wl;
                const x = [
                    v,
                    y
                ], b = new Up;
                b.layers.enable(1), b.layers.enable(2);
                let w = null, E = null;
                function T(e1) {
                    const t = M.indexOf(e1.inputSource);
                    if (-1 === t) return;
                    const n = A[t];
                    void 0 !== n && (n.update(e1.inputSource, e1.frame, l || a), n.dispatchEvent({
                        type: e1.type,
                        data: e1.inputSource
                    }));
                }
                function S() {
                    i.removeEventListener("select", T), i.removeEventListener("selectstart", T), i.removeEventListener("selectend", T), i.removeEventListener("squeeze", T), i.removeEventListener("squeezestart", T), i.removeEventListener("squeezeend", T), i.removeEventListener("end", S), i.removeEventListener("inputsourceschange", I);
                    for(let e1 = 0; e1 < A.length; e1++){
                        const t = M[e1];
                        null !== t && (M[e1] = null, A[e1].disconnect(t));
                    }
                    w = null, E = null, e1.setRenderTarget(g), d = null, h = null, u = null, i = null, m = null, L.stop(), n.isPresenting = !1, n.dispatchEvent({
                        type: "sessionend"
                    });
                }
                function I(e1) {
                    for(let t = 0; t < e1.removed.length; t++){
                        const n = e1.removed[t], i = M.indexOf(n);
                        i >= 0 && (M[i] = null, A[i].disconnect(n));
                    }
                    for(let t = 0; t < e1.added.length; t++){
                        const n = e1.added[t];
                        let i = M.indexOf(n);
                        if (-1 === i) {
                            for(let e1 = 0; e1 < A.length; e1++){
                                if (e1 >= M.length) {
                                    M.push(n), i = e1;
                                    break;
                                }
                                if (null === M[e1]) {
                                    M[e1] = n, i = e1;
                                    break;
                                }
                            }
                            if (-1 === i) break;
                        }
                        const r = A[i];
                        r && r.connect(n);
                    }
                }
                this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getTargetRaySpace();
                }, this.getControllerGrip = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getGripSpace();
                }, this.getHand = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getHandSpace();
                }, this.setFramebufferScaleFactor = function(e1) {
                    r = e1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                }, this.setReferenceSpaceType = function(e1) {
                    s = e1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                }, this.getReferenceSpace = function() {
                    return l || a;
                }, this.setReferenceSpace = function(e1) {
                    l = e1;
                }, this.getBaseLayer = function() {
                    return null !== h ? h : d;
                }, this.getBinding = function() {
                    return u;
                }, this.getFrame = function() {
                    return p;
                }, this.getSession = function() {
                    return i;
                }, this.setSession = async function(c) {
                    if (i = c, null !== i) {
                        if (g = e1.getRenderTarget(), i.addEventListener("select", T), i.addEventListener("selectstart", T), i.addEventListener("selectend", T), i.addEventListener("squeeze", T), i.addEventListener("squeezestart", T), i.addEventListener("squeezeend", T), i.addEventListener("end", S), i.addEventListener("inputsourceschange", I), !0 !== f.xrCompatible && await t.makeXRCompatible(), void 0 === i.renderState.layers || !1 === e1.capabilities.isWebGL2) {
                            const n = {
                                antialias: void 0 !== i.renderState.layers || f.antialias,
                                alpha: !0,
                                depth: f.depth,
                                stencil: f.stencil,
                                framebufferScaleFactor: r
                            };
                            d = new XRWebGLLayer(i, t, n), i.updateRenderState({
                                baseLayer: d
                            }), m = new Tl(d.framebufferWidth, d.framebufferHeight, {
                                format: Pa,
                                type: Ea,
                                colorSpace: e1.outputColorSpace,
                                stencilBuffer: f.stencil
                            });
                        } else {
                            let n = null, a = null, s = null;
                            f.depth && (s = f.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, n = f.stencil ? Ba : ka, a = f.stencil ? Oa : Da);
                            const o = {
                                colorFormat: t.RGBA8,
                                depthFormat: s,
                                scaleFactor: r
                            };
                            u = new XRWebGLBinding(i, t), h = u.createProjectionLayer(o), i.updateRenderState({
                                layers: [
                                    h
                                ]
                            }), m = new Tl(h.textureWidth, h.textureHeight, {
                                format: Pa,
                                type: Ea,
                                depthTexture: new Fp(h.textureWidth, h.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, n),
                                stencilBuffer: f.stencil,
                                colorSpace: e1.outputColorSpace,
                                samples: f.antialias ? 4 : 0
                            }), e1.properties.get(m).__ignoreDepthValues = h.ignoreDepthValues;
                        }
                        m.isXRRenderTarget = !0, this.setFoveation(o), l = null, a = await i.requestReferenceSpace(s), L.setContext(i), L.start(), n.isPresenting = !0, n.dispatchEvent({
                            type: "sessionstart"
                        });
                    }
                }, this.getEnvironmentBlendMode = function() {
                    if (null !== i) return i.environmentBlendMode;
                };
                const N = new Ll, D = new Ll;
                function _(e1, t) {
                    null === t ? e1.matrixWorld.copy(e1.matrix) : e1.matrixWorld.multiplyMatrices(t.matrixWorld, e1.matrix), e1.matrixWorldInverse.copy(e1.matrixWorld).invert();
                }
                this.updateCamera = function(e1) {
                    if (null === i) return;
                    b.near = y.near = v.near = e1.near, b.far = y.far = v.far = e1.far, w === b.near && E === b.far || (i.updateRenderState({
                        depthNear: b.near,
                        depthFar: b.far
                    }), w = b.near, E = b.far);
                    const t = e1.parent, n = b.cameras;
                    _(b, t);
                    for(let e1 = 0; e1 < n.length; e1++)_(n[e1], t);
                    2 === n.length ? function(e1, t, n) {
                        N.setFromMatrixPosition(t.matrixWorld), D.setFromMatrixPosition(n.matrixWorld);
                        const i = N.distanceTo(D), r = t.projectionMatrix.elements, a = n.projectionMatrix.elements, s = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], u = (r[8] - 1) / r[0], h = (a[8] + 1) / a[0], d = s * u, p = s * h, f = i / (-u + h), g = f * -u;
                        t.matrixWorld.decompose(e1.position, e1.quaternion, e1.scale), e1.translateX(g), e1.translateZ(f), e1.matrixWorld.compose(e1.position, e1.quaternion, e1.scale), e1.matrixWorldInverse.copy(e1.matrixWorld).invert();
                        const m = s + f, A = o + f, M = d - g, v = p + (i - g), y = l * o / A * m, x = c * o / A * m;
                        e1.projectionMatrix.makePerspective(M, v, y, x, m, A), e1.projectionMatrixInverse.copy(e1.projectionMatrix).invert();
                    }(b, v, y) : b.projectionMatrix.copy(v.projectionMatrix), function(e1, t, n) {
                        null === n ? e1.matrix.copy(t.matrixWorld) : (e1.matrix.copy(n.matrixWorld), e1.matrix.invert(), e1.matrix.multiply(t.matrixWorld)), e1.matrix.decompose(e1.position, e1.quaternion, e1.scale), e1.updateMatrixWorld(!0), e1.projectionMatrix.copy(t.projectionMatrix), e1.projectionMatrixInverse.copy(t.projectionMatrixInverse), e1.isPerspectiveCamera && (e1.fov = 2 * Ho * Math.atan(1 / e1.projectionMatrix.elements[5]), e1.zoom = 1);
                    }(e1, b, t);
                }, this.getCamera = function() {
                    return b;
                }, this.getFoveation = function() {
                    if (null !== h || null !== d) return o;
                }, this.setFoveation = function(e1) {
                    o = e1, null !== h && (h.fixedFoveation = e1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = e1);
                };
                let C = null;
                const L = new hh;
                L.setAnimationLoop(function(t, i) {
                    if (c = i.getViewerPose(l || a), p = i, null !== c) {
                        const t = c.views;
                        null !== d && (e1.setRenderTargetFramebuffer(m, d.framebuffer), e1.setRenderTarget(m));
                        let n = !1;
                        t.length !== b.cameras.length && (b.cameras.length = 0, n = !0);
                        for(let i = 0; i < t.length; i++){
                            const r = t[i];
                            let a = null;
                            if (null !== d) a = d.getViewport(r);
                            else {
                                const t = u.getViewSubImage(h, r);
                                a = t.viewport, 0 === i && (e1.setRenderTargetTextures(m, t.colorTexture, h.ignoreDepthValues ? void 0 : t.depthStencilTexture), e1.setRenderTarget(m));
                            }
                            let s = x[i];
                            void 0 === s && (s = new $u, s.layers.enable(i), s.viewport = new wl, x[i] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(a.x, a.y, a.width, a.height), 0 === i && (b.matrix.copy(s.matrix), b.matrix.decompose(b.position, b.quaternion, b.scale)), !0 === n && b.cameras.push(s);
                        }
                    }
                    for(let e1 = 0; e1 < A.length; e1++){
                        const t = M[e1], n = A[e1];
                        null !== t && void 0 !== n && n.update(t, i, l || a);
                    }
                    C && C(t, i), i.detectedPlanes && n.dispatchEvent({
                        type: "planesdetected",
                        data: i
                    }), p = null;
                }), this.setAnimationLoop = function(e1) {
                    C = e1;
                }, this.dispose = function() {};
            }
        }
        function Gp(e1, t) {
            function n(e1, t) {
                !0 === e1.matrixAutoUpdate && e1.updateMatrix(), t.value.copy(e1.matrix);
            }
            function i(i, r) {
                i.opacity.value = r.opacity, r.color && i.diffuse.value.copy(r.color), r.emissive && i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (i.map.value = r.map, n(r.map, i.mapTransform)), r.alphaMap && (i.alphaMap.value = r.alphaMap, n(r.alphaMap, i.alphaMapTransform)), r.bumpMap && (i.bumpMap.value = r.bumpMap, n(r.bumpMap, i.bumpMapTransform), i.bumpScale.value = r.bumpScale, r.side === hr && (i.bumpScale.value *= -1)), r.normalMap && (i.normalMap.value = r.normalMap, n(r.normalMap, i.normalMapTransform), i.normalScale.value.copy(r.normalScale), r.side === hr && i.normalScale.value.negate()), r.displacementMap && (i.displacementMap.value = r.displacementMap, n(r.displacementMap, i.displacementMapTransform), i.displacementScale.value = r.displacementScale, i.displacementBias.value = r.displacementBias), r.emissiveMap && (i.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, i.emissiveMapTransform)), r.specularMap && (i.specularMap.value = r.specularMap, n(r.specularMap, i.specularMapTransform)), r.alphaTest > 0 && (i.alphaTest.value = r.alphaTest);
                const a = t.get(r).envMap;
                if (a && (i.envMap.value = a, i.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, i.reflectivity.value = r.reflectivity, i.ior.value = r.ior, i.refractionRatio.value = r.refractionRatio), r.lightMap) {
                    i.lightMap.value = r.lightMap;
                    const t = !0 === e1._useLegacyLights ? Math.PI : 1;
                    i.lightMapIntensity.value = r.lightMapIntensity * t, n(r.lightMap, i.lightMapTransform);
                }
                r.aoMap && (i.aoMap.value = r.aoMap, i.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, i.aoMapTransform));
            }
            return {
                refreshFogUniforms: function(t, n) {
                    n.color.getRGB(t.fogColor.value, Zu(e1)), n.isFog ? (t.fogNear.value = n.near, t.fogFar.value = n.far) : n.isFogExp2 && (t.fogDensity.value = n.density);
                },
                refreshMaterialUniforms: function(e1, r, a, s, o) {
                    r.isMeshBasicMaterial || r.isMeshLambertMaterial ? i(e1, r) : r.isMeshToonMaterial ? (i(e1, r), function(e1, t) {
                        t.gradientMap && (e1.gradientMap.value = t.gradientMap);
                    }(e1, r)) : r.isMeshPhongMaterial ? (i(e1, r), function(e1, t) {
                        e1.specular.value.copy(t.specular), e1.shininess.value = Math.max(t.shininess, 1e-4);
                    }(e1, r)) : r.isMeshStandardMaterial ? (i(e1, r), function(e1, i) {
                        e1.metalness.value = i.metalness, i.metalnessMap && (e1.metalnessMap.value = i.metalnessMap, n(i.metalnessMap, e1.metalnessMapTransform)), e1.roughness.value = i.roughness, i.roughnessMap && (e1.roughnessMap.value = i.roughnessMap, n(i.roughnessMap, e1.roughnessMapTransform));
                        t.get(i).envMap && (e1.envMapIntensity.value = i.envMapIntensity);
                    }(e1, r), r.isMeshPhysicalMaterial && function(e1, t, i) {
                        e1.ior.value = t.ior, t.sheen > 0 && (e1.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e1.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e1.sheenColorMap.value = t.sheenColorMap, n(t.sheenColorMap, e1.sheenColorMapTransform)), t.sheenRoughnessMap && (e1.sheenRoughnessMap.value = t.sheenRoughnessMap, n(t.sheenRoughnessMap, e1.sheenRoughnessMapTransform))), t.clearcoat > 0 && (e1.clearcoat.value = t.clearcoat, e1.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e1.clearcoatMap.value = t.clearcoatMap, n(t.clearcoatMap, e1.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e1.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, n(t.clearcoatRoughnessMap, e1.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e1.clearcoatNormalMap.value = t.clearcoatNormalMap, n(t.clearcoatNormalMap, e1.clearcoatNormalMapTransform), e1.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), t.side === hr && e1.clearcoatNormalScale.value.negate())), t.iridescence > 0 && (e1.iridescence.value = t.iridescence, e1.iridescenceIOR.value = t.iridescenceIOR, e1.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e1.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e1.iridescenceMap.value = t.iridescenceMap, n(t.iridescenceMap, e1.iridescenceMapTransform)), t.iridescenceThicknessMap && (e1.iridescenceThicknessMap.value = t.iridescenceThicknessMap, n(t.iridescenceThicknessMap, e1.iridescenceThicknessMapTransform))), t.transmission > 0 && (e1.transmission.value = t.transmission, e1.transmissionSamplerMap.value = i.texture, e1.transmissionSamplerSize.value.set(i.width, i.height), t.transmissionMap && (e1.transmissionMap.value = t.transmissionMap, n(t.transmissionMap, e1.transmissionMapTransform)), e1.thickness.value = t.thickness, t.thicknessMap && (e1.thicknessMap.value = t.thicknessMap, n(t.thicknessMap, e1.thicknessMapTransform)), e1.attenuationDistance.value = t.attenuationDistance, e1.attenuationColor.value.copy(t.attenuationColor)), t.anisotropy > 0 && (e1.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e1.anisotropyMap.value = t.anisotropyMap, n(t.anisotropyMap, e1.anisotropyMapTransform))), e1.specularIntensity.value = t.specularIntensity, e1.specularColor.value.copy(t.specularColor), t.specularColorMap && (e1.specularColorMap.value = t.specularColorMap, n(t.specularColorMap, e1.specularColorMapTransform)), t.specularIntensityMap && (e1.specularIntensityMap.value = t.specularIntensityMap, n(t.specularIntensityMap, e1.specularIntensityMapTransform));
                    }(e1, r, o)) : r.isMeshMatcapMaterial ? (i(e1, r), function(e1, t) {
                        t.matcap && (e1.matcap.value = t.matcap);
                    }(e1, r)) : r.isMeshDepthMaterial ? i(e1, r) : r.isMeshDistanceMaterial ? (i(e1, r), function(e1, n) {
                        const i = t.get(n).light;
                        e1.referencePosition.value.setFromMatrixPosition(i.matrixWorld), e1.nearDistance.value = i.shadow.camera.near, e1.farDistance.value = i.shadow.camera.far;
                    }(e1, r)) : r.isMeshNormalMaterial ? i(e1, r) : r.isLineBasicMaterial ? (function(e1, t) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, t.map && (e1.map.value = t.map, n(t.map, e1.mapTransform));
                    }(e1, r), r.isLineDashedMaterial && function(e1, t) {
                        e1.dashSize.value = t.dashSize, e1.totalSize.value = t.dashSize + t.gapSize, e1.scale.value = t.scale;
                    }(e1, r)) : r.isPointsMaterial ? function(e1, t, i, r) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.size.value = t.size * i, e1.scale.value = .5 * r, t.map && (e1.map.value = t.map, n(t.map, e1.uvTransform)), t.alphaMap && (e1.alphaMap.value = t.alphaMap, n(t.alphaMap, e1.alphaMapTransform)), t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
                    }(e1, r, a, s) : r.isSpriteMaterial ? function(e1, t) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.rotation.value = t.rotation, t.map && (e1.map.value = t.map, n(t.map, e1.mapTransform)), t.alphaMap && (e1.alphaMap.value = t.alphaMap, n(t.alphaMap, e1.alphaMapTransform)), t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
                    }(e1, r) : r.isShadowMaterial ? (e1.color.value.copy(r.color), e1.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
                }
            };
        }
        function Vp(e1, t, n, i) {
            let r = {}, a = {}, s = [];
            const o = n.isWebGL2 ? e1.getParameter(e1.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
            function l(e1, t, n) {
                const i = e1.value;
                if (void 0 === n[t]) {
                    if ("number" == typeof i) n[t] = i;
                    else {
                        const e1 = Array.isArray(i) ? i : [
                            i
                        ], r = [];
                        for(let t = 0; t < e1.length; t++)r.push(e1[t].clone());
                        n[t] = r;
                    }
                    return !0;
                }
                if ("number" == typeof i) {
                    if (n[t] !== i) return n[t] = i, !0;
                } else {
                    const e1 = Array.isArray(n[t]) ? n[t] : [
                        n[t]
                    ], r = Array.isArray(i) ? i : [
                        i
                    ];
                    for(let t = 0; t < e1.length; t++){
                        const n = e1[t];
                        if (!1 === n.equals(r[t])) return n.copy(r[t]), !0;
                    }
                }
                return !1;
            }
            function c(e1) {
                const t = {
                    boundary: 0,
                    storage: 0
                };
                return "number" == typeof e1 ? (t.boundary = 4, t.storage = 4) : e1.isVector2 ? (t.boundary = 8, t.storage = 8) : e1.isVector3 || e1.isColor ? (t.boundary = 16, t.storage = 12) : e1.isVector4 ? (t.boundary = 16, t.storage = 16) : e1.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e1.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", e1), t;
            }
            function u(t) {
                const n = t.target;
                n.removeEventListener("dispose", u);
                const i = s.indexOf(n.__bindingPointIndex);
                s.splice(i, 1), e1.deleteBuffer(r[n.id]), delete r[n.id], delete a[n.id];
            }
            return {
                bind: function(e1, t) {
                    const n = t.program;
                    i.uniformBlockBinding(e1, n);
                },
                update: function(n, h) {
                    let d = r[n.id];
                    void 0 === d && (function(e1) {
                        const t = e1.uniforms;
                        let n = 0;
                        let i = 0;
                        for(let e1 = 0, r = t.length; e1 < r; e1++){
                            const r = t[e1], a = {
                                boundary: 0,
                                storage: 0
                            }, s = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            for(let e1 = 0, t = s.length; e1 < t; e1++){
                                const t = c(s[e1]);
                                a.boundary += t.boundary, a.storage += t.storage;
                            }
                            r.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = n, e1 > 0 && (i = n % 16, 0 !== i && 16 - i - a.boundary < 0 && (n += 16 - i, r.__offset = n)), n += a.storage;
                        }
                        i = n % 16, i > 0 && (n += 16 - i), e1.__size = n, e1.__cache = {};
                    }(n), d = function(t) {
                        const n = function() {
                            for(let e1 = 0; e1 < o; e1++)if (-1 === s.indexOf(e1)) return s.push(e1), e1;
                            return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                        }();
                        t.__bindingPointIndex = n;
                        const i = e1.createBuffer(), r = t.__size, a = t.usage;
                        return e1.bindBuffer(e1.UNIFORM_BUFFER, i), e1.bufferData(e1.UNIFORM_BUFFER, r, a), e1.bindBuffer(e1.UNIFORM_BUFFER, null), e1.bindBufferBase(e1.UNIFORM_BUFFER, n, i), i;
                    }(n), r[n.id] = d, n.addEventListener("dispose", u));
                    const p = h.program;
                    i.updateUBOMapping(n, p);
                    const f = t.render.frame;
                    a[n.id] !== f && (function(t) {
                        const n = r[t.id], i = t.uniforms, a = t.__cache;
                        e1.bindBuffer(e1.UNIFORM_BUFFER, n);
                        for(let t = 0, n = i.length; t < n; t++){
                            const n = i[t];
                            if (!0 === l(n, t, a)) {
                                const t = n.__offset, i = Array.isArray(n.value) ? n.value : [
                                    n.value
                                ];
                                let r = 0;
                                for(let a = 0; a < i.length; a++){
                                    const s = i[a], o = c(s);
                                    "number" == typeof s ? (n.__data[0] = s, e1.bufferSubData(e1.UNIFORM_BUFFER, t + r, n.__data)) : s.isMatrix3 ? (n.__data[0] = s.elements[0], n.__data[1] = s.elements[1], n.__data[2] = s.elements[2], n.__data[3] = s.elements[0], n.__data[4] = s.elements[3], n.__data[5] = s.elements[4], n.__data[6] = s.elements[5], n.__data[7] = s.elements[0], n.__data[8] = s.elements[6], n.__data[9] = s.elements[7], n.__data[10] = s.elements[8], n.__data[11] = s.elements[0]) : (s.toArray(n.__data, r), r += o.storage / Float32Array.BYTES_PER_ELEMENT);
                                }
                                e1.bufferSubData(e1.UNIFORM_BUFFER, t, n.__data);
                            }
                        }
                        e1.bindBuffer(e1.UNIFORM_BUFFER, null);
                    }(n), a[n.id] = f);
                },
                dispose: function() {
                    for(const t in r)e1.deleteBuffer(r[t]);
                    s = [], r = {}, a = {};
                }
            };
        }
        class Qp {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const { canvas: t = sl(), context: n = null, depth: i = !0, stencil: r = !0, alpha: a = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1 } = e1;
                let h;
                this.isWebGLRenderer = !0, h = null !== n ? n.getContextAttributes().alpha : a;
                const d = new Uint32Array(4), p = new Int32Array(4);
                let f = null, g = null;
                const m = [], A = [];
                this.domElement = t, this.debug = {
                    checkShaderErrors: !0,
                    onShaderError: null
                }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = Qs, this._useLegacyLights = !1, this.toneMapping = Kr, this.toneMappingExposure = 1;
                const M = this;
                let v = !1, y = 0, x = 0, b = null, w = -1, E = null;
                const T = new wl, S = new wl;
                let I = null;
                const N = new qc(0);
                let D = 0, _ = t.width, C = t.height, L = 1, z = null, O = null;
                const R = new wl(0, 0, _, C), P = new wl(0, 0, _, C);
                let U = !1;
                const j = new uh;
                let k = !1, B = !1, F = null;
                const H = new lc, G = new $o, V = new Ll, Q = {
                    background: null,
                    fog: null,
                    environment: null,
                    overrideMaterial: null,
                    isScene: !0
                };
                function W() {
                    return null === b ? L : 1;
                }
                let Y, X, Z, q, K, J, $, ee, te, ne, ie, re, ae, se, oe, le, ce, ue, he, de, pe, fe, ge, me, Ae = n;
                function Me(e1, n) {
                    for(let i = 0; i < e1.length; i++){
                        const r = e1[i], a = t.getContext(r, n);
                        if (null !== a) return a;
                    }
                    return null;
                }
                try {
                    const e1 = {
                        alpha: !0,
                        depth: i,
                        stencil: r,
                        antialias: s,
                        premultipliedAlpha: o,
                        preserveDrawingBuffer: l,
                        powerPreference: c,
                        failIfMajorPerformanceCaveat: u
                    };
                    if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${$i}`), t.addEventListener("webglcontextlost", xe, !1), t.addEventListener("webglcontextrestored", be, !1), t.addEventListener("webglcontextcreationerror", we, !1), null === Ae) {
                        const t = [
                            "webgl2",
                            "webgl",
                            "experimental-webgl"
                        ];
                        if (!0 === M.isWebGL1Renderer && t.shift(), Ae = Me(t, e1), null === Ae) throw Me(t) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                    }
                    "undefined" != typeof WebGLRenderingContext && Ae instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === Ae.getShaderPrecisionFormat && (Ae.getShaderPrecisionFormat = function() {
                        return {
                            rangeMin: 1,
                            rangeMax: 1,
                            precision: 1
                        };
                    });
                } catch (e1) {
                    throw console.error("THREE.WebGLRenderer: " + e1.message), e1;
                }
                function ve() {
                    Y = new Bh(Ae), X = new xh(Ae, Y, e1), Y.init(X), fe = new Pp(Ae, Y, X), Z = new Op(Ae, Y, X), q = new Gh(Ae), K = new yp, J = new Rp(Ae, Y, Z, K, X, fe, q), $ = new wh(M), ee = new kh(M), te = new dh(Ae, X), ge = new vh(Ae, Y, te, X), ne = new Fh(Ae, te, q, ge), ie = new Yh(Ae, ne, te, q), he = new Wh(Ae, X, J), le = new bh(K), re = new vp(M, $, ee, Y, X, ge, le), ae = new Gp(M, K), se = new Ep, oe = new _p(Y, X), ue = new Mh(M, $, ee, Z, ie, h, o), ce = new zp(M, ie, X), me = new Vp(Ae, q, X, Z), de = new yh(Ae, Y, q, X), pe = new Hh(Ae, Y, q, X), q.programs = re.programs, M.capabilities = X, M.extensions = Y, M.properties = K, M.renderLists = se, M.shadowMap = ce, M.state = Z, M.info = q;
                }
                ve();
                const ye = new Hp(M, Ae);
                function xe(e1) {
                    e1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), v = !0;
                }
                function be() {
                    console.log("THREE.WebGLRenderer: Context Restored."), v = !1;
                    const e1 = q.autoReset, t = ce.enabled, n = ce.autoUpdate, i = ce.needsUpdate, r = ce.type;
                    ve(), q.autoReset = e1, ce.enabled = t, ce.autoUpdate = n, ce.needsUpdate = i, ce.type = r;
                }
                function we(e1) {
                    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", e1.statusMessage);
                }
                function Ee(e1) {
                    const t = e1.target;
                    t.removeEventListener("dispose", Ee), function(e1) {
                        (function(e1) {
                            const t = K.get(e1).programs;
                            void 0 !== t && (t.forEach(function(e1) {
                                re.releaseProgram(e1);
                            }), e1.isShaderMaterial && re.releaseShaderCache(e1));
                        })(e1), K.remove(e1);
                    }(t);
                }
                function Te(e1, t, n) {
                    !0 === e1.transparent && e1.side === dr && !1 === e1.forceSinglePass ? (e1.side = hr, e1.needsUpdate = !0, Oe(e1, t, n), e1.side = ur, e1.needsUpdate = !0, Oe(e1, t, n), e1.side = dr) : Oe(e1, t, n);
                }
                this.xr = ye, this.getContext = function() {
                    return Ae;
                }, this.getContextAttributes = function() {
                    return Ae.getContextAttributes();
                }, this.forceContextLoss = function() {
                    const e1 = Y.get("WEBGL_lose_context");
                    e1 && e1.loseContext();
                }, this.forceContextRestore = function() {
                    const e1 = Y.get("WEBGL_lose_context");
                    e1 && e1.restoreContext();
                }, this.getPixelRatio = function() {
                    return L;
                }, this.setPixelRatio = function(e1) {
                    void 0 !== e1 && (L = e1, this.setSize(_, C, !1));
                }, this.getSize = function(e1) {
                    return e1.set(_, C);
                }, this.setSize = function(e1, n) {
                    let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    ye.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (_ = e1, C = n, t.width = Math.floor(e1 * L), t.height = Math.floor(n * L), !0 === i && (t.style.width = e1 + "px", t.style.height = n + "px"), this.setViewport(0, 0, e1, n));
                }, this.getDrawingBufferSize = function(e1) {
                    return e1.set(_ * L, C * L).floor();
                }, this.setDrawingBufferSize = function(e1, n, i) {
                    _ = e1, C = n, L = i, t.width = Math.floor(e1 * i), t.height = Math.floor(n * i), this.setViewport(0, 0, e1, n);
                }, this.getCurrentViewport = function(e1) {
                    return e1.copy(T);
                }, this.getViewport = function(e1) {
                    return e1.copy(R);
                }, this.setViewport = function(e1, t, n, i) {
                    e1.isVector4 ? R.set(e1.x, e1.y, e1.z, e1.w) : R.set(e1, t, n, i), Z.viewport(T.copy(R).multiplyScalar(L).floor());
                }, this.getScissor = function(e1) {
                    return e1.copy(P);
                }, this.setScissor = function(e1, t, n, i) {
                    e1.isVector4 ? P.set(e1.x, e1.y, e1.z, e1.w) : P.set(e1, t, n, i), Z.scissor(S.copy(P).multiplyScalar(L).floor());
                }, this.getScissorTest = function() {
                    return U;
                }, this.setScissorTest = function(e1) {
                    Z.setScissorTest(U = e1);
                }, this.setOpaqueSort = function(e1) {
                    z = e1;
                }, this.setTransparentSort = function(e1) {
                    O = e1;
                }, this.getClearColor = function(e1) {
                    return e1.copy(ue.getClearColor());
                }, this.setClearColor = function() {
                    ue.setClearColor.apply(ue, arguments);
                }, this.getClearAlpha = function() {
                    return ue.getClearAlpha();
                }, this.setClearAlpha = function() {
                    ue.setClearAlpha.apply(ue, arguments);
                }, this.clear = function() {
                    let e1 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], t = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], n = 0;
                    if (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]) {
                        let e1 = !1;
                        if (null !== b) {
                            const t = b.texture.format;
                            e1 = t === Qa || t === Va || t === Ha;
                        }
                        if (e1) {
                            const e1 = b.texture.type, t = e1 === Ea || e1 === Da || e1 === Ia || e1 === Oa || e1 === La || e1 === za, n = ue.getClearColor(), i = ue.getClearAlpha(), r = n.r, a = n.g, s = n.b;
                            t ? (d[0] = r, d[1] = a, d[2] = s, d[3] = i, Ae.clearBufferuiv(Ae.COLOR, 0, d)) : (p[0] = r, p[1] = a, p[2] = s, p[3] = i, Ae.clearBufferiv(Ae.COLOR, 0, p));
                        } else n |= Ae.COLOR_BUFFER_BIT;
                    }
                    e1 && (n |= Ae.DEPTH_BUFFER_BIT), t && (n |= Ae.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Ae.clear(n);
                }, this.clearColor = function() {
                    this.clear(!0, !1, !1);
                }, this.clearDepth = function() {
                    this.clear(!1, !0, !1);
                }, this.clearStencil = function() {
                    this.clear(!1, !1, !0);
                }, this.dispose = function() {
                    t.removeEventListener("webglcontextlost", xe, !1), t.removeEventListener("webglcontextrestored", be, !1), t.removeEventListener("webglcontextcreationerror", we, !1), se.dispose(), oe.dispose(), K.dispose(), $.dispose(), ee.dispose(), ie.dispose(), ge.dispose(), me.dispose(), re.dispose(), ye.dispose(), ye.removeEventListener("sessionstart", Ie), ye.removeEventListener("sessionend", Ne), F && (F.dispose(), F = null), De.stop();
                }, this.renderBufferDirect = function(e1, t, n, i, r, a) {
                    null === t && (t = Q);
                    const s = r.isMesh && r.matrixWorld.determinant() < 0, o = function(e1, t, n, i, r) {
                        !0 !== t.isScene && (t = Q), J.resetTextureUnits();
                        const a = t.fog, s = i.isMeshStandardMaterial ? t.environment : null, o = null === b ? M.outputColorSpace : !0 === b.isXRRenderTarget ? b.texture.colorSpace : Ws, l = (i.isMeshStandardMaterial ? ee : $).get(i.envMap || s), c = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize, u = !!n.attributes.tangent && (!!i.normalMap || i.anisotropy > 0), h = !!n.morphAttributes.position, d = !!n.morphAttributes.normal, p = !!n.morphAttributes.color;
                        let f = Kr;
                        i.toneMapped && (null !== b && !0 !== b.isXRRenderTarget || (f = M.toneMapping));
                        const m = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, A = void 0 !== m ? m.length : 0, v = K.get(i), y = g.state.lights;
                        if (!0 === k && (!0 === B || e1 !== E)) {
                            const t = e1 === E && i.id === w;
                            le.setState(i, e1, t);
                        }
                        let x = !1;
                        i.version === v.__version ? v.needsLights && v.lightsStateVersion !== y.state.version || v.outputColorSpace !== o || r.isInstancedMesh && !1 === v.instancing ? x = !0 : r.isInstancedMesh || !0 !== v.instancing ? r.isSkinnedMesh && !1 === v.skinning ? x = !0 : r.isSkinnedMesh || !0 !== v.skinning ? r.isInstancedMesh && !0 === v.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === v.instancingColor && null !== r.instanceColor || v.envMap !== l || !0 === i.fog && v.fog !== a ? x = !0 : void 0 === v.numClippingPlanes || v.numClippingPlanes === le.numPlanes && v.numIntersection === le.numIntersection ? (v.vertexAlphas !== c || v.vertexTangents !== u || v.morphTargets !== h || v.morphNormals !== d || v.morphColors !== p || v.toneMapping !== f || !0 === X.isWebGL2 && v.morphTargetsCount !== A) && (x = !0) : x = !0 : x = !0 : x = !0 : (x = !0, v.__version = i.version);
                        let T = v.currentProgram;
                        !0 === x && (T = Oe(i, t, r));
                        let S = !1, I = !1, N = !1;
                        const D = T.getUniforms(), _ = v.uniforms;
                        if (Z.useProgram(T.program) && (S = !0, I = !0, N = !0), i.id !== w && (w = i.id, I = !0), S || E !== e1) {
                            D.setValue(Ae, "projectionMatrix", e1.projectionMatrix), D.setValue(Ae, "viewMatrix", e1.matrixWorldInverse);
                            const t = D.map.cameraPosition;
                            void 0 !== t && t.setValue(Ae, V.setFromMatrixPosition(e1.matrixWorld)), X.logarithmicDepthBuffer && D.setValue(Ae, "logDepthBufFC", 2 / (Math.log(e1.far + 1) / Math.LN2)), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && D.setValue(Ae, "isOrthographic", !0 === e1.isOrthographicCamera), E !== e1 && (E = e1, I = !0, N = !0);
                        }
                        if (r.isSkinnedMesh) {
                            D.setOptional(Ae, r, "bindMatrix"), D.setOptional(Ae, r, "bindMatrixInverse");
                            const e1 = r.skeleton;
                            e1 && (X.floatVertexTextures ? (null === e1.boneTexture && e1.computeBoneTexture(), D.setValue(Ae, "boneTexture", e1.boneTexture, J), D.setValue(Ae, "boneTextureSize", e1.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
                        }
                        const z = n.morphAttributes;
                        var O, R;
                        if ((void 0 !== z.position || void 0 !== z.normal || void 0 !== z.color && !0 === X.isWebGL2) && he.update(r, n, T), (I || v.receiveShadow !== r.receiveShadow) && (v.receiveShadow = r.receiveShadow, D.setValue(Ae, "receiveShadow", r.receiveShadow)), i.isMeshGouraudMaterial && null !== i.envMap && (_.envMap.value = l, _.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), I && (D.setValue(Ae, "toneMappingExposure", M.toneMappingExposure), v.needsLights && (R = N, (O = _).ambientLightColor.needsUpdate = R, O.lightProbe.needsUpdate = R, O.directionalLights.needsUpdate = R, O.directionalLightShadows.needsUpdate = R, O.pointLights.needsUpdate = R, O.pointLightShadows.needsUpdate = R, O.spotLights.needsUpdate = R, O.spotLightShadows.needsUpdate = R, O.rectAreaLights.needsUpdate = R, O.hemisphereLights.needsUpdate = R), a && !0 === i.fog && ae.refreshFogUniforms(_, a), ae.refreshMaterialUniforms(_, i, L, C, F), Kd.upload(Ae, Re(v), _, J)), i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (Kd.upload(Ae, Re(v), _, J), i.uniformsNeedUpdate = !1), i.isSpriteMaterial && D.setValue(Ae, "center", r.center), D.setValue(Ae, "modelViewMatrix", r.modelViewMatrix), D.setValue(Ae, "normalMatrix", r.normalMatrix), D.setValue(Ae, "modelMatrix", r.matrixWorld), i.isShaderMaterial || i.isRawShaderMaterial) {
                            const e1 = i.uniformsGroups;
                            for(let t = 0, n = e1.length; t < n; t++)if (X.isWebGL2) {
                                const n = e1[t];
                                me.update(n, T), me.bind(n, T);
                            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
                        }
                        return T;
                    }(e1, t, n, i, r);
                    Z.setMaterial(i, s);
                    let l = n.index, c = 1;
                    if (!0 === i.wireframe) {
                        if (l = ne.getWireframeAttribute(n), void 0 === l) return;
                        c = 2;
                    }
                    const u = n.drawRange, h = n.attributes.position;
                    let d = u.start * c, p = (u.start + u.count) * c;
                    null !== a && (d = Math.max(d, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
                    const f = p - d;
                    if (f < 0 || f === 1 / 0) return;
                    let m;
                    ge.setup(r, i, o, n, l);
                    let A = de;
                    if (null !== l && (m = te.get(l), A = pe, A.setIndex(m)), r.isMesh) !0 === i.wireframe ? (Z.setLineWidth(i.wireframeLinewidth * W()), A.setMode(Ae.LINES)) : A.setMode(Ae.TRIANGLES);
                    else if (r.isLine) {
                        let e1 = i.linewidth;
                        void 0 === e1 && (e1 = 1), Z.setLineWidth(e1 * W()), r.isLineSegments ? A.setMode(Ae.LINES) : r.isLineLoop ? A.setMode(Ae.LINE_LOOP) : A.setMode(Ae.LINE_STRIP);
                    } else r.isPoints ? A.setMode(Ae.POINTS) : r.isSprite && A.setMode(Ae.TRIANGLES);
                    if (r.isInstancedMesh) A.renderInstances(d, f, r.count);
                    else if (n.isInstancedBufferGeometry) {
                        const e1 = void 0 !== n._maxInstanceCount ? n._maxInstanceCount : 1 / 0, t = Math.min(n.instanceCount, e1);
                        A.renderInstances(d, f, t);
                    } else A.render(d, f);
                }, this.compile = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    null === n && (n = e1), g = oe.get(n), g.init(), A.push(g), n.traverseVisible(function(e1) {
                        e1.isLight && e1.layers.test(t.layers) && (g.pushLight(e1), e1.castShadow && g.pushShadow(e1));
                    }), e1 !== n && e1.traverseVisible(function(e1) {
                        e1.isLight && e1.layers.test(t.layers) && (g.pushLight(e1), e1.castShadow && g.pushShadow(e1));
                    }), g.setupLights(M._useLegacyLights);
                    const i = new Set;
                    return e1.traverse(function(e1) {
                        const t = e1.material;
                        if (t) {
                            if (Array.isArray(t)) for(let r = 0; r < t.length; r++){
                                const a = t[r];
                                Te(a, n, e1), i.add(a);
                            }
                            else Te(t, n, e1), i.add(t);
                        }
                    }), A.pop(), g = null, i;
                }, this.compileAsync = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    const i = this.compile(e1, t, n);
                    return new Promise((t)=>{
                        function n() {
                            i.forEach(function(e1) {
                                K.get(e1).currentProgram.isReady() && i.delete(e1);
                            }), 0 !== i.size ? setTimeout(n, 10) : t(e1);
                        }
                        null !== Y.get("KHR_parallel_shader_compile") ? n() : setTimeout(n, 10);
                    });
                };
                let Se = null;
                function Ie() {
                    De.stop();
                }
                function Ne() {
                    De.start();
                }
                const De = new hh;
                function _e(e1, t, n, i) {
                    if (!1 === e1.visible) return;
                    if (e1.layers.test(t.layers)) {
                        if (e1.isGroup) n = e1.renderOrder;
                        else if (e1.isLOD) !0 === e1.autoUpdate && e1.update(t);
                        else if (e1.isLight) g.pushLight(e1), e1.castShadow && g.pushShadow(e1);
                        else if (e1.isSprite) {
                            if (!e1.frustumCulled || j.intersectsSprite(e1)) {
                                i && V.setFromMatrixPosition(e1.matrixWorld).applyMatrix4(H);
                                const t = ie.update(e1), r = e1.material;
                                r.visible && f.push(e1, t, r, n, V.z, null);
                            }
                        } else if ((e1.isMesh || e1.isLine || e1.isPoints) && (!e1.frustumCulled || j.intersectsObject(e1))) {
                            const t = ie.update(e1), r = e1.material;
                            if (i && (void 0 !== e1.boundingSphere ? (null === e1.boundingSphere && e1.computeBoundingSphere(), V.copy(e1.boundingSphere.center)) : (null === t.boundingSphere && t.computeBoundingSphere(), V.copy(t.boundingSphere.center)), V.applyMatrix4(e1.matrixWorld).applyMatrix4(H)), Array.isArray(r)) {
                                const i = t.groups;
                                for(let a = 0, s = i.length; a < s; a++){
                                    const s = i[a], o = r[s.materialIndex];
                                    o && o.visible && f.push(e1, t, o, n, V.z, s);
                                }
                            } else r.visible && f.push(e1, t, r, n, V.z, null);
                        }
                    }
                    const r = e1.children;
                    for(let e1 = 0, a = r.length; e1 < a; e1++)_e(r[e1], t, n, i);
                }
                function Ce(e1, t, n, i) {
                    const r = e1.opaque, a = e1.transmissive, s = e1.transparent;
                    g.setupLightsView(n), !0 === k && le.setGlobalState(M.clippingPlanes, n), a.length > 0 && function(e1, t, n, i) {
                        if (null !== (!0 === n.isScene ? n.overrideMaterial : null)) return;
                        const r = X.isWebGL2;
                        null === F && (F = new Tl(1, 1, {
                            generateMipmaps: !0,
                            type: Y.has("EXT_color_buffer_half_float") ? Ca : Ea,
                            minFilter: ba,
                            samples: r ? 4 : 0
                        })), M.getDrawingBufferSize(G), r ? F.setSize(G.x, G.y) : F.setSize(Zo(G.x), Zo(G.y));
                        const a = M.getRenderTarget();
                        M.setRenderTarget(F), M.getClearColor(N), D = M.getClearAlpha(), D < 1 && M.setClearColor(16777215, .5), M.clear();
                        const s = M.toneMapping;
                        M.toneMapping = Kr, Le(e1, n, i), J.updateMultisampleRenderTarget(F), J.updateRenderTargetMipmap(F);
                        let o = !1;
                        for(let e1 = 0, r = t.length; e1 < r; e1++){
                            const r = t[e1], a = r.object, s = r.geometry, l = r.material, c = r.group;
                            if (l.side === dr && a.layers.test(i.layers)) {
                                const e1 = l.side;
                                l.side = hr, l.needsUpdate = !0, ze(a, n, i, s, l, c), l.side = e1, l.needsUpdate = !0, o = !0;
                            }
                        }
                        !0 === o && (J.updateMultisampleRenderTarget(F), J.updateRenderTargetMipmap(F)), M.setRenderTarget(a), M.setClearColor(N, D), M.toneMapping = s;
                    }(r, a, t, n), i && Z.viewport(T.copy(i)), r.length > 0 && Le(r, t, n), a.length > 0 && Le(a, t, n), s.length > 0 && Le(s, t, n), Z.buffers.depth.setTest(!0), Z.buffers.depth.setMask(!0), Z.buffers.color.setMask(!0), Z.setPolygonOffset(!1);
                }
                function Le(e1, t, n) {
                    const i = !0 === t.isScene ? t.overrideMaterial : null;
                    for(let r = 0, a = e1.length; r < a; r++){
                        const a = e1[r], s = a.object, o = a.geometry, l = null === i ? a.material : i, c = a.group;
                        s.layers.test(n.layers) && ze(s, t, n, o, l, c);
                    }
                }
                function ze(e1, t, n, i, r, a) {
                    e1.onBeforeRender(M, t, n, i, r, a), e1.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e1.matrixWorld), e1.normalMatrix.getNormalMatrix(e1.modelViewMatrix), r.onBeforeRender(M, t, n, i, e1, a), !0 === r.transparent && r.side === dr && !1 === r.forceSinglePass ? (r.side = hr, r.needsUpdate = !0, M.renderBufferDirect(n, t, i, r, e1, a), r.side = ur, r.needsUpdate = !0, M.renderBufferDirect(n, t, i, r, e1, a), r.side = dr) : M.renderBufferDirect(n, t, i, r, e1, a), e1.onAfterRender(M, t, n, i, r, a);
                }
                function Oe(e1, t, n) {
                    !0 !== t.isScene && (t = Q);
                    const i = K.get(e1), r = g.state.lights, a = g.state.shadowsArray, s = r.state.version, o = re.getParameters(e1, r.state, a, t, n), l = re.getProgramCacheKey(o);
                    let c = i.programs;
                    i.environment = e1.isMeshStandardMaterial ? t.environment : null, i.fog = t.fog, i.envMap = (e1.isMeshStandardMaterial ? ee : $).get(e1.envMap || i.environment), void 0 === c && (e1.addEventListener("dispose", Ee), c = new Map, i.programs = c);
                    let u = c.get(l);
                    if (void 0 !== u) {
                        if (i.currentProgram === u && i.lightsStateVersion === s) return Pe(e1, o), u;
                    } else o.uniforms = re.getUniforms(e1), e1.onBuild(n, o, M), e1.onBeforeCompile(o, M), u = re.acquireProgram(o, l), c.set(l, u), i.uniforms = o.uniforms;
                    const h = i.uniforms;
                    return (e1.isShaderMaterial || e1.isRawShaderMaterial) && !0 !== e1.clipping || (h.clippingPlanes = le.uniform), Pe(e1, o), i.needsLights = function(e1) {
                        return e1.isMeshLambertMaterial || e1.isMeshToonMaterial || e1.isMeshPhongMaterial || e1.isMeshStandardMaterial || e1.isShadowMaterial || e1.isShaderMaterial && !0 === e1.lights;
                    }(e1), i.lightsStateVersion = s, i.needsLights && (h.ambientLightColor.value = r.state.ambient, h.lightProbe.value = r.state.probe, h.directionalLights.value = r.state.directional, h.directionalLightShadows.value = r.state.directionalShadow, h.spotLights.value = r.state.spot, h.spotLightShadows.value = r.state.spotShadow, h.rectAreaLights.value = r.state.rectArea, h.ltc_1.value = r.state.rectAreaLTC1, h.ltc_2.value = r.state.rectAreaLTC2, h.pointLights.value = r.state.point, h.pointLightShadows.value = r.state.pointShadow, h.hemisphereLights.value = r.state.hemi, h.directionalShadowMap.value = r.state.directionalShadowMap, h.directionalShadowMatrix.value = r.state.directionalShadowMatrix, h.spotShadowMap.value = r.state.spotShadowMap, h.spotLightMatrix.value = r.state.spotLightMatrix, h.spotLightMap.value = r.state.spotLightMap, h.pointShadowMap.value = r.state.pointShadowMap, h.pointShadowMatrix.value = r.state.pointShadowMatrix), i.currentProgram = u, i.uniformsList = null, u;
                }
                function Re(e1) {
                    if (null === e1.uniformsList) {
                        const t = e1.currentProgram.getUniforms();
                        e1.uniformsList = Kd.seqWithValue(t.seq, e1.uniforms);
                    }
                    return e1.uniformsList;
                }
                function Pe(e1, t) {
                    const n = K.get(e1);
                    n.outputColorSpace = t.outputColorSpace, n.instancing = t.instancing, n.instancingColor = t.instancingColor, n.skinning = t.skinning, n.morphTargets = t.morphTargets, n.morphNormals = t.morphNormals, n.morphColors = t.morphColors, n.morphTargetsCount = t.morphTargetsCount, n.numClippingPlanes = t.numClippingPlanes, n.numIntersection = t.numClipIntersection, n.vertexAlphas = t.vertexAlphas, n.vertexTangents = t.vertexTangents, n.toneMapping = t.toneMapping;
                }
                De.setAnimationLoop(function(e1) {
                    Se && Se(e1);
                }), "undefined" != typeof self && De.setContext(self), this.setAnimationLoop = function(e1) {
                    Se = e1, ye.setAnimationLoop(e1), null === e1 ? De.stop() : De.start();
                }, ye.addEventListener("sessionstart", Ie), ye.addEventListener("sessionend", Ne), this.render = function(e1, t) {
                    if (void 0 !== t && !0 !== t.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                    if (!0 === v) return;
                    !0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), !0 === ye.enabled && !0 === ye.isPresenting && (!0 === ye.cameraAutoUpdate && ye.updateCamera(t), t = ye.getCamera()), !0 === e1.isScene && e1.onBeforeRender(M, e1, t, b), g = oe.get(e1, A.length), g.init(), A.push(g), H.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), j.setFromProjectionMatrix(H), B = this.localClippingEnabled, k = le.init(this.clippingPlanes, B), f = se.get(e1, m.length), f.init(), m.push(f), _e(e1, t, 0, M.sortObjects), f.finish(), !0 === M.sortObjects && f.sort(z, O), this.info.render.frame++, !0 === k && le.beginShadows();
                    const n = g.state.shadowsArray;
                    if (ce.render(n, e1, t), !0 === k && le.endShadows(), !0 === this.info.autoReset && this.info.reset(), ue.render(f, e1), g.setupLights(M._useLegacyLights), t.isArrayCamera) {
                        const n = t.cameras;
                        for(let t = 0, i = n.length; t < i; t++){
                            const i = n[t];
                            Ce(f, e1, i, i.viewport);
                        }
                    } else Ce(f, e1, t);
                    null !== b && (J.updateMultisampleRenderTarget(b), J.updateRenderTargetMipmap(b)), !0 === e1.isScene && e1.onAfterRender(M, e1, t), ge.resetDefaultState(), w = -1, E = null, A.pop(), g = A.length > 0 ? A[A.length - 1] : null, m.pop(), f = m.length > 0 ? m[m.length - 1] : null;
                }, this.getActiveCubeFace = function() {
                    return y;
                }, this.getActiveMipmapLevel = function() {
                    return x;
                }, this.getRenderTarget = function() {
                    return b;
                }, this.setRenderTargetTextures = function(e1, t, n) {
                    K.get(e1.texture).__webglTexture = t, K.get(e1.depthTexture).__webglTexture = n;
                    const i = K.get(e1);
                    i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === Y.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
                }, this.setRenderTargetFramebuffer = function(e1, t) {
                    const n = K.get(e1);
                    n.__webglFramebuffer = t, n.__useDefaultFramebuffer = void 0 === t;
                }, this.setRenderTarget = function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                    b = e1, y = t, x = n;
                    let i = !0, r = null, a = !1, s = !1;
                    if (e1) {
                        const o = K.get(e1);
                        void 0 !== o.__useDefaultFramebuffer ? (Z.bindFramebuffer(Ae.FRAMEBUFFER, null), i = !1) : void 0 === o.__webglFramebuffer ? J.setupRenderTarget(e1) : o.__hasExternalTextures && J.rebindTextures(e1, K.get(e1.texture).__webglTexture, K.get(e1.depthTexture).__webglTexture);
                        const l = e1.texture;
                        (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (s = !0);
                        const c = K.get(e1).__webglFramebuffer;
                        e1.isWebGLCubeRenderTarget ? (r = Array.isArray(c[t]) ? c[t][n] : c[t], a = !0) : r = X.isWebGL2 && e1.samples > 0 && !1 === J.useMultisampledRTT(e1) ? K.get(e1).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, T.copy(e1.viewport), S.copy(e1.scissor), I = e1.scissorTest;
                    } else T.copy(R).multiplyScalar(L).floor(), S.copy(P).multiplyScalar(L).floor(), I = U;
                    if (Z.bindFramebuffer(Ae.FRAMEBUFFER, r) && X.drawBuffers && i && Z.drawBuffers(e1, r), Z.viewport(T), Z.scissor(S), Z.setScissorTest(I), a) {
                        const i = K.get(e1.texture);
                        Ae.framebufferTexture2D(Ae.FRAMEBUFFER, Ae.COLOR_ATTACHMENT0, Ae.TEXTURE_CUBE_MAP_POSITIVE_X + t, i.__webglTexture, n);
                    } else if (s) {
                        const i = K.get(e1.texture), r = t || 0;
                        Ae.framebufferTextureLayer(Ae.FRAMEBUFFER, Ae.COLOR_ATTACHMENT0, i.__webglTexture, n || 0, r);
                    }
                    w = -1;
                }, this.readRenderTargetPixels = function(e1, t, n, i, r, a, s) {
                    if (!e1 || !e1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                    let o = K.get(e1).__webglFramebuffer;
                    if (e1.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o) {
                        Z.bindFramebuffer(Ae.FRAMEBUFFER, o);
                        try {
                            const s = e1.texture, o = s.format, l = s.type;
                            if (o !== Pa && fe.convert(o) !== Ae.getParameter(Ae.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                            const c = l === Ca && (Y.has("EXT_color_buffer_half_float") || X.isWebGL2 && Y.has("EXT_color_buffer_float"));
                            if (!(l === Ea || fe.convert(l) === Ae.getParameter(Ae.IMPLEMENTATION_COLOR_READ_TYPE) || l === _a && (X.isWebGL2 || Y.has("OES_texture_float") || Y.has("WEBGL_color_buffer_float")) || c)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                            t >= 0 && t <= e1.width - i && n >= 0 && n <= e1.height - r && Ae.readPixels(t, n, i, r, fe.convert(o), fe.convert(l), a);
                        } finally{
                            const e1 = null !== b ? K.get(b).__webglFramebuffer : null;
                            Z.bindFramebuffer(Ae.FRAMEBUFFER, e1);
                        }
                    }
                }, this.copyFramebufferToTexture = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                    const i = Math.pow(2, -n), r = Math.floor(t.image.width * i), a = Math.floor(t.image.height * i);
                    J.setTexture2D(t, 0), Ae.copyTexSubImage2D(Ae.TEXTURE_2D, n, 0, 0, e1.x, e1.y, r, a), Z.unbindTexture();
                }, this.copyTextureToTexture = function(e1, t, n) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
                    const r = t.image.width, a = t.image.height, s = fe.convert(n.format), o = fe.convert(n.type);
                    J.setTexture2D(n, 0), Ae.pixelStorei(Ae.UNPACK_FLIP_Y_WEBGL, n.flipY), Ae.pixelStorei(Ae.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), Ae.pixelStorei(Ae.UNPACK_ALIGNMENT, n.unpackAlignment), t.isDataTexture ? Ae.texSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, r, a, s, o, t.image.data) : t.isCompressedTexture ? Ae.compressedTexSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, t.mipmaps[0].width, t.mipmaps[0].height, s, t.mipmaps[0].data) : Ae.texSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, s, o, t.image), 0 === i && n.generateMipmaps && Ae.generateMipmap(Ae.TEXTURE_2D), Z.unbindTexture();
                }, this.copyTextureToTexture3D = function(e1, t, n, i) {
                    let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                    if (M.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                    const a = e1.max.x - e1.min.x + 1, s = e1.max.y - e1.min.y + 1, o = e1.max.z - e1.min.z + 1, l = fe.convert(i.format), c = fe.convert(i.type);
                    let u;
                    if (i.isData3DTexture) J.setTexture3D(i, 0), u = Ae.TEXTURE_3D;
                    else {
                        if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                        J.setTexture2DArray(i, 0), u = Ae.TEXTURE_2D_ARRAY;
                    }
                    Ae.pixelStorei(Ae.UNPACK_FLIP_Y_WEBGL, i.flipY), Ae.pixelStorei(Ae.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), Ae.pixelStorei(Ae.UNPACK_ALIGNMENT, i.unpackAlignment);
                    const h = Ae.getParameter(Ae.UNPACK_ROW_LENGTH), d = Ae.getParameter(Ae.UNPACK_IMAGE_HEIGHT), p = Ae.getParameter(Ae.UNPACK_SKIP_PIXELS), f = Ae.getParameter(Ae.UNPACK_SKIP_ROWS), g = Ae.getParameter(Ae.UNPACK_SKIP_IMAGES), m = n.isCompressedTexture ? n.mipmaps[0] : n.image;
                    Ae.pixelStorei(Ae.UNPACK_ROW_LENGTH, m.width), Ae.pixelStorei(Ae.UNPACK_IMAGE_HEIGHT, m.height), Ae.pixelStorei(Ae.UNPACK_SKIP_PIXELS, e1.min.x), Ae.pixelStorei(Ae.UNPACK_SKIP_ROWS, e1.min.y), Ae.pixelStorei(Ae.UNPACK_SKIP_IMAGES, e1.min.z), n.isDataTexture || n.isData3DTexture ? Ae.texSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, c, m.data) : n.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), Ae.compressedTexSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, m.data)) : Ae.texSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, c, m), Ae.pixelStorei(Ae.UNPACK_ROW_LENGTH, h), Ae.pixelStorei(Ae.UNPACK_IMAGE_HEIGHT, d), Ae.pixelStorei(Ae.UNPACK_SKIP_PIXELS, p), Ae.pixelStorei(Ae.UNPACK_SKIP_ROWS, f), Ae.pixelStorei(Ae.UNPACK_SKIP_IMAGES, g), 0 === r && i.generateMipmaps && Ae.generateMipmap(u), Z.unbindTexture();
                }, this.initTexture = function(e1) {
                    e1.isCubeTexture ? J.setTextureCube(e1, 0) : e1.isData3DTexture ? J.setTexture3D(e1, 0) : e1.isDataArrayTexture || e1.isCompressedArrayTexture ? J.setTexture2DArray(e1, 0) : J.setTexture2D(e1, 0), Z.unbindTexture();
                }, this.resetState = function() {
                    y = 0, x = 0, b = null, Z.reset(), ge.reset();
                }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            get coordinateSystem() {
                return Po;
            }
            get outputColorSpace() {
                return this._outputColorSpace;
            }
            set outputColorSpace(e1) {
                this._outputColorSpace = e1;
                const t = this.getContext();
                t.drawingBufferColorSpace = e1 === Ys ? "display-p3" : "srgb", t.unpackColorSpace = pl.workingColorSpace === Xs ? "display-p3" : "srgb";
            }
            get physicallyCorrectLights() {
                return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
            }
            set physicallyCorrectLights(e1) {
                console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !e1;
            }
            get outputEncoding() {
                return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === Qs ? ks : js;
            }
            set outputEncoding(e1) {
                console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = e1 === ks ? Qs : Ws;
            }
            get useLegacyLights() {
                return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
            }
            set useLegacyLights(e1) {
                console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = e1;
            }
        }
        class Wp extends Qp {
        }
        Wp.prototype.isWebGL1Renderer = !0;
        class Yp {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 25e-5;
                this.isFogExp2 = !0, this.name = "", this.color = new qc(e1), this.density = t;
            }
            clone() {
                return new Yp(this.color, this.density);
            }
            toJSON() {
                return {
                    type: "FogExp2",
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
        class Xp {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3;
                this.isFog = !0, this.name = "", this.color = new qc(e1), this.near = t, this.far = n;
            }
            clone() {
                return new Xp(this.color, this.near, this.far);
            }
            toJSON() {
                return {
                    type: "Fog",
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
        class Zp extends zc {
            constructor(){
                super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            copy(e1, t) {
                return super.copy(e1, t), null !== e1.background && (this.background = e1.background.clone()), null !== e1.environment && (this.environment = e1.environment.clone()), null !== e1.fog && (this.fog = e1.fog.clone()), this.backgroundBlurriness = e1.backgroundBlurriness, this.backgroundIntensity = e1.backgroundIntensity, null !== e1.overrideMaterial && (this.overrideMaterial = e1.overrideMaterial.clone()), this.matrixAutoUpdate = e1.matrixAutoUpdate, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return null !== this.fog && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (t.object.backgroundIntensity = this.backgroundIntensity), t;
            }
        }
        class qp {
            constructor(e1, t){
                this.isInterleavedBuffer = !0, this.array = e1, this.stride = t, this.count = void 0 !== e1 ? e1.length / t : 0, this.usage = Eo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.version = 0, this.uuid = Go();
            }
            onUploadCallback() {}
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            copy(e1) {
                return this.array = new e1.array.constructor(e1.array), this.count = e1.count, this.stride = e1.stride, this.usage = e1.usage, this;
            }
            copyAt(e1, t, n) {
                e1 *= this.stride, n *= t.stride;
                for(let i = 0, r = this.stride; i < r; i++)this.array[e1 + i] = t.array[n + i];
                return this;
            }
            set(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.array.set(e1, t), this;
            }
            clone(e1) {
                void 0 === e1.arrayBuffers && (e1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Go()), void 0 === e1.arrayBuffers[this.array.buffer._uuid] && (e1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
                const t = new this.array.constructor(e1.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
                return n.setUsage(this.usage), n;
            }
            onUpload(e1) {
                return this.onUploadCallback = e1, this;
            }
            toJSON(e1) {
                return void 0 === e1.arrayBuffers && (e1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Go()), void 0 === e1.arrayBuffers[this.array.buffer._uuid] && (e1.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
        const Kp = new Ll;
        class Jp {
            constructor(e1, t, n){
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e1, this.itemSize = t, this.offset = n, this.normalized = i;
            }
            get count() {
                return this.data.count;
            }
            get array() {
                return this.data.array;
            }
            set needsUpdate(e1) {
                this.data.needsUpdate = e1;
            }
            applyMatrix4(e1) {
                for(let t = 0, n = this.data.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.applyMatrix4(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            applyNormalMatrix(e1) {
                for(let t = 0, n = this.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.applyNormalMatrix(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            transformDirection(e1) {
                for(let t = 0, n = this.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.transformDirection(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            setX(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.data.array[e1 * this.data.stride + this.offset] = t, this;
            }
            setY(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 1] = t, this;
            }
            setZ(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 2] = t, this;
            }
            setW(e1, t) {
                return this.normalized && (t = Ko(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 3] = t, this;
            }
            getX(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            getY(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 1];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            getZ(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 2];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            getW(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 3];
                return this.normalized && (t = qo(t, this.array)), t;
            }
            setXY(e1, t, n) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this;
            }
            setXYZ(e1, t, n, i) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this.data.array[e1 + 2] = i, this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = Ko(t, this.array), n = Ko(n, this.array), i = Ko(i, this.array), r = Ko(r, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this.data.array[e1 + 2] = i, this.data.array[e1 + 3] = r, this;
            }
            clone(e1) {
                if (void 0 === e1) {
                    console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
                    const e1 = [];
                    for(let t = 0; t < this.count; t++){
                        const n = t * this.data.stride + this.offset;
                        for(let t = 0; t < this.itemSize; t++)e1.push(this.data.array[n + t]);
                    }
                    return new lu(new this.array.constructor(e1), this.itemSize, this.normalized);
                }
                return void 0 === e1.interleavedBuffers && (e1.interleavedBuffers = {}), void 0 === e1.interleavedBuffers[this.data.uuid] && (e1.interleavedBuffers[this.data.uuid] = this.data.clone(e1)), new Jp(e1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
            }
            toJSON(e1) {
                if (void 0 === e1) {
                    console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
                    const e1 = [];
                    for(let t = 0; t < this.count; t++){
                        const n = t * this.data.stride + this.offset;
                        for(let t = 0; t < this.itemSize; t++)e1.push(this.data.array[n + t]);
                    }
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: e1,
                        normalized: this.normalized
                    };
                }
                return void 0 === e1.interleavedBuffers && (e1.interleavedBuffers = {}), void 0 === e1.interleavedBuffers[this.data.uuid] && (e1.interleavedBuffers[this.data.uuid] = this.data.toJSON(e1)), {
                    isInterleavedBufferAttribute: !0,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                };
            }
        }
        class $p extends $c {
            constructor(e1){
                super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new qc(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.alphaMap = e1.alphaMap, this.rotation = e1.rotation, this.sizeAttenuation = e1.sizeAttenuation, this.fog = e1.fog, this;
            }
        }
        let ef;
        const tf = new Ll, nf = new Ll, rf = new Ll, af = new $o, sf = new $o, of = new lc, lf = new Ll, cf = new Ll, uf = new Ll, hf = new $o, df = new $o, pf = new $o;
        class ff extends zc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $p;
                if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === ef) {
                    ef = new Su;
                    const e1 = new Float32Array([
                        -0.5,
                        -0.5,
                        0,
                        0,
                        0,
                        .5,
                        -0.5,
                        0,
                        1,
                        0,
                        .5,
                        .5,
                        0,
                        1,
                        1,
                        -0.5,
                        .5,
                        0,
                        0,
                        1
                    ]), t = new qp(e1, 5);
                    ef.setIndex([
                        0,
                        1,
                        2,
                        0,
                        2,
                        3
                    ]), ef.setAttribute("position", new Jp(t, 3, 0, !1)), ef.setAttribute("uv", new Jp(t, 2, 3, !1));
                }
                this.geometry = ef, this.material = e1, this.center = new $o(.5, .5);
            }
            raycast(e1, t) {
                null === e1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), nf.setFromMatrixScale(this.matrixWorld), of.copy(e1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e1.camera.matrixWorldInverse, this.matrixWorld), rf.setFromMatrixPosition(this.modelViewMatrix), e1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && nf.multiplyScalar(-rf.z);
                const n = this.material.rotation;
                let i, r;
                0 !== n && (r = Math.cos(n), i = Math.sin(n));
                const a = this.center;
                gf(lf.set(-0.5, -0.5, 0), rf, a, nf, i, r), gf(cf.set(.5, -0.5, 0), rf, a, nf, i, r), gf(uf.set(.5, .5, 0), rf, a, nf, i, r), hf.set(0, 0), df.set(1, 0), pf.set(1, 1);
                let s = e1.ray.intersectTriangle(lf, cf, uf, !1, tf);
                if (null === s && (gf(cf.set(-0.5, .5, 0), rf, a, nf, i, r), df.set(0, 1), s = e1.ray.intersectTriangle(lf, uf, cf, !1, tf), null === s)) return;
                const o = e1.ray.origin.distanceTo(tf);
                o < e1.near || o > e1.far || t.push({
                    distance: o,
                    point: tf.clone(),
                    uv: Qc.getInterpolation(tf, lf, cf, uf, hf, df, pf, new $o),
                    face: null,
                    object: this
                });
            }
            copy(e1, t) {
                return super.copy(e1, t), void 0 !== e1.center && this.center.copy(e1.center), this.material = e1.material, this;
            }
        }
        function gf(e1, t, n, i, r, a) {
            af.subVectors(e1, n).addScalar(.5).multiply(i), void 0 !== r ? (sf.x = a * af.x - r * af.y, sf.y = r * af.x + a * af.y) : sf.copy(af), e1.copy(t), e1.x += sf.x, e1.y += sf.y, e1.applyMatrix4(of);
        }
        const mf = new Ll, Af = new Ll;
        class Mf extends zc {
            constructor(){
                super(), this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
                    levels: {
                        enumerable: !0,
                        value: []
                    },
                    isLOD: {
                        value: !0
                    }
                }), this.autoUpdate = !0;
            }
            copy(e1) {
                super.copy(e1, !1);
                const t = e1.levels;
                for(let e1 = 0, n = t.length; e1 < n; e1++){
                    const n = t[e1];
                    this.addLevel(n.object.clone(), n.distance, n.hysteresis);
                }
                return this.autoUpdate = e1.autoUpdate, this;
            }
            addLevel(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                t = Math.abs(t);
                const i = this.levels;
                let r;
                for(r = 0; r < i.length && !(t < i[r].distance); r++);
                return i.splice(r, 0, {
                    distance: t,
                    hysteresis: n,
                    object: e1
                }), this.add(e1), this;
            }
            getCurrentLevel() {
                return this._currentLevel;
            }
            getObjectForDistance(e1) {
                const t = this.levels;
                if (t.length > 0) {
                    let n, i;
                    for(n = 1, i = t.length; n < i; n++){
                        let i = t[n].distance;
                        if (t[n].object.visible && (i -= i * t[n].hysteresis), e1 < i) break;
                    }
                    return t[n - 1].object;
                }
                return null;
            }
            raycast(e1, t) {
                if (this.levels.length > 0) {
                    mf.setFromMatrixPosition(this.matrixWorld);
                    const n = e1.ray.origin.distanceTo(mf);
                    this.getObjectForDistance(n).raycast(e1, t);
                }
            }
            update(e1) {
                const t = this.levels;
                if (t.length > 1) {
                    mf.setFromMatrixPosition(e1.matrixWorld), Af.setFromMatrixPosition(this.matrixWorld);
                    const n = mf.distanceTo(Af) / e1.zoom;
                    let i, r;
                    for(t[0].object.visible = !0, i = 1, r = t.length; i < r; i++){
                        let e1 = t[i].distance;
                        if (t[i].object.visible && (e1 -= e1 * t[i].hysteresis), !(n >= e1)) break;
                        t[i - 1].object.visible = !1, t[i].object.visible = !0;
                    }
                    for(this._currentLevel = i - 1; i < r; i++)t[i].object.visible = !1;
                }
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                !1 === this.autoUpdate && (t.object.autoUpdate = !1), t.object.levels = [];
                const n = this.levels;
                for(let e1 = 0, i = n.length; e1 < i; e1++){
                    const i = n[e1];
                    t.object.levels.push({
                        object: i.object.uuid,
                        distance: i.distance,
                        hysteresis: i.hysteresis
                    });
                }
                return t;
            }
        }
        const vf = new Ll, yf = new wl, xf = new wl, bf = new Ll, wf = new lc, Ef = new Ll, Tf = new $l, Sf = new lc, If = new oc;
        class Nf extends Vu {
            constructor(e1, t){
                super(e1, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = ia, this.bindMatrix = new lc, this.bindMatrixInverse = new lc, this.boundingBox = null, this.boundingSphere = null;
            }
            computeBoundingBox() {
                const e1 = this.geometry;
                null === this.boundingBox && (this.boundingBox = new Rl), this.boundingBox.makeEmpty();
                const t = e1.getAttribute("position");
                for(let e1 = 0; e1 < t.count; e1++)this.getVertexPosition(e1, Ef), this.boundingBox.expandByPoint(Ef);
            }
            computeBoundingSphere() {
                const e1 = this.geometry;
                null === this.boundingSphere && (this.boundingSphere = new $l), this.boundingSphere.makeEmpty();
                const t = e1.getAttribute("position");
                for(let e1 = 0; e1 < t.count; e1++)this.getVertexPosition(e1, Ef), this.boundingSphere.expandByPoint(Ef);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.bindMode = e1.bindMode, this.bindMatrix.copy(e1.bindMatrix), this.bindMatrixInverse.copy(e1.bindMatrixInverse), this.skeleton = e1.skeleton, null !== e1.boundingBox && (this.boundingBox = e1.boundingBox.clone()), null !== e1.boundingSphere && (this.boundingSphere = e1.boundingSphere.clone()), this;
            }
            raycast(e1, t) {
                const n = this.material, i = this.matrixWorld;
                void 0 !== n && (null === this.boundingSphere && this.computeBoundingSphere(), Tf.copy(this.boundingSphere), Tf.applyMatrix4(i), !1 !== e1.ray.intersectsSphere(Tf) && (Sf.copy(i).invert(), If.copy(e1.ray).applyMatrix4(Sf), null !== this.boundingBox && !1 === If.intersectsBox(this.boundingBox) || this._computeIntersections(e1, t, If)));
            }
            getVertexPosition(e1, t) {
                return super.getVertexPosition(e1, t), this.applyBoneTransform(e1, t), t;
            }
            bind(e1, t) {
                this.skeleton = e1, void 0 === t && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
            }
            pose() {
                this.skeleton.pose();
            }
            normalizeSkinWeights() {
                const e1 = new wl, t = this.geometry.attributes.skinWeight;
                for(let n = 0, i = t.count; n < i; n++){
                    e1.fromBufferAttribute(t, n);
                    const i = 1 / e1.manhattanLength();
                    i !== 1 / 0 ? e1.multiplyScalar(i) : e1.set(1, 0, 0, 0), t.setXYZW(n, e1.x, e1.y, e1.z, e1.w);
                }
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.bindMode === ia ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === ra ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            }
            applyBoneTransform(e1, t) {
                const n = this.skeleton, i = this.geometry;
                yf.fromBufferAttribute(i.attributes.skinIndex, e1), xf.fromBufferAttribute(i.attributes.skinWeight, e1), vf.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
                for(let e1 = 0; e1 < 4; e1++){
                    const i = xf.getComponent(e1);
                    if (0 !== i) {
                        const r = yf.getComponent(e1);
                        wf.multiplyMatrices(n.bones[r].matrixWorld, n.boneInverses[r]), t.addScaledVector(bf.copy(vf).applyMatrix4(wf), i);
                    }
                }
                return t.applyMatrix4(this.bindMatrixInverse);
            }
            boneTransform(e1, t) {
                return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(e1, t);
            }
        }
        class Df extends zc {
            constructor(){
                super(), this.isBone = !0, this.type = "Bone";
            }
        }
        class _f extends bl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(null, arguments.length > 5 ? arguments[5] : void 0, arguments.length > 6 ? arguments[6] : void 0, arguments.length > 7 ? arguments[7] : void 0, arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : fa, arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : fa, arguments.length > 3 ? arguments[3] : void 0, arguments.length > 4 ? arguments[4] : void 0, arguments.length > 10 ? arguments[10] : void 0, arguments.length > 11 ? arguments[11] : void 0), this.isDataTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        const Cf = new lc, Lf = new lc;
        class zf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                this.uuid = Go(), this.bones = e1.slice(0), this.boneInverses = t, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
            }
            init() {
                const e1 = this.bones, t = this.boneInverses;
                if (this.boneMatrices = new Float32Array(16 * e1.length), 0 === t.length) this.calculateInverses();
                else if (e1.length !== t.length) {
                    console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
                    for(let e1 = 0, t = this.bones.length; e1 < t; e1++)this.boneInverses.push(new lc);
                }
            }
            calculateInverses() {
                this.boneInverses.length = 0;
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = new lc;
                    this.bones[e1] && t.copy(this.bones[e1].matrixWorld).invert(), this.boneInverses.push(t);
                }
            }
            pose() {
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = this.bones[e1];
                    t && t.matrixWorld.copy(this.boneInverses[e1]).invert();
                }
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = this.bones[e1];
                    t && (t.parent && t.parent.isBone ? (t.matrix.copy(t.parent.matrixWorld).invert(), t.matrix.multiply(t.matrixWorld)) : t.matrix.copy(t.matrixWorld), t.matrix.decompose(t.position, t.quaternion, t.scale));
                }
            }
            update() {
                const e1 = this.bones, t = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
                for(let i = 0, r = e1.length; i < r; i++){
                    const r = e1[i] ? e1[i].matrixWorld : Lf;
                    Cf.multiplyMatrices(r, t[i]), Cf.toArray(n, 16 * i);
                }
                null !== i && (i.needsUpdate = !0);
            }
            clone() {
                return new zf(this.bones, this.boneInverses);
            }
            computeBoneTexture() {
                let e1 = Math.sqrt(4 * this.bones.length);
                e1 = Xo(e1), e1 = Math.max(e1, 4);
                const t = new Float32Array(e1 * e1 * 4);
                t.set(this.boneMatrices);
                const n = new _f(t, e1, e1, Pa, _a);
                return n.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = n, this.boneTextureSize = e1, this;
            }
            getBoneByName(e1) {
                for(let t = 0, n = this.bones.length; t < n; t++){
                    const n = this.bones[t];
                    if (n.name === e1) return n;
                }
            }
            dispose() {
                null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
            }
            fromJSON(e1, t) {
                this.uuid = e1.uuid;
                for(let n = 0, i = e1.bones.length; n < i; n++){
                    const i = e1.bones[n];
                    let r = t[i];
                    void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", i), r = new Df), this.bones.push(r), this.boneInverses.push((new lc).fromArray(e1.boneInverses[n]));
                }
                return this.init(), this;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "Skeleton",
                        generator: "Skeleton.toJSON"
                    },
                    bones: [],
                    boneInverses: []
                };
                e1.uuid = this.uuid;
                const t = this.bones, n = this.boneInverses;
                for(let i = 0, r = t.length; i < r; i++){
                    const r = t[i];
                    e1.bones.push(r.uuid);
                    const a = n[i];
                    e1.boneInverses.push(a.toArray());
                }
                return e1;
            }
        }
        class Of extends lu {
            constructor(e1, t, n){
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(e1, t, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
            }
            copy(e1) {
                return super.copy(e1), this.meshPerAttribute = e1.meshPerAttribute, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.meshPerAttribute = this.meshPerAttribute, e1.isInstancedBufferAttribute = !0, e1;
            }
        }
        const Rf = new lc, Pf = new lc, Uf = [], jf = new Rl, kf = new lc, Bf = new Vu, Ff = new $l;
        class Hf extends Vu {
            constructor(e1, t, n){
                super(e1, t), this.isInstancedMesh = !0, this.instanceMatrix = new Of(new Float32Array(16 * n), 16), this.instanceColor = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
                for(let e1 = 0; e1 < n; e1++)this.setMatrixAt(e1, kf);
            }
            computeBoundingBox() {
                const e1 = this.geometry, t = this.count;
                null === this.boundingBox && (this.boundingBox = new Rl), null === e1.boundingBox && e1.computeBoundingBox(), this.boundingBox.makeEmpty();
                for(let n = 0; n < t; n++)this.getMatrixAt(n, Rf), jf.copy(e1.boundingBox).applyMatrix4(Rf), this.boundingBox.union(jf);
            }
            computeBoundingSphere() {
                const e1 = this.geometry, t = this.count;
                null === this.boundingSphere && (this.boundingSphere = new $l), null === e1.boundingSphere && e1.computeBoundingSphere(), this.boundingSphere.makeEmpty();
                for(let n = 0; n < t; n++)this.getMatrixAt(n, Rf), Ff.copy(e1.boundingSphere).applyMatrix4(Rf), this.boundingSphere.union(Ff);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.instanceMatrix.copy(e1.instanceMatrix), null !== e1.instanceColor && (this.instanceColor = e1.instanceColor.clone()), this.count = e1.count, null !== e1.boundingBox && (this.boundingBox = e1.boundingBox.clone()), null !== e1.boundingSphere && (this.boundingSphere = e1.boundingSphere.clone()), this;
            }
            getColorAt(e1, t) {
                t.fromArray(this.instanceColor.array, 3 * e1);
            }
            getMatrixAt(e1, t) {
                t.fromArray(this.instanceMatrix.array, 16 * e1);
            }
            raycast(e1, t) {
                const n = this.matrixWorld, i = this.count;
                if (Bf.geometry = this.geometry, Bf.material = this.material, void 0 !== Bf.material && (null === this.boundingSphere && this.computeBoundingSphere(), Ff.copy(this.boundingSphere), Ff.applyMatrix4(n), !1 !== e1.ray.intersectsSphere(Ff))) for(let r = 0; r < i; r++){
                    this.getMatrixAt(r, Rf), Pf.multiplyMatrices(n, Rf), Bf.matrixWorld = Pf, Bf.raycast(e1, Uf);
                    for(let e1 = 0, n = Uf.length; e1 < n; e1++){
                        const n = Uf[e1];
                        n.instanceId = r, n.object = this, t.push(n);
                    }
                    Uf.length = 0;
                }
            }
            setColorAt(e1, t) {
                null === this.instanceColor && (this.instanceColor = new Of(new Float32Array(3 * this.instanceMatrix.count), 3)), t.toArray(this.instanceColor.array, 3 * e1);
            }
            setMatrixAt(e1, t) {
                t.toArray(this.instanceMatrix.array, 16 * e1);
            }
            updateMorphTargets() {}
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Gf extends $c {
            constructor(e1){
                super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new qc(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.linewidth = e1.linewidth, this.linecap = e1.linecap, this.linejoin = e1.linejoin, this.fog = e1.fog, this;
            }
        }
        const Vf = new Ll, Qf = new Ll, Wf = new lc, Yf = new oc, Xf = new $l;
        class Zf extends zc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Su, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Gf;
                super(), this.isLine = !0, this.type = "Line", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            computeLineDistances() {
                const e1 = this.geometry;
                if (null === e1.index) {
                    const t = e1.attributes.position, n = [
                        0
                    ];
                    for(let e1 = 1, i = t.count; e1 < i; e1++)Vf.fromBufferAttribute(t, e1 - 1), Qf.fromBufferAttribute(t, e1), n[e1] = n[e1 - 1], n[e1] += Vf.distanceTo(Qf);
                    e1.setAttribute("lineDistance", new Au(n, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.matrixWorld, r = e1.params.Line.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), Xf.copy(n.boundingSphere), Xf.applyMatrix4(i), Xf.radius += r, !1 === e1.ray.intersectsSphere(Xf)) return;
                Wf.copy(i).invert(), Yf.copy(e1.ray).applyMatrix4(Wf);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = new Ll, c = new Ll, u = new Ll, h = new Ll, d = this.isLineSegments ? 2 : 1, p = n.index, f = n.attributes.position;
                if (null !== p) for(let n = Math.max(0, a.start), i = Math.min(p.count, a.start + a.count) - 1; n < i; n += d){
                    const i = p.getX(n), r = p.getX(n + 1);
                    if (l.fromBufferAttribute(f, i), c.fromBufferAttribute(f, r), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const a = e1.ray.origin.distanceTo(h);
                    a < e1.near || a > e1.far || t.push({
                        distance: a,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
                else for(let n = Math.max(0, a.start), i = Math.min(f.count, a.start + a.count) - 1; n < i; n += d){
                    if (l.fromBufferAttribute(f, n), c.fromBufferAttribute(f, n + 1), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const i = e1.ray.origin.distanceTo(h);
                    i < e1.near || i > e1.far || t.push({
                        distance: i,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
        }
        const qf = new Ll, Kf = new Ll;
        class Jf extends Zf {
            constructor(e1, t){
                super(e1, t), this.isLineSegments = !0, this.type = "LineSegments";
            }
            computeLineDistances() {
                const e1 = this.geometry;
                if (null === e1.index) {
                    const t = e1.attributes.position, n = [];
                    for(let e1 = 0, i = t.count; e1 < i; e1 += 2)qf.fromBufferAttribute(t, e1), Kf.fromBufferAttribute(t, e1 + 1), n[e1] = 0 === e1 ? 0 : n[e1 - 1], n[e1 + 1] = n[e1] + qf.distanceTo(Kf);
                    e1.setAttribute("lineDistance", new Au(n, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
        }
        class $f extends Zf {
            constructor(e1, t){
                super(e1, t), this.isLineLoop = !0, this.type = "LineLoop";
            }
        }
        class eg extends $c {
            constructor(e1){
                super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new qc(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.alphaMap = e1.alphaMap, this.size = e1.size, this.sizeAttenuation = e1.sizeAttenuation, this.fog = e1.fog, this;
            }
        }
        const tg = new lc, ng = new oc, ig = new $l, rg = new Ll;
        class ag extends zc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Su, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new eg;
                super(), this.isPoints = !0, this.type = "Points", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.matrixWorld, r = e1.params.Points.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), ig.copy(n.boundingSphere), ig.applyMatrix4(i), ig.radius += r, !1 === e1.ray.intersectsSphere(ig)) return;
                tg.copy(i).invert(), ng.copy(e1.ray).applyMatrix4(tg);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = n.index, c = n.attributes.position;
                if (null !== l) for(let n = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count); n < r; n++){
                    const r = l.getX(n);
                    rg.fromBufferAttribute(c, r), sg(rg, r, o, i, e1, t, this);
                }
                else for(let n = Math.max(0, a.start), r = Math.min(c.count, a.start + a.count); n < r; n++)rg.fromBufferAttribute(c, n), sg(rg, n, o, i, e1, t, this);
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
        }
        function sg(e1, t, n, i, r, a, s) {
            const o = ng.distanceSqToPoint(e1);
            if (o < n) {
                const n = new Ll;
                ng.closestPointToPoint(e1, n), n.applyMatrix4(i);
                const l = r.ray.origin.distanceTo(n);
                if (l < r.near || l > r.far) return;
                a.push({
                    distance: l,
                    distanceToRay: Math.sqrt(o),
                    point: n,
                    index: t,
                    face: null,
                    object: s
                });
            }
        }
        class og extends bl {
            constructor(e1, t, n, i, r, a, s, o, l){
                super(e1, t, n, i, r, a, s, o, l), this.isVideoTexture = !0, this.minFilter = void 0 !== a ? a : va, this.magFilter = void 0 !== r ? r : va, this.generateMipmaps = !1;
                const c = this;
                "requestVideoFrameCallback" in e1 && e1.requestVideoFrameCallback(function t() {
                    c.needsUpdate = !0, e1.requestVideoFrameCallback(t);
                });
            }
            clone() {
                return new this.constructor(this.image).copy(this);
            }
            update() {
                const e1 = this.image;
                !1 == "requestVideoFrameCallback" in e1 && e1.readyState >= e1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
        }
        class lg extends bl {
            constructor(e1, t){
                super({
                    width: e1,
                    height: t
                }), this.isFramebufferTexture = !0, this.magFilter = fa, this.minFilter = fa, this.generateMipmaps = !1, this.needsUpdate = !0;
            }
        }
        class cg extends bl {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h){
                super(null, a, s, o, l, c, i, r, u, h), this.isCompressedTexture = !0, this.image = {
                    width: t,
                    height: n
                }, this.mipmaps = e1, this.flipY = !1, this.generateMipmaps = !1;
            }
        }
        class ug extends cg {
            constructor(e1, t, n, i, r, a){
                super(e1, t, n, r, a), this.isCompressedArrayTexture = !0, this.image.depth = i, this.wrapR = da;
            }
        }
        class hg extends cg {
            constructor(e1, t, n){
                super(void 0, e1[0].width, e1[0].height, t, n, sa), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = e1;
            }
        }
        class dg extends bl {
            constructor(e1, t, n, i, r, a, s, o, l){
                super(e1, t, n, i, r, a, s, o, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
            }
        }
        class pg {
            constructor(){
                this.type = "Curve", this.arcLengthDivisions = 200;
            }
            getPoint() {
                return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            }
            getPointAt(e1, t) {
                const n = this.getUtoTmapping(e1);
                return this.getPoint(n, t);
            }
            getPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPoint(n / e1));
                return t;
            }
            getSpacedPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPointAt(n / e1));
                return t;
            }
            getLength() {
                const e1 = this.getLengths();
                return e1[e1.length - 1];
            }
            getLengths() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === e1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = !1;
                const t = [];
                let n, i = this.getPoint(0), r = 0;
                t.push(0);
                for(let a = 1; a <= e1; a++)n = this.getPoint(a / e1), r += n.distanceTo(i), t.push(r), i = n;
                return this.cacheArcLengths = t, t;
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.getLengths();
            }
            getUtoTmapping(e1, t) {
                const n = this.getLengths();
                let i = 0;
                const r = n.length;
                let a;
                a = t || e1 * n[r - 1];
                let s, o = 0, l = r - 1;
                for(; o <= l;)if (i = Math.floor(o + (l - o) / 2), s = n[i] - a, s < 0) o = i + 1;
                else {
                    if (!(s > 0)) {
                        l = i;
                        break;
                    }
                    l = i - 1;
                }
                if (i = l, n[i] === a) return i / (r - 1);
                const c = n[i];
                return (i + (a - c) / (n[i + 1] - c)) / (r - 1);
            }
            getTangent(e1, t) {
                const n = 1e-4;
                let i = e1 - n, r = e1 + n;
                i < 0 && (i = 0), r > 1 && (r = 1);
                const a = this.getPoint(i), s = this.getPoint(r), o = t || (a.isVector2 ? new $o : new Ll);
                return o.copy(s).sub(a).normalize(), o;
            }
            getTangentAt(e1, t) {
                const n = this.getUtoTmapping(e1);
                return this.getTangent(n, t);
            }
            computeFrenetFrames(e1, t) {
                const n = new Ll, i = [], r = [], a = [], s = new Ll, o = new lc;
                for(let t = 0; t <= e1; t++){
                    const n = t / e1;
                    i[t] = this.getTangentAt(n, new Ll);
                }
                r[0] = new Ll, a[0] = new Ll;
                let l = Number.MAX_VALUE;
                const c = Math.abs(i[0].x), u = Math.abs(i[0].y), h = Math.abs(i[0].z);
                c <= l && (l = c, n.set(1, 0, 0)), u <= l && (l = u, n.set(0, 1, 0)), h <= l && n.set(0, 0, 1), s.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], s), a[0].crossVectors(i[0], r[0]);
                for(let t = 1; t <= e1; t++){
                    if (r[t] = r[t - 1].clone(), a[t] = a[t - 1].clone(), s.crossVectors(i[t - 1], i[t]), s.length() > Number.EPSILON) {
                        s.normalize();
                        const e1 = Math.acos(Vo(i[t - 1].dot(i[t]), -1, 1));
                        r[t].applyMatrix4(o.makeRotationAxis(s, e1));
                    }
                    a[t].crossVectors(i[t], r[t]);
                }
                if (!0 === t) {
                    let t = Math.acos(Vo(r[0].dot(r[e1]), -1, 1));
                    t /= e1, i[0].dot(s.crossVectors(r[0], r[e1])) > 0 && (t = -t);
                    for(let n = 1; n <= e1; n++)r[n].applyMatrix4(o.makeRotationAxis(i[n], t * n)), a[n].crossVectors(i[n], r[n]);
                }
                return {
                    tangents: i,
                    normals: r,
                    binormals: a
                };
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.arcLengthDivisions = e1.arcLengthDivisions, this;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "Curve",
                        generator: "Curve.toJSON"
                    }
                };
                return e1.arcLengthDivisions = this.arcLengthDivisions, e1.type = this.type, e1;
            }
            fromJSON(e1) {
                return this.arcLengthDivisions = e1.arcLengthDivisions, this;
            }
        }
        class fg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2 * Math.PI, s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6], o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0;
                super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e1, this.aY = t, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = a, this.aClockwise = s, this.aRotation = o;
            }
            getPoint(e1, t) {
                const n = t || new $o, i = 2 * Math.PI;
                let r = this.aEndAngle - this.aStartAngle;
                const a = Math.abs(r) < Number.EPSILON;
                for(; r < 0;)r += i;
                for(; r > i;)r -= i;
                r < Number.EPSILON && (r = a ? 0 : i), !0 !== this.aClockwise || a || (r === i ? r = -i : r -= i);
                const s = this.aStartAngle + e1 * r;
                let o = this.aX + this.xRadius * Math.cos(s), l = this.aY + this.yRadius * Math.sin(s);
                if (0 !== this.aRotation) {
                    const e1 = Math.cos(this.aRotation), t = Math.sin(this.aRotation), n = o - this.aX, i = l - this.aY;
                    o = n * e1 - i * t + this.aX, l = n * t + i * e1 + this.aY;
                }
                return n.set(o, l);
            }
            copy(e1) {
                return super.copy(e1), this.aX = e1.aX, this.aY = e1.aY, this.xRadius = e1.xRadius, this.yRadius = e1.yRadius, this.aStartAngle = e1.aStartAngle, this.aEndAngle = e1.aEndAngle, this.aClockwise = e1.aClockwise, this.aRotation = e1.aRotation, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.aX = this.aX, e1.aY = this.aY, e1.xRadius = this.xRadius, e1.yRadius = this.yRadius, e1.aStartAngle = this.aStartAngle, e1.aEndAngle = this.aEndAngle, e1.aClockwise = this.aClockwise, e1.aRotation = this.aRotation, e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.aX = e1.aX, this.aY = e1.aY, this.xRadius = e1.xRadius, this.yRadius = e1.yRadius, this.aStartAngle = e1.aStartAngle, this.aEndAngle = e1.aEndAngle, this.aClockwise = e1.aClockwise, this.aRotation = e1.aRotation, this;
            }
        }
        class gg extends fg {
            constructor(e1, t, n, i, r, a){
                super(e1, t, n, n, i, r, a), this.isArcCurve = !0, this.type = "ArcCurve";
            }
        }
        function mg() {
            let e1 = 0, t = 0, n = 0, i = 0;
            function r(r, a, s, o) {
                e1 = r, t = s, n = -3 * r + 3 * a - 2 * s - o, i = 2 * r - 2 * a + s + o;
            }
            return {
                initCatmullRom: function(e1, t, n, i, a) {
                    r(t, n, a * (n - e1), a * (i - t));
                },
                initNonuniformCatmullRom: function(e1, t, n, i, a, s, o) {
                    let l = (t - e1) / a - (n - e1) / (a + s) + (n - t) / s, c = (n - t) / s - (i - t) / (s + o) + (i - n) / o;
                    l *= s, c *= s, r(t, n, l, c);
                },
                calc: function(r) {
                    const a = r * r;
                    return e1 + t * r + n * a + i * (a * r);
                }
            };
        }
        const Ag = new Ll, Mg = new mg, vg = new mg, yg = new mg;
        class xg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "centripetal", i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = e1, this.closed = t, this.curveType = n, this.tension = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = this.points, i = n.length, r = (i - (this.closed ? 0 : 1)) * e1;
                let a, s, o = Math.floor(r), l = r - o;
                this.closed ? o += o > 0 ? 0 : (Math.floor(Math.abs(o) / i) + 1) * i : 0 === l && o === i - 1 && (o = i - 2, l = 1), this.closed || o > 0 ? a = n[(o - 1) % i] : (Ag.subVectors(n[0], n[1]).add(n[0]), a = Ag);
                const c = n[o % i], u = n[(o + 1) % i];
                if (this.closed || o + 2 < i ? s = n[(o + 2) % i] : (Ag.subVectors(n[i - 1], n[i - 2]).add(n[i - 1]), s = Ag), "centripetal" === this.curveType || "chordal" === this.curveType) {
                    const e1 = "chordal" === this.curveType ? .5 : .25;
                    let t = Math.pow(a.distanceToSquared(c), e1), n = Math.pow(c.distanceToSquared(u), e1), i = Math.pow(u.distanceToSquared(s), e1);
                    n < 1e-4 && (n = 1), t < 1e-4 && (t = n), i < 1e-4 && (i = n), Mg.initNonuniformCatmullRom(a.x, c.x, u.x, s.x, t, n, i), vg.initNonuniformCatmullRom(a.y, c.y, u.y, s.y, t, n, i), yg.initNonuniformCatmullRom(a.z, c.z, u.z, s.z, t, n, i);
                } else "catmullrom" === this.curveType && (Mg.initCatmullRom(a.x, c.x, u.x, s.x, this.tension), vg.initCatmullRom(a.y, c.y, u.y, s.y, this.tension), yg.initCatmullRom(a.z, c.z, u.z, s.z, this.tension));
                return t.set(Mg.calc(l), vg.calc(l), yg.calc(l)), t;
            }
            copy(e1) {
                super.copy(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push(n.clone());
                }
                return this.closed = e1.closed, this.curveType = e1.curveType, this.tension = e1.tension, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.points = [];
                for(let t = 0, n = this.points.length; t < n; t++){
                    const n = this.points[t];
                    e1.points.push(n.toArray());
                }
                return e1.closed = this.closed, e1.curveType = this.curveType, e1.tension = this.tension, e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push((new Ll).fromArray(n));
                }
                return this.closed = e1.closed, this.curveType = e1.curveType, this.tension = e1.tension, this;
            }
        }
        function bg(e1, t, n, i, r) {
            const a = .5 * (i - t), s = .5 * (r - n), o = e1 * e1;
            return (2 * n - 2 * i + a + s) * (e1 * o) + (-3 * n + 3 * i - 2 * a - s) * o + a * e1 + n;
        }
        function wg(e1, t, n, i) {
            return function(e1, t) {
                const n = 1 - e1;
                return n * n * t;
            }(e1, t) + function(e1, t) {
                return 2 * (1 - e1) * e1 * t;
            }(e1, n) + function(e1, t) {
                return e1 * e1 * t;
            }(e1, i);
        }
        function Eg(e1, t, n, i, r) {
            return function(e1, t) {
                const n = 1 - e1;
                return n * n * n * t;
            }(e1, t) + function(e1, t) {
                const n = 1 - e1;
                return 3 * n * n * e1 * t;
            }(e1, n) + function(e1, t) {
                return 3 * (1 - e1) * e1 * e1 * t;
            }(e1, i) + function(e1, t) {
                return e1 * e1 * e1 * t;
            }(e1, r);
        }
        class Tg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $o, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new $o, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new $o;
                super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = e1, this.v1 = t, this.v2 = n, this.v3 = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o, n = this.v0, i = this.v1, r = this.v2, a = this.v3;
                return t.set(Eg(e1, n.x, i.x, r.x, a.x), Eg(e1, n.y, i.y, r.y, a.y)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this.v3.copy(e1.v3), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1.v3 = this.v3.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this.v3.fromArray(e1.v3), this;
            }
        }
        class Sg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Ll, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new Ll;
                super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = e1, this.v1 = t, this.v2 = n, this.v3 = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = this.v0, i = this.v1, r = this.v2, a = this.v3;
                return t.set(Eg(e1, n.x, i.x, r.x, a.x), Eg(e1, n.y, i.y, r.y, a.y), Eg(e1, n.z, i.z, r.z, a.z)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this.v3.copy(e1.v3), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1.v3 = this.v3.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this.v3.fromArray(e1.v3), this;
            }
        }
        class Ig extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $o, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o;
                super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = e1, this.v2 = t;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o;
                return 1 === e1 ? t.copy(this.v2) : (t.copy(this.v2).sub(this.v1), t.multiplyScalar(e1).add(this.v1)), t;
            }
            getPointAt(e1, t) {
                return this.getPoint(e1, t);
            }
            getTangent(e1) {
                return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o).subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(e1, t) {
                return this.getTangent(e1, t);
            }
            copy(e1) {
                return super.copy(e1), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Ng extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll;
                super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = e1, this.v2 = t;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll;
                return 1 === e1 ? t.copy(this.v2) : (t.copy(this.v2).sub(this.v1), t.multiplyScalar(e1).add(this.v1)), t;
            }
            getPointAt(e1, t) {
                return this.getPoint(e1, t);
            }
            getTangent(e1) {
                return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll).subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(e1, t) {
                return this.getTangent(e1, t);
            }
            copy(e1) {
                return super.copy(e1), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Dg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $o, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new $o;
                super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = e1, this.v1 = t, this.v2 = n;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o, n = this.v0, i = this.v1, r = this.v2;
                return t.set(wg(e1, n.x, i.x, r.x), wg(e1, n.y, i.y, r.y)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class _g extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Ll;
                super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = e1, this.v1 = t, this.v2 = n;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll, n = this.v0, i = this.v1, r = this.v2;
                return t.set(wg(e1, n.x, i.x, r.x), wg(e1, n.y, i.y, r.y), wg(e1, n.z, i.z, r.z)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Cg extends pg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = e1;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o, n = this.points, i = (n.length - 1) * e1, r = Math.floor(i), a = i - r, s = n[0 === r ? r : r - 1], o = n[r], l = n[r > n.length - 2 ? n.length - 1 : r + 1], c = n[r > n.length - 3 ? n.length - 1 : r + 2];
                return t.set(bg(a, s.x, o.x, l.x, c.x), bg(a, s.y, o.y, l.y, c.y)), t;
            }
            copy(e1) {
                super.copy(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.points = [];
                for(let t = 0, n = this.points.length; t < n; t++){
                    const n = this.points[t];
                    e1.points.push(n.toArray());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push((new $o).fromArray(n));
                }
                return this;
            }
        }
        var Lg = Object.freeze({
            __proto__: null,
            ArcCurve: gg,
            CatmullRomCurve3: xg,
            CubicBezierCurve: Tg,
            CubicBezierCurve3: Sg,
            EllipseCurve: fg,
            LineCurve: Ig,
            LineCurve3: Ng,
            QuadraticBezierCurve: Dg,
            QuadraticBezierCurve3: _g,
            SplineCurve: Cg
        });
        class zg extends pg {
            constructor(){
                super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
            }
            add(e1) {
                this.curves.push(e1);
            }
            closePath() {
                const e1 = this.curves[0].getPoint(0), t = this.curves[this.curves.length - 1].getPoint(1);
                if (!e1.equals(t)) {
                    const n = !0 === e1.isVector2 ? "LineCurve" : "LineCurve3";
                    this.curves.push(new Lg[n](t, e1));
                }
                return this;
            }
            getPoint(e1, t) {
                const n = e1 * this.getLength(), i = this.getCurveLengths();
                let r = 0;
                for(; r < i.length;){
                    if (i[r] >= n) {
                        const e1 = i[r] - n, a = this.curves[r], s = a.getLength(), o = 0 === s ? 0 : 1 - e1 / s;
                        return a.getPointAt(o, t);
                    }
                    r++;
                }
                return null;
            }
            getLength() {
                const e1 = this.getCurveLengths();
                return e1[e1.length - 1];
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            }
            getCurveLengths() {
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                const e1 = [];
                let t = 0;
                for(let n = 0, i = this.curves.length; n < i; n++)t += this.curves[n].getLength(), e1.push(t);
                return this.cacheLengths = e1, e1;
            }
            getSpacedPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 40;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPoint(n / e1));
                return this.autoClose && t.push(t[0]), t;
            }
            getPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 12;
                const t = [];
                let n;
                for(let i = 0, r = this.curves; i < r.length; i++){
                    const a = r[i], s = a.isEllipseCurve ? 2 * e1 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? e1 * a.points.length : e1, o = a.getPoints(s);
                    for(let e1 = 0; e1 < o.length; e1++){
                        const i = o[e1];
                        n && n.equals(i) || (t.push(i), n = i);
                    }
                }
                return this.autoClose && t.length > 1 && !t[t.length - 1].equals(t[0]) && t.push(t[0]), t;
            }
            copy(e1) {
                super.copy(e1), this.curves = [];
                for(let t = 0, n = e1.curves.length; t < n; t++){
                    const n = e1.curves[t];
                    this.curves.push(n.clone());
                }
                return this.autoClose = e1.autoClose, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.autoClose = this.autoClose, e1.curves = [];
                for(let t = 0, n = this.curves.length; t < n; t++){
                    const n = this.curves[t];
                    e1.curves.push(n.toJSON());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.autoClose = e1.autoClose, this.curves = [];
                for(let t = 0, n = e1.curves.length; t < n; t++){
                    const n = e1.curves[t];
                    this.curves.push((new Lg[n.type]).fromJSON(n));
                }
                return this;
            }
        }
        class Og extends zg {
            constructor(e1){
                super(), this.type = "Path", this.currentPoint = new $o, e1 && this.setFromPoints(e1);
            }
            setFromPoints(e1) {
                this.moveTo(e1[0].x, e1[0].y);
                for(let t = 1, n = e1.length; t < n; t++)this.lineTo(e1[t].x, e1[t].y);
                return this;
            }
            moveTo(e1, t) {
                return this.currentPoint.set(e1, t), this;
            }
            lineTo(e1, t) {
                const n = new Ig(this.currentPoint.clone(), new $o(e1, t));
                return this.curves.push(n), this.currentPoint.set(e1, t), this;
            }
            quadraticCurveTo(e1, t, n, i) {
                const r = new Dg(this.currentPoint.clone(), new $o(e1, t), new $o(n, i));
                return this.curves.push(r), this.currentPoint.set(n, i), this;
            }
            bezierCurveTo(e1, t, n, i, r, a) {
                const s = new Tg(this.currentPoint.clone(), new $o(e1, t), new $o(n, i), new $o(r, a));
                return this.curves.push(s), this.currentPoint.set(r, a), this;
            }
            splineThru(e1) {
                const t = [
                    this.currentPoint.clone()
                ].concat(e1), n = new Cg(t);
                return this.curves.push(n), this.currentPoint.copy(e1[e1.length - 1]), this;
            }
            arc(e1, t, n, i, r, a) {
                const s = this.currentPoint.x, o = this.currentPoint.y;
                return this.absarc(e1 + s, t + o, n, i, r, a), this;
            }
            absarc(e1, t, n, i, r, a) {
                return this.absellipse(e1, t, n, n, i, r, a), this;
            }
            ellipse(e1, t, n, i, r, a, s, o) {
                const l = this.currentPoint.x, c = this.currentPoint.y;
                return this.absellipse(e1 + l, t + c, n, i, r, a, s, o), this;
            }
            absellipse(e1, t, n, i, r, a, s, o) {
                const l = new fg(e1, t, n, i, r, a, s, o);
                if (this.curves.length > 0) {
                    const e1 = l.getPoint(0);
                    e1.equals(this.currentPoint) || this.lineTo(e1.x, e1.y);
                }
                this.curves.push(l);
                const c = l.getPoint(1);
                return this.currentPoint.copy(c), this;
            }
            copy(e1) {
                return super.copy(e1), this.currentPoint.copy(e1.currentPoint), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.currentPoint = this.currentPoint.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.currentPoint.fromArray(e1.currentPoint), this;
            }
        }
        class Rg extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [
                    new $o(0, -0.5),
                    new $o(.5, 0),
                    new $o(0, .5)
                ], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 12, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2 * Math.PI;
                super(), this.type = "LatheGeometry", this.parameters = {
                    points: e1,
                    segments: t,
                    phiStart: n,
                    phiLength: i
                }, t = Math.floor(t), i = Vo(i, 0, 2 * Math.PI);
                const r = [], a = [], s = [], o = [], l = [], c = 1 / t, u = new Ll, h = new $o, d = new Ll, p = new Ll, f = new Ll;
                let g = 0, m = 0;
                for(let t = 0; t <= e1.length - 1; t++)switch(t){
                    case 0:
                        g = e1[t + 1].x - e1[t].x, m = e1[t + 1].y - e1[t].y, d.x = 1 * m, d.y = -g, d.z = 0 * m, f.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                        break;
                    case e1.length - 1:
                        o.push(f.x, f.y, f.z);
                        break;
                    default:
                        g = e1[t + 1].x - e1[t].x, m = e1[t + 1].y - e1[t].y, d.x = 1 * m, d.y = -g, d.z = 0 * m, p.copy(d), d.x += f.x, d.y += f.y, d.z += f.z, d.normalize(), o.push(d.x, d.y, d.z), f.copy(p);
                }
                for(let r = 0; r <= t; r++){
                    const d = n + r * c * i, p = Math.sin(d), f = Math.cos(d);
                    for(let n = 0; n <= e1.length - 1; n++){
                        u.x = e1[n].x * p, u.y = e1[n].y, u.z = e1[n].x * f, a.push(u.x, u.y, u.z), h.x = r / t, h.y = n / (e1.length - 1), s.push(h.x, h.y);
                        const i = o[3 * n + 0] * p, c = o[3 * n + 1], d = o[3 * n + 0] * f;
                        l.push(i, c, d);
                    }
                }
                for(let n = 0; n < t; n++)for(let t = 0; t < e1.length - 1; t++){
                    const i = t + n * e1.length, a = i, s = i + e1.length, o = i + e1.length + 1, l = i + 1;
                    r.push(a, s, l), r.push(o, l, s);
                }
                this.setIndex(r), this.setAttribute("position", new Au(a, 3)), this.setAttribute("uv", new Au(s, 2)), this.setAttribute("normal", new Au(l, 3));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Rg(e1.points, e1.segments, e1.phiStart, e1.phiLength);
            }
        }
        class Pg extends Rg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8;
                const r = new Og;
                r.absarc(0, -t / 2, e1, 1.5 * Math.PI, 0), r.absarc(0, t / 2, e1, 0, .5 * Math.PI), super(r.getPoints(n), i), this.type = "CapsuleGeometry", this.parameters = {
                    radius: e1,
                    length: t,
                    capSegments: n,
                    radialSegments: i
                };
            }
            static fromJSON(e1) {
                return new Pg(e1.radius, e1.length, e1.capSegments, e1.radialSegments);
            }
        }
        class Ug extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2 * Math.PI;
                super(), this.type = "CircleGeometry", this.parameters = {
                    radius: e1,
                    segments: t,
                    thetaStart: n,
                    thetaLength: i
                }, t = Math.max(3, t);
                const r = [], a = [], s = [], o = [], l = new Ll, c = new $o;
                a.push(0, 0, 0), s.push(0, 0, 1), o.push(.5, .5);
                for(let r = 0, u = 3; r <= t; r++, u += 3){
                    const h = n + r / t * i;
                    l.x = e1 * Math.cos(h), l.y = e1 * Math.sin(h), a.push(l.x, l.y, l.z), s.push(0, 0, 1), c.x = (a[u] / e1 + 1) / 2, c.y = (a[u + 1] / e1 + 1) / 2, o.push(c.x, c.y);
                }
                for(let e1 = 1; e1 <= t; e1++)r.push(e1, e1 + 1, 0);
                this.setIndex(r), this.setAttribute("position", new Au(a, 3)), this.setAttribute("normal", new Au(s, 3)), this.setAttribute("uv", new Au(o, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Ug(e1.radius, e1.segments, e1.thetaStart, e1.thetaLength);
            }
        }
        class jg extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 32, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1, a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5], s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 2 * Math.PI;
                super(), this.type = "CylinderGeometry", this.parameters = {
                    radiusTop: e1,
                    radiusBottom: t,
                    height: n,
                    radialSegments: i,
                    heightSegments: r,
                    openEnded: a,
                    thetaStart: s,
                    thetaLength: o
                };
                const l = this;
                i = Math.floor(i), r = Math.floor(r);
                const c = [], u = [], h = [], d = [];
                let p = 0;
                const f = [], g = n / 2;
                let m = 0;
                function A(n) {
                    const r = p, a = new $o, f = new Ll;
                    let A = 0;
                    const M = !0 === n ? e1 : t, v = !0 === n ? 1 : -1;
                    for(let e1 = 1; e1 <= i; e1++)u.push(0, g * v, 0), h.push(0, v, 0), d.push(.5, .5), p++;
                    const y = p;
                    for(let e1 = 0; e1 <= i; e1++){
                        const t = e1 / i * o + s, n = Math.cos(t), r = Math.sin(t);
                        f.x = M * r, f.y = g * v, f.z = M * n, u.push(f.x, f.y, f.z), h.push(0, v, 0), a.x = .5 * n + .5, a.y = .5 * r * v + .5, d.push(a.x, a.y), p++;
                    }
                    for(let e1 = 0; e1 < i; e1++){
                        const t = r + e1, i = y + e1;
                        !0 === n ? c.push(i, i + 1, t) : c.push(i + 1, i, t), A += 3;
                    }
                    l.addGroup(m, A, !0 === n ? 1 : 2), m += A;
                }
                !function() {
                    const a = new Ll, A = new Ll;
                    let M = 0;
                    const v = (t - e1) / n;
                    for(let l = 0; l <= r; l++){
                        const c = [], m = l / r, M = m * (t - e1) + e1;
                        for(let e1 = 0; e1 <= i; e1++){
                            const t = e1 / i, r = t * o + s, l = Math.sin(r), f = Math.cos(r);
                            A.x = M * l, A.y = -m * n + g, A.z = M * f, u.push(A.x, A.y, A.z), a.set(l, v, f).normalize(), h.push(a.x, a.y, a.z), d.push(t, 1 - m), c.push(p++);
                        }
                        f.push(c);
                    }
                    for(let e1 = 0; e1 < i; e1++)for(let t = 0; t < r; t++){
                        const n = f[t][e1], i = f[t + 1][e1], r = f[t + 1][e1 + 1], a = f[t][e1 + 1];
                        c.push(n, i, a), c.push(i, r, a), M += 6;
                    }
                    l.addGroup(m, M, 0), m += M;
                }(), !1 === a && (e1 > 0 && A(!0), t > 0 && A(!1)), this.setIndex(c), this.setAttribute("position", new Au(u, 3)), this.setAttribute("normal", new Au(h, 3)), this.setAttribute("uv", new Au(d, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new jg(e1.radiusTop, e1.radiusBottom, e1.height, e1.radialSegments, e1.heightSegments, e1.openEnded, e1.thetaStart, e1.thetaLength);
            }
        }
        class kg extends jg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 32, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 2 * Math.PI;
                super(0, e1, t, n, i, r, a, s), this.type = "ConeGeometry", this.parameters = {
                    radius: e1,
                    height: t,
                    radialSegments: n,
                    heightSegments: i,
                    openEnded: r,
                    thetaStart: a,
                    thetaLength: s
                };
            }
            static fromJSON(e1) {
                return new kg(e1.radius, e1.height, e1.radialSegments, e1.heightSegments, e1.openEnded, e1.thetaStart, e1.thetaLength);
            }
        }
        class Bg extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
                super(), this.type = "PolyhedronGeometry", this.parameters = {
                    vertices: e1,
                    indices: t,
                    radius: n,
                    detail: i
                };
                const r = [], a = [];
                function s(e1, t, n, i) {
                    const r = i + 1, a = [];
                    for(let i = 0; i <= r; i++){
                        a[i] = [];
                        const s = e1.clone().lerp(n, i / r), o = t.clone().lerp(n, i / r), l = r - i;
                        for(let e1 = 0; e1 <= l; e1++)a[i][e1] = 0 === e1 && i === r ? s : s.clone().lerp(o, e1 / l);
                    }
                    for(let e1 = 0; e1 < r; e1++)for(let t = 0; t < 2 * (r - e1) - 1; t++){
                        const n = Math.floor(t / 2);
                        t % 2 == 0 ? (o(a[e1][n + 1]), o(a[e1 + 1][n]), o(a[e1][n])) : (o(a[e1][n + 1]), o(a[e1 + 1][n + 1]), o(a[e1 + 1][n]));
                    }
                }
                function o(e1) {
                    r.push(e1.x, e1.y, e1.z);
                }
                function l(t, n) {
                    const i = 3 * t;
                    n.x = e1[i + 0], n.y = e1[i + 1], n.z = e1[i + 2];
                }
                function c(e1, t, n, i) {
                    i < 0 && 1 === e1.x && (a[t] = e1.x - 1), 0 === n.x && 0 === n.z && (a[t] = i / 2 / Math.PI + .5);
                }
                function u(e1) {
                    return Math.atan2(e1.z, -e1.x);
                }
                !function(e1) {
                    const n = new Ll, i = new Ll, r = new Ll;
                    for(let a = 0; a < t.length; a += 3)l(t[a + 0], n), l(t[a + 1], i), l(t[a + 2], r), s(n, i, r, e1);
                }(i), function(e1) {
                    const t = new Ll;
                    for(let n = 0; n < r.length; n += 3)t.x = r[n + 0], t.y = r[n + 1], t.z = r[n + 2], t.normalize().multiplyScalar(e1), r[n + 0] = t.x, r[n + 1] = t.y, r[n + 2] = t.z;
                }(n), function() {
                    const e1 = new Ll;
                    for(let n = 0; n < r.length; n += 3){
                        e1.x = r[n + 0], e1.y = r[n + 1], e1.z = r[n + 2];
                        const i = u(e1) / 2 / Math.PI + .5, s = (t = e1, Math.atan2(-t.y, Math.sqrt(t.x * t.x + t.z * t.z)) / Math.PI + .5);
                        a.push(i, 1 - s);
                    }
                    var t;
                    (function() {
                        const e1 = new Ll, t = new Ll, n = new Ll, i = new Ll, s = new $o, o = new $o, l = new $o;
                        for(let h = 0, d = 0; h < r.length; h += 9, d += 6){
                            e1.set(r[h + 0], r[h + 1], r[h + 2]), t.set(r[h + 3], r[h + 4], r[h + 5]), n.set(r[h + 6], r[h + 7], r[h + 8]), s.set(a[d + 0], a[d + 1]), o.set(a[d + 2], a[d + 3]), l.set(a[d + 4], a[d + 5]), i.copy(e1).add(t).add(n).divideScalar(3);
                            const p = u(i);
                            c(s, d + 0, e1, p), c(o, d + 2, t, p), c(l, d + 4, n, p);
                        }
                    })(), function() {
                        for(let e1 = 0; e1 < a.length; e1 += 6){
                            const t = a[e1 + 0], n = a[e1 + 2], i = a[e1 + 4], r = Math.max(t, n, i), s = Math.min(t, n, i);
                            r > .9 && s < .1 && (t < .2 && (a[e1 + 0] += 1), n < .2 && (a[e1 + 2] += 1), i < .2 && (a[e1 + 4] += 1));
                        }
                    }();
                }(), this.setAttribute("position", new Au(r, 3)), this.setAttribute("normal", new Au(r.slice(), 3)), this.setAttribute("uv", new Au(a, 2)), 0 === i ? this.computeVertexNormals() : this.normalizeNormals();
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Bg(e1.vertices, e1.indices, e1.radius, e1.details);
            }
        }
        class Fg extends Bg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = (1 + Math.sqrt(5)) / 2, i = 1 / n;
                super([
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    0,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    -i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    i
                ], [
                    3,
                    11,
                    7,
                    3,
                    7,
                    15,
                    3,
                    15,
                    13,
                    7,
                    19,
                    17,
                    7,
                    17,
                    6,
                    7,
                    6,
                    15,
                    17,
                    4,
                    8,
                    17,
                    8,
                    10,
                    17,
                    10,
                    6,
                    8,
                    0,
                    16,
                    8,
                    16,
                    2,
                    8,
                    2,
                    10,
                    0,
                    12,
                    1,
                    0,
                    1,
                    18,
                    0,
                    18,
                    16,
                    6,
                    10,
                    2,
                    6,
                    2,
                    13,
                    6,
                    13,
                    15,
                    2,
                    16,
                    18,
                    2,
                    18,
                    3,
                    2,
                    3,
                    13,
                    18,
                    1,
                    9,
                    18,
                    9,
                    11,
                    18,
                    11,
                    3,
                    4,
                    14,
                    12,
                    4,
                    12,
                    0,
                    4,
                    0,
                    8,
                    11,
                    9,
                    5,
                    11,
                    5,
                    19,
                    11,
                    19,
                    7,
                    19,
                    5,
                    14,
                    19,
                    14,
                    4,
                    19,
                    4,
                    17,
                    1,
                    12,
                    14,
                    1,
                    14,
                    5,
                    1,
                    5,
                    9
                ], e1, t), this.type = "DodecahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new Fg(e1.radius, e1.detail);
            }
        }
        const Hg = new Ll, Gg = new Ll, Vg = new Ll, Qg = new Qc;
        class Wg extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                if (super(), this.type = "EdgesGeometry", this.parameters = {
                    geometry: e1,
                    thresholdAngle: t
                }, null !== e1) {
                    const n = 4, i = Math.pow(10, n), r = Math.cos(Fo * t), a = e1.getIndex(), s = e1.getAttribute("position"), o = a ? a.count : s.count, l = [
                        0,
                        0,
                        0
                    ], c = [
                        "a",
                        "b",
                        "c"
                    ], u = new Array(3), h = {}, d = [];
                    for(let e1 = 0; e1 < o; e1 += 3){
                        a ? (l[0] = a.getX(e1), l[1] = a.getX(e1 + 1), l[2] = a.getX(e1 + 2)) : (l[0] = e1, l[1] = e1 + 1, l[2] = e1 + 2);
                        const { a: t, b: n, c: o } = Qg;
                        if (t.fromBufferAttribute(s, l[0]), n.fromBufferAttribute(s, l[1]), o.fromBufferAttribute(s, l[2]), Qg.getNormal(Vg), u[0] = `${Math.round(t.x * i)},${Math.round(t.y * i)},${Math.round(t.z * i)}`, u[1] = `${Math.round(n.x * i)},${Math.round(n.y * i)},${Math.round(n.z * i)}`, u[2] = `${Math.round(o.x * i)},${Math.round(o.y * i)},${Math.round(o.z * i)}`, u[0] !== u[1] && u[1] !== u[2] && u[2] !== u[0]) for(let e1 = 0; e1 < 3; e1++){
                            const t = (e1 + 1) % 3, n = u[e1], i = u[t], a = Qg[c[e1]], s = Qg[c[t]], o = `${n}_${i}`, p = `${i}_${n}`;
                            p in h && h[p] ? (Vg.dot(h[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)), h[p] = null) : o in h || (h[o] = {
                                index0: l[e1],
                                index1: l[t],
                                normal: Vg.clone()
                            });
                        }
                    }
                    for(const e1 in h)if (h[e1]) {
                        const { index0: t, index1: n } = h[e1];
                        Hg.fromBufferAttribute(s, t), Gg.fromBufferAttribute(s, n), d.push(Hg.x, Hg.y, Hg.z), d.push(Gg.x, Gg.y, Gg.z);
                    }
                    this.setAttribute("position", new Au(d, 3));
                }
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
        }
        class Yg extends Og {
            constructor(e1){
                super(e1), this.uuid = Go(), this.type = "Shape", this.holes = [];
            }
            getPointsHoles(e1) {
                const t = [];
                for(let n = 0, i = this.holes.length; n < i; n++)t[n] = this.holes[n].getPoints(e1);
                return t;
            }
            extractPoints(e1) {
                return {
                    shape: this.getPoints(e1),
                    holes: this.getPointsHoles(e1)
                };
            }
            copy(e1) {
                super.copy(e1), this.holes = [];
                for(let t = 0, n = e1.holes.length; t < n; t++){
                    const n = e1.holes[t];
                    this.holes.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.uuid = this.uuid, e1.holes = [];
                for(let t = 0, n = this.holes.length; t < n; t++){
                    const n = this.holes[t];
                    e1.holes.push(n.toJSON());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.uuid = e1.uuid, this.holes = [];
                for(let t = 0, n = e1.holes.length; t < n; t++){
                    const n = e1.holes[t];
                    this.holes.push((new Og).fromJSON(n));
                }
                return this;
            }
        }
        function Xg(e1, t, n, i, r) {
            let a, s;
            if (r === function(e1, t, n, i) {
                let r = 0;
                for(let a = t, s = n - i; a < n; a += i)r += (e1[s] - e1[a]) * (e1[a + 1] + e1[s + 1]), s = a;
                return r;
            }(e1, t, n, i) > 0) for(a = t; a < n; a += i)s = gm(a, e1[a], e1[a + 1], s);
            else for(a = n - i; a >= t; a -= i)s = gm(a, e1[a], e1[a + 1], s);
            return s && cm(s, s.next) && (mm(s), s = s.next), s;
        }
        function Zg(e1, t) {
            if (!e1) return e1;
            t || (t = e1);
            let n, i = e1;
            do if (n = !1, i.steiner || !cm(i, i.next) && 0 !== lm(i.prev, i, i.next)) i = i.next;
            else {
                if (mm(i), i = t = i.prev, i === i.next) break;
                n = !0;
            }
            while (n || i !== t);
            return t;
        }
        function qg(e1, t, n, i, r, a, s) {
            if (!e1) return;
            !s && a && function(e1, t, n, i) {
                let r = e1;
                do 0 === r.z && (r.z = rm(r.x, r.y, t, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== e1);
                r.prevZ.nextZ = null, r.prevZ = null, function(e1) {
                    let t, n, i, r, a, s, o, l, c = 1;
                    do {
                        for(n = e1, e1 = null, a = null, s = 0; n;){
                            for(s++, i = n, o = 0, t = 0; t < c && (o++, i = i.nextZ, i); t++);
                            for(l = c; o > 0 || l > 0 && i;)0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), a ? a.nextZ = r : e1 = r, r.prevZ = a, a = r;
                            n = i;
                        }
                        a.nextZ = null, c *= 2;
                    }while (s > 1);
                }(r);
            }(e1, i, r, a);
            let o, l, c = e1;
            for(; e1.prev !== e1.next;)if (o = e1.prev, l = e1.next, a ? Jg(e1, i, r, a) : Kg(e1)) t.push(o.i / n | 0), t.push(e1.i / n | 0), t.push(l.i / n | 0), mm(e1), e1 = l.next, c = l.next;
            else if ((e1 = l) === c) {
                s ? 1 === s ? qg(e1 = $g(Zg(e1), t, n), t, n, i, r, a, 2) : 2 === s && em(e1, t, n, i, r, a) : qg(Zg(e1), t, n, i, r, a, 1);
                break;
            }
        }
        function Kg(e1) {
            const t = e1.prev, n = e1, i = e1.next;
            if (lm(t, n, i) >= 0) return !1;
            const r = t.x, a = n.x, s = i.x, o = t.y, l = n.y, c = i.y, u = r < a ? r < s ? r : s : a < s ? a : s, h = o < l ? o < c ? o : c : l < c ? l : c, d = r > a ? r > s ? r : s : a > s ? a : s, p = o > l ? o > c ? o : c : l > c ? l : c;
            let f = i.next;
            for(; f !== t;){
                if (f.x >= u && f.x <= d && f.y >= h && f.y <= p && sm(r, o, a, l, s, c, f.x, f.y) && lm(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function Jg(e1, t, n, i) {
            const r = e1.prev, a = e1, s = e1.next;
            if (lm(r, a, s) >= 0) return !1;
            const o = r.x, l = a.x, c = s.x, u = r.y, h = a.y, d = s.y, p = o < l ? o < c ? o : c : l < c ? l : c, f = u < h ? u < d ? u : d : h < d ? h : d, g = o > l ? o > c ? o : c : l > c ? l : c, m = u > h ? u > d ? u : d : h > d ? h : d, A = rm(p, f, t, n, i), M = rm(g, m, t, n, i);
            let v = e1.prevZ, y = e1.nextZ;
            for(; v && v.z >= A && y && y.z <= M;){
                if (v.x >= p && v.x <= g && v.y >= f && v.y <= m && v !== r && v !== s && sm(o, u, l, h, c, d, v.x, v.y) && lm(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, y.x >= p && y.x <= g && y.y >= f && y.y <= m && y !== r && y !== s && sm(o, u, l, h, c, d, y.x, y.y) && lm(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            for(; v && v.z >= A;){
                if (v.x >= p && v.x <= g && v.y >= f && v.y <= m && v !== r && v !== s && sm(o, u, l, h, c, d, v.x, v.y) && lm(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; y && y.z <= M;){
                if (y.x >= p && y.x <= g && y.y >= f && y.y <= m && y !== r && y !== s && sm(o, u, l, h, c, d, y.x, y.y) && lm(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            return !0;
        }
        function $g(e1, t, n) {
            let i = e1;
            do {
                const r = i.prev, a = i.next.next;
                !cm(r, a) && um(r, i, i.next, a) && pm(r, a) && pm(a, r) && (t.push(r.i / n | 0), t.push(i.i / n | 0), t.push(a.i / n | 0), mm(i), mm(i.next), i = e1 = a), i = i.next;
            }while (i !== e1);
            return Zg(i);
        }
        function em(e1, t, n, i, r, a) {
            let s = e1;
            do {
                let e1 = s.next.next;
                for(; e1 !== s.prev;){
                    if (s.i !== e1.i && om(s, e1)) {
                        let o = fm(s, e1);
                        return s = Zg(s, s.next), o = Zg(o, o.next), qg(s, t, n, i, r, a, 0), void qg(o, t, n, i, r, a, 0);
                    }
                    e1 = e1.next;
                }
                s = s.next;
            }while (s !== e1);
        }
        function tm(e1, t) {
            return e1.x - t.x;
        }
        function nm(e1, t) {
            const n = function(e1, t) {
                let n, i = t, r = -1 / 0;
                const a = e1.x, s = e1.y;
                do {
                    if (s <= i.y && s >= i.next.y && i.next.y !== i.y) {
                        const e1 = i.x + (s - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                        if (e1 <= a && e1 > r && (r = e1, n = i.x < i.next.x ? i : i.next, e1 === a)) return n;
                    }
                    i = i.next;
                }while (i !== t);
                if (!n) return null;
                const o = n, l = n.x, c = n.y;
                let u, h = 1 / 0;
                i = n;
                do a >= i.x && i.x >= l && a !== i.x && sm(s < c ? a : r, s, l, c, s < c ? r : a, s, i.x, i.y) && (u = Math.abs(s - i.y) / (a - i.x), pm(i, e1) && (u < h || u === h && (i.x > n.x || i.x === n.x && im(n, i))) && (n = i, h = u)), i = i.next;
                while (i !== o);
                return n;
            }(e1, t);
            if (!n) return t;
            const i = fm(n, e1);
            return Zg(i, i.next), Zg(n, n.next);
        }
        function im(e1, t) {
            return lm(e1.prev, e1, t.prev) < 0 && lm(t.next, e1, e1.next) < 0;
        }
        function rm(e1, t, n, i, r) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * r | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - i) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
        }
        function am(e1) {
            let t = e1, n = e1;
            do (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
            while (t !== e1);
            return n;
        }
        function sm(e1, t, n, i, r, a, s, o) {
            return (r - s) * (t - o) >= (e1 - s) * (a - o) && (e1 - s) * (i - o) >= (n - s) * (t - o) && (n - s) * (a - o) >= (r - s) * (i - o);
        }
        function om(e1, t) {
            return e1.next.i !== t.i && e1.prev.i !== t.i && !function(e1, t) {
                let n = e1;
                do {
                    if (n.i !== e1.i && n.next.i !== e1.i && n.i !== t.i && n.next.i !== t.i && um(n, n.next, e1, t)) return !0;
                    n = n.next;
                }while (n !== e1);
                return !1;
            }(e1, t) && (pm(e1, t) && pm(t, e1) && function(e1, t) {
                let n = e1, i = !1;
                const r = (e1.x + t.x) / 2, a = (e1.y + t.y) / 2;
                do n.y > a != n.next.y > a && n.next.y !== n.y && r < (n.next.x - n.x) * (a - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
                while (n !== e1);
                return i;
            }(e1, t) && (lm(e1.prev, e1, t.prev) || lm(e1, t.prev, t)) || cm(e1, t) && lm(e1.prev, e1, e1.next) > 0 && lm(t.prev, t, t.next) > 0);
        }
        function lm(e1, t, n) {
            return (t.y - e1.y) * (n.x - t.x) - (t.x - e1.x) * (n.y - t.y);
        }
        function cm(e1, t) {
            return e1.x === t.x && e1.y === t.y;
        }
        function um(e1, t, n, i) {
            const r = dm(lm(e1, t, n)), a = dm(lm(e1, t, i)), s = dm(lm(n, i, e1)), o = dm(lm(n, i, t));
            return r !== a && s !== o || !(0 !== r || !hm(e1, n, t)) || !(0 !== a || !hm(e1, i, t)) || !(0 !== s || !hm(n, e1, i)) || !(0 !== o || !hm(n, t, i));
        }
        function hm(e1, t, n) {
            return t.x <= Math.max(e1.x, n.x) && t.x >= Math.min(e1.x, n.x) && t.y <= Math.max(e1.y, n.y) && t.y >= Math.min(e1.y, n.y);
        }
        function dm(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function pm(e1, t) {
            return lm(e1.prev, e1, e1.next) < 0 ? lm(e1, t, e1.next) >= 0 && lm(e1, e1.prev, t) >= 0 : lm(e1, t, e1.prev) < 0 || lm(e1, e1.next, t) < 0;
        }
        function fm(e1, t) {
            const n = new Am(e1.i, e1.x, e1.y), i = new Am(t.i, t.x, t.y), r = e1.next, a = t.prev;
            return e1.next = t, t.prev = e1, n.next = r, r.prev = n, i.next = n, n.prev = i, a.next = i, i.prev = a, i;
        }
        function gm(e1, t, n, i) {
            const r = new Am(e1, t, n);
            return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
        }
        function mm(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function Am(e1, t, n) {
            this.i = e1, this.x = t, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        class Mm {
            static area(e1) {
                const t = e1.length;
                let n = 0;
                for(let i = t - 1, r = 0; r < t; i = r++)n += e1[i].x * e1[r].y - e1[r].x * e1[i].y;
                return .5 * n;
            }
            static isClockWise(e1) {
                return Mm.area(e1) < 0;
            }
            static triangulateShape(e1, t) {
                const n = [], i = [], r = [];
                vm(e1), ym(n, e1);
                let a = e1.length;
                t.forEach(vm);
                for(let e1 = 0; e1 < t.length; e1++)i.push(a), a += t[e1].length, ym(n, t[e1]);
                const s = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
                    const i = t && t.length, r = i ? t[0] * n : e1.length;
                    let a = Xg(e1, 0, r, n, !0);
                    const s = [];
                    if (!a || a.next === a.prev) return s;
                    let o, l, c, u, h, d, p;
                    if (i && (a = function(e1, t, n, i) {
                        const r = [];
                        let a, s, o, l, c;
                        for(a = 0, s = t.length; a < s; a++)o = t[a] * i, l = a < s - 1 ? t[a + 1] * i : e1.length, c = Xg(e1, o, l, i, !1), c === c.next && (c.steiner = !0), r.push(am(c));
                        for(r.sort(tm), a = 0; a < r.length; a++)n = nm(r[a], n);
                        return n;
                    }(e1, t, a, n)), e1.length > 80 * n) {
                        o = c = e1[0], l = u = e1[1];
                        for(let t = n; t < r; t += n)h = e1[t], d = e1[t + 1], h < o && (o = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
                        p = Math.max(c - o, u - l), p = 0 !== p ? 32767 / p : 0;
                    }
                    return qg(a, s, n, o, l, p, 0), s;
                }(n, i);
                for(let e1 = 0; e1 < s.length; e1 += 3)r.push(s.slice(e1, e1 + 3));
                return r;
            }
        }
        function vm(e1) {
            const t = e1.length;
            t > 2 && e1[t - 1].equals(e1[0]) && e1.pop();
        }
        function ym(e1, t) {
            for(let n = 0; n < t.length; n++)e1.push(t[n].x), e1.push(t[n].y);
        }
        class xm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Yg([
                    new $o(.5, .5),
                    new $o(-0.5, .5),
                    new $o(-0.5, -0.5),
                    new $o(.5, -0.5)
                ]), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                super(), this.type = "ExtrudeGeometry", this.parameters = {
                    shapes: e1,
                    options: t
                }, e1 = Array.isArray(e1) ? e1 : [
                    e1
                ];
                const n = this, i = [], r = [];
                for(let t = 0, n = e1.length; t < n; t++)a(e1[t]);
                function a(e1) {
                    const a = [], s = void 0 !== t.curveSegments ? t.curveSegments : 12, o = void 0 !== t.steps ? t.steps : 1, l = void 0 !== t.depth ? t.depth : 1;
                    let c = void 0 === t.bevelEnabled || t.bevelEnabled, u = void 0 !== t.bevelThickness ? t.bevelThickness : .2, h = void 0 !== t.bevelSize ? t.bevelSize : u - .1, d = void 0 !== t.bevelOffset ? t.bevelOffset : 0, p = void 0 !== t.bevelSegments ? t.bevelSegments : 3;
                    const f = t.extrudePath, g = void 0 !== t.UVGenerator ? t.UVGenerator : bm;
                    let m, A, M, v, y, x = !1;
                    f && (m = f.getSpacedPoints(o), x = !0, c = !1, A = f.computeFrenetFrames(o, !1), M = new Ll, v = new Ll, y = new Ll), c || (p = 0, u = 0, h = 0, d = 0);
                    const b = e1.extractPoints(s);
                    let w = b.shape;
                    const E = b.holes;
                    if (!Mm.isClockWise(w)) {
                        w = w.reverse();
                        for(let e1 = 0, t = E.length; e1 < t; e1++){
                            const t = E[e1];
                            Mm.isClockWise(t) && (E[e1] = t.reverse());
                        }
                    }
                    const T = Mm.triangulateShape(w, E), S = w;
                    for(let e1 = 0, t = E.length; e1 < t; e1++){
                        const t = E[e1];
                        w = w.concat(t);
                    }
                    function I(e1, t, n) {
                        return t || console.error("THREE.ExtrudeGeometry: vec does not exist"), e1.clone().addScaledVector(t, n);
                    }
                    const N = w.length, D = T.length;
                    function _(e1, t, n) {
                        let i, r, a;
                        const s = e1.x - t.x, o = e1.y - t.y, l = n.x - e1.x, c = n.y - e1.y, u = s * s + o * o, h = s * c - o * l;
                        if (Math.abs(h) > Number.EPSILON) {
                            const h = Math.sqrt(u), d = Math.sqrt(l * l + c * c), p = t.x - o / h, f = t.y + s / h, g = ((n.x - c / d - p) * c - (n.y + l / d - f) * l) / (s * c - o * l);
                            i = p + s * g - e1.x, r = f + o * g - e1.y;
                            const m = i * i + r * r;
                            if (m <= 2) return new $o(i, r);
                            a = Math.sqrt(m / 2);
                        } else {
                            let e1 = !1;
                            s > Number.EPSILON ? l > Number.EPSILON && (e1 = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (e1 = !0) : Math.sign(o) === Math.sign(c) && (e1 = !0), e1 ? (i = -o, r = s, a = Math.sqrt(u)) : (i = s, r = o, a = Math.sqrt(u / 2));
                        }
                        return new $o(i / a, r / a);
                    }
                    const C = [];
                    for(let e1 = 0, t = S.length, n = t - 1, i = e1 + 1; e1 < t; e1++, n++, i++)n === t && (n = 0), i === t && (i = 0), C[e1] = _(S[e1], S[n], S[i]);
                    const L = [];
                    let z, O = C.concat();
                    for(let e1 = 0, t = E.length; e1 < t; e1++){
                        const t = E[e1];
                        z = [];
                        for(let e1 = 0, n = t.length, i = n - 1, r = e1 + 1; e1 < n; e1++, i++, r++)i === n && (i = 0), r === n && (r = 0), z[e1] = _(t[e1], t[i], t[r]);
                        L.push(z), O = O.concat(z);
                    }
                    for(let e1 = 0; e1 < p; e1++){
                        const t = e1 / p, n = u * Math.cos(t * Math.PI / 2), i = h * Math.sin(t * Math.PI / 2) + d;
                        for(let e1 = 0, t = S.length; e1 < t; e1++){
                            const t = I(S[e1], C[e1], i);
                            U(t.x, t.y, -n);
                        }
                        for(let e1 = 0, t = E.length; e1 < t; e1++){
                            const t = E[e1];
                            z = L[e1];
                            for(let e1 = 0, r = t.length; e1 < r; e1++){
                                const r = I(t[e1], z[e1], i);
                                U(r.x, r.y, -n);
                            }
                        }
                    }
                    const R = h + d;
                    for(let e1 = 0; e1 < N; e1++){
                        const t = c ? I(w[e1], O[e1], R) : w[e1];
                        x ? (v.copy(A.normals[0]).multiplyScalar(t.x), M.copy(A.binormals[0]).multiplyScalar(t.y), y.copy(m[0]).add(v).add(M), U(y.x, y.y, y.z)) : U(t.x, t.y, 0);
                    }
                    for(let e1 = 1; e1 <= o; e1++)for(let t = 0; t < N; t++){
                        const n = c ? I(w[t], O[t], R) : w[t];
                        x ? (v.copy(A.normals[e1]).multiplyScalar(n.x), M.copy(A.binormals[e1]).multiplyScalar(n.y), y.copy(m[e1]).add(v).add(M), U(y.x, y.y, y.z)) : U(n.x, n.y, l / o * e1);
                    }
                    for(let e1 = p - 1; e1 >= 0; e1--){
                        const t = e1 / p, n = u * Math.cos(t * Math.PI / 2), i = h * Math.sin(t * Math.PI / 2) + d;
                        for(let e1 = 0, t = S.length; e1 < t; e1++){
                            const t = I(S[e1], C[e1], i);
                            U(t.x, t.y, l + n);
                        }
                        for(let e1 = 0, t = E.length; e1 < t; e1++){
                            const t = E[e1];
                            z = L[e1];
                            for(let e1 = 0, r = t.length; e1 < r; e1++){
                                const r = I(t[e1], z[e1], i);
                                x ? U(r.x, r.y + m[o - 1].y, m[o - 1].x + n) : U(r.x, r.y, l + n);
                            }
                        }
                    }
                    function P(e1, t) {
                        let n = e1.length;
                        for(; --n >= 0;){
                            const i = n;
                            let r = n - 1;
                            r < 0 && (r = e1.length - 1);
                            for(let e1 = 0, n = o + 2 * p; e1 < n; e1++){
                                const n = N * e1, a = N * (e1 + 1);
                                k(t + i + n, t + r + n, t + r + a, t + i + a);
                            }
                        }
                    }
                    function U(e1, t, n) {
                        a.push(e1), a.push(t), a.push(n);
                    }
                    function j(e1, t, r) {
                        B(e1), B(t), B(r);
                        const a = i.length / 3, s = g.generateTopUV(n, i, a - 3, a - 2, a - 1);
                        F(s[0]), F(s[1]), F(s[2]);
                    }
                    function k(e1, t, r, a) {
                        B(e1), B(t), B(a), B(t), B(r), B(a);
                        const s = i.length / 3, o = g.generateSideWallUV(n, i, s - 6, s - 3, s - 2, s - 1);
                        F(o[0]), F(o[1]), F(o[3]), F(o[1]), F(o[2]), F(o[3]);
                    }
                    function B(e1) {
                        i.push(a[3 * e1 + 0]), i.push(a[3 * e1 + 1]), i.push(a[3 * e1 + 2]);
                    }
                    function F(e1) {
                        r.push(e1.x), r.push(e1.y);
                    }
                    !function() {
                        const e1 = i.length / 3;
                        if (c) {
                            let e1 = 0, t = N * e1;
                            for(let e1 = 0; e1 < D; e1++){
                                const n = T[e1];
                                j(n[2] + t, n[1] + t, n[0] + t);
                            }
                            e1 = o + 2 * p, t = N * e1;
                            for(let e1 = 0; e1 < D; e1++){
                                const n = T[e1];
                                j(n[0] + t, n[1] + t, n[2] + t);
                            }
                        } else {
                            for(let e1 = 0; e1 < D; e1++){
                                const t = T[e1];
                                j(t[2], t[1], t[0]);
                            }
                            for(let e1 = 0; e1 < D; e1++){
                                const t = T[e1];
                                j(t[0] + N * o, t[1] + N * o, t[2] + N * o);
                            }
                        }
                        n.addGroup(e1, i.length / 3 - e1, 0);
                    }(), function() {
                        const e1 = i.length / 3;
                        let t = 0;
                        P(S, t), t += S.length;
                        for(let e1 = 0, n = E.length; e1 < n; e1++){
                            const n = E[e1];
                            P(n, t), t += n.length;
                        }
                        n.addGroup(e1, i.length / 3 - e1, 1);
                    }();
                }
                this.setAttribute("position", new Au(i, 3)), this.setAttribute("uv", new Au(r, 2)), this.computeVertexNormals();
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return function(e1, t, n) {
                    if (n.shapes = [], Array.isArray(e1)) for(let t = 0, i = e1.length; t < i; t++){
                        const i = e1[t];
                        n.shapes.push(i.uuid);
                    }
                    else n.shapes.push(e1.uuid);
                    return n.options = Object.assign({}, t), void 0 !== t.extrudePath && (n.options.extrudePath = t.extrudePath.toJSON()), n;
                }(this.parameters.shapes, this.parameters.options, e1);
            }
            static fromJSON(e1, t) {
                const n = [];
                for(let i = 0, r = e1.shapes.length; i < r; i++){
                    const r = t[e1.shapes[i]];
                    n.push(r);
                }
                const i = e1.options.extrudePath;
                return void 0 !== i && (e1.options.extrudePath = (new Lg[i.type]).fromJSON(i)), new xm(n, e1.options);
            }
        }
        const bm = {
            generateTopUV: function(e1, t, n, i, r) {
                const a = t[3 * n], s = t[3 * n + 1], o = t[3 * i], l = t[3 * i + 1], c = t[3 * r], u = t[3 * r + 1];
                return [
                    new $o(a, s),
                    new $o(o, l),
                    new $o(c, u)
                ];
            },
            generateSideWallUV: function(e1, t, n, i, r, a) {
                const s = t[3 * n], o = t[3 * n + 1], l = t[3 * n + 2], c = t[3 * i], u = t[3 * i + 1], h = t[3 * i + 2], d = t[3 * r], p = t[3 * r + 1], f = t[3 * r + 2], g = t[3 * a], m = t[3 * a + 1], A = t[3 * a + 2];
                return Math.abs(o - u) < Math.abs(s - c) ? [
                    new $o(s, 1 - l),
                    new $o(c, 1 - h),
                    new $o(d, 1 - f),
                    new $o(g, 1 - A)
                ] : [
                    new $o(o, 1 - l),
                    new $o(u, 1 - h),
                    new $o(p, 1 - f),
                    new $o(m, 1 - A)
                ];
            }
        };
        class wm extends Bg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = (1 + Math.sqrt(5)) / 2;
                super([
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    0,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    n,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    -n,
                    0,
                    -1,
                    -n,
                    0,
                    1
                ], [
                    0,
                    11,
                    5,
                    0,
                    5,
                    1,
                    0,
                    1,
                    7,
                    0,
                    7,
                    10,
                    0,
                    10,
                    11,
                    1,
                    5,
                    9,
                    5,
                    11,
                    4,
                    11,
                    10,
                    2,
                    10,
                    7,
                    6,
                    7,
                    1,
                    8,
                    3,
                    9,
                    4,
                    3,
                    4,
                    2,
                    3,
                    2,
                    6,
                    3,
                    6,
                    8,
                    3,
                    8,
                    9,
                    4,
                    9,
                    5,
                    2,
                    4,
                    11,
                    6,
                    2,
                    10,
                    8,
                    6,
                    7,
                    9,
                    8,
                    1
                ], e1, t), this.type = "IcosahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new wm(e1.radius, e1.detail);
            }
        }
        class Em extends Bg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                super([
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1
                ], [
                    0,
                    2,
                    4,
                    0,
                    4,
                    3,
                    0,
                    3,
                    5,
                    0,
                    5,
                    2,
                    1,
                    2,
                    5,
                    1,
                    5,
                    3,
                    1,
                    3,
                    4,
                    1,
                    4,
                    2
                ], e1, t), this.type = "OctahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new Em(e1.radius, e1.detail);
            }
        }
        class Tm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : .5, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 32, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2 * Math.PI;
                super(), this.type = "RingGeometry", this.parameters = {
                    innerRadius: e1,
                    outerRadius: t,
                    thetaSegments: n,
                    phiSegments: i,
                    thetaStart: r,
                    thetaLength: a
                }, n = Math.max(3, n), i = Math.max(1, i);
                const s = [], o = [], l = [], c = [];
                let u = e1;
                const h = (t - e1) / i, d = new Ll, p = new $o;
                for(let e1 = 0; e1 <= i; e1++){
                    for(let e1 = 0; e1 <= n; e1++){
                        const i = r + e1 / n * a;
                        d.x = u * Math.cos(i), d.y = u * Math.sin(i), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / t + 1) / 2, p.y = (d.y / t + 1) / 2, c.push(p.x, p.y);
                    }
                    u += h;
                }
                for(let e1 = 0; e1 < i; e1++){
                    const t = e1 * (n + 1);
                    for(let e1 = 0; e1 < n; e1++){
                        const i = e1 + t, r = i, a = i + n + 1, o = i + n + 2, l = i + 1;
                        s.push(r, a, l), s.push(a, o, l);
                    }
                }
                this.setIndex(s), this.setAttribute("position", new Au(o, 3)), this.setAttribute("normal", new Au(l, 3)), this.setAttribute("uv", new Au(c, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Tm(e1.innerRadius, e1.outerRadius, e1.thetaSegments, e1.phiSegments, e1.thetaStart, e1.thetaLength);
            }
        }
        class Sm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Yg([
                    new $o(0, .5),
                    new $o(-0.5, -0.5),
                    new $o(.5, -0.5)
                ]), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 12;
                super(), this.type = "ShapeGeometry", this.parameters = {
                    shapes: e1,
                    curveSegments: t
                };
                const n = [], i = [], r = [], a = [];
                let s = 0, o = 0;
                if (!1 === Array.isArray(e1)) l(e1);
                else for(let t = 0; t < e1.length; t++)l(e1[t]), this.addGroup(s, o, t), s += o, o = 0;
                function l(e1) {
                    const s = i.length / 3, l = e1.extractPoints(t);
                    let c = l.shape;
                    const u = l.holes;
                    !1 === Mm.isClockWise(c) && (c = c.reverse());
                    for(let e1 = 0, t = u.length; e1 < t; e1++){
                        const t = u[e1];
                        !0 === Mm.isClockWise(t) && (u[e1] = t.reverse());
                    }
                    const h = Mm.triangulateShape(c, u);
                    for(let e1 = 0, t = u.length; e1 < t; e1++){
                        const t = u[e1];
                        c = c.concat(t);
                    }
                    for(let e1 = 0, t = c.length; e1 < t; e1++){
                        const t = c[e1];
                        i.push(t.x, t.y, 0), r.push(0, 0, 1), a.push(t.x, t.y);
                    }
                    for(let e1 = 0, t = h.length; e1 < t; e1++){
                        const t = h[e1], i = t[0] + s, r = t[1] + s, a = t[2] + s;
                        n.push(i, r, a), o += 3;
                    }
                }
                this.setIndex(n), this.setAttribute("position", new Au(i, 3)), this.setAttribute("normal", new Au(r, 3)), this.setAttribute("uv", new Au(a, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return function(e1, t) {
                    if (t.shapes = [], Array.isArray(e1)) for(let n = 0, i = e1.length; n < i; n++){
                        const i = e1[n];
                        t.shapes.push(i.uuid);
                    }
                    else t.shapes.push(e1.uuid);
                    return t;
                }(this.parameters.shapes, e1);
            }
            static fromJSON(e1, t) {
                const n = [];
                for(let i = 0, r = e1.shapes.length; i < r; i++){
                    const r = t[e1.shapes[i]];
                    n.push(r);
                }
                return new Sm(n, e1.curveSegments);
            }
        }
        class Im extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2 * Math.PI, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Math.PI;
                super(), this.type = "SphereGeometry", this.parameters = {
                    radius: e1,
                    widthSegments: t,
                    heightSegments: n,
                    phiStart: i,
                    phiLength: r,
                    thetaStart: a,
                    thetaLength: s
                }, t = Math.max(3, Math.floor(t)), n = Math.max(2, Math.floor(n));
                const o = Math.min(a + s, Math.PI);
                let l = 0;
                const c = [], u = new Ll, h = new Ll, d = [], p = [], f = [], g = [];
                for(let d = 0; d <= n; d++){
                    const m = [], A = d / n;
                    let M = 0;
                    0 === d && 0 === a ? M = .5 / t : d === n && o === Math.PI && (M = -0.5 / t);
                    for(let n = 0; n <= t; n++){
                        const o = n / t;
                        u.x = -e1 * Math.cos(i + o * r) * Math.sin(a + A * s), u.y = e1 * Math.cos(a + A * s), u.z = e1 * Math.sin(i + o * r) * Math.sin(a + A * s), p.push(u.x, u.y, u.z), h.copy(u).normalize(), f.push(h.x, h.y, h.z), g.push(o + M, 1 - A), m.push(l++);
                    }
                    c.push(m);
                }
                for(let e1 = 0; e1 < n; e1++)for(let i = 0; i < t; i++){
                    const t = c[e1][i + 1], r = c[e1][i], s = c[e1 + 1][i], l = c[e1 + 1][i + 1];
                    (0 !== e1 || a > 0) && d.push(t, r, l), (e1 !== n - 1 || o < Math.PI) && d.push(r, s, l);
                }
                this.setIndex(d), this.setAttribute("position", new Au(p, 3)), this.setAttribute("normal", new Au(f, 3)), this.setAttribute("uv", new Au(g, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Im(e1.radius, e1.widthSegments, e1.heightSegments, e1.phiStart, e1.phiLength, e1.thetaStart, e1.thetaLength);
            }
        }
        class Nm extends Bg {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                super([
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ], [
                    2,
                    1,
                    0,
                    0,
                    3,
                    2,
                    1,
                    3,
                    0,
                    2,
                    3,
                    1
                ], e1, t), this.type = "TetrahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new Nm(e1.radius, e1.detail);
            }
        }
        class Dm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .4, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 12, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 48, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2 * Math.PI;
                super(), this.type = "TorusGeometry", this.parameters = {
                    radius: e1,
                    tube: t,
                    radialSegments: n,
                    tubularSegments: i,
                    arc: r
                }, n = Math.floor(n), i = Math.floor(i);
                const a = [], s = [], o = [], l = [], c = new Ll, u = new Ll, h = new Ll;
                for(let a = 0; a <= n; a++)for(let d = 0; d <= i; d++){
                    const p = d / i * r, f = a / n * Math.PI * 2;
                    u.x = (e1 + t * Math.cos(f)) * Math.cos(p), u.y = (e1 + t * Math.cos(f)) * Math.sin(p), u.z = t * Math.sin(f), s.push(u.x, u.y, u.z), c.x = e1 * Math.cos(p), c.y = e1 * Math.sin(p), h.subVectors(u, c).normalize(), o.push(h.x, h.y, h.z), l.push(d / i), l.push(a / n);
                }
                for(let e1 = 1; e1 <= n; e1++)for(let t = 1; t <= i; t++){
                    const n = (i + 1) * e1 + t - 1, r = (i + 1) * (e1 - 1) + t - 1, s = (i + 1) * (e1 - 1) + t, o = (i + 1) * e1 + t;
                    a.push(n, r, o), a.push(r, s, o);
                }
                this.setIndex(a), this.setAttribute("position", new Au(s, 3)), this.setAttribute("normal", new Au(o, 3)), this.setAttribute("uv", new Au(l, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Dm(e1.radius, e1.tube, e1.radialSegments, e1.tubularSegments, e1.arc);
            }
        }
        class _m extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .4, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 64, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 3;
                super(), this.type = "TorusKnotGeometry", this.parameters = {
                    radius: e1,
                    tube: t,
                    tubularSegments: n,
                    radialSegments: i,
                    p: r,
                    q: a
                }, n = Math.floor(n), i = Math.floor(i);
                const s = [], o = [], l = [], c = [], u = new Ll, h = new Ll, d = new Ll, p = new Ll, f = new Ll, g = new Ll, m = new Ll;
                for(let s = 0; s <= n; ++s){
                    const M = s / n * r * Math.PI * 2;
                    A(M, r, a, e1, d), A(M + .01, r, a, e1, p), g.subVectors(p, d), m.addVectors(p, d), f.crossVectors(g, m), m.crossVectors(f, g), f.normalize(), m.normalize();
                    for(let e1 = 0; e1 <= i; ++e1){
                        const r = e1 / i * Math.PI * 2, a = -t * Math.cos(r), p = t * Math.sin(r);
                        u.x = d.x + (a * m.x + p * f.x), u.y = d.y + (a * m.y + p * f.y), u.z = d.z + (a * m.z + p * f.z), o.push(u.x, u.y, u.z), h.subVectors(u, d).normalize(), l.push(h.x, h.y, h.z), c.push(s / n), c.push(e1 / i);
                    }
                }
                for(let e1 = 1; e1 <= n; e1++)for(let t = 1; t <= i; t++){
                    const n = (i + 1) * (e1 - 1) + (t - 1), r = (i + 1) * e1 + (t - 1), a = (i + 1) * e1 + t, o = (i + 1) * (e1 - 1) + t;
                    s.push(n, r, o), s.push(r, a, o);
                }
                function A(e1, t, n, i, r) {
                    const a = Math.cos(e1), s = Math.sin(e1), o = n / t * e1, l = Math.cos(o);
                    r.x = i * (2 + l) * .5 * a, r.y = i * (2 + l) * s * .5, r.z = i * Math.sin(o) * .5;
                }
                this.setIndex(s), this.setAttribute("position", new Au(o, 3)), this.setAttribute("normal", new Au(l, 3)), this.setAttribute("uv", new Au(c, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new _m(e1.radius, e1.tube, e1.tubularSegments, e1.radialSegments, e1.p, e1.q);
            }
        }
        class Cm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new _g(new Ll(-1, -1, 0), new Ll(-1, 1, 0), new Ll(1, 1, 0)), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 64, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                super(), this.type = "TubeGeometry", this.parameters = {
                    path: e1,
                    tubularSegments: t,
                    radius: n,
                    radialSegments: i,
                    closed: r
                };
                const a = e1.computeFrenetFrames(t, r);
                this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals;
                const s = new Ll, o = new Ll, l = new $o;
                let c = new Ll;
                const u = [], h = [], d = [], p = [];
                function f(r) {
                    c = e1.getPointAt(r / t, c);
                    const l = a.normals[r], d = a.binormals[r];
                    for(let e1 = 0; e1 <= i; e1++){
                        const t = e1 / i * Math.PI * 2, r = Math.sin(t), a = -Math.cos(t);
                        o.x = a * l.x + r * d.x, o.y = a * l.y + r * d.y, o.z = a * l.z + r * d.z, o.normalize(), h.push(o.x, o.y, o.z), s.x = c.x + n * o.x, s.y = c.y + n * o.y, s.z = c.z + n * o.z, u.push(s.x, s.y, s.z);
                    }
                }
                !function() {
                    for(let e1 = 0; e1 < t; e1++)f(e1);
                    f(!1 === r ? t : 0), function() {
                        for(let e1 = 0; e1 <= t; e1++)for(let n = 0; n <= i; n++)l.x = e1 / t, l.y = n / i, d.push(l.x, l.y);
                    }(), function() {
                        for(let e1 = 1; e1 <= t; e1++)for(let t = 1; t <= i; t++){
                            const n = (i + 1) * (e1 - 1) + (t - 1), r = (i + 1) * e1 + (t - 1), a = (i + 1) * e1 + t, s = (i + 1) * (e1 - 1) + t;
                            p.push(n, r, s), p.push(r, a, s);
                        }
                    }();
                }(), this.setIndex(p), this.setAttribute("position", new Au(u, 3)), this.setAttribute("normal", new Au(h, 3)), this.setAttribute("uv", new Au(d, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.path = this.parameters.path.toJSON(), e1;
            }
            static fromJSON(e1) {
                return new Cm((new Lg[e1.path.type]).fromJSON(e1.path), e1.tubularSegments, e1.radius, e1.radialSegments, e1.closed);
            }
        }
        class Lm extends Su {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (super(), this.type = "WireframeGeometry", this.parameters = {
                    geometry: e1
                }, null !== e1) {
                    const t = [], n = new Set, i = new Ll, r = new Ll;
                    if (null !== e1.index) {
                        const a = e1.attributes.position, s = e1.index;
                        let o = e1.groups;
                        0 === o.length && (o = [
                            {
                                start: 0,
                                count: s.count,
                                materialIndex: 0
                            }
                        ]);
                        for(let e1 = 0, l = o.length; e1 < l; ++e1){
                            const l = o[e1], c = l.start;
                            for(let e1 = c, o = c + l.count; e1 < o; e1 += 3)for(let o = 0; o < 3; o++){
                                const l = s.getX(e1 + o), c = s.getX(e1 + (o + 1) % 3);
                                i.fromBufferAttribute(a, l), r.fromBufferAttribute(a, c), !0 === zm(i, r, n) && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                            }
                        }
                    } else {
                        const a = e1.attributes.position;
                        for(let e1 = 0, s = a.count / 3; e1 < s; e1++)for(let s = 0; s < 3; s++){
                            const o = 3 * e1 + s, l = 3 * e1 + (s + 1) % 3;
                            i.fromBufferAttribute(a, o), r.fromBufferAttribute(a, l), !0 === zm(i, r, n) && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                        }
                    }
                    this.setAttribute("position", new Au(t, 3));
                }
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
        }
        function zm(e1, t, n) {
            const i = `${e1.x},${e1.y},${e1.z}-${t.x},${t.y},${t.z}`, r = `${t.x},${t.y},${t.z}-${e1.x},${e1.y},${e1.z}`;
            return !0 !== n.has(i) && !0 !== n.has(r) && (n.add(i), n.add(r), !0);
        }
        var Om = Object.freeze({
            __proto__: null,
            BoxGeometry: Wu,
            CapsuleGeometry: Pg,
            CircleGeometry: Ug,
            ConeGeometry: kg,
            CylinderGeometry: jg,
            DodecahedronGeometry: Fg,
            EdgesGeometry: Wg,
            ExtrudeGeometry: xm,
            IcosahedronGeometry: wm,
            LatheGeometry: Rg,
            OctahedronGeometry: Em,
            PlaneGeometry: ph,
            PolyhedronGeometry: Bg,
            RingGeometry: Tm,
            ShapeGeometry: Sm,
            SphereGeometry: Im,
            TetrahedronGeometry: Nm,
            TorusGeometry: Dm,
            TorusKnotGeometry: _m,
            TubeGeometry: Cm,
            WireframeGeometry: Lm
        });
        class Rm extends $c {
            constructor(e1){
                super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new qc(0), this.transparent = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.fog = e1.fog, this;
            }
        }
        class Pm extends Ku {
            constructor(e1){
                super(e1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
            }
        }
        class Um extends $c {
            constructor(e1){
                super(), this.isMeshStandardMaterial = !0, this.defines = {
                    STANDARD: ""
                }, this.type = "MeshStandardMaterial", this.color = new qc(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new qc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    STANDARD: ""
                }, this.color.copy(e1.color), this.roughness = e1.roughness, this.metalness = e1.metalness, this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.roughnessMap = e1.roughnessMap, this.metalnessMap = e1.metalnessMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.envMapIntensity = e1.envMapIntensity, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class jm extends Um {
            constructor(e1){
                super(), this.isMeshPhysicalMaterial = !0, this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new $o(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
                    get: function() {
                        return Vo(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                    },
                    set: function(e1) {
                        this.ior = (1 + .4 * e1) / (1 - .4 * e1);
                    }
                }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
                    100,
                    400
                ], this.iridescenceThicknessMap = null, this.sheenColor = new qc(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new qc(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new qc(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e1);
            }
            get anisotropy() {
                return this._anisotropy;
            }
            set anisotropy(e1) {
                this._anisotropy > 0 != e1 > 0 && this.version++, this._anisotropy = e1;
            }
            get clearcoat() {
                return this._clearcoat;
            }
            set clearcoat(e1) {
                this._clearcoat > 0 != e1 > 0 && this.version++, this._clearcoat = e1;
            }
            get iridescence() {
                return this._iridescence;
            }
            set iridescence(e1) {
                this._iridescence > 0 != e1 > 0 && this.version++, this._iridescence = e1;
            }
            get sheen() {
                return this._sheen;
            }
            set sheen(e1) {
                this._sheen > 0 != e1 > 0 && this.version++, this._sheen = e1;
            }
            get transmission() {
                return this._transmission;
            }
            set transmission(e1) {
                this._transmission > 0 != e1 > 0 && this.version++, this._transmission = e1;
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.anisotropy = e1.anisotropy, this.anisotropyRotation = e1.anisotropyRotation, this.anisotropyMap = e1.anisotropyMap, this.clearcoat = e1.clearcoat, this.clearcoatMap = e1.clearcoatMap, this.clearcoatRoughness = e1.clearcoatRoughness, this.clearcoatRoughnessMap = e1.clearcoatRoughnessMap, this.clearcoatNormalMap = e1.clearcoatNormalMap, this.clearcoatNormalScale.copy(e1.clearcoatNormalScale), this.ior = e1.ior, this.iridescence = e1.iridescence, this.iridescenceMap = e1.iridescenceMap, this.iridescenceIOR = e1.iridescenceIOR, this.iridescenceThicknessRange = [
                    ...e1.iridescenceThicknessRange
                ], this.iridescenceThicknessMap = e1.iridescenceThicknessMap, this.sheen = e1.sheen, this.sheenColor.copy(e1.sheenColor), this.sheenColorMap = e1.sheenColorMap, this.sheenRoughness = e1.sheenRoughness, this.sheenRoughnessMap = e1.sheenRoughnessMap, this.transmission = e1.transmission, this.transmissionMap = e1.transmissionMap, this.thickness = e1.thickness, this.thicknessMap = e1.thicknessMap, this.attenuationDistance = e1.attenuationDistance, this.attenuationColor.copy(e1.attenuationColor), this.specularIntensity = e1.specularIntensity, this.specularIntensityMap = e1.specularIntensityMap, this.specularColor.copy(e1.specularColor), this.specularColorMap = e1.specularColorMap, this;
            }
        }
        class km extends $c {
            constructor(e1){
                super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new qc(16777215), this.specular = new qc(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new qc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Xr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.specular.copy(e1.specular), this.shininess = e1.shininess, this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Bm extends $c {
            constructor(e1){
                super(), this.isMeshToonMaterial = !0, this.defines = {
                    TOON: ""
                }, this.type = "MeshToonMaterial", this.color = new qc(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new qc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.gradientMap = e1.gradientMap, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.alphaMap = e1.alphaMap, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.fog = e1.fog, this;
            }
        }
        class Fm extends $c {
            constructor(e1){
                super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.flatShading = e1.flatShading, this;
            }
        }
        class Hm extends $c {
            constructor(e1){
                super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new qc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new qc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Xr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Gm extends $c {
            constructor(e1){
                super(), this.isMeshMatcapMaterial = !0, this.defines = {
                    MATCAP: ""
                }, this.type = "MeshMatcapMaterial", this.color = new qc(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Hs, this.normalScale = new $o(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    MATCAP: ""
                }, this.color.copy(e1.color), this.matcap = e1.matcap, this.map = e1.map, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.alphaMap = e1.alphaMap, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Vm extends Gf {
            constructor(e1){
                super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.scale = e1.scale, this.dashSize = e1.dashSize, this.gapSize = e1.gapSize, this;
            }
        }
        function Qm(e1, t, n) {
            return !e1 || !n && e1.constructor === t ? e1 : "number" == typeof t.BYTES_PER_ELEMENT ? new t(e1) : Array.prototype.slice.call(e1);
        }
        function Wm(e1) {
            return ArrayBuffer.isView(e1) && !(e1 instanceof DataView);
        }
        function Ym(e1) {
            const t = e1.length, n = new Array(t);
            for(let e1 = 0; e1 !== t; ++e1)n[e1] = e1;
            return n.sort(function(t, n) {
                return e1[t] - e1[n];
            }), n;
        }
        function Xm(e1, t, n) {
            const i = e1.length, r = new e1.constructor(i);
            for(let a = 0, s = 0; s !== i; ++a){
                const i = n[a] * t;
                for(let n = 0; n !== t; ++n)r[s++] = e1[i + n];
            }
            return r;
        }
        function Zm(e1, t, n, i) {
            let r = 1, a = e1[0];
            for(; void 0 !== a && void 0 === a[i];)a = e1[r++];
            if (void 0 === a) return;
            let s = a[i];
            if (void 0 !== s) {
                if (Array.isArray(s)) do s = a[i], void 0 !== s && (t.push(a.time), n.push.apply(n, s)), a = e1[r++];
                while (void 0 !== a);
                else if (void 0 !== s.toArray) do s = a[i], void 0 !== s && (t.push(a.time), s.toArray(n, n.length)), a = e1[r++];
                while (void 0 !== a);
                else do s = a[i], void 0 !== s && (t.push(a.time), n.push(s)), a = e1[r++];
                while (void 0 !== a);
            }
        }
        const qm = {
            convertArray: Qm,
            isTypedArray: Wm,
            getKeyframeOrder: Ym,
            sortedArray: Xm,
            flattenJSON: Zm,
            subclip: function(e1, t, n, i) {
                let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 30;
                const a = e1.clone();
                a.name = t;
                const s = [];
                for(let e1 = 0; e1 < a.tracks.length; ++e1){
                    const t = a.tracks[e1], o = t.getValueSize(), l = [], c = [];
                    for(let e1 = 0; e1 < t.times.length; ++e1){
                        const a = t.times[e1] * r;
                        if (!(a < n || a >= i)) {
                            l.push(t.times[e1]);
                            for(let n = 0; n < o; ++n)c.push(t.values[e1 * o + n]);
                        }
                    }
                    0 !== l.length && (t.times = Qm(l, t.times.constructor), t.values = Qm(c, t.values.constructor), s.push(t));
                }
                a.tracks = s;
                let o = 1 / 0;
                for(let e1 = 0; e1 < a.tracks.length; ++e1)o > a.tracks[e1].times[0] && (o = a.tracks[e1].times[0]);
                for(let e1 = 0; e1 < a.tracks.length; ++e1)a.tracks[e1].shift(-1 * o);
                return a.resetDuration(), a;
            },
            makeClipAdditive: function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 30;
                i <= 0 && (i = 30);
                const r = n.tracks.length, a = t / i;
                for(let t = 0; t < r; ++t){
                    const i = n.tracks[t], r = i.ValueTypeName;
                    if ("bool" === r || "string" === r) continue;
                    const s = e1.tracks.find(function(e1) {
                        return e1.name === i.name && e1.ValueTypeName === r;
                    });
                    if (void 0 === s) continue;
                    let o = 0;
                    const l = i.getValueSize();
                    i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
                    let c = 0;
                    const u = s.getValueSize();
                    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = u / 3);
                    const h = i.times.length - 1;
                    let d;
                    if (a <= i.times[0]) {
                        const e1 = o, t = l - o;
                        d = i.values.slice(e1, t);
                    } else if (a >= i.times[h]) {
                        const e1 = h * l + o, t = e1 + l - o;
                        d = i.values.slice(e1, t);
                    } else {
                        const e1 = i.createInterpolant(), t = o, n = l - o;
                        e1.evaluate(a), d = e1.resultBuffer.slice(t, n);
                    }
                    "quaternion" === r && (new Cl).fromArray(d).normalize().conjugate().toArray(d);
                    const p = s.times.length;
                    for(let e1 = 0; e1 < p; ++e1){
                        const t = e1 * u + c;
                        if ("quaternion" === r) Cl.multiplyQuaternionsFlat(s.values, t, d, 0, s.values, t);
                        else {
                            const e1 = u - 2 * c;
                            for(let n = 0; n < e1; ++n)s.values[t + n] -= d[n];
                        }
                    }
                }
                return e1.blendMode = Os, e1;
            }
        };
        class Km {
            constructor(e1, t, n, i){
                this.parameterPositions = e1, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new t.constructor(n), this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
            }
            evaluate(e1) {
                const t = this.parameterPositions;
                let n = this._cachedIndex, i = t[n], r = t[n - 1];
                e: {
                    t: {
                        let a;
                        n: {
                            i: if (!(e1 < i)) {
                                for(let a = n + 2;;){
                                    if (void 0 === i) {
                                        if (e1 < r) break i;
                                        return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                                    }
                                    if (n === a) break;
                                    if (r = i, i = t[++n], e1 < i) break t;
                                }
                                a = t.length;
                                break n;
                            }
                            if (e1 >= r) break e;
                            {
                                const s = t[1];
                                e1 < s && (n = 2, r = s);
                                for(let a = n - 2;;){
                                    if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                                    if (n === a) break;
                                    if (i = r, r = t[--n - 1], e1 >= r) break t;
                                }
                                a = n, n = 0;
                            }
                        }
                        for(; n < a;){
                            const i = n + a >>> 1;
                            e1 < t[i] ? a = i : n = i + 1;
                        }
                        if (i = t[n], r = t[n - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                        if (void 0 === i) return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                    }
                    this._cachedIndex = n, this.intervalChanged_(n, r, i);
                }
                return this.interpolate_(n, r, e1, i);
            }
            getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
            copySampleValue_(e1) {
                const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e1 * i;
                for(let e1 = 0; e1 !== i; ++e1)t[e1] = n[r + e1];
                return t;
            }
            interpolate_() {
                throw new Error("call to abstract method");
            }
            intervalChanged_() {}
        }
        class Jm extends Km {
            constructor(e1, t, n, i){
                super(e1, t, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                    endingStart: _s,
                    endingEnd: _s
                };
            }
            intervalChanged_(e1, t, n) {
                const i = this.parameterPositions;
                let r = e1 - 2, a = e1 + 1, s = i[r], o = i[a];
                if (void 0 === s) switch(this.getSettings_().endingStart){
                    case Cs:
                        r = e1, s = 2 * t - n;
                        break;
                    case Ls:
                        r = i.length - 2, s = t + i[r] - i[r + 1];
                        break;
                    default:
                        r = e1, s = n;
                }
                if (void 0 === o) switch(this.getSettings_().endingEnd){
                    case Cs:
                        a = e1, o = 2 * n - t;
                        break;
                    case Ls:
                        a = 1, o = n + i[1] - i[0];
                        break;
                    default:
                        a = e1 - 1, o = t;
                }
                const l = .5 * (n - t), c = this.valueSize;
                this._weightPrev = l / (t - s), this._weightNext = l / (o - n), this._offsetPrev = r * c, this._offsetNext = a * c;
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = e1 * s, l = o - s, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, d = this._weightNext, p = (n - t) / (i - t), f = p * p, g = f * p, m = -h * g + 2 * h * f - h * p, A = (1 + h) * g + (-1.5 - 2 * h) * f + (-0.5 + h) * p + 1, M = (-1 - d) * g + (1.5 + d) * f + .5 * p, v = d * g - d * f;
                for(let e1 = 0; e1 !== s; ++e1)r[e1] = m * a[c + e1] + A * a[l + e1] + M * a[o + e1] + v * a[u + e1];
                return r;
            }
        }
        class $m extends Km {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = e1 * s, l = o - s, c = (n - t) / (i - t), u = 1 - c;
                for(let e1 = 0; e1 !== s; ++e1)r[e1] = a[l + e1] * u + a[o + e1] * c;
                return r;
            }
        }
        class eA extends Km {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1) {
                return this.copySampleValue_(e1 - 1);
            }
        }
        class tA {
            constructor(e1, t, n, i){
                if (void 0 === e1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                if (void 0 === t || 0 === t.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e1);
                this.name = e1, this.times = Qm(t, this.TimeBufferType), this.values = Qm(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
            }
            static toJSON(e1) {
                const t = e1.constructor;
                let n;
                if (t.toJSON !== this.toJSON) n = t.toJSON(e1);
                else {
                    n = {
                        name: e1.name,
                        times: Qm(e1.times, Array),
                        values: Qm(e1.values, Array)
                    };
                    const t = e1.getInterpolation();
                    t !== e1.DefaultInterpolation && (n.interpolation = t);
                }
                return n.type = e1.ValueTypeName, n;
            }
            InterpolantFactoryMethodDiscrete(e1) {
                return new eA(this.times, this.values, this.getValueSize(), e1);
            }
            InterpolantFactoryMethodLinear(e1) {
                return new $m(this.times, this.values, this.getValueSize(), e1);
            }
            InterpolantFactoryMethodSmooth(e1) {
                return new Jm(this.times, this.values, this.getValueSize(), e1);
            }
            setInterpolation(e1) {
                let t;
                switch(e1){
                    case Is:
                        t = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case Ns:
                        t = this.InterpolantFactoryMethodLinear;
                        break;
                    case Ds:
                        t = this.InterpolantFactoryMethodSmooth;
                }
                if (void 0 === t) {
                    const t = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                    if (void 0 === this.createInterpolant) {
                        if (e1 === this.DefaultInterpolation) throw new Error(t);
                        this.setInterpolation(this.DefaultInterpolation);
                    }
                    return console.warn("THREE.KeyframeTrack:", t), this;
                }
                return this.createInterpolant = t, this;
            }
            getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return Is;
                    case this.InterpolantFactoryMethodLinear:
                        return Ns;
                    case this.InterpolantFactoryMethodSmooth:
                        return Ds;
                }
            }
            getValueSize() {
                return this.values.length / this.times.length;
            }
            shift(e1) {
                if (0 !== e1) {
                    const t = this.times;
                    for(let n = 0, i = t.length; n !== i; ++n)t[n] += e1;
                }
                return this;
            }
            scale(e1) {
                if (1 !== e1) {
                    const t = this.times;
                    for(let n = 0, i = t.length; n !== i; ++n)t[n] *= e1;
                }
                return this;
            }
            trim(e1, t) {
                const n = this.times, i = n.length;
                let r = 0, a = i - 1;
                for(; r !== i && n[r] < e1;)++r;
                for(; -1 !== a && n[a] > t;)--a;
                if (++a, 0 !== r || a !== i) {
                    r >= a && (a = Math.max(a, 1), r = a - 1);
                    const e1 = this.getValueSize();
                    this.times = n.slice(r, a), this.values = this.values.slice(r * e1, a * e1);
                }
                return this;
            }
            validate() {
                let e1 = !0;
                const t = this.getValueSize();
                t - Math.floor(t) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e1 = !1);
                const n = this.times, i = this.values, r = n.length;
                0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), e1 = !1);
                let a = null;
                for(let t = 0; t !== r; t++){
                    const i = n[t];
                    if ("number" == typeof i && isNaN(i)) {
                        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, t, i), e1 = !1;
                        break;
                    }
                    if (null !== a && a > i) {
                        console.error("THREE.KeyframeTrack: Out of order keys.", this, t, i, a), e1 = !1;
                        break;
                    }
                    a = i;
                }
                if (void 0 !== i && Wm(i)) for(let t = 0, n = i.length; t !== n; ++t){
                    const n = i[t];
                    if (isNaN(n)) {
                        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, t, n), e1 = !1;
                        break;
                    }
                }
                return e1;
            }
            optimize() {
                const e1 = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), i = this.getInterpolation() === Ds, r = e1.length - 1;
                let a = 1;
                for(let s = 1; s < r; ++s){
                    let r = !1;
                    const o = e1[s];
                    if (o !== e1[s + 1] && (1 !== s || o !== e1[0])) {
                        if (i) r = !0;
                        else {
                            const e1 = s * n, i = e1 - n, a = e1 + n;
                            for(let s = 0; s !== n; ++s){
                                const n = t[e1 + s];
                                if (n !== t[i + s] || n !== t[a + s]) {
                                    r = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (r) {
                        if (s !== a) {
                            e1[a] = e1[s];
                            const i = s * n, r = a * n;
                            for(let e1 = 0; e1 !== n; ++e1)t[r + e1] = t[i + e1];
                        }
                        ++a;
                    }
                }
                if (r > 0) {
                    e1[a] = e1[r];
                    for(let e1 = r * n, i = a * n, s = 0; s !== n; ++s)t[i + s] = t[e1 + s];
                    ++a;
                }
                return a !== e1.length ? (this.times = e1.slice(0, a), this.values = t.slice(0, a * n)) : (this.times = e1, this.values = t), this;
            }
            clone() {
                const e1 = this.times.slice(), t = this.values.slice(), n = new this.constructor(this.name, e1, t);
                return n.createInterpolant = this.createInterpolant, n;
            }
        }
        tA.prototype.TimeBufferType = Float32Array, tA.prototype.ValueBufferType = Float32Array, tA.prototype.DefaultInterpolation = Ns;
        class nA extends tA {
        }
        nA.prototype.ValueTypeName = "bool", nA.prototype.ValueBufferType = Array, nA.prototype.DefaultInterpolation = Is, nA.prototype.InterpolantFactoryMethodLinear = void 0, nA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class iA extends tA {
        }
        iA.prototype.ValueTypeName = "color";
        class rA extends tA {
        }
        rA.prototype.ValueTypeName = "number";
        class aA extends Km {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = (n - t) / (i - t);
                let l = e1 * s;
                for(let e1 = l + s; l !== e1; l += 4)Cl.slerpFlat(r, 0, a, l - s, a, l, o);
                return r;
            }
        }
        class sA extends tA {
            InterpolantFactoryMethodLinear(e1) {
                return new aA(this.times, this.values, this.getValueSize(), e1);
            }
        }
        sA.prototype.ValueTypeName = "quaternion", sA.prototype.DefaultInterpolation = Ns, sA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class oA extends tA {
        }
        oA.prototype.ValueTypeName = "string", oA.prototype.ValueBufferType = Array, oA.prototype.DefaultInterpolation = Is, oA.prototype.InterpolantFactoryMethodLinear = void 0, oA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class lA extends tA {
        }
        lA.prototype.ValueTypeName = "vector";
        class cA {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1, n = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : zs;
                this.name = e1, this.tracks = n, this.duration = t, this.blendMode = i, this.uuid = Go(), this.duration < 0 && this.resetDuration();
            }
            static parse(e1) {
                const t = [], n = e1.tracks, i = 1 / (e1.fps || 1);
                for(let e1 = 0, r = n.length; e1 !== r; ++e1)t.push(uA(n[e1]).scale(i));
                const r = new this(e1.name, e1.duration, t, e1.blendMode);
                return r.uuid = e1.uuid, r;
            }
            static toJSON(e1) {
                const t = [], n = e1.tracks, i = {
                    name: e1.name,
                    duration: e1.duration,
                    tracks: t,
                    uuid: e1.uuid,
                    blendMode: e1.blendMode
                };
                for(let e1 = 0, i = n.length; e1 !== i; ++e1)t.push(tA.toJSON(n[e1]));
                return i;
            }
            static CreateFromMorphTargetSequence(e1, t, n, i) {
                const r = t.length, a = [];
                for(let e1 = 0; e1 < r; e1++){
                    let s = [], o = [];
                    s.push((e1 + r - 1) % r, e1, (e1 + 1) % r), o.push(0, 1, 0);
                    const l = Ym(s);
                    s = Xm(s, 1, l), o = Xm(o, 1, l), i || 0 !== s[0] || (s.push(r), o.push(o[0])), a.push(new rA(".morphTargetInfluences[" + t[e1].name + "]", s, o).scale(1 / n));
                }
                return new this(e1, -1, a);
            }
            static findByName(e1, t) {
                let n = e1;
                if (!Array.isArray(e1)) {
                    const t = e1;
                    n = t.geometry && t.geometry.animations || t.animations;
                }
                for(let e1 = 0; e1 < n.length; e1++)if (n[e1].name === t) return n[e1];
                return null;
            }
            static CreateClipsFromMorphTargetSequences(e1, t, n) {
                const i = {}, r = /^([\w-]*?)([\d]+)$/;
                for(let t = 0, n = e1.length; t < n; t++){
                    const n = e1[t], a = n.name.match(r);
                    if (a && a.length > 1) {
                        const e1 = a[1];
                        let t = i[e1];
                        t || (i[e1] = t = []), t.push(n);
                    }
                }
                const a = [];
                for(const e1 in i)a.push(this.CreateFromMorphTargetSequence(e1, i[e1], t, n));
                return a;
            }
            static parseAnimation(e1, t) {
                if (!e1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
                const n = function(e1, t, n, i, r) {
                    if (0 !== n.length) {
                        const a = [], s = [];
                        Zm(n, a, s, i), 0 !== a.length && r.push(new e1(t, a, s));
                    }
                }, i = [], r = e1.name || "default", a = e1.fps || 30, s = e1.blendMode;
                let o = e1.length || -1;
                const l = e1.hierarchy || [];
                for(let e1 = 0; e1 < l.length; e1++){
                    const r = l[e1].keys;
                    if (r && 0 !== r.length) {
                        if (r[0].morphTargets) {
                            const e1 = {};
                            let t;
                            for(t = 0; t < r.length; t++)if (r[t].morphTargets) for(let n = 0; n < r[t].morphTargets.length; n++)e1[r[t].morphTargets[n]] = -1;
                            for(const n in e1){
                                const e1 = [], a = [];
                                for(let i = 0; i !== r[t].morphTargets.length; ++i){
                                    const i = r[t];
                                    e1.push(i.time), a.push(i.morphTarget === n ? 1 : 0);
                                }
                                i.push(new rA(".morphTargetInfluence[" + n + "]", e1, a));
                            }
                            o = e1.length * a;
                        } else {
                            const a = ".bones[" + t[e1].name + "]";
                            n(lA, a + ".position", r, "pos", i), n(sA, a + ".quaternion", r, "rot", i), n(lA, a + ".scale", r, "scl", i);
                        }
                    }
                }
                return 0 === i.length ? null : new this(r, o, i, s);
            }
            resetDuration() {
                let e1 = 0;
                for(let t = 0, n = this.tracks.length; t !== n; ++t){
                    const n = this.tracks[t];
                    e1 = Math.max(e1, n.times[n.times.length - 1]);
                }
                return this.duration = e1, this;
            }
            trim() {
                for(let e1 = 0; e1 < this.tracks.length; e1++)this.tracks[e1].trim(0, this.duration);
                return this;
            }
            validate() {
                let e1 = !0;
                for(let t = 0; t < this.tracks.length; t++)e1 = e1 && this.tracks[t].validate();
                return e1;
            }
            optimize() {
                for(let e1 = 0; e1 < this.tracks.length; e1++)this.tracks[e1].optimize();
                return this;
            }
            clone() {
                const e1 = [];
                for(let t = 0; t < this.tracks.length; t++)e1.push(this.tracks[t].clone());
                return new this.constructor(this.name, this.duration, e1, this.blendMode);
            }
            toJSON() {
                return this.constructor.toJSON(this);
            }
        }
        function uA(e1) {
            if (void 0 === e1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            const t = function(e1) {
                switch(e1.toLowerCase()){
                    case "scalar":
                    case "double":
                    case "float":
                    case "number":
                    case "integer":
                        return rA;
                    case "vector":
                    case "vector2":
                    case "vector3":
                    case "vector4":
                        return lA;
                    case "color":
                        return iA;
                    case "quaternion":
                        return sA;
                    case "bool":
                    case "boolean":
                        return nA;
                    case "string":
                        return oA;
                }
                throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + e1);
            }(e1.type);
            if (void 0 === e1.times) {
                const t = [], n = [];
                Zm(e1.keys, t, n, "value"), e1.times = t, e1.values = n;
            }
            return void 0 !== t.parse ? t.parse(e1) : new t(e1.name, e1.times, e1.values, e1.interpolation);
        }
        const hA = {
            enabled: !1,
            files: {},
            add: function(e1, t) {
                !1 !== this.enabled && (this.files[e1] = t);
            },
            get: function(e1) {
                if (!1 !== this.enabled) return this.files[e1];
            },
            remove: function(e1) {
                delete this.files[e1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class dA {
            constructor(e1, t, n){
                const i = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = e1, this.onProgress = t, this.onError = n, this.itemStart = function(e1) {
                    o++, !1 === a && void 0 !== i.onStart && i.onStart(e1, s, o), a = !0;
                }, this.itemEnd = function(e1) {
                    s++, void 0 !== i.onProgress && i.onProgress(e1, s, o), s === o && (a = !1, void 0 !== i.onLoad && i.onLoad());
                }, this.itemError = function(e1) {
                    void 0 !== i.onError && i.onError(e1);
                }, this.resolveURL = function(e1) {
                    return r ? r(e1) : e1;
                }, this.setURLModifier = function(e1) {
                    return r = e1, this;
                }, this.addHandler = function(e1, t) {
                    return l.push(e1, t), this;
                }, this.removeHandler = function(e1) {
                    const t = l.indexOf(e1);
                    return -1 !== t && l.splice(t, 2), this;
                }, this.getHandler = function(e1) {
                    for(let t = 0, n = l.length; t < n; t += 2){
                        const n = l[t], i = l[t + 1];
                        if (n.global && (n.lastIndex = 0), n.test(e1)) return i;
                    }
                    return null;
                };
            }
        }
        const pA = new dA;
        class fA {
            constructor(e1){
                this.manager = void 0 !== e1 ? e1 : pA, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.load(e1, i, t, r);
                });
            }
            parse() {}
            setCrossOrigin(e1) {
                return this.crossOrigin = e1, this;
            }
            setWithCredentials(e1) {
                return this.withCredentials = e1, this;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            setResourcePath(e1) {
                return this.resourcePath = e1, this;
            }
            setRequestHeader(e1) {
                return this.requestHeader = e1, this;
            }
        }
        fA.DEFAULT_MATERIAL_NAME = "__DEFAULT";
        const gA = {};
        class mA extends Error {
            constructor(e1, t){
                super(e1), this.response = t;
            }
        }
        class AA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 === e1 && (e1 = ""), void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = hA.get(e1);
                if (void 0 !== r) return this.manager.itemStart(e1), setTimeout(()=>{
                    t && t(r), this.manager.itemEnd(e1);
                }, 0), r;
                if (void 0 !== gA[e1]) return void gA[e1].push({
                    onLoad: t,
                    onProgress: n,
                    onError: i
                });
                gA[e1] = [], gA[e1].push({
                    onLoad: t,
                    onProgress: n,
                    onError: i
                });
                const a = new Request(e1, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? "include" : "same-origin"
                }), s = this.mimeType, o = this.responseType;
                fetch(a).then((t)=>{
                    if (200 === t.status || 0 === t.status) {
                        if (0 === t.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === t.body || void 0 === t.body.getReader) return t;
                        const n = gA[e1], i = t.body.getReader(), r = t.headers.get("Content-Length") || t.headers.get("X-File-Size"), a = r ? parseInt(r) : 0, s = 0 !== a;
                        let o = 0;
                        const l = new ReadableStream({
                            start (e1) {
                                !function t() {
                                    i.read().then((i)=>{
                                        let { done: r, value: l } = i;
                                        if (r) e1.close();
                                        else {
                                            o += l.byteLength;
                                            const i = new ProgressEvent("progress", {
                                                lengthComputable: s,
                                                loaded: o,
                                                total: a
                                            });
                                            for(let e1 = 0, t = n.length; e1 < t; e1++){
                                                const t = n[e1];
                                                t.onProgress && t.onProgress(i);
                                            }
                                            e1.enqueue(l), t();
                                        }
                                    });
                                }();
                            }
                        });
                        return new Response(l);
                    }
                    throw new mA(`fetch for "${t.url}" responded with ${t.status}: ${t.statusText}`, t);
                }).then((e1)=>{
                    switch(o){
                        case "arraybuffer":
                            return e1.arrayBuffer();
                        case "blob":
                            return e1.blob();
                        case "document":
                            return e1.text().then((e1)=>(new DOMParser).parseFromString(e1, s));
                        case "json":
                            return e1.json();
                        default:
                            if (void 0 === s) return e1.text();
                            {
                                const t = /charset="?([^;"\s]*)"?/i.exec(s), n = t && t[1] ? t[1].toLowerCase() : void 0, i = new TextDecoder(n);
                                return e1.arrayBuffer().then((e1)=>i.decode(e1));
                            }
                    }
                }).then((t)=>{
                    hA.add(e1, t);
                    const n = gA[e1];
                    delete gA[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++){
                        const i = n[e1];
                        i.onLoad && i.onLoad(t);
                    }
                }).catch((t)=>{
                    const n = gA[e1];
                    if (void 0 === n) throw this.manager.itemError(e1), t;
                    delete gA[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++){
                        const i = n[e1];
                        i.onError && i.onError(t);
                    }
                    this.manager.itemError(e1);
                }).finally(()=>{
                    this.manager.itemEnd(e1);
                }), this.manager.itemStart(e1);
            }
            setResponseType(e1) {
                return this.responseType = e1, this;
            }
            setMimeType(e1) {
                return this.mimeType = e1, this;
            }
        }
        class MA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(this.manager);
                a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = [];
                for(let n = 0; n < e1.length; n++){
                    const i = cA.parse(e1[n]);
                    t.push(i);
                }
                return t;
            }
        }
        class vA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = [], s = new cg, o = new AA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
                let l = 0;
                function c(c) {
                    o.load(e1[c], function(e1) {
                        const n = r.parse(e1, !0);
                        a[c] = {
                            width: n.width,
                            height: n.height,
                            format: n.format,
                            mipmaps: n.mipmaps
                        }, l += 1, 6 === l && (1 === n.mipmapCount && (s.minFilter = va), s.image = a, s.format = n.format, s.needsUpdate = !0, t && t(s));
                    }, n, i);
                }
                if (Array.isArray(e1)) for(let t = 0, n = e1.length; t < n; ++t)c(t);
                else o.load(e1, function(e1) {
                    const n = r.parse(e1, !0);
                    if (n.isCubemap) {
                        const e1 = n.mipmaps.length / n.mipmapCount;
                        for(let t = 0; t < e1; t++){
                            a[t] = {
                                mipmaps: []
                            };
                            for(let e1 = 0; e1 < n.mipmapCount; e1++)a[t].mipmaps.push(n.mipmaps[t * n.mipmapCount + e1]), a[t].format = n.format, a[t].width = n.width, a[t].height = n.height;
                        }
                        s.image = a;
                    } else s.image.width = n.width, s.image.height = n.height, s.mipmaps = n.mipmaps;
                    1 === n.mipmapCount && (s.minFilter = va), s.format = n.format, s.needsUpdate = !0, t && t(s);
                }, n, i);
                return s;
            }
        }
        class yA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = hA.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = al("img");
                function o() {
                    c(), hA.add(e1, this), t && t(this), r.manager.itemEnd(e1);
                }
                function l(t) {
                    c(), i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(e1), s.src = e1, s;
            }
        }
        class xA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new nh;
                r.colorSpace = Qs;
                const a = new yA(this.manager);
                a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
                let s = 0;
                function o(n) {
                    a.load(e1[n], function(e1) {
                        r.images[n] = e1, s++, 6 === s && (r.needsUpdate = !0, t && t(r));
                    }, void 0, i);
                }
                for(let t = 0; t < e1.length; ++t)o(t);
                return r;
            }
        }
        class bA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new _f, s = new AA(this.manager);
                return s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setPath(this.path), s.setWithCredentials(r.withCredentials), s.load(e1, function(e1) {
                    let n;
                    try {
                        n = r.parse(e1);
                    } catch (e1) {
                        if (void 0 === i) return void console.error(e1);
                        i(e1);
                    }
                    void 0 !== n.image ? a.image = n.image : void 0 !== n.data && (a.image.width = n.width, a.image.height = n.height, a.image.data = n.data), a.wrapS = void 0 !== n.wrapS ? n.wrapS : da, a.wrapT = void 0 !== n.wrapT ? n.wrapT : da, a.magFilter = void 0 !== n.magFilter ? n.magFilter : va, a.minFilter = void 0 !== n.minFilter ? n.minFilter : va, a.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.colorSpace ? a.colorSpace = n.colorSpace : void 0 !== n.encoding && (a.encoding = n.encoding), void 0 !== n.flipY && (a.flipY = n.flipY), void 0 !== n.format && (a.format = n.format), void 0 !== n.type && (a.type = n.type), void 0 !== n.mipmaps && (a.mipmaps = n.mipmaps, a.minFilter = ba), 1 === n.mipmapCount && (a.minFilter = va), void 0 !== n.generateMipmaps && (a.generateMipmaps = n.generateMipmaps), a.needsUpdate = !0, t && t(a, n);
                }, n, i), a;
            }
        }
        class wA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new bl, a = new yA(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e1, function(e1) {
                    r.image = e1, r.needsUpdate = !0, void 0 !== t && t(r);
                }, n, i), r;
            }
        }
        class EA extends zc {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                super(), this.isLight = !0, this.type = "Light", this.color = new qc(e1), this.intensity = t;
            }
            dispose() {}
            copy(e1, t) {
                return super.copy(e1, t), this.color.copy(e1.color), this.intensity = e1.intensity, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, void 0 !== this.groundColor && (t.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (t.object.distance = this.distance), void 0 !== this.angle && (t.object.angle = this.angle), void 0 !== this.decay && (t.object.decay = this.decay), void 0 !== this.penumbra && (t.object.penumbra = this.penumbra), void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()), t;
            }
        }
        class TA extends EA {
            constructor(e1, t, n){
                super(e1, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(zc.DEFAULT_UP), this.updateMatrix(), this.groundColor = new qc(t);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.groundColor.copy(e1.groundColor), this;
            }
        }
        const SA = new lc, IA = new Ll, NA = new Ll;
        class DA {
            constructor(e1){
                this.camera = e1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new $o(512, 512), this.map = null, this.mapPass = null, this.matrix = new lc, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new uh, this._frameExtents = new $o(1, 1), this._viewportCount = 1, this._viewports = [
                    new wl(0, 0, 1, 1)
                ];
            }
            getViewportCount() {
                return this._viewportCount;
            }
            getFrustum() {
                return this._frustum;
            }
            updateMatrices(e1) {
                const t = this.camera, n = this.matrix;
                IA.setFromMatrixPosition(e1.matrixWorld), t.position.copy(IA), NA.setFromMatrixPosition(e1.target.matrixWorld), t.lookAt(NA), t.updateMatrixWorld(), SA.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(SA), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(SA);
            }
            getViewport(e1) {
                return this._viewports[e1];
            }
            getFrameExtents() {
                return this._frameExtents;
            }
            dispose() {
                this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
            }
            copy(e1) {
                return this.camera = e1.camera.clone(), this.bias = e1.bias, this.radius = e1.radius, this.mapSize.copy(e1.mapSize), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            toJSON() {
                const e1 = {};
                return 0 !== this.bias && (e1.bias = this.bias), 0 !== this.normalBias && (e1.normalBias = this.normalBias), 1 !== this.radius && (e1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (e1.mapSize = this.mapSize.toArray()), e1.camera = this.camera.toJSON(!1).object, delete e1.camera.matrix, e1;
            }
        }
        class _A extends DA {
            constructor(){
                super(new $u(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
            }
            updateMatrices(e1) {
                const t = this.camera, n = 2 * Ho * e1.angle * this.focus, i = this.mapSize.width / this.mapSize.height, r = e1.distance || t.far;
                n === t.fov && i === t.aspect && r === t.far || (t.fov = n, t.aspect = i, t.far = r, t.updateProjectionMatrix()), super.updateMatrices(e1);
            }
            copy(e1) {
                return super.copy(e1), this.focus = e1.focus, this;
            }
        }
        class CA extends EA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Math.PI / 3, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2;
                super(e1, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(zc.DEFAULT_UP), this.updateMatrix(), this.target = new zc, this.distance = n, this.angle = i, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new _A;
            }
            get power() {
                return this.intensity * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / Math.PI;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.distance = e1.distance, this.angle = e1.angle, this.penumbra = e1.penumbra, this.decay = e1.decay, this.target = e1.target.clone(), this.shadow = e1.shadow.clone(), this;
            }
        }
        const LA = new lc, zA = new Ll, OA = new Ll;
        class RA extends DA {
            constructor(){
                super(new $u(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new $o(4, 2), this._viewportCount = 6, this._viewports = [
                    new wl(2, 1, 1, 1),
                    new wl(0, 1, 1, 1),
                    new wl(3, 1, 1, 1),
                    new wl(1, 1, 1, 1),
                    new wl(3, 0, 1, 1),
                    new wl(1, 0, 1, 1)
                ], this._cubeDirections = [
                    new Ll(1, 0, 0),
                    new Ll(-1, 0, 0),
                    new Ll(0, 0, 1),
                    new Ll(0, 0, -1),
                    new Ll(0, 1, 0),
                    new Ll(0, -1, 0)
                ], this._cubeUps = [
                    new Ll(0, 1, 0),
                    new Ll(0, 1, 0),
                    new Ll(0, 1, 0),
                    new Ll(0, 1, 0),
                    new Ll(0, 0, 1),
                    new Ll(0, 0, -1)
                ];
            }
            updateMatrices(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.camera, i = this.matrix, r = e1.distance || n.far;
                r !== n.far && (n.far = r, n.updateProjectionMatrix()), zA.setFromMatrixPosition(e1.matrixWorld), n.position.copy(zA), OA.copy(n.position), OA.add(this._cubeDirections[t]), n.up.copy(this._cubeUps[t]), n.lookAt(OA), n.updateMatrixWorld(), i.makeTranslation(-zA.x, -zA.y, -zA.z), LA.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(LA);
            }
        }
        class PA extends EA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2;
                super(e1, t), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new RA;
            }
            get power() {
                return 4 * this.intensity * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / (4 * Math.PI);
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.distance = e1.distance, this.decay = e1.decay, this.shadow = e1.shadow.clone(), this;
            }
        }
        class UA extends DA {
            constructor(){
                super(new Eh(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
            }
        }
        class jA extends EA {
            constructor(e1, t){
                super(e1, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(zc.DEFAULT_UP), this.updateMatrix(), this.target = new zc, this.shadow = new UA;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1) {
                return super.copy(e1), this.target = e1.target.clone(), this.shadow = e1.shadow.clone(), this;
            }
        }
        class kA extends EA {
            constructor(e1, t){
                super(e1, t), this.isAmbientLight = !0, this.type = "AmbientLight";
            }
        }
        class BA extends EA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 10;
                super(e1, t), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = n, this.height = i;
            }
            get power() {
                return this.intensity * this.width * this.height * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / (this.width * this.height * Math.PI);
            }
            copy(e1) {
                return super.copy(e1), this.width = e1.width, this.height = e1.height, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.width = this.width, t.object.height = this.height, t;
            }
        }
        class FA {
            constructor(){
                this.isSphericalHarmonics3 = !0, this.coefficients = [];
                for(let e1 = 0; e1 < 9; e1++)this.coefficients.push(new Ll);
            }
            set(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].copy(e1[t]);
                return this;
            }
            zero() {
                for(let e1 = 0; e1 < 9; e1++)this.coefficients[e1].set(0, 0, 0);
                return this;
            }
            getAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = this.coefficients;
                return t.copy(a[0]).multiplyScalar(.282095), t.addScaledVector(a[1], .488603 * i), t.addScaledVector(a[2], .488603 * r), t.addScaledVector(a[3], .488603 * n), t.addScaledVector(a[4], n * i * 1.092548), t.addScaledVector(a[5], i * r * 1.092548), t.addScaledVector(a[6], .315392 * (3 * r * r - 1)), t.addScaledVector(a[7], n * r * 1.092548), t.addScaledVector(a[8], .546274 * (n * n - i * i)), t;
            }
            getIrradianceAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = this.coefficients;
                return t.copy(a[0]).multiplyScalar(.886227), t.addScaledVector(a[1], 1.023328 * i), t.addScaledVector(a[2], 1.023328 * r), t.addScaledVector(a[3], 1.023328 * n), t.addScaledVector(a[4], .858086 * n * i), t.addScaledVector(a[5], .858086 * i * r), t.addScaledVector(a[6], .743125 * r * r - .247708), t.addScaledVector(a[7], .858086 * n * r), t.addScaledVector(a[8], .429043 * (n * n - i * i)), t;
            }
            add(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].add(e1.coefficients[t]);
                return this;
            }
            addScaledSH(e1, t) {
                for(let n = 0; n < 9; n++)this.coefficients[n].addScaledVector(e1.coefficients[n], t);
                return this;
            }
            scale(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].multiplyScalar(e1);
                return this;
            }
            lerp(e1, t) {
                for(let n = 0; n < 9; n++)this.coefficients[n].lerp(e1.coefficients[n], t);
                return this;
            }
            equals(e1) {
                for(let t = 0; t < 9; t++)if (!this.coefficients[t].equals(e1.coefficients[t])) return !1;
                return !0;
            }
            copy(e1) {
                return this.set(e1.coefficients);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].fromArray(e1, t + 3 * i);
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].toArray(e1, t + 3 * i);
                return e1;
            }
            static getBasisAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z;
                t[0] = .282095, t[1] = .488603 * i, t[2] = .488603 * r, t[3] = .488603 * n, t[4] = 1.092548 * n * i, t[5] = 1.092548 * i * r, t[6] = .315392 * (3 * r * r - 1), t[7] = 1.092548 * n * r, t[8] = .546274 * (n * n - i * i);
            }
        }
        class HA extends EA {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new FA;
                super(void 0, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1), this.isLightProbe = !0, this.sh = e1;
            }
            copy(e1) {
                return super.copy(e1), this.sh.copy(e1.sh), this;
            }
            fromJSON(e1) {
                return this.intensity = e1.intensity, this.sh.fromArray(e1.sh), this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.sh = this.sh.toArray(), t;
            }
        }
        class GA extends fA {
            constructor(e1){
                super(e1), this.textures = {};
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = this.textures;
                function n(e1) {
                    return void 0 === t[e1] && console.warn("THREE.MaterialLoader: Undefined texture", e1), t[e1];
                }
                const i = GA.createMaterialFromType(e1.type);
                if (void 0 !== e1.uuid && (i.uuid = e1.uuid), void 0 !== e1.name && (i.name = e1.name), void 0 !== e1.color && void 0 !== i.color && i.color.setHex(e1.color), void 0 !== e1.roughness && (i.roughness = e1.roughness), void 0 !== e1.metalness && (i.metalness = e1.metalness), void 0 !== e1.sheen && (i.sheen = e1.sheen), void 0 !== e1.sheenColor && (i.sheenColor = (new qc).setHex(e1.sheenColor)), void 0 !== e1.sheenRoughness && (i.sheenRoughness = e1.sheenRoughness), void 0 !== e1.emissive && void 0 !== i.emissive && i.emissive.setHex(e1.emissive), void 0 !== e1.specular && void 0 !== i.specular && i.specular.setHex(e1.specular), void 0 !== e1.specularIntensity && (i.specularIntensity = e1.specularIntensity), void 0 !== e1.specularColor && void 0 !== i.specularColor && i.specularColor.setHex(e1.specularColor), void 0 !== e1.shininess && (i.shininess = e1.shininess), void 0 !== e1.clearcoat && (i.clearcoat = e1.clearcoat), void 0 !== e1.clearcoatRoughness && (i.clearcoatRoughness = e1.clearcoatRoughness), void 0 !== e1.iridescence && (i.iridescence = e1.iridescence), void 0 !== e1.iridescenceIOR && (i.iridescenceIOR = e1.iridescenceIOR), void 0 !== e1.iridescenceThicknessRange && (i.iridescenceThicknessRange = e1.iridescenceThicknessRange), void 0 !== e1.transmission && (i.transmission = e1.transmission), void 0 !== e1.thickness && (i.thickness = e1.thickness), void 0 !== e1.attenuationDistance && (i.attenuationDistance = e1.attenuationDistance), void 0 !== e1.attenuationColor && void 0 !== i.attenuationColor && i.attenuationColor.setHex(e1.attenuationColor), void 0 !== e1.anisotropy && (i.anisotropy = e1.anisotropy), void 0 !== e1.anisotropyRotation && (i.anisotropyRotation = e1.anisotropyRotation), void 0 !== e1.fog && (i.fog = e1.fog), void 0 !== e1.flatShading && (i.flatShading = e1.flatShading), void 0 !== e1.blending && (i.blending = e1.blending), void 0 !== e1.combine && (i.combine = e1.combine), void 0 !== e1.side && (i.side = e1.side), void 0 !== e1.shadowSide && (i.shadowSide = e1.shadowSide), void 0 !== e1.opacity && (i.opacity = e1.opacity), void 0 !== e1.transparent && (i.transparent = e1.transparent), void 0 !== e1.alphaTest && (i.alphaTest = e1.alphaTest), void 0 !== e1.alphaHash && (i.alphaHash = e1.alphaHash), void 0 !== e1.depthFunc && (i.depthFunc = e1.depthFunc), void 0 !== e1.depthTest && (i.depthTest = e1.depthTest), void 0 !== e1.depthWrite && (i.depthWrite = e1.depthWrite), void 0 !== e1.colorWrite && (i.colorWrite = e1.colorWrite), void 0 !== e1.blendSrc && (i.blendSrc = e1.blendSrc), void 0 !== e1.blendDst && (i.blendDst = e1.blendDst), void 0 !== e1.blendEquation && (i.blendEquation = e1.blendEquation), void 0 !== e1.blendSrcAlpha && (i.blendSrcAlpha = e1.blendSrcAlpha), void 0 !== e1.blendDstAlpha && (i.blendDstAlpha = e1.blendDstAlpha), void 0 !== e1.blendEquationAlpha && (i.blendEquationAlpha = e1.blendEquationAlpha), void 0 !== e1.blendColor && void 0 !== i.blendColor && i.blendColor.setHex(e1.blendColor), void 0 !== e1.blendAlpha && (i.blendAlpha = e1.blendAlpha), void 0 !== e1.stencilWriteMask && (i.stencilWriteMask = e1.stencilWriteMask), void 0 !== e1.stencilFunc && (i.stencilFunc = e1.stencilFunc), void 0 !== e1.stencilRef && (i.stencilRef = e1.stencilRef), void 0 !== e1.stencilFuncMask && (i.stencilFuncMask = e1.stencilFuncMask), void 0 !== e1.stencilFail && (i.stencilFail = e1.stencilFail), void 0 !== e1.stencilZFail && (i.stencilZFail = e1.stencilZFail), void 0 !== e1.stencilZPass && (i.stencilZPass = e1.stencilZPass), void 0 !== e1.stencilWrite && (i.stencilWrite = e1.stencilWrite), void 0 !== e1.wireframe && (i.wireframe = e1.wireframe), void 0 !== e1.wireframeLinewidth && (i.wireframeLinewidth = e1.wireframeLinewidth), void 0 !== e1.wireframeLinecap && (i.wireframeLinecap = e1.wireframeLinecap), void 0 !== e1.wireframeLinejoin && (i.wireframeLinejoin = e1.wireframeLinejoin), void 0 !== e1.rotation && (i.rotation = e1.rotation), void 0 !== e1.linewidth && (i.linewidth = e1.linewidth), void 0 !== e1.dashSize && (i.dashSize = e1.dashSize), void 0 !== e1.gapSize && (i.gapSize = e1.gapSize), void 0 !== e1.scale && (i.scale = e1.scale), void 0 !== e1.polygonOffset && (i.polygonOffset = e1.polygonOffset), void 0 !== e1.polygonOffsetFactor && (i.polygonOffsetFactor = e1.polygonOffsetFactor), void 0 !== e1.polygonOffsetUnits && (i.polygonOffsetUnits = e1.polygonOffsetUnits), void 0 !== e1.dithering && (i.dithering = e1.dithering), void 0 !== e1.alphaToCoverage && (i.alphaToCoverage = e1.alphaToCoverage), void 0 !== e1.premultipliedAlpha && (i.premultipliedAlpha = e1.premultipliedAlpha), void 0 !== e1.forceSinglePass && (i.forceSinglePass = e1.forceSinglePass), void 0 !== e1.visible && (i.visible = e1.visible), void 0 !== e1.toneMapped && (i.toneMapped = e1.toneMapped), void 0 !== e1.userData && (i.userData = e1.userData), void 0 !== e1.vertexColors && ("number" == typeof e1.vertexColors ? i.vertexColors = e1.vertexColors > 0 : i.vertexColors = e1.vertexColors), void 0 !== e1.uniforms) for(const t in e1.uniforms){
                    const r = e1.uniforms[t];
                    switch(i.uniforms[t] = {}, r.type){
                        case "t":
                            i.uniforms[t].value = n(r.value);
                            break;
                        case "c":
                            i.uniforms[t].value = (new qc).setHex(r.value);
                            break;
                        case "v2":
                            i.uniforms[t].value = (new $o).fromArray(r.value);
                            break;
                        case "v3":
                            i.uniforms[t].value = (new Ll).fromArray(r.value);
                            break;
                        case "v4":
                            i.uniforms[t].value = (new wl).fromArray(r.value);
                            break;
                        case "m3":
                            i.uniforms[t].value = (new el).fromArray(r.value);
                            break;
                        case "m4":
                            i.uniforms[t].value = (new lc).fromArray(r.value);
                            break;
                        default:
                            i.uniforms[t].value = r.value;
                    }
                }
                if (void 0 !== e1.defines && (i.defines = e1.defines), void 0 !== e1.vertexShader && (i.vertexShader = e1.vertexShader), void 0 !== e1.fragmentShader && (i.fragmentShader = e1.fragmentShader), void 0 !== e1.glslVersion && (i.glslVersion = e1.glslVersion), void 0 !== e1.extensions) for(const t in e1.extensions)i.extensions[t] = e1.extensions[t];
                if (void 0 !== e1.lights && (i.lights = e1.lights), void 0 !== e1.clipping && (i.clipping = e1.clipping), void 0 !== e1.size && (i.size = e1.size), void 0 !== e1.sizeAttenuation && (i.sizeAttenuation = e1.sizeAttenuation), void 0 !== e1.map && (i.map = n(e1.map)), void 0 !== e1.matcap && (i.matcap = n(e1.matcap)), void 0 !== e1.alphaMap && (i.alphaMap = n(e1.alphaMap)), void 0 !== e1.bumpMap && (i.bumpMap = n(e1.bumpMap)), void 0 !== e1.bumpScale && (i.bumpScale = e1.bumpScale), void 0 !== e1.normalMap && (i.normalMap = n(e1.normalMap)), void 0 !== e1.normalMapType && (i.normalMapType = e1.normalMapType), void 0 !== e1.normalScale) {
                    let t = e1.normalScale;
                    !1 === Array.isArray(t) && (t = [
                        t,
                        t
                    ]), i.normalScale = (new $o).fromArray(t);
                }
                return void 0 !== e1.displacementMap && (i.displacementMap = n(e1.displacementMap)), void 0 !== e1.displacementScale && (i.displacementScale = e1.displacementScale), void 0 !== e1.displacementBias && (i.displacementBias = e1.displacementBias), void 0 !== e1.roughnessMap && (i.roughnessMap = n(e1.roughnessMap)), void 0 !== e1.metalnessMap && (i.metalnessMap = n(e1.metalnessMap)), void 0 !== e1.emissiveMap && (i.emissiveMap = n(e1.emissiveMap)), void 0 !== e1.emissiveIntensity && (i.emissiveIntensity = e1.emissiveIntensity), void 0 !== e1.specularMap && (i.specularMap = n(e1.specularMap)), void 0 !== e1.specularIntensityMap && (i.specularIntensityMap = n(e1.specularIntensityMap)), void 0 !== e1.specularColorMap && (i.specularColorMap = n(e1.specularColorMap)), void 0 !== e1.envMap && (i.envMap = n(e1.envMap)), void 0 !== e1.envMapIntensity && (i.envMapIntensity = e1.envMapIntensity), void 0 !== e1.reflectivity && (i.reflectivity = e1.reflectivity), void 0 !== e1.refractionRatio && (i.refractionRatio = e1.refractionRatio), void 0 !== e1.lightMap && (i.lightMap = n(e1.lightMap)), void 0 !== e1.lightMapIntensity && (i.lightMapIntensity = e1.lightMapIntensity), void 0 !== e1.aoMap && (i.aoMap = n(e1.aoMap)), void 0 !== e1.aoMapIntensity && (i.aoMapIntensity = e1.aoMapIntensity), void 0 !== e1.gradientMap && (i.gradientMap = n(e1.gradientMap)), void 0 !== e1.clearcoatMap && (i.clearcoatMap = n(e1.clearcoatMap)), void 0 !== e1.clearcoatRoughnessMap && (i.clearcoatRoughnessMap = n(e1.clearcoatRoughnessMap)), void 0 !== e1.clearcoatNormalMap && (i.clearcoatNormalMap = n(e1.clearcoatNormalMap)), void 0 !== e1.clearcoatNormalScale && (i.clearcoatNormalScale = (new $o).fromArray(e1.clearcoatNormalScale)), void 0 !== e1.iridescenceMap && (i.iridescenceMap = n(e1.iridescenceMap)), void 0 !== e1.iridescenceThicknessMap && (i.iridescenceThicknessMap = n(e1.iridescenceThicknessMap)), void 0 !== e1.transmissionMap && (i.transmissionMap = n(e1.transmissionMap)), void 0 !== e1.thicknessMap && (i.thicknessMap = n(e1.thicknessMap)), void 0 !== e1.anisotropyMap && (i.anisotropyMap = n(e1.anisotropyMap)), void 0 !== e1.sheenColorMap && (i.sheenColorMap = n(e1.sheenColorMap)), void 0 !== e1.sheenRoughnessMap && (i.sheenRoughnessMap = n(e1.sheenRoughnessMap)), i;
            }
            setTextures(e1) {
                return this.textures = e1, this;
            }
            static createMaterialFromType(e1) {
                return new ({
                    ShadowMaterial: Rm,
                    SpriteMaterial: $p,
                    RawShaderMaterial: Pm,
                    ShaderMaterial: Ku,
                    PointsMaterial: eg,
                    MeshPhysicalMaterial: jm,
                    MeshStandardMaterial: Um,
                    MeshPhongMaterial: km,
                    MeshToonMaterial: Bm,
                    MeshNormalMaterial: Fm,
                    MeshLambertMaterial: Hm,
                    MeshDepthMaterial: Cp,
                    MeshDistanceMaterial: Lp,
                    MeshBasicMaterial: eu,
                    MeshMatcapMaterial: Gm,
                    LineDashedMaterial: Vm,
                    LineBasicMaterial: Gf,
                    Material: $c
                })[e1];
            }
        }
        class VA {
            static decodeText(e1) {
                if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(e1);
                let t = "";
                for(let n = 0, i = e1.length; n < i; n++)t += String.fromCharCode(e1[n]);
                try {
                    return decodeURIComponent(escape(t));
                } catch (e1) {
                    return t;
                }
            }
            static extractUrlBase(e1) {
                const t = e1.lastIndexOf("/");
                return -1 === t ? "./" : e1.slice(0, t + 1);
            }
            static resolveURL(e1, t) {
                return "string" != typeof e1 || "" === e1 ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e1) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e1) || /^data:.*,.*$/i.test(e1) || /^blob:.*$/i.test(e1) ? e1 : t + e1);
            }
        }
        class QA extends Su {
            constructor(){
                super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
            }
            copy(e1) {
                return super.copy(e1), this.instanceCount = e1.instanceCount, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.instanceCount = this.instanceCount, e1.isInstancedBufferGeometry = !0, e1;
            }
        }
        class WA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = {}, n = {};
                function i(e1, i) {
                    if (void 0 !== t[i]) return t[i];
                    const r = e1.interleavedBuffers[i], a = function(e1, t) {
                        if (void 0 !== n[t]) return n[t];
                        const i = e1.arrayBuffers[t], r = new Uint32Array(i).buffer;
                        return n[t] = r, r;
                    }(e1, r.buffer), s = rl(r.type, a), o = new qp(s, r.stride);
                    return o.uuid = r.uuid, t[i] = o, o;
                }
                const r = e1.isInstancedBufferGeometry ? new QA : new Su, a = e1.data.index;
                if (void 0 !== a) {
                    const e1 = rl(a.type, a.array);
                    r.setIndex(new lu(e1, 1));
                }
                const s = e1.data.attributes;
                for(const t in s){
                    const n = s[t];
                    let a;
                    if (n.isInterleavedBufferAttribute) {
                        const t = i(e1.data, n.data);
                        a = new Jp(t, n.itemSize, n.offset, n.normalized);
                    } else {
                        const e1 = rl(n.type, n.array);
                        a = new (n.isInstancedBufferAttribute ? Of : lu)(e1, n.itemSize, n.normalized);
                    }
                    void 0 !== n.name && (a.name = n.name), void 0 !== n.usage && a.setUsage(n.usage), void 0 !== n.updateRange && (a.updateRange.offset = n.updateRange.offset, a.updateRange.count = n.updateRange.count), r.setAttribute(t, a);
                }
                const o = e1.data.morphAttributes;
                if (o) for(const t in o){
                    const n = o[t], a = [];
                    for(let t = 0, r = n.length; t < r; t++){
                        const r = n[t];
                        let s;
                        if (r.isInterleavedBufferAttribute) {
                            const t = i(e1.data, r.data);
                            s = new Jp(t, r.itemSize, r.offset, r.normalized);
                        } else {
                            const e1 = rl(r.type, r.array);
                            s = new lu(e1, r.itemSize, r.normalized);
                        }
                        void 0 !== r.name && (s.name = r.name), a.push(s);
                    }
                    r.morphAttributes[t] = a;
                }
                e1.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
                const l = e1.data.groups || e1.data.drawcalls || e1.data.offsets;
                if (void 0 !== l) for(let e1 = 0, t = l.length; e1 !== t; ++e1){
                    const t = l[e1];
                    r.addGroup(t.start, t.count, t.materialIndex);
                }
                const c = e1.data.boundingSphere;
                if (void 0 !== c) {
                    const e1 = new Ll;
                    void 0 !== c.center && e1.fromArray(c.center), r.boundingSphere = new $l(e1, c.radius);
                }
                return e1.name && (r.name = e1.name), e1.userData && (r.userData = e1.userData), r;
            }
        }
        class YA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = "" === this.path ? VA.extractUrlBase(e1) : this.path;
                this.resourcePath = this.resourcePath || a;
                const s = new AA(this.manager);
                s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(e1, function(n) {
                    let a = null;
                    try {
                        a = JSON.parse(n);
                    } catch (t) {
                        return void 0 !== i && i(t), void console.error("THREE:ObjectLoader: Can't parse " + e1 + ".", t.message);
                    }
                    const s = a.metadata;
                    if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) return void 0 !== i && i(new Error("THREE.ObjectLoader: Can't load " + e1)), void console.error("THREE.ObjectLoader: Can't load " + e1);
                    r.parse(a, t);
                }, n, i);
            }
            async loadAsync(e1, t) {
                const n = "" === this.path ? VA.extractUrlBase(e1) : this.path;
                this.resourcePath = this.resourcePath || n;
                const i = new AA(this.manager);
                i.setPath(this.path), i.setRequestHeader(this.requestHeader), i.setWithCredentials(this.withCredentials);
                const r = await i.loadAsync(e1, t), a = JSON.parse(r), s = a.metadata;
                if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + e1);
                return await this.parseAsync(a);
            }
            parse(e1, t) {
                const n = this.parseAnimations(e1.animations), i = this.parseShapes(e1.shapes), r = this.parseGeometries(e1.geometries, i), a = this.parseImages(e1.images, function() {
                    void 0 !== t && t(l);
                }), s = this.parseTextures(e1.textures, a), o = this.parseMaterials(e1.materials, s), l = this.parseObject(e1.object, r, o, s, n), c = this.parseSkeletons(e1.skeletons, l);
                if (this.bindSkeletons(l, c), void 0 !== t) {
                    let e1 = !1;
                    for(const t in a)if (a[t].data instanceof HTMLImageElement) {
                        e1 = !0;
                        break;
                    }
                    !1 === e1 && t(l);
                }
                return l;
            }
            async parseAsync(e1) {
                const t = this.parseAnimations(e1.animations), n = this.parseShapes(e1.shapes), i = this.parseGeometries(e1.geometries, n), r = await this.parseImagesAsync(e1.images), a = this.parseTextures(e1.textures, r), s = this.parseMaterials(e1.materials, a), o = this.parseObject(e1.object, i, s, a, t), l = this.parseSkeletons(e1.skeletons, o);
                return this.bindSkeletons(o, l), o;
            }
            parseShapes(e1) {
                const t = {};
                if (void 0 !== e1) for(let n = 0, i = e1.length; n < i; n++){
                    const i = (new Yg).fromJSON(e1[n]);
                    t[i.uuid] = i;
                }
                return t;
            }
            parseSkeletons(e1, t) {
                const n = {}, i = {};
                if (t.traverse(function(e1) {
                    e1.isBone && (i[e1.uuid] = e1);
                }), void 0 !== e1) for(let t = 0, r = e1.length; t < r; t++){
                    const r = (new zf).fromJSON(e1[t], i);
                    n[r.uuid] = r;
                }
                return n;
            }
            parseGeometries(e1, t) {
                const n = {};
                if (void 0 !== e1) {
                    const i = new WA;
                    for(let r = 0, a = e1.length; r < a; r++){
                        let a;
                        const s = e1[r];
                        switch(s.type){
                            case "BufferGeometry":
                            case "InstancedBufferGeometry":
                                a = i.parse(s);
                                break;
                            default:
                                s.type in Om ? a = Om[s.type].fromJSON(s, t) : console.warn(`THREE.ObjectLoader: Unsupported geometry type "${s.type}"`);
                        }
                        a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.userData && (a.userData = s.userData), n[s.uuid] = a;
                    }
                }
                return n;
            }
            parseMaterials(e1, t) {
                const n = {}, i = {};
                if (void 0 !== e1) {
                    const r = new GA;
                    r.setTextures(t);
                    for(let t = 0, a = e1.length; t < a; t++){
                        const a = e1[t];
                        void 0 === n[a.uuid] && (n[a.uuid] = r.parse(a)), i[a.uuid] = n[a.uuid];
                    }
                }
                return i;
            }
            parseAnimations(e1) {
                const t = {};
                if (void 0 !== e1) for(let n = 0; n < e1.length; n++){
                    const i = e1[n], r = cA.parse(i);
                    t[r.uuid] = r;
                }
                return t;
            }
            parseImages(e1, t) {
                const n = this, i = {};
                let r;
                function a(e1) {
                    if ("string" == typeof e1) {
                        const t = e1;
                        return function(e1) {
                            return n.manager.itemStart(e1), r.load(e1, function() {
                                n.manager.itemEnd(e1);
                            }, void 0, function() {
                                n.manager.itemError(e1), n.manager.itemEnd(e1);
                            });
                        }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(t) ? t : n.resourcePath + t);
                    }
                    return e1.data ? {
                        data: rl(e1.type, e1.data),
                        width: e1.width,
                        height: e1.height
                    } : null;
                }
                if (void 0 !== e1 && e1.length > 0) {
                    const n = new dA(t);
                    r = new yA(n), r.setCrossOrigin(this.crossOrigin);
                    for(let t = 0, n = e1.length; t < n; t++){
                        const n = e1[t], r = n.url;
                        if (Array.isArray(r)) {
                            const e1 = [];
                            for(let t = 0, n = r.length; t < n; t++){
                                const n = a(r[t]);
                                null !== n && (n instanceof HTMLImageElement ? e1.push(n) : e1.push(new _f(n.data, n.width, n.height)));
                            }
                            i[n.uuid] = new vl(e1);
                        } else {
                            const e1 = a(n.url);
                            i[n.uuid] = new vl(e1);
                        }
                    }
                }
                return i;
            }
            async parseImagesAsync(e1) {
                const t = this, n = {};
                let i;
                async function r(e1) {
                    if ("string" == typeof e1) {
                        const n = e1, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(n) ? n : t.resourcePath + n;
                        return await i.loadAsync(r);
                    }
                    return e1.data ? {
                        data: rl(e1.type, e1.data),
                        width: e1.width,
                        height: e1.height
                    } : null;
                }
                if (void 0 !== e1 && e1.length > 0) {
                    i = new yA(this.manager), i.setCrossOrigin(this.crossOrigin);
                    for(let t = 0, i = e1.length; t < i; t++){
                        const i = e1[t], a = i.url;
                        if (Array.isArray(a)) {
                            const e1 = [];
                            for(let t = 0, n = a.length; t < n; t++){
                                const n = a[t], i = await r(n);
                                null !== i && (i instanceof HTMLImageElement ? e1.push(i) : e1.push(new _f(i.data, i.width, i.height)));
                            }
                            n[i.uuid] = new vl(e1);
                        } else {
                            const e1 = await r(i.url);
                            n[i.uuid] = new vl(e1);
                        }
                    }
                }
                return n;
            }
            parseTextures(e1, t) {
                function n(e1, t) {
                    return "number" == typeof e1 ? e1 : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", e1), t[e1]);
                }
                const i = {};
                if (void 0 !== e1) for(let r = 0, a = e1.length; r < a; r++){
                    const a = e1[r];
                    void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid), void 0 === t[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
                    const s = t[a.image], o = s.data;
                    let l;
                    Array.isArray(o) ? (l = new nh, 6 === o.length && (l.needsUpdate = !0)) : (l = o && o.data ? new _f : new bl, o && (l.needsUpdate = !0)), l.source = s, l.uuid = a.uuid, void 0 !== a.name && (l.name = a.name), void 0 !== a.mapping && (l.mapping = n(a.mapping, XA)), void 0 !== a.channel && (l.channel = a.channel), void 0 !== a.offset && l.offset.fromArray(a.offset), void 0 !== a.repeat && l.repeat.fromArray(a.repeat), void 0 !== a.center && l.center.fromArray(a.center), void 0 !== a.rotation && (l.rotation = a.rotation), void 0 !== a.wrap && (l.wrapS = n(a.wrap[0], ZA), l.wrapT = n(a.wrap[1], ZA)), void 0 !== a.format && (l.format = a.format), void 0 !== a.internalFormat && (l.internalFormat = a.internalFormat), void 0 !== a.type && (l.type = a.type), void 0 !== a.colorSpace && (l.colorSpace = a.colorSpace), void 0 !== a.encoding && (l.encoding = a.encoding), void 0 !== a.minFilter && (l.minFilter = n(a.minFilter, qA)), void 0 !== a.magFilter && (l.magFilter = n(a.magFilter, qA)), void 0 !== a.anisotropy && (l.anisotropy = a.anisotropy), void 0 !== a.flipY && (l.flipY = a.flipY), void 0 !== a.generateMipmaps && (l.generateMipmaps = a.generateMipmaps), void 0 !== a.premultiplyAlpha && (l.premultiplyAlpha = a.premultiplyAlpha), void 0 !== a.unpackAlignment && (l.unpackAlignment = a.unpackAlignment), void 0 !== a.compareFunction && (l.compareFunction = a.compareFunction), void 0 !== a.userData && (l.userData = a.userData), i[a.uuid] = l;
                }
                return i;
            }
            parseObject(e1, t, n, i, r) {
                let a, s, o;
                function l(e1) {
                    return void 0 === t[e1] && console.warn("THREE.ObjectLoader: Undefined geometry", e1), t[e1];
                }
                function c(e1) {
                    if (void 0 !== e1) {
                        if (Array.isArray(e1)) {
                            const t = [];
                            for(let i = 0, r = e1.length; i < r; i++){
                                const r = e1[i];
                                void 0 === n[r] && console.warn("THREE.ObjectLoader: Undefined material", r), t.push(n[r]);
                            }
                            return t;
                        }
                        return void 0 === n[e1] && console.warn("THREE.ObjectLoader: Undefined material", e1), n[e1];
                    }
                }
                function u(e1) {
                    return void 0 === i[e1] && console.warn("THREE.ObjectLoader: Undefined texture", e1), i[e1];
                }
                switch(e1.type){
                    case "Scene":
                        a = new Zp, void 0 !== e1.background && (Number.isInteger(e1.background) ? a.background = new qc(e1.background) : a.background = u(e1.background)), void 0 !== e1.environment && (a.environment = u(e1.environment)), void 0 !== e1.fog && ("Fog" === e1.fog.type ? a.fog = new Xp(e1.fog.color, e1.fog.near, e1.fog.far) : "FogExp2" === e1.fog.type && (a.fog = new Yp(e1.fog.color, e1.fog.density)), "" !== e1.fog.name && (a.fog.name = e1.fog.name)), void 0 !== e1.backgroundBlurriness && (a.backgroundBlurriness = e1.backgroundBlurriness), void 0 !== e1.backgroundIntensity && (a.backgroundIntensity = e1.backgroundIntensity);
                        break;
                    case "PerspectiveCamera":
                        a = new $u(e1.fov, e1.aspect, e1.near, e1.far), void 0 !== e1.focus && (a.focus = e1.focus), void 0 !== e1.zoom && (a.zoom = e1.zoom), void 0 !== e1.filmGauge && (a.filmGauge = e1.filmGauge), void 0 !== e1.filmOffset && (a.filmOffset = e1.filmOffset), void 0 !== e1.view && (a.view = Object.assign({}, e1.view));
                        break;
                    case "OrthographicCamera":
                        a = new Eh(e1.left, e1.right, e1.top, e1.bottom, e1.near, e1.far), void 0 !== e1.zoom && (a.zoom = e1.zoom), void 0 !== e1.view && (a.view = Object.assign({}, e1.view));
                        break;
                    case "AmbientLight":
                        a = new kA(e1.color, e1.intensity);
                        break;
                    case "DirectionalLight":
                        a = new jA(e1.color, e1.intensity);
                        break;
                    case "PointLight":
                        a = new PA(e1.color, e1.intensity, e1.distance, e1.decay);
                        break;
                    case "RectAreaLight":
                        a = new BA(e1.color, e1.intensity, e1.width, e1.height);
                        break;
                    case "SpotLight":
                        a = new CA(e1.color, e1.intensity, e1.distance, e1.angle, e1.penumbra, e1.decay);
                        break;
                    case "HemisphereLight":
                        a = new TA(e1.color, e1.groundColor, e1.intensity);
                        break;
                    case "LightProbe":
                        a = (new HA).fromJSON(e1);
                        break;
                    case "SkinnedMesh":
                        s = l(e1.geometry), o = c(e1.material), a = new Nf(s, o), void 0 !== e1.bindMode && (a.bindMode = e1.bindMode), void 0 !== e1.bindMatrix && a.bindMatrix.fromArray(e1.bindMatrix), void 0 !== e1.skeleton && (a.skeleton = e1.skeleton);
                        break;
                    case "Mesh":
                        s = l(e1.geometry), o = c(e1.material), a = new Vu(s, o);
                        break;
                    case "InstancedMesh":
                        s = l(e1.geometry), o = c(e1.material);
                        const t1 = e1.count, n1 = e1.instanceMatrix, i1 = e1.instanceColor;
                        a = new Hf(s, o, t1), a.instanceMatrix = new Of(new Float32Array(n1.array), 16), void 0 !== i1 && (a.instanceColor = new Of(new Float32Array(i1.array), i1.itemSize));
                        break;
                    case "LOD":
                        a = new Mf;
                        break;
                    case "Line":
                        a = new Zf(l(e1.geometry), c(e1.material));
                        break;
                    case "LineLoop":
                        a = new $f(l(e1.geometry), c(e1.material));
                        break;
                    case "LineSegments":
                        a = new Jf(l(e1.geometry), c(e1.material));
                        break;
                    case "PointCloud":
                    case "Points":
                        a = new ag(l(e1.geometry), c(e1.material));
                        break;
                    case "Sprite":
                        a = new ff(c(e1.material));
                        break;
                    case "Group":
                        a = new jp;
                        break;
                    case "Bone":
                        a = new Df;
                        break;
                    default:
                        a = new zc;
                }
                if (a.uuid = e1.uuid, void 0 !== e1.name && (a.name = e1.name), void 0 !== e1.matrix ? (a.matrix.fromArray(e1.matrix), void 0 !== e1.matrixAutoUpdate && (a.matrixAutoUpdate = e1.matrixAutoUpdate), a.matrixAutoUpdate && a.matrix.decompose(a.position, a.quaternion, a.scale)) : (void 0 !== e1.position && a.position.fromArray(e1.position), void 0 !== e1.rotation && a.rotation.fromArray(e1.rotation), void 0 !== e1.quaternion && a.quaternion.fromArray(e1.quaternion), void 0 !== e1.scale && a.scale.fromArray(e1.scale)), void 0 !== e1.up && a.up.fromArray(e1.up), void 0 !== e1.castShadow && (a.castShadow = e1.castShadow), void 0 !== e1.receiveShadow && (a.receiveShadow = e1.receiveShadow), e1.shadow && (void 0 !== e1.shadow.bias && (a.shadow.bias = e1.shadow.bias), void 0 !== e1.shadow.normalBias && (a.shadow.normalBias = e1.shadow.normalBias), void 0 !== e1.shadow.radius && (a.shadow.radius = e1.shadow.radius), void 0 !== e1.shadow.mapSize && a.shadow.mapSize.fromArray(e1.shadow.mapSize), void 0 !== e1.shadow.camera && (a.shadow.camera = this.parseObject(e1.shadow.camera))), void 0 !== e1.visible && (a.visible = e1.visible), void 0 !== e1.frustumCulled && (a.frustumCulled = e1.frustumCulled), void 0 !== e1.renderOrder && (a.renderOrder = e1.renderOrder), void 0 !== e1.userData && (a.userData = e1.userData), void 0 !== e1.layers && (a.layers.mask = e1.layers), void 0 !== e1.children) {
                    const s = e1.children;
                    for(let e1 = 0; e1 < s.length; e1++)a.add(this.parseObject(s[e1], t, n, i, r));
                }
                if (void 0 !== e1.animations) {
                    const t = e1.animations;
                    for(let e1 = 0; e1 < t.length; e1++){
                        const n = t[e1];
                        a.animations.push(r[n]);
                    }
                }
                if ("LOD" === e1.type) {
                    void 0 !== e1.autoUpdate && (a.autoUpdate = e1.autoUpdate);
                    const t = e1.levels;
                    for(let e1 = 0; e1 < t.length; e1++){
                        const n = t[e1], i = a.getObjectByProperty("uuid", n.object);
                        void 0 !== i && a.addLevel(i, n.distance, n.hysteresis);
                    }
                }
                return a;
            }
            bindSkeletons(e1, t) {
                0 !== Object.keys(t).length && e1.traverse(function(e1) {
                    if (!0 === e1.isSkinnedMesh && void 0 !== e1.skeleton) {
                        const n = t[e1.skeleton];
                        void 0 === n ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", e1.skeleton) : e1.bind(n, e1.bindMatrix);
                    }
                });
            }
        }
        const XA = {
            UVMapping: aa,
            CubeReflectionMapping: sa,
            CubeRefractionMapping: oa,
            EquirectangularReflectionMapping: la,
            EquirectangularRefractionMapping: ca,
            CubeUVReflectionMapping: ua
        }, ZA = {
            RepeatWrapping: ha,
            ClampToEdgeWrapping: da,
            MirroredRepeatWrapping: pa
        }, qA = {
            NearestFilter: fa,
            NearestMipmapNearestFilter: ga,
            NearestMipmapLinearFilter: Aa,
            LinearFilter: va,
            LinearMipmapNearestFilter: ya,
            LinearMipmapLinearFilter: ba
        };
        class KA extends fA {
            constructor(e1){
                super(e1), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
                    premultiplyAlpha: "none"
                };
            }
            setOptions(e1) {
                return this.options = e1, this;
            }
            load(e1, t, n, i) {
                void 0 === e1 && (e1 = ""), void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = hA.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = {};
                s.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", s.headers = this.requestHeader, fetch(e1, s).then(function(e1) {
                    return e1.blob();
                }).then(function(e1) {
                    return createImageBitmap(e1, Object.assign(r.options, {
                        colorSpaceConversion: "none"
                    }));
                }).then(function(n) {
                    hA.add(e1, n), t && t(n), r.manager.itemEnd(e1);
                }).catch(function(t) {
                    i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }), r.manager.itemStart(e1);
            }
        }
        let JA;
        class $A {
            static getContext() {
                return void 0 === JA && (JA = new (window.AudioContext || window.webkitAudioContext)), JA;
            }
            static setContext(e1) {
                JA = e1;
            }
        }
        class eM extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(this.manager);
                function s(t) {
                    i ? i(t) : console.error(t), r.manager.itemError(e1);
                }
                a.setResponseType("arraybuffer"), a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e1, function(e1) {
                    try {
                        const n = e1.slice(0);
                        $A.getContext().decodeAudioData(n, function(e1) {
                            t(e1);
                        }, s);
                    } catch (e1) {
                        s(e1);
                    }
                }, n, i);
            }
        }
        const tM = new lc, nM = new lc, iM = new lc;
        class rM {
            constructor(){
                this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new $u, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new $u, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
                    focus: null,
                    fov: null,
                    aspect: null,
                    near: null,
                    far: null,
                    zoom: null,
                    eyeSep: null
                };
            }
            update(e1) {
                const t = this._cache;
                if (t.focus !== e1.focus || t.fov !== e1.fov || t.aspect !== e1.aspect * this.aspect || t.near !== e1.near || t.far !== e1.far || t.zoom !== e1.zoom || t.eyeSep !== this.eyeSep) {
                    t.focus = e1.focus, t.fov = e1.fov, t.aspect = e1.aspect * this.aspect, t.near = e1.near, t.far = e1.far, t.zoom = e1.zoom, t.eyeSep = this.eyeSep, iM.copy(e1.projectionMatrix);
                    const n = t.eyeSep / 2, i = n * t.near / t.focus, r = t.near * Math.tan(Fo * t.fov * .5) / t.zoom;
                    let a, s;
                    nM.elements[12] = -n, tM.elements[12] = n, a = -r * t.aspect + i, s = r * t.aspect + i, iM.elements[0] = 2 * t.near / (s - a), iM.elements[8] = (s + a) / (s - a), this.cameraL.projectionMatrix.copy(iM), a = -r * t.aspect - i, s = r * t.aspect - i, iM.elements[0] = 2 * t.near / (s - a), iM.elements[8] = (s + a) / (s - a), this.cameraR.projectionMatrix.copy(iM);
                }
                this.cameraL.matrixWorld.copy(e1.matrixWorld).multiply(nM), this.cameraR.matrixWorld.copy(e1.matrixWorld).multiply(tM);
            }
        }
        class aM {
            constructor(){
                let e1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                this.autoStart = e1, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
            }
            start() {
                this.startTime = sM(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            }
            stop() {
                this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            }
            getElapsedTime() {
                return this.getDelta(), this.elapsedTime;
            }
            getDelta() {
                let e1 = 0;
                if (this.autoStart && !this.running) return this.start(), 0;
                if (this.running) {
                    const t = sM();
                    e1 = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e1;
                }
                return e1;
            }
        }
        function sM() {
            return ("undefined" == typeof performance ? Date : performance).now();
        }
        const oM = new Ll, lM = new Cl, cM = new Ll, uM = new Ll;
        class hM extends zc {
            constructor(){
                super(), this.type = "AudioListener", this.context = $A.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new aM;
            }
            getInput() {
                return this.gain;
            }
            removeFilter() {
                return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            }
            getFilter() {
                return this.filter;
            }
            setFilter(e1) {
                return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = e1, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            }
            getMasterVolume() {
                return this.gain.gain.value;
            }
            setMasterVolume(e1) {
                return this.gain.gain.setTargetAtTime(e1, this.context.currentTime, .01), this;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1);
                const t = this.context.listener, n = this.up;
                if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(oM, lM, cM), uM.set(0, 0, -1).applyQuaternion(lM), t.positionX) {
                    const e1 = this.context.currentTime + this.timeDelta;
                    t.positionX.linearRampToValueAtTime(oM.x, e1), t.positionY.linearRampToValueAtTime(oM.y, e1), t.positionZ.linearRampToValueAtTime(oM.z, e1), t.forwardX.linearRampToValueAtTime(uM.x, e1), t.forwardY.linearRampToValueAtTime(uM.y, e1), t.forwardZ.linearRampToValueAtTime(uM.z, e1), t.upX.linearRampToValueAtTime(n.x, e1), t.upY.linearRampToValueAtTime(n.y, e1), t.upZ.linearRampToValueAtTime(n.z, e1);
                } else t.setPosition(oM.x, oM.y, oM.z), t.setOrientation(uM.x, uM.y, uM.z, n.x, n.y, n.z);
            }
        }
        class dM extends zc {
            constructor(e1){
                super(), this.type = "Audio", this.listener = e1, this.context = e1.context, this.gain = this.context.createGain(), this.gain.connect(e1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
            }
            getOutput() {
                return this.gain;
            }
            setNodeSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = e1, this.connect(), this;
            }
            setMediaElementSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(e1), this.connect(), this;
            }
            setMediaStreamSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(e1), this.connect(), this;
            }
            setBuffer(e1) {
                return this.buffer = e1, this.sourceType = "buffer", this.autoplay && this.play(), this;
            }
            play() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
                if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
                this._startedAt = this.context.currentTime + e1;
                const t = this.context.createBufferSource();
                return t.buffer = this.buffer, t.loop = this.loop, t.loopStart = this.loopStart, t.loopEnd = this.loopEnd, t.onended = this.onEnded.bind(this), t.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = t, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
            }
            pause() {
                if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            stop() {
                if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(), this.source.onended = null), this.isPlaying = !1, this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(let e1 = 1, t = this.filters.length; e1 < t; e1++)this.filters[e1 - 1].connect(this.filters[e1]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                return this._connected = !0, this;
            }
            disconnect() {
                if (!1 !== this._connected) {
                    if (this.filters.length > 0) {
                        this.source.disconnect(this.filters[0]);
                        for(let e1 = 1, t = this.filters.length; e1 < t; e1++)this.filters[e1 - 1].disconnect(this.filters[e1]);
                        this.filters[this.filters.length - 1].disconnect(this.getOutput());
                    } else this.source.disconnect(this.getOutput());
                    return this._connected = !1, this;
                }
            }
            getFilters() {
                return this.filters;
            }
            setFilters(e1) {
                return e1 || (e1 = []), !0 === this._connected ? (this.disconnect(), this.filters = e1.slice(), this.connect()) : this.filters = e1.slice(), this;
            }
            setDetune(e1) {
                if (this.detune = e1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
            }
            getDetune() {
                return this.detune;
            }
            getFilter() {
                return this.getFilters()[0];
            }
            setFilter(e1) {
                return this.setFilters(e1 ? [
                    e1
                ] : []);
            }
            setPlaybackRate(e1) {
                if (!1 !== this.hasPlaybackControl) return this.playbackRate = e1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            getPlaybackRate() {
                return this.playbackRate;
            }
            onEnded() {
                this.isPlaying = !1;
            }
            getLoop() {
                return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            }
            setLoop(e1) {
                if (!1 !== this.hasPlaybackControl) return this.loop = e1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            setLoopStart(e1) {
                return this.loopStart = e1, this;
            }
            setLoopEnd(e1) {
                return this.loopEnd = e1, this;
            }
            getVolume() {
                return this.gain.gain.value;
            }
            setVolume(e1) {
                return this.gain.gain.setTargetAtTime(e1, this.context.currentTime, .01), this;
            }
        }
        const pM = new Ll, fM = new Cl, gM = new Ll, mM = new Ll;
        class AM extends dM {
            constructor(e1){
                super(e1), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
            }
            connect() {
                super.connect(), this.panner.connect(this.gain);
            }
            disconnect() {
                super.disconnect(), this.panner.disconnect(this.gain);
            }
            getOutput() {
                return this.panner;
            }
            getRefDistance() {
                return this.panner.refDistance;
            }
            setRefDistance(e1) {
                return this.panner.refDistance = e1, this;
            }
            getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
            setRolloffFactor(e1) {
                return this.panner.rolloffFactor = e1, this;
            }
            getDistanceModel() {
                return this.panner.distanceModel;
            }
            setDistanceModel(e1) {
                return this.panner.distanceModel = e1, this;
            }
            getMaxDistance() {
                return this.panner.maxDistance;
            }
            setMaxDistance(e1) {
                return this.panner.maxDistance = e1, this;
            }
            setDirectionalCone(e1, t, n) {
                return this.panner.coneInnerAngle = e1, this.panner.coneOuterAngle = t, this.panner.coneOuterGain = n, this;
            }
            updateMatrixWorld(e1) {
                if (super.updateMatrixWorld(e1), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
                this.matrixWorld.decompose(pM, fM, gM), mM.set(0, 0, 1).applyQuaternion(fM);
                const t = this.panner;
                if (t.positionX) {
                    const e1 = this.context.currentTime + this.listener.timeDelta;
                    t.positionX.linearRampToValueAtTime(pM.x, e1), t.positionY.linearRampToValueAtTime(pM.y, e1), t.positionZ.linearRampToValueAtTime(pM.z, e1), t.orientationX.linearRampToValueAtTime(mM.x, e1), t.orientationY.linearRampToValueAtTime(mM.y, e1), t.orientationZ.linearRampToValueAtTime(mM.z, e1);
                } else t.setPosition(pM.x, pM.y, pM.z), t.setOrientation(mM.x, mM.y, mM.z);
            }
        }
        class MM {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2048;
                this.analyser = e1.context.createAnalyser(), this.analyser.fftSize = t, this.data = new Uint8Array(this.analyser.frequencyBinCount), e1.getOutput().connect(this.analyser);
            }
            getFrequencyData() {
                return this.analyser.getByteFrequencyData(this.data), this.data;
            }
            getAverageFrequency() {
                let e1 = 0;
                const t = this.getFrequencyData();
                for(let n = 0; n < t.length; n++)e1 += t[n];
                return e1 / t.length;
            }
        }
        class vM {
            constructor(e1, t, n){
                let i, r, a;
                switch(this.binding = e1, this.valueSize = n, t){
                    case "quaternion":
                        i = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
                        break;
                    case "string":
                    case "bool":
                        i = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
                        break;
                    default:
                        i = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
                }
                this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
            }
            accumulate(e1, t) {
                const n = this.buffer, i = this.valueSize, r = e1 * i + i;
                let a = this.cumulativeWeight;
                if (0 === a) {
                    for(let e1 = 0; e1 !== i; ++e1)n[r + e1] = n[e1];
                    a = t;
                } else {
                    a += t;
                    const e1 = t / a;
                    this._mixBufferRegion(n, r, 0, e1, i);
                }
                this.cumulativeWeight = a;
            }
            accumulateAdditive(e1) {
                const t = this.buffer, n = this.valueSize, i = n * this._addIndex;
                0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(t, i, 0, e1, n), this.cumulativeWeightAdditive += e1;
            }
            apply(e1) {
                const t = this.valueSize, n = this.buffer, i = e1 * t + t, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, s = this.binding;
                if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
                    const e1 = t * this._origIndex;
                    this._mixBufferRegion(n, i, e1, 1 - r, t);
                }
                a > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t);
                for(let e1 = t, r = t + t; e1 !== r; ++e1)if (n[e1] !== n[e1 + t]) {
                    s.setValue(n, i);
                    break;
                }
            }
            saveOriginalState() {
                const e1 = this.binding, t = this.buffer, n = this.valueSize, i = n * this._origIndex;
                e1.getValue(t, i);
                for(let e1 = n, r = i; e1 !== r; ++e1)t[e1] = t[i + e1 % n];
                this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
            }
            restoreOriginalState() {
                const e1 = 3 * this.valueSize;
                this.binding.setValue(this.buffer, e1);
            }
            _setAdditiveIdentityNumeric() {
                const e1 = this._addIndex * this.valueSize, t = e1 + this.valueSize;
                for(let n = e1; n < t; n++)this.buffer[n] = 0;
            }
            _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
            _setAdditiveIdentityOther() {
                const e1 = this._origIndex * this.valueSize, t = this._addIndex * this.valueSize;
                for(let n = 0; n < this.valueSize; n++)this.buffer[t + n] = this.buffer[e1 + n];
            }
            _select(e1, t, n, i, r) {
                if (i >= .5) for(let i = 0; i !== r; ++i)e1[t + i] = e1[n + i];
            }
            _slerp(e1, t, n, i) {
                Cl.slerpFlat(e1, t, e1, t, e1, n, i);
            }
            _slerpAdditive(e1, t, n, i, r) {
                const a = this._workIndex * r;
                Cl.multiplyQuaternionsFlat(e1, a, e1, t, e1, n), Cl.slerpFlat(e1, t, e1, t, e1, a, i);
            }
            _lerp(e1, t, n, i, r) {
                const a = 1 - i;
                for(let s = 0; s !== r; ++s){
                    const r = t + s;
                    e1[r] = e1[r] * a + e1[n + s] * i;
                }
            }
            _lerpAdditive(e1, t, n, i, r) {
                for(let a = 0; a !== r; ++a){
                    const r = t + a;
                    e1[r] = e1[r] + e1[n + a] * i;
                }
            }
        }
        const yM = "\\[\\]\\.:\\/", xM = new RegExp("[" + yM + "]", "g"), bM = "[^" + yM + "]", wM = "[^" + yM.replace("\\.", "") + "]", EM = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", bM) + /(WCOD+)?/.source.replace("WCOD", wM) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", bM) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", bM) + "$"), TM = [
            "material",
            "materials",
            "bones",
            "map"
        ];
        class SM {
            constructor(e1, t, n){
                this.path = t, this.parsedPath = n || SM.parseTrackName(t), this.node = SM.findNode(e1, this.parsedPath.nodeName), this.rootNode = e1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
            static create(e1, t, n) {
                return e1 && e1.isAnimationObjectGroup ? new SM.Composite(e1, t, n) : new SM(e1, t, n);
            }
            static sanitizeNodeName(e1) {
                return e1.replace(/\s/g, "_").replace(xM, "");
            }
            static parseTrackName(e1) {
                const t = EM.exec(e1);
                if (null === t) throw new Error("PropertyBinding: Cannot parse trackName: " + e1);
                const n = {
                    nodeName: t[2],
                    objectName: t[3],
                    objectIndex: t[4],
                    propertyName: t[5],
                    propertyIndex: t[6]
                }, i = n.nodeName && n.nodeName.lastIndexOf(".");
                if (void 0 !== i && -1 !== i) {
                    const e1 = n.nodeName.substring(i + 1);
                    -1 !== TM.indexOf(e1) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = e1);
                }
                if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e1);
                return n;
            }
            static findNode(e1, t) {
                if (void 0 === t || "" === t || "." === t || -1 === t || t === e1.name || t === e1.uuid) return e1;
                if (e1.skeleton) {
                    const n = e1.skeleton.getBoneByName(t);
                    if (void 0 !== n) return n;
                }
                if (e1.children) {
                    const n = function(e1) {
                        for(let i = 0; i < e1.length; i++){
                            const r = e1[i];
                            if (r.name === t || r.uuid === t) return r;
                            const a = n(r.children);
                            if (a) return a;
                        }
                        return null;
                    }, i = n(e1.children);
                    if (i) return i;
                }
                return null;
            }
            _getValue_unavailable() {}
            _setValue_unavailable() {}
            _getValue_direct(e1, t) {
                e1[t] = this.targetObject[this.propertyName];
            }
            _getValue_array(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)e1[t++] = n[i];
            }
            _getValue_arrayElement(e1, t) {
                e1[t] = this.resolvedProperty[this.propertyIndex];
            }
            _getValue_toArray(e1, t) {
                this.resolvedProperty.toArray(e1, t);
            }
            _setValue_direct(e1, t) {
                this.targetObject[this.propertyName] = e1[t];
            }
            _setValue_direct_setNeedsUpdate(e1, t) {
                this.targetObject[this.propertyName] = e1[t], this.targetObject.needsUpdate = !0;
            }
            _setValue_direct_setMatrixWorldNeedsUpdate(e1, t) {
                this.targetObject[this.propertyName] = e1[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_array(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
            }
            _setValue_array_setNeedsUpdate(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
                this.targetObject.needsUpdate = !0;
            }
            _setValue_array_setMatrixWorldNeedsUpdate(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
                this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_arrayElement(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t];
            }
            _setValue_arrayElement_setNeedsUpdate(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t], this.targetObject.needsUpdate = !0;
            }
            _setValue_arrayElement_setMatrixWorldNeedsUpdate(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_fromArray(e1, t) {
                this.resolvedProperty.fromArray(e1, t);
            }
            _setValue_fromArray_setNeedsUpdate(e1, t) {
                this.resolvedProperty.fromArray(e1, t), this.targetObject.needsUpdate = !0;
            }
            _setValue_fromArray_setMatrixWorldNeedsUpdate(e1, t) {
                this.resolvedProperty.fromArray(e1, t), this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _getValue_unbound(e1, t) {
                this.bind(), this.getValue(e1, t);
            }
            _setValue_unbound(e1, t) {
                this.bind(), this.setValue(e1, t);
            }
            bind() {
                let e1 = this.node;
                const t = this.parsedPath, n = t.objectName, i = t.propertyName;
                let r = t.propertyIndex;
                if (e1 || (e1 = SM.findNode(this.rootNode, t.nodeName), this.node = e1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                if (n) {
                    let i = t.objectIndex;
                    switch(n){
                        case "materials":
                            if (!e1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!e1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                            e1 = e1.material.materials;
                            break;
                        case "bones":
                            if (!e1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                            e1 = e1.skeleton.bones;
                            for(let t = 0; t < e1.length; t++)if (e1[t].name === i) {
                                i = t;
                                break;
                            }
                            break;
                        case "map":
                            if ("map" in e1) {
                                e1 = e1.map;
                                break;
                            }
                            if (!e1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!e1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                            e1 = e1.material.map;
                            break;
                        default:
                            if (void 0 === e1[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                            e1 = e1[n];
                    }
                    if (void 0 !== i) {
                        if (void 0 === e1[i]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e1);
                        e1 = e1[i];
                    }
                }
                const a = e1[i];
                if (void 0 === a) {
                    const n = t.nodeName;
                    return void console.error("THREE.PropertyBinding: Trying to update property for track: " + n + "." + i + " but it wasn't found.", e1);
                }
                let s = this.Versioning.None;
                this.targetObject = e1, void 0 !== e1.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== e1.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
                let o = this.BindingType.Direct;
                if (void 0 !== r) {
                    if ("morphTargetInfluences" === i) {
                        if (!e1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                        if (!e1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        void 0 !== e1.morphTargetDictionary[r] && (r = e1.morphTargetDictionary[r]);
                    }
                    o = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
                } else void 0 !== a.fromArray && void 0 !== a.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (o = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = i;
                this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][s];
            }
            unbind() {
                this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
        }
        SM.Composite = class {
            constructor(e1, t, n){
                const i = n || SM.parseTrackName(t);
                this._targetGroup = e1, this._bindings = e1.subscribe_(t, i);
            }
            getValue(e1, t) {
                this.bind();
                const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
                void 0 !== i && i.getValue(e1, t);
            }
            setValue(e1, t) {
                const n = this._bindings;
                for(let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)n[i].setValue(e1, t);
            }
            bind() {
                const e1 = this._bindings;
                for(let t = this._targetGroup.nCachedObjects_, n = e1.length; t !== n; ++t)e1[t].bind();
            }
            unbind() {
                const e1 = this._bindings;
                for(let t = this._targetGroup.nCachedObjects_, n = e1.length; t !== n; ++t)e1[t].unbind();
            }
        }, SM.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
        }, SM.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
        }, SM.prototype.GetterByBindingType = [
            SM.prototype._getValue_direct,
            SM.prototype._getValue_array,
            SM.prototype._getValue_arrayElement,
            SM.prototype._getValue_toArray
        ], SM.prototype.SetterByBindingTypeAndVersioning = [
            [
                SM.prototype._setValue_direct,
                SM.prototype._setValue_direct_setNeedsUpdate,
                SM.prototype._setValue_direct_setMatrixWorldNeedsUpdate
            ],
            [
                SM.prototype._setValue_array,
                SM.prototype._setValue_array_setNeedsUpdate,
                SM.prototype._setValue_array_setMatrixWorldNeedsUpdate
            ],
            [
                SM.prototype._setValue_arrayElement,
                SM.prototype._setValue_arrayElement_setNeedsUpdate,
                SM.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
            ],
            [
                SM.prototype._setValue_fromArray,
                SM.prototype._setValue_fromArray_setNeedsUpdate,
                SM.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
            ]
        ];
        class IM {
            constructor(){
                this.isAnimationObjectGroup = !0, this.uuid = Go(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
                const e1 = {};
                this._indicesByUUID = e1;
                for(let t = 0, n = arguments.length; t !== n; ++t)e1[arguments[t].uuid] = t;
                this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
                const t = this;
                this.stats = {
                    objects: {
                        get total () {
                            return t._objects.length;
                        },
                        get inUse () {
                            return this.total - t.nCachedObjects_;
                        }
                    },
                    get bindingsPerObject () {
                        return t._bindings.length;
                    }
                };
            }
            add() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._paths, i = this._parsedPaths, r = this._bindings, a = r.length;
                let s, o = e1.length, l = this.nCachedObjects_;
                for(let c = 0, u = arguments.length; c !== u; ++c){
                    const u = arguments[c], h = u.uuid;
                    let d = t[h];
                    if (void 0 === d) {
                        d = o++, t[h] = d, e1.push(u);
                        for(let e1 = 0, t = a; e1 !== t; ++e1)r[e1].push(new SM(u, n[e1], i[e1]));
                    } else if (d < l) {
                        s = e1[d];
                        const o = --l, c = e1[o];
                        t[c.uuid] = d, e1[d] = c, t[h] = o, e1[o] = u;
                        for(let e1 = 0, t = a; e1 !== t; ++e1){
                            const t = r[e1], a = t[o];
                            let s = t[d];
                            t[d] = a, void 0 === s && (s = new SM(u, n[e1], i[e1])), t[o] = s;
                        }
                    } else e1[d] !== s && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                }
                this.nCachedObjects_ = l;
            }
            remove() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_;
                for(let a = 0, s = arguments.length; a !== s; ++a){
                    const s = arguments[a], o = s.uuid, l = t[o];
                    if (void 0 !== l && l >= r) {
                        const a = r++, c = e1[a];
                        t[c.uuid] = l, e1[l] = c, t[o] = a, e1[a] = s;
                        for(let e1 = 0, t = i; e1 !== t; ++e1){
                            const t = n[e1], i = t[a], r = t[l];
                            t[l] = i, t[a] = r;
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            uncache() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_, a = e1.length;
                for(let s = 0, o = arguments.length; s !== o; ++s){
                    const o = arguments[s].uuid, l = t[o];
                    if (void 0 !== l) {
                        if (delete t[o], l < r) {
                            const s = --r, o = e1[s], c = --a, u = e1[c];
                            t[o.uuid] = l, e1[l] = o, t[u.uuid] = s, e1[s] = u, e1.pop();
                            for(let e1 = 0, t = i; e1 !== t; ++e1){
                                const t = n[e1], i = t[s], r = t[c];
                                t[l] = i, t[s] = r, t.pop();
                            }
                        } else {
                            const r = --a, s = e1[r];
                            r > 0 && (t[s.uuid] = l), e1[l] = s, e1.pop();
                            for(let e1 = 0, t = i; e1 !== t; ++e1){
                                const t = n[e1];
                                t[l] = t[r], t.pop();
                            }
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            subscribe_(e1, t) {
                const n = this._bindingsIndicesByPath;
                let i = n[e1];
                const r = this._bindings;
                if (void 0 !== i) return r[i];
                const a = this._paths, s = this._parsedPaths, o = this._objects, l = o.length, c = this.nCachedObjects_, u = new Array(l);
                i = r.length, n[e1] = i, a.push(e1), s.push(t), r.push(u);
                for(let n = c, i = o.length; n !== i; ++n){
                    const i = o[n];
                    u[n] = new SM(i, e1, t);
                }
                return u;
            }
            unsubscribe_(e1) {
                const t = this._bindingsIndicesByPath, n = t[e1];
                if (void 0 !== n) {
                    const i = this._paths, r = this._parsedPaths, a = this._bindings, s = a.length - 1, o = a[s];
                    t[e1[s]] = n, a[n] = o, a.pop(), r[n] = r[s], r.pop(), i[n] = i[s], i.pop();
                }
            }
        }
        class NM {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.blendMode;
                this._mixer = e1, this._clip = t, this._localRoot = n, this.blendMode = i;
                const r = t.tracks, a = r.length, s = new Array(a), o = {
                    endingStart: _s,
                    endingEnd: _s
                };
                for(let e1 = 0; e1 !== a; ++e1){
                    const t = r[e1].createInterpolant(null);
                    s[e1] = t, t.settings = o;
                }
                this._interpolantSettings = o, this._interpolants = s, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = Ts, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
            }
            play() {
                return this._mixer._activateAction(this), this;
            }
            stop() {
                return this._mixer._deactivateAction(this), this.reset();
            }
            reset() {
                return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            }
            isRunning() {
                return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            }
            isScheduled() {
                return this._mixer._isActiveAction(this);
            }
            startAt(e1) {
                return this._startTime = e1, this;
            }
            setLoop(e1, t) {
                return this.loop = e1, this.repetitions = t, this;
            }
            setEffectiveWeight(e1) {
                return this.weight = e1, this._effectiveWeight = this.enabled ? e1 : 0, this.stopFading();
            }
            getEffectiveWeight() {
                return this._effectiveWeight;
            }
            fadeIn(e1) {
                return this._scheduleFading(e1, 0, 1);
            }
            fadeOut(e1) {
                return this._scheduleFading(e1, 1, 0);
            }
            crossFadeFrom(e1, t, n) {
                if (e1.fadeOut(t), this.fadeIn(t), n) {
                    const n = this._clip.duration, i = e1._clip.duration, r = i / n, a = n / i;
                    e1.warp(1, r, t), this.warp(a, 1, t);
                }
                return this;
            }
            crossFadeTo(e1, t, n) {
                return e1.crossFadeFrom(this, t, n);
            }
            stopFading() {
                const e1 = this._weightInterpolant;
                return null !== e1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e1)), this;
            }
            setEffectiveTimeScale(e1) {
                return this.timeScale = e1, this._effectiveTimeScale = this.paused ? 0 : e1, this.stopWarping();
            }
            getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
            setDuration(e1) {
                return this.timeScale = this._clip.duration / e1, this.stopWarping();
            }
            syncWith(e1) {
                return this.time = e1.time, this.timeScale = e1.timeScale, this.stopWarping();
            }
            halt(e1) {
                return this.warp(this._effectiveTimeScale, 0, e1);
            }
            warp(e1, t, n) {
                const i = this._mixer, r = i.time, a = this.timeScale;
                let s = this._timeScaleInterpolant;
                null === s && (s = i._lendControlInterpolant(), this._timeScaleInterpolant = s);
                const o = s.parameterPositions, l = s.sampleValues;
                return o[0] = r, o[1] = r + n, l[0] = e1 / a, l[1] = t / a, this;
            }
            stopWarping() {
                const e1 = this._timeScaleInterpolant;
                return null !== e1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e1)), this;
            }
            getMixer() {
                return this._mixer;
            }
            getClip() {
                return this._clip;
            }
            getRoot() {
                return this._localRoot || this._mixer._root;
            }
            _update(e1, t, n, i) {
                if (!this.enabled) return void this._updateWeight(e1);
                const r = this._startTime;
                if (null !== r) {
                    const i = (e1 - r) * n;
                    i < 0 || 0 === n ? t = 0 : (this._startTime = null, t = n * i);
                }
                t *= this._updateTimeScale(e1);
                const a = this._updateTime(t), s = this._updateWeight(e1);
                if (s > 0) {
                    const e1 = this._interpolants, t = this._propertyBindings;
                    if (this.blendMode === Os) for(let n = 0, i = e1.length; n !== i; ++n)e1[n].evaluate(a), t[n].accumulateAdditive(s);
                    else for(let n = 0, r = e1.length; n !== r; ++n)e1[n].evaluate(a), t[n].accumulate(i, s);
                }
            }
            _updateWeight(e1) {
                let t = 0;
                if (this.enabled) {
                    t = this.weight;
                    const n = this._weightInterpolant;
                    if (null !== n) {
                        const i = n.evaluate(e1)[0];
                        t *= i, e1 > n.parameterPositions[1] && (this.stopFading(), 0 === i && (this.enabled = !1));
                    }
                }
                return this._effectiveWeight = t, t;
            }
            _updateTimeScale(e1) {
                let t = 0;
                if (!this.paused) {
                    t = this.timeScale;
                    const n = this._timeScaleInterpolant;
                    null !== n && (t *= n.evaluate(e1)[0], e1 > n.parameterPositions[1] && (this.stopWarping(), 0 === t ? this.paused = !0 : this.timeScale = t));
                }
                return this._effectiveTimeScale = t, t;
            }
            _updateTime(e1) {
                const t = this._clip.duration, n = this.loop;
                let i = this.time + e1, r = this._loopCount;
                const a = n === Ss;
                if (0 === e1) return -1 === r || !a || 1 & ~r ? i : t - i;
                if (n === Es) {
                    -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                    e: {
                        if (i >= t) i = t;
                        else {
                            if (!(i < 0)) {
                                this.time = i;
                                break e;
                            }
                            i = 0;
                        }
                        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: e1 < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (-1 === r && (e1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), i >= t || i < 0) {
                        const n = Math.floor(i / t);
                        i -= t * n, r += Math.abs(n);
                        const s = this.repetitions - r;
                        if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = e1 > 0 ? t : 0, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: e1 > 0 ? 1 : -1
                        });
                        else {
                            if (1 === s) {
                                const t = e1 < 0;
                                this._setEndings(t, !t, a);
                            } else this._setEndings(!1, !1, a);
                            this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                                type: "loop",
                                action: this,
                                loopDelta: n
                            });
                        }
                    } else this.time = i;
                    if (a && !(1 & ~r)) return t - i;
                }
                return i;
            }
            _setEndings(e1, t, n) {
                const i = this._interpolantSettings;
                n ? (i.endingStart = Cs, i.endingEnd = Cs) : (i.endingStart = e1 ? this.zeroSlopeAtStart ? Cs : _s : Ls, i.endingEnd = t ? this.zeroSlopeAtEnd ? Cs : _s : Ls);
            }
            _scheduleFading(e1, t, n) {
                const i = this._mixer, r = i.time;
                let a = this._weightInterpolant;
                null === a && (a = i._lendControlInterpolant(), this._weightInterpolant = a);
                const s = a.parameterPositions, o = a.sampleValues;
                return s[0] = r, o[0] = t, s[1] = r + e1, o[1] = n, this;
            }
        }
        const DM = new Float32Array(1);
        class _M extends jo {
            constructor(e1){
                super(), this._root = e1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
            }
            _bindAction(e1, t) {
                const n = e1._localRoot || this._root, i = e1._clip.tracks, r = i.length, a = e1._propertyBindings, s = e1._interpolants, o = n.uuid, l = this._bindingsByRootAndName;
                let c = l[o];
                void 0 === c && (c = {}, l[o] = c);
                for(let e1 = 0; e1 !== r; ++e1){
                    const r = i[e1], l = r.name;
                    let u = c[l];
                    if (void 0 !== u) ++u.referenceCount, a[e1] = u;
                    else {
                        if (u = a[e1], void 0 !== u) {
                            null === u._cacheIndex && (++u.referenceCount, this._addInactiveBinding(u, o, l));
                            continue;
                        }
                        const i = t && t._propertyBindings[e1].binding.parsedPath;
                        u = new vM(SM.create(n, l, i), r.ValueTypeName, r.getValueSize()), ++u.referenceCount, this._addInactiveBinding(u, o, l), a[e1] = u;
                    }
                    s[e1].resultBuffer = u.buffer;
                }
            }
            _activateAction(e1) {
                if (!this._isActiveAction(e1)) {
                    if (null === e1._cacheIndex) {
                        const t = (e1._localRoot || this._root).uuid, n = e1._clip.uuid, i = this._actionsByClip[n];
                        this._bindAction(e1, i && i.knownActions[0]), this._addInactiveAction(e1, n, t);
                    }
                    const t = e1._propertyBindings;
                    for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                        const n = t[e1];
                        0 == n.useCount++ && (this._lendBinding(n), n.saveOriginalState());
                    }
                    this._lendAction(e1);
                }
            }
            _deactivateAction(e1) {
                if (this._isActiveAction(e1)) {
                    const t = e1._propertyBindings;
                    for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                        const n = t[e1];
                        0 == --n.useCount && (n.restoreOriginalState(), this._takeBackBinding(n));
                    }
                    this._takeBackAction(e1);
                }
            }
            _initMemoryManager() {
                this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
                const e1 = this;
                this.stats = {
                    actions: {
                        get total () {
                            return e1._actions.length;
                        },
                        get inUse () {
                            return e1._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return e1._bindings.length;
                        },
                        get inUse () {
                            return e1._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return e1._controlInterpolants.length;
                        },
                        get inUse () {
                            return e1._nActiveControlInterpolants;
                        }
                    }
                };
            }
            _isActiveAction(e1) {
                const t = e1._cacheIndex;
                return null !== t && t < this._nActiveActions;
            }
            _addInactiveAction(e1, t, n) {
                const i = this._actions, r = this._actionsByClip;
                let a = r[t];
                if (void 0 === a) a = {
                    knownActions: [
                        e1
                    ],
                    actionByRoot: {}
                }, e1._byClipCacheIndex = 0, r[t] = a;
                else {
                    const t = a.knownActions;
                    e1._byClipCacheIndex = t.length, t.push(e1);
                }
                e1._cacheIndex = i.length, i.push(e1), a.actionByRoot[n] = e1;
            }
            _removeInactiveAction(e1) {
                const t = this._actions, n = t[t.length - 1], i = e1._cacheIndex;
                n._cacheIndex = i, t[i] = n, t.pop(), e1._cacheIndex = null;
                const r = e1._clip.uuid, a = this._actionsByClip, s = a[r], o = s.knownActions, l = o[o.length - 1], c = e1._byClipCacheIndex;
                l._byClipCacheIndex = c, o[c] = l, o.pop(), e1._byClipCacheIndex = null, delete s.actionByRoot[(e1._localRoot || this._root).uuid], 0 === o.length && delete a[r], this._removeInactiveBindingsForAction(e1);
            }
            _removeInactiveBindingsForAction(e1) {
                const t = e1._propertyBindings;
                for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                    const n = t[e1];
                    0 == --n.referenceCount && this._removeInactiveBinding(n);
                }
            }
            _lendAction(e1) {
                const t = this._actions, n = e1._cacheIndex, i = this._nActiveActions++, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _takeBackAction(e1) {
                const t = this._actions, n = e1._cacheIndex, i = --this._nActiveActions, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _addInactiveBinding(e1, t, n) {
                const i = this._bindingsByRootAndName, r = this._bindings;
                let a = i[t];
                void 0 === a && (a = {}, i[t] = a), a[n] = e1, e1._cacheIndex = r.length, r.push(e1);
            }
            _removeInactiveBinding(e1) {
                const t = this._bindings, n = e1.binding, i = n.rootNode.uuid, r = n.path, a = this._bindingsByRootAndName, s = a[i], o = t[t.length - 1], l = e1._cacheIndex;
                o._cacheIndex = l, t[l] = o, t.pop(), delete s[r], 0 === Object.keys(s).length && delete a[i];
            }
            _lendBinding(e1) {
                const t = this._bindings, n = e1._cacheIndex, i = this._nActiveBindings++, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _takeBackBinding(e1) {
                const t = this._bindings, n = e1._cacheIndex, i = --this._nActiveBindings, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _lendControlInterpolant() {
                const e1 = this._controlInterpolants, t = this._nActiveControlInterpolants++;
                let n = e1[t];
                return void 0 === n && (n = new $m(new Float32Array(2), new Float32Array(2), 1, DM), n.__cacheIndex = t, e1[t] = n), n;
            }
            _takeBackControlInterpolant(e1) {
                const t = this._controlInterpolants, n = e1.__cacheIndex, i = --this._nActiveControlInterpolants, r = t[i];
                e1.__cacheIndex = i, t[i] = e1, r.__cacheIndex = n, t[n] = r;
            }
            clipAction(e1, t, n) {
                const i = t || this._root, r = i.uuid;
                let a = "string" == typeof e1 ? cA.findByName(i, e1) : e1;
                const s = null !== a ? a.uuid : e1, o = this._actionsByClip[s];
                let l = null;
                if (void 0 === n && (n = null !== a ? a.blendMode : zs), void 0 !== o) {
                    const e1 = o.actionByRoot[r];
                    if (void 0 !== e1 && e1.blendMode === n) return e1;
                    l = o.knownActions[0], null === a && (a = l._clip);
                }
                if (null === a) return null;
                const c = new NM(this, a, t, n);
                return this._bindAction(c, l), this._addInactiveAction(c, s, r), c;
            }
            existingAction(e1, t) {
                const n = t || this._root, i = n.uuid, r = "string" == typeof e1 ? cA.findByName(n, e1) : e1, a = r ? r.uuid : e1, s = this._actionsByClip[a];
                return void 0 !== s && s.actionByRoot[i] || null;
            }
            stopAllAction() {
                const e1 = this._actions;
                for(let t = this._nActiveActions - 1; t >= 0; --t)e1[t].stop();
                return this;
            }
            update(e1) {
                e1 *= this.timeScale;
                const t = this._actions, n = this._nActiveActions, i = this.time += e1, r = Math.sign(e1), a = this._accuIndex ^= 1;
                for(let s = 0; s !== n; ++s)t[s]._update(i, e1, r, a);
                const s = this._bindings, o = this._nActiveBindings;
                for(let e1 = 0; e1 !== o; ++e1)s[e1].apply(a);
                return this;
            }
            setTime(e1) {
                this.time = 0;
                for(let e1 = 0; e1 < this._actions.length; e1++)this._actions[e1].time = 0;
                return this.update(e1);
            }
            getRoot() {
                return this._root;
            }
            uncacheClip(e1) {
                const t = this._actions, n = e1.uuid, i = this._actionsByClip, r = i[n];
                if (void 0 !== r) {
                    const e1 = r.knownActions;
                    for(let n = 0, i = e1.length; n !== i; ++n){
                        const i = e1[n];
                        this._deactivateAction(i);
                        const r = i._cacheIndex, a = t[t.length - 1];
                        i._cacheIndex = null, i._byClipCacheIndex = null, a._cacheIndex = r, t[r] = a, t.pop(), this._removeInactiveBindingsForAction(i);
                    }
                    delete i[n];
                }
            }
            uncacheRoot(e1) {
                const t = e1.uuid, n = this._actionsByClip;
                for(const e1 in n){
                    const i = n[e1].actionByRoot[t];
                    void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
                }
                const i = this._bindingsByRootAndName[t];
                if (void 0 !== i) for(const e1 in i){
                    const t = i[e1];
                    t.restoreOriginalState(), this._removeInactiveBinding(t);
                }
            }
            uncacheAction(e1, t) {
                const n = this.existingAction(e1, t);
                null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
            }
        }
        class CM {
            constructor(e1){
                this.value = e1;
            }
            clone() {
                return new CM(void 0 === this.value.clone ? this.value : this.value.clone());
            }
        }
        let LM = 0;
        class zM extends jo {
            constructor(){
                super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
                    value: LM++
                }), this.name = "", this.usage = Eo, this.uniforms = [];
            }
            add(e1) {
                return this.uniforms.push(e1), this;
            }
            remove(e1) {
                const t = this.uniforms.indexOf(e1);
                return -1 !== t && this.uniforms.splice(t, 1), this;
            }
            setName(e1) {
                return this.name = e1, this;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            dispose() {
                return this.dispatchEvent({
                    type: "dispose"
                }), this;
            }
            copy(e1) {
                this.name = e1.name, this.usage = e1.usage;
                const t = e1.uniforms;
                this.uniforms.length = 0;
                for(let e1 = 0, n = t.length; e1 < n; e1++)this.uniforms.push(t[e1].clone());
                return this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class OM extends qp {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
            }
            copy(e1) {
                return super.copy(e1), this.meshPerAttribute = e1.meshPerAttribute, this;
            }
            clone(e1) {
                const t = super.clone(e1);
                return t.meshPerAttribute = this.meshPerAttribute, t;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
            }
        }
        class RM {
            constructor(e1, t, n, i, r){
                this.isGLBufferAttribute = !0, this.name = "", this.buffer = e1, this.type = t, this.itemSize = n, this.elementSize = i, this.count = r, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setBuffer(e1) {
                return this.buffer = e1, this;
            }
            setType(e1, t) {
                return this.type = e1, this.elementSize = t, this;
            }
            setItemSize(e1) {
                return this.itemSize = e1, this;
            }
            setCount(e1) {
                return this.count = e1, this;
            }
        }
        class PM {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0;
                this.ray = new oc(e1, t), this.near = n, this.far = i, this.camera = null, this.layers = new vc, this.params = {
                    Mesh: {},
                    Line: {
                        threshold: 1
                    },
                    LOD: {},
                    Points: {
                        threshold: 1
                    },
                    Sprite: {}
                };
            }
            set(e1, t) {
                this.ray.set(e1, t);
            }
            setFromCamera(e1, t) {
                t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e1.x, e1.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e1.x, e1.y, (t.near + t.far) / (t.near - t.far)).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : console.error("THREE.Raycaster: Unsupported camera type: " + t.type);
            }
            intersectObject(e1) {
                let t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                return jM(e1, this, t, !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]), t.sort(UM), t;
            }
            intersectObjects(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                for(let i = 0, r = e1.length; i < r; i++)jM(e1[i], this, n, t);
                return n.sort(UM), n;
            }
        }
        function UM(e1, t) {
            return e1.distance - t.distance;
        }
        function jM(e1, t, n, i) {
            if (e1.layers.test(t.layers) && e1.raycast(t, n), !0 === i) {
                const i = e1.children;
                for(let e1 = 0, r = i.length; e1 < r; e1++)jM(i[e1], t, n, !0);
            }
        }
        class kM {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                return this.radius = e1, this.phi = t, this.theta = n, this;
            }
            set(e1, t, n) {
                return this.radius = e1, this.phi = t, this.theta = n, this;
            }
            copy(e1) {
                return this.radius = e1.radius, this.phi = e1.phi, this.theta = e1.theta, this;
            }
            makeSafe() {
                const e1 = 1e-6;
                return this.phi = Math.max(e1, Math.min(Math.PI - e1, this.phi)), this;
            }
            setFromVector3(e1) {
                return this.setFromCartesianCoords(e1.x, e1.y, e1.z);
            }
            setFromCartesianCoords(e1, t, n) {
                return this.radius = Math.sqrt(e1 * e1 + t * t + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e1, n), this.phi = Math.acos(Vo(t / this.radius, -1, 1))), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class BM {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                return this.radius = e1, this.theta = t, this.y = n, this;
            }
            set(e1, t, n) {
                return this.radius = e1, this.theta = t, this.y = n, this;
            }
            copy(e1) {
                return this.radius = e1.radius, this.theta = e1.theta, this.y = e1.y, this;
            }
            setFromVector3(e1) {
                return this.setFromCartesianCoords(e1.x, e1.y, e1.z);
            }
            setFromCartesianCoords(e1, t, n) {
                return this.radius = Math.sqrt(e1 * e1 + n * n), this.theta = Math.atan2(e1, n), this.y = t, this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const FM = new $o;
        class HM {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $o(1 / 0, 1 / 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $o(-1 / 0, -1 / 0);
                this.isBox2 = !0, this.min = e1, this.max = t;
            }
            set(e1, t) {
                return this.min.copy(e1), this.max.copy(t), this;
            }
            setFromPoints(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t++)this.expandByPoint(e1[t]);
                return this;
            }
            setFromCenterAndSize(e1, t) {
                const n = FM.copy(t).multiplyScalar(.5);
                return this.min.copy(e1).sub(n), this.max.copy(e1).add(n), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.min.copy(e1.min), this.max.copy(e1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
            getCenter(e1) {
                return this.isEmpty() ? e1.set(0, 0) : e1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(e1) {
                return this.isEmpty() ? e1.set(0, 0) : e1.subVectors(this.max, this.min);
            }
            expandByPoint(e1) {
                return this.min.min(e1), this.max.max(e1), this;
            }
            expandByVector(e1) {
                return this.min.sub(e1), this.max.add(e1), this;
            }
            expandByScalar(e1) {
                return this.min.addScalar(-e1), this.max.addScalar(e1), this;
            }
            containsPoint(e1) {
                return !(e1.x < this.min.x || e1.x > this.max.x || e1.y < this.min.y || e1.y > this.max.y);
            }
            containsBox(e1) {
                return this.min.x <= e1.min.x && e1.max.x <= this.max.x && this.min.y <= e1.min.y && e1.max.y <= this.max.y;
            }
            getParameter(e1, t) {
                return t.set((e1.x - this.min.x) / (this.max.x - this.min.x), (e1.y - this.min.y) / (this.max.y - this.min.y));
            }
            intersectsBox(e1) {
                return !(e1.max.x < this.min.x || e1.min.x > this.max.x || e1.max.y < this.min.y || e1.min.y > this.max.y);
            }
            clampPoint(e1, t) {
                return t.copy(e1).clamp(this.min, this.max);
            }
            distanceToPoint(e1) {
                return this.clampPoint(e1, FM).distanceTo(e1);
            }
            intersect(e1) {
                return this.min.max(e1.min), this.max.min(e1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(e1) {
                return this.min.min(e1.min), this.max.max(e1.max), this;
            }
            translate(e1) {
                return this.min.add(e1), this.max.add(e1), this;
            }
            equals(e1) {
                return e1.min.equals(this.min) && e1.max.equals(this.max);
            }
        }
        const GM = new Ll, VM = new Ll;
        class QM {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll;
                this.start = e1, this.end = t;
            }
            set(e1, t) {
                return this.start.copy(e1), this.end.copy(t), this;
            }
            copy(e1) {
                return this.start.copy(e1.start), this.end.copy(e1.end), this;
            }
            getCenter(e1) {
                return e1.addVectors(this.start, this.end).multiplyScalar(.5);
            }
            delta(e1) {
                return e1.subVectors(this.end, this.start);
            }
            distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
            distance() {
                return this.start.distanceTo(this.end);
            }
            at(e1, t) {
                return this.delta(t).multiplyScalar(e1).add(this.start);
            }
            closestPointToPointParameter(e1, t) {
                GM.subVectors(e1, this.start), VM.subVectors(this.end, this.start);
                const n = VM.dot(VM);
                let i = VM.dot(GM) / n;
                return t && (i = Vo(i, 0, 1)), i;
            }
            closestPointToPoint(e1, t, n) {
                const i = this.closestPointToPointParameter(e1, t);
                return this.delta(n).multiplyScalar(i).add(this.start);
            }
            applyMatrix4(e1) {
                return this.start.applyMatrix4(e1), this.end.applyMatrix4(e1), this;
            }
            equals(e1) {
                return e1.start.equals(this.start) && e1.end.equals(this.end);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const WM = new Ll;
        class YM extends zc {
            constructor(e1, t){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = t, this.type = "SpotLightHelper";
                const n = new Su, i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1
                ];
                for(let e1 = 0, t = 1, n = 32; e1 < n; e1++, t++){
                    const r = e1 / n * Math.PI * 2, a = t / n * Math.PI * 2;
                    i.push(Math.cos(r), Math.sin(r), 1, Math.cos(a), Math.sin(a), 1);
                }
                n.setAttribute("position", new Au(i, 3));
                const r = new Gf({
                    fog: !1,
                    toneMapped: !1
                });
                this.cone = new Jf(n, r), this.add(this.cone), this.update();
            }
            dispose() {
                this.cone.geometry.dispose(), this.cone.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
                const e1 = this.light.distance ? this.light.distance : 1e3, t = e1 * Math.tan(this.light.angle);
                this.cone.scale.set(t, t, e1), WM.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(WM), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
            }
        }
        const XM = new Ll, ZM = new lc, qM = new lc;
        class KM extends Jf {
            constructor(e1){
                const t = JM(e1), n = new Su, i = [], r = [], a = new qc(0, 0, 1), s = new qc(0, 1, 0);
                for(let e1 = 0; e1 < t.length; e1++){
                    const n = t[e1];
                    n.parent && n.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(a.r, a.g, a.b), r.push(s.r, s.g, s.b));
                }
                n.setAttribute("position", new Au(i, 3)), n.setAttribute("color", new Au(r, 3)), super(n, new Gf({
                    vertexColors: !0,
                    depthTest: !1,
                    depthWrite: !1,
                    toneMapped: !1,
                    transparent: !0
                })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = e1, this.bones = t, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1;
            }
            updateMatrixWorld(e1) {
                const t = this.bones, n = this.geometry, i = n.getAttribute("position");
                qM.copy(this.root.matrixWorld).invert();
                for(let e1 = 0, n = 0; e1 < t.length; e1++){
                    const r = t[e1];
                    r.parent && r.parent.isBone && (ZM.multiplyMatrices(qM, r.matrixWorld), XM.setFromMatrixPosition(ZM), i.setXYZ(n, XM.x, XM.y, XM.z), ZM.multiplyMatrices(qM, r.parent.matrixWorld), XM.setFromMatrixPosition(ZM), i.setXYZ(n + 1, XM.x, XM.y, XM.z), n += 2);
                }
                n.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(e1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function JM(e1) {
            const t = [];
            !0 === e1.isBone && t.push(e1);
            for(let n = 0; n < e1.children.length; n++)t.push.apply(t, JM(e1.children[n]));
            return t;
        }
        class $M extends Vu {
            constructor(e1, t, n){
                super(new Im(t, 4, 2), new eu({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                })), this.light = e1, this.color = n, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
            }
        }
        const ev = new Ll, tv = new qc, nv = new qc;
        class iv extends zc {
            constructor(e1, t, n){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "HemisphereLightHelper";
                const i = new Em(t);
                i.rotateY(.5 * Math.PI), this.material = new eu({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                }), void 0 === this.color && (this.material.vertexColors = !0);
                const r = i.getAttribute("position"), a = new Float32Array(3 * r.count);
                i.setAttribute("color", new lu(a, 3)), this.add(new Vu(i, this.material)), this.update();
            }
            dispose() {
                this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
            update() {
                const e1 = this.children[0];
                if (void 0 !== this.color) this.material.color.set(this.color);
                else {
                    const t = e1.geometry.getAttribute("color");
                    tv.copy(this.light.color), nv.copy(this.light.groundColor);
                    for(let e1 = 0, n = t.count; e1 < n; e1++){
                        const i = e1 < n / 2 ? tv : nv;
                        t.setXYZ(e1, i.r, i.g, i.b);
                    }
                    t.needsUpdate = !0;
                }
                this.light.updateWorldMatrix(!0, !1), e1.lookAt(ev.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
        class rv extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4473924, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8947848;
                n = new qc(n), i = new qc(i);
                const r = t / 2, a = e1 / t, s = e1 / 2, o = [], l = [];
                for(let e1 = 0, c = 0, u = -s; e1 <= t; e1++, u += a){
                    o.push(-s, 0, u, s, 0, u), o.push(u, 0, -s, u, 0, s);
                    const t = e1 === r ? n : i;
                    t.toArray(l, c), c += 3, t.toArray(l, c), c += 3, t.toArray(l, c), c += 3, t.toArray(l, c), c += 3;
                }
                const c = new Su;
                c.setAttribute("position", new Au(o, 3)), c.setAttribute("color", new Au(l, 3)), super(c, new Gf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "GridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class av extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 8, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 64, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 4473924, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 8947848;
                r = new qc(r), a = new qc(a);
                const s = [], o = [];
                if (t > 1) for(let n = 0; n < t; n++){
                    const i = n / t * (2 * Math.PI), l = Math.sin(i) * e1, c = Math.cos(i) * e1;
                    s.push(0, 0, 0), s.push(l, 0, c);
                    const u = 1 & n ? r : a;
                    o.push(u.r, u.g, u.b), o.push(u.r, u.g, u.b);
                }
                for(let t = 0; t < n; t++){
                    const l = 1 & t ? r : a, c = e1 - e1 / n * t;
                    for(let e1 = 0; e1 < i; e1++){
                        let t = e1 / i * (2 * Math.PI), n = Math.sin(t) * c, r = Math.cos(t) * c;
                        s.push(n, 0, r), o.push(l.r, l.g, l.b), t = (e1 + 1) / i * (2 * Math.PI), n = Math.sin(t) * c, r = Math.cos(t) * c, s.push(n, 0, r), o.push(l.r, l.g, l.b);
                    }
                }
                const l = new Su;
                l.setAttribute("position", new Au(s, 3)), l.setAttribute("color", new Au(o, 3)), super(l, new Gf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "PolarGridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        const sv = new Ll, ov = new Ll, lv = new Ll;
        class cv extends zc {
            constructor(e1, t, n){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "DirectionalLightHelper", void 0 === t && (t = 1);
                let i = new Su;
                i.setAttribute("position", new Au([
                    -t,
                    t,
                    0,
                    t,
                    t,
                    0,
                    t,
                    -t,
                    0,
                    -t,
                    -t,
                    0,
                    -t,
                    t,
                    0
                ], 3));
                const r = new Gf({
                    fog: !1,
                    toneMapped: !1
                });
                this.lightPlane = new Zf(i, r), this.add(this.lightPlane), i = new Su, i.setAttribute("position", new Au([
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ], 3)), this.targetLine = new Zf(i, r), this.add(this.targetLine), this.update();
            }
            dispose() {
                this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), sv.setFromMatrixPosition(this.light.matrixWorld), ov.setFromMatrixPosition(this.light.target.matrixWorld), lv.subVectors(ov, sv), this.lightPlane.lookAt(ov), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(ov), this.targetLine.scale.z = lv.length();
            }
        }
        const uv = new Ll, hv = new Ju;
        class dv extends Jf {
            constructor(e1){
                const t = new Su, n = new Gf({
                    color: 16777215,
                    vertexColors: !0,
                    toneMapped: !1
                }), i = [], r = [], a = {};
                function s(e1, t) {
                    o(e1), o(t);
                }
                function o(e1) {
                    i.push(0, 0, 0), r.push(0, 0, 0), void 0 === a[e1] && (a[e1] = []), a[e1].push(i.length / 3 - 1);
                }
                s("n1", "n2"), s("n2", "n4"), s("n4", "n3"), s("n3", "n1"), s("f1", "f2"), s("f2", "f4"), s("f4", "f3"), s("f3", "f1"), s("n1", "f1"), s("n2", "f2"), s("n3", "f3"), s("n4", "f4"), s("p", "n1"), s("p", "n2"), s("p", "n3"), s("p", "n4"), s("u1", "u2"), s("u2", "u3"), s("u3", "u1"), s("c", "t"), s("p", "c"), s("cn1", "cn2"), s("cn3", "cn4"), s("cf1", "cf2"), s("cf3", "cf4"), t.setAttribute("position", new Au(i, 3)), t.setAttribute("color", new Au(r, 3)), super(t, n), this.type = "CameraHelper", this.camera = e1, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
                const l = new qc(16755200), c = new qc(16711680), u = new qc(43775), h = new qc(16777215), d = new qc(3355443);
                this.setColors(l, c, u, h, d);
            }
            setColors(e1, t, n, i, r) {
                const a = this.geometry.getAttribute("color");
                a.setXYZ(0, e1.r, e1.g, e1.b), a.setXYZ(1, e1.r, e1.g, e1.b), a.setXYZ(2, e1.r, e1.g, e1.b), a.setXYZ(3, e1.r, e1.g, e1.b), a.setXYZ(4, e1.r, e1.g, e1.b), a.setXYZ(5, e1.r, e1.g, e1.b), a.setXYZ(6, e1.r, e1.g, e1.b), a.setXYZ(7, e1.r, e1.g, e1.b), a.setXYZ(8, e1.r, e1.g, e1.b), a.setXYZ(9, e1.r, e1.g, e1.b), a.setXYZ(10, e1.r, e1.g, e1.b), a.setXYZ(11, e1.r, e1.g, e1.b), a.setXYZ(12, e1.r, e1.g, e1.b), a.setXYZ(13, e1.r, e1.g, e1.b), a.setXYZ(14, e1.r, e1.g, e1.b), a.setXYZ(15, e1.r, e1.g, e1.b), a.setXYZ(16, e1.r, e1.g, e1.b), a.setXYZ(17, e1.r, e1.g, e1.b), a.setXYZ(18, e1.r, e1.g, e1.b), a.setXYZ(19, e1.r, e1.g, e1.b), a.setXYZ(20, e1.r, e1.g, e1.b), a.setXYZ(21, e1.r, e1.g, e1.b), a.setXYZ(22, e1.r, e1.g, e1.b), a.setXYZ(23, e1.r, e1.g, e1.b), a.setXYZ(24, t.r, t.g, t.b), a.setXYZ(25, t.r, t.g, t.b), a.setXYZ(26, t.r, t.g, t.b), a.setXYZ(27, t.r, t.g, t.b), a.setXYZ(28, t.r, t.g, t.b), a.setXYZ(29, t.r, t.g, t.b), a.setXYZ(30, t.r, t.g, t.b), a.setXYZ(31, t.r, t.g, t.b), a.setXYZ(32, n.r, n.g, n.b), a.setXYZ(33, n.r, n.g, n.b), a.setXYZ(34, n.r, n.g, n.b), a.setXYZ(35, n.r, n.g, n.b), a.setXYZ(36, n.r, n.g, n.b), a.setXYZ(37, n.r, n.g, n.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, r.r, r.g, r.b), a.setXYZ(41, r.r, r.g, r.b), a.setXYZ(42, r.r, r.g, r.b), a.setXYZ(43, r.r, r.g, r.b), a.setXYZ(44, r.r, r.g, r.b), a.setXYZ(45, r.r, r.g, r.b), a.setXYZ(46, r.r, r.g, r.b), a.setXYZ(47, r.r, r.g, r.b), a.setXYZ(48, r.r, r.g, r.b), a.setXYZ(49, r.r, r.g, r.b), a.needsUpdate = !0;
            }
            update() {
                const e1 = this.geometry, t = this.pointMap;
                hv.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), pv("c", t, e1, hv, 0, 0, -1), pv("t", t, e1, hv, 0, 0, 1), pv("n1", t, e1, hv, -1, -1, -1), pv("n2", t, e1, hv, 1, -1, -1), pv("n3", t, e1, hv, -1, 1, -1), pv("n4", t, e1, hv, 1, 1, -1), pv("f1", t, e1, hv, -1, -1, 1), pv("f2", t, e1, hv, 1, -1, 1), pv("f3", t, e1, hv, -1, 1, 1), pv("f4", t, e1, hv, 1, 1, 1), pv("u1", t, e1, hv, .7, 1.1, -1), pv("u2", t, e1, hv, -0.7, 1.1, -1), pv("u3", t, e1, hv, 0, 2, -1), pv("cf1", t, e1, hv, -1, 0, 1), pv("cf2", t, e1, hv, 1, 0, 1), pv("cf3", t, e1, hv, 0, -1, 1), pv("cf4", t, e1, hv, 0, 1, 1), pv("cn1", t, e1, hv, -1, 0, -1), pv("cn2", t, e1, hv, 1, 0, -1), pv("cn3", t, e1, hv, 0, -1, -1), pv("cn4", t, e1, hv, 0, 1, -1), e1.getAttribute("position").needsUpdate = !0;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function pv(e1, t, n, i, r, a, s) {
            uv.set(r, a, s).unproject(i);
            const o = t[e1];
            if (void 0 !== o) {
                const e1 = n.getAttribute("position");
                for(let t = 0, n = o.length; t < n; t++)e1.setXYZ(o[t], uv.x, uv.y, uv.z);
            }
        }
        const fv = new Rl;
        class gv extends Jf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16776960;
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Float32Array(24), r = new Su;
                r.setIndex(new lu(n, 1)), r.setAttribute("position", new lu(i, 3)), super(r, new Gf({
                    color: t,
                    toneMapped: !1
                })), this.object = e1, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
            }
            update(e1) {
                if (void 0 !== e1 && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && fv.setFromObject(this.object), fv.isEmpty()) return;
                const t = fv.min, n = fv.max, i = this.geometry.attributes.position, r = i.array;
                r[0] = n.x, r[1] = n.y, r[2] = n.z, r[3] = t.x, r[4] = n.y, r[5] = n.z, r[6] = t.x, r[7] = t.y, r[8] = n.z, r[9] = n.x, r[10] = t.y, r[11] = n.z, r[12] = n.x, r[13] = n.y, r[14] = t.z, r[15] = t.x, r[16] = n.y, r[17] = t.z, r[18] = t.x, r[19] = t.y, r[20] = t.z, r[21] = n.x, r[22] = t.y, r[23] = t.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
            setFromObject(e1) {
                return this.object = e1, this.update(), this;
            }
            copy(e1, t) {
                return super.copy(e1, t), this.object = e1.object, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class mv extends Jf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16776960;
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Su;
                i.setIndex(new lu(n, 1)), i.setAttribute("position", new Au([
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1
                ], 3)), super(i, new Gf({
                    color: t,
                    toneMapped: !1
                })), this.box = e1, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
            }
            updateMatrixWorld(e1) {
                const t = this.box;
                t.isEmpty() || (t.getCenter(this.position), t.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(e1));
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class Av extends Zf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                const n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16776960, i = new Su;
                i.setAttribute("position", new Au([
                    1,
                    -1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0,
                    1,
                    1,
                    0
                ], 3)), i.computeBoundingSphere(), super(i, new Gf({
                    color: n,
                    toneMapped: !1
                })), this.type = "PlaneHelper", this.plane = e1, this.size = t;
                const r = new Su;
                r.setAttribute("position", new Au([
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ], 3)), r.computeBoundingSphere(), this.add(new Vu(r, new eu({
                    color: n,
                    opacity: .2,
                    transparent: !0,
                    depthWrite: !1,
                    toneMapped: !1
                })));
            }
            updateMatrixWorld(e1) {
                this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(e1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
        }
        const Mv = new Ll;
        let vv, yv;
        class xv extends zc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ll(0, 0, 1), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Ll(0, 0, 0), n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 16776960, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : .2 * n, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : .2 * r;
                super(), this.type = "ArrowHelper", void 0 === vv && (vv = new Su, vv.setAttribute("position", new Au([
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ], 3)), yv = new jg(0, .5, 1, 5, 1), yv.translate(0, -0.5, 0)), this.position.copy(t), this.line = new Zf(vv, new Gf({
                    color: i,
                    toneMapped: !1
                })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Vu(yv, new eu({
                    color: i,
                    toneMapped: !1
                })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(e1), this.setLength(n, r, a);
            }
            setDirection(e1) {
                if (e1.y > .99999) this.quaternion.set(0, 0, 0, 1);
                else if (e1.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    Mv.set(e1.z, 0, -e1.x).normalize();
                    const t = Math.acos(e1.y);
                    this.quaternion.setFromAxisAngle(Mv, t);
                }
            }
            setLength(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .2 * e1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .2 * t;
                this.line.scale.set(1, Math.max(1e-4, e1 - t), 1), this.line.updateMatrix(), this.cone.scale.set(n, t, n), this.cone.position.y = e1, this.cone.updateMatrix();
            }
            setColor(e1) {
                this.line.material.color.set(e1), this.cone.material.color.set(e1);
            }
            copy(e1) {
                return super.copy(e1, !1), this.line.copy(e1.line), this.cone.copy(e1.cone), this;
            }
            dispose() {
                this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
            }
        }
        class bv extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                const t = [
                    0,
                    0,
                    0,
                    e1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    e1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    e1
                ], n = new Su;
                n.setAttribute("position", new Au(t, 3)), n.setAttribute("color", new Au([
                    1,
                    0,
                    0,
                    1,
                    .6,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1
                ], 3)), super(n, new Gf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "AxesHelper";
            }
            setColors(e1, t, n) {
                const i = new qc, r = this.geometry.attributes.color.array;
                return i.set(e1), i.toArray(r, 0), i.toArray(r, 3), i.set(t), i.toArray(r, 6), i.toArray(r, 9), i.set(n), i.toArray(r, 12), i.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class wv {
            constructor(){
                this.type = "ShapePath", this.color = new qc, this.subPaths = [], this.currentPath = null;
            }
            moveTo(e1, t) {
                return this.currentPath = new Og, this.subPaths.push(this.currentPath), this.currentPath.moveTo(e1, t), this;
            }
            lineTo(e1, t) {
                return this.currentPath.lineTo(e1, t), this;
            }
            quadraticCurveTo(e1, t, n, i) {
                return this.currentPath.quadraticCurveTo(e1, t, n, i), this;
            }
            bezierCurveTo(e1, t, n, i, r, a) {
                return this.currentPath.bezierCurveTo(e1, t, n, i, r, a), this;
            }
            splineThru(e1) {
                return this.currentPath.splineThru(e1), this;
            }
            toShapes(e1) {
                function t(e1, t) {
                    const n = t.length;
                    let i = !1;
                    for(let r = n - 1, a = 0; a < n; r = a++){
                        let n = t[r], s = t[a], o = s.x - n.x, l = s.y - n.y;
                        if (Math.abs(l) > Number.EPSILON) {
                            if (l < 0 && (n = t[a], o = -o, s = t[r], l = -l), e1.y < n.y || e1.y > s.y) continue;
                            if (e1.y === n.y) {
                                if (e1.x === n.x) return !0;
                            } else {
                                const t = l * (e1.x - n.x) - o * (e1.y - n.y);
                                if (0 === t) return !0;
                                if (t < 0) continue;
                                i = !i;
                            }
                        } else {
                            if (e1.y !== n.y) continue;
                            if (s.x <= e1.x && e1.x <= n.x || n.x <= e1.x && e1.x <= s.x) return !0;
                        }
                    }
                    return i;
                }
                const n = Mm.isClockWise, i = this.subPaths;
                if (0 === i.length) return [];
                let r, a, s;
                const o = [];
                if (1 === i.length) return a = i[0], s = new Yg, s.curves = a.curves, o.push(s), o;
                let l = !n(i[0].getPoints());
                l = e1 ? !l : l;
                const c = [], u = [];
                let h, d, p = [], f = 0;
                u[f] = void 0, p[f] = [];
                for(let t = 0, s = i.length; t < s; t++)a = i[t], h = a.getPoints(), r = n(h), r = e1 ? !r : r, r ? (!l && u[f] && f++, u[f] = {
                    s: new Yg,
                    p: h
                }, u[f].s.curves = a.curves, l && f++, p[f] = []) : p[f].push({
                    h: a,
                    p: h[0]
                });
                if (!u[0]) return function(e1) {
                    const t = [];
                    for(let n = 0, i = e1.length; n < i; n++){
                        const i = e1[n], r = new Yg;
                        r.curves = i.curves, t.push(r);
                    }
                    return t;
                }(i);
                if (u.length > 1) {
                    let e1 = !1, n = 0;
                    for(let e1 = 0, t = u.length; e1 < t; e1++)c[e1] = [];
                    for(let i = 0, r = u.length; i < r; i++){
                        const r = p[i];
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            let o = !0;
                            for(let r = 0; r < u.length; r++)t(s.p, u[r].p) && (i !== r && n++, o ? (o = !1, c[r].push(s)) : e1 = !0);
                            o && c[i].push(s);
                        }
                    }
                    n > 0 && !1 === e1 && (p = c);
                }
                for(let e1 = 0, t = u.length; e1 < t; e1++){
                    s = u[e1].s, o.push(s), d = p[e1];
                    for(let e1 = 0, t = d.length; e1 < t; e1++)s.holes.push(d[e1].h);
                }
                return o;
            }
        }
        function Ev(e1, t) {
            if (t === Rs) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), e1;
            if (t === Us || t === Ps) {
                let n = e1.getIndex();
                if (null === n) {
                    const t = [], i = e1.getAttribute("position");
                    if (void 0 === i) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), e1;
                    for(let e1 = 0; e1 < i.count; e1++)t.push(e1);
                    e1.setIndex(t), n = e1.getIndex();
                }
                const i = n.count - 2, r = [];
                if (t === Us) for(let e1 = 1; e1 <= i; e1++)r.push(n.getX(0)), r.push(n.getX(e1)), r.push(n.getX(e1 + 1));
                else for(let e1 = 0; e1 < i; e1++)e1 % 2 == 0 ? (r.push(n.getX(e1)), r.push(n.getX(e1 + 1)), r.push(n.getX(e1 + 2))) : (r.push(n.getX(e1 + 2)), r.push(n.getX(e1 + 1)), r.push(n.getX(e1)));
                r.length / 3 !== i && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
                const a = e1.clone();
                return a.setIndex(r), a.clearGroups(), a;
            }
            return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", t), e1;
        }
        "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
            detail: {
                revision: $i
            }
        })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $i);
        class Tv extends fA {
            constructor(e1){
                super(e1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(e1) {
                    return new Cv(e1);
                }), this.register(function(e1) {
                    return new kv(e1);
                }), this.register(function(e1) {
                    return new Bv(e1);
                }), this.register(function(e1) {
                    return new Fv(e1);
                }), this.register(function(e1) {
                    return new zv(e1);
                }), this.register(function(e1) {
                    return new Ov(e1);
                }), this.register(function(e1) {
                    return new Rv(e1);
                }), this.register(function(e1) {
                    return new Pv(e1);
                }), this.register(function(e1) {
                    return new _v(e1);
                }), this.register(function(e1) {
                    return new Uv(e1);
                }), this.register(function(e1) {
                    return new Lv(e1);
                }), this.register(function(e1) {
                    return new jv(e1);
                }), this.register(function(e1) {
                    return new Nv(e1);
                }), this.register(function(e1) {
                    return new Hv(e1);
                }), this.register(function(e1) {
                    return new Gv(e1);
                });
            }
            load(e1, t, n, i) {
                const r = this;
                let a;
                a = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : VA.extractUrlBase(e1), this.manager.itemStart(e1);
                const s = function(t) {
                    i ? i(t) : console.error(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }, o = new AA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(e1, function(n) {
                    try {
                        r.parse(n, a, function(n) {
                            t(n), r.manager.itemEnd(e1);
                        }, s);
                    } catch (e1) {
                        s(e1);
                    }
                }, n, s);
            }
            setDRACOLoader(e1) {
                return this.dracoLoader = e1, this;
            }
            setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
            }
            setKTX2Loader(e1) {
                return this.ktx2Loader = e1, this;
            }
            setMeshoptDecoder(e1) {
                return this.meshoptDecoder = e1, this;
            }
            register(e1) {
                return -1 === this.pluginCallbacks.indexOf(e1) && this.pluginCallbacks.push(e1), this;
            }
            unregister(e1) {
                return -1 !== this.pluginCallbacks.indexOf(e1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e1), 1), this;
            }
            parse(e1, t, n, i) {
                let r;
                const a = {}, s = {}, o = new TextDecoder;
                if ("string" == typeof e1) r = JSON.parse(e1);
                else if (e1 instanceof ArrayBuffer) {
                    if (o.decode(new Uint8Array(e1, 0, 4)) === Vv) {
                        try {
                            a[Iv.KHR_BINARY_GLTF] = new Qv(e1);
                        } catch (e1) {
                            return void (i && i(e1));
                        }
                        r = JSON.parse(a[Iv.KHR_BINARY_GLTF].content);
                    } else r = JSON.parse(o.decode(e1));
                } else r = e1;
                if (void 0 === r.asset || r.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
                const l = new py(r, {
                    path: t || this.resourcePath || "",
                    crossOrigin: this.crossOrigin,
                    requestHeader: this.requestHeader,
                    manager: this.manager,
                    ktx2Loader: this.ktx2Loader,
                    meshoptDecoder: this.meshoptDecoder
                });
                l.fileLoader.setRequestHeader(this.requestHeader);
                for(let e1 = 0; e1 < this.pluginCallbacks.length; e1++){
                    const t = this.pluginCallbacks[e1](l);
                    t.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), s[t.name] = t, a[t.name] = !0;
                }
                if (r.extensionsUsed) for(let e1 = 0; e1 < r.extensionsUsed.length; ++e1){
                    const t = r.extensionsUsed[e1], n = r.extensionsRequired || [];
                    switch(t){
                        case Iv.KHR_MATERIALS_UNLIT:
                            a[t] = new Dv;
                            break;
                        case Iv.KHR_DRACO_MESH_COMPRESSION:
                            a[t] = new Wv(r, this.dracoLoader);
                            break;
                        case Iv.KHR_TEXTURE_TRANSFORM:
                            a[t] = new Yv;
                            break;
                        case Iv.KHR_MESH_QUANTIZATION:
                            a[t] = new Xv;
                            break;
                        default:
                            n.indexOf(t) >= 0 && void 0 === s[t] && console.warn('THREE.GLTFLoader: Unknown extension "' + t + '".');
                    }
                }
                l.setExtensions(a), l.setPlugins(s), l.parse(n, i);
            }
            parseAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.parse(e1, t, i, r);
                });
            }
        }
        function Sv() {
            let e1 = {};
            return {
                get: function(t) {
                    return e1[t];
                },
                add: function(t, n) {
                    e1[t] = n;
                },
                remove: function(t) {
                    delete e1[t];
                },
                removeAll: function() {
                    e1 = {};
                }
            };
        }
        const Iv = {
            KHR_BINARY_GLTF: "KHR_binary_glTF",
            KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
            KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
            KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
            KHR_MATERIALS_IOR: "KHR_materials_ior",
            KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
            KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
            KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
            KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
            KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
            KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
            KHR_MATERIALS_VOLUME: "KHR_materials_volume",
            KHR_TEXTURE_BASISU: "KHR_texture_basisu",
            KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
            KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
            KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
            EXT_TEXTURE_WEBP: "EXT_texture_webp",
            EXT_TEXTURE_AVIF: "EXT_texture_avif",
            EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
            EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
        };
        class Nv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_LIGHTS_PUNCTUAL, this.cache = {
                    refs: {},
                    uses: {}
                };
            }
            _markDefs() {
                const e1 = this.parser, t = this.parser.json.nodes || [];
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n];
                    i.extensions && i.extensions[this.name] && void 0 !== i.extensions[this.name].light && e1._addNodeRef(this.cache, i.extensions[this.name].light);
                }
            }
            _loadLight(e1) {
                const t = this.parser, n = "light:" + e1;
                let i = t.cache.get(n);
                if (i) return i;
                const r = t.json, a = ((r.extensions && r.extensions[this.name] || {}).lights || [])[e1];
                let s;
                const o = new qc(16777215);
                void 0 !== a.color && o.setRGB(a.color[0], a.color[1], a.color[2], Ws);
                const l = void 0 !== a.range ? a.range : 0;
                switch(a.type){
                    case "directional":
                        s = new jA(o), s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    case "point":
                        s = new PA(o), s.distance = l;
                        break;
                    case "spot":
                        s = new CA(o), s.distance = l, a.spot = a.spot || {}, a.spot.innerConeAngle = void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = void 0 !== a.spot.outerConeAngle ? a.spot.outerConeAngle : Math.PI / 4, s.angle = a.spot.outerConeAngle, s.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    default:
                        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
                }
                return s.position.set(0, 0, 0), s.decay = 2, oy(s, a), void 0 !== a.intensity && (s.intensity = a.intensity), s.name = t.createUniqueName(a.name || "light_" + e1), i = Promise.resolve(s), t.cache.add(n, i), i;
            }
            getDependency(e1, t) {
                if ("light" === e1) return this._loadLight(t);
            }
            createNodeAttachment(e1) {
                const t = this, n = this.parser, i = n.json.nodes[e1], r = (i.extensions && i.extensions[this.name] || {}).light;
                return void 0 === r ? null : this._loadLight(r).then(function(e1) {
                    return n._getNodeRef(t.cache, r, e1);
                });
            }
        }
        class Dv {
            constructor(){
                this.name = Iv.KHR_MATERIALS_UNLIT;
            }
            getMaterialType() {
                return eu;
            }
            extendParams(e1, t, n) {
                const i = [];
                e1.color = new qc(1, 1, 1), e1.opacity = 1;
                const r = t.pbrMetallicRoughness;
                if (r) {
                    if (Array.isArray(r.baseColorFactor)) {
                        const t = r.baseColorFactor;
                        e1.color.setRGB(t[0], t[1], t[2], Ws), e1.opacity = t[3];
                    }
                    void 0 !== r.baseColorTexture && i.push(n.assignTexture(e1, "map", r.baseColorTexture, Qs));
                }
                return Promise.all(i);
            }
        }
        class _v {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser.json.materials[e1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name].emissiveStrength;
                return void 0 !== i && (t.emissiveIntensity = i), Promise.resolve();
            }
        }
        class Cv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_CLEARCOAT;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                if (void 0 !== a.clearcoatFactor && (t.clearcoat = a.clearcoatFactor), void 0 !== a.clearcoatTexture && r.push(n.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), void 0 !== a.clearcoatRoughnessFactor && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), void 0 !== a.clearcoatRoughnessTexture && r.push(n.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), void 0 !== a.clearcoatNormalTexture && (r.push(n.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), void 0 !== a.clearcoatNormalTexture.scale)) {
                    const e1 = a.clearcoatNormalTexture.scale;
                    t.clearcoatNormalScale = new $o(e1, e1);
                }
                return Promise.all(r);
            }
        }
        class Lv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_IRIDESCENCE;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.iridescenceFactor && (t.iridescence = a.iridescenceFactor), void 0 !== a.iridescenceTexture && r.push(n.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), void 0 !== a.iridescenceIor && (t.iridescenceIOR = a.iridescenceIor), void 0 === t.iridescenceThicknessRange && (t.iridescenceThicknessRange = [
                    100,
                    400
                ]), void 0 !== a.iridescenceThicknessMinimum && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), void 0 !== a.iridescenceThicknessMaximum && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), void 0 !== a.iridescenceThicknessTexture && r.push(n.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
            }
        }
        class zv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_SHEEN;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [];
                t.sheenColor = new qc(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
                const a = i.extensions[this.name];
                if (void 0 !== a.sheenColorFactor) {
                    const e1 = a.sheenColorFactor;
                    t.sheenColor.setRGB(e1[0], e1[1], e1[2], Ws);
                }
                return void 0 !== a.sheenRoughnessFactor && (t.sheenRoughness = a.sheenRoughnessFactor), void 0 !== a.sheenColorTexture && r.push(n.assignTexture(t, "sheenColorMap", a.sheenColorTexture, Qs)), void 0 !== a.sheenRoughnessTexture && r.push(n.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
            }
        }
        class Ov {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_TRANSMISSION;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.transmissionFactor && (t.transmission = a.transmissionFactor), void 0 !== a.transmissionTexture && r.push(n.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(r);
            }
        }
        class Rv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_VOLUME;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                t.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0, void 0 !== a.thicknessTexture && r.push(n.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
                const s = a.attenuationColor || [
                    1,
                    1,
                    1
                ];
                return t.attenuationColor = (new qc).setRGB(s[0], s[1], s[2], Ws), Promise.all(r);
            }
        }
        class Pv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_IOR;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser.json.materials[e1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name];
                return t.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
            }
        }
        class Uv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_SPECULAR;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                t.specularIntensity = void 0 !== a.specularFactor ? a.specularFactor : 1, void 0 !== a.specularTexture && r.push(n.assignTexture(t, "specularIntensityMap", a.specularTexture));
                const s = a.specularColorFactor || [
                    1,
                    1,
                    1
                ];
                return t.specularColor = (new qc).setRGB(s[0], s[1], s[2], Ws), void 0 !== a.specularColorTexture && r.push(n.assignTexture(t, "specularColorMap", a.specularColorTexture, Qs)), Promise.all(r);
            }
        }
        class jv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_MATERIALS_ANISOTROPY;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? jm : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.anisotropyStrength && (t.anisotropy = a.anisotropyStrength), void 0 !== a.anisotropyRotation && (t.anisotropyRotation = a.anisotropyRotation), void 0 !== a.anisotropyTexture && r.push(n.assignTexture(t, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
            }
        }
        class kv {
            constructor(e1){
                this.parser = e1, this.name = Iv.KHR_TEXTURE_BASISU;
            }
            loadTexture(e1) {
                const t = this.parser, n = t.json, i = n.textures[e1];
                if (!i.extensions || !i.extensions[this.name]) return null;
                const r = i.extensions[this.name], a = t.options.ktx2Loader;
                if (!a) {
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
                    return null;
                }
                return t.loadTextureImage(e1, r.source, a);
            }
        }
        class Bv {
            constructor(e1){
                this.parser = e1, this.name = Iv.EXT_TEXTURE_WEBP, this.isSupported = null;
            }
            loadTexture(e1) {
                const t = this.name, n = this.parser, i = n.json, r = i.textures[e1];
                if (!r.extensions || !r.extensions[t]) return null;
                const a = r.extensions[t], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const e1 = n.options.manager.getHandler(s.uri);
                    null !== e1 && (o = e1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(e1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
                    return n.loadTexture(e1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(e1) {
                    const t = new Image;
                    t.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", t.onload = t.onerror = function() {
                        e1(1 === t.height);
                    };
                })), this.isSupported;
            }
        }
        class Fv {
            constructor(e1){
                this.parser = e1, this.name = Iv.EXT_TEXTURE_AVIF, this.isSupported = null;
            }
            loadTexture(e1) {
                const t = this.name, n = this.parser, i = n.json, r = i.textures[e1];
                if (!r.extensions || !r.extensions[t]) return null;
                const a = r.extensions[t], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const e1 = n.options.manager.getHandler(s.uri);
                    null !== e1 && (o = e1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(e1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
                    return n.loadTexture(e1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(e1) {
                    const t = new Image;
                    t.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", t.onload = t.onerror = function() {
                        e1(1 === t.height);
                    };
                })), this.isSupported;
            }
        }
        class Hv {
            constructor(e1){
                this.name = Iv.EXT_MESHOPT_COMPRESSION, this.parser = e1;
            }
            loadBufferView(e1) {
                const t = this.parser.json, n = t.bufferViews[e1];
                if (n.extensions && n.extensions[this.name]) {
                    const e1 = n.extensions[this.name], i = this.parser.getDependency("buffer", e1.buffer), r = this.parser.options.meshoptDecoder;
                    if (!r || !r.supported) {
                        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                        return null;
                    }
                    return i.then(function(t) {
                        const n = e1.byteOffset || 0, i = e1.byteLength || 0, a = e1.count, s = e1.byteStride, o = new Uint8Array(t, n, i);
                        return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(a, s, o, e1.mode, e1.filter).then(function(e1) {
                            return e1.buffer;
                        }) : r.ready.then(function() {
                            const t = new ArrayBuffer(a * s);
                            return r.decodeGltfBuffer(new Uint8Array(t), a, s, o, e1.mode, e1.filter), t;
                        });
                    });
                }
                return null;
            }
        }
        class Gv {
            constructor(e1){
                this.name = Iv.EXT_MESH_GPU_INSTANCING, this.parser = e1;
            }
            createNodeMesh(e1) {
                const t = this.parser.json, n = t.nodes[e1];
                if (!n.extensions || !n.extensions[this.name] || void 0 === n.mesh) return null;
                const i = t.meshes[n.mesh];
                for (const e1 of i.primitives)if (e1.mode !== Jv.TRIANGLES && e1.mode !== Jv.TRIANGLE_STRIP && e1.mode !== Jv.TRIANGLE_FAN && void 0 !== e1.mode) return null;
                const r = n.extensions[this.name].attributes, a = [], s = {};
                for(const e1 in r)a.push(this.parser.getDependency("accessor", r[e1]).then((t)=>(s[e1] = t, s[e1])));
                return a.length < 1 ? null : (a.push(this.parser.createNodeMesh(e1)), Promise.all(a).then((e1)=>{
                    const t = e1.pop(), n = t.isGroup ? t.children : [
                        t
                    ], i = e1[0].count, r = [];
                    for (const e1 of n){
                        const t = new lc, n = new Ll, a = new Cl, o = new Ll(1, 1, 1), l = new Hf(e1.geometry, e1.material, i);
                        for(let e1 = 0; e1 < i; e1++)s.TRANSLATION && n.fromBufferAttribute(s.TRANSLATION, e1), s.ROTATION && a.fromBufferAttribute(s.ROTATION, e1), s.SCALE && o.fromBufferAttribute(s.SCALE, e1), l.setMatrixAt(e1, t.compose(n, a, o));
                        for(const t in s)if ("_COLOR_0" === t) {
                            const e1 = s[t];
                            l.instanceColor = new Of(e1.array, e1.itemSize, e1.normalized);
                        } else "TRANSLATION" !== t && "ROTATION" !== t && "SCALE" !== t && e1.geometry.setAttribute(t, s[t]);
                        zc.prototype.copy.call(l, e1), this.parser.assignFinalMaterial(l), r.push(l);
                    }
                    return t.isGroup ? (t.clear(), t.add(...r), t) : r[0];
                }));
            }
        }
        const Vv = "glTF";
        class Qv {
            constructor(e1){
                this.name = Iv.KHR_BINARY_GLTF, this.content = null, this.body = null;
                const t = new DataView(e1, 0, 12), n = new TextDecoder;
                if (this.header = {
                    magic: n.decode(new Uint8Array(e1.slice(0, 4))),
                    version: t.getUint32(4, !0),
                    length: t.getUint32(8, !0)
                }, this.header.magic !== Vv) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
                if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
                const i = this.header.length - 12, r = new DataView(e1, 12);
                let a = 0;
                for(; a < i;){
                    const t = r.getUint32(a, !0);
                    a += 4;
                    const i = r.getUint32(a, !0);
                    if (a += 4, 1313821514 === i) {
                        const i = new Uint8Array(e1, 12 + a, t);
                        this.content = n.decode(i);
                    } else if (5130562 === i) {
                        const n = 12 + a;
                        this.body = e1.slice(n, n + t);
                    }
                    a += t;
                }
                if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
            }
        }
        class Wv {
            constructor(e1, t){
                if (!t) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
                this.name = Iv.KHR_DRACO_MESH_COMPRESSION, this.json = e1, this.dracoLoader = t, this.dracoLoader.preload();
            }
            decodePrimitive(e1, t) {
                const n = this.json, i = this.dracoLoader, r = e1.extensions[this.name].bufferView, a = e1.extensions[this.name].attributes, s = {}, o = {}, l = {};
                for(const e1 in a){
                    const t = iy[e1] || e1.toLowerCase();
                    s[t] = a[e1];
                }
                for(const t in e1.attributes){
                    const i = iy[t] || t.toLowerCase();
                    if (void 0 !== a[t]) {
                        const r = n.accessors[e1.attributes[t]], a = $v[r.componentType];
                        l[i] = a.name, o[i] = !0 === r.normalized;
                    }
                }
                return t.getDependency("bufferView", r).then(function(e1) {
                    return new Promise(function(t) {
                        i.decodeDracoFile(e1, function(e1) {
                            for(const t in e1.attributes){
                                const n = e1.attributes[t], i = o[t];
                                void 0 !== i && (n.normalized = i);
                            }
                            t(e1);
                        }, s, l);
                    });
                });
            }
        }
        class Yv {
            constructor(){
                this.name = Iv.KHR_TEXTURE_TRANSFORM;
            }
            extendTexture(e1, t) {
                return void 0 !== t.texCoord && t.texCoord !== e1.channel || void 0 !== t.offset || void 0 !== t.rotation || void 0 !== t.scale ? (e1 = e1.clone(), void 0 !== t.texCoord && (e1.channel = t.texCoord), void 0 !== t.offset && e1.offset.fromArray(t.offset), void 0 !== t.rotation && (e1.rotation = t.rotation), void 0 !== t.scale && e1.repeat.fromArray(t.scale), e1.needsUpdate = !0, e1) : e1;
            }
        }
        class Xv {
            constructor(){
                this.name = Iv.KHR_MESH_QUANTIZATION;
            }
        }
        class Zv extends Km {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            copySampleValue_(e1) {
                const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e1 * i * 3 + i;
                for(let e1 = 0; e1 !== i; e1++)t[e1] = n[r + e1];
                return t;
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = 2 * s, l = 3 * s, c = i - t, u = (n - t) / c, h = u * u, d = h * u, p = e1 * l, f = p - l, g = -2 * d + 3 * h, m = d - h, A = 1 - g, M = m - h + u;
                for(let e1 = 0; e1 !== s; e1++){
                    const t = a[f + e1 + s], n = a[f + e1 + o] * c, i = a[p + e1 + s], l = a[p + e1] * c;
                    r[e1] = A * t + M * n + g * i + m * l;
                }
                return r;
            }
        }
        const qv = new Cl;
        class Kv extends Zv {
            interpolate_(e1, t, n, i) {
                const r = super.interpolate_(e1, t, n, i);
                return qv.fromArray(r).normalize().toArray(r), r;
            }
        }
        const Jv = {
            FLOAT: 5126,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        }, $v = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, ey = {
            9728: fa,
            9729: va,
            9984: ga,
            9985: ya,
            9986: Aa,
            9987: ba
        }, ty = {
            33071: da,
            33648: pa,
            10497: ha
        }, ny = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        }, iy = {
            POSITION: "position",
            NORMAL: "normal",
            TANGENT: "tangent",
            TEXCOORD_0: "uv",
            TEXCOORD_1: "uv1",
            TEXCOORD_2: "uv2",
            TEXCOORD_3: "uv3",
            COLOR_0: "color",
            WEIGHTS_0: "skinWeight",
            JOINTS_0: "skinIndex"
        }, ry = {
            scale: "scale",
            translation: "position",
            rotation: "quaternion",
            weights: "morphTargetInfluences"
        }, ay = {
            CUBICSPLINE: void 0,
            LINEAR: Ns,
            STEP: Is
        };
        function sy(e1, t, n) {
            for(const i in n.extensions)void 0 === e1[i] && (t.userData.gltfExtensions = t.userData.gltfExtensions || {}, t.userData.gltfExtensions[i] = n.extensions[i]);
        }
        function oy(e1, t) {
            void 0 !== t.extras && ("object" == typeof t.extras ? Object.assign(e1.userData, t.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + t.extras));
        }
        function ly(e1, t) {
            if (e1.updateMorphTargets(), void 0 !== t.weights) for(let n = 0, i = t.weights.length; n < i; n++)e1.morphTargetInfluences[n] = t.weights[n];
            if (t.extras && Array.isArray(t.extras.targetNames)) {
                const n = t.extras.targetNames;
                if (e1.morphTargetInfluences.length === n.length) {
                    e1.morphTargetDictionary = {};
                    for(let t = 0, i = n.length; t < i; t++)e1.morphTargetDictionary[n[t]] = t;
                } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
            }
        }
        function cy(e1) {
            let t;
            const n = e1.extensions && e1.extensions[Iv.KHR_DRACO_MESH_COMPRESSION];
            if (t = n ? "draco:" + n.bufferView + ":" + n.indices + ":" + uy(n.attributes) : e1.indices + ":" + uy(e1.attributes) + ":" + e1.mode, void 0 !== e1.targets) for(let n = 0, i = e1.targets.length; n < i; n++)t += ":" + uy(e1.targets[n]);
            return t;
        }
        function uy(e1) {
            let t = "";
            const n = Object.keys(e1).sort();
            for(let i = 0, r = n.length; i < r; i++)t += n[i] + ":" + e1[n[i]] + ";";
            return t;
        }
        function hy(e1) {
            switch(e1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
            }
        }
        const dy = new lc;
        class py {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                this.json = e1, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new Sv, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
                    refs: {},
                    uses: {}
                }, this.cameraCache = {
                    refs: {},
                    uses: {}
                }, this.lightCache = {
                    refs: {},
                    uses: {}
                }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
                let n = !1, i = !1, r = -1;
                "undefined" != typeof navigator && (n = !0 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent), i = navigator.userAgent.indexOf("Firefox") > -1, r = i ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), "undefined" == typeof createImageBitmap || n || i && r < 98 ? this.textureLoader = new wA(this.options.manager) : this.textureLoader = new KA(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new AA(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
            }
            setExtensions(e1) {
                this.extensions = e1;
            }
            setPlugins(e1) {
                this.plugins = e1;
            }
            parse(e1, t) {
                const n = this, i = this.json, r = this.extensions;
                this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(e1) {
                    return e1._markDefs && e1._markDefs();
                }), Promise.all(this._invokeAll(function(e1) {
                    return e1.beforeRoot && e1.beforeRoot();
                })).then(function() {
                    return Promise.all([
                        n.getDependencies("scene"),
                        n.getDependencies("animation"),
                        n.getDependencies("camera")
                    ]);
                }).then(function(t) {
                    const a = {
                        scene: t[0][i.scene || 0],
                        scenes: t[0],
                        animations: t[1],
                        cameras: t[2],
                        asset: i.asset,
                        parser: n,
                        userData: {}
                    };
                    return sy(r, a, i), oy(a, i), Promise.all(n._invokeAll(function(e1) {
                        return e1.afterRoot && e1.afterRoot(a);
                    })).then(function() {
                        e1(a);
                    });
                }).catch(t);
            }
            _markDefs() {
                const e1 = this.json.nodes || [], t = this.json.skins || [], n = this.json.meshes || [];
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n].joints;
                    for(let t = 0, n = i.length; t < n; t++)e1[i[t]].isBone = !0;
                }
                for(let t = 0, i = e1.length; t < i; t++){
                    const i = e1[t];
                    void 0 !== i.mesh && (this._addNodeRef(this.meshCache, i.mesh), void 0 !== i.skin && (n[i.mesh].isSkinnedMesh = !0)), void 0 !== i.camera && this._addNodeRef(this.cameraCache, i.camera);
                }
            }
            _addNodeRef(e1, t) {
                void 0 !== t && (void 0 === e1.refs[t] && (e1.refs[t] = e1.uses[t] = 0), e1.refs[t]++);
            }
            _getNodeRef(e1, t, n) {
                if (e1.refs[t] <= 1) return n;
                const i = n.clone(), r = (e1, t)=>{
                    const n = this.associations.get(e1);
                    null != n && this.associations.set(t, n);
                    for (const [n, i] of e1.children.entries())r(i, t.children[n]);
                };
                return r(n, i), i.name += "_instance_" + e1.uses[t]++, i;
            }
            _invokeOne(e1) {
                const t = Object.values(this.plugins);
                t.push(this);
                for(let n = 0; n < t.length; n++){
                    const i = e1(t[n]);
                    if (i) return i;
                }
                return null;
            }
            _invokeAll(e1) {
                const t = Object.values(this.plugins);
                t.unshift(this);
                const n = [];
                for(let i = 0; i < t.length; i++){
                    const r = e1(t[i]);
                    r && n.push(r);
                }
                return n;
            }
            getDependency(e1, t) {
                const n = e1 + ":" + t;
                let i = this.cache.get(n);
                if (!i) {
                    switch(e1){
                        case "scene":
                            i = this.loadScene(t);
                            break;
                        case "node":
                            i = this._invokeOne(function(e1) {
                                return e1.loadNode && e1.loadNode(t);
                            });
                            break;
                        case "mesh":
                            i = this._invokeOne(function(e1) {
                                return e1.loadMesh && e1.loadMesh(t);
                            });
                            break;
                        case "accessor":
                            i = this.loadAccessor(t);
                            break;
                        case "bufferView":
                            i = this._invokeOne(function(e1) {
                                return e1.loadBufferView && e1.loadBufferView(t);
                            });
                            break;
                        case "buffer":
                            i = this.loadBuffer(t);
                            break;
                        case "material":
                            i = this._invokeOne(function(e1) {
                                return e1.loadMaterial && e1.loadMaterial(t);
                            });
                            break;
                        case "texture":
                            i = this._invokeOne(function(e1) {
                                return e1.loadTexture && e1.loadTexture(t);
                            });
                            break;
                        case "skin":
                            i = this.loadSkin(t);
                            break;
                        case "animation":
                            i = this._invokeOne(function(e1) {
                                return e1.loadAnimation && e1.loadAnimation(t);
                            });
                            break;
                        case "camera":
                            i = this.loadCamera(t);
                            break;
                        default:
                            if (i = this._invokeOne(function(n) {
                                return n != this && n.getDependency && n.getDependency(e1, t);
                            }), !i) throw new Error("Unknown type: " + e1);
                    }
                    this.cache.add(n, i);
                }
                return i;
            }
            getDependencies(e1) {
                let t = this.cache.get(e1);
                if (!t) {
                    const n = this, i = this.json[e1 + ("mesh" === e1 ? "es" : "s")] || [];
                    t = Promise.all(i.map(function(t, i) {
                        return n.getDependency(e1, i);
                    })), this.cache.add(e1, t);
                }
                return t;
            }
            loadBuffer(e1) {
                const t = this.json.buffers[e1], n = this.fileLoader;
                if (t.type && "arraybuffer" !== t.type) throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
                if (void 0 === t.uri && 0 === e1) return Promise.resolve(this.extensions[Iv.KHR_BINARY_GLTF].body);
                const i = this.options;
                return new Promise(function(e1, r) {
                    n.load(VA.resolveURL(t.uri, i.path), e1, void 0, function() {
                        r(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
                    });
                });
            }
            loadBufferView(e1) {
                const t = this.json.bufferViews[e1];
                return this.getDependency("buffer", t.buffer).then(function(e1) {
                    const n = t.byteLength || 0, i = t.byteOffset || 0;
                    return e1.slice(i, i + n);
                });
            }
            loadAccessor(e1) {
                const t = this, n = this.json, i = this.json.accessors[e1];
                if (void 0 === i.bufferView && void 0 === i.sparse) {
                    const e1 = ny[i.type], t = $v[i.componentType], n = !0 === i.normalized, r = new t(i.count * e1);
                    return Promise.resolve(new lu(r, e1, n));
                }
                const r = [];
                return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function(e1) {
                    const r = e1[0], a = ny[i.type], s = $v[i.componentType], o = s.BYTES_PER_ELEMENT, l = o * a, c = i.byteOffset || 0, u = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0, h = !0 === i.normalized;
                    let d, p;
                    if (u && u !== l) {
                        const e1 = Math.floor(c / u), n = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + e1 + ":" + i.count;
                        let l = t.cache.get(n);
                        l || (d = new s(r, e1 * u, i.count * u / o), l = new qp(d, u / o), t.cache.add(n, l)), p = new Jp(l, a, c % u / o, h);
                    } else d = null === r ? new s(i.count * a) : new s(r, c, i.count * a), p = new lu(d, a, h);
                    if (void 0 !== i.sparse) {
                        const t = ny.SCALAR, n = $v[i.sparse.indices.componentType], o = i.sparse.indices.byteOffset || 0, l = i.sparse.values.byteOffset || 0, c = new n(e1[1], o, i.sparse.count * t), u = new s(e1[2], l, i.sparse.count * a);
                        null !== r && (p = new lu(p.array.slice(), p.itemSize, p.normalized));
                        for(let e1 = 0, t = c.length; e1 < t; e1++){
                            const t = c[e1];
                            if (p.setX(t, u[e1 * a]), a >= 2 && p.setY(t, u[e1 * a + 1]), a >= 3 && p.setZ(t, u[e1 * a + 2]), a >= 4 && p.setW(t, u[e1 * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                        }
                    }
                    return p;
                });
            }
            loadTexture(e1) {
                const t = this.json, n = this.options, i = t.textures[e1].source, r = t.images[i];
                let a = this.textureLoader;
                if (r.uri) {
                    const e1 = n.manager.getHandler(r.uri);
                    null !== e1 && (a = e1);
                }
                return this.loadTextureImage(e1, i, a);
            }
            loadTextureImage(e1, t, n) {
                const i = this, r = this.json, a = r.textures[e1], s = r.images[t], o = (s.uri || s.bufferView) + ":" + a.sampler;
                if (this.textureCache[o]) return this.textureCache[o];
                const l = this.loadImageSource(t, n).then(function(t) {
                    t.flipY = !1, t.name = a.name || s.name || "", "" === t.name && "string" == typeof s.uri && !1 === s.uri.startsWith("data:image/") && (t.name = s.uri);
                    const n = (r.samplers || {})[a.sampler] || {};
                    return t.magFilter = ey[n.magFilter] || va, t.minFilter = ey[n.minFilter] || ba, t.wrapS = ty[n.wrapS] || ha, t.wrapT = ty[n.wrapT] || ha, i.associations.set(t, {
                        textures: e1
                    }), t;
                }).catch(function() {
                    return null;
                });
                return this.textureCache[o] = l, l;
            }
            loadImageSource(e1, t) {
                const n = this.json, i = this.options;
                if (void 0 !== this.sourceCache[e1]) return this.sourceCache[e1].then((e1)=>e1.clone());
                const r = n.images[e1], a = self.URL || self.webkitURL;
                let s = r.uri || "", o = !1;
                if (void 0 !== r.bufferView) s = this.getDependency("bufferView", r.bufferView).then(function(e1) {
                    o = !0;
                    const t = new Blob([
                        e1
                    ], {
                        type: r.mimeType
                    });
                    return s = a.createObjectURL(t), s;
                });
                else if (void 0 === r.uri) throw new Error("THREE.GLTFLoader: Image " + e1 + " is missing URI and bufferView");
                const l = Promise.resolve(s).then(function(e1) {
                    return new Promise(function(n, r) {
                        let a = n;
                        !0 === t.isImageBitmapLoader && (a = function(e1) {
                            const t = new bl(e1);
                            t.needsUpdate = !0, n(t);
                        }), t.load(VA.resolveURL(e1, i.path), a, void 0, r);
                    });
                }).then(function(e1) {
                    var t;
                    return !0 === o && a.revokeObjectURL(s), e1.userData.mimeType = r.mimeType || ((t = r.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === t.search(/^data\:image\/jpeg/) ? "image/jpeg" : t.search(/\.webp($|\?)/i) > 0 || 0 === t.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), e1;
                }).catch(function(e1) {
                    throw console.error("THREE.GLTFLoader: Couldn't load texture", s), e1;
                });
                return this.sourceCache[e1] = l, l;
            }
            assignTexture(e1, t, n, i) {
                const r = this;
                return this.getDependency("texture", n.index).then(function(a) {
                    if (!a) return null;
                    if (void 0 !== n.texCoord && n.texCoord > 0 && ((a = a.clone()).channel = n.texCoord), r.extensions[Iv.KHR_TEXTURE_TRANSFORM]) {
                        const e1 = void 0 !== n.extensions ? n.extensions[Iv.KHR_TEXTURE_TRANSFORM] : void 0;
                        if (e1) {
                            const t = r.associations.get(a);
                            a = r.extensions[Iv.KHR_TEXTURE_TRANSFORM].extendTexture(a, e1), r.associations.set(a, t);
                        }
                    }
                    return void 0 !== i && (a.colorSpace = i), e1[t] = a, a;
                });
            }
            assignFinalMaterial(e1) {
                const t = e1.geometry;
                let n = e1.material;
                const i = void 0 === t.attributes.tangent, r = void 0 !== t.attributes.color, a = void 0 === t.attributes.normal;
                if (e1.isPoints) {
                    const e1 = "PointsMaterial:" + n.uuid;
                    let t = this.cache.get(e1);
                    t || (t = new eg, $c.prototype.copy.call(t, n), t.color.copy(n.color), t.map = n.map, t.sizeAttenuation = !1, this.cache.add(e1, t)), n = t;
                } else if (e1.isLine) {
                    const e1 = "LineBasicMaterial:" + n.uuid;
                    let t = this.cache.get(e1);
                    t || (t = new Gf, $c.prototype.copy.call(t, n), t.color.copy(n.color), t.map = n.map, this.cache.add(e1, t)), n = t;
                }
                if (i || r || a) {
                    let e1 = "ClonedMaterial:" + n.uuid + ":";
                    i && (e1 += "derivative-tangents:"), r && (e1 += "vertex-colors:"), a && (e1 += "flat-shading:");
                    let t = this.cache.get(e1);
                    t || (t = n.clone(), r && (t.vertexColors = !0), a && (t.flatShading = !0), i && (t.normalScale && (t.normalScale.y *= -1), t.clearcoatNormalScale && (t.clearcoatNormalScale.y *= -1)), this.cache.add(e1, t), this.associations.set(t, this.associations.get(n))), n = t;
                }
                e1.material = n;
            }
            getMaterialType() {
                return Um;
            }
            loadMaterial(e1) {
                const t = this, n = this.json, i = this.extensions, r = n.materials[e1];
                let a;
                const s = {}, o = [];
                if ((r.extensions || {})[Iv.KHR_MATERIALS_UNLIT]) {
                    const e1 = i[Iv.KHR_MATERIALS_UNLIT];
                    a = e1.getMaterialType(), o.push(e1.extendParams(s, r, t));
                } else {
                    const n = r.pbrMetallicRoughness || {};
                    if (s.color = new qc(1, 1, 1), s.opacity = 1, Array.isArray(n.baseColorFactor)) {
                        const e1 = n.baseColorFactor;
                        s.color.setRGB(e1[0], e1[1], e1[2], Ws), s.opacity = e1[3];
                    }
                    void 0 !== n.baseColorTexture && o.push(t.assignTexture(s, "map", n.baseColorTexture, Qs)), s.metalness = void 0 !== n.metallicFactor ? n.metallicFactor : 1, s.roughness = void 0 !== n.roughnessFactor ? n.roughnessFactor : 1, void 0 !== n.metallicRoughnessTexture && (o.push(t.assignTexture(s, "metalnessMap", n.metallicRoughnessTexture)), o.push(t.assignTexture(s, "roughnessMap", n.metallicRoughnessTexture))), a = this._invokeOne(function(t) {
                        return t.getMaterialType && t.getMaterialType(e1);
                    }), o.push(Promise.all(this._invokeAll(function(t) {
                        return t.extendMaterialParams && t.extendMaterialParams(e1, s);
                    })));
                }
                !0 === r.doubleSided && (s.side = dr);
                const l = r.alphaMode || "OPAQUE";
                if ("BLEND" === l ? (s.transparent = !0, s.depthWrite = !1) : (s.transparent = !1, "MASK" === l && (s.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && a !== eu && (o.push(t.assignTexture(s, "normalMap", r.normalTexture)), s.normalScale = new $o(1, 1), void 0 !== r.normalTexture.scale)) {
                    const e1 = r.normalTexture.scale;
                    s.normalScale.set(e1, e1);
                }
                if (void 0 !== r.occlusionTexture && a !== eu && (o.push(t.assignTexture(s, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (s.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && a !== eu) {
                    const e1 = r.emissiveFactor;
                    s.emissive = (new qc).setRGB(e1[0], e1[1], e1[2], Ws);
                }
                return void 0 !== r.emissiveTexture && a !== eu && o.push(t.assignTexture(s, "emissiveMap", r.emissiveTexture, Qs)), Promise.all(o).then(function() {
                    const n = new a(s);
                    return r.name && (n.name = r.name), oy(n, r), t.associations.set(n, {
                        materials: e1
                    }), r.extensions && sy(i, n, r), n;
                });
            }
            createUniqueName(e1) {
                const t = SM.sanitizeNodeName(e1 || "");
                return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
            }
            loadGeometries(e1) {
                const t = this, n = this.extensions, i = this.primitiveCache;
                function r(e1) {
                    return n[Iv.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(e1, t).then(function(n) {
                        return fy(n, e1, t);
                    });
                }
                const a = [];
                for(let n = 0, s = e1.length; n < s; n++){
                    const s = e1[n], o = cy(s), l = i[o];
                    if (l) a.push(l.promise);
                    else {
                        let e1;
                        e1 = s.extensions && s.extensions[Iv.KHR_DRACO_MESH_COMPRESSION] ? r(s) : fy(new Su, s, t), i[o] = {
                            primitive: s,
                            promise: e1
                        }, a.push(e1);
                    }
                }
                return Promise.all(a);
            }
            loadMesh(e1) {
                const t = this, n = this.json, i = this.extensions, r = n.meshes[e1], a = r.primitives, s = [];
                for(let e1 = 0, t = a.length; e1 < t; e1++){
                    const t = void 0 === a[e1].material ? (void 0 === (o = this.cache).DefaultMaterial && (o.DefaultMaterial = new Um({
                        color: 16777215,
                        emissive: 0,
                        metalness: 1,
                        roughness: 1,
                        transparent: !1,
                        depthTest: !0,
                        side: ur
                    })), o.DefaultMaterial) : this.getDependency("material", a[e1].material);
                    s.push(t);
                }
                var o;
                return s.push(t.loadGeometries(a)), Promise.all(s).then(function(n) {
                    const s = n.slice(0, n.length - 1), o = n[n.length - 1], l = [];
                    for(let n = 0, c = o.length; n < c; n++){
                        const c = o[n], u = a[n];
                        let h;
                        const d = s[n];
                        if (u.mode === Jv.TRIANGLES || u.mode === Jv.TRIANGLE_STRIP || u.mode === Jv.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new Nf(c, d) : new Vu(c, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === Jv.TRIANGLE_STRIP ? h.geometry = Ev(h.geometry, Ps) : u.mode === Jv.TRIANGLE_FAN && (h.geometry = Ev(h.geometry, Us));
                        else if (u.mode === Jv.LINES) h = new Jf(c, d);
                        else if (u.mode === Jv.LINE_STRIP) h = new Zf(c, d);
                        else if (u.mode === Jv.LINE_LOOP) h = new $f(c, d);
                        else {
                            if (u.mode !== Jv.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                            h = new ag(c, d);
                        }
                        Object.keys(h.geometry.morphAttributes).length > 0 && ly(h, r), h.name = t.createUniqueName(r.name || "mesh_" + e1), oy(h, r), u.extensions && sy(i, h, u), t.assignFinalMaterial(h), l.push(h);
                    }
                    for(let n = 0, i = l.length; n < i; n++)t.associations.set(l[n], {
                        meshes: e1,
                        primitives: n
                    });
                    if (1 === l.length) return r.extensions && sy(i, l[0], r), l[0];
                    const c = new jp;
                    r.extensions && sy(i, c, r), t.associations.set(c, {
                        meshes: e1
                    });
                    for(let e1 = 0, t = l.length; e1 < t; e1++)c.add(l[e1]);
                    return c;
                });
            }
            loadCamera(e1) {
                let t;
                const n = this.json.cameras[e1], i = n[n.type];
                if (i) return "perspective" === n.type ? t = new $u(Jo.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (t = new Eh(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (t.name = this.createUniqueName(n.name)), oy(t, n), Promise.resolve(t);
                console.warn("THREE.GLTFLoader: Missing camera parameters.");
            }
            loadSkin(e1) {
                const t = this.json.skins[e1], n = [];
                for(let e1 = 0, i = t.joints.length; e1 < i; e1++)n.push(this._loadNodeShallow(t.joints[e1]));
                return void 0 !== t.inverseBindMatrices ? n.push(this.getDependency("accessor", t.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(e1) {
                    const n = e1.pop(), i = e1, r = [], a = [];
                    for(let e1 = 0, s = i.length; e1 < s; e1++){
                        const s = i[e1];
                        if (s) {
                            r.push(s);
                            const t = new lc;
                            null !== n && t.fromArray(n.array, 16 * e1), a.push(t);
                        } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[e1]);
                    }
                    return new zf(r, a);
                });
            }
            loadAnimation(e1) {
                const t = this.json, n = this, i = t.animations[e1], r = i.name ? i.name : "animation_" + e1, a = [], s = [], o = [], l = [], c = [];
                for(let e1 = 0, t = i.channels.length; e1 < t; e1++){
                    const t = i.channels[e1], n = i.samplers[t.sampler], r = t.target, u = r.node, h = void 0 !== i.parameters ? i.parameters[n.input] : n.input, d = void 0 !== i.parameters ? i.parameters[n.output] : n.output;
                    void 0 !== r.node && (a.push(this.getDependency("node", u)), s.push(this.getDependency("accessor", h)), o.push(this.getDependency("accessor", d)), l.push(n), c.push(r));
                }
                return Promise.all([
                    Promise.all(a),
                    Promise.all(s),
                    Promise.all(o),
                    Promise.all(l),
                    Promise.all(c)
                ]).then(function(e1) {
                    const t = e1[0], i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = [];
                    for(let e1 = 0, r = t.length; e1 < r; e1++){
                        const r = t[e1], c = i[e1], u = a[e1], h = s[e1], d = o[e1];
                        if (void 0 === r) continue;
                        r.updateMatrix && r.updateMatrix();
                        const p = n._createAnimationTracks(r, c, u, h, d);
                        if (p) for(let e1 = 0; e1 < p.length; e1++)l.push(p[e1]);
                    }
                    return new cA(r, void 0, l);
                });
            }
            createNodeMesh(e1) {
                const t = this.json, n = this, i = t.nodes[e1];
                return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function(e1) {
                    const t = n._getNodeRef(n.meshCache, i.mesh, e1);
                    return void 0 !== i.weights && t.traverse(function(e1) {
                        if (e1.isMesh) for(let t = 0, n = i.weights.length; t < n; t++)e1.morphTargetInfluences[t] = i.weights[t];
                    }), t;
                });
            }
            loadNode(e1) {
                const t = this, n = this.json.nodes[e1], i = t._loadNodeShallow(e1), r = [], a = n.children || [];
                for(let e1 = 0, n = a.length; e1 < n; e1++)r.push(t.getDependency("node", a[e1]));
                const s = void 0 === n.skin ? Promise.resolve(null) : t.getDependency("skin", n.skin);
                return Promise.all([
                    i,
                    Promise.all(r),
                    s
                ]).then(function(e1) {
                    const t = e1[0], n = e1[1], i = e1[2];
                    null !== i && t.traverse(function(e1) {
                        e1.isSkinnedMesh && e1.bind(i, dy);
                    });
                    for(let e1 = 0, i = n.length; e1 < i; e1++)t.add(n[e1]);
                    return t;
                });
            }
            _loadNodeShallow(e1) {
                const t = this.json, n = this.extensions, i = this;
                if (void 0 !== this.nodeCache[e1]) return this.nodeCache[e1];
                const r = t.nodes[e1], a = r.name ? i.createUniqueName(r.name) : "", s = [], o = i._invokeOne(function(t) {
                    return t.createNodeMesh && t.createNodeMesh(e1);
                });
                return o && s.push(o), void 0 !== r.camera && s.push(i.getDependency("camera", r.camera).then(function(e1) {
                    return i._getNodeRef(i.cameraCache, r.camera, e1);
                })), i._invokeAll(function(t) {
                    return t.createNodeAttachment && t.createNodeAttachment(e1);
                }).forEach(function(e1) {
                    s.push(e1);
                }), this.nodeCache[e1] = Promise.all(s).then(function(t) {
                    let s;
                    if (s = !0 === r.isBone ? new Df : t.length > 1 ? new jp : 1 === t.length ? t[0] : new zc, s !== t[0]) for(let e1 = 0, n = t.length; e1 < n; e1++)s.add(t[e1]);
                    if (r.name && (s.userData.name = r.name, s.name = a), oy(s, r), r.extensions && sy(n, s, r), void 0 !== r.matrix) {
                        const e1 = new lc;
                        e1.fromArray(r.matrix), s.applyMatrix4(e1);
                    } else void 0 !== r.translation && s.position.fromArray(r.translation), void 0 !== r.rotation && s.quaternion.fromArray(r.rotation), void 0 !== r.scale && s.scale.fromArray(r.scale);
                    return i.associations.has(s) || i.associations.set(s, {}), i.associations.get(s).nodes = e1, s;
                }), this.nodeCache[e1];
            }
            loadScene(e1) {
                const t = this.extensions, n = this.json.scenes[e1], i = this, r = new jp;
                n.name && (r.name = i.createUniqueName(n.name)), oy(r, n), n.extensions && sy(t, r, n);
                const a = n.nodes || [], s = [];
                for(let e1 = 0, t = a.length; e1 < t; e1++)s.push(i.getDependency("node", a[e1]));
                return Promise.all(s).then(function(e1) {
                    for(let t = 0, n = e1.length; t < n; t++)r.add(e1[t]);
                    return i.associations = ((e1)=>{
                        const t = new Map;
                        for (const [e1, n] of i.associations)(e1 instanceof $c || e1 instanceof bl) && t.set(e1, n);
                        return e1.traverse((e1)=>{
                            const n = i.associations.get(e1);
                            null != n && t.set(e1, n);
                        }), t;
                    })(r), r;
                });
            }
            _createAnimationTracks(e1, t, n, i, r) {
                const a = [], s = e1.name ? e1.name : e1.uuid, o = [];
                let l;
                switch(ry[r.path] === ry.weights ? e1.traverse(function(e1) {
                    e1.morphTargetInfluences && o.push(e1.name ? e1.name : e1.uuid);
                }) : o.push(s), ry[r.path]){
                    case ry.weights:
                        l = rA;
                        break;
                    case ry.rotation:
                        l = sA;
                        break;
                    case ry.position:
                    case ry.scale:
                        l = lA;
                        break;
                    default:
                        l = 1 === n.itemSize ? rA : lA;
                }
                const c = void 0 !== i.interpolation ? ay[i.interpolation] : Ns, u = this._getArrayFromAccessor(n);
                for(let e1 = 0, n = o.length; e1 < n; e1++){
                    const n = new l(o[e1] + "." + ry[r.path], t.array, u, c);
                    "CUBICSPLINE" === i.interpolation && this._createCubicSplineTrackInterpolant(n), a.push(n);
                }
                return a;
            }
            _getArrayFromAccessor(e1) {
                let t = e1.array;
                if (e1.normalized) {
                    const e1 = hy(t.constructor), n = new Float32Array(t.length);
                    for(let i = 0, r = t.length; i < r; i++)n[i] = t[i] * e1;
                    t = n;
                }
                return t;
            }
            _createCubicSplineTrackInterpolant(e1) {
                e1.createInterpolant = function(e1) {
                    return new (this instanceof sA ? Kv : Zv)(this.times, this.values, this.getValueSize() / 3, e1);
                }, e1.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
            }
        }
        function fy(e1, t, n) {
            const i = t.attributes, r = [];
            function a(t, i) {
                return n.getDependency("accessor", t).then(function(t) {
                    e1.setAttribute(i, t);
                });
            }
            for(const t in i){
                const n = iy[t] || t.toLowerCase();
                n in e1.attributes || r.push(a(i[t], n));
            }
            if (void 0 !== t.indices && !e1.index) {
                const i = n.getDependency("accessor", t.indices).then(function(t) {
                    e1.setIndex(t);
                });
                r.push(i);
            }
            return pl.workingColorSpace !== Ws && "COLOR_0" in i && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${pl.workingColorSpace}" not supported.`), oy(e1, t), function(e1, t, n) {
                const i = t.attributes, r = new Rl;
                if (void 0 === i.POSITION) return;
                {
                    const e1 = n.json.accessors[i.POSITION], t = e1.min, a = e1.max;
                    if (void 0 === t || void 0 === a) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                    if (r.set(new Ll(t[0], t[1], t[2]), new Ll(a[0], a[1], a[2])), e1.normalized) {
                        const t = hy($v[e1.componentType]);
                        r.min.multiplyScalar(t), r.max.multiplyScalar(t);
                    }
                }
                const a = t.targets;
                if (void 0 !== a) {
                    const e1 = new Ll, t = new Ll;
                    for(let i = 0, r = a.length; i < r; i++){
                        const r = a[i];
                        if (void 0 !== r.POSITION) {
                            const i = n.json.accessors[r.POSITION], a = i.min, s = i.max;
                            if (void 0 !== a && void 0 !== s) {
                                if (t.setX(Math.max(Math.abs(a[0]), Math.abs(s[0]))), t.setY(Math.max(Math.abs(a[1]), Math.abs(s[1]))), t.setZ(Math.max(Math.abs(a[2]), Math.abs(s[2]))), i.normalized) {
                                    const e1 = hy($v[i.componentType]);
                                    t.multiplyScalar(e1);
                                }
                                e1.max(t);
                            } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                        }
                    }
                    r.expandByVector(e1);
                }
                e1.boundingBox = r;
                const s = new $l;
                r.getCenter(s.center), s.radius = r.min.distanceTo(r.max) / 2, e1.boundingSphere = s;
            }(e1, t, n), Promise.all(r).then(function() {
                return void 0 !== t.targets ? function(e1, t, n) {
                    let i = !1, r = !1, a = !1;
                    for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        if (void 0 !== n.POSITION && (i = !0), void 0 !== n.NORMAL && (r = !0), void 0 !== n.COLOR_0 && (a = !0), i && r && a) break;
                    }
                    if (!i && !r && !a) return Promise.resolve(e1);
                    const s = [], o = [], l = [];
                    for(let c = 0, u = t.length; c < u; c++){
                        const u = t[c];
                        if (i) {
                            const t = void 0 !== u.POSITION ? n.getDependency("accessor", u.POSITION) : e1.attributes.position;
                            s.push(t);
                        }
                        if (r) {
                            const t = void 0 !== u.NORMAL ? n.getDependency("accessor", u.NORMAL) : e1.attributes.normal;
                            o.push(t);
                        }
                        if (a) {
                            const t = void 0 !== u.COLOR_0 ? n.getDependency("accessor", u.COLOR_0) : e1.attributes.color;
                            l.push(t);
                        }
                    }
                    return Promise.all([
                        Promise.all(s),
                        Promise.all(o),
                        Promise.all(l)
                    ]).then(function(t) {
                        const n = t[0], s = t[1], o = t[2];
                        return i && (e1.morphAttributes.position = n), r && (e1.morphAttributes.normal = s), a && (e1.morphAttributes.color = o), e1.morphTargetsRelative = !0, e1;
                    });
                }(e1, t.targets, n) : e1;
            });
        }
        const gy = {
            Handedness: Object.freeze({
                NONE: "none",
                LEFT: "left",
                RIGHT: "right"
            }),
            ComponentState: Object.freeze({
                DEFAULT: "default",
                TOUCHED: "touched",
                PRESSED: "pressed"
            }),
            ComponentProperty: Object.freeze({
                BUTTON: "button",
                X_AXIS: "xAxis",
                Y_AXIS: "yAxis",
                STATE: "state"
            }),
            ComponentType: Object.freeze({
                TRIGGER: "trigger",
                SQUEEZE: "squeeze",
                TOUCHPAD: "touchpad",
                THUMBSTICK: "thumbstick",
                BUTTON: "button"
            }),
            ButtonTouchThreshold: .05,
            AxisTouchThreshold: .1,
            VisualResponseProperty: Object.freeze({
                TRANSFORM: "transform",
                VISIBILITY: "visibility"
            })
        };
        async function my(e1) {
            const t = await fetch(e1);
            if (t.ok) return t.json();
            throw new Error(t.statusText);
        }
        const Ay = {
            xAxis: 0,
            yAxis: 0,
            button: 0,
            state: gy.ComponentState.DEFAULT
        };
        class My {
            constructor(e1){
                this.componentProperty = e1.componentProperty, this.states = e1.states, this.valueNodeName = e1.valueNodeName, this.valueNodeProperty = e1.valueNodeProperty, this.valueNodeProperty === gy.VisualResponseProperty.TRANSFORM && (this.minNodeName = e1.minNodeName, this.maxNodeName = e1.maxNodeName), this.value = 0, this.updateFromComponent(Ay);
            }
            updateFromComponent(e1) {
                let { xAxis: t, yAxis: n, button: i, state: r } = e1;
                const { normalizedXAxis: a, normalizedYAxis: s } = function() {
                    let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = e1, i = t;
                    if (Math.sqrt(e1 * e1 + t * t) > 1) {
                        const r = Math.atan2(t, e1);
                        n = Math.cos(r), i = Math.sin(r);
                    }
                    return {
                        normalizedXAxis: .5 * n + .5,
                        normalizedYAxis: .5 * i + .5
                    };
                }(t, n);
                switch(this.componentProperty){
                    case gy.ComponentProperty.X_AXIS:
                        this.value = this.states.includes(r) ? a : .5;
                        break;
                    case gy.ComponentProperty.Y_AXIS:
                        this.value = this.states.includes(r) ? s : .5;
                        break;
                    case gy.ComponentProperty.BUTTON:
                        this.value = this.states.includes(r) ? i : 0;
                        break;
                    case gy.ComponentProperty.STATE:
                        this.valueNodeProperty === gy.VisualResponseProperty.VISIBILITY ? this.value = this.states.includes(r) : this.value = this.states.includes(r) ? 1 : 0;
                        break;
                    default:
                        throw new Error(`Unexpected visualResponse componentProperty ${this.componentProperty}`);
                }
            }
        }
        class vy {
            constructor(e1, t){
                if (!(e1 && t && t.visualResponses && t.gamepadIndices && 0 !== Object.keys(t.gamepadIndices).length)) throw new Error("Invalid arguments supplied");
                this.id = e1, this.type = t.type, this.rootNodeName = t.rootNodeName, this.touchPointNodeName = t.touchPointNodeName, this.visualResponses = {}, Object.keys(t.visualResponses).forEach((e1)=>{
                    const n = new My(t.visualResponses[e1]);
                    this.visualResponses[e1] = n;
                }), this.gamepadIndices = Object.assign({}, t.gamepadIndices), this.values = {
                    state: gy.ComponentState.DEFAULT,
                    button: void 0 !== this.gamepadIndices.button ? 0 : void 0,
                    xAxis: void 0 !== this.gamepadIndices.xAxis ? 0 : void 0,
                    yAxis: void 0 !== this.gamepadIndices.yAxis ? 0 : void 0
                };
            }
            get data() {
                return {
                    id: this.id,
                    ...this.values
                };
            }
            updateFromGamepad(e1) {
                if (this.values.state = gy.ComponentState.DEFAULT, void 0 !== this.gamepadIndices.button && e1.buttons.length > this.gamepadIndices.button) {
                    const t = e1.buttons[this.gamepadIndices.button];
                    this.values.button = t.value, this.values.button = this.values.button < 0 ? 0 : this.values.button, this.values.button = this.values.button > 1 ? 1 : this.values.button, t.pressed || 1 === this.values.button ? this.values.state = gy.ComponentState.PRESSED : (t.touched || this.values.button > gy.ButtonTouchThreshold) && (this.values.state = gy.ComponentState.TOUCHED);
                }
                void 0 !== this.gamepadIndices.xAxis && e1.axes.length > this.gamepadIndices.xAxis && (this.values.xAxis = e1.axes[this.gamepadIndices.xAxis], this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis, this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis, this.values.state === gy.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > gy.AxisTouchThreshold && (this.values.state = gy.ComponentState.TOUCHED)), void 0 !== this.gamepadIndices.yAxis && e1.axes.length > this.gamepadIndices.yAxis && (this.values.yAxis = e1.axes[this.gamepadIndices.yAxis], this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis, this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis, this.values.state === gy.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > gy.AxisTouchThreshold && (this.values.state = gy.ComponentState.TOUCHED)), Object.values(this.visualResponses).forEach((e1)=>{
                    e1.updateFromComponent(this.values);
                });
            }
        }
        class yy {
            constructor(e1, t, n){
                if (!e1) throw new Error("No xrInputSource supplied");
                if (!t) throw new Error("No profile supplied");
                this.xrInputSource = e1, this.assetUrl = n, this.id = t.profileId, this.layoutDescription = t.layouts[e1.handedness], this.components = {}, Object.keys(this.layoutDescription.components).forEach((e1)=>{
                    const t = this.layoutDescription.components[e1];
                    this.components[e1] = new vy(e1, t);
                }), this.updateFromGamepad();
            }
            get gripSpace() {
                return this.xrInputSource.gripSpace;
            }
            get targetRaySpace() {
                return this.xrInputSource.targetRaySpace;
            }
            get data() {
                const e1 = [];
                return Object.values(this.components).forEach((t)=>{
                    e1.push(t.data);
                }), e1;
            }
            updateFromGamepad() {
                Object.values(this.components).forEach((e1)=>{
                    e1.updateFromGamepad(this.xrInputSource.gamepad);
                });
            }
        }
        class xy extends zc {
            constructor(){
                super(), this.motionController = null, this.envMap = null;
            }
            setEnvironmentMap(e1) {
                return this.envMap == e1 || (this.envMap = e1, this.traverse((e1)=>{
                    e1.isMesh && (e1.material.envMap = this.envMap, e1.material.needsUpdate = !0);
                })), this;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.motionController && (this.motionController.updateFromGamepad(), Object.values(this.motionController.components).forEach((e1)=>{
                    Object.values(e1.visualResponses).forEach((e1)=>{
                        const { valueNode: t, minNode: n, maxNode: i, value: r, valueNodeProperty: a } = e1;
                        t && (a === gy.VisualResponseProperty.VISIBILITY ? t.visible = r : a === gy.VisualResponseProperty.TRANSFORM && (t.quaternion.slerpQuaternions(n.quaternion, i.quaternion, r), t.position.lerpVectors(n.position, i.position, r)));
                    });
                }));
            }
        }
        function by(e1, t) {
            !function(e1, t) {
                Object.values(e1.components).forEach((e1)=>{
                    const { type: n, touchPointNodeName: i, visualResponses: r } = e1;
                    if (n === gy.ComponentType.TOUCHPAD) {
                        if (e1.touchPointNode = t.getObjectByName(i), e1.touchPointNode) {
                            const t = new Im(.001), n = new eu({
                                color: 255
                            }), i = new Vu(t, n);
                            e1.touchPointNode.add(i);
                        } else console.warn(`Could not find touch dot, ${e1.touchPointNodeName}, in touchpad component ${e1.id}`);
                    }
                    Object.values(r).forEach((e1)=>{
                        const { valueNodeName: n, minNodeName: i, maxNodeName: r, valueNodeProperty: a } = e1;
                        if (a === gy.VisualResponseProperty.TRANSFORM) {
                            if (e1.minNode = t.getObjectByName(i), e1.maxNode = t.getObjectByName(r), !e1.minNode) return void console.warn(`Could not find ${i} in the model`);
                            if (!e1.maxNode) return void console.warn(`Could not find ${r} in the model`);
                        }
                        e1.valueNode = t.getObjectByName(n), e1.valueNode || console.warn(`Could not find ${n} in the model`);
                    });
                });
            }(e1.motionController, t), e1.envMap && t.traverse((t)=>{
                t.isMesh && (t.material.envMap = e1.envMap, t.material.needsUpdate = !0);
            }), e1.add(t);
        }
        class wy {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.gltfLoader = e1, this.path = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles", this._assetCache = {}, this.gltfLoader || (this.gltfLoader = new Tv);
            }
            createControllerModel(e1) {
                const t = new xy;
                let n = null;
                return e1.addEventListener("connected", (e1)=>{
                    const i = e1.data;
                    "tracked-pointer" === i.targetRayMode && i.gamepad && (async function(e1, t) {
                        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        if (!e1) throw new Error("No xrInputSource supplied");
                        if (!t) throw new Error("No basePath supplied");
                        const r = await async function(e1) {
                            if (!e1) throw new Error("No basePath supplied");
                            return await my(`${e1}/profilesList.json`);
                        }(t);
                        let a;
                        if (e1.profiles.some((e1)=>{
                            const n = r[e1];
                            return n && (a = {
                                profileId: e1,
                                profilePath: `${t}/${n.path}`,
                                deprecated: !!n.deprecated
                            }), !!a;
                        }), !a) {
                            if (!n) throw new Error("No matching profile name found");
                            const e1 = r[n];
                            if (!e1) throw new Error(`No matching profile name found and default profile "${n}" missing.`);
                            a = {
                                profileId: n,
                                profilePath: `${t}/${e1.path}`,
                                deprecated: !!e1.deprecated
                            };
                        }
                        const s = await my(a.profilePath);
                        let o;
                        if (i) {
                            let t;
                            if (t = "any" === e1.handedness ? s.layouts[Object.keys(s.layouts)[0]] : s.layouts[e1.handedness], !t) throw new Error(`No matching handedness, ${e1.handedness}, in profile ${a.profileId}`);
                            t.assetPath && (o = a.profilePath.replace("profile.json", t.assetPath));
                        }
                        return {
                            profile: s,
                            assetPath: o
                        };
                    })(i, this.path, "generic-trigger").then((e1)=>{
                        let { profile: r, assetPath: a } = e1;
                        t.motionController = new yy(i, r, a);
                        const s = this._assetCache[t.motionController.assetUrl];
                        if (s) n = s.scene.clone(), by(t, n);
                        else {
                            if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                            this.gltfLoader.setPath(""), this.gltfLoader.load(t.motionController.assetUrl, (e1)=>{
                                this._assetCache[t.motionController.assetUrl] = e1, n = e1.scene.clone(), by(t, n);
                            }, null, ()=>{
                                throw new Error(`Asset ${t.motionController.assetUrl} missing or malformed.`);
                            });
                        }
                    }).catch((e1)=>{
                        console.warn(e1);
                    });
                }), e1.addEventListener("disconnected", ()=>{
                    t.motionController = null, t.remove(n), n = null;
                }), t;
            }
        }
        const Ey = new lc, Ty = new Ll;
        class Sy {
            constructor(e1, t, n, i, r){
                let a;
                this.controller = t, this.handModel = e1, this.envMap = null, r && r.primitive && "sphere" !== r.primitive ? "box" === r.primitive && (a = new Wu(1, 1, 1)) : a = new Im(1, 10, 10);
                const s = new Um;
                this.handMesh = new Hf(a, s, 30), this.handMesh.frustumCulled = !1, this.handMesh.instanceMatrix.setUsage(To), this.handMesh.castShadow = !0, this.handMesh.receiveShadow = !0, this.handModel.add(this.handMesh), this.joints = [
                    "wrist",
                    "thumb-metacarpal",
                    "thumb-phalanx-proximal",
                    "thumb-phalanx-distal",
                    "thumb-tip",
                    "index-finger-metacarpal",
                    "index-finger-phalanx-proximal",
                    "index-finger-phalanx-intermediate",
                    "index-finger-phalanx-distal",
                    "index-finger-tip",
                    "middle-finger-metacarpal",
                    "middle-finger-phalanx-proximal",
                    "middle-finger-phalanx-intermediate",
                    "middle-finger-phalanx-distal",
                    "middle-finger-tip",
                    "ring-finger-metacarpal",
                    "ring-finger-phalanx-proximal",
                    "ring-finger-phalanx-intermediate",
                    "ring-finger-phalanx-distal",
                    "ring-finger-tip",
                    "pinky-finger-metacarpal",
                    "pinky-finger-phalanx-proximal",
                    "pinky-finger-phalanx-intermediate",
                    "pinky-finger-phalanx-distal",
                    "pinky-finger-tip"
                ];
            }
            updateMesh() {
                const e1 = this.controller.joints;
                let t = 0;
                for(let n = 0; n < this.joints.length; n++){
                    const i = e1[this.joints[n]];
                    i.visible && (Ty.setScalar(i.jointRadius || .008), Ey.compose(i.position, i.quaternion, Ty), this.handMesh.setMatrixAt(n, Ey), t++);
                }
                this.handMesh.count = t, this.handMesh.instanceMatrix.needsUpdate = !0;
            }
        }
        class Iy {
            constructor(e1, t, n, i){
                let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                this.controller = t, this.handModel = e1, this.bones = [], null === r && (r = new Tv, r.setPath(n || "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/")), r.load(`${i}.glb`, (e1)=>{
                    const t = e1.scene.children[0];
                    this.handModel.add(t);
                    const n = t.getObjectByProperty("type", "SkinnedMesh");
                    n.frustumCulled = !1, n.castShadow = !0, n.receiveShadow = !0, [
                        "wrist",
                        "thumb-metacarpal",
                        "thumb-phalanx-proximal",
                        "thumb-phalanx-distal",
                        "thumb-tip",
                        "index-finger-metacarpal",
                        "index-finger-phalanx-proximal",
                        "index-finger-phalanx-intermediate",
                        "index-finger-phalanx-distal",
                        "index-finger-tip",
                        "middle-finger-metacarpal",
                        "middle-finger-phalanx-proximal",
                        "middle-finger-phalanx-intermediate",
                        "middle-finger-phalanx-distal",
                        "middle-finger-tip",
                        "ring-finger-metacarpal",
                        "ring-finger-phalanx-proximal",
                        "ring-finger-phalanx-intermediate",
                        "ring-finger-phalanx-distal",
                        "ring-finger-tip",
                        "pinky-finger-metacarpal",
                        "pinky-finger-phalanx-proximal",
                        "pinky-finger-phalanx-intermediate",
                        "pinky-finger-phalanx-distal",
                        "pinky-finger-tip"
                    ].forEach((e1)=>{
                        const n = t.getObjectByName(e1);
                        void 0 !== n ? n.jointName = e1 : console.warn(`Couldn't find ${e1} in ${i} hand mesh`), this.bones.push(n);
                    });
                });
            }
            updateMesh() {
                const e1 = this.controller.joints;
                for(let t = 0; t < this.bones.length; t++){
                    const n = this.bones[t];
                    if (n) {
                        const t = e1[n.jointName];
                        if (t.visible) {
                            const e1 = t.position;
                            n.position.copy(e1), n.quaternion.copy(t.quaternion);
                        }
                    }
                }
            }
        }
        class Ny extends zc {
            constructor(e1){
                super(), this.controller = e1, this.motionController = null, this.envMap = null, this.mesh = null;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.motionController && this.motionController.updateMesh();
            }
        }
        class Dy {
            constructor(){
                this.path = null;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            createHandModel(e1, t) {
                const n = new Ny(e1);
                return e1.addEventListener("connected", (i)=>{
                    const r = i.data;
                    r.hand && !n.motionController && (n.xrInputSource = r, void 0 === t || "spheres" === t ? n.motionController = new Sy(n, e1, this.path, r.handedness, {
                        primitive: "sphere"
                    }) : "boxes" === t ? n.motionController = new Sy(n, e1, this.path, r.handedness, {
                        primitive: "box"
                    }) : "mesh" === t && (n.motionController = new Iy(n, e1, this.path, r.handedness))), e1.visible = !0;
                }), e1.addEventListener("disconnected", ()=>{
                    e1.visible = !1;
                }), n;
            }
        }
        function _y(e1) {
            return Math.sqrt(Math.pow(e1[1][0] - e1[0][0], 2) + Math.pow(e1[1][1] - e1[0][1], 2));
        }
        rn({
            useProxies: "never"
        });
        const Cy = new class {
            constructor(){
                var e1, t, n;
                e1 = this, n = void 0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "capabilities")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.capabilities = null, Tn(this);
            }
            get isProActive() {
                return "proactive" === this.capabilities?.camera_navigation;
            }
            get isMask() {
                return "mask" === this.capabilities?.floor_navigation;
            }
            isCapable(e1) {
                return Boolean(this.capabilities?.[e1]?.enabled);
            }
            setCapabilities(e1) {
                this.capabilities = e1;
            }
        };
        var Ly = function(e1) {
            return URL.createObjectURL(new Blob([
                e1
            ], {
                type: "text/javascript"
            }));
        };
        try {
            URL.revokeObjectURL(Ly(""));
        } catch (e1) {
            Ly = function(e1) {
                return "data:application/javascript;charset=UTF-8," + encodeURI(e1);
            };
        }
        var zy = Uint8Array, Oy = Uint16Array, Ry = Uint32Array, Py = new zy([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Uy = new zy([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), jy = new zy([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), ky = function(e1, t) {
            for(var n = new Oy(31), i = 0; i < 31; ++i)n[i] = t += 1 << e1[i - 1];
            var r = new Ry(n[30]);
            for(i = 1; i < 30; ++i)for(var a = n[i]; a < n[i + 1]; ++a)r[a] = a - n[i] << 5 | i;
            return [
                n,
                r
            ];
        }, By = ky(Py, 2), Fy = By[0], Hy = By[1];
        Fy[28] = 258, Hy[258] = 28;
        for(var Gy = ky(Uy, 0), Vy = Gy[0], Qy = (Gy[1], new Oy(32768)), Wy = 0; Wy < 32768; ++Wy){
            var Yy = (43690 & Wy) >>> 1 | (21845 & Wy) << 1;
            Yy = (61680 & (Yy = (52428 & Yy) >>> 2 | (13107 & Yy) << 2)) >>> 4 | (3855 & Yy) << 4, Qy[Wy] = ((65280 & Yy) >>> 8 | (255 & Yy) << 8) >>> 1;
        }
        var Xy = function(e1, t, n) {
            for(var i = e1.length, r = 0, a = new Oy(t); r < i; ++r)++a[e1[r] - 1];
            var s, o = new Oy(t);
            for(r = 0; r < t; ++r)o[r] = o[r - 1] + a[r - 1] << 1;
            if (n) {
                s = new Oy(1 << t);
                var l = 15 - t;
                for(r = 0; r < i; ++r)if (e1[r]) for(var c = r << 4 | e1[r], u = t - e1[r], h = o[e1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[Qy[h] >>> l] = c;
            } else for(s = new Oy(i), r = 0; r < i; ++r)e1[r] && (s[r] = Qy[o[e1[r] - 1]++] >>> 15 - e1[r]);
            return s;
        }, Zy = new zy(288);
        for(Wy = 0; Wy < 144; ++Wy)Zy[Wy] = 8;
        for(Wy = 144; Wy < 256; ++Wy)Zy[Wy] = 9;
        for(Wy = 256; Wy < 280; ++Wy)Zy[Wy] = 7;
        for(Wy = 280; Wy < 288; ++Wy)Zy[Wy] = 8;
        var qy = new zy(32);
        for(Wy = 0; Wy < 32; ++Wy)qy[Wy] = 5;
        var Ky = Xy(Zy, 9, 1), Jy = Xy(qy, 5, 1), $y = function(e1) {
            for(var t = e1[0], n = 1; n < e1.length; ++n)e1[n] > t && (t = e1[n]);
            return t;
        }, ex = function(e1, t, n) {
            var i = t / 8 | 0;
            return (e1[i] | e1[i + 1] << 8) >> (7 & t) & n;
        }, tx = function(e1, t) {
            var n = t / 8 | 0;
            return (e1[n] | e1[n + 1] << 8 | e1[n + 2] << 16) >> (7 & t);
        }, nx = function(e1, t, n) {
            var i = e1.length;
            if (!i || n && !n.l && i < 5) return t || new zy(0);
            var r = !t || n, a = !n || n.i;
            n || (n = {}), t || (t = new zy(3 * i));
            var s, o = function(e1) {
                var n = t.length;
                if (e1 > n) {
                    var i = new zy(Math.max(2 * n, e1));
                    i.set(t), t = i;
                }
            }, l = n.f || 0, c = n.p || 0, u = n.b || 0, h = n.l, d = n.d, p = n.m, f = n.n, g = 8 * i;
            do {
                if (!h) {
                    n.f = l = ex(e1, c, 1);
                    var m = ex(e1, c + 1, 3);
                    if (c += 3, !m) {
                        var A = e1[s = c, (N = (s / 8 | 0) + (7 & s && 1) + 4) - 4] | e1[N - 3] << 8, M = N + A;
                        if (M > i) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + A), t.set(e1.subarray(N, M), u), n.b = u += A, n.p = c = 8 * M;
                        continue;
                    }
                    if (1 == m) h = Ky, d = Jy, p = 9, f = 5;
                    else {
                        if (2 != m) throw "invalid block type";
                        var v = ex(e1, c, 31) + 257, y = ex(e1, c + 10, 15) + 4, x = v + ex(e1, c + 5, 31) + 1;
                        c += 14;
                        for(var b = new zy(x), w = new zy(19), E = 0; E < y; ++E)w[jy[E]] = ex(e1, c + 3 * E, 7);
                        c += 3 * y;
                        var T = $y(w), S = (1 << T) - 1, I = Xy(w, T, 1);
                        for(E = 0; E < x;){
                            var N, D = I[ex(e1, c, S)];
                            if (c += 15 & D, (N = D >>> 4) < 16) b[E++] = N;
                            else {
                                var _ = 0, C = 0;
                                for(16 == N ? (C = 3 + ex(e1, c, 3), c += 2, _ = b[E - 1]) : 17 == N ? (C = 3 + ex(e1, c, 7), c += 3) : 18 == N && (C = 11 + ex(e1, c, 127), c += 7); C--;)b[E++] = _;
                            }
                        }
                        var L = b.subarray(0, v), z = b.subarray(v);
                        p = $y(L), f = $y(z), h = Xy(L, p, 1), d = Xy(z, f, 1);
                    }
                    if (c > g) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                }
                r && o(u + 131072);
                for(var O = (1 << p) - 1, R = (1 << f) - 1, P = c;; P = c){
                    var U = (_ = h[tx(e1, c) & O]) >>> 4;
                    if ((c += 15 & _) > g) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                    if (!_) throw "invalid length/literal";
                    if (U < 256) t[u++] = U;
                    else {
                        if (256 == U) {
                            P = c, h = null;
                            break;
                        }
                        var j = U - 254;
                        if (U > 264) {
                            var k = Py[E = U - 257];
                            j = ex(e1, c, (1 << k) - 1) + Fy[E], c += k;
                        }
                        var B = d[tx(e1, c) & R], F = B >>> 4;
                        if (!B) throw "invalid distance";
                        if (c += 15 & B, z = Vy[F], F > 3 && (k = Uy[F], z += tx(e1, c) & (1 << k) - 1, c += k), c > g) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + 131072);
                        for(var H = u + j; u < H; u += 4)t[u] = t[u - z], t[u + 1] = t[u + 1 - z], t[u + 2] = t[u + 2 - z], t[u + 3] = t[u + 3 - z];
                        u = H;
                    }
                }
                n.l = h, n.p = P, n.b = u, h && (l = 1, n.m = p, n.d = d, n.n = f);
            }while (!l);
            return u == t.length ? t : function(e1, t, n) {
                (null == t || t < 0) && (t = 0), (null == n || n > e1.length) && (n = e1.length);
                var i = new (e1 instanceof Oy ? Oy : e1 instanceof Ry ? Ry : zy)(n - t);
                return i.set(e1.subarray(t, n)), i;
            }(t, 0, u);
        }, ix = new zy(0);
        function rx(e1, t) {
            return nx((function(e1) {
                if (8 != (15 & e1[0]) || e1[0] >>> 4 > 7 || (e1[0] << 8 | e1[1]) % 31) throw "invalid zlib data";
                if (32 & e1[1]) throw "invalid zlib data: preset dictionaries not supported";
            }(e1), e1.subarray(2, -4)), t);
        }
        var ax = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            ax.decode(ix, {
                stream: !0
            });
        } catch (e1) {}
        class sx extends bA {
            constructor(e1){
                super(e1), this.type = Ca;
            }
            parse(e1) {
                const t = 65536, n = 14, i = 65537, r = Math.pow(2.7182818, 2.2), a = {
                    l: 0,
                    c: 0,
                    lc: 0
                };
                function s(e1, t, n, i, r) {
                    for(; n < e1;)t = t << 8 | U(i, r), n += 8;
                    n -= e1, a.l = t >> n & (1 << e1) - 1, a.c = t, a.lc = n;
                }
                const o = new Array(59);
                function l(e1) {
                    return 63 & e1;
                }
                function c(e1) {
                    return e1 >> 6;
                }
                const u = {
                    c: 0,
                    lc: 0
                };
                function h(e1, t, n, i) {
                    e1 = e1 << 8 | U(n, i), t += 8, u.c = e1, u.lc = t;
                }
                const d = {
                    c: 0,
                    lc: 0
                };
                function p(e1, t, n, i, r, a, s, o, l) {
                    if (e1 == t) {
                        i < 8 && (h(n, i, r, a), n = u.c, i = u.lc);
                        let e1 = n >> (i -= 8);
                        if (e1 = new Uint8Array([
                            e1
                        ])[0], o.value + e1 > l) return !1;
                        const t = s[o.value - 1];
                        for(; e1-- > 0;)s[o.value++] = t;
                    } else {
                        if (!(o.value < l)) return !1;
                        s[o.value++] = e1;
                    }
                    d.c = n, d.lc = i;
                }
                function f(e1) {
                    return 65535 & e1;
                }
                function g(e1) {
                    const t = f(e1);
                    return t > 32767 ? t - 65536 : t;
                }
                const m = {
                    a: 0,
                    b: 0
                };
                function A(e1, t) {
                    const n = g(e1), i = g(t), r = n + (1 & i) + (i >> 1), a = r, s = r - i;
                    m.a = a, m.b = s;
                }
                function M(e1, t) {
                    const n = f(e1), i = f(t), r = n - (i >> 1) & 65535, a = i + r - 32768 & 65535;
                    m.a = a, m.b = r;
                }
                function v(e1, t, n, i, r, a, s) {
                    const o = s < 16384, l = n > r ? r : n;
                    let c, u, h = 1;
                    for(; h <= l;)h <<= 1;
                    for(h >>= 1, c = h, h >>= 1; h >= 1;){
                        u = 0;
                        const s = u + a * (r - c), l = a * h, d = a * c, p = i * h, f = i * c;
                        let g, v, y, x;
                        for(; u <= s; u += d){
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p, i = r + l, a = i + p;
                                o ? (A(e1[r + t], e1[i + t]), g = m.a, y = m.b, A(e1[n + t], e1[a + t]), v = m.a, x = m.b, A(g, v), e1[r + t] = m.a, e1[n + t] = m.b, A(y, x), e1[i + t] = m.a, e1[a + t] = m.b) : (M(e1[r + t], e1[i + t]), g = m.a, y = m.b, M(e1[n + t], e1[a + t]), v = m.a, x = m.b, M(g, v), e1[r + t] = m.a, e1[n + t] = m.b, M(y, x), e1[i + t] = m.a, e1[a + t] = m.b);
                            }
                            if (n & h) {
                                const n = r + l;
                                o ? A(e1[r + t], e1[n + t]) : M(e1[r + t], e1[n + t]), g = m.a, e1[n + t] = m.b, e1[r + t] = g;
                            }
                        }
                        if (r & h) {
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p;
                                o ? A(e1[r + t], e1[n + t]) : M(e1[r + t], e1[n + t]), g = m.a, e1[n + t] = m.b, e1[r + t] = g;
                            }
                        }
                        c = h, h >>= 1;
                    }
                    return u;
                }
                function y(e1, t, r, f, g, m) {
                    const A = r.value, M = P(t, r), v = P(t, r);
                    r.value += 4;
                    const y = P(t, r);
                    if (r.value += 4, M < 0 || M >= i || v < 0 || v >= i) throw new Error("Something wrong with HUF_ENCSIZE");
                    const x = new Array(i), b = new Array(16384);
                    if (function(e1) {
                        for(let t = 0; t < 16384; t++)e1[t] = {}, e1[t].len = 0, e1[t].lit = 0, e1[t].p = null;
                    }(b), function(e1, t, n, r, l, c) {
                        const u = t;
                        let h = 0, d = 0;
                        for(; r <= l; r++){
                            if (u.value - t.value > n) return !1;
                            s(6, h, d, e1, u);
                            const i = a.l;
                            if (h = a.c, d = a.lc, c[r] = i, 63 == i) {
                                if (u.value - t.value > n) throw new Error("Something wrong with hufUnpackEncTable");
                                s(8, h, d, e1, u);
                                let i = a.l + 6;
                                if (h = a.c, d = a.lc, r + i > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; i--;)c[r++] = 0;
                                r--;
                            } else if (i >= 59) {
                                let e1 = i - 59 + 2;
                                if (r + e1 > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; e1--;)c[r++] = 0;
                                r--;
                            }
                        }
                        !function(e1) {
                            for(let e1 = 0; e1 <= 58; ++e1)o[e1] = 0;
                            for(let t = 0; t < i; ++t)o[e1[t]] += 1;
                            let t = 0;
                            for(let e1 = 58; e1 > 0; --e1){
                                const n = t + o[e1] >> 1;
                                o[e1] = t, t = n;
                            }
                            for(let t = 0; t < i; ++t){
                                const n = e1[t];
                                n > 0 && (e1[t] = n | o[n]++ << 6);
                            }
                        }(c);
                    }(e1, r, f - (r.value - A), M, v, x), y > 8 * (f - (r.value - A))) throw new Error("Something wrong with hufUncompress");
                    !function(e1, t, i, r) {
                        for(; t <= i; t++){
                            const i = c(e1[t]), a = l(e1[t]);
                            if (i >> a) throw new Error("Invalid table entry");
                            if (a > n) {
                                const e1 = r[i >> a - n];
                                if (e1.len) throw new Error("Invalid table entry");
                                if (e1.lit++, e1.p) {
                                    const t = e1.p;
                                    e1.p = new Array(e1.lit);
                                    for(let n = 0; n < e1.lit - 1; ++n)e1.p[n] = t[n];
                                } else e1.p = new Array(1);
                                e1.p[e1.lit - 1] = t;
                            } else if (a) {
                                let e1 = 0;
                                for(let s = 1 << n - a; s > 0; s--){
                                    const s = r[(i << n - a) + e1];
                                    if (s.len || s.p) throw new Error("Invalid table entry");
                                    s.len = a, s.lit = t, e1++;
                                }
                            }
                        }
                    }(x, M, v, b), function(e1, t, i, r, a, s, o, f, g) {
                        let m = 0, A = 0;
                        const M = o, v = Math.trunc(r.value + (a + 7) / 8);
                        for(; r.value < v;)for(h(m, A, i, r), m = u.c, A = u.lc; A >= n;){
                            const a = t[m >> A - n & 16383];
                            if (a.len) A -= a.len, p(a.lit, s, m, A, i, r, f, g, M), m = d.c, A = d.lc;
                            else {
                                if (!a.p) throw new Error("hufDecode issues");
                                let t;
                                for(t = 0; t < a.lit; t++){
                                    const n = l(e1[a.p[t]]);
                                    for(; A < n && r.value < v;)h(m, A, i, r), m = u.c, A = u.lc;
                                    if (A >= n && c(e1[a.p[t]]) == (m >> A - n & (1 << n) - 1)) {
                                        A -= n, p(a.p[t], s, m, A, i, r, f, g, M), m = d.c, A = d.lc;
                                        break;
                                    }
                                }
                                if (t == a.lit) throw new Error("hufDecode issues");
                            }
                        }
                        const y = 8 - a & 7;
                        for(m >>= y, A -= y; A > 0;){
                            const e1 = t[m << n - A & 16383];
                            if (!e1.len) throw new Error("hufDecode issues");
                            A -= e1.len, p(e1.lit, s, m, A, i, r, f, g, M), m = d.c, A = d.lc;
                        }
                    }(x, b, e1, r, y, v, m, g, {
                        value: 0
                    });
                }
                function x(e1) {
                    for(let t = 1; t < e1.length; t++){
                        const n = e1[t - 1] + e1[t] - 128;
                        e1[t] = n;
                    }
                }
                function b(e1, t) {
                    let n = 0, i = Math.floor((e1.length + 1) / 2), r = 0;
                    const a = e1.length - 1;
                    for(; !(r > a || (t[r++] = e1[n++], r > a));)t[r++] = e1[i++];
                }
                function w(e1) {
                    let t = e1.byteLength;
                    const n = new Array;
                    let i = 0;
                    const r = new DataView(e1);
                    for(; t > 0;){
                        const e1 = r.getInt8(i++);
                        if (e1 < 0) {
                            const a = -e1;
                            t -= a + 1;
                            for(let e1 = 0; e1 < a; e1++)n.push(r.getUint8(i++));
                        } else {
                            const a = e1;
                            t -= 2;
                            const s = r.getUint8(i++);
                            for(let e1 = 0; e1 < a + 1; e1++)n.push(s);
                        }
                    }
                    return n;
                }
                function E(e1, t, n) {
                    let i, r = 1;
                    for(; r < 64;)i = t[e1.value], 65280 == i ? r = 64 : i >> 8 == 255 ? r += 255 & i : (n[r] = i, r++), e1.value++;
                }
                function T(e1) {
                    const t = .5 * Math.cos(.7853975), n = .5 * Math.cos(3.14159 / 16), i = .5 * Math.cos(3.14159 / 8), r = .5 * Math.cos(3 * 3.14159 / 16), a = .5 * Math.cos(.981746875), s = .5 * Math.cos(3 * 3.14159 / 8), o = .5 * Math.cos(1.374445625), l = new Array(4), c = new Array(4), u = new Array(4), h = new Array(4);
                    for(let d = 0; d < 8; ++d){
                        const p = 8 * d;
                        l[0] = i * e1[p + 2], l[1] = s * e1[p + 2], l[2] = i * e1[p + 6], l[3] = s * e1[p + 6], c[0] = n * e1[p + 1] + r * e1[p + 3] + a * e1[p + 5] + o * e1[p + 7], c[1] = r * e1[p + 1] - o * e1[p + 3] - n * e1[p + 5] - a * e1[p + 7], c[2] = a * e1[p + 1] - n * e1[p + 3] + o * e1[p + 5] + r * e1[p + 7], c[3] = o * e1[p + 1] - a * e1[p + 3] + r * e1[p + 5] - n * e1[p + 7], u[0] = t * (e1[p + 0] + e1[p + 4]), u[3] = t * (e1[p + 0] - e1[p + 4]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], e1[p + 0] = h[0] + c[0], e1[p + 1] = h[1] + c[1], e1[p + 2] = h[2] + c[2], e1[p + 3] = h[3] + c[3], e1[p + 4] = h[3] - c[3], e1[p + 5] = h[2] - c[2], e1[p + 6] = h[1] - c[1], e1[p + 7] = h[0] - c[0];
                    }
                    for(let d = 0; d < 8; ++d)l[0] = i * e1[16 + d], l[1] = s * e1[16 + d], l[2] = i * e1[48 + d], l[3] = s * e1[48 + d], c[0] = n * e1[8 + d] + r * e1[24 + d] + a * e1[40 + d] + o * e1[56 + d], c[1] = r * e1[8 + d] - o * e1[24 + d] - n * e1[40 + d] - a * e1[56 + d], c[2] = a * e1[8 + d] - n * e1[24 + d] + o * e1[40 + d] + r * e1[56 + d], c[3] = o * e1[8 + d] - a * e1[24 + d] + r * e1[40 + d] - n * e1[56 + d], u[0] = t * (e1[d] + e1[32 + d]), u[3] = t * (e1[d] - e1[32 + d]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], e1[0 + d] = h[0] + c[0], e1[8 + d] = h[1] + c[1], e1[16 + d] = h[2] + c[2], e1[24 + d] = h[3] + c[3], e1[32 + d] = h[3] - c[3], e1[40 + d] = h[2] - c[2], e1[48 + d] = h[1] - c[1], e1[56 + d] = h[0] - c[0];
                }
                function S(e1) {
                    for(let t = 0; t < 64; ++t){
                        const n = e1[0][t], i = e1[1][t], r = e1[2][t];
                        e1[0][t] = n + 1.5747 * r, e1[1][t] = n - .1873 * i - .4682 * r, e1[2][t] = n + 1.8556 * i;
                    }
                }
                function I(e1, t, n) {
                    for(let a = 0; a < 64; ++a)t[n + a] = au.toHalfFloat((i = e1[a]) <= 1 ? Math.sign(i) * Math.pow(Math.abs(i), 2.2) : Math.sign(i) * Math.pow(r, Math.abs(i) - 1));
                    var i;
                }
                function N(e1) {
                    return new DataView(e1.array.buffer, e1.offset.value, e1.size);
                }
                function D(e1) {
                    const t = e1.viewer.buffer.slice(e1.offset.value, e1.offset.value + e1.size), n = new Uint8Array(w(t)), i = new Uint8Array(n.length);
                    return x(n), b(n, i), new DataView(i.buffer);
                }
                function _(e1) {
                    const t = rx(e1.array.slice(e1.offset.value, e1.offset.value + e1.size)), n = new Uint8Array(t.length);
                    return x(t), b(t, n), new DataView(n.buffer);
                }
                function C(e1) {
                    const n = e1.viewer, i = {
                        value: e1.offset.value
                    }, r = new Uint16Array(e1.width * e1.scanlineBlockSize * (e1.channels * e1.type)), a = new Uint8Array(8192);
                    let s = 0;
                    const o = new Array(e1.channels);
                    for(let t = 0; t < e1.channels; t++)o[t] = {}, o[t].start = s, o[t].end = o[t].start, o[t].nx = e1.width, o[t].ny = e1.lines, o[t].size = e1.type, s += o[t].nx * o[t].ny * o[t].size;
                    const l = G(n, i), c = G(n, i);
                    if (c >= 8192) throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");
                    if (l <= c) for(let e1 = 0; e1 < c - l + 1; e1++)a[e1 + l] = j(n, i);
                    const u = new Uint16Array(t), h = function(e1, n) {
                        let i = 0;
                        for(let r = 0; r < t; ++r)(0 == r || e1[r >> 3] & 1 << (7 & r)) && (n[i++] = r);
                        const r = i - 1;
                        for(; i < t;)n[i++] = 0;
                        return r;
                    }(a, u), d = P(n, i);
                    y(e1.array, n, i, d, r, s);
                    for(let t = 0; t < e1.channels; ++t){
                        const e1 = o[t];
                        for(let n = 0; n < o[t].size; ++n)v(r, e1.start + n, e1.nx, e1.size, e1.ny, e1.nx * e1.size, h);
                    }
                    !function(e1, t, n) {
                        for(let i = 0; i < n; ++i)t[i] = e1[t[i]];
                    }(u, r, s);
                    let p = 0;
                    const f = new Uint8Array(r.buffer.byteLength);
                    for(let t = 0; t < e1.lines; t++)for(let t = 0; t < e1.channels; t++){
                        const e1 = o[t], n = e1.nx * e1.size, i = new Uint8Array(r.buffer, 2 * e1.end, 2 * n);
                        f.set(i, p), p += 2 * n, e1.end += n;
                    }
                    return new DataView(f.buffer);
                }
                function L(e1) {
                    const t = rx(e1.array.slice(e1.offset.value, e1.offset.value + e1.size)), n = e1.lines * e1.channels * e1.width, i = 1 == e1.type ? new Uint16Array(n) : new Uint32Array(n);
                    let r = 0, a = 0;
                    const s = new Array(4);
                    for(let n = 0; n < e1.lines; n++)for(let n = 0; n < e1.channels; n++){
                        let n = 0;
                        switch(e1.type){
                            case 1:
                                s[0] = r, s[1] = s[0] + e1.width, r = s[1] + e1.width;
                                for(let r = 0; r < e1.width; ++r)n += t[s[0]++] << 8 | t[s[1]++], i[a] = n, a++;
                                break;
                            case 2:
                                s[0] = r, s[1] = s[0] + e1.width, s[2] = s[1] + e1.width, r = s[2] + e1.width;
                                for(let r = 0; r < e1.width; ++r)n += t[s[0]++] << 24 | t[s[1]++] << 16 | t[s[2]++] << 8, i[a] = n, a++;
                        }
                    }
                    return new DataView(i.buffer);
                }
                function z(e1) {
                    const t = e1.viewer, n = {
                        value: e1.offset.value
                    }, i = new Uint8Array(e1.width * e1.lines * (e1.channels * e1.type * 2)), r = {
                        version: k(t, n),
                        unknownUncompressedSize: k(t, n),
                        unknownCompressedSize: k(t, n),
                        acCompressedSize: k(t, n),
                        dcCompressedSize: k(t, n),
                        rleCompressedSize: k(t, n),
                        rleUncompressedSize: k(t, n),
                        rleRawSize: k(t, n),
                        totalAcUncompressedCount: k(t, n),
                        totalDcUncompressedCount: k(t, n),
                        acCompression: k(t, n)
                    };
                    if (r.version < 2) throw new Error("EXRLoader.parse: " + Z.compression + " version " + r.version + " is unsupported");
                    const a = new Array;
                    let s = G(t, n) - 2;
                    for(; s > 0;){
                        const e1 = O(t.buffer, n), i = j(t, n), r = i >> 2 & 3, o = new Int8Array([
                            (i >> 4) - 1
                        ])[0], l = j(t, n);
                        a.push({
                            name: e1,
                            index: o,
                            type: l,
                            compression: r
                        }), s -= e1.length + 3;
                    }
                    const o = Z.channels, l = new Array(e1.channels);
                    for(let t = 0; t < e1.channels; ++t){
                        const n = l[t] = {}, i = o[t];
                        n.name = i.name, n.compression = 0, n.decoded = !1, n.type = i.pixelType, n.pLinear = i.pLinear, n.width = e1.width, n.height = e1.lines;
                    }
                    const c = {
                        idx: new Array(3)
                    };
                    for(let t = 0; t < e1.channels; ++t){
                        const e1 = l[t];
                        for(let n = 0; n < a.length; ++n){
                            const i = a[n];
                            e1.name == i.name && (e1.compression = i.compression, i.index >= 0 && (c.idx[i.index] = t), e1.offset = t);
                        }
                    }
                    let u, h, d;
                    if (r.acCompressedSize > 0) switch(r.acCompression){
                        case 0:
                            u = new Uint16Array(r.totalAcUncompressedCount), y(e1.array, t, n, r.acCompressedSize, u, r.totalAcUncompressedCount);
                            break;
                        case 1:
                            const i1 = rx(e1.array.slice(n.value, n.value + r.totalAcUncompressedCount));
                            u = new Uint16Array(i1.buffer), n.value += r.totalAcUncompressedCount;
                    }
                    if (r.dcCompressedSize > 0) {
                        const t = {
                            array: e1.array,
                            offset: n,
                            size: r.dcCompressedSize
                        };
                        h = new Uint16Array(_(t).buffer), n.value += r.dcCompressedSize;
                    }
                    r.rleRawSize > 0 && (d = w(rx(e1.array.slice(n.value, n.value + r.rleCompressedSize)).buffer), n.value += r.rleCompressedSize);
                    let p = 0;
                    const f = new Array(l.length);
                    for(let e1 = 0; e1 < f.length; ++e1)f[e1] = new Array;
                    for(let t = 0; t < e1.lines; ++t)for(let t = 0; t < l.length; ++t)f[t].push(p), p += l[t].width * e1.type * 2;
                    !function(e1, t, n, i, r, a) {
                        let s = new DataView(a.buffer);
                        const o = n[e1.idx[0]].width, l = n[e1.idx[0]].height, c = Math.floor(o / 8), u = Math.ceil(o / 8), h = Math.ceil(l / 8), d = o - 8 * (u - 1), p = l - 8 * (h - 1), f = {
                            value: 0
                        }, g = new Array(3), m = new Array(3), A = new Array(3), M = new Array(3), v = new Array(3);
                        for(let n = 0; n < 3; ++n)v[n] = t[e1.idx[n]], g[n] = n < 1 ? 0 : g[n - 1] + u * h, m[n] = new Float32Array(64), A[n] = new Uint16Array(64), M[n] = new Uint16Array(64 * u);
                        for(let t = 0; t < h; ++t){
                            let a = 8;
                            t == h - 1 && (a = p);
                            let o = 8;
                            for(let e1 = 0; e1 < u; ++e1){
                                e1 == u - 1 && (o = d);
                                for(let e1 = 0; e1 < 3; ++e1)A[e1].fill(0), A[e1][0] = r[g[e1]++], E(f, i, A[e1]), y = A[e1], (x = m[e1])[0] = H(y[0]), x[1] = H(y[1]), x[2] = H(y[5]), x[3] = H(y[6]), x[4] = H(y[14]), x[5] = H(y[15]), x[6] = H(y[27]), x[7] = H(y[28]), x[8] = H(y[2]), x[9] = H(y[4]), x[10] = H(y[7]), x[11] = H(y[13]), x[12] = H(y[16]), x[13] = H(y[26]), x[14] = H(y[29]), x[15] = H(y[42]), x[16] = H(y[3]), x[17] = H(y[8]), x[18] = H(y[12]), x[19] = H(y[17]), x[20] = H(y[25]), x[21] = H(y[30]), x[22] = H(y[41]), x[23] = H(y[43]), x[24] = H(y[9]), x[25] = H(y[11]), x[26] = H(y[18]), x[27] = H(y[24]), x[28] = H(y[31]), x[29] = H(y[40]), x[30] = H(y[44]), x[31] = H(y[53]), x[32] = H(y[10]), x[33] = H(y[19]), x[34] = H(y[23]), x[35] = H(y[32]), x[36] = H(y[39]), x[37] = H(y[45]), x[38] = H(y[52]), x[39] = H(y[54]), x[40] = H(y[20]), x[41] = H(y[22]), x[42] = H(y[33]), x[43] = H(y[38]), x[44] = H(y[46]), x[45] = H(y[51]), x[46] = H(y[55]), x[47] = H(y[60]), x[48] = H(y[21]), x[49] = H(y[34]), x[50] = H(y[37]), x[51] = H(y[47]), x[52] = H(y[50]), x[53] = H(y[56]), x[54] = H(y[59]), x[55] = H(y[61]), x[56] = H(y[35]), x[57] = H(y[36]), x[58] = H(y[48]), x[59] = H(y[49]), x[60] = H(y[57]), x[61] = H(y[58]), x[62] = H(y[62]), x[63] = H(y[63]), T(m[e1]);
                                S(m);
                                for(let t = 0; t < 3; ++t)I(m[t], M[t], 64 * e1);
                            }
                            let l = 0;
                            for(let i = 0; i < 3; ++i){
                                const r = n[e1.idx[i]].type;
                                for(let e1 = 8 * t; e1 < 8 * t + a; ++e1){
                                    l = v[i][e1];
                                    for(let t = 0; t < c; ++t){
                                        const n = 64 * t + 8 * (7 & e1);
                                        s.setUint16(l + 0 * r, M[i][n + 0], !0), s.setUint16(l + 2 * r, M[i][n + 1], !0), s.setUint16(l + 4 * r, M[i][n + 2], !0), s.setUint16(l + 6 * r, M[i][n + 3], !0), s.setUint16(l + 8 * r, M[i][n + 4], !0), s.setUint16(l + 10 * r, M[i][n + 5], !0), s.setUint16(l + 12 * r, M[i][n + 6], !0), s.setUint16(l + 14 * r, M[i][n + 7], !0), l += 16 * r;
                                    }
                                }
                                if (c != u) for(let e1 = 8 * t; e1 < 8 * t + a; ++e1){
                                    const t = v[i][e1] + 8 * c * 2 * r, n = 64 * c + 8 * (7 & e1);
                                    for(let e1 = 0; e1 < o; ++e1)s.setUint16(t + 2 * e1 * r, M[i][n + e1], !0);
                                }
                            }
                        }
                        var y, x;
                        const b = new Uint16Array(o);
                        s = new DataView(a.buffer);
                        for(let t = 0; t < 3; ++t){
                            n[e1.idx[t]].decoded = !0;
                            const i = n[e1.idx[t]].type;
                            if (2 == n[t].type) for(let e1 = 0; e1 < l; ++e1){
                                const n = v[t][e1];
                                for(let e1 = 0; e1 < o; ++e1)b[e1] = s.getUint16(n + 2 * e1 * i, !0);
                                for(let e1 = 0; e1 < o; ++e1)s.setFloat32(n + 2 * e1 * i, H(b[e1]), !0);
                            }
                        }
                    }(c, f, l, u, h, i);
                    for(let t = 0; t < l.length; ++t){
                        const n = l[t];
                        if (!n.decoded) {
                            if (2 !== n.compression) throw new Error("EXRLoader.parse: unsupported channel compression");
                            {
                                let r = 0, a = 0;
                                for(let s = 0; s < e1.lines; ++s){
                                    let e1 = f[t][r];
                                    for(let t = 0; t < n.width; ++t){
                                        for(let t = 0; t < 2 * n.type; ++t)i[e1++] = d[a + t * n.width * n.height];
                                        a++;
                                    }
                                    r++;
                                }
                            }
                        }
                    }
                    return new DataView(i.buffer);
                }
                function O(e1, t) {
                    const n = new Uint8Array(e1);
                    let i = 0;
                    for(; 0 != n[t.value + i];)i += 1;
                    const r = (new TextDecoder).decode(n.slice(t.value, t.value + i));
                    return t.value = t.value + i + 1, r;
                }
                function R(e1, t) {
                    const n = e1.getInt32(t.value, !0);
                    return t.value = t.value + 4, n;
                }
                function P(e1, t) {
                    const n = e1.getUint32(t.value, !0);
                    return t.value = t.value + 4, n;
                }
                function U(e1, t) {
                    const n = e1[t.value];
                    return t.value = t.value + 1, n;
                }
                function j(e1, t) {
                    const n = e1.getUint8(t.value);
                    return t.value = t.value + 1, n;
                }
                const k = function(e1, t) {
                    let n;
                    return n = "getBigInt64" in DataView.prototype ? Number(e1.getBigInt64(t.value, !0)) : e1.getUint32(t.value + 4, !0) + Number(e1.getUint32(t.value, !0) << 32), t.value += 8, n;
                };
                function B(e1, t) {
                    const n = e1.getFloat32(t.value, !0);
                    return t.value += 4, n;
                }
                function F(e1, t) {
                    return au.toHalfFloat(B(e1, t));
                }
                function H(e1) {
                    const t = (31744 & e1) >> 10, n = 1023 & e1;
                    return (e1 >> 15 ? -1 : 1) * (t ? 31 === t ? n ? NaN : 1 / 0 : Math.pow(2, t - 15) * (1 + n / 1024) : n / 1024 * 6103515625e-14);
                }
                function G(e1, t) {
                    const n = e1.getUint16(t.value, !0);
                    return t.value += 2, n;
                }
                function V(e1, t) {
                    return H(G(e1, t));
                }
                function Q(e1, t, n, i, r) {
                    return "string" === i || "stringvector" === i || "iccProfile" === i ? function(e1, t, n) {
                        const i = (new TextDecoder).decode(new Uint8Array(e1).slice(t.value, t.value + n));
                        return t.value = t.value + n, i;
                    }(t, n, r) : "chlist" === i ? function(e1, t, n, i) {
                        const r = n.value, a = [];
                        for(; n.value < r + i - 1;){
                            const i = O(t, n), r = R(e1, n), s = j(e1, n);
                            n.value += 3;
                            const o = R(e1, n), l = R(e1, n);
                            a.push({
                                name: i,
                                pixelType: r,
                                pLinear: s,
                                xSampling: o,
                                ySampling: l
                            });
                        }
                        return n.value += 1, a;
                    }(e1, t, n, r) : "chromaticities" === i ? function(e1, t) {
                        return {
                            redX: B(e1, t),
                            redY: B(e1, t),
                            greenX: B(e1, t),
                            greenY: B(e1, t),
                            blueX: B(e1, t),
                            blueY: B(e1, t),
                            whiteX: B(e1, t),
                            whiteY: B(e1, t)
                        };
                    }(e1, n) : "compression" === i ? function(e1, t) {
                        return [
                            "NO_COMPRESSION",
                            "RLE_COMPRESSION",
                            "ZIPS_COMPRESSION",
                            "ZIP_COMPRESSION",
                            "PIZ_COMPRESSION",
                            "PXR24_COMPRESSION",
                            "B44_COMPRESSION",
                            "B44A_COMPRESSION",
                            "DWAA_COMPRESSION",
                            "DWAB_COMPRESSION"
                        ][j(e1, t)];
                    }(e1, n) : "box2i" === i ? function(e1, t) {
                        return {
                            xMin: P(e1, t),
                            yMin: P(e1, t),
                            xMax: P(e1, t),
                            yMax: P(e1, t)
                        };
                    }(e1, n) : "lineOrder" === i ? function(e1, t) {
                        return [
                            "INCREASING_Y"
                        ][j(e1, t)];
                    }(e1, n) : "float" === i ? B(e1, n) : "v2f" === i ? function(e1, t) {
                        return [
                            B(e1, t),
                            B(e1, t)
                        ];
                    }(e1, n) : "v3f" === i ? function(e1, t) {
                        return [
                            B(e1, t),
                            B(e1, t),
                            B(e1, t)
                        ];
                    }(e1, n) : "int" === i ? R(e1, n) : "rational" === i ? function(e1, t) {
                        return [
                            R(e1, t),
                            P(e1, t)
                        ];
                    }(e1, n) : "timecode" === i ? function(e1, t) {
                        return [
                            P(e1, t),
                            P(e1, t)
                        ];
                    }(e1, n) : "preview" === i ? (n.value += r, "skipped") : void (n.value += r);
                }
                const W = new DataView(e1), Y = new Uint8Array(e1), X = {
                    value: 0
                }, Z = function(e1, t, n) {
                    const i = {};
                    if (20000630 != e1.getUint32(0, !0)) throw new Error("THREE.EXRLoader: Provided file doesn't appear to be in OpenEXR format.");
                    i.version = e1.getUint8(4);
                    const r = e1.getUint8(5);
                    i.spec = {
                        singleTile: !!(2 & r),
                        longName: !!(4 & r),
                        deepFormat: !!(8 & r),
                        multiPart: !!(16 & r)
                    }, n.value = 8;
                    let a = !0;
                    for(; a;){
                        const r = O(t, n);
                        if (0 == r) a = !1;
                        else {
                            const a = O(t, n), s = Q(e1, t, n, a, P(e1, n));
                            void 0 === s ? console.warn(`THREE.EXRLoader: Skipped unknown header attribute type '${a}'.`) : i[r] = s;
                        }
                    }
                    if (-5 & r) throw console.error("THREE.EXRHeader:", i), new Error("THREE.EXRLoader: Provided file is currently unsupported.");
                    return i;
                }(W, e1, X), q = function(e1, t, n, i, r) {
                    const a = {
                        size: 0,
                        viewer: t,
                        array: n,
                        offset: i,
                        width: e1.dataWindow.xMax - e1.dataWindow.xMin + 1,
                        height: e1.dataWindow.yMax - e1.dataWindow.yMin + 1,
                        channels: e1.channels.length,
                        bytesPerLine: null,
                        lines: null,
                        inputSize: null,
                        type: e1.channels[0].pixelType,
                        uncompress: null,
                        getter: null,
                        format: null,
                        colorSpace: Ws
                    };
                    switch(e1.compression){
                        case "NO_COMPRESSION":
                            a.lines = 1, a.uncompress = N;
                            break;
                        case "RLE_COMPRESSION":
                            a.lines = 1, a.uncompress = D;
                            break;
                        case "ZIPS_COMPRESSION":
                            a.lines = 1, a.uncompress = _;
                            break;
                        case "ZIP_COMPRESSION":
                            a.lines = 16, a.uncompress = _;
                            break;
                        case "PIZ_COMPRESSION":
                            a.lines = 32, a.uncompress = C;
                            break;
                        case "PXR24_COMPRESSION":
                            a.lines = 16, a.uncompress = L;
                            break;
                        case "DWAA_COMPRESSION":
                            a.lines = 32, a.uncompress = z;
                            break;
                        case "DWAB_COMPRESSION":
                            a.lines = 256, a.uncompress = z;
                            break;
                        default:
                            throw new Error("EXRLoader.parse: " + e1.compression + " is unsupported");
                    }
                    if (a.scanlineBlockSize = a.lines, 1 == a.type) switch(r){
                        case _a:
                            a.getter = V, a.inputSize = 2;
                            break;
                        case Ca:
                            a.getter = G, a.inputSize = 2;
                    }
                    else {
                        if (2 != a.type) throw new Error("EXRLoader.parse: unsupported pixelType " + a.type + " for " + e1.compression + ".");
                        switch(r){
                            case _a:
                                a.getter = B, a.inputSize = 4;
                                break;
                            case Ca:
                                a.getter = F, a.inputSize = 4;
                        }
                    }
                    a.blockCount = (e1.dataWindow.yMax + 1) / a.scanlineBlockSize;
                    for(let e1 = 0; e1 < a.blockCount; e1++)k(t, i);
                    a.outputChannels = 3 == a.channels ? 4 : a.channels;
                    const s = a.width * a.height * a.outputChannels;
                    switch(r){
                        case _a:
                            a.byteArray = new Float32Array(s), a.channels < a.outputChannels && a.byteArray.fill(1, 0, s);
                            break;
                        case Ca:
                            a.byteArray = new Uint16Array(s), a.channels < a.outputChannels && a.byteArray.fill(15360, 0, s);
                            break;
                        default:
                            console.error("THREE.EXRLoader: unsupported type: ", r);
                    }
                    return a.bytesPerLine = a.width * a.inputSize * a.channels, 4 == a.outputChannels ? (a.format = Pa, a.colorSpace = Ws) : (a.format = Fa, a.colorSpace = Vs), a;
                }(Z, W, Y, X, this.type), K = {
                    value: 0
                }, J = {
                    R: 0,
                    G: 1,
                    B: 2,
                    A: 3,
                    Y: 0
                };
                for(let e1 = 0; e1 < q.height / q.scanlineBlockSize; e1++){
                    const t = P(W, X);
                    q.size = P(W, X), q.lines = t + q.scanlineBlockSize > q.height ? q.height - t : q.scanlineBlockSize;
                    const n = q.size < q.lines * q.bytesPerLine ? q.uncompress(q) : N(q);
                    X.value += q.size;
                    for(let t = 0; t < q.scanlineBlockSize; t++){
                        const i = t + e1 * q.scanlineBlockSize;
                        if (i >= q.height) break;
                        for(let e1 = 0; e1 < q.channels; e1++){
                            const r = J[Z.channels[e1].name];
                            for(let a = 0; a < q.width; a++){
                                K.value = (t * (q.channels * q.width) + e1 * q.width + a) * q.inputSize;
                                const s = (q.height - 1 - i) * (q.width * q.outputChannels) + a * q.outputChannels + r;
                                q.byteArray[s] = q.getter(n, K);
                            }
                        }
                    }
                }
                return {
                    header: Z,
                    width: q.width,
                    height: q.height,
                    data: q.byteArray,
                    format: q.format,
                    colorSpace: q.colorSpace,
                    type: this.type
                };
            }
            setDataType(e1) {
                return this.type = e1, this;
            }
            load(e1, t, n, i) {
                return super.load(e1, function(e1, n) {
                    e1.colorSpace = n.colorSpace, e1.minFilter = va, e1.magFilter = va, e1.generateMipmaps = !1, e1.flipY = !1, t && t(e1, n);
                }, n, i);
            }
        }
        class ox {
            static async get(e1) {
                const t = await ox.getCache(), n = await t?.match(e1);
                if (!n) return;
                const { headers: i } = n, r = i.get("expires"), a = i.get("date") ?? "", s = r && "-1" !== r ? Date.parse(r) : Date.parse(a) + 18e5;
                if (!(Date.now() >= s)) return n;
                await ox.delete(e1);
            }
            static async put(e1, t) {
                const n = await ox.getCache(), i = t.clone(), r = new Headers([
                    ...i.headers.entries()
                ]);
                r.set("date", (new Date).toUTCString());
                const { body: a, ...s } = i;
                return n?.put(e1, new Response(a, {
                    ...s,
                    headers: r
                }));
            }
            static async delete(e1) {
                const t = await ox.getCache();
                return Boolean(t?.delete(e1));
            }
            static async getCache() {
                return await window.caches?.open("cache") ?? null;
            }
        }
        var lx = n(512), cx = n.n(lx);
        function ux() {
            return cx()('/*! For license information please see widget.module.worker.js.LICENSE.txt */\n(()=>{"use strict";const e="158",t=1,n=2,i=3,r=0,a=1,s=2,o=100,l=101,c=102,h=200,u=201,d=202,p=203,f=204,m=205,g=206,_=207,v=208,x=209,M=210,S=211,y=212,E=213,T=214,b=0,w=1,A=2,R=0,C=1,L=2,P=3,U=4,D=5,N=301,I=302,O=306,F=1e3,z=1001,B=1002,H=1003,V=1004,G=1005,k=1006,W=1007,X=1008,j=1009,q=1012,Y=1014,K=1015,Z=1016,J=1020,Q=1023,$=1026,ee=1027,te=33776,ne=33777,ie=33778,re=33779,ae=36492,se=2300,oe=2301,le=2302,ce=3001,he="",ue="srgb",de="srgb-linear",pe="display-p3",fe="display-p3-linear",me="linear",ge="srgb",_e="rec709",ve="p3",xe=7680,Me=512,Se=513,ye=514,Ee=515,Te=516,be=517,we=518,Ae=519,Re="300 es",Ce=1035,Le=2e3,Pe=2001;class Ue{addEventListener(e,t){void 0===this._listeners&&(this._listeners={});const n=this._listeners;void 0===n[e]&&(n[e]=[]),-1===n[e].indexOf(t)&&n[e].push(t)}hasEventListener(e,t){if(void 0===this._listeners)return!1;const n=this._listeners;return void 0!==n[e]&&-1!==n[e].indexOf(t)}removeEventListener(e,t){if(void 0===this._listeners)return;const n=this._listeners[e];if(void 0!==n){const e=n.indexOf(t);-1!==e&&n.splice(e,1)}}dispatchEvent(e){if(void 0===this._listeners)return;const t=this._listeners[e.type];if(void 0!==t){e.target=this;const n=t.slice(0);for(let t=0,i=n.length;t<i;t++)n[t].call(this,e);e.target=null}}}const De=["00","01","02","03","04","05","06","07","08","09","0a","0b","0c","0d","0e","0f","10","11","12","13","14","15","16","17","18","19","1a","1b","1c","1d","1e","1f","20","21","22","23","24","25","26","27","28","29","2a","2b","2c","2d","2e","2f","30","31","32","33","34","35","36","37","38","39","3a","3b","3c","3d","3e","3f","40","41","42","43","44","45","46","47","48","49","4a","4b","4c","4d","4e","4f","50","51","52","53","54","55","56","57","58","59","5a","5b","5c","5d","5e","5f","60","61","62","63","64","65","66","67","68","69","6a","6b","6c","6d","6e","6f","70","71","72","73","74","75","76","77","78","79","7a","7b","7c","7d","7e","7f","80","81","82","83","84","85","86","87","88","89","8a","8b","8c","8d","8e","8f","90","91","92","93","94","95","96","97","98","99","9a","9b","9c","9d","9e","9f","a0","a1","a2","a3","a4","a5","a6","a7","a8","a9","aa","ab","ac","ad","ae","af","b0","b1","b2","b3","b4","b5","b6","b7","b8","b9","ba","bb","bc","bd","be","bf","c0","c1","c2","c3","c4","c5","c6","c7","c8","c9","ca","cb","cc","cd","ce","cf","d0","d1","d2","d3","d4","d5","d6","d7","d8","d9","da","db","dc","dd","de","df","e0","e1","e2","e3","e4","e5","e6","e7","e8","e9","ea","eb","ec","ed","ee","ef","f0","f1","f2","f3","f4","f5","f6","f7","f8","f9","fa","fb","fc","fd","fe","ff"],Ne=Math.PI/180,Ie=180/Math.PI;function Oe(){const e=4294967295*Math.random()|0,t=4294967295*Math.random()|0,n=4294967295*Math.random()|0,i=4294967295*Math.random()|0;return(De[255&e]+De[e>>8&255]+De[e>>16&255]+De[e>>24&255]+"-"+De[255&t]+De[t>>8&255]+"-"+De[t>>16&15|64]+De[t>>24&255]+"-"+De[63&n|128]+De[n>>8&255]+"-"+De[n>>16&255]+De[n>>24&255]+De[255&i]+De[i>>8&255]+De[i>>16&255]+De[i>>24&255]).toLowerCase()}function Fe(e,t,n){return Math.max(t,Math.min(n,e))}function ze(e,t,n){return(1-n)*e+n*t}function Be(e){return!(e&e-1)&&0!==e}function He(e){return Math.pow(2,Math.floor(Math.log(e)/Math.LN2))}function Ve(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw new Error("Invalid component type.")}}function Ge(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(4294967295*e);case Uint16Array:return Math.round(65535*e);case Uint8Array:return Math.round(255*e);case Int32Array:return Math.round(2147483647*e);case Int16Array:return Math.round(32767*e);case Int8Array:return Math.round(127*e);default:throw new Error("Invalid component type.")}}class ke{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;ke.prototype.isVector2=!0,this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){const t=this.x,n=this.y,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6],this.y=i[1]*t+i[4]*n+i[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){const t=Math.sqrt(this.lengthSq()*e.lengthSq());if(0===t)return Math.PI/2;const n=this.dot(e)/t;return Math.acos(Fe(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){const t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){const n=Math.cos(t),i=Math.sin(t),r=this.x-e.x,a=this.y-e.y;return this.x=r*n-a*i+e.x,this.y=r*i+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}}class We{constructor(e,t,n,i,r,a,s,o,l){We.prototype.isMatrix3=!0,this.elements=[1,0,0,0,1,0,0,0,1],void 0!==e&&this.set(e,t,n,i,r,a,s,o,l)}set(e,t,n,i,r,a,s,o,l){const c=this.elements;return c[0]=e,c[1]=i,c[2]=s,c[3]=t,c[4]=r,c[5]=o,c[6]=n,c[7]=a,c[8]=l,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){const t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){const t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){const n=e.elements,i=t.elements,r=this.elements,a=n[0],s=n[3],o=n[6],l=n[1],c=n[4],h=n[7],u=n[2],d=n[5],p=n[8],f=i[0],m=i[3],g=i[6],_=i[1],v=i[4],x=i[7],M=i[2],S=i[5],y=i[8];return r[0]=a*f+s*_+o*M,r[3]=a*m+s*v+o*S,r[6]=a*g+s*x+o*y,r[1]=l*f+c*_+h*M,r[4]=l*m+c*v+h*S,r[7]=l*g+c*x+h*y,r[2]=u*f+d*_+p*M,r[5]=u*m+d*v+p*S,r[8]=u*g+d*x+p*y,this}multiplyScalar(e){const t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8];return t*a*c-t*s*l-n*r*c+n*s*o+i*r*l-i*a*o}invert(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8],h=c*a-s*l,u=s*o-c*r,d=l*r-a*o,p=t*h+n*u+i*d;if(0===p)return this.set(0,0,0,0,0,0,0,0,0);const f=1/p;return e[0]=h*f,e[1]=(i*l-c*n)*f,e[2]=(s*n-i*a)*f,e[3]=u*f,e[4]=(c*t-i*o)*f,e[5]=(i*r-s*t)*f,e[6]=d*f,e[7]=(n*o-l*t)*f,e[8]=(a*t-n*r)*f,this}transpose(){let e;const t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){const t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,i,r,a,s){const o=Math.cos(r),l=Math.sin(r);return this.set(n*o,n*l,-n*(o*a+l*s)+a+e,-i*l,i*o,-i*(-l*a+o*s)+s+t,0,0,1),this}scale(e,t){return this.premultiply(Xe.makeScale(e,t)),this}rotate(e){return this.premultiply(Xe.makeRotation(-e)),this}translate(e,t){return this.premultiply(Xe.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){const t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return(new this.constructor).fromArray(this.elements)}}const Xe=new We;function je(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function qe(e){return document.createElementNS("http://www.w3.org/1999/xhtml",e)}function Ye(){const e=qe("canvas");return e.style.display="block",e}Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array;const Ke={};function Ze(e){e in Ke||(Ke[e]=!0,console.warn(e))}const Je=(new We).set(.8224621,.177538,0,.0331941,.9668058,0,.0170827,.0723974,.9105199),Qe=(new We).set(1.2249401,-.2249404,0,-.0420569,1.0420571,0,-.0196376,-.0786361,1.0982735),$e={[de]:{transfer:me,primaries:_e,toReference:e=>e,fromReference:e=>e},[ue]:{transfer:ge,primaries:_e,toReference:e=>e.convertSRGBToLinear(),fromReference:e=>e.convertLinearToSRGB()},[fe]:{transfer:me,primaries:ve,toReference:e=>e.applyMatrix3(Qe),fromReference:e=>e.applyMatrix3(Je)},[pe]:{transfer:ge,primaries:ve,toReference:e=>e.convertSRGBToLinear().applyMatrix3(Qe),fromReference:e=>e.applyMatrix3(Je).convertLinearToSRGB()}},et=new Set([de,fe]),tt={enabled:!0,_workingColorSpace:de,get legacyMode(){return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."),!this.enabled},set legacyMode(e){console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."),this.enabled=!e},get workingColorSpace(){return this._workingColorSpace},set workingColorSpace(e){if(!et.has(e))throw new Error(`Unsupported working color space, "${e}".`);this._workingColorSpace=e},convert:function(e,t,n){if(!1===this.enabled||t===n||!t||!n)return e;const i=$e[t].toReference;return(0,$e[n].fromReference)(i(e))},fromWorkingColorSpace:function(e,t){return this.convert(e,this._workingColorSpace,t)},toWorkingColorSpace:function(e,t){return this.convert(e,t,this._workingColorSpace)},getPrimaries:function(e){return $e[e].primaries},getTransfer:function(e){return e===he?me:$e[e].transfer}};function nt(e){return e<.04045?.0773993808*e:Math.pow(.9478672986*e+.0521327014,2.4)}function it(e){return e<.0031308?12.92*e:1.055*Math.pow(e,.41666)-.055}let rt;class at{static getDataURL(e){if(/^data:/i.test(e.src))return e.src;if("undefined"==typeof HTMLCanvasElement)return e.src;let t;if(e instanceof HTMLCanvasElement)t=e;else{void 0===rt&&(rt=qe("canvas")),rt.width=e.width,rt.height=e.height;const n=rt.getContext("2d");e instanceof ImageData?n.putImageData(e,0,0):n.drawImage(e,0,0,e.width,e.height),t=rt}return t.width>2048||t.height>2048?(console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",e),t.toDataURL("image/jpeg",.6)):t.toDataURL("image/png")}static sRGBToLinear(e){if("undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap){const t=qe("canvas");t.width=e.width,t.height=e.height;const n=t.getContext("2d");n.drawImage(e,0,0,e.width,e.height);const i=n.getImageData(0,0,e.width,e.height),r=i.data;for(let e=0;e<r.length;e++)r[e]=255*nt(r[e]/255);return n.putImageData(i,0,0),t}if(e.data){const t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(255*nt(t[e]/255)):t[e]=nt(t[e]);return{data:t,width:e.width,height:e.height}}return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."),e}}let st=0;class ot{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.isSource=!0,Object.defineProperty(this,"id",{value:st++}),this.uuid=Oe(),this.data=e,this.version=0}set needsUpdate(e){!0===e&&this.version++}toJSON(e){const t=void 0===e||"string"==typeof e;if(!t&&void 0!==e.images[this.uuid])return e.images[this.uuid];const n={uuid:this.uuid,url:""},i=this.data;if(null!==i){let e;if(Array.isArray(i)){e=[];for(let t=0,n=i.length;t<n;t++)i[t].isDataTexture?e.push(lt(i[t].image)):e.push(lt(i[t]))}else e=lt(i);n.url=e}return t||(e.images[this.uuid]=n),n}}function lt(e){return"undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap?at.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(console.warn("THREE.Texture: Unable to serialize Texture."),{})}let ct=0;class ht extends Ue{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ht.DEFAULT_IMAGE,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ht.DEFAULT_MAPPING,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:z,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:z,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:k,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:X,s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Q,o=arguments.length>7&&void 0!==arguments[7]?arguments[7]:j,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:ht.DEFAULT_ANISOTROPY,c=arguments.length>9&&void 0!==arguments[9]?arguments[9]:he;super(),this.isTexture=!0,Object.defineProperty(this,"id",{value:ct++}),this.uuid=Oe(),this.name="",this.source=new ot(e),this.mipmaps=[],this.mapping=t,this.channel=0,this.wrapS=n,this.wrapT=i,this.magFilter=r,this.minFilter=a,this.anisotropy=l,this.format=s,this.internalFormat=null,this.type=o,this.offset=new ke(0,0),this.repeat=new ke(1,1),this.center=new ke(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new We,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,"string"==typeof c?this.colorSpace=c:(Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace=c===ce?ue:he),this.userData={},this.version=0,this.onUpdate=null,this.isRenderTargetTexture=!1,this.needsPMREMUpdate=!1}get image(){return this.source.data}set image(e){void 0===e&&(e=null),this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}clone(){return(new this.constructor).copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}toJSON(e){const t=void 0===e||"string"==typeof e;if(!t&&void 0!==e.textures[this.uuid])return e.textures[this.uuid];const n={metadata:{version:4.6,type:"Texture",generator:"Texture.toJSON"},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:"dispose"})}transformUv(e){if(300!==this.mapping)return e;if(e.applyMatrix3(this.matrix),e.x<0||e.x>1)switch(this.wrapS){case F:e.x=e.x-Math.floor(e.x);break;case z:e.x=e.x<0?0:1;break;case B:1===Math.abs(Math.floor(e.x)%2)?e.x=Math.ceil(e.x)-e.x:e.x=e.x-Math.floor(e.x)}if(e.y<0||e.y>1)switch(this.wrapT){case F:e.y=e.y-Math.floor(e.y);break;case z:e.y=e.y<0?0:1;break;case B:1===Math.abs(Math.floor(e.y)%2)?e.y=Math.ceil(e.y)-e.y:e.y=e.y-Math.floor(e.y)}return this.flipY&&(e.y=1-e.y),e}set needsUpdate(e){!0===e&&(this.version++,this.source.needsUpdate=!0)}get encoding(){return Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace===ue?ce:3e3}set encoding(e){Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace=e===ce?ue:he}}ht.DEFAULT_IMAGE=null,ht.DEFAULT_MAPPING=300,ht.DEFAULT_ANISOTROPY=1;class ut{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;ut.prototype.isVector4=!0,this.x=e,this.y=t,this.z=n,this.w=i}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,i){return this.x=e,this.y=t,this.z=n,this.w=i,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=void 0!==e.w?e.w:1,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){const t=this.x,n=this.y,i=this.z,r=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*i+a[12]*r,this.y=a[1]*t+a[5]*n+a[9]*i+a[13]*r,this.z=a[2]*t+a[6]*n+a[10]*i+a[14]*r,this.w=a[3]*t+a[7]*n+a[11]*i+a[15]*r,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);const t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,i,r;const a=.01,s=.1,o=e.elements,l=o[0],c=o[4],h=o[8],u=o[1],d=o[5],p=o[9],f=o[2],m=o[6],g=o[10];if(Math.abs(c-u)<a&&Math.abs(h-f)<a&&Math.abs(p-m)<a){if(Math.abs(c+u)<s&&Math.abs(h+f)<s&&Math.abs(p+m)<s&&Math.abs(l+d+g-3)<s)return this.set(1,0,0,0),this;t=Math.PI;const e=(l+1)/2,o=(d+1)/2,_=(g+1)/2,v=(c+u)/4,x=(h+f)/4,M=(p+m)/4;return e>o&&e>_?e<a?(n=0,i=.707106781,r=.707106781):(n=Math.sqrt(e),i=v/n,r=x/n):o>_?o<a?(n=.707106781,i=0,r=.707106781):(i=Math.sqrt(o),n=v/i,r=M/i):_<a?(n=.707106781,i=.707106781,r=0):(r=Math.sqrt(_),n=x/r,i=M/r),this.set(n,i,r,t),this}let _=Math.sqrt((m-p)*(m-p)+(h-f)*(h-f)+(u-c)*(u-c));return Math.abs(_)<.001&&(_=1),this.x=(m-p)/_,this.y=(h-f)/_,this.z=(u-c)/_,this.w=Math.acos((l+d+g-1)/2),this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this.w=Math.max(e.w,Math.min(t.w,this.w)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this.w=Math.max(e,Math.min(t,this.w)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}}class dt extends Ue{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};super(),this.isRenderTarget=!0,this.width=e,this.height=t,this.depth=1,this.scissor=new ut(0,0,e,t),this.scissorTest=!1,this.viewport=new ut(0,0,e,t);const i={width:e,height:t,depth:1};void 0!==n.encoding&&(Ze("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."),n.colorSpace=n.encoding===ce?ue:he),n=Object.assign({generateMipmaps:!1,internalFormat:null,minFilter:k,depthBuffer:!0,stencilBuffer:!1,depthTexture:null,samples:0},n),this.texture=new ht(i,n.mapping,n.wrapS,n.wrapT,n.magFilter,n.minFilter,n.format,n.type,n.anisotropy,n.colorSpace),this.texture.isRenderTargetTexture=!0,this.texture.flipY=!1,this.texture.generateMipmaps=n.generateMipmaps,this.texture.internalFormat=n.internalFormat,this.depthBuffer=n.depthBuffer,this.stencilBuffer=n.stencilBuffer,this.depthTexture=n.depthTexture,this.samples=n.samples}setSize(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;this.width===e&&this.height===t&&this.depth===n||(this.width=e,this.height=t,this.depth=n,this.texture.image.width=e,this.texture.image.height=t,this.texture.image.depth=n,this.dispose()),this.viewport.set(0,0,e,t),this.scissor.set(0,0,e,t)}clone(){return(new this.constructor).copy(this)}copy(e){this.width=e.width,this.height=e.height,this.depth=e.depth,this.scissor.copy(e.scissor),this.scissorTest=e.scissorTest,this.viewport.copy(e.viewport),this.texture=e.texture.clone(),this.texture.isRenderTargetTexture=!0;const t=Object.assign({},e.texture.image);return this.texture.source=new ot(t),this.depthBuffer=e.depthBuffer,this.stencilBuffer=e.stencilBuffer,null!==e.depthTexture&&(this.depthTexture=e.depthTexture.clone()),this.samples=e.samples,this}dispose(){this.dispatchEvent({type:"dispose"})}}class pt extends dt{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}),this.isWebGLRenderTarget=!0}}class ft extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(null),this.isDataArrayTexture=!0,this.image={data:e,width:t,height:n,depth:i},this.magFilter=H,this.minFilter=H,this.wrapR=z,this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}class mt extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(null),this.isData3DTexture=!0,this.image={data:e,width:t,height:n,depth:i},this.magFilter=H,this.minFilter=H,this.wrapR=z,this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}class gt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=i}static slerpFlat(e,t,n,i,r,a,s){let o=n[i+0],l=n[i+1],c=n[i+2],h=n[i+3];const u=r[a+0],d=r[a+1],p=r[a+2],f=r[a+3];if(0===s)return e[t+0]=o,e[t+1]=l,e[t+2]=c,void(e[t+3]=h);if(1===s)return e[t+0]=u,e[t+1]=d,e[t+2]=p,void(e[t+3]=f);if(h!==f||o!==u||l!==d||c!==p){let e=1-s;const t=o*u+l*d+c*p+h*f,n=t>=0?1:-1,i=1-t*t;if(i>Number.EPSILON){const r=Math.sqrt(i),a=Math.atan2(r,t*n);e=Math.sin(e*a)/r,s=Math.sin(s*a)/r}const r=s*n;if(o=o*e+u*r,l=l*e+d*r,c=c*e+p*r,h=h*e+f*r,e===1-s){const e=1/Math.sqrt(o*o+l*l+c*c+h*h);o*=e,l*=e,c*=e,h*=e}}e[t]=o,e[t+1]=l,e[t+2]=c,e[t+3]=h}static multiplyQuaternionsFlat(e,t,n,i,r,a){const s=n[i],o=n[i+1],l=n[i+2],c=n[i+3],h=r[a],u=r[a+1],d=r[a+2],p=r[a+3];return e[t]=s*p+c*h+o*d-l*u,e[t+1]=o*p+c*u+l*h-s*d,e[t+2]=l*p+c*d+s*u-o*h,e[t+3]=c*p-s*h-o*u-l*d,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,i){return this._x=e,this._y=t,this._z=n,this._w=i,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t){const n=e._x,i=e._y,r=e._z,a=e._order,s=Math.cos,o=Math.sin,l=s(n/2),c=s(i/2),h=s(r/2),u=o(n/2),d=o(i/2),p=o(r/2);switch(a){case"XYZ":this._x=u*c*h+l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h-u*d*p;break;case"YXZ":this._x=u*c*h+l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h+u*d*p;break;case"ZXY":this._x=u*c*h-l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h-u*d*p;break;case"ZYX":this._x=u*c*h-l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h+u*d*p;break;case"YZX":this._x=u*c*h+l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h-u*d*p;break;case"XZY":this._x=u*c*h-l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h+u*d*p;break;default:console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: "+a)}return!1!==t&&this._onChangeCallback(),this}setFromAxisAngle(e,t){const n=t/2,i=Math.sin(n);return this._x=e.x*i,this._y=e.y*i,this._z=e.z*i,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){const t=e.elements,n=t[0],i=t[4],r=t[8],a=t[1],s=t[5],o=t[9],l=t[2],c=t[6],h=t[10],u=n+s+h;if(u>0){const e=.5/Math.sqrt(u+1);this._w=.25/e,this._x=(c-o)*e,this._y=(r-l)*e,this._z=(a-i)*e}else if(n>s&&n>h){const e=2*Math.sqrt(1+n-s-h);this._w=(c-o)/e,this._x=.25*e,this._y=(i+a)/e,this._z=(r+l)/e}else if(s>h){const e=2*Math.sqrt(1+s-n-h);this._w=(r-l)/e,this._x=(i+a)/e,this._y=.25*e,this._z=(o+c)/e}else{const e=2*Math.sqrt(1+h-n-s);this._w=(a-i)/e,this._x=(r+l)/e,this._y=(o+c)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<Number.EPSILON?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(Fe(this.dot(e),-1,1)))}rotateTowards(e,t){const n=this.angleTo(e);if(0===n)return this;const i=Math.min(1,t/n);return this.slerp(e,i),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return 0===e?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x=this._x*e,this._y=this._y*e,this._z=this._z*e,this._w=this._w*e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){const n=e._x,i=e._y,r=e._z,a=e._w,s=t._x,o=t._y,l=t._z,c=t._w;return this._x=n*c+a*s+i*l-r*o,this._y=i*c+a*o+r*s-n*l,this._z=r*c+a*l+n*o-i*s,this._w=a*c-n*s-i*o-r*l,this._onChangeCallback(),this}slerp(e,t){if(0===t)return this;if(1===t)return this.copy(e);const n=this._x,i=this._y,r=this._z,a=this._w;let s=a*e._w+n*e._x+i*e._y+r*e._z;if(s<0?(this._w=-e._w,this._x=-e._x,this._y=-e._y,this._z=-e._z,s=-s):this.copy(e),s>=1)return this._w=a,this._x=n,this._y=i,this._z=r,this;const o=1-s*s;if(o<=Number.EPSILON){const e=1-t;return this._w=e*a+t*this._w,this._x=e*n+t*this._x,this._y=e*i+t*this._y,this._z=e*r+t*this._z,this.normalize(),this._onChangeCallback(),this}const l=Math.sqrt(o),c=Math.atan2(l,s),h=Math.sin((1-t)*c)/l,u=Math.sin(t*c)/l;return this._w=a*h+this._w*u,this._x=n*h+this._x*u,this._y=i*h+this._y*u,this._z=r*h+this._z*u,this._onChangeCallback(),this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){const e=Math.random(),t=Math.sqrt(1-e),n=Math.sqrt(e),i=2*Math.PI*Math.random(),r=2*Math.PI*Math.random();return this.set(t*Math.cos(i),n*Math.sin(r),n*Math.cos(r),t*Math.sin(i))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}}class _t{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;_t.prototype.isVector3=!0,this.x=e,this.y=t,this.z=n}set(e,t,n){return void 0===n&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(xt.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(xt.setFromAxisAngle(e,t))}applyMatrix3(e){const t=this.x,n=this.y,i=this.z,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6]*i,this.y=r[1]*t+r[4]*n+r[7]*i,this.z=r[2]*t+r[5]*n+r[8]*i,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){const t=this.x,n=this.y,i=this.z,r=e.elements,a=1/(r[3]*t+r[7]*n+r[11]*i+r[15]);return this.x=(r[0]*t+r[4]*n+r[8]*i+r[12])*a,this.y=(r[1]*t+r[5]*n+r[9]*i+r[13])*a,this.z=(r[2]*t+r[6]*n+r[10]*i+r[14])*a,this}applyQuaternion(e){const t=this.x,n=this.y,i=this.z,r=e.x,a=e.y,s=e.z,o=e.w,l=2*(a*i-s*n),c=2*(s*t-r*i),h=2*(r*n-a*t);return this.x=t+o*l+a*h-s*c,this.y=n+o*c+s*l-r*h,this.z=i+o*h+r*c-a*l,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){const t=this.x,n=this.y,i=this.z,r=e.elements;return this.x=r[0]*t+r[4]*n+r[8]*i,this.y=r[1]*t+r[5]*n+r[9]*i,this.z=r[2]*t+r[6]*n+r[10]*i,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){const n=e.x,i=e.y,r=e.z,a=t.x,s=t.y,o=t.z;return this.x=i*o-r*s,this.y=r*a-n*o,this.z=n*s-i*a,this}projectOnVector(e){const t=e.lengthSq();if(0===t)return this.set(0,0,0);const n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return vt.copy(this).projectOnVector(e),this.sub(vt)}reflect(e){return this.sub(vt.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){const t=Math.sqrt(this.lengthSq()*e.lengthSq());if(0===t)return Math.PI/2;const n=this.dot(e)/t;return Math.acos(Fe(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){const t=this.x-e.x,n=this.y-e.y,i=this.z-e.z;return t*t+n*n+i*i}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){const i=Math.sin(t)*e;return this.x=i*Math.sin(n),this.y=Math.cos(t)*e,this.z=i*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){const t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){const t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),i=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=i,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,4*t)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,3*t)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){const e=2*(Math.random()-.5),t=Math.random()*Math.PI*2,n=Math.sqrt(1-e**2);return this.x=n*Math.cos(t),this.y=n*Math.sin(t),this.z=e,this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}}const vt=new _t,xt=new gt;class Mt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t(1/0,1/0,1/0),t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t(-1/0,-1/0,-1/0);this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(yt.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(yt.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){const n=yt.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return this.makeEmpty(),this.expandByObject(e,t)}clone(){return(new this.constructor).copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e.updateWorldMatrix(!1,!1);const n=e.geometry;if(void 0!==n){const i=n.getAttribute("position");if(!0===t&&void 0!==i&&!0!==e.isInstancedMesh)for(let t=0,n=i.count;t<n;t++)!0===e.isMesh?e.getVertexPosition(t,yt):yt.fromBufferAttribute(i,t),yt.applyMatrix4(e.matrixWorld),this.expandByPoint(yt);else void 0!==e.boundingBox?(null===e.boundingBox&&e.computeBoundingBox(),Et.copy(e.boundingBox)):(null===n.boundingBox&&n.computeBoundingBox(),Et.copy(n.boundingBox)),Et.applyMatrix4(e.matrixWorld),this.union(Et)}const i=e.children;for(let e=0,n=i.length;e<n;e++)this.expandByObject(i[e],t);return this}containsPoint(e){return!(e.x<this.min.x||e.x>this.max.x||e.y<this.min.y||e.y>this.max.y||e.z<this.min.z||e.z>this.max.z)}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return!(e.max.x<this.min.x||e.min.x>this.max.x||e.max.y<this.min.y||e.min.y>this.max.y||e.max.z<this.min.z||e.min.z>this.max.z)}intersectsSphere(e){return this.clampPoint(e.center,yt),yt.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(Lt),Pt.subVectors(this.max,Lt),Tt.subVectors(e.a,Lt),bt.subVectors(e.b,Lt),wt.subVectors(e.c,Lt),At.subVectors(bt,Tt),Rt.subVectors(wt,bt),Ct.subVectors(Tt,wt);let t=[0,-At.z,At.y,0,-Rt.z,Rt.y,0,-Ct.z,Ct.y,At.z,0,-At.x,Rt.z,0,-Rt.x,Ct.z,0,-Ct.x,-At.y,At.x,0,-Rt.y,Rt.x,0,-Ct.y,Ct.x,0];return!!Nt(t,Tt,bt,wt,Pt)&&(t=[1,0,0,0,1,0,0,0,1],!!Nt(t,Tt,bt,wt,Pt)&&(Ut.crossVectors(At,Rt),t=[Ut.x,Ut.y,Ut.z],Nt(t,Tt,bt,wt,Pt)))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,yt).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=.5*this.getSize(yt).length()),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()||(St[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),St[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),St[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),St[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),St[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),St[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),St[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),St[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(St)),this}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}}const St=[new _t,new _t,new _t,new _t,new _t,new _t,new _t,new _t],yt=new _t,Et=new Mt,Tt=new _t,bt=new _t,wt=new _t,At=new _t,Rt=new _t,Ct=new _t,Lt=new _t,Pt=new _t,Ut=new _t,Dt=new _t;function Nt(e,t,n,i,r){for(let a=0,s=e.length-3;a<=s;a+=3){Dt.fromArray(e,a);const s=r.x*Math.abs(Dt.x)+r.y*Math.abs(Dt.y)+r.z*Math.abs(Dt.z),o=t.dot(Dt),l=n.dot(Dt),c=i.dot(Dt);if(Math.max(-Math.max(o,l,c),Math.min(o,l,c))>s)return!1}return!0}const It=new Mt,Ot=new _t,Ft=new _t;class zt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:-1;this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){const n=this.center;void 0!==t?n.copy(t):It.setFromPoints(e).getCenter(n);let i=0;for(let t=0,r=e.length;t<r;t++)i=Math.max(i,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(i),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){const t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){const n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius=this.radius*e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;Ot.subVectors(e,this.center);const t=Ot.lengthSq();if(t>this.radius*this.radius){const e=Math.sqrt(t),n=.5*(e-this.radius);this.center.addScaledVector(Ot,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(!0===this.center.equals(e.center)?this.radius=Math.max(this.radius,e.radius):(Ft.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(Ot.copy(e.center).add(Ft)),this.expandByPoint(Ot.copy(e.center).sub(Ft))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return(new this.constructor).copy(this)}}const Bt=new _t,Ht=new _t,Vt=new _t,Gt=new _t,kt=new _t,Wt=new _t,Xt=new _t;class jt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t(0,0,-1);this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,Bt)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);const n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){const t=Bt.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(Bt.copy(this.origin).addScaledVector(this.direction,t),Bt.distanceToSquared(e))}distanceSqToSegment(e,t,n,i){Ht.copy(e).add(t).multiplyScalar(.5),Vt.copy(t).sub(e).normalize(),Gt.copy(this.origin).sub(Ht);const r=.5*e.distanceTo(t),a=-this.direction.dot(Vt),s=Gt.dot(this.direction),o=-Gt.dot(Vt),l=Gt.lengthSq(),c=Math.abs(1-a*a);let h,u,d,p;if(c>0)if(h=a*o-s,u=a*s-o,p=r*c,h>=0)if(u>=-p)if(u<=p){const e=1/c;h*=e,u*=e,d=h*(h+a*u+2*s)+u*(a*h+u+2*o)+l}else u=r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;else u=-r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;else u<=-p?(h=Math.max(0,-(-a*r+s)),u=h>0?-r:Math.min(Math.max(-r,-o),r),d=-h*h+u*(u+2*o)+l):u<=p?(h=0,u=Math.min(Math.max(-r,-o),r),d=u*(u+2*o)+l):(h=Math.max(0,-(a*r+s)),u=h>0?r:Math.min(Math.max(-r,-o),r),d=-h*h+u*(u+2*o)+l);else u=a>0?-r:r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;return n&&n.copy(this.origin).addScaledVector(this.direction,h),i&&i.copy(Ht).addScaledVector(Vt,u),d}intersectSphere(e,t){Bt.subVectors(e.center,this.origin);const n=Bt.dot(this.direction),i=Bt.dot(Bt)-n*n,r=e.radius*e.radius;if(i>r)return null;const a=Math.sqrt(r-i),s=n-a,o=n+a;return o<0?null:s<0?this.at(o,t):this.at(s,t)}intersectsSphere(e){return this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){const t=e.normal.dot(this.direction);if(0===t)return 0===e.distanceToPoint(this.origin)?0:null;const n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){const n=this.distanceToPlane(e);return null===n?null:this.at(n,t)}intersectsPlane(e){const t=e.distanceToPoint(this.origin);return 0===t||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,i,r,a,s,o;const l=1/this.direction.x,c=1/this.direction.y,h=1/this.direction.z,u=this.origin;return l>=0?(n=(e.min.x-u.x)*l,i=(e.max.x-u.x)*l):(n=(e.max.x-u.x)*l,i=(e.min.x-u.x)*l),c>=0?(r=(e.min.y-u.y)*c,a=(e.max.y-u.y)*c):(r=(e.max.y-u.y)*c,a=(e.min.y-u.y)*c),n>a||r>i?null:((r>n||isNaN(n))&&(n=r),(a<i||isNaN(i))&&(i=a),h>=0?(s=(e.min.z-u.z)*h,o=(e.max.z-u.z)*h):(s=(e.max.z-u.z)*h,o=(e.min.z-u.z)*h),n>o||s>i?null:((s>n||n!=n)&&(n=s),(o<i||i!=i)&&(i=o),i<0?null:this.at(n>=0?n:i,t)))}intersectsBox(e){return null!==this.intersectBox(e,Bt)}intersectTriangle(e,t,n,i,r){kt.subVectors(t,e),Wt.subVectors(n,e),Xt.crossVectors(kt,Wt);let a,s=this.direction.dot(Xt);if(s>0){if(i)return null;a=1}else{if(!(s<0))return null;a=-1,s=-s}Gt.subVectors(this.origin,e);const o=a*this.direction.dot(Wt.crossVectors(Gt,Wt));if(o<0)return null;const l=a*this.direction.dot(kt.cross(Gt));if(l<0)return null;if(o+l>s)return null;const c=-a*Gt.dot(Xt);return c<0?null:this.at(c/s,r)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return(new this.constructor).copy(this)}}class qt{constructor(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m){qt.prototype.isMatrix4=!0,this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],void 0!==e&&this.set(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m)}set(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m){const g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=i,g[1]=r,g[5]=a,g[9]=s,g[13]=o,g[2]=l,g[6]=c,g[10]=h,g[14]=u,g[3]=d,g[7]=p,g[11]=f,g[15]=m,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return(new qt).fromArray(this.elements)}copy(e){const t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){const t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){const t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){const t=this.elements,n=e.elements,i=1/Yt.setFromMatrixColumn(e,0).length(),r=1/Yt.setFromMatrixColumn(e,1).length(),a=1/Yt.setFromMatrixColumn(e,2).length();return t[0]=n[0]*i,t[1]=n[1]*i,t[2]=n[2]*i,t[3]=0,t[4]=n[4]*r,t[5]=n[5]*r,t[6]=n[6]*r,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){const t=this.elements,n=e.x,i=e.y,r=e.z,a=Math.cos(n),s=Math.sin(n),o=Math.cos(i),l=Math.sin(i),c=Math.cos(r),h=Math.sin(r);if("XYZ"===e.order){const e=a*c,n=a*h,i=s*c,r=s*h;t[0]=o*c,t[4]=-o*h,t[8]=l,t[1]=n+i*l,t[5]=e-r*l,t[9]=-s*o,t[2]=r-e*l,t[6]=i+n*l,t[10]=a*o}else if("YXZ"===e.order){const e=o*c,n=o*h,i=l*c,r=l*h;t[0]=e+r*s,t[4]=i*s-n,t[8]=a*l,t[1]=a*h,t[5]=a*c,t[9]=-s,t[2]=n*s-i,t[6]=r+e*s,t[10]=a*o}else if("ZXY"===e.order){const e=o*c,n=o*h,i=l*c,r=l*h;t[0]=e-r*s,t[4]=-a*h,t[8]=i+n*s,t[1]=n+i*s,t[5]=a*c,t[9]=r-e*s,t[2]=-a*l,t[6]=s,t[10]=a*o}else if("ZYX"===e.order){const e=a*c,n=a*h,i=s*c,r=s*h;t[0]=o*c,t[4]=i*l-n,t[8]=e*l+r,t[1]=o*h,t[5]=r*l+e,t[9]=n*l-i,t[2]=-l,t[6]=s*o,t[10]=a*o}else if("YZX"===e.order){const e=a*o,n=a*l,i=s*o,r=s*l;t[0]=o*c,t[4]=r-e*h,t[8]=i*h+n,t[1]=h,t[5]=a*c,t[9]=-s*c,t[2]=-l*c,t[6]=n*h+i,t[10]=e-r*h}else if("XZY"===e.order){const e=a*o,n=a*l,i=s*o,r=s*l;t[0]=o*c,t[4]=-h,t[8]=l*c,t[1]=e*h+r,t[5]=a*c,t[9]=n*h-i,t[2]=i*h-n,t[6]=s*c,t[10]=r*h+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(Zt,e,Jt)}lookAt(e,t,n){const i=this.elements;return en.subVectors(e,t),0===en.lengthSq()&&(en.z=1),en.normalize(),Qt.crossVectors(n,en),0===Qt.lengthSq()&&(1===Math.abs(n.z)?en.x+=1e-4:en.z+=1e-4,en.normalize(),Qt.crossVectors(n,en)),Qt.normalize(),$t.crossVectors(en,Qt),i[0]=Qt.x,i[4]=$t.x,i[8]=en.x,i[1]=Qt.y,i[5]=$t.y,i[9]=en.y,i[2]=Qt.z,i[6]=$t.z,i[10]=en.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){const n=e.elements,i=t.elements,r=this.elements,a=n[0],s=n[4],o=n[8],l=n[12],c=n[1],h=n[5],u=n[9],d=n[13],p=n[2],f=n[6],m=n[10],g=n[14],_=n[3],v=n[7],x=n[11],M=n[15],S=i[0],y=i[4],E=i[8],T=i[12],b=i[1],w=i[5],A=i[9],R=i[13],C=i[2],L=i[6],P=i[10],U=i[14],D=i[3],N=i[7],I=i[11],O=i[15];return r[0]=a*S+s*b+o*C+l*D,r[4]=a*y+s*w+o*L+l*N,r[8]=a*E+s*A+o*P+l*I,r[12]=a*T+s*R+o*U+l*O,r[1]=c*S+h*b+u*C+d*D,r[5]=c*y+h*w+u*L+d*N,r[9]=c*E+h*A+u*P+d*I,r[13]=c*T+h*R+u*U+d*O,r[2]=p*S+f*b+m*C+g*D,r[6]=p*y+f*w+m*L+g*N,r[10]=p*E+f*A+m*P+g*I,r[14]=p*T+f*R+m*U+g*O,r[3]=_*S+v*b+x*C+M*D,r[7]=_*y+v*w+x*L+M*N,r[11]=_*E+v*A+x*P+M*I,r[15]=_*T+v*R+x*U+M*O,this}multiplyScalar(e){const t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){const e=this.elements,t=e[0],n=e[4],i=e[8],r=e[12],a=e[1],s=e[5],o=e[9],l=e[13],c=e[2],h=e[6],u=e[10],d=e[14];return e[3]*(+r*o*h-i*l*h-r*s*u+n*l*u+i*s*d-n*o*d)+e[7]*(+t*o*d-t*l*u+r*a*u-i*a*d+i*l*c-r*o*c)+e[11]*(+t*l*h-t*s*d-r*a*h+n*a*d+r*s*c-n*l*c)+e[15]*(-i*s*c-t*o*h+t*s*u+i*a*h-n*a*u+n*o*c)}transpose(){const e=this.elements;let t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){const i=this.elements;return e.isVector3?(i[12]=e.x,i[13]=e.y,i[14]=e.z):(i[12]=e,i[13]=t,i[14]=n),this}invert(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8],h=e[9],u=e[10],d=e[11],p=e[12],f=e[13],m=e[14],g=e[15],_=h*m*l-f*u*l+f*o*d-s*m*d-h*o*g+s*u*g,v=p*u*l-c*m*l-p*o*d+a*m*d+c*o*g-a*u*g,x=c*f*l-p*h*l+p*s*d-a*f*d-c*s*g+a*h*g,M=p*h*o-c*f*o-p*s*u+a*f*u+c*s*m-a*h*m,S=t*_+n*v+i*x+r*M;if(0===S)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);const y=1/S;return e[0]=_*y,e[1]=(f*u*r-h*m*r-f*i*d+n*m*d+h*i*g-n*u*g)*y,e[2]=(s*m*r-f*o*r+f*i*l-n*m*l-s*i*g+n*o*g)*y,e[3]=(h*o*r-s*u*r-h*i*l+n*u*l+s*i*d-n*o*d)*y,e[4]=v*y,e[5]=(c*m*r-p*u*r+p*i*d-t*m*d-c*i*g+t*u*g)*y,e[6]=(p*o*r-a*m*r-p*i*l+t*m*l+a*i*g-t*o*g)*y,e[7]=(a*u*r-c*o*r+c*i*l-t*u*l-a*i*d+t*o*d)*y,e[8]=x*y,e[9]=(p*h*r-c*f*r-p*n*d+t*f*d+c*n*g-t*h*g)*y,e[10]=(a*f*r-p*s*r+p*n*l-t*f*l-a*n*g+t*s*g)*y,e[11]=(c*s*r-a*h*r-c*n*l+t*h*l+a*n*d-t*s*d)*y,e[12]=M*y,e[13]=(c*f*i-p*h*i+p*n*u-t*f*u-c*n*m+t*h*m)*y,e[14]=(p*s*i-a*f*i-p*n*o+t*f*o+a*n*m-t*s*m)*y,e[15]=(a*h*i-c*s*i+c*n*o-t*h*o-a*n*u+t*s*u)*y,this}scale(e){const t=this.elements,n=e.x,i=e.y,r=e.z;return t[0]*=n,t[4]*=i,t[8]*=r,t[1]*=n,t[5]*=i,t[9]*=r,t[2]*=n,t[6]*=i,t[10]*=r,t[3]*=n,t[7]*=i,t[11]*=r,this}getMaxScaleOnAxis(){const e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],i=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,i))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){const t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){const n=Math.cos(t),i=Math.sin(t),r=1-n,a=e.x,s=e.y,o=e.z,l=r*a,c=r*s;return this.set(l*a+n,l*s-i*o,l*o+i*s,0,l*s+i*o,c*s+n,c*o-i*a,0,l*o-i*s,c*o+i*a,r*o*o+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,i,r,a){return this.set(1,n,r,0,e,1,a,0,t,i,1,0,0,0,0,1),this}compose(e,t,n){const i=this.elements,r=t._x,a=t._y,s=t._z,o=t._w,l=r+r,c=a+a,h=s+s,u=r*l,d=r*c,p=r*h,f=a*c,m=a*h,g=s*h,_=o*l,v=o*c,x=o*h,M=n.x,S=n.y,y=n.z;return i[0]=(1-(f+g))*M,i[1]=(d+x)*M,i[2]=(p-v)*M,i[3]=0,i[4]=(d-x)*S,i[5]=(1-(u+g))*S,i[6]=(m+_)*S,i[7]=0,i[8]=(p+v)*y,i[9]=(m-_)*y,i[10]=(1-(u+f))*y,i[11]=0,i[12]=e.x,i[13]=e.y,i[14]=e.z,i[15]=1,this}decompose(e,t,n){const i=this.elements;let r=Yt.set(i[0],i[1],i[2]).length();const a=Yt.set(i[4],i[5],i[6]).length(),s=Yt.set(i[8],i[9],i[10]).length();this.determinant()<0&&(r=-r),e.x=i[12],e.y=i[13],e.z=i[14],Kt.copy(this);const o=1/r,l=1/a,c=1/s;return Kt.elements[0]*=o,Kt.elements[1]*=o,Kt.elements[2]*=o,Kt.elements[4]*=l,Kt.elements[5]*=l,Kt.elements[6]*=l,Kt.elements[8]*=c,Kt.elements[9]*=c,Kt.elements[10]*=c,t.setFromRotationMatrix(Kt),n.x=r,n.y=a,n.z=s,this}makePerspective(e,t,n,i,r,a){let s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Le;const o=this.elements,l=2*r/(t-e),c=2*r/(n-i),h=(t+e)/(t-e),u=(n+i)/(n-i);let d,p;if(s===Le)d=-(a+r)/(a-r),p=-2*a*r/(a-r);else{if(s!==Pe)throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: "+s);d=-a/(a-r),p=-a*r/(a-r)}return o[0]=l,o[4]=0,o[8]=h,o[12]=0,o[1]=0,o[5]=c,o[9]=u,o[13]=0,o[2]=0,o[6]=0,o[10]=d,o[14]=p,o[3]=0,o[7]=0,o[11]=-1,o[15]=0,this}makeOrthographic(e,t,n,i,r,a){let s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Le;const o=this.elements,l=1/(t-e),c=1/(n-i),h=1/(a-r),u=(t+e)*l,d=(n+i)*c;let p,f;if(s===Le)p=(a+r)*h,f=-2*h;else{if(s!==Pe)throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: "+s);p=r*h,f=-1*h}return o[0]=2*l,o[4]=0,o[8]=0,o[12]=-u,o[1]=0,o[5]=2*c,o[9]=0,o[13]=-d,o[2]=0,o[6]=0,o[10]=f,o[14]=-p,o[3]=0,o[7]=0,o[11]=0,o[15]=1,this}equals(e){const t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}}const Yt=new _t,Kt=new qt,Zt=new _t(0,0,0),Jt=new _t(1,1,1),Qt=new _t,$t=new _t,en=new _t,tn=new qt,nn=new gt;class rn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:rn.DEFAULT_ORDER;this.isEuler=!0,this._x=e,this._y=t,this._z=n,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:this._order;return this._x=e,this._y=t,this._z=n,this._order=i,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._order,n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];const i=e.elements,r=i[0],a=i[4],s=i[8],o=i[1],l=i[5],c=i[9],h=i[2],u=i[6],d=i[10];switch(t){case"XYZ":this._y=Math.asin(Fe(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-c,d),this._z=Math.atan2(-a,r)):(this._x=Math.atan2(u,l),this._z=0);break;case"YXZ":this._x=Math.asin(-Fe(c,-1,1)),Math.abs(c)<.9999999?(this._y=Math.atan2(s,d),this._z=Math.atan2(o,l)):(this._y=Math.atan2(-h,r),this._z=0);break;case"ZXY":this._x=Math.asin(Fe(u,-1,1)),Math.abs(u)<.9999999?(this._y=Math.atan2(-h,d),this._z=Math.atan2(-a,l)):(this._y=0,this._z=Math.atan2(o,r));break;case"ZYX":this._y=Math.asin(-Fe(h,-1,1)),Math.abs(h)<.9999999?(this._x=Math.atan2(u,d),this._z=Math.atan2(o,r)):(this._x=0,this._z=Math.atan2(-a,l));break;case"YZX":this._z=Math.asin(Fe(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-c,l),this._y=Math.atan2(-h,r)):(this._x=0,this._y=Math.atan2(s,d));break;case"XZY":this._z=Math.asin(-Fe(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(u,l),this._y=Math.atan2(s,r)):(this._x=Math.atan2(-c,d),this._y=0);break;default:console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: "+t)}return this._order=t,!0===n&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return tn.makeRotationFromQuaternion(e),this.setFromRotationMatrix(tn,t,n)}setFromVector3(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._order;return this.set(e.x,e.y,e.z,t)}reorder(e){return nn.setFromEuler(this),this.setFromQuaternion(nn,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],void 0!==e[3]&&(this._order=e[3]),this._onChangeCallback(),this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}}rn.DEFAULT_ORDER="XYZ";class an{constructor(){this.mask=1}set(e){this.mask=1<<e>>>0}enable(e){this.mask|=1<<e}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e}disable(e){this.mask&=~(1<<e)}disableAll(){this.mask=0}test(e){return!!(this.mask&e.mask)}isEnabled(e){return!!(this.mask&1<<e)}}let sn=0;const on=new _t,ln=new gt,cn=new qt,hn=new _t,un=new _t,dn=new _t,pn=new gt,fn=new _t(1,0,0),mn=new _t(0,1,0),gn=new _t(0,0,1),_n={type:"added"},vn={type:"removed"};class xn extends Ue{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,"id",{value:sn++}),this.uuid=Oe(),this.name="",this.type="Object3D",this.parent=null,this.children=[],this.up=xn.DEFAULT_UP.clone();const e=new _t,t=new rn,n=new gt,i=new _t(1,1,1);t._onChange((function(){n.setFromEuler(t,!1)})),n._onChange((function(){t.setFromQuaternion(n,void 0,!1)})),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:e},rotation:{configurable:!0,enumerable:!0,value:t},quaternion:{configurable:!0,enumerable:!0,value:n},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new qt},normalMatrix:{value:new We}}),this.matrix=new qt,this.matrixWorld=new qt,this.matrixAutoUpdate=xn.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.matrixWorldAutoUpdate=xn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.layers=new an,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.userData={}}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return ln.setFromAxisAngle(e,t),this.quaternion.multiply(ln),this}rotateOnWorldAxis(e,t){return ln.setFromAxisAngle(e,t),this.quaternion.premultiply(ln),this}rotateX(e){return this.rotateOnAxis(fn,e)}rotateY(e){return this.rotateOnAxis(mn,e)}rotateZ(e){return this.rotateOnAxis(gn,e)}translateOnAxis(e,t){return on.copy(e).applyQuaternion(this.quaternion),this.position.add(on.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(fn,e)}translateY(e){return this.translateOnAxis(mn,e)}translateZ(e){return this.translateOnAxis(gn,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(cn.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?hn.copy(e):hn.set(e,t,n);const i=this.parent;this.updateWorldMatrix(!0,!1),un.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?cn.lookAt(un,hn,this.up):cn.lookAt(hn,un,this.up),this.quaternion.setFromRotationMatrix(cn),i&&(cn.extractRotation(i.matrixWorld),ln.setFromRotationMatrix(cn),this.quaternion.premultiply(ln.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(console.error("THREE.Object3D.add: object can\'t be added as a child of itself.",e),this):(e&&e.isObject3D?(null!==e.parent&&e.parent.remove(e),e.parent=this,this.children.push(e),e.dispatchEvent(_n)):console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.",e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}const t=this.children.indexOf(e);return-1!==t&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(vn)),this}removeFromParent(){const e=this.parent;return null!==e&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),cn.copy(this.matrixWorld).invert(),null!==e.parent&&(e.parent.updateWorldMatrix(!0,!1),cn.multiply(e.parent.matrixWorld)),e.applyMatrix4(cn),this.add(e),e.updateWorldMatrix(!1,!0),this}getObjectById(e){return this.getObjectByProperty("id",e)}getObjectByName(e){return this.getObjectByProperty("name",e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,i=this.children.length;n<i;n++){const i=this.children[n].getObjectByProperty(e,t);if(void 0!==i)return i}}getObjectsByProperty(e,t){let n=[];this[e]===t&&n.push(this);for(let i=0,r=this.children.length;i<r;i++){const r=this.children[i].getObjectsByProperty(e,t);r.length>0&&(n=n.concat(r))}return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(un,e,dn),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(un,pn,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);const t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}traverse(e){e(this);const t=this.children;for(let n=0,i=t.length;n<i;n++)t[n].traverse(e)}traverseVisible(e){if(!1===this.visible)return;e(this);const t=this.children;for(let n=0,i=t.length;n<i;n++)t[n].traverseVisible(e)}traverseAncestors(e){const t=this.parent;null!==t&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale),this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),this.matrixWorldNeedsUpdate=!1,e=!0);const t=this.children;for(let n=0,i=t.length;n<i;n++){const i=t[n];!0!==i.matrixWorldAutoUpdate&&!0!==e||i.updateMatrixWorld(e)}}updateWorldMatrix(e,t){const n=this.parent;if(!0===e&&null!==n&&!0===n.matrixWorldAutoUpdate&&n.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),!0===t){const e=this.children;for(let t=0,n=e.length;t<n;t++){const n=e[t];!0===n.matrixWorldAutoUpdate&&n.updateWorldMatrix(!1,!0)}}}toJSON(e){const t=void 0===e||"string"==typeof e,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.6,type:"Object",generator:"Object3D.toJSON"});const i={};function r(t,n){return void 0===t[n.uuid]&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(i.uuid=this.uuid,i.type=this.type,""!==this.name&&(i.name=this.name),!0===this.castShadow&&(i.castShadow=!0),!0===this.receiveShadow&&(i.receiveShadow=!0),!1===this.visible&&(i.visible=!1),!1===this.frustumCulled&&(i.frustumCulled=!1),0!==this.renderOrder&&(i.renderOrder=this.renderOrder),Object.keys(this.userData).length>0&&(i.userData=this.userData),i.layers=this.layers.mask,i.matrix=this.matrix.toArray(),i.up=this.up.toArray(),!1===this.matrixAutoUpdate&&(i.matrixAutoUpdate=!1),this.isInstancedMesh&&(i.type="InstancedMesh",i.count=this.count,i.instanceMatrix=this.instanceMatrix.toJSON(),null!==this.instanceColor&&(i.instanceColor=this.instanceColor.toJSON())),this.isScene)this.background&&(this.background.isColor?i.background=this.background.toJSON():this.background.isTexture&&(i.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&!0!==this.environment.isRenderTargetTexture&&(i.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){i.geometry=r(e.geometries,this.geometry);const t=this.geometry.parameters;if(void 0!==t&&void 0!==t.shapes){const n=t.shapes;if(Array.isArray(n))for(let t=0,i=n.length;t<i;t++){const i=n[t];r(e.shapes,i)}else r(e.shapes,n)}}if(this.isSkinnedMesh&&(i.bindMode=this.bindMode,i.bindMatrix=this.bindMatrix.toArray(),void 0!==this.skeleton&&(r(e.skeletons,this.skeleton),i.skeleton=this.skeleton.uuid)),void 0!==this.material)if(Array.isArray(this.material)){const t=[];for(let n=0,i=this.material.length;n<i;n++)t.push(r(e.materials,this.material[n]));i.material=t}else i.material=r(e.materials,this.material);if(this.children.length>0){i.children=[];for(let t=0;t<this.children.length;t++)i.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){i.animations=[];for(let t=0;t<this.animations.length;t++){const n=this.animations[t];i.animations.push(r(e.animations,n))}}if(t){const t=a(e.geometries),i=a(e.materials),r=a(e.textures),s=a(e.images),o=a(e.shapes),l=a(e.skeletons),c=a(e.animations),h=a(e.nodes);t.length>0&&(n.geometries=t),i.length>0&&(n.materials=i),r.length>0&&(n.textures=r),s.length>0&&(n.images=s),o.length>0&&(n.shapes=o),l.length>0&&(n.skeletons=l),c.length>0&&(n.animations=c),h.length>0&&(n.nodes=h)}return n.object=i,n;function a(e){const t=[];for(const n in e){const i=e[n];delete i.metadata,t.push(i)}return t}}clone(e){return(new this.constructor).copy(this,e)}copy(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),!0===t)for(let t=0;t<e.children.length;t++){const n=e.children[t];this.add(n.clone())}return this}}xn.DEFAULT_UP=new _t(0,1,0),xn.DEFAULT_MATRIX_AUTO_UPDATE=!0,xn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;const Mn=new _t,Sn=new _t,yn=new _t,En=new _t,Tn=new _t,bn=new _t,wn=new _t,An=new _t,Rn=new _t,Cn=new _t;let Ln=!1;class Pn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new _t;this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,i){i.subVectors(n,t),Mn.subVectors(e,t),i.cross(Mn);const r=i.lengthSq();return r>0?i.multiplyScalar(1/Math.sqrt(r)):i.set(0,0,0)}static getBarycoord(e,t,n,i,r){Mn.subVectors(i,t),Sn.subVectors(n,t),yn.subVectors(e,t);const a=Mn.dot(Mn),s=Mn.dot(Sn),o=Mn.dot(yn),l=Sn.dot(Sn),c=Sn.dot(yn),h=a*l-s*s;if(0===h)return r.set(-2,-1,-1);const u=1/h,d=(l*o-s*c)*u,p=(a*c-s*o)*u;return r.set(1-d-p,p,d)}static containsPoint(e,t,n,i){return this.getBarycoord(e,t,n,i,En),En.x>=0&&En.y>=0&&En.x+En.y<=1}static getUV(e,t,n,i,r,a,s,o){return!1===Ln&&(console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."),Ln=!0),this.getInterpolation(e,t,n,i,r,a,s,o)}static getInterpolation(e,t,n,i,r,a,s,o){return this.getBarycoord(e,t,n,i,En),o.setScalar(0),o.addScaledVector(r,En.x),o.addScaledVector(a,En.y),o.addScaledVector(s,En.z),o}static isFrontFacing(e,t,n,i){return Mn.subVectors(n,t),Sn.subVectors(e,t),Mn.cross(Sn).dot(i)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,i){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[i]),this}setFromAttributeAndIndices(e,t,n,i){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,i),this}clone(){return(new this.constructor).copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return Mn.subVectors(this.c,this.b),Sn.subVectors(this.a,this.b),.5*Mn.cross(Sn).length()}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(e){return Pn.getNormal(this.a,this.b,this.c,e)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(e,t){return Pn.getBarycoord(e,this.a,this.b,this.c,t)}getUV(e,t,n,i,r){return!1===Ln&&(console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."),Ln=!0),Pn.getInterpolation(e,this.a,this.b,this.c,t,n,i,r)}getInterpolation(e,t,n,i,r){return Pn.getInterpolation(e,this.a,this.b,this.c,t,n,i,r)}containsPoint(e){return Pn.containsPoint(e,this.a,this.b,this.c)}isFrontFacing(e){return Pn.isFrontFacing(this.a,this.b,this.c,e)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){const n=this.a,i=this.b,r=this.c;let a,s;Tn.subVectors(i,n),bn.subVectors(r,n),An.subVectors(e,n);const o=Tn.dot(An),l=bn.dot(An);if(o<=0&&l<=0)return t.copy(n);Rn.subVectors(e,i);const c=Tn.dot(Rn),h=bn.dot(Rn);if(c>=0&&h<=c)return t.copy(i);const u=o*h-c*l;if(u<=0&&o>=0&&c<=0)return a=o/(o-c),t.copy(n).addScaledVector(Tn,a);Cn.subVectors(e,r);const d=Tn.dot(Cn),p=bn.dot(Cn);if(p>=0&&d<=p)return t.copy(r);const f=d*l-o*p;if(f<=0&&l>=0&&p<=0)return s=l/(l-p),t.copy(n).addScaledVector(bn,s);const m=c*p-d*h;if(m<=0&&h-c>=0&&d-p>=0)return wn.subVectors(r,i),s=(h-c)/(h-c+(d-p)),t.copy(i).addScaledVector(wn,s);const g=1/(m+f+u);return a=f*g,s=u*g,t.copy(n).addScaledVector(Tn,a).addScaledVector(bn,s)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}}const Un={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},Dn={h:0,s:0,l:0},Nn={h:0,s:0,l:0};function In(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+6*(t-e)*(2/3-n):e}class On{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(void 0===t&&void 0===n){const t=e;t&&t.isColor?this.copy(t):"number"==typeof t?this.setHex(t):"string"==typeof t&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(255&e)/255,tt.toWorkingColorSpace(this,t),this}setRGB(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:tt.workingColorSpace;return this.r=e,this.g=t,this.b=n,tt.toWorkingColorSpace(this,i),this}setHSL(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:tt.workingColorSpace;if(e=(e%(r=1)+r)%r,t=Fe(t,0,1),n=Fe(n,0,1),0===t)this.r=this.g=this.b=n;else{const i=n<=.5?n*(1+t):n+t-n*t,r=2*n-i;this.r=In(r,i,e+1/3),this.g=In(r,i,e),this.b=In(r,i,e-1/3)}var r;return tt.toWorkingColorSpace(this,i),this}setStyle(e){let t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;function i(t){void 0!==t&&parseFloat(t)<1&&console.warn("THREE.Color: Alpha component of "+e+" will be ignored.")}if(t=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let r;const a=t[1],s=t[2];switch(a){case"rgb":case"rgba":if(r=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setRGB(Math.min(255,parseInt(r[1],10))/255,Math.min(255,parseInt(r[2],10))/255,Math.min(255,parseInt(r[3],10))/255,n);if(r=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setRGB(Math.min(100,parseInt(r[1],10))/100,Math.min(100,parseInt(r[2],10))/100,Math.min(100,parseInt(r[3],10))/100,n);break;case"hsl":case"hsla":if(r=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setHSL(parseFloat(r[1])/360,parseFloat(r[2])/100,parseFloat(r[3])/100,n);break;default:console.warn("THREE.Color: Unknown color model "+e)}}else if(t=/^\\#([A-Fa-f\\d]+)$/.exec(e)){const i=t[1],r=i.length;if(3===r)return this.setRGB(parseInt(i.charAt(0),16)/15,parseInt(i.charAt(1),16)/15,parseInt(i.charAt(2),16)/15,n);if(6===r)return this.setHex(parseInt(i,16),n);console.warn("THREE.Color: Invalid hex color "+e)}else if(e&&e.length>0)return this.setColorName(e,n);return this}setColorName(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;const n=Un[e.toLowerCase()];return void 0!==n?this.setHex(n,t):console.warn("THREE.Color: Unknown color "+e),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=nt(e.r),this.g=nt(e.g),this.b=nt(e.b),this}copyLinearToSRGB(e){return this.r=it(e.r),this.g=it(e.g),this.b=it(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;return tt.fromWorkingColorSpace(Fn.copy(this),e),65536*Math.round(Fe(255*Fn.r,0,255))+256*Math.round(Fe(255*Fn.g,0,255))+Math.round(Fe(255*Fn.b,0,255))}getHexString(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;return("000000"+this.getHex(e).toString(16)).slice(-6)}getHSL(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:tt.workingColorSpace;tt.fromWorkingColorSpace(Fn.copy(this),t);const n=Fn.r,i=Fn.g,r=Fn.b,a=Math.max(n,i,r),s=Math.min(n,i,r);let o,l;const c=(s+a)/2;if(s===a)o=0,l=0;else{const e=a-s;switch(l=c<=.5?e/(a+s):e/(2-a-s),a){case n:o=(i-r)/e+(i<r?6:0);break;case i:o=(r-n)/e+2;break;case r:o=(n-i)/e+4}o/=6}return e.h=o,e.s=l,e.l=c,e}getRGB(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:tt.workingColorSpace;return tt.fromWorkingColorSpace(Fn.copy(this),t),e.r=Fn.r,e.g=Fn.g,e.b=Fn.b,e}getStyle(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;tt.fromWorkingColorSpace(Fn.copy(this),e);const t=Fn.r,n=Fn.g,i=Fn.b;return e!==ue?`color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${i.toFixed(3)})`:`rgb(${Math.round(255*t)},${Math.round(255*n)},${Math.round(255*i)})`}offsetHSL(e,t,n){return this.getHSL(Dn),this.setHSL(Dn.h+e,Dn.s+t,Dn.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(Dn),e.getHSL(Nn);const n=ze(Dn.h,Nn.h,t),i=ze(Dn.s,Nn.s,t),r=ze(Dn.l,Nn.l,t);return this.setHSL(n,i,r),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){const t=this.r,n=this.g,i=this.b,r=e.elements;return this.r=r[0]*t+r[3]*n+r[6]*i,this.g=r[1]*t+r[4]*n+r[7]*i,this.b=r[2]*t+r[5]*n+r[8]*i,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}}const Fn=new On;On.NAMES=Un;let zn=0;class Bn extends Ue{constructor(){super(),this.isMaterial=!0,Object.defineProperty(this,"id",{value:zn++}),this.uuid=Oe(),this.name="",this.type="Material",this.blending=1,this.side=0,this.vertexColors=!1,this.opacity=1,this.transparent=!1,this.alphaHash=!1,this.blendSrc=204,this.blendDst=205,this.blendEquation=o,this.blendSrcAlpha=null,this.blendDstAlpha=null,this.blendEquationAlpha=null,this.blendColor=new On(0,0,0),this.blendAlpha=0,this.depthFunc=3,this.depthTest=!0,this.depthWrite=!0,this.stencilWriteMask=255,this.stencilFunc=519,this.stencilRef=0,this.stencilFuncMask=255,this.stencilFail=xe,this.stencilZFail=xe,this.stencilZPass=xe,this.stencilWrite=!1,this.clippingPlanes=null,this.clipIntersection=!1,this.clipShadows=!1,this.shadowSide=null,this.colorWrite=!0,this.precision=null,this.polygonOffset=!1,this.polygonOffsetFactor=0,this.polygonOffsetUnits=0,this.dithering=!1,this.alphaToCoverage=!1,this.premultipliedAlpha=!1,this.forceSinglePass=!1,this.visible=!0,this.toneMapped=!0,this.userData={},this.version=0,this._alphaTest=0}get alphaTest(){return this._alphaTest}set alphaTest(e){this._alphaTest>0!=e>0&&this.version++,this._alphaTest=e}onBuild(){}onBeforeRender(){}onBeforeCompile(){}customProgramCacheKey(){return this.onBeforeCompile.toString()}setValues(e){if(void 0!==e)for(const t in e){const n=e[t];if(void 0===n){console.warn(`THREE.Material: parameter \'${t}\' has value of undefined.`);continue}const i=this[t];void 0!==i?i&&i.isColor?i.set(n):i&&i.isVector3&&n&&n.isVector3?i.copy(n):this[t]=n:console.warn(`THREE.Material: \'${t}\' is not a property of THREE.${this.type}.`)}}toJSON(e){const t=void 0===e||"string"==typeof e;t&&(e={textures:{},images:{}});const n={metadata:{version:4.6,type:"Material",generator:"Material.toJSON"}};function i(e){const t=[];for(const n in e){const i=e[n];delete i.metadata,t.push(i)}return t}if(n.uuid=this.uuid,n.type=this.type,""!==this.name&&(n.name=this.name),this.color&&this.color.isColor&&(n.color=this.color.getHex()),void 0!==this.roughness&&(n.roughness=this.roughness),void 0!==this.metalness&&(n.metalness=this.metalness),void 0!==this.sheen&&(n.sheen=this.sheen),this.sheenColor&&this.sheenColor.isColor&&(n.sheenColor=this.sheenColor.getHex()),void 0!==this.sheenRoughness&&(n.sheenRoughness=this.sheenRoughness),this.emissive&&this.emissive.isColor&&(n.emissive=this.emissive.getHex()),this.emissiveIntensity&&1!==this.emissiveIntensity&&(n.emissiveIntensity=this.emissiveIntensity),this.specular&&this.specular.isColor&&(n.specular=this.specular.getHex()),void 0!==this.specularIntensity&&(n.specularIntensity=this.specularIntensity),this.specularColor&&this.specularColor.isColor&&(n.specularColor=this.specularColor.getHex()),void 0!==this.shininess&&(n.shininess=this.shininess),void 0!==this.clearcoat&&(n.clearcoat=this.clearcoat),void 0!==this.clearcoatRoughness&&(n.clearcoatRoughness=this.clearcoatRoughness),this.clearcoatMap&&this.clearcoatMap.isTexture&&(n.clearcoatMap=this.clearcoatMap.toJSON(e).uuid),this.clearcoatRoughnessMap&&this.clearcoatRoughnessMap.isTexture&&(n.clearcoatRoughnessMap=this.clearcoatRoughnessMap.toJSON(e).uuid),this.clearcoatNormalMap&&this.clearcoatNormalMap.isTexture&&(n.clearcoatNormalMap=this.clearcoatNormalMap.toJSON(e).uuid,n.clearcoatNormalScale=this.clearcoatNormalScale.toArray()),void 0!==this.iridescence&&(n.iridescence=this.iridescence),void 0!==this.iridescenceIOR&&(n.iridescenceIOR=this.iridescenceIOR),void 0!==this.iridescenceThicknessRange&&(n.iridescenceThicknessRange=this.iridescenceThicknessRange),this.iridescenceMap&&this.iridescenceMap.isTexture&&(n.iridescenceMap=this.iridescenceMap.toJSON(e).uuid),this.iridescenceThicknessMap&&this.iridescenceThicknessMap.isTexture&&(n.iridescenceThicknessMap=this.iridescenceThicknessMap.toJSON(e).uuid),void 0!==this.anisotropy&&(n.anisotropy=this.anisotropy),void 0!==this.anisotropyRotation&&(n.anisotropyRotation=this.anisotropyRotation),this.anisotropyMap&&this.anisotropyMap.isTexture&&(n.anisotropyMap=this.anisotropyMap.toJSON(e).uuid),this.map&&this.map.isTexture&&(n.map=this.map.toJSON(e).uuid),this.matcap&&this.matcap.isTexture&&(n.matcap=this.matcap.toJSON(e).uuid),this.alphaMap&&this.alphaMap.isTexture&&(n.alphaMap=this.alphaMap.toJSON(e).uuid),this.lightMap&&this.lightMap.isTexture&&(n.lightMap=this.lightMap.toJSON(e).uuid,n.lightMapIntensity=this.lightMapIntensity),this.aoMap&&this.aoMap.isTexture&&(n.aoMap=this.aoMap.toJSON(e).uuid,n.aoMapIntensity=this.aoMapIntensity),this.bumpMap&&this.bumpMap.isTexture&&(n.bumpMap=this.bumpMap.toJSON(e).uuid,n.bumpScale=this.bumpScale),this.normalMap&&this.normalMap.isTexture&&(n.normalMap=this.normalMap.toJSON(e).uuid,n.normalMapType=this.normalMapType,n.normalScale=this.normalScale.toArray()),this.displacementMap&&this.displacementMap.isTexture&&(n.displacementMap=this.displacementMap.toJSON(e).uuid,n.displacementScale=this.displacementScale,n.displacementBias=this.displacementBias),this.roughnessMap&&this.roughnessMap.isTexture&&(n.roughnessMap=this.roughnessMap.toJSON(e).uuid),this.metalnessMap&&this.metalnessMap.isTexture&&(n.metalnessMap=this.metalnessMap.toJSON(e).uuid),this.emissiveMap&&this.emissiveMap.isTexture&&(n.emissiveMap=this.emissiveMap.toJSON(e).uuid),this.specularMap&&this.specularMap.isTexture&&(n.specularMap=this.specularMap.toJSON(e).uuid),this.specularIntensityMap&&this.specularIntensityMap.isTexture&&(n.specularIntensityMap=this.specularIntensityMap.toJSON(e).uuid),this.specularColorMap&&this.specularColorMap.isTexture&&(n.specularColorMap=this.specularColorMap.toJSON(e).uuid),this.envMap&&this.envMap.isTexture&&(n.envMap=this.envMap.toJSON(e).uuid,void 0!==this.combine&&(n.combine=this.combine)),void 0!==this.envMapIntensity&&(n.envMapIntensity=this.envMapIntensity),void 0!==this.reflectivity&&(n.reflectivity=this.reflectivity),void 0!==this.refractionRatio&&(n.refractionRatio=this.refractionRatio),this.gradientMap&&this.gradientMap.isTexture&&(n.gradientMap=this.gradientMap.toJSON(e).uuid),void 0!==this.transmission&&(n.transmission=this.transmission),this.transmissionMap&&this.transmissionMap.isTexture&&(n.transmissionMap=this.transmissionMap.toJSON(e).uuid),void 0!==this.thickness&&(n.thickness=this.thickness),this.thicknessMap&&this.thicknessMap.isTexture&&(n.thicknessMap=this.thicknessMap.toJSON(e).uuid),void 0!==this.attenuationDistance&&this.attenuationDistance!==1/0&&(n.attenuationDistance=this.attenuationDistance),void 0!==this.attenuationColor&&(n.attenuationColor=this.attenuationColor.getHex()),void 0!==this.size&&(n.size=this.size),null!==this.shadowSide&&(n.shadowSide=this.shadowSide),void 0!==this.sizeAttenuation&&(n.sizeAttenuation=this.sizeAttenuation),1!==this.blending&&(n.blending=this.blending),0!==this.side&&(n.side=this.side),!0===this.vertexColors&&(n.vertexColors=!0),this.opacity<1&&(n.opacity=this.opacity),!0===this.transparent&&(n.transparent=!0),204!==this.blendSrc&&(n.blendSrc=this.blendSrc),205!==this.blendDst&&(n.blendDst=this.blendDst),this.blendEquation!==o&&(n.blendEquation=this.blendEquation),null!==this.blendSrcAlpha&&(n.blendSrcAlpha=this.blendSrcAlpha),null!==this.blendDstAlpha&&(n.blendDstAlpha=this.blendDstAlpha),null!==this.blendEquationAlpha&&(n.blendEquationAlpha=this.blendEquationAlpha),this.blendColor&&this.blendColor.isColor&&(n.blendColor=this.blendColor.getHex()),0!==this.blendAlpha&&(n.blendAlpha=this.blendAlpha),3!==this.depthFunc&&(n.depthFunc=this.depthFunc),!1===this.depthTest&&(n.depthTest=this.depthTest),!1===this.depthWrite&&(n.depthWrite=this.depthWrite),!1===this.colorWrite&&(n.colorWrite=this.colorWrite),255!==this.stencilWriteMask&&(n.stencilWriteMask=this.stencilWriteMask),519!==this.stencilFunc&&(n.stencilFunc=this.stencilFunc),0!==this.stencilRef&&(n.stencilRef=this.stencilRef),255!==this.stencilFuncMask&&(n.stencilFuncMask=this.stencilFuncMask),this.stencilFail!==xe&&(n.stencilFail=this.stencilFail),this.stencilZFail!==xe&&(n.stencilZFail=this.stencilZFail),this.stencilZPass!==xe&&(n.stencilZPass=this.stencilZPass),!0===this.stencilWrite&&(n.stencilWrite=this.stencilWrite),void 0!==this.rotation&&0!==this.rotation&&(n.rotation=this.rotation),!0===this.polygonOffset&&(n.polygonOffset=!0),0!==this.polygonOffsetFactor&&(n.polygonOffsetFactor=this.polygonOffsetFactor),0!==this.polygonOffsetUnits&&(n.polygonOffsetUnits=this.polygonOffsetUnits),void 0!==this.linewidth&&1!==this.linewidth&&(n.linewidth=this.linewidth),void 0!==this.dashSize&&(n.dashSize=this.dashSize),void 0!==this.gapSize&&(n.gapSize=this.gapSize),void 0!==this.scale&&(n.scale=this.scale),!0===this.dithering&&(n.dithering=!0),this.alphaTest>0&&(n.alphaTest=this.alphaTest),!0===this.alphaHash&&(n.alphaHash=!0),!0===this.alphaToCoverage&&(n.alphaToCoverage=!0),!0===this.premultipliedAlpha&&(n.premultipliedAlpha=!0),!0===this.forceSinglePass&&(n.forceSinglePass=!0),!0===this.wireframe&&(n.wireframe=!0),this.wireframeLinewidth>1&&(n.wireframeLinewidth=this.wireframeLinewidth),"round"!==this.wireframeLinecap&&(n.wireframeLinecap=this.wireframeLinecap),"round"!==this.wireframeLinejoin&&(n.wireframeLinejoin=this.wireframeLinejoin),!0===this.flatShading&&(n.flatShading=!0),!1===this.visible&&(n.visible=!1),!1===this.toneMapped&&(n.toneMapped=!1),!1===this.fog&&(n.fog=!1),Object.keys(this.userData).length>0&&(n.userData=this.userData),t){const t=i(e.textures),r=i(e.images);t.length>0&&(n.textures=t),r.length>0&&(n.images=r)}return n}clone(){return(new this.constructor).copy(this)}copy(e){this.name=e.name,this.blending=e.blending,this.side=e.side,this.vertexColors=e.vertexColors,this.opacity=e.opacity,this.transparent=e.transparent,this.blendSrc=e.blendSrc,this.blendDst=e.blendDst,this.blendEquation=e.blendEquation,this.blendSrcAlpha=e.blendSrcAlpha,this.blendDstAlpha=e.blendDstAlpha,this.blendEquationAlpha=e.blendEquationAlpha,this.blendColor.copy(e.blendColor),this.blendAlpha=e.blendAlpha,this.depthFunc=e.depthFunc,this.depthTest=e.depthTest,this.depthWrite=e.depthWrite,this.stencilWriteMask=e.stencilWriteMask,this.stencilFunc=e.stencilFunc,this.stencilRef=e.stencilRef,this.stencilFuncMask=e.stencilFuncMask,this.stencilFail=e.stencilFail,this.stencilZFail=e.stencilZFail,this.stencilZPass=e.stencilZPass,this.stencilWrite=e.stencilWrite;const t=e.clippingPlanes;let n=null;if(null!==t){const e=t.length;n=new Array(e);for(let i=0;i!==e;++i)n[i]=t[i].clone()}return this.clippingPlanes=n,this.clipIntersection=e.clipIntersection,this.clipShadows=e.clipShadows,this.shadowSide=e.shadowSide,this.colorWrite=e.colorWrite,this.precision=e.precision,this.polygonOffset=e.polygonOffset,this.polygonOffsetFactor=e.polygonOffsetFactor,this.polygonOffsetUnits=e.polygonOffsetUnits,this.dithering=e.dithering,this.alphaTest=e.alphaTest,this.alphaHash=e.alphaHash,this.alphaToCoverage=e.alphaToCoverage,this.premultipliedAlpha=e.premultipliedAlpha,this.forceSinglePass=e.forceSinglePass,this.visible=e.visible,this.toneMapped=e.toneMapped,this.userData=JSON.parse(JSON.stringify(e.userData)),this}dispose(){this.dispatchEvent({type:"dispose"})}set needsUpdate(e){!0===e&&this.version++}}class Hn extends Bn{constructor(e){super(),this.isMeshBasicMaterial=!0,this.type="MeshBasicMaterial",this.color=new On(16777215),this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.combine=b,this.reflectivity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap="round",this.wireframeLinejoin="round",this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.combine=e.combine,this.reflectivity=e.reflectivity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.fog=e.fog,this}}const Vn=Gn();function Gn(){const e=new ArrayBuffer(4),t=new Float32Array(e),n=new Uint32Array(e),i=new Uint32Array(512),r=new Uint32Array(512);for(let e=0;e<256;++e){const t=e-127;t<-27?(i[e]=0,i[256|e]=32768,r[e]=24,r[256|e]=24):t<-14?(i[e]=1024>>-t-14,i[256|e]=1024>>-t-14|32768,r[e]=-t-1,r[256|e]=-t-1):t<=15?(i[e]=t+15<<10,i[256|e]=t+15<<10|32768,r[e]=13,r[256|e]=13):t<128?(i[e]=31744,i[256|e]=64512,r[e]=24,r[256|e]=24):(i[e]=31744,i[256|e]=64512,r[e]=13,r[256|e]=13)}const a=new Uint32Array(2048),s=new Uint32Array(64),o=new Uint32Array(64);for(let e=1;e<1024;++e){let t=e<<13,n=0;for(;!(8388608&t);)t<<=1,n-=8388608;t&=-8388609,n+=947912704,a[e]=t|n}for(let e=1024;e<2048;++e)a[e]=939524096+(e-1024<<13);for(let e=1;e<31;++e)s[e]=e<<23;s[31]=1199570944,s[32]=2147483648;for(let e=33;e<63;++e)s[e]=2147483648+(e-32<<23);s[63]=3347054592;for(let e=1;e<64;++e)32!==e&&(o[e]=1024);return{floatView:t,uint32View:n,baseTable:i,shiftTable:r,mantissaTable:a,exponentTable:s,offsetTable:o}}const kn={toHalfFloat:function(e){Math.abs(e)>65504&&console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."),e=Fe(e,-65504,65504),Vn.floatView[0]=e;const t=Vn.uint32View[0],n=t>>23&511;return Vn.baseTable[n]+((8388607&t)>>Vn.shiftTable[n])},fromHalfFloat:function(e){const t=e>>10;return Vn.uint32View[0]=Vn.mantissaTable[Vn.offsetTable[t]+(1023&e)]+Vn.exponentTable[t],Vn.floatView[0]}},Wn=new _t,Xn=new ke;class jn{constructor(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(Array.isArray(e))throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");this.isBufferAttribute=!0,this.name="",this.array=e,this.itemSize=t,this.count=void 0!==e?e.length/t:0,this.normalized=n,this.usage=35044,this.updateRange={offset:0,count:-1},this.gpuType=K,this.version=0}onUploadCallback(){}set needsUpdate(e){!0===e&&this.version++}setUsage(e){return this.usage=e,this}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let i=0,r=this.itemSize;i<r;i++)this.array[e+i]=t.array[n+i];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(2===this.itemSize)for(let t=0,n=this.count;t<n;t++)Xn.fromBufferAttribute(this,t),Xn.applyMatrix3(e),this.setXY(t,Xn.x,Xn.y);else if(3===this.itemSize)for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyMatrix3(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyMatrix4(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyNormalMatrix(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.transformDirection(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}set(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=Ve(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=Ge(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=Ve(t,this.array)),t}setX(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=Ve(t,this.array)),t}setY(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=Ve(t,this.array)),t}setZ(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=Ve(t,this.array)),t}setW(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,i){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array),i=Ge(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=i,this}setXYZW(e,t,n,i,r){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array),i=Ge(i,this.array),r=Ge(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=i,this.array[e+3]=r,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){const e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return""!==this.name&&(e.name=this.name),35044!==this.usage&&(e.usage=this.usage),0===this.updateRange.offset&&-1===this.updateRange.count||(e.updateRange=this.updateRange),e}}class qn extends jn{constructor(e,t,n){super(new Uint16Array(e),t,n)}}class Yn extends jn{constructor(e,t,n){super(new Uint32Array(e),t,n)}}class Kn extends jn{constructor(e,t,n){super(new Float32Array(e),t,n)}}let Zn=0;const Jn=new qt,Qn=new xn,$n=new _t,ei=new Mt,ti=new Mt,ni=new _t;class ii extends Ue{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,"id",{value:Zn++}),this.uuid=Oe(),this.name="",this.type="BufferGeometry",this.index=null,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={}}getIndex(){return this.index}setIndex(e){return Array.isArray(e)?this.index=new(je(e)?Yn:qn)(e,1):this.index=e,this}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return void 0!==this.attributes[e]}addGroup(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){const t=this.attributes.position;void 0!==t&&(t.applyMatrix4(e),t.needsUpdate=!0);const n=this.attributes.normal;if(void 0!==n){const t=(new We).getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}const i=this.attributes.tangent;return void 0!==i&&(i.transformDirection(e),i.needsUpdate=!0),null!==this.boundingBox&&this.computeBoundingBox(),null!==this.boundingSphere&&this.computeBoundingSphere(),this}applyQuaternion(e){return Jn.makeRotationFromQuaternion(e),this.applyMatrix4(Jn),this}rotateX(e){return Jn.makeRotationX(e),this.applyMatrix4(Jn),this}rotateY(e){return Jn.makeRotationY(e),this.applyMatrix4(Jn),this}rotateZ(e){return Jn.makeRotationZ(e),this.applyMatrix4(Jn),this}translate(e,t,n){return Jn.makeTranslation(e,t,n),this.applyMatrix4(Jn),this}scale(e,t,n){return Jn.makeScale(e,t,n),this.applyMatrix4(Jn),this}lookAt(e){return Qn.lookAt(e),Qn.updateMatrix(),this.applyMatrix4(Qn.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter($n).negate(),this.translate($n.x,$n.y,$n.z),this}setFromPoints(e){const t=[];for(let n=0,i=e.length;n<i;n++){const i=e[n];t.push(i.x,i.y,i.z||0)}return this.setAttribute("position",new Kn(t,3)),this}computeBoundingBox(){null===this.boundingBox&&(this.boundingBox=new Mt);const e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute)return console.error(\'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".\',this),void this.boundingBox.set(new _t(-1/0,-1/0,-1/0),new _t(1/0,1/0,1/0));if(void 0!==e){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){const n=t[e];ei.setFromBufferAttribute(n),this.morphTargetsRelative?(ni.addVectors(this.boundingBox.min,ei.min),this.boundingBox.expandByPoint(ni),ni.addVectors(this.boundingBox.max,ei.max),this.boundingBox.expandByPoint(ni)):(this.boundingBox.expandByPoint(ei.min),this.boundingBox.expandByPoint(ei.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&console.error(\'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.\',this)}computeBoundingSphere(){null===this.boundingSphere&&(this.boundingSphere=new zt);const e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute)return console.error(\'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".\',this),void this.boundingSphere.set(new _t,1/0);if(e){const n=this.boundingSphere.center;if(ei.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){const n=t[e];ti.setFromBufferAttribute(n),this.morphTargetsRelative?(ni.addVectors(ei.min,ti.min),ei.expandByPoint(ni),ni.addVectors(ei.max,ti.max),ei.expandByPoint(ni)):(ei.expandByPoint(ti.min),ei.expandByPoint(ti.max))}ei.getCenter(n);let i=0;for(let t=0,r=e.count;t<r;t++)ni.fromBufferAttribute(e,t),i=Math.max(i,n.distanceToSquared(ni));if(t)for(let r=0,a=t.length;r<a;r++){const a=t[r],s=this.morphTargetsRelative;for(let t=0,r=a.count;t<r;t++)ni.fromBufferAttribute(a,t),s&&($n.fromBufferAttribute(e,t),ni.add($n)),i=Math.max(i,n.distanceToSquared(ni))}this.boundingSphere.radius=Math.sqrt(i),isNaN(this.boundingSphere.radius)&&console.error(\'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.\',this)}}computeTangents(){const e=this.index,t=this.attributes;if(null===e||void 0===t.position||void 0===t.normal||void 0===t.uv)return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");const n=e.array,i=t.position.array,r=t.normal.array,a=t.uv.array,s=i.length/3;!1===this.hasAttribute("tangent")&&this.setAttribute("tangent",new jn(new Float32Array(4*s),4));const o=this.getAttribute("tangent").array,l=[],c=[];for(let e=0;e<s;e++)l[e]=new _t,c[e]=new _t;const h=new _t,u=new _t,d=new _t,p=new ke,f=new ke,m=new ke,g=new _t,_=new _t;function v(e,t,n){h.fromArray(i,3*e),u.fromArray(i,3*t),d.fromArray(i,3*n),p.fromArray(a,2*e),f.fromArray(a,2*t),m.fromArray(a,2*n),u.sub(h),d.sub(h),f.sub(p),m.sub(p);const r=1/(f.x*m.y-m.x*f.y);isFinite(r)&&(g.copy(u).multiplyScalar(m.y).addScaledVector(d,-f.y).multiplyScalar(r),_.copy(d).multiplyScalar(f.x).addScaledVector(u,-m.x).multiplyScalar(r),l[e].add(g),l[t].add(g),l[n].add(g),c[e].add(_),c[t].add(_),c[n].add(_))}let x=this.groups;0===x.length&&(x=[{start:0,count:n.length}]);for(let e=0,t=x.length;e<t;++e){const t=x[e],i=t.start;for(let e=i,r=i+t.count;e<r;e+=3)v(n[e+0],n[e+1],n[e+2])}const M=new _t,S=new _t,y=new _t,E=new _t;function T(e){y.fromArray(r,3*e),E.copy(y);const t=l[e];M.copy(t),M.sub(y.multiplyScalar(y.dot(t))).normalize(),S.crossVectors(E,t);const n=S.dot(c[e])<0?-1:1;o[4*e]=M.x,o[4*e+1]=M.y,o[4*e+2]=M.z,o[4*e+3]=n}for(let e=0,t=x.length;e<t;++e){const t=x[e],i=t.start;for(let e=i,r=i+t.count;e<r;e+=3)T(n[e+0]),T(n[e+1]),T(n[e+2])}}computeVertexNormals(){const e=this.index,t=this.getAttribute("position");if(void 0!==t){let n=this.getAttribute("normal");if(void 0===n)n=new jn(new Float32Array(3*t.count),3),this.setAttribute("normal",n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);const i=new _t,r=new _t,a=new _t,s=new _t,o=new _t,l=new _t,c=new _t,h=new _t;if(e)for(let u=0,d=e.count;u<d;u+=3){const d=e.getX(u+0),p=e.getX(u+1),f=e.getX(u+2);i.fromBufferAttribute(t,d),r.fromBufferAttribute(t,p),a.fromBufferAttribute(t,f),c.subVectors(a,r),h.subVectors(i,r),c.cross(h),s.fromBufferAttribute(n,d),o.fromBufferAttribute(n,p),l.fromBufferAttribute(n,f),s.add(c),o.add(c),l.add(c),n.setXYZ(d,s.x,s.y,s.z),n.setXYZ(p,o.x,o.y,o.z),n.setXYZ(f,l.x,l.y,l.z)}else for(let e=0,s=t.count;e<s;e+=3)i.fromBufferAttribute(t,e+0),r.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),c.subVectors(a,r),h.subVectors(i,r),c.cross(h),n.setXYZ(e+0,c.x,c.y,c.z),n.setXYZ(e+1,c.x,c.y,c.z),n.setXYZ(e+2,c.x,c.y,c.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){const e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)ni.fromBufferAttribute(e,t),ni.normalize(),e.setXYZ(t,ni.x,ni.y,ni.z)}toNonIndexed(){function e(e,t){const n=e.array,i=e.itemSize,r=e.normalized,a=new n.constructor(t.length*i);let s=0,o=0;for(let r=0,l=t.length;r<l;r++){s=e.isInterleavedBufferAttribute?t[r]*e.data.stride+e.offset:t[r]*i;for(let e=0;e<i;e++)a[o++]=n[s++]}return new jn(a,i,r)}if(null===this.index)return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."),this;const t=new ii,n=this.index.array,i=this.attributes;for(const r in i){const a=e(i[r],n);t.setAttribute(r,a)}const r=this.morphAttributes;for(const i in r){const a=[],s=r[i];for(let t=0,i=s.length;t<i;t++){const i=e(s[t],n);a.push(i)}t.morphAttributes[i]=a}t.morphTargetsRelative=this.morphTargetsRelative;const a=this.groups;for(let e=0,n=a.length;e<n;e++){const n=a[e];t.addGroup(n.start,n.count,n.materialIndex)}return t}toJSON(){const e={metadata:{version:4.6,type:"BufferGeometry",generator:"BufferGeometry.toJSON"}};if(e.uuid=this.uuid,e.type=this.type,""!==this.name&&(e.name=this.name),Object.keys(this.userData).length>0&&(e.userData=this.userData),void 0!==this.parameters){const t=this.parameters;for(const n in t)void 0!==t[n]&&(e[n]=t[n]);return e}e.data={attributes:{}};const t=this.index;null!==t&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});const n=this.attributes;for(const t in n){const i=n[t];e.data.attributes[t]=i.toJSON(e.data)}const i={};let r=!1;for(const t in this.morphAttributes){const n=this.morphAttributes[t],a=[];for(let t=0,i=n.length;t<i;t++){const i=n[t];a.push(i.toJSON(e.data))}a.length>0&&(i[t]=a,r=!0)}r&&(e.data.morphAttributes=i,e.data.morphTargetsRelative=this.morphTargetsRelative);const a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));const s=this.boundingSphere;return null!==s&&(e.data.boundingSphere={center:s.center.toArray(),radius:s.radius}),e}clone(){return(new this.constructor).copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;const t={};this.name=e.name;const n=e.index;null!==n&&this.setIndex(n.clone(t));const i=e.attributes;for(const e in i){const n=i[e];this.setAttribute(e,n.clone(t))}const r=e.morphAttributes;for(const e in r){const n=[],i=r[e];for(let e=0,r=i.length;e<r;e++)n.push(i[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;const a=e.groups;for(let e=0,t=a.length;e<t;e++){const t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}const s=e.boundingBox;null!==s&&(this.boundingBox=s.clone());const o=e.boundingSphere;return null!==o&&(this.boundingSphere=o.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this}dispose(){this.dispatchEvent({type:"dispose"})}}const ri=new qt,ai=new jt,si=new zt,oi=new _t,li=new _t,ci=new _t,hi=new _t,ui=new _t,di=new _t,pi=new ke,fi=new ke,mi=new ke,gi=new _t,_i=new _t,vi=new _t,xi=new _t,Mi=new _t;class Si extends xn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new ii,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new Hn;super(),this.isMesh=!0,this.type="Mesh",this.geometry=e,this.material=t,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),void 0!==e.morphTargetInfluences&&(this.morphTargetInfluences=e.morphTargetInfluences.slice()),void 0!==e.morphTargetDictionary&&(this.morphTargetDictionary=Object.assign({},e.morphTargetDictionary)),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}updateMorphTargets(){const e=this.geometry.morphAttributes,t=Object.keys(e);if(t.length>0){const n=e[t[0]];if(void 0!==n){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=n.length;e<t;e++){const t=n[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[t]=e}}}}getVertexPosition(e,t){const n=this.geometry,i=n.attributes.position,r=n.morphAttributes.position,a=n.morphTargetsRelative;t.fromBufferAttribute(i,e);const s=this.morphTargetInfluences;if(r&&s){di.set(0,0,0);for(let n=0,i=r.length;n<i;n++){const i=s[n],o=r[n];0!==i&&(ui.fromBufferAttribute(o,e),a?di.addScaledVector(ui,i):di.addScaledVector(ui.sub(t),i))}t.add(di)}return t}raycast(e,t){const n=this.geometry,i=this.material,r=this.matrixWorld;if(void 0!==i){if(null===n.boundingSphere&&n.computeBoundingSphere(),si.copy(n.boundingSphere),si.applyMatrix4(r),ai.copy(e.ray).recast(e.near),!1===si.containsPoint(ai.origin)){if(null===ai.intersectSphere(si,oi))return;if(ai.origin.distanceToSquared(oi)>(e.far-e.near)**2)return}ri.copy(r).invert(),ai.copy(e.ray).applyMatrix4(ri),null!==n.boundingBox&&!1===ai.intersectsBox(n.boundingBox)||this._computeIntersections(e,t,ai)}}_computeIntersections(e,t,n){let i;const r=this.geometry,a=this.material,s=r.index,o=r.attributes.position,l=r.attributes.uv,c=r.attributes.uv1,h=r.attributes.normal,u=r.groups,d=r.drawRange;if(null!==s)if(Array.isArray(a))for(let r=0,o=u.length;r<o;r++){const o=u[r],p=a[o.materialIndex];for(let r=Math.max(o.start,d.start),a=Math.min(s.count,Math.min(o.start+o.count,d.start+d.count));r<a;r+=3)i=yi(this,p,e,n,l,c,h,s.getX(r),s.getX(r+1),s.getX(r+2)),i&&(i.faceIndex=Math.floor(r/3),i.face.materialIndex=o.materialIndex,t.push(i))}else for(let r=Math.max(0,d.start),o=Math.min(s.count,d.start+d.count);r<o;r+=3)i=yi(this,a,e,n,l,c,h,s.getX(r),s.getX(r+1),s.getX(r+2)),i&&(i.faceIndex=Math.floor(r/3),t.push(i));else if(void 0!==o)if(Array.isArray(a))for(let r=0,s=u.length;r<s;r++){const s=u[r],p=a[s.materialIndex];for(let r=Math.max(s.start,d.start),a=Math.min(o.count,Math.min(s.start+s.count,d.start+d.count));r<a;r+=3)i=yi(this,p,e,n,l,c,h,r,r+1,r+2),i&&(i.faceIndex=Math.floor(r/3),i.face.materialIndex=s.materialIndex,t.push(i))}else for(let r=Math.max(0,d.start),s=Math.min(o.count,d.start+d.count);r<s;r+=3)i=yi(this,a,e,n,l,c,h,r,r+1,r+2),i&&(i.faceIndex=Math.floor(r/3),t.push(i))}}function yi(e,t,n,i,r,a,s,o,l,c){e.getVertexPosition(o,li),e.getVertexPosition(l,ci),e.getVertexPosition(c,hi);const h=function(e,t,n,i,r,a,s,o){let l;if(l=1===t.side?i.intersectTriangle(s,a,r,!0,o):i.intersectTriangle(r,a,s,0===t.side,o),null===l)return null;Mi.copy(o),Mi.applyMatrix4(e.matrixWorld);const c=n.ray.origin.distanceTo(Mi);return c<n.near||c>n.far?null:{distance:c,point:Mi.clone(),object:e}}(e,t,n,i,li,ci,hi,xi);if(h){r&&(pi.fromBufferAttribute(r,o),fi.fromBufferAttribute(r,l),mi.fromBufferAttribute(r,c),h.uv=Pn.getInterpolation(xi,li,ci,hi,pi,fi,mi,new ke)),a&&(pi.fromBufferAttribute(a,o),fi.fromBufferAttribute(a,l),mi.fromBufferAttribute(a,c),h.uv1=Pn.getInterpolation(xi,li,ci,hi,pi,fi,mi,new ke),h.uv2=h.uv1),s&&(gi.fromBufferAttribute(s,o),_i.fromBufferAttribute(s,l),vi.fromBufferAttribute(s,c),h.normal=Pn.getInterpolation(xi,li,ci,hi,gi,_i,vi,new _t),h.normal.dot(i.direction)>0&&h.normal.multiplyScalar(-1));const e={a:o,b:l,c,normal:new _t,materialIndex:0};Pn.getNormal(li,ci,hi,e.normal),h.face=e}return h}class Ei extends ii{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:1;super(),this.type="BoxGeometry",this.parameters={width:e,height:t,depth:n,widthSegments:i,heightSegments:r,depthSegments:a};const s=this;i=Math.floor(i),r=Math.floor(r),a=Math.floor(a);const o=[],l=[],c=[],h=[];let u=0,d=0;function p(e,t,n,i,r,a,p,f,m,g,_){const v=a/m,x=p/g,M=a/2,S=p/2,y=f/2,E=m+1,T=g+1;let b=0,w=0;const A=new _t;for(let a=0;a<T;a++){const s=a*x-S;for(let o=0;o<E;o++){const u=o*v-M;A[e]=u*i,A[t]=s*r,A[n]=y,l.push(A.x,A.y,A.z),A[e]=0,A[t]=0,A[n]=f>0?1:-1,c.push(A.x,A.y,A.z),h.push(o/m),h.push(1-a/g),b+=1}}for(let e=0;e<g;e++)for(let t=0;t<m;t++){const n=u+t+E*e,i=u+t+E*(e+1),r=u+(t+1)+E*(e+1),a=u+(t+1)+E*e;o.push(n,i,a),o.push(i,r,a),w+=6}s.addGroup(d,w,_),d+=w,u+=b}p("z","y","x",-1,-1,n,t,e,a,r,0),p("z","y","x",1,-1,n,t,-e,a,r,1),p("x","z","y",1,1,e,n,t,i,a,2),p("x","z","y",1,-1,e,n,-t,i,a,3),p("x","y","z",1,-1,e,t,n,i,r,4),p("x","y","z",-1,-1,e,t,-n,i,r,5),this.setIndex(o),this.setAttribute("position",new Kn(l,3)),this.setAttribute("normal",new Kn(c,3)),this.setAttribute("uv",new Kn(h,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Ei(e.width,e.height,e.depth,e.widthSegments,e.heightSegments,e.depthSegments)}}function Ti(e){const t={};for(const n in e){t[n]={};for(const i in e[n]){const r=e[n][i];r&&(r.isColor||r.isMatrix3||r.isMatrix4||r.isVector2||r.isVector3||r.isVector4||r.isTexture||r.isQuaternion)?r.isRenderTargetTexture?(console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."),t[n][i]=null):t[n][i]=r.clone():Array.isArray(r)?t[n][i]=r.slice():t[n][i]=r}}return t}function bi(e){const t={};for(let n=0;n<e.length;n++){const i=Ti(e[n]);for(const e in i)t[e]=i[e]}return t}function wi(e){return null===e.getRenderTarget()?e.outputColorSpace:tt.workingColorSpace}const Ai={clone:Ti,merge:bi};class Ri extends Bn{constructor(e){super(),this.isShaderMaterial=!0,this.type="ShaderMaterial",this.defines={},this.uniforms={},this.uniformsGroups=[],this.vertexShader="void main() {\\n\\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\\n}",this.fragmentShader="void main() {\\n\\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\\n}",this.linewidth=1,this.wireframe=!1,this.wireframeLinewidth=1,this.fog=!1,this.lights=!1,this.clipping=!1,this.forceSinglePass=!0,this.extensions={derivatives:!1,fragDepth:!1,drawBuffers:!1,shaderTextureLOD:!1},this.defaultAttributeValues={color:[1,1,1],uv:[0,0],uv1:[0,0]},this.index0AttributeName=void 0,this.uniformsNeedUpdate=!1,this.glslVersion=null,void 0!==e&&this.setValues(e)}copy(e){return super.copy(e),this.fragmentShader=e.fragmentShader,this.vertexShader=e.vertexShader,this.uniforms=Ti(e.uniforms),this.uniformsGroups=function(e){const t=[];for(let n=0;n<e.length;n++)t.push(e[n].clone());return t}(e.uniformsGroups),this.defines=Object.assign({},e.defines),this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.fog=e.fog,this.lights=e.lights,this.clipping=e.clipping,this.extensions=Object.assign({},e.extensions),this.glslVersion=e.glslVersion,this}toJSON(e){const t=super.toJSON(e);t.glslVersion=this.glslVersion,t.uniforms={};for(const n in this.uniforms){const i=this.uniforms[n].value;i&&i.isTexture?t.uniforms[n]={type:"t",value:i.toJSON(e).uuid}:i&&i.isColor?t.uniforms[n]={type:"c",value:i.getHex()}:i&&i.isVector2?t.uniforms[n]={type:"v2",value:i.toArray()}:i&&i.isVector3?t.uniforms[n]={type:"v3",value:i.toArray()}:i&&i.isVector4?t.uniforms[n]={type:"v4",value:i.toArray()}:i&&i.isMatrix3?t.uniforms[n]={type:"m3",value:i.toArray()}:i&&i.isMatrix4?t.uniforms[n]={type:"m4",value:i.toArray()}:t.uniforms[n]={value:i}}Object.keys(this.defines).length>0&&(t.defines=this.defines),t.vertexShader=this.vertexShader,t.fragmentShader=this.fragmentShader,t.lights=this.lights,t.clipping=this.clipping;const n={};for(const e in this.extensions)!0===this.extensions[e]&&(n[e]=!0);return Object.keys(n).length>0&&(t.extensions=n),t}}class Ci extends xn{constructor(){super(),this.isCamera=!0,this.type="Camera",this.matrixWorldInverse=new qt,this.projectionMatrix=new qt,this.projectionMatrixInverse=new qt,this.coordinateSystem=Le}copy(e,t){return super.copy(e,t),this.matrixWorldInverse.copy(e.matrixWorldInverse),this.projectionMatrix.copy(e.projectionMatrix),this.projectionMatrixInverse.copy(e.projectionMatrixInverse),this.coordinateSystem=e.coordinateSystem,this}getWorldDirection(e){return super.getWorldDirection(e).negate()}updateMatrixWorld(e){super.updateMatrixWorld(e),this.matrixWorldInverse.copy(this.matrixWorld).invert()}updateWorldMatrix(e,t){super.updateWorldMatrix(e,t),this.matrixWorldInverse.copy(this.matrixWorld).invert()}clone(){return(new this.constructor).copy(this)}}class Li extends Ci{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:50,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2e3;super(),this.isPerspectiveCamera=!0,this.type="PerspectiveCamera",this.fov=e,this.zoom=1,this.near=n,this.far=i,this.focus=10,this.aspect=t,this.view=null,this.filmGauge=35,this.filmOffset=0,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.fov=e.fov,this.zoom=e.zoom,this.near=e.near,this.far=e.far,this.focus=e.focus,this.aspect=e.aspect,this.view=null===e.view?null:Object.assign({},e.view),this.filmGauge=e.filmGauge,this.filmOffset=e.filmOffset,this}setFocalLength(e){const t=.5*this.getFilmHeight()/e;this.fov=2*Ie*Math.atan(t),this.updateProjectionMatrix()}getFocalLength(){const e=Math.tan(.5*Ne*this.fov);return.5*this.getFilmHeight()/e}getEffectiveFOV(){return 2*Ie*Math.atan(Math.tan(.5*Ne*this.fov)/this.zoom)}getFilmWidth(){return this.filmGauge*Math.min(this.aspect,1)}getFilmHeight(){return this.filmGauge/Math.max(this.aspect,1)}setViewOffset(e,t,n,i,r,a){this.aspect=e/t,null===this.view&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=i,this.view.width=r,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){null!==this.view&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){const e=this.near;let t=e*Math.tan(.5*Ne*this.fov)/this.zoom,n=2*t,i=this.aspect*n,r=-.5*i;const a=this.view;if(null!==this.view&&this.view.enabled){const e=a.fullWidth,s=a.fullHeight;r+=a.offsetX*i/e,t-=a.offsetY*n/s,i*=a.width/e,n*=a.height/s}const s=this.filmOffset;0!==s&&(r+=e*s/this.getFilmWidth()),this.projectionMatrix.makePerspective(r,r+i,t,t-n,e,this.far,this.coordinateSystem),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){const t=super.toJSON(e);return t.object.fov=this.fov,t.object.zoom=this.zoom,t.object.near=this.near,t.object.far=this.far,t.object.focus=this.focus,t.object.aspect=this.aspect,null!==this.view&&(t.object.view=Object.assign({},this.view)),t.object.filmGauge=this.filmGauge,t.object.filmOffset=this.filmOffset,t}}const Pi=-90;class Ui extends xn{constructor(e,t,n){super(),this.type="CubeCamera",this.renderTarget=n,this.coordinateSystem=null,this.activeMipmapLevel=0;const i=new Li(Pi,1,e,t);i.layers=this.layers,this.add(i);const r=new Li(Pi,1,e,t);r.layers=this.layers,this.add(r);const a=new Li(Pi,1,e,t);a.layers=this.layers,this.add(a);const s=new Li(Pi,1,e,t);s.layers=this.layers,this.add(s);const o=new Li(Pi,1,e,t);o.layers=this.layers,this.add(o);const l=new Li(Pi,1,e,t);l.layers=this.layers,this.add(l)}updateCoordinateSystem(){const e=this.coordinateSystem,t=this.children.concat(),[n,i,r,a,s,o]=t;for(const e of t)this.remove(e);if(e===Le)n.up.set(0,1,0),n.lookAt(1,0,0),i.up.set(0,1,0),i.lookAt(-1,0,0),r.up.set(0,0,-1),r.lookAt(0,1,0),a.up.set(0,0,1),a.lookAt(0,-1,0),s.up.set(0,1,0),s.lookAt(0,0,1),o.up.set(0,1,0),o.lookAt(0,0,-1);else{if(e!==Pe)throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: "+e);n.up.set(0,-1,0),n.lookAt(-1,0,0),i.up.set(0,-1,0),i.lookAt(1,0,0),r.up.set(0,0,1),r.lookAt(0,1,0),a.up.set(0,0,-1),a.lookAt(0,-1,0),s.up.set(0,-1,0),s.lookAt(0,0,1),o.up.set(0,-1,0),o.lookAt(0,0,-1)}for(const e of t)this.add(e),e.updateMatrixWorld()}update(e,t){null===this.parent&&this.updateMatrixWorld();const{renderTarget:n,activeMipmapLevel:i}=this;this.coordinateSystem!==e.coordinateSystem&&(this.coordinateSystem=e.coordinateSystem,this.updateCoordinateSystem());const[r,a,s,o,l,c]=this.children,h=e.getRenderTarget(),u=e.getActiveCubeFace(),d=e.getActiveMipmapLevel(),p=e.xr.enabled;e.xr.enabled=!1;const f=n.texture.generateMipmaps;n.texture.generateMipmaps=!1,e.setRenderTarget(n,0,i),e.render(t,r),e.setRenderTarget(n,1,i),e.render(t,a),e.setRenderTarget(n,2,i),e.render(t,s),e.setRenderTarget(n,3,i),e.render(t,o),e.setRenderTarget(n,4,i),e.render(t,l),n.texture.generateMipmaps=f,e.setRenderTarget(n,5,i),e.render(t,c),e.setRenderTarget(h,u,d),e.xr.enabled=p,n.texture.needsPMREMUpdate=!0}}class Di extends ht{constructor(e,t,n,i,r,a,s,o,l,c){super(e=void 0!==e?e:[],t=void 0!==t?t:N,n,i,r,a,s,o,l,c),this.isCubeTexture=!0,this.flipY=!1}get images(){return this.image}set images(e){this.image=e}}class Ni extends pt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(e,e,t),this.isWebGLCubeRenderTarget=!0;const n={width:e,height:e,depth:1},i=[n,n,n,n,n,n];void 0!==t.encoding&&(Ze("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."),t.colorSpace=t.encoding===ce?ue:he),this.texture=new Di(i,t.mapping,t.wrapS,t.wrapT,t.magFilter,t.minFilter,t.format,t.type,t.anisotropy,t.colorSpace),this.texture.isRenderTargetTexture=!0,this.texture.generateMipmaps=void 0!==t.generateMipmaps&&t.generateMipmaps,this.texture.minFilter=void 0!==t.minFilter?t.minFilter:k}fromEquirectangularTexture(e,t){this.texture.type=t.type,this.texture.colorSpace=t.colorSpace,this.texture.generateMipmaps=t.generateMipmaps,this.texture.minFilter=t.minFilter,this.texture.magFilter=t.magFilter;const n={tEquirect:{value:null}},i="\\n\\n\\t\\t\\t\\tvarying vec3 vWorldDirection;\\n\\n\\t\\t\\t\\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\\n\\n\\t\\t\\t\\t\\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\t\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\n\\t\\t\\t\\t\\t#include <begin_vertex>\\n\\t\\t\\t\\t\\t#include <project_vertex>\\n\\n\\t\\t\\t\\t}\\n\\t\\t\\t",r="\\n\\n\\t\\t\\t\\tuniform sampler2D tEquirect;\\n\\n\\t\\t\\t\\tvarying vec3 vWorldDirection;\\n\\n\\t\\t\\t\\t#include <common>\\n\\n\\t\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\t\\tvec3 direction = normalize( vWorldDirection );\\n\\n\\t\\t\\t\\t\\tvec2 sampleUV = equirectUv( direction );\\n\\n\\t\\t\\t\\t\\tgl_FragColor = texture2D( tEquirect, sampleUV );\\n\\n\\t\\t\\t\\t}\\n\\t\\t\\t",a=new Ei(5,5,5),s=new Ri({name:"CubemapFromEquirect",uniforms:Ti(n),vertexShader:i,fragmentShader:r,side:1,blending:0});s.uniforms.tEquirect.value=t;const o=new Si(a,s),l=t.minFilter;return t.minFilter===X&&(t.minFilter=k),new Ui(1,10,this).update(e,o),t.minFilter=l,o.geometry.dispose(),o.material.dispose(),this}clear(e,t,n,i){const r=e.getRenderTarget();for(let r=0;r<6;r++)e.setRenderTarget(this,r),e.clear(t,n,i);e.setRenderTarget(r)}}const Ii=new _t,Oi=new _t,Fi=new We;class zi{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t(1,0,0),t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,i){return this.normal.set(e,t,n),this.constant=i,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){const i=Ii.subVectors(n,t).cross(Oi.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(i,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){const e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t){const n=e.delta(Ii),i=this.normal.dot(n);if(0===i)return 0===this.distanceToPoint(e.start)?t.copy(e.start):null;const r=-(e.start.dot(this.normal)+this.constant)/i;return r<0||r>1?null:t.copy(e.start).addScaledVector(n,r)}intersectsLine(e){const t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){const n=t||Fi.getNormalMatrix(e),i=this.coplanarPoint(Ii).applyMatrix4(e),r=this.normal.applyMatrix3(n).normalize();return this.constant=-i.dot(r),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return(new this.constructor).copy(this)}}const Bi=new zt,Hi=new _t;class Vi{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new zi,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new zi,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new zi,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:new zi,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:new zi,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:new zi;this.planes=[e,t,n,i,r,a]}set(e,t,n,i,r,a){const s=this.planes;return s[0].copy(e),s[1].copy(t),s[2].copy(n),s[3].copy(i),s[4].copy(r),s[5].copy(a),this}copy(e){const t=this.planes;for(let n=0;n<6;n++)t[n].copy(e.planes[n]);return this}setFromProjectionMatrix(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Le;const n=this.planes,i=e.elements,r=i[0],a=i[1],s=i[2],o=i[3],l=i[4],c=i[5],h=i[6],u=i[7],d=i[8],p=i[9],f=i[10],m=i[11],g=i[12],_=i[13],v=i[14],x=i[15];if(n[0].setComponents(o-r,u-l,m-d,x-g).normalize(),n[1].setComponents(o+r,u+l,m+d,x+g).normalize(),n[2].setComponents(o+a,u+c,m+p,x+_).normalize(),n[3].setComponents(o-a,u-c,m-p,x-_).normalize(),n[4].setComponents(o-s,u-h,m-f,x-v).normalize(),t===Le)n[5].setComponents(o+s,u+h,m+f,x+v).normalize();else{if(t!==Pe)throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: "+t);n[5].setComponents(s,h,f,v).normalize()}return this}intersectsObject(e){if(void 0!==e.boundingSphere)null===e.boundingSphere&&e.computeBoundingSphere(),Bi.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);else{const t=e.geometry;null===t.boundingSphere&&t.computeBoundingSphere(),Bi.copy(t.boundingSphere).applyMatrix4(e.matrixWorld)}return this.intersectsSphere(Bi)}intersectsSprite(e){return Bi.center.set(0,0,0),Bi.radius=.7071067811865476,Bi.applyMatrix4(e.matrixWorld),this.intersectsSphere(Bi)}intersectsSphere(e){const t=this.planes,n=e.center,i=-e.radius;for(let e=0;e<6;e++)if(t[e].distanceToPoint(n)<i)return!1;return!0}intersectsBox(e){const t=this.planes;for(let n=0;n<6;n++){const i=t[n];if(Hi.x=i.normal.x>0?e.max.x:e.min.x,Hi.y=i.normal.y>0?e.max.y:e.min.y,Hi.z=i.normal.z>0?e.max.z:e.min.z,i.distanceToPoint(Hi)<0)return!1}return!0}containsPoint(e){const t=this.planes;for(let n=0;n<6;n++)if(t[n].distanceToPoint(e)<0)return!1;return!0}clone(){return(new this.constructor).copy(this)}}function Gi(){let e=null,t=!1,n=null,i=null;function r(t,a){n(t,a),i=e.requestAnimationFrame(r)}return{start:function(){!0!==t&&null!==n&&(i=e.requestAnimationFrame(r),t=!0)},stop:function(){e.cancelAnimationFrame(i),t=!1},setAnimationLoop:function(e){n=e},setContext:function(t){e=t}}}function ki(e,t){const n=t.isWebGL2,i=new WeakMap;return{get:function(e){return e.isInterleavedBufferAttribute&&(e=e.data),i.get(e)},remove:function(t){t.isInterleavedBufferAttribute&&(t=t.data);const n=i.get(t);n&&(e.deleteBuffer(n.buffer),i.delete(t))},update:function(t,r){if(t.isGLBufferAttribute){const e=i.get(t);return void((!e||e.version<t.version)&&i.set(t,{buffer:t.buffer,type:t.type,bytesPerElement:t.elementSize,version:t.version}))}t.isInterleavedBufferAttribute&&(t=t.data);const a=i.get(t);void 0===a?i.set(t,function(t,i){const r=t.array,a=t.usage,s=e.createBuffer();let o;if(e.bindBuffer(i,s),e.bufferData(i,r,a),t.onUploadCallback(),r instanceof Float32Array)o=e.FLOAT;else if(r instanceof Uint16Array)if(t.isFloat16BufferAttribute){if(!n)throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");o=e.HALF_FLOAT}else o=e.UNSIGNED_SHORT;else if(r instanceof Int16Array)o=e.SHORT;else if(r instanceof Uint32Array)o=e.UNSIGNED_INT;else if(r instanceof Int32Array)o=e.INT;else if(r instanceof Int8Array)o=e.BYTE;else if(r instanceof Uint8Array)o=e.UNSIGNED_BYTE;else{if(!(r instanceof Uint8ClampedArray))throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: "+r);o=e.UNSIGNED_BYTE}return{buffer:s,type:o,bytesPerElement:r.BYTES_PER_ELEMENT,version:t.version}}(t,r)):a.version<t.version&&(function(t,i,r){const a=i.array,s=i.updateRange;e.bindBuffer(r,t),-1===s.count?e.bufferSubData(r,0,a):(n?e.bufferSubData(r,s.offset*a.BYTES_PER_ELEMENT,a,s.offset,s.count):e.bufferSubData(r,s.offset*a.BYTES_PER_ELEMENT,a.subarray(s.offset,s.offset+s.count)),s.count=-1),i.onUploadCallback()}(a.buffer,t,r),a.version=t.version)}}}class Wi extends ii{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(),this.type="PlaneGeometry",this.parameters={width:e,height:t,widthSegments:n,heightSegments:i};const r=e/2,a=t/2,s=Math.floor(n),o=Math.floor(i),l=s+1,c=o+1,h=e/s,u=t/o,d=[],p=[],f=[],m=[];for(let e=0;e<c;e++){const t=e*u-a;for(let n=0;n<l;n++){const i=n*h-r;p.push(i,-t,0),f.push(0,0,1),m.push(n/s),m.push(1-e/o)}}for(let e=0;e<o;e++)for(let t=0;t<s;t++){const n=t+l*e,i=t+l*(e+1),r=t+1+l*(e+1),a=t+1+l*e;d.push(n,i,a),d.push(i,r,a)}this.setIndex(d),this.setAttribute("position",new Kn(p,3)),this.setAttribute("normal",new Kn(f,3)),this.setAttribute("uv",new Kn(m,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Wi(e.width,e.height,e.widthSegments,e.heightSegments)}}const Xi={alphahash_fragment:"#ifdef USE_ALPHAHASH\\n\\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\\n#endif",alphahash_pars_fragment:"#ifdef USE_ALPHAHASH\\n\\tconst float ALPHA_HASH_SCALE = 0.05;\\n\\tfloat hash2D( vec2 value ) {\\n\\t\\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\\n\\t}\\n\\tfloat hash3D( vec3 value ) {\\n\\t\\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\\n\\t}\\n\\tfloat getAlphaHashThreshold( vec3 position ) {\\n\\t\\tfloat maxDeriv = max(\\n\\t\\t\\tlength( dFdx( position.xyz ) ),\\n\\t\\t\\tlength( dFdy( position.xyz ) )\\n\\t\\t);\\n\\t\\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\\n\\t\\tvec2 pixScales = vec2(\\n\\t\\t\\texp2( floor( log2( pixScale ) ) ),\\n\\t\\t\\texp2( ceil( log2( pixScale ) ) )\\n\\t\\t);\\n\\t\\tvec2 alpha = vec2(\\n\\t\\t\\thash3D( floor( pixScales.x * position.xyz ) ),\\n\\t\\t\\thash3D( floor( pixScales.y * position.xyz ) )\\n\\t\\t);\\n\\t\\tfloat lerpFactor = fract( log2( pixScale ) );\\n\\t\\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\\n\\t\\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\\n\\t\\tvec3 cases = vec3(\\n\\t\\t\\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\\n\\t\\t\\t( x - 0.5 * a ) / ( 1.0 - a ),\\n\\t\\t\\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\\n\\t\\t);\\n\\t\\tfloat threshold = ( x < ( 1.0 - a ) )\\n\\t\\t\\t? ( ( x < a ) ? cases.x : cases.y )\\n\\t\\t\\t: cases.z;\\n\\t\\treturn clamp( threshold , 1.0e-6, 1.0 );\\n\\t}\\n#endif",alphamap_fragment:"#ifdef USE_ALPHAMAP\\n\\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\\n#endif",alphamap_pars_fragment:"#ifdef USE_ALPHAMAP\\n\\tuniform sampler2D alphaMap;\\n#endif",alphatest_fragment:"#ifdef USE_ALPHATEST\\n\\tif ( diffuseColor.a < alphaTest ) discard;\\n#endif",alphatest_pars_fragment:"#ifdef USE_ALPHATEST\\n\\tuniform float alphaTest;\\n#endif",aomap_fragment:"#ifdef USE_AOMAP\\n\\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\\n\\treflectedLight.indirectDiffuse *= ambientOcclusion;\\n\\t#if defined( USE_CLEARCOAT ) \\n\\t\\tclearcoatSpecularIndirect *= ambientOcclusion;\\n\\t#endif\\n\\t#if defined( USE_SHEEN ) \\n\\t\\tsheenSpecularIndirect *= ambientOcclusion;\\n\\t#endif\\n\\t#if defined( USE_ENVMAP ) && defined( STANDARD )\\n\\t\\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\\n\\t\\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\\n\\t#endif\\n#endif",aomap_pars_fragment:"#ifdef USE_AOMAP\\n\\tuniform sampler2D aoMap;\\n\\tuniform float aoMapIntensity;\\n#endif",begin_vertex:"vec3 transformed = vec3( position );\\n#ifdef USE_ALPHAHASH\\n\\tvPosition = vec3( position );\\n#endif",beginnormal_vertex:"vec3 objectNormal = vec3( normal );\\n#ifdef USE_TANGENT\\n\\tvec3 objectTangent = vec3( tangent.xyz );\\n#endif",bsdfs:"float G_BlinnPhong_Implicit( ) {\\n\\treturn 0.25;\\n}\\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\\n\\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\\n}\\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\\n\\tfloat G = G_BlinnPhong_Implicit( );\\n\\tfloat D = D_BlinnPhong( shininess, dotNH );\\n\\treturn F * ( G * D );\\n} // validated",iridescence_fragment:"#ifdef USE_IRIDESCENCE\\n\\tconst mat3 XYZ_TO_REC709 = mat3(\\n\\t\\t 3.2404542, -0.9692660,  0.0556434,\\n\\t\\t-1.5371385,  1.8760108, -0.2040259,\\n\\t\\t-0.4985314,  0.0415560,  1.0572252\\n\\t);\\n\\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\\n\\t\\tvec3 sqrtF0 = sqrt( fresnel0 );\\n\\t\\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\\n\\t}\\n\\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\\n\\t\\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\\n\\t}\\n\\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\\n\\t\\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\\n\\t}\\n\\tvec3 evalSensitivity( float OPD, vec3 shift ) {\\n\\t\\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\\n\\t\\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\\n\\t\\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\\n\\t\\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\\n\\t\\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\\n\\t\\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\\n\\t\\txyz /= 1.0685e-7;\\n\\t\\tvec3 rgb = XYZ_TO_REC709 * xyz;\\n\\t\\treturn rgb;\\n\\t}\\n\\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\\n\\t\\tvec3 I;\\n\\t\\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\\n\\t\\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\\n\\t\\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\\n\\t\\tif ( cosTheta2Sq < 0.0 ) {\\n\\t\\t\\treturn vec3( 1.0 );\\n\\t\\t}\\n\\t\\tfloat cosTheta2 = sqrt( cosTheta2Sq );\\n\\t\\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\\n\\t\\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\\n\\t\\tfloat T121 = 1.0 - R12;\\n\\t\\tfloat phi12 = 0.0;\\n\\t\\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\\n\\t\\tfloat phi21 = PI - phi12;\\n\\t\\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\\t\\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\\n\\t\\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\\n\\t\\tvec3 phi23 = vec3( 0.0 );\\n\\t\\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\\n\\t\\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\\n\\t\\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\\n\\t\\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\\n\\t\\tvec3 phi = vec3( phi21 ) + phi23;\\n\\t\\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\\n\\t\\tvec3 r123 = sqrt( R123 );\\n\\t\\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\\n\\t\\tvec3 C0 = R12 + Rs;\\n\\t\\tI = C0;\\n\\t\\tvec3 Cm = Rs - T121;\\n\\t\\tfor ( int m = 1; m <= 2; ++ m ) {\\n\\t\\t\\tCm *= r123;\\n\\t\\t\\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\\n\\t\\t\\tI += Cm * Sm;\\n\\t\\t}\\n\\t\\treturn max( I, vec3( 0.0 ) );\\n\\t}\\n#endif",bumpmap_pars_fragment:"#ifdef USE_BUMPMAP\\n\\tuniform sampler2D bumpMap;\\n\\tuniform float bumpScale;\\n\\tvec2 dHdxy_fwd() {\\n\\t\\tvec2 dSTdx = dFdx( vBumpMapUv );\\n\\t\\tvec2 dSTdy = dFdy( vBumpMapUv );\\n\\t\\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\\n\\t\\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\\n\\t\\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\\n\\t\\treturn vec2( dBx, dBy );\\n\\t}\\n\\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\\n\\t\\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\\n\\t\\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\\n\\t\\tvec3 vN = surf_norm;\\n\\t\\tvec3 R1 = cross( vSigmaY, vN );\\n\\t\\tvec3 R2 = cross( vN, vSigmaX );\\n\\t\\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\\n\\t\\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\\n\\t\\treturn normalize( abs( fDet ) * surf_norm - vGrad );\\n\\t}\\n#endif",clipping_planes_fragment:"#if NUM_CLIPPING_PLANES > 0\\n\\tvec4 plane;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\\n\\t\\tplane = clippingPlanes[ i ];\\n\\t\\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\\n\\t\\tbool clipped = true;\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\\n\\t\\t\\tplane = clippingPlanes[ i ];\\n\\t\\t\\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t\\tif ( clipped ) discard;\\n\\t#endif\\n#endif",clipping_planes_pars_fragment:"#if NUM_CLIPPING_PLANES > 0\\n\\tvarying vec3 vClipPosition;\\n\\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\\n#endif",clipping_planes_pars_vertex:"#if NUM_CLIPPING_PLANES > 0\\n\\tvarying vec3 vClipPosition;\\n#endif",clipping_planes_vertex:"#if NUM_CLIPPING_PLANES > 0\\n\\tvClipPosition = - mvPosition.xyz;\\n#endif",color_fragment:"#if defined( USE_COLOR_ALPHA )\\n\\tdiffuseColor *= vColor;\\n#elif defined( USE_COLOR )\\n\\tdiffuseColor.rgb *= vColor;\\n#endif",color_pars_fragment:"#if defined( USE_COLOR_ALPHA )\\n\\tvarying vec4 vColor;\\n#elif defined( USE_COLOR )\\n\\tvarying vec3 vColor;\\n#endif",color_pars_vertex:"#if defined( USE_COLOR_ALPHA )\\n\\tvarying vec4 vColor;\\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\\n\\tvarying vec3 vColor;\\n#endif",color_vertex:"#if defined( USE_COLOR_ALPHA )\\n\\tvColor = vec4( 1.0 );\\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\\n\\tvColor = vec3( 1.0 );\\n#endif\\n#ifdef USE_COLOR\\n\\tvColor *= color;\\n#endif\\n#ifdef USE_INSTANCING_COLOR\\n\\tvColor.xyz *= instanceColor.xyz;\\n#endif",common:"#define PI 3.141592653589793\\n#define PI2 6.283185307179586\\n#define PI_HALF 1.5707963267948966\\n#define RECIPROCAL_PI 0.3183098861837907\\n#define RECIPROCAL_PI2 0.15915494309189535\\n#define EPSILON 1e-6\\n#ifndef saturate\\n#define saturate( a ) clamp( a, 0.0, 1.0 )\\n#endif\\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\\nfloat pow2( const in float x ) { return x*x; }\\nvec3 pow2( const in vec3 x ) { return x*x; }\\nfloat pow3( const in float x ) { return x*x*x; }\\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\\nhighp float rand( const in vec2 uv ) {\\n\\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\\n\\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\\n\\treturn fract( sin( sn ) * c );\\n}\\n#ifdef HIGH_PRECISION\\n\\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\\n#else\\n\\tfloat precisionSafeLength( vec3 v ) {\\n\\t\\tfloat maxComponent = max3( abs( v ) );\\n\\t\\treturn length( v / maxComponent ) * maxComponent;\\n\\t}\\n#endif\\nstruct IncidentLight {\\n\\tvec3 color;\\n\\tvec3 direction;\\n\\tbool visible;\\n};\\nstruct ReflectedLight {\\n\\tvec3 directDiffuse;\\n\\tvec3 directSpecular;\\n\\tvec3 indirectDiffuse;\\n\\tvec3 indirectSpecular;\\n};\\n#ifdef USE_ALPHAHASH\\n\\tvarying vec3 vPosition;\\n#endif\\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\\n\\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\\n}\\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\\n\\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\\n}\\nmat3 transposeMat3( const in mat3 m ) {\\n\\tmat3 tmp;\\n\\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\\n\\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\\n\\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\\n\\treturn tmp;\\n}\\nfloat luminance( const in vec3 rgb ) {\\n\\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\\n\\treturn dot( weights, rgb );\\n}\\nbool isPerspectiveMatrix( mat4 m ) {\\n\\treturn m[ 2 ][ 3 ] == - 1.0;\\n}\\nvec2 equirectUv( in vec3 dir ) {\\n\\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\\n\\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\\n\\treturn vec2( u, v );\\n}\\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\\n\\treturn RECIPROCAL_PI * diffuseColor;\\n}\\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\\n\\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\\n\\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\\n}\\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\\n\\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\\n\\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\\n} // validated",cube_uv_reflection_fragment:"#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t#define cubeUV_minMipLevel 4.0\\n\\t#define cubeUV_minTileSize 16.0\\n\\tfloat getFace( vec3 direction ) {\\n\\t\\tvec3 absDirection = abs( direction );\\n\\t\\tfloat face = - 1.0;\\n\\t\\tif ( absDirection.x > absDirection.z ) {\\n\\t\\t\\tif ( absDirection.x > absDirection.y )\\n\\t\\t\\t\\tface = direction.x > 0.0 ? 0.0 : 3.0;\\n\\t\\t\\telse\\n\\t\\t\\t\\tface = direction.y > 0.0 ? 1.0 : 4.0;\\n\\t\\t} else {\\n\\t\\t\\tif ( absDirection.z > absDirection.y )\\n\\t\\t\\t\\tface = direction.z > 0.0 ? 2.0 : 5.0;\\n\\t\\t\\telse\\n\\t\\t\\t\\tface = direction.y > 0.0 ? 1.0 : 4.0;\\n\\t\\t}\\n\\t\\treturn face;\\n\\t}\\n\\tvec2 getUV( vec3 direction, float face ) {\\n\\t\\tvec2 uv;\\n\\t\\tif ( face == 0.0 ) {\\n\\t\\t\\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\\n\\t\\t} else if ( face == 1.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\\n\\t\\t} else if ( face == 2.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\\n\\t\\t} else if ( face == 3.0 ) {\\n\\t\\t\\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\\n\\t\\t} else if ( face == 4.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\\n\\t\\t} else {\\n\\t\\t\\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\\n\\t\\t}\\n\\t\\treturn 0.5 * ( uv + 1.0 );\\n\\t}\\n\\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\\n\\t\\tfloat face = getFace( direction );\\n\\t\\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\\n\\t\\tmipInt = max( mipInt, cubeUV_minMipLevel );\\n\\t\\tfloat faceSize = exp2( mipInt );\\n\\t\\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\\n\\t\\tif ( face > 2.0 ) {\\n\\t\\t\\tuv.y += faceSize;\\n\\t\\t\\tface -= 3.0;\\n\\t\\t}\\n\\t\\tuv.x += face * faceSize;\\n\\t\\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\\n\\t\\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\\n\\t\\tuv.x *= CUBEUV_TEXEL_WIDTH;\\n\\t\\tuv.y *= CUBEUV_TEXEL_HEIGHT;\\n\\t\\t#ifdef texture2DGradEXT\\n\\t\\t\\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\\n\\t\\t#else\\n\\t\\t\\treturn texture2D( envMap, uv ).rgb;\\n\\t\\t#endif\\n\\t}\\n\\t#define cubeUV_r0 1.0\\n\\t#define cubeUV_v0 0.339\\n\\t#define cubeUV_m0 - 2.0\\n\\t#define cubeUV_r1 0.8\\n\\t#define cubeUV_v1 0.276\\n\\t#define cubeUV_m1 - 1.0\\n\\t#define cubeUV_r4 0.4\\n\\t#define cubeUV_v4 0.046\\n\\t#define cubeUV_m4 2.0\\n\\t#define cubeUV_r5 0.305\\n\\t#define cubeUV_v5 0.016\\n\\t#define cubeUV_m5 3.0\\n\\t#define cubeUV_r6 0.21\\n\\t#define cubeUV_v6 0.0038\\n\\t#define cubeUV_m6 4.0\\n\\tfloat roughnessToMip( float roughness ) {\\n\\t\\tfloat mip = 0.0;\\n\\t\\tif ( roughness >= cubeUV_r1 ) {\\n\\t\\t\\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\\n\\t\\t} else if ( roughness >= cubeUV_r4 ) {\\n\\t\\t\\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\\n\\t\\t} else if ( roughness >= cubeUV_r5 ) {\\n\\t\\t\\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\\n\\t\\t} else if ( roughness >= cubeUV_r6 ) {\\n\\t\\t\\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\\n\\t\\t} else {\\n\\t\\t\\tmip = - 2.0 * log2( 1.16 * roughness );\\t\\t}\\n\\t\\treturn mip;\\n\\t}\\n\\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\\n\\t\\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\\n\\t\\tfloat mipF = fract( mip );\\n\\t\\tfloat mipInt = floor( mip );\\n\\t\\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\\n\\t\\tif ( mipF == 0.0 ) {\\n\\t\\t\\treturn vec4( color0, 1.0 );\\n\\t\\t} else {\\n\\t\\t\\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\\n\\t\\t\\treturn vec4( mix( color0, color1, mipF ), 1.0 );\\n\\t\\t}\\n\\t}\\n#endif",defaultnormal_vertex:"vec3 transformedNormal = objectNormal;\\n#ifdef USE_INSTANCING\\n\\tmat3 m = mat3( instanceMatrix );\\n\\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\\n\\ttransformedNormal = m * transformedNormal;\\n#endif\\ntransformedNormal = normalMatrix * transformedNormal;\\n#ifdef FLIP_SIDED\\n\\ttransformedNormal = - transformedNormal;\\n#endif\\n#ifdef USE_TANGENT\\n\\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\\n\\t#ifdef FLIP_SIDED\\n\\t\\ttransformedTangent = - transformedTangent;\\n\\t#endif\\n#endif",displacementmap_pars_vertex:"#ifdef USE_DISPLACEMENTMAP\\n\\tuniform sampler2D displacementMap;\\n\\tuniform float displacementScale;\\n\\tuniform float displacementBias;\\n#endif",displacementmap_vertex:"#ifdef USE_DISPLACEMENTMAP\\n\\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\\n#endif",emissivemap_fragment:"#ifdef USE_EMISSIVEMAP\\n\\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\\n\\ttotalEmissiveRadiance *= emissiveColor.rgb;\\n#endif",emissivemap_pars_fragment:"#ifdef USE_EMISSIVEMAP\\n\\tuniform sampler2D emissiveMap;\\n#endif",colorspace_fragment:"gl_FragColor = linearToOutputTexel( gl_FragColor );",colorspace_pars_fragment:"\\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\\n\\tvec3( 0.8224621, 0.177538, 0.0 ),\\n\\tvec3( 0.0331941, 0.9668058, 0.0 ),\\n\\tvec3( 0.0170827, 0.0723974, 0.9105199 )\\n);\\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\\n\\tvec3( 1.2249401, - 0.2249404, 0.0 ),\\n\\tvec3( - 0.0420569, 1.0420571, 0.0 ),\\n\\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\\n);\\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\\n\\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\\n}\\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\\n\\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\\n}\\nvec4 LinearTransferOETF( in vec4 value ) {\\n\\treturn value;\\n}\\nvec4 sRGBTransferOETF( in vec4 value ) {\\n\\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\\n}\\nvec4 LinearToLinear( in vec4 value ) {\\n\\treturn value;\\n}\\nvec4 LinearTosRGB( in vec4 value ) {\\n\\treturn sRGBTransferOETF( value );\\n}",envmap_fragment:"#ifdef USE_ENVMAP\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvec3 cameraToFrag;\\n\\t\\tif ( isOrthographic ) {\\n\\t\\t\\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\\n\\t\\t} else {\\n\\t\\t\\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\\n\\t\\t}\\n\\t\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\t\\t#ifdef ENVMAP_MODE_REFLECTION\\n\\t\\t\\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\\n\\t\\t#else\\n\\t\\t\\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\\n\\t\\t#endif\\n\\t#else\\n\\t\\tvec3 reflectVec = vReflect;\\n\\t#endif\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\\n\\t#else\\n\\t\\tvec4 envColor = vec4( 0.0 );\\n\\t#endif\\n\\t#ifdef ENVMAP_BLENDING_MULTIPLY\\n\\t\\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\\n\\t#elif defined( ENVMAP_BLENDING_MIX )\\n\\t\\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\\n\\t#elif defined( ENVMAP_BLENDING_ADD )\\n\\t\\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\\n\\t#endif\\n#endif",envmap_common_pars_fragment:"#ifdef USE_ENVMAP\\n\\tuniform float envMapIntensity;\\n\\tuniform float flipEnvMap;\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tuniform samplerCube envMap;\\n\\t#else\\n\\t\\tuniform sampler2D envMap;\\n\\t#endif\\n\\t\\n#endif",envmap_pars_fragment:"#ifdef USE_ENVMAP\\n\\tuniform float reflectivity;\\n\\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\\n\\t\\t#define ENV_WORLDPOS\\n\\t#endif\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvarying vec3 vWorldPosition;\\n\\t\\tuniform float refractionRatio;\\n\\t#else\\n\\t\\tvarying vec3 vReflect;\\n\\t#endif\\n#endif",envmap_pars_vertex:"#ifdef USE_ENVMAP\\n\\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\\n\\t\\t#define ENV_WORLDPOS\\n\\t#endif\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\t\\n\\t\\tvarying vec3 vWorldPosition;\\n\\t#else\\n\\t\\tvarying vec3 vReflect;\\n\\t\\tuniform float refractionRatio;\\n\\t#endif\\n#endif",envmap_physical_pars_fragment:"#ifdef USE_ENVMAP\\n\\tvec3 getIBLIrradiance( const in vec3 normal ) {\\n\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\t\\t\\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\\n\\t\\t\\treturn PI * envMapColor.rgb * envMapIntensity;\\n\\t\\t#else\\n\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t#endif\\n\\t}\\n\\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\\n\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\tvec3 reflectVec = reflect( - viewDir, normal );\\n\\t\\t\\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\\n\\t\\t\\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\\n\\t\\t\\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\\n\\t\\t\\treturn envMapColor.rgb * envMapIntensity;\\n\\t\\t#else\\n\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t#endif\\n\\t}\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\\n\\t\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\t\\tvec3 bentNormal = cross( bitangent, viewDir );\\n\\t\\t\\t\\tbentNormal = normalize( cross( bentNormal, bitangent ) );\\n\\t\\t\\t\\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\\n\\t\\t\\t\\treturn getIBLRadiance( viewDir, bentNormal, roughness );\\n\\t\\t\\t#else\\n\\t\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t\\t#endif\\n\\t\\t}\\n\\t#endif\\n#endif",envmap_vertex:"#ifdef USE_ENVMAP\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvWorldPosition = worldPosition.xyz;\\n\\t#else\\n\\t\\tvec3 cameraToVertex;\\n\\t\\tif ( isOrthographic ) {\\n\\t\\t\\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\\n\\t\\t} else {\\n\\t\\t\\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\\n\\t\\t}\\n\\t\\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\\n\\t\\t#ifdef ENVMAP_MODE_REFLECTION\\n\\t\\t\\tvReflect = reflect( cameraToVertex, worldNormal );\\n\\t\\t#else\\n\\t\\t\\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\\n\\t\\t#endif\\n\\t#endif\\n#endif",fog_vertex:"#ifdef USE_FOG\\n\\tvFogDepth = - mvPosition.z;\\n#endif",fog_pars_vertex:"#ifdef USE_FOG\\n\\tvarying float vFogDepth;\\n#endif",fog_fragment:"#ifdef USE_FOG\\n\\t#ifdef FOG_EXP2\\n\\t\\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\\n\\t#else\\n\\t\\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\\n\\t#endif\\n\\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\\n#endif",fog_pars_fragment:"#ifdef USE_FOG\\n\\tuniform vec3 fogColor;\\n\\tvarying float vFogDepth;\\n\\t#ifdef FOG_EXP2\\n\\t\\tuniform float fogDensity;\\n\\t#else\\n\\t\\tuniform float fogNear;\\n\\t\\tuniform float fogFar;\\n\\t#endif\\n#endif",gradientmap_pars_fragment:"#ifdef USE_GRADIENTMAP\\n\\tuniform sampler2D gradientMap;\\n#endif\\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\\n\\tfloat dotNL = dot( normal, lightDirection );\\n\\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\\n\\t#ifdef USE_GRADIENTMAP\\n\\t\\treturn vec3( texture2D( gradientMap, coord ).r );\\n\\t#else\\n\\t\\tvec2 fw = fwidth( coord ) * 0.5;\\n\\t\\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\\n\\t#endif\\n}",lightmap_fragment:"#ifdef USE_LIGHTMAP\\n\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\\n\\treflectedLight.indirectDiffuse += lightMapIrradiance;\\n#endif",lightmap_pars_fragment:"#ifdef USE_LIGHTMAP\\n\\tuniform sampler2D lightMap;\\n\\tuniform float lightMapIntensity;\\n#endif",lights_lambert_fragment:"LambertMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;\\nmaterial.specularStrength = specularStrength;",lights_lambert_pars_fragment:"varying vec3 vViewPosition;\\nstruct LambertMaterial {\\n\\tvec3 diffuseColor;\\n\\tfloat specularStrength;\\n};\\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Lambert\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Lambert",lights_pars_begin:"uniform bool receiveShadow;\\nuniform vec3 ambientLightColor;\\n#if defined( USE_LIGHT_PROBES )\\n\\tuniform vec3 lightProbe[ 9 ];\\n#endif\\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\\n\\tfloat x = normal.x, y = normal.y, z = normal.z;\\n\\tvec3 result = shCoefficients[ 0 ] * 0.886227;\\n\\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\\n\\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\\n\\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\\n\\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\\n\\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\\n\\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\\n\\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\\n\\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\\n\\treturn result;\\n}\\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\\n\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\\n\\treturn irradiance;\\n}\\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\\n\\tvec3 irradiance = ambientLightColor;\\n\\treturn irradiance;\\n}\\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\\n\\t#if defined ( LEGACY_LIGHTS )\\n\\t\\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\\n\\t\\t\\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\\n\\t\\t}\\n\\t\\treturn 1.0;\\n\\t#else\\n\\t\\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\\n\\t\\tif ( cutoffDistance > 0.0 ) {\\n\\t\\t\\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\\n\\t\\t}\\n\\t\\treturn distanceFalloff;\\n\\t#endif\\n}\\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\\n\\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\\n}\\n#if NUM_DIR_LIGHTS > 0\\n\\tstruct DirectionalLight {\\n\\t\\tvec3 direction;\\n\\t\\tvec3 color;\\n\\t};\\n\\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\\n\\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\\n\\t\\tlight.color = directionalLight.color;\\n\\t\\tlight.direction = directionalLight.direction;\\n\\t\\tlight.visible = true;\\n\\t}\\n#endif\\n#if NUM_POINT_LIGHTS > 0\\n\\tstruct PointLight {\\n\\t\\tvec3 position;\\n\\t\\tvec3 color;\\n\\t\\tfloat distance;\\n\\t\\tfloat decay;\\n\\t};\\n\\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\\n\\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\\n\\t\\tvec3 lVector = pointLight.position - geometryPosition;\\n\\t\\tlight.direction = normalize( lVector );\\n\\t\\tfloat lightDistance = length( lVector );\\n\\t\\tlight.color = pointLight.color;\\n\\t\\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\\n\\t\\tlight.visible = ( light.color != vec3( 0.0 ) );\\n\\t}\\n#endif\\n#if NUM_SPOT_LIGHTS > 0\\n\\tstruct SpotLight {\\n\\t\\tvec3 position;\\n\\t\\tvec3 direction;\\n\\t\\tvec3 color;\\n\\t\\tfloat distance;\\n\\t\\tfloat decay;\\n\\t\\tfloat coneCos;\\n\\t\\tfloat penumbraCos;\\n\\t};\\n\\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\\n\\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\\n\\t\\tvec3 lVector = spotLight.position - geometryPosition;\\n\\t\\tlight.direction = normalize( lVector );\\n\\t\\tfloat angleCos = dot( light.direction, spotLight.direction );\\n\\t\\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\\n\\t\\tif ( spotAttenuation > 0.0 ) {\\n\\t\\t\\tfloat lightDistance = length( lVector );\\n\\t\\t\\tlight.color = spotLight.color * spotAttenuation;\\n\\t\\t\\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\\n\\t\\t\\tlight.visible = ( light.color != vec3( 0.0 ) );\\n\\t\\t} else {\\n\\t\\t\\tlight.color = vec3( 0.0 );\\n\\t\\t\\tlight.visible = false;\\n\\t\\t}\\n\\t}\\n#endif\\n#if NUM_RECT_AREA_LIGHTS > 0\\n\\tstruct RectAreaLight {\\n\\t\\tvec3 color;\\n\\t\\tvec3 position;\\n\\t\\tvec3 halfWidth;\\n\\t\\tvec3 halfHeight;\\n\\t};\\n\\tuniform sampler2D ltc_1;\\tuniform sampler2D ltc_2;\\n\\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\\n#endif\\n#if NUM_HEMI_LIGHTS > 0\\n\\tstruct HemisphereLight {\\n\\t\\tvec3 direction;\\n\\t\\tvec3 skyColor;\\n\\t\\tvec3 groundColor;\\n\\t};\\n\\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\\n\\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\\n\\t\\tfloat dotNL = dot( normal, hemiLight.direction );\\n\\t\\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\\n\\t\\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\\n\\t\\treturn irradiance;\\n\\t}\\n#endif",lights_toon_fragment:"ToonMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;",lights_toon_pars_fragment:"varying vec3 vViewPosition;\\nstruct ToonMaterial {\\n\\tvec3 diffuseColor;\\n};\\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Toon\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Toon",lights_phong_fragment:"BlinnPhongMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;\\nmaterial.specularColor = specular;\\nmaterial.specularShininess = shininess;\\nmaterial.specularStrength = specularStrength;",lights_phong_pars_fragment:"varying vec3 vViewPosition;\\nstruct BlinnPhongMaterial {\\n\\tvec3 diffuseColor;\\n\\tvec3 specularColor;\\n\\tfloat specularShininess;\\n\\tfloat specularStrength;\\n};\\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n\\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\\n}\\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_BlinnPhong\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_BlinnPhong",lights_physical_fragment:"PhysicalMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\\nmaterial.roughness = min( material.roughness, 1.0 );\\n#ifdef IOR\\n\\tmaterial.ior = ior;\\n\\t#ifdef USE_SPECULAR\\n\\t\\tfloat specularIntensityFactor = specularIntensity;\\n\\t\\tvec3 specularColorFactor = specularColor;\\n\\t\\t#ifdef USE_SPECULAR_COLORMAP\\n\\t\\t\\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\\n\\t\\t#endif\\n\\t\\t#ifdef USE_SPECULAR_INTENSITYMAP\\n\\t\\t\\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\\n\\t\\t#endif\\n\\t\\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\\n\\t#else\\n\\t\\tfloat specularIntensityFactor = 1.0;\\n\\t\\tvec3 specularColorFactor = vec3( 1.0 );\\n\\t\\tmaterial.specularF90 = 1.0;\\n\\t#endif\\n\\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\\n#else\\n\\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\\n\\tmaterial.specularF90 = 1.0;\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tmaterial.clearcoat = clearcoat;\\n\\tmaterial.clearcoatRoughness = clearcoatRoughness;\\n\\tmaterial.clearcoatF0 = vec3( 0.04 );\\n\\tmaterial.clearcoatF90 = 1.0;\\n\\t#ifdef USE_CLEARCOATMAP\\n\\t\\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\t\\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\\n\\t#endif\\n\\tmaterial.clearcoat = saturate( material.clearcoat );\\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\\n\\tmaterial.clearcoatRoughness += geometryRoughness;\\n\\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tmaterial.iridescence = iridescence;\\n\\tmaterial.iridescenceIOR = iridescenceIOR;\\n\\t#ifdef USE_IRIDESCENCEMAP\\n\\t\\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\\n\\t#endif\\n\\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\t\\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\\n\\t#else\\n\\t\\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\\n\\t#endif\\n#endif\\n#ifdef USE_SHEEN\\n\\tmaterial.sheenColor = sheenColor;\\n\\t#ifdef USE_SHEEN_COLORMAP\\n\\t\\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\\n\\t#endif\\n\\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\\n\\t#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\t\\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\\n\\t#endif\\n#endif\\n#ifdef USE_ANISOTROPY\\n\\t#ifdef USE_ANISOTROPYMAP\\n\\t\\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\\n\\t\\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\\n\\t\\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\\n\\t#else\\n\\t\\tvec2 anisotropyV = anisotropyVector;\\n\\t#endif\\n\\tmaterial.anisotropy = length( anisotropyV );\\n\\tanisotropyV /= material.anisotropy;\\n\\tmaterial.anisotropy = saturate( material.anisotropy );\\n\\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\\n\\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\\n\\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\\n#endif",lights_physical_pars_fragment:"struct PhysicalMaterial {\\n\\tvec3 diffuseColor;\\n\\tfloat roughness;\\n\\tvec3 specularColor;\\n\\tfloat specularF90;\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat clearcoat;\\n\\t\\tfloat clearcoatRoughness;\\n\\t\\tvec3 clearcoatF0;\\n\\t\\tfloat clearcoatF90;\\n\\t#endif\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tfloat iridescence;\\n\\t\\tfloat iridescenceIOR;\\n\\t\\tfloat iridescenceThickness;\\n\\t\\tvec3 iridescenceFresnel;\\n\\t\\tvec3 iridescenceF0;\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tvec3 sheenColor;\\n\\t\\tfloat sheenRoughness;\\n\\t#endif\\n\\t#ifdef IOR\\n\\t\\tfloat ior;\\n\\t#endif\\n\\t#ifdef USE_TRANSMISSION\\n\\t\\tfloat transmission;\\n\\t\\tfloat transmissionAlpha;\\n\\t\\tfloat thickness;\\n\\t\\tfloat attenuationDistance;\\n\\t\\tvec3 attenuationColor;\\n\\t#endif\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tfloat anisotropy;\\n\\t\\tfloat alphaT;\\n\\t\\tvec3 anisotropyT;\\n\\t\\tvec3 anisotropyB;\\n\\t#endif\\n};\\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\\nvec3 sheenSpecularDirect = vec3( 0.0 );\\nvec3 sheenSpecularIndirect = vec3(0.0 );\\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\\n    float x2 = x * x;\\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\\n}\\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\\n\\tfloat a2 = pow2( alpha );\\n\\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\\n\\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\\n\\treturn 0.5 / max( gv + gl, EPSILON );\\n}\\nfloat D_GGX( const in float alpha, const in float dotNH ) {\\n\\tfloat a2 = pow2( alpha );\\n\\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\\n\\treturn RECIPROCAL_PI * a2 / pow2( denom );\\n}\\n#ifdef USE_ANISOTROPY\\n\\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\\n\\t\\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\\n\\t\\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\\n\\t\\tfloat v = 0.5 / ( gv + gl );\\n\\t\\treturn saturate(v);\\n\\t}\\n\\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\\n\\t\\tfloat a2 = alphaT * alphaB;\\n\\t\\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\\n\\t\\thighp float v2 = dot( v, v );\\n\\t\\tfloat w2 = a2 / v2;\\n\\t\\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\\n\\t}\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\\n\\t\\tvec3 f0 = material.clearcoatF0;\\n\\t\\tfloat f90 = material.clearcoatF90;\\n\\t\\tfloat roughness = material.clearcoatRoughness;\\n\\t\\tfloat alpha = pow2( roughness );\\n\\t\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\t\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\t\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\t\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\t\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\t\\tvec3 F = F_Schlick( f0, f90, dotVH );\\n\\t\\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\\n\\t\\tfloat D = D_GGX( alpha, dotNH );\\n\\t\\treturn F * ( V * D );\\n\\t}\\n#endif\\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\\n\\tvec3 f0 = material.specularColor;\\n\\tfloat f90 = material.specularF90;\\n\\tfloat roughness = material.roughness;\\n\\tfloat alpha = pow2( roughness );\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\tvec3 F = F_Schlick( f0, f90, dotVH );\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tF = mix( F, material.iridescenceFresnel, material.iridescence );\\n\\t#endif\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tfloat dotTL = dot( material.anisotropyT, lightDir );\\n\\t\\tfloat dotTV = dot( material.anisotropyT, viewDir );\\n\\t\\tfloat dotTH = dot( material.anisotropyT, halfDir );\\n\\t\\tfloat dotBL = dot( material.anisotropyB, lightDir );\\n\\t\\tfloat dotBV = dot( material.anisotropyB, viewDir );\\n\\t\\tfloat dotBH = dot( material.anisotropyB, halfDir );\\n\\t\\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\\n\\t\\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\\n\\t#else\\n\\t\\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\\n\\t\\tfloat D = D_GGX( alpha, dotNH );\\n\\t#endif\\n\\treturn F * ( V * D );\\n}\\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\\n\\tconst float LUT_SIZE = 64.0;\\n\\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\\n\\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\\n\\tfloat dotNV = saturate( dot( N, V ) );\\n\\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\\n\\tuv = uv * LUT_SCALE + LUT_BIAS;\\n\\treturn uv;\\n}\\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\\n\\tfloat l = length( f );\\n\\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\\n}\\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\\n\\tfloat x = dot( v1, v2 );\\n\\tfloat y = abs( x );\\n\\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\\n\\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\\n\\tfloat v = a / b;\\n\\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\\n\\treturn cross( v1, v2 ) * theta_sintheta;\\n}\\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\\n\\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\\n\\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\\n\\tvec3 lightNormal = cross( v1, v2 );\\n\\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\\n\\tvec3 T1, T2;\\n\\tT1 = normalize( V - N * dot( V, N ) );\\n\\tT2 = - cross( N, T1 );\\n\\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\\n\\tvec3 coords[ 4 ];\\n\\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\\n\\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\\n\\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\\n\\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\\n\\tcoords[ 0 ] = normalize( coords[ 0 ] );\\n\\tcoords[ 1 ] = normalize( coords[ 1 ] );\\n\\tcoords[ 2 ] = normalize( coords[ 2 ] );\\n\\tcoords[ 3 ] = normalize( coords[ 3 ] );\\n\\tvec3 vectorFormFactor = vec3( 0.0 );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\\n\\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\\n\\treturn vec3( result );\\n}\\n#if defined( USE_SHEEN )\\nfloat D_Charlie( float roughness, float dotNH ) {\\n\\tfloat alpha = pow2( roughness );\\n\\tfloat invAlpha = 1.0 / alpha;\\n\\tfloat cos2h = dotNH * dotNH;\\n\\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\\n\\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\\n}\\nfloat V_Neubelt( float dotNV, float dotNL ) {\\n\\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\\n}\\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat D = D_Charlie( sheenRoughness, dotNH );\\n\\tfloat V = V_Neubelt( dotNV, dotNL );\\n\\treturn sheenColor * ( D * V );\\n}\\n#endif\\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat r2 = roughness * roughness;\\n\\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\\n\\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\\n\\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\\n\\treturn saturate( DG * RECIPROCAL_PI );\\n}\\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\\n\\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\\n\\tvec4 r = roughness * c0 + c1;\\n\\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\\n\\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\\n\\treturn fab;\\n}\\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\\n\\tvec2 fab = DFGApprox( normal, viewDir, roughness );\\n\\treturn specularColor * fab.x + specularF90 * fab.y;\\n}\\n#ifdef USE_IRIDESCENCE\\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\\n#else\\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\\n#endif\\n\\tvec2 fab = DFGApprox( normal, viewDir, roughness );\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\\n\\t#else\\n\\t\\tvec3 Fr = specularColor;\\n\\t#endif\\n\\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\\n\\tfloat Ess = fab.x + fab.y;\\n\\tfloat Ems = 1.0 - Ess;\\n\\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\\n\\tsingleScatter += FssEss;\\n\\tmultiScatter += Fms * Ems;\\n}\\n#if NUM_RECT_AREA_LIGHTS > 0\\n\\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\t\\tvec3 normal = geometryNormal;\\n\\t\\tvec3 viewDir = geometryViewDir;\\n\\t\\tvec3 position = geometryPosition;\\n\\t\\tvec3 lightPos = rectAreaLight.position;\\n\\t\\tvec3 halfWidth = rectAreaLight.halfWidth;\\n\\t\\tvec3 halfHeight = rectAreaLight.halfHeight;\\n\\t\\tvec3 lightColor = rectAreaLight.color;\\n\\t\\tfloat roughness = material.roughness;\\n\\t\\tvec3 rectCoords[ 4 ];\\n\\t\\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\\t\\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\\n\\t\\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\\n\\t\\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\\n\\t\\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\\n\\t\\tvec4 t1 = texture2D( ltc_1, uv );\\n\\t\\tvec4 t2 = texture2D( ltc_2, uv );\\n\\t\\tmat3 mInv = mat3(\\n\\t\\t\\tvec3( t1.x, 0, t1.y ),\\n\\t\\t\\tvec3(    0, 1,    0 ),\\n\\t\\t\\tvec3( t1.z, 0, t1.w )\\n\\t\\t);\\n\\t\\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\\n\\t\\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\\n\\t\\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\\n\\t}\\n#endif\\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\\n\\t\\tvec3 ccIrradiance = dotNLcc * directLight.color;\\n\\t\\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\\n\\t#endif\\n\\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\\n\\t#endif\\n\\tvec3 singleScattering = vec3( 0.0 );\\n\\tvec3 multiScattering = vec3( 0.0 );\\n\\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\\n\\t#else\\n\\t\\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\\n\\t#endif\\n\\tvec3 totalScattering = singleScattering + multiScattering;\\n\\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\\n\\treflectedLight.indirectSpecular += radiance * singleScattering;\\n\\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\\n\\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Physical\\n#define RE_Direct_RectArea\\t\\tRE_Direct_RectArea_Physical\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Physical\\n#define RE_IndirectSpecular\\t\\tRE_IndirectSpecular_Physical\\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\\n\\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\\n}",lights_fragment_begin:"\\nvec3 geometryPosition = - vViewPosition;\\nvec3 geometryNormal = normal;\\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\\nvec3 geometryClearcoatNormal = vec3( 0.0 );\\n#ifdef USE_CLEARCOAT\\n\\tgeometryClearcoatNormal = clearcoatNormal;\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\\n\\tif ( material.iridescenceThickness == 0.0 ) {\\n\\t\\tmaterial.iridescence = 0.0;\\n\\t} else {\\n\\t\\tmaterial.iridescence = saturate( material.iridescence );\\n\\t}\\n\\tif ( material.iridescence > 0.0 ) {\\n\\t\\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\\n\\t\\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\\n\\t}\\n#endif\\nIncidentLight directLight;\\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tPointLight pointLight;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\\n\\tPointLightShadow pointLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\\n\\t\\tpointLight = pointLights[ i ];\\n\\t\\tgetPointLightInfo( pointLight, geometryPosition, directLight );\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\\n\\t\\tpointLightShadow = pointLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tSpotLight spotLight;\\n\\tvec4 spotColor;\\n\\tvec3 spotLightCoord;\\n\\tbool inSpotLightMap;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\\n\\tSpotLightShadow spotLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\\n\\t\\tspotLight = spotLights[ i ];\\n\\t\\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\\n\\t\\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\\n\\t\\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\\n\\t\\t#else\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\\n\\t\\t#endif\\n\\t\\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\\n\\t\\t\\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\\n\\t\\t\\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\\n\\t\\t\\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\\n\\t\\t\\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\\n\\t\\t#endif\\n\\t\\t#undef SPOT_LIGHT_MAP_INDEX\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\tspotLightShadow = spotLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tDirectionalLight directionalLight;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\\n\\tDirectionalLightShadow directionalLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\\n\\t\\tdirectionalLight = directionalLights[ i ];\\n\\t\\tgetDirectionalLightInfo( directionalLight, directLight );\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\\n\\t\\tdirectionalLightShadow = directionalLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\\n\\tRectAreaLight rectAreaLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\\n\\t\\trectAreaLight = rectAreaLights[ i ];\\n\\t\\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if defined( RE_IndirectDiffuse )\\n\\tvec3 iblIrradiance = vec3( 0.0 );\\n\\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\\n\\t#if defined( USE_LIGHT_PROBES )\\n\\t\\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\\n\\t#endif\\n\\t#if ( NUM_HEMI_LIGHTS > 0 )\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\\n\\t\\t\\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n#endif\\n#if defined( RE_IndirectSpecular )\\n\\tvec3 radiance = vec3( 0.0 );\\n\\tvec3 clearcoatRadiance = vec3( 0.0 );\\n#endif",lights_fragment_maps:"#if defined( RE_IndirectDiffuse )\\n\\t#ifdef USE_LIGHTMAP\\n\\t\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\t\\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\\n\\t\\tirradiance += lightMapIrradiance;\\n\\t#endif\\n\\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\\n\\t\\tiblIrradiance += getIBLIrradiance( geometryNormal );\\n\\t#endif\\n#endif\\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\\n\\t#else\\n\\t\\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\\n\\t#endif\\n#endif",lights_fragment_end:"#if defined( RE_IndirectDiffuse )\\n\\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n#endif\\n#if defined( RE_IndirectSpecular )\\n\\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n#endif",logdepthbuf_fragment:"#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\\n\\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\\n#endif",logdepthbuf_pars_fragment:"#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\\n\\tuniform float logDepthBufFC;\\n\\tvarying float vFragDepth;\\n\\tvarying float vIsPerspective;\\n#endif",logdepthbuf_pars_vertex:"#ifdef USE_LOGDEPTHBUF\\n\\t#ifdef USE_LOGDEPTHBUF_EXT\\n\\t\\tvarying float vFragDepth;\\n\\t\\tvarying float vIsPerspective;\\n\\t#else\\n\\t\\tuniform float logDepthBufFC;\\n\\t#endif\\n#endif",logdepthbuf_vertex:"#ifdef USE_LOGDEPTHBUF\\n\\t#ifdef USE_LOGDEPTHBUF_EXT\\n\\t\\tvFragDepth = 1.0 + gl_Position.w;\\n\\t\\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\\n\\t#else\\n\\t\\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\\n\\t\\t\\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\\n\\t\\t\\tgl_Position.z *= gl_Position.w;\\n\\t\\t}\\n\\t#endif\\n#endif",map_fragment:"#ifdef USE_MAP\\n\\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\\n\\t#ifdef DECODE_VIDEO_TEXTURE\\n\\t\\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\\n\\t\\n\\t#endif\\n\\tdiffuseColor *= sampledDiffuseColor;\\n#endif",map_pars_fragment:"#ifdef USE_MAP\\n\\tuniform sampler2D map;\\n#endif",map_particle_fragment:"#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\\n\\t#if defined( USE_POINTS_UV )\\n\\t\\tvec2 uv = vUv;\\n\\t#else\\n\\t\\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\\n\\t#endif\\n#endif\\n#ifdef USE_MAP\\n\\tdiffuseColor *= texture2D( map, uv );\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\\n#endif",map_particle_pars_fragment:"#if defined( USE_POINTS_UV )\\n\\tvarying vec2 vUv;\\n#else\\n\\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\\n\\t\\tuniform mat3 uvTransform;\\n\\t#endif\\n#endif\\n#ifdef USE_MAP\\n\\tuniform sampler2D map;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tuniform sampler2D alphaMap;\\n#endif",metalnessmap_fragment:"float metalnessFactor = metalness;\\n#ifdef USE_METALNESSMAP\\n\\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\\n\\tmetalnessFactor *= texelMetalness.b;\\n#endif",metalnessmap_pars_fragment:"#ifdef USE_METALNESSMAP\\n\\tuniform sampler2D metalnessMap;\\n#endif",morphcolor_vertex:"#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\\n\\tvColor *= morphTargetBaseInfluence;\\n\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t#if defined( USE_COLOR_ALPHA )\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\\n\\t\\t#elif defined( USE_COLOR )\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\\n\\t\\t#endif\\n\\t}\\n#endif",morphnormal_vertex:"#ifdef USE_MORPHNORMALS\\n\\tobjectNormal *= morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\\n\\t\\t}\\n\\t#else\\n\\t\\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\\n\\t\\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\\n\\t\\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\\n\\t\\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\\n\\t#endif\\n#endif",morphtarget_pars_vertex:"#ifdef USE_MORPHTARGETS\\n\\tuniform float morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\\n\\t\\tuniform sampler2DArray morphTargetsTexture;\\n\\t\\tuniform ivec2 morphTargetsTextureSize;\\n\\t\\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\\n\\t\\t\\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\\n\\t\\t\\tint y = texelIndex / morphTargetsTextureSize.x;\\n\\t\\t\\tint x = texelIndex - y * morphTargetsTextureSize.x;\\n\\t\\t\\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\\n\\t\\t\\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\\n\\t\\t}\\n\\t#else\\n\\t\\t#ifndef USE_MORPHNORMALS\\n\\t\\t\\tuniform float morphTargetInfluences[ 8 ];\\n\\t\\t#else\\n\\t\\t\\tuniform float morphTargetInfluences[ 4 ];\\n\\t\\t#endif\\n\\t#endif\\n#endif",morphtarget_vertex:"#ifdef USE_MORPHTARGETS\\n\\ttransformed *= morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\\n\\t\\t}\\n\\t#else\\n\\t\\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\\n\\t\\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\\n\\t\\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\\n\\t\\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\\n\\t\\t#ifndef USE_MORPHNORMALS\\n\\t\\t\\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\\n\\t\\t\\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\\n\\t\\t\\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\\n\\t\\t\\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\\n\\t\\t#endif\\n\\t#endif\\n#endif",normal_fragment_begin:"float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\\n#ifdef FLAT_SHADED\\n\\tvec3 fdx = dFdx( vViewPosition );\\n\\tvec3 fdy = dFdy( vViewPosition );\\n\\tvec3 normal = normalize( cross( fdx, fdy ) );\\n#else\\n\\tvec3 normal = normalize( vNormal );\\n\\t#ifdef DOUBLE_SIDED\\n\\t\\tnormal *= faceDirection;\\n\\t#endif\\n#endif\\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\\n\\t#ifdef USE_TANGENT\\n\\t\\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\\n\\t#else\\n\\t\\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\\n\\t\\t#if defined( USE_NORMALMAP )\\n\\t\\t\\tvNormalMapUv\\n\\t\\t#elif defined( USE_CLEARCOAT_NORMALMAP )\\n\\t\\t\\tvClearcoatNormalMapUv\\n\\t\\t#else\\n\\t\\t\\tvUv\\n\\t\\t#endif\\n\\t\\t);\\n\\t#endif\\n\\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\\n\\t\\ttbn[0] *= faceDirection;\\n\\t\\ttbn[1] *= faceDirection;\\n\\t#endif\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\t#ifdef USE_TANGENT\\n\\t\\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\\n\\t#else\\n\\t\\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\\n\\t#endif\\n\\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\\n\\t\\ttbn2[0] *= faceDirection;\\n\\t\\ttbn2[1] *= faceDirection;\\n\\t#endif\\n#endif\\nvec3 nonPerturbedNormal = normal;",normal_fragment_maps:"#ifdef USE_NORMALMAP_OBJECTSPACE\\n\\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\\n\\t#ifdef FLIP_SIDED\\n\\t\\tnormal = - normal;\\n\\t#endif\\n\\t#ifdef DOUBLE_SIDED\\n\\t\\tnormal = normal * faceDirection;\\n\\t#endif\\n\\tnormal = normalize( normalMatrix * normal );\\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\\n\\tmapN.xy *= normalScale;\\n\\tnormal = normalize( tbn * mapN );\\n#elif defined( USE_BUMPMAP )\\n\\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\\n#endif",normal_pars_fragment:"#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n\\t#ifdef USE_TANGENT\\n\\t\\tvarying vec3 vTangent;\\n\\t\\tvarying vec3 vBitangent;\\n\\t#endif\\n#endif",normal_pars_vertex:"#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n\\t#ifdef USE_TANGENT\\n\\t\\tvarying vec3 vTangent;\\n\\t\\tvarying vec3 vBitangent;\\n\\t#endif\\n#endif",normal_vertex:"#ifndef FLAT_SHADED\\n\\tvNormal = normalize( transformedNormal );\\n\\t#ifdef USE_TANGENT\\n\\t\\tvTangent = normalize( transformedTangent );\\n\\t\\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\\n\\t#endif\\n#endif",normalmap_pars_fragment:"#ifdef USE_NORMALMAP\\n\\tuniform sampler2D normalMap;\\n\\tuniform vec2 normalScale;\\n#endif\\n#ifdef USE_NORMALMAP_OBJECTSPACE\\n\\tuniform mat3 normalMatrix;\\n#endif\\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\\n\\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\\n\\t\\tvec3 q0 = dFdx( eye_pos.xyz );\\n\\t\\tvec3 q1 = dFdy( eye_pos.xyz );\\n\\t\\tvec2 st0 = dFdx( uv.st );\\n\\t\\tvec2 st1 = dFdy( uv.st );\\n\\t\\tvec3 N = surf_norm;\\n\\t\\tvec3 q1perp = cross( q1, N );\\n\\t\\tvec3 q0perp = cross( N, q0 );\\n\\t\\tvec3 T = q1perp * st0.x + q0perp * st1.x;\\n\\t\\tvec3 B = q1perp * st0.y + q0perp * st1.y;\\n\\t\\tfloat det = max( dot( T, T ), dot( B, B ) );\\n\\t\\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\\n\\t\\treturn mat3( T * scale, B * scale, N );\\n\\t}\\n#endif",clearcoat_normal_fragment_begin:"#ifdef USE_CLEARCOAT\\n\\tvec3 clearcoatNormal = nonPerturbedNormal;\\n#endif",clearcoat_normal_fragment_maps:"#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\\n\\tclearcoatMapN.xy *= clearcoatNormalScale;\\n\\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\\n#endif",clearcoat_pars_fragment:"#ifdef USE_CLEARCOATMAP\\n\\tuniform sampler2D clearcoatMap;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tuniform sampler2D clearcoatNormalMap;\\n\\tuniform vec2 clearcoatNormalScale;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tuniform sampler2D clearcoatRoughnessMap;\\n#endif",iridescence_pars_fragment:"#ifdef USE_IRIDESCENCEMAP\\n\\tuniform sampler2D iridescenceMap;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tuniform sampler2D iridescenceThicknessMap;\\n#endif",opaque_fragment:"#ifdef OPAQUE\\ndiffuseColor.a = 1.0;\\n#endif\\n#ifdef USE_TRANSMISSION\\ndiffuseColor.a *= material.transmissionAlpha;\\n#endif\\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",packing:"vec3 packNormalToRGB( const in vec3 normal ) {\\n\\treturn normalize( normal ) * 0.5 + 0.5;\\n}\\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\\n\\treturn 2.0 * rgb.xyz - 1.0;\\n}\\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\\nconst float ShiftRight8 = 1. / 256.;\\nvec4 packDepthToRGBA( const in float v ) {\\n\\tvec4 r = vec4( fract( v * PackFactors ), v );\\n\\tr.yzw -= r.xyz * ShiftRight8;\\treturn r * PackUpscale;\\n}\\nfloat unpackRGBAToDepth( const in vec4 v ) {\\n\\treturn dot( v, UnpackFactors );\\n}\\nvec2 packDepthToRG( in highp float v ) {\\n\\treturn packDepthToRGBA( v ).yx;\\n}\\nfloat unpackRGToDepth( const in highp vec2 v ) {\\n\\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\\n}\\nvec4 pack2HalfToRGBA( vec2 v ) {\\n\\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\\n\\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\\n}\\nvec2 unpackRGBATo2Half( vec4 v ) {\\n\\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\\n}\\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\\n\\treturn ( viewZ + near ) / ( near - far );\\n}\\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\\n\\treturn depth * ( near - far ) - near;\\n}\\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\\n\\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\\n}\\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\\n\\treturn ( near * far ) / ( ( far - near ) * depth - far );\\n}",premultiplied_alpha_fragment:"#ifdef PREMULTIPLIED_ALPHA\\n\\tgl_FragColor.rgb *= gl_FragColor.a;\\n#endif",project_vertex:"vec4 mvPosition = vec4( transformed, 1.0 );\\n#ifdef USE_INSTANCING\\n\\tmvPosition = instanceMatrix * mvPosition;\\n#endif\\nmvPosition = modelViewMatrix * mvPosition;\\ngl_Position = projectionMatrix * mvPosition;",dithering_fragment:"#ifdef DITHERING\\n\\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\\n#endif",dithering_pars_fragment:"#ifdef DITHERING\\n\\tvec3 dithering( vec3 color ) {\\n\\t\\tfloat grid_position = rand( gl_FragCoord.xy );\\n\\t\\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\\n\\t\\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\\n\\t\\treturn color + dither_shift_RGB;\\n\\t}\\n#endif",roughnessmap_fragment:"float roughnessFactor = roughness;\\n#ifdef USE_ROUGHNESSMAP\\n\\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\\n\\troughnessFactor *= texelRoughness.g;\\n#endif",roughnessmap_pars_fragment:"#ifdef USE_ROUGHNESSMAP\\n\\tuniform sampler2D roughnessMap;\\n#endif",shadowmap_pars_fragment:"#if NUM_SPOT_LIGHT_COORDS > 0\\n\\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\\n#endif\\n#if NUM_SPOT_LIGHT_MAPS > 0\\n\\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\\n#endif\\n#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tstruct DirectionalLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t\\tstruct SpotLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tstruct PointLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t\\tfloat shadowCameraNear;\\n\\t\\t\\tfloat shadowCameraFar;\\n\\t\\t};\\n\\t\\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\\n\\t\\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\\n\\t}\\n\\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\\n\\t\\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\\n\\t}\\n\\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\\n\\t\\tfloat occlusion = 1.0;\\n\\t\\tvec2 distribution = texture2DDistribution( shadow, uv );\\n\\t\\tfloat hard_shadow = step( compare , distribution.x );\\n\\t\\tif (hard_shadow != 1.0 ) {\\n\\t\\t\\tfloat distance = compare - distribution.x ;\\n\\t\\t\\tfloat variance = max( 0.00000, distribution.y * distribution.y );\\n\\t\\t\\tfloat softness_probability = variance / (variance + distance * distance );\\t\\t\\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\\t\\t\\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\\n\\t\\t}\\n\\t\\treturn occlusion;\\n\\t}\\n\\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\\n\\t\\tfloat shadow = 1.0;\\n\\t\\tshadowCoord.xyz /= shadowCoord.w;\\n\\t\\tshadowCoord.z += shadowBias;\\n\\t\\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\\n\\t\\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\\n\\t\\tif ( frustumTest ) {\\n\\t\\t#if defined( SHADOWMAP_TYPE_PCF )\\n\\t\\t\\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\\n\\t\\t\\tfloat dx0 = - texelSize.x * shadowRadius;\\n\\t\\t\\tfloat dy0 = - texelSize.y * shadowRadius;\\n\\t\\t\\tfloat dx1 = + texelSize.x * shadowRadius;\\n\\t\\t\\tfloat dy1 = + texelSize.y * shadowRadius;\\n\\t\\t\\tfloat dx2 = dx0 / 2.0;\\n\\t\\t\\tfloat dy2 = dy0 / 2.0;\\n\\t\\t\\tfloat dx3 = dx1 / 2.0;\\n\\t\\t\\tfloat dy3 = dy1 / 2.0;\\n\\t\\t\\tshadow = (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\\n\\t\\t\\t) * ( 1.0 / 17.0 );\\n\\t\\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\\n\\t\\t\\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\\n\\t\\t\\tfloat dx = texelSize.x;\\n\\t\\t\\tfloat dy = texelSize.y;\\n\\t\\t\\tvec2 uv = shadowCoord.xy;\\n\\t\\t\\tvec2 f = fract( uv * shadowMapSize + 0.5 );\\n\\t\\t\\tuv -= f * texelSize;\\n\\t\\t\\tshadow = (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.x ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.x ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.y ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.y ) +\\n\\t\\t\\t\\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  f.x ),\\n\\t\\t\\t\\t\\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  f.x ),\\n\\t\\t\\t\\t\\t f.y )\\n\\t\\t\\t) * ( 1.0 / 9.0 );\\n\\t\\t#elif defined( SHADOWMAP_TYPE_VSM )\\n\\t\\t\\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\\n\\t\\t#else\\n\\t\\t\\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\\n\\t\\t#endif\\n\\t\\t}\\n\\t\\treturn shadow;\\n\\t}\\n\\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\\n\\t\\tvec3 absV = abs( v );\\n\\t\\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\\n\\t\\tabsV *= scaleToCube;\\n\\t\\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\\n\\t\\tvec2 planar = v.xy;\\n\\t\\tfloat almostATexel = 1.5 * texelSizeY;\\n\\t\\tfloat almostOne = 1.0 - almostATexel;\\n\\t\\tif ( absV.z >= almostOne ) {\\n\\t\\t\\tif ( v.z > 0.0 )\\n\\t\\t\\t\\tplanar.x = 4.0 - v.x;\\n\\t\\t} else if ( absV.x >= almostOne ) {\\n\\t\\t\\tfloat signX = sign( v.x );\\n\\t\\t\\tplanar.x = v.z * signX + 2.0 * signX;\\n\\t\\t} else if ( absV.y >= almostOne ) {\\n\\t\\t\\tfloat signY = sign( v.y );\\n\\t\\t\\tplanar.x = v.x + 2.0 * signY + 2.0;\\n\\t\\t\\tplanar.y = v.z * signY - 2.0;\\n\\t\\t}\\n\\t\\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\\n\\t}\\n\\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\\n\\t\\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\\n\\t\\tvec3 lightToPosition = shadowCoord.xyz;\\n\\t\\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\\t\\tdp += shadowBias;\\n\\t\\tvec3 bd3D = normalize( lightToPosition );\\n\\t\\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\\n\\t\\t\\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\\n\\t\\t\\treturn (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\\n\\t\\t\\t) * ( 1.0 / 9.0 );\\n\\t\\t#else\\n\\t\\t\\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\\n\\t\\t#endif\\n\\t}\\n#endif",shadowmap_pars_vertex:"#if NUM_SPOT_LIGHT_COORDS > 0\\n\\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\\n\\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\\n#endif\\n#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tstruct DirectionalLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\t\\tstruct SpotLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tstruct PointLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t\\tfloat shadowCameraNear;\\n\\t\\t\\tfloat shadowCameraFar;\\n\\t\\t};\\n\\t\\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t#endif\\n#endif",shadowmap_vertex:"#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\\n\\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\\n\\tvec4 shadowWorldPosition;\\n#endif\\n#if defined( USE_SHADOWMAP )\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\\n\\t\\t\\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\\n\\t\\t\\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\t\\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\\n\\t\\t\\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n#endif\\n#if NUM_SPOT_LIGHT_COORDS > 0\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\\n\\t\\tshadowWorldPosition = worldPosition;\\n\\t\\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\t\\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\\n\\t\\t#endif\\n\\t\\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif",shadowmask_pars_fragment:"float getShadowMask() {\\n\\tfloat shadow = 1.0;\\n\\t#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\tDirectionalLightShadow directionalLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tdirectionalLight = directionalLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\tSpotLightShadow spotLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tspotLight = spotLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\tPointLightShadow pointLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tpointLight = pointLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#endif\\n\\treturn shadow;\\n}",skinbase_vertex:"#ifdef USE_SKINNING\\n\\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\\n\\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\\n\\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\\n\\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\\n#endif",skinning_pars_vertex:"#ifdef USE_SKINNING\\n\\tuniform mat4 bindMatrix;\\n\\tuniform mat4 bindMatrixInverse;\\n\\tuniform highp sampler2D boneTexture;\\n\\tuniform int boneTextureSize;\\n\\tmat4 getBoneMatrix( const in float i ) {\\n\\t\\tfloat j = i * 4.0;\\n\\t\\tfloat x = mod( j, float( boneTextureSize ) );\\n\\t\\tfloat y = floor( j / float( boneTextureSize ) );\\n\\t\\tfloat dx = 1.0 / float( boneTextureSize );\\n\\t\\tfloat dy = 1.0 / float( boneTextureSize );\\n\\t\\ty = dy * ( y + 0.5 );\\n\\t\\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\\n\\t\\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\\n\\t\\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\\n\\t\\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\\n\\t\\tmat4 bone = mat4( v1, v2, v3, v4 );\\n\\t\\treturn bone;\\n\\t}\\n#endif",skinning_vertex:"#ifdef USE_SKINNING\\n\\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\\n\\tvec4 skinned = vec4( 0.0 );\\n\\tskinned += boneMatX * skinVertex * skinWeight.x;\\n\\tskinned += boneMatY * skinVertex * skinWeight.y;\\n\\tskinned += boneMatZ * skinVertex * skinWeight.z;\\n\\tskinned += boneMatW * skinVertex * skinWeight.w;\\n\\ttransformed = ( bindMatrixInverse * skinned ).xyz;\\n#endif",skinnormal_vertex:"#ifdef USE_SKINNING\\n\\tmat4 skinMatrix = mat4( 0.0 );\\n\\tskinMatrix += skinWeight.x * boneMatX;\\n\\tskinMatrix += skinWeight.y * boneMatY;\\n\\tskinMatrix += skinWeight.z * boneMatZ;\\n\\tskinMatrix += skinWeight.w * boneMatW;\\n\\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\\n\\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\\n\\t#ifdef USE_TANGENT\\n\\t\\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\\n\\t#endif\\n#endif",specularmap_fragment:"float specularStrength;\\n#ifdef USE_SPECULARMAP\\n\\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\\n\\tspecularStrength = texelSpecular.r;\\n#else\\n\\tspecularStrength = 1.0;\\n#endif",specularmap_pars_fragment:"#ifdef USE_SPECULARMAP\\n\\tuniform sampler2D specularMap;\\n#endif",tonemapping_fragment:"#if defined( TONE_MAPPING )\\n\\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\\n#endif",tonemapping_pars_fragment:"#ifndef saturate\\n#define saturate( a ) clamp( a, 0.0, 1.0 )\\n#endif\\nuniform float toneMappingExposure;\\nvec3 LinearToneMapping( vec3 color ) {\\n\\treturn saturate( toneMappingExposure * color );\\n}\\nvec3 ReinhardToneMapping( vec3 color ) {\\n\\tcolor *= toneMappingExposure;\\n\\treturn saturate( color / ( vec3( 1.0 ) + color ) );\\n}\\nvec3 OptimizedCineonToneMapping( vec3 color ) {\\n\\tcolor *= toneMappingExposure;\\n\\tcolor = max( vec3( 0.0 ), color - 0.004 );\\n\\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\\n}\\nvec3 RRTAndODTFit( vec3 v ) {\\n\\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\\n\\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\\n\\treturn a / b;\\n}\\nvec3 ACESFilmicToneMapping( vec3 color ) {\\n\\tconst mat3 ACESInputMat = mat3(\\n\\t\\tvec3( 0.59719, 0.07600, 0.02840 ),\\t\\tvec3( 0.35458, 0.90834, 0.13383 ),\\n\\t\\tvec3( 0.04823, 0.01566, 0.83777 )\\n\\t);\\n\\tconst mat3 ACESOutputMat = mat3(\\n\\t\\tvec3(  1.60475, -0.10208, -0.00327 ),\\t\\tvec3( -0.53108,  1.10813, -0.07276 ),\\n\\t\\tvec3( -0.07367, -0.00605,  1.07602 )\\n\\t);\\n\\tcolor *= toneMappingExposure / 0.6;\\n\\tcolor = ACESInputMat * color;\\n\\tcolor = RRTAndODTFit( color );\\n\\tcolor = ACESOutputMat * color;\\n\\treturn saturate( color );\\n}\\nvec3 CustomToneMapping( vec3 color ) { return color; }",transmission_fragment:"#ifdef USE_TRANSMISSION\\n\\tmaterial.transmission = transmission;\\n\\tmaterial.transmissionAlpha = 1.0;\\n\\tmaterial.thickness = thickness;\\n\\tmaterial.attenuationDistance = attenuationDistance;\\n\\tmaterial.attenuationColor = attenuationColor;\\n\\t#ifdef USE_TRANSMISSIONMAP\\n\\t\\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\\n\\t#endif\\n\\t#ifdef USE_THICKNESSMAP\\n\\t\\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\\n\\t#endif\\n\\tvec3 pos = vWorldPosition;\\n\\tvec3 v = normalize( cameraPosition - pos );\\n\\tvec3 n = inverseTransformDirection( normal, viewMatrix );\\n\\tvec4 transmitted = getIBLVolumeRefraction(\\n\\t\\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\\n\\t\\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\\n\\t\\tmaterial.attenuationColor, material.attenuationDistance );\\n\\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\\n\\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\\n#endif",transmission_pars_fragment:"#ifdef USE_TRANSMISSION\\n\\tuniform float transmission;\\n\\tuniform float thickness;\\n\\tuniform float attenuationDistance;\\n\\tuniform vec3 attenuationColor;\\n\\t#ifdef USE_TRANSMISSIONMAP\\n\\t\\tuniform sampler2D transmissionMap;\\n\\t#endif\\n\\t#ifdef USE_THICKNESSMAP\\n\\t\\tuniform sampler2D thicknessMap;\\n\\t#endif\\n\\tuniform vec2 transmissionSamplerSize;\\n\\tuniform sampler2D transmissionSamplerMap;\\n\\tuniform mat4 modelMatrix;\\n\\tuniform mat4 projectionMatrix;\\n\\tvarying vec3 vWorldPosition;\\n\\tfloat w0( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\\n\\t}\\n\\tfloat w1( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\\n\\t}\\n\\tfloat w2( float a ){\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\\n\\t}\\n\\tfloat w3( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * a * a );\\n\\t}\\n\\tfloat g0( float a ) {\\n\\t\\treturn w0( a ) + w1( a );\\n\\t}\\n\\tfloat g1( float a ) {\\n\\t\\treturn w2( a ) + w3( a );\\n\\t}\\n\\tfloat h0( float a ) {\\n\\t\\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\\n\\t}\\n\\tfloat h1( float a ) {\\n\\t\\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\\n\\t}\\n\\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\\n\\t\\tuv = uv * texelSize.zw + 0.5;\\n\\t\\tvec2 iuv = floor( uv );\\n\\t\\tvec2 fuv = fract( uv );\\n\\t\\tfloat g0x = g0( fuv.x );\\n\\t\\tfloat g1x = g1( fuv.x );\\n\\t\\tfloat h0x = h0( fuv.x );\\n\\t\\tfloat h1x = h1( fuv.x );\\n\\t\\tfloat h0y = h0( fuv.y );\\n\\t\\tfloat h1y = h1( fuv.y );\\n\\t\\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\\n\\t\\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\\n\\t\\t\\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\\n\\t}\\n\\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\\n\\t\\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\\n\\t\\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\\n\\t\\tvec2 fLodSizeInv = 1.0 / fLodSize;\\n\\t\\tvec2 cLodSizeInv = 1.0 / cLodSize;\\n\\t\\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\\n\\t\\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\\n\\t\\treturn mix( fSample, cSample, fract( lod ) );\\n\\t}\\n\\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\\n\\t\\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\\n\\t\\tvec3 modelScale;\\n\\t\\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\\n\\t\\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\\n\\t\\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\\n\\t\\treturn normalize( refractionVector ) * thickness * modelScale;\\n\\t}\\n\\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\\n\\t\\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\\n\\t}\\n\\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\\n\\t\\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\\n\\t\\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\\n\\t}\\n\\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\\n\\t\\tif ( isinf( attenuationDistance ) ) {\\n\\t\\t\\treturn vec3( 1.0 );\\n\\t\\t} else {\\n\\t\\t\\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\\n\\t\\t\\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\\t\\t\\treturn transmittance;\\n\\t\\t}\\n\\t}\\n\\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\\n\\t\\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\\n\\t\\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\\n\\t\\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\\n\\t\\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\\n\\t\\tvec3 refractedRayExit = position + transmissionRay;\\n\\t\\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\\n\\t\\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\\n\\t\\trefractionCoords += 1.0;\\n\\t\\trefractionCoords /= 2.0;\\n\\t\\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\\n\\t\\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\\n\\t\\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\\n\\t\\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\\n\\t\\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\\n\\t\\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\\n\\t}\\n#endif",uv_pars_fragment:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvarying vec2 vUv;\\n#endif\\n#ifdef USE_MAP\\n\\tvarying vec2 vMapUv;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tvarying vec2 vAlphaMapUv;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tvarying vec2 vLightMapUv;\\n#endif\\n#ifdef USE_AOMAP\\n\\tvarying vec2 vAoMapUv;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tvarying vec2 vBumpMapUv;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tvarying vec2 vNormalMapUv;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tvarying vec2 vEmissiveMapUv;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tvarying vec2 vMetalnessMapUv;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tvarying vec2 vRoughnessMapUv;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tvarying vec2 vAnisotropyMapUv;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tvarying vec2 vClearcoatMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvarying vec2 vClearcoatNormalMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tvarying vec2 vClearcoatRoughnessMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tvarying vec2 vIridescenceMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tvarying vec2 vIridescenceThicknessMapUv;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tvarying vec2 vSheenColorMapUv;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tvarying vec2 vSheenRoughnessMapUv;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tvarying vec2 vSpecularMapUv;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tvarying vec2 vSpecularColorMapUv;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tvarying vec2 vSpecularIntensityMapUv;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tuniform mat3 transmissionMapTransform;\\n\\tvarying vec2 vTransmissionMapUv;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tuniform mat3 thicknessMapTransform;\\n\\tvarying vec2 vThicknessMapUv;\\n#endif",uv_pars_vertex:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvarying vec2 vUv;\\n#endif\\n#ifdef USE_MAP\\n\\tuniform mat3 mapTransform;\\n\\tvarying vec2 vMapUv;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tuniform mat3 alphaMapTransform;\\n\\tvarying vec2 vAlphaMapUv;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tuniform mat3 lightMapTransform;\\n\\tvarying vec2 vLightMapUv;\\n#endif\\n#ifdef USE_AOMAP\\n\\tuniform mat3 aoMapTransform;\\n\\tvarying vec2 vAoMapUv;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tuniform mat3 bumpMapTransform;\\n\\tvarying vec2 vBumpMapUv;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tuniform mat3 normalMapTransform;\\n\\tvarying vec2 vNormalMapUv;\\n#endif\\n#ifdef USE_DISPLACEMENTMAP\\n\\tuniform mat3 displacementMapTransform;\\n\\tvarying vec2 vDisplacementMapUv;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tuniform mat3 emissiveMapTransform;\\n\\tvarying vec2 vEmissiveMapUv;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tuniform mat3 metalnessMapTransform;\\n\\tvarying vec2 vMetalnessMapUv;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tuniform mat3 roughnessMapTransform;\\n\\tvarying vec2 vRoughnessMapUv;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tuniform mat3 anisotropyMapTransform;\\n\\tvarying vec2 vAnisotropyMapUv;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tuniform mat3 clearcoatMapTransform;\\n\\tvarying vec2 vClearcoatMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tuniform mat3 clearcoatNormalMapTransform;\\n\\tvarying vec2 vClearcoatNormalMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tuniform mat3 clearcoatRoughnessMapTransform;\\n\\tvarying vec2 vClearcoatRoughnessMapUv;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tuniform mat3 sheenColorMapTransform;\\n\\tvarying vec2 vSheenColorMapUv;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tuniform mat3 sheenRoughnessMapTransform;\\n\\tvarying vec2 vSheenRoughnessMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tuniform mat3 iridescenceMapTransform;\\n\\tvarying vec2 vIridescenceMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tuniform mat3 iridescenceThicknessMapTransform;\\n\\tvarying vec2 vIridescenceThicknessMapUv;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tuniform mat3 specularMapTransform;\\n\\tvarying vec2 vSpecularMapUv;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tuniform mat3 specularColorMapTransform;\\n\\tvarying vec2 vSpecularColorMapUv;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tuniform mat3 specularIntensityMapTransform;\\n\\tvarying vec2 vSpecularIntensityMapUv;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tuniform mat3 transmissionMapTransform;\\n\\tvarying vec2 vTransmissionMapUv;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tuniform mat3 thicknessMapTransform;\\n\\tvarying vec2 vThicknessMapUv;\\n#endif",uv_vertex:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvUv = vec3( uv, 1 ).xy;\\n#endif\\n#ifdef USE_MAP\\n\\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_AOMAP\\n\\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_DISPLACEMENTMAP\\n\\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\\n#endif",worldpos_vertex:"#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\\n\\tvec4 worldPosition = vec4( transformed, 1.0 );\\n\\t#ifdef USE_INSTANCING\\n\\t\\tworldPosition = instanceMatrix * worldPosition;\\n\\t#endif\\n\\tworldPosition = modelMatrix * worldPosition;\\n#endif",background_vert:"varying vec2 vUv;\\nuniform mat3 uvTransform;\\nvoid main() {\\n\\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\\n\\tgl_Position = vec4( position.xy, 1.0, 1.0 );\\n}",background_frag:"uniform sampler2D t2D;\\nuniform float backgroundIntensity;\\nvarying vec2 vUv;\\nvoid main() {\\n\\tvec4 texColor = texture2D( t2D, vUv );\\n\\t#ifdef DECODE_VIDEO_TEXTURE\\n\\t\\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\\n\\t#endif\\n\\ttexColor.rgb *= backgroundIntensity;\\n\\tgl_FragColor = texColor;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",backgroundCube_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n\\tgl_Position.z = gl_Position.w;\\n}",backgroundCube_frag:"#ifdef ENVMAP_TYPE_CUBE\\n\\tuniform samplerCube envMap;\\n#elif defined( ENVMAP_TYPE_CUBE_UV )\\n\\tuniform sampler2D envMap;\\n#endif\\nuniform float flipEnvMap;\\nuniform float backgroundBlurriness;\\nuniform float backgroundIntensity;\\nvarying vec3 vWorldDirection;\\n#include <cube_uv_reflection_fragment>\\nvoid main() {\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\\n\\t#elif defined( ENVMAP_TYPE_CUBE_UV )\\n\\t\\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\\n\\t#else\\n\\t\\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\t#endif\\n\\ttexColor.rgb *= backgroundIntensity;\\n\\tgl_FragColor = texColor;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",cube_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n\\tgl_Position.z = gl_Position.w;\\n}",cube_frag:"uniform samplerCube tCube;\\nuniform float tFlip;\\nuniform float opacity;\\nvarying vec3 vWorldDirection;\\nvoid main() {\\n\\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\\n\\tgl_FragColor = texColor;\\n\\tgl_FragColor.a *= opacity;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",depth_vert:"#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvarying vec2 vHighPrecisionZW;\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#ifdef USE_DISPLACEMENTMAP\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvHighPrecisionZW = gl_Position.zw;\\n}",depth_frag:"#if DEPTH_PACKING == 3200\\n\\tuniform float opacity;\\n#endif\\n#include <common>\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvarying vec2 vHighPrecisionZW;\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( 1.0 );\\n\\t#if DEPTH_PACKING == 3200\\n\\t\\tdiffuseColor.a = opacity;\\n\\t#endif\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <logdepthbuf_fragment>\\n\\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\\n\\t#if DEPTH_PACKING == 3200\\n\\t\\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\\n\\t#elif DEPTH_PACKING == 3201\\n\\t\\tgl_FragColor = packDepthToRGBA( fragCoordZ );\\n\\t#endif\\n}",distanceRGBA_vert:"#define DISTANCE\\nvarying vec3 vWorldPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#ifdef USE_DISPLACEMENTMAP\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvWorldPosition = worldPosition.xyz;\\n}",distanceRGBA_frag:"#define DISTANCE\\nuniform vec3 referencePosition;\\nuniform float nearDistance;\\nuniform float farDistance;\\nvarying vec3 vWorldPosition;\\n#include <common>\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main () {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( 1.0 );\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\tfloat dist = length( vWorldPosition - referencePosition );\\n\\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\\n\\tdist = saturate( dist );\\n\\tgl_FragColor = packDepthToRGBA( dist );\\n}",equirect_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n}",equirect_frag:"uniform sampler2D tEquirect;\\nvarying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvec3 direction = normalize( vWorldDirection );\\n\\tvec2 sampleUV = equirectUv( direction );\\n\\tgl_FragColor = texture2D( tEquirect, sampleUV );\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",linedashed_vert:"uniform float scale;\\nattribute float lineDistance;\\nvarying float vLineDistance;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\tvLineDistance = scale * lineDistance;\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n}",linedashed_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\nuniform float dashSize;\\nuniform float totalSize;\\nvarying float vLineDistance;\\n#include <common>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\\n\\t\\tdiscard;\\n\\t}\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n}",meshbasic_vert:"#include <common>\\n#include <uv_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinbase_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t\\t#include <defaultnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshbasic_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n#endif\\n#include <common>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\t#ifdef USE_LIGHTMAP\\n\\t\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\t\\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\\n\\t#else\\n\\t\\treflectedLight.indirectDiffuse += vec3( 1.0 );\\n\\t#endif\\n\\t#include <aomap_fragment>\\n\\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\\n\\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshlambert_vert:"#define LAMBERT\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshlambert_frag:"#define LAMBERT\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_lambert_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_lambert_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshmatcap_vert:"#define MATCAP\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <color_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n}",meshmatcap_frag:"#define MATCAP\\nuniform vec3 diffuse;\\nuniform float opacity;\\nuniform sampler2D matcap;\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <normal_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\tvec3 viewDir = normalize( vViewPosition );\\n\\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\\n\\tvec3 y = cross( viewDir, x );\\n\\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\\n\\t#ifdef USE_MATCAP\\n\\t\\tvec4 matcapColor = texture2D( matcap, uv );\\n\\t#else\\n\\t\\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\\n\\t#endif\\n\\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshnormal_vert:"#define NORMAL\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvarying vec3 vViewPosition;\\n#endif\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvViewPosition = - mvPosition.xyz;\\n#endif\\n}",meshnormal_frag:"#define NORMAL\\nuniform float opacity;\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvarying vec3 vViewPosition;\\n#endif\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <normal_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\\n\\t#ifdef OPAQUE\\n\\t\\tgl_FragColor.a = 1.0;\\n\\t#endif\\n}",meshphong_vert:"#define PHONG\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshphong_frag:"#define PHONG\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform vec3 specular;\\nuniform float shininess;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_phong_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_phong_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshphysical_vert:"#define STANDARD\\nvarying vec3 vViewPosition;\\n#ifdef USE_TRANSMISSION\\n\\tvarying vec3 vWorldPosition;\\n#endif\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n#ifdef USE_TRANSMISSION\\n\\tvWorldPosition = worldPosition.xyz;\\n#endif\\n}",meshphysical_frag:"#define STANDARD\\n#ifdef PHYSICAL\\n\\t#define IOR\\n\\t#define USE_SPECULAR\\n#endif\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float roughness;\\nuniform float metalness;\\nuniform float opacity;\\n#ifdef IOR\\n\\tuniform float ior;\\n#endif\\n#ifdef USE_SPECULAR\\n\\tuniform float specularIntensity;\\n\\tuniform vec3 specularColor;\\n\\t#ifdef USE_SPECULAR_COLORMAP\\n\\t\\tuniform sampler2D specularColorMap;\\n\\t#endif\\n\\t#ifdef USE_SPECULAR_INTENSITYMAP\\n\\t\\tuniform sampler2D specularIntensityMap;\\n\\t#endif\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tuniform float clearcoat;\\n\\tuniform float clearcoatRoughness;\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tuniform float iridescence;\\n\\tuniform float iridescenceIOR;\\n\\tuniform float iridescenceThicknessMinimum;\\n\\tuniform float iridescenceThicknessMaximum;\\n#endif\\n#ifdef USE_SHEEN\\n\\tuniform vec3 sheenColor;\\n\\tuniform float sheenRoughness;\\n\\t#ifdef USE_SHEEN_COLORMAP\\n\\t\\tuniform sampler2D sheenColorMap;\\n\\t#endif\\n\\t#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\t\\tuniform sampler2D sheenRoughnessMap;\\n\\t#endif\\n#endif\\n#ifdef USE_ANISOTROPY\\n\\tuniform vec2 anisotropyVector;\\n\\t#ifdef USE_ANISOTROPYMAP\\n\\t\\tuniform sampler2D anisotropyMap;\\n\\t#endif\\n#endif\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <iridescence_fragment>\\n#include <cube_uv_reflection_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_physical_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_physical_pars_fragment>\\n#include <transmission_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <clearcoat_pars_fragment>\\n#include <iridescence_pars_fragment>\\n#include <roughnessmap_pars_fragment>\\n#include <metalnessmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <roughnessmap_fragment>\\n\\t#include <metalnessmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <clearcoat_normal_fragment_begin>\\n\\t#include <clearcoat_normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_physical_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\\n\\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\\n\\t#include <transmission_fragment>\\n\\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\\n\\t#ifdef USE_SHEEN\\n\\t\\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\\n\\t\\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\\n\\t\\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\\n\\t\\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\\n\\t#endif\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshtoon_vert:"#define TOON\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshtoon_frag:"#define TOON\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <gradientmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_toon_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_toon_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",points_vert:"uniform float size;\\nuniform float scale;\\n#include <common>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\n#ifdef USE_POINTS_UV\\n\\tvarying vec2 vUv;\\n\\tuniform mat3 uvTransform;\\n#endif\\nvoid main() {\\n\\t#ifdef USE_POINTS_UV\\n\\t\\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\\n\\t#endif\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <project_vertex>\\n\\tgl_PointSize = size;\\n\\t#ifdef USE_SIZEATTENUATION\\n\\t\\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\\n\\t\\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\\n\\t#endif\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <fog_vertex>\\n}",points_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#include <common>\\n#include <color_pars_fragment>\\n#include <map_particle_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_particle_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n}",shadow_vert:"#include <common>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <shadowmap_pars_vertex>\\nvoid main() {\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",shadow_frag:"uniform vec3 color;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <logdepthbuf_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <shadowmask_pars_fragment>\\nvoid main() {\\n\\t#include <logdepthbuf_fragment>\\n\\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n}",sprite_vert:"uniform float rotation;\\nuniform vec2 center;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\tvec2 scale;\\n\\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\\n\\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\\n\\t#ifndef USE_SIZEATTENUATION\\n\\t\\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\\n\\t\\tif ( isPerspective ) scale *= - mvPosition.z;\\n\\t#endif\\n\\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\\n\\tvec2 rotatedPosition;\\n\\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\\n\\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\\n\\tmvPosition.xy += rotatedPosition;\\n\\tgl_Position = projectionMatrix * mvPosition;\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n}",sprite_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#include <common>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n}"},ji={common:{diffuse:{value:new On(16777215)},opacity:{value:1},map:{value:null},mapTransform:{value:new We},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0}},specularmap:{specularMap:{value:null},specularMapTransform:{value:new We}},envmap:{envMap:{value:null},flipEnvMap:{value:-1},reflectivity:{value:1},ior:{value:1.5},refractionRatio:{value:.98}},aomap:{aoMap:{value:null},aoMapIntensity:{value:1},aoMapTransform:{value:new We}},lightmap:{lightMap:{value:null},lightMapIntensity:{value:1},lightMapTransform:{value:new We}},bumpmap:{bumpMap:{value:null},bumpMapTransform:{value:new We},bumpScale:{value:1}},normalmap:{normalMap:{value:null},normalMapTransform:{value:new We},normalScale:{value:new ke(1,1)}},displacementmap:{displacementMap:{value:null},displacementMapTransform:{value:new We},displacementScale:{value:1},displacementBias:{value:0}},emissivemap:{emissiveMap:{value:null},emissiveMapTransform:{value:new We}},metalnessmap:{metalnessMap:{value:null},metalnessMapTransform:{value:new We}},roughnessmap:{roughnessMap:{value:null},roughnessMapTransform:{value:new We}},gradientmap:{gradientMap:{value:null}},fog:{fogDensity:{value:25e-5},fogNear:{value:1},fogFar:{value:2e3},fogColor:{value:new On(16777215)}},lights:{ambientLightColor:{value:[]},lightProbe:{value:[]},directionalLights:{value:[],properties:{direction:{},color:{}}},directionalLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},directionalShadowMap:{value:[]},directionalShadowMatrix:{value:[]},spotLights:{value:[],properties:{color:{},position:{},direction:{},distance:{},coneCos:{},penumbraCos:{},decay:{}}},spotLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},spotLightMap:{value:[]},spotShadowMap:{value:[]},spotLightMatrix:{value:[]},pointLights:{value:[],properties:{color:{},position:{},decay:{},distance:{}}},pointLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{},shadowCameraNear:{},shadowCameraFar:{}}},pointShadowMap:{value:[]},pointShadowMatrix:{value:[]},hemisphereLights:{value:[],properties:{direction:{},skyColor:{},groundColor:{}}},rectAreaLights:{value:[],properties:{color:{},position:{},width:{},height:{}}},ltc_1:{value:null},ltc_2:{value:null}},points:{diffuse:{value:new On(16777215)},opacity:{value:1},size:{value:1},scale:{value:1},map:{value:null},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0},uvTransform:{value:new We}},sprite:{diffuse:{value:new On(16777215)},opacity:{value:1},center:{value:new ke(.5,.5)},rotation:{value:0},map:{value:null},mapTransform:{value:new We},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0}}},qi={basic:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.fog]),vertexShader:Xi.meshbasic_vert,fragmentShader:Xi.meshbasic_frag},lambert:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,ji.lights,{emissive:{value:new On(0)}}]),vertexShader:Xi.meshlambert_vert,fragmentShader:Xi.meshlambert_frag},phong:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,ji.lights,{emissive:{value:new On(0)},specular:{value:new On(1118481)},shininess:{value:30}}]),vertexShader:Xi.meshphong_vert,fragmentShader:Xi.meshphong_frag},standard:{uniforms:bi([ji.common,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.roughnessmap,ji.metalnessmap,ji.fog,ji.lights,{emissive:{value:new On(0)},roughness:{value:1},metalness:{value:0},envMapIntensity:{value:1}}]),vertexShader:Xi.meshphysical_vert,fragmentShader:Xi.meshphysical_frag},toon:{uniforms:bi([ji.common,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.gradientmap,ji.fog,ji.lights,{emissive:{value:new On(0)}}]),vertexShader:Xi.meshtoon_vert,fragmentShader:Xi.meshtoon_frag},matcap:{uniforms:bi([ji.common,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,{matcap:{value:null}}]),vertexShader:Xi.meshmatcap_vert,fragmentShader:Xi.meshmatcap_frag},points:{uniforms:bi([ji.points,ji.fog]),vertexShader:Xi.points_vert,fragmentShader:Xi.points_frag},dashed:{uniforms:bi([ji.common,ji.fog,{scale:{value:1},dashSize:{value:1},totalSize:{value:2}}]),vertexShader:Xi.linedashed_vert,fragmentShader:Xi.linedashed_frag},depth:{uniforms:bi([ji.common,ji.displacementmap]),vertexShader:Xi.depth_vert,fragmentShader:Xi.depth_frag},normal:{uniforms:bi([ji.common,ji.bumpmap,ji.normalmap,ji.displacementmap,{opacity:{value:1}}]),vertexShader:Xi.meshnormal_vert,fragmentShader:Xi.meshnormal_frag},sprite:{uniforms:bi([ji.sprite,ji.fog]),vertexShader:Xi.sprite_vert,fragmentShader:Xi.sprite_frag},background:{uniforms:{uvTransform:{value:new We},t2D:{value:null},backgroundIntensity:{value:1}},vertexShader:Xi.background_vert,fragmentShader:Xi.background_frag},backgroundCube:{uniforms:{envMap:{value:null},flipEnvMap:{value:-1},backgroundBlurriness:{value:0},backgroundIntensity:{value:1}},vertexShader:Xi.backgroundCube_vert,fragmentShader:Xi.backgroundCube_frag},cube:{uniforms:{tCube:{value:null},tFlip:{value:-1},opacity:{value:1}},vertexShader:Xi.cube_vert,fragmentShader:Xi.cube_frag},equirect:{uniforms:{tEquirect:{value:null}},vertexShader:Xi.equirect_vert,fragmentShader:Xi.equirect_frag},distanceRGBA:{uniforms:bi([ji.common,ji.displacementmap,{referencePosition:{value:new _t},nearDistance:{value:1},farDistance:{value:1e3}}]),vertexShader:Xi.distanceRGBA_vert,fragmentShader:Xi.distanceRGBA_frag},shadow:{uniforms:bi([ji.lights,ji.fog,{color:{value:new On(0)},opacity:{value:1}}]),vertexShader:Xi.shadow_vert,fragmentShader:Xi.shadow_frag}};qi.physical={uniforms:bi([qi.standard.uniforms,{clearcoat:{value:0},clearcoatMap:{value:null},clearcoatMapTransform:{value:new We},clearcoatNormalMap:{value:null},clearcoatNormalMapTransform:{value:new We},clearcoatNormalScale:{value:new ke(1,1)},clearcoatRoughness:{value:0},clearcoatRoughnessMap:{value:null},clearcoatRoughnessMapTransform:{value:new We},iridescence:{value:0},iridescenceMap:{value:null},iridescenceMapTransform:{value:new We},iridescenceIOR:{value:1.3},iridescenceThicknessMinimum:{value:100},iridescenceThicknessMaximum:{value:400},iridescenceThicknessMap:{value:null},iridescenceThicknessMapTransform:{value:new We},sheen:{value:0},sheenColor:{value:new On(0)},sheenColorMap:{value:null},sheenColorMapTransform:{value:new We},sheenRoughness:{value:1},sheenRoughnessMap:{value:null},sheenRoughnessMapTransform:{value:new We},transmission:{value:0},transmissionMap:{value:null},transmissionMapTransform:{value:new We},transmissionSamplerSize:{value:new ke},transmissionSamplerMap:{value:null},thickness:{value:0},thicknessMap:{value:null},thicknessMapTransform:{value:new We},attenuationDistance:{value:0},attenuationColor:{value:new On(0)},specularColor:{value:new On(1,1,1)},specularColorMap:{value:null},specularColorMapTransform:{value:new We},specularIntensity:{value:1},specularIntensityMap:{value:null},specularIntensityMapTransform:{value:new We},anisotropyVector:{value:new ke},anisotropyMap:{value:null},anisotropyMapTransform:{value:new We}}]),vertexShader:Xi.meshphysical_vert,fragmentShader:Xi.meshphysical_frag};const Yi={r:0,b:0,g:0};function Ki(e,t,n,i,r,a,s){const o=new On(0);let l,c,h=!0===a?0:1,u=null,d=0,p=null;function f(t,n){t.getRGB(Yi,wi(e)),i.buffers.color.setClear(Yi.r,Yi.g,Yi.b,n,s)}return{getClearColor:function(){return o},setClearColor:function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;o.set(e),h=t,f(o,h)},getClearAlpha:function(){return h},setClearAlpha:function(e){h=e,f(o,h)},render:function(a,m){let g=!1,_=!0===m.isScene?m.background:null;_&&_.isTexture&&(_=(m.backgroundBlurriness>0?n:t).get(_)),null===_?f(o,h):_&&_.isColor&&(f(_,1),g=!0);const v=e.xr.getEnvironmentBlendMode();"additive"===v?i.buffers.color.setClear(0,0,0,1,s):"alpha-blend"===v&&i.buffers.color.setClear(0,0,0,0,s),(e.autoClear||g)&&e.clear(e.autoClearColor,e.autoClearDepth,e.autoClearStencil),_&&(_.isCubeTexture||_.mapping===O)?(void 0===c&&(c=new Si(new Ei(1,1,1),new Ri({name:"BackgroundCubeMaterial",uniforms:Ti(qi.backgroundCube.uniforms),vertexShader:qi.backgroundCube.vertexShader,fragmentShader:qi.backgroundCube.fragmentShader,side:1,depthTest:!1,depthWrite:!1,fog:!1})),c.geometry.deleteAttribute("normal"),c.geometry.deleteAttribute("uv"),c.onBeforeRender=function(e,t,n){this.matrixWorld.copyPosition(n.matrixWorld)},Object.defineProperty(c.material,"envMap",{get:function(){return this.uniforms.envMap.value}}),r.update(c)),c.material.uniforms.envMap.value=_,c.material.uniforms.flipEnvMap.value=_.isCubeTexture&&!1===_.isRenderTargetTexture?-1:1,c.material.uniforms.backgroundBlurriness.value=m.backgroundBlurriness,c.material.uniforms.backgroundIntensity.value=m.backgroundIntensity,c.material.toneMapped=tt.getTransfer(_.colorSpace)!==ge,u===_&&d===_.version&&p===e.toneMapping||(c.material.needsUpdate=!0,u=_,d=_.version,p=e.toneMapping),c.layers.enableAll(),a.unshift(c,c.geometry,c.material,0,0,null)):_&&_.isTexture&&(void 0===l&&(l=new Si(new Wi(2,2),new Ri({name:"BackgroundMaterial",uniforms:Ti(qi.background.uniforms),vertexShader:qi.background.vertexShader,fragmentShader:qi.background.fragmentShader,side:0,depthTest:!1,depthWrite:!1,fog:!1})),l.geometry.deleteAttribute("normal"),Object.defineProperty(l.material,"map",{get:function(){return this.uniforms.t2D.value}}),r.update(l)),l.material.uniforms.t2D.value=_,l.material.uniforms.backgroundIntensity.value=m.backgroundIntensity,l.material.toneMapped=tt.getTransfer(_.colorSpace)!==ge,!0===_.matrixAutoUpdate&&_.updateMatrix(),l.material.uniforms.uvTransform.value.copy(_.matrix),u===_&&d===_.version&&p===e.toneMapping||(l.material.needsUpdate=!0,u=_,d=_.version,p=e.toneMapping),l.layers.enableAll(),a.unshift(l,l.geometry,l.material,0,0,null))}}}function Zi(e,t,n,i){const r=e.getParameter(e.MAX_VERTEX_ATTRIBS),a=i.isWebGL2?null:t.get("OES_vertex_array_object"),s=i.isWebGL2||null!==a,o={},l=p(null);let c=l,h=!1;function u(t){return i.isWebGL2?e.bindVertexArray(t):a.bindVertexArrayOES(t)}function d(t){return i.isWebGL2?e.deleteVertexArray(t):a.deleteVertexArrayOES(t)}function p(e){const t=[],n=[],i=[];for(let e=0;e<r;e++)t[e]=0,n[e]=0,i[e]=0;return{geometry:null,program:null,wireframe:!1,newAttributes:t,enabledAttributes:n,attributeDivisors:i,object:e,attributes:{},index:null}}function f(){const e=c.newAttributes;for(let t=0,n=e.length;t<n;t++)e[t]=0}function m(e){g(e,0)}function g(n,r){const a=c.newAttributes,s=c.enabledAttributes,o=c.attributeDivisors;a[n]=1,0===s[n]&&(e.enableVertexAttribArray(n),s[n]=1),o[n]!==r&&((i.isWebGL2?e:t.get("ANGLE_instanced_arrays"))[i.isWebGL2?"vertexAttribDivisor":"vertexAttribDivisorANGLE"](n,r),o[n]=r)}function _(){const t=c.newAttributes,n=c.enabledAttributes;for(let i=0,r=n.length;i<r;i++)n[i]!==t[i]&&(e.disableVertexAttribArray(i),n[i]=0)}function v(t,n,i,r,a,s,o){!0===o?e.vertexAttribIPointer(t,n,i,a,s):e.vertexAttribPointer(t,n,i,r,a,s)}function x(){M(),h=!0,c!==l&&(c=l,u(c.object))}function M(){l.geometry=null,l.program=null,l.wireframe=!1}return{setup:function(r,l,d,x,M){let S=!1;if(s){const t=function(t,n,r){const s=!0===r.wireframe;let l=o[t.id];void 0===l&&(l={},o[t.id]=l);let c=l[n.id];void 0===c&&(c={},l[n.id]=c);let h=c[s];return void 0===h&&(h=p(i.isWebGL2?e.createVertexArray():a.createVertexArrayOES()),c[s]=h),h}(x,d,l);c!==t&&(c=t,u(c.object)),S=function(e,t,n,i){const r=c.attributes,a=t.attributes;let s=0;const o=n.getAttributes();for(const t in o)if(o[t].location>=0){const n=r[t];let i=a[t];if(void 0===i&&("instanceMatrix"===t&&e.instanceMatrix&&(i=e.instanceMatrix),"instanceColor"===t&&e.instanceColor&&(i=e.instanceColor)),void 0===n)return!0;if(n.attribute!==i)return!0;if(i&&n.data!==i.data)return!0;s++}return c.attributesNum!==s||c.index!==i}(r,x,d,M),S&&function(e,t,n,i){const r={},a=t.attributes;let s=0;const o=n.getAttributes();for(const t in o)if(o[t].location>=0){let n=a[t];void 0===n&&("instanceMatrix"===t&&e.instanceMatrix&&(n=e.instanceMatrix),"instanceColor"===t&&e.instanceColor&&(n=e.instanceColor));const i={};i.attribute=n,n&&n.data&&(i.data=n.data),r[t]=i,s++}c.attributes=r,c.attributesNum=s,c.index=i}(r,x,d,M)}else{const e=!0===l.wireframe;c.geometry===x.id&&c.program===d.id&&c.wireframe===e||(c.geometry=x.id,c.program=d.id,c.wireframe=e,S=!0)}null!==M&&n.update(M,e.ELEMENT_ARRAY_BUFFER),(S||h)&&(h=!1,function(r,a,s,o){if(!1===i.isWebGL2&&(r.isInstancedMesh||o.isInstancedBufferGeometry)&&null===t.get("ANGLE_instanced_arrays"))return;f();const l=o.attributes,c=s.getAttributes(),h=a.defaultAttributeValues;for(const t in c){const a=c[t];if(a.location>=0){let s=l[t];if(void 0===s&&("instanceMatrix"===t&&r.instanceMatrix&&(s=r.instanceMatrix),"instanceColor"===t&&r.instanceColor&&(s=r.instanceColor)),void 0!==s){const t=s.normalized,l=s.itemSize,c=n.get(s);if(void 0===c)continue;const h=c.buffer,u=c.type,d=c.bytesPerElement,p=!0===i.isWebGL2&&(u===e.INT||u===e.UNSIGNED_INT||1013===s.gpuType);if(s.isInterleavedBufferAttribute){const n=s.data,i=n.stride,c=s.offset;if(n.isInstancedInterleavedBuffer){for(let e=0;e<a.locationSize;e++)g(a.location+e,n.meshPerAttribute);!0!==r.isInstancedMesh&&void 0===o._maxInstanceCount&&(o._maxInstanceCount=n.meshPerAttribute*n.count)}else for(let e=0;e<a.locationSize;e++)m(a.location+e);e.bindBuffer(e.ARRAY_BUFFER,h);for(let e=0;e<a.locationSize;e++)v(a.location+e,l/a.locationSize,u,t,i*d,(c+l/a.locationSize*e)*d,p)}else{if(s.isInstancedBufferAttribute){for(let e=0;e<a.locationSize;e++)g(a.location+e,s.meshPerAttribute);!0!==r.isInstancedMesh&&void 0===o._maxInstanceCount&&(o._maxInstanceCount=s.meshPerAttribute*s.count)}else for(let e=0;e<a.locationSize;e++)m(a.location+e);e.bindBuffer(e.ARRAY_BUFFER,h);for(let e=0;e<a.locationSize;e++)v(a.location+e,l/a.locationSize,u,t,l*d,l/a.locationSize*e*d,p)}}else if(void 0!==h){const n=h[t];if(void 0!==n)switch(n.length){case 2:e.vertexAttrib2fv(a.location,n);break;case 3:e.vertexAttrib3fv(a.location,n);break;case 4:e.vertexAttrib4fv(a.location,n);break;default:e.vertexAttrib1fv(a.location,n)}}}}_()}(r,l,d,x),null!==M&&e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,n.get(M).buffer))},reset:x,resetDefaultState:M,dispose:function(){x();for(const e in o){const t=o[e];for(const e in t){const n=t[e];for(const e in n)d(n[e].object),delete n[e];delete t[e]}delete o[e]}},releaseStatesOfGeometry:function(e){if(void 0===o[e.id])return;const t=o[e.id];for(const e in t){const n=t[e];for(const e in n)d(n[e].object),delete n[e];delete t[e]}delete o[e.id]},releaseStatesOfProgram:function(e){for(const t in o){const n=o[t];if(void 0===n[e.id])continue;const i=n[e.id];for(const e in i)d(i[e].object),delete i[e];delete n[e.id]}},initAttributes:f,enableAttribute:m,disableUnusedAttributes:_}}function Ji(e,t,n,i){const r=i.isWebGL2;let a;this.setMode=function(e){a=e},this.render=function(t,i){e.drawArrays(a,t,i),n.update(i,a,1)},this.renderInstances=function(i,s,o){if(0===o)return;let l,c;if(r)l=e,c="drawArraysInstanced";else if(l=t.get("ANGLE_instanced_arrays"),c="drawArraysInstancedANGLE",null===l)return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");l[c](a,i,s,o),n.update(s,a,o)}}function Qi(e,t,n){let i;function r(t){if("highp"===t){if(e.getShaderPrecisionFormat(e.VERTEX_SHADER,e.HIGH_FLOAT).precision>0&&e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.HIGH_FLOAT).precision>0)return"highp";t="mediump"}return"mediump"===t&&e.getShaderPrecisionFormat(e.VERTEX_SHADER,e.MEDIUM_FLOAT).precision>0&&e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.MEDIUM_FLOAT).precision>0?"mediump":"lowp"}const a="undefined"!=typeof WebGL2RenderingContext&&"WebGL2RenderingContext"===e.constructor.name;let s=void 0!==n.precision?n.precision:"highp";const o=r(s);o!==s&&(console.warn("THREE.WebGLRenderer:",s,"not supported, using",o,"instead."),s=o);const l=a||t.has("WEBGL_draw_buffers"),c=!0===n.logarithmicDepthBuffer,h=e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),u=e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),d=e.getParameter(e.MAX_TEXTURE_SIZE),p=e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),f=e.getParameter(e.MAX_VERTEX_ATTRIBS),m=e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),g=e.getParameter(e.MAX_VARYING_VECTORS),_=e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),v=u>0,x=a||t.has("OES_texture_float");return{isWebGL2:a,drawBuffers:l,getMaxAnisotropy:function(){if(void 0!==i)return i;if(!0===t.has("EXT_texture_filter_anisotropic")){const n=t.get("EXT_texture_filter_anisotropic");i=e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT)}else i=0;return i},getMaxPrecision:r,precision:s,logarithmicDepthBuffer:c,maxTextures:h,maxVertexTextures:u,maxTextureSize:d,maxCubemapSize:p,maxAttributes:f,maxVertexUniforms:m,maxVaryings:g,maxFragmentUniforms:_,vertexTextures:v,floatFragmentTextures:x,floatVertexTextures:v&&x,maxSamples:a?e.getParameter(e.MAX_SAMPLES):0}}function $i(e){const t=this;let n=null,i=0,r=!1,a=!1;const s=new zi,o=new We,l={value:null,needsUpdate:!1};function c(e,n,i,r){const a=null!==e?e.length:0;let c=null;if(0!==a){if(c=l.value,!0!==r||null===c){const t=i+4*a,r=n.matrixWorldInverse;o.getNormalMatrix(r),(null===c||c.length<t)&&(c=new Float32Array(t));for(let t=0,n=i;t!==a;++t,n+=4)s.copy(e[t]).applyMatrix4(r,o),s.normal.toArray(c,n),c[n+3]=s.constant}l.value=c,l.needsUpdate=!0}return t.numPlanes=a,t.numIntersection=0,c}this.uniform=l,this.numPlanes=0,this.numIntersection=0,this.init=function(e,t){const n=0!==e.length||t||0!==i||r;return r=t,i=e.length,n},this.beginShadows=function(){a=!0,c(null)},this.endShadows=function(){a=!1},this.setGlobalState=function(e,t){n=c(e,t,0)},this.setState=function(s,o,h){const u=s.clippingPlanes,d=s.clipIntersection,p=s.clipShadows,f=e.get(s);if(!r||null===u||0===u.length||a&&!p)a?c(null):(l.value!==n&&(l.value=n,l.needsUpdate=i>0),t.numPlanes=i,t.numIntersection=0);else{const e=a?0:i,t=4*e;let r=f.clippingState||null;l.value=r,r=c(u,o,t,h);for(let e=0;e!==t;++e)r[e]=n[e];f.clippingState=r,this.numIntersection=d?this.numPlanes:0,this.numPlanes+=e}}}function er(e){let t=new WeakMap;function n(e,t){return 303===t?e.mapping=N:304===t&&(e.mapping=I),e}function i(e){const n=e.target;n.removeEventListener("dispose",i);const r=t.get(n);void 0!==r&&(t.delete(n),r.dispose())}return{get:function(r){if(r&&r.isTexture&&!1===r.isRenderTargetTexture){const a=r.mapping;if(303===a||304===a){if(t.has(r))return n(t.get(r).texture,r.mapping);{const a=r.image;if(a&&a.height>0){const s=new Ni(a.height/2);return s.fromEquirectangularTexture(e,r),t.set(r,s),r.addEventListener("dispose",i),n(s.texture,r.mapping)}return null}}}return r},dispose:function(){t=new WeakMap}}}class tr extends Ci{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:-1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:-1,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:.1,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:2e3;super(),this.isOrthographicCamera=!0,this.type="OrthographicCamera",this.zoom=1,this.view=null,this.left=e,this.right=t,this.top=n,this.bottom=i,this.near=r,this.far=a,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.left=e.left,this.right=e.right,this.top=e.top,this.bottom=e.bottom,this.near=e.near,this.far=e.far,this.zoom=e.zoom,this.view=null===e.view?null:Object.assign({},e.view),this}setViewOffset(e,t,n,i,r,a){null===this.view&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=i,this.view.width=r,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){null!==this.view&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){const e=(this.right-this.left)/(2*this.zoom),t=(this.top-this.bottom)/(2*this.zoom),n=(this.right+this.left)/2,i=(this.top+this.bottom)/2;let r=n-e,a=n+e,s=i+t,o=i-t;if(null!==this.view&&this.view.enabled){const e=(this.right-this.left)/this.view.fullWidth/this.zoom,t=(this.top-this.bottom)/this.view.fullHeight/this.zoom;r+=e*this.view.offsetX,a=r+e*this.view.width,s-=t*this.view.offsetY,o=s-t*this.view.height}this.projectionMatrix.makeOrthographic(r,a,s,o,this.near,this.far,this.coordinateSystem),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){const t=super.toJSON(e);return t.object.zoom=this.zoom,t.object.left=this.left,t.object.right=this.right,t.object.top=this.top,t.object.bottom=this.bottom,t.object.near=this.near,t.object.far=this.far,null!==this.view&&(t.object.view=Object.assign({},this.view)),t}}const nr=[.125,.215,.35,.446,.526,.582],ir=new tr,rr=new On;let ar=null,sr=0,or=0;const lr=(1+Math.sqrt(5))/2,cr=1/lr,hr=[new _t(1,1,1),new _t(-1,1,1),new _t(1,1,-1),new _t(-1,1,-1),new _t(0,lr,cr),new _t(0,lr,-cr),new _t(cr,0,lr),new _t(-cr,0,lr),new _t(lr,cr,0),new _t(-lr,cr,0)];class ur{constructor(e){this._renderer=e,this._pingPongRenderTarget=null,this._lodMax=0,this._cubeSize=0,this._lodPlanes=[],this._sizeLods=[],this._sigmas=[],this._blurMaterial=null,this._cubemapMaterial=null,this._equirectMaterial=null,this._compileMaterial(this._blurMaterial)}fromScene(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:100;ar=this._renderer.getRenderTarget(),sr=this._renderer.getActiveCubeFace(),or=this._renderer.getActiveMipmapLevel(),this._setSize(256);const r=this._allocateTargets();return r.depthBuffer=!0,this._sceneToCubeUV(e,n,i,r),t>0&&this._blur(r,0,0,t),this._applyPMREM(r),this._cleanup(r),r}fromEquirectangular(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return this._fromTexture(e,t)}fromCubemap(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return this._fromTexture(e,t)}compileCubemapShader(){null===this._cubemapMaterial&&(this._cubemapMaterial=mr(),this._compileMaterial(this._cubemapMaterial))}compileEquirectangularShader(){null===this._equirectMaterial&&(this._equirectMaterial=fr(),this._compileMaterial(this._equirectMaterial))}dispose(){this._dispose(),null!==this._cubemapMaterial&&this._cubemapMaterial.dispose(),null!==this._equirectMaterial&&this._equirectMaterial.dispose()}_setSize(e){this._lodMax=Math.floor(Math.log2(e)),this._cubeSize=Math.pow(2,this._lodMax)}_dispose(){null!==this._blurMaterial&&this._blurMaterial.dispose(),null!==this._pingPongRenderTarget&&this._pingPongRenderTarget.dispose();for(let e=0;e<this._lodPlanes.length;e++)this._lodPlanes[e].dispose()}_cleanup(e){this._renderer.setRenderTarget(ar,sr,or),e.scissorTest=!1,pr(e,0,0,e.width,e.height)}_fromTexture(e,t){e.mapping===N||e.mapping===I?this._setSize(0===e.image.length?16:e.image[0].width||e.image[0].image.width):this._setSize(e.image.width/4),ar=this._renderer.getRenderTarget(),sr=this._renderer.getActiveCubeFace(),or=this._renderer.getActiveMipmapLevel();const n=t||this._allocateTargets();return this._textureToCubeUV(e,n),this._applyPMREM(n),this._cleanup(n),n}_allocateTargets(){const e=3*Math.max(this._cubeSize,112),t=4*this._cubeSize,n={magFilter:k,minFilter:k,generateMipmaps:!1,type:Z,format:Q,colorSpace:de,depthBuffer:!1},i=dr(e,t,n);if(null===this._pingPongRenderTarget||this._pingPongRenderTarget.width!==e||this._pingPongRenderTarget.height!==t){null!==this._pingPongRenderTarget&&this._dispose(),this._pingPongRenderTarget=dr(e,t,n);const{_lodMax:i}=this;({sizeLods:this._sizeLods,lodPlanes:this._lodPlanes,sigmas:this._sigmas}=function(e){const t=[],n=[],i=[];let r=e;const a=e-4+1+nr.length;for(let s=0;s<a;s++){const a=Math.pow(2,r);n.push(a);let o=1/a;s>e-4?o=nr[s-e+4-1]:0===s&&(o=0),i.push(o);const l=1/(a-2),c=-l,h=1+l,u=[c,c,h,c,h,h,c,c,h,h,c,h],d=6,p=6,f=3,m=2,g=1,_=new Float32Array(f*p*d),v=new Float32Array(m*p*d),x=new Float32Array(g*p*d);for(let e=0;e<d;e++){const t=e%3*2/3-1,n=e>2?0:-1,i=[t,n,0,t+2/3,n,0,t+2/3,n+1,0,t,n,0,t+2/3,n+1,0,t,n+1,0];_.set(i,f*p*e),v.set(u,m*p*e);const r=[e,e,e,e,e,e];x.set(r,g*p*e)}const M=new ii;M.setAttribute("position",new jn(_,f)),M.setAttribute("uv",new jn(v,m)),M.setAttribute("faceIndex",new jn(x,g)),t.push(M),r>4&&r--}return{lodPlanes:t,sizeLods:n,sigmas:i}}(i)),this._blurMaterial=function(e,t,n){const i=new Float32Array(20),r=new _t(0,1,0);return new Ri({name:"SphericalGaussianBlur",defines:{n:20,CUBEUV_TEXEL_WIDTH:1/t,CUBEUV_TEXEL_HEIGHT:1/n,CUBEUV_MAX_MIP:`${e}.0`},uniforms:{envMap:{value:null},samples:{value:1},weights:{value:i},latitudinal:{value:!1},dTheta:{value:0},mipInt:{value:0},poleAxis:{value:r}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform sampler2D envMap;\\n\\t\\t\\tuniform int samples;\\n\\t\\t\\tuniform float weights[ n ];\\n\\t\\t\\tuniform bool latitudinal;\\n\\t\\t\\tuniform float dTheta;\\n\\t\\t\\tuniform float mipInt;\\n\\t\\t\\tuniform vec3 poleAxis;\\n\\n\\t\\t\\t#define ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\t#include <cube_uv_reflection_fragment>\\n\\n\\t\\t\\tvec3 getSample( float theta, vec3 axis ) {\\n\\n\\t\\t\\t\\tfloat cosTheta = cos( theta );\\n\\t\\t\\t\\t// Rodrigues\' axis-angle rotation\\n\\t\\t\\t\\tvec3 sampleDirection = vOutputDirection * cosTheta\\n\\t\\t\\t\\t\\t+ cross( axis, vOutputDirection ) * sin( theta )\\n\\t\\t\\t\\t\\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\\n\\n\\t\\t\\t\\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\\n\\n\\t\\t\\t\\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\\n\\n\\t\\t\\t\\t\\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\taxis = normalize( axis );\\n\\n\\t\\t\\t\\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\t\\t\\t\\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\\n\\n\\t\\t\\t\\tfor ( int i = 1; i < n; i++ ) {\\n\\n\\t\\t\\t\\t\\tif ( i >= samples ) {\\n\\n\\t\\t\\t\\t\\t\\tbreak;\\n\\n\\t\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\t\\tfloat theta = dTheta * float( i );\\n\\t\\t\\t\\t\\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\\n\\t\\t\\t\\t\\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}(i,e,t)}return i}_compileMaterial(e){const t=new Si(this._lodPlanes[0],e);this._renderer.compile(t,ir)}_sceneToCubeUV(e,t,n,i){const r=new Li(90,1,t,n),a=[1,-1,1,1,1,1],s=[1,1,1,-1,-1,-1],o=this._renderer,l=o.autoClear,c=o.toneMapping;o.getClearColor(rr),o.toneMapping=R,o.autoClear=!1;const h=new Hn({name:"PMREM.Background",side:1,depthWrite:!1,depthTest:!1}),u=new Si(new Ei,h);let d=!1;const p=e.background;p?p.isColor&&(h.color.copy(p),e.background=null,d=!0):(h.color.copy(rr),d=!0);for(let t=0;t<6;t++){const n=t%3;0===n?(r.up.set(0,a[t],0),r.lookAt(s[t],0,0)):1===n?(r.up.set(0,0,a[t]),r.lookAt(0,s[t],0)):(r.up.set(0,a[t],0),r.lookAt(0,0,s[t]));const l=this._cubeSize;pr(i,n*l,t>2?l:0,l,l),o.setRenderTarget(i),d&&o.render(u,r),o.render(e,r)}u.geometry.dispose(),u.material.dispose(),o.toneMapping=c,o.autoClear=l,e.background=p}_textureToCubeUV(e,t){const n=this._renderer,i=e.mapping===N||e.mapping===I;i?(null===this._cubemapMaterial&&(this._cubemapMaterial=mr()),this._cubemapMaterial.uniforms.flipEnvMap.value=!1===e.isRenderTargetTexture?-1:1):null===this._equirectMaterial&&(this._equirectMaterial=fr());const r=i?this._cubemapMaterial:this._equirectMaterial,a=new Si(this._lodPlanes[0],r);r.uniforms.envMap.value=e;const s=this._cubeSize;pr(t,0,0,3*s,2*s),n.setRenderTarget(t),n.render(a,ir)}_applyPMREM(e){const t=this._renderer,n=t.autoClear;t.autoClear=!1;for(let t=1;t<this._lodPlanes.length;t++){const n=Math.sqrt(this._sigmas[t]*this._sigmas[t]-this._sigmas[t-1]*this._sigmas[t-1]),i=hr[(t-1)%hr.length];this._blur(e,t-1,t,n,i)}t.autoClear=n}_blur(e,t,n,i,r){const a=this._pingPongRenderTarget;this._halfBlur(e,a,t,n,i,"latitudinal",r),this._halfBlur(a,e,n,n,i,"longitudinal",r)}_halfBlur(e,t,n,i,r,a,s){const o=this._renderer,l=this._blurMaterial;"latitudinal"!==a&&"longitudinal"!==a&&console.error("blur direction must be either latitudinal or longitudinal!");const c=new Si(this._lodPlanes[i],l),h=l.uniforms,u=this._sizeLods[n]-1,d=isFinite(r)?Math.PI/(2*u):2*Math.PI/39,p=r/d,f=isFinite(r)?1+Math.floor(3*p):20;f>20&&console.warn(`sigmaRadians, ${r}, is too large and will clip, as it requested ${f} samples when the maximum is set to 20`);const m=[];let g=0;for(let e=0;e<20;++e){const t=e/p,n=Math.exp(-t*t/2);m.push(n),0===e?g+=n:e<f&&(g+=2*n)}for(let e=0;e<m.length;e++)m[e]=m[e]/g;h.envMap.value=e.texture,h.samples.value=f,h.weights.value=m,h.latitudinal.value="latitudinal"===a,s&&(h.poleAxis.value=s);const{_lodMax:_}=this;h.dTheta.value=d,h.mipInt.value=_-n;const v=this._sizeLods[i];pr(t,3*v*(i>_-4?i-_+4:0),4*(this._cubeSize-v),3*v,2*v),o.setRenderTarget(t),o.render(c,ir)}}function dr(e,t,n){const i=new pt(e,t,n);return i.texture.mapping=O,i.texture.name="PMREM.cubeUv",i.scissorTest=!0,i}function pr(e,t,n,i,r){e.viewport.set(t,n,i,r),e.scissor.set(t,n,i,r)}function fr(){return new Ri({name:"EquirectangularToCubeUV",uniforms:{envMap:{value:null}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform sampler2D envMap;\\n\\n\\t\\t\\t#include <common>\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tvec3 outputDirection = normalize( vOutputDirection );\\n\\t\\t\\t\\tvec2 uv = equirectUv( outputDirection );\\n\\n\\t\\t\\t\\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}function mr(){return new Ri({name:"CubemapToCubeUV",uniforms:{envMap:{value:null},flipEnvMap:{value:-1}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tuniform float flipEnvMap;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform samplerCube envMap;\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}function gr(e){let t=new WeakMap,n=null;function i(e){const n=e.target;n.removeEventListener("dispose",i);const r=t.get(n);void 0!==r&&(t.delete(n),r.dispose())}return{get:function(r){if(r&&r.isTexture){const a=r.mapping,s=303===a||304===a,o=a===N||a===I;if(s||o){if(r.isRenderTargetTexture&&!0===r.needsPMREMUpdate){r.needsPMREMUpdate=!1;let i=t.get(r);return null===n&&(n=new ur(e)),i=s?n.fromEquirectangular(r,i):n.fromCubemap(r,i),t.set(r,i),i.texture}if(t.has(r))return t.get(r).texture;{const a=r.image;if(s&&a&&a.height>0||o&&a&&function(e){let t=0;for(let n=0;n<6;n++)void 0!==e[n]&&t++;return 6===t}(a)){null===n&&(n=new ur(e));const a=s?n.fromEquirectangular(r):n.fromCubemap(r);return t.set(r,a),r.addEventListener("dispose",i),a.texture}return null}}}return r},dispose:function(){t=new WeakMap,null!==n&&(n.dispose(),n=null)}}}function _r(e){const t={};function n(n){if(void 0!==t[n])return t[n];let i;switch(n){case"WEBGL_depth_texture":i=e.getExtension("WEBGL_depth_texture")||e.getExtension("MOZ_WEBGL_depth_texture")||e.getExtension("WEBKIT_WEBGL_depth_texture");break;case"EXT_texture_filter_anisotropic":i=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");break;case"WEBGL_compressed_texture_s3tc":i=e.getExtension("WEBGL_compressed_texture_s3tc")||e.getExtension("MOZ_WEBGL_compressed_texture_s3tc")||e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");break;case"WEBGL_compressed_texture_pvrtc":i=e.getExtension("WEBGL_compressed_texture_pvrtc")||e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");break;default:i=e.getExtension(n)}return t[n]=i,i}return{has:function(e){return null!==n(e)},init:function(e){e.isWebGL2?n("EXT_color_buffer_float"):(n("WEBGL_depth_texture"),n("OES_texture_float"),n("OES_texture_half_float"),n("OES_texture_half_float_linear"),n("OES_standard_derivatives"),n("OES_element_index_uint"),n("OES_vertex_array_object"),n("ANGLE_instanced_arrays")),n("OES_texture_float_linear"),n("EXT_color_buffer_half_float"),n("WEBGL_multisampled_render_to_texture")},get:function(e){const t=n(e);return null===t&&console.warn("THREE.WebGLRenderer: "+e+" extension not supported."),t}}}function vr(e,t,n,i){const r={},a=new WeakMap;function s(e){const o=e.target;null!==o.index&&t.remove(o.index);for(const e in o.attributes)t.remove(o.attributes[e]);for(const e in o.morphAttributes){const n=o.morphAttributes[e];for(let e=0,i=n.length;e<i;e++)t.remove(n[e])}o.removeEventListener("dispose",s),delete r[o.id];const l=a.get(o);l&&(t.remove(l),a.delete(o)),i.releaseStatesOfGeometry(o),!0===o.isInstancedBufferGeometry&&delete o._maxInstanceCount,n.memory.geometries--}function o(e){const n=[],i=e.index,r=e.attributes.position;let s=0;if(null!==i){const e=i.array;s=i.version;for(let t=0,i=e.length;t<i;t+=3){const i=e[t+0],r=e[t+1],a=e[t+2];n.push(i,r,r,a,a,i)}}else{if(void 0===r)return;{const e=r.array;s=r.version;for(let t=0,i=e.length/3-1;t<i;t+=3){const e=t+0,i=t+1,r=t+2;n.push(e,i,i,r,r,e)}}}const o=new(je(n)?Yn:qn)(n,1);o.version=s;const l=a.get(e);l&&t.remove(l),a.set(e,o)}return{get:function(e,t){return!0===r[t.id]||(t.addEventListener("dispose",s),r[t.id]=!0,n.memory.geometries++),t},update:function(n){const i=n.attributes;for(const n in i)t.update(i[n],e.ARRAY_BUFFER);const r=n.morphAttributes;for(const n in r){const i=r[n];for(let n=0,r=i.length;n<r;n++)t.update(i[n],e.ARRAY_BUFFER)}},getWireframeAttribute:function(e){const t=a.get(e);if(t){const n=e.index;null!==n&&t.version<n.version&&o(e)}else o(e);return a.get(e)}}}function xr(e,t,n,i){const r=i.isWebGL2;let a,s,o;this.setMode=function(e){a=e},this.setIndex=function(e){s=e.type,o=e.bytesPerElement},this.render=function(t,i){e.drawElements(a,i,s,t*o),n.update(i,a,1)},this.renderInstances=function(i,l,c){if(0===c)return;let h,u;if(r)h=e,u="drawElementsInstanced";else if(h=t.get("ANGLE_instanced_arrays"),u="drawElementsInstancedANGLE",null===h)return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");h[u](a,l,s,i*o,c),n.update(l,a,c)}}function Mr(e){const t={frame:0,calls:0,triangles:0,points:0,lines:0};return{memory:{geometries:0,textures:0},render:t,programs:null,autoReset:!0,reset:function(){t.calls=0,t.triangles=0,t.points=0,t.lines=0},update:function(n,i,r){switch(t.calls++,i){case e.TRIANGLES:t.triangles+=r*(n/3);break;case e.LINES:t.lines+=r*(n/2);break;case e.LINE_STRIP:t.lines+=r*(n-1);break;case e.LINE_LOOP:t.lines+=r*n;break;case e.POINTS:t.points+=r*n;break;default:console.error("THREE.WebGLInfo: Unknown draw mode:",i)}}}}function Sr(e,t){return e[0]-t[0]}function yr(e,t){return Math.abs(t[1])-Math.abs(e[1])}function Er(e,t,n){const i={},r=new Float32Array(8),a=new WeakMap,s=new ut,o=[];for(let e=0;e<8;e++)o[e]=[e,0];return{update:function(l,c,h){const u=l.morphTargetInfluences;if(!0===t.isWebGL2){const d=c.morphAttributes.position||c.morphAttributes.normal||c.morphAttributes.color,p=void 0!==d?d.length:0;let f=a.get(c);if(void 0===f||f.count!==p){void 0!==f&&f.texture.dispose();const _=void 0!==c.morphAttributes.position,v=void 0!==c.morphAttributes.normal,x=void 0!==c.morphAttributes.color,M=c.morphAttributes.position||[],S=c.morphAttributes.normal||[],y=c.morphAttributes.color||[];let E=0;!0===_&&(E=1),!0===v&&(E=2),!0===x&&(E=3);let T=c.attributes.position.count*E,b=1;T>t.maxTextureSize&&(b=Math.ceil(T/t.maxTextureSize),T=t.maxTextureSize);const w=new Float32Array(T*b*4*p),A=new ft(w,T,b,p);A.type=K,A.needsUpdate=!0;const R=4*E;for(let L=0;L<p;L++){const P=M[L],U=S[L],D=y[L],N=T*b*4*L;for(let I=0;I<P.count;I++){const O=I*R;!0===_&&(s.fromBufferAttribute(P,I),w[N+O+0]=s.x,w[N+O+1]=s.y,w[N+O+2]=s.z,w[N+O+3]=0),!0===v&&(s.fromBufferAttribute(U,I),w[N+O+4]=s.x,w[N+O+5]=s.y,w[N+O+6]=s.z,w[N+O+7]=0),!0===x&&(s.fromBufferAttribute(D,I),w[N+O+8]=s.x,w[N+O+9]=s.y,w[N+O+10]=s.z,w[N+O+11]=4===D.itemSize?s.w:1)}}function C(){A.dispose(),a.delete(c),c.removeEventListener("dispose",C)}f={count:p,texture:A,size:new ke(T,b)},a.set(c,f),c.addEventListener("dispose",C)}let m=0;for(let F=0;F<u.length;F++)m+=u[F];const g=c.morphTargetsRelative?1:1-m;h.getUniforms().setValue(e,"morphTargetBaseInfluence",g),h.getUniforms().setValue(e,"morphTargetInfluences",u),h.getUniforms().setValue(e,"morphTargetsTexture",f.texture,n),h.getUniforms().setValue(e,"morphTargetsTextureSize",f.size)}else{const z=void 0===u?0:u.length;let B=i[c.id];if(void 0===B||B.length!==z){B=[];for(let W=0;W<z;W++)B[W]=[W,0];i[c.id]=B}for(let X=0;X<z;X++){const j=B[X];j[0]=X,j[1]=u[X]}B.sort(yr);for(let q=0;q<8;q++)q<z&&B[q][1]?(o[q][0]=B[q][0],o[q][1]=B[q][1]):(o[q][0]=Number.MAX_SAFE_INTEGER,o[q][1]=0);o.sort(Sr);const H=c.morphAttributes.position,V=c.morphAttributes.normal;let G=0;for(let Y=0;Y<8;Y++){const Z=o[Y],J=Z[0],Q=Z[1];J!==Number.MAX_SAFE_INTEGER&&Q?(H&&c.getAttribute("morphTarget"+Y)!==H[J]&&c.setAttribute("morphTarget"+Y,H[J]),V&&c.getAttribute("morphNormal"+Y)!==V[J]&&c.setAttribute("morphNormal"+Y,V[J]),r[Y]=Q,G+=Q):(H&&!0===c.hasAttribute("morphTarget"+Y)&&c.deleteAttribute("morphTarget"+Y),V&&!0===c.hasAttribute("morphNormal"+Y)&&c.deleteAttribute("morphNormal"+Y),r[Y]=0)}const k=c.morphTargetsRelative?1:1-G;h.getUniforms().setValue(e,"morphTargetBaseInfluence",k),h.getUniforms().setValue(e,"morphTargetInfluences",r)}}}}function Tr(e,t,n,i){let r=new WeakMap;function a(e){const t=e.target;t.removeEventListener("dispose",a),n.remove(t.instanceMatrix),null!==t.instanceColor&&n.remove(t.instanceColor)}return{update:function(s){const o=i.render.frame,l=s.geometry,c=t.get(s,l);if(r.get(c)!==o&&(t.update(c),r.set(c,o)),s.isInstancedMesh&&(!1===s.hasEventListener("dispose",a)&&s.addEventListener("dispose",a),r.get(s)!==o&&(n.update(s.instanceMatrix,e.ARRAY_BUFFER),null!==s.instanceColor&&n.update(s.instanceColor,e.ARRAY_BUFFER),r.set(s,o))),s.isSkinnedMesh){const e=s.skeleton;r.get(e)!==o&&(e.update(),r.set(e,o))}return c},dispose:function(){r=new WeakMap}}}const br=new ht,wr=new ft,Ar=new mt,Rr=new Di,Cr=[],Lr=[],Pr=new Float32Array(16),Ur=new Float32Array(9),Dr=new Float32Array(4);function Nr(e,t,n){const i=e[0];if(i<=0||i>0)return e;const r=t*n;let a=Cr[r];if(void 0===a&&(a=new Float32Array(r),Cr[r]=a),0!==t){i.toArray(a,0);for(let i=1,r=0;i!==t;++i)r+=n,e[i].toArray(a,r)}return a}function Ir(e,t){if(e.length!==t.length)return!1;for(let n=0,i=e.length;n<i;n++)if(e[n]!==t[n])return!1;return!0}function Or(e,t){for(let n=0,i=t.length;n<i;n++)e[n]=t[n]}function Fr(e,t){let n=Lr[t];void 0===n&&(n=new Int32Array(t),Lr[t]=n);for(let i=0;i!==t;++i)n[i]=e.allocateTextureUnit();return n}function zr(e,t){const n=this.cache;n[0]!==t&&(e.uniform1f(this.addr,t),n[0]=t)}function Br(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2f(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Ir(n,t))return;e.uniform2fv(this.addr,t),Or(n,t)}}function Hr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3f(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else if(void 0!==t.r)n[0]===t.r&&n[1]===t.g&&n[2]===t.b||(e.uniform3f(this.addr,t.r,t.g,t.b),n[0]=t.r,n[1]=t.g,n[2]=t.b);else{if(Ir(n,t))return;e.uniform3fv(this.addr,t),Or(n,t)}}function Vr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4f(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Ir(n,t))return;e.uniform4fv(this.addr,t),Or(n,t)}}function Gr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Ir(n,t))return;e.uniformMatrix2fv(this.addr,!1,t),Or(n,t)}else{if(Ir(n,i))return;Dr.set(i),e.uniformMatrix2fv(this.addr,!1,Dr),Or(n,i)}}function kr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Ir(n,t))return;e.uniformMatrix3fv(this.addr,!1,t),Or(n,t)}else{if(Ir(n,i))return;Ur.set(i),e.uniformMatrix3fv(this.addr,!1,Ur),Or(n,i)}}function Wr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Ir(n,t))return;e.uniformMatrix4fv(this.addr,!1,t),Or(n,t)}else{if(Ir(n,i))return;Pr.set(i),e.uniformMatrix4fv(this.addr,!1,Pr),Or(n,i)}}function Xr(e,t){const n=this.cache;n[0]!==t&&(e.uniform1i(this.addr,t),n[0]=t)}function jr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2i(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Ir(n,t))return;e.uniform2iv(this.addr,t),Or(n,t)}}function qr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3i(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else{if(Ir(n,t))return;e.uniform3iv(this.addr,t),Or(n,t)}}function Yr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4i(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Ir(n,t))return;e.uniform4iv(this.addr,t),Or(n,t)}}function Kr(e,t){const n=this.cache;n[0]!==t&&(e.uniform1ui(this.addr,t),n[0]=t)}function Zr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2ui(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Ir(n,t))return;e.uniform2uiv(this.addr,t),Or(n,t)}}function Jr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3ui(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else{if(Ir(n,t))return;e.uniform3uiv(this.addr,t),Or(n,t)}}function Qr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4ui(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Ir(n,t))return;e.uniform4uiv(this.addr,t),Or(n,t)}}function $r(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture2D(t||br,r)}function ea(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture3D(t||Ar,r)}function ta(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTextureCube(t||Rr,r)}function na(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture2DArray(t||wr,r)}function ia(e,t){e.uniform1fv(this.addr,t)}function ra(e,t){const n=Nr(t,this.size,2);e.uniform2fv(this.addr,n)}function aa(e,t){const n=Nr(t,this.size,3);e.uniform3fv(this.addr,n)}function sa(e,t){const n=Nr(t,this.size,4);e.uniform4fv(this.addr,n)}function oa(e,t){const n=Nr(t,this.size,4);e.uniformMatrix2fv(this.addr,!1,n)}function la(e,t){const n=Nr(t,this.size,9);e.uniformMatrix3fv(this.addr,!1,n)}function ca(e,t){const n=Nr(t,this.size,16);e.uniformMatrix4fv(this.addr,!1,n)}function ha(e,t){e.uniform1iv(this.addr,t)}function ua(e,t){e.uniform2iv(this.addr,t)}function da(e,t){e.uniform3iv(this.addr,t)}function pa(e,t){e.uniform4iv(this.addr,t)}function fa(e,t){e.uniform1uiv(this.addr,t)}function ma(e,t){e.uniform2uiv(this.addr,t)}function ga(e,t){e.uniform3uiv(this.addr,t)}function _a(e,t){e.uniform4uiv(this.addr,t)}function va(e,t,n){const i=this.cache,r=t.length,a=Fr(n,r);Ir(i,a)||(e.uniform1iv(this.addr,a),Or(i,a));for(let e=0;e!==r;++e)n.setTexture2D(t[e]||br,a[e])}function xa(e,t,n){const i=this.cache,r=t.length,a=Fr(n,r);Ir(i,a)||(e.uniform1iv(this.addr,a),Or(i,a));for(let e=0;e!==r;++e)n.setTexture3D(t[e]||Ar,a[e])}function Ma(e,t,n){const i=this.cache,r=t.length,a=Fr(n,r);Ir(i,a)||(e.uniform1iv(this.addr,a),Or(i,a));for(let e=0;e!==r;++e)n.setTextureCube(t[e]||Rr,a[e])}function Sa(e,t,n){const i=this.cache,r=t.length,a=Fr(n,r);Ir(i,a)||(e.uniform1iv(this.addr,a),Or(i,a));for(let e=0;e!==r;++e)n.setTexture2DArray(t[e]||wr,a[e])}class ya{constructor(e,t,n){this.id=e,this.addr=n,this.cache=[],this.setValue=function(e){switch(e){case 5126:return zr;case 35664:return Br;case 35665:return Hr;case 35666:return Vr;case 35674:return Gr;case 35675:return kr;case 35676:return Wr;case 5124:case 35670:return Xr;case 35667:case 35671:return jr;case 35668:case 35672:return qr;case 35669:case 35673:return Yr;case 5125:return Kr;case 36294:return Zr;case 36295:return Jr;case 36296:return Qr;case 35678:case 36198:case 36298:case 36306:case 35682:return $r;case 35679:case 36299:case 36307:return ea;case 35680:case 36300:case 36308:case 36293:return ta;case 36289:case 36303:case 36311:case 36292:return na}}(t.type)}}class Ea{constructor(e,t,n){this.id=e,this.addr=n,this.cache=[],this.size=t.size,this.setValue=function(e){switch(e){case 5126:return ia;case 35664:return ra;case 35665:return aa;case 35666:return sa;case 35674:return oa;case 35675:return la;case 35676:return ca;case 5124:case 35670:return ha;case 35667:case 35671:return ua;case 35668:case 35672:return da;case 35669:case 35673:return pa;case 5125:return fa;case 36294:return ma;case 36295:return ga;case 36296:return _a;case 35678:case 36198:case 36298:case 36306:case 35682:return va;case 35679:case 36299:case 36307:return xa;case 35680:case 36300:case 36308:case 36293:return Ma;case 36289:case 36303:case 36311:case 36292:return Sa}}(t.type)}}class Ta{constructor(e){this.id=e,this.seq=[],this.map={}}setValue(e,t,n){const i=this.seq;for(let r=0,a=i.length;r!==a;++r){const a=i[r];a.setValue(e,t[a.id],n)}}}const ba=/(\\w+)(\\])?(\\[|\\.)?/g;function wa(e,t){e.seq.push(t),e.map[t.id]=t}function Aa(e,t,n){const i=e.name,r=i.length;for(ba.lastIndex=0;;){const a=ba.exec(i),s=ba.lastIndex;let o=a[1];const l="]"===a[2],c=a[3];if(l&&(o|=0),void 0===c||"["===c&&s+2===r){wa(n,void 0===c?new ya(o,e,t):new Ea(o,e,t));break}{let e=n.map[o];void 0===e&&(e=new Ta(o),wa(n,e)),n=e}}}class Ra{constructor(e,t){this.seq=[],this.map={};const n=e.getProgramParameter(t,e.ACTIVE_UNIFORMS);for(let i=0;i<n;++i){const n=e.getActiveUniform(t,i);Aa(n,e.getUniformLocation(t,n.name),this)}}setValue(e,t,n,i){const r=this.map[t];void 0!==r&&r.setValue(e,n,i)}setOptional(e,t,n){const i=t[n];void 0!==i&&this.setValue(e,n,i)}static upload(e,t,n,i){for(let r=0,a=t.length;r!==a;++r){const a=t[r],s=n[a.id];!1!==s.needsUpdate&&a.setValue(e,s.value,i)}}static seqWithValue(e,t){const n=[];for(let i=0,r=e.length;i!==r;++i){const r=e[i];r.id in t&&n.push(r)}return n}}function Ca(e,t,n){const i=e.createShader(t);return e.shaderSource(i,n),e.compileShader(i),i}const La=37297;let Pa=0;function Ua(e,t,n){const i=e.getShaderParameter(t,e.COMPILE_STATUS),r=e.getShaderInfoLog(t).trim();if(i&&""===r)return"";const a=/ERROR: 0:(\\d+)/.exec(r);if(a){const i=parseInt(a[1]);return n.toUpperCase()+"\\n\\n"+r+"\\n\\n"+function(e,t){const n=e.split("\\n"),i=[],r=Math.max(t-6,0),a=Math.min(t+6,n.length);for(let e=r;e<a;e++){const r=e+1;i.push(`${r===t?">":" "} ${r}: ${n[e]}`)}return i.join("\\n")}(e.getShaderSource(t),i)}return r}function Da(e,t){const n=function(e){const t=tt.getPrimaries(tt.workingColorSpace),n=tt.getPrimaries(e);let i;switch(t===n?i="":t===ve&&n===_e?i="LinearDisplayP3ToLinearSRGB":t===_e&&n===ve&&(i="LinearSRGBToLinearDisplayP3"),e){case de:case fe:return[i,"LinearTransferOETF"];case ue:case pe:return[i,"sRGBTransferOETF"];default:return console.warn("THREE.WebGLProgram: Unsupported color space:",e),[i,"LinearTransferOETF"]}}(t);return`vec4 ${e}( vec4 value ) { return ${n[0]}( ${n[1]}( value ) ); }`}function Na(e,t){let n;switch(t){case C:n="Linear";break;case L:n="Reinhard";break;case P:n="OptimizedCineon";break;case U:n="ACESFilmic";break;case D:n="Custom";break;default:console.warn("THREE.WebGLProgram: Unsupported toneMapping:",t),n="Linear"}return"vec3 "+e+"( vec3 color ) { return "+n+"ToneMapping( color ); }"}function Ia(e){return""!==e}function Oa(e,t){const n=t.numSpotLightShadows+t.numSpotLightMaps-t.numSpotLightShadowsWithMaps;return e.replace(/NUM_DIR_LIGHTS/g,t.numDirLights).replace(/NUM_SPOT_LIGHTS/g,t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g,t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g,n).replace(/NUM_RECT_AREA_LIGHTS/g,t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g,t.numPointLights).replace(/NUM_HEMI_LIGHTS/g,t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g,t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g,t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g,t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g,t.numPointLightShadows)}function Fa(e,t){return e.replace(/NUM_CLIPPING_PLANES/g,t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g,t.numClippingPlanes-t.numClipIntersection)}const za=/^[ \\t]*#include +<([\\w\\d./]+)>/gm;function Ba(e){return e.replace(za,Va)}const Ha=new Map([["encodings_fragment","colorspace_fragment"],["encodings_pars_fragment","colorspace_pars_fragment"],["output_fragment","opaque_fragment"]]);function Va(e,t){let n=Xi[t];if(void 0===n){const e=Ha.get(t);if(void 0===e)throw new Error("Can not resolve #include <"+t+">");n=Xi[e],console.warn(\'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.\',t,e)}return Ba(n)}const Ga=/#pragma unroll_loop_start\\s+for\\s*\\(\\s*int\\s+i\\s*=\\s*(\\d+)\\s*;\\s*i\\s*<\\s*(\\d+)\\s*;\\s*i\\s*\\+\\+\\s*\\)\\s*{([\\s\\S]+?)}\\s+#pragma unroll_loop_end/g;function ka(e){return e.replace(Ga,Wa)}function Wa(e,t,n,i){let r="";for(let e=parseInt(t);e<parseInt(n);e++)r+=i.replace(/\\[\\s*i\\s*\\]/g,"[ "+e+" ]").replace(/UNROLLED_LOOP_INDEX/g,e);return r}function Xa(e){let t="precision "+e.precision+" float;\\nprecision "+e.precision+" int;";return"highp"===e.precision?t+="\\n#define HIGH_PRECISION":"mediump"===e.precision?t+="\\n#define MEDIUM_PRECISION":"lowp"===e.precision&&(t+="\\n#define LOW_PRECISION"),t}function ja(e,r,a,s){const o=e.getContext(),l=a.defines;let c=a.vertexShader,h=a.fragmentShader;const u=function(e){let r="SHADOWMAP_TYPE_BASIC";return e.shadowMapType===t?r="SHADOWMAP_TYPE_PCF":e.shadowMapType===n?r="SHADOWMAP_TYPE_PCF_SOFT":e.shadowMapType===i&&(r="SHADOWMAP_TYPE_VSM"),r}(a),d=function(e){let t="ENVMAP_TYPE_CUBE";if(e.envMap)switch(e.envMapMode){case N:case I:t="ENVMAP_TYPE_CUBE";break;case O:t="ENVMAP_TYPE_CUBE_UV"}return t}(a),p=function(e){let t="ENVMAP_MODE_REFLECTION";return e.envMap&&e.envMapMode===I&&(t="ENVMAP_MODE_REFRACTION"),t}(a),f=function(e){let t="ENVMAP_BLENDING_NONE";if(e.envMap)switch(e.combine){case b:t="ENVMAP_BLENDING_MULTIPLY";break;case w:t="ENVMAP_BLENDING_MIX";break;case A:t="ENVMAP_BLENDING_ADD"}return t}(a),m=function(e){const t=e.envMapCubeUVHeight;if(null===t)return null;const n=Math.log2(t)-2,i=1/t;return{texelWidth:1/(3*Math.max(Math.pow(2,n),112)),texelHeight:i,maxMip:n}}(a),g=a.isWebGL2?"":function(e){return[e.extensionDerivatives||e.envMapCubeUVHeight||e.bumpMap||e.normalMapTangentSpace||e.clearcoatNormalMap||e.flatShading||"physical"===e.shaderID?"#extension GL_OES_standard_derivatives : enable":"",(e.extensionFragDepth||e.logarithmicDepthBuffer)&&e.rendererExtensionFragDepth?"#extension GL_EXT_frag_depth : enable":"",e.extensionDrawBuffers&&e.rendererExtensionDrawBuffers?"#extension GL_EXT_draw_buffers : require":"",(e.extensionShaderTextureLOD||e.envMap||e.transmission)&&e.rendererExtensionShaderTextureLod?"#extension GL_EXT_shader_texture_lod : enable":""].filter(Ia).join("\\n")}(a),_=function(e){const t=[];for(const n in e){const i=e[n];!1!==i&&t.push("#define "+n+" "+i)}return t.join("\\n")}(l),v=o.createProgram();let x,M,S=a.glslVersion?"#version "+a.glslVersion+"\\n":"";a.isRawShaderMaterial?(x=["#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_].filter(Ia).join("\\n"),x.length>0&&(x+="\\n"),M=[g,"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_].filter(Ia).join("\\n"),M.length>0&&(M+="\\n")):(x=[Xa(a),"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_,a.instancing?"#define USE_INSTANCING":"",a.instancingColor?"#define USE_INSTANCING_COLOR":"",a.useFog&&a.fog?"#define USE_FOG":"",a.useFog&&a.fogExp2?"#define FOG_EXP2":"",a.map?"#define USE_MAP":"",a.envMap?"#define USE_ENVMAP":"",a.envMap?"#define "+p:"",a.lightMap?"#define USE_LIGHTMAP":"",a.aoMap?"#define USE_AOMAP":"",a.bumpMap?"#define USE_BUMPMAP":"",a.normalMap?"#define USE_NORMALMAP":"",a.normalMapObjectSpace?"#define USE_NORMALMAP_OBJECTSPACE":"",a.normalMapTangentSpace?"#define USE_NORMALMAP_TANGENTSPACE":"",a.displacementMap?"#define USE_DISPLACEMENTMAP":"",a.emissiveMap?"#define USE_EMISSIVEMAP":"",a.anisotropy?"#define USE_ANISOTROPY":"",a.anisotropyMap?"#define USE_ANISOTROPYMAP":"",a.clearcoatMap?"#define USE_CLEARCOATMAP":"",a.clearcoatRoughnessMap?"#define USE_CLEARCOAT_ROUGHNESSMAP":"",a.clearcoatNormalMap?"#define USE_CLEARCOAT_NORMALMAP":"",a.iridescenceMap?"#define USE_IRIDESCENCEMAP":"",a.iridescenceThicknessMap?"#define USE_IRIDESCENCE_THICKNESSMAP":"",a.specularMap?"#define USE_SPECULARMAP":"",a.specularColorMap?"#define USE_SPECULAR_COLORMAP":"",a.specularIntensityMap?"#define USE_SPECULAR_INTENSITYMAP":"",a.roughnessMap?"#define USE_ROUGHNESSMAP":"",a.metalnessMap?"#define USE_METALNESSMAP":"",a.alphaMap?"#define USE_ALPHAMAP":"",a.alphaHash?"#define USE_ALPHAHASH":"",a.transmission?"#define USE_TRANSMISSION":"",a.transmissionMap?"#define USE_TRANSMISSIONMAP":"",a.thicknessMap?"#define USE_THICKNESSMAP":"",a.sheenColorMap?"#define USE_SHEEN_COLORMAP":"",a.sheenRoughnessMap?"#define USE_SHEEN_ROUGHNESSMAP":"",a.mapUv?"#define MAP_UV "+a.mapUv:"",a.alphaMapUv?"#define ALPHAMAP_UV "+a.alphaMapUv:"",a.lightMapUv?"#define LIGHTMAP_UV "+a.lightMapUv:"",a.aoMapUv?"#define AOMAP_UV "+a.aoMapUv:"",a.emissiveMapUv?"#define EMISSIVEMAP_UV "+a.emissiveMapUv:"",a.bumpMapUv?"#define BUMPMAP_UV "+a.bumpMapUv:"",a.normalMapUv?"#define NORMALMAP_UV "+a.normalMapUv:"",a.displacementMapUv?"#define DISPLACEMENTMAP_UV "+a.displacementMapUv:"",a.metalnessMapUv?"#define METALNESSMAP_UV "+a.metalnessMapUv:"",a.roughnessMapUv?"#define ROUGHNESSMAP_UV "+a.roughnessMapUv:"",a.anisotropyMapUv?"#define ANISOTROPYMAP_UV "+a.anisotropyMapUv:"",a.clearcoatMapUv?"#define CLEARCOATMAP_UV "+a.clearcoatMapUv:"",a.clearcoatNormalMapUv?"#define CLEARCOAT_NORMALMAP_UV "+a.clearcoatNormalMapUv:"",a.clearcoatRoughnessMapUv?"#define CLEARCOAT_ROUGHNESSMAP_UV "+a.clearcoatRoughnessMapUv:"",a.iridescenceMapUv?"#define IRIDESCENCEMAP_UV "+a.iridescenceMapUv:"",a.iridescenceThicknessMapUv?"#define IRIDESCENCE_THICKNESSMAP_UV "+a.iridescenceThicknessMapUv:"",a.sheenColorMapUv?"#define SHEEN_COLORMAP_UV "+a.sheenColorMapUv:"",a.sheenRoughnessMapUv?"#define SHEEN_ROUGHNESSMAP_UV "+a.sheenRoughnessMapUv:"",a.specularMapUv?"#define SPECULARMAP_UV "+a.specularMapUv:"",a.specularColorMapUv?"#define SPECULAR_COLORMAP_UV "+a.specularColorMapUv:"",a.specularIntensityMapUv?"#define SPECULAR_INTENSITYMAP_UV "+a.specularIntensityMapUv:"",a.transmissionMapUv?"#define TRANSMISSIONMAP_UV "+a.transmissionMapUv:"",a.thicknessMapUv?"#define THICKNESSMAP_UV "+a.thicknessMapUv:"",a.vertexTangents&&!1===a.flatShading?"#define USE_TANGENT":"",a.vertexColors?"#define USE_COLOR":"",a.vertexAlphas?"#define USE_COLOR_ALPHA":"",a.vertexUv1s?"#define USE_UV1":"",a.vertexUv2s?"#define USE_UV2":"",a.vertexUv3s?"#define USE_UV3":"",a.pointsUvs?"#define USE_POINTS_UV":"",a.flatShading?"#define FLAT_SHADED":"",a.skinning?"#define USE_SKINNING":"",a.morphTargets?"#define USE_MORPHTARGETS":"",a.morphNormals&&!1===a.flatShading?"#define USE_MORPHNORMALS":"",a.morphColors&&a.isWebGL2?"#define USE_MORPHCOLORS":"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_TEXTURE":"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_TEXTURE_STRIDE "+a.morphTextureStride:"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_COUNT "+a.morphTargetsCount:"",a.doubleSided?"#define DOUBLE_SIDED":"",a.flipSided?"#define FLIP_SIDED":"",a.shadowMapEnabled?"#define USE_SHADOWMAP":"",a.shadowMapEnabled?"#define "+u:"",a.sizeAttenuation?"#define USE_SIZEATTENUATION":"",a.numLightProbes>0?"#define USE_LIGHT_PROBES":"",a.useLegacyLights?"#define LEGACY_LIGHTS":"",a.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",a.logarithmicDepthBuffer&&a.rendererExtensionFragDepth?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 modelMatrix;","uniform mat4 modelViewMatrix;","uniform mat4 projectionMatrix;","uniform mat4 viewMatrix;","uniform mat3 normalMatrix;","uniform vec3 cameraPosition;","uniform bool isOrthographic;","#ifdef USE_INSTANCING","\\tattribute mat4 instanceMatrix;","#endif","#ifdef USE_INSTANCING_COLOR","\\tattribute vec3 instanceColor;","#endif","attribute vec3 position;","attribute vec3 normal;","attribute vec2 uv;","#ifdef USE_UV1","\\tattribute vec2 uv1;","#endif","#ifdef USE_UV2","\\tattribute vec2 uv2;","#endif","#ifdef USE_UV3","\\tattribute vec2 uv3;","#endif","#ifdef USE_TANGENT","\\tattribute vec4 tangent;","#endif","#if defined( USE_COLOR_ALPHA )","\\tattribute vec4 color;","#elif defined( USE_COLOR )","\\tattribute vec3 color;","#endif","#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )","\\tattribute vec3 morphTarget0;","\\tattribute vec3 morphTarget1;","\\tattribute vec3 morphTarget2;","\\tattribute vec3 morphTarget3;","\\t#ifdef USE_MORPHNORMALS","\\t\\tattribute vec3 morphNormal0;","\\t\\tattribute vec3 morphNormal1;","\\t\\tattribute vec3 morphNormal2;","\\t\\tattribute vec3 morphNormal3;","\\t#else","\\t\\tattribute vec3 morphTarget4;","\\t\\tattribute vec3 morphTarget5;","\\t\\tattribute vec3 morphTarget6;","\\t\\tattribute vec3 morphTarget7;","\\t#endif","#endif","#ifdef USE_SKINNING","\\tattribute vec4 skinIndex;","\\tattribute vec4 skinWeight;","#endif","\\n"].filter(Ia).join("\\n"),M=[g,Xa(a),"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_,a.useFog&&a.fog?"#define USE_FOG":"",a.useFog&&a.fogExp2?"#define FOG_EXP2":"",a.map?"#define USE_MAP":"",a.matcap?"#define USE_MATCAP":"",a.envMap?"#define USE_ENVMAP":"",a.envMap?"#define "+d:"",a.envMap?"#define "+p:"",a.envMap?"#define "+f:"",m?"#define CUBEUV_TEXEL_WIDTH "+m.texelWidth:"",m?"#define CUBEUV_TEXEL_HEIGHT "+m.texelHeight:"",m?"#define CUBEUV_MAX_MIP "+m.maxMip+".0":"",a.lightMap?"#define USE_LIGHTMAP":"",a.aoMap?"#define USE_AOMAP":"",a.bumpMap?"#define USE_BUMPMAP":"",a.normalMap?"#define USE_NORMALMAP":"",a.normalMapObjectSpace?"#define USE_NORMALMAP_OBJECTSPACE":"",a.normalMapTangentSpace?"#define USE_NORMALMAP_TANGENTSPACE":"",a.emissiveMap?"#define USE_EMISSIVEMAP":"",a.anisotropy?"#define USE_ANISOTROPY":"",a.anisotropyMap?"#define USE_ANISOTROPYMAP":"",a.clearcoat?"#define USE_CLEARCOAT":"",a.clearcoatMap?"#define USE_CLEARCOATMAP":"",a.clearcoatRoughnessMap?"#define USE_CLEARCOAT_ROUGHNESSMAP":"",a.clearcoatNormalMap?"#define USE_CLEARCOAT_NORMALMAP":"",a.iridescence?"#define USE_IRIDESCENCE":"",a.iridescenceMap?"#define USE_IRIDESCENCEMAP":"",a.iridescenceThicknessMap?"#define USE_IRIDESCENCE_THICKNESSMAP":"",a.specularMap?"#define USE_SPECULARMAP":"",a.specularColorMap?"#define USE_SPECULAR_COLORMAP":"",a.specularIntensityMap?"#define USE_SPECULAR_INTENSITYMAP":"",a.roughnessMap?"#define USE_ROUGHNESSMAP":"",a.metalnessMap?"#define USE_METALNESSMAP":"",a.alphaMap?"#define USE_ALPHAMAP":"",a.alphaTest?"#define USE_ALPHATEST":"",a.alphaHash?"#define USE_ALPHAHASH":"",a.sheen?"#define USE_SHEEN":"",a.sheenColorMap?"#define USE_SHEEN_COLORMAP":"",a.sheenRoughnessMap?"#define USE_SHEEN_ROUGHNESSMAP":"",a.transmission?"#define USE_TRANSMISSION":"",a.transmissionMap?"#define USE_TRANSMISSIONMAP":"",a.thicknessMap?"#define USE_THICKNESSMAP":"",a.vertexTangents&&!1===a.flatShading?"#define USE_TANGENT":"",a.vertexColors||a.instancingColor?"#define USE_COLOR":"",a.vertexAlphas?"#define USE_COLOR_ALPHA":"",a.vertexUv1s?"#define USE_UV1":"",a.vertexUv2s?"#define USE_UV2":"",a.vertexUv3s?"#define USE_UV3":"",a.pointsUvs?"#define USE_POINTS_UV":"",a.gradientMap?"#define USE_GRADIENTMAP":"",a.flatShading?"#define FLAT_SHADED":"",a.doubleSided?"#define DOUBLE_SIDED":"",a.flipSided?"#define FLIP_SIDED":"",a.shadowMapEnabled?"#define USE_SHADOWMAP":"",a.shadowMapEnabled?"#define "+u:"",a.premultipliedAlpha?"#define PREMULTIPLIED_ALPHA":"",a.numLightProbes>0?"#define USE_LIGHT_PROBES":"",a.useLegacyLights?"#define LEGACY_LIGHTS":"",a.decodeVideoTexture?"#define DECODE_VIDEO_TEXTURE":"",a.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",a.logarithmicDepthBuffer&&a.rendererExtensionFragDepth?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 viewMatrix;","uniform vec3 cameraPosition;","uniform bool isOrthographic;",a.toneMapping!==R?"#define TONE_MAPPING":"",a.toneMapping!==R?Xi.tonemapping_pars_fragment:"",a.toneMapping!==R?Na("toneMapping",a.toneMapping):"",a.dithering?"#define DITHERING":"",a.opaque?"#define OPAQUE":"",Xi.colorspace_pars_fragment,Da("linearToOutputTexel",a.outputColorSpace),a.useDepthPacking?"#define DEPTH_PACKING "+a.depthPacking:"","\\n"].filter(Ia).join("\\n")),c=Ba(c),c=Oa(c,a),c=Fa(c,a),h=Ba(h),h=Oa(h,a),h=Fa(h,a),c=ka(c),h=ka(h),a.isWebGL2&&!0!==a.isRawShaderMaterial&&(S="#version 300 es\\n",x=["precision mediump sampler2DArray;","#define attribute in","#define varying out","#define texture2D texture"].join("\\n")+"\\n"+x,M=["precision mediump sampler2DArray;","#define varying in",a.glslVersion===Re?"":"layout(location = 0) out highp vec4 pc_fragColor;",a.glslVersion===Re?"":"#define gl_FragColor pc_fragColor","#define gl_FragDepthEXT gl_FragDepth","#define texture2D texture","#define textureCube texture","#define texture2DProj textureProj","#define texture2DLodEXT textureLod","#define texture2DProjLodEXT textureProjLod","#define textureCubeLodEXT textureLod","#define texture2DGradEXT textureGrad","#define texture2DProjGradEXT textureProjGrad","#define textureCubeGradEXT textureGrad"].join("\\n")+"\\n"+M);const y=S+x+c,E=S+M+h,T=Ca(o,o.VERTEX_SHADER,y),C=Ca(o,o.FRAGMENT_SHADER,E);function L(t){if(e.debug.checkShaderErrors){const n=o.getProgramInfoLog(v).trim(),i=o.getShaderInfoLog(T).trim(),r=o.getShaderInfoLog(C).trim();let a=!0,s=!0;if(!1===o.getProgramParameter(v,o.LINK_STATUS))if(a=!1,"function"==typeof e.debug.onShaderError)e.debug.onShaderError(o,v,T,C);else{const e=Ua(o,T,"vertex"),t=Ua(o,C,"fragment");console.error("THREE.WebGLProgram: Shader Error "+o.getError()+" - VALIDATE_STATUS "+o.getProgramParameter(v,o.VALIDATE_STATUS)+"\\n\\nProgram Info Log: "+n+"\\n"+e+"\\n"+t)}else""!==n?console.warn("THREE.WebGLProgram: Program Info Log:",n):""!==i&&""!==r||(s=!1);s&&(t.diagnostics={runnable:a,programLog:n,vertexShader:{log:i,prefix:x},fragmentShader:{log:r,prefix:M}})}o.deleteShader(T),o.deleteShader(C),P=new Ra(o,v),U=function(e,t){const n={},i=e.getProgramParameter(t,e.ACTIVE_ATTRIBUTES);for(let r=0;r<i;r++){const i=e.getActiveAttrib(t,r),a=i.name;let s=1;i.type===e.FLOAT_MAT2&&(s=2),i.type===e.FLOAT_MAT3&&(s=3),i.type===e.FLOAT_MAT4&&(s=4),n[a]={type:i.type,location:e.getAttribLocation(t,a),locationSize:s}}return n}(o,v)}let P,U;o.attachShader(v,T),o.attachShader(v,C),void 0!==a.index0AttributeName?o.bindAttribLocation(v,0,a.index0AttributeName):!0===a.morphTargets&&o.bindAttribLocation(v,0,"position"),o.linkProgram(v),this.getUniforms=function(){return void 0===P&&L(this),P},this.getAttributes=function(){return void 0===U&&L(this),U};let D=!1===a.rendererExtensionParallelShaderCompile;return this.isReady=function(){return!1===D&&(D=o.getProgramParameter(v,La)),D},this.destroy=function(){s.releaseStatesOfProgram(this),o.deleteProgram(v),this.program=void 0},this.type=a.shaderType,this.name=a.shaderName,this.id=Pa++,this.cacheKey=r,this.usedTimes=1,this.program=v,this.vertexShader=T,this.fragmentShader=C,this}let qa=0;class Ya{constructor(){this.shaderCache=new Map,this.materialCache=new Map}update(e){const t=e.vertexShader,n=e.fragmentShader,i=this._getShaderStage(t),r=this._getShaderStage(n),a=this._getShaderCacheForMaterial(e);return!1===a.has(i)&&(a.add(i),i.usedTimes++),!1===a.has(r)&&(a.add(r),r.usedTimes++),this}remove(e){const t=this.materialCache.get(e);for(const e of t)e.usedTimes--,0===e.usedTimes&&this.shaderCache.delete(e.code);return this.materialCache.delete(e),this}getVertexShaderID(e){return this._getShaderStage(e.vertexShader).id}getFragmentShaderID(e){return this._getShaderStage(e.fragmentShader).id}dispose(){this.shaderCache.clear(),this.materialCache.clear()}_getShaderCacheForMaterial(e){const t=this.materialCache;let n=t.get(e);return void 0===n&&(n=new Set,t.set(e,n)),n}_getShaderStage(e){const t=this.shaderCache;let n=t.get(e);return void 0===n&&(n=new Ka(e),t.set(e,n)),n}}class Ka{constructor(e){this.id=qa++,this.code=e,this.usedTimes=0}}function Za(e,t,n,i,r,a,s){const o=new an,l=new Ya,c=[],h=r.isWebGL2,u=r.logarithmicDepthBuffer,d=r.vertexTextures;let p=r.precision;const f={MeshDepthMaterial:"depth",MeshDistanceMaterial:"distanceRGBA",MeshNormalMaterial:"normal",MeshBasicMaterial:"basic",MeshLambertMaterial:"lambert",MeshPhongMaterial:"phong",MeshToonMaterial:"toon",MeshStandardMaterial:"physical",MeshPhysicalMaterial:"physical",MeshMatcapMaterial:"matcap",LineBasicMaterial:"basic",LineDashedMaterial:"dashed",PointsMaterial:"points",ShadowMaterial:"shadow",SpriteMaterial:"sprite"};function m(e){return 0===e?"uv":`uv${e}`}return{getParameters:function(a,o,c,g,_){const v=g.fog,x=_.geometry,M=a.isMeshStandardMaterial?g.environment:null,S=(a.isMeshStandardMaterial?n:t).get(a.envMap||M),y=S&&S.mapping===O?S.image.height:null,E=f[a.type];null!==a.precision&&(p=r.getMaxPrecision(a.precision),p!==a.precision&&console.warn("THREE.WebGLProgram.getParameters:",a.precision,"not supported, using",p,"instead."));const T=x.morphAttributes.position||x.morphAttributes.normal||x.morphAttributes.color,b=void 0!==T?T.length:0;let w,A,C,L,P=0;if(void 0!==x.morphAttributes.position&&(P=1),void 0!==x.morphAttributes.normal&&(P=2),void 0!==x.morphAttributes.color&&(P=3),E){const e=qi[E];w=e.vertexShader,A=e.fragmentShader}else w=a.vertexShader,A=a.fragmentShader,l.update(a),C=l.getVertexShaderID(a),L=l.getFragmentShaderID(a);const U=e.getRenderTarget(),D=!0===_.isInstancedMesh,N=!!a.map,I=!!a.matcap,F=!!S,z=!!a.aoMap,B=!!a.lightMap,H=!!a.bumpMap,V=!!a.normalMap,G=!!a.displacementMap,k=!!a.emissiveMap,W=!!a.metalnessMap,X=!!a.roughnessMap,j=a.anisotropy>0,q=a.clearcoat>0,Y=a.iridescence>0,K=a.sheen>0,Z=a.transmission>0,J=j&&!!a.anisotropyMap,Q=q&&!!a.clearcoatMap,$=q&&!!a.clearcoatNormalMap,ee=q&&!!a.clearcoatRoughnessMap,te=Y&&!!a.iridescenceMap,ne=Y&&!!a.iridescenceThicknessMap,ie=K&&!!a.sheenColorMap,re=K&&!!a.sheenRoughnessMap,ae=!!a.specularMap,se=!!a.specularColorMap,oe=!!a.specularIntensityMap,le=Z&&!!a.transmissionMap,ce=Z&&!!a.thicknessMap,he=!!a.gradientMap,ue=!!a.alphaMap,pe=a.alphaTest>0,fe=!!a.alphaHash,me=!!a.extensions,_e=!!x.attributes.uv1,ve=!!x.attributes.uv2,xe=!!x.attributes.uv3;let Me=R;return a.toneMapped&&(null!==U&&!0!==U.isXRRenderTarget||(Me=e.toneMapping)),{isWebGL2:h,shaderID:E,shaderType:a.type,shaderName:a.name,vertexShader:w,fragmentShader:A,defines:a.defines,customVertexShaderID:C,customFragmentShaderID:L,isRawShaderMaterial:!0===a.isRawShaderMaterial,glslVersion:a.glslVersion,precision:p,instancing:D,instancingColor:D&&null!==_.instanceColor,supportsVertexTextures:d,outputColorSpace:null===U?e.outputColorSpace:!0===U.isXRRenderTarget?U.texture.colorSpace:de,map:N,matcap:I,envMap:F,envMapMode:F&&S.mapping,envMapCubeUVHeight:y,aoMap:z,lightMap:B,bumpMap:H,normalMap:V,displacementMap:d&&G,emissiveMap:k,normalMapObjectSpace:V&&1===a.normalMapType,normalMapTangentSpace:V&&0===a.normalMapType,metalnessMap:W,roughnessMap:X,anisotropy:j,anisotropyMap:J,clearcoat:q,clearcoatMap:Q,clearcoatNormalMap:$,clearcoatRoughnessMap:ee,iridescence:Y,iridescenceMap:te,iridescenceThicknessMap:ne,sheen:K,sheenColorMap:ie,sheenRoughnessMap:re,specularMap:ae,specularColorMap:se,specularIntensityMap:oe,transmission:Z,transmissionMap:le,thicknessMap:ce,gradientMap:he,opaque:!1===a.transparent&&1===a.blending,alphaMap:ue,alphaTest:pe,alphaHash:fe,combine:a.combine,mapUv:N&&m(a.map.channel),aoMapUv:z&&m(a.aoMap.channel),lightMapUv:B&&m(a.lightMap.channel),bumpMapUv:H&&m(a.bumpMap.channel),normalMapUv:V&&m(a.normalMap.channel),displacementMapUv:G&&m(a.displacementMap.channel),emissiveMapUv:k&&m(a.emissiveMap.channel),metalnessMapUv:W&&m(a.metalnessMap.channel),roughnessMapUv:X&&m(a.roughnessMap.channel),anisotropyMapUv:J&&m(a.anisotropyMap.channel),clearcoatMapUv:Q&&m(a.clearcoatMap.channel),clearcoatNormalMapUv:$&&m(a.clearcoatNormalMap.channel),clearcoatRoughnessMapUv:ee&&m(a.clearcoatRoughnessMap.channel),iridescenceMapUv:te&&m(a.iridescenceMap.channel),iridescenceThicknessMapUv:ne&&m(a.iridescenceThicknessMap.channel),sheenColorMapUv:ie&&m(a.sheenColorMap.channel),sheenRoughnessMapUv:re&&m(a.sheenRoughnessMap.channel),specularMapUv:ae&&m(a.specularMap.channel),specularColorMapUv:se&&m(a.specularColorMap.channel),specularIntensityMapUv:oe&&m(a.specularIntensityMap.channel),transmissionMapUv:le&&m(a.transmissionMap.channel),thicknessMapUv:ce&&m(a.thicknessMap.channel),alphaMapUv:ue&&m(a.alphaMap.channel),vertexTangents:!!x.attributes.tangent&&(V||j),vertexColors:a.vertexColors,vertexAlphas:!0===a.vertexColors&&!!x.attributes.color&&4===x.attributes.color.itemSize,vertexUv1s:_e,vertexUv2s:ve,vertexUv3s:xe,pointsUvs:!0===_.isPoints&&!!x.attributes.uv&&(N||ue),fog:!!v,useFog:!0===a.fog,fogExp2:v&&v.isFogExp2,flatShading:!0===a.flatShading,sizeAttenuation:!0===a.sizeAttenuation,logarithmicDepthBuffer:u,skinning:!0===_.isSkinnedMesh,morphTargets:void 0!==x.morphAttributes.position,morphNormals:void 0!==x.morphAttributes.normal,morphColors:void 0!==x.morphAttributes.color,morphTargetsCount:b,morphTextureStride:P,numDirLights:o.directional.length,numPointLights:o.point.length,numSpotLights:o.spot.length,numSpotLightMaps:o.spotLightMap.length,numRectAreaLights:o.rectArea.length,numHemiLights:o.hemi.length,numDirLightShadows:o.directionalShadowMap.length,numPointLightShadows:o.pointShadowMap.length,numSpotLightShadows:o.spotShadowMap.length,numSpotLightShadowsWithMaps:o.numSpotLightShadowsWithMaps,numLightProbes:o.numLightProbes,numClippingPlanes:s.numPlanes,numClipIntersection:s.numIntersection,dithering:a.dithering,shadowMapEnabled:e.shadowMap.enabled&&c.length>0,shadowMapType:e.shadowMap.type,toneMapping:Me,useLegacyLights:e._useLegacyLights,decodeVideoTexture:N&&!0===a.map.isVideoTexture&&tt.getTransfer(a.map.colorSpace)===ge,premultipliedAlpha:a.premultipliedAlpha,doubleSided:2===a.side,flipSided:1===a.side,useDepthPacking:a.depthPacking>=0,depthPacking:a.depthPacking||0,index0AttributeName:a.index0AttributeName,extensionDerivatives:me&&!0===a.extensions.derivatives,extensionFragDepth:me&&!0===a.extensions.fragDepth,extensionDrawBuffers:me&&!0===a.extensions.drawBuffers,extensionShaderTextureLOD:me&&!0===a.extensions.shaderTextureLOD,rendererExtensionFragDepth:h||i.has("EXT_frag_depth"),rendererExtensionDrawBuffers:h||i.has("WEBGL_draw_buffers"),rendererExtensionShaderTextureLod:h||i.has("EXT_shader_texture_lod"),rendererExtensionParallelShaderCompile:i.has("KHR_parallel_shader_compile"),customProgramCacheKey:a.customProgramCacheKey()}},getProgramCacheKey:function(t){const n=[];if(t.shaderID?n.push(t.shaderID):(n.push(t.customVertexShaderID),n.push(t.customFragmentShaderID)),void 0!==t.defines)for(const e in t.defines)n.push(e),n.push(t.defines[e]);return!1===t.isRawShaderMaterial&&(function(e,t){e.push(t.precision),e.push(t.outputColorSpace),e.push(t.envMapMode),e.push(t.envMapCubeUVHeight),e.push(t.mapUv),e.push(t.alphaMapUv),e.push(t.lightMapUv),e.push(t.aoMapUv),e.push(t.bumpMapUv),e.push(t.normalMapUv),e.push(t.displacementMapUv),e.push(t.emissiveMapUv),e.push(t.metalnessMapUv),e.push(t.roughnessMapUv),e.push(t.anisotropyMapUv),e.push(t.clearcoatMapUv),e.push(t.clearcoatNormalMapUv),e.push(t.clearcoatRoughnessMapUv),e.push(t.iridescenceMapUv),e.push(t.iridescenceThicknessMapUv),e.push(t.sheenColorMapUv),e.push(t.sheenRoughnessMapUv),e.push(t.specularMapUv),e.push(t.specularColorMapUv),e.push(t.specularIntensityMapUv),e.push(t.transmissionMapUv),e.push(t.thicknessMapUv),e.push(t.combine),e.push(t.fogExp2),e.push(t.sizeAttenuation),e.push(t.morphTargetsCount),e.push(t.morphAttributeCount),e.push(t.numDirLights),e.push(t.numPointLights),e.push(t.numSpotLights),e.push(t.numSpotLightMaps),e.push(t.numHemiLights),e.push(t.numRectAreaLights),e.push(t.numDirLightShadows),e.push(t.numPointLightShadows),e.push(t.numSpotLightShadows),e.push(t.numSpotLightShadowsWithMaps),e.push(t.numLightProbes),e.push(t.shadowMapType),e.push(t.toneMapping),e.push(t.numClippingPlanes),e.push(t.numClipIntersection),e.push(t.depthPacking)}(n,t),function(e,t){o.disableAll(),t.isWebGL2&&o.enable(0),t.supportsVertexTextures&&o.enable(1),t.instancing&&o.enable(2),t.instancingColor&&o.enable(3),t.matcap&&o.enable(4),t.envMap&&o.enable(5),t.normalMapObjectSpace&&o.enable(6),t.normalMapTangentSpace&&o.enable(7),t.clearcoat&&o.enable(8),t.iridescence&&o.enable(9),t.alphaTest&&o.enable(10),t.vertexColors&&o.enable(11),t.vertexAlphas&&o.enable(12),t.vertexUv1s&&o.enable(13),t.vertexUv2s&&o.enable(14),t.vertexUv3s&&o.enable(15),t.vertexTangents&&o.enable(16),t.anisotropy&&o.enable(17),t.alphaHash&&o.enable(18),e.push(o.mask),o.disableAll(),t.fog&&o.enable(0),t.useFog&&o.enable(1),t.flatShading&&o.enable(2),t.logarithmicDepthBuffer&&o.enable(3),t.skinning&&o.enable(4),t.morphTargets&&o.enable(5),t.morphNormals&&o.enable(6),t.morphColors&&o.enable(7),t.premultipliedAlpha&&o.enable(8),t.shadowMapEnabled&&o.enable(9),t.useLegacyLights&&o.enable(10),t.doubleSided&&o.enable(11),t.flipSided&&o.enable(12),t.useDepthPacking&&o.enable(13),t.dithering&&o.enable(14),t.transmission&&o.enable(15),t.sheen&&o.enable(16),t.opaque&&o.enable(17),t.pointsUvs&&o.enable(18),t.decodeVideoTexture&&o.enable(19),e.push(o.mask)}(n,t),n.push(e.outputColorSpace)),n.push(t.customProgramCacheKey),n.join()},getUniforms:function(e){const t=f[e.type];let n;if(t){const e=qi[t];n=Ai.clone(e.uniforms)}else n=e.uniforms;return n},acquireProgram:function(t,n){let i;for(let e=0,t=c.length;e<t;e++){const t=c[e];if(t.cacheKey===n){i=t,++i.usedTimes;break}}return void 0===i&&(i=new ja(e,n,t,a),c.push(i)),i},releaseProgram:function(e){if(0==--e.usedTimes){const t=c.indexOf(e);c[t]=c[c.length-1],c.pop(),e.destroy()}},releaseShaderCache:function(e){l.remove(e)},programs:c,dispose:function(){l.dispose()}}}function Ja(){let e=new WeakMap;return{get:function(t){let n=e.get(t);return void 0===n&&(n={},e.set(t,n)),n},remove:function(t){e.delete(t)},update:function(t,n,i){e.get(t)[n]=i},dispose:function(){e=new WeakMap}}}function Qa(e,t){return e.groupOrder!==t.groupOrder?e.groupOrder-t.groupOrder:e.renderOrder!==t.renderOrder?e.renderOrder-t.renderOrder:e.material.id!==t.material.id?e.material.id-t.material.id:e.z!==t.z?e.z-t.z:e.id-t.id}function $a(e,t){return e.groupOrder!==t.groupOrder?e.groupOrder-t.groupOrder:e.renderOrder!==t.renderOrder?e.renderOrder-t.renderOrder:e.z!==t.z?t.z-e.z:e.id-t.id}function es(){const e=[];let t=0;const n=[],i=[],r=[];function a(n,i,r,a,s,o){let l=e[t];return void 0===l?(l={id:n.id,object:n,geometry:i,material:r,groupOrder:a,renderOrder:n.renderOrder,z:s,group:o},e[t]=l):(l.id=n.id,l.object=n,l.geometry=i,l.material=r,l.groupOrder=a,l.renderOrder=n.renderOrder,l.z=s,l.group=o),t++,l}return{opaque:n,transmissive:i,transparent:r,init:function(){t=0,n.length=0,i.length=0,r.length=0},push:function(e,t,s,o,l,c){const h=a(e,t,s,o,l,c);s.transmission>0?i.push(h):!0===s.transparent?r.push(h):n.push(h)},unshift:function(e,t,s,o,l,c){const h=a(e,t,s,o,l,c);s.transmission>0?i.unshift(h):!0===s.transparent?r.unshift(h):n.unshift(h)},finish:function(){for(let n=t,i=e.length;n<i;n++){const t=e[n];if(null===t.id)break;t.id=null,t.object=null,t.geometry=null,t.material=null,t.group=null}},sort:function(e,t){n.length>1&&n.sort(e||Qa),i.length>1&&i.sort(t||$a),r.length>1&&r.sort(t||$a)}}}function ts(){let e=new WeakMap;return{get:function(t,n){const i=e.get(t);let r;return void 0===i?(r=new es,e.set(t,[r])):n>=i.length?(r=new es,i.push(r)):r=i[n],r},dispose:function(){e=new WeakMap}}}function ns(){const e={};return{get:function(t){if(void 0!==e[t.id])return e[t.id];let n;switch(t.type){case"DirectionalLight":n={direction:new _t,color:new On};break;case"SpotLight":n={position:new _t,direction:new _t,color:new On,distance:0,coneCos:0,penumbraCos:0,decay:0};break;case"PointLight":n={position:new _t,color:new On,distance:0,decay:0};break;case"HemisphereLight":n={direction:new _t,skyColor:new On,groundColor:new On};break;case"RectAreaLight":n={color:new On,position:new _t,halfWidth:new _t,halfHeight:new _t}}return e[t.id]=n,n}}}let is=0;function rs(e,t){return(t.castShadow?2:0)-(e.castShadow?2:0)+(t.map?1:0)-(e.map?1:0)}function as(e,t){const n=new ns,i=function(){const e={};return{get:function(t){if(void 0!==e[t.id])return e[t.id];let n;switch(t.type){case"DirectionalLight":case"SpotLight":n={shadowBias:0,shadowNormalBias:0,shadowRadius:1,shadowMapSize:new ke};break;case"PointLight":n={shadowBias:0,shadowNormalBias:0,shadowRadius:1,shadowMapSize:new ke,shadowCameraNear:1,shadowCameraFar:1e3}}return e[t.id]=n,n}}}(),r={version:0,hash:{directionalLength:-1,pointLength:-1,spotLength:-1,rectAreaLength:-1,hemiLength:-1,numDirectionalShadows:-1,numPointShadows:-1,numSpotShadows:-1,numSpotMaps:-1,numLightProbes:-1},ambient:[0,0,0],probe:[],directional:[],directionalShadow:[],directionalShadowMap:[],directionalShadowMatrix:[],spot:[],spotLightMap:[],spotShadow:[],spotShadowMap:[],spotLightMatrix:[],rectArea:[],rectAreaLTC1:null,rectAreaLTC2:null,point:[],pointShadow:[],pointShadowMap:[],pointShadowMatrix:[],hemi:[],numSpotLightShadowsWithMaps:0,numLightProbes:0};for(let e=0;e<9;e++)r.probe.push(new _t);const a=new _t,s=new qt,o=new qt;return{setup:function(a,s){let o=0,l=0,c=0;for(let e=0;e<9;e++)r.probe[e].set(0,0,0);let h=0,u=0,d=0,p=0,f=0,m=0,g=0,_=0,v=0,x=0,M=0;a.sort(rs);const S=!0===s?Math.PI:1;for(let e=0,t=a.length;e<t;e++){const t=a[e],s=t.color,y=t.intensity,E=t.distance,T=t.shadow&&t.shadow.map?t.shadow.map.texture:null;if(t.isAmbientLight)o+=s.r*y*S,l+=s.g*y*S,c+=s.b*y*S;else if(t.isLightProbe){for(let e=0;e<9;e++)r.probe[e].addScaledVector(t.sh.coefficients[e],y);M++}else if(t.isDirectionalLight){const e=n.get(t);if(e.color.copy(t.color).multiplyScalar(t.intensity*S),t.castShadow){const e=t.shadow,n=i.get(t);n.shadowBias=e.bias,n.shadowNormalBias=e.normalBias,n.shadowRadius=e.radius,n.shadowMapSize=e.mapSize,r.directionalShadow[h]=n,r.directionalShadowMap[h]=T,r.directionalShadowMatrix[h]=t.shadow.matrix,m++}r.directional[h]=e,h++}else if(t.isSpotLight){const e=n.get(t);e.position.setFromMatrixPosition(t.matrixWorld),e.color.copy(s).multiplyScalar(y*S),e.distance=E,e.coneCos=Math.cos(t.angle),e.penumbraCos=Math.cos(t.angle*(1-t.penumbra)),e.decay=t.decay,r.spot[d]=e;const a=t.shadow;if(t.map&&(r.spotLightMap[v]=t.map,v++,a.updateMatrices(t),t.castShadow&&x++),r.spotLightMatrix[d]=a.matrix,t.castShadow){const e=i.get(t);e.shadowBias=a.bias,e.shadowNormalBias=a.normalBias,e.shadowRadius=a.radius,e.shadowMapSize=a.mapSize,r.spotShadow[d]=e,r.spotShadowMap[d]=T,_++}d++}else if(t.isRectAreaLight){const e=n.get(t);e.color.copy(s).multiplyScalar(y),e.halfWidth.set(.5*t.width,0,0),e.halfHeight.set(0,.5*t.height,0),r.rectArea[p]=e,p++}else if(t.isPointLight){const e=n.get(t);if(e.color.copy(t.color).multiplyScalar(t.intensity*S),e.distance=t.distance,e.decay=t.decay,t.castShadow){const e=t.shadow,n=i.get(t);n.shadowBias=e.bias,n.shadowNormalBias=e.normalBias,n.shadowRadius=e.radius,n.shadowMapSize=e.mapSize,n.shadowCameraNear=e.camera.near,n.shadowCameraFar=e.camera.far,r.pointShadow[u]=n,r.pointShadowMap[u]=T,r.pointShadowMatrix[u]=t.shadow.matrix,g++}r.point[u]=e,u++}else if(t.isHemisphereLight){const e=n.get(t);e.skyColor.copy(t.color).multiplyScalar(y*S),e.groundColor.copy(t.groundColor).multiplyScalar(y*S),r.hemi[f]=e,f++}}p>0&&(t.isWebGL2||!0===e.has("OES_texture_float_linear")?(r.rectAreaLTC1=ji.LTC_FLOAT_1,r.rectAreaLTC2=ji.LTC_FLOAT_2):!0===e.has("OES_texture_half_float_linear")?(r.rectAreaLTC1=ji.LTC_HALF_1,r.rectAreaLTC2=ji.LTC_HALF_2):console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")),r.ambient[0]=o,r.ambient[1]=l,r.ambient[2]=c;const y=r.hash;y.directionalLength===h&&y.pointLength===u&&y.spotLength===d&&y.rectAreaLength===p&&y.hemiLength===f&&y.numDirectionalShadows===m&&y.numPointShadows===g&&y.numSpotShadows===_&&y.numSpotMaps===v&&y.numLightProbes===M||(r.directional.length=h,r.spot.length=d,r.rectArea.length=p,r.point.length=u,r.hemi.length=f,r.directionalShadow.length=m,r.directionalShadowMap.length=m,r.pointShadow.length=g,r.pointShadowMap.length=g,r.spotShadow.length=_,r.spotShadowMap.length=_,r.directionalShadowMatrix.length=m,r.pointShadowMatrix.length=g,r.spotLightMatrix.length=_+v-x,r.spotLightMap.length=v,r.numSpotLightShadowsWithMaps=x,r.numLightProbes=M,y.directionalLength=h,y.pointLength=u,y.spotLength=d,y.rectAreaLength=p,y.hemiLength=f,y.numDirectionalShadows=m,y.numPointShadows=g,y.numSpotShadows=_,y.numSpotMaps=v,y.numLightProbes=M,r.version=is++)},setupView:function(e,t){let n=0,i=0,l=0,c=0,h=0;const u=t.matrixWorldInverse;for(let t=0,d=e.length;t<d;t++){const d=e[t];if(d.isDirectionalLight){const e=r.directional[n];e.direction.setFromMatrixPosition(d.matrixWorld),a.setFromMatrixPosition(d.target.matrixWorld),e.direction.sub(a),e.direction.transformDirection(u),n++}else if(d.isSpotLight){const e=r.spot[l];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),e.direction.setFromMatrixPosition(d.matrixWorld),a.setFromMatrixPosition(d.target.matrixWorld),e.direction.sub(a),e.direction.transformDirection(u),l++}else if(d.isRectAreaLight){const e=r.rectArea[c];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),o.identity(),s.copy(d.matrixWorld),s.premultiply(u),o.extractRotation(s),e.halfWidth.set(.5*d.width,0,0),e.halfHeight.set(0,.5*d.height,0),e.halfWidth.applyMatrix4(o),e.halfHeight.applyMatrix4(o),c++}else if(d.isPointLight){const e=r.point[i];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),i++}else if(d.isHemisphereLight){const e=r.hemi[h];e.direction.setFromMatrixPosition(d.matrixWorld),e.direction.transformDirection(u),h++}}},state:r}}function ss(e,t){const n=new as(e,t),i=[],r=[];return{init:function(){i.length=0,r.length=0},state:{lightsArray:i,shadowsArray:r,lights:n},setupLights:function(e){n.setup(i,e)},setupLightsView:function(e){n.setupView(i,e)},pushLight:function(e){i.push(e)},pushShadow:function(e){r.push(e)}}}function os(e,t){let n=new WeakMap;return{get:function(i){let r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const a=n.get(i);let s;return void 0===a?(s=new ss(e,t),n.set(i,[s])):r>=a.length?(s=new ss(e,t),a.push(s)):s=a[r],s},dispose:function(){n=new WeakMap}}}class ls extends Bn{constructor(e){super(),this.isMeshDepthMaterial=!0,this.type="MeshDepthMaterial",this.depthPacking=3200,this.map=null,this.alphaMap=null,this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.wireframe=!1,this.wireframeLinewidth=1,this.setValues(e)}copy(e){return super.copy(e),this.depthPacking=e.depthPacking,this.map=e.map,this.alphaMap=e.alphaMap,this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this}}class cs extends Bn{constructor(e){super(),this.isMeshDistanceMaterial=!0,this.type="MeshDistanceMaterial",this.map=null,this.alphaMap=null,this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.setValues(e)}copy(e){return super.copy(e),this.map=e.map,this.alphaMap=e.alphaMap,this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this}}function hs(e,n,o){let l=new Vi;const c=new ke,h=new ke,u=new ut,d=new ls({depthPacking:3201}),p=new cs,f={},m=o.maxTextureSize,g={[r]:1,[a]:0,[s]:2},_=new Ri({defines:{VSM_SAMPLES:8},uniforms:{shadow_pass:{value:null},resolution:{value:new ke},radius:{value:4}},vertexShader:"void main() {\\n\\tgl_Position = vec4( position, 1.0 );\\n}",fragmentShader:"uniform sampler2D shadow_pass;\\nuniform vec2 resolution;\\nuniform float radius;\\n#include <packing>\\nvoid main() {\\n\\tconst float samples = float( VSM_SAMPLES );\\n\\tfloat mean = 0.0;\\n\\tfloat squared_mean = 0.0;\\n\\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\\n\\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\\n\\tfor ( float i = 0.0; i < samples; i ++ ) {\\n\\t\\tfloat uvOffset = uvStart + i * uvStride;\\n\\t\\t#ifdef HORIZONTAL_PASS\\n\\t\\t\\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\\n\\t\\t\\tmean += distribution.x;\\n\\t\\t\\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\\n\\t\\t#else\\n\\t\\t\\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\\n\\t\\t\\tmean += depth;\\n\\t\\t\\tsquared_mean += depth * depth;\\n\\t\\t#endif\\n\\t}\\n\\tmean = mean / samples;\\n\\tsquared_mean = squared_mean / samples;\\n\\tfloat std_dev = sqrt( squared_mean - mean * mean );\\n\\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\\n}"}),v=_.clone();v.defines.HORIZONTAL_PASS=1;const x=new ii;x.setAttribute("position",new jn(new Float32Array([-1,-1,.5,3,-1,.5,-1,3,.5]),3));const M=new Si(x,_),S=this;this.enabled=!1,this.autoUpdate=!0,this.needsUpdate=!1,this.type=t;let y=this.type;function E(t,i){const r=n.update(M);_.defines.VSM_SAMPLES!==t.blurSamples&&(_.defines.VSM_SAMPLES=t.blurSamples,v.defines.VSM_SAMPLES=t.blurSamples,_.needsUpdate=!0,v.needsUpdate=!0),null===t.mapPass&&(t.mapPass=new pt(c.x,c.y)),_.uniforms.shadow_pass.value=t.map.texture,_.uniforms.resolution.value=t.mapSize,_.uniforms.radius.value=t.radius,e.setRenderTarget(t.mapPass),e.clear(),e.renderBufferDirect(i,null,r,_,M,null),v.uniforms.shadow_pass.value=t.mapPass.texture,v.uniforms.resolution.value=t.mapSize,v.uniforms.radius.value=t.radius,e.setRenderTarget(t.map),e.clear(),e.renderBufferDirect(i,null,r,v,M,null)}function T(t,n,r,a){let s=null;const o=!0===r.isPointLight?t.customDistanceMaterial:t.customDepthMaterial;if(void 0!==o)s=o;else if(s=!0===r.isPointLight?p:d,e.localClippingEnabled&&!0===n.clipShadows&&Array.isArray(n.clippingPlanes)&&0!==n.clippingPlanes.length||n.displacementMap&&0!==n.displacementScale||n.alphaMap&&n.alphaTest>0||n.map&&n.alphaTest>0){const e=s.uuid,t=n.uuid;let i=f[e];void 0===i&&(i={},f[e]=i);let r=i[t];void 0===r&&(r=s.clone(),i[t]=r),s=r}return s.visible=n.visible,s.wireframe=n.wireframe,s.side=a===i?null!==n.shadowSide?n.shadowSide:n.side:null!==n.shadowSide?n.shadowSide:g[n.side],s.alphaMap=n.alphaMap,s.alphaTest=n.alphaTest,s.map=n.map,s.clipShadows=n.clipShadows,s.clippingPlanes=n.clippingPlanes,s.clipIntersection=n.clipIntersection,s.displacementMap=n.displacementMap,s.displacementScale=n.displacementScale,s.displacementBias=n.displacementBias,s.wireframeLinewidth=n.wireframeLinewidth,s.linewidth=n.linewidth,!0===r.isPointLight&&!0===s.isMeshDistanceMaterial&&(e.properties.get(s).light=r),s}function b(t,r,a,s,o){if(!1===t.visible)return;if(t.layers.test(r.layers)&&(t.isMesh||t.isLine||t.isPoints)&&(t.castShadow||t.receiveShadow&&o===i)&&(!t.frustumCulled||l.intersectsObject(t))){t.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse,t.matrixWorld);const i=n.update(t),r=t.material;if(Array.isArray(r)){const n=i.groups;for(let l=0,c=n.length;l<c;l++){const c=n[l],h=r[c.materialIndex];if(h&&h.visible){const n=T(t,h,s,o);e.renderBufferDirect(a,null,i,n,t,c)}}}else if(r.visible){const n=T(t,r,s,o);e.renderBufferDirect(a,null,i,n,t,null)}}const c=t.children;for(let e=0,t=c.length;e<t;e++)b(c[e],r,a,s,o)}this.render=function(t,n,r){if(!1===S.enabled)return;if(!1===S.autoUpdate&&!1===S.needsUpdate)return;if(0===t.length)return;const a=e.getRenderTarget(),s=e.getActiveCubeFace(),o=e.getActiveMipmapLevel(),d=e.state;d.setBlending(0),d.buffers.color.setClear(1,1,1,1),d.buffers.depth.setTest(!0),d.setScissorTest(!1);const p=y!==i&&this.type===i,f=y===i&&this.type!==i;for(let a=0,s=t.length;a<s;a++){const s=t[a],o=s.shadow;if(void 0===o){console.warn("THREE.WebGLShadowMap:",s,"has no shadow.");continue}if(!1===o.autoUpdate&&!1===o.needsUpdate)continue;c.copy(o.mapSize);const g=o.getFrameExtents();if(c.multiply(g),h.copy(o.mapSize),(c.x>m||c.y>m)&&(c.x>m&&(h.x=Math.floor(m/g.x),c.x=h.x*g.x,o.mapSize.x=h.x),c.y>m&&(h.y=Math.floor(m/g.y),c.y=h.y*g.y,o.mapSize.y=h.y)),null===o.map||!0===p||!0===f){const e=this.type!==i?{minFilter:H,magFilter:H}:{};null!==o.map&&o.map.dispose(),o.map=new pt(c.x,c.y,e),o.map.texture.name=s.name+".shadowMap",o.camera.updateProjectionMatrix()}e.setRenderTarget(o.map),e.clear();const _=o.getViewportCount();for(let e=0;e<_;e++){const t=o.getViewport(e);u.set(h.x*t.x,h.y*t.y,h.x*t.z,h.y*t.w),d.viewport(u),o.updateMatrices(s,e),l=o.getFrustum(),b(n,r,o.camera,s,this.type)}!0!==o.isPointLightShadow&&this.type===i&&E(o,r),o.needsUpdate=!1}y=this.type,S.needsUpdate=!1,e.setRenderTarget(a,s,o)}}function us(e,t,n){const i=n.isWebGL2,r=new function(){let t=!1;const n=new ut;let i=null;const r=new ut(0,0,0,0);return{setMask:function(n){i===n||t||(e.colorMask(n,n,n,n),i=n)},setLocked:function(e){t=e},setClear:function(t,i,a,s,o){!0===o&&(t*=s,i*=s,a*=s),n.set(t,i,a,s),!1===r.equals(n)&&(e.clearColor(t,i,a,s),r.copy(n))},reset:function(){t=!1,i=null,r.set(-1,0,0,0)}}},a=new function(){let t=!1,n=null,i=null,r=null;return{setTest:function(t){t?se(e.DEPTH_TEST):oe(e.DEPTH_TEST)},setMask:function(i){n===i||t||(e.depthMask(i),n=i)},setFunc:function(t){if(i!==t){switch(t){case 0:e.depthFunc(e.NEVER);break;case 1:e.depthFunc(e.ALWAYS);break;case 2:e.depthFunc(e.LESS);break;case 3:default:e.depthFunc(e.LEQUAL);break;case 4:e.depthFunc(e.EQUAL);break;case 5:e.depthFunc(e.GEQUAL);break;case 6:e.depthFunc(e.GREATER);break;case 7:e.depthFunc(e.NOTEQUAL)}i=t}},setLocked:function(e){t=e},setClear:function(t){r!==t&&(e.clearDepth(t),r=t)},reset:function(){t=!1,n=null,i=null,r=null}}},s=new function(){let t=!1,n=null,i=null,r=null,a=null,s=null,o=null,l=null,c=null;return{setTest:function(n){t||(n?se(e.STENCIL_TEST):oe(e.STENCIL_TEST))},setMask:function(i){n===i||t||(e.stencilMask(i),n=i)},setFunc:function(t,n,s){i===t&&r===n&&a===s||(e.stencilFunc(t,n,s),i=t,r=n,a=s)},setOp:function(t,n,i){s===t&&o===n&&l===i||(e.stencilOp(t,n,i),s=t,o=n,l=i)},setLocked:function(e){t=e},setClear:function(t){c!==t&&(e.clearStencil(t),c=t)},reset:function(){t=!1,n=null,i=null,r=null,a=null,s=null,o=null,l=null,c=null}}},b=new WeakMap,w=new WeakMap;let A={},R={},C=new WeakMap,L=[],P=null,U=!1,D=null,N=null,I=null,O=null,F=null,z=null,B=null,H=new On(0,0,0),V=0,G=!1,k=null,W=null,X=null,j=null,q=null;const Y=e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);let K=!1,Z=0;const J=e.getParameter(e.VERSION);-1!==J.indexOf("WebGL")?(Z=parseFloat(/^WebGL (\\d)/.exec(J)[1]),K=Z>=1):-1!==J.indexOf("OpenGL ES")&&(Z=parseFloat(/^OpenGL ES (\\d)/.exec(J)[1]),K=Z>=2);let Q=null,$={};const ee=e.getParameter(e.SCISSOR_BOX),te=e.getParameter(e.VIEWPORT),ne=(new ut).fromArray(ee),ie=(new ut).fromArray(te);function re(t,n,r,a){const s=new Uint8Array(4),o=e.createTexture();e.bindTexture(t,o),e.texParameteri(t,e.TEXTURE_MIN_FILTER,e.NEAREST),e.texParameteri(t,e.TEXTURE_MAG_FILTER,e.NEAREST);for(let o=0;o<r;o++)!i||t!==e.TEXTURE_3D&&t!==e.TEXTURE_2D_ARRAY?e.texImage2D(n+o,0,e.RGBA,1,1,0,e.RGBA,e.UNSIGNED_BYTE,s):e.texImage3D(n,0,e.RGBA,1,1,a,0,e.RGBA,e.UNSIGNED_BYTE,s);return o}const ae={};function se(t){!0!==A[t]&&(e.enable(t),A[t]=!0)}function oe(t){!1!==A[t]&&(e.disable(t),A[t]=!1)}ae[e.TEXTURE_2D]=re(e.TEXTURE_2D,e.TEXTURE_2D,1),ae[e.TEXTURE_CUBE_MAP]=re(e.TEXTURE_CUBE_MAP,e.TEXTURE_CUBE_MAP_POSITIVE_X,6),i&&(ae[e.TEXTURE_2D_ARRAY]=re(e.TEXTURE_2D_ARRAY,e.TEXTURE_2D_ARRAY,1,1),ae[e.TEXTURE_3D]=re(e.TEXTURE_3D,e.TEXTURE_3D,1,1)),r.setClear(0,0,0,1),a.setClear(1),s.setClear(0),se(e.DEPTH_TEST),a.setFunc(3),ue(!1),de(1),se(e.CULL_FACE),he(0);const le={[o]:e.FUNC_ADD,[l]:e.FUNC_SUBTRACT,[c]:e.FUNC_REVERSE_SUBTRACT};if(i)le[103]=e.MIN,le[104]=e.MAX;else{const e=t.get("EXT_blend_minmax");null!==e&&(le[103]=e.MIN_EXT,le[104]=e.MAX_EXT)}const ce={[h]:e.ZERO,[u]:e.ONE,[d]:e.SRC_COLOR,[f]:e.SRC_ALPHA,[M]:e.SRC_ALPHA_SATURATE,[v]:e.DST_COLOR,[g]:e.DST_ALPHA,[p]:e.ONE_MINUS_SRC_COLOR,[m]:e.ONE_MINUS_SRC_ALPHA,[x]:e.ONE_MINUS_DST_COLOR,[_]:e.ONE_MINUS_DST_ALPHA,[S]:e.CONSTANT_COLOR,[y]:e.ONE_MINUS_CONSTANT_COLOR,[E]:e.CONSTANT_ALPHA,[T]:e.ONE_MINUS_CONSTANT_ALPHA};function he(t,n,i,r,a,s,l,c,h,u){if(0!==t){if(!1===U&&(se(e.BLEND),U=!0),5===t)a=a||n,s=s||i,l=l||r,n===N&&a===F||(e.blendEquationSeparate(le[n],le[a]),N=n,F=a),i===I&&r===O&&s===z&&l===B||(e.blendFuncSeparate(ce[i],ce[r],ce[s],ce[l]),I=i,O=r,z=s,B=l),!1!==c.equals(H)&&h===V||(e.blendColor(c.r,c.g,c.b,h),H.copy(c),V=h),D=t,G=!1;else if(t!==D||u!==G){if(N===o&&F===o||(e.blendEquation(e.FUNC_ADD),N=o,F=o),u)switch(t){case 1:e.blendFuncSeparate(e.ONE,e.ONE_MINUS_SRC_ALPHA,e.ONE,e.ONE_MINUS_SRC_ALPHA);break;case 2:e.blendFunc(e.ONE,e.ONE);break;case 3:e.blendFuncSeparate(e.ZERO,e.ONE_MINUS_SRC_COLOR,e.ZERO,e.ONE);break;case 4:e.blendFuncSeparate(e.ZERO,e.SRC_COLOR,e.ZERO,e.SRC_ALPHA);break;default:console.error("THREE.WebGLState: Invalid blending: ",t)}else switch(t){case 1:e.blendFuncSeparate(e.SRC_ALPHA,e.ONE_MINUS_SRC_ALPHA,e.ONE,e.ONE_MINUS_SRC_ALPHA);break;case 2:e.blendFunc(e.SRC_ALPHA,e.ONE);break;case 3:e.blendFuncSeparate(e.ZERO,e.ONE_MINUS_SRC_COLOR,e.ZERO,e.ONE);break;case 4:e.blendFunc(e.ZERO,e.SRC_COLOR);break;default:console.error("THREE.WebGLState: Invalid blending: ",t)}I=null,O=null,z=null,B=null,H.set(0,0,0),V=0,D=t,G=u}}else!0===U&&(oe(e.BLEND),U=!1)}function ue(t){k!==t&&(t?e.frontFace(e.CW):e.frontFace(e.CCW),k=t)}function de(t){0!==t?(se(e.CULL_FACE),t!==W&&(1===t?e.cullFace(e.BACK):2===t?e.cullFace(e.FRONT):e.cullFace(e.FRONT_AND_BACK))):oe(e.CULL_FACE),W=t}function pe(t,n,i){t?(se(e.POLYGON_OFFSET_FILL),j===n&&q===i||(e.polygonOffset(n,i),j=n,q=i)):oe(e.POLYGON_OFFSET_FILL)}return{buffers:{color:r,depth:a,stencil:s},enable:se,disable:oe,bindFramebuffer:function(t,n){return R[t]!==n&&(e.bindFramebuffer(t,n),R[t]=n,i&&(t===e.DRAW_FRAMEBUFFER&&(R[e.FRAMEBUFFER]=n),t===e.FRAMEBUFFER&&(R[e.DRAW_FRAMEBUFFER]=n)),!0)},drawBuffers:function(i,r){let a=L,s=!1;if(i)if(a=C.get(r),void 0===a&&(a=[],C.set(r,a)),i.isWebGLMultipleRenderTargets){const t=i.texture;if(a.length!==t.length||a[0]!==e.COLOR_ATTACHMENT0){for(let n=0,i=t.length;n<i;n++)a[n]=e.COLOR_ATTACHMENT0+n;a.length=t.length,s=!0}}else a[0]!==e.COLOR_ATTACHMENT0&&(a[0]=e.COLOR_ATTACHMENT0,s=!0);else a[0]!==e.BACK&&(a[0]=e.BACK,s=!0);s&&(n.isWebGL2?e.drawBuffers(a):t.get("WEBGL_draw_buffers").drawBuffersWEBGL(a))},useProgram:function(t){return P!==t&&(e.useProgram(t),P=t,!0)},setBlending:he,setMaterial:function(t,n){2===t.side?oe(e.CULL_FACE):se(e.CULL_FACE);let i=1===t.side;n&&(i=!i),ue(i),1===t.blending&&!1===t.transparent?he(0):he(t.blending,t.blendEquation,t.blendSrc,t.blendDst,t.blendEquationAlpha,t.blendSrcAlpha,t.blendDstAlpha,t.blendColor,t.blendAlpha,t.premultipliedAlpha),a.setFunc(t.depthFunc),a.setTest(t.depthTest),a.setMask(t.depthWrite),r.setMask(t.colorWrite);const o=t.stencilWrite;s.setTest(o),o&&(s.setMask(t.stencilWriteMask),s.setFunc(t.stencilFunc,t.stencilRef,t.stencilFuncMask),s.setOp(t.stencilFail,t.stencilZFail,t.stencilZPass)),pe(t.polygonOffset,t.polygonOffsetFactor,t.polygonOffsetUnits),!0===t.alphaToCoverage?se(e.SAMPLE_ALPHA_TO_COVERAGE):oe(e.SAMPLE_ALPHA_TO_COVERAGE)},setFlipSided:ue,setCullFace:de,setLineWidth:function(t){t!==X&&(K&&e.lineWidth(t),X=t)},setPolygonOffset:pe,setScissorTest:function(t){t?se(e.SCISSOR_TEST):oe(e.SCISSOR_TEST)},activeTexture:function(t){void 0===t&&(t=e.TEXTURE0+Y-1),Q!==t&&(e.activeTexture(t),Q=t)},bindTexture:function(t,n,i){void 0===i&&(i=null===Q?e.TEXTURE0+Y-1:Q);let r=$[i];void 0===r&&(r={type:void 0,texture:void 0},$[i]=r),r.type===t&&r.texture===n||(Q!==i&&(e.activeTexture(i),Q=i),e.bindTexture(t,n||ae[t]),r.type=t,r.texture=n)},unbindTexture:function(){const t=$[Q];void 0!==t&&void 0!==t.type&&(e.bindTexture(t.type,null),t.type=void 0,t.texture=void 0)},compressedTexImage2D:function(){try{e.compressedTexImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexImage3D:function(){try{e.compressedTexImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texImage2D:function(){try{e.texImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texImage3D:function(){try{e.texImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},updateUBOMapping:function(t,n){let i=w.get(n);void 0===i&&(i=new WeakMap,w.set(n,i));let r=i.get(t);void 0===r&&(r=e.getUniformBlockIndex(n,t.name),i.set(t,r))},uniformBlockBinding:function(t,n){const i=w.get(n).get(t);b.get(n)!==i&&(e.uniformBlockBinding(n,i,t.__bindingPointIndex),b.set(n,i))},texStorage2D:function(){try{e.texStorage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texStorage3D:function(){try{e.texStorage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texSubImage2D:function(){try{e.texSubImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texSubImage3D:function(){try{e.texSubImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexSubImage2D:function(){try{e.compressedTexSubImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexSubImage3D:function(){try{e.compressedTexSubImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},scissor:function(t){!1===ne.equals(t)&&(e.scissor(t.x,t.y,t.z,t.w),ne.copy(t))},viewport:function(t){!1===ie.equals(t)&&(e.viewport(t.x,t.y,t.z,t.w),ie.copy(t))},reset:function(){e.disable(e.BLEND),e.disable(e.CULL_FACE),e.disable(e.DEPTH_TEST),e.disable(e.POLYGON_OFFSET_FILL),e.disable(e.SCISSOR_TEST),e.disable(e.STENCIL_TEST),e.disable(e.SAMPLE_ALPHA_TO_COVERAGE),e.blendEquation(e.FUNC_ADD),e.blendFunc(e.ONE,e.ZERO),e.blendFuncSeparate(e.ONE,e.ZERO,e.ONE,e.ZERO),e.blendColor(0,0,0,0),e.colorMask(!0,!0,!0,!0),e.clearColor(0,0,0,0),e.depthMask(!0),e.depthFunc(e.LESS),e.clearDepth(1),e.stencilMask(4294967295),e.stencilFunc(e.ALWAYS,0,4294967295),e.stencilOp(e.KEEP,e.KEEP,e.KEEP),e.clearStencil(0),e.cullFace(e.BACK),e.frontFace(e.CCW),e.polygonOffset(0,0),e.activeTexture(e.TEXTURE0),e.bindFramebuffer(e.FRAMEBUFFER,null),!0===i&&(e.bindFramebuffer(e.DRAW_FRAMEBUFFER,null),e.bindFramebuffer(e.READ_FRAMEBUFFER,null)),e.useProgram(null),e.lineWidth(1),e.scissor(0,0,e.canvas.width,e.canvas.height),e.viewport(0,0,e.canvas.width,e.canvas.height),A={},Q=null,$={},R={},C=new WeakMap,L=[],P=null,U=!1,D=null,N=null,I=null,O=null,F=null,z=null,B=null,H=new On(0,0,0),V=0,G=!1,k=null,W=null,X=null,j=null,q=null,ne.set(0,0,e.canvas.width,e.canvas.height),ie.set(0,0,e.canvas.width,e.canvas.height),r.reset(),a.reset(),s.reset()}}}function ds(e,t,n,i,r,a,s){const o=r.isWebGL2,l=r.maxTextures,c=r.maxCubemapSize,h=r.maxTextureSize,u=r.maxSamples,d=t.has("WEBGL_multisampled_render_to_texture")?t.get("WEBGL_multisampled_render_to_texture"):null,p="undefined"!=typeof navigator&&/OculusBrowser/g.test(navigator.userAgent),f=new WeakMap;let m;const g=new WeakMap;let _=!1;try{_="undefined"!=typeof OffscreenCanvas&&null!==new OffscreenCanvas(1,1).getContext("2d")}catch(e){}function v(e,t){return _?new OffscreenCanvas(e,t):qe("canvas")}function x(e,t,n,i){let r=1;if((e.width>i||e.height>i)&&(r=i/Math.max(e.width,e.height)),r<1||!0===t){if("undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap){const i=t?He:Math.floor,a=i(r*e.width),s=i(r*e.height);void 0===m&&(m=v(a,s));const o=n?v(a,s):m;return o.width=a,o.height=s,o.getContext("2d").drawImage(e,0,0,a,s),console.warn("THREE.WebGLRenderer: Texture has been resized from ("+e.width+"x"+e.height+") to ("+a+"x"+s+")."),o}return"data"in e&&console.warn("THREE.WebGLRenderer: Image in DataTexture is too big ("+e.width+"x"+e.height+")."),e}return e}function M(e){return Be(e.width)&&Be(e.height)}function S(e,t){return e.generateMipmaps&&t&&e.minFilter!==H&&e.minFilter!==k}function y(t){e.generateMipmap(t)}function E(n,i,r,a){let s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(!1===o)return i;if(null!==n){if(void 0!==e[n])return e[n];console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'"+n+"\'")}let l=i;if(i===e.RED&&(r===e.FLOAT&&(l=e.R32F),r===e.HALF_FLOAT&&(l=e.R16F),r===e.UNSIGNED_BYTE&&(l=e.R8)),i===e.RED_INTEGER&&(r===e.UNSIGNED_BYTE&&(l=e.R8UI),r===e.UNSIGNED_SHORT&&(l=e.R16UI),r===e.UNSIGNED_INT&&(l=e.R32UI),r===e.BYTE&&(l=e.R8I),r===e.SHORT&&(l=e.R16I),r===e.INT&&(l=e.R32I)),i===e.RG&&(r===e.FLOAT&&(l=e.RG32F),r===e.HALF_FLOAT&&(l=e.RG16F),r===e.UNSIGNED_BYTE&&(l=e.RG8)),i===e.RGBA){const t=s?me:tt.getTransfer(a);r===e.FLOAT&&(l=e.RGBA32F),r===e.HALF_FLOAT&&(l=e.RGBA16F),r===e.UNSIGNED_BYTE&&(l=t===ge?e.SRGB8_ALPHA8:e.RGBA8),r===e.UNSIGNED_SHORT_4_4_4_4&&(l=e.RGBA4),r===e.UNSIGNED_SHORT_5_5_5_1&&(l=e.RGB5_A1)}return l!==e.R16F&&l!==e.R32F&&l!==e.RG16F&&l!==e.RG32F&&l!==e.RGBA16F&&l!==e.RGBA32F||t.get("EXT_color_buffer_float"),l}function T(e,t,n){return!0===S(e,n)||e.isFramebufferTexture&&e.minFilter!==H&&e.minFilter!==k?Math.log2(Math.max(t.width,t.height))+1:void 0!==e.mipmaps&&e.mipmaps.length>0?e.mipmaps.length:e.isCompressedTexture&&Array.isArray(e.image)?t.mipmaps.length:1}function b(t){return t===H||1004===t||t===G?e.NEAREST:e.LINEAR}function w(e){const t=e.target;t.removeEventListener("dispose",w),function(e){const t=i.get(e);if(void 0===t.__webglInit)return;const n=e.source,r=g.get(n);if(r){const i=r[t.__cacheKey];i.usedTimes--,0===i.usedTimes&&R(e),0===Object.keys(r).length&&g.delete(n)}i.remove(e)}(t),t.isVideoTexture&&f.delete(t)}function A(t){const n=t.target;n.removeEventListener("dispose",A),function(t){const n=t.texture,r=i.get(t),a=i.get(n);if(void 0!==a.__webglTexture&&(e.deleteTexture(a.__webglTexture),s.memory.textures--),t.depthTexture&&t.depthTexture.dispose(),t.isWebGLCubeRenderTarget)for(let t=0;t<6;t++){if(Array.isArray(r.__webglFramebuffer[t]))for(let n=0;n<r.__webglFramebuffer[t].length;n++)e.deleteFramebuffer(r.__webglFramebuffer[t][n]);else e.deleteFramebuffer(r.__webglFramebuffer[t]);r.__webglDepthbuffer&&e.deleteRenderbuffer(r.__webglDepthbuffer[t])}else{if(Array.isArray(r.__webglFramebuffer))for(let t=0;t<r.__webglFramebuffer.length;t++)e.deleteFramebuffer(r.__webglFramebuffer[t]);else e.deleteFramebuffer(r.__webglFramebuffer);if(r.__webglDepthbuffer&&e.deleteRenderbuffer(r.__webglDepthbuffer),r.__webglMultisampledFramebuffer&&e.deleteFramebuffer(r.__webglMultisampledFramebuffer),r.__webglColorRenderbuffer)for(let t=0;t<r.__webglColorRenderbuffer.length;t++)r.__webglColorRenderbuffer[t]&&e.deleteRenderbuffer(r.__webglColorRenderbuffer[t]);r.__webglDepthRenderbuffer&&e.deleteRenderbuffer(r.__webglDepthRenderbuffer)}if(t.isWebGLMultipleRenderTargets)for(let t=0,r=n.length;t<r;t++){const r=i.get(n[t]);r.__webglTexture&&(e.deleteTexture(r.__webglTexture),s.memory.textures--),i.remove(n[t])}i.remove(n),i.remove(t)}(n)}function R(t){const n=i.get(t);e.deleteTexture(n.__webglTexture);const r=t.source;delete g.get(r)[n.__cacheKey],s.memory.textures--}let C=0;function L(t,r){const a=i.get(t);if(t.isVideoTexture&&function(e){const t=s.render.frame;f.get(e)!==t&&(f.set(e,t),e.update())}(t),!1===t.isRenderTargetTexture&&t.version>0&&a.__version!==t.version){const e=t.image;if(null===e)console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");else{if(!1!==e.complete)return void O(a,t,r);console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete")}}n.bindTexture(e.TEXTURE_2D,a.__webglTexture,e.TEXTURE0+r)}const P={[F]:e.REPEAT,[z]:e.CLAMP_TO_EDGE,[B]:e.MIRRORED_REPEAT},U={[H]:e.NEAREST,[V]:e.NEAREST_MIPMAP_NEAREST,[G]:e.NEAREST_MIPMAP_LINEAR,[k]:e.LINEAR,[W]:e.LINEAR_MIPMAP_NEAREST,[X]:e.LINEAR_MIPMAP_LINEAR},D={[Me]:e.NEVER,[Ae]:e.ALWAYS,[Se]:e.LESS,[Ee]:e.LEQUAL,[ye]:e.EQUAL,[we]:e.GEQUAL,[Te]:e.GREATER,[be]:e.NOTEQUAL};function N(n,a,s){if(s?(e.texParameteri(n,e.TEXTURE_WRAP_S,P[a.wrapS]),e.texParameteri(n,e.TEXTURE_WRAP_T,P[a.wrapT]),n!==e.TEXTURE_3D&&n!==e.TEXTURE_2D_ARRAY||e.texParameteri(n,e.TEXTURE_WRAP_R,P[a.wrapR]),e.texParameteri(n,e.TEXTURE_MAG_FILTER,U[a.magFilter]),e.texParameteri(n,e.TEXTURE_MIN_FILTER,U[a.minFilter])):(e.texParameteri(n,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(n,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE),n!==e.TEXTURE_3D&&n!==e.TEXTURE_2D_ARRAY||e.texParameteri(n,e.TEXTURE_WRAP_R,e.CLAMP_TO_EDGE),a.wrapS===z&&a.wrapT===z||console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."),e.texParameteri(n,e.TEXTURE_MAG_FILTER,b(a.magFilter)),e.texParameteri(n,e.TEXTURE_MIN_FILTER,b(a.minFilter)),a.minFilter!==H&&a.minFilter!==k&&console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")),a.compareFunction&&(e.texParameteri(n,e.TEXTURE_COMPARE_MODE,e.COMPARE_REF_TO_TEXTURE),e.texParameteri(n,e.TEXTURE_COMPARE_FUNC,D[a.compareFunction])),!0===t.has("EXT_texture_filter_anisotropic")){const s=t.get("EXT_texture_filter_anisotropic");if(a.magFilter===H)return;if(a.minFilter!==G&&a.minFilter!==X)return;if(a.type===K&&!1===t.has("OES_texture_float_linear"))return;if(!1===o&&a.type===Z&&!1===t.has("OES_texture_half_float_linear"))return;(a.anisotropy>1||i.get(a).__currentAnisotropy)&&(e.texParameterf(n,s.TEXTURE_MAX_ANISOTROPY_EXT,Math.min(a.anisotropy,r.getMaxAnisotropy())),i.get(a).__currentAnisotropy=a.anisotropy)}}function I(t,n){let i=!1;void 0===t.__webglInit&&(t.__webglInit=!0,n.addEventListener("dispose",w));const r=n.source;let a=g.get(r);void 0===a&&(a={},g.set(r,a));const o=function(e){const t=[];return t.push(e.wrapS),t.push(e.wrapT),t.push(e.wrapR||0),t.push(e.magFilter),t.push(e.minFilter),t.push(e.anisotropy),t.push(e.internalFormat),t.push(e.format),t.push(e.type),t.push(e.generateMipmaps),t.push(e.premultiplyAlpha),t.push(e.flipY),t.push(e.unpackAlignment),t.push(e.colorSpace),t.join()}(n);if(o!==t.__cacheKey){void 0===a[o]&&(a[o]={texture:e.createTexture(),usedTimes:0},s.memory.textures++,i=!0),a[o].usedTimes++;const r=a[t.__cacheKey];void 0!==r&&(a[t.__cacheKey].usedTimes--,0===r.usedTimes&&R(n)),t.__cacheKey=o,t.__webglTexture=a[o].texture}return i}function O(t,r,s){let l=e.TEXTURE_2D;(r.isDataArrayTexture||r.isCompressedArrayTexture)&&(l=e.TEXTURE_2D_ARRAY),r.isData3DTexture&&(l=e.TEXTURE_3D);const c=I(t,r),u=r.source;n.bindTexture(l,t.__webglTexture,e.TEXTURE0+s);const d=i.get(u);if(u.version!==d.__version||!0===c){n.activeTexture(e.TEXTURE0+s);const t=tt.getPrimaries(tt.workingColorSpace),i=r.colorSpace===he?null:tt.getPrimaries(r.colorSpace),p=r.colorSpace===he||t===i?e.NONE:e.BROWSER_DEFAULT_WEBGL;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,r.flipY),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,r.premultiplyAlpha),e.pixelStorei(e.UNPACK_ALIGNMENT,r.unpackAlignment),e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL,p);const f=function(e){return!o&&(e.wrapS!==z||e.wrapT!==z||e.minFilter!==H&&e.minFilter!==k)}(r)&&!1===M(r.image);let m=x(r.image,f,!1,h);m=se(r,m);const g=M(m)||o,_=a.convert(r.format,r.colorSpace);let v,b=a.convert(r.type),w=E(r.internalFormat,_,b,r.colorSpace,r.isVideoTexture);N(l,r,g);const A=r.mipmaps,R=o&&!0!==r.isVideoTexture,C=void 0===d.__version||!0===c,L=T(r,m,g);if(r.isDepthTexture)w=e.DEPTH_COMPONENT,o?w=r.type===K?e.DEPTH_COMPONENT32F:r.type===Y?e.DEPTH_COMPONENT24:r.type===J?e.DEPTH24_STENCIL8:e.DEPTH_COMPONENT16:r.type===K&&console.error("WebGLRenderer: Floating point depth texture requires WebGL2."),r.format===$&&w===e.DEPTH_COMPONENT&&r.type!==q&&r.type!==Y&&(console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."),r.type=Y,b=a.convert(r.type)),r.format===ee&&w===e.DEPTH_COMPONENT&&(w=e.DEPTH_STENCIL,r.type!==J&&(console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."),r.type=J,b=a.convert(r.type))),C&&(R?n.texStorage2D(e.TEXTURE_2D,1,w,m.width,m.height):n.texImage2D(e.TEXTURE_2D,0,w,m.width,m.height,0,_,b,null));else if(r.isDataTexture)if(A.length>0&&g){R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,b,v.data):n.texImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,_,b,v.data);r.generateMipmaps=!1}else R?(C&&n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height),n.texSubImage2D(e.TEXTURE_2D,0,0,0,m.width,m.height,_,b,m.data)):n.texImage2D(e.TEXTURE_2D,0,w,m.width,m.height,0,_,b,m.data);else if(r.isCompressedTexture)if(r.isCompressedArrayTexture){R&&C&&n.texStorage3D(e.TEXTURE_2D_ARRAY,L,w,A[0].width,A[0].height,m.depth);for(let t=0,i=A.length;t<i;t++)v=A[t],r.format!==Q?null!==_?R?n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY,t,0,0,0,v.width,v.height,m.depth,_,v.data,0,0):n.compressedTexImage3D(e.TEXTURE_2D_ARRAY,t,w,v.width,v.height,m.depth,0,v.data,0,0):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"):R?n.texSubImage3D(e.TEXTURE_2D_ARRAY,t,0,0,0,v.width,v.height,m.depth,_,b,v.data):n.texImage3D(e.TEXTURE_2D_ARRAY,t,w,v.width,v.height,m.depth,0,_,b,v.data)}else{R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],r.format!==Q?null!==_?R?n.compressedTexSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,v.data):n.compressedTexImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,v.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"):R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,b,v.data):n.texImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,_,b,v.data)}else if(r.isDataArrayTexture)R?(C&&n.texStorage3D(e.TEXTURE_2D_ARRAY,L,w,m.width,m.height,m.depth),n.texSubImage3D(e.TEXTURE_2D_ARRAY,0,0,0,0,m.width,m.height,m.depth,_,b,m.data)):n.texImage3D(e.TEXTURE_2D_ARRAY,0,w,m.width,m.height,m.depth,0,_,b,m.data);else if(r.isData3DTexture)R?(C&&n.texStorage3D(e.TEXTURE_3D,L,w,m.width,m.height,m.depth),n.texSubImage3D(e.TEXTURE_3D,0,0,0,0,m.width,m.height,m.depth,_,b,m.data)):n.texImage3D(e.TEXTURE_3D,0,w,m.width,m.height,m.depth,0,_,b,m.data);else if(r.isFramebufferTexture){if(C)if(R)n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height);else{let t=m.width,i=m.height;for(let r=0;r<L;r++)n.texImage2D(e.TEXTURE_2D,r,w,t,i,0,_,b,null),t>>=1,i>>=1}}else if(A.length>0&&g){R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,_,b,v):n.texImage2D(e.TEXTURE_2D,t,w,_,b,v);r.generateMipmaps=!1}else R?(C&&n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height),n.texSubImage2D(e.TEXTURE_2D,0,0,0,_,b,m)):n.texImage2D(e.TEXTURE_2D,0,w,_,b,m);S(r,g)&&y(l),d.__version=u.version,r.onUpdate&&r.onUpdate(r)}t.__version=r.version}function te(t,r,s,o,l,c){const h=a.convert(s.format,s.colorSpace),u=a.convert(s.type),p=E(s.internalFormat,h,u,s.colorSpace);if(!i.get(r).__hasExternalTextures){const t=Math.max(1,r.width>>c),i=Math.max(1,r.height>>c);l===e.TEXTURE_3D||l===e.TEXTURE_2D_ARRAY?n.texImage3D(l,c,p,t,i,r.depth,0,h,u,null):n.texImage2D(l,c,p,t,i,0,h,u,null)}n.bindFramebuffer(e.FRAMEBUFFER,t),ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,o,l,i.get(s).__webglTexture,0,re(r)):(l===e.TEXTURE_2D||l>=e.TEXTURE_CUBE_MAP_POSITIVE_X&&l<=e.TEXTURE_CUBE_MAP_NEGATIVE_Z)&&e.framebufferTexture2D(e.FRAMEBUFFER,o,l,i.get(s).__webglTexture,c),n.bindFramebuffer(e.FRAMEBUFFER,null)}function ne(t,n,i){if(e.bindRenderbuffer(e.RENDERBUFFER,t),n.depthBuffer&&!n.stencilBuffer){let r=!0===o?e.DEPTH_COMPONENT24:e.DEPTH_COMPONENT16;if(i||ae(n)){const t=n.depthTexture;t&&t.isDepthTexture&&(t.type===K?r=e.DEPTH_COMPONENT32F:t.type===Y&&(r=e.DEPTH_COMPONENT24));const i=re(n);ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,i,r,n.width,n.height):e.renderbufferStorageMultisample(e.RENDERBUFFER,i,r,n.width,n.height)}else e.renderbufferStorage(e.RENDERBUFFER,r,n.width,n.height);e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t)}else if(n.depthBuffer&&n.stencilBuffer){const r=re(n);i&&!1===ae(n)?e.renderbufferStorageMultisample(e.RENDERBUFFER,r,e.DEPTH24_STENCIL8,n.width,n.height):ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,r,e.DEPTH24_STENCIL8,n.width,n.height):e.renderbufferStorage(e.RENDERBUFFER,e.DEPTH_STENCIL,n.width,n.height),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.RENDERBUFFER,t)}else{const t=!0===n.isWebGLMultipleRenderTargets?n.texture:[n.texture];for(let r=0;r<t.length;r++){const s=t[r],o=a.convert(s.format,s.colorSpace),l=a.convert(s.type),c=E(s.internalFormat,o,l,s.colorSpace),h=re(n);i&&!1===ae(n)?e.renderbufferStorageMultisample(e.RENDERBUFFER,h,c,n.width,n.height):ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,h,c,n.width,n.height):e.renderbufferStorage(e.RENDERBUFFER,c,n.width,n.height)}}e.bindRenderbuffer(e.RENDERBUFFER,null)}function ie(t){const r=i.get(t),a=!0===t.isWebGLCubeRenderTarget;if(t.depthTexture&&!r.__autoAllocateDepthBuffer){if(a)throw new Error("target.depthTexture not supported in Cube render targets");!function(t,r){if(r&&r.isWebGLCubeRenderTarget)throw new Error("Depth Texture with cube render targets is not supported");if(n.bindFramebuffer(e.FRAMEBUFFER,t),!r.depthTexture||!r.depthTexture.isDepthTexture)throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");i.get(r.depthTexture).__webglTexture&&r.depthTexture.image.width===r.width&&r.depthTexture.image.height===r.height||(r.depthTexture.image.width=r.width,r.depthTexture.image.height=r.height,r.depthTexture.needsUpdate=!0),L(r.depthTexture,0);const a=i.get(r.depthTexture).__webglTexture,s=re(r);if(r.depthTexture.format===$)ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.TEXTURE_2D,a,0,s):e.framebufferTexture2D(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.TEXTURE_2D,a,0);else{if(r.depthTexture.format!==ee)throw new Error("Unknown depthTexture format");ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.TEXTURE_2D,a,0,s):e.framebufferTexture2D(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.TEXTURE_2D,a,0)}}(r.__webglFramebuffer,t)}else if(a){r.__webglDepthbuffer=[];for(let i=0;i<6;i++)n.bindFramebuffer(e.FRAMEBUFFER,r.__webglFramebuffer[i]),r.__webglDepthbuffer[i]=e.createRenderbuffer(),ne(r.__webglDepthbuffer[i],t,!1)}else n.bindFramebuffer(e.FRAMEBUFFER,r.__webglFramebuffer),r.__webglDepthbuffer=e.createRenderbuffer(),ne(r.__webglDepthbuffer,t,!1);n.bindFramebuffer(e.FRAMEBUFFER,null)}function re(e){return Math.min(u,e.samples)}function ae(e){const n=i.get(e);return o&&e.samples>0&&!0===t.has("WEBGL_multisampled_render_to_texture")&&!1!==n.__useRenderToTexture}function se(e,n){const i=e.colorSpace,r=e.format,a=e.type;return!0===e.isCompressedTexture||!0===e.isVideoTexture||e.format===Ce||i!==de&&i!==he&&(tt.getTransfer(i)===ge?!1===o?!0===t.has("EXT_sRGB")&&r===Q?(e.format=Ce,e.minFilter=k,e.generateMipmaps=!1):n=at.sRGBToLinear(n):r===Q&&a===j||console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType."):console.error("THREE.WebGLTextures: Unsupported texture color space:",i)),n}this.allocateTextureUnit=function(){const e=C;return e>=l&&console.warn("THREE.WebGLTextures: Trying to use "+e+" texture units while this GPU supports only "+l),C+=1,e},this.resetTextureUnits=function(){C=0},this.setTexture2D=L,this.setTexture2DArray=function(t,r){const a=i.get(t);t.version>0&&a.__version!==t.version?O(a,t,r):n.bindTexture(e.TEXTURE_2D_ARRAY,a.__webglTexture,e.TEXTURE0+r)},this.setTexture3D=function(t,r){const a=i.get(t);t.version>0&&a.__version!==t.version?O(a,t,r):n.bindTexture(e.TEXTURE_3D,a.__webglTexture,e.TEXTURE0+r)},this.setTextureCube=function(t,r){const s=i.get(t);t.version>0&&s.__version!==t.version?function(t,r,s){if(6!==r.image.length)return;const l=I(t,r),h=r.source;n.bindTexture(e.TEXTURE_CUBE_MAP,t.__webglTexture,e.TEXTURE0+s);const u=i.get(h);if(h.version!==u.__version||!0===l){n.activeTexture(e.TEXTURE0+s);const t=tt.getPrimaries(tt.workingColorSpace),i=r.colorSpace===he?null:tt.getPrimaries(r.colorSpace),d=r.colorSpace===he||t===i?e.NONE:e.BROWSER_DEFAULT_WEBGL;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,r.flipY),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,r.premultiplyAlpha),e.pixelStorei(e.UNPACK_ALIGNMENT,r.unpackAlignment),e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL,d);const p=r.isCompressedTexture||r.image[0].isCompressedTexture,f=r.image[0]&&r.image[0].isDataTexture,m=[];for(let e=0;e<6;e++)m[e]=p||f?f?r.image[e].image:r.image[e]:x(r.image[e],!1,!0,c),m[e]=se(r,m[e]);const g=m[0],_=M(g)||o,v=a.convert(r.format,r.colorSpace),b=a.convert(r.type),w=E(r.internalFormat,v,b,r.colorSpace),A=o&&!0!==r.isVideoTexture,R=void 0===u.__version||!0===l;let C,L=T(r,g,_);if(N(e.TEXTURE_CUBE_MAP,r,_),p){A&&R&&n.texStorage2D(e.TEXTURE_CUBE_MAP,L,w,g.width,g.height);for(let t=0;t<6;t++){C=m[t].mipmaps;for(let i=0;i<C.length;i++){const a=C[i];r.format!==Q?null!==v?A?n.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,0,0,a.width,a.height,v,a.data):n.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,w,a.width,a.height,0,a.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()"):A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,0,0,a.width,a.height,v,b,a.data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,w,a.width,a.height,0,v,b,a.data)}}}else{C=r.mipmaps,A&&R&&(C.length>0&&L++,n.texStorage2D(e.TEXTURE_CUBE_MAP,L,w,m[0].width,m[0].height));for(let t=0;t<6;t++)if(f){A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,0,0,m[t].width,m[t].height,v,b,m[t].data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,w,m[t].width,m[t].height,0,v,b,m[t].data);for(let i=0;i<C.length;i++){const r=C[i].image[t].image;A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,0,0,r.width,r.height,v,b,r.data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,w,r.width,r.height,0,v,b,r.data)}}else{A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,0,0,v,b,m[t]):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,w,v,b,m[t]);for(let i=0;i<C.length;i++){const r=C[i];A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,0,0,v,b,r.image[t]):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,w,v,b,r.image[t])}}}S(r,_)&&y(e.TEXTURE_CUBE_MAP),u.__version=h.version,r.onUpdate&&r.onUpdate(r)}t.__version=r.version}(s,t,r):n.bindTexture(e.TEXTURE_CUBE_MAP,s.__webglTexture,e.TEXTURE0+r)},this.rebindTextures=function(t,n,r){const a=i.get(t);void 0!==n&&te(a.__webglFramebuffer,t,t.texture,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,0),void 0!==r&&ie(t)},this.setupRenderTarget=function(t){const l=t.texture,c=i.get(t),h=i.get(l);t.addEventListener("dispose",A),!0!==t.isWebGLMultipleRenderTargets&&(void 0===h.__webglTexture&&(h.__webglTexture=e.createTexture()),h.__version=l.version,s.memory.textures++);const u=!0===t.isWebGLCubeRenderTarget,d=!0===t.isWebGLMultipleRenderTargets,p=M(t)||o;if(u){c.__webglFramebuffer=[];for(let t=0;t<6;t++)if(o&&l.mipmaps&&l.mipmaps.length>0){c.__webglFramebuffer[t]=[];for(let n=0;n<l.mipmaps.length;n++)c.__webglFramebuffer[t][n]=e.createFramebuffer()}else c.__webglFramebuffer[t]=e.createFramebuffer()}else{if(o&&l.mipmaps&&l.mipmaps.length>0){c.__webglFramebuffer=[];for(let t=0;t<l.mipmaps.length;t++)c.__webglFramebuffer[t]=e.createFramebuffer()}else c.__webglFramebuffer=e.createFramebuffer();if(d)if(r.drawBuffers){const n=t.texture;for(let t=0,r=n.length;t<r;t++){const r=i.get(n[t]);void 0===r.__webglTexture&&(r.__webglTexture=e.createTexture(),s.memory.textures++)}}else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");if(o&&t.samples>0&&!1===ae(t)){const i=d?l:[l];c.__webglMultisampledFramebuffer=e.createFramebuffer(),c.__webglColorRenderbuffer=[],n.bindFramebuffer(e.FRAMEBUFFER,c.__webglMultisampledFramebuffer);for(let n=0;n<i.length;n++){const r=i[n];c.__webglColorRenderbuffer[n]=e.createRenderbuffer(),e.bindRenderbuffer(e.RENDERBUFFER,c.__webglColorRenderbuffer[n]);const s=a.convert(r.format,r.colorSpace),o=a.convert(r.type),l=E(r.internalFormat,s,o,r.colorSpace,!0===t.isXRRenderTarget),h=re(t);e.renderbufferStorageMultisample(e.RENDERBUFFER,h,l,t.width,t.height),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+n,e.RENDERBUFFER,c.__webglColorRenderbuffer[n])}e.bindRenderbuffer(e.RENDERBUFFER,null),t.depthBuffer&&(c.__webglDepthRenderbuffer=e.createRenderbuffer(),ne(c.__webglDepthRenderbuffer,t,!0)),n.bindFramebuffer(e.FRAMEBUFFER,null)}}if(u){n.bindTexture(e.TEXTURE_CUBE_MAP,h.__webglTexture),N(e.TEXTURE_CUBE_MAP,l,p);for(let n=0;n<6;n++)if(o&&l.mipmaps&&l.mipmaps.length>0)for(let i=0;i<l.mipmaps.length;i++)te(c.__webglFramebuffer[n][i],t,l,e.COLOR_ATTACHMENT0,e.TEXTURE_CUBE_MAP_POSITIVE_X+n,i);else te(c.__webglFramebuffer[n],t,l,e.COLOR_ATTACHMENT0,e.TEXTURE_CUBE_MAP_POSITIVE_X+n,0);S(l,p)&&y(e.TEXTURE_CUBE_MAP),n.unbindTexture()}else if(d){const r=t.texture;for(let a=0,s=r.length;a<s;a++){const s=r[a],o=i.get(s);n.bindTexture(e.TEXTURE_2D,o.__webglTexture),N(e.TEXTURE_2D,s,p),te(c.__webglFramebuffer,t,s,e.COLOR_ATTACHMENT0+a,e.TEXTURE_2D,0),S(s,p)&&y(e.TEXTURE_2D)}n.unbindTexture()}else{let i=e.TEXTURE_2D;if((t.isWebGL3DRenderTarget||t.isWebGLArrayRenderTarget)&&(o?i=t.isWebGL3DRenderTarget?e.TEXTURE_3D:e.TEXTURE_2D_ARRAY:console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")),n.bindTexture(i,h.__webglTexture),N(i,l,p),o&&l.mipmaps&&l.mipmaps.length>0)for(let n=0;n<l.mipmaps.length;n++)te(c.__webglFramebuffer[n],t,l,e.COLOR_ATTACHMENT0,i,n);else te(c.__webglFramebuffer,t,l,e.COLOR_ATTACHMENT0,i,0);S(l,p)&&y(i),n.unbindTexture()}t.depthBuffer&&ie(t)},this.updateRenderTargetMipmap=function(t){const r=M(t)||o,a=!0===t.isWebGLMultipleRenderTargets?t.texture:[t.texture];for(let s=0,o=a.length;s<o;s++){const o=a[s];if(S(o,r)){const r=t.isWebGLCubeRenderTarget?e.TEXTURE_CUBE_MAP:e.TEXTURE_2D,a=i.get(o).__webglTexture;n.bindTexture(r,a),y(r),n.unbindTexture()}}},this.updateMultisampleRenderTarget=function(t){if(o&&t.samples>0&&!1===ae(t)){const r=t.isWebGLMultipleRenderTargets?t.texture:[t.texture],a=t.width,s=t.height;let o=e.COLOR_BUFFER_BIT;const l=[],c=t.stencilBuffer?e.DEPTH_STENCIL_ATTACHMENT:e.DEPTH_ATTACHMENT,h=i.get(t),u=!0===t.isWebGLMultipleRenderTargets;if(u)for(let t=0;t<r.length;t++)n.bindFramebuffer(e.FRAMEBUFFER,h.__webglMultisampledFramebuffer),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.RENDERBUFFER,null),n.bindFramebuffer(e.FRAMEBUFFER,h.__webglFramebuffer),e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.TEXTURE_2D,null,0);n.bindFramebuffer(e.READ_FRAMEBUFFER,h.__webglMultisampledFramebuffer),n.bindFramebuffer(e.DRAW_FRAMEBUFFER,h.__webglFramebuffer);for(let n=0;n<r.length;n++){l.push(e.COLOR_ATTACHMENT0+n),t.depthBuffer&&l.push(c);const d=void 0!==h.__ignoreDepthValues&&h.__ignoreDepthValues;if(!1===d&&(t.depthBuffer&&(o|=e.DEPTH_BUFFER_BIT),t.stencilBuffer&&(o|=e.STENCIL_BUFFER_BIT)),u&&e.framebufferRenderbuffer(e.READ_FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.RENDERBUFFER,h.__webglColorRenderbuffer[n]),!0===d&&(e.invalidateFramebuffer(e.READ_FRAMEBUFFER,[c]),e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER,[c])),u){const t=i.get(r[n]).__webglTexture;e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0)}e.blitFramebuffer(0,0,a,s,0,0,a,s,o,e.NEAREST),p&&e.invalidateFramebuffer(e.READ_FRAMEBUFFER,l)}if(n.bindFramebuffer(e.READ_FRAMEBUFFER,null),n.bindFramebuffer(e.DRAW_FRAMEBUFFER,null),u)for(let t=0;t<r.length;t++){n.bindFramebuffer(e.FRAMEBUFFER,h.__webglMultisampledFramebuffer),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.RENDERBUFFER,h.__webglColorRenderbuffer[t]);const a=i.get(r[t]).__webglTexture;n.bindFramebuffer(e.FRAMEBUFFER,h.__webglFramebuffer),e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.TEXTURE_2D,a,0)}n.bindFramebuffer(e.DRAW_FRAMEBUFFER,h.__webglMultisampledFramebuffer)}},this.setupDepthRenderbuffer=ie,this.setupFrameBufferTexture=te,this.useMultisampledRTT=ae}function ps(e,t,n){const i=n.isWebGL2;return{convert:function(n){let r,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:he;const s=tt.getTransfer(a);if(n===j)return e.UNSIGNED_BYTE;if(1017===n)return e.UNSIGNED_SHORT_4_4_4_4;if(1018===n)return e.UNSIGNED_SHORT_5_5_5_1;if(1010===n)return e.BYTE;if(1011===n)return e.SHORT;if(n===q)return e.UNSIGNED_SHORT;if(1013===n)return e.INT;if(n===Y)return e.UNSIGNED_INT;if(n===K)return e.FLOAT;if(n===Z)return i?e.HALF_FLOAT:(r=t.get("OES_texture_half_float"),null!==r?r.HALF_FLOAT_OES:null);if(1021===n)return e.ALPHA;if(n===Q)return e.RGBA;if(1024===n)return e.LUMINANCE;if(1025===n)return e.LUMINANCE_ALPHA;if(n===$)return e.DEPTH_COMPONENT;if(n===ee)return e.DEPTH_STENCIL;if(n===Ce)return r=t.get("EXT_sRGB"),null!==r?r.SRGB_ALPHA_EXT:null;if(1028===n)return e.RED;if(1029===n)return e.RED_INTEGER;if(1030===n)return e.RG;if(1031===n)return e.RG_INTEGER;if(1033===n)return e.RGBA_INTEGER;if(n===te||n===ne||n===ie||n===re)if(s===ge){if(r=t.get("WEBGL_compressed_texture_s3tc_srgb"),null===r)return null;if(n===te)return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;if(n===ne)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;if(n===ie)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;if(n===re)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT}else{if(r=t.get("WEBGL_compressed_texture_s3tc"),null===r)return null;if(n===te)return r.COMPRESSED_RGB_S3TC_DXT1_EXT;if(n===ne)return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;if(n===ie)return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;if(n===re)return r.COMPRESSED_RGBA_S3TC_DXT5_EXT}if(35840===n||35841===n||35842===n||35843===n){if(r=t.get("WEBGL_compressed_texture_pvrtc"),null===r)return null;if(35840===n)return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;if(35841===n)return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;if(35842===n)return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;if(35843===n)return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG}if(36196===n)return r=t.get("WEBGL_compressed_texture_etc1"),null!==r?r.COMPRESSED_RGB_ETC1_WEBGL:null;if(37492===n||37496===n){if(r=t.get("WEBGL_compressed_texture_etc"),null===r)return null;if(37492===n)return s===ge?r.COMPRESSED_SRGB8_ETC2:r.COMPRESSED_RGB8_ETC2;if(37496===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC:r.COMPRESSED_RGBA8_ETC2_EAC}if(37808===n||37809===n||37810===n||37811===n||37812===n||37813===n||37814===n||37815===n||37816===n||37817===n||37818===n||37819===n||37820===n||37821===n){if(r=t.get("WEBGL_compressed_texture_astc"),null===r)return null;if(37808===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR:r.COMPRESSED_RGBA_ASTC_4x4_KHR;if(37809===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR:r.COMPRESSED_RGBA_ASTC_5x4_KHR;if(37810===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR:r.COMPRESSED_RGBA_ASTC_5x5_KHR;if(37811===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR:r.COMPRESSED_RGBA_ASTC_6x5_KHR;if(37812===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR:r.COMPRESSED_RGBA_ASTC_6x6_KHR;if(37813===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR:r.COMPRESSED_RGBA_ASTC_8x5_KHR;if(37814===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR:r.COMPRESSED_RGBA_ASTC_8x6_KHR;if(37815===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR:r.COMPRESSED_RGBA_ASTC_8x8_KHR;if(37816===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR:r.COMPRESSED_RGBA_ASTC_10x5_KHR;if(37817===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR:r.COMPRESSED_RGBA_ASTC_10x6_KHR;if(37818===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR:r.COMPRESSED_RGBA_ASTC_10x8_KHR;if(37819===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR:r.COMPRESSED_RGBA_ASTC_10x10_KHR;if(37820===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR:r.COMPRESSED_RGBA_ASTC_12x10_KHR;if(37821===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR:r.COMPRESSED_RGBA_ASTC_12x12_KHR}if(n===ae||36494===n||36495===n){if(r=t.get("EXT_texture_compression_bptc"),null===r)return null;if(n===ae)return s===ge?r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT:r.COMPRESSED_RGBA_BPTC_UNORM_EXT;if(36494===n)return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;if(36495===n)return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT}if(36283===n||36284===n||36285===n||36286===n){if(r=t.get("EXT_texture_compression_rgtc"),null===r)return null;if(n===ae)return r.COMPRESSED_RED_RGTC1_EXT;if(36284===n)return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;if(36285===n)return r.COMPRESSED_RED_GREEN_RGTC2_EXT;if(36286===n)return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT}return n===J?i?e.UNSIGNED_INT_24_8:(r=t.get("WEBGL_depth_texture"),null!==r?r.UNSIGNED_INT_24_8_WEBGL:null):void 0!==e[n]?e[n]:null}}}class fs extends Li{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];super(),this.isArrayCamera=!0,this.cameras=e}}class ms extends xn{constructor(){super(),this.isGroup=!0,this.type="Group"}}const gs={type:"move"};class _s{constructor(){this._targetRay=null,this._grip=null,this._hand=null}getHandSpace(){return null===this._hand&&(this._hand=new ms,this._hand.matrixAutoUpdate=!1,this._hand.visible=!1,this._hand.joints={},this._hand.inputState={pinching:!1}),this._hand}getTargetRaySpace(){return null===this._targetRay&&(this._targetRay=new ms,this._targetRay.matrixAutoUpdate=!1,this._targetRay.visible=!1,this._targetRay.hasLinearVelocity=!1,this._targetRay.linearVelocity=new _t,this._targetRay.hasAngularVelocity=!1,this._targetRay.angularVelocity=new _t),this._targetRay}getGripSpace(){return null===this._grip&&(this._grip=new ms,this._grip.matrixAutoUpdate=!1,this._grip.visible=!1,this._grip.hasLinearVelocity=!1,this._grip.linearVelocity=new _t,this._grip.hasAngularVelocity=!1,this._grip.angularVelocity=new _t),this._grip}dispatchEvent(e){return null!==this._targetRay&&this._targetRay.dispatchEvent(e),null!==this._grip&&this._grip.dispatchEvent(e),null!==this._hand&&this._hand.dispatchEvent(e),this}connect(e){if(e&&e.hand){const t=this._hand;if(t)for(const n of e.hand.values())this._getHandJoint(t,n)}return this.dispatchEvent({type:"connected",data:e}),this}disconnect(e){return this.dispatchEvent({type:"disconnected",data:e}),null!==this._targetRay&&(this._targetRay.visible=!1),null!==this._grip&&(this._grip.visible=!1),null!==this._hand&&(this._hand.visible=!1),this}update(e,t,n){let i=null,r=null,a=null;const s=this._targetRay,o=this._grip,l=this._hand;if(e&&"visible-blurred"!==t.session.visibilityState){if(l&&e.hand){a=!0;for(const i of e.hand.values()){const e=t.getJointPose(i,n),r=this._getHandJoint(l,i);null!==e&&(r.matrix.fromArray(e.transform.matrix),r.matrix.decompose(r.position,r.rotation,r.scale),r.matrixWorldNeedsUpdate=!0,r.jointRadius=e.radius),r.visible=null!==e}const i=l.joints["index-finger-tip"],r=l.joints["thumb-tip"],s=i.position.distanceTo(r.position),o=.02,c=.005;l.inputState.pinching&&s>o+c?(l.inputState.pinching=!1,this.dispatchEvent({type:"pinchend",handedness:e.handedness,target:this})):!l.inputState.pinching&&s<=o-c&&(l.inputState.pinching=!0,this.dispatchEvent({type:"pinchstart",handedness:e.handedness,target:this}))}else null!==o&&e.gripSpace&&(r=t.getPose(e.gripSpace,n),null!==r&&(o.matrix.fromArray(r.transform.matrix),o.matrix.decompose(o.position,o.rotation,o.scale),o.matrixWorldNeedsUpdate=!0,r.linearVelocity?(o.hasLinearVelocity=!0,o.linearVelocity.copy(r.linearVelocity)):o.hasLinearVelocity=!1,r.angularVelocity?(o.hasAngularVelocity=!0,o.angularVelocity.copy(r.angularVelocity)):o.hasAngularVelocity=!1));null!==s&&(i=t.getPose(e.targetRaySpace,n),null===i&&null!==r&&(i=r),null!==i&&(s.matrix.fromArray(i.transform.matrix),s.matrix.decompose(s.position,s.rotation,s.scale),s.matrixWorldNeedsUpdate=!0,i.linearVelocity?(s.hasLinearVelocity=!0,s.linearVelocity.copy(i.linearVelocity)):s.hasLinearVelocity=!1,i.angularVelocity?(s.hasAngularVelocity=!0,s.angularVelocity.copy(i.angularVelocity)):s.hasAngularVelocity=!1,this.dispatchEvent(gs)))}return null!==s&&(s.visible=null!==i),null!==o&&(o.visible=null!==r),null!==l&&(l.visible=null!==a),this}_getHandJoint(e,t){if(void 0===e.joints[t.jointName]){const n=new ms;n.matrixAutoUpdate=!1,n.visible=!1,e.joints[t.jointName]=n,e.add(n)}return e.joints[t.jointName]}}class vs extends ht{constructor(e,t,n,i,r,a,s,o,l,c){if((c=void 0!==c?c:$)!==$&&c!==ee)throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");void 0===n&&c===$&&(n=Y),void 0===n&&c===ee&&(n=J),super(null,i,r,a,s,o,c,n,l),this.isDepthTexture=!0,this.image={width:e,height:t},this.magFilter=void 0!==s?s:H,this.minFilter=void 0!==o?o:H,this.flipY=!1,this.generateMipmaps=!1,this.compareFunction=null}copy(e){return super.copy(e),this.compareFunction=e.compareFunction,this}toJSON(e){const t=super.toJSON(e);return null!==this.compareFunction&&(t.compareFunction=this.compareFunction),t}}class xs extends Ue{constructor(e,t){super();const n=this;let i=null,r=1,a=null,s="local-floor",o=1,l=null,c=null,h=null,u=null,d=null,p=null;const f=t.getContextAttributes();let m=null,g=null;const _=[],v=[],x=new Li;x.layers.enable(1),x.viewport=new ut;const M=new Li;M.layers.enable(2),M.viewport=new ut;const S=[x,M],y=new fs;y.layers.enable(1),y.layers.enable(2);let E=null,T=null;function b(e){const t=v.indexOf(e.inputSource);if(-1===t)return;const n=_[t];void 0!==n&&(n.update(e.inputSource,e.frame,l||a),n.dispatchEvent({type:e.type,data:e.inputSource}))}function w(){i.removeEventListener("select",b),i.removeEventListener("selectstart",b),i.removeEventListener("selectend",b),i.removeEventListener("squeeze",b),i.removeEventListener("squeezestart",b),i.removeEventListener("squeezeend",b),i.removeEventListener("end",w),i.removeEventListener("inputsourceschange",A);for(let e=0;e<_.length;e++){const t=v[e];null!==t&&(v[e]=null,_[e].disconnect(t))}E=null,T=null,e.setRenderTarget(m),d=null,u=null,h=null,i=null,g=null,U.stop(),n.isPresenting=!1,n.dispatchEvent({type:"sessionend"})}function A(e){for(let t=0;t<e.removed.length;t++){const n=e.removed[t],i=v.indexOf(n);i>=0&&(v[i]=null,_[i].disconnect(n))}for(let t=0;t<e.added.length;t++){const n=e.added[t];let i=v.indexOf(n);if(-1===i){for(let e=0;e<_.length;e++){if(e>=v.length){v.push(n),i=e;break}if(null===v[e]){v[e]=n,i=e;break}}if(-1===i)break}const r=_[i];r&&r.connect(n)}}this.cameraAutoUpdate=!0,this.enabled=!1,this.isPresenting=!1,this.getController=function(e){let t=_[e];return void 0===t&&(t=new _s,_[e]=t),t.getTargetRaySpace()},this.getControllerGrip=function(e){let t=_[e];return void 0===t&&(t=new _s,_[e]=t),t.getGripSpace()},this.getHand=function(e){let t=_[e];return void 0===t&&(t=new _s,_[e]=t),t.getHandSpace()},this.setFramebufferScaleFactor=function(e){r=e,!0===n.isPresenting&&console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.")},this.setReferenceSpaceType=function(e){s=e,!0===n.isPresenting&&console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.")},this.getReferenceSpace=function(){return l||a},this.setReferenceSpace=function(e){l=e},this.getBaseLayer=function(){return null!==u?u:d},this.getBinding=function(){return h},this.getFrame=function(){return p},this.getSession=function(){return i},this.setSession=async function(c){if(i=c,null!==i){if(m=e.getRenderTarget(),i.addEventListener("select",b),i.addEventListener("selectstart",b),i.addEventListener("selectend",b),i.addEventListener("squeeze",b),i.addEventListener("squeezestart",b),i.addEventListener("squeezeend",b),i.addEventListener("end",w),i.addEventListener("inputsourceschange",A),!0!==f.xrCompatible&&await t.makeXRCompatible(),void 0===i.renderState.layers||!1===e.capabilities.isWebGL2){const n={antialias:void 0!==i.renderState.layers||f.antialias,alpha:!0,depth:f.depth,stencil:f.stencil,framebufferScaleFactor:r};d=new XRWebGLLayer(i,t,n),i.updateRenderState({baseLayer:d}),g=new pt(d.framebufferWidth,d.framebufferHeight,{format:Q,type:j,colorSpace:e.outputColorSpace,stencilBuffer:f.stencil})}else{let n=null,a=null,s=null;f.depth&&(s=f.stencil?t.DEPTH24_STENCIL8:t.DEPTH_COMPONENT24,n=f.stencil?ee:$,a=f.stencil?J:Y);const o={colorFormat:t.RGBA8,depthFormat:s,scaleFactor:r};h=new XRWebGLBinding(i,t),u=h.createProjectionLayer(o),i.updateRenderState({layers:[u]}),g=new pt(u.textureWidth,u.textureHeight,{format:Q,type:j,depthTexture:new vs(u.textureWidth,u.textureHeight,a,void 0,void 0,void 0,void 0,void 0,void 0,n),stencilBuffer:f.stencil,colorSpace:e.outputColorSpace,samples:f.antialias?4:0}),e.properties.get(g).__ignoreDepthValues=u.ignoreDepthValues}g.isXRRenderTarget=!0,this.setFoveation(o),l=null,a=await i.requestReferenceSpace(s),U.setContext(i),U.start(),n.isPresenting=!0,n.dispatchEvent({type:"sessionstart"})}},this.getEnvironmentBlendMode=function(){if(null!==i)return i.environmentBlendMode};const R=new _t,C=new _t;function L(e,t){null===t?e.matrixWorld.copy(e.matrix):e.matrixWorld.multiplyMatrices(t.matrixWorld,e.matrix),e.matrixWorldInverse.copy(e.matrixWorld).invert()}this.updateCamera=function(e){if(null===i)return;y.near=M.near=x.near=e.near,y.far=M.far=x.far=e.far,E===y.near&&T===y.far||(i.updateRenderState({depthNear:y.near,depthFar:y.far}),E=y.near,T=y.far);const t=e.parent,n=y.cameras;L(y,t);for(let e=0;e<n.length;e++)L(n[e],t);2===n.length?function(e,t,n){R.setFromMatrixPosition(t.matrixWorld),C.setFromMatrixPosition(n.matrixWorld);const i=R.distanceTo(C),r=t.projectionMatrix.elements,a=n.projectionMatrix.elements,s=r[14]/(r[10]-1),o=r[14]/(r[10]+1),l=(r[9]+1)/r[5],c=(r[9]-1)/r[5],h=(r[8]-1)/r[0],u=(a[8]+1)/a[0],d=s*h,p=s*u,f=i/(-h+u),m=f*-h;t.matrixWorld.decompose(e.position,e.quaternion,e.scale),e.translateX(m),e.translateZ(f),e.matrixWorld.compose(e.position,e.quaternion,e.scale),e.matrixWorldInverse.copy(e.matrixWorld).invert();const g=s+f,_=o+f,v=d-m,x=p+(i-m),M=l*o/_*g,S=c*o/_*g;e.projectionMatrix.makePerspective(v,x,M,S,g,_),e.projectionMatrixInverse.copy(e.projectionMatrix).invert()}(y,x,M):y.projectionMatrix.copy(x.projectionMatrix),function(e,t,n){null===n?e.matrix.copy(t.matrixWorld):(e.matrix.copy(n.matrixWorld),e.matrix.invert(),e.matrix.multiply(t.matrixWorld)),e.matrix.decompose(e.position,e.quaternion,e.scale),e.updateMatrixWorld(!0),e.projectionMatrix.copy(t.projectionMatrix),e.projectionMatrixInverse.copy(t.projectionMatrixInverse),e.isPerspectiveCamera&&(e.fov=2*Ie*Math.atan(1/e.projectionMatrix.elements[5]),e.zoom=1)}(e,y,t)},this.getCamera=function(){return y},this.getFoveation=function(){if(null!==u||null!==d)return o},this.setFoveation=function(e){o=e,null!==u&&(u.fixedFoveation=e),null!==d&&void 0!==d.fixedFoveation&&(d.fixedFoveation=e)};let P=null;const U=new Gi;U.setAnimationLoop((function(t,i){if(c=i.getViewerPose(l||a),p=i,null!==c){const t=c.views;null!==d&&(e.setRenderTargetFramebuffer(g,d.framebuffer),e.setRenderTarget(g));let n=!1;t.length!==y.cameras.length&&(y.cameras.length=0,n=!0);for(let i=0;i<t.length;i++){const r=t[i];let a=null;if(null!==d)a=d.getViewport(r);else{const t=h.getViewSubImage(u,r);a=t.viewport,0===i&&(e.setRenderTargetTextures(g,t.colorTexture,u.ignoreDepthValues?void 0:t.depthStencilTexture),e.setRenderTarget(g))}let s=S[i];void 0===s&&(s=new Li,s.layers.enable(i),s.viewport=new ut,S[i]=s),s.matrix.fromArray(r.transform.matrix),s.matrix.decompose(s.position,s.quaternion,s.scale),s.projectionMatrix.fromArray(r.projectionMatrix),s.projectionMatrixInverse.copy(s.projectionMatrix).invert(),s.viewport.set(a.x,a.y,a.width,a.height),0===i&&(y.matrix.copy(s.matrix),y.matrix.decompose(y.position,y.quaternion,y.scale)),!0===n&&y.cameras.push(s)}}for(let e=0;e<_.length;e++){const t=v[e],n=_[e];null!==t&&void 0!==n&&n.update(t,i,l||a)}P&&P(t,i),i.detectedPlanes&&n.dispatchEvent({type:"planesdetected",data:i}),p=null})),this.setAnimationLoop=function(e){P=e},this.dispose=function(){}}}function Ms(e,t){function n(e,t){!0===e.matrixAutoUpdate&&e.updateMatrix(),t.value.copy(e.matrix)}function i(i,r){i.opacity.value=r.opacity,r.color&&i.diffuse.value.copy(r.color),r.emissive&&i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity),r.map&&(i.map.value=r.map,n(r.map,i.mapTransform)),r.alphaMap&&(i.alphaMap.value=r.alphaMap,n(r.alphaMap,i.alphaMapTransform)),r.bumpMap&&(i.bumpMap.value=r.bumpMap,n(r.bumpMap,i.bumpMapTransform),i.bumpScale.value=r.bumpScale,1===r.side&&(i.bumpScale.value*=-1)),r.normalMap&&(i.normalMap.value=r.normalMap,n(r.normalMap,i.normalMapTransform),i.normalScale.value.copy(r.normalScale),1===r.side&&i.normalScale.value.negate()),r.displacementMap&&(i.displacementMap.value=r.displacementMap,n(r.displacementMap,i.displacementMapTransform),i.displacementScale.value=r.displacementScale,i.displacementBias.value=r.displacementBias),r.emissiveMap&&(i.emissiveMap.value=r.emissiveMap,n(r.emissiveMap,i.emissiveMapTransform)),r.specularMap&&(i.specularMap.value=r.specularMap,n(r.specularMap,i.specularMapTransform)),r.alphaTest>0&&(i.alphaTest.value=r.alphaTest);const a=t.get(r).envMap;if(a&&(i.envMap.value=a,i.flipEnvMap.value=a.isCubeTexture&&!1===a.isRenderTargetTexture?-1:1,i.reflectivity.value=r.reflectivity,i.ior.value=r.ior,i.refractionRatio.value=r.refractionRatio),r.lightMap){i.lightMap.value=r.lightMap;const t=!0===e._useLegacyLights?Math.PI:1;i.lightMapIntensity.value=r.lightMapIntensity*t,n(r.lightMap,i.lightMapTransform)}r.aoMap&&(i.aoMap.value=r.aoMap,i.aoMapIntensity.value=r.aoMapIntensity,n(r.aoMap,i.aoMapTransform))}return{refreshFogUniforms:function(t,n){n.color.getRGB(t.fogColor.value,wi(e)),n.isFog?(t.fogNear.value=n.near,t.fogFar.value=n.far):n.isFogExp2&&(t.fogDensity.value=n.density)},refreshMaterialUniforms:function(e,r,a,s,o){r.isMeshBasicMaterial||r.isMeshLambertMaterial?i(e,r):r.isMeshToonMaterial?(i(e,r),function(e,t){t.gradientMap&&(e.gradientMap.value=t.gradientMap)}(e,r)):r.isMeshPhongMaterial?(i(e,r),function(e,t){e.specular.value.copy(t.specular),e.shininess.value=Math.max(t.shininess,1e-4)}(e,r)):r.isMeshStandardMaterial?(i(e,r),function(e,i){e.metalness.value=i.metalness,i.metalnessMap&&(e.metalnessMap.value=i.metalnessMap,n(i.metalnessMap,e.metalnessMapTransform)),e.roughness.value=i.roughness,i.roughnessMap&&(e.roughnessMap.value=i.roughnessMap,n(i.roughnessMap,e.roughnessMapTransform));t.get(i).envMap&&(e.envMapIntensity.value=i.envMapIntensity)}(e,r),r.isMeshPhysicalMaterial&&function(e,t,i){e.ior.value=t.ior,t.sheen>0&&(e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen),e.sheenRoughness.value=t.sheenRoughness,t.sheenColorMap&&(e.sheenColorMap.value=t.sheenColorMap,n(t.sheenColorMap,e.sheenColorMapTransform)),t.sheenRoughnessMap&&(e.sheenRoughnessMap.value=t.sheenRoughnessMap,n(t.sheenRoughnessMap,e.sheenRoughnessMapTransform))),t.clearcoat>0&&(e.clearcoat.value=t.clearcoat,e.clearcoatRoughness.value=t.clearcoatRoughness,t.clearcoatMap&&(e.clearcoatMap.value=t.clearcoatMap,n(t.clearcoatMap,e.clearcoatMapTransform)),t.clearcoatRoughnessMap&&(e.clearcoatRoughnessMap.value=t.clearcoatRoughnessMap,n(t.clearcoatRoughnessMap,e.clearcoatRoughnessMapTransform)),t.clearcoatNormalMap&&(e.clearcoatNormalMap.value=t.clearcoatNormalMap,n(t.clearcoatNormalMap,e.clearcoatNormalMapTransform),e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale),1===t.side&&e.clearcoatNormalScale.value.negate())),t.iridescence>0&&(e.iridescence.value=t.iridescence,e.iridescenceIOR.value=t.iridescenceIOR,e.iridescenceThicknessMinimum.value=t.iridescenceThicknessRange[0],e.iridescenceThicknessMaximum.value=t.iridescenceThicknessRange[1],t.iridescenceMap&&(e.iridescenceMap.value=t.iridescenceMap,n(t.iridescenceMap,e.iridescenceMapTransform)),t.iridescenceThicknessMap&&(e.iridescenceThicknessMap.value=t.iridescenceThicknessMap,n(t.iridescenceThicknessMap,e.iridescenceThicknessMapTransform))),t.transmission>0&&(e.transmission.value=t.transmission,e.transmissionSamplerMap.value=i.texture,e.transmissionSamplerSize.value.set(i.width,i.height),t.transmissionMap&&(e.transmissionMap.value=t.transmissionMap,n(t.transmissionMap,e.transmissionMapTransform)),e.thickness.value=t.thickness,t.thicknessMap&&(e.thicknessMap.value=t.thicknessMap,n(t.thicknessMap,e.thicknessMapTransform)),e.attenuationDistance.value=t.attenuationDistance,e.attenuationColor.value.copy(t.attenuationColor)),t.anisotropy>0&&(e.anisotropyVector.value.set(t.anisotropy*Math.cos(t.anisotropyRotation),t.anisotropy*Math.sin(t.anisotropyRotation)),t.anisotropyMap&&(e.anisotropyMap.value=t.anisotropyMap,n(t.anisotropyMap,e.anisotropyMapTransform))),e.specularIntensity.value=t.specularIntensity,e.specularColor.value.copy(t.specularColor),t.specularColorMap&&(e.specularColorMap.value=t.specularColorMap,n(t.specularColorMap,e.specularColorMapTransform)),t.specularIntensityMap&&(e.specularIntensityMap.value=t.specularIntensityMap,n(t.specularIntensityMap,e.specularIntensityMapTransform))}(e,r,o)):r.isMeshMatcapMaterial?(i(e,r),function(e,t){t.matcap&&(e.matcap.value=t.matcap)}(e,r)):r.isMeshDepthMaterial?i(e,r):r.isMeshDistanceMaterial?(i(e,r),function(e,n){const i=t.get(n).light;e.referencePosition.value.setFromMatrixPosition(i.matrixWorld),e.nearDistance.value=i.shadow.camera.near,e.farDistance.value=i.shadow.camera.far}(e,r)):r.isMeshNormalMaterial?i(e,r):r.isLineBasicMaterial?(function(e,t){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,t.map&&(e.map.value=t.map,n(t.map,e.mapTransform))}(e,r),r.isLineDashedMaterial&&function(e,t){e.dashSize.value=t.dashSize,e.totalSize.value=t.dashSize+t.gapSize,e.scale.value=t.scale}(e,r)):r.isPointsMaterial?function(e,t,i,r){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,e.size.value=t.size*i,e.scale.value=.5*r,t.map&&(e.map.value=t.map,n(t.map,e.uvTransform)),t.alphaMap&&(e.alphaMap.value=t.alphaMap,n(t.alphaMap,e.alphaMapTransform)),t.alphaTest>0&&(e.alphaTest.value=t.alphaTest)}(e,r,a,s):r.isSpriteMaterial?function(e,t){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,e.rotation.value=t.rotation,t.map&&(e.map.value=t.map,n(t.map,e.mapTransform)),t.alphaMap&&(e.alphaMap.value=t.alphaMap,n(t.alphaMap,e.alphaMapTransform)),t.alphaTest>0&&(e.alphaTest.value=t.alphaTest)}(e,r):r.isShadowMaterial?(e.color.value.copy(r.color),e.opacity.value=r.opacity):r.isShaderMaterial&&(r.uniformsNeedUpdate=!1)}}}function Ss(e,t,n,i){let r={},a={},s=[];const o=n.isWebGL2?e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS):0;function l(e,t,n){const i=e.value;if(void 0===n[t]){if("number"==typeof i)n[t]=i;else{const e=Array.isArray(i)?i:[i],r=[];for(let t=0;t<e.length;t++)r.push(e[t].clone());n[t]=r}return!0}if("number"==typeof i){if(n[t]!==i)return n[t]=i,!0}else{const e=Array.isArray(n[t])?n[t]:[n[t]],r=Array.isArray(i)?i:[i];for(let t=0;t<e.length;t++){const n=e[t];if(!1===n.equals(r[t]))return n.copy(r[t]),!0}}return!1}function c(e){const t={boundary:0,storage:0};return"number"==typeof e?(t.boundary=4,t.storage=4):e.isVector2?(t.boundary=8,t.storage=8):e.isVector3||e.isColor?(t.boundary=16,t.storage=12):e.isVector4?(t.boundary=16,t.storage=16):e.isMatrix3?(t.boundary=48,t.storage=48):e.isMatrix4?(t.boundary=64,t.storage=64):e.isTexture?console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group."):console.warn("THREE.WebGLRenderer: Unsupported uniform value type.",e),t}function h(t){const n=t.target;n.removeEventListener("dispose",h);const i=s.indexOf(n.__bindingPointIndex);s.splice(i,1),e.deleteBuffer(r[n.id]),delete r[n.id],delete a[n.id]}return{bind:function(e,t){const n=t.program;i.uniformBlockBinding(e,n)},update:function(n,u){let d=r[n.id];void 0===d&&(function(e){const t=e.uniforms;let n=0;let i=0;for(let e=0,r=t.length;e<r;e++){const r=t[e],a={boundary:0,storage:0},s=Array.isArray(r.value)?r.value:[r.value];for(let e=0,t=s.length;e<t;e++){const t=c(s[e]);a.boundary+=t.boundary,a.storage+=t.storage}r.__data=new Float32Array(a.storage/Float32Array.BYTES_PER_ELEMENT),r.__offset=n,e>0&&(i=n%16,0!==i&&16-i-a.boundary<0&&(n+=16-i,r.__offset=n)),n+=a.storage}i=n%16,i>0&&(n+=16-i),e.__size=n,e.__cache={}}(n),d=function(t){const n=function(){for(let e=0;e<o;e++)if(-1===s.indexOf(e))return s.push(e),e;return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."),0}();t.__bindingPointIndex=n;const i=e.createBuffer(),r=t.__size,a=t.usage;return e.bindBuffer(e.UNIFORM_BUFFER,i),e.bufferData(e.UNIFORM_BUFFER,r,a),e.bindBuffer(e.UNIFORM_BUFFER,null),e.bindBufferBase(e.UNIFORM_BUFFER,n,i),i}(n),r[n.id]=d,n.addEventListener("dispose",h));const p=u.program;i.updateUBOMapping(n,p);const f=t.render.frame;a[n.id]!==f&&(function(t){const n=r[t.id],i=t.uniforms,a=t.__cache;e.bindBuffer(e.UNIFORM_BUFFER,n);for(let t=0,n=i.length;t<n;t++){const n=i[t];if(!0===l(n,t,a)){const t=n.__offset,i=Array.isArray(n.value)?n.value:[n.value];let r=0;for(let a=0;a<i.length;a++){const s=i[a],o=c(s);"number"==typeof s?(n.__data[0]=s,e.bufferSubData(e.UNIFORM_BUFFER,t+r,n.__data)):s.isMatrix3?(n.__data[0]=s.elements[0],n.__data[1]=s.elements[1],n.__data[2]=s.elements[2],n.__data[3]=s.elements[0],n.__data[4]=s.elements[3],n.__data[5]=s.elements[4],n.__data[6]=s.elements[5],n.__data[7]=s.elements[0],n.__data[8]=s.elements[6],n.__data[9]=s.elements[7],n.__data[10]=s.elements[8],n.__data[11]=s.elements[0]):(s.toArray(n.__data,r),r+=o.storage/Float32Array.BYTES_PER_ELEMENT)}e.bufferSubData(e.UNIFORM_BUFFER,t,n.__data)}}e.bindBuffer(e.UNIFORM_BUFFER,null)}(n),a[n.id]=f)},dispose:function(){for(const t in r)e.deleteBuffer(r[t]);s=[],r={},a={}}}}class ys{constructor(){let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{canvas:n=Ye(),context:i=null,depth:r=!0,stencil:a=!0,alpha:s=!1,antialias:o=!1,premultipliedAlpha:l=!0,preserveDrawingBuffer:c=!1,powerPreference:h="default",failIfMajorPerformanceCaveat:u=!1}=t;let d;this.isWebGLRenderer=!0,d=null!==i?i.getContextAttributes().alpha:s;const p=new Uint32Array(4),f=new Int32Array(4);let m=null,g=null;const _=[],v=[];this.domElement=n,this.debug={checkShaderErrors:!0,onShaderError:null},this.autoClear=!0,this.autoClearColor=!0,this.autoClearDepth=!0,this.autoClearStencil=!0,this.sortObjects=!0,this.clippingPlanes=[],this.localClippingEnabled=!1,this._outputColorSpace=ue,this._useLegacyLights=!1,this.toneMapping=R,this.toneMappingExposure=1;const x=this;let M=!1,S=0,y=0,E=null,T=-1,b=null;const w=new ut,A=new ut;let C=null;const L=new On(0);let P=0,U=n.width,D=n.height,N=1,I=null,O=null;const F=new ut(0,0,U,D),z=new ut(0,0,U,D);let B=!1;const H=new Vi;let V=!1,G=!1,k=null;const W=new qt,$=new ke,ee=new _t,te={background:null,fog:null,environment:null,overrideMaterial:null,isScene:!0};function ne(){return null===E?N:1}let ie,re,ae,se,oe,le,ce,he,pe,fe,me,ge,_e,ve,xe,Me,Se,ye,Ee,Te,be,we,Ae,Re,Ce=i;function Le(e,t){for(let i=0;i<e.length;i++){const r=e[i],a=n.getContext(r,t);if(null!==a)return a}return null}try{const t={alpha:!0,depth:r,stencil:a,antialias:o,premultipliedAlpha:l,preserveDrawingBuffer:c,powerPreference:h,failIfMajorPerformanceCaveat:u};if("setAttribute"in n&&n.setAttribute("data-engine",`three.js r${e}`),n.addEventListener("webglcontextlost",De,!1),n.addEventListener("webglcontextrestored",Ne,!1),n.addEventListener("webglcontextcreationerror",Ie,!1),null===Ce){const e=["webgl2","webgl","experimental-webgl"];if(!0===x.isWebGL1Renderer&&e.shift(),Ce=Le(e,t),null===Ce)throw Le(e)?new Error("Error creating WebGL context with your selected attributes."):new Error("Error creating WebGL context.")}"undefined"!=typeof WebGLRenderingContext&&Ce instanceof WebGLRenderingContext&&console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."),void 0===Ce.getShaderPrecisionFormat&&(Ce.getShaderPrecisionFormat=function(){return{rangeMin:1,rangeMax:1,precision:1}})}catch(e){throw console.error("THREE.WebGLRenderer: "+e.message),e}function Pe(){ie=new _r(Ce),re=new Qi(Ce,ie,t),ie.init(re),we=new ps(Ce,ie,re),ae=new us(Ce,ie,re),se=new Mr(Ce),oe=new Ja,le=new ds(Ce,ie,ae,oe,re,we,se),ce=new er(x),he=new gr(x),pe=new ki(Ce,re),Ae=new Zi(Ce,ie,pe,re),fe=new vr(Ce,pe,se,Ae),me=new Tr(Ce,fe,pe,se),Ee=new Er(Ce,re,le),Me=new $i(oe),ge=new Za(x,ce,he,ie,re,Ae,Me),_e=new Ms(x,oe),ve=new ts,xe=new os(ie,re),ye=new Ki(x,ce,he,ae,me,d,l),Se=new hs(x,me,re),Re=new Ss(Ce,se,re,ae),Te=new Ji(Ce,ie,se,re),be=new xr(Ce,ie,se,re),se.programs=ge.programs,x.capabilities=re,x.extensions=ie,x.properties=oe,x.renderLists=ve,x.shadowMap=Se,x.state=ae,x.info=se}Pe();const Ue=new xs(x,Ce);function De(e){e.preventDefault(),console.log("THREE.WebGLRenderer: Context Lost."),M=!0}function Ne(){console.log("THREE.WebGLRenderer: Context Restored."),M=!1;const e=se.autoReset,t=Se.enabled,n=Se.autoUpdate,i=Se.needsUpdate,r=Se.type;Pe(),se.autoReset=e,Se.enabled=t,Se.autoUpdate=n,Se.needsUpdate=i,Se.type=r}function Ie(e){console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ",e.statusMessage)}function Oe(e){const t=e.target;t.removeEventListener("dispose",Oe),function(e){(function(e){const t=oe.get(e).programs;void 0!==t&&(t.forEach((function(e){ge.releaseProgram(e)})),e.isShaderMaterial&&ge.releaseShaderCache(e))})(e),oe.remove(e)}(t)}function Fe(e,t,n){!0===e.transparent&&2===e.side&&!1===e.forceSinglePass?(e.side=1,e.needsUpdate=!0,Ke(e,t,n),e.side=0,e.needsUpdate=!0,Ke(e,t,n),e.side=2):Ke(e,t,n)}this.xr=Ue,this.getContext=function(){return Ce},this.getContextAttributes=function(){return Ce.getContextAttributes()},this.forceContextLoss=function(){const e=ie.get("WEBGL_lose_context");e&&e.loseContext()},this.forceContextRestore=function(){const e=ie.get("WEBGL_lose_context");e&&e.restoreContext()},this.getPixelRatio=function(){return N},this.setPixelRatio=function(e){void 0!==e&&(N=e,this.setSize(U,D,!1))},this.getSize=function(e){return e.set(U,D)},this.setSize=function(e,t){let i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];Ue.isPresenting?console.warn("THREE.WebGLRenderer: Can\'t change size while VR device is presenting."):(U=e,D=t,n.width=Math.floor(e*N),n.height=Math.floor(t*N),!0===i&&(n.style.width=e+"px",n.style.height=t+"px"),this.setViewport(0,0,e,t))},this.getDrawingBufferSize=function(e){return e.set(U*N,D*N).floor()},this.setDrawingBufferSize=function(e,t,i){U=e,D=t,N=i,n.width=Math.floor(e*i),n.height=Math.floor(t*i),this.setViewport(0,0,e,t)},this.getCurrentViewport=function(e){return e.copy(w)},this.getViewport=function(e){return e.copy(F)},this.setViewport=function(e,t,n,i){e.isVector4?F.set(e.x,e.y,e.z,e.w):F.set(e,t,n,i),ae.viewport(w.copy(F).multiplyScalar(N).floor())},this.getScissor=function(e){return e.copy(z)},this.setScissor=function(e,t,n,i){e.isVector4?z.set(e.x,e.y,e.z,e.w):z.set(e,t,n,i),ae.scissor(A.copy(z).multiplyScalar(N).floor())},this.getScissorTest=function(){return B},this.setScissorTest=function(e){ae.setScissorTest(B=e)},this.setOpaqueSort=function(e){I=e},this.setTransparentSort=function(e){O=e},this.getClearColor=function(e){return e.copy(ye.getClearColor())},this.setClearColor=function(){ye.setClearColor.apply(ye,arguments)},this.getClearAlpha=function(){return ye.getClearAlpha()},this.setClearAlpha=function(){ye.setClearAlpha.apply(ye,arguments)},this.clear=function(){let e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],t=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],n=0;if(!(arguments.length>0&&void 0!==arguments[0])||arguments[0]){let e=!1;if(null!==E){const t=E.texture.format;e=1033===t||1031===t||1029===t}if(e){const e=E.texture.type,t=e===j||e===Y||e===q||e===J||1017===e||1018===e,n=ye.getClearColor(),i=ye.getClearAlpha(),r=n.r,a=n.g,s=n.b;t?(p[0]=r,p[1]=a,p[2]=s,p[3]=i,Ce.clearBufferuiv(Ce.COLOR,0,p)):(f[0]=r,f[1]=a,f[2]=s,f[3]=i,Ce.clearBufferiv(Ce.COLOR,0,f))}else n|=Ce.COLOR_BUFFER_BIT}e&&(n|=Ce.DEPTH_BUFFER_BIT),t&&(n|=Ce.STENCIL_BUFFER_BIT,this.state.buffers.stencil.setMask(4294967295)),Ce.clear(n)},this.clearColor=function(){this.clear(!0,!1,!1)},this.clearDepth=function(){this.clear(!1,!0,!1)},this.clearStencil=function(){this.clear(!1,!1,!0)},this.dispose=function(){n.removeEventListener("webglcontextlost",De,!1),n.removeEventListener("webglcontextrestored",Ne,!1),n.removeEventListener("webglcontextcreationerror",Ie,!1),ve.dispose(),xe.dispose(),oe.dispose(),ce.dispose(),he.dispose(),me.dispose(),Ae.dispose(),Re.dispose(),ge.dispose(),Ue.dispose(),Ue.removeEventListener("sessionstart",Be),Ue.removeEventListener("sessionend",Ve),k&&(k.dispose(),k=null),Ge.stop()},this.renderBufferDirect=function(e,t,n,i,r,a){null===t&&(t=te);const s=r.isMesh&&r.matrixWorld.determinant()<0,o=function(e,t,n,i,r){!0!==t.isScene&&(t=te),le.resetTextureUnits();const a=t.fog,s=i.isMeshStandardMaterial?t.environment:null,o=null===E?x.outputColorSpace:!0===E.isXRRenderTarget?E.texture.colorSpace:de,l=(i.isMeshStandardMaterial?he:ce).get(i.envMap||s),c=!0===i.vertexColors&&!!n.attributes.color&&4===n.attributes.color.itemSize,h=!!n.attributes.tangent&&(!!i.normalMap||i.anisotropy>0),u=!!n.morphAttributes.position,d=!!n.morphAttributes.normal,p=!!n.morphAttributes.color;let f=R;i.toneMapped&&(null!==E&&!0!==E.isXRRenderTarget||(f=x.toneMapping));const m=n.morphAttributes.position||n.morphAttributes.normal||n.morphAttributes.color,_=void 0!==m?m.length:0,v=oe.get(i),M=g.state.lights;if(!0===V&&(!0===G||e!==b)){const t=e===b&&i.id===T;Me.setState(i,e,t)}let S=!1;i.version===v.__version?v.needsLights&&v.lightsStateVersion!==M.state.version||v.outputColorSpace!==o||r.isInstancedMesh&&!1===v.instancing?S=!0:r.isInstancedMesh||!0!==v.instancing?r.isSkinnedMesh&&!1===v.skinning?S=!0:r.isSkinnedMesh||!0!==v.skinning?r.isInstancedMesh&&!0===v.instancingColor&&null===r.instanceColor||r.isInstancedMesh&&!1===v.instancingColor&&null!==r.instanceColor||v.envMap!==l||!0===i.fog&&v.fog!==a?S=!0:void 0===v.numClippingPlanes||v.numClippingPlanes===Me.numPlanes&&v.numIntersection===Me.numIntersection?(v.vertexAlphas!==c||v.vertexTangents!==h||v.morphTargets!==u||v.morphNormals!==d||v.morphColors!==p||v.toneMapping!==f||!0===re.isWebGL2&&v.morphTargetsCount!==_)&&(S=!0):S=!0:S=!0:S=!0:(S=!0,v.__version=i.version);let y=v.currentProgram;!0===S&&(y=Ke(i,t,r));let w=!1,A=!1,C=!1;const L=y.getUniforms(),P=v.uniforms;if(ae.useProgram(y.program)&&(w=!0,A=!0,C=!0),i.id!==T&&(T=i.id,A=!0),w||b!==e){L.setValue(Ce,"projectionMatrix",e.projectionMatrix),L.setValue(Ce,"viewMatrix",e.matrixWorldInverse);const t=L.map.cameraPosition;void 0!==t&&t.setValue(Ce,ee.setFromMatrixPosition(e.matrixWorld)),re.logarithmicDepthBuffer&&L.setValue(Ce,"logDepthBufFC",2/(Math.log(e.far+1)/Math.LN2)),(i.isMeshPhongMaterial||i.isMeshToonMaterial||i.isMeshLambertMaterial||i.isMeshBasicMaterial||i.isMeshStandardMaterial||i.isShaderMaterial)&&L.setValue(Ce,"isOrthographic",!0===e.isOrthographicCamera),b!==e&&(b=e,A=!0,C=!0)}if(r.isSkinnedMesh){L.setOptional(Ce,r,"bindMatrix"),L.setOptional(Ce,r,"bindMatrixInverse");const e=r.skeleton;e&&(re.floatVertexTextures?(null===e.boneTexture&&e.computeBoneTexture(),L.setValue(Ce,"boneTexture",e.boneTexture,le),L.setValue(Ce,"boneTextureSize",e.boneTextureSize)):console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."))}const U=n.morphAttributes;var I,O;if((void 0!==U.position||void 0!==U.normal||void 0!==U.color&&!0===re.isWebGL2)&&Ee.update(r,n,y),(A||v.receiveShadow!==r.receiveShadow)&&(v.receiveShadow=r.receiveShadow,L.setValue(Ce,"receiveShadow",r.receiveShadow)),i.isMeshGouraudMaterial&&null!==i.envMap&&(P.envMap.value=l,P.flipEnvMap.value=l.isCubeTexture&&!1===l.isRenderTargetTexture?-1:1),A&&(L.setValue(Ce,"toneMappingExposure",x.toneMappingExposure),v.needsLights&&(O=C,(I=P).ambientLightColor.needsUpdate=O,I.lightProbe.needsUpdate=O,I.directionalLights.needsUpdate=O,I.directionalLightShadows.needsUpdate=O,I.pointLights.needsUpdate=O,I.pointLightShadows.needsUpdate=O,I.spotLights.needsUpdate=O,I.spotLightShadows.needsUpdate=O,I.rectAreaLights.needsUpdate=O,I.hemisphereLights.needsUpdate=O),a&&!0===i.fog&&_e.refreshFogUniforms(P,a),_e.refreshMaterialUniforms(P,i,N,D,k),Ra.upload(Ce,Ze(v),P,le)),i.isShaderMaterial&&!0===i.uniformsNeedUpdate&&(Ra.upload(Ce,Ze(v),P,le),i.uniformsNeedUpdate=!1),i.isSpriteMaterial&&L.setValue(Ce,"center",r.center),L.setValue(Ce,"modelViewMatrix",r.modelViewMatrix),L.setValue(Ce,"normalMatrix",r.normalMatrix),L.setValue(Ce,"modelMatrix",r.matrixWorld),i.isShaderMaterial||i.isRawShaderMaterial){const e=i.uniformsGroups;for(let t=0,n=e.length;t<n;t++)if(re.isWebGL2){const n=e[t];Re.update(n,y),Re.bind(n,y)}else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.")}return y}(e,t,n,i,r);ae.setMaterial(i,s);let l=n.index,c=1;if(!0===i.wireframe){if(l=fe.getWireframeAttribute(n),void 0===l)return;c=2}const h=n.drawRange,u=n.attributes.position;let d=h.start*c,p=(h.start+h.count)*c;null!==a&&(d=Math.max(d,a.start*c),p=Math.min(p,(a.start+a.count)*c)),null!==l?(d=Math.max(d,0),p=Math.min(p,l.count)):null!=u&&(d=Math.max(d,0),p=Math.min(p,u.count));const f=p-d;if(f<0||f===1/0)return;let m;Ae.setup(r,i,o,n,l);let _=Te;if(null!==l&&(m=pe.get(l),_=be,_.setIndex(m)),r.isMesh)!0===i.wireframe?(ae.setLineWidth(i.wireframeLinewidth*ne()),_.setMode(Ce.LINES)):_.setMode(Ce.TRIANGLES);else if(r.isLine){let e=i.linewidth;void 0===e&&(e=1),ae.setLineWidth(e*ne()),r.isLineSegments?_.setMode(Ce.LINES):r.isLineLoop?_.setMode(Ce.LINE_LOOP):_.setMode(Ce.LINE_STRIP)}else r.isPoints?_.setMode(Ce.POINTS):r.isSprite&&_.setMode(Ce.TRIANGLES);if(r.isInstancedMesh)_.renderInstances(d,f,r.count);else if(n.isInstancedBufferGeometry){const e=void 0!==n._maxInstanceCount?n._maxInstanceCount:1/0,t=Math.min(n.instanceCount,e);_.renderInstances(d,f,t)}else _.render(d,f)},this.compile=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;null===n&&(n=e),g=xe.get(n),g.init(),v.push(g),n.traverseVisible((function(e){e.isLight&&e.layers.test(t.layers)&&(g.pushLight(e),e.castShadow&&g.pushShadow(e))})),e!==n&&e.traverseVisible((function(e){e.isLight&&e.layers.test(t.layers)&&(g.pushLight(e),e.castShadow&&g.pushShadow(e))})),g.setupLights(x._useLegacyLights);const i=new Set;return e.traverse((function(e){const t=e.material;if(t)if(Array.isArray(t))for(let r=0;r<t.length;r++){const a=t[r];Fe(a,n,e),i.add(a)}else Fe(t,n,e),i.add(t)})),v.pop(),g=null,i},this.compileAsync=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;const i=this.compile(e,t,n);return new Promise((t=>{function n(){i.forEach((function(e){oe.get(e).currentProgram.isReady()&&i.delete(e)})),0!==i.size?setTimeout(n,10):t(e)}null!==ie.get("KHR_parallel_shader_compile")?n():setTimeout(n,10)}))};let ze=null;function Be(){Ge.stop()}function Ve(){Ge.start()}const Ge=new Gi;function We(e,t,n,i){if(!1===e.visible)return;if(e.layers.test(t.layers))if(e.isGroup)n=e.renderOrder;else if(e.isLOD)!0===e.autoUpdate&&e.update(t);else if(e.isLight)g.pushLight(e),e.castShadow&&g.pushShadow(e);else if(e.isSprite){if(!e.frustumCulled||H.intersectsSprite(e)){i&&ee.setFromMatrixPosition(e.matrixWorld).applyMatrix4(W);const t=me.update(e),r=e.material;r.visible&&m.push(e,t,r,n,ee.z,null)}}else if((e.isMesh||e.isLine||e.isPoints)&&(!e.frustumCulled||H.intersectsObject(e))){const t=me.update(e),r=e.material;if(i&&(void 0!==e.boundingSphere?(null===e.boundingSphere&&e.computeBoundingSphere(),ee.copy(e.boundingSphere.center)):(null===t.boundingSphere&&t.computeBoundingSphere(),ee.copy(t.boundingSphere.center)),ee.applyMatrix4(e.matrixWorld).applyMatrix4(W)),Array.isArray(r)){const i=t.groups;for(let a=0,s=i.length;a<s;a++){const s=i[a],o=r[s.materialIndex];o&&o.visible&&m.push(e,t,o,n,ee.z,s)}}else r.visible&&m.push(e,t,r,n,ee.z,null)}const r=e.children;for(let e=0,a=r.length;e<a;e++)We(r[e],t,n,i)}function Xe(e,t,n,i){const r=e.opaque,a=e.transmissive,s=e.transparent;g.setupLightsView(n),!0===V&&Me.setGlobalState(x.clippingPlanes,n),a.length>0&&function(e,t,n,i){if(null!==(!0===n.isScene?n.overrideMaterial:null))return;const r=re.isWebGL2;null===k&&(k=new pt(1,1,{generateMipmaps:!0,type:ie.has("EXT_color_buffer_half_float")?Z:j,minFilter:X,samples:r?4:0})),x.getDrawingBufferSize($),r?k.setSize($.x,$.y):k.setSize(He($.x),He($.y));const a=x.getRenderTarget();x.setRenderTarget(k),x.getClearColor(L),P=x.getClearAlpha(),P<1&&x.setClearColor(16777215,.5),x.clear();const s=x.toneMapping;x.toneMapping=R,je(e,n,i),le.updateMultisampleRenderTarget(k),le.updateRenderTargetMipmap(k);let o=!1;for(let e=0,r=t.length;e<r;e++){const r=t[e],a=r.object,s=r.geometry,l=r.material,c=r.group;if(2===l.side&&a.layers.test(i.layers)){const e=l.side;l.side=1,l.needsUpdate=!0,qe(a,n,i,s,l,c),l.side=e,l.needsUpdate=!0,o=!0}}!0===o&&(le.updateMultisampleRenderTarget(k),le.updateRenderTargetMipmap(k)),x.setRenderTarget(a),x.setClearColor(L,P),x.toneMapping=s}(r,a,t,n),i&&ae.viewport(w.copy(i)),r.length>0&&je(r,t,n),a.length>0&&je(a,t,n),s.length>0&&je(s,t,n),ae.buffers.depth.setTest(!0),ae.buffers.depth.setMask(!0),ae.buffers.color.setMask(!0),ae.setPolygonOffset(!1)}function je(e,t,n){const i=!0===t.isScene?t.overrideMaterial:null;for(let r=0,a=e.length;r<a;r++){const a=e[r],s=a.object,o=a.geometry,l=null===i?a.material:i,c=a.group;s.layers.test(n.layers)&&qe(s,t,n,o,l,c)}}function qe(e,t,n,i,r,a){e.onBeforeRender(x,t,n,i,r,a),e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse,e.matrixWorld),e.normalMatrix.getNormalMatrix(e.modelViewMatrix),r.onBeforeRender(x,t,n,i,e,a),!0===r.transparent&&2===r.side&&!1===r.forceSinglePass?(r.side=1,r.needsUpdate=!0,x.renderBufferDirect(n,t,i,r,e,a),r.side=0,r.needsUpdate=!0,x.renderBufferDirect(n,t,i,r,e,a),r.side=2):x.renderBufferDirect(n,t,i,r,e,a),e.onAfterRender(x,t,n,i,r,a)}function Ke(e,t,n){!0!==t.isScene&&(t=te);const i=oe.get(e),r=g.state.lights,a=g.state.shadowsArray,s=r.state.version,o=ge.getParameters(e,r.state,a,t,n),l=ge.getProgramCacheKey(o);let c=i.programs;i.environment=e.isMeshStandardMaterial?t.environment:null,i.fog=t.fog,i.envMap=(e.isMeshStandardMaterial?he:ce).get(e.envMap||i.environment),void 0===c&&(e.addEventListener("dispose",Oe),c=new Map,i.programs=c);let h=c.get(l);if(void 0!==h){if(i.currentProgram===h&&i.lightsStateVersion===s)return Je(e,o),h}else o.uniforms=ge.getUniforms(e),e.onBuild(n,o,x),e.onBeforeCompile(o,x),h=ge.acquireProgram(o,l),c.set(l,h),i.uniforms=o.uniforms;const u=i.uniforms;return(e.isShaderMaterial||e.isRawShaderMaterial)&&!0!==e.clipping||(u.clippingPlanes=Me.uniform),Je(e,o),i.needsLights=function(e){return e.isMeshLambertMaterial||e.isMeshToonMaterial||e.isMeshPhongMaterial||e.isMeshStandardMaterial||e.isShadowMaterial||e.isShaderMaterial&&!0===e.lights}(e),i.lightsStateVersion=s,i.needsLights&&(u.ambientLightColor.value=r.state.ambient,u.lightProbe.value=r.state.probe,u.directionalLights.value=r.state.directional,u.directionalLightShadows.value=r.state.directionalShadow,u.spotLights.value=r.state.spot,u.spotLightShadows.value=r.state.spotShadow,u.rectAreaLights.value=r.state.rectArea,u.ltc_1.value=r.state.rectAreaLTC1,u.ltc_2.value=r.state.rectAreaLTC2,u.pointLights.value=r.state.point,u.pointLightShadows.value=r.state.pointShadow,u.hemisphereLights.value=r.state.hemi,u.directionalShadowMap.value=r.state.directionalShadowMap,u.directionalShadowMatrix.value=r.state.directionalShadowMatrix,u.spotShadowMap.value=r.state.spotShadowMap,u.spotLightMatrix.value=r.state.spotLightMatrix,u.spotLightMap.value=r.state.spotLightMap,u.pointShadowMap.value=r.state.pointShadowMap,u.pointShadowMatrix.value=r.state.pointShadowMatrix),i.currentProgram=h,i.uniformsList=null,h}function Ze(e){if(null===e.uniformsList){const t=e.currentProgram.getUniforms();e.uniformsList=Ra.seqWithValue(t.seq,e.uniforms)}return e.uniformsList}function Je(e,t){const n=oe.get(e);n.outputColorSpace=t.outputColorSpace,n.instancing=t.instancing,n.instancingColor=t.instancingColor,n.skinning=t.skinning,n.morphTargets=t.morphTargets,n.morphNormals=t.morphNormals,n.morphColors=t.morphColors,n.morphTargetsCount=t.morphTargetsCount,n.numClippingPlanes=t.numClippingPlanes,n.numIntersection=t.numClipIntersection,n.vertexAlphas=t.vertexAlphas,n.vertexTangents=t.vertexTangents,n.toneMapping=t.toneMapping}Ge.setAnimationLoop((function(e){ze&&ze(e)})),"undefined"!=typeof self&&Ge.setContext(self),this.setAnimationLoop=function(e){ze=e,Ue.setAnimationLoop(e),null===e?Ge.stop():Ge.start()},Ue.addEventListener("sessionstart",Be),Ue.addEventListener("sessionend",Ve),this.render=function(e,t){if(void 0!==t&&!0!==t.isCamera)return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");if(!0===M)return;!0===e.matrixWorldAutoUpdate&&e.updateMatrixWorld(),null===t.parent&&!0===t.matrixWorldAutoUpdate&&t.updateMatrixWorld(),!0===Ue.enabled&&!0===Ue.isPresenting&&(!0===Ue.cameraAutoUpdate&&Ue.updateCamera(t),t=Ue.getCamera()),!0===e.isScene&&e.onBeforeRender(x,e,t,E),g=xe.get(e,v.length),g.init(),v.push(g),W.multiplyMatrices(t.projectionMatrix,t.matrixWorldInverse),H.setFromProjectionMatrix(W),G=this.localClippingEnabled,V=Me.init(this.clippingPlanes,G),m=ve.get(e,_.length),m.init(),_.push(m),We(e,t,0,x.sortObjects),m.finish(),!0===x.sortObjects&&m.sort(I,O),this.info.render.frame++,!0===V&&Me.beginShadows();const n=g.state.shadowsArray;if(Se.render(n,e,t),!0===V&&Me.endShadows(),!0===this.info.autoReset&&this.info.reset(),ye.render(m,e),g.setupLights(x._useLegacyLights),t.isArrayCamera){const n=t.cameras;for(let t=0,i=n.length;t<i;t++){const i=n[t];Xe(m,e,i,i.viewport)}}else Xe(m,e,t);null!==E&&(le.updateMultisampleRenderTarget(E),le.updateRenderTargetMipmap(E)),!0===e.isScene&&e.onAfterRender(x,e,t),Ae.resetDefaultState(),T=-1,b=null,v.pop(),g=v.length>0?v[v.length-1]:null,_.pop(),m=_.length>0?_[_.length-1]:null},this.getActiveCubeFace=function(){return S},this.getActiveMipmapLevel=function(){return y},this.getRenderTarget=function(){return E},this.setRenderTargetTextures=function(e,t,n){oe.get(e.texture).__webglTexture=t,oe.get(e.depthTexture).__webglTexture=n;const i=oe.get(e);i.__hasExternalTextures=!0,i.__hasExternalTextures&&(i.__autoAllocateDepthBuffer=void 0===n,i.__autoAllocateDepthBuffer||!0===ie.has("WEBGL_multisampled_render_to_texture")&&(console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"),i.__useRenderToTexture=!1))},this.setRenderTargetFramebuffer=function(e,t){const n=oe.get(e);n.__webglFramebuffer=t,n.__useDefaultFramebuffer=void 0===t},this.setRenderTarget=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;E=e,S=t,y=n;let i=!0,r=null,a=!1,s=!1;if(e){const o=oe.get(e);void 0!==o.__useDefaultFramebuffer?(ae.bindFramebuffer(Ce.FRAMEBUFFER,null),i=!1):void 0===o.__webglFramebuffer?le.setupRenderTarget(e):o.__hasExternalTextures&&le.rebindTextures(e,oe.get(e.texture).__webglTexture,oe.get(e.depthTexture).__webglTexture);const l=e.texture;(l.isData3DTexture||l.isDataArrayTexture||l.isCompressedArrayTexture)&&(s=!0);const c=oe.get(e).__webglFramebuffer;e.isWebGLCubeRenderTarget?(r=Array.isArray(c[t])?c[t][n]:c[t],a=!0):r=re.isWebGL2&&e.samples>0&&!1===le.useMultisampledRTT(e)?oe.get(e).__webglMultisampledFramebuffer:Array.isArray(c)?c[n]:c,w.copy(e.viewport),A.copy(e.scissor),C=e.scissorTest}else w.copy(F).multiplyScalar(N).floor(),A.copy(z).multiplyScalar(N).floor(),C=B;if(ae.bindFramebuffer(Ce.FRAMEBUFFER,r)&&re.drawBuffers&&i&&ae.drawBuffers(e,r),ae.viewport(w),ae.scissor(A),ae.setScissorTest(C),a){const i=oe.get(e.texture);Ce.framebufferTexture2D(Ce.FRAMEBUFFER,Ce.COLOR_ATTACHMENT0,Ce.TEXTURE_CUBE_MAP_POSITIVE_X+t,i.__webglTexture,n)}else if(s){const i=oe.get(e.texture),r=t||0;Ce.framebufferTextureLayer(Ce.FRAMEBUFFER,Ce.COLOR_ATTACHMENT0,i.__webglTexture,n||0,r)}T=-1},this.readRenderTargetPixels=function(e,t,n,i,r,a,s){if(!e||!e.isWebGLRenderTarget)return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");let o=oe.get(e).__webglFramebuffer;if(e.isWebGLCubeRenderTarget&&void 0!==s&&(o=o[s]),o){ae.bindFramebuffer(Ce.FRAMEBUFFER,o);try{const s=e.texture,o=s.format,l=s.type;if(o!==Q&&we.convert(o)!==Ce.getParameter(Ce.IMPLEMENTATION_COLOR_READ_FORMAT))return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");const c=l===Z&&(ie.has("EXT_color_buffer_half_float")||re.isWebGL2&&ie.has("EXT_color_buffer_float"));if(!(l===j||we.convert(l)===Ce.getParameter(Ce.IMPLEMENTATION_COLOR_READ_TYPE)||l===K&&(re.isWebGL2||ie.has("OES_texture_float")||ie.has("WEBGL_color_buffer_float"))||c))return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");t>=0&&t<=e.width-i&&n>=0&&n<=e.height-r&&Ce.readPixels(t,n,i,r,we.convert(o),we.convert(l),a)}finally{const e=null!==E?oe.get(E).__webglFramebuffer:null;ae.bindFramebuffer(Ce.FRAMEBUFFER,e)}}},this.copyFramebufferToTexture=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;const i=Math.pow(2,-n),r=Math.floor(t.image.width*i),a=Math.floor(t.image.height*i);le.setTexture2D(t,0),Ce.copyTexSubImage2D(Ce.TEXTURE_2D,n,0,0,e.x,e.y,r,a),ae.unbindTexture()},this.copyTextureToTexture=function(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;const r=t.image.width,a=t.image.height,s=we.convert(n.format),o=we.convert(n.type);le.setTexture2D(n,0),Ce.pixelStorei(Ce.UNPACK_FLIP_Y_WEBGL,n.flipY),Ce.pixelStorei(Ce.UNPACK_PREMULTIPLY_ALPHA_WEBGL,n.premultiplyAlpha),Ce.pixelStorei(Ce.UNPACK_ALIGNMENT,n.unpackAlignment),t.isDataTexture?Ce.texSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,r,a,s,o,t.image.data):t.isCompressedTexture?Ce.compressedTexSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,t.mipmaps[0].width,t.mipmaps[0].height,s,t.mipmaps[0].data):Ce.texSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,s,o,t.image),0===i&&n.generateMipmaps&&Ce.generateMipmap(Ce.TEXTURE_2D),ae.unbindTexture()},this.copyTextureToTexture3D=function(e,t,n,i){let r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0;if(x.isWebGL1Renderer)return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");const a=e.max.x-e.min.x+1,s=e.max.y-e.min.y+1,o=e.max.z-e.min.z+1,l=we.convert(i.format),c=we.convert(i.type);let h;if(i.isData3DTexture)le.setTexture3D(i,0),h=Ce.TEXTURE_3D;else{if(!i.isDataArrayTexture)return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");le.setTexture2DArray(i,0),h=Ce.TEXTURE_2D_ARRAY}Ce.pixelStorei(Ce.UNPACK_FLIP_Y_WEBGL,i.flipY),Ce.pixelStorei(Ce.UNPACK_PREMULTIPLY_ALPHA_WEBGL,i.premultiplyAlpha),Ce.pixelStorei(Ce.UNPACK_ALIGNMENT,i.unpackAlignment);const u=Ce.getParameter(Ce.UNPACK_ROW_LENGTH),d=Ce.getParameter(Ce.UNPACK_IMAGE_HEIGHT),p=Ce.getParameter(Ce.UNPACK_SKIP_PIXELS),f=Ce.getParameter(Ce.UNPACK_SKIP_ROWS),m=Ce.getParameter(Ce.UNPACK_SKIP_IMAGES),g=n.isCompressedTexture?n.mipmaps[0]:n.image;Ce.pixelStorei(Ce.UNPACK_ROW_LENGTH,g.width),Ce.pixelStorei(Ce.UNPACK_IMAGE_HEIGHT,g.height),Ce.pixelStorei(Ce.UNPACK_SKIP_PIXELS,e.min.x),Ce.pixelStorei(Ce.UNPACK_SKIP_ROWS,e.min.y),Ce.pixelStorei(Ce.UNPACK_SKIP_IMAGES,e.min.z),n.isDataTexture||n.isData3DTexture?Ce.texSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,c,g.data):n.isCompressedArrayTexture?(console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."),Ce.compressedTexSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,g.data)):Ce.texSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,c,g),Ce.pixelStorei(Ce.UNPACK_ROW_LENGTH,u),Ce.pixelStorei(Ce.UNPACK_IMAGE_HEIGHT,d),Ce.pixelStorei(Ce.UNPACK_SKIP_PIXELS,p),Ce.pixelStorei(Ce.UNPACK_SKIP_ROWS,f),Ce.pixelStorei(Ce.UNPACK_SKIP_IMAGES,m),0===r&&i.generateMipmaps&&Ce.generateMipmap(h),ae.unbindTexture()},this.initTexture=function(e){e.isCubeTexture?le.setTextureCube(e,0):e.isData3DTexture?le.setTexture3D(e,0):e.isDataArrayTexture||e.isCompressedArrayTexture?le.setTexture2DArray(e,0):le.setTexture2D(e,0),ae.unbindTexture()},this.resetState=function(){S=0,y=0,E=null,ae.reset(),Ae.reset()},"undefined"!=typeof __THREE_DEVTOOLS__&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe",{detail:this}))}get coordinateSystem(){return Le}get outputColorSpace(){return this._outputColorSpace}set outputColorSpace(e){this._outputColorSpace=e;const t=this.getContext();t.drawingBufferColorSpace=e===pe?"display-p3":"srgb",t.unpackColorSpace=tt.workingColorSpace===fe?"display-p3":"srgb"}get physicallyCorrectLights(){return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."),!this.useLegacyLights}set physicallyCorrectLights(e){console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."),this.useLegacyLights=!e}get outputEncoding(){return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."),this.outputColorSpace===ue?ce:3e3}set outputEncoding(e){console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."),this.outputColorSpace=e===ce?ue:de}get useLegacyLights(){return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."),this._useLegacyLights}set useLegacyLights(e){console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."),this._useLegacyLights=e}}(class extends ys{}).prototype.isWebGL1Renderer=!0;class Es extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;super(null,arguments.length>5?arguments[5]:void 0,arguments.length>6?arguments[6]:void 0,arguments.length>7?arguments[7]:void 0,arguments.length>8&&void 0!==arguments[8]?arguments[8]:H,arguments.length>9&&void 0!==arguments[9]?arguments[9]:H,arguments.length>3?arguments[3]:void 0,arguments.length>4?arguments[4]:void 0,arguments.length>10?arguments[10]:void 0,arguments.length>11?arguments[11]:void 0),this.isDataTexture=!0,this.image={data:e,width:t,height:n},this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}function Ts(e,t,n){return!e||!n&&e.constructor===t?e:"number"==typeof t.BYTES_PER_ELEMENT?new t(e):Array.prototype.slice.call(e)}class bs{constructor(e,t,n,i){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=void 0!==i?i:new t.constructor(n),this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){const t=this.parameterPositions;let n=this._cachedIndex,i=t[n],r=t[n-1];e:{t:{let a;n:{i:if(!(e<i)){for(let a=n+2;;){if(void 0===i){if(e<r)break i;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(r=i,i=t[++n],e<i)break t}a=t.length;break n}if(e>=r)break e;{const s=t[1];e<s&&(n=2,r=s);for(let a=n-2;;){if(void 0===r)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(i=r,r=t[--n-1],e>=r)break t}a=n,n=0}}for(;n<a;){const i=n+a>>>1;e<t[i]?a=i:n=i+1}if(i=t[n],r=t[n-1],void 0===r)return this._cachedIndex=0,this.copySampleValue_(0);if(void 0===i)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,r,i)}return this.interpolate_(n,r,e,i)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){const t=this.resultBuffer,n=this.sampleValues,i=this.valueSize,r=e*i;for(let e=0;e!==i;++e)t[e]=n[r+e];return t}interpolate_(){throw new Error("call to abstract method")}intervalChanged_(){}}class ws extends bs{constructor(e,t,n,i){super(e,t,n,i),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:2400,endingEnd:2400}}intervalChanged_(e,t,n){const i=this.parameterPositions;let r=e-2,a=e+1,s=i[r],o=i[a];if(void 0===s)switch(this.getSettings_().endingStart){case 2401:r=e,s=2*t-n;break;case 2402:r=i.length-2,s=t+i[r]-i[r+1];break;default:r=e,s=n}if(void 0===o)switch(this.getSettings_().endingEnd){case 2401:a=e,o=2*n-t;break;case 2402:a=1,o=n+i[1]-i[0];break;default:a=e-1,o=t}const l=.5*(n-t),c=this.valueSize;this._weightPrev=l/(t-s),this._weightNext=l/(o-n),this._offsetPrev=r*c,this._offsetNext=a*c}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=e*s,l=o-s,c=this._offsetPrev,h=this._offsetNext,u=this._weightPrev,d=this._weightNext,p=(n-t)/(i-t),f=p*p,m=f*p,g=-u*m+2*u*f-u*p,_=(1+u)*m+(-1.5-2*u)*f+(-.5+u)*p+1,v=(-1-d)*m+(1.5+d)*f+.5*p,x=d*m-d*f;for(let e=0;e!==s;++e)r[e]=g*a[c+e]+_*a[l+e]+v*a[o+e]+x*a[h+e];return r}}class As extends bs{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=e*s,l=o-s,c=(n-t)/(i-t),h=1-c;for(let e=0;e!==s;++e)r[e]=a[l+e]*h+a[o+e]*c;return r}}class Rs extends bs{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e){return this.copySampleValue_(e-1)}}class Cs{constructor(e,t,n,i){if(void 0===e)throw new Error("THREE.KeyframeTrack: track name is undefined");if(void 0===t||0===t.length)throw new Error("THREE.KeyframeTrack: no keyframes in track named "+e);this.name=e,this.times=Ts(t,this.TimeBufferType),this.values=Ts(n,this.ValueBufferType),this.setInterpolation(i||this.DefaultInterpolation)}static toJSON(e){const t=e.constructor;let n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:Ts(e.times,Array),values:Ts(e.values,Array)};const t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t)}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new Rs(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new As(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new ws(this.times,this.values,this.getValueSize(),e)}setInterpolation(e){let t;switch(e){case se:t=this.InterpolantFactoryMethodDiscrete;break;case oe:t=this.InterpolantFactoryMethodLinear;break;case le:t=this.InterpolantFactoryMethodSmooth}if(void 0===t){const t="unsupported interpolation for "+this.ValueTypeName+" keyframe track named "+this.name;if(void 0===this.createInterpolant){if(e===this.DefaultInterpolation)throw new Error(t);this.setInterpolation(this.DefaultInterpolation)}return console.warn("THREE.KeyframeTrack:",t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return se;case this.InterpolantFactoryMethodLinear:return oe;case this.InterpolantFactoryMethodSmooth:return le}}getValueSize(){return this.values.length/this.times.length}shift(e){if(0!==e){const t=this.times;for(let n=0,i=t.length;n!==i;++n)t[n]+=e}return this}scale(e){if(1!==e){const t=this.times;for(let n=0,i=t.length;n!==i;++n)t[n]*=e}return this}trim(e,t){const n=this.times,i=n.length;let r=0,a=i-1;for(;r!==i&&n[r]<e;)++r;for(;-1!==a&&n[a]>t;)--a;if(++a,0!==r||a!==i){r>=a&&(a=Math.max(a,1),r=a-1);const e=this.getValueSize();this.times=n.slice(r,a),this.values=this.values.slice(r*e,a*e)}return this}validate(){let e=!0;const t=this.getValueSize();t-Math.floor(t)!=0&&(console.error("THREE.KeyframeTrack: Invalid value size in track.",this),e=!1);const n=this.times,i=this.values,r=n.length;0===r&&(console.error("THREE.KeyframeTrack: Track is empty.",this),e=!1);let a=null;for(let t=0;t!==r;t++){const i=n[t];if("number"==typeof i&&isNaN(i)){console.error("THREE.KeyframeTrack: Time is not a valid number.",this,t,i),e=!1;break}if(null!==a&&a>i){console.error("THREE.KeyframeTrack: Out of order keys.",this,t,i,a),e=!1;break}a=i}if(void 0!==i&&(s=i,ArrayBuffer.isView(s)&&!(s instanceof DataView)))for(let t=0,n=i.length;t!==n;++t){const n=i[t];if(isNaN(n)){console.error("THREE.KeyframeTrack: Value is not a valid number.",this,t,n),e=!1;break}}var s;return e}optimize(){const e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),i=this.getInterpolation()===le,r=e.length-1;let a=1;for(let s=1;s<r;++s){let r=!1;const o=e[s];if(o!==e[s+1]&&(1!==s||o!==e[0]))if(i)r=!0;else{const e=s*n,i=e-n,a=e+n;for(let s=0;s!==n;++s){const n=t[e+s];if(n!==t[i+s]||n!==t[a+s]){r=!0;break}}}if(r){if(s!==a){e[a]=e[s];const i=s*n,r=a*n;for(let e=0;e!==n;++e)t[r+e]=t[i+e]}++a}}if(r>0){e[a]=e[r];for(let e=r*n,i=a*n,s=0;s!==n;++s)t[i+s]=t[e+s];++a}return a!==e.length?(this.times=e.slice(0,a),this.values=t.slice(0,a*n)):(this.times=e,this.values=t),this}clone(){const e=this.times.slice(),t=this.values.slice(),n=new(0,this.constructor)(this.name,e,t);return n.createInterpolant=this.createInterpolant,n}}Cs.prototype.TimeBufferType=Float32Array,Cs.prototype.ValueBufferType=Float32Array,Cs.prototype.DefaultInterpolation=oe;class Ls extends Cs{}Ls.prototype.ValueTypeName="bool",Ls.prototype.ValueBufferType=Array,Ls.prototype.DefaultInterpolation=se,Ls.prototype.InterpolantFactoryMethodLinear=void 0,Ls.prototype.InterpolantFactoryMethodSmooth=void 0;(class extends Cs{}).prototype.ValueTypeName="color";(class extends Cs{}).prototype.ValueTypeName="number";class Ps extends bs{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=(n-t)/(i-t);let l=e*s;for(let e=l+s;l!==e;l+=4)gt.slerpFlat(r,0,a,l-s,a,l,o);return r}}class Us extends Cs{InterpolantFactoryMethodLinear(e){return new Ps(this.times,this.values,this.getValueSize(),e)}}Us.prototype.ValueTypeName="quaternion",Us.prototype.DefaultInterpolation=oe,Us.prototype.InterpolantFactoryMethodSmooth=void 0;class Ds extends Cs{}Ds.prototype.ValueTypeName="string",Ds.prototype.ValueBufferType=Array,Ds.prototype.DefaultInterpolation=se,Ds.prototype.InterpolantFactoryMethodLinear=void 0,Ds.prototype.InterpolantFactoryMethodSmooth=void 0;(class extends Cs{}).prototype.ValueTypeName="vector";const Ns={enabled:!1,files:{},add:function(e,t){!1!==this.enabled&&(this.files[e]=t)},get:function(e){if(!1!==this.enabled)return this.files[e]},remove:function(e){delete this.files[e]},clear:function(){this.files={}}};class Is{constructor(e,t,n){const i=this;let r,a=!1,s=0,o=0;const l=[];this.onStart=void 0,this.onLoad=e,this.onProgress=t,this.onError=n,this.itemStart=function(e){o++,!1===a&&void 0!==i.onStart&&i.onStart(e,s,o),a=!0},this.itemEnd=function(e){s++,void 0!==i.onProgress&&i.onProgress(e,s,o),s===o&&(a=!1,void 0!==i.onLoad&&i.onLoad())},this.itemError=function(e){void 0!==i.onError&&i.onError(e)},this.resolveURL=function(e){return r?r(e):e},this.setURLModifier=function(e){return r=e,this},this.addHandler=function(e,t){return l.push(e,t),this},this.removeHandler=function(e){const t=l.indexOf(e);return-1!==t&&l.splice(t,2),this},this.getHandler=function(e){for(let t=0,n=l.length;t<n;t+=2){const n=l[t],i=l[t+1];if(n.global&&(n.lastIndex=0),n.test(e))return i}return null}}}const Os=new Is;class Fs{constructor(e){this.manager=void 0!==e?e:Os,this.crossOrigin="anonymous",this.withCredentials=!1,this.path="",this.resourcePath="",this.requestHeader={}}load(){}loadAsync(e,t){const n=this;return new Promise((function(i,r){n.load(e,i,t,r)}))}parse(){}setCrossOrigin(e){return this.crossOrigin=e,this}setWithCredentials(e){return this.withCredentials=e,this}setPath(e){return this.path=e,this}setResourcePath(e){return this.resourcePath=e,this}setRequestHeader(e){return this.requestHeader=e,this}}Fs.DEFAULT_MATERIAL_NAME="__DEFAULT";const zs={};class Bs extends Error{constructor(e,t){super(e),this.response=t}}class Hs extends Fs{constructor(e){super(e)}load(e,t,n,i){void 0===e&&(e=""),void 0!==this.path&&(e=this.path+e),e=this.manager.resolveURL(e);const r=Ns.get(e);if(void 0!==r)return this.manager.itemStart(e),setTimeout((()=>{t&&t(r),this.manager.itemEnd(e)}),0),r;if(void 0!==zs[e])return void zs[e].push({onLoad:t,onProgress:n,onError:i});zs[e]=[],zs[e].push({onLoad:t,onProgress:n,onError:i});const a=new Request(e,{headers:new Headers(this.requestHeader),credentials:this.withCredentials?"include":"same-origin"}),s=this.mimeType,o=this.responseType;fetch(a).then((t=>{if(200===t.status||0===t.status){if(0===t.status&&console.warn("THREE.FileLoader: HTTP Status 0 received."),"undefined"==typeof ReadableStream||void 0===t.body||void 0===t.body.getReader)return t;const n=zs[e],i=t.body.getReader(),r=t.headers.get("Content-Length")||t.headers.get("X-File-Size"),a=r?parseInt(r):0,s=0!==a;let o=0;const l=new ReadableStream({start(e){!function t(){i.read().then((i=>{let{done:r,value:l}=i;if(r)e.close();else{o+=l.byteLength;const i=new ProgressEvent("progress",{lengthComputable:s,loaded:o,total:a});for(let e=0,t=n.length;e<t;e++){const t=n[e];t.onProgress&&t.onProgress(i)}e.enqueue(l),t()}}))}()}});return new Response(l)}throw new Bs(`fetch for "${t.url}" responded with ${t.status}: ${t.statusText}`,t)})).then((e=>{switch(o){case"arraybuffer":return e.arrayBuffer();case"blob":return e.blob();case"document":return e.text().then((e=>(new DOMParser).parseFromString(e,s)));case"json":return e.json();default:if(void 0===s)return e.text();{const t=/charset="?([^;"\\s]*)"?/i.exec(s),n=t&&t[1]?t[1].toLowerCase():void 0,i=new TextDecoder(n);return e.arrayBuffer().then((e=>i.decode(e)))}}})).then((t=>{Ns.add(e,t);const n=zs[e];delete zs[e];for(let e=0,i=n.length;e<i;e++){const i=n[e];i.onLoad&&i.onLoad(t)}})).catch((t=>{const n=zs[e];if(void 0===n)throw this.manager.itemError(e),t;delete zs[e];for(let e=0,i=n.length;e<i;e++){const i=n[e];i.onError&&i.onError(t)}this.manager.itemError(e)})).finally((()=>{this.manager.itemEnd(e)})),this.manager.itemStart(e)}setResponseType(e){return this.responseType=e,this}setMimeType(e){return this.mimeType=e,this}}class Vs extends Fs{constructor(e){super(e)}load(e,t,n,i){const r=this,a=new Es,s=new Hs(this.manager);return s.setResponseType("arraybuffer"),s.setRequestHeader(this.requestHeader),s.setPath(this.path),s.setWithCredentials(r.withCredentials),s.load(e,(function(e){let n;try{n=r.parse(e)}catch(e){if(void 0===i)return void console.error(e);i(e)}void 0!==n.image?a.image=n.image:void 0!==n.data&&(a.image.width=n.width,a.image.height=n.height,a.image.data=n.data),a.wrapS=void 0!==n.wrapS?n.wrapS:z,a.wrapT=void 0!==n.wrapT?n.wrapT:z,a.magFilter=void 0!==n.magFilter?n.magFilter:k,a.minFilter=void 0!==n.minFilter?n.minFilter:k,a.anisotropy=void 0!==n.anisotropy?n.anisotropy:1,void 0!==n.colorSpace?a.colorSpace=n.colorSpace:void 0!==n.encoding&&(a.encoding=n.encoding),void 0!==n.flipY&&(a.flipY=n.flipY),void 0!==n.format&&(a.format=n.format),void 0!==n.type&&(a.type=n.type),void 0!==n.mipmaps&&(a.mipmaps=n.mipmaps,a.minFilter=X),1===n.mipmapCount&&(a.minFilter=k),void 0!==n.generateMipmaps&&(a.generateMipmaps=n.generateMipmaps),a.needsUpdate=!0,t&&t(a,n)}),n,i),a}}const Gs="\\\\[\\\\]\\\\.:\\\\/",ks=new RegExp("["+Gs+"]","g"),Ws="[^"+Gs+"]",Xs="[^"+Gs.replace("\\\\.","")+"]",js=new RegExp("^"+/((?:WC+[\\/:])*)/.source.replace("WC",Ws)+/(WCOD+)?/.source.replace("WCOD",Xs)+/(?:\\.(WC+)(?:\\[(.+)\\])?)?/.source.replace("WC",Ws)+/\\.(WC+)(?:\\[(.+)\\])?/.source.replace("WC",Ws)+"$"),qs=["material","materials","bones","map"];class Ys{constructor(e,t,n){this.path=t,this.parsedPath=n||Ys.parseTrackName(t),this.node=Ys.findNode(e,this.parsedPath.nodeName),this.rootNode=e,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(e,t,n){return e&&e.isAnimationObjectGroup?new Ys.Composite(e,t,n):new Ys(e,t,n)}static sanitizeNodeName(e){return e.replace(/\\s/g,"_").replace(ks,"")}static parseTrackName(e){const t=js.exec(e);if(null===t)throw new Error("PropertyBinding: Cannot parse trackName: "+e);const n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},i=n.nodeName&&n.nodeName.lastIndexOf(".");if(void 0!==i&&-1!==i){const e=n.nodeName.substring(i+1);-1!==qs.indexOf(e)&&(n.nodeName=n.nodeName.substring(0,i),n.objectName=e)}if(null===n.propertyName||0===n.propertyName.length)throw new Error("PropertyBinding: can not parse propertyName from trackName: "+e);return n}static findNode(e,t){if(void 0===t||""===t||"."===t||-1===t||t===e.name||t===e.uuid)return e;if(e.skeleton){const n=e.skeleton.getBoneByName(t);if(void 0!==n)return n}if(e.children){const n=function(e){for(let i=0;i<e.length;i++){const r=e[i];if(r.name===t||r.uuid===t)return r;const a=n(r.children);if(a)return a}return null},i=n(e.children);if(i)return i}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)e[t++]=n[i]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++]}_setValue_array_setNeedsUpdate(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let e=this.node;const t=this.parsedPath,n=t.objectName,i=t.propertyName;let r=t.propertyIndex;if(e||(e=Ys.findNode(this.rootNode,t.nodeName),this.node=e),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!e)return void console.warn("THREE.PropertyBinding: No target node found for track: "+this.path+".");if(n){let i=t.objectIndex;switch(n){case"materials":if(!e.material)return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.",this);if(!e.material.materials)return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.",this);e=e.material.materials;break;case"bones":if(!e.skeleton)return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.",this);e=e.skeleton.bones;for(let t=0;t<e.length;t++)if(e[t].name===i){i=t;break}break;case"map":if("map"in e){e=e.map;break}if(!e.material)return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.",this);if(!e.material.map)return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.",this);e=e.material.map;break;default:if(void 0===e[n])return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.",this);e=e[n]}if(void 0!==i){if(void 0===e[i])return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.",this,e);e=e[i]}}const a=e[i];if(void 0===a){const n=t.nodeName;return void console.error("THREE.PropertyBinding: Trying to update property for track: "+n+"."+i+" but it wasn\'t found.",e)}let s=this.Versioning.None;this.targetObject=e,void 0!==e.needsUpdate?s=this.Versioning.NeedsUpdate:void 0!==e.matrixWorldNeedsUpdate&&(s=this.Versioning.MatrixWorldNeedsUpdate);let o=this.BindingType.Direct;if(void 0!==r){if("morphTargetInfluences"===i){if(!e.geometry)return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.",this);if(!e.geometry.morphAttributes)return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.",this);void 0!==e.morphTargetDictionary[r]&&(r=e.morphTargetDictionary[r])}o=this.BindingType.ArrayElement,this.resolvedProperty=a,this.propertyIndex=r}else void 0!==a.fromArray&&void 0!==a.toArray?(o=this.BindingType.HasFromToArray,this.resolvedProperty=a):Array.isArray(a)?(o=this.BindingType.EntireArray,this.resolvedProperty=a):this.propertyName=i;this.getValue=this.GetterByBindingType[o],this.setValue=this.SetterByBindingTypeAndVersioning[o][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}}Ys.Composite=class{constructor(e,t,n){const i=n||Ys.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,i)}getValue(e,t){this.bind();const n=this._targetGroup.nCachedObjects_,i=this._bindings[n];void 0!==i&&i.getValue(e,t)}setValue(e,t){const n=this._bindings;for(let i=this._targetGroup.nCachedObjects_,r=n.length;i!==r;++i)n[i].setValue(e,t)}bind(){const e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){const e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},Ys.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},Ys.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},Ys.prototype.GetterByBindingType=[Ys.prototype._getValue_direct,Ys.prototype._getValue_array,Ys.prototype._getValue_arrayElement,Ys.prototype._getValue_toArray],Ys.prototype.SetterByBindingTypeAndVersioning=[[Ys.prototype._setValue_direct,Ys.prototype._setValue_direct_setNeedsUpdate,Ys.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[Ys.prototype._setValue_array,Ys.prototype._setValue_array_setNeedsUpdate,Ys.prototype._setValue_array_setMatrixWorldNeedsUpdate],[Ys.prototype._setValue_arrayElement,Ys.prototype._setValue_arrayElement_setNeedsUpdate,Ys.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[Ys.prototype._setValue_fromArray,Ys.prototype._setValue_fromArray_setNeedsUpdate,Ys.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],new Float32Array(1),"undefined"!=typeof __THREE_DEVTOOLS__&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register",{detail:{revision:e}})),"undefined"!=typeof window&&(window.__THREE__?console.warn("WARNING: Multiple instances of Three.js being imported."):window.__THREE__=e);var Ks=function(e){return URL.createObjectURL(new Blob([e],{type:"text/javascript"}))};try{URL.revokeObjectURL(Ks(""))}catch(e){Ks=function(e){return"data:application/javascript;charset=UTF-8,"+encodeURI(e)}}var Zs=Uint8Array,Js=Uint16Array,Qs=Uint32Array,$s=new Zs([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),eo=new Zs([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),to=new Zs([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),no=function(e,t){for(var n=new Js(31),i=0;i<31;++i)n[i]=t+=1<<e[i-1];var r=new Qs(n[30]);for(i=1;i<30;++i)for(var a=n[i];a<n[i+1];++a)r[a]=a-n[i]<<5|i;return[n,r]},io=no($s,2),ro=io[0],ao=io[1];ro[28]=258,ao[258]=28;for(var so=no(eo,0),oo=so[0],lo=(so[1],new Js(32768)),co=0;co<32768;++co){var ho=(43690&co)>>>1|(21845&co)<<1;ho=(61680&(ho=(52428&ho)>>>2|(13107&ho)<<2))>>>4|(3855&ho)<<4,lo[co]=((65280&ho)>>>8|(255&ho)<<8)>>>1}var uo=function(e,t,n){for(var i=e.length,r=0,a=new Js(t);r<i;++r)++a[e[r]-1];var s,o=new Js(t);for(r=0;r<t;++r)o[r]=o[r-1]+a[r-1]<<1;if(n){s=new Js(1<<t);var l=15-t;for(r=0;r<i;++r)if(e[r])for(var c=r<<4|e[r],h=t-e[r],u=o[e[r]-1]++<<h,d=u|(1<<h)-1;u<=d;++u)s[lo[u]>>>l]=c}else for(s=new Js(i),r=0;r<i;++r)e[r]&&(s[r]=lo[o[e[r]-1]++]>>>15-e[r]);return s},po=new Zs(288);for(co=0;co<144;++co)po[co]=8;for(co=144;co<256;++co)po[co]=9;for(co=256;co<280;++co)po[co]=7;for(co=280;co<288;++co)po[co]=8;var fo=new Zs(32);for(co=0;co<32;++co)fo[co]=5;var mo=uo(po,9,1),go=uo(fo,5,1),_o=function(e){for(var t=e[0],n=1;n<e.length;++n)e[n]>t&&(t=e[n]);return t},vo=function(e,t,n){var i=t/8|0;return(e[i]|e[i+1]<<8)>>(7&t)&n},xo=function(e,t){var n=t/8|0;return(e[n]|e[n+1]<<8|e[n+2]<<16)>>(7&t)},Mo=function(e,t,n){var i=e.length;if(!i||n&&!n.l&&i<5)return t||new Zs(0);var r=!t||n,a=!n||n.i;n||(n={}),t||(t=new Zs(3*i));var s,o=function(e){var n=t.length;if(e>n){var i=new Zs(Math.max(2*n,e));i.set(t),t=i}},l=n.f||0,c=n.p||0,h=n.b||0,u=n.l,d=n.d,p=n.m,f=n.n,m=8*i;do{if(!u){n.f=l=vo(e,c,1);var g=vo(e,c+1,3);if(c+=3,!g){var _=e[(s=c,(R=(s/8|0)+(7&s&&1)+4)-4)]|e[R-3]<<8,v=R+_;if(v>i){if(a)throw"unexpected EOF";break}r&&o(h+_),t.set(e.subarray(R,v),h),n.b=h+=_,n.p=c=8*v;continue}if(1==g)u=mo,d=go,p=9,f=5;else{if(2!=g)throw"invalid block type";var x=vo(e,c,31)+257,M=vo(e,c+10,15)+4,S=x+vo(e,c+5,31)+1;c+=14;for(var y=new Zs(S),E=new Zs(19),T=0;T<M;++T)E[to[T]]=vo(e,c+3*T,7);c+=3*M;var b=_o(E),w=(1<<b)-1,A=uo(E,b,1);for(T=0;T<S;){var R,C=A[vo(e,c,w)];if(c+=15&C,(R=C>>>4)<16)y[T++]=R;else{var L=0,P=0;for(16==R?(P=3+vo(e,c,3),c+=2,L=y[T-1]):17==R?(P=3+vo(e,c,7),c+=3):18==R&&(P=11+vo(e,c,127),c+=7);P--;)y[T++]=L}}var U=y.subarray(0,x),D=y.subarray(x);p=_o(U),f=_o(D),u=uo(U,p,1),d=uo(D,f,1)}if(c>m){if(a)throw"unexpected EOF";break}}r&&o(h+131072);for(var N=(1<<p)-1,I=(1<<f)-1,O=c;;O=c){var F=(L=u[xo(e,c)&N])>>>4;if((c+=15&L)>m){if(a)throw"unexpected EOF";break}if(!L)throw"invalid length/literal";if(F<256)t[h++]=F;else{if(256==F){O=c,u=null;break}var z=F-254;if(F>264){var B=$s[T=F-257];z=vo(e,c,(1<<B)-1)+ro[T],c+=B}var H=d[xo(e,c)&I],V=H>>>4;if(!H)throw"invalid distance";if(c+=15&H,D=oo[V],V>3&&(B=eo[V],D+=xo(e,c)&(1<<B)-1,c+=B),c>m){if(a)throw"unexpected EOF";break}r&&o(h+131072);for(var G=h+z;h<G;h+=4)t[h]=t[h-D],t[h+1]=t[h+1-D],t[h+2]=t[h+2-D],t[h+3]=t[h+3-D];h=G}}n.l=u,n.p=O,n.b=h,u&&(l=1,n.m=p,n.d=d,n.n=f)}while(!l);return h==t.length?t:function(e,t,n){(null==t||t<0)&&(t=0),(null==n||n>e.length)&&(n=e.length);var i=new(e instanceof Js?Js:e instanceof Qs?Qs:Zs)(n-t);return i.set(e.subarray(t,n)),i}(t,0,h)},So=new Zs(0);function yo(e,t){return Mo((function(e){if(8!=(15&e[0])||e[0]>>>4>7||(e[0]<<8|e[1])%31)throw"invalid zlib data";if(32&e[1])throw"invalid zlib data: preset dictionaries not supported"}(e),e.subarray(2,-4)),t)}var Eo="undefined"!=typeof TextDecoder&&new TextDecoder;try{Eo.decode(So,{stream:!0})}catch(e){}class To extends Vs{constructor(e){super(e),this.type=Z}parse(e){const t=65536,n=14,i=65537,r=Math.pow(2.7182818,2.2),a={l:0,c:0,lc:0};function s(e,t,n,i,r){for(;n<e;)t=t<<8|F(i,r),n+=8;n-=e,a.l=t>>n&(1<<e)-1,a.c=t,a.lc=n}const o=new Array(59);function l(e){return 63&e}function c(e){return e>>6}const h={c:0,lc:0};function u(e,t,n,i){e=e<<8|F(n,i),t+=8,h.c=e,h.lc=t}const d={c:0,lc:0};function p(e,t,n,i,r,a,s,o,l){if(e==t){i<8&&(u(n,i,r,a),n=h.c,i=h.lc);let e=n>>(i-=8);if(e=new Uint8Array([e])[0],o.value+e>l)return!1;const t=s[o.value-1];for(;e-- >0;)s[o.value++]=t}else{if(!(o.value<l))return!1;s[o.value++]=e}d.c=n,d.lc=i}function f(e){return 65535&e}function m(e){const t=f(e);return t>32767?t-65536:t}const g={a:0,b:0};function _(e,t){const n=m(e),i=m(t),r=n+(1&i)+(i>>1),a=r,s=r-i;g.a=a,g.b=s}function v(e,t){const n=f(e),i=f(t),r=n-(i>>1)&65535,a=i+r-32768&65535;g.a=a,g.b=r}function x(e,t,n,i,r,a,s){const o=s<16384,l=n>r?r:n;let c,h,u=1;for(;u<=l;)u<<=1;for(u>>=1,c=u,u>>=1;u>=1;){h=0;const s=h+a*(r-c),l=a*u,d=a*c,p=i*u,f=i*c;let m,x,M,S;for(;h<=s;h+=d){let r=h;const a=h+i*(n-c);for(;r<=a;r+=f){const n=r+p,i=r+l,a=i+p;o?(_(e[r+t],e[i+t]),m=g.a,M=g.b,_(e[n+t],e[a+t]),x=g.a,S=g.b,_(m,x),e[r+t]=g.a,e[n+t]=g.b,_(M,S),e[i+t]=g.a,e[a+t]=g.b):(v(e[r+t],e[i+t]),m=g.a,M=g.b,v(e[n+t],e[a+t]),x=g.a,S=g.b,v(m,x),e[r+t]=g.a,e[n+t]=g.b,v(M,S),e[i+t]=g.a,e[a+t]=g.b)}if(n&u){const n=r+l;o?_(e[r+t],e[n+t]):v(e[r+t],e[n+t]),m=g.a,e[n+t]=g.b,e[r+t]=m}}if(r&u){let r=h;const a=h+i*(n-c);for(;r<=a;r+=f){const n=r+p;o?_(e[r+t],e[n+t]):v(e[r+t],e[n+t]),m=g.a,e[n+t]=g.b,e[r+t]=m}}c=u,u>>=1}return h}function M(e,t,r,f,m,g){const _=r.value,v=O(t,r),x=O(t,r);r.value+=4;const M=O(t,r);if(r.value+=4,v<0||v>=i||x<0||x>=i)throw new Error("Something wrong with HUF_ENCSIZE");const S=new Array(i),y=new Array(16384);if(function(e){for(let t=0;t<16384;t++)e[t]={},e[t].len=0,e[t].lit=0,e[t].p=null}(y),function(e,t,n,r,l,c){const h=t;let u=0,d=0;for(;r<=l;r++){if(h.value-t.value>n)return!1;s(6,u,d,e,h);const i=a.l;if(u=a.c,d=a.lc,c[r]=i,63==i){if(h.value-t.value>n)throw new Error("Something wrong with hufUnpackEncTable");s(8,u,d,e,h);let i=a.l+6;if(u=a.c,d=a.lc,r+i>l+1)throw new Error("Something wrong with hufUnpackEncTable");for(;i--;)c[r++]=0;r--}else if(i>=59){let e=i-59+2;if(r+e>l+1)throw new Error("Something wrong with hufUnpackEncTable");for(;e--;)c[r++]=0;r--}}!function(e){for(let e=0;e<=58;++e)o[e]=0;for(let t=0;t<i;++t)o[e[t]]+=1;let t=0;for(let e=58;e>0;--e){const n=t+o[e]>>1;o[e]=t,t=n}for(let t=0;t<i;++t){const n=e[t];n>0&&(e[t]=n|o[n]++<<6)}}(c)}(e,r,f-(r.value-_),v,x,S),M>8*(f-(r.value-_)))throw new Error("Something wrong with hufUncompress");!function(e,t,i,r){for(;t<=i;t++){const i=c(e[t]),a=l(e[t]);if(i>>a)throw new Error("Invalid table entry");if(a>n){const e=r[i>>a-n];if(e.len)throw new Error("Invalid table entry");if(e.lit++,e.p){const t=e.p;e.p=new Array(e.lit);for(let n=0;n<e.lit-1;++n)e.p[n]=t[n]}else e.p=new Array(1);e.p[e.lit-1]=t}else if(a){let e=0;for(let s=1<<n-a;s>0;s--){const s=r[(i<<n-a)+e];if(s.len||s.p)throw new Error("Invalid table entry");s.len=a,s.lit=t,e++}}}}(S,v,x,y),function(e,t,i,r,a,s,o,f,m){let g=0,_=0;const v=o,x=Math.trunc(r.value+(a+7)/8);for(;r.value<x;)for(u(g,_,i,r),g=h.c,_=h.lc;_>=n;){const a=t[g>>_-n&16383];if(a.len)_-=a.len,p(a.lit,s,g,_,i,r,f,m,v),g=d.c,_=d.lc;else{if(!a.p)throw new Error("hufDecode issues");let t;for(t=0;t<a.lit;t++){const n=l(e[a.p[t]]);for(;_<n&&r.value<x;)u(g,_,i,r),g=h.c,_=h.lc;if(_>=n&&c(e[a.p[t]])==(g>>_-n&(1<<n)-1)){_-=n,p(a.p[t],s,g,_,i,r,f,m,v),g=d.c,_=d.lc;break}}if(t==a.lit)throw new Error("hufDecode issues")}}const M=8-a&7;for(g>>=M,_-=M;_>0;){const e=t[g<<n-_&16383];if(!e.len)throw new Error("hufDecode issues");_-=e.len,p(e.lit,s,g,_,i,r,f,m,v),g=d.c,_=d.lc}}(S,y,e,r,M,x,g,m,{value:0})}function S(e){for(let t=1;t<e.length;t++){const n=e[t-1]+e[t]-128;e[t]=n}}function y(e,t){let n=0,i=Math.floor((e.length+1)/2),r=0;const a=e.length-1;for(;!(r>a||(t[r++]=e[n++],r>a));)t[r++]=e[i++]}function E(e){let t=e.byteLength;const n=new Array;let i=0;const r=new DataView(e);for(;t>0;){const e=r.getInt8(i++);if(e<0){const a=-e;t-=a+1;for(let e=0;e<a;e++)n.push(r.getUint8(i++))}else{const a=e;t-=2;const s=r.getUint8(i++);for(let e=0;e<a+1;e++)n.push(s)}}return n}function T(e,t,n){let i,r=1;for(;r<64;)i=t[e.value],65280==i?r=64:i>>8==255?r+=255&i:(n[r]=i,r++),e.value++}function b(e){const t=.5*Math.cos(.7853975),n=.5*Math.cos(3.14159/16),i=.5*Math.cos(3.14159/8),r=.5*Math.cos(3*3.14159/16),a=.5*Math.cos(.981746875),s=.5*Math.cos(3*3.14159/8),o=.5*Math.cos(1.374445625),l=new Array(4),c=new Array(4),h=new Array(4),u=new Array(4);for(let d=0;d<8;++d){const p=8*d;l[0]=i*e[p+2],l[1]=s*e[p+2],l[2]=i*e[p+6],l[3]=s*e[p+6],c[0]=n*e[p+1]+r*e[p+3]+a*e[p+5]+o*e[p+7],c[1]=r*e[p+1]-o*e[p+3]-n*e[p+5]-a*e[p+7],c[2]=a*e[p+1]-n*e[p+3]+o*e[p+5]+r*e[p+7],c[3]=o*e[p+1]-a*e[p+3]+r*e[p+5]-n*e[p+7],h[0]=t*(e[p+0]+e[p+4]),h[3]=t*(e[p+0]-e[p+4]),h[1]=l[0]+l[3],h[2]=l[1]-l[2],u[0]=h[0]+h[1],u[1]=h[3]+h[2],u[2]=h[3]-h[2],u[3]=h[0]-h[1],e[p+0]=u[0]+c[0],e[p+1]=u[1]+c[1],e[p+2]=u[2]+c[2],e[p+3]=u[3]+c[3],e[p+4]=u[3]-c[3],e[p+5]=u[2]-c[2],e[p+6]=u[1]-c[1],e[p+7]=u[0]-c[0]}for(let d=0;d<8;++d)l[0]=i*e[16+d],l[1]=s*e[16+d],l[2]=i*e[48+d],l[3]=s*e[48+d],c[0]=n*e[8+d]+r*e[24+d]+a*e[40+d]+o*e[56+d],c[1]=r*e[8+d]-o*e[24+d]-n*e[40+d]-a*e[56+d],c[2]=a*e[8+d]-n*e[24+d]+o*e[40+d]+r*e[56+d],c[3]=o*e[8+d]-a*e[24+d]+r*e[40+d]-n*e[56+d],h[0]=t*(e[d]+e[32+d]),h[3]=t*(e[d]-e[32+d]),h[1]=l[0]+l[3],h[2]=l[1]-l[2],u[0]=h[0]+h[1],u[1]=h[3]+h[2],u[2]=h[3]-h[2],u[3]=h[0]-h[1],e[0+d]=u[0]+c[0],e[8+d]=u[1]+c[1],e[16+d]=u[2]+c[2],e[24+d]=u[3]+c[3],e[32+d]=u[3]-c[3],e[40+d]=u[2]-c[2],e[48+d]=u[1]-c[1],e[56+d]=u[0]-c[0]}function w(e){for(let t=0;t<64;++t){const n=e[0][t],i=e[1][t],r=e[2][t];e[0][t]=n+1.5747*r,e[1][t]=n-.1873*i-.4682*r,e[2][t]=n+1.8556*i}}function A(e,t,n){for(let a=0;a<64;++a)t[n+a]=kn.toHalfFloat((i=e[a])<=1?Math.sign(i)*Math.pow(Math.abs(i),2.2):Math.sign(i)*Math.pow(r,Math.abs(i)-1));var i}function R(e){return new DataView(e.array.buffer,e.offset.value,e.size)}function C(e){const t=e.viewer.buffer.slice(e.offset.value,e.offset.value+e.size),n=new Uint8Array(E(t)),i=new Uint8Array(n.length);return S(n),y(n,i),new DataView(i.buffer)}function L(e){const t=yo(e.array.slice(e.offset.value,e.offset.value+e.size)),n=new Uint8Array(t.length);return S(t),y(t,n),new DataView(n.buffer)}function P(e){const n=e.viewer,i={value:e.offset.value},r=new Uint16Array(e.width*e.scanlineBlockSize*(e.channels*e.type)),a=new Uint8Array(8192);let s=0;const o=new Array(e.channels);for(let t=0;t<e.channels;t++)o[t]={},o[t].start=s,o[t].end=o[t].start,o[t].nx=e.width,o[t].ny=e.lines,o[t].size=e.type,s+=o[t].nx*o[t].ny*o[t].size;const l=k(n,i),c=k(n,i);if(c>=8192)throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");if(l<=c)for(let e=0;e<c-l+1;e++)a[e+l]=z(n,i);const h=new Uint16Array(t),u=function(e,n){let i=0;for(let r=0;r<t;++r)(0==r||e[r>>3]&1<<(7&r))&&(n[i++]=r);const r=i-1;for(;i<t;)n[i++]=0;return r}(a,h),d=O(n,i);M(e.array,n,i,d,r,s);for(let t=0;t<e.channels;++t){const e=o[t];for(let n=0;n<o[t].size;++n)x(r,e.start+n,e.nx,e.size,e.ny,e.nx*e.size,u)}!function(e,t,n){for(let i=0;i<n;++i)t[i]=e[t[i]]}(h,r,s);let p=0;const f=new Uint8Array(r.buffer.byteLength);for(let t=0;t<e.lines;t++)for(let t=0;t<e.channels;t++){const e=o[t],n=e.nx*e.size,i=new Uint8Array(r.buffer,2*e.end,2*n);f.set(i,p),p+=2*n,e.end+=n}return new DataView(f.buffer)}function U(e){const t=yo(e.array.slice(e.offset.value,e.offset.value+e.size)),n=e.lines*e.channels*e.width,i=1==e.type?new Uint16Array(n):new Uint32Array(n);let r=0,a=0;const s=new Array(4);for(let n=0;n<e.lines;n++)for(let n=0;n<e.channels;n++){let n=0;switch(e.type){case 1:s[0]=r,s[1]=s[0]+e.width,r=s[1]+e.width;for(let r=0;r<e.width;++r)n+=t[s[0]++]<<8|t[s[1]++],i[a]=n,a++;break;case 2:s[0]=r,s[1]=s[0]+e.width,s[2]=s[1]+e.width,r=s[2]+e.width;for(let r=0;r<e.width;++r)n+=t[s[0]++]<<24|t[s[1]++]<<16|t[s[2]++]<<8,i[a]=n,a++}}return new DataView(i.buffer)}function D(e){const t=e.viewer,n={value:e.offset.value},i=new Uint8Array(e.width*e.lines*(e.channels*e.type*2)),r={version:B(t,n),unknownUncompressedSize:B(t,n),unknownCompressedSize:B(t,n),acCompressedSize:B(t,n),dcCompressedSize:B(t,n),rleCompressedSize:B(t,n),rleUncompressedSize:B(t,n),rleRawSize:B(t,n),totalAcUncompressedCount:B(t,n),totalDcUncompressedCount:B(t,n),acCompression:B(t,n)};if(r.version<2)throw new Error("EXRLoader.parse: "+J.compression+" version "+r.version+" is unsupported");const a=new Array;let s=k(t,n)-2;for(;s>0;){const e=N(t.buffer,n),i=z(t,n),r=i>>2&3,o=new Int8Array([(i>>4)-1])[0],l=z(t,n);a.push({name:e,index:o,type:l,compression:r}),s-=e.length+3}const o=J.channels,l=new Array(e.channels);for(let t=0;t<e.channels;++t){const n=l[t]={},i=o[t];n.name=i.name,n.compression=0,n.decoded=!1,n.type=i.pixelType,n.pLinear=i.pLinear,n.width=e.width,n.height=e.lines}const c={idx:new Array(3)};for(let t=0;t<e.channels;++t){const e=l[t];for(let n=0;n<a.length;++n){const i=a[n];e.name==i.name&&(e.compression=i.compression,i.index>=0&&(c.idx[i.index]=t),e.offset=t)}}let h,u,d;if(r.acCompressedSize>0)switch(r.acCompression){case 0:h=new Uint16Array(r.totalAcUncompressedCount),M(e.array,t,n,r.acCompressedSize,h,r.totalAcUncompressedCount);break;case 1:const i=yo(e.array.slice(n.value,n.value+r.totalAcUncompressedCount));h=new Uint16Array(i.buffer),n.value+=r.totalAcUncompressedCount}if(r.dcCompressedSize>0){const t={array:e.array,offset:n,size:r.dcCompressedSize};u=new Uint16Array(L(t).buffer),n.value+=r.dcCompressedSize}r.rleRawSize>0&&(d=E(yo(e.array.slice(n.value,n.value+r.rleCompressedSize)).buffer),n.value+=r.rleCompressedSize);let p=0;const f=new Array(l.length);for(let e=0;e<f.length;++e)f[e]=new Array;for(let t=0;t<e.lines;++t)for(let t=0;t<l.length;++t)f[t].push(p),p+=l[t].width*e.type*2;!function(e,t,n,i,r,a){let s=new DataView(a.buffer);const o=n[e.idx[0]].width,l=n[e.idx[0]].height,c=Math.floor(o/8),h=Math.ceil(o/8),u=Math.ceil(l/8),d=o-8*(h-1),p=l-8*(u-1),f={value:0},m=new Array(3),g=new Array(3),_=new Array(3),v=new Array(3),x=new Array(3);for(let n=0;n<3;++n)x[n]=t[e.idx[n]],m[n]=n<1?0:m[n-1]+h*u,g[n]=new Float32Array(64),_[n]=new Uint16Array(64),v[n]=new Uint16Array(64*h);for(let t=0;t<u;++t){let a=8;t==u-1&&(a=p);let o=8;for(let e=0;e<h;++e){e==h-1&&(o=d);for(let e=0;e<3;++e)_[e].fill(0),_[e][0]=r[m[e]++],T(f,i,_[e]),M=_[e],(S=g[e])[0]=G(M[0]),S[1]=G(M[1]),S[2]=G(M[5]),S[3]=G(M[6]),S[4]=G(M[14]),S[5]=G(M[15]),S[6]=G(M[27]),S[7]=G(M[28]),S[8]=G(M[2]),S[9]=G(M[4]),S[10]=G(M[7]),S[11]=G(M[13]),S[12]=G(M[16]),S[13]=G(M[26]),S[14]=G(M[29]),S[15]=G(M[42]),S[16]=G(M[3]),S[17]=G(M[8]),S[18]=G(M[12]),S[19]=G(M[17]),S[20]=G(M[25]),S[21]=G(M[30]),S[22]=G(M[41]),S[23]=G(M[43]),S[24]=G(M[9]),S[25]=G(M[11]),S[26]=G(M[18]),S[27]=G(M[24]),S[28]=G(M[31]),S[29]=G(M[40]),S[30]=G(M[44]),S[31]=G(M[53]),S[32]=G(M[10]),S[33]=G(M[19]),S[34]=G(M[23]),S[35]=G(M[32]),S[36]=G(M[39]),S[37]=G(M[45]),S[38]=G(M[52]),S[39]=G(M[54]),S[40]=G(M[20]),S[41]=G(M[22]),S[42]=G(M[33]),S[43]=G(M[38]),S[44]=G(M[46]),S[45]=G(M[51]),S[46]=G(M[55]),S[47]=G(M[60]),S[48]=G(M[21]),S[49]=G(M[34]),S[50]=G(M[37]),S[51]=G(M[47]),S[52]=G(M[50]),S[53]=G(M[56]),S[54]=G(M[59]),S[55]=G(M[61]),S[56]=G(M[35]),S[57]=G(M[36]),S[58]=G(M[48]),S[59]=G(M[49]),S[60]=G(M[57]),S[61]=G(M[58]),S[62]=G(M[62]),S[63]=G(M[63]),b(g[e]);w(g);for(let t=0;t<3;++t)A(g[t],v[t],64*e)}let l=0;for(let i=0;i<3;++i){const r=n[e.idx[i]].type;for(let e=8*t;e<8*t+a;++e){l=x[i][e];for(let t=0;t<c;++t){const n=64*t+8*(7&e);s.setUint16(l+0*r,v[i][n+0],!0),s.setUint16(l+2*r,v[i][n+1],!0),s.setUint16(l+4*r,v[i][n+2],!0),s.setUint16(l+6*r,v[i][n+3],!0),s.setUint16(l+8*r,v[i][n+4],!0),s.setUint16(l+10*r,v[i][n+5],!0),s.setUint16(l+12*r,v[i][n+6],!0),s.setUint16(l+14*r,v[i][n+7],!0),l+=16*r}}if(c!=h)for(let e=8*t;e<8*t+a;++e){const t=x[i][e]+8*c*2*r,n=64*c+8*(7&e);for(let e=0;e<o;++e)s.setUint16(t+2*e*r,v[i][n+e],!0)}}}var M,S;const y=new Uint16Array(o);s=new DataView(a.buffer);for(let t=0;t<3;++t){n[e.idx[t]].decoded=!0;const i=n[e.idx[t]].type;if(2==n[t].type)for(let e=0;e<l;++e){const n=x[t][e];for(let e=0;e<o;++e)y[e]=s.getUint16(n+2*e*i,!0);for(let e=0;e<o;++e)s.setFloat32(n+2*e*i,G(y[e]),!0)}}}(c,f,l,h,u,i);for(let t=0;t<l.length;++t){const n=l[t];if(!n.decoded){if(2!==n.compression)throw new Error("EXRLoader.parse: unsupported channel compression");{let r=0,a=0;for(let s=0;s<e.lines;++s){let e=f[t][r];for(let t=0;t<n.width;++t){for(let t=0;t<2*n.type;++t)i[e++]=d[a+t*n.width*n.height];a++}r++}}}}return new DataView(i.buffer)}function N(e,t){const n=new Uint8Array(e);let i=0;for(;0!=n[t.value+i];)i+=1;const r=(new TextDecoder).decode(n.slice(t.value,t.value+i));return t.value=t.value+i+1,r}function I(e,t){const n=e.getInt32(t.value,!0);return t.value=t.value+4,n}function O(e,t){const n=e.getUint32(t.value,!0);return t.value=t.value+4,n}function F(e,t){const n=e[t.value];return t.value=t.value+1,n}function z(e,t){const n=e.getUint8(t.value);return t.value=t.value+1,n}const B=function(e,t){let n;return n="getBigInt64"in DataView.prototype?Number(e.getBigInt64(t.value,!0)):e.getUint32(t.value+4,!0)+Number(e.getUint32(t.value,!0)<<32),t.value+=8,n};function H(e,t){const n=e.getFloat32(t.value,!0);return t.value+=4,n}function V(e,t){return kn.toHalfFloat(H(e,t))}function G(e){const t=(31744&e)>>10,n=1023&e;return(e>>15?-1:1)*(t?31===t?n?NaN:1/0:Math.pow(2,t-15)*(1+n/1024):n/1024*6103515625e-14)}function k(e,t){const n=e.getUint16(t.value,!0);return t.value+=2,n}function W(e,t){return G(k(e,t))}function X(e,t,n,i,r){return"string"===i||"stringvector"===i||"iccProfile"===i?function(e,t,n){const i=(new TextDecoder).decode(new Uint8Array(e).slice(t.value,t.value+n));return t.value=t.value+n,i}(t,n,r):"chlist"===i?function(e,t,n,i){const r=n.value,a=[];for(;n.value<r+i-1;){const i=N(t,n),r=I(e,n),s=z(e,n);n.value+=3;const o=I(e,n),l=I(e,n);a.push({name:i,pixelType:r,pLinear:s,xSampling:o,ySampling:l})}return n.value+=1,a}(e,t,n,r):"chromaticities"===i?function(e,t){return{redX:H(e,t),redY:H(e,t),greenX:H(e,t),greenY:H(e,t),blueX:H(e,t),blueY:H(e,t),whiteX:H(e,t),whiteY:H(e,t)}}(e,n):"compression"===i?function(e,t){return["NO_COMPRESSION","RLE_COMPRESSION","ZIPS_COMPRESSION","ZIP_COMPRESSION","PIZ_COMPRESSION","PXR24_COMPRESSION","B44_COMPRESSION","B44A_COMPRESSION","DWAA_COMPRESSION","DWAB_COMPRESSION"][z(e,t)]}(e,n):"box2i"===i?function(e,t){return{xMin:O(e,t),yMin:O(e,t),xMax:O(e,t),yMax:O(e,t)}}(e,n):"lineOrder"===i?function(e,t){return["INCREASING_Y"][z(e,t)]}(e,n):"float"===i?H(e,n):"v2f"===i?function(e,t){return[H(e,t),H(e,t)]}(e,n):"v3f"===i?function(e,t){return[H(e,t),H(e,t),H(e,t)]}(e,n):"int"===i?I(e,n):"rational"===i?function(e,t){return[I(e,t),O(e,t)]}(e,n):"timecode"===i?function(e,t){return[O(e,t),O(e,t)]}(e,n):"preview"===i?(n.value+=r,"skipped"):void(n.value+=r)}const j=new DataView(e),q=new Uint8Array(e),Y={value:0},J=function(e,t,n){const i={};if(20000630!=e.getUint32(0,!0))throw new Error("THREE.EXRLoader: Provided file doesn\'t appear to be in OpenEXR format.");i.version=e.getUint8(4);const r=e.getUint8(5);i.spec={singleTile:!!(2&r),longName:!!(4&r),deepFormat:!!(8&r),multiPart:!!(16&r)},n.value=8;let a=!0;for(;a;){const r=N(t,n);if(0==r)a=!1;else{const a=N(t,n),s=X(e,t,n,a,O(e,n));void 0===s?console.warn(`THREE.EXRLoader: Skipped unknown header attribute type \'${a}\'.`):i[r]=s}}if(-5&r)throw console.error("THREE.EXRHeader:",i),new Error("THREE.EXRLoader: Provided file is currently unsupported.");return i}(j,e,Y),$=function(e,t,n,i,r){const a={size:0,viewer:t,array:n,offset:i,width:e.dataWindow.xMax-e.dataWindow.xMin+1,height:e.dataWindow.yMax-e.dataWindow.yMin+1,channels:e.channels.length,bytesPerLine:null,lines:null,inputSize:null,type:e.channels[0].pixelType,uncompress:null,getter:null,format:null,colorSpace:de};switch(e.compression){case"NO_COMPRESSION":a.lines=1,a.uncompress=R;break;case"RLE_COMPRESSION":a.lines=1,a.uncompress=C;break;case"ZIPS_COMPRESSION":a.lines=1,a.uncompress=L;break;case"ZIP_COMPRESSION":a.lines=16,a.uncompress=L;break;case"PIZ_COMPRESSION":a.lines=32,a.uncompress=P;break;case"PXR24_COMPRESSION":a.lines=16,a.uncompress=U;break;case"DWAA_COMPRESSION":a.lines=32,a.uncompress=D;break;case"DWAB_COMPRESSION":a.lines=256,a.uncompress=D;break;default:throw new Error("EXRLoader.parse: "+e.compression+" is unsupported")}if(a.scanlineBlockSize=a.lines,1==a.type)switch(r){case K:a.getter=W,a.inputSize=2;break;case Z:a.getter=k,a.inputSize=2}else{if(2!=a.type)throw new Error("EXRLoader.parse: unsupported pixelType "+a.type+" for "+e.compression+".");switch(r){case K:a.getter=H,a.inputSize=4;break;case Z:a.getter=V,a.inputSize=4}}a.blockCount=(e.dataWindow.yMax+1)/a.scanlineBlockSize;for(let e=0;e<a.blockCount;e++)B(t,i);a.outputChannels=3==a.channels?4:a.channels;const s=a.width*a.height*a.outputChannels;switch(r){case K:a.byteArray=new Float32Array(s),a.channels<a.outputChannels&&a.byteArray.fill(1,0,s);break;case Z:a.byteArray=new Uint16Array(s),a.channels<a.outputChannels&&a.byteArray.fill(15360,0,s);break;default:console.error("THREE.EXRLoader: unsupported type: ",r)}return a.bytesPerLine=a.width*a.inputSize*a.channels,4==a.outputChannels?(a.format=Q,a.colorSpace=de):(a.format=1028,a.colorSpace=he),a}(J,j,q,Y,this.type),ee={value:0},te={R:0,G:1,B:2,A:3,Y:0};for(let e=0;e<$.height/$.scanlineBlockSize;e++){const t=O(j,Y);$.size=O(j,Y),$.lines=t+$.scanlineBlockSize>$.height?$.height-t:$.scanlineBlockSize;const n=$.size<$.lines*$.bytesPerLine?$.uncompress($):R($);Y.value+=$.size;for(let t=0;t<$.scanlineBlockSize;t++){const i=t+e*$.scanlineBlockSize;if(i>=$.height)break;for(let e=0;e<$.channels;e++){const r=te[J.channels[e].name];for(let a=0;a<$.width;a++){ee.value=(t*($.channels*$.width)+e*$.width+a)*$.inputSize;const s=($.height-1-i)*($.width*$.outputChannels)+a*$.outputChannels+r;$.byteArray[s]=$.getter(n,ee)}}}}return{header:J,width:$.width,height:$.height,data:$.byteArray,format:$.format,colorSpace:$.colorSpace,type:this.type}}setDataType(e){return this.type=e,this}load(e,t,n,i){return super.load(e,(function(e,n){e.colorSpace=n.colorSpace,e.minFilter=k,e.magFilter=k,e.generateMipmaps=!1,e.flipY=!1,t&&t(e,n)}),n,i)}}onmessage=e=>{const t=new To;t.type=K;try{const n={isError:!1,value:t.parse(e.data)};postMessage(n)}catch(e){postMessage({isError:!0,value:e})}}})();', "Worker", void 0, void 0);
        }
        class hx {
            static async load(e1) {
                let t = await ox.get(e1);
                t || (t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), await ox.put(e1, t));
                const n = await t.arrayBuffer();
                return hx.parse(n);
            }
            static async parse(e1) {
                if (window.Worker) return new Promise((t, n)=>{
                    const i = new ux(e1);
                    i.onmessage = (e1)=>{
                        e1.data.isError ? n(e1.data.value) : t(e1.data.value);
                    }, i.postMessage(e1);
                });
                const t = new sx;
                return t.type = _a, t.parse(e1);
            }
        }
        var dx = n(229), px = n.n(dx);
        function fx(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const gx = new class {
            constructor(){
                fx(this, "parser", void 0), fx(this, "deviceOrientationStatus", void 0), this.deviceOrientationStatus = "denied", Tn(this), this.parser = new (px());
            }
            get isMobile() {
                return "mobile" === this.device.type;
            }
            get isTablet() {
                return "tablet" === this.device.type;
            }
            get isMobileDevice() {
                return this.isMobile || this.isTablet;
            }
            get deviceOrientationGranted() {
                return "granted" === this.deviceOrientationStatus;
            }
            get device() {
                return this.parser.getDevice();
            }
            async requestDeviceOrientation() {
                try {
                    const e1 = DeviceOrientationEvent;
                    return e1.requestPermission ? await e1.requestPermission().then((e1)=>this.setDeviceOrientationStatus(e1)) : this.setDeviceOrientationStatus("granted");
                } catch (e1) {
                    console.log(e1);
                }
            }
            setDeviceOrientationStatus(e1) {
                return this.deviceOrientationStatus = e1, e1;
            }
        };
        function mx(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const Ax = new class {
            constructor(){
                mx(this, "_textures", void 0), mx(this, "_depthTextures", void 0), mx(this, "_isLoading", void 0), this._textures = {}, this._depthTextures = {}, this._isLoading = {};
            }
            async getTexture(e1) {
                return e1 ? gx.isMobile ? await this.loadTexture(e1) : (this._textures[e1] || await this.cacheTexture(e1), this._textures[e1]) : null;
            }
            async getDepth(e1) {
                return e1 ? gx.isMobile ? await this.loadDepth(e1) : (this._depthTextures[e1] || await this.cacheDepth(e1), this._depthTextures[e1]) : null;
            }
            async cacheTexture(e1) {
                if (e1) {
                    if (!this.isCached(e1)) {
                        if (this.isLoading(e1)) await ji(()=>this.isLoading(e1));
                        else {
                            this._isLoading[e1] = !0;
                            try {
                                this._textures[e1] = await this.loadTexture(e1);
                            } catch (t) {
                                console.warn(e1, t);
                            }
                            this._isLoading[e1] = !1;
                        }
                    }
                } else console.warn("Cache empty url skipped!");
            }
            async cacheDepth(e1) {
                if (e1) {
                    if (!this.isCached(e1)) {
                        if (this.isLoading(e1)) await ji(()=>this.isLoading(e1));
                        else {
                            this._isLoading[e1] = !0;
                            try {
                                this._depthTextures[e1] = await this.loadDepth(e1);
                            } catch (t) {
                                console.warn(e1, t);
                            }
                            this._isLoading[e1] = !1;
                        }
                    }
                } else console.warn("Cache empty url skipped!");
            }
            isCached(e1) {
                return null != this._textures[e1] || null != this._depthTextures[e1];
            }
            isLoading(e1) {
                return this._isLoading[e1];
            }
            invalidate(e1) {
                delete this._textures[e1], delete this._depthTextures[e1], delete this._isLoading[e1];
            }
            clear() {
                this._textures = {}, this._depthTextures = {}, this._isLoading = {};
            }
            async loadTexture(e1) {
                const t = new wA, n = await t.loadAsync(e1);
                return n.center = new $o(.5, .5), n.colorSpace = Qs, n.minFilter = wa, n.magFilter = va, n.anisotropy = 8, n;
            }
            async loadDepth(e1) {
                return hx.load(e1);
            }
        }, Mx = (e1, t, n)=>e1 + (t - e1) * n, vx = (Math.PI, Math.PI, (e1)=>{
            const t = new bl(e1);
            return t.center = new $o(.5, .5), t.colorSpace = Qs, t.minFilter = wa, t.magFilter = va, t.needsUpdate = !0, t;
        }), yx = (e1, t, n)=>e1.find((e1)=>e1.ID === t).Vertices.map((e1)=>{
                const t = n.find((t)=>t.ID === e1);
                return [
                    t.Location.X,
                    t.Location.Y
                ];
            }), xx = (e1, t)=>{
            const { Rooms: n } = e1.Floors[Ci.currentFloorIndex].Units[0];
            return n.find((e1)=>{
                let { ID: n } = e1;
                return n === t;
            }) || null;
        }, bx = (e1, t)=>{
            const { CameraPoints: n } = e1.Floors[Ci.currentFloorIndex];
            return n?.find((e1)=>{
                let { ID: n } = e1;
                return n === t;
            }) || null;
        }, wx = (e1, t)=>t.reduce((t, n)=>{
                const i = _y([
                    e1,
                    [
                        n.userData.left,
                        n.userData.top
                    ]
                ]);
                return i < t.length ? {
                    panorama: n,
                    length: i
                } : t;
            }, {
                length: 1 / 0,
                panorama: null
            }), Ex = async (e1, t, n)=>new Promise((i)=>{
                const r = e1.opacity;
                let a = 0, s = 0;
                const o = (l)=>{
                    if (e1.opacity === n) return i();
                    var c, u;
                    0 === s && (s = l), a += l - s, s = l, e1.opacity = (c = r) + (n - c) * ((u = a / (1e3 * t)) < 0 ? 0 : u > 1 ? 1 : u), requestAnimationFrame(o);
                };
                return o(s);
            }), Tx = async (e1)=>{
            const t = (Ci.config?.fadeOptions?.fadeOutTime ?? .5) || 1e3;
            return e1.opacity = 1, Ex(e1, t, 0);
        }, Sx = async (e1)=>{
            const t = (Ci.config?.fadeOptions?.fadeInTime ?? .5) || 1e3;
            return e1.opacity = 0, Ex(e1, t, 1);
        }, Ix = (e1)=>Jo.DEG2RAD * e1, Nx = (e1)=>Jo.RAD2DEG * e1, Dx = (e1, t, n)=>{
            const { data: i, width: r, height: a } = n, s = i.length / a, o = (Math.round(a - t * a) - 1) * s + 4 * Math.round(e1 * r), [l, c, u, h] = i.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, _x = (e1, t, n)=>{
            const { data: i, width: r, height: a } = n, s = 4 * r, o = (Math.round(a - t * a) - 1) * s + 4 * Math.round(e1 * r), [l, c, u, h] = i.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, Cx = (e1, t)=>{
            const n = e1.X - t.X, i = e1.Y - t.Y;
            return n * n + i * i;
        }, Lx = (e1, t, n)=>{
            const i = e1.clone().sub(t).normalize(), r = e1.clone().sub(n).normalize();
            return i.cross(r);
        }, zx = (e1, t)=>{
            for (const n of e1.Floors)for (const e1 of n.Units)for (const n of e1.Rooms)for (const e1 of n.Furniture)if (e1.ID === t) return e1;
            return null;
        }, Ox = (e1)=>{
            switch(Ci.config.movementType){
                case "intraroom":
                    return !e1;
                case "interroom":
                    return !0;
                default:
                    return !1;
            }
        }, Rx = (e1)=>e1.includes("_Masked");
        function Px(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const Ux = class extends jp {
            constructor(e1, t){
                super(), Px(this, "_tempPointer", new $o), Px(this, "_raycaster", new PM), Px(this, "_tempMatrix", new lc), Px(this, "_pointer", new $o), Px(this, "deepChildren", []), Px(this, "_hoverElement", void 0), Px(this, "controller1", void 0), Px(this, "controller2", void 0), Px(this, "_renderer", void 0), Px(this, "_camera", void 0), Px(this, "updateDeepChildren", ()=>{
                    const e1 = [];
                    this.traverse((t)=>{
                        t.interactive && e1.push(t);
                    }, []), this.deepChildren = e1;
                }), this._camera = t, this._renderer = e1, this._renderer.domElement.addEventListener("pointermove", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("pointerdown", this.onPointerDown.bind(this)), this._renderer.domElement.addEventListener("pointerup", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("mousemove", this.onPointerEvent.bind(this)), this.controller1 = this.createController(0), this.controller2 = this.createController(1);
            }
            get hover() {
                return this._pointer.hover || this.controller1.hover || this.controller2.hover;
            }
            get cursor() {
                return LN.rulerModeEnabled ? "none" : this._pointer._hoverElement ? this._pointer._hoverElement.isLinkSphere ? "none" : this._pointer._hoverElement.isDoor ? "url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1MThfOTMyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjc1NCA2LjIyOTIxQzEwLjI3NTQgNS44OTk4NiAxMC40ODgyIDUuNjA4MzMgMTAuODAxOCA1LjUwODJMMjcuMDYzNyAwLjMxNTAxNEMyNy41NTE2IDAuMTU5MTkxIDI4LjA1IDAuNTIzNTEyIDI4LjA1IDEuMDM2MDJWNDguOTk2OEMyOC4wNSA0OS40ODQ0IDI3LjU5NTggNDkuODQ0OCAyNy4xMjEzIDQ5LjczMzdMMTAuODU5NCA0NS45MjUzQzEwLjUxNzMgNDUuODQ1MyAxMC4yNzU0IDQ1LjU0IDEwLjI3NTQgNDUuMTg4NVY2LjIyOTIxWk0yNS40MDI3IDI2LjExMDhDMjQuOTg1IDI2LjExMDggMjQuNjQ2NCAyNS43NzIgMjQuNjQ2NCAyNS4zNTRWMjQuMjE4OEMyNC42NDY0IDIzLjgwMDggMjQuOTg1IDIzLjQ2MTkgMjUuNDAyNyAyMy40NjE5QzI1LjgyMDUgMjMuNDYxOSAyNi4xNTkxIDIzLjgwMDggMjYuMTU5MSAyNC4yMTg4VjI1LjM1NEMyNi4xNTkxIDI1Ljc3MiAyNS44MjA1IDI2LjExMDggMjUuNDAyNyAyNi4xMTA4Wk0zMC42OTczIDUuMjk3ODhDMzAuNjk3MyA1LjcxNTg4IDMxLjAzNTkgNi4wNTQ3MiAzMS40NTM2IDYuMDU0NzJIMzguMjYwOUMzOC42Nzg3IDYuMDU0NzIgMzkuMDE3MyA2LjM5MzU3IDM5LjAxNzMgNi44MTE1NlY0My44OTY1QzM5LjAxNzMgNDQuMzE0NSAzOC42Nzg3IDQ0LjY1MzMgMzguMjYwOSA0NC42NTMzSDMxLjQ1MzZDMzEuMDM1OSA0NC42NTMzIDMwLjY5NzMgNDQuOTkyMiAzMC42OTczIDQ1LjQxMDJDMzAuNjk3MyA0NS44MjgyIDMxLjAzNTkgNDYuMTY3IDMxLjQ1MzYgNDYuMTY3SDM5Ljc3MzdDNDAuMTkxNCA0Ni4xNjcgNDAuNTMgNDUuODI4MiA0MC41MyA0NS40MTAyVjUuMjk3ODhDNDAuNTMgNC44Nzk5IDQwLjE5MTQgNC41NDEwNSAzOS43NzM3IDQuNTQxMDVIMzEuNDUzNkMzMS4wMzU5IDQuNTQxMDUgMzAuNjk3MyA0Ljg3OTkgMzAuNjk3MyA1LjI5Nzg4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTE4XzkzMiI+CjxyZWN0IHdpZHRoPSIzNi45NjI5IiBoZWlnaHQ9IjQ5Ljk1MTIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU0Mjk3KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=) 25 25, pointer" : this._pointer._hoverElement.isMesh ? "none" : "pointer" : "none";
            }
            add() {
                super.add(...arguments), this.updateDeepChildren();
            }
            createControllerLine(e1) {
                const t = new Ig(new Ll(0, 0, 0), new Ll(0, 0, -500)), n = new Cm(t, 100, .002, 100, !1), i = new Um({
                    color: new qc(16777215),
                    side: dr
                }), r = new Vu(n, i);
                return r.isVrControllerLine = !0, r.defaultDistance = 500, r.renderOrder = 7, e1.distanceLine = r, e1.add(r), r;
            }
            createControllerCircle(e1) {
                const t = document.createElement("canvas"), n = t.getContext("2d");
                t.width = 128, t.height = 128, n.beginPath(), n.arc(t.width / 2, t.height / 2, t.width / 4, 0, 2 * Math.PI, !1), n.strokeStyle = "rgba(255, 255, 255, 1)", n.fillStyle = "rgba(20, 20, 20, 0.26)", n.lineWidth = 10, n.fill(), n.stroke();
                const i = vx(t), r = new $p({
                    color: new qc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    side: dr,
                    map: i,
                    opacity: 1
                }), a = new ff(r);
                return a.isVrControllerCircle = !0, a.scale.setScalar(.05), a.renderOrder = 7, e1.distanceCircle = a, e1.add(a), a;
            }
            createController(e1) {
                const t = this._renderer.xr.getController(e1);
                t.isVrController = !0, this.createControllerLine(t), this.createControllerCircle(t);
                const n = new wy, i = new Dy, r = this._renderer.xr.getControllerGrip(e1);
                r.add(n.createControllerModel(r)), r.isVrControllerGrip = !0;
                const a = this._renderer.xr.getHand(e1);
                return a.add(i.createHandModel(a, "mesh")), a.isVrHand = !0, t.addEventListener("move", this.onXRControllerEvent.bind(this)), t.addEventListener("select", this.onXRControllerEvent.bind(this)), this.add(t, r, a), t;
            }
            getIntersections() {
                return this._raycaster.intersectObjects(this.deepChildren, !1).filter((e1)=>e1.object.visible && e1.object.parent).sort((e1)=>e1.object.isLinkSphere ? 1 : -1);
            }
            onPointerDown(e1) {
                let { clientX: t, clientY: n } = e1;
                this._tempPointer.x = Number(t.toFixed(0)), this._tempPointer.y = Number(n.toFixed(0));
            }
            onPointerEvent(e1) {
                const t = Math.abs(this._tempPointer.x - Number(e1.clientX.toFixed(0))) < 10, n = Math.abs(this._tempPointer.y - Number(e1.clientY.toFixed(0))) < 10, i = "pointerup" === e1.type ? "click" : e1.type;
                if (!("click" !== i || t && n)) return;
                const r = this._renderer.domElement.getBoundingClientRect();
                this._pointer.x = (e1.clientX - r.left) / r.width * 2 - 1, this._pointer.y = -(e1.clientY - r.top) / r.height * 2 + 1, this._raycaster.setFromCamera(this._pointer, this._camera);
                const a = this.getIntersections();
                a.length > 0 && this.onIntersection(a, i, this._pointer) || (this._pointer._hoverElement?.dispatchEvent({
                    type: "hoverend",
                    controller: null
                }), this._pointer._hoverElement = null, this._pointer.hover = !1);
            }
            onXRControllerEvent(e1) {
                const t = {
                    move: "mousemove",
                    select: "click"
                }, n = e1.target;
                this._tempMatrix.identity().extractRotation(n.matrixWorld), this._raycaster.ray.origin.setFromMatrixPosition(n.matrixWorld), this._raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this._tempMatrix);
                const i = this.getIntersections();
                i.length > 0 && this.onIntersection(i, t[e1.type], n) ? n.distanceCircle.material.depthTest = !1 : (n.distanceCircle.material.depthTest = !0, this.updateControllerPointer(n, 500), n._hoverElement?.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = null, n.hover = !1);
            }
            onIntersection(e1, t, n) {
                this.deepChildren.forEach((t)=>{
                    if (!t.isLinkSphere) return;
                    const i = e1.some((e1)=>e1.object.uuid === t.uuid);
                    t.dispatchEvent({
                        type: i ? "hoverstart" : "hoverend",
                        controller: n
                    });
                });
                const i = e1[0];
                if (!i) return null;
                const { object: r } = i, a = {
                    x: i.uv.x,
                    y: 1 - i.uv.y
                };
                return r.dispatchEvent({
                    type: "hoverstart",
                    data: a,
                    controller: n
                }), r.dispatchEvent({
                    type: t,
                    data: a,
                    controller: n
                }), n && n.isVrController && this.updateControllerPointer(n, i.distance), n._hoverElement && n._hoverElement.uuid !== r.uuid && n._hoverElement.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = r, n.hover = !0, r;
            }
            updateControllerPointer(e1, t) {
                e1.distanceCircle.position.z = -t;
                const n = t / e1.distanceLine.defaultDistance;
                e1.distanceLine.scale.set(1, 1, n);
            }
        }, jx = [
            "StraightStair_01",
            "StraightStair_01_WithLanding",
            "StraightStairWithTurn_01",
            "HelicalStair_01",
            "QuarterLandingStair_01",
            "HalfLandingStair_01",
            "DoubleQuarterLandingStair_01",
            "StraightStair_03",
            "StraightStair_03_WithLanding",
            "StraightStairWithTurn_03",
            "HelicalStair_03",
            "QuarterLandingStair_03",
            "HalfLandingStair_03",
            "DoubleQuarterLandingStair_03"
        ];
        function kx(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const Bx = class extends Vu {
            constructor(e1){
                super(), kx(this, "interactive", !0), kx(this, "_visible", !0), kx(this, "isDoor", !0), kx(this, "depthParams", {
                    maxDistance: 800,
                    maxDelta: 100
                }), this.userData = e1, this.position.copy(e1.position), this.rotation.copy(e1.rotation), this.renderOrder = 3, this.visible = !1, this.createGeometry(), this.createMaterial(), this.onHoverEnd(), this.addEventListeners();
            }
            get visible() {
                return this._visible;
            }
            set visible(e1) {
                this._visible = e1, this.sprite && (this.sprite.visible = e1 ? gx.isMobileDevice : e1);
            }
            createGeometry() {
                return this.geometry = new ph(this.userData.width, this.userData.height, 10, 10), this;
            }
            async createMaterial() {
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    opacity: 0
                }), this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {}
            onHoverEnd() {}
            onClick() {}
        };
        function Fx(e1) {
            if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e1;
        }
        function Hx(e1, t) {
            e1.prototype = Object.create(t.prototype), e1.prototype.constructor = e1, e1.__proto__ = t;
        }
        var Gx, Vx, Qx, Wx, Yx, Xx, Zx, qx, Kx, Jx, $x, eb, tb, nb, ib, rb, ab, sb = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        }, ob = {
            duration: .5,
            overwrite: !1,
            delay: 0
        }, lb = 1e8, cb = 1e-8, ub = 2 * Math.PI, hb = ub / 4, db = 0, pb = Math.sqrt, fb = Math.cos, gb = Math.sin, mb = function(e1) {
            return "string" == typeof e1;
        }, Ab = function(e1) {
            return "function" == typeof e1;
        }, Mb = function(e1) {
            return "number" == typeof e1;
        }, vb = function(e1) {
            return void 0 === e1;
        }, yb = function(e1) {
            return "object" == typeof e1;
        }, xb = function(e1) {
            return !1 !== e1;
        }, bb = function() {
            return "undefined" != typeof window;
        }, wb = function(e1) {
            return Ab(e1) || mb(e1);
        }, Eb = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}, Tb = Array.isArray, Sb = /(?:-?\.?\d|\.)+/gi, Ib = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, Nb = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Db = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, _b = /[+-]=-?[.\d]+/, Cb = /[^,'"\[\]\s]+/gi, Lb = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, zb = {}, Ob = {}, Rb = function(e1) {
            return (Ob = uw(e1, zb)) && uT;
        }, Pb = function(e1, t) {
            return console.warn("Invalid property", e1, "set to", t, "Missing plugin? gsap.registerPlugin()");
        }, Ub = function(e1, t) {
            return !t && console.warn(e1);
        }, jb = function(e1, t) {
            return e1 && (zb[e1] = t) && Ob && (Ob[e1] = t) || zb;
        }, kb = function() {
            return 0;
        }, Bb = {
            suppressEvents: !0,
            isStart: !0,
            kill: !1
        }, Fb = {
            suppressEvents: !0,
            kill: !1
        }, Hb = {
            suppressEvents: !0
        }, Gb = {}, Vb = [], Qb = {}, Wb = {}, Yb = {}, Xb = 30, Zb = [], qb = "", Kb = function(e1) {
            var t, n, i = e1[0];
            if (yb(i) || Ab(i) || (e1 = [
                e1
            ]), !(t = (i._gsap || {}).harness)) {
                for(n = Zb.length; n-- && !Zb[n].targetTest(i););
                t = Zb[n];
            }
            for(n = e1.length; n--;)e1[n] && (e1[n]._gsap || (e1[n]._gsap = new EE(e1[n], t))) || e1.splice(n, 1);
            return e1;
        }, Jb = function(e1) {
            return e1._gsap || Kb(Fw(e1))[0]._gsap;
        }, $b = function(e1, t, n) {
            return (n = e1[t]) && Ab(n) ? e1[t]() : vb(n) && e1.getAttribute && e1.getAttribute(t) || n;
        }, ew = function(e1, t) {
            return (e1 = e1.split(",")).forEach(t) || e1;
        }, tw = function(e1) {
            return Math.round(1e5 * e1) / 1e5 || 0;
        }, nw = function(e1) {
            return Math.round(1e7 * e1) / 1e7 || 0;
        }, iw = function(e1, t) {
            var n = t.charAt(0), i = parseFloat(t.substr(2));
            return e1 = parseFloat(e1), "+" === n ? e1 + i : "-" === n ? e1 - i : "*" === n ? e1 * i : e1 / i;
        }, rw = function(e1, t) {
            for(var n = t.length, i = 0; e1.indexOf(t[i]) < 0 && ++i < n;);
            return i < n;
        }, aw = function() {
            var e1, t, n = Vb.length, i = Vb.slice(0);
            for(Qb = {}, Vb.length = 0, e1 = 0; e1 < n; e1++)(t = i[e1]) && t._lazy && (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        }, sw = function(e1, t, n, i) {
            Vb.length && !Vx && aw(), e1.render(t, n, i || Vx && t < 0 && (e1._initted || e1._startAt)), Vb.length && !Vx && aw();
        }, ow = function(e1) {
            var t = parseFloat(e1);
            return (t || 0 === t) && (e1 + "").match(Cb).length < 2 ? t : mb(e1) ? e1.trim() : e1;
        }, lw = function(e1) {
            return e1;
        }, cw = function(e1, t) {
            for(var n in t)n in e1 || (e1[n] = t[n]);
            return e1;
        }, uw = function(e1, t) {
            for(var n in t)e1[n] = t[n];
            return e1;
        }, hw = function e1(t, n) {
            for(var i in n)"__proto__" !== i && "constructor" !== i && "prototype" !== i && (t[i] = yb(n[i]) ? e1(t[i] || (t[i] = {}), n[i]) : n[i]);
            return t;
        }, dw = function(e1, t) {
            var n, i = {};
            for(n in e1)n in t || (i[n] = e1[n]);
            return i;
        }, pw = function(e1) {
            var t, n = e1.parent || Wx, i = e1.keyframes ? (t = Tb(e1.keyframes), function(e1, n) {
                for(var i in n)i in e1 || "duration" === i && t || "ease" === i || (e1[i] = n[i]);
            }) : cw;
            if (xb(e1.inherit)) for(; n;)i(e1, n.vars.defaults), n = n.parent || n._dp;
            return e1;
        }, fw = function(e1, t, n, i, r) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var a, s = e1[i];
            if (r) for(a = t[r]; s && s[r] > a;)s = s._prev;
            return s ? (t._next = s._next, s._next = t) : (t._next = e1[n], e1[n] = t), t._next ? t._next._prev = t : e1[i] = t, t._prev = s, t.parent = t._dp = e1, t;
        }, gw = function(e1, t, n, i) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var r = t._prev, a = t._next;
            r ? r._next = a : e1[n] === t && (e1[n] = a), a ? a._prev = r : e1[i] === t && (e1[i] = r), t._next = t._prev = t.parent = null;
        }, mw = function(e1, t) {
            e1.parent && (!t || e1.parent.autoRemoveChildren) && e1.parent.remove && e1.parent.remove(e1), e1._act = 0;
        }, Aw = function(e1, t) {
            if (e1 && (!t || t._end > e1._dur || t._start < 0)) for(var n = e1; n;)n._dirty = 1, n = n.parent;
            return e1;
        }, Mw = function(e1, t, n, i) {
            return e1._startAt && (Vx ? e1._startAt.revert(Fb) : e1.vars.immediateRender && !e1.vars.autoRevert || e1._startAt.render(t, !0, i));
        }, vw = function e1(t) {
            return !t || t._ts && e1(t.parent);
        }, yw = function(e1) {
            return e1._repeat ? xw(e1._tTime, e1 = e1.duration() + e1._rDelay) * e1 : 0;
        }, xw = function(e1, t) {
            var n = Math.floor(e1 /= t);
            return e1 && n === e1 ? n - 1 : n;
        }, bw = function(e1, t) {
            return (e1 - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
        }, ww = function(e1) {
            return e1._end = nw(e1._start + (e1._tDur / Math.abs(e1._ts || e1._rts || cb) || 0));
        }, Ew = function(e1, t) {
            var n = e1._dp;
            return n && n.smoothChildTiming && e1._ts && (e1._start = nw(n._time - (e1._ts > 0 ? t / e1._ts : ((e1._dirty ? e1.totalDuration() : e1._tDur) - t) / -e1._ts)), ww(e1), n._dirty || Aw(n, e1)), e1;
        }, Tw = function(e1, t) {
            var n;
            if ((t._time || !t._dur && t._initted || t._start < e1._time && (t._dur || !t.add)) && (n = bw(e1.rawTime(), t), (!t._dur || Uw(0, t.totalDuration(), n) - t._tTime > cb) && t.render(n, !0)), Aw(e1, t)._dp && e1._initted && e1._time >= e1._dur && e1._ts) {
                if (e1._dur < e1.duration()) for(n = e1; n._dp;)n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
                e1._zTime = -0.00000001;
            }
        }, Sw = function(e1, t, n, i) {
            return t.parent && mw(t), t._start = nw((Mb(n) ? n : n || e1 !== Wx ? Ow(e1, n, t) : e1._time) + t._delay), t._end = nw(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), fw(e1, t, "_first", "_last", e1._sort ? "_start" : 0), _w(t) || (e1._recent = t), i || Tw(e1, t), e1._ts < 0 && Ew(e1, e1._tTime), e1;
        }, Iw = function(e1, t) {
            return (zb.ScrollTrigger || Pb("scrollTrigger", t)) && zb.ScrollTrigger.create(t, e1);
        }, Nw = function(e1, t, n, i, r) {
            return LE(e1, t, r), e1._initted ? !n && e1._pt && !Vx && (e1._dur && !1 !== e1.vars.lazy || !e1._dur && e1.vars.lazy) && Kx !== hE.frame ? (Vb.push(e1), e1._lazy = [
                r,
                i
            ], 1) : void 0 : 1;
        }, Dw = function e1(t) {
            var n = t.parent;
            return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e1(n));
        }, _w = function(e1) {
            var t = e1.data;
            return "isFromStart" === t || "isStart" === t;
        }, Cw = function(e1, t, n, i) {
            var r = e1._repeat, a = nw(t) || 0, s = e1._tTime / e1._tDur;
            return s && !i && (e1._time *= a / e1._dur), e1._dur = a, e1._tDur = r ? r < 0 ? 1e10 : nw(a * (r + 1) + e1._rDelay * r) : a, s > 0 && !i && Ew(e1, e1._tTime = e1._tDur * s), e1.parent && ww(e1), n || Aw(e1.parent, e1), e1;
        }, Lw = function(e1) {
            return e1 instanceof SE ? Aw(e1) : Cw(e1, e1._dur);
        }, zw = {
            _start: 0,
            endTime: kb,
            totalDuration: kb
        }, Ow = function e1(t, n, i) {
            var r, a, s, o = t.labels, l = t._recent || zw, c = t.duration() >= lb ? l.endTime(!1) : t._dur;
            return mb(n) && (isNaN(n) || n in o) ? (a = n.charAt(0), s = "%" === n.substr(-1), r = n.indexOf("="), "<" === a || ">" === a ? (r >= 0 && (n = n.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (s ? (r < 0 ? l : i).totalDuration() / 100 : 1)) : r < 0 ? (n in o || (o[n] = c), o[n]) : (a = parseFloat(n.charAt(r - 1) + n.substr(r + 1)), s && i && (a = a / 100 * (Tb(i) ? i[0] : i).totalDuration()), r > 1 ? e1(t, n.substr(0, r - 1), i) + a : c + a)) : null == n ? c : +n;
        }, Rw = function(e1, t, n) {
            var i, r, a = Mb(t[1]), s = (a ? 2 : 1) + (e1 < 2 ? 0 : 1), o = t[s];
            if (a && (o.duration = t[1]), o.parent = n, e1) {
                for(i = o, r = n; r && !("immediateRender" in i);)i = r.vars.defaults || {}, r = xb(r.vars.inherit) && r.parent;
                o.immediateRender = xb(i.immediateRender), e1 < 2 ? o.runBackwards = 1 : o.startAt = t[s - 1];
            }
            return new UE(t[0], o, t[s + 1]);
        }, Pw = function(e1, t) {
            return e1 || 0 === e1 ? t(e1) : t;
        }, Uw = function(e1, t, n) {
            return n < e1 ? e1 : n > t ? t : n;
        }, jw = function(e1, t) {
            return mb(e1) && (t = Lb.exec(e1)) ? t[1] : "";
        }, kw = [].slice, Bw = function(e1, t) {
            return e1 && yb(e1) && "length" in e1 && (!t && !e1.length || e1.length - 1 in e1 && yb(e1[0])) && !e1.nodeType && e1 !== Yx;
        }, Fw = function(e1, t, n) {
            return Qx && !t && Qx.selector ? Qx.selector(e1) : !mb(e1) || n || !Xx && dE() ? Tb(e1) ? function(e1, t, n) {
                return void 0 === n && (n = []), e1.forEach(function(e1) {
                    var i;
                    return mb(e1) && !t || Bw(e1, 1) ? (i = n).push.apply(i, Fw(e1)) : n.push(e1);
                }) || n;
            }(e1, n) : Bw(e1) ? kw.call(e1, 0) : e1 ? [
                e1
            ] : [] : kw.call((t || Zx).querySelectorAll(e1), 0);
        }, Hw = function(e1) {
            return e1 = Fw(e1)[0] || Ub("Invalid scope") || {}, function(t) {
                var n = e1.current || e1.nativeElement || e1;
                return Fw(t, n.querySelectorAll ? n : n === e1 ? Ub("Invalid scope") || Zx.createElement("div") : e1);
            };
        }, Gw = function(e1) {
            return e1.sort(function() {
                return .5 - Math.random();
            });
        }, Vw = function(e1) {
            if (Ab(e1)) return e1;
            var t = yb(e1) ? e1 : {
                each: e1
            }, n = vE(t.ease), i = t.from || 0, r = parseFloat(t.base) || 0, a = {}, s = i > 0 && i < 1, o = isNaN(i) || s, l = t.axis, c = i, u = i;
            return mb(i) ? c = u = ({
                center: .5,
                edges: .5,
                end: 1
            })[i] || 0 : !s && o && (c = i[0], u = i[1]), function(e1, s, h) {
                var d, p, f, g, m, A, M, v, y, x = (h || t).length, b = a[x];
                if (!b) {
                    if (!(y = "auto" === t.grid ? 0 : (t.grid || [
                        1,
                        lb
                    ])[1])) {
                        for(M = -lb; M < (M = h[y++].getBoundingClientRect().left) && y < x;);
                        y < x && y--;
                    }
                    for(b = a[x] = [], d = o ? Math.min(y, x) * c - .5 : i % y, p = y === lb ? 0 : o ? x * u / y - .5 : i / y | 0, M = 0, v = lb, A = 0; A < x; A++)f = A % y - d, g = p - (A / y | 0), b[A] = m = l ? Math.abs("y" === l ? g : f) : pb(f * f + g * g), m > M && (M = m), m < v && (v = m);
                    "random" === i && Gw(b), b.max = M - v, b.min = v, b.v = x = (parseFloat(t.amount) || parseFloat(t.each) * (y > x ? x - 1 : l ? "y" === l ? x / y : y : Math.max(y, x / y)) || 0) * ("edges" === i ? -1 : 1), b.b = x < 0 ? r - x : r, b.u = jw(t.amount || t.each) || 0, n = n && x < 0 ? AE(n) : n;
                }
                return x = (b[e1] - b.min) / b.max || 0, nw(b.b + (n ? n(x) : x) * b.v) + b.u;
            };
        }, Qw = function(e1) {
            var t = Math.pow(10, ((e1 + "").split(".")[1] || "").length);
            return function(n) {
                var i = nw(Math.round(parseFloat(n) / e1) * e1 * t);
                return (i - i % 1) / t + (Mb(n) ? 0 : jw(n));
            };
        }, Ww = function(e1, t) {
            var n, i, r = Tb(e1);
            return !r && yb(e1) && (n = r = e1.radius || lb, e1.values ? (e1 = Fw(e1.values), (i = !Mb(e1[0])) && (n *= n)) : e1 = Qw(e1.increment)), Pw(t, r ? Ab(e1) ? function(t) {
                return i = e1(t), Math.abs(i - t) <= n ? i : t;
            } : function(t) {
                for(var r, a, s = parseFloat(i ? t.x : t), o = parseFloat(i ? t.y : 0), l = lb, c = 0, u = e1.length; u--;)(r = i ? (r = e1[u].x - s) * r + (a = e1[u].y - o) * a : Math.abs(e1[u] - s)) < l && (l = r, c = u);
                return c = !n || l <= n ? e1[c] : t, i || c === t || Mb(t) ? c : c + jw(t);
            } : Qw(e1));
        }, Yw = function(e1, t, n, i) {
            return Pw(Tb(e1) ? !t : !0 === n ? (n = 0, false) : !i, function() {
                return Tb(e1) ? e1[~~(Math.random() * e1.length)] : (n = n || 1e-5, i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((e1 - n / 2 + Math.random() * (t - e1 + .99 * n)) / n) * n * i) / i;
            });
        }, Xw = function(e1, t, n) {
            return Pw(n, function(n) {
                return e1[~~t(n)];
            });
        }, Zw = function(e1) {
            for(var t, n, i, r, a = 0, s = ""; ~(t = e1.indexOf("random(", a));)i = e1.indexOf(")", t), r = "[" === e1.charAt(t + 7), n = e1.substr(t + 7, i - t - 7).match(r ? Cb : Sb), s += e1.substr(a, t - a) + Yw(r ? n : +n[0], r ? 0 : +n[1], +n[2] || 1e-5), a = i + 1;
            return s + e1.substr(a, e1.length - a);
        }, qw = function(e1, t, n, i, r) {
            var a = t - e1, s = i - n;
            return Pw(r, function(t) {
                return n + ((t - e1) / a * s || 0);
            });
        }, Kw = function(e1, t, n) {
            var i, r, a, s = e1.labels, o = lb;
            for(i in s)(r = s[i] - t) < 0 == !!n && r && o > (r = Math.abs(r)) && (a = i, o = r);
            return a;
        }, Jw = function(e1, t, n) {
            var i, r, a, s = e1.vars, o = s[t], l = Qx, c = e1._ctx;
            if (o) return i = s[t + "Params"], r = s.callbackScope || e1, n && Vb.length && aw(), c && (Qx = c), a = i ? o.apply(r, i) : o.call(r), Qx = l, a;
        }, $w = function(e1) {
            return mw(e1), e1.scrollTrigger && e1.scrollTrigger.kill(!!Vx), e1.progress() < 1 && Jw(e1, "onInterrupt"), e1;
        }, eE = [], tE = function(e1) {
            if (e1) {
                if (e1 = !e1.name && e1.default || e1, bb() || e1.headless) {
                    var t = e1.name, n = Ab(e1), i = t && !n && e1.init ? function() {
                        this._props = [];
                    } : e1, r = {
                        init: kb,
                        render: WE,
                        add: _E,
                        kill: XE,
                        modifier: YE,
                        rawVars: 0
                    }, a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: HE,
                        aliases: {},
                        register: 0
                    };
                    if (dE(), e1 !== i) {
                        if (Wb[t]) return;
                        cw(i, cw(dw(e1, r), a)), uw(i.prototype, uw(r, dw(e1, a))), Wb[i.prop = t] = i, e1.targetTest && (Zb.push(i), Gb[t] = 1), t = ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
                    }
                    jb(t, i), e1.register && e1.register(uT, i, KE);
                } else eE.push(e1);
            }
        }, nE = 255, iE = {
            aqua: [
                0,
                nE,
                nE
            ],
            lime: [
                0,
                nE,
                0
            ],
            silver: [
                192,
                192,
                192
            ],
            black: [
                0,
                0,
                0
            ],
            maroon: [
                128,
                0,
                0
            ],
            teal: [
                0,
                128,
                128
            ],
            blue: [
                0,
                0,
                nE
            ],
            navy: [
                0,
                0,
                128
            ],
            white: [
                nE,
                nE,
                nE
            ],
            olive: [
                128,
                128,
                0
            ],
            yellow: [
                nE,
                nE,
                0
            ],
            orange: [
                nE,
                165,
                0
            ],
            gray: [
                128,
                128,
                128
            ],
            purple: [
                128,
                0,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            red: [
                nE,
                0,
                0
            ],
            pink: [
                nE,
                192,
                203
            ],
            cyan: [
                0,
                nE,
                nE
            ],
            transparent: [
                nE,
                nE,
                nE,
                0
            ]
        }, rE = function(e1, t, n) {
            return (6 * (e1 += e1 < 0 ? 1 : e1 > 1 ? -1 : 0) < 1 ? t + (n - t) * e1 * 6 : e1 < .5 ? n : 3 * e1 < 2 ? t + (n - t) * (2 / 3 - e1) * 6 : t) * nE + .5 | 0;
        }, aE = function(e1, t, n) {
            var i, r, a, s, o, l, c, u, h, d, p = e1 ? Mb(e1) ? [
                e1 >> 16,
                e1 >> 8 & nE,
                e1 & nE
            ] : 0 : iE.black;
            if (!p) {
                if ("," === e1.substr(-1) && (e1 = e1.substr(0, e1.length - 1)), iE[e1]) p = iE[e1];
                else if ("#" === e1.charAt(0)) {
                    if (e1.length < 6 && (i = e1.charAt(1), r = e1.charAt(2), a = e1.charAt(3), e1 = "#" + i + i + r + r + a + a + (5 === e1.length ? e1.charAt(4) + e1.charAt(4) : "")), 9 === e1.length) return [
                        (p = parseInt(e1.substr(1, 6), 16)) >> 16,
                        p >> 8 & nE,
                        p & nE,
                        parseInt(e1.substr(7), 16) / 255
                    ];
                    p = [
                        (e1 = parseInt(e1.substr(1), 16)) >> 16,
                        e1 >> 8 & nE,
                        e1 & nE
                    ];
                } else if ("hsl" === e1.substr(0, 3)) {
                    if (p = d = e1.match(Sb), t) {
                        if (~e1.indexOf("=")) return p = e1.match(Ib), n && p.length < 4 && (p[3] = 1), p;
                    } else s = +p[0] % 360 / 360, o = +p[1] / 100, i = 2 * (l = +p[2] / 100) - (r = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = rE(s + 1 / 3, i, r), p[1] = rE(s, i, r), p[2] = rE(s - 1 / 3, i, r);
                } else p = e1.match(Sb) || iE.transparent;
                p = p.map(Number);
            }
            return t && !d && (i = p[0] / nE, r = p[1] / nE, a = p[2] / nE, l = ((c = Math.max(i, r, a)) + (u = Math.min(i, r, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === i ? (r - a) / h + (r < a ? 6 : 0) : c === r ? (a - i) / h + 2 : (i - r) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), n && p.length < 4 && (p[3] = 1), p;
        }, sE = function(e1) {
            var t = [], n = [], i = -1;
            return e1.split(lE).forEach(function(e1) {
                var r = e1.match(Nb) || [];
                t.push.apply(t, r), n.push(i += r.length + 1);
            }), t.c = n, t;
        }, oE = function(e1, t, n) {
            var i, r, a, s, o = "", l = (e1 + o).match(lE), c = t ? "hsla(" : "rgba(", u = 0;
            if (!l) return e1;
            if (l = l.map(function(e1) {
                return (e1 = aE(e1, t, 1)) && c + (t ? e1[0] + "," + e1[1] + "%," + e1[2] + "%," + e1[3] : e1.join(",")) + ")";
            }), n && (a = sE(e1), (i = n.c).join(o) !== a.c.join(o))) for(s = (r = e1.replace(lE, "1").split(Nb)).length - 1; u < s; u++)o += r[u] + (~i.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : n).shift());
            if (!r) for(s = (r = e1.split(lE)).length - 1; u < s; u++)o += r[u] + l[u];
            return o + r[s];
        }, lE = function() {
            var e1, t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
            for(e1 in iE)t += "|" + e1 + "\\b";
            return new RegExp(t + ")", "gi");
        }(), cE = /hsl[a]?\(/, uE = function(e1) {
            var t, n = e1.join(" ");
            if (lE.lastIndex = 0, lE.test(n)) return t = cE.test(n), e1[1] = oE(e1[1], t), e1[0] = oE(e1[0], t, sE(e1[1])), !0;
        }, hE = function() {
            var e1, t, n, i, r, a, s = Date.now, o = 500, l = 33, c = s(), u = c, h = 1e3 / 240, d = h, p = [], f = function n(f) {
                var g, m, A, M, v = s() - u, y = !0 === f;
                if ((v > o || v < 0) && (c += v - l), ((g = (A = (u += v) - c) - d) > 0 || y) && (M = ++i.frame, r = A - 1e3 * i.time, i.time = A /= 1e3, d += g + (g >= h ? 4 : h - g), m = 1), y || (e1 = t(n)), m) for(a = 0; a < p.length; a++)p[a](A, r, M, f);
            };
            return i = {
                time: 0,
                frame: 0,
                tick: function() {
                    f(!0);
                },
                deltaRatio: function(e1) {
                    return r / (1e3 / (e1 || 60));
                },
                wake: function() {
                    qx && (!Xx && bb() && (Yx = Xx = window, Zx = Yx.document || {}, zb.gsap = uT, (Yx.gsapVersions || (Yx.gsapVersions = [])).push(uT.version), Rb(Ob || Yx.GreenSockGlobals || !Yx.gsap && Yx || {}), eE.forEach(tE)), n = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, e1 && i.sleep(), t = n || function(e1) {
                        return setTimeout(e1, d - 1e3 * i.time + 1 | 0);
                    }, $x = 1, f(2));
                },
                sleep: function() {
                    (n ? cancelAnimationFrame : clearTimeout)(e1), $x = 0, t = kb;
                },
                lagSmoothing: function(e1, t) {
                    o = e1 || 1 / 0, l = Math.min(t || 33, o);
                },
                fps: function(e1) {
                    h = 1e3 / (e1 || 240), d = 1e3 * i.time + h;
                },
                add: function(e1, t, n) {
                    var r = t ? function(t, n, a, s) {
                        e1(t, n, a, s), i.remove(r);
                    } : e1;
                    return i.remove(e1), p[n ? "unshift" : "push"](r), dE(), r;
                },
                remove: function(e1, t) {
                    ~(t = p.indexOf(e1)) && p.splice(t, 1) && a >= t && a--;
                },
                _listeners: p
            }, i;
        }(), dE = function() {
            return !$x && hE.wake();
        }, pE = {}, fE = /^[\d.\-M][\d.\-,\s]/, gE = /["']/g, mE = function(e1) {
            for(var t, n, i, r = {}, a = e1.substr(1, e1.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++)n = a[o], t = o !== l - 1 ? n.lastIndexOf(",") : n.length, i = n.substr(0, t), r[s] = isNaN(i) ? i.replace(gE, "").trim() : +i, s = n.substr(t + 1).trim();
            return r;
        }, AE = function(e1) {
            return function(t) {
                return 1 - e1(1 - t);
            };
        }, ME = function e1(t, n) {
            for(var i, r = t._first; r;)r instanceof SE ? e1(r, n) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === n || (r.timeline ? e1(r.timeline, n) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = n)), r = r._next;
        }, vE = function(e1, t) {
            return e1 && (Ab(e1) ? e1 : pE[e1] || function(e1) {
                var t, n, i, r, a = (e1 + "").split("("), s = pE[a[0]];
                return s && a.length > 1 && s.config ? s.config.apply(null, ~e1.indexOf("{") ? [
                    mE(a[1])
                ] : (t = e1, n = t.indexOf("(") + 1, i = t.indexOf(")"), r = t.indexOf("(", n), t.substring(n, ~r && r < i ? t.indexOf(")", i + 1) : i)).split(",").map(ow)) : pE._CE && fE.test(e1) ? pE._CE("", e1) : s;
            }(e1)) || t;
        }, yE = function(e1, t, n, i) {
            void 0 === n && (n = function(e1) {
                return 1 - t(1 - e1);
            }), void 0 === i && (i = function(e1) {
                return e1 < .5 ? t(2 * e1) / 2 : 1 - t(2 * (1 - e1)) / 2;
            });
            var r, a = {
                easeIn: t,
                easeOut: n,
                easeInOut: i
            };
            return ew(e1, function(e1) {
                for(var t in pE[e1] = zb[e1] = a, pE[r = e1.toLowerCase()] = n, a)pE[r + ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")] = pE[e1 + "." + t] = a[t];
            }), a;
        }, xE = function(e1) {
            return function(t) {
                return t < .5 ? (1 - e1(1 - 2 * t)) / 2 : .5 + e1(2 * (t - .5)) / 2;
            };
        }, bE = function e1(t, n, i) {
            var r = n >= 1 ? n : 1, a = (i || (t ? .3 : .45)) / (n < 1 ? n : 1), s = a / ub * (Math.asin(1 / r) || 0), o = function(e1) {
                return 1 === e1 ? 1 : r * Math.pow(2, -10 * e1) * gb((e1 - s) * a) + 1;
            }, l = "out" === t ? o : "in" === t ? function(e1) {
                return 1 - o(1 - e1);
            } : xE(o);
            return a = ub / a, l.config = function(n, i) {
                return e1(t, n, i);
            }, l;
        }, wE = function e1(t, n) {
            void 0 === n && (n = 1.70158);
            var i = function(e1) {
                return e1 ? --e1 * e1 * ((n + 1) * e1 + n) + 1 : 0;
            }, r = "out" === t ? i : "in" === t ? function(e1) {
                return 1 - i(1 - e1);
            } : xE(i);
            return r.config = function(n) {
                return e1(t, n);
            }, r;
        };
        ew("Linear,Quad,Cubic,Quart,Quint,Strong", function(e1, t) {
            var n = t < 5 ? t + 1 : t;
            yE(e1 + ",Power" + (n - 1), t ? function(e1) {
                return Math.pow(e1, n);
            } : function(e1) {
                return e1;
            }, function(e1) {
                return 1 - Math.pow(1 - e1, n);
            }, function(e1) {
                return e1 < .5 ? Math.pow(2 * e1, n) / 2 : 1 - Math.pow(2 * (1 - e1), n) / 2;
            });
        }), pE.Linear.easeNone = pE.none = pE.Linear.easeIn, yE("Elastic", bE("in"), bE("out"), bE()), eb = 7.5625, ib = 2 * (nb = 1 / (tb = 2.75)), rb = 2.5 * nb, yE("Bounce", function(e1) {
            return 1 - ab(1 - e1);
        }, ab = function(e1) {
            return e1 < nb ? eb * e1 * e1 : e1 < ib ? eb * Math.pow(e1 - 1.5 / tb, 2) + .75 : e1 < rb ? eb * (e1 -= 2.25 / tb) * e1 + .9375 : eb * Math.pow(e1 - 2.625 / tb, 2) + .984375;
        }), yE("Expo", function(e1) {
            return e1 ? Math.pow(2, 10 * (e1 - 1)) : 0;
        }), yE("Circ", function(e1) {
            return -(pb(1 - e1 * e1) - 1);
        }), yE("Sine", function(e1) {
            return 1 === e1 ? 1 : 1 - fb(e1 * hb);
        }), yE("Back", wE("in"), wE("out"), wE()), pE.SteppedEase = pE.steps = zb.SteppedEase = {
            config: function(e1, t) {
                void 0 === e1 && (e1 = 1);
                var n = 1 / e1, i = e1 + (t ? 0 : 1), r = t ? 1 : 0;
                return function(e1) {
                    return ((i * Uw(0, .99999999, e1) | 0) + r) * n;
                };
            }
        }, ob.ease = pE["quad.out"], ew("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e1) {
            return qb += e1 + "," + e1 + "Params,";
        });
        var EE = function(e1, t) {
            this.id = db++, e1._gsap = this, this.target = e1, this.harness = t, this.get = t ? t.get : $b, this.set = t ? t.getSetter : HE;
        }, TE = function() {
            function e1(e1) {
                this.vars = e1, this._delay = +e1.delay || 0, (this._repeat = e1.repeat === 1 / 0 ? -2 : e1.repeat || 0) && (this._rDelay = e1.repeatDelay || 0, this._yoyo = !!e1.yoyo || !!e1.yoyoEase), this._ts = 1, Cw(this, +e1.duration, 1, 1), this.data = e1.data, Qx && (this._ctx = Qx, Qx.data.push(this)), $x || hE.wake();
            }
            var t = e1.prototype;
            return t.delay = function(e1) {
                return e1 || 0 === e1 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e1 - this._delay), this._delay = e1, this) : this._delay;
            }, t.duration = function(e1) {
                return arguments.length ? this.totalDuration(this._repeat > 0 ? e1 + (e1 + this._rDelay) * this._repeat : e1) : this.totalDuration() && this._dur;
            }, t.totalDuration = function(e1) {
                return arguments.length ? (this._dirty = 0, Cw(this, this._repeat < 0 ? e1 : (e1 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }, t.totalTime = function(e1, t) {
                if (dE(), !arguments.length) return this._tTime;
                var n = this._dp;
                if (n && n.smoothChildTiming && this._ts) {
                    for(Ew(this, e1), !n._dp || n.parent || Tw(n, this); n && n.parent;)n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), n = n.parent;
                    !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && e1 < this._tDur || this._ts < 0 && e1 > 0 || !this._tDur && !e1) && Sw(this._dp, this, this._start - this._delay);
                }
                return (this._tTime !== e1 || !this._dur && !t || this._initted && Math.abs(this._zTime) === cb || !e1 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = e1), sw(this, e1, t)), this;
            }, t.time = function(e1, t) {
                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e1 + yw(this)) % (this._dur + this._rDelay) || (e1 ? this._dur : 0), t) : this._time;
            }, t.totalProgress = function(e1, t) {
                return arguments.length ? this.totalTime(this.totalDuration() * e1, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
            }, t.progress = function(e1, t) {
                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? e1 : 1 - e1) + yw(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
            }, t.iteration = function(e1, t) {
                var n = this.duration() + this._rDelay;
                return arguments.length ? this.totalTime(this._time + (e1 - 1) * n, t) : this._repeat ? xw(this._tTime, n) + 1 : 1;
            }, t.timeScale = function(e1, t) {
                if (!arguments.length) return -0.00000001 === this._rts ? 0 : this._rts;
                if (this._rts === e1) return this;
                var n = this.parent && this._ts ? bw(this.parent._time, this) : this._tTime;
                return this._rts = +e1 || 0, this._ts = this._ps || -0.00000001 === e1 ? 0 : this._rts, this.totalTime(Uw(-Math.abs(this._delay), this._tDur, n), !1 !== t), ww(this), function(e1) {
                    for(var t = e1.parent; t && t.parent;)t._dirty = 1, t.totalDuration(), t = t.parent;
                    return e1;
                }(this);
            }, t.paused = function(e1) {
                return arguments.length ? (this._ps !== e1 && (this._ps = e1, e1 ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (dE(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== cb && (this._tTime -= cb)))), this) : this._ps;
            }, t.startTime = function(e1) {
                if (arguments.length) {
                    this._start = e1;
                    var t = this.parent || this._dp;
                    return t && (t._sort || !this.parent) && Sw(t, this, e1 - this._delay), this;
                }
                return this._start;
            }, t.endTime = function(e1) {
                return this._start + (xb(e1) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }, t.rawTime = function(e1) {
                var t = this.parent || this._dp;
                return t ? e1 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? bw(t.rawTime(e1), this) : this._tTime : this._tTime;
            }, t.revert = function(e1) {
                void 0 === e1 && (e1 = Hb);
                var t = Vx;
                return Vx = e1, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(e1), this.totalTime(-0.01, e1.suppressEvents)), "nested" !== this.data && !1 !== e1.kill && this.kill(), Vx = t, this;
            }, t.globalTime = function(e1) {
                for(var t = this, n = arguments.length ? e1 : t.rawTime(); t;)n = t._start + n / (Math.abs(t._ts) || 1), t = t._dp;
                return !this.parent && this._sat ? this._sat.globalTime(e1) : n;
            }, t.repeat = function(e1) {
                return arguments.length ? (this._repeat = e1 === 1 / 0 ? -2 : e1, Lw(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }, t.repeatDelay = function(e1) {
                if (arguments.length) {
                    var t = this._time;
                    return this._rDelay = e1, Lw(this), t ? this.time(t) : this;
                }
                return this._rDelay;
            }, t.yoyo = function(e1) {
                return arguments.length ? (this._yoyo = e1, this) : this._yoyo;
            }, t.seek = function(e1, t) {
                return this.totalTime(Ow(this, e1), xb(t));
            }, t.restart = function(e1, t) {
                return this.play().totalTime(e1 ? -this._delay : 0, xb(t));
            }, t.play = function(e1, t) {
                return null != e1 && this.seek(e1, t), this.reversed(!1).paused(!1);
            }, t.reverse = function(e1, t) {
                return null != e1 && this.seek(e1 || this.totalDuration(), t), this.reversed(!0).paused(!1);
            }, t.pause = function(e1, t) {
                return null != e1 && this.seek(e1, t), this.paused(!0);
            }, t.resume = function() {
                return this.paused(!1);
            }, t.reversed = function(e1) {
                return arguments.length ? (!!e1 !== this.reversed() && this.timeScale(-this._rts || (e1 ? -0.00000001 : 0)), this) : this._rts < 0;
            }, t.invalidate = function() {
                return this._initted = this._act = 0, this._zTime = -0.00000001, this;
            }, t.isActive = function() {
                var e1, t = this.parent || this._dp, n = this._start;
                return !(t && !(this._ts && this._initted && t.isActive() && (e1 = t.rawTime(!0)) >= n && e1 < this.endTime(!0) - cb));
            }, t.eventCallback = function(e1, t, n) {
                var i = this.vars;
                return arguments.length > 1 ? (t ? (i[e1] = t, n && (i[e1 + "Params"] = n), "onUpdate" === e1 && (this._onUpdate = t)) : delete i[e1], this) : i[e1];
            }, t.then = function(e1) {
                var t = this;
                return new Promise(function(n) {
                    var i = Ab(e1) ? e1 : lw, r = function() {
                        var e1 = t.then;
                        t.then = null, Ab(i) && (i = i(t)) && (i.then || i === t) && (t.then = e1), n(i), t.then = e1;
                    };
                    t._initted && 1 === t.totalProgress() && t._ts >= 0 || !t._tTime && t._ts < 0 ? r() : t._prom = r;
                });
            }, t.kill = function() {
                $w(this);
            }, e1;
        }();
        cw(TE.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -0.00000001,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var SE = function(e1) {
            function t(t, n) {
                var i;
                return void 0 === t && (t = {}), (i = e1.call(this, t) || this).labels = {}, i.smoothChildTiming = !!t.smoothChildTiming, i.autoRemoveChildren = !!t.autoRemoveChildren, i._sort = xb(t.sortChildren), Wx && Sw(t.parent || Wx, Fx(i), n), t.reversed && i.reverse(), t.paused && i.paused(!0), t.scrollTrigger && Iw(Fx(i), t.scrollTrigger), i;
            }
            Hx(t, e1);
            var n = t.prototype;
            return n.to = function(e1, t, n) {
                return Rw(0, arguments, this), this;
            }, n.from = function(e1, t, n) {
                return Rw(1, arguments, this), this;
            }, n.fromTo = function(e1, t, n, i) {
                return Rw(2, arguments, this), this;
            }, n.set = function(e1, t, n) {
                return t.duration = 0, t.parent = this, pw(t).repeatDelay || (t.repeat = 0), t.immediateRender = !!t.immediateRender, new UE(e1, t, Ow(this, n), 1), this;
            }, n.call = function(e1, t, n) {
                return Sw(this, UE.delayedCall(0, e1, t), n);
            }, n.staggerTo = function(e1, t, n, i, r, a, s) {
                return n.duration = t, n.stagger = n.stagger || i, n.onComplete = a, n.onCompleteParams = s, n.parent = this, new UE(e1, n, Ow(this, r)), this;
            }, n.staggerFrom = function(e1, t, n, i, r, a, s) {
                return n.runBackwards = 1, pw(n).immediateRender = xb(n.immediateRender), this.staggerTo(e1, t, n, i, r, a, s);
            }, n.staggerFromTo = function(e1, t, n, i, r, a, s, o) {
                return i.startAt = n, pw(i).immediateRender = xb(i.immediateRender), this.staggerTo(e1, t, i, r, a, s, o);
            }, n.render = function(e1, t, n) {
                var i, r, a, s, o, l, c, u, h, d, p, f, g = this._time, m = this._dirty ? this.totalDuration() : this._tDur, A = this._dur, M = e1 <= 0 ? 0 : nw(e1), v = this._zTime < 0 != e1 < 0 && (this._initted || !A);
                if (this !== Wx && M > m && e1 >= 0 && (M = m), M !== this._tTime || n || v) {
                    if (g !== this._time && A && (M += this._time - g, e1 += this._time - g), i = M, h = this._start, l = !(u = this._ts), v && (A || (g = this._zTime), (e1 || !t) && (this._zTime = e1)), this._repeat) {
                        if (p = this._yoyo, o = A + this._rDelay, this._repeat < -1 && e1 < 0) return this.totalTime(100 * o + e1, t, n);
                        if (i = nw(M % o), M === m ? (s = this._repeat, i = A) : ((s = ~~(M / o)) && s === M / o && (i = A, s--), i > A && (i = A)), d = xw(this._tTime, o), !g && this._tTime && d !== s && this._tTime - d * o - this._dur <= 0 && (d = s), p && 1 & s && (i = A - i, f = 1), s !== d && !this._lock) {
                            var y = p && 1 & d, x = y === (p && 1 & s);
                            if (s < d && (y = !y), g = y ? 0 : M % A ? A : M, this._lock = 1, this.render(g || (f ? 0 : nw(s * o)), t, !A)._lock = 0, this._tTime = M, !t && this.parent && Jw(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), g && g !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (A = this._dur, m = this._tDur, x && (this._lock = 2, g = y ? A : -0.0001, this.render(g, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            ME(this, f);
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(e1, t, n) {
                        var i;
                        if (n > t) for(i = e1._first; i && i._start <= n;){
                            if ("isPause" === i.data && i._start > t) return i;
                            i = i._next;
                        }
                        else for(i = e1._last; i && i._start >= n;){
                            if ("isPause" === i.data && i._start < t) return i;
                            i = i._prev;
                        }
                    }(this, nw(g), nw(i)), c && (M -= i - (i = c._start))), this._tTime = M, this._time = i, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = e1, g = 0), !g && i && !t && !s && (Jw(this, "onStart"), this._tTime !== M)) return this;
                    if (i >= g && e1 >= 0) for(r = this._first; r;){
                        if (a = r._next, (r._act || i >= r._start) && r._ts && c !== r) {
                            if (r.parent !== this) return this.render(e1, t, n);
                            if (r.render(r._ts > 0 ? (i - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (i - r._start) * r._ts, t, n), i !== this._time || !this._ts && !l) {
                                c = 0, a && (M += this._zTime = -0.00000001);
                                break;
                            }
                        }
                        r = a;
                    }
                    else {
                        r = this._last;
                        for(var b = e1 < 0 ? e1 : i; r;){
                            if (a = r._prev, (r._act || b <= r._end) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(e1, t, n);
                                if (r.render(r._ts > 0 ? (b - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (b - r._start) * r._ts, t, n || Vx && (r._initted || r._startAt)), i !== this._time || !this._ts && !l) {
                                    c = 0, a && (M += this._zTime = b ? -0.00000001 : cb);
                                    break;
                                }
                            }
                            r = a;
                        }
                    }
                    if (c && !t && (this.pause(), c.render(i >= g ? 0 : -0.00000001)._zTime = i >= g ? 1 : -1, this._ts)) return this._start = h, ww(this), this.render(e1, t, n);
                    this._onUpdate && !t && Jw(this, "onUpdate", !0), (M === m && this._tTime >= this.totalDuration() || !M && g) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((e1 || !A) && (M === m && this._ts > 0 || !M && this._ts < 0) && mw(this, 1), t || e1 < 0 && !g || !M && !g && m || (Jw(this, M === m && e1 >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(M < m && this.timeScale() > 0) && this._prom())));
                }
                return this;
            }, n.add = function(e1, t) {
                var n = this;
                if (Mb(t) || (t = Ow(this, t, e1)), !(e1 instanceof TE)) {
                    if (Tb(e1)) return e1.forEach(function(e1) {
                        return n.add(e1, t);
                    }), this;
                    if (mb(e1)) return this.addLabel(e1, t);
                    if (!Ab(e1)) return this;
                    e1 = UE.delayedCall(0, e1);
                }
                return this !== e1 ? Sw(this, e1, t) : this;
            }, n.getChildren = function(e1, t, n, i) {
                void 0 === e1 && (e1 = !0), void 0 === t && (t = !0), void 0 === n && (n = !0), void 0 === i && (i = -lb);
                for(var r = [], a = this._first; a;)a._start >= i && (a instanceof UE ? t && r.push(a) : (n && r.push(a), e1 && r.push.apply(r, a.getChildren(!0, t, n)))), a = a._next;
                return r;
            }, n.getById = function(e1) {
                for(var t = this.getChildren(1, 1, 1), n = t.length; n--;)if (t[n].vars.id === e1) return t[n];
            }, n.remove = function(e1) {
                return mb(e1) ? this.removeLabel(e1) : Ab(e1) ? this.killTweensOf(e1) : (gw(this, e1), e1 === this._recent && (this._recent = this._last), Aw(this));
            }, n.totalTime = function(t, n) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = nw(hE.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts))), e1.prototype.totalTime.call(this, t, n), this._forcing = 0, this) : this._tTime;
            }, n.addLabel = function(e1, t) {
                return this.labels[e1] = Ow(this, t), this;
            }, n.removeLabel = function(e1) {
                return delete this.labels[e1], this;
            }, n.addPause = function(e1, t, n) {
                var i = UE.delayedCall(0, t || kb, n);
                return i.data = "isPause", this._hasPause = 1, Sw(this, i, Ow(this, e1));
            }, n.removePause = function(e1) {
                var t = this._first;
                for(e1 = Ow(this, e1); t;)t._start === e1 && "isPause" === t.data && mw(t), t = t._next;
            }, n.killTweensOf = function(e1, t, n) {
                for(var i = this.getTweensOf(e1, n), r = i.length; r--;)IE !== i[r] && i[r].kill(e1, t);
                return this;
            }, n.getTweensOf = function(e1, t) {
                for(var n, i = [], r = Fw(e1), a = this._first, s = Mb(t); a;)a instanceof UE ? rw(a._targets, r) && (s ? (!IE || a._initted && a._ts) && a.globalTime(0) <= t && a.globalTime(a.totalDuration()) > t : !t || a.isActive()) && i.push(a) : (n = a.getTweensOf(r, t)).length && i.push.apply(i, n), a = a._next;
                return i;
            }, n.tweenTo = function(e1, t) {
                t = t || {};
                var n, i = this, r = Ow(i, e1), a = t, s = a.startAt, o = a.onStart, l = a.onStartParams, c = a.immediateRender, u = UE.to(i, cw({
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: r,
                    overwrite: "auto",
                    duration: t.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale()) || cb,
                    onStart: function() {
                        if (i.pause(), !n) {
                            var e1 = t.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale());
                            u._dur !== e1 && Cw(u, e1, 0, 1).render(u._time, !0, !0), n = 1;
                        }
                        o && o.apply(u, l || []);
                    }
                }, t));
                return c ? u.render(0) : u;
            }, n.tweenFromTo = function(e1, t, n) {
                return this.tweenTo(t, cw({
                    startAt: {
                        time: Ow(this, e1)
                    }
                }, n));
            }, n.recent = function() {
                return this._recent;
            }, n.nextLabel = function(e1) {
                return void 0 === e1 && (e1 = this._time), Kw(this, Ow(this, e1));
            }, n.previousLabel = function(e1) {
                return void 0 === e1 && (e1 = this._time), Kw(this, Ow(this, e1), 1);
            }, n.currentLabel = function(e1) {
                return arguments.length ? this.seek(e1, !0) : this.previousLabel(this._time + cb);
            }, n.shiftChildren = function(e1, t, n) {
                void 0 === n && (n = 0);
                for(var i, r = this._first, a = this.labels; r;)r._start >= n && (r._start += e1, r._end += e1), r = r._next;
                if (t) for(i in a)a[i] >= n && (a[i] += e1);
                return Aw(this);
            }, n.invalidate = function(t) {
                var n = this._first;
                for(this._lock = 0; n;)n.invalidate(t), n = n._next;
                return e1.prototype.invalidate.call(this, t);
            }, n.clear = function(e1) {
                void 0 === e1 && (e1 = !0);
                for(var t, n = this._first; n;)t = n._next, this.remove(n), n = t;
                return this._dp && (this._time = this._tTime = this._pTime = 0), e1 && (this.labels = {}), Aw(this);
            }, n.totalDuration = function(e1) {
                var t, n, i, r = 0, a = this, s = a._last, o = lb;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -e1 : e1));
                if (a._dirty) {
                    for(i = a.parent; s;)t = s._prev, s._dirty && s.totalDuration(), (n = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, Sw(a, s, n - s._delay, 1)._lock = 0) : o = n, n < 0 && s._ts && (r -= n, (!i && !a._dp || i && i.smoothChildTiming) && (a._start += n / a._ts, a._time -= n, a._tTime -= n), a.shiftChildren(-n, !1, -Infinity), o = 0), s._end > r && s._ts && (r = s._end), s = t;
                    Cw(a, a === Wx && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
                }
                return a._tDur;
            }, t.updateRoot = function(e1) {
                if (Wx._ts && (sw(Wx, bw(e1, Wx)), Kx = hE.frame), hE.frame >= Xb) {
                    Xb += sb.autoSleep || 120;
                    var t = Wx._first;
                    if ((!t || !t._ts) && sb.autoSleep && hE._listeners.length < 2) {
                        for(; t && !t._ts;)t = t._next;
                        t || hE.sleep();
                    }
                }
            }, t;
        }(TE);
        cw(SE.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var IE, NE, DE = function(e1, t, n, i, r, a, s) {
            var o, l, c, u, h, d, p, f, g = new KE(this._pt, e1, t, 0, 1, QE, null, r), m = 0, A = 0;
            for(g.b = n, g.e = i, n += "", (p = ~(i += "").indexOf("random(")) && (i = Zw(i)), a && (a(f = [
                n,
                i
            ], e1, t), n = f[0], i = f[1]), l = n.match(Db) || []; o = Db.exec(i);)u = o[0], h = i.substring(m, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[A++] && (d = parseFloat(l[A - 1]) || 0, g._pt = {
                _next: g._pt,
                p: h || 1 === A ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? iw(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, m = Db.lastIndex);
            return g.c = m < i.length ? i.substring(m, i.length) : "", g.fp = s, (_b.test(i) || p) && (g.e = 0), this._pt = g, g;
        }, _E = function(e1, t, n, i, r, a, s, o, l, c) {
            Ab(i) && (i = i(r || 0, e1, a));
            var u, h = e1[t], d = "get" !== n ? n : Ab(h) ? l ? e1[t.indexOf("set") || !Ab(e1["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e1[t]() : h, p = Ab(h) ? l ? BE : kE : jE;
            if (mb(i) && (~i.indexOf("random(") && (i = Zw(i)), "=" === i.charAt(1) && ((u = iw(d, i) + (jw(d) || 0)) || 0 === u) && (i = u)), !c || d !== i || NE) return isNaN(d * i) || "" === i ? (!h && !(t in e1) && Pb(t, i), DE.call(this, e1, t, d, i, p, o || sb.stringFilter, l)) : (u = new KE(this._pt, e1, t, +d || 0, i - (d || 0), "boolean" == typeof h ? VE : GE, 0, p), l && (u.fp = l), s && u.modifier(s, this, e1), this._pt = u);
        }, CE = function(e1, t, n, i, r, a) {
            var s, o, l, c;
            if (Wb[e1] && !1 !== (s = new Wb[e1]).init(r, s.rawVars ? t[e1] : function(e1, t, n, i, r) {
                if (Ab(e1) && (e1 = OE(e1, r, t, n, i)), !yb(e1) || e1.style && e1.nodeType || Tb(e1) || Eb(e1)) return mb(e1) ? OE(e1, r, t, n, i) : e1;
                var a, s = {};
                for(a in e1)s[a] = OE(e1[a], r, t, n, i);
                return s;
            }(t[e1], i, r, a, n), n, i, a) && (n._pt = o = new KE(n._pt, r, e1, 0, 1, s.render, s, 0, s.priority), n !== Jx)) for(l = n._ptLookup[n._targets.indexOf(r)], c = s._props.length; c--;)l[s._props[c]] = o;
            return s;
        }, LE = function e1(t, n, i) {
            var r, a, s, o, l, c, u, h, d, p, f, g, m, A = t.vars, M = A.ease, v = A.startAt, y = A.immediateRender, x = A.lazy, b = A.onUpdate, w = A.runBackwards, E = A.yoyoEase, T = A.keyframes, S = A.autoRevert, I = t._dur, N = t._startAt, D = t._targets, _ = t.parent, C = _ && "nested" === _.data ? _.vars.targets : D, L = "auto" === t._overwrite && !Gx, z = t.timeline;
            if (z && (!T || !M) && (M = "none"), t._ease = vE(M, ob.ease), t._yEase = E ? AE(vE(!0 === E ? M : E, ob.ease)) : 0, E && t._yoyo && !t._repeat && (E = t._yEase, t._yEase = t._ease, t._ease = E), t._from = !z && !!A.runBackwards, !z || T && !A.stagger) {
                if (g = (h = D[0] ? Jb(D[0]).harness : 0) && A[h.prop], r = dw(A, Gb), N && (N._zTime < 0 && N.progress(1), n < 0 && w && y && !S ? N.render(-1, !0) : N.revert(w && I ? Fb : Bb), N._lazy = 0), v) {
                    if (mw(t._startAt = UE.set(D, cw({
                        data: "isStart",
                        overwrite: !1,
                        parent: _,
                        immediateRender: !0,
                        lazy: !N && xb(x),
                        startAt: null,
                        delay: 0,
                        onUpdate: b && function() {
                            return Jw(t, "onUpdate");
                        },
                        stagger: 0
                    }, v))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (Vx || !y && !S) && t._startAt.revert(Fb), y && I && n <= 0 && i <= 0) return void (n && (t._zTime = n));
                } else if (w && I && !N) {
                    if (n && (y = !1), s = cw({
                        overwrite: !1,
                        data: "isFromStart",
                        lazy: y && !N && xb(x),
                        immediateRender: y,
                        stagger: 0,
                        parent: _
                    }, r), g && (s[h.prop] = g), mw(t._startAt = UE.set(D, s)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (Vx ? t._startAt.revert(Fb) : t._startAt.render(-1, !0)), t._zTime = n, y) {
                        if (!n) return;
                    } else e1(t._startAt, cb, cb);
                }
                for(t._pt = t._ptCache = 0, x = I && xb(x) || x && !I, a = 0; a < D.length; a++){
                    if (u = (l = D[a])._gsap || Kb(D)[a]._gsap, t._ptLookup[a] = p = {}, Qb[u.id] && Vb.length && aw(), f = C === D ? a : C.indexOf(l), h && !1 !== (d = new h).init(l, g || r, t, f, C) && (t._pt = o = new KE(t._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach(function(e1) {
                        p[e1] = o;
                    }), d.priority && (c = 1)), !h || g) for(s in r)Wb[s] && (d = CE(s, r, t, f, l, C)) ? d.priority && (c = 1) : p[s] = o = _E.call(t, l, s, "get", r[s], f, C, 0, A.stringFilter);
                    t._op && t._op[a] && t.kill(l, t._op[a]), L && t._pt && (IE = t, Wx.killTweensOf(l, p, t.globalTime(n)), m = !t.parent, IE = 0), t._pt && x && (Qb[u.id] = 1);
                }
                c && qE(t), t._onInit && t._onInit(t);
            }
            t._onUpdate = b, t._initted = (!t._op || t._pt) && !m, T && n <= 0 && z.render(lb, !0, !0);
        }, zE = function(e1, t, n, i) {
            var r, a, s = t.ease || i || "power1.inOut";
            if (Tb(t)) a = n[e1] || (n[e1] = []), t.forEach(function(e1, n) {
                return a.push({
                    t: n / (t.length - 1) * 100,
                    v: e1,
                    e: s
                });
            });
            else for(r in t)a = n[r] || (n[r] = []), "ease" === r || a.push({
                t: parseFloat(e1),
                v: t[r],
                e: s
            });
        }, OE = function(e1, t, n, i, r) {
            return Ab(e1) ? e1.call(t, n, i, r) : mb(e1) && ~e1.indexOf("random(") ? Zw(e1) : e1;
        }, RE = qb + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", PE = {};
        ew(RE + ",id,stagger,delay,duration,paused,scrollTrigger", function(e1) {
            return PE[e1] = 1;
        });
        var UE = function(e1) {
            function t(t, n, i, r) {
                var a;
                "number" == typeof n && (i.duration = n, n = i, i = null);
                var s, o, l, c, u, h, d, p, f = (a = e1.call(this, r ? n : pw(n)) || this).vars, g = f.duration, m = f.delay, A = f.immediateRender, M = f.stagger, v = f.overwrite, y = f.keyframes, x = f.defaults, b = f.scrollTrigger, w = f.yoyoEase, E = n.parent || Wx, T = (Tb(t) || Eb(t) ? Mb(t[0]) : "length" in n) ? [
                    t
                ] : Fw(t);
                if (a._targets = T.length ? Kb(T) : Ub("GSAP target " + t + " not found. https://gsap.com", !sb.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = v, y || M || wb(g) || wb(m)) {
                    if (n = a.vars, (s = a.timeline = new SE({
                        data: "nested",
                        defaults: x || {},
                        targets: E && "nested" === E.data ? E.vars.targets : T
                    })).kill(), s.parent = s._dp = Fx(a), s._start = 0, M || wb(g) || wb(m)) {
                        if (c = T.length, d = M && Vw(M), yb(M)) for(u in M)~RE.indexOf(u) && (p || (p = {}), p[u] = M[u]);
                        for(o = 0; o < c; o++)(l = dw(n, PE)).stagger = 0, w && (l.yoyoEase = w), p && uw(l, p), h = T[o], l.duration = +OE(g, Fx(a), o, h, T), l.delay = (+OE(m, Fx(a), o, h, T) || 0) - a._delay, !M && 1 === c && l.delay && (a._delay = m = l.delay, a._start += m, l.delay = 0), s.to(h, l, d ? d(o, h, T) : 0), s._ease = pE.none;
                        s.duration() ? g = m = 0 : a.timeline = 0;
                    } else if (y) {
                        pw(cw(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = vE(y.ease || n.ease || "none");
                        var S, I, N, D = 0;
                        if (Tb(y)) y.forEach(function(e1) {
                            return s.to(T, e1, ">");
                        }), s.duration();
                        else {
                            for(u in l = {}, y)"ease" === u || "easeEach" === u || zE(u, y[u], l, y.easeEach);
                            for(u in l)for(S = l[u].sort(function(e1, t) {
                                return e1.t - t.t;
                            }), D = 0, o = 0; o < S.length; o++)(N = {
                                ease: (I = S[o]).e,
                                duration: (I.t - (o ? S[o - 1].t : 0)) / 100 * g
                            })[u] = I.v, s.to(T, N, D), D += N.duration;
                            s.duration() < g && s.to({}, {
                                duration: g - s.duration()
                            });
                        }
                    }
                    g || a.duration(g = s.duration());
                } else a.timeline = 0;
                return !0 !== v || Gx || (IE = Fx(a), Wx.killTweensOf(T), IE = 0), Sw(E, Fx(a), i), n.reversed && a.reverse(), n.paused && a.paused(!0), (A || !g && !y && a._start === nw(E._time) && xb(A) && vw(Fx(a)) && "nested" !== E.data) && (a._tTime = -0.00000001, a.render(Math.max(0, -m) || 0)), b && Iw(Fx(a), b), a;
            }
            Hx(t, e1);
            var n = t.prototype;
            return n.render = function(e1, t, n) {
                var i, r, a, s, o, l, c, u, h, d = this._time, p = this._tDur, f = this._dur, g = e1 < 0, m = e1 > p - cb && !g ? p : e1 < cb ? 0 : e1;
                if (f) {
                    if (m !== this._tTime || !e1 || n || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== g) {
                        if (i = m, u = this.timeline, this._repeat) {
                            if (s = f + this._rDelay, this._repeat < -1 && g) return this.totalTime(100 * s + e1, t, n);
                            if (i = nw(m % s), m === p ? (a = this._repeat, i = f) : ((a = ~~(m / s)) && a === nw(m / s) && (i = f, a--), i > f && (i = f)), (l = this._yoyo && 1 & a) && (h = this._yEase, i = f - i), o = xw(this._tTime, s), i === d && !n && this._initted && a === o) return this._tTime = m, this;
                            a !== o && (u && this._yEase && ME(u, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== s && this._initted && (this._lock = n = 1, this.render(nw(s * a), !0).invalidate()._lock = 0));
                        }
                        if (!this._initted) {
                            if (Nw(this, g ? e1 : i, n, t, m)) return this._tTime = 0, this;
                            if (!(d === this._time || n && this.vars.repeatRefresh && a !== o)) return this;
                            if (f !== this._dur) return this.render(e1, t, n);
                        }
                        if (this._tTime = m, this._time = i, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(i / f), this._from && (this.ratio = c = 1 - c), i && !d && !t && !a && (Jw(this, "onStart"), this._tTime !== m)) return this;
                        for(r = this._pt; r;)r.r(c, r.d), r = r._next;
                        u && u.render(e1 < 0 ? e1 : u._dur * u._ease(i / this._dur), t, n) || this._startAt && (this._zTime = e1), this._onUpdate && !t && (g && Mw(this, e1, 0, n), Jw(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !t && this.parent && Jw(this, "onRepeat"), m !== this._tDur && m || this._tTime !== m || (g && !this._onUpdate && Mw(this, e1, 0, !0), (e1 || !f) && (m === this._tDur && this._ts > 0 || !m && this._ts < 0) && mw(this, 1), t || g && !d || !(m || d || l) || (Jw(this, m === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < p && this.timeScale() > 0) && this._prom()));
                    }
                } else !function(e1, t, n, i) {
                    var r, a, s, o = e1.ratio, l = t < 0 || !t && (!e1._start && Dw(e1) && (e1._initted || !_w(e1)) || (e1._ts < 0 || e1._dp._ts < 0) && !_w(e1)) ? 0 : 1, c = e1._rDelay, u = 0;
                    if (c && e1._repeat && (u = Uw(0, e1._tDur, t), a = xw(u, c), e1._yoyo && 1 & a && (l = 1 - l), a !== xw(e1._tTime, c) && (o = 1 - l, e1.vars.repeatRefresh && e1._initted && e1.invalidate())), l !== o || Vx || i || e1._zTime === cb || !t && e1._zTime) {
                        if (!e1._initted && Nw(e1, t, i, n, u)) return;
                        for(s = e1._zTime, e1._zTime = t || (n ? cb : 0), n || (n = t && !s), e1.ratio = l, e1._from && (l = 1 - l), e1._time = 0, e1._tTime = u, r = e1._pt; r;)r.r(l, r.d), r = r._next;
                        t < 0 && Mw(e1, t, 0, !0), e1._onUpdate && !n && Jw(e1, "onUpdate"), u && e1._repeat && !n && e1.parent && Jw(e1, "onRepeat"), (t >= e1._tDur || t < 0) && e1.ratio === l && (l && mw(e1, 1), n || Vx || (Jw(e1, l ? "onComplete" : "onReverseComplete", !0), e1._prom && e1._prom()));
                    } else e1._zTime || (e1._zTime = t);
                }(this, e1, t, n);
                return this;
            }, n.targets = function() {
                return this._targets;
            }, n.invalidate = function(t) {
                return (!t || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(t), e1.prototype.invalidate.call(this, t);
            }, n.resetTo = function(e1, t, n, i, r) {
                $x || hE.wake(), this._ts || this.play();
                var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || LE(this, a), function(e1, t, n, i, r, a, s, o) {
                    var l, c, u, h, d = (e1._pt && e1._ptCache || (e1._ptCache = {}))[t];
                    if (!d) for(d = e1._ptCache[t] = [], u = e1._ptLookup, h = e1._targets.length; h--;){
                        if ((l = u[h][t]) && l.d && l.d._pt) for(l = l.d._pt; l && l.p !== t && l.fp !== t;)l = l._next;
                        if (!l) return NE = 1, e1.vars[t] = "+=0", LE(e1, s), NE = 0, o ? Ub(t + " not eligible for reset") : 1;
                        d.push(l);
                    }
                    for(h = d.length; h--;)(l = (c = d[h])._pt || c).s = !i && 0 !== i || r ? l.s + (i || 0) + a * l.c : i, l.c = n - l.s, c.e && (c.e = tw(n) + jw(c.e)), c.b && (c.b = l.s + jw(c.b));
                }(this, e1, t, n, i, this._ease(a / this._dur), a, r) ? this.resetTo(e1, t, n, i, 1) : (Ew(this, 0), this.parent || fw(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
            }, n.kill = function(e1, t) {
                if (void 0 === t && (t = "all"), !(e1 || t && "all" !== t)) return this._lazy = this._pt = 0, this.parent ? $w(this) : this;
                if (this.timeline) {
                    var n = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(e1, t, IE && !0 !== IE.vars.overwrite)._first || $w(this), this.parent && n !== this.timeline.totalDuration() && Cw(this, this._dur * this.timeline._tDur / n, 0, 1), this;
                }
                var i, r, a, s, o, l, c, u = this._targets, h = e1 ? Fw(e1) : u, d = this._ptLookup, p = this._pt;
                if ((!t || "all" === t) && function(e1, t) {
                    for(var n = e1.length, i = n === t.length; i && n-- && e1[n] === t[n];);
                    return n < 0;
                }(u, h)) return "all" === t && (this._pt = 0), $w(this);
                for(i = this._op = this._op || [], "all" !== t && (mb(t) && (o = {}, ew(t, function(e1) {
                    return o[e1] = 1;
                }), t = o), t = function(e1, t) {
                    var n, i, r, a, s = e1[0] ? Jb(e1[0]).harness : 0, o = s && s.aliases;
                    if (!o) return t;
                    for(i in n = uw({}, t), o)if (i in n) for(r = (a = o[i].split(",")).length; r--;)n[a[r]] = n[i];
                    return n;
                }(u, t)), c = u.length; c--;)if (~h.indexOf(u[c])) for(o in r = d[c], "all" === t ? (i[c] = t, s = r, a = {}) : (a = i[c] = i[c] || {}, s = t), s)(l = r && r[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || gw(this, l, "_pt"), delete r[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && $w(this), this;
            }, t.to = function(e1, n) {
                return new t(e1, n, arguments[2]);
            }, t.from = function(e1, t) {
                return Rw(1, arguments);
            }, t.delayedCall = function(e1, n, i, r) {
                return new t(n, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: e1,
                    onComplete: n,
                    onReverseComplete: n,
                    onCompleteParams: i,
                    onReverseCompleteParams: i,
                    callbackScope: r
                });
            }, t.fromTo = function(e1, t, n) {
                return Rw(2, arguments);
            }, t.set = function(e1, n) {
                return n.duration = 0, n.repeatDelay || (n.repeat = 0), new t(e1, n);
            }, t.killTweensOf = function(e1, t, n) {
                return Wx.killTweensOf(e1, t, n);
            }, t;
        }(TE);
        cw(UE.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), ew("staggerTo,staggerFrom,staggerFromTo", function(e1) {
            UE[e1] = function() {
                var t = new SE, n = kw.call(arguments, 0);
                return n.splice("staggerFromTo" === e1 ? 5 : 4, 0, 0), t[e1].apply(t, n);
            };
        });
        var jE = function(e1, t, n) {
            return e1[t] = n;
        }, kE = function(e1, t, n) {
            return e1[t](n);
        }, BE = function(e1, t, n, i) {
            return e1[t](i.fp, n);
        }, FE = function(e1, t, n) {
            return e1.setAttribute(t, n);
        }, HE = function(e1, t) {
            return Ab(e1[t]) ? kE : vb(e1[t]) && e1.setAttribute ? FE : jE;
        }, GE = function(e1, t) {
            return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e1)) / 1e6, t);
        }, VE = function(e1, t) {
            return t.set(t.t, t.p, !!(t.s + t.c * e1), t);
        }, QE = function(e1, t) {
            var n = t._pt, i = "";
            if (!e1 && t.b) i = t.b;
            else if (1 === e1 && t.e) i = t.e;
            else {
                for(; n;)i = n.p + (n.m ? n.m(n.s + n.c * e1) : Math.round(1e4 * (n.s + n.c * e1)) / 1e4) + i, n = n._next;
                i += t.c;
            }
            t.set(t.t, t.p, i, t);
        }, WE = function(e1, t) {
            for(var n = t._pt; n;)n.r(e1, n.d), n = n._next;
        }, YE = function(e1, t, n, i) {
            for(var r, a = this._pt; a;)r = a._next, a.p === i && a.modifier(e1, t, n), a = r;
        }, XE = function(e1) {
            for(var t, n, i = this._pt; i;)n = i._next, i.p === e1 && !i.op || i.op === e1 ? gw(this, i, "_pt") : i.dep || (t = 1), i = n;
            return !t;
        }, ZE = function(e1, t, n, i) {
            i.mSet(e1, t, i.m.call(i.tween, n, i.mt), i);
        }, qE = function(e1) {
            for(var t, n, i, r, a = e1._pt; a;){
                for(t = a._next, n = i; n && n.pr > a.pr;)n = n._next;
                (a._prev = n ? n._prev : r) ? a._prev._next = a : i = a, (a._next = n) ? n._prev = a : r = a, a = t;
            }
            e1._pt = i;
        }, KE = function() {
            function e1(e1, t, n, i, r, a, s, o, l) {
                this.t = t, this.s = i, this.c = r, this.p = n, this.r = a || GE, this.d = s || this, this.set = o || jE, this.pr = l || 0, this._next = e1, e1 && (e1._prev = this);
            }
            return e1.prototype.modifier = function(e1, t, n) {
                this.mSet = this.mSet || this.set, this.set = ZE, this.m = e1, this.mt = n, this.tween = t;
            }, e1;
        }();
        ew(qb + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e1) {
            return Gb[e1] = 1;
        }), zb.TweenMax = zb.TweenLite = UE, zb.TimelineLite = zb.TimelineMax = SE, Wx = new SE({
            sortChildren: !1,
            defaults: ob,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), sb.stringFilter = uE;
        var JE = [], $E = {}, eT = [], tT = 0, nT = 0, iT = function(e1) {
            return ($E[e1] || eT).map(function(e1) {
                return e1();
            });
        }, rT = function() {
            var e1 = Date.now(), t = [];
            e1 - tT > 2 && (iT("matchMediaInit"), JE.forEach(function(e1) {
                var n, i, r, a, s = e1.queries, o = e1.conditions;
                for(i in s)(n = Yx.matchMedia(s[i]).matches) && (r = 1), n !== o[i] && (o[i] = n, a = 1);
                a && (e1.revert(), r && t.push(e1));
            }), iT("matchMediaRevert"), t.forEach(function(e1) {
                return e1.onMatch(e1, function(t) {
                    return e1.add(null, t);
                });
            }), tT = e1, iT("matchMedia"));
        }, aT = function() {
            function e1(e1, t) {
                this.selector = t && Hw(t), this.data = [], this._r = [], this.isReverted = !1, this.id = nT++, e1 && this.add(e1);
            }
            var t = e1.prototype;
            return t.add = function(e1, t, n) {
                Ab(e1) && (n = t, t = e1, e1 = Ab);
                var i = this, r = function() {
                    var e1, r = Qx, a = i.selector;
                    return r && r !== i && r.data.push(i), n && (i.selector = Hw(n)), Qx = i, e1 = t.apply(i, arguments), Ab(e1) && i._r.push(e1), Qx = r, i.selector = a, i.isReverted = !1, e1;
                };
                return i.last = r, e1 === Ab ? r(i, function(e1) {
                    return i.add(null, e1);
                }) : e1 ? i[e1] = r : r;
            }, t.ignore = function(e1) {
                var t = Qx;
                Qx = null, e1(this), Qx = t;
            }, t.getTweens = function() {
                var t = [];
                return this.data.forEach(function(n) {
                    return n instanceof e1 ? t.push.apply(t, n.getTweens()) : n instanceof UE && !(n.parent && "nested" === n.parent.data) && t.push(n);
                }), t;
            }, t.clear = function() {
                this._r.length = this.data.length = 0;
            }, t.kill = function(e1, t) {
                var n = this;
                if (e1 ? function() {
                    for(var t, i = n.getTweens(), r = n.data.length; r--;)"isFlip" === (t = n.data[r]).data && (t.revert(), t.getChildren(!0, !0, !1).forEach(function(e1) {
                        return i.splice(i.indexOf(e1), 1);
                    }));
                    for(i.map(function(e1) {
                        return {
                            g: e1._dur || e1._delay || e1._sat && !e1._sat.vars.immediateRender ? e1.globalTime(0) : -1 / 0,
                            t: e1
                        };
                    }).sort(function(e1, t) {
                        return t.g - e1.g || -1 / 0;
                    }).forEach(function(t) {
                        return t.t.revert(e1);
                    }), r = n.data.length; r--;)(t = n.data[r]) instanceof SE ? "nested" !== t.data && (t.scrollTrigger && t.scrollTrigger.revert(), t.kill()) : !(t instanceof UE) && t.revert && t.revert(e1);
                    n._r.forEach(function(t) {
                        return t(e1, n);
                    }), n.isReverted = !0;
                }() : this.data.forEach(function(e1) {
                    return e1.kill && e1.kill();
                }), this.clear(), t) for(var i = JE.length; i--;)JE[i].id === this.id && JE.splice(i, 1);
            }, t.revert = function(e1) {
                this.kill(e1 || {});
            }, e1;
        }(), sT = function() {
            function e1(e1) {
                this.contexts = [], this.scope = e1, Qx && Qx.data.push(this);
            }
            var t = e1.prototype;
            return t.add = function(e1, t, n) {
                yb(e1) || (e1 = {
                    matches: e1
                });
                var i, r, a, s = new aT(0, n || this.scope), o = s.conditions = {};
                for(r in Qx && !s.selector && (s.selector = Qx.selector), this.contexts.push(s), t = s.add("onMatch", t), s.queries = e1, e1)"all" === r ? a = 1 : (i = Yx.matchMedia(e1[r])) && (JE.indexOf(s) < 0 && JE.push(s), (o[r] = i.matches) && (a = 1), i.addListener ? i.addListener(rT) : i.addEventListener("change", rT));
                return a && t(s, function(e1) {
                    return s.add(null, e1);
                }), this;
            }, t.revert = function(e1) {
                this.kill(e1 || {});
            }, t.kill = function(e1) {
                this.contexts.forEach(function(t) {
                    return t.kill(e1, !0);
                });
            }, e1;
        }(), oT = {
            registerPlugin: function() {
                for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                t.forEach(function(e1) {
                    return tE(e1);
                });
            },
            timeline: function(e1) {
                return new SE(e1);
            },
            getTweensOf: function(e1, t) {
                return Wx.getTweensOf(e1, t);
            },
            getProperty: function(e1, t, n, i) {
                mb(e1) && (e1 = Fw(e1)[0]);
                var r = Jb(e1 || {}).get, a = n ? lw : ow;
                return "native" === n && (n = ""), e1 ? t ? a((Wb[t] && Wb[t].get || r)(e1, t, n, i)) : function(t, n, i) {
                    return a((Wb[t] && Wb[t].get || r)(e1, t, n, i));
                } : e1;
            },
            quickSetter: function(e1, t, n) {
                if ((e1 = Fw(e1)).length > 1) {
                    var i = e1.map(function(e1) {
                        return uT.quickSetter(e1, t, n);
                    }), r = i.length;
                    return function(e1) {
                        for(var t = r; t--;)i[t](e1);
                    };
                }
                e1 = e1[0] || {};
                var a = Wb[t], s = Jb(e1), o = s.harness && (s.harness.aliases || {})[t] || t, l = a ? function(t) {
                    var i = new a;
                    Jx._pt = 0, i.init(e1, n ? t + n : t, Jx, 0, [
                        e1
                    ]), i.render(1, i), Jx._pt && WE(1, Jx);
                } : s.set(e1, o);
                return a ? l : function(t) {
                    return l(e1, o, n ? t + n : t, s, 1);
                };
            },
            quickTo: function(e1, t, n) {
                var i, r = uT.to(e1, uw(((i = {})[t] = "+=0.1", i.paused = !0, i), n || {})), a = function(e1, n, i) {
                    return r.resetTo(t, e1, n, i);
                };
                return a.tween = r, a;
            },
            isTweening: function(e1) {
                return Wx.getTweensOf(e1, !0).length > 0;
            },
            defaults: function(e1) {
                return e1 && e1.ease && (e1.ease = vE(e1.ease, ob.ease)), hw(ob, e1 || {});
            },
            config: function(e1) {
                return hw(sb, e1 || {});
            },
            registerEffect: function(e1) {
                var t = e1.name, n = e1.effect, i = e1.plugins, r = e1.defaults, a = e1.extendTimeline;
                (i || "").split(",").forEach(function(e1) {
                    return e1 && !Wb[e1] && !zb[e1] && Ub(t + " effect requires " + e1 + " plugin.");
                }), Yb[t] = function(e1, t, i) {
                    return n(Fw(e1), cw(t || {}, r), i);
                }, a && (SE.prototype[t] = function(e1, n, i) {
                    return this.add(Yb[t](e1, yb(n) ? n : (i = n) && {}, this), i);
                });
            },
            registerEase: function(e1, t) {
                pE[e1] = vE(t);
            },
            parseEase: function(e1, t) {
                return arguments.length ? vE(e1, t) : pE;
            },
            getById: function(e1) {
                return Wx.getById(e1);
            },
            exportRoot: function(e1, t) {
                void 0 === e1 && (e1 = {});
                var n, i, r = new SE(e1);
                for(r.smoothChildTiming = xb(e1.smoothChildTiming), Wx.remove(r), r._dp = 0, r._time = r._tTime = Wx._time, n = Wx._first; n;)i = n._next, !t && !n._dur && n instanceof UE && n.vars.onComplete === n._targets[0] || Sw(r, n, n._start - n._delay), n = i;
                return Sw(Wx, r, 0), r;
            },
            context: function(e1, t) {
                return e1 ? new aT(e1, t) : Qx;
            },
            matchMedia: function(e1) {
                return new sT(e1);
            },
            matchMediaRefresh: function() {
                return JE.forEach(function(e1) {
                    var t, n, i = e1.conditions;
                    for(n in i)i[n] && (i[n] = !1, t = 1);
                    t && e1.revert();
                }) || rT();
            },
            addEventListener: function(e1, t) {
                var n = $E[e1] || ($E[e1] = []);
                ~n.indexOf(t) || n.push(t);
            },
            removeEventListener: function(e1, t) {
                var n = $E[e1], i = n && n.indexOf(t);
                i >= 0 && n.splice(i, 1);
            },
            utils: {
                wrap: function e1(t, n, i) {
                    var r = n - t;
                    return Tb(t) ? Xw(t, e1(0, t.length), n) : Pw(i, function(e1) {
                        return (r + (e1 - t) % r) % r + t;
                    });
                },
                wrapYoyo: function e1(t, n, i) {
                    var r = n - t, a = 2 * r;
                    return Tb(t) ? Xw(t, e1(0, t.length - 1), n) : Pw(i, function(e1) {
                        return t + ((e1 = (a + (e1 - t) % a) % a || 0) > r ? a - e1 : e1);
                    });
                },
                distribute: Vw,
                random: Yw,
                snap: Ww,
                normalize: function(e1, t, n) {
                    return qw(e1, t, 0, 1, n);
                },
                getUnit: jw,
                clamp: function(e1, t, n) {
                    return Pw(n, function(n) {
                        return Uw(e1, t, n);
                    });
                },
                splitColor: aE,
                toArray: Fw,
                selector: Hw,
                mapRange: qw,
                pipe: function() {
                    for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                    return function(e1) {
                        return t.reduce(function(e1, t) {
                            return t(e1);
                        }, e1);
                    };
                },
                unitize: function(e1, t) {
                    return function(n) {
                        return e1(parseFloat(n)) + (t || jw(n));
                    };
                },
                interpolate: function e1(t, n, i, r) {
                    var a = isNaN(t + n) ? 0 : function(e1) {
                        return (1 - e1) * t + e1 * n;
                    };
                    if (!a) {
                        var s, o, l, c, u, h = mb(t), d = {};
                        if (!0 === i && (r = 1) && (i = null), h) t = {
                            p: t
                        }, n = {
                            p: n
                        };
                        else if (Tb(t) && !Tb(n)) {
                            for(l = [], c = t.length, u = c - 2, o = 1; o < c; o++)l.push(e1(t[o - 1], t[o]));
                            c--, a = function(e1) {
                                e1 *= c;
                                var t = Math.min(u, ~~e1);
                                return l[t](e1 - t);
                            }, i = n;
                        } else r || (t = uw(Tb(t) ? [] : {}, t));
                        if (!l) {
                            for(s in n)_E.call(d, t, s, "get", n[s]);
                            a = function(e1) {
                                return WE(e1, d) || (h ? t.p : t);
                            };
                        }
                    }
                    return Pw(i, a);
                },
                shuffle: Gw
            },
            install: Rb,
            effects: Yb,
            ticker: hE,
            updateRoot: SE.updateRoot,
            plugins: Wb,
            globalTimeline: Wx,
            core: {
                PropTween: KE,
                globals: jb,
                Tween: UE,
                Timeline: SE,
                Animation: TE,
                getCache: Jb,
                _removeLinkedListItem: gw,
                reverting: function() {
                    return Vx;
                },
                context: function(e1) {
                    return e1 && Qx && (Qx.data.push(e1), e1._ctx = Qx), Qx;
                },
                suppressOverwrites: function(e1) {
                    return Gx = e1;
                }
            }
        };
        ew("to,from,fromTo,delayedCall,set,killTweensOf", function(e1) {
            return oT[e1] = UE[e1];
        }), hE.add(SE.updateRoot), Jx = oT.to({}, {
            duration: 0
        });
        var lT = function(e1, t) {
            for(var n = e1._pt; n && n.p !== t && n.op !== t && n.fp !== t;)n = n._next;
            return n;
        }, cT = function(e1, t) {
            return {
                name: e1,
                rawVars: 1,
                init: function(e1, n, i) {
                    i._onInit = function(e1) {
                        var i, r;
                        if (mb(n) && (i = {}, ew(n, function(e1) {
                            return i[e1] = 1;
                        }), n = i), t) {
                            for(r in i = {}, n)i[r] = t(n[r]);
                            n = i;
                        }
                        !function(e1, t) {
                            var n, i, r, a = e1._targets;
                            for(n in t)for(i = a.length; i--;)(r = e1._ptLookup[i][n]) && (r = r.d) && (r._pt && (r = lT(r, n)), r && r.modifier && r.modifier(t[n], e1, a[i], n));
                        }(e1, n);
                    };
                }
            };
        }, uT = oT.registerPlugin({
            name: "attr",
            init: function(e1, t, n, i, r) {
                var a, s, o;
                for(a in this.tween = n, t)o = e1.getAttribute(a) || "", (s = this.add(e1, "setAttribute", (o || 0) + "", t[a], i, r, 0, 0, a)).op = a, s.b = o, this._props.push(a);
            },
            render: function(e1, t) {
                for(var n = t._pt; n;)Vx ? n.set(n.t, n.p, n.b, n) : n.r(e1, n.d), n = n._next;
            }
        }, {
            name: "endArray",
            init: function(e1, t) {
                for(var n = t.length; n--;)this.add(e1, n, e1[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
            }
        }, cT("roundProps", Qw), cT("modifiers"), cT("snap", Ww)) || oT;
        UE.version = SE.version = uT.version = "3.12.5", qx = 1, bb() && dE(), pE.Power0, pE.Power1, pE.Power2, pE.Power3, pE.Power4, pE.Linear, pE.Quad, pE.Cubic, pE.Quart, pE.Quint, pE.Strong, pE.Elastic, pE.Back, pE.SteppedEase, pE.Bounce, pE.Sine, pE.Expo, pE.Circ;
        var hT, dT, pT, fT, gT, mT, AT, MT, vT = {}, yT = 180 / Math.PI, xT = Math.PI / 180, bT = Math.atan2, wT = /([A-Z])/g, ET = /(left|right|width|margin|padding|x)/i, TT = /[\s,\(]\S/, ST = {
            autoAlpha: "opacity,visibility",
            scale: "scaleX,scaleY",
            alpha: "opacity"
        }, IT = function(e1, t) {
            return t.set(t.t, t.p, Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u, t);
        }, NT = function(e1, t) {
            return t.set(t.t, t.p, 1 === e1 ? t.e : Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u, t);
        }, DT = function(e1, t) {
            return t.set(t.t, t.p, e1 ? Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u : t.b, t);
        }, _T = function(e1, t) {
            var n = t.s + t.c * e1;
            t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : .5)) + t.u, t);
        }, CT = function(e1, t) {
            return t.set(t.t, t.p, e1 ? t.e : t.b, t);
        }, LT = function(e1, t) {
            return t.set(t.t, t.p, 1 !== e1 ? t.b : t.e, t);
        }, zT = function(e1, t, n) {
            return e1.style[t] = n;
        }, OT = function(e1, t, n) {
            return e1.style.setProperty(t, n);
        }, RT = function(e1, t, n) {
            return e1._gsap[t] = n;
        }, PT = function(e1, t, n) {
            return e1._gsap.scaleX = e1._gsap.scaleY = n;
        }, UT = function(e1, t, n, i, r) {
            var a = e1._gsap;
            a.scaleX = a.scaleY = n, a.renderTransform(r, a);
        }, jT = function(e1, t, n, i, r) {
            var a = e1._gsap;
            a[t] = n, a.renderTransform(r, a);
        }, kT = "transform", BT = kT + "Origin", FT = function e1(t, n) {
            var i = this, r = this.target, a = r.style, s = r._gsap;
            if (t in vT && a) {
                if (this.tfm = this.tfm || {}, "transform" === t) return ST.transform.split(",").forEach(function(t) {
                    return e1.call(i, t, n);
                });
                if (~(t = ST[t] || t).indexOf(",") ? t.split(",").forEach(function(e1) {
                    return i.tfm[e1] = aS(r, e1);
                }) : this.tfm[t] = s.x ? s[t] : aS(r, t), t === BT && (this.tfm.zOrigin = s.zOrigin), this.props.indexOf(kT) >= 0) return;
                s.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(BT, n, "")), t = kT;
            }
            (a || n) && this.props.push(t, n, a[t]);
        }, HT = function(e1) {
            e1.translate && (e1.removeProperty("translate"), e1.removeProperty("scale"), e1.removeProperty("rotate"));
        }, GT = function() {
            var e1, t, n = this.props, i = this.target, r = i.style, a = i._gsap;
            for(e1 = 0; e1 < n.length; e1 += 3)n[e1 + 1] ? i[n[e1]] = n[e1 + 2] : n[e1 + 2] ? r[n[e1]] = n[e1 + 2] : r.removeProperty("--" === n[e1].substr(0, 2) ? n[e1] : n[e1].replace(wT, "-$1").toLowerCase());
            if (this.tfm) {
                for(t in this.tfm)a[t] = this.tfm[t];
                a.svg && (a.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")), (e1 = AT()) && e1.isStart || r[kT] || (HT(r), a.zOrigin && r[BT] && (r[BT] += " " + a.zOrigin + "px", a.zOrigin = 0, a.renderTransform()), a.uncache = 1);
            }
        }, VT = function(e1, t) {
            var n = {
                target: e1,
                props: [],
                revert: GT,
                save: FT
            };
            return e1._gsap || uT.core.getCache(e1), t && t.split(",").forEach(function(e1) {
                return n.save(e1);
            }), n;
        }, QT = function(e1, t) {
            var n = dT.createElementNS ? dT.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e1) : dT.createElement(e1);
            return n && n.style ? n : dT.createElement(e1);
        }, WT = function e1(t, n, i) {
            var r = getComputedStyle(t);
            return r[n] || r.getPropertyValue(n.replace(wT, "-$1").toLowerCase()) || r.getPropertyValue(n) || !i && e1(t, XT(n) || n, 1) || "";
        }, YT = "O,Moz,ms,Ms,Webkit".split(","), XT = function(e1, t, n) {
            var i = (t || gT).style, r = 5;
            if (e1 in i && !n) return e1;
            for(e1 = e1.charAt(0).toUpperCase() + e1.substr(1); r-- && !(YT[r] + e1 in i););
            return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? YT[r] : "") + e1;
        }, ZT = function() {
            "undefined" != typeof window && window.document && (hT = window, dT = hT.document, pT = dT.documentElement, gT = QT("div") || {
                style: {}
            }, QT("div"), kT = XT(kT), BT = kT + "Origin", gT.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", MT = !!XT("perspective"), AT = uT.core.reverting, fT = 1);
        }, qT = function e1(t) {
            var n, i = QT("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, a = this.nextSibling, s = this.style.cssText;
            if (pT.appendChild(i), i.appendChild(this), this.style.display = "block", t) try {
                n = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = e1;
            } catch (e1) {}
            else this._gsapBBox && (n = this._gsapBBox());
            return r && (a ? r.insertBefore(this, a) : r.appendChild(this)), pT.removeChild(i), this.style.cssText = s, n;
        }, KT = function(e1, t) {
            for(var n = t.length; n--;)if (e1.hasAttribute(t[n])) return e1.getAttribute(t[n]);
        }, JT = function(e1) {
            var t;
            try {
                t = e1.getBBox();
            } catch (n) {
                t = qT.call(e1, !0);
            }
            return t && (t.width || t.height) || e1.getBBox === qT || (t = qT.call(e1, !0)), !t || t.width || t.x || t.y ? t : {
                x: +KT(e1, [
                    "x",
                    "cx",
                    "x1"
                ]) || 0,
                y: +KT(e1, [
                    "y",
                    "cy",
                    "y1"
                ]) || 0,
                width: 0,
                height: 0
            };
        }, $T = function(e1) {
            return !(!e1.getCTM || e1.parentNode && !e1.ownerSVGElement || !JT(e1));
        }, eS = function(e1, t) {
            if (t) {
                var n, i = e1.style;
                t in vT && t !== BT && (t = kT), i.removeProperty ? ("ms" !== (n = t.substr(0, 2)) && "webkit" !== t.substr(0, 6) || (t = "-" + t), i.removeProperty("--" === n ? t : t.replace(wT, "-$1").toLowerCase())) : i.removeAttribute(t);
            }
        }, tS = function(e1, t, n, i, r, a) {
            var s = new KE(e1._pt, t, n, 0, 1, a ? LT : CT);
            return e1._pt = s, s.b = i, s.e = r, e1._props.push(n), s;
        }, nS = {
            deg: 1,
            rad: 1,
            turn: 1
        }, iS = {
            grid: 1,
            flex: 1
        }, rS = function e1(t, n, i, r) {
            var a, s, o, l, c = parseFloat(i) || 0, u = (i + "").trim().substr((c + "").length) || "px", h = gT.style, d = ET.test(n), p = "svg" === t.tagName.toLowerCase(), f = (p ? "client" : "offset") + (d ? "Width" : "Height"), g = 100, m = "px" === r, A = "%" === r;
            if (r === u || !c || nS[r] || nS[u]) return c;
            if ("px" !== u && !m && (c = e1(t, n, i, "px")), l = t.getCTM && $T(t), (A || "%" === u) && (vT[n] || ~n.indexOf("adius"))) return a = l ? t.getBBox()[d ? "width" : "height"] : t[f], tw(A ? c / a * g : c / 100 * a);
            if (h[d ? "width" : "height"] = g + (m ? u : r), s = ~n.indexOf("adius") || "em" === r && t.appendChild && !p ? t : t.parentNode, l && (s = (t.ownerSVGElement || {}).parentNode), s && s !== dT && s.appendChild || (s = dT.body), (o = s._gsap) && A && o.width && d && o.time === hE.time && !o.uncache) return tw(c / o.width * g);
            if (!A || "height" !== n && "width" !== n) (A || "%" === u) && !iS[WT(s, "display")] && (h.position = WT(t, "position")), s === t && (h.position = "static"), s.appendChild(gT), a = gT[f], s.removeChild(gT), h.position = "absolute";
            else {
                var M = t.style[n];
                t.style[n] = g + r, a = t[f], M ? t.style[n] = M : eS(t, n);
            }
            return d && A && ((o = Jb(s)).time = hE.time, o.width = s[f]), tw(m ? a * c / g : a && c ? g / a * c : 0);
        }, aS = function(e1, t, n, i) {
            var r;
            return fT || ZT(), t in ST && "transform" !== t && ~(t = ST[t]).indexOf(",") && (t = t.split(",")[0]), vT[t] && "transform" !== t ? (r = AS(e1, i), r = "transformOrigin" !== t ? r[t] : r.svg ? r.origin : MS(WT(e1, BT)) + " " + r.zOrigin + "px") : (!(r = e1.style[t]) || "auto" === r || i || ~(r + "").indexOf("calc(")) && (r = uS[t] && uS[t](e1, t, n) || WT(e1, t) || $b(e1, t) || ("opacity" === t ? 1 : 0)), n && !~(r + "").trim().indexOf(" ") ? rS(e1, t, r, n) + n : r;
        }, sS = function(e1, t, n, i) {
            if (!n || "none" === n) {
                var r = XT(t, e1, 1), a = r && WT(e1, r, 1);
                a && a !== n ? (t = r, n = a) : "borderColor" === t && (n = WT(e1, "borderTopColor"));
            }
            var s, o, l, c, u, h, d, p, f, g, m, A = new KE(this._pt, e1.style, t, 0, 1, QE), M = 0, v = 0;
            if (A.b = n, A.e = i, n += "", "auto" == (i += "") && (h = e1.style[t], e1.style[t] = i, i = WT(e1, t) || i, h ? e1.style[t] = h : eS(e1, t)), uE(s = [
                n,
                i
            ]), i = s[1], l = (n = s[0]).match(Nb) || [], (i.match(Nb) || []).length) {
                for(; o = Nb.exec(i);)d = o[0], f = i.substring(M, o.index), u ? u = (u + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (u = 1), d !== (h = l[v++] || "") && (c = parseFloat(h) || 0, m = h.substr((c + "").length), "=" === d.charAt(1) && (d = iw(c, d) + m), p = parseFloat(d), g = d.substr((p + "").length), M = Nb.lastIndex - g.length, g || (g = g || sb.units[t] || m, M === i.length && (i += g, A.e += g)), m !== g && (c = rS(e1, t, h, g) || 0), A._pt = {
                    _next: A._pt,
                    p: f || 1 === v ? f : ",",
                    s: c,
                    c: p - c,
                    m: u && u < 4 || "zIndex" === t ? Math.round : 0
                });
                A.c = M < i.length ? i.substring(M, i.length) : "";
            } else A.r = "display" === t && "none" === i ? LT : CT;
            return _b.test(i) && (A.e = 0), this._pt = A, A;
        }, oS = {
            top: "0%",
            bottom: "100%",
            left: "0%",
            right: "100%",
            center: "50%"
        }, lS = function(e1) {
            var t = e1.split(" "), n = t[0], i = t[1] || "50%";
            return "top" !== n && "bottom" !== n && "left" !== i && "right" !== i || (e1 = n, n = i, i = e1), t[0] = oS[n] || n, t[1] = oS[i] || i, t.join(" ");
        }, cS = function(e1, t) {
            if (t.tween && t.tween._time === t.tween._dur) {
                var n, i, r, a = t.t, s = a.style, o = t.u, l = a._gsap;
                if ("all" === o || !0 === o) s.cssText = "", i = 1;
                else for(r = (o = o.split(",")).length; --r > -1;)n = o[r], vT[n] && (i = 1, n = "transformOrigin" === n ? BT : kT), eS(a, n);
                i && (eS(a, kT), l && (l.svg && a.removeAttribute("transform"), AS(a, 1), l.uncache = 1, HT(s)));
            }
        }, uS = {
            clearProps: function(e1, t, n, i, r) {
                if ("isFromStart" !== r.data) {
                    var a = e1._pt = new KE(e1._pt, t, n, 0, 0, cS);
                    return a.u = i, a.pr = -10, a.tween = r, e1._props.push(n), 1;
                }
            }
        }, hS = [
            1,
            0,
            0,
            1,
            0,
            0
        ], dS = {}, pS = function(e1) {
            return "matrix(1, 0, 0, 1, 0, 0)" === e1 || "none" === e1 || !e1;
        }, fS = function(e1) {
            var t = WT(e1, kT);
            return pS(t) ? hS : t.substr(7).match(Ib).map(tw);
        }, gS = function(e1, t) {
            var n, i, r, a, s = e1._gsap || Jb(e1), o = e1.style, l = fS(e1);
            return s.svg && e1.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [
                (r = e1.transform.baseVal.consolidate().matrix).a,
                r.b,
                r.c,
                r.d,
                r.e,
                r.f
            ]).join(",") ? hS : l : (l !== hS || e1.offsetParent || e1 === pT || s.svg || (r = o.display, o.display = "block", (n = e1.parentNode) && e1.offsetParent || (a = 1, i = e1.nextElementSibling, pT.appendChild(e1)), l = fS(e1), r ? o.display = r : eS(e1, "display"), a && (i ? n.insertBefore(e1, i) : n ? n.appendChild(e1) : pT.removeChild(e1))), t && l.length > 6 ? [
                l[0],
                l[1],
                l[4],
                l[5],
                l[12],
                l[13]
            ] : l);
        }, mS = function(e1, t, n, i, r, a) {
            var s, o, l, c = e1._gsap, u = r || gS(e1, !0), h = c.xOrigin || 0, d = c.yOrigin || 0, p = c.xOffset || 0, f = c.yOffset || 0, g = u[0], m = u[1], A = u[2], M = u[3], v = u[4], y = u[5], x = t.split(" "), b = parseFloat(x[0]) || 0, w = parseFloat(x[1]) || 0;
            n ? u !== hS && (o = g * M - m * A) && (l = b * (-m / o) + w * (g / o) - (g * y - m * v) / o, b = b * (M / o) + w * (-A / o) + (A * y - M * v) / o, w = l) : (b = (s = JT(e1)).x + (~x[0].indexOf("%") ? b / 100 * s.width : b), w = s.y + (~(x[1] || x[0]).indexOf("%") ? w / 100 * s.height : w)), i || !1 !== i && c.smooth ? (v = b - h, y = w - d, c.xOffset = p + (v * g + y * A) - v, c.yOffset = f + (v * m + y * M) - y) : c.xOffset = c.yOffset = 0, c.xOrigin = b, c.yOrigin = w, c.smooth = !!i, c.origin = t, c.originIsAbsolute = !!n, e1.style[BT] = "0px 0px", a && (tS(a, c, "xOrigin", h, b), tS(a, c, "yOrigin", d, w), tS(a, c, "xOffset", p, c.xOffset), tS(a, c, "yOffset", f, c.yOffset)), e1.setAttribute("data-svg-origin", b + " " + w);
        }, AS = function(e1, t) {
            var n = e1._gsap || new EE(e1);
            if ("x" in n && !t && !n.uncache) return n;
            var i, r, a, s, o, l, c, u, h, d, p, f, g, m, A, M, v, y, x, b, w, E, T, S, I, N, D, _, C, L, z, O, R = e1.style, P = n.scaleX < 0, U = "px", j = "deg", k = getComputedStyle(e1), B = WT(e1, BT) || "0";
            return i = r = a = l = c = u = h = d = p = 0, s = o = 1, n.svg = !(!e1.getCTM || !$T(e1)), k.translate && ("none" === k.translate && "none" === k.scale && "none" === k.rotate || (R[kT] = ("none" !== k.translate ? "translate3d(" + (k.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== k.rotate ? "rotate(" + k.rotate + ") " : "") + ("none" !== k.scale ? "scale(" + k.scale.split(" ").join(",") + ") " : "") + ("none" !== k[kT] ? k[kT] : "")), R.scale = R.rotate = R.translate = "none"), m = gS(e1, n.svg), n.svg && (n.uncache ? (I = e1.getBBox(), B = n.xOrigin - I.x + "px " + (n.yOrigin - I.y) + "px", S = "") : S = !t && e1.getAttribute("data-svg-origin"), mS(e1, S || B, !!S || n.originIsAbsolute, !1 !== n.smooth, m)), f = n.xOrigin || 0, g = n.yOrigin || 0, m !== hS && (y = m[0], x = m[1], b = m[2], w = m[3], i = E = m[4], r = T = m[5], 6 === m.length ? (s = Math.sqrt(y * y + x * x), o = Math.sqrt(w * w + b * b), l = y || x ? bT(x, y) * yT : 0, (h = b || w ? bT(b, w) * yT + l : 0) && (o *= Math.abs(Math.cos(h * xT))), n.svg && (i -= f - (f * y + g * b), r -= g - (f * x + g * w))) : (O = m[6], L = m[7], D = m[8], _ = m[9], C = m[10], z = m[11], i = m[12], r = m[13], a = m[14], c = (A = bT(O, C)) * yT, A && (S = E * (M = Math.cos(-A)) + D * (v = Math.sin(-A)), I = T * M + _ * v, N = O * M + C * v, D = E * -v + D * M, _ = T * -v + _ * M, C = O * -v + C * M, z = L * -v + z * M, E = S, T = I, O = N), u = (A = bT(-b, C)) * yT, A && (M = Math.cos(-A), z = w * (v = Math.sin(-A)) + z * M, y = S = y * M - D * v, x = I = x * M - _ * v, b = N = b * M - C * v), l = (A = bT(x, y)) * yT, A && (S = y * (M = Math.cos(A)) + x * (v = Math.sin(A)), I = E * M + T * v, x = x * M - y * v, T = T * M - E * v, y = S, E = I), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = tw(Math.sqrt(y * y + x * x + b * b)), o = tw(Math.sqrt(T * T + O * O)), A = bT(E, T), h = Math.abs(A) > 2e-4 ? A * yT : 0, p = z ? 1 / (z < 0 ? -z : z) : 0), n.svg && (S = e1.getAttribute("transform"), n.forceCSS = e1.setAttribute("transform", "") || !pS(WT(e1, kT)), S && e1.setAttribute("transform", S))), Math.abs(h) > 90 && Math.abs(h) < 270 && (P ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), t = t || n.uncache, n.x = i - ((n.xPercent = i && (!t && n.xPercent || (Math.round(e1.offsetWidth / 2) === Math.round(-i) ? -50 : 0))) ? e1.offsetWidth * n.xPercent / 100 : 0) + U, n.y = r - ((n.yPercent = r && (!t && n.yPercent || (Math.round(e1.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? e1.offsetHeight * n.yPercent / 100 : 0) + U, n.z = a + U, n.scaleX = tw(s), n.scaleY = tw(o), n.rotation = tw(l) + j, n.rotationX = tw(c) + j, n.rotationY = tw(u) + j, n.skewX = h + j, n.skewY = d + j, n.transformPerspective = p + U, (n.zOrigin = parseFloat(B.split(" ")[2]) || !t && n.zOrigin || 0) && (R[BT] = MS(B)), n.xOffset = n.yOffset = 0, n.force3D = sb.force3D, n.renderTransform = n.svg ? TS : MT ? ES : yS, n.uncache = 0, n;
        }, MS = function(e1) {
            return (e1 = e1.split(" "))[0] + " " + e1[1];
        }, vS = function(e1, t, n) {
            var i = jw(t);
            return tw(parseFloat(t) + parseFloat(rS(e1, "x", n + "px", i))) + i;
        }, yS = function(e1, t) {
            t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, ES(e1, t);
        }, xS = "0deg", bS = "0px", wS = ") ", ES = function(e1, t) {
            var n = t || this, i = n.xPercent, r = n.yPercent, a = n.x, s = n.y, o = n.z, l = n.rotation, c = n.rotationY, u = n.rotationX, h = n.skewX, d = n.skewY, p = n.scaleX, f = n.scaleY, g = n.transformPerspective, m = n.force3D, A = n.target, M = n.zOrigin, v = "", y = "auto" === m && e1 && 1 !== e1 || !0 === m;
            if (M && (u !== xS || c !== xS)) {
                var x, b = parseFloat(c) * xT, w = Math.sin(b), E = Math.cos(b);
                b = parseFloat(u) * xT, x = Math.cos(b), a = vS(A, a, w * x * -M), s = vS(A, s, -Math.sin(b) * -M), o = vS(A, o, E * x * -M + M);
            }
            g !== bS && (v += "perspective(" + g + wS), (i || r) && (v += "translate(" + i + "%, " + r + "%) "), (y || a !== bS || s !== bS || o !== bS) && (v += o !== bS || y ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + wS), l !== xS && (v += "rotate(" + l + wS), c !== xS && (v += "rotateY(" + c + wS), u !== xS && (v += "rotateX(" + u + wS), h === xS && d === xS || (v += "skew(" + h + ", " + d + wS), 1 === p && 1 === f || (v += "scale(" + p + ", " + f + wS), A.style[kT] = v || "translate(0, 0)";
        }, TS = function(e1, t) {
            var n, i, r, a, s, o = t || this, l = o.xPercent, c = o.yPercent, u = o.x, h = o.y, d = o.rotation, p = o.skewX, f = o.skewY, g = o.scaleX, m = o.scaleY, A = o.target, M = o.xOrigin, v = o.yOrigin, y = o.xOffset, x = o.yOffset, b = o.forceCSS, w = parseFloat(u), E = parseFloat(h);
            d = parseFloat(d), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), d += f), d || p ? (d *= xT, p *= xT, n = Math.cos(d) * g, i = Math.sin(d) * g, r = Math.sin(d - p) * -m, a = Math.cos(d - p) * m, p && (f *= xT, s = Math.tan(p - f), r *= s = Math.sqrt(1 + s * s), a *= s, f && (s = Math.tan(f), n *= s = Math.sqrt(1 + s * s), i *= s)), n = tw(n), i = tw(i), r = tw(r), a = tw(a)) : (n = g, a = m, i = r = 0), (w && !~(u + "").indexOf("px") || E && !~(h + "").indexOf("px")) && (w = rS(A, "x", u, "px"), E = rS(A, "y", h, "px")), (M || v || y || x) && (w = tw(w + M - (M * n + v * r) + y), E = tw(E + v - (M * i + v * a) + x)), (l || c) && (s = A.getBBox(), w = tw(w + l / 100 * s.width), E = tw(E + c / 100 * s.height)), s = "matrix(" + n + "," + i + "," + r + "," + a + "," + w + "," + E + ")", A.setAttribute("transform", s), b && (A.style[kT] = s);
        }, SS = function(e1, t, n, i, r) {
            var a, s, o = 360, l = mb(r), c = parseFloat(r) * (l && ~r.indexOf("rad") ? yT : 1) - i, u = i + c + "deg";
            return l && ("short" === (a = r.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), e1._pt = s = new KE(e1._pt, t, n, i, c, NT), s.e = u, s.u = "deg", e1._props.push(n), s;
        }, IS = function(e1, t) {
            for(var n in t)e1[n] = t[n];
            return e1;
        }, NS = function(e1, t, n) {
            var i, r, a, s, o, l, c, u = IS({}, n._gsap), h = n.style;
            for(r in u.svg ? (a = n.getAttribute("transform"), n.setAttribute("transform", ""), h[kT] = t, i = AS(n, 1), eS(n, kT), n.setAttribute("transform", a)) : (a = getComputedStyle(n)[kT], h[kT] = t, i = AS(n, 1), h[kT] = a), vT)(a = u[r]) !== (s = i[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (o = jw(a) !== (c = jw(s)) ? rS(n, r, a, c) : parseFloat(a), l = parseFloat(s), e1._pt = new KE(e1._pt, i, r, o, l - o, IT), e1._pt.u = c || 0, e1._props.push(r));
            IS(i, u);
        };
        ew("padding,margin,Width,Radius", function(e1, t) {
            var n = "Top", i = "Right", r = "Bottom", a = "Left", s = (t < 3 ? [
                n,
                i,
                r,
                a
            ] : [
                n + a,
                n + i,
                r + i,
                r + a
            ]).map(function(n) {
                return t < 2 ? e1 + n : "border" + n + e1;
            });
            uS[t > 1 ? "border" + e1 : e1] = function(e1, t, n, i, r) {
                var a, o;
                if (arguments.length < 4) return a = s.map(function(t) {
                    return aS(e1, t, n);
                }), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (i + "").split(" "), o = {}, s.forEach(function(e1, t) {
                    return o[e1] = a[t] = a[t] || a[(t - 1) / 2 | 0];
                }), e1.init(t, o, r);
            };
        });
        var DS, _S, CS = {
            name: "css",
            register: ZT,
            targetTest: function(e1) {
                return e1.style && e1.nodeType;
            },
            init: function(e1, t, n, i, r) {
                var a, s, o, l, c, u, h, d, p, f, g, m, A, M, v, y, x = this._props, b = e1.style, w = n.vars.startAt;
                for(h in fT || ZT(), this.styles = this.styles || VT(e1), y = this.styles.props, this.tween = n, t)if ("autoRound" !== h && (s = t[h], !Wb[h] || !CE(h, t, n, i, e1, r))) {
                    if (c = typeof s, u = uS[h], "function" === c && (c = typeof (s = s.call(n, i, e1, r))), "string" === c && ~s.indexOf("random(") && (s = Zw(s)), u) u(this, e1, h, s, n) && (v = 1);
                    else if ("--" === h.substr(0, 2)) a = (getComputedStyle(e1).getPropertyValue(h) + "").trim(), s += "", lE.lastIndex = 0, lE.test(a) || (d = jw(a), p = jw(s)), p ? d !== p && (a = rS(e1, h, a, p) + p) : d && (s += d), this.add(b, "setProperty", a, s, i, r, 0, 0, h), x.push(h), y.push(h, 0, b[h]);
                    else if ("undefined" !== c) {
                        if (w && h in w ? (a = "function" == typeof w[h] ? w[h].call(n, i, e1, r) : w[h], mb(a) && ~a.indexOf("random(") && (a = Zw(a)), jw(a + "") || "auto" === a || (a += sb.units[h] || jw(aS(e1, h)) || ""), "=" === (a + "").charAt(1) && (a = aS(e1, h))) : a = aS(e1, h), l = parseFloat(a), (f = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in ST && ("autoAlpha" === h && (1 === l && "hidden" === aS(e1, "visibility") && o && (l = 0), y.push("visibility", 0, b.visibility), tS(this, b, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = ST[h]).indexOf(",") && (h = h.split(",")[0])), g = h in vT) {
                            if (this.styles.save(h), m || ((A = e1._gsap).renderTransform && !t.parseTransform || AS(e1, t.parseTransform), M = !1 !== t.smoothOrigin && A.smooth, (m = this._pt = new KE(this._pt, b, kT, 0, 1, A.renderTransform, A, 0, -1)).dep = 1), "scale" === h) this._pt = new KE(this._pt, A, "scaleY", A.scaleY, (f ? iw(A.scaleY, f + o) : o) - A.scaleY || 0, IT), this._pt.u = 0, x.push("scaleY", h), h += "X";
                            else {
                                if ("transformOrigin" === h) {
                                    y.push(BT, 0, b[BT]), s = lS(s), A.svg ? mS(e1, s, 0, M, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== A.zOrigin && tS(this, A, "zOrigin", A.zOrigin, p), tS(this, b, h, MS(a), MS(s)));
                                    continue;
                                }
                                if ("svgOrigin" === h) {
                                    mS(e1, s, 1, M, 0, this);
                                    continue;
                                }
                                if (h in dS) {
                                    SS(this, A, h, l, f ? iw(l, f + s) : s);
                                    continue;
                                }
                                if ("smoothOrigin" === h) {
                                    tS(this, A, "smooth", A.smooth, s);
                                    continue;
                                }
                                if ("force3D" === h) {
                                    A[h] = s;
                                    continue;
                                }
                                if ("transform" === h) {
                                    NS(this, s, e1);
                                    continue;
                                }
                            }
                        } else h in b || (h = XT(h) || h);
                        if (g || (o || 0 === o) && (l || 0 === l) && !TT.test(s) && h in b) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = jw(s) || (h in sb.units ? sb.units[h] : d)) && (l = rS(e1, h, a, p)), this._pt = new KE(this._pt, g ? A : b, h, l, (f ? iw(l, f + o) : o) - l, g || "px" !== p && "zIndex" !== h || !1 === t.autoRound ? IT : _T), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = DT);
                        else if (h in b) sS.call(this, e1, h, a, f ? f + s : s);
                        else if (h in e1) this.add(e1, h, a || e1[h], f ? f + s : s, i, r);
                        else if ("parseTransform" !== h) {
                            Pb(h, s);
                            continue;
                        }
                        g || (h in b ? y.push(h, 0, b[h]) : y.push(h, 1, a || e1[h])), x.push(h);
                    }
                }
                v && qE(this);
            },
            render: function(e1, t) {
                if (t.tween._time || !AT()) for(var n = t._pt; n;)n.r(e1, n.d), n = n._next;
                else t.styles.revert();
            },
            get: aS,
            aliases: ST,
            getSetter: function(e1, t, n) {
                var i = ST[t];
                return i && i.indexOf(",") < 0 && (t = i), t in vT && t !== BT && (e1._gsap.x || aS(e1, "x")) ? n && mT === n ? "scale" === t ? PT : RT : (mT = n || {}, "scale" === t ? UT : jT) : e1.style && !vb(e1.style[t]) ? zT : ~t.indexOf("-") ? OT : HE(e1, t);
            },
            core: {
                _removeProperty: eS,
                _getMatrix: gS
            }
        };
        uT.utils.checkPrefix = XT, uT.core.getStyleSaver = VT, _S = ew("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (DS = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(e1) {
            vT[e1] = 1;
        }), ew(DS, function(e1) {
            sb.units[e1] = "deg", dS[e1] = 1;
        }), ST[_S[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + DS, ew("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(e1) {
            var t = e1.split(":");
            ST[t[1]] = _S[t[0]];
        }), ew("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e1) {
            sb.units[e1] = "px";
        }), uT.registerPlugin(CS);
        var LS = uT.registerPlugin(CS) || uT;
        function zS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        LS.core.Tween;
        const OS = new class {
            constructor(){
                zS(this, "_animationListeners", void 0), zS(this, "_prevTime", void 0), this._animationListeners = [], this._prevTime = 0;
                const e1 = (t)=>{
                    const n = (t - (this._prevTime || t)) / 1e3;
                    this._prevTime = t, this._animationListeners.forEach((e1)=>e1(n)), requestAnimationFrame(e1);
                };
                requestAnimationFrame(e1);
            }
            addEventListener(e1, t) {
                "animation" === e1 && this._animationListeners.push(t);
            }
            removeEventListener(e1, t) {
                switch(e1){
                    case "animation":
                        {
                            const e1 = this._animationListeners.indexOf(t);
                            -1 !== e1 && this._animationListeners.splice(e1, 1);
                            break;
                        }
                }
            }
            clearListeners() {
                this._animationListeners.length = 0;
            }
        };
        function RS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const PS = class extends jp {
            constructor(e1){
                super(), RS(this, "_visible", !0), RS(this, "depthParams", {
                    maxDistance: 800,
                    maxDelta: 40
                }), RS(this, "_onAnimation", void 0), RS(this, "pulseState", {
                    isHover: !1,
                    time: 0,
                    transition: 0
                }), this.userData = e1, this.visible = !1, this.createHoverArea(), this.createPoint().then(()=>this.addEventListeners()), this.enablePulse && this.addPulse();
            }
            get visible() {
                return this._visible;
            }
            get pulseFrom() {
                return Ci.config?.linkOptions?.pulseFrom ?? 1;
            }
            get pulseTo() {
                return Ci.config?.linkOptions?.pulseTo ?? 2;
            }
            get pulseSpeed() {
                return Ci.config?.linkOptions?.pulseSpeed ?? 1;
            }
            get enablePulse() {
                return Ci.config?.linkOptions?.enablePulse ?? true;
            }
            get canHover() {
                return !gx.isMobileDevice && !LN.rulerModeEnabled && !!Ci.config.enablePointHoverVisibility;
            }
            set visible(e1) {
                this._visible = e1, this.hoverArea && (this.hoverArea.visible = e1), this.point && (this.point.visible = e1);
            }
            addPulse() {
                this._onAnimation = (e1)=>{
                    const t = this.pulseState.isHover ? .1 : -0.1;
                    var n;
                    this.pulseState.transition = (n = this.pulseState.transition + t) < 0 ? 0 : n > 1 ? 1 : n;
                    const i = Math.abs(Math.cos(this.pulseState.time * Math.PI)), r = Mx(this.pulseFrom, this.pulseTo, i), a = Mx(1, r, this.pulseState.transition);
                    this.point && this.point.scale.setScalar(a), this.pulseState.time += e1 * this.pulseSpeed;
                }, OS.addEventListener("animation", this._onAnimation);
            }
            getOpacity() {
                return Ci.config.enablePointHoverVisibility ? gx.isMobileDevice ? .5 : 0 : 1;
            }
            async createPoint() {
                const e1 = new ph(30, 30, 10, 10), t = new wA, n = await t.loadAsync(this.userData.icon);
                n.center = new $o(.5, .5), n.colorSpace = Qs, n.minFilter = wa, n.magFilter = va, n.anisotropy = 8;
                const i = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    map: n,
                    opacity: this.getOpacity()
                });
                this.point = new Vu(e1, i), this.point.position.copy(this.userData.position), this.point.rotation.x = Math.PI / 2, this.point.visible = this.visible, this.point.interactive = !0, this.point.renderOrder = 3, this.point.isLink = !0, this.point.updateOpacity = LS.quickTo(this.point.material, "opacity", {
                    ease: "back",
                    duration: .5
                }), this.add(this.point);
            }
            createHoverArea() {
                const e1 = new Ug(125, 10, 10), t = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    opacity: 0
                });
                this.hoverArea = new Vu(e1, t), this.hoverArea.position.copy(this.userData.position), this.hoverArea.rotation.x = Math.PI / 2, this.hoverArea.visible = this.visible, this.hoverArea.isLinkSphere = !0, this.hoverArea.interactive = !0, this.hoverArea.renderOrder = 2, this.add(this.hoverArea);
            }
            addEventListeners() {
                return this.point.addEventListener("select", ()=>this.onClick()), this.point.addEventListener("click", ()=>this.onClick()), this.point.addEventListener("hoverstart", ()=>this.onHoverPointStart()), this.point.addEventListener("hoverend", ()=>this.onHoverPointEnd()), this.hoverArea.addEventListener("hoverstart", ()=>this.onHoverStart()), this.hoverArea.addEventListener("hoverend", ()=>this.onHoverEnd()), this.hoverArea.addEventListener("click", ()=>this.onClick()), this;
            }
            dispose() {
                this.point && (this.point.material.dispose(), this.point.removeFromParent()), this.hoverArea && (this.hoverArea.material.dispose(), this.hoverArea.removeFromParent()), OS.removeEventListener("animation", this._onAnimation), this.removeFromParent();
            }
            onHoverStart() {
                this.canHover && this.point.updateOpacity(1);
            }
            onHoverEnd() {
                this.canHover && this.point.updateOpacity(0);
            }
            onHoverPointStart() {
                const { pointHoverScale: e1 } = Ci.config;
                null != e1 && this.point.scale.setScalar(e1), this.pulseState.isHover || (this.pulseState.time = 0), this.pulseState.isHover = !0;
            }
            onHoverPointEnd() {
                const { pointHoverScale: e1 } = Ci.config;
                null != e1 && this.point.scale.setScalar(1), this.pulseState.isHover = !1;
            }
            onClick() {}
        };
        function US(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const jS = class extends ff {
            constructor(e1){
                super(), US(this, "interactive", !0), US(this, "isStairs", !0), this.userData = e1, this.position.copy(e1.position), this.renderOrder = 3, this.visible = !1, this.onHoverEnd(), this.createMaterial(), this.addEventListeners();
            }
            createGeometry() {
                return this.geometry = new ph(1, 1, 10, 10), this;
            }
            async createMaterial() {
                const e1 = new wA, t = await e1.loadAsync(this.userData.icon);
                t.center = new $o(.5, .5), t.colorSpace = Qs, t.minFilter = wa, t.magFilter = va, t.anisotropy = 8;
                const n = new $p({
                    color: new qc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    map: t,
                    opacity: gx.isMobileDevice
                });
                return this.material = n, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            changeVisible(e1) {
                this.material.opacity = e1;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {
                this.scale.setScalar(this.userData.scale + 20 * this.userData.scale / 100);
            }
            onHoverEnd() {
                this.scale.setScalar(this.userData.scale);
            }
            onClick() {}
        };
        const kS = {
            hasRealSize: !1,
            realSize: 300,
            realSizeMobileScale: 1,
            realSizeMinDistance: 100,
            realSizeDistanceMinScale: .1,
            hoverScale: 1.2
        };
        class BS extends ff {
            constructor(e1){
                var t, n, i;
                super(), t = this, i = void 0, (n = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(n = "interactive")) in t ? Object.defineProperty(t, n, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[n] = i, this.interactive = !0, this.userData = e1, this.position.copy(e1.position), this.renderOrder = 3, this.visible = !1, this.onHoverEnd(), this.createMaterial().then(()=>this.addEventListeners());
            }
            get options() {
                return {
                    ...kS,
                    ...Ci.config.defaultLinkOptions
                };
            }
            get hasRealSize() {
                return Boolean(this.options.hasRealSize);
            }
            get hoverScale() {
                return this.options.hoverScale;
            }
            get distanceScale() {
                if (!this.hasRealSize) return 1;
                const e1 = this.options.realSizeMinDistance;
                if (!e1) return 1;
                const { x: t, z: n } = this.position, i = Math.sqrt(t * t + n * n);
                return i > e1 ? 1 : Math.max(this.options.realSizeDistanceMinScale, i / e1);
            }
            get spriteScale() {
                if (!this.hasRealSize) return this.userData.scale;
                const e1 = (gx.isMobile ? this.options.realSizeMobileScale : 1) * this.options.realSize * this.distanceScale;
                return this.userData.scale * e1;
            }
            createGeometry() {
                return this.geometry = new ph(1, 1, 1, 1), this;
            }
            async createMaterial() {
                const e1 = await Ax.getTexture(this.userData.icon);
                return e1 ? (e1.center = new $o(.5, .5), e1.colorSpace = Qs, e1.minFilter = wa, e1.magFilter = va, e1.anisotropy = 8, this.material = new $p({
                    color: new qc(16777215),
                    sizeAttenuation: this.hasRealSize,
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    map: e1,
                    opacity: 1
                }), this) : this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            onHoverStart() {
                this.scale.setScalar(this.spriteScale * this.hoverScale);
            }
            onHoverEnd() {
                this.scale.setScalar(this.spriteScale);
            }
            onClick() {}
        }
        const FS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NjZfMikiPgo8cGF0aCBkPSJNMi43MDIyMSAxNS4yOTgxTDE0LjQ0NjggMy41NTM0NiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuOTA0MzMgMy41NTM0N0wxNC40NDY4IDMuNTUzNDdMMTQuNDQ2OSAxMy4wOTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NjZfMiI+CjxyZWN0IHdpZHRoPSI0Ny45OTk4IiBoZWlnaHQ9IjQ3Ljk5OTgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDA2IDEuMDAwMjQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", HS = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NTFfMTcyKSI+CjxwYXRoIGQ9Ik0xNC40NDY4IDMuNTUzNDZMMi43MDIyIDE1LjI5ODEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi4yNDQ3IDE1LjI5ODFMMi43MDIyIDE1LjI5ODFMMi43MDIyIDUuNzU1NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NTFfMTcyIj4KPHJlY3Qgd2lkdGg9IjQ3Ljk5OTgiIGhlaWdodD0iNDcuOTk5OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDYgMS4wMDAyNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
        function GS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        function VS(e1, t) {
            return e1.get(function(e1, t, n) {
                if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
                throw new TypeError("Private element is not present on this object");
            }(e1, t));
        }
        var QS = new WeakMap;
        const WS = class extends Vu {
            constructor(e1, t){
                var n, i, r;
                super(t), GS(this, "depthMap", null), GS(this, "loaded", !1), GS(this, "links", []), r = [], function(e1, t) {
                    if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }(n = this, i = QS), i.set(n, r), this.renderOrder = 0, this.userData = e1;
            }
            get panoramaId() {
                return this.userData.camera_id;
            }
            async loadDepth() {
                performance.mark("start downloadingDepth");
                try {
                    this.depthMap = await Ax.getDepth(this.userData.images.scene_depth);
                } catch (e1) {
                    this.depthMap = null, console.error("Error loading depthMap");
                }
                performance.mark("finish start downloadingDepth"), performance.measure("downloadingDepth", "start downloadingDepth", "finish start downloadingDepth");
            }
            async loadMask() {
                try {
                    this.mask = await Ax.getDepth(this.userData.images.object_ids);
                } catch (e1) {
                    this.mask = null, console.error("Error loading mask");
                }
            }
            async load() {
                return this.userData.images.scene_depth && await this.loadDepth().then(()=>this.removeBlockedLinks()), Cy.isMask && (await this.loadMask(), this.hideStairsIcon()), await this.createMaterial().then(()=>this.loaded = !0);
            }
            removeBlockedLinks() {
                const { depthMap: e1 } = this;
                e1 && this.links.forEach((t)=>{
                    if (!t.depthParams) return;
                    const { maxDistance: n, maxDelta: i } = t.depthParams, { delta: r, distance: a } = ((e1, t)=>{
                        const { direction: n } = (new oc).lookAt(e1), i = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, r = Math.acos(n.y) / Math.PI, { R: a } = Dx(i, r, t), s = a || 140, o = (new Ll).distanceTo(e1);
                        return {
                            depth: s,
                            distance: o,
                            delta: o - s
                        };
                    })(t.userData.position, e1);
                    return r > i || a > n ? t.dispose() : void 0;
                });
            }
            createLinks(e1) {
                return this.createCameraPoints(), this.createDoors(e1), this.createStairs(), this;
            }
            hideStairsIcon() {
                LN.getPanoramaById(this.panoramaId)?.links.forEach((e1)=>{
                    if (!e1.isStairs) return;
                    const { x: t, y: n, z: i } = e1.userData.position.normalize(), r = .5 + Math.atan2(i, t) / (2 * Math.PI), a = .5 - Math.asin(n) / Math.PI;
                    [
                        {
                            u: r,
                            v: a
                        },
                        {
                            u: r - .01,
                            v: a - .01
                        },
                        {
                            u: r + .01,
                            v: a - .01
                        },
                        {
                            u: r - .01,
                            v: a + .01
                        },
                        {
                            u: r + .01,
                            v: a + .01
                        }
                    ].map((e1)=>{
                        let { u: t, v: n } = e1;
                        const { R: i } = Dx(t, n, this.mask);
                        return Math.round(i);
                    }).every((e1)=>!e1) && e1.dispose();
                });
            }
            createStairs() {
                const e1 = Ci.config.json.ObjectMaskColorPairs?.map((e1)=>{
                    const { LowerFloorCameraPointID: t, UpperFloorCameraPointID: n, RoomID: i, LowerEntranceLocation: r, UpperEntranceLocation: a } = zx(Ci.config.json, e1.ObjectID), s = this.userData.roomPanoramas.includes(t);
                    return {
                        ...e1,
                        LowerFloorCameraPointID: t,
                        UpperFloorCameraPointID: n,
                        EntranceLocation: s ? r : a,
                        directionUp: s,
                        roomId: i
                    };
                });
                return e1?.forEach((e1)=>{
                    const t = {
                        panoramaId: this.panoramaId,
                        LowerFloorCameraPointID: e1.LowerFloorCameraPointID,
                        UpperFloorCameraPointID: e1.UpperFloorCameraPointID,
                        directionUp: e1.directionUp
                    };
                    this.createLink(null, e1.EntranceLocation, !1, null, !0, t);
                }), this;
            }
            createCameraPoints() {
                for (const e1 of this.userData.roomPanoramas){
                    if (e1 === this.panoramaId) continue;
                    const t = bx(Ci.config.json, e1);
                    t && this.createLink(e1, t.Location, !1);
                }
                return this;
            }
            createDoors(e1) {
                const { json: t } = Ci.config, n = t.Floors[Ci.currentFloorIndex], i = n.Apertures ?? [], r = [
                    ...n.Doors ?? [],
                    ...i
                ], a = r.length, { Rooms: s } = n.Units[0], o = xx(t, this.userData.room_id), l = o.Walls;
                for(let t = 0; t < a; t++){
                    const { Location: n, Walls: i, ...a } = r[t];
                    if (!i.some((e1)=>l.includes(e1))) continue;
                    const c = s.find((e1)=>e1.ID !== o.ID && i.some((t)=>e1.Walls.includes(t)));
                    if (!c) continue;
                    const u = e1.filter((e1)=>{
                        let { userData: t } = e1;
                        return t.room_id === c.ID;
                    }), { panorama: h } = wx([
                        n.X,
                        n.Y
                    ], u);
                    h && this.createLink(h.panoramaId, n, !0, a);
                }
                return this;
            }
            createLink(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], i = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 ? arguments[5] : void 0;
                if (!t) return;
                const s = this.userData.cameraData?.Location.Z || 140, o = [
                    this.userData.left,
                    this.userData.top
                ], l = t.X - o[0], c = t.Y - o[1], u = n ? i.Height / 2 - s : -s, h = new Ll(l, u, c);
                h.applyAxisAngle(new Ll(0, 1, 0), Math.PI / 2);
                const d = {
                    panoramaId: this.panoramaId,
                    position: h,
                    targetId: e1
                };
                if (n) {
                    const e1 = Ci.config.panoramaIcons.door, t = !Cy.isProActive || gx.isMobileDevice && Ci.config.enableDoorVisibility ? new BS({
                        ...d,
                        scale: .1,
                        icon: e1
                    }) : new Bx({
                        ...d,
                        rotation: new Mc(0, Ix(i.Rotation.Yaw + 90), 0),
                        height: i.Height,
                        width: i.Width,
                        scale: .1,
                        icon: e1,
                        loc: this.userData.cameraData.Location
                    });
                    return this.links.push(t), t;
                }
                if (r) {
                    const e1 = a.directionUp ? FS : HS, t = new jS({
                        ...a,
                        scale: .08,
                        position: h,
                        icon: e1
                    });
                    return this.links.push(t), t;
                }
                const p = Cy.isProActive ? Ci.config.panoramaIcons.interactiveSpot : Ci.config.panoramaIcons.spot, f = Cy.isProActive ? new PS({
                    ...d,
                    icon: p,
                    scale: 1
                }) : new BS({
                    ...d,
                    scale: .1,
                    icon: p
                });
                return this.links.push(f), f;
            }
            addEventListener(e1, t) {
                "materialcreate" === e1 ? VS(QS, this).push({
                    type: e1,
                    listener: t
                }) : super.addEventListener(e1, t);
            }
            invoke(e1, t) {
                VS(QS, this).forEach((n)=>{
                    e1 === n.type && n.listener(t);
                });
            }
        }, YS = class extends WS {
            constructor(e1){
                performance.mark("start creating SphereGeometry");
                const t = new Im(1e3, 512, 512).scale(-1, 1, 1);
                performance.mark("finish creating SphereGeometry"), performance.measure("creating SphereGeometry", "start creating SphereGeometry", "finish creating SphereGeometry"), super(e1, t), this.userData.image = e1.images.sphere || e1.images[0];
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const e1 = await Ax.getTexture(this.userData.image.replace(/\.jpe?g|\.webp/, (e1)=>{
                    switch(e1){
                        case ".jpg":
                        case ".jpeg":
                            return "_Unfurnished.jpg";
                        case ".webp":
                            return "_Unfurnished.webp";
                        default:
                            return e1;
                    }
                }));
                return this.material = new Um({
                    transparent: !0,
                    side: ur,
                    map: e1,
                    opacity: 0
                }), this.bareshellMaterial = this.material, this;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const e1 = await Ax.getTexture(this.userData.image);
                return this.material = new Um({
                    transparent: !0,
                    side: ur,
                    map: e1,
                    opacity: 0
                }), this.defaultMaterial = this.material, this;
            }
            async createMaterial() {
                const e1 = await (LN.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), e1;
            }
            async fadeOut() {
                return await Tx(this.material).then(()=>this.visible = !1);
            }
            async fadeIn() {
                return this.visible = !0, await Sx(this.material);
            }
        }, XS = class extends WS {
            constructor(e1){
                performance.mark("start creating BoxGeometry");
                const t = new Wu(2e3, 2e3, 2e3).scale(-1, 1, 1);
                performance.mark("finish creating BoxGeometry"), performance.measure("creating BoxGeometry", "start creating BoxGeometry", "finish creating BoxGeometry"), super(e1, t), this.userData.cubemap = [
                    {
                        url: e1.images.front,
                        rotation: 0
                    },
                    {
                        url: e1.images.back,
                        rotation: 0
                    },
                    {
                        url: e1.images.top,
                        rotation: 90
                    },
                    {
                        url: e1.images.bottom,
                        rotation: 270
                    },
                    {
                        url: e1.images.left,
                        rotation: 0
                    },
                    {
                        url: e1.images.right,
                        rotation: 0
                    }
                ];
            }
            async loadSides() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                const { cubemap: t } = this.userData;
                let n = 0;
                const i = t.length, r = new Array(t.length);
                return new Promise((a)=>{
                    const s = ()=>{
                        n++, n === i && a(r);
                    };
                    t.forEach((t, n)=>{
                        let i = t.url;
                        if (e1) {
                            const e1 = /(Panorama_\d_\d_\d_([a-zA-Zа-яА-Я0-9-]+)\/.+)\.[a-zA-Z0-9]+/gm, n = t.url.match(e1)[0], r = n.replace("/", "_Unfurnished/");
                            i = t.url.replace(n, r);
                        }
                        Ax.getTexture(i).then((e1)=>{
                            e1.rotation = Ix(t.rotation), r[n] = e1, s();
                        }).catch(s);
                    });
                });
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const e1 = await this.loadSides(!0);
                this.material = e1.map((e1)=>new Um({
                        transparent: !0,
                        side: ur,
                        opacity: 0,
                        map: e1
                    })), this.bareshellMaterial = this.material;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const e1 = await this.loadSides();
                this.material = e1.map((e1)=>new Um({
                        transparent: !0,
                        side: ur,
                        opacity: 0,
                        map: e1
                    })), this.defaultMaterial = this.material;
            }
            async createMaterial() {
                const e1 = await (LN.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), e1;
            }
            async fadeOut() {
                const e1 = this.material.map(Tx);
                return await Promise.all(e1).then(()=>this.visible = !1);
            }
            async fadeIn() {
                this.visible = !0;
                const e1 = this.material.map(Sx);
                return await Promise.all(e1);
            }
        };
        function ZS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const qS = class extends jp {
            constructor(e1){
                super(), ZS(this, "type", "sphere"), ZS(this, "items", []), ZS(this, "floorIndex", void 0), this.floorIndex = e1;
            }
            getCreatedPanoramas() {
                const { json: e1 } = Ci.config, t = e1.Floors[Ci.currentFloorIndex];
                if (!t) return this.items.map((e1)=>{
                    const t = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...e1
                    };
                    return this.createPanorama(t);
                });
                const { primaryCameraPointId: n } = Ci, i = bx(e1, n), { Walls: r, Doors: a } = t, { Vertices: s } = e1;
                return this.items.reduce((t, n)=>{
                    performance.mark("start getting rooms, cameras, svg paths ...");
                    const a = bx(e1, n.camera_id), o = xx(e1, n.room_id), l = this.items.reduce((e1, t)=>(t.room_id === n.room_id && e1.push(t.camera_id), e1), []), c = ((e1, t, n)=>{
                        const i = e1.Walls.reduce((e1, i)=>{
                            const r = t.find((e1)=>e1.ID === i);
                            return yx(t, r.ID, n).forEach((t)=>e1.push(t)), e1;
                        }, []);
                        return i;
                    })(o, r, s), u = o.Walls.reduce((e1, t, n)=>{
                        const i = r.find((e1)=>e1.ID === t), [a, o] = yx(r, t, s), l = [];
                        return 0 === n && e1.push({
                            type: "M",
                            x: a[0],
                            y: a[1]
                        }), e1.push({
                            type: "L",
                            x: a[0],
                            y: a[1]
                        }), i.ControlPoint && l.push({
                            type: "Q",
                            x: i.ControlPoint.Location.X,
                            y: i.ControlPoint.Location.Y,
                            dx: o[0],
                            dy: o[1]
                        }), l.push({
                            type: "L",
                            x: o[0],
                            y: o[1]
                        }), [
                            ...e1,
                            ...l
                        ];
                    }, []);
                    performance.mark("finish getting rooms, cameras, svg paths ..."), performance.measure("getting rooms, cameras, svg paths ...", "start getting rooms, cameras, svg paths ...", "finish getting rooms, cameras, svg paths ...");
                    const [h, d] = a ? [
                        a.Location.X,
                        a.Location.Y
                    ] : function(e1) {
                        let t = 0, n = 0, i = e1.length;
                        for(let r = 0; r < i; r++){
                            const i = e1[r];
                            t += i[0], n += i[1];
                        }
                        return [
                            t / i,
                            n / i
                        ];
                    }(c), p = -1 * Ix(a.Rotation?.Yaw || 0), f = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...n,
                        cameraData: a || null,
                        roomPanoramas: l,
                        svgPathActions: u,
                        rotation: p,
                        points: c,
                        left: h,
                        top: d
                    }, g = this.createPanorama(f);
                    return i && i.ID === a.ID ? (t.unshift(g), t) : i || o.ID !== Ci.initialPanoramaRoomId ? (t.push(g), t) : (t.unshift(g), t);
                }, []);
            }
            createPanoramas(e1, t) {
                this.items = e1, this.type = t, performance.mark("start create panorama's data");
                const n = this.getCreatedPanoramas();
                return performance.mark("finish create panorama's data"), performance.measure("creating panorama's data", "start create panorama's data", "finish create panorama's data"), n.forEach((e1, t)=>{
                    e1.userData.panorama_index = t;
                }), Ci.config.json && n.forEach((e1)=>{
                    e1.createLinks(n);
                }), n;
            }
            createPanorama(e1) {
                const t = "cube" === this.type ? new XS(e1) : new YS(e1);
                return t.addEventListener("materialcreate", ()=>{
                    ((e1, t)=>{
                        if (gx.isMobile) return;
                        const { currentFloorIndex: n, config: i } = Ci, r = e1?.Floors?.[n]?.CameraPoints;
                        if (!r) return void console.warn("Panorama cache: can't get floor cameras!");
                        const a = i.panoramaData?.items;
                        if (!a) return void console.warn("Panorama cache: can't get panorama images data!");
                        let s = null;
                        const o = [];
                        if (r.forEach((e1)=>{
                            if (e1.ID === t) return void (s = e1);
                            const n = a.find((t)=>t.camera_id === e1.ID)?.images;
                            if (n) {
                                const t = {
                                    id: e1.ID,
                                    images: n.sphere ? [
                                        n.sphere
                                    ] : [
                                        n.front,
                                        n.back,
                                        n.left,
                                        n.right,
                                        n.top,
                                        n.bottom
                                    ],
                                    depths: [],
                                    location: e1.Location
                                };
                                i.enablePreloadMasks && Cy.isCapable("ruler") && t.depths.push(n.scene_depth, n.object_ids), o.push(t);
                            }
                        }), !s) return;
                        const l = Ci.config.preloadPerPanoramaCount ?? 3;
                        o.length > l && o.sort((e1, t)=>{
                            if (Ci.config.forcePreloadNonCached) {
                                const n = Number(e1.images.every((e1)=>Ax.isCached(e1))), i = Number(t.images.every((e1)=>Ax.isCached(e1)));
                                if (n || i) return n - i;
                            }
                            return Cx(e1.location, s.Location) - Cx(t.location, s.Location);
                        });
                        const c = Math.min(l, o.length);
                        for(let e1 = 0; e1 < c; e1++){
                            const { images: t, depths: n } = o[e1];
                            t.forEach((e1)=>Ax.cacheTexture(e1)), n.forEach((e1)=>Ax.cacheDepth(e1));
                        }
                    })(Ci.config.json, t.panoramaId);
                }), t.visible = !1, this.add(t), t;
            }
        };
        const KS = class extends Qp {
            constructor(){
                var e1, t, n;
                super({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                }), e1 = this, n = void 0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "currentVrSession")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.toneMapping = Jr, this.toneMappingExposure = 1, this.setPixelRatio(window.devicePixelRatio), this.setClearColor(new qc(0), 0), this.setClearAlpha(1), this.xr.setReferenceSpaceType("local"), this.xr.enabled = !0;
            }
            async checkVrSessionSupport() {
                try {
                    return await navigator.xr.isSessionSupported("immersive-vr");
                } catch (e1) {
                    return !1;
                }
            }
            async onSessionStarted(e1) {
                e1.addEventListener("end", this.onSessionEnded.bind(this)), await this.xr.setSession(e1), this.xr.setFoveation(0), this.currentVrSession = e1;
            }
            onSessionEnded() {
                this.currentVrSession.removeEventListener("end", this.onSessionEnded.bind(this)), this.currentVrSession = null;
            }
            async enterVR() {
                return await navigator.xr.requestSession("immersive-vr", {
                    optionalFeatures: [
                        "local-floor",
                        "bounded-floor",
                        "hand-tracking",
                        "layers"
                    ]
                }).then(this.onSessionStarted.bind(this));
            }
            async exitVR() {
                if (this.currentVrSession) return await this.xr.getSession().end();
            }
        };
        function JS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const $S = class {
            constructor(e1, t){
                JS(this, "deviceOrientation", {}), JS(this, "screenOrientation", 0), JS(this, "alphaOffsetAngle", 0), JS(this, "connected", !1), JS(this, "enabled", !1), JS(this, "domElement", void 0), JS(this, "alpha", 0), JS(this, "tempX", 0), JS(this, "tempY", 0), JS(this, "rotY", 0), JS(this, "rotX", 0), JS(this, "camera", void 0), this.camera = e1, this.camera.rotation.reorder("YXZ"), this.domElement = t || document;
            }
            enable() {
                this.enabled = !0;
            }
            disable() {
                this.enabled = !1;
            }
            connect() {
                this.onScreenOrientationChange(), window.addEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.update.bind(this)), this.domElement.addEventListener("touchstart", this.onTouchStart.bind(this)), this.domElement.addEventListener("touchmove", this.onTouchMove.bind(this)), this.connected = !0;
            }
            disconnect() {
                window.removeEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.update.bind(this)), this.domElement.removeEventListener("touchstart", this.onTouchStart), this.domElement.removeEventListener("touchmove", this.onTouchMove), this.connected = !1;
            }
            onDeviceOrientationChange(e1) {
                this.deviceOrientation = e1;
            }
            onScreenOrientationChange() {
                this.screenOrientation = window.orientation || 0;
            }
            onTouchStart(e1) {
                e1.preventDefault(), e1.stopPropagation(), this.tempX = e1.touches[0].pageX, this.tempY = e1.touches[0].pageY;
            }
            onTouchMove(e1) {
                e1.preventDefault(), e1.stopPropagation(), this.rotY += Ix((e1.touches[0].pageX - this.tempX) / 4), this.rotX += Ix((this.tempY - e1.touches[0].pageY) / 4), this.updateAlphaOffsetAngle(this.rotY), this.tempX = e1.touches[0].pageX, this.tempY = e1.touches[0].pageY;
            }
            setCameraQuaternion(e1, t, n, i, r) {
                const a = new Ll(0, 0, 1), s = new Mc, o = new Cl, l = new Cl(-Math.sqrt(.5), 0, 0, Math.sqrt(.5)), c = new Cl, u = new Cl;
                let h = null;
                0 === this.screenOrientation ? (h = new Ll(1, 0, 0), c.setFromAxisAngle(h, -this.rotX)) : 180 === this.screenOrientation ? (h = new Ll(1, 0, 0), c.setFromAxisAngle(h, this.rotX)) : 90 === this.screenOrientation ? (h = new Ll(0, 1, 0), c.setFromAxisAngle(h, this.rotX)) : -90 === this.screenOrientation && (h = new Ll(0, 1, 0), c.setFromAxisAngle(h, -this.rotX)), l.multiply(c), l.multiply(u), s.set(n, t, -i, "YXZ"), e1.setFromEuler(s), e1.multiply(l), e1.multiply(o.setFromAxisAngle(a, -r));
            }
            updateAlphaOffsetAngle(e1) {
                this.alphaOffsetAngle = e1, this.update();
            }
            update() {
                if (!1 === this.enabled) return;
                const e1 = this.deviceOrientation.alpha ? Ix(this.deviceOrientation.alpha + 90) + this.alphaOffsetAngle : 0, t = this.deviceOrientation.beta ? Ix(this.deviceOrientation.beta) : 0, n = this.deviceOrientation.gamma ? Ix(this.deviceOrientation.gamma) : 0, i = this.screenOrientation ? Ix(this.screenOrientation) : 0;
                this.setCameraQuaternion(this.camera.quaternion, e1, t, n, i), this.alpha = e1;
            }
            dispose() {
                this.disconnect();
            }
        }, eI = Object.freeze({
            NONE: 0,
            ROTATE: 1,
            TRUCK: 2,
            OFFSET: 4,
            DOLLY: 8,
            ZOOM: 16,
            TOUCH_ROTATE: 32,
            TOUCH_TRUCK: 64,
            TOUCH_OFFSET: 128,
            TOUCH_DOLLY: 256,
            TOUCH_ZOOM: 512,
            TOUCH_DOLLY_TRUCK: 1024,
            TOUCH_DOLLY_OFFSET: 2048,
            TOUCH_DOLLY_ROTATE: 4096,
            TOUCH_ZOOM_TRUCK: 8192,
            TOUCH_ZOOM_OFFSET: 16384,
            TOUCH_ZOOM_ROTATE: 32768
        });
        function tI(e1) {
            return e1.isPerspectiveCamera;
        }
        function nI(e1) {
            return e1.isOrthographicCamera;
        }
        const iI = 2 * Math.PI, rI = Math.PI / 2, aI = 1e-5, sI = Math.PI / 180;
        function oI(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        function lI(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : aI;
            return Math.abs(e1) < t;
        }
        function cI(e1, t) {
            return lI(e1 - t, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : aI);
        }
        function uI(e1, t) {
            return Math.round(e1 / t) * t;
        }
        function hI(e1) {
            return isFinite(e1) ? e1 : e1 < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
        }
        function dI(e1) {
            return Math.abs(e1) < Number.MAX_VALUE ? e1 : e1 * (1 / 0);
        }
        function pI(e1, t, n, i) {
            let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1 / 0, a = arguments.length > 5 ? arguments[5] : void 0;
            const s = 2 / (i = Math.max(1e-4, i)), o = s * a, l = 1 / (1 + o + .48 * o * o + .235 * o * o * o);
            let c = e1 - t;
            const u = t, h = r * i;
            c = oI(c, -h, h), t = e1 - c;
            const d = (n.value + s * c) * a;
            n.value = (n.value - s * d) * l;
            let p = t + (c + d) * l;
            return u - e1 > 0 == p > u && (p = u, n.value = (p - u) / a), p;
        }
        function fI(e1, t, n, i) {
            let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1 / 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 ? arguments[6] : void 0;
            const o = 2 / (i = Math.max(1e-4, i)), l = o * a, c = 1 / (1 + l + .48 * l * l + .235 * l * l * l);
            let u = t.x, h = t.y, d = t.z, p = e1.x - u, f = e1.y - h, g = e1.z - d;
            const m = u, A = h, M = d, v = r * i, y = p * p + f * f + g * g;
            if (y > v * v) {
                const e1 = Math.sqrt(y);
                p = p / e1 * v, f = f / e1 * v, g = g / e1 * v;
            }
            u = e1.x - p, h = e1.y - f, d = e1.z - g;
            const x = (n.x + o * p) * a, b = (n.y + o * f) * a, w = (n.z + o * g) * a;
            n.x = (n.x - o * x) * c, n.y = (n.y - o * b) * c, n.z = (n.z - o * w) * c, s.x = u + (p + x) * c, s.y = h + (f + b) * c, s.z = d + (g + w) * c;
            const E = m - e1.x, T = A - e1.y, S = M - e1.z;
            return E * (s.x - m) + T * (s.y - A) + S * (s.z - M) > 0 && (s.x = m, s.y = A, s.z = M, n.x = (s.x - m) / a, n.y = (s.y - A) / a, n.z = (s.z - M) / a), s;
        }
        function gI(e1, t) {
            t.set(0, 0), e1.forEach((e1)=>{
                t.x += e1.clientX, t.y += e1.clientY;
            }), t.x /= e1.length, t.y /= e1.length;
        }
        function mI(e1, t) {
            return !!nI(e1) && (console.warn(`${t} is not supported in OrthographicCamera`), !0);
        }
        class AI {
            constructor(){
                this._listeners = {};
            }
            addEventListener(e1, t) {
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            removeAllEventListeners(e1) {
                e1 ? Array.isArray(this._listeners[e1]) && (this._listeners[e1].length = 0) : this._listeners = {};
            }
            dispatchEvent(e1) {
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                }
            }
        }
        var MI;
        const vI = 1 / 8, yI = /Mac/.test(null === (MI = null === globalThis || void 0 === globalThis ? void 0 : globalThis.navigator) || void 0 === MI ? void 0 : MI.platform);
        let xI, bI, wI, EI, TI, SI, II, NI, DI, _I, CI, LI, zI, OI, RI, PI, UI, jI, kI, BI, FI, HI, GI;
        class VI extends AI {
            static install(e1) {
                xI = e1.THREE, bI = Object.freeze(new xI.Vector3(0, 0, 0)), wI = Object.freeze(new xI.Vector3(0, 1, 0)), EI = Object.freeze(new xI.Vector3(0, 0, 1)), TI = new xI.Vector2, SI = new xI.Vector3, II = new xI.Vector3, NI = new xI.Vector3, DI = new xI.Vector3, _I = new xI.Vector3, CI = new xI.Vector3, LI = new xI.Vector3, zI = new xI.Vector3, OI = new xI.Vector3, RI = new xI.Spherical, PI = new xI.Spherical, UI = new xI.Box3, jI = new xI.Box3, kI = new xI.Sphere, BI = new xI.Quaternion, FI = new xI.Quaternion, HI = new xI.Matrix4, GI = new xI.Raycaster;
            }
            static get ACTION() {
                return eI;
            }
            constructor(e1, t){
                super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = .01, this.maxZoom = 1 / 0, this.smoothTime = .25, this.draggingSmoothTime = .125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.verticalDragToForward = !1, this.boundaryFriction = 0, this.restThreshold = .01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = eI.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect, this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = 0, this._thetaVelocity = {
                    value: 0
                }, this._phiVelocity = {
                    value: 0
                }, this._radiusVelocity = {
                    value: 0
                }, this._targetVelocity = new xI.Vector3, this._focalOffsetVelocity = new xI.Vector3, this._zoomVelocity = {
                    value: 0
                }, this._truckInternal = (e1, t, n)=>{
                    let i, r;
                    if (tI(this._camera)) {
                        const n = SI.copy(this._camera.position).sub(this._target), a = this._camera.getEffectiveFOV() * sI, s = n.length() * Math.tan(.5 * a);
                        i = this.truckSpeed * e1 * s / this._elementRect.height, r = this.truckSpeed * t * s / this._elementRect.height;
                    } else {
                        if (!nI(this._camera)) return;
                        {
                            const n = this._camera;
                            i = e1 * (n.right - n.left) / n.zoom / this._elementRect.width, r = t * (n.top - n.bottom) / n.zoom / this._elementRect.height;
                        }
                    }
                    this.verticalDragToForward ? (n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(i, 0, !0), this.forward(-r, !0)) : n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y + r, this._focalOffsetEnd.z, !0) : this.truck(i, r, !0);
                }, this._rotateInternal = (e1, t)=>{
                    const n = iI * this.azimuthRotateSpeed * e1 / this._elementRect.height, i = iI * this.polarRotateSpeed * t / this._elementRect.height;
                    this.rotate(n, i, !0);
                }, this._dollyInternal = (e1, t, n)=>{
                    const i = Math.pow(.95, -e1 * this.dollySpeed), r = this._sphericalEnd.radius, a = this._sphericalEnd.radius * i, s = oI(a, this.minDistance, this.maxDistance), o = s - a;
                    this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(a, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(o, !0), this._dollyToNoClamp(s, !0)) : this._dollyToNoClamp(s, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? a : s) - r, this._dollyControlCoord.set(t, n)), this._lastDollyDirection = Math.sign(-e1);
                }, this._zoomInternal = (e1, t, n)=>{
                    const i = Math.pow(.95, e1 * this.dollySpeed), r = this._zoom, a = this._zoom * i;
                    this.zoomTo(a, !0), this.dollyToCursor && (this._changedZoom += a - r, this._dollyControlCoord.set(t, n));
                }, void 0 === xI && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = e1, this._yAxisUpSpace = (new xI.Quaternion).setFromUnitVectors(this._camera.up, wI), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = eI.NONE, this._target = new xI.Vector3, this._targetEnd = this._target.clone(), this._focalOffset = new xI.Vector3, this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = (new xI.Spherical).setFromVector3(SI.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
                    new xI.Vector3,
                    new xI.Vector3,
                    new xI.Vector3,
                    new xI.Vector3
                ], this._updateNearPlaneCorners(), this._boundary = new xI.Box3(new xI.Vector3(-1 / 0, -1 / 0, -1 / 0), new xI.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new xI.Vector2, this.mouseButtons = {
                    left: eI.ROTATE,
                    middle: eI.DOLLY,
                    right: eI.TRUCK,
                    wheel: tI(this._camera) ? eI.DOLLY : nI(this._camera) ? eI.ZOOM : eI.NONE
                }, this.touches = {
                    one: eI.TOUCH_ROTATE,
                    two: tI(this._camera) ? eI.TOUCH_DOLLY_TRUCK : nI(this._camera) ? eI.TOUCH_ZOOM_TRUCK : eI.NONE,
                    three: eI.TOUCH_TRUCK
                };
                const n = new xI.Vector2, i = new xI.Vector2, r = new xI.Vector2, a = (e1)=>{
                    if (!this._enabled || !this._domElement) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const t = this._domElement.getBoundingClientRect(), n = e1.clientX / t.width, i = e1.clientY / t.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    const t = "mouse" !== e1.pointerType ? null : 1 & ~e1.buttons ? 4 & ~e1.buttons ? 2 & ~e1.buttons ? null : 2 : 4 : 1;
                    if (null !== t) {
                        const e1 = this._findPointerByMouseButton(t);
                        e1 && this._disposePointer(e1);
                    }
                    if (!(1 & ~e1.buttons) && this._lockedPointer) return;
                    const n = {
                        pointerId: e1.pointerId,
                        clientX: e1.clientX,
                        clientY: e1.clientY,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: t
                    };
                    this._activePointers.push(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), this._isDragging = !0, h(e1);
                }, s = (e1)=>{
                    e1.cancelable && e1.preventDefault();
                    const t = e1.pointerId, n = this._lockedPointer || this._findPointerById(t);
                    if (n) {
                        if (n.clientX = e1.clientX, n.clientY = e1.clientY, n.deltaX = e1.movementX, n.deltaY = e1.movementY, this._state = 0, "touch" === e1.pointerType) switch(this._activePointers.length){
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else (!this._isDragging && this._lockedPointer || this._isDragging && !(1 & ~e1.buttons)) && (this._state = this._state | this.mouseButtons.left), this._isDragging && !(4 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.middle), this._isDragging && !(2 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        d();
                    }
                }, o = (e1)=>{
                    const t = this._findPointerById(e1.pointerId);
                    if (!t || t !== this._lockedPointer) {
                        if (t && this._disposePointer(t), "touch" === e1.pointerType) switch(this._activePointers.length){
                            case 0:
                                this._state = eI.NONE;
                                break;
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else this._state = eI.NONE;
                        p();
                    }
                };
                let l = -1;
                const c = (e1)=>{
                    if (!this._domElement) return;
                    if (!this._enabled || this.mouseButtons.wheel === eI.NONE) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const t = this._domElement.getBoundingClientRect(), n = e1.clientX / t.width, i = e1.clientY / t.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    if (e1.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === eI.ROTATE || this.mouseButtons.wheel === eI.TRUCK) {
                        const e1 = performance.now();
                        l - e1 < 1e3 && this._getClientRect(this._elementRect), l = e1;
                    }
                    const t = yI ? -1 : -3, n = 1 === e1.deltaMode ? e1.deltaY / t : e1.deltaY / (10 * t), i = this.dollyToCursor ? (e1.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, r = this.dollyToCursor ? (e1.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                    switch(this.mouseButtons.wheel){
                        case eI.ROTATE:
                            this._rotateInternal(e1.deltaX, e1.deltaY), this._isUserControllingRotate = !0;
                            break;
                        case eI.TRUCK:
                            this._truckInternal(e1.deltaX, e1.deltaY, !1), this._isUserControllingTruck = !0;
                            break;
                        case eI.OFFSET:
                            this._truckInternal(e1.deltaX, e1.deltaY, !0), this._isUserControllingOffset = !0;
                            break;
                        case eI.DOLLY:
                            this._dollyInternal(-n, i, r), this._isUserControllingDolly = !0;
                            break;
                        case eI.ZOOM:
                            this._zoomInternal(-n, i, r), this._isUserControllingZoom = !0;
                    }
                    this.dispatchEvent({
                        type: "control"
                    });
                }, u = (e1)=>{
                    if (this._domElement && this._enabled) {
                        if (this.mouseButtons.right === VI.ACTION.NONE) {
                            const t = e1 instanceof PointerEvent ? e1.pointerId : 0, n = this._findPointerById(t);
                            return n && this._disposePointer(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                                passive: !1
                            }), void this._domElement.ownerDocument.removeEventListener("pointerup", o);
                        }
                        e1.preventDefault();
                    }
                }, h = (e1)=>{
                    if (this._enabled) {
                        if (gI(this._activePointers, TI), this._getClientRect(this._elementRect), n.copy(TI), i.copy(TI), this._activePointers.length >= 2) {
                            const e1 = TI.x - this._activePointers[1].clientX, t = TI.y - this._activePointers[1].clientY, n = Math.sqrt(e1 * e1 + t * t);
                            r.set(0, n);
                            const a = .5 * (this._activePointers[0].clientX + this._activePointers[1].clientX), s = .5 * (this._activePointers[0].clientY + this._activePointers[1].clientY);
                            i.set(a, s);
                        }
                        if (this._state = 0, e1) {
                            if ("pointerType" in e1 && "touch" === e1.pointerType) switch(this._activePointers.length){
                                case 1:
                                    this._state = this.touches.one;
                                    break;
                                case 2:
                                    this._state = this.touches.two;
                                    break;
                                case 3:
                                    this._state = this.touches.three;
                            }
                            else this._lockedPointer || !!(1 & ~e1.buttons) || (this._state = this._state | this.mouseButtons.left), !(4 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.middle), !(2 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        } else this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
                        (this._state & eI.ROTATE) !== eI.ROTATE && (this._state & eI.TOUCH_ROTATE) !== eI.TOUCH_ROTATE && (this._state & eI.TOUCH_DOLLY_ROTATE) !== eI.TOUCH_DOLLY_ROTATE && (this._state & eI.TOUCH_ZOOM_ROTATE) !== eI.TOUCH_ZOOM_ROTATE || (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), (this._state & eI.TRUCK) !== eI.TRUCK && (this._state & eI.TOUCH_TRUCK) !== eI.TOUCH_TRUCK && (this._state & eI.TOUCH_DOLLY_TRUCK) !== eI.TOUCH_DOLLY_TRUCK && (this._state & eI.TOUCH_ZOOM_TRUCK) !== eI.TOUCH_ZOOM_TRUCK || (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), (this._state & eI.DOLLY) !== eI.DOLLY && (this._state & eI.TOUCH_DOLLY) !== eI.TOUCH_DOLLY && (this._state & eI.TOUCH_DOLLY_TRUCK) !== eI.TOUCH_DOLLY_TRUCK && (this._state & eI.TOUCH_DOLLY_OFFSET) !== eI.TOUCH_DOLLY_OFFSET && (this._state & eI.TOUCH_DOLLY_ROTATE) !== eI.TOUCH_DOLLY_ROTATE || (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), (this._state & eI.ZOOM) !== eI.ZOOM && (this._state & eI.TOUCH_ZOOM) !== eI.TOUCH_ZOOM && (this._state & eI.TOUCH_ZOOM_TRUCK) !== eI.TOUCH_ZOOM_TRUCK && (this._state & eI.TOUCH_ZOOM_OFFSET) !== eI.TOUCH_ZOOM_OFFSET && (this._state & eI.TOUCH_ZOOM_ROTATE) !== eI.TOUCH_ZOOM_ROTATE || (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), (this._state & eI.OFFSET) !== eI.OFFSET && (this._state & eI.TOUCH_OFFSET) !== eI.TOUCH_OFFSET && (this._state & eI.TOUCH_DOLLY_OFFSET) !== eI.TOUCH_DOLLY_OFFSET && (this._state & eI.TOUCH_ZOOM_OFFSET) !== eI.TOUCH_ZOOM_OFFSET || (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                            type: "controlstart"
                        });
                    }
                }, d = ()=>{
                    if (!this._enabled || !this._dragNeedsUpdate) return;
                    this._dragNeedsUpdate = !1, gI(this._activePointers, TI);
                    const e1 = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, t = e1 ? -e1.deltaX : i.x - TI.x, a = e1 ? -e1.deltaY : i.y - TI.y;
                    if (i.copy(TI), (this._state & eI.ROTATE) !== eI.ROTATE && (this._state & eI.TOUCH_ROTATE) !== eI.TOUCH_ROTATE && (this._state & eI.TOUCH_DOLLY_ROTATE) !== eI.TOUCH_DOLLY_ROTATE && (this._state & eI.TOUCH_ZOOM_ROTATE) !== eI.TOUCH_ZOOM_ROTATE || (this._rotateInternal(t, a), this._isUserControllingRotate = !0), (this._state & eI.DOLLY) === eI.DOLLY || (this._state & eI.ZOOM) === eI.ZOOM) {
                        const e1 = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, t = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, i = this.dollyDragInverted ? -1 : 1;
                        (this._state & eI.DOLLY) === eI.DOLLY ? (this._dollyInternal(i * a * vI, e1, t), this._isUserControllingDolly = !0) : (this._zoomInternal(i * a * vI, e1, t), this._isUserControllingZoom = !0);
                    }
                    if ((this._state & eI.TOUCH_DOLLY) === eI.TOUCH_DOLLY || (this._state & eI.TOUCH_ZOOM) === eI.TOUCH_ZOOM || (this._state & eI.TOUCH_DOLLY_TRUCK) === eI.TOUCH_DOLLY_TRUCK || (this._state & eI.TOUCH_ZOOM_TRUCK) === eI.TOUCH_ZOOM_TRUCK || (this._state & eI.TOUCH_DOLLY_OFFSET) === eI.TOUCH_DOLLY_OFFSET || (this._state & eI.TOUCH_ZOOM_OFFSET) === eI.TOUCH_ZOOM_OFFSET || (this._state & eI.TOUCH_DOLLY_ROTATE) === eI.TOUCH_DOLLY_ROTATE || (this._state & eI.TOUCH_ZOOM_ROTATE) === eI.TOUCH_ZOOM_ROTATE) {
                        const e1 = TI.x - this._activePointers[1].clientX, t = TI.y - this._activePointers[1].clientY, n = Math.sqrt(e1 * e1 + t * t), a = r.y - n;
                        r.set(0, n);
                        const s = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, o = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                        (this._state & eI.TOUCH_DOLLY) === eI.TOUCH_DOLLY || (this._state & eI.TOUCH_DOLLY_ROTATE) === eI.TOUCH_DOLLY_ROTATE || (this._state & eI.TOUCH_DOLLY_TRUCK) === eI.TOUCH_DOLLY_TRUCK || (this._state & eI.TOUCH_DOLLY_OFFSET) === eI.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(a * vI, s, o), this._isUserControllingDolly = !0) : (this._zoomInternal(a * vI, s, o), this._isUserControllingZoom = !0);
                    }
                    (this._state & eI.TRUCK) !== eI.TRUCK && (this._state & eI.TOUCH_TRUCK) !== eI.TOUCH_TRUCK && (this._state & eI.TOUCH_DOLLY_TRUCK) !== eI.TOUCH_DOLLY_TRUCK && (this._state & eI.TOUCH_ZOOM_TRUCK) !== eI.TOUCH_ZOOM_TRUCK || (this._truckInternal(t, a, !1), this._isUserControllingTruck = !0), (this._state & eI.OFFSET) !== eI.OFFSET && (this._state & eI.TOUCH_OFFSET) !== eI.TOUCH_OFFSET && (this._state & eI.TOUCH_DOLLY_OFFSET) !== eI.TOUCH_DOLLY_OFFSET && (this._state & eI.TOUCH_ZOOM_OFFSET) !== eI.TOUCH_ZOOM_OFFSET || (this._truckInternal(t, a, !0), this._isUserControllingOffset = !0), this.dispatchEvent({
                        type: "control"
                    });
                }, p = ()=>{
                    gI(this._activePointers, TI), i.copy(TI), this._dragNeedsUpdate = !1, (0 === this._activePointers.length || 1 === this._activePointers.length && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), 0 === this._activePointers.length && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this.dispatchEvent({
                        type: "controlend"
                    }));
                };
                this.lockPointer = ()=>{
                    this._enabled && this._domElement && (this.cancel(), this._lockedPointer = {
                        pointerId: -1,
                        clientX: 0,
                        clientY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: null
                    }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", f), this._domElement.ownerDocument.addEventListener("pointerlockerror", g), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), h());
                }, this.unlockPointer = ()=>{
                    var e1, t, n;
                    null !== this._lockedPointer && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), null === (e1 = this._domElement) || void 0 === e1 || e1.ownerDocument.exitPointerLock(), null === (t = this._domElement) || void 0 === t || t.ownerDocument.removeEventListener("pointerlockchange", f), null === (n = this._domElement) || void 0 === n || n.ownerDocument.removeEventListener("pointerlockerror", g), this.cancel();
                };
                const f = ()=>{
                    this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
                }, g = ()=>{
                    this.unlockPointer();
                };
                this._addAllEventListeners = (e1)=>{
                    this._domElement = e1, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", o), this._domElement.addEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.addEventListener("contextmenu", u);
                }, this._removeAllEventListeners = ()=>{
                    this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", o), this._domElement.removeEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.removeEventListener("contextmenu", u), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.removeEventListener("pointerlockchange", f), this._domElement.ownerDocument.removeEventListener("pointerlockerror", g));
                }, this.cancel = ()=>{
                    this._state !== eI.NONE && (this._state = eI.NONE, this._activePointers.length = 0, p());
                }, t && this.connect(t), this.update(0);
            }
            get camera() {
                return this._camera;
            }
            set camera(e1) {
                this._camera = e1, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(e1) {
                this._enabled = e1, this._domElement && (e1 ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
            }
            get active() {
                return !this._hasRested;
            }
            get currentAction() {
                return this._state;
            }
            get distance() {
                return this._spherical.radius;
            }
            set distance(e1) {
                this._spherical.radius === e1 && this._sphericalEnd.radius === e1 || (this._spherical.radius = e1, this._sphericalEnd.radius = e1, this._needsUpdate = !0);
            }
            get azimuthAngle() {
                return this._spherical.theta;
            }
            set azimuthAngle(e1) {
                this._spherical.theta === e1 && this._sphericalEnd.theta === e1 || (this._spherical.theta = e1, this._sphericalEnd.theta = e1, this._needsUpdate = !0);
            }
            get polarAngle() {
                return this._spherical.phi;
            }
            set polarAngle(e1) {
                this._spherical.phi === e1 && this._sphericalEnd.phi === e1 || (this._spherical.phi = e1, this._sphericalEnd.phi = e1, this._needsUpdate = !0);
            }
            get boundaryEnclosesCamera() {
                return this._boundaryEnclosesCamera;
            }
            set boundaryEnclosesCamera(e1) {
                this._boundaryEnclosesCamera = e1, this._needsUpdate = !0;
            }
            set interactiveArea(e1) {
                this._interactiveArea.width = oI(e1.width, 0, 1), this._interactiveArea.height = oI(e1.height, 0, 1), this._interactiveArea.x = oI(e1.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = oI(e1.y, 0, 1 - this._interactiveArea.height);
            }
            addEventListener(e1, t) {
                super.addEventListener(e1, t);
            }
            removeEventListener(e1, t) {
                super.removeEventListener(e1, t);
            }
            rotate(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return this.rotateTo(this._sphericalEnd.theta + e1, this._sphericalEnd.phi + t, n);
            }
            rotateAzimuthTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.rotateTo(e1, this._sphericalEnd.phi, t);
            }
            rotatePolarTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.rotateTo(this._sphericalEnd.theta, e1, t);
            }
            rotateTo(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                this._isUserControllingRotate = !1;
                const i = oI(e1, this.minAzimuthAngle, this.maxAzimuthAngle), r = oI(t, this.minPolarAngle, this.maxPolarAngle);
                this._sphericalEnd.theta = i, this._sphericalEnd.phi = r, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, n || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
                const a = !n || cI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && cI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            dolly(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.dollyTo(this._sphericalEnd.radius - e1, t);
            }
            dollyTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this._isUserControllingDolly = !1, this._lastDollyDirection = 0, this._changedDolly = 0, this._dollyToNoClamp(oI(e1, this.minDistance, this.maxDistance), t);
            }
            _dollyToNoClamp(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = this._sphericalEnd.radius;
                if (this.colliderMeshes.length >= 1) {
                    const t = this._collisionTest(), i = cI(t, this._spherical.radius);
                    if (!(n > e1) && i) return Promise.resolve();
                    this._sphericalEnd.radius = Math.min(e1, t);
                } else this._sphericalEnd.radius = e1;
                this._needsUpdate = !0, t || (this._spherical.radius = this._sphericalEnd.radius);
                const i = !t || cI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(i);
            }
            dollyInFixed(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this._targetEnd.add(this._getCameraDirection(DI).multiplyScalar(e1)), t || this._target.copy(this._targetEnd);
                const n = !t || cI(this._target.x, this._targetEnd.x, this.restThreshold) && cI(this._target.y, this._targetEnd.y, this.restThreshold) && cI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(n);
            }
            zoom(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.zoomTo(this._zoomEnd + e1, t);
            }
            zoomTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this._isUserControllingZoom = !1, this._zoomEnd = oI(e1, this.minZoom, this.maxZoom), this._needsUpdate = !0, t || (this._zoom = this._zoomEnd);
                const n = !t || cI(this._zoom, this._zoomEnd, this.restThreshold);
                return this._changedZoom = 0, this._createOnRestPromise(n);
            }
            pan(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return console.warn("`pan` has been renamed to `truck`"), this.truck(e1, t, n);
            }
            truck(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                this._camera.updateMatrix(), _I.setFromMatrixColumn(this._camera.matrix, 0), CI.setFromMatrixColumn(this._camera.matrix, 1), _I.multiplyScalar(e1), CI.multiplyScalar(-t);
                const i = SI.copy(_I).add(CI), r = II.copy(this._targetEnd).add(i);
                return this.moveTo(r.x, r.y, r.z, n);
            }
            forward(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                SI.setFromMatrixColumn(this._camera.matrix, 0), SI.crossVectors(this._camera.up, SI), SI.multiplyScalar(e1);
                const n = II.copy(this._targetEnd).add(SI);
                return this.moveTo(n.x, n.y, n.z, t);
            }
            elevate(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return SI.copy(this._camera.up).multiplyScalar(e1), this.moveTo(this._targetEnd.x + SI.x, this._targetEnd.y + SI.y, this._targetEnd.z + SI.z, t);
            }
            moveTo(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this._isUserControllingTruck = !1;
                const r = SI.set(e1, t, n).sub(this._targetEnd);
                this._encloseToBoundary(this._targetEnd, r, this.boundaryFriction), this._needsUpdate = !0, i || this._target.copy(this._targetEnd);
                const a = !i || cI(this._target.x, this._targetEnd.x, this.restThreshold) && cI(this._target.y, this._targetEnd.y, this.restThreshold) && cI(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            lookInDirectionOf(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                const r = SI.set(e1, t, n).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
                return this.setPosition(r.x, r.y, r.z, i);
            }
            fitToBox(e1, t) {
                let { cover: n = !1, paddingLeft: i = 0, paddingRight: r = 0, paddingBottom: a = 0, paddingTop: s = 0 } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                const o = [], l = e1.isBox3 ? UI.copy(e1) : UI.setFromObject(e1);
                l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
                const c = uI(this._sphericalEnd.theta, rI), u = uI(this._sphericalEnd.phi, rI);
                o.push(this.rotateTo(c, u, t));
                const h = SI.setFromSpherical(this._sphericalEnd).normalize(), d = BI.setFromUnitVectors(h, EI), p = cI(Math.abs(h.y), 1);
                p && d.multiply(FI.setFromAxisAngle(wI, c)), d.multiply(this._yAxisUpSpaceInverse);
                const f = jI.makeEmpty();
                II.copy(l.min).applyQuaternion(d), f.expandByPoint(II), II.copy(l.min).setX(l.max.x).applyQuaternion(d), f.expandByPoint(II), II.copy(l.min).setY(l.max.y).applyQuaternion(d), f.expandByPoint(II), II.copy(l.max).setZ(l.min.z).applyQuaternion(d), f.expandByPoint(II), II.copy(l.min).setZ(l.max.z).applyQuaternion(d), f.expandByPoint(II), II.copy(l.max).setY(l.min.y).applyQuaternion(d), f.expandByPoint(II), II.copy(l.max).setX(l.min.x).applyQuaternion(d), f.expandByPoint(II), II.copy(l.max).applyQuaternion(d), f.expandByPoint(II), f.min.x -= i, f.min.y -= a, f.max.x += r, f.max.y += s, d.setFromUnitVectors(EI, h), p && d.premultiply(FI.invert()), d.premultiply(this._yAxisUpSpace);
                const g = f.getSize(SI), m = f.getCenter(II).applyQuaternion(d);
                if (tI(this._camera)) {
                    const e1 = this.getDistanceToFitBox(g.x, g.y, g.z, n);
                    o.push(this.moveTo(m.x, m.y, m.z, t)), o.push(this.dollyTo(e1, t)), o.push(this.setFocalOffset(0, 0, 0, t));
                } else if (nI(this._camera)) {
                    const e1 = this._camera, i = e1.right - e1.left, r = e1.top - e1.bottom, a = n ? Math.max(i / g.x, r / g.y) : Math.min(i / g.x, r / g.y);
                    o.push(this.moveTo(m.x, m.y, m.z, t)), o.push(this.zoomTo(a, t)), o.push(this.setFocalOffset(0, 0, 0, t));
                }
                return Promise.all(o);
            }
            fitToSphere(e1, t) {
                const n = [], i = "isObject3D" in e1 ? VI.createBoundingSphere(e1, kI) : kI.copy(e1);
                if (n.push(this.moveTo(i.center.x, i.center.y, i.center.z, t)), tI(this._camera)) {
                    const e1 = this.getDistanceToFitSphere(i.radius);
                    n.push(this.dollyTo(e1, t));
                } else if (nI(this._camera)) {
                    const e1 = this._camera.right - this._camera.left, r = this._camera.top - this._camera.bottom, a = 2 * i.radius, s = Math.min(e1 / a, r / a);
                    n.push(this.zoomTo(s, t));
                }
                return n.push(this.setFocalOffset(0, 0, 0, t)), Promise.all(n);
            }
            setLookAt(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6];
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const o = II.set(i, r, a), l = SI.set(e1, t, n);
                this._targetEnd.copy(o), this._sphericalEnd.setFromVector3(l.sub(o).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, s || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const c = !s || cI(this._target.x, this._targetEnd.x, this.restThreshold) && cI(this._target.y, this._targetEnd.y, this.restThreshold) && cI(this._target.z, this._targetEnd.z, this.restThreshold) && cI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && cI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && cI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(c);
            }
            lerpLookAt(e1, t, n, i, r, a, s, o, l, c, u, h, d) {
                let p = arguments.length > 13 && void 0 !== arguments[13] && arguments[13];
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const f = SI.set(i, r, a), g = II.set(e1, t, n);
                RI.setFromVector3(g.sub(f).applyQuaternion(this._yAxisUpSpace));
                const m = NI.set(c, u, h), A = II.set(s, o, l);
                PI.setFromVector3(A.sub(m).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(f.lerp(m, d));
                const M = PI.theta - RI.theta, v = PI.phi - RI.phi, y = PI.radius - RI.radius;
                this._sphericalEnd.set(RI.radius + y * d, RI.phi + v * d, RI.theta + M * d), this.normalizeRotations(), this._needsUpdate = !0, p || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const x = !p || cI(this._target.x, this._targetEnd.x, this.restThreshold) && cI(this._target.y, this._targetEnd.y, this.restThreshold) && cI(this._target.z, this._targetEnd.z, this.restThreshold) && cI(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && cI(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && cI(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(x);
            }
            setPosition(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                return this.setLookAt(e1, t, n, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, i);
            }
            setTarget(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                const r = this.getPosition(SI), a = this.setLookAt(r.x, r.y, r.z, e1, t, n, i);
                return this._sphericalEnd.phi = oI(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
            }
            setFocalOffset(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this._isUserControllingOffset = !1, this._focalOffsetEnd.set(e1, t, n), this._needsUpdate = !0, i || this._focalOffset.copy(this._focalOffsetEnd);
                const r = !i || cI(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && cI(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && cI(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
                return this._createOnRestPromise(r);
            }
            setOrbitPoint(e1, t, n) {
                this._camera.updateMatrixWorld(), _I.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), CI.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), LI.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
                const i = SI.set(e1, t, n), r = i.distanceTo(this._camera.position), a = i.sub(this._camera.position);
                _I.multiplyScalar(a.x), CI.multiplyScalar(a.y), LI.multiplyScalar(a.z), SI.copy(_I).add(CI).add(LI), SI.z = SI.z + r, this.dollyTo(r, !1), this.setFocalOffset(-SI.x, SI.y, -SI.z, !1), this.moveTo(e1, t, n, !1);
            }
            setBoundary(e1) {
                if (!e1) return this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), void (this._needsUpdate = !0);
                this._boundary.copy(e1), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
            }
            setViewport(e1, t, n, i) {
                null !== e1 ? (this._viewport = this._viewport || new xI.Vector4, "number" == typeof e1 ? this._viewport.set(e1, t, n, i) : this._viewport.copy(e1)) : this._viewport = null;
            }
            getDistanceToFitBox(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                if (mI(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
                const r = e1 / t, a = this._camera.getEffectiveFOV() * sI, s = this._camera.aspect;
                return .5 * ((i ? r > s : r < s) ? t : e1 / s) / Math.tan(.5 * a) + .5 * n;
            }
            getDistanceToFitSphere(e1) {
                if (mI(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
                const t = this._camera.getEffectiveFOV() * sI, n = 2 * Math.atan(Math.tan(.5 * t) * this._camera.aspect), i = 1 < this._camera.aspect ? t : n;
                return e1 / Math.sin(.5 * i);
            }
            getTarget(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new xI.Vector3).copy(t ? this._targetEnd : this._target);
            }
            getPosition(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new xI.Vector3).setFromSpherical(t ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(t ? this._targetEnd : this._target);
            }
            getSpherical(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 || new xI.Spherical).copy(t ? this._sphericalEnd : this._spherical);
            }
            getFocalOffset(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new xI.Vector3).copy(t ? this._focalOffsetEnd : this._focalOffset);
            }
            normalizeRotations() {
                this._sphericalEnd.theta = this._sphericalEnd.theta % iI, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += iI), this._spherical.theta += iI * Math.round((this._sphericalEnd.theta - this._spherical.theta) / iI);
            }
            reset() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (!cI(this._camera.up.x, this._cameraUp0.x) || !cI(this._camera.up.y, this._cameraUp0.y) || !cI(this._camera.up.z, this._cameraUp0.z)) {
                    this._camera.up.copy(this._cameraUp0);
                    const e1 = this.getPosition(SI);
                    this.updateCameraUp(), this.setPosition(e1.x, e1.y, e1.z);
                }
                const t = [
                    this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, e1),
                    this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, e1),
                    this.zoomTo(this._zoom0, e1)
                ];
                return Promise.all(t);
            }
            saveState() {
                this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
            }
            updateCameraUp() {
                this._yAxisUpSpace.setFromUnitVectors(this._camera.up, wI), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
            }
            applyCameraUp() {
                const e1 = SI.subVectors(this._target, this._camera.position).normalize(), t = II.crossVectors(e1, this._camera.up);
                this._camera.up.crossVectors(t, e1).normalize(), this._camera.updateMatrixWorld();
                const n = this.getPosition(SI);
                this.updateCameraUp(), this.setPosition(n.x, n.y, n.z);
            }
            update(e1) {
                const t = this._sphericalEnd.theta - this._spherical.theta, n = this._sphericalEnd.phi - this._spherical.phi, i = this._sphericalEnd.radius - this._spherical.radius, r = zI.subVectors(this._targetEnd, this._target), a = OI.subVectors(this._focalOffsetEnd, this._focalOffset), s = this._zoomEnd - this._zoom;
                if (lI(t)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
                else {
                    const t = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.theta = pI(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, t, 1 / 0, e1), this._needsUpdate = !0;
                }
                if (lI(n)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
                else {
                    const t = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.phi = pI(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, t, 1 / 0, e1), this._needsUpdate = !0;
                }
                if (lI(i)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
                else {
                    const t = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.radius = pI(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, t, this.maxSpeed, e1), this._needsUpdate = !0;
                }
                if (lI(r.x) && lI(r.y) && lI(r.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
                else {
                    const t = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
                    fI(this._target, this._targetEnd, this._targetVelocity, t, this.maxSpeed, e1, this._target), this._needsUpdate = !0;
                }
                if (lI(a.x) && lI(a.y) && lI(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
                else {
                    const t = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
                    fI(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, t, this.maxSpeed, e1, this._focalOffset), this._needsUpdate = !0;
                }
                if (lI(s)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
                else {
                    const t = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
                    this._zoom = pI(this._zoom, this._zoomEnd, this._zoomVelocity, t, 1 / 0, e1);
                }
                if (this.dollyToCursor) {
                    if (tI(this._camera) && 0 !== this._changedDolly) {
                        const e1 = this._spherical.radius - this._lastDistance, t = this._camera, n = this._getCameraDirection(DI), i = SI.copy(n).cross(t.up).normalize();
                        0 === i.lengthSq() && (i.x = 1);
                        const r = II.crossVectors(i, n), a = this._sphericalEnd.radius * Math.tan(t.getEffectiveFOV() * sI * .5), s = (this._sphericalEnd.radius - e1 - this._sphericalEnd.radius) / this._sphericalEnd.radius, o = NI.copy(this._targetEnd).add(i.multiplyScalar(this._dollyControlCoord.x * a * t.aspect)).add(r.multiplyScalar(this._dollyControlCoord.y * a)), l = SI.copy(this._targetEnd).lerp(o, s), c = 1 === this._lastDollyDirection && this._spherical.radius <= this.minDistance, u = -1 === this._lastDollyDirection && this.maxDistance <= this._spherical.radius;
                        if (this.infinityDolly && (c || u)) {
                            this._sphericalEnd.radius -= e1, this._spherical.radius -= e1;
                            const t = II.copy(n).multiplyScalar(-e1);
                            l.add(t);
                        }
                        this._boundary.clampPoint(l, l);
                        const h = II.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedDolly -= e1, lI(this._changedDolly) && (this._changedDolly = 0);
                    } else if (nI(this._camera) && 0 !== this._changedZoom) {
                        const e1 = this._zoom - this._lastZoom, t = this._camera, n = SI.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (t.near + t.far) / (t.near - t.far)).unproject(t), i = II.set(0, 0, -1).applyQuaternion(t.quaternion), r = NI.copy(n).add(i.multiplyScalar(-n.dot(t.up))), a = -(this._zoom - e1 - this._zoom) / this._zoom, s = this._getCameraDirection(DI), o = this._targetEnd.dot(s), l = SI.copy(this._targetEnd).lerp(r, a), c = l.dot(s), u = s.multiplyScalar(c - o);
                        l.sub(u), this._boundary.clampPoint(l, l);
                        const h = II.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedZoom -= e1, lI(this._changedZoom) && (this._changedZoom = 0);
                    }
                }
                this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
                const o = this._collisionTest();
                this._spherical.radius = Math.min(this._spherical.radius, o), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!lI(this._focalOffset.x) || !lI(this._focalOffset.y) || !lI(this._focalOffset.z)) && (this._camera.updateMatrixWorld(), _I.setFromMatrixColumn(this._camera.matrix, 0), CI.setFromMatrixColumn(this._camera.matrix, 1), LI.setFromMatrixColumn(this._camera.matrix, 2), _I.multiplyScalar(this._focalOffset.x), CI.multiplyScalar(-this._focalOffset.y), LI.multiplyScalar(this._focalOffset.z), SI.copy(_I).add(CI).add(LI), this._camera.position.add(SI)), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), SI.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
                const l = this._needsUpdate;
                return l && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
                    type: "wake"
                }), this.dispatchEvent({
                    type: "update"
                })) : l ? (this.dispatchEvent({
                    type: "update"
                }), lI(t, this.restThreshold) && lI(n, this.restThreshold) && lI(i, this.restThreshold) && lI(r.x, this.restThreshold) && lI(r.y, this.restThreshold) && lI(r.z, this.restThreshold) && lI(a.x, this.restThreshold) && lI(a.y, this.restThreshold) && lI(a.z, this.restThreshold) && lI(s, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
                    type: "rest"
                }))) : !l && this._updatedLastTime && this.dispatchEvent({
                    type: "sleep"
                }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = l, this._needsUpdate = !1, l;
            }
            toJSON() {
                return JSON.stringify({
                    enabled: this._enabled,
                    minDistance: this.minDistance,
                    maxDistance: hI(this.maxDistance),
                    minZoom: this.minZoom,
                    maxZoom: hI(this.maxZoom),
                    minPolarAngle: this.minPolarAngle,
                    maxPolarAngle: hI(this.maxPolarAngle),
                    minAzimuthAngle: hI(this.minAzimuthAngle),
                    maxAzimuthAngle: hI(this.maxAzimuthAngle),
                    smoothTime: this.smoothTime,
                    draggingSmoothTime: this.draggingSmoothTime,
                    dollySpeed: this.dollySpeed,
                    truckSpeed: this.truckSpeed,
                    dollyToCursor: this.dollyToCursor,
                    verticalDragToForward: this.verticalDragToForward,
                    target: this._targetEnd.toArray(),
                    position: SI.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
                    zoom: this._zoomEnd,
                    focalOffset: this._focalOffsetEnd.toArray(),
                    target0: this._target0.toArray(),
                    position0: this._position0.toArray(),
                    zoom0: this._zoom0,
                    focalOffset0: this._focalOffset0.toArray()
                });
            }
            fromJSON(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = JSON.parse(e1);
                this.enabled = n.enabled, this.minDistance = n.minDistance, this.maxDistance = dI(n.maxDistance), this.minZoom = n.minZoom, this.maxZoom = dI(n.maxZoom), this.minPolarAngle = n.minPolarAngle, this.maxPolarAngle = dI(n.maxPolarAngle), this.minAzimuthAngle = dI(n.minAzimuthAngle), this.maxAzimuthAngle = dI(n.maxAzimuthAngle), this.smoothTime = n.smoothTime, this.draggingSmoothTime = n.draggingSmoothTime, this.dollySpeed = n.dollySpeed, this.truckSpeed = n.truckSpeed, this.dollyToCursor = n.dollyToCursor, this.verticalDragToForward = n.verticalDragToForward, this._target0.fromArray(n.target0), this._position0.fromArray(n.position0), this._zoom0 = n.zoom0, this._focalOffset0.fromArray(n.focalOffset0), this.moveTo(n.target[0], n.target[1], n.target[2], t), RI.setFromVector3(SI.fromArray(n.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(RI.theta, RI.phi, t), this.dollyTo(RI.radius, t), this.zoomTo(n.zoom, t), this.setFocalOffset(n.focalOffset[0], n.focalOffset[1], n.focalOffset[2], t), this._needsUpdate = !0;
            }
            connect(e1) {
                this._domElement ? console.warn("camera-controls is already connected.") : (e1.setAttribute("data-camera-controls-version", "2.8.5"), this._addAllEventListeners(e1), this._getClientRect(this._elementRect));
            }
            disconnect() {
                this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
            }
            dispose() {
                this.removeAllEventListeners(), this.disconnect();
            }
            _getTargetDirection(e1) {
                return e1.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
            }
            _getCameraDirection(e1) {
                return this._getTargetDirection(e1).negate();
            }
            _findPointerById(e1) {
                return this._activePointers.find((t)=>t.pointerId === e1);
            }
            _findPointerByMouseButton(e1) {
                return this._activePointers.find((t)=>t.mouseButton === e1);
            }
            _disposePointer(e1) {
                this._activePointers.splice(this._activePointers.indexOf(e1), 1);
            }
            _encloseToBoundary(e1, t, n) {
                const i = t.lengthSq();
                if (0 === i) return e1;
                const r = II.copy(t).add(e1), a = this._boundary.clampPoint(r, NI).sub(r), s = a.lengthSq();
                if (0 === s) return e1.add(t);
                if (s === i) return e1;
                if (0 === n) return e1.add(t).add(a);
                {
                    const i = 1 + n * s / t.dot(a);
                    return e1.add(II.copy(t).multiplyScalar(i)).add(a.multiplyScalar(1 - n));
                }
            }
            _updateNearPlaneCorners() {
                if (tI(this._camera)) {
                    const e1 = this._camera, t = e1.near, n = e1.getEffectiveFOV() * sI, i = Math.tan(.5 * n) * t, r = i * e1.aspect;
                    this._nearPlaneCorners[0].set(-r, -i, 0), this._nearPlaneCorners[1].set(r, -i, 0), this._nearPlaneCorners[2].set(r, i, 0), this._nearPlaneCorners[3].set(-r, i, 0);
                } else if (nI(this._camera)) {
                    const e1 = this._camera, t = 1 / e1.zoom, n = e1.left * t, i = e1.right * t, r = e1.top * t, a = e1.bottom * t;
                    this._nearPlaneCorners[0].set(n, r, 0), this._nearPlaneCorners[1].set(i, r, 0), this._nearPlaneCorners[2].set(i, a, 0), this._nearPlaneCorners[3].set(n, a, 0);
                }
            }
            _collisionTest() {
                let e1 = 1 / 0;
                if (!(this.colliderMeshes.length >= 1)) return e1;
                if (mI(this._camera, "_collisionTest")) return e1;
                const t = this._getTargetDirection(DI);
                HI.lookAt(bI, t, this._camera.up);
                for(let n = 0; n < 4; n++){
                    const i = II.copy(this._nearPlaneCorners[n]);
                    i.applyMatrix4(HI);
                    const r = NI.addVectors(this._target, i);
                    GI.set(r, t), GI.far = this._spherical.radius + 1;
                    const a = GI.intersectObjects(this.colliderMeshes);
                    0 !== a.length && a[0].distance < e1 && (e1 = a[0].distance);
                }
                return e1;
            }
            _getClientRect(e1) {
                if (!this._domElement) return;
                const t = this._domElement.getBoundingClientRect();
                return e1.x = t.left, e1.y = t.top, this._viewport ? (e1.x += this._viewport.x, e1.y += t.height - this._viewport.w - this._viewport.y, e1.width = this._viewport.z, e1.height = this._viewport.w) : (e1.width = t.width, e1.height = t.height), e1;
            }
            _createOnRestPromise(e1) {
                return e1 ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
                    type: "transitionstart"
                }), new Promise((e1)=>{
                    const t = ()=>{
                        this.removeEventListener("rest", t), e1();
                    };
                    this.addEventListener("rest", t);
                }));
            }
            _addAllEventListeners(e1) {}
            _removeAllEventListeners() {}
            get dampingFactor() {
                return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
            }
            set dampingFactor(e1) {
                console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
            }
            get draggingDampingFactor() {
                return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
            }
            set draggingDampingFactor(e1) {
                console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
            }
            static createBoundingSphere(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new xI.Sphere, n = t.center;
                UI.makeEmpty(), e1.traverseVisible((e1)=>{
                    e1.isMesh && UI.expandByObject(e1);
                }), UI.getCenter(n);
                let i = 0;
                return e1.traverseVisible((e1)=>{
                    if (!e1.isMesh) return;
                    const t = e1, r = t.geometry.clone();
                    r.applyMatrix4(t.matrixWorld);
                    const a = r.attributes.position;
                    for(let e1 = 0, t = a.count; e1 < t; e1++)SI.fromBufferAttribute(a, e1), i = Math.max(i, n.distanceToSquared(SI));
                }), t.radius = Math.sqrt(i), t;
            }
        }
        function QI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        VI.install({
            THREE: e1
        });
        const WI = class extends VI {
            constructor(e1, t){
                super(t, e1.domElement), QI(this, "disableAutoRotate", !1), QI(this, "userDragging", !1), QI(this, "_renderer", void 0), QI(this, "_camera", void 0), this._renderer = e1, this._camera = t, this.mouseButtons.middle = VI.ACTION.NONE, this.mouseButtons.left = VI.ACTION.ROTATE, this.mouseButtons.right = VI.ACTION.NONE, this.mouseButtons.wheel = VI.ACTION.NONE, this.touches.three = VI.ACTION.NONE, this.touches.two = VI.ACTION.NONE, this.touches.one = VI.ACTION.TOUCH_ROTATE, this.verticalDragToForward = !0, this.azimuthRotateSpeed = -0.25, this.polarRotateSpeed = -0.25, this.maxDistance = .001, this.truckSpeed = 1e4, this.minDistance = 0, this.dollySpeed = 0, this.minZoom = 1, this.maxZoom = 2, this.rotateTo(0, Math.PI / 2), this.setDefaultPosition(), this.addListeners();
            }
            setDefaultPosition() {
                this.moveTo(0, 0, 0), this.dollyTo(1e-9), this.zoomTo(1);
            }
            onRest() {
                this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !1, this.holding = !1;
            }
            onControlStart() {
                this.currentAction !== VI.ACTION.NONE && (this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !0, this.holding = !0);
            }
            onControlEnd() {
                this.active ? this.addEventListener("rest", this.onRest) : this.onRest();
            }
            onTransitionStart() {
                this.holding || (this.disableAutoRotate = !0, this.addEventListener("rest", this.onRest));
            }
            addListeners() {
                this.addEventListener("transitionstart", this.onTransitionStart), this.addEventListener("controlstart", this.onControlStart), this.addEventListener("controlend", this.onControlEnd);
            }
        };
        function YI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const XI = class extends $u {
            constructor(e1){
                super(60, 1, .1, 1e4), YI(this, "deviceOrientationControls", void 0), YI(this, "controls", void 0), this.controls = new WI(e1, this), this.deviceOrientationControls = new $S(this, e1.domElement);
            }
        };
        const ZI = class extends Zp {
            constructor(){
                var e1, t, n;
                super(), e1 = this, n = void 0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "controls")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.background = new qc(16777215), this.add(new kA(new qc(16777215), 3));
            }
        };
        function qI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const KI = class extends Vu {
            constructor(){
                super(), qI(this, "canvas", document.createElement("canvas")), qI(this, "interactive", !0), qI(this, "height", 775), qI(this, "width", 775), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.addEventListener("select", (e1)=>this.onClick(e1)), this.addEventListener("click", (e1)=>this.onClick(e1)), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            onHoverStart() {
                this.scale.setScalar(1.15);
            }
            onHoverEnd() {
                this.scale.setScalar(1);
            }
            createGeomtery() {
                this.geometry = new ph(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    side: dr,
                    opacity: 1
                }), this;
            }
            async loadImage(e1) {
                const t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await t.blob();
                return await Oi(URL.createObjectURL(n));
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? 1 : 0);
            }
            async updateMaterial(e1) {
                const t = `${e1 + 1} ${Pi("floor")}`, n = Ci.config.colors.mainText, i = Ci.getFloorConfig(e1);
                return this.loadImage(i.planImage).then((e1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", Ri(this.context, 0, 0, this.canvas.width, this.canvas.height, 50), this.context.fill(), this.context.drawImage(e1, 165, 75, 450, 450), this.context.textAlign = "center", this.context.font = "Bold 80px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillColor = n, this.context.fillText(t, this.canvas.width / 2, this.canvas.height - 100), this.context.fillRect((this.canvas.width - 430) / 2, this.canvas.height - 55, 430, 5), this.material.map || (this.material.map = vx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
        };
        function JI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const $I = class extends Vu {
            constructor(){
                super(), JI(this, "canvas", document.createElement("canvas")), JI(this, "height", 700), JI(this, "width", 700), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeomtery() {
                this.geometry = new ph(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    side: dr,
                    opacity: 1
                }), this;
            }
            updateMaterial() {
                const e1 = `${Ci.currentFloorIndex + 1} ${Pi("floor")}`, t = Ci.config.colors.mainText;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.textAlign = "center", this.context.font = "Bold 140px/1 Roboto Mono", this.context.fillStyle = t, this.context.fillColor = t, this.context.fillText(e1, this.canvas.width / 2, this.canvas.height / 2), this.context.fillRect(0, this.canvas.height / 2 + 50, this.canvas.width, 5), this.material.map || (this.material.map = vx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
        };
        function eN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const tN = class extends Vu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                super(), eN(this, "canvas", document.createElement("canvas")), eN(this, "isContainer", !0), this.canvas.width = e1, this.canvas.height = 120, this.createGeometry(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new ph(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(20, 20, 20, 0.26)", Ri(this.context, 0, 0, this.canvas.width, this.canvas.height, 64), this.context.fill();
                const e1 = vx(this.canvas);
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    side: dr,
                    map: e1,
                    opacity: 1
                }), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function nN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const iN = class extends Vu {
            constructor(e1){
                super(), nN(this, "canvas", document.createElement("canvas")), nN(this, "interactive", !0), nN(this, "isButton", !0), this.canvas.height = 92, this.canvas.width = 92, this.createGeometry(), this.createMaterial(), this.update(e1), this.addEventListener("select", (e1)=>this.onClick(e1)), this.addEventListener("click", (e1)=>this.onClick(e1)), this.position.set(0, 0, 1), this.renderOrder = 6;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            createGeometry() {
                return this.geometry = new ph(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    side: dr,
                    opacity: 1
                }), this;
            }
            update(e1) {
                return Oi(e1).then((e1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", Ri(this.context, 0, 0, this.canvas.width, this.canvas.height, 46), this.context.fill(), this.context.drawImage(e1, 20, 20, 52, 52), this.material.map || (this.material.map = vx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? 1 : 0);
            }
        };
        function rN(e1, t) {
            let n = e1[0], i = e1[1], r = !1;
            for(let e1 = 0, a = t.length - 1; e1 < t.length; a = e1++){
                const s = t[e1][0], o = t[e1][1], l = t[a][0], c = t[a][1];
                o > i != c > i && n < (l - s) * (i - o) / (c - o) + s && (r = !r);
            }
            return r;
        }
        function aN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const sN = class extends jp {
            constructor(){
                super(), aN(this, "planScale", new $o(1, 1)), aN(this, "currentPanoramasGroup", void 0), aN(this, "padding", 16), aN(this, "rooms", []), this.scale.set(1, -1, 1), this.renderOrder = 6;
            }
            updateScale(e1) {
                let { X: t, Y: n } = e1;
                return this.planScale.x = t, this.planScale.y = n, this.deleteRooms(), this.createRooms(this.currentPanoramasGroup), this;
            }
            showRoomById(e1) {
                return this.rooms.forEach((t)=>{
                    t.material.opacity = t.userData.id === e1 ? .3 : 0;
                }), this;
            }
            createRooms(e1) {
                return this.currentPanoramasGroup = e1, this.currentPanoramasGroup.children.forEach((e1)=>{
                    let { userData: t, panoramaId: n } = e1;
                    const i = t.points.map((e1)=>{
                        let [t, n] = e1;
                        return [
                            this.padding + 2 * t * this.planScale.x,
                            this.padding + 2 * n * this.planScale.y
                        ];
                    }).filter((e1)=>{
                        let [t, n] = e1;
                        return !isNaN(t) && !isNaN(n);
                    });
                    if (!i.length) return;
                    const r = this.padding + 2 * t.left * this.planScale.x, a = this.padding + 2 * t.top * this.planScale.y, s = new Yg;
                    s.moveTo(i[0][0], i[0][1]), i.forEach((e1)=>{
                        let [t, n] = e1;
                        return s.lineTo(t, n);
                    });
                    const o = new Sm(s), l = new Um({
                        color: new qc(Ci.config.colors.main),
                        transparent: !0,
                        side: dr,
                        opacity: 0
                    }), c = new Vu(o, l);
                    c.userData = {
                        id: n,
                        points: i,
                        left: r,
                        top: a
                    }, this.rooms.push(c), this.add(c);
                }), this;
            }
            deleteRooms() {
                return this.rooms.forEach((e1)=>{
                    e1.material.dispose(), e1.removeFromParent();
                }), this.rooms = [], this;
            }
        };
        function oN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const lN = class extends Vu {
            constructor(){
                super(), oN(this, "height", 140), oN(this, "width", 140), this.createGeometry(), this.createMaterial(), this.renderOrder = 7;
            }
            createGeometry() {
                return this.geometry = new ph(this.width, this.height, 10, 10), this;
            }
            createMaterial() {
                const e1 = this.width / 2, t = this.height / 2, n = Math.PI / 3 * 4, i = n + Math.PI / 3, r = document.createElement("canvas"), a = r.getContext("2d");
                return r.height = this.height, r.width = this.width, a.clearRect(0, 0, this.width, this.height), a.globalAlpha = .4, a.beginPath(), a.moveTo(e1, t), a.fillStyle = Ci.config.colors.main, a.arc(e1, t, 70, n, i), a.lineTo(e1, t), a.fill(), a.closePath(), a.globalAlpha = 1, a.beginPath(), a.fillStyle = Ci.config.colors.main, a.arc(e1, t, 16, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = "rgba(255, 255, 255, 1)", a.arc(e1, t, 12, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = Ci.config.colors.main, a.arc(e1, t, 8, 0, 2 * Math.PI), a.fill(), a.closePath(), this.material = new Um({
                    map: vx(r),
                    color: new qc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    opacity: 1
                }), this;
            }
            update(e1, t, n) {
                this.position.set(e1, t, 10), this.rotation.set(0, 0, n);
            }
        };
        function cN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const uN = class extends Vu {
            constructor(){
                super(), cN(this, "planScale", new $o(1, 1)), cN(this, "pointer", new $o(-1, -1)), cN(this, "interactive", !0), cN(this, "boundingScale", 4), cN(this, "padding", 16), cN(this, "hoverRoom", void 0), cN(this, "fovLayer", void 0), cN(this, "height", void 0), cN(this, "width", void 0), this.height = 200, this.width = 200, this.createGeometry(), this.createMaterial(), this.creteRoomsLayer(), this.createFovLayer(), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.addEventListener("click", this.handleClick), this.renderOrder = 5;
            }
            createGeometry() {
                return this.geometry = new ph(this.width, this.height, 100, 100), this;
            }
            createMaterial() {
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    side: dr,
                    opacity: 1
                }), this;
            }
            async loadImage(e1) {
                const t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await t.blob();
                return this.image = new Image, this.image.onload = ()=>this.updateMaterial(), this.image.src = URL.createObjectURL(n), this;
            }
            createFovLayer() {
                return this.fovLayer = new lN, this.add(this.fovLayer), this;
            }
            creteRoomsLayer() {
                return this.roomsLayer = new sN, this.add(this.roomsLayer), this;
            }
            setDisabledState(e1) {
                this.disabled = e1;
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? this.boundingScale : 0);
            }
            onHoverStart(e1) {
                const { x: t, y: n } = e1.data, i = this.height * n, r = this.width * t;
                this.pointer.x = r, this.pointer.y = i;
            }
            onHoverEnd() {
                this.pointer.x = -1, this.pointer.y = -1;
            }
            handleClick() {
                this.hoverRoom && (this.onClick(this.hoverRoom.userData.id), this.dispatchEvent({
                    type: "closemap"
                }));
            }
            onClick() {}
            updateMaterial() {
                const e1 = document.createElement("canvas"), t = e1.getContext("2d");
                return e1.height = this.height, e1.width = this.width, t.fillStyle = "rgba(255, 255, 255, 1)", Ri(t, 0, 0, this.width, this.height, 20), t.fill(), this.image && t.drawImage(this.image, this.padding, this.padding, this.width - 2 * this.padding, this.height - 2 * this.padding), this.material.map && this.material.map.dispose(), this.material.map = vx(e1), this.material.needsUpdate = !0, this;
            }
            updateSize(e1, t) {
                this.height = t + 2 * this.padding, this.width = e1 + 2 * this.padding, this.roomsLayer.position.set(-this.width / 2, this.height / 2, 5), this.createGeometry();
                const n = Math.min(this.width / this.height, 1);
                return this.boundingScale = 5 * n, this.setVisibility(this.visible), this;
            }
            updateScale(e1) {
                let { X: t, Y: n } = e1;
                return this.planScale.x = t, this.planScale.y = n, this.roomsLayer.updateScale({
                    X: t,
                    Y: n
                }), this;
            }
            updateRoomsLayer(e1) {
                return this.roomsLayer.deleteRooms(), this.roomsLayer.createRooms(e1), this;
            }
            update(e1, t, n) {
                if (n) {
                    const e1 = this.roomsLayer.rooms.filter((e1)=>rN([
                            this.pointer.x,
                            this.pointer.y
                        ], e1.userData.points));
                    this.hoverRoom = wx([
                        this.pointer.x,
                        this.pointer.y
                    ], e1).panorama;
                }
                if (this.roomsLayer.showRoomById(this.hoverRoom?.userData.id || null), !this.disabled && t) {
                    const n = this.padding + 2 * t.userData.left * this.planScale.x, i = this.padding + 2 * t.userData.top * this.planScale.y, r = this.height / 2, a = n - this.width / 2, s = -1 * (i - r);
                    this.fovLayer.update(a, s, e1);
                }
                return this;
            }
        }, hN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjI0KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTg0OF82MjQiPgo8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
        function dN(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function pN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        function fN(e1, t) {
            return e1.get(mN(e1, t));
        }
        function gN(e1, t, n) {
            return e1.set(mN(e1, t), n), n;
        }
        function mN(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var AN = new WeakMap, MN = new WeakMap;
        const vN = class extends jp {
            constructor(){
                super(), pN(this, "mapGroup", new jp), dN(this, AN, void 0), dN(this, MN, void 0), pN(this, "prevFloorButton", void 0), pN(this, "nextFloorButton", void 0), pN(this, "rulerButton", void 0), pN(this, "floorTitle", void 0), pN(this, "exitButton", void 0), pN(this, "mapButton", void 0), pN(this, "container", void 0), pN(this, "map", void 0), this.createContainer(), this.createButtons(), this.createMap(), this.createFloorTitle(), this.createPrevFloorButton(), this.createNextFloorButton(), this.closeMap(), this.mapButton.setVisibility(!1), this.setVisibility(!1), this.mapGroup.position.set(0, 2e3, -2500), this.mapGroup.rotation.set(Ix(30), 0, 0), this.add(this.mapGroup);
            }
            set rulerButtonAvailable(e1) {
                gN(AN, this, e1), this.map.visible || this.setRulerButtonVisibility(e1);
            }
            set mapButtonAvailable(e1) {
                gN(MN, this, e1), this.map.visible || this.setMapButtonVisibility(e1);
            }
            onRulerButtonClick() {}
            onExitButtonClick() {}
            createContainer() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                if (this.container) {
                    const t = new tN(e1);
                    this.container.geometry = t.geometry.clone(), this.container.material = t.material.clone(), t.dispose();
                } else this.container = new tN(e1), this.add(this.container);
                return this;
            }
            createButtons() {
                return this.exitButton = new iN("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjE2NjEgNC44MzM5OEwxNCAxNC4wMDAxTTE0IDE0LjAwMDFMNC44MzM4IDIzLjE2NjNNMTQgMTQuMDAwMUwyMy4xNjYxIDIzLjE2NjNNMTQgMTQuMDAwMUw0LjgzMzggNC44MzM5OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"), this.exitButton.onClick = (e1)=>{
                    if (this.map.visible) return this.closeMap();
                    this.onExitButtonClick(e1);
                }, this.rulerButton = new iN(hN), this.rulerButton.onClick = (e1)=>this.onRulerButtonClick(e1), this.mapButton = new iN("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjIxMTQgMjQuNDIxMUgzLjc4ODY1QzMuNjI3NDggMjQuNDIxMSAzLjQ5NjgzIDI0LjI5MDQgMy40OTY4MyAyNC4xMjkzTDMuNDk2NzcgNC4wNjYyNEMzLjQ5Njc3IDMuOTA1MDcgMy42Mjc0MiAzLjc3NDQxIDMuNzg4NTkgMy43NzQ0MUgyNC4yMTE0QzI0LjM3MjUgMy43NzQ0MSAyNC41MDMyIDMuOTA1MDcgMjQuNTAzMiA0LjA2NjI0VjI0LjEyOTNDMjQuNTAzMiAyNC4yOTA0IDI0LjM3MjUgMjQuNDIxMSAyNC4yMTE0IDI0LjQyMTFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNC4wMDE0NiAxMC4wNDU0SDEzLjM2ODRDMTMuNTI5NiAxMC4wNDU0IDEzLjY2MDIgMTAuMTc2MSAxMy42NjAyIDEwLjMzNzJWMjQuMjA1OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNDU5MSIvPgo8cGF0aCBkPSJNMjQuNTAzMiAxMS4wNjU2SDE4LjM2NTFDMTguMjA0IDExLjA2NTYgMTguMDczMyAxMC45MzQ5IDE4LjA3MzMgMTAuNzczOFYzLjU3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjQ1OTEiLz4KPC9zdmc+Cg=="), this.mapButton.onClick = (e1)=>this.openMap(e1), this.add(this.exitButton, this.rulerButton, this.mapButton), this;
            }
            createMap() {
                return this.map = new uN, this.map.addEventListener("closemap", this.closeMap.bind(this)), this.mapGroup.add(this.map), this;
            }
            createFloorTitle() {
                return this.floorTitle = new $I, this.mapGroup.add(this.floorTitle), this;
            }
            createNextFloorButton() {
                return this.nextFloorButton = new KI, this.mapGroup.add(this.nextFloorButton), this;
            }
            createPrevFloorButton() {
                return this.prevFloorButton = new KI, this.mapGroup.add(this.prevFloorButton), this;
            }
            openMap() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Ci.prevFloorIndex), this.nextFloorButton.updateMaterial(Ci.nextFloorIndex), this.mapGroup.visible = !0, this.map.setVisibility(!0), this.rulerButton.setVisibility(!1), this.setMapButtonVisibility(!1);
                const e1 = Ci.configParams.floors.length > 1;
                this.prevFloorButton.setVisibility(e1), this.nextFloorButton.setVisibility(e1);
            }
            closeMap() {
                this.mapGroup.visible = !1, this.map.setVisibility(!1), this.rulerButton.setVisibility(fN(AN, this)), this.setMapButtonVisibility(!0), this.prevFloorButton.setVisibility(!1), this.nextFloorButton.setVisibility(!1);
            }
            setRulerButtonVisibility(e1) {
                this.rulerButton.setVisibility(e1), this.updateButtonsPositions();
            }
            setMapButtonVisibility(e1) {
                this.mapButton.setVisibility(e1), this.updateButtonsPositions();
            }
            setVisibility(e1) {
                e1 ? (this.setRulerButtonVisibility(fN(AN, this)), this.setMapButtonVisibility(fN(MN, this))) : (this.setRulerButtonVisibility(!1), this.setMapButtonVisibility(!1)), this.exitButton.setVisibility(e1), this.container.visible = e1, this.visible = e1, this.scale.setScalar(e1 ? 6e-4 : 0);
            }
            setRulerIcon(e1) {
                return e1 ? this.rulerButton.update("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjU5KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjEwLjYyNDYiIHk9IjYuMjkzNDYiIHdpZHRoPSIxNS44MDAyIiBoZWlnaHQ9IjMuNjYxNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTAuNjI0NiA2LjI5MzQ2KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMuMDA2MjkgNC43MTE0M0wyMi45OTM4IDI1LjI4NzkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQ4XzY1OSI+CjxyZWN0IHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K") : this.rulerButton.update(hN);
            }
            updateButtonsPositions() {
                return this.map.visible ? (this.exitButton.position.x = 0, void this.createContainer(120)) : this.mapButton.visible ? this.rulerButton.visible ? (this.rulerButton.position.x = 0, this.exitButton.position.x = 140, this.mapButton.position.x = -140, void this.createContainer(400)) : (this.exitButton.position.x = 70, this.mapButton.position.x = -70, void this.createContainer(260)) : this.rulerButton.visible ? (this.rulerButton.position.x = -70, this.exitButton.position.x = 70, void this.createContainer(260)) : (this.exitButton.position.x = 0, void this.createContainer(120));
            }
            updateFloorMaterials() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Ci.prevFloorIndex), this.nextFloorButton.updateMaterial(Ci.nextFloorIndex);
            }
            updateFloorTitlePosition() {
                const e1 = 210 + this.map.height * this.map.scale.y / 2;
                this.floorTitle.position.set(0, e1, 0);
            }
            updateFloorButtonsPositions() {
                const { width: e1, height: t } = this.nextFloorButton, n = t / 2 - this.map.height * this.map.scale.y / 2, i = e1 / 2 + 200 + this.map.width * this.map.scale.x / 2;
                this.prevFloorButton.position.set(-i, n, 0), this.nextFloorButton.position.set(i, n, 0);
            }
            update(e1, t, n, i) {
                this.map.visible && this.map.update(t, n, i);
                const r = new Ll(.025, -0.5, -0.9);
                r.applyMatrix4(e1.matrixWorld);
                const a = new Mc(0, 0, 0);
                a.setFromRotationMatrix(e1.matrixWorld), this.position.copy(r), this.rotation.copy(a), this.rotateX(Ix(-30)), this.updateMatrix(), this.updateFloorTitlePosition(), this.updateFloorButtonsPositions();
            }
        };
        const yN = class extends Vu {
            constructor(){
                var e1, t, n;
                super(), e1 = this, n = !0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "isDistanceLine")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.createGeometry(), this.createMaterial(), this.renderOrder = 3;
            }
            createGeometry(e1, t) {
                const n = new Ig(e1, t);
                return this.geometry = new Cm(n, 100, .1, 100, !1), this;
            }
            createMaterial() {
                return this.material = new Um({
                    color: new qc(4275774),
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    opacity: 1
                }), this;
            }
            update(e1, t) {
                return this.createGeometry(e1, t), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
        };
        function xN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const bN = class extends ff {
            constructor(e1){
                super(), xN(this, "canvas", document.createElement("canvas")), xN(this, "isCenterPoint", !0), xN(this, "interactive", !0), xN(this, "materialValue", 0), xN(this, "ruler", void 0), this.ruler = e1;
                const t = .15 * this.fontScale;
                this.canvas.width = 256, this.canvas.height = 128, this.scale.set(t, t / (this.canvas.width / this.canvas.height), t), this.renderOrder = 5, this.createMaterial();
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            get fontSize() {
                return Ci.config.rulerOptions?.fontSize ?? 38;
            }
            get fontScale() {
                return this.fontSize / 38;
            }
            onClick() {
                this.ruler.dispose();
            }
            onHoverStart() {
                this.updateMaterial(this.materialValue, "rgba(255, 99, 64, 0.8)", "rgba(255, 255, 255, 1)");
            }
            onHoverEnd() {
                this.updateMaterial(this.materialValue);
            }
            addEventListeners() {
                return this.addEventListener("select", this.onClick), this.addEventListener("click", this.onClick), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this;
            }
            createMaterial() {
                return this.material = new $p({
                    color: new qc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: dr,
                    opacity: 1
                }), this;
            }
            updateMaterial(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "rgba(255, 255, 255, 0.8)", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Ci.config.colors.mainText;
                this.materialValue = e1;
                const i = `${Number(e1 / 100).toFixed(2)} m `, r = `${Number(.0328084 * e1).toFixed(2)} ft`;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = t, Ri(this.context, 0, 0, this.canvas.width, this.canvas.height, 55), this.context.fill(), this.context.textAlign = "center", this.context.font = "Bold 38px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillText(r, this.canvas.width / 2, 100), this.context.fillText(i, this.canvas.width / 2, 50), this.material.map || (this.material.map = vx(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
            updatePosition(e1, t) {
                const n = new Ig(e1, t).getPoint(.5, new Ll);
                return this.position.copy(n), this;
            }
            update(e1, t, n) {
                return this.updateMaterial(e1), this.updatePosition(t, n), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function wN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const EN = class extends Vu {
            constructor(){
                super(), wN(this, "canvas", document.createElement("canvas")), wN(this, "isPoint", !0), this.canvas.width = 128, this.canvas.height = 128, this.createGeometry(), this.createMaterial(), this.renderOrder = 4;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new ph(15, 15, 1, 1), this.geometry.rotateX(-Math.PI / 2), this;
            }
            createMaterial() {
                const { width: e1, height: t } = this.canvas, n = e1 / 2, i = t / 2, r = n / 2;
                this.context.fillStyle = "rgba(255, 255, 255, 1)", this.context.strokeStyle = Ci.config.colors.main, this.context.lineWidth = 15, this.context.beginPath(), this.context.arc(n, i, r, 0, 2 * Math.PI), this.context.closePath(), this.context.fill(), this.context.stroke();
                const a = vx(this.canvas);
                return this.material = new Um({
                    color: new qc(16777215),
                    transparent: !0,
                    depthWrite: !1,
                    depthTest: !1,
                    side: dr,
                    map: a,
                    opacity: 1
                }), this;
            }
            update(e1, t) {
                let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.position.copy(e1), n ? (this.quaternion.slerp(t, .5), this) : (this.quaternion.copy(t), this);
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function TN(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const SN = class extends jp {
            constructor(e1){
                super(), TN(this, "distanceLine", null), TN(this, "centerPoint", null), TN(this, "secondPoint", null), TN(this, "firstPoint", null), TN(this, "isRuler", !0), this.userData = {
                    panoramaId: e1
                };
            }
            get distance() {
                return this.firstPoint && this.secondPoint ? this.firstPoint.position.distanceTo(this.secondPoint.position) : 0;
            }
            createRest(e1, t) {
                return this.createSecondPoint(e1, t), this.createDistanceLine(), this.createCenterPoint(), this;
            }
            createFirstPoint(e1, t) {
                return this.firstPoint = (new EN).update(e1, t, !1), this.add(this.firstPoint), this;
            }
            createSecondPoint(e1, t) {
                return this.secondPoint = (new EN).update(e1, t, !1), this.add(this.secondPoint), this;
            }
            createDistanceLine() {
                return this.distanceLine = new yN, this.add(this.distanceLine), this;
            }
            createCenterPoint() {
                return this.centerPoint = new bN(this), this.add(this.centerPoint), this;
            }
            update(e1, t) {
                return this.secondPoint?.update(e1, t, !0), this.centerPoint?.update(this.distance, this.firstPoint.position, this.secondPoint.position), this.distanceLine?.update(this.firstPoint.position, this.secondPoint.position), this;
            }
            dispose() {
                return this.firstPoint?.dispose(), this.secondPoint?.dispose(), this.centerPoint?.dispose(), this.distanceLine?.dispose(), this.removeFromParent(), this;
            }
        }, IN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ5OCAyMC41MzUySDI0Ljc0ODgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjk0ODA5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIwLjUzOCAzMC43NjM1QzI2LjE4NjUgMzAuNzYzNSAzMC43NjU0IDI2LjE4NDUgMzAuNzY1NCAyMC41MzZDMzAuNzY1NCAxNC44ODc2IDI2LjE4NjUgMTAuMzA4NiAyMC41MzggMTAuMzA4NkMxNC44ODk1IDEwLjMwODYgMTAuMzEwNSAxNC44ODc2IDEwLjMxMDUgMjAuNTM2QzEwLjMxMDUgMjYuMTg0NSAxNC44ODk1IDMwLjc2MzUgMjAuNTM4IDMwLjc2MzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45NDgwOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy43NzE1IDI3Ljc2NTZMMzMuNjg4OCAzMy42ODI5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45NDgwOSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", NN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjM0NTEgMTAuODMwN0wxMC44MjU3IDI2LjM1MDFDMTAuNDYwMyAyNi43MTU1IDEwLjQyODcgMjcuMjc2MyAxMC43NTUxIDI3LjYwMjhMMTYuMjYwMSAzMy4xMDc3QzE2LjU4NjUgMzMuNDM0MiAxNy4xNDczIDMzLjQwMjUgMTcuNTEyOCAzMy4wMzcxTDMzLjAzMjIgMTcuNTE3N0MzMy4zOTc2IDE3LjE1MjMgMzMuNDI5MiAxNi41OTE1IDMzLjEwMjggMTYuMjY1TDI3LjU5NzggMTAuNzYwMUMyNy4yNzE0IDEwLjQzMzcgMjYuNzEwNSAxMC40NjUzIDI2LjM0NTEgMTAuODMwN1oiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjk5Mzk0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIzLjMyNDIgMTQuOTA2MkwyNy4wNjcgMTguNjQ5MSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzOTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuMTEzMyAxOS4xMjExTDIxLjk0MDMgMjEuOTQ4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzOTQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuOTAyMyAyMy4zMzJMMTguNjQ1MiAyNy4wNzQ5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45OTM5NCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", DN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5Ljk2ODUgMjQuMjM4M0wyOS4yMzQ2IDIyLjg0MzJMMjkuOTY4NSAyNC4yMzgzWk0xMS45MDQ1IDI3LjIyMjFDMTIuNzQyMiAyNy40NTkzIDEzLjYxMzUgMjYuOTcyNiAxMy44NTA4IDI2LjEzNDlDMTQuMDg4IDI1LjI5NzMgMTMuNjAxMyAyNC40MjU5IDEyLjc2MzYgMjQuMTg4N0wxMS45MDQ1IDI3LjIyMjFaTTIyLjU1NTcgMjQuODUxM0MyMS42OTI1IDI0Ljk2NDEgMjEuMDg0MSAyNS43NTUzIDIxLjE5NjkgMjYuNjE4NkMyMS4zMDk3IDI3LjQ4MTggMjIuMTAxIDI4LjA5MDIgMjIuOTY0MiAyNy45Nzc0TDIyLjU1NTcgMjQuODUxM1pNMzAuNzAyMyAyNS42MzM1QzMzLjg4MDcgMjMuOTYxNiAzNi4yMDA0IDIxLjUwMzkgMzYuNzY0NiAxOC41NTVMMzMuNjY4IDE3Ljk2MjZDMzMuMzUwMiAxOS42MjM5IDMxLjkzMzUgMjEuNDIzNiAyOS4yMzQ2IDIyLjg0MzJMMzAuNzAyMyAyNS42MzM1Wk0zNi43NjQ2IDE4LjU1NUMzNy4zNDMxIDE1LjUzMSAzNS45NTI2IDEyLjY3NDQgMzMuMzY1NCAxMC41Mjg4TDMxLjM1MjkgMTIuOTU1NkMzMy4zMjc3IDE0LjU5MzMgMzMuOTcxNSAxNi4zNzY1IDMzLjY2OCAxNy45NjI2TDM2Ljc2NDYgMTguNTU1Wk0zMy4zNjU0IDEwLjUyODhDMzAuNzk2NyA4LjM5ODU2IDI3LjEwNzIgNi45ODQ4MSAyMy4wNjAzIDYuNDQxNTRMMjIuNjQwOCA5LjU2NjIyQzI2LjI3ODkgMTAuMDU0NiAyOS4zNTk1IDExLjMwMjUgMzEuMzUyOSAxMi45NTU2TDMzLjM2NTQgMTAuNTI4OFpNMjMuMDYwMyA2LjQ0MTU0QzE4Ljk5OTkgNS44OTY0NyAxNC43Mjk2IDYuMjQ2MjYgMTEuMDQwNCA3LjQ0NjgzTDEyLjAxNiAxMC40NDQ4QzE1LjIyNSA5LjQwMDQ5IDE5LjAxNjEgOS4wNzk2MyAyMi42NDA4IDkuNTY2MjJMMjMuMDYwMyA2LjQ0MTU0Wk0xMS4wNDA0IDcuNDQ2ODNDNy4zODAxOCA4LjYzNzk2IDQuMzYyMzQgMTAuNjQ5MyAyLjc5NzI5IDEzLjI4MzZMNS41MDc3NSAxNC44OTM5QzYuNTQ0NDQgMTMuMTQ4OSA4Ljc3ODA0IDExLjQ5ODUgMTIuMDE2IDEwLjQ0NDhMMTEuMDQwNCA3LjQ0NjgzWk0yLjc5NzI5IDEzLjI4MzZDMS4xNjczMSAxNi4wMjcyIDEuMzMzNzQgMTkuMDkyMiAzLjE4NzIxIDIxLjcyMzlMNS43NjQ4IDE5LjkwODVDNC41OTk4OSAxOC4yNTQ1IDQuNTM2MDEgMTYuNTI5NSA1LjUwNzc1IDE0Ljg5MzlMMi43OTcyOSAxMy4yODM2Wk0zLjE4NzIxIDIxLjcyMzlDNC45NzUwMSAyNC4yNjIzIDguMTQ0OTEgMjYuMTU3MyAxMS45MDQ1IDI3LjIyMjFMMTIuNzYzNiAyNC4xODg3QzkuNDIwMzcgMjMuMjQxOCA2Ljk5NTM3IDIxLjY1NTcgNS43NjQ4IDE5LjkwODVMMy4xODcyMSAyMS43MjM5Wk0yMi45NjQyIDI3Ljk3NzRDMjUuNzc4MyAyNy42MDk3IDI4LjQ0OTcgMjYuODE4NCAzMC43MDIzIDI1LjYzMzVMMjkuMjM0NiAyMi44NDMyQzI3LjM2NTEgMjMuODI2NiAyNS4wNjM3IDI0LjUyMzUgMjIuNTU1NyAyNC44NTEzTDIyLjk2NDIgMjcuOTc3NFoiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTI1LjI1MzYgMTkuNDMzM0wxOS45Njg3IDI2LjA4MzlMMjYuMDg3MyAzMC45NDYzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPg==";
        function _N(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const CN = new class {
            constructor(){
                _N(this, "currentAutoRotateIcon", DN), _N(this, "currentRulerIcon", NN), _N(this, "currentFovIcon", IN), _N(this, "currentFovText", "1x"), _N(this, "rulerInstructionShown", !1), _N(this, "tempPointer", new $o), _N(this, "raycaster", new PM), _N(this, "tempMatrix", new lc), _N(this, "vrSessionSupported", !1), _N(this, "rulerButtonEnabled", !1), _N(this, "rulersGroup", new jp), _N(this, "renderer", new KS), _N(this, "floorsGroup", new jp), _N(this, "initialPanoramaId", null), _N(this, "rulerModeEnabled", !1), _N(this, "autoRotateState", !1), _N(this, "pointer", new $o), _N(this, "panoramasGroup", null), _N(this, "initialized", !1), _N(this, "clock", new aM), _N(this, "scene", new ZI), _N(this, "animation", !1), _N(this, "currentPanoramaId", void 0), _N(this, "interactiveGroup", void 0), _N(this, "tempRuler", null), _N(this, "currentPanorama", void 0), _N(this, "loading", !1), _N(this, "vrControlPanel", void 0), _N(this, "maskCursor", void 0), _N(this, "camera", void 0), _N(this, "bareshell", !1), _N(this, "isFirstRender", !0), _N(this, "customCursor", null), _N(this, "onMouseMove", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    this.pointer.x = t / Ci.config.width * 2 - 1, this.pointer.y = -n / Ci.config.height * 2 + 1;
                }), _N(this, "onPointerDown", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    this.tempPointer.x = Number(t.toFixed(0)), this.tempPointer.y = Number(n.toFixed(0)), this.onMouseMove({
                        clientX: t,
                        clientY: n
                    });
                }), _N(this, "onPointerUp", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    if (this.interactiveGroup.hover || !this.currentPanorama) return;
                    const i = Math.abs(this.tempPointer.x - Number(t.toFixed(0))) < 10, r = Math.abs(this.tempPointer.y - Number(n.toFixed(0))) < 10;
                    i && r && (this.rulerModeEnabled ? this.addRulerPoint() : (this.onMaskObjectClick(), this.relocateToClosestPoint()));
                }), _N(this, "onControllerMove", (e1)=>{
                    const t = e1.target;
                    this.tempMatrix.identity().extractRotation(t.matrixWorld), this.raycaster.ray.origin.setFromMatrixPosition(t.matrixWorld), this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);
                }), _N(this, "onControllerSelect", ()=>{
                    this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick();
                }), _N(this, "onMaskObjectClick", ()=>{}), Tn(this), this.camera = new XI(this.renderer), this.interactiveGroup = new Ux(this.renderer, this.camera), this.floorsGroup.rotation.y = Math.PI, this.scene.add(this.interactiveGroup, this.rulersGroup, this.floorsGroup), this.addEventListeners();
            }
            get currentViewAngle() {
                const e1 = this.currentCamera.getWorldDirection(new Ll), t = new Ll(-1, 0, 0), n = e1.x * t.x + e1.z * t.z, i = Math.sqrt(Math.pow(e1.x, 2) + Math.pow(e1.z, 2)), r = Math.sqrt(Math.pow(t.x, 2) + Math.pow(t.z, 2)), a = Math.acos(n / (i * r));
                return Math.sign(e1.z) * a;
            }
            get currentCamera() {
                return this.renderer.xr.getCamera().cameras[0] || this.camera;
            }
            get currentControls() {
                return this.camera.deviceOrientationControls.enabled ? this.camera.deviceOrientationControls : this.camera.controls;
            }
            getPanoramaById(e1) {
                return this.panoramasGroup.children.find((t)=>{
                    let { panoramaId: n } = t;
                    return n === e1;
                });
            }
            setLoadingState(e1) {
                this.loading = e1;
            }
            setInitializedState(e1) {
                this.initialized = e1;
            }
            setBareshell(e1) {
                this.bareshell = e1;
            }
            updateWindowSize(e1, t) {
                return this.renderer.setSize(e1, t), this.camera.aspect = e1 / t, this.camera.updateProjectionMatrix(), this.render();
            }
            enableRender() {
                this.renderer.setAnimationLoop(this.render.bind(this)), Cy.isProActive && this.createCustomCursor();
            }
            disableRender() {
                this.renderer.setAnimationLoop(null), this.customCursor = null;
            }
            createCustomCursor() {
                const e1 = document.getElementById("cursor");
                this.customCursor = e1;
                const t = document.querySelector(".widget-tab__panorama-overlay");
                t.addEventListener("mouseenter", ()=>{
                    e1.style.display = "block";
                }), t.addEventListener("mouseleave", ()=>{
                    e1.style.display = "none";
                }), t.addEventListener("mousemove", (n)=>{
                    const i = t.getBoundingClientRect(), r = n.clientX - i.left, a = n.clientY - i.top;
                    e1.style.left = r + "px", e1.style.top = a + "px", "none" !== this.renderer.domElement.style.cursor || this.rulerModeEnabled ? e1.style.display = "none" : e1.style.display = "block";
                });
            }
            render() {
                const e1 = this.clock.getDelta();
                this.currentControls.update(e1), this.camera.updateProjectionMatrix(), this.autoRotateState && !this.camera.controls.disableAutoRotate && (this.camera.controls.azimuthAngle -= Ix(10 * e1)), this.renderer.currentVrSession || this.raycaster.setFromCamera(this.pointer, this.camera), gx.isMobileDevice || (this.tempRuler ? this.updateRuler() : this.updateMask()), this.maskCursor ? this.renderer.domElement.style.cursor = this.maskCursor : this.interactiveGroup.hover && this.interactiveGroup.cursor.length > 0 ? this.renderer.domElement.style.cursor = this.interactiveGroup.cursor : this.rulerModeEnabled || Cy.isProActive ? this.renderer.domElement.style.cursor = "none" : this.camera.controls.holding ? this.renderer.domElement.style.cursor = "grabbing" : this.renderer.domElement.style.cursor = "grab";
                const t = document.querySelector(".widget-tab__panorama-map__fov");
                t && t.style.setProperty("--rotate", -this.currentViewAngle);
                const n = document.querySelector(".camera--current");
                return n && n.style.setProperty("--rotate", -this.currentViewAngle), this.renderer.currentVrSession && this.vrControlPanel.update(this.currentCamera, this.currentViewAngle, this.getPanoramaById(this.currentPanoramaId), this.panoramasGroup), this.renderer.render(this.scene, this.camera), this.isFirstRender && (this.isFirstRender = !1, performance.mark("first render")), this;
            }
            async init(e1, t, n) {
                return this.vrControlPanel = new vN, this.interactiveGroup.add(this.vrControlPanel), this.vrControlPanel.onRulerButtonClick = this.toggleRulerMode.bind(this), this.vrControlPanel.onExitButtonClick = this.exitVr.bind(this), this.vrControlPanel.map.onClick = this.setCurrentPanoramaById.bind(this), this.vrControlPanel.prevFloorButton.onClick = ()=>Ci.setPrevFloorIndex(), this.vrControlPanel.nextFloorButton.onClick = ()=>Ci.setNextFloorIndex(), this.setRulerButtonState(!1), this.cameraFovValues = {
                    x1: Ci.config.panoramaFov,
                    x2: Ci.config.panoramaFov / 2,
                    x05: 1.35 * Ci.config.panoramaFov
                }, this.setCameraFov(this.cameraFovValues[Ci.scales[0]]), this.checkVrSessionSupport(), await this.createPanoramasGroup(e1, t, n), this.setInitializedState(!0), this;
            }
            async createPanoramasGroup(e1, t, n) {
                performance.mark("start creatingPanoramas");
                const i = new qS(n);
                return this.floorsGroup.add(i), this.setCurrentPanoramasGroup(n), this.createPanoramas(e1, t), await this.setInitialCurrentPanorama(), this.interactiveGroup.updateDeepChildren(), this;
            }
            addEventListeners() {
                const { domElement: e1 } = this.renderer;
                e1.addEventListener("contextmenu", (e1)=>e1.preventDefault()), e1.addEventListener("pointerdown", this.onPointerDown), e1.addEventListener("pointerup", this.onPointerUp), e1.addEventListener("mousemove", this.onMouseMove);
            }
            relocateToClosestPoint() {
                if (this.maskCursor || this.rulerModeEnabled) return;
                const e1 = this.currentPanorama.depthMap ? ((e1, t, n)=>{
                    const { direction: i } = e1.ray, r = (1 + Math.atan2(i.z, i.x) / Math.PI) / 2, a = Math.acos(i.y) / Math.PI, { R: s } = Dx(r, a, n.depthMap), o = s || 140, l = i.clone().multiplyScalar(o);
                    let c = null, u = 1 / 0;
                    for (const e1 of t){
                        const t = l.distanceTo(e1.userData.position);
                        t < u && Ox(e1.isDoor) && (u = t, c = e1);
                    }
                    return c;
                })(this.raycaster, this.currentPanorama.links, this.currentPanorama) : ((e1, t)=>{
                    let n = 1 / 0, i = null, r = 1 / 0;
                    for (const a of t){
                        const t = (new Ll).subVectors(a.userData.position, e1.ray.origin).dot(e1.ray.direction), s = (new Ll).copy(e1.ray.origin).add(e1.ray.direction.clone().multiplyScalar(t)), o = a.userData.position.distanceTo(s);
                        o < r && t >= 0 && Ox(a.isDoor) && (r = o, i = a.userData.position), o < n && Ox(a.isDoor) && (r = o, i = a.userData.position);
                    }
                    return t.find((e1)=>(e1.userData.position === i) ?? null);
                })(this.raycaster, this.currentPanorama.links);
                e1 && this.setCurrentPanoramaById(e1.userData.targetId);
            }
            async enterVr() {
                return await this.renderer.enterVR().then(()=>{
                    this.vrControlPanel.setVisibility(!0);
                });
            }
            async exitVr() {
                return await this.renderer.exitVR().then(()=>{
                    this.camera.fov = this.cameraFov, this.vrControlPanel.setVisibility(!1);
                });
            }
            async checkVrSessionSupport() {
                const e1 = await this.renderer.checkVrSessionSupport();
                return this.setVrSessionSupport(e1), this.vrSessionSupported;
            }
            setVrSessionSupport(e1) {
                this.vrSessionSupported = e1;
            }
            resetMaskOptions() {
                this.onMaskObjectClick = ()=>{}, this.maskCursor = null;
            }
            setMaskObjectStairs(e1) {
                const t = e1.RoomID === this.currentPanorama.userData.room_id, n = `url(${t ? FS : HS}) 25 25, pointer`, i = t ? Ci.nextFloorIndex : Ci.prevFloorIndex, r = t ? e1.UpperFloorCameraPointID : e1.LowerFloorCameraPointID, { CameraPoints: a } = Ci.config.json.Floors[i], { id: s } = a.reduce((t, n)=>{
                    const i = [
                        n.Location.X,
                        n.Location.Y
                    ], r = _y([
                        [
                            e1.Location.X,
                            e1.Location.Y
                        ],
                        i
                    ]);
                    return r < t.length ? {
                        id: n.ID,
                        length: r
                    } : t;
                }, {
                    length: 1 / 0,
                    id: null
                });
                this.initialPanoramaId = r || s, this.maskCursor = n, this.onMaskObjectClick = ()=>t ? Ci.setNextFloorIndex() : Ci.setPrevFloorIndex();
            }
            setMaskObjectDefault() {
                this.maskCursor = "pointer", this.onMaskObjectClick = ()=>{};
            }
            updateMask() {
                const e1 = this.getObjectFromMask(), t = jx.some((t)=>e1?.Model === t);
                return e1 ? t ? this.setMaskObjectStairs(e1) : this.setMaskObjectDefault() : this.resetMaskOptions();
            }
            getObjectFromMask() {
                if (!this.currentPanorama || !this.currentPanorama.mask) return;
                if (!Ci.config.json || !Ci.config.json.ObjectMaskColorPairs) return;
                if (this.interactiveGroup.hover) return;
                const { direction: e1 } = this.raycaster.ray, t = (1 + Math.atan2(e1.z, e1.x) / Math.PI) / 2, n = Math.acos(e1.y) / Math.PI, { R: i } = Dx(t, n, this.currentPanorama.mask), r = Math.round(i), a = Ci.config.json.ObjectMaskColorPairs.find((e1)=>e1.MaskColorID.R === r);
                return a && "Furniture" === a.Type && xx(Ci.config.json, this.currentPanorama.userData.room_id) ? zx(Ci.config.json, a.ObjectID) : void 0;
            }
            setRulerInstructionShown(e1) {
                this.rulerInstructionShown = e1;
            }
            setRulerButtonState(e1) {
                this.rulerButtonEnabled = e1, this.vrControlPanel.rulerButtonAvailable = e1;
            }
            setRulerMode(e1) {
                this.rulerModeEnabled = e1, this.vrControlPanel.setRulerIcon(e1), this.rulersGroup.children.forEach((t)=>{
                    const n = !!e1 && t.userData.panoramaId === this.currentPanorama.panoramaId;
                    t.centerPoint && (t.centerPoint.visible = n), t.visible = n;
                }), e1 ? (this.currentRulerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkyMjggMTcuODIyTDI1LjM1NSAxNS4zODk3TDMwLjIxOTYgMTAuNTI1MUMzMC42Nzc4IDEwLjA2NyAzMC43MTc0IDkuMzYzNzggMzAuMzA4MSA4Ljk1NDVMMjMuNDA2IDIuMDUyNEMyMi45OTY3IDEuNjQzMTIgMjIuMjkzNSAxLjY4Mjc0IDIxLjgzNTQgMi4xNDA5TDE2Ljk3MDggNy4wMDU0NkwxNC41Mzg1IDkuNDM3NzRNMTkuMzE3OCAyMS40MjdMMTAuNzYxNCAyOS45ODM0QzEwLjMwMzIgMzAuNDQxNSA5LjYgMzAuNDgxMiA5LjE5MDcyIDMwLjA3MTlMMi4yODg2MiAyMy4xNjk4QzEuODc5MzMgMjIuNzYwNSAxLjkxODk2IDIyLjA1NzMgMi4zNzcxMiAyMS41OTkxTDEwLjc2MTQgMTMuMjE0OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC4wNDkzIDcuMjU0MzlMMjIuNzQyIDExLjk0NzEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy40OTA2IDE3LjgxM0wxMi4xODM0IDIyLjUwNTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41NDkyNiAzLjQ5NjA5TDI5LjEwMjMgMzAuODExMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuMjgzMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", gx.isMobileDevice || this.createTempRuler()) : (this.currentRulerIcon = NN, this.destroyTempRuler());
            }
            toggleRulerMode(e1) {
                this.setRulerMode(!this.rulerModeEnabled), e1 && e1.controller && (this.interactiveGroup.controller1.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller1.removeEventListener("move", this.onControllerMove), this.interactiveGroup.controller2.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller2.removeEventListener("move", this.onControllerMove), e1.controller.addEventListener("select", this.onControllerSelect), e1.controller.addEventListener("move", this.onControllerMove));
            }
            getRulerPoint() {
                const { direction: e1 } = this.raycaster.ray, t = (1 + Math.atan2(e1.z, e1.x) / Math.PI) / 2, n = Math.acos(e1.y) / Math.PI, { R: i } = Dx(t, n, this.currentPanorama.depthMap), r = i || 140;
                return {
                    depthValue: r,
                    position: e1.clone().multiplyScalar(r).add(this.currentCamera.position),
                    quaternion: this.getRulerPointQuaternion()
                };
            }
            getRulerPointQuaternion() {
                const { width: e1, height: t } = this.currentPanorama.depthMap, { direction: n } = this.raycaster.ray, i = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 0,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: 1,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 1
                    },
                    {
                        x: 0,
                        y: 1
                    },
                    {
                        x: 1,
                        y: 1
                    }
                ], r = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, a = Math.acos(n.y) / Math.PI, s = 1 / t, o = 1 / e1, l = Math.round(Math.sqrt(i.length)), c = i.map((e1)=>{
                    let { x: t, y: n } = e1;
                    const i = r + o * t, l = a + s * n, { R: c } = Dx(i, l, this.currentPanorama.depthMap), u = c || 140, h = ((e1, t)=>{
                        const n = new Ll;
                        return n.x = Math.cos((2 * e1 - 1) * Math.PI) * Math.sin(t * Math.PI), n.z = Math.sin((2 * e1 - 1) * Math.PI) * Math.sin(t * Math.PI), n.y = Math.cos(t * Math.PI), n;
                    })(i, l);
                    return h.clone().multiplyScalar(u).add(this.currentCamera.position);
                }), u = new Ll(0, 0, 0);
                for(let e1 = 0; e1 < l - 1; e1++)for(let t = 0; t < l - 1; t++){
                    const n = e1 * l + t, i = (e1 + 1) * l + t, r = c[n], a = c[n + 1], s = c[i], o = c[i + 1];
                    u.add(Lx(r, a, s)), u.add(Lx(a, o, s));
                }
                u.normalize();
                const h = new Ll(0, Math.sign(n.y), 0), d = (new Ll).crossVectors(h, u), p = u.angleTo(h);
                return (new Cl).setFromAxisAngle(d, p);
            }
            updateRuler() {
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return this.tempRuler.secondPoint ? this.tempRuler.update(e1, t) : this.tempRuler.firstPoint.update(e1, t);
            }
            finishRuler() {
                return this.interactiveGroup.add(this.tempRuler.centerPoint), this.tempRuler.centerPoint.addEventListeners(), this.tempRuler = null, this;
            }
            addRulerPoint() {
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return gx.isMobileDevice ? this.tempRuler ? void (this.tempRuler.firstPoint && (this.tempRuler.createRest(e1, t), this.updateRuler(), this.finishRuler())) : this.createTempRuler() : this.tempRuler.secondPoint ? (this.finishRuler(), this.createTempRuler()) : this.tempRuler.createRest(e1, t);
            }
            createTempRuler() {
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return this.tempRuler = new SN(this.currentPanorama.panoramaId), this.tempRuler.createFirstPoint(e1, t), this.rulersGroup.add(this.tempRuler), this;
            }
            destroyTempRuler() {
                return this.tempRuler ? (this.tempRuler.dispose(), this.tempRuler = null, this) : this;
            }
            setCameraFov(e1) {
                switch(this.camera.fov = e1, this.cameraFov = e1, e1){
                    case this.cameraFovValues.x1:
                        this.currentFovIcon = "sidebar" === Ci.config.designType ? IN : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTYzMiAyNC45MDY3VjUuOTA2NjhIOC45NjI1N0wwLjQ4Mjg1NyA4Ljg5NVYxMi4wNTNMNS40MDQ4NCAxMC4zMzA0VjI0LjkwNjdIOS4xNjMyWiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMjMuMTI2NiAxNS4xOTc5TDE5Ljk5NjkgMTAuNzg3MkgxNS45OTc4TDIwLjgzOTUgMTcuNzE2NEwxNS44MTA1IDI0LjkwNjdIMTkuODM2NEwyMy4xNCAyMC4yODcyTDI2LjQ3MDQgMjQuOTA2N0gzMC40ODI5TDI1LjQ1MzkgMTcuNzE2NEwzMC4zMDkgMTAuNzg3MkgyNi4zMDk5TDIzLjEyNjYgMTUuMTk3OVoiIGZpbGw9IiM0MTNFM0UiLz4KPC9zdmc+Cg==", this.currentFovText = "1x";
                        break;
                    case this.cameraFovValues.x2:
                        this.currentFovIcon = "sidebar" === Ci.config.designType ? IN : "data:image/svg+xml;base64,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", this.currentFovText = "2x";
                        break;
                    case this.cameraFovValues.x05:
                        this.currentFovIcon = "sidebar" === Ci.config.designType ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ5OCAyMC42MjVIMjQuNzQ4OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuNjIzIDE2LjVWMjQuNzUwNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjAuNTM4IDMwLjc2NzRDMjYuMTg2NSAzMC43Njc0IDMwLjc2NTQgMjYuMTg4NCAzMC43NjU0IDIwLjUzOTlDMzAuNzY1NCAxNC44OTE1IDI2LjE4NjUgMTAuMzEyNSAyMC41MzggMTAuMzEyNUMxNC44ODk1IDEwLjMxMjUgMTAuMzEwNSAxNC44OTE1IDEwLjMxMDUgMjAuNTM5OUMxMC4zMTA1IDI2LjE4ODQgMTQuODg5NSAzMC43Njc0IDIwLjUzOCAzMC43Njc0WiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuNzcxNSAyNy43Njk1TDMzLjY4ODggMzMuNjg2OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTQ4MDkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K" : "data:image/svg+xml;base64,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", this.currentFovText = "0.5x";
                }
            }
            toggleFov() {
                const e1 = Object.entries(this.cameraFovValues).find((e1)=>{
                    let [t, n] = e1;
                    return n === this.camera.fov;
                })[0], t = Ci.scales.findIndex((t)=>t === e1);
                Ci.scales[t + 1] ? this.setCameraFov(this.cameraFovValues[Ci.scales[t + 1]]) : this.setCameraFov(this.cameraFovValues[Ci.scales[0]]);
            }
            setAutoRotateState(e1) {
                this.autoRotateState = e1, this.currentAutoRotateIcon = e1 ? "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjM4IiBoZWlnaHQ9IjM4IiB2aWV3Qm94PSIwIDAgMzggMzgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMi43NiAyNi40MTQzQzI1LjQyMSAyNi4wNjY2IDI3LjkwNzQgMjUuMzIyNSAyOS45Njg1IDI0LjIzODNDMzIuOTA3MSAyMi42OTI2IDM0Ljc3NTMgMjAuNTYzOSAzNS4yMTYzIDE4LjI1ODhDMzUuNjU3MyAxNS45NTM3IDM0LjY0MDEgMTMuNjMzOCAzMi4zNTkxIDExLjc0MjJDMzAuMDc4MSA5Ljg1MDUxIDI2LjY5MzEgOC41MTk2OCAyMi44NTA1IDguMDAzODVDMTkuMDA4IDcuNDg4MDIgMTQuOTc3MyA3LjgyMzM0IDExLjUyODIgOC45NDU3N0M4LjA3OTExIDEwLjA2ODIgNS40NTMzOSAxMS44OTkxIDQuMTUyNTIgMTQuMDg4N0MzLjgxODExIDE0LjY1MTYgMy41NzcyOCAxNS4yMjggMy40Mjk2NSAxNS44MTAzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNS4yNTM2IDE5LjQzMzNMMTkuOTY4NyAyNi4wODM5TDI2LjA4NzMgMzAuOTQ2MyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuNDc4NSAyMC45Njk3TDUuNDEwMjMgMzAuMDM4IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC40Nzg1IDMwLjAzOEw1LjQxMDIzIDIwLjk2OTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+" : DN;
            }
            toggleAutoRotate() {
                this.setAutoRotateState(!this.autoRotateState), this.autoRotateState ? this.camera.deviceOrientationControls.disable() : gx.deviceOrientationGranted && this.camera.deviceOrientationControls.enable();
            }
            setCurrentPanoramasGroup(e1) {
                const t = this.floorsGroup.children.find((t)=>t.floorIndex === e1);
                if (t) return this.panoramasGroup = t, this.vrControlPanel.map.updateRoomsLayer(t), this.vrControlPanel.updateFloorMaterials(), this;
            }
            async setCurrentPanoramaById(e1) {
                if (this.currentPanorama?.panoramaId === e1) return;
                const t = this.getPanoramaById(e1);
                if (this.animation || !t) return this;
                if (this.setCurrentPanoramaId(e1), this.animation = !0, Cy.isCapable("hidden_furniture") && t.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await t.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanorama", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1)), !t.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await t.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanoramas", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1), Ci.config.enableCameraRotationBetweenPanoramas && 0 !== t.userData.rotation)) {
                    const e1 = !!Ci.config.enableCameraTransitionBetweenPanoramas && this.currentPanorama;
                    setTimeout(()=>{
                        this.camera.controls.normalizeRotations();
                        const n = Nx(this.camera.controls.azimuthAngle), i = Nx(t.userData.rotation), r = Ix(((e1, t)=>{
                            const n = (t - e1) % 360;
                            return n > 180 ? n - 360 : n < -180 ? n + 360 : n;
                        })(n, i));
                        this.camera.controls.rotate(r, 0, e1);
                    }, e1 ? 200 : 0);
                }
                for (const e1 of this.currentPanorama?.links || [])e1.visible = !1;
                for (const e1 of t.links)e1.visible = !0;
                if (this.rulerModeEnabled) for (const t of this.rulersGroup.children){
                    const n = t.userData.panoramaId === e1;
                    t.centerPoint && (t.centerPoint.visible = n), t.visible = n;
                }
                this.currentPanorama && (this.currentPanorama.renderOrder = 0), t.renderOrder = 1, t.visible = !0, await t.fadeIn(), this.currentPanorama && (await this.currentPanorama.fadeOut(), this.currentPanorama.visible = !1);
                const n = null !== t.depthMap;
                return this.setCurrentPanorama(t), this.animation = !1, this.destroyTempRuler(), this.setRulerButtonState(n), this.rulerModeEnabled && this.setRulerMode(n), this;
            }
            setCurrentPanoramaId(e1) {
                this.currentPanoramaId = e1;
            }
            setCurrentPanorama(e1) {
                this.currentPanorama = e1;
            }
            async setInitialCurrentPanorama() {
                const e1 = this.panoramasGroup.children.find((e1)=>0 === e1.userData.panorama_index), t = this.initialPanoramaId || e1?.panoramaId || null;
                return this.setCurrentPanoramaById(t).then(()=>{
                    this.initialPanoramaId = null;
                });
            }
            createPanoramas(e1, t) {
                const n = this.panoramasGroup.createPanoramas(e1, t);
                for (const e1 of n)for (const t of e1.links)t.onClick = ()=>{
                    if (!this.rulerModeEnabled || !Cy.isProActive) return t.isStairs ? t.userData.directionUp ? Ci.setNextFloorIndex() : Ci.setPrevFloorIndex() : void this.setCurrentPanoramaById(t.userData.targetId);
                    this.addRulerPoint();
                }, this.interactiveGroup.add(t);
                return this;
            }
        }, LN = CN;
        if (!t.useState) throw new Error("mobx-react-lite requires React with Hooks support");
        function zN(e1) {
            e1();
        }
        function ON(e1) {
            var t;
            return sn(hi(e1, t));
        }
        var RN = function() {
            function e1(e1) {
                var t = this;
                Object.defineProperty(this, "finalize", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: e1
                }), Object.defineProperty(this, "registrations", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: new Map
                }), Object.defineProperty(this, "sweepTimeout", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                }), Object.defineProperty(this, "sweep", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function(e1) {
                        void 0 === e1 && (e1 = 1e4), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
                        var n = Date.now();
                        t.registrations.forEach(function(i, r) {
                            n - i.registeredAt >= e1 && (t.finalize(i.value), t.registrations.delete(r));
                        }), t.registrations.size > 0 && t.scheduleSweep();
                    }
                }), Object.defineProperty(this, "finalizeAllImmediately", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        t.sweep(0);
                    }
                });
            }
            return Object.defineProperty(e1.prototype, "register", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(e1, t, n) {
                    this.registrations.set(n, {
                        value: t,
                        registeredAt: Date.now()
                    }), this.scheduleSweep();
                }
            }), Object.defineProperty(e1.prototype, "unregister", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(e1) {
                    this.registrations.delete(e1);
                }
            }), Object.defineProperty(e1.prototype, "scheduleSweep", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function() {
                    void 0 === this.sweepTimeout && (this.sweepTimeout = setTimeout(this.sweep, 1e4));
                }
            }), e1;
        }(), PN = new ("undefined" != typeof FinalizationRegistry ? FinalizationRegistry : RN)(function(e1) {
            var t;
            null === (t = e1.reaction) || void 0 === t || t.dispose(), e1.reaction = null;
        }), UN = !1;
        function jN() {
            return UN;
        }
        var kN = function(e1, t) {
            var n = "function" == typeof Symbol && e1[Symbol.iterator];
            if (!n) return e1;
            var i, r, a = n.call(e1), s = [];
            try {
                for(; (void 0 === t || t-- > 0) && !(i = a.next()).done;)s.push(i.value);
            } catch (e1) {
                r = {
                    error: e1
                };
            } finally{
                try {
                    i && !i.done && (n = a.return) && n.call(a);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s;
        };
        function BN(e1) {
            return "observer".concat(e1);
        }
        var FN = function() {};
        function HN() {
            return new FN;
        }
        var GN = "function" == typeof Symbol && Symbol.for, VN = GN ? Symbol.for("react.forward_ref") : "function" == typeof t.forwardRef && (0, t.forwardRef)(function(e1) {
            return null;
        }).$$typeof, QN = GN ? Symbol.for("react.memo") : "function" == typeof t.memo && (0, t.memo)(function(e1) {
            return null;
        }).$$typeof;
        function WN(e1, n) {
            var i;
            if (QN && e1.$$typeof === QN) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
            if (jN()) return e1;
            var r = null !== (i = null == n ? void 0 : n.forwardRef) && void 0 !== i && i, a = e1, s = e1.displayName || e1.name;
            if (VN && e1.$$typeof === VN && (r = !0, "function" != typeof (a = e1.render))) throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
            var o, l, c = function(e1, n) {
                return function(e1, n) {
                    if (void 0 === n && (n = "observed"), jN()) return e1();
                    var i = kN(t.useState(HN), 1)[0], r = kN(t.useState(), 2)[1], a = function() {
                        return r([]);
                    }, s = t.useRef(null);
                    s.current || (s.current = {
                        reaction: null,
                        mounted: !1,
                        changedBeforeMount: !1
                    });
                    var o, l, c = s.current;
                    if (c.reaction || (c.reaction = new Rt(BN(n), function() {
                        c.mounted ? a() : c.changedBeforeMount = !0;
                    }), PN.register(i, c, c)), t.useDebugValue(c.reaction, ON), t.useEffect(function() {
                        return PN.unregister(c), c.mounted = !0, c.reaction ? c.changedBeforeMount && (c.changedBeforeMount = !1, a()) : (c.reaction = new Rt(BN(n), function() {
                            a();
                        }), a()), function() {
                            c.reaction.dispose(), c.reaction = null, c.mounted = !1, c.changedBeforeMount = !1;
                        };
                    }, []), c.reaction.track(function() {
                        try {
                            o = e1();
                        } catch (e1) {
                            l = e1;
                        }
                    }), l) throw l;
                    return o;
                }(function() {
                    return a(e1, n);
                }, s);
            };
            return "" !== s && (c.displayName = s), e1.contextTypes && (c.contextTypes = e1.contextTypes), r && (c = (0, t.forwardRef)(c)), o = e1, l = c = (0, t.memo)(c), Object.keys(o).forEach(function(e1) {
                YN[e1] || Object.defineProperty(l, e1, Object.getOwnPropertyDescriptor(o, e1));
            }), c;
        }
        var YN = {
            $$typeof: !0,
            render: !0,
            compare: !0,
            type: !0,
            displayName: !0
        };
        !function(e1) {
            e1 || (e1 = zN), rn({
                reactionScheduler: e1
            });
        }(xi.unstable_batchedUpdates), PN.finalizeAllImmediately;
        class XN {
            static keys(e1) {
                return Object.keys(e1);
            }
        }
        const ZN = {
            smallMobile: 374,
            mobile: 670,
            tablet: 1100,
            laptop: 1440
        }, qN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjQwODkgMTAuMjc2OUwxMS4wMzQ1IDM4LjY1MTMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM5LjQwODkgMzguNjUxM0wxMS4wMzQ1IDEwLjI3NjkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", KN = WN(()=>Zi.enabled ? "standard" !== Ci.config.designType ? null : Zi.active ? t.createElement("button", {
                type: "button",
                className: "widget-exit-fullscreen",
                onClick: ()=>Zi.exit()
            }, t.createElement("img", {
                src: qN,
                alt: "exit-fullscreen"
            })) : t.createElement("button", {
                type: "button",
                className: "widget-enter-fullscreen",
                onClick: ()=>Zi.enter()
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjI1IDkuODc1SDQwLjYyNVYxOS4yNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuNjg3NSAyMC44MTI1TDQwLjYyNSA5Ljg3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguNzUgNDEuMTI1SDkuMzc1VjMxLjc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4zMTI1IDMwLjE4NzVMOS4zNzUgNDEuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=",
                alt: "enter-fullscreen"
            })) : null), JN = WN(()=>{
            const [e1, n] = (0, t.useState)(!1);
            return t.createElement("button", {
                type: "button",
                className: "widget-tab-button",
                disabled: e1,
                onClick: async ()=>{
                    n(!0), LN.enterVr().finally(()=>n(!1));
                }
            }, "VR");
        }), $N = (e1)=>{
            let { active: n, text: i, img: r, onClick: a } = e1;
            return t.createElement("button", {
                type: "button",
                className: "widget-tab-button " + (n ? "widget-tab-button--active" : ""),
                onClick: a
            }, i, Boolean(r) && t.createElement("img", {
                src: r,
                alt: "icon"
            }));
        }, eD = (e1)=>{
            let { href: n, text: i } = e1;
            return t.createElement("a", {
                href: n,
                target: "_blank",
                rel: "noreferrer"
            }, t.createElement("span", null, "made by"), " ", i);
        };
        var tD = n(300), nD = n.n(tD);
        function iD(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function rD(e1, t) {
            return e1.get(sD(e1, t));
        }
        function aD(e1, t, n) {
            return e1.set(sD(e1, t), n), n;
        }
        function sD(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var oD = new WeakMap, lD = new WeakMap, cD = new WeakMap;
        const uD = class {
            constructor(e1, t){
                iD(this, oD, null), iD(this, lD, null), iD(this, cD, null), aD(lD, this, t), aD(cD, this, {
                    container: {
                        mousedown: (e1)=>{
                            0 === e1.button && aD(oD, this, e1.pageX);
                        },
                        touchstart: (e1)=>aD(oD, this, e1.touches[0].clientX),
                        touchend: ()=>aD(oD, this, null)
                    },
                    prev: {
                        mousedown: (t)=>{
                            t.preventDefault(), e1.play(!0);
                        },
                        mouseup: (t)=>{
                            t.preventDefault(), e1.stop();
                        },
                        touchstart: (t)=>{
                            t.preventDefault(), e1.prev();
                        }
                    },
                    next: {
                        mousedown: (t)=>{
                            t.preventDefault(), e1.play();
                        },
                        mouseup: (t)=>{
                            t.preventDefault(), e1.stop();
                        },
                        touchstart: (t)=>{
                            t.preventDefault(), e1.next();
                        }
                    },
                    global: {
                        mouseup: ()=>aD(oD, this, null),
                        mousemove: (t)=>{
                            rD(oD, this) && Math.abs(rD(oD, this) - t.pageX) > rD(lD, this).dragTolerance && (e1.stop(), rD(oD, this) > t.pageX ? e1.prev() : e1.next(), aD(oD, this, t.pageX));
                        },
                        touchmove: (t)=>{
                            2 !== t.touches.length && (1 === t.touches.length && t.stopPropagation(), rD(oD, this) && Math.abs(rD(oD, this) - t.touches[0].clientX) > rD(lD, this).swipeTolerance && (e1.stop(), rD(oD, this) > t.touches[0].clientX ? e1.prev() : e1.next(), aD(oD, this, t.touches[0].clientX)));
                        },
                        keydown: (t)=>{
                            [
                                37,
                                39
                            ].includes(t.keyCode) && e1.play(37 === t.keyCode);
                        },
                        keyup: (t)=>{
                            [
                                37,
                                39
                            ].includes(t.keyCode) && e1.stop();
                        }
                    }
                }), this._initEvents();
            }
            destroy() {
                rD(lD, this).swipeTarget.removeEventListener("mousedown", rD(cD, this).container.mousedown), rD(lD, this).swipeTarget.removeEventListener("touchstart", rD(cD, this).container.touchstart), rD(lD, this).swipeTarget.removeEventListener("touchend", rD(cD, this).container.touchend), n.g.removeEventListener("mouseup", rD(cD, this).global.mouseup), n.g.removeEventListener("mousemove", rD(cD, this).global.mousemove), rD(lD, this).parentElement.removeEventListener("touchmove", rD(cD, this).global.touchmove), n.g.removeEventListener("keydown", rD(cD, this).global.keydown), n.g.removeEventListener("keyup", rD(cD, this).global.keyup), rD(lD, this).prev && (rD(lD, this).prev.removeEventListener("mousedown", rD(cD, this).prev.mousedown), rD(lD, this).prev.removeEventListener("mouseup", rD(cD, this).prev.mouseup), rD(lD, this).prev.removeEventListener("touchstart", rD(cD, this).prev.touchstart)), rD(lD, this).next && (rD(lD, this).next.removeEventListener("mousedown", rD(cD, this).next.mousedown), rD(lD, this).next.removeEventListener("mouseup", rD(cD, this).next.mouseup), rD(lD, this).next.removeEventListener("touchstart", rD(cD, this).next.touchstart));
            }
            _initEvents() {
                rD(lD, this).draggable && (rD(lD, this).swipeTarget.addEventListener("mousedown", rD(cD, this).container.mousedown), n.g.addEventListener("mouseup", rD(cD, this).global.mouseup), n.g.addEventListener("mousemove", rD(cD, this).global.mousemove)), rD(lD, this).swipeable && (rD(lD, this).swipeTarget.addEventListener("touchstart", rD(cD, this).container.touchstart), rD(lD, this).swipeTarget.addEventListener("touchend", rD(cD, this).container.touchend), rD(lD, this).parentElement.addEventListener("touchmove", rD(cD, this).global.touchmove)), rD(lD, this).keys && (n.g.addEventListener("keydown", rD(cD, this).global.keydown), n.g.addEventListener("keyup", rD(cD, this).global.keyup)), rD(lD, this).prev && (rD(lD, this).prev.addEventListener("mousedown", rD(cD, this).prev.mousedown), rD(lD, this).prev.addEventListener("mouseup", rD(cD, this).prev.mouseup), rD(lD, this).prev.addEventListener("touchstart", rD(cD, this).prev.touchstart)), rD(lD, this).next && (rD(lD, this).next.addEventListener("mousedown", rD(cD, this).next.mousedown), rD(lD, this).next.addEventListener("mouseup", rD(cD, this).next.mouseup), rD(lD, this).next.addEventListener("touchstart", rD(cD, this).next.touchstart));
            }
        };
        function hD(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function dD(e1, t) {
            return e1.get(fD(e1, t));
        }
        function pD(e1, t, n) {
            return e1.set(fD(e1, t), n), n;
        }
        function fD(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var gD = new WeakMap, mD = new WeakMap, AD = new WeakMap, MD = new WeakMap, vD = new WeakMap, yD = new WeakMap;
        const xD = class {
            constructor(e1, t){
                hD(this, gD, null), hD(this, mD, 0), hD(this, AD, null), hD(this, MD, !1), hD(this, vD, null), hD(this, yD, !1), this.container = e1, pD(gD, this, Object.assign({
                    width: 300,
                    height: 300,
                    aspectRatio: 0,
                    count: 0,
                    perRow: 0,
                    speed: 100,
                    dragTolerance: 10,
                    swipeTolerance: 10,
                    draggable: !0,
                    swipeable: !0,
                    keys: !0,
                    inverted: !1
                }, t)), dD(gD, this).swipeTarget = dD(gD, this).swipeTarget || this.container, pD(yD, this, !Array.isArray(dD(gD, this).image)), this.sprite || (dD(gD, this).count = dD(gD, this).image.length), Object.freeze(dD(gD, this)), pD(vD, this, new uD(this, dD(gD, this))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer();
            }
            get isResponsive() {
                return dD(gD, this).aspectRatio > 0;
            }
            get containerWidth() {
                return this.isResponsive ? this.container.clientWidth : dD(gD, this).width;
            }
            get containerHeight() {
                return this.isResponsive ? this.container.clientWidth * dD(gD, this).aspectRatio : dD(gD, this).height;
            }
            get index() {
                return dD(mD, this);
            }
            get looping() {
                return dD(MD, this);
            }
            get sprite() {
                return dD(yD, this);
            }
            next() {
                this.goto(dD(gD, this).inverted ? dD(mD, this) - 1 : dD(mD, this) + 1);
            }
            prev() {
                this.goto(dD(gD, this).inverted ? dD(mD, this) + 1 : dD(mD, this) - 1);
            }
            goto(e1) {
                pD(mD, this, (dD(gD, this).count + e1) % dD(gD, this).count), this._update();
            }
            play(e1) {
                this.looping || (this._loop(e1), pD(MD, this, !0));
            }
            stop() {
                this.looping && (n.g.clearTimeout(dD(AD, this)), pD(MD, this, !1));
            }
            toggle(e1) {
                this.looping ? this.stop() : this.play(e1);
            }
            destroy() {
                this.stop(), dD(vD, this).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener);
            }
            _loop(e1) {
                e1 ? this.prev() : this.next(), pD(AD, this, n.g.setTimeout(()=>{
                    this._loop(e1);
                }, dD(gD, this).speed));
            }
            _update() {
                this.sprite ? (this.container.style.backgroundPositionX = -dD(mD, this) % dD(gD, this).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(dD(mD, this) / dD(gD, this).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = `url("${dD(gD, this).image[dD(mD, this)]}")`;
            }
            _windowResizeListener() {
                this.container.style.height = this.containerHeight + "px", this._update();
            }
            _initContainer() {
                if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) {
                    this.container.style.backgroundImage = `url("${dD(gD, this).image}")`;
                    const e1 = dD(gD, this).perRow, t = Math.ceil(dD(gD, this).count / dD(gD, this).perRow);
                    this.container.style.backgroundSize = 100 * e1 + "% " + 100 * t + "%";
                }
                this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update();
            }
        }, bD = (e1)=>{
            let { initialized: n, images: i, activeIndex: r } = e1;
            return t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__threesixty " + (n ? "widget-tab__threesixty--active" : "")
            }, t.createElement("div", {
                className: "widget-tab__threesixty-container",
                onTouchMove: (e1)=>{
                    e1.touches.length > 1 || n || e1.stopPropagation();
                }
            }, i.map((e1, n)=>t.createElement("img", {
                    className: r === n ? "active" : "",
                    alt: `rotation-view-${n}`,
                    key: n,
                    src: e1
                })))));
        }, wD = (e1)=>{
            let { steps: n = [], disabled: i = !1, onClick: r = ()=>{}, isRuler: a } = e1;
            const s = Pi("instructions-hint-text");
            return t.createElement("div", {
                className: "widget-instructions",
                onClick: ()=>{
                    i || r();
                }
            }, t.createElement("div", {
                className: "widget-instructions__content",
                onClick: (e1)=>e1.stopPropagation()
            }, t.createElement("div", {
                className: "widget-instructions__steps"
            }, n.map((e1, n)=>{
                let { text: i, icon: r } = e1;
                return t.createElement("div", {
                    className: "widget-instructions__step",
                    key: n
                }, t.createElement("img", {
                    src: r,
                    alt: "step-icon"
                }), t.createElement("p", null, i));
            })), t.createElement("div", {
                className: "widget-instructions__line"
            }), t.createElement("button", {
                disabled: i,
                onClick: r,
                type: "button"
            }, Pi(a ? "ruler-ok" : "ok")), Boolean(s) && t.createElement("div", {
                className: "widget-instructions__hint"
            }, t.createElement("p", null, s))));
        }, ED = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTZIMjciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4IDdMMjcgMTZMMTggMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", TD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE2SDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDdMNSAxNkwxNCAyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
        class SD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                SD.prototype.isVector4 = !0, this.x = e1, this.y = t, this.z = n, this.w = i;
            }
            get width() {
                return this.z;
            }
            set width(e1) {
                this.z = e1;
            }
            get height() {
                return this.w;
            }
            set height(e1) {
                this.w = e1;
            }
            set(e1, t, n, i) {
                return this.x = e1, this.y = t, this.z = n, this.w = i, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this.w = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setW(e1) {
                return this.w = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    case 3:
                        this.w = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this.w = void 0 !== e1.w ? e1.w : 1, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this.w += e1.w, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this.w += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this.w = e1.w + t.w, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this.w += e1.w * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this.w -= e1.w, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this.w -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this.w = e1.w - t.w, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this.w *= e1.w, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this.w *= e1, this;
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = this.w, a = e1.elements;
                return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            setAxisAngleFromQuaternion(e1) {
                this.w = 2 * Math.acos(e1.w);
                const t = Math.sqrt(1 - e1.w * e1.w);
                return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e1.x / t, this.y = e1.y / t, this.z = e1.z / t), this;
            }
            setAxisAngleFromRotationMatrix(e1) {
                let t, n, i, r;
                const a = .01, s = .1, o = e1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], g = o[6], m = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - g) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + g) < s && Math.abs(l + d + m - 3) < s) return this.set(1, 0, 0, 0), this;
                    t = Math.PI;
                    const e1 = (l + 1) / 2, o = (d + 1) / 2, A = (m + 1) / 2, M = (c + h) / 4, v = (u + f) / 4, y = (p + g) / 4;
                    return e1 > o && e1 > A ? e1 < a ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(e1), i = M / n, r = v / n) : o > A ? o < a ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = M / i, r = y / i) : A < a ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(A), n = v / r, i = y / r), this.set(n, i, r, t), this;
                }
                let A = Math.sqrt((g - p) * (g - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(A) < .001 && (A = 1), this.x = (g - p) / A, this.y = (u - f) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + m - 1) / 2), this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this.w = Math.min(this.w, e1.w), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this.w = Math.max(this.w, e1.w), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this.w = Math.max(e1.w, Math.min(t.w, this.w)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this.w = Math.max(e1, Math.min(t, this.w)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z + this.w * e1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this.w += (e1.w - this.w) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this.w = e1.w + (t.w - e1.w) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z && e1.w === this.w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this.w = e1[t + 3], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1[t + 3] = this.w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this.w = e1.getW(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        const ID = {
            enabled: !1,
            files: {},
            add: function(e1, t) {
                !1 !== this.enabled && (this.files[e1] = t);
            },
            get: function(e1) {
                if (!1 !== this.enabled) return this.files[e1];
            },
            remove: function(e1) {
                delete this.files[e1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class ND {
            constructor(e1, t, n){
                const i = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = e1, this.onProgress = t, this.onError = n, this.itemStart = function(e1) {
                    o++, !1 === a && void 0 !== i.onStart && i.onStart(e1, s, o), a = !0;
                }, this.itemEnd = function(e1) {
                    s++, void 0 !== i.onProgress && i.onProgress(e1, s, o), s === o && (a = !1, void 0 !== i.onLoad && i.onLoad());
                }, this.itemError = function(e1) {
                    void 0 !== i.onError && i.onError(e1);
                }, this.resolveURL = function(e1) {
                    return r ? r(e1) : e1;
                }, this.setURLModifier = function(e1) {
                    return r = e1, this;
                }, this.addHandler = function(e1, t) {
                    return l.push(e1, t), this;
                }, this.removeHandler = function(e1) {
                    const t = l.indexOf(e1);
                    return -1 !== t && l.splice(t, 2), this;
                }, this.getHandler = function(e1) {
                    for(let t = 0, n = l.length; t < n; t += 2){
                        const n = l[t], i = l[t + 1];
                        if (n.global && (n.lastIndex = 0), n.test(e1)) return i;
                    }
                    return null;
                };
            }
        }
        const DD = new ND;
        class _D {
            constructor(e1){
                this.manager = void 0 !== e1 ? e1 : DD, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.load(e1, i, t, r);
                });
            }
            parse() {}
            setCrossOrigin(e1) {
                return this.crossOrigin = e1, this;
            }
            setWithCredentials(e1) {
                return this.withCredentials = e1, this;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            setResourcePath(e1) {
                return this.resourcePath = e1, this;
            }
            setRequestHeader(e1) {
                return this.requestHeader = e1, this;
            }
        }
        function CD(e1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", e1);
        }
        _D.DEFAULT_MATERIAL_NAME = "__DEFAULT", Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
        const LD = {};
        function zD(e1) {
            e1 in LD || (LD[e1] = !0, console.warn(e1));
        }
        class OD extends _D {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = ID.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = CD("img");
                function o() {
                    c(), ID.add(e1, this), t && t(this), r.manager.itemEnd(e1);
                }
                function l(t) {
                    c(), i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(e1), s.src = e1, s;
            }
        }
        class RD {
            addEventListener(e1, t) {
                void 0 === this._listeners && (this._listeners = {});
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                if (void 0 === this._listeners) return !1;
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                if (void 0 === this._listeners) return;
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            dispatchEvent(e1) {
                if (void 0 === this._listeners) return;
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                    e1.target = null;
                }
            }
        }
        const PD = 1001, UD = 3001, jD = "srgb", kD = 2e3, BD = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        function FD() {
            const e1 = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
            return (BD[255 & e1] + BD[e1 >> 8 & 255] + BD[e1 >> 16 & 255] + BD[e1 >> 24 & 255] + "-" + BD[255 & t] + BD[t >> 8 & 255] + "-" + BD[t >> 16 & 15 | 64] + BD[t >> 24 & 255] + "-" + BD[63 & n | 128] + BD[n >> 8 & 255] + "-" + BD[n >> 16 & 255] + BD[n >> 24 & 255] + BD[255 & i] + BD[i >> 8 & 255] + BD[i >> 16 & 255] + BD[i >> 24 & 255]).toLowerCase();
        }
        function HD(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        Math.PI, Math.PI;
        class GD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                GD.prototype.isVector2 = !0, this.x = e1, this.y = t;
            }
            get width() {
                return this.x;
            }
            set width(e1) {
                this.x = e1;
            }
            get height() {
                return this.y;
            }
            set height(e1) {
                this.y = e1;
            }
            set(e1, t) {
                return this.x = e1, this.y = t, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this;
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = e1.elements;
                return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y;
            }
            cross(e1) {
                return this.x * e1.y - this.y * e1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(HD(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y;
                return t * t + n * n;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this;
            }
            rotateAround(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = this.x - e1.x, a = this.y - e1.y;
                return this.x = r * n - a * i + e1.x, this.y = r * i + a * n + e1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class VD {
            constructor(e1, t, n, i, r, a, s, o, l){
                VD.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l);
            }
            set(e1, t, n, i, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = e1, c[1] = i, c[2] = s, c[3] = t, c[4] = r, c[5] = o, c[6] = n, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(e1) {
                const t = e1.elements;
                return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[3], o = n[6], l = n[1], c = n[4], u = n[7], h = n[2], d = n[5], p = n[8], f = i[0], g = i[3], m = i[6], A = i[1], M = i[4], v = i[7], y = i[2], x = i[5], b = i[8];
                return r[0] = a * f + s * A + o * y, r[3] = a * g + s * M + o * x, r[6] = a * m + s * v + o * b, r[1] = l * f + c * A + u * y, r[4] = l * g + c * M + u * x, r[7] = l * m + c * v + u * b, r[2] = h * f + d * A + p * y, r[5] = h * g + d * M + p * x, r[8] = h * m + d * v + p * b, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[3] *= e1, t[6] *= e1, t[1] *= e1, t[4] *= e1, t[7] *= e1, t[2] *= e1, t[5] *= e1, t[8] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
                return t * a * c - t * s * l - n * r * c + n * s * o + i * r * l - i * a * o;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = t * u + n * h + i * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return e1[0] = u * f, e1[1] = (i * l - c * n) * f, e1[2] = (s * n - i * a) * f, e1[3] = h * f, e1[4] = (c * t - i * o) * f, e1[5] = (i * r - s * t) * f, e1[6] = d * f, e1[7] = (n * o - l * t) * f, e1[8] = (a * t - n * r) * f, this;
            }
            transpose() {
                let e1;
                const t = this.elements;
                return e1 = t[1], t[1] = t[3], t[3] = e1, e1 = t[2], t[2] = t[6], t[6] = e1, e1 = t[5], t[5] = t[7], t[7] = e1, this;
            }
            getNormalMatrix(e1) {
                return this.setFromMatrix4(e1).invert().transpose();
            }
            transposeIntoArray(e1) {
                const t = this.elements;
                return e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8], this;
            }
            setUvTransform(e1, t, n, i, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(n * o, n * l, -n * (o * a + l * s) + a + e1, -i * l, i * o, -i * (-l * a + o * s) + s + t, 0, 0, 1), this;
            }
            scale(e1, t) {
                return this.premultiply(QD.makeScale(e1, t)), this;
            }
            rotate(e1) {
                return this.premultiply(QD.makeRotation(-e1)), this;
            }
            translate(e1, t) {
                return this.premultiply(QD.makeTranslation(e1, t)), this;
            }
            makeTranslation(e1, t) {
                return e1.isVector2 ? this.set(1, 0, e1.x, 0, 1, e1.y, 0, 0, 1) : this.set(1, 0, e1, 0, 1, t, 0, 0, 1), this;
            }
            makeRotation(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
            }
            makeScale(e1, t) {
                return this.set(e1, 0, 0, 0, t, 0, 0, 0, 1), this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 9; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 9; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const QD = new VD;
        function WD(e1) {
            return e1 < .04045 ? .0773993808 * e1 : Math.pow(.9478672986 * e1 + .0521327014, 2.4);
        }
        let YD;
        new Set([
            "srgb-linear",
            "display-p3-linear"
        ]);
        class XD {
            static getDataURL(e1) {
                if (/^data:/i.test(e1.src)) return e1.src;
                if ("undefined" == typeof HTMLCanvasElement) return e1.src;
                let t;
                if (e1 instanceof HTMLCanvasElement) t = e1;
                else {
                    void 0 === YD && (YD = CD("canvas")), YD.width = e1.width, YD.height = e1.height;
                    const n = YD.getContext("2d");
                    e1 instanceof ImageData ? n.putImageData(e1, 0, 0) : n.drawImage(e1, 0, 0, e1.width, e1.height), t = YD;
                }
                return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e1), t.toDataURL("image/jpeg", .6)) : t.toDataURL("image/png");
            }
            static sRGBToLinear(e1) {
                if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                    const t = CD("canvas");
                    t.width = e1.width, t.height = e1.height;
                    const n = t.getContext("2d");
                    n.drawImage(e1, 0, 0, e1.width, e1.height);
                    const i = n.getImageData(0, 0, e1.width, e1.height), r = i.data;
                    for(let e1 = 0; e1 < r.length; e1++)r[e1] = 255 * WD(r[e1] / 255);
                    return n.putImageData(i, 0, 0), t;
                }
                if (e1.data) {
                    const t = e1.data.slice(0);
                    for(let e1 = 0; e1 < t.length; e1++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e1] = Math.floor(255 * WD(t[e1] / 255)) : t[e1] = WD(t[e1]);
                    return {
                        data: t,
                        width: e1.width,
                        height: e1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e1;
            }
        }
        let ZD = 0;
        class qD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: ZD++
                }), this.uuid = FD(), this.data = e1, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.images[this.uuid]) return e1.images[this.uuid];
                const n = {
                    uuid: this.uuid,
                    url: ""
                }, i = this.data;
                if (null !== i) {
                    let e1;
                    if (Array.isArray(i)) {
                        e1 = [];
                        for(let t = 0, n = i.length; t < n; t++)i[t].isDataTexture ? e1.push(KD(i[t].image)) : e1.push(KD(i[t]));
                    } else e1 = KD(i);
                    n.url = e1;
                }
                return t || (e1.images[this.uuid] = n), n;
            }
        }
        function KD(e1) {
            return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap ? XD.getDataURL(e1) : e1.data ? {
                data: Array.from(e1.data),
                width: e1.width,
                height: e1.height,
                type: e1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let JD = 0;
        class $D extends RD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $D.DEFAULT_IMAGE, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $D.DEFAULT_MAPPING, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : PD, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : PD, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1006, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1008, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1023, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 1009, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : $D.DEFAULT_ANISOTROPY, c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : "";
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: JD++
                }), this.uuid = FD(), this.name = "", this.source = new qD(e1), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new GD(0, 0), this.repeat = new GD(1, 1), this.center = new GD(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new VD, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (zD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === UD ? jD : ""), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(e1) {
                void 0 === e1 && (e1 = null), this.source.data = e1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.name = e1.name, this.source = e1.source, this.mipmaps = e1.mipmaps.slice(0), this.mapping = e1.mapping, this.channel = e1.channel, this.wrapS = e1.wrapS, this.wrapT = e1.wrapT, this.magFilter = e1.magFilter, this.minFilter = e1.minFilter, this.anisotropy = e1.anisotropy, this.format = e1.format, this.internalFormat = e1.internalFormat, this.type = e1.type, this.offset.copy(e1.offset), this.repeat.copy(e1.repeat), this.center.copy(e1.center), this.rotation = e1.rotation, this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrix.copy(e1.matrix), this.generateMipmaps = e1.generateMipmaps, this.premultiplyAlpha = e1.premultiplyAlpha, this.flipY = e1.flipY, this.unpackAlignment = e1.unpackAlignment, this.colorSpace = e1.colorSpace, this.userData = JSON.parse(JSON.stringify(e1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.textures[this.uuid]) return e1.textures[this.uuid];
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(e1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e1.textures[this.uuid] = n), n;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(e1) {
                if (300 !== this.mapping) return e1;
                if (e1.applyMatrix3(this.matrix), e1.x < 0 || e1.x > 1) switch(this.wrapS){
                    case 1e3:
                        e1.x = e1.x - Math.floor(e1.x);
                        break;
                    case PD:
                        e1.x = e1.x < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(e1.x) % 2) ? e1.x = Math.ceil(e1.x) - e1.x : e1.x = e1.x - Math.floor(e1.x);
                }
                if (e1.y < 0 || e1.y > 1) switch(this.wrapT){
                    case 1e3:
                        e1.y = e1.y - Math.floor(e1.y);
                        break;
                    case PD:
                        e1.y = e1.y < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(e1.y) % 2) ? e1.y = Math.ceil(e1.y) - e1.y : e1.y = e1.y - Math.floor(e1.y);
                }
                return this.flipY && (e1.y = 1 - e1.y), e1;
            }
            set needsUpdate(e1) {
                !0 === e1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return zD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === jD ? UD : 3e3;
            }
            set encoding(e1) {
                zD("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e1 === UD ? jD : "";
            }
        }
        $D.DEFAULT_IMAGE = null, $D.DEFAULT_MAPPING = 300, $D.DEFAULT_ANISOTROPY = 1;
        class e_ extends _D {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new $D, a = new OD(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e1, function(e1) {
                    r.image = e1, r.needsUpdate = !0, void 0 !== t && t(r);
                }, n, i), r;
            }
        }
        class t_ extends $D {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(null, arguments.length > 5 ? arguments[5] : void 0, arguments.length > 6 ? arguments[6] : void 0, arguments.length > 7 ? arguments[7] : void 0, arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 1003, arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 1003, arguments.length > 3 ? arguments[3] : void 0, arguments.length > 4 ? arguments[4] : void 0, arguments.length > 10 ? arguments[10] : void 0, arguments.length > 11 ? arguments[11] : void 0), this.isDataTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        function n_(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        rn({
            useProxies: "never"
        });
        const i_ = new class {
            constructor(){
                n_(this, "roomMask", null), n_(this, "roomsVisible", null), n_(this, "currentColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), n_(this, "fixedColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), n_(this, "textureImg", null), n_(this, "textureMask", null), Tn(this);
            }
            getCurrentColorVector() {
                return new SD(this.currentColor.R, this.currentColor.G, this.currentColor.B, this.currentColor.A);
            }
            getFixedColorVector() {
                return new SD(this.fixedColor.R, this.fixedColor.G, this.fixedColor.B, this.fixedColor.A);
            }
            setRoomMask(e1) {
                this.roomMask = e1;
            }
            setRoomsVisible(e1) {
                this.roomsVisible = e1;
            }
            setCurrentColor(e1) {
                this.currentColor = e1;
            }
            setFixedColor(e1) {
                this.fixedColor = e1;
            }
            setTextureImg(e1) {
                const t = new e_;
                this.textureImg = t.load(e1);
            }
            setTextureMask(e1) {
                const t = new t_(e1.data, e1.width, e1.height);
                t.needsUpdate = !0, t.type = _a, this.textureMask = t;
            }
        }, r_ = WN((e1)=>{
            let { imgs: n, masks: i, activeIndex: r, visible: a } = e1;
            const s = (0, t.useRef)(null), [o, l] = (0, t.useState)(null);
            (0, t.useEffect)(()=>{
                (async ()=>{
                    const e1 = await Ax.getDepth(i[r]);
                    e1 && (i_.setTextureImg(n[r]), i_.setTextureMask(e1), i_.setRoomMask(e1), o || h());
                })();
            }, [
                r,
                n
            ]);
            const c = (e1, t)=>{
                const n = document.getElementsByClassName("widget-tab__isometry-container")[0].style.transform.match(/\((.*?)\)/)[1].split(",")[0], i = e1.getBoundingClientRect(), r = t.clientX - i.left, a = t.clientY - i.top, s = r / (n * e1.offsetWidth), o = a / (n * e1.offsetHeight);
                return _x(s.toFixed(2), o.toFixed(2), i_.roomMask);
            }, u = (e1, t)=>{
                const n = c(e1, t);
                i_.setCurrentColor(n);
            }, h = ()=>{
                const e1 = s.current, t = (3 === (n = (n = Ci.config.colors.main).slice(1)).length && (n = n.split("").map((e1)=>`${e1}${e1}`).join("")), {
                    r: parseInt(n.slice(0, 2), 16),
                    g: parseInt(n.slice(2, 4), 16),
                    b: parseInt(n.slice(4, 6), 16)
                });
                var n;
                const i = new Eh(-1, 1, 1, -1, 0, 1), r = new Zp, a = new ph(2, 2), o = {
                    texture1: {
                        value: i_.textureImg
                    },
                    texture2: {
                        value: i_.textureMask
                    },
                    color: {
                        type: "vec4",
                        value: new wl
                    },
                    fixedColor: {
                        type: "vec4",
                        value: new wl
                    },
                    shaderEnabled: {
                        value: i_.roomsVisible ?? !1
                    },
                    fillColor: {
                        type: "vec4",
                        value: new wl(t.r, t.g, t.b, 1)
                    }
                }, h = new Ku({
                    uniforms: o,
                    fragmentShader: "\n      varying vec2 vUv;\n\n      uniform vec4 color;\n      uniform vec4 fixedColor;\n      uniform sampler2D texture1; \n      uniform sampler2D texture2; \n      uniform int shaderEnabled;\n      uniform vec4 fillColor;\n\n      void main()\t{\n        vec4 color1 = texture2D(texture1, vUv);\n        vec4 color2 = texture2D(texture2, vUv);\n\n        gl_FragColor = color1;\n        if (color2.r == 0.0 || shaderEnabled == 0) {\n          return;\n        }\n\n        vec4 mixColor = vec4(fillColor.rgb / 255.0, 1.0);\n\n        if (color2.r == fixedColor.r) {\n          gl_FragColor = mix(color1, mixColor, 0.6);\n        } else if (color2.r == color.r) {\n          gl_FragColor = mix(color1, mixColor, 0.4);\n        }\n      }\n\n  ",
                    vertexShader: "\n      varying vec2 vUv;\n\n      void main()\t{\n\n          vUv = uv;\n          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n      }\n  "
                }), d = new Vu(a, h);
                r.add(d);
                const p = new Qp({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                });
                p.toneMapping = Jr, p.toneMappingExposure = 1, p.setPixelRatio(window.devicePixelRatio), p.setSize(3 * e1.offsetWidth, 3 * e1.offsetHeight), p.render(r, i), p.setAnimationLoop(()=>{
                    o.texture1.value = i_.textureImg, o.texture2.value = i_.textureMask, o.color = {
                        type: "vec4",
                        value: i_.getCurrentColorVector()
                    }, o.fixedColor = {
                        type: "vec4",
                        value: i_.getFixedColorVector()
                    }, o.shaderEnabled = {
                        value: i_.roomsVisible ?? !1
                    }, p.render(r, i);
                }), e1.appendChild(p.domElement), l(p), ((e1, t)=>{
                    t.addEventListener("mousemove", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchStart", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchMove", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchEnd", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("click", (e1)=>{
                        ((e1, t)=>{
                            const n = c(e1, t);
                            i_.setFixedColor(n);
                        })(t, e1);
                    }), window.addEventListener("resize", ()=>e1.setSize(3 * t.offsetWidth, 3 * t.offsetHeight));
                })(p, e1);
            };
            return t.createElement("div", {
                ref: s,
                className: "widget-tab__isometry-shader " + (a ? "" : "hidden")
            });
        }), a_ = r_, s_ = (e1)=>{
            let { activeIndex: n, planImage: i, images: r, topView: a, masks: s = [], setActiveIndex: o, currentStep: l, steps: c, setCurrentStep: u } = e1;
            const [h, d] = (0, t.useState)([]), p = (e1)=>{
                e1.preventDefault();
                const t = n + 1;
                o(h[t] ? t : 0);
            }, f = (e1)=>{
                e1.preventDefault();
                const t = n - 1;
                o(h[t] ? t : h.length - 1);
            };
            let g = {
                x: 0,
                y: 0
            };
            const m = (e1)=>{
                if (e1.touches.length > 1) return;
                const t = e1.touches[0];
                g = {
                    x: t.screenX
                };
            }, A = (e1)=>{
                if (e1.touches.length > 1) return;
                e1.stopPropagation();
                const t = e1.touches[0], n = g.x - t.screenX;
                0 !== g.x && (n >= 100 ? (p(), M()) : n <= -100 && (f(), M()));
            }, M = ()=>g = {
                    x: 0,
                    y: 0
                };
            return (0, t.useEffect)(()=>{
                "three" === Ci.config.tabsButtonsDesign ? d([
                    a,
                    ...r
                ]) : d(r);
            }, []), "two" === Ci.config.tabsButtonsDesign ? t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__isometry"
            }, t.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: m,
                onTouchMove: A,
                onTouchEnd: M
            }, t.createElement("img", {
                className: "widget-tab__isometry--plan " + ("plan" === l ? "active" : ""),
                src: i,
                alt: "plan"
            }), t.createElement("img", {
                className: "widget-tab__isometry--top-view " + ("topView" === l ? "active" : ""),
                src: a,
                alt: "top-view"
            }), h.map((e1, i)=>t.createElement("img", {
                    className: "carousel" === l && n === i ? "active" : "",
                    alt: `rotation-view-${i}`,
                    key: i,
                    src: e1
                })))), "carousel" === l && t.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: f
            }, t.createElement("img", {
                src: TD,
                alt: "arrow-left"
            })), t.createElement("span", null, n + 1, "/", h.length), t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: p
            }, t.createElement("img", {
                src: ED,
                alt: "arrow-right"
            }))), t.createElement("div", {
                className: "widget-tab__isometry-buttons"
            }, c.length > 1 && t.createElement("button", {
                className: "widget-tab__isometry-button",
                onClick: ()=>u((()=>{
                        const e1 = c.findIndex((e1)=>e1 === l);
                        return c[e1 + 1] || c[0];
                    })())
            }, t.createElement("img", {
                src: (()=>{
                    switch(l){
                        case "carousel":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjUxNDcgMzlMNy41IDMxLjVMMTYuMjUgMjcuNzVMMjAuNjI1IDI1Ljg3NUwyNSAyNy43NUwyOS4zNzUgMjUuODc1TDMzLjc1IDI3Ljc1TDQyLjUgMzEuNUwyNS41MTQ3IDM5WiIgZmlsbD0iI0M0QzRDNCIvPgo8cGF0aCBkPSJNMzAuMTUwOSAyNS4xMjVMMzQuOTM0IDI3LjI1TDQ0LjUgMzEuNUwyNS4zNjc5IDQwTDUuNSAzMS41TDE1LjQzNCAyNy4yNUwyMC40MDA5IDI1LjEyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS41IDE4LjVMMjUuMzY3OSAxMEw0NC41IDE4LjVMMjUuMzY3OSAyN0w1LjUgMTguNVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+";
                        case "plan":
                        default:
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1MCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk5NzIgMzguODk5NEgxMS4wMDM2QzEwLjc4MjcgMzguODk5NCAxMC42MDM2IDM4LjcyMDMgMTAuNjAzNiAzOC40OTk0TDEwLjYwMzUgMTAuOTk4OUMxMC42MDM1IDEwLjc3OCAxMC43ODI2IDEwLjU5ODkgMTEuMDAzNSAxMC41OTg5SDM4Ljk5NzJDMzkuMjE4MSAxMC41OTg5IDM5LjM5NzIgMTAuNzc4IDM5LjM5NzIgMTAuOTk4OVYzOC40OTk0QzM5LjM5NzIgMzguNzIwMyAzOS4yMTgxIDM4Ljg5OTQgMzguOTk3MiAzOC44OTk0WiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiLz4KPHBhdGggZD0iTTEyLjE2OTkgMTkuMTk0NkgyNC4xMzQxQzI0LjM1NTEgMTkuMTk0NiAyNC41MzQxIDE5LjM3MzcgMjQuNTM0MSAxOS41OTQ2VjM3LjMyMTQiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zNy44MjA2IDIwLjU5NDVIMzAuOTg0QzMwLjc2MzEgMjAuNTk0NSAzMC41ODQgMjAuNDE1NCAzMC41ODQgMjAuMTk0NVYxMi4xNjg3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
                        case "topView":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODU1N0wyNC44MzcgNDMuMTc3TDQxLjg0OTcgMzUuODU1NyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYuMzMwMSA0My4xOTQ2TDguODMwMDggMzUuNjk0NkwyNS44MzAxIDI4LjE5NDZMNDIuODMwMSAzNS42OTQ2TDI2LjMzMDEgNDMuMTk0NloiIGZpbGw9IiNDNEM0QzQiLz4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODE5NlYxMy44NTU3TDI0LjgzNyA2LjUzNDQyTDQxLjg0OTcgMTMuODU1N1YzNS44MTk2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNC44MzU5IDYuNjk0NThWMjguMTU4NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4xNjk5MiAzNi41MTU5TDI0LjgzNyAyOS4xOTQ2TDQxLjg0OTcgMzYuNTE1OUwyNC44MzcgNDMuODM3Mkw3LjE2OTkyIDM2LjUxNTlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==";
                    }
                })(),
                alt: `${l}-icon`
            })))) : t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__isometry"
            }, t.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: m,
                onTouchMove: A,
                onTouchEnd: M
            }, s.length > 0 && t.createElement(a_, {
                imgs: h,
                masks: s,
                activeIndex: n,
                visible: s || 0 === n
            }), 0 === s.length && t.createElement(t.Fragment, null, h?.map((e1, i)=>t.createElement("img", {
                    className: n === i ? "active" : "",
                    alt: `rotation-view-${i}`,
                    key: i,
                    src: e1
                }))))), t.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: (e1)=>f(e1)
            }, t.createElement("img", {
                src: TD,
                alt: "arrow-left"
            })), t.createElement("span", null, n + 1, "/", h.length), t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: (e1)=>p(e1)
            }, t.createElement("img", {
                src: ED,
                alt: "arrow-right"
            }))));
        }, o_ = "data:image/svg+xml;base64,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", l_ = (e1)=>{
            let { images: n, topView: i, planImage: r, masks: a, mode: s, disabled: o = !1 } = e1;
            const l = [
                {
                    icon: o_,
                    text: Pi("rotate-plan")
                }
            ], [c, u] = (0, t.useState)(!1), [h, d] = (0, t.useState)(null), [p, f] = (0, t.useState)(0), [, g] = (0, t.useState)(null), [m] = (0, t.useState)((()=>{
                const e1 = [];
                return n && n.length > 0 && e1.push("carousel"), r && e1.push("plan"), n[0] && e1.push("topView"), e1.filter((e1)=>Ci.config.availableRotationSteps.includes(e1));
            })()), [A, M] = (0, t.useState)(m[0]);
            function v() {
                f(this.index);
            }
            return (0, t.useEffect)(()=>{
                performance.mark("opening rotation mode");
                const e1 = document.querySelector(".widget-tab__threesixty-container"), t = document.querySelector(".widget-tab__isometry-container"), n = s === qi.THREESIXTY ? e1 : t, i = nD()(n, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                d(i);
            }, []), t.createElement("div", {
                className: "widget-tab__rotation",
                onContextMenu: zi
            }, s === qi.THREESIXTY && t.createElement(bD, {
                initialized: c,
                activeIndex: p,
                images: n
            }), s === qi.DEFAULT && t.createElement(s_, {
                setActiveIndex: f,
                activeIndex: p,
                images: n,
                topView: i,
                masks: a,
                steps: m,
                planImage: r,
                currentStep: A,
                setCurrentStep: (e1)=>{
                    const { scale: t } = h.getTransform();
                    h.pause(), h.zoomTo(0, 0, 1 / t), h.moveTo(0, 0), h.resume(), M(e1);
                }
            }), s === qi.THREESIXTY && !c && t.createElement(wD, {
                onClick: ()=>{
                    u(!0);
                    const e1 = document.querySelector(".widget-tab__threesixty-container"), t = document.querySelector(".widget-tab__rotation"), i = new xD(e1, {
                        image: [
                            ...n
                        ],
                        parentElement: t,
                        inverted: !0,
                        speed: 300
                    });
                    i._update = v, h.on("panstart", ()=>{
                        i.stop(), i._update = ()=>{};
                    }), h.on("panend", ()=>{
                        i.goto(i.index), i._update = v;
                    }), g(i);
                },
                steps: l,
                disabled: o
            }));
        }, c_ = (e1)=>{
            let { absolute: n, size: i = "lg" } = e1;
            return t.createElement("div", {
                className: `widget-loader widget-loader--${i} ${n ? "widget-loader--absolute" : ""}`
            }, t.createElement("div", null), t.createElement("div", null), t.createElement("div", null), t.createElement("div", null));
        }, u_ = WN((e1)=>{
            let { disabled: n } = e1;
            const { planImage: i, json: r } = Ci.config, [a, s] = (0, t.useState)({
                width: "200px",
                height: "auto"
            }), [o, l] = (0, t.useState)(!0), [c, u] = (0, t.useState)({
                X: 1,
                Y: 1
            }), [h, d] = (0, t.useState)(!1), p = LN.panoramasGroup, f = ()=>{
                const e1 = document.querySelector(".widget-tab__panorama-map img");
                if (!e1) return;
                const t = e1.naturalWidth / e1.naturalHeight || 1, n = Ci.config.height - 200;
                let i = 200, a = i / t;
                a >= n && (a = n, i = a * t);
                const o = ((e1, t)=>{
                    let { width: n, height: i } = e1;
                    if (!t) return {
                        X: 1,
                        Y: 1
                    };
                    const r = ((e1)=>{
                        const t = e1.Meta;
                        if (!t) return {
                            X: e1.Scale.X,
                            Y: e1.Scale.X
                        };
                        const n = Ci.currentFloorIndex, i = t.BackgroundsTransforms?.[n], r = t.WidgetInfo?.PlanBounds?.[n];
                        if (i?.Modified && r) return {
                            Width: r.Right,
                            Height: r.Bottom
                        };
                        const a = t.FloorsScales?.[n];
                        return {
                            X: a?.X ?? e1.Scale.X,
                            Y: a?.Y ?? e1.Scale.X
                        };
                    })(t);
                    if (r.Width && r.Height) return {
                        X: n / r.Width,
                        Y: i / r.Height
                    };
                    const a = i * (1024 / n);
                    return {
                        X: n / 1024 / r.X,
                        Y: i / a / r.Y
                    };
                })({
                    width: i,
                    height: a
                }, r);
                s({
                    width: `${i}px`,
                    height: `${a}px`
                }), u(o), LN.updateWindowSize(Ci.config.width, Ci.config.height), LN.vrControlPanel.map.updateSize(2 * i, 2 * a), LN.vrControlPanel.map.updateScale(o);
            }, g = ()=>{
                Ci.showControls(), d(!1);
            };
            return (0, t.useEffect)(f, [
                Ci.config.width,
                Ci.config.height,
                Ci.currentFloorIndex
            ]), o || Ci.setPanoramaTourReady(), t.createElement(t.Fragment, null, h && t.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: g
            }, t.createElement("img", {
                src: qN,
                alt: "close-map"
            })), h && t.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: g
            }), t.createElement("div", {
                className: (()=>{
                    let e1 = "widget-tab__panorama-map";
                    return Cy.isCapable("hidden_furniture") && (e1 += " widget-tab__panorama-map--bottom"), o && (e1 += " widget-tab__panorama-map--hidden"), h && (e1 += " widget-tab__panorama-map--scaled"), e1;
                })()
            }, t.createElement("img", {
                src: i,
                style: a,
                alt: "plan",
                onLoad: ()=>{
                    f(), l(!r || n), LN.vrControlPanel.map.setDisabledState(!r || n), LN.vrControlPanel.map.loadImage(i).then(()=>{
                        LN.vrControlPanel.mapButtonAvailable = !0;
                    });
                }
            }), !o && t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama-map__fov",
                style: (()=>{
                    const e1 = LN.getPanoramaById(LN.currentPanoramaId);
                    if (!e1) return {
                        display: "none"
                    };
                    const { left: t, top: n } = e1.userData;
                    return {
                        "--x": t * c.X + "px",
                        "--y": n * c.Y + "px"
                    };
                })()
            }, t.createElement("div", {
                className: "widget-tab__panorama-map__fov-direction"
            }), t.createElement("div", {
                className: "widget-tab__panorama-map__fov-dot"
            })), t.createElement("svg", {
                style: {
                    width: a.width
                },
                key: `X-${c.X}-Y-${c.Y}`,
                onClick: (e1)=>{
                    if (LN.loading) return;
                    if (Ci.config.width <= ZN.tablet && !h) return Ci.hideControls(), void d(!0);
                    const t = document.querySelector(".widget-tab__panorama-map");
                    if (!t) return;
                    const n = t.getBoundingClientRect().width / t.offsetWidth, i = document.querySelector(".widget-tab__panorama-map img");
                    if (!i) return;
                    const r = i.getBoundingClientRect(), { clientX: a, clientY: s } = e1, o = (a - r.left) / n / c.X, l = (s - r.top) / n / c.Y, u = p.children.filter((e1)=>{
                        let { userData: t } = e1;
                        return rN([
                            o,
                            l
                        ], t.points);
                    }), { panorama: f } = wx([
                        o,
                        l
                    ], u);
                    g(), f && LN.setCurrentPanoramaById(f.panoramaId);
                }
            }, LN.panoramasGroup.children.map((e1, n)=>{
                let { userData: i } = e1;
                const r = i.svgPathActions.reduce((e1, t)=>{
                    const n = t.x * c.X, i = t.y * c.Y;
                    let r = `${t.type} ${n} ${i}`;
                    return "Q" === t.type && (r += ` ${t.dx * c.X} ${t.dy * c.Y}`), `${e1} ${r}`;
                }, "");
                return t.createElement("path", {
                    key: n,
                    d: r
                });
            })))));
        }), h_ = (e1, t, n, i)=>{
            const r = 1 - e1;
            return {
                x: r * r * t.Location.X + 2 * r * e1 * n.Location.X + e1 * e1 * i.Location.X,
                y: r * r * t.Location.Y + 2 * r * e1 * n.Location.Y + e1 * e1 * i.Location.Y
            };
        }, d_ = (e1, t)=>{
            const n = e1.length;
            for(let i = 0; i < n; i++){
                const n = e1[i];
                if (n.ID === t) return n;
            }
            return null;
        }, p_ = (e1, t, n, i, r)=>{
            const a = [
                {
                    x: -n,
                    y: -i
                },
                {
                    x: n,
                    y: -i
                },
                {
                    x: n,
                    y: i
                },
                {
                    x: -n,
                    y: i
                }
            ], s = Math.cos(r), o = Math.sin(r);
            for(let n = 0; n < 4; n++){
                const i = a[n], r = e1 + i.x * s - i.y * o;
                i.y = t + i.y * s + i.x * o, i.x = r;
            }
            return a;
        };
        class f_ {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                this.isQuaternion = !0, this._x = e1, this._y = t, this._z = n, this._w = i;
            }
            static slerpFlat(e1, t, n, i, r, a, s) {
                let o = n[i + 0], l = n[i + 1], c = n[i + 2], u = n[i + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return e1[t + 0] = o, e1[t + 1] = l, e1[t + 2] = c, void (e1[t + 3] = u);
                if (1 === s) return e1[t + 0] = h, e1[t + 1] = d, e1[t + 2] = p, void (e1[t + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let e1 = 1 - s;
                    const t = o * h + l * d + c * p + u * f, n = t >= 0 ? 1 : -1, i = 1 - t * t;
                    if (i > Number.EPSILON) {
                        const r = Math.sqrt(i), a = Math.atan2(r, t * n);
                        e1 = Math.sin(e1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * n;
                    if (o = o * e1 + h * r, l = l * e1 + d * r, c = c * e1 + p * r, u = u * e1 + f * r, e1 === 1 - s) {
                        const e1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= e1, l *= e1, c *= e1, u *= e1;
                    }
                }
                e1[t] = o, e1[t + 1] = l, e1[t + 2] = c, e1[t + 3] = u;
            }
            static multiplyQuaternionsFlat(e1, t, n, i, r, a) {
                const s = n[i], o = n[i + 1], l = n[i + 2], c = n[i + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return e1[t] = s * p + c * u + o * d - l * h, e1[t + 1] = o * p + c * h + l * u - s * d, e1[t + 2] = l * p + c * d + s * h - o * u, e1[t + 3] = c * p - s * u - o * h - l * d, e1;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(e1) {
                this._w = e1, this._onChangeCallback();
            }
            set(e1, t, n, i) {
                return this._x = e1, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(e1) {
                return this._x = e1.x, this._y = e1.y, this._z = e1.z, this._w = e1.w, this._onChangeCallback(), this;
            }
            setFromEuler(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._order, s = Math.cos, o = Math.sin, l = s(n / 2), c = s(i / 2), u = s(r / 2), h = o(n / 2), d = o(i / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== t && this._onChangeCallback(), this;
            }
            setFromAxisAngle(e1, t) {
                const n = t / 2, i = Math.sin(n);
                return this._x = e1.x * i, this._y = e1.y * i, this._z = e1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                const t = e1.elements, n = t[0], i = t[4], r = t[8], a = t[1], s = t[5], o = t[9], l = t[2], c = t[6], u = t[10], h = n + s + u;
                if (h > 0) {
                    const e1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / e1, this._x = (c - o) * e1, this._y = (r - l) * e1, this._z = (a - i) * e1;
                } else if (n > s && n > u) {
                    const e1 = 2 * Math.sqrt(1 + n - s - u);
                    this._w = (c - o) / e1, this._x = .25 * e1, this._y = (i + a) / e1, this._z = (r + l) / e1;
                } else if (s > u) {
                    const e1 = 2 * Math.sqrt(1 + s - n - u);
                    this._w = (r - l) / e1, this._x = (i + a) / e1, this._y = .25 * e1, this._z = (o + c) / e1;
                } else {
                    const e1 = 2 * Math.sqrt(1 + u - n - s);
                    this._w = (a - i) / e1, this._x = (r + l) / e1, this._y = (o + c) / e1, this._z = .25 * e1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(e1, t) {
                let n = e1.dot(t) + 1;
                return n < Number.EPSILON ? (n = 0, Math.abs(e1.x) > Math.abs(e1.z) ? (this._x = -e1.y, this._y = e1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e1.z, this._z = e1.y, this._w = n)) : (this._x = e1.y * t.z - e1.z * t.y, this._y = e1.z * t.x - e1.x * t.z, this._z = e1.x * t.y - e1.y * t.x, this._w = n), this.normalize();
            }
            angleTo(e1) {
                return 2 * Math.acos(Math.abs(HD(this.dot(e1), -1, 1)));
            }
            rotateTowards(e1, t) {
                const n = this.angleTo(e1);
                if (0 === n) return this;
                const i = Math.min(1, t / n);
                return this.slerp(e1, i), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(e1) {
                return this._x * e1._x + this._y * e1._y + this._z * e1._z + this._w * e1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let e1 = this.length();
                return 0 === e1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e1 = 1 / e1, this._x = this._x * e1, this._y = this._y * e1, this._z = this._z * e1, this._w = this._w * e1), this._onChangeCallback(), this;
            }
            multiply(e1) {
                return this.multiplyQuaternions(this, e1);
            }
            premultiply(e1) {
                return this.multiplyQuaternions(e1, this);
            }
            multiplyQuaternions(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._w, s = t._x, o = t._y, l = t._z, c = t._w;
                return this._x = n * c + a * s + i * l - r * o, this._y = i * c + a * o + r * s - n * l, this._z = r * c + a * l + n * o - i * s, this._w = a * c - n * s - i * o - r * l, this._onChangeCallback(), this;
            }
            slerp(e1, t) {
                if (0 === t) return this;
                if (1 === t) return this.copy(e1);
                const n = this._x, i = this._y, r = this._z, a = this._w;
                let s = a * e1._w + n * e1._x + i * e1._y + r * e1._z;
                if (s < 0 ? (this._w = -e1._w, this._x = -e1._x, this._y = -e1._y, this._z = -e1._z, s = -s) : this.copy(e1), s >= 1) return this._w = a, this._x = n, this._y = i, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const e1 = 1 - t;
                    return this._w = e1 * a + t * this._w, this._x = e1 * n + t * this._x, this._y = e1 * i + t * this._y, this._z = e1 * r + t * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - t) * c) / l, h = Math.sin(t * c) / l;
                return this._w = a * u + this._w * h, this._x = n * u + this._x * h, this._y = i * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(e1, t, n) {
                return this.copy(e1).slerp(t, n);
            }
            random() {
                const e1 = Math.random(), t = Math.sqrt(1 - e1), n = Math.sqrt(e1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(t * Math.cos(i), n * Math.sin(r), n * Math.cos(r), t * Math.sin(i));
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._w === this._w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this._x = e1[t], this._y = e1[t + 1], this._z = e1[t + 2], this._w = e1[t + 3], this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this._x = e1.getX(t), this._y = e1.getY(t), this._z = e1.getZ(t), this._w = e1.getW(t), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class g_ {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                g_.prototype.isVector3 = !0, this.x = e1, this.y = t, this.z = n;
            }
            set(e1, t, n) {
                return void 0 === n && (n = this.z), this.x = e1, this.y = t, this.z = n, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this;
            }
            multiplyVectors(e1, t) {
                return this.x = e1.x * t.x, this.y = e1.y * t.y, this.z = e1.z * t.z, this;
            }
            applyEuler(e1) {
                return this.applyQuaternion(A_.setFromEuler(e1));
            }
            applyAxisAngle(e1, t) {
                return this.applyQuaternion(A_.setFromAxisAngle(e1, t));
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
            }
            applyNormalMatrix(e1) {
                return this.applyMatrix3(e1).normalize();
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements, a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
                return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a, this;
            }
            applyQuaternion(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.x, a = e1.y, s = e1.z, o = e1.w, l = 2 * (a * i - s * n), c = 2 * (s * t - r * i), u = 2 * (r * n - a * t);
                return this.x = t + o * l + a * u - s * c, this.y = n + o * c + s * l - r * u, this.z = i + o * u + r * c - a * l, this;
            }
            project(e1) {
                return this.applyMatrix4(e1.matrixWorldInverse).applyMatrix4(e1.projectionMatrix);
            }
            unproject(e1) {
                return this.applyMatrix4(e1.projectionMatrixInverse).applyMatrix4(e1.matrixWorld);
            }
            transformDirection(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this;
            }
            cross(e1) {
                return this.crossVectors(this, e1);
            }
            crossVectors(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = t.x, s = t.y, o = t.z;
                return this.x = i * o - r * s, this.y = r * a - n * o, this.z = n * s - i * a, this;
            }
            projectOnVector(e1) {
                const t = e1.lengthSq();
                if (0 === t) return this.set(0, 0, 0);
                const n = e1.dot(this) / t;
                return this.copy(e1).multiplyScalar(n);
            }
            projectOnPlane(e1) {
                return m_.copy(this).projectOnVector(e1), this.sub(m_);
            }
            reflect(e1) {
                return this.sub(m_.copy(e1).multiplyScalar(2 * this.dot(e1)));
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(HD(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y, i = this.z - e1.z;
                return t * t + n * n + i * i;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y) + Math.abs(this.z - e1.z);
            }
            setFromSpherical(e1) {
                return this.setFromSphericalCoords(e1.radius, e1.phi, e1.theta);
            }
            setFromSphericalCoords(e1, t, n) {
                const i = Math.sin(t) * e1;
                return this.x = i * Math.sin(n), this.y = Math.cos(t) * e1, this.z = i * Math.cos(n), this;
            }
            setFromCylindrical(e1) {
                return this.setFromCylindricalCoords(e1.radius, e1.theta, e1.y);
            }
            setFromCylindricalCoords(e1, t, n) {
                return this.x = e1 * Math.sin(t), this.y = n, this.z = e1 * Math.cos(t), this;
            }
            setFromMatrixPosition(e1) {
                const t = e1.elements;
                return this.x = t[12], this.y = t[13], this.z = t[14], this;
            }
            setFromMatrixScale(e1) {
                const t = this.setFromMatrixColumn(e1, 0).length(), n = this.setFromMatrixColumn(e1, 1).length(), i = this.setFromMatrixColumn(e1, 2).length();
                return this.x = t, this.y = n, this.z = i, this;
            }
            setFromMatrixColumn(e1, t) {
                return this.fromArray(e1.elements, 4 * t);
            }
            setFromMatrix3Column(e1, t) {
                return this.fromArray(e1.elements, 3 * t);
            }
            setFromEuler(e1) {
                return this.x = e1._x, this.y = e1._y, this.z = e1._z, this;
            }
            setFromColor(e1) {
                return this.x = e1.r, this.y = e1.g, this.z = e1.b, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const e1 = 2 * (Math.random() - .5), t = Math.random() * Math.PI * 2, n = Math.sqrt(1 - e1 ** 2);
                return this.x = n * Math.cos(t), this.y = n * Math.sin(t), this.z = e1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const m_ = new g_, A_ = new f_;
        class M_ {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g){
                M_.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g);
            }
            set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, g) {
                const m = this.elements;
                return m[0] = e1, m[4] = t, m[8] = n, m[12] = i, m[1] = r, m[5] = a, m[9] = s, m[13] = o, m[2] = l, m[6] = c, m[10] = u, m[14] = h, m[3] = d, m[7] = p, m[11] = f, m[15] = g, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new M_).fromArray(this.elements);
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
            }
            copyPosition(e1) {
                const t = this.elements, n = e1.elements;
                return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
            }
            setFromMatrix3(e1) {
                const t = e1.elements;
                return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(e1, t, n) {
                return this.set(e1.x, t.x, n.x, 0, e1.y, t.y, n.y, 0, e1.z, t.z, n.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(e1) {
                const t = this.elements, n = e1.elements, i = 1 / v_.setFromMatrixColumn(e1, 0).length(), r = 1 / v_.setFromMatrixColumn(e1, 1).length(), a = 1 / v_.setFromMatrixColumn(e1, 2).length();
                return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromEuler(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z, a = Math.cos(n), s = Math.sin(n), o = Math.cos(i), l = Math.sin(i), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = -o * u, t[8] = l, t[1] = n + i * l, t[5] = e1 - r * l, t[9] = -s * o, t[2] = r - e1 * l, t[6] = i + n * l, t[10] = a * o;
                } else if ("YXZ" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 + r * s, t[4] = i * s - n, t[8] = a * l, t[1] = a * u, t[5] = a * c, t[9] = -s, t[2] = n * s - i, t[6] = r + e1 * s, t[10] = a * o;
                } else if ("ZXY" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 - r * s, t[4] = -a * u, t[8] = i + n * s, t[1] = n + i * s, t[5] = a * c, t[9] = r - e1 * s, t[2] = -a * l, t[6] = s, t[10] = a * o;
                } else if ("ZYX" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = i * l - n, t[8] = e1 * l + r, t[1] = o * u, t[5] = r * l + e1, t[9] = n * l - i, t[2] = -l, t[6] = s * o, t[10] = a * o;
                } else if ("YZX" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = r - e1 * u, t[8] = i * u + n, t[1] = u, t[5] = a * c, t[9] = -s * c, t[2] = -l * c, t[6] = n * u + i, t[10] = e1 - r * u;
                } else if ("XZY" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = -u, t[8] = l * c, t[1] = e1 * u + r, t[5] = a * c, t[9] = n * u - i, t[2] = i * u - n, t[6] = s * c, t[10] = r * u + e1;
                }
                return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromQuaternion(e1) {
                return this.compose(x_, e1, b_);
            }
            lookAt(e1, t, n) {
                const i = this.elements;
                return T_.subVectors(e1, t), 0 === T_.lengthSq() && (T_.z = 1), T_.normalize(), w_.crossVectors(n, T_), 0 === w_.lengthSq() && (1 === Math.abs(n.z) ? T_.x += 1e-4 : T_.z += 1e-4, T_.normalize(), w_.crossVectors(n, T_)), w_.normalize(), E_.crossVectors(T_, w_), i[0] = w_.x, i[4] = E_.x, i[8] = T_.x, i[1] = w_.y, i[5] = E_.y, i[9] = T_.y, i[2] = w_.z, i[6] = E_.z, i[10] = T_.z, this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[4], o = n[8], l = n[12], c = n[1], u = n[5], h = n[9], d = n[13], p = n[2], f = n[6], g = n[10], m = n[14], A = n[3], M = n[7], v = n[11], y = n[15], x = i[0], b = i[4], w = i[8], E = i[12], T = i[1], S = i[5], I = i[9], N = i[13], D = i[2], _ = i[6], C = i[10], L = i[14], z = i[3], O = i[7], R = i[11], P = i[15];
                return r[0] = a * x + s * T + o * D + l * z, r[4] = a * b + s * S + o * _ + l * O, r[8] = a * w + s * I + o * C + l * R, r[12] = a * E + s * N + o * L + l * P, r[1] = c * x + u * T + h * D + d * z, r[5] = c * b + u * S + h * _ + d * O, r[9] = c * w + u * I + h * C + d * R, r[13] = c * E + u * N + h * L + d * P, r[2] = p * x + f * T + g * D + m * z, r[6] = p * b + f * S + g * _ + m * O, r[10] = p * w + f * I + g * C + m * R, r[14] = p * E + f * N + g * L + m * P, r[3] = A * x + M * T + v * D + y * z, r[7] = A * b + M * S + v * _ + y * O, r[11] = A * w + M * I + v * C + y * R, r[15] = A * E + M * N + v * L + y * P, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[4] *= e1, t[8] *= e1, t[12] *= e1, t[1] *= e1, t[5] *= e1, t[9] *= e1, t[13] *= e1, t[2] *= e1, t[6] *= e1, t[10] *= e1, t[14] *= e1, t[3] *= e1, t[7] *= e1, t[11] *= e1, t[15] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[4], i = e1[8], r = e1[12], a = e1[1], s = e1[5], o = e1[9], l = e1[13], c = e1[2], u = e1[6], h = e1[10], d = e1[14];
                return e1[3] * (+r * o * u - i * l * u - r * s * h + n * l * h + i * s * d - n * o * d) + e1[7] * (+t * o * d - t * l * h + r * a * h - i * a * d + i * l * c - r * o * c) + e1[11] * (+t * l * u - t * s * d - r * a * u + n * a * d + r * s * c - n * l * c) + e1[15] * (-i * s * c - t * o * u + t * s * h + i * a * u - n * a * h + n * o * c);
            }
            transpose() {
                const e1 = this.elements;
                let t;
                return t = e1[1], e1[1] = e1[4], e1[4] = t, t = e1[2], e1[2] = e1[8], e1[8] = t, t = e1[6], e1[6] = e1[9], e1[9] = t, t = e1[3], e1[3] = e1[12], e1[12] = t, t = e1[7], e1[7] = e1[13], e1[13] = t, t = e1[11], e1[11] = e1[14], e1[14] = t, this;
            }
            setPosition(e1, t, n) {
                const i = this.elements;
                return e1.isVector3 ? (i[12] = e1.x, i[13] = e1.y, i[14] = e1.z) : (i[12] = e1, i[13] = t, i[14] = n), this;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], d = e1[11], p = e1[12], f = e1[13], g = e1[14], m = e1[15], A = u * g * l - f * h * l + f * o * d - s * g * d - u * o * m + s * h * m, M = p * h * l - c * g * l - p * o * d + a * g * d + c * o * m - a * h * m, v = c * f * l - p * u * l + p * s * d - a * f * d - c * s * m + a * u * m, y = p * u * o - c * f * o - p * s * h + a * f * h + c * s * g - a * u * g, x = t * A + n * M + i * v + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const b = 1 / x;
                return e1[0] = A * b, e1[1] = (f * h * r - u * g * r - f * i * d + n * g * d + u * i * m - n * h * m) * b, e1[2] = (s * g * r - f * o * r + f * i * l - n * g * l - s * i * m + n * o * m) * b, e1[3] = (u * o * r - s * h * r - u * i * l + n * h * l + s * i * d - n * o * d) * b, e1[4] = M * b, e1[5] = (c * g * r - p * h * r + p * i * d - t * g * d - c * i * m + t * h * m) * b, e1[6] = (p * o * r - a * g * r - p * i * l + t * g * l + a * i * m - t * o * m) * b, e1[7] = (a * h * r - c * o * r + c * i * l - t * h * l - a * i * d + t * o * d) * b, e1[8] = v * b, e1[9] = (p * u * r - c * f * r - p * n * d + t * f * d + c * n * m - t * u * m) * b, e1[10] = (a * f * r - p * s * r + p * n * l - t * f * l - a * n * m + t * s * m) * b, e1[11] = (c * s * r - a * u * r - c * n * l + t * u * l + a * n * d - t * s * d) * b, e1[12] = y * b, e1[13] = (c * f * i - p * u * i + p * n * h - t * f * h - c * n * g + t * u * g) * b, e1[14] = (p * s * i - a * f * i - p * n * o + t * f * o + a * n * g - t * s * g) * b, e1[15] = (a * u * i - c * s * i + c * n * o - t * u * o - a * n * h + t * s * h) * b, this;
            }
            scale(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z;
                return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const e1 = this.elements, t = e1[0] * e1[0] + e1[1] * e1[1] + e1[2] * e1[2], n = e1[4] * e1[4] + e1[5] * e1[5] + e1[6] * e1[6], i = e1[8] * e1[8] + e1[9] * e1[9] + e1[10] * e1[10];
                return Math.sqrt(Math.max(t, n, i));
            }
            makeTranslation(e1, t, n) {
                return e1.isVector3 ? this.set(1, 0, 0, e1.x, 0, 1, 0, e1.y, 0, 0, 1, e1.z, 0, 0, 0, 1) : this.set(1, 0, 0, e1, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
            }
            makeRotationX(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = 1 - n, a = e1.x, s = e1.y, o = e1.z, l = r * a, c = r * s;
                return this.set(l * a + n, l * s - i * o, l * o + i * s, 0, l * s + i * o, c * s + n, c * o - i * a, 0, l * o - i * s, c * o + i * a, r * o * o + n, 0, 0, 0, 0, 1), this;
            }
            makeScale(e1, t, n) {
                return this.set(e1, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            }
            makeShear(e1, t, n, i, r, a) {
                return this.set(1, n, r, 0, e1, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this;
            }
            compose(e1, t, n) {
                const i = this.elements, r = t._x, a = t._y, s = t._z, o = t._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, g = a * u, m = s * u, A = o * l, M = o * c, v = o * u, y = n.x, x = n.y, b = n.z;
                return i[0] = (1 - (f + m)) * y, i[1] = (d + v) * y, i[2] = (p - M) * y, i[3] = 0, i[4] = (d - v) * x, i[5] = (1 - (h + m)) * x, i[6] = (g + A) * x, i[7] = 0, i[8] = (p + M) * b, i[9] = (g - A) * b, i[10] = (1 - (h + f)) * b, i[11] = 0, i[12] = e1.x, i[13] = e1.y, i[14] = e1.z, i[15] = 1, this;
            }
            decompose(e1, t, n) {
                const i = this.elements;
                let r = v_.set(i[0], i[1], i[2]).length();
                const a = v_.set(i[4], i[5], i[6]).length(), s = v_.set(i[8], i[9], i[10]).length();
                this.determinant() < 0 && (r = -r), e1.x = i[12], e1.y = i[13], e1.z = i[14], y_.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return y_.elements[0] *= o, y_.elements[1] *= o, y_.elements[2] *= o, y_.elements[4] *= l, y_.elements[5] *= l, y_.elements[6] *= l, y_.elements[8] *= c, y_.elements[9] *= c, y_.elements[10] *= c, t.setFromRotationMatrix(y_), n.x = r, n.y = a, n.z = s, this;
            }
            makePerspective(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : kD;
                const o = this.elements, l = 2 * r / (t - e1), c = 2 * r / (n - i), u = (t + e1) / (t - e1), h = (n + i) / (n - i);
                let d, p;
                if (s === kD) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : kD;
                const o = this.elements, l = 1 / (t - e1), c = 1 / (n - i), u = 1 / (a - r), h = (t + e1) * l, d = (n + i) * c;
                let p, f;
                if (s === kD) p = (a + r) * u, f = -2 * u;
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 16; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 16; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1[t + 9] = n[9], e1[t + 10] = n[10], e1[t + 11] = n[11], e1[t + 12] = n[12], e1[t + 13] = n[13], e1[t + 14] = n[14], e1[t + 15] = n[15], e1;
            }
        }
        const v_ = new g_, y_ = new M_, x_ = new g_(0, 0, 0), b_ = new g_(1, 1, 1), w_ = new g_, E_ = new g_, T_ = new g_, S_ = (e1)=>Math.cos(e1 * Math.PI / 180), I_ = (e1)=>Math.sin(e1 * Math.PI / 180), N_ = (e1)=>Math.tan(e1 * Math.PI / 180), D_ = function(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21;
            const i = new M_(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -t.X, -t.Y, -t.Z, 1), r = -90, a = -90, s = new M_(S_(a), -I_(a), 0, 0, I_(a), S_(a), 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), o = new M_(S_(r), 0, -I_(r), 0, 0, 1, 0, 0, I_(r), 0, S_(r), 0, 0, 0, 0, 1), l = new M_(1, 0, 0, 0, 0, S_(0), I_(0), 0, 0, -I_(0), S_(0), 0, 0, 0, 0, 1), c = s.multiply(o).multiply(l).multiply(new M_(0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1)), u = n / 2, h = new M_(1 / N_(u), 0, 0, 0, 0, 1 / N_(u), 0, 0, 0, 0, 0, 1, 0, 0, 1, 0), d = i.multiply(c).multiply(h), { X: p, Y: f, Z: g } = e1, m = ((e1, t)=>{
                const n = t.elements;
                return new SD(e1.x * n[0] + e1.y * n[1] + e1.z * n[2] + e1.w * n[3], e1.x * n[4] + e1.y * n[5] + e1.z * n[6] + e1.w * n[7], e1.x * n[8] + e1.y * n[9] + e1.z * n[10] + e1.w * n[11], e1.x * n[12] + e1.y * n[13] + e1.z * n[14] + e1.w * n[15]);
            })(new SD(p, f, g, 1), d);
            if (m.w > 0) {
                const e1 = 1 / m.w;
                return {
                    x: m.x * e1 / 2 + .5,
                    y: 1 - m.y * e1 / 2 - .5
                };
            }
            return null;
        }, __ = "#version 300 es", C_ = `${__}\n  precision lowp float;\n\n  layout(location = 0) in vec2 iPos;\n  layout(location = 1) in vec2 iTexCoord;\n\n  out vec2 vTexCoord;\n  out vec2 vAltTexCoord;\n\n  void main()\t{\n    vTexCoord = iTexCoord;\n    vAltTexCoord = vec2(iTexCoord.x, 1.0 - iTexCoord.y);\n    gl_Position = vec4(iPos, 0, 1);\n  }\n`, L_ = `${__}\n  precision lowp float;\n  precision lowp int;\n\n  in vec2 vTexCoord;\n  in vec2 vAltTexCoord;\n\n  out vec4 oColor;\n\n  uniform vec4 uColor;\n  uniform sampler2D uTexture0;\n  uniform sampler2D uTexture1;\n\n  void main()\t{\n    vec4 color1 = texture(uTexture0, vTexCoord);\n    vec4 color2 = texture(uTexture1, vAltTexCoord);\n\n    int r = int(uColor.r);\n    int rColor = int(color2.r);\n\n    if (r != 0 && r == rColor) {\n      vec4 uSelectColor = vec4(1.0, 0.65, 0.0, 1.0);\n\n      float t = 0.7;\n      oColor = color1 * t + uSelectColor * (1.0 - t);\n    } else {\n      oColor = color1;\n    }\n  }\n`;
        function z_(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const O_ = new class {
            constructor(){
                z_(this, "_textures", []), z_(this, "_canvas", void 0), z_(this, "_gl", void 0), z_(this, "_program", null), z_(this, "_vao", void 0), z_(this, "_ebo", void 0), z_(this, "_posBuf", void 0), z_(this, "_texCoordBuf", void 0), z_(this, "_uColorLocation", void 0), z_(this, "createShader", (e1, t, n)=>{
                    const i = e1.createShader(t);
                    return e1.shaderSource(i, n), e1.compileShader(i), e1.getShaderParameter(i, e1.COMPILE_STATUS) ? i : (console.error("Failed to load shader:", e1.getShaderInfoLog(i)), e1.deleteShader(i), null);
                }), z_(this, "isPowerOf2", (e1)=>!(e1 & e1 - 1));
            }
            async init(e1) {
                this._canvas = e1, this._gl = e1.getContext("webgl2"), this._program && this._gl.deleteProgram(this._program), this._program = this.createProgram(C_, L_), this.initBuffersAndLocations(), this.prepareUniforms();
            }
            async setTextures(e1, t) {
                const n = this._gl;
                this._textures.forEach((e1)=>{
                    e1 && n.deleteTexture(e1);
                }), this._textures = [
                    null,
                    null
                ], e1 && (this._textures[0] = await this.loadTextureFromUrl(e1)), t && (this._textures[1] = await this.loadTextureFromExr(t));
            }
            draw(e1) {
                const t = this._gl;
                t.clearColor(1, 1, 1, 1), t.clear(t.COLOR_BUFFER_BIT), this._textures.forEach((e1, n)=>{
                    t.activeTexture(t.TEXTURE0 + n), t.bindTexture(t.TEXTURE_2D, e1 ?? null);
                }), e1 ? t.uniform4f(this._uColorLocation, e1.R, e1.G, e1.B, e1.A) : t.uniform4f(this._uColorLocation, 0, 0, 0, 0), t.drawElements(t.TRIANGLES, 6, t.UNSIGNED_SHORT, 0);
            }
            initBuffersAndLocations() {
                const e1 = this._gl, t = e1.createVertexArray();
                e1.bindVertexArray(t);
                const n = e1.createBuffer();
                e1.bindBuffer(e1.ARRAY_BUFFER, n), e1.bufferData(e1.ARRAY_BUFFER, new Float32Array([
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ]), e1.STATIC_DRAW), e1.vertexAttribPointer(0, 2, e1.FLOAT, !1, 0, 0), e1.enableVertexAttribArray(0);
                const i = e1.createBuffer();
                e1.bindBuffer(e1.ARRAY_BUFFER, i), e1.bufferData(e1.ARRAY_BUFFER, new Float32Array([
                    0,
                    0,
                    1,
                    0,
                    1,
                    1,
                    0,
                    1
                ]), e1.STATIC_DRAW), e1.vertexAttribPointer(1, 2, e1.FLOAT, !1, 0, 0), e1.enableVertexAttribArray(1);
                const r = e1.createBuffer();
                e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, r), e1.bufferData(e1.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                    0,
                    1,
                    2,
                    0,
                    2,
                    3
                ]), e1.STATIC_DRAW), this._vao && e1.deleteVertexArray(this._vao), this._posBuf && e1.deleteBuffer(this._posBuf), this._texCoordBuf && e1.deleteBuffer(this._texCoordBuf), this._ebo && e1.deleteBuffer(this._ebo), this._vao = t, this._posBuf = n, this._texCoordBuf = i, this._ebo = r;
            }
            prepareUniforms() {
                const e1 = this._gl, t = this._program;
                this._uColorLocation = e1.getUniformLocation(t, "uColor"), e1.uniform1i(e1.getUniformLocation(t, "uTexture0"), 0), e1.uniform1i(e1.getUniformLocation(t, "uTexture1"), 1);
            }
            async loadTextureFromUrl(e1) {
                const t = this._gl, n = this.isPowerOf2;
                return new Promise((i)=>{
                    const r = new Image;
                    r.crossOrigin = "anonymous", r.onload = ()=>{
                        const e1 = t.createTexture();
                        t.bindTexture(t.TEXTURE_2D, e1), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, r), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), n(r.width) && n(r.height) ? (t.generateMipmap(t.TEXTURE_2D), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR_MIPMAP_LINEAR)) : t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), i(e1);
                    }, r.onerror = (e1)=>{
                        console.error(e1), i(null);
                    }, r.src = e1;
                });
            }
            async loadTextureFromExr(e1) {
                const t = this._gl, n = t.createTexture();
                return t.bindTexture(t.TEXTURE_2D, n), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA32F, e1.width, e1.height, 0, t.RGBA, t.FLOAT, e1.data.slice()), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST), n;
            }
            createProgram(e1, t) {
                const n = this._gl, i = this.createShader, r = i(n, n.VERTEX_SHADER, e1), a = i(n, n.FRAGMENT_SHADER, t);
                if (!r || !a) return r && n.deleteShader(r), a && n.deleteShader(a), null;
                const s = n.createProgram();
                return n.attachShader(s, r), n.attachShader(s, a), n.linkProgram(s), n.deleteShader(r), n.deleteShader(a), n.getProgramParameter(s, n.LINK_STATUS) ? (n.useProgram(s), s) : (console.error("Failed to link program:", n.getProgramInfoLog(s)), n.deleteProgram(s), null);
            }
        }, R_ = "top-view-mask", P_ = WN((e1)=>{
            let { disabled: n } = e1;
            const { currentFloorIndex: i } = Ci, { topViewImage: r, bareshell: a, topViewResolutionUpscale: s } = Ci.config, o = Ci.config.json, l = LN.currentPanoramaId, c = 200, u = 200, [h, d] = (0, t.useState)(!0), [p, f] = (0, t.useState)(!1), [g, m] = (0, t.useState)(null), A = (0, t.useMemo)(()=>(function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50;
                    const n = N_((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21) / 2), i = Math.max(e1.Extent.X, e1.Extent.Y) + t, r = e1.Extent.Z + i / n;
                    return {
                        X: e1.Origin.X,
                        Y: e1.Origin.Y,
                        Z: e1.Origin.Z + r
                    };
                })(((e1, t)=>{
                    const n = e1.Floors[t];
                    if (!n) return null;
                    let i = 1 / 0, r = 1 / 0, a = n.Location.Z, s = -1 / 0, o = -1 / 0, l = n.Location.Z + n.Height;
                    const c = ((e1, t)=>{
                        const n = [];
                        return ((e1, t)=>{
                            const n = t.length;
                            for(let i = 0; i < n; i++){
                                const n = t[i], r = p_(n.Location.X, n.Location.Y, n.Extent.X, n.Extent.Y, n.Rotation.Yaw * Math.PI / 180);
                                for(let t = 0; t < 4; t++)e1.push(r[t]);
                            }
                        })(n, e1.Decors), ((e1, t, n)=>{
                            const i = t.length, r = new Set;
                            for(let a = 0; a < i; a++){
                                const i = t[a];
                                if (!i.IsExterior) continue;
                                const s = d_(n, i.Vertices[0]), o = i.ControlPoint, l = d_(n, i.Vertices[1]);
                                if (s && (r.has(s) || (e1.push({
                                    x: s.Location.X,
                                    y: s.Location.Y
                                }), r.add(s.ID)), l)) {
                                    if (o) {
                                        const t = 1 / 21, n = 1 - t;
                                        for(let i = t; i <= n; i += t)e1.push(h_(i, s, o, l));
                                    }
                                    r.has(l) || (e1.push({
                                        x: l.Location.X,
                                        y: l.Location.Y
                                    }), r.add(l.ID));
                                }
                            }
                        })(n, e1.Walls, t), n;
                    })(n, e1.Vertices), u = c.length;
                    for(let e1 = 0; e1 < u; e1++){
                        const { x: t, y: n } = c[e1];
                        t < i && (i = t), t > s && (s = t), n < r && (r = n), n > o && (o = n);
                    }
                    return {
                        Origin: {
                            X: (i + s) / 2,
                            Y: (r + o) / 2,
                            Z: (a + l) / 2
                        },
                        Extent: {
                            X: (s - i) / 2,
                            Y: (o - r) / 2,
                            Z: (l - a) / 2
                        }
                    };
                })(o, i)), [
                i
            ]), M = (0, t.useMemo)(()=>{
                if (!A) return [];
                const e1 = o.Floors[i];
                return e1.CameraPoints.map((t)=>{
                    const { X: n, Y: i } = t.Location, r = e1.Location.Z + t.Location.Z;
                    return {
                        id: t.ID,
                        roomId: t.RoomID,
                        position: D_({
                            X: n,
                            Y: i,
                            Z: r
                        }, A)
                    };
                });
            }, [
                i,
                A,
                c
            ]);
            (0, t.useEffect)(()=>{
                d(!0), o && !n && v().then(()=>{
                    d(!1);
                });
            }, [
                r
            ]);
            const v = async ()=>{
                const e1 = await Ax.getDepth(b);
                m(e1), e1 || console.warn(`Failed to load top view color mask: ${b}`);
                const t = document.getElementById(R_);
                t && (await O_.init(t), await O_.setTextures(r, e1), O_.draw());
            }, y = ()=>{
                i_.setCurrentColor({
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                }), O_.draw();
            }, x = ()=>{
                Ci.showControls(), f(!1);
            }, b = r.replace(/\.(jpe?g|webp|png|svg)/, "_RoomIDs.exr"), w = {
                width: c,
                height: u
            }, E = {
                width: c * s,
                height: u * s
            };
            return h || Ci.setPanoramaTourReady(), t.createElement(t.Fragment, null, p && t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: x
            }, t.createElement("img", {
                src: qN,
                alt: "close-map"
            })), t.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: x
            })), t.createElement("div", {
                className: (()=>{
                    const e1 = [
                        "widget-tab__panorama-top-view-map"
                    ];
                    return a && e1.push("widget-tab__panorama-top-view-map--bottom"), h && e1.push("widget-tab__panorama-top-view-map--hidden"), p && e1.push("widget-tab__panorama-top-view-map--scaled"), e1.join(" ");
                })()
            }, t.createElement("div", {
                className: "display-wrapper"
            }, t.createElement("canvas", {
                id: R_,
                width: E.width,
                height: E.height,
                style: w,
                onClick: (e1)=>{
                    if (Ci.config.width <= ZN.tablet && !p) return y(), Ci.hideControls(), void f(!0);
                    if (!document.getElementById(R_)) return;
                    x();
                    const t = e1.nativeEvent.layerX / c, n = e1.nativeEvent.layerY / u, i = i_.currentColor, r = o.RoomColorIDPairs?.find((e1)=>e1.ColorID.R === i.R && e1.ColorID.G === i.G && e1.ColorID.B === i.B);
                    let a = M;
                    r && (a = a.filter((e1)=>e1.roomId === r.ObjectID));
                    const [s] = a.sort((e1, i)=>{
                        const r = (e1.position?.x ?? 0) - t, a = (e1.position?.y ?? 0) - n, s = (i.position?.x ?? 0) - t, o = (i.position?.y ?? 0) - n;
                        return r * r + a * a - (s * s + o * o);
                    });
                    s && LN.setCurrentPanoramaById(s.id);
                },
                onMouseMove: (e1)=>{
                    if (!g || h) return;
                    const t = e1.nativeEvent.layerX / c, n = e1.nativeEvent.layerY / u;
                    if (t < 0 || n < 0 || t > 1 || n > 1) return;
                    const { R: i, G: r, B: a, A: s } = _x(t, n, g);
                    e1.target.style.cursor = 0 === i ? "default" : "pointer";
                    const o = {
                        R: i,
                        G: r,
                        B: a,
                        A: s
                    };
                    O_.draw(o), i_.setCurrentColor(o);
                },
                onMouseLeave: y
            }), M.map((e1)=>{
                const n = e1.id === l ? "camera camera--current" : "camera", i = {
                    left: (e1.position?.x ?? 1) * c,
                    top: (e1.position?.y ?? 1) * c
                };
                return t.createElement("span", {
                    className: n,
                    key: e1.id,
                    style: i
                });
            }))));
        }), U_ = WN((e1)=>{
            let { disabled: n } = e1;
            const i = Cy.isCapable("top_view_as_miniplan"), r = Cy.isCapable("top_view_as_mini_plan"), a = Boolean(Ci.config.forceTopViewOnMap) || i || r, s = Boolean(Ci.config.topViewImage), o = a && s;
            a && !s && console.warn("Top view map requested, but image missed!");
            const l = o ? P_ : u_;
            return t.createElement(l, {
                disabled: n
            });
        }), j_ = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA1MiA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzg1NF84MjMzKSI+CjxwYXRoIGQ9Ik0zMS4xMjk4IDIzLjIwODNDMzAuNTE0MiAyMy44MjM5IDMwLjUxNDIgMjQuODIyIDMxLjEyOTggMjUuNDM3NkMzMS43NDU0IDI2LjA1MzMgMzIuNzQzNSAyNi4wNTMzIDMzLjM1OTEgMjUuNDM3NkwzMS4xMjk4IDIzLjIwODNaTTM1LjA5MjUgMTAuMDA1M0wzNi41NDg4IDkuNDAyMDJWOS40MDIwMkwzNS4wOTI1IDEwLjAwNTNaTTMwLjI1MzYgNC4xMDkwOEwyOS4zNzc4IDUuNDE5NzdMMzAuMjUzNiA0LjEwOTA4Wk0xNS42NTU0IDQuMTA5MDhMMTQuNzc5NiAyLjc5ODM5VjIuNzk4MzlMMTUuNjU1NCA0LjEwOTA4Wk0xMC44MTY1IDEwLjAwNTNMOS4zNjAxMyA5LjQwMjAySDkuMzYwMTNMMTAuODE2NSAxMC4wMDUzWk0xMi41NDk4IDI1LjQzNzZDMTMuMTY1NCAyNi4wNTMyIDE0LjE2MzUgMjYuMDUzMiAxNC43NzkxIDI1LjQzNzZDMTUuMzk0NyAyNC44MjIgMTUuMzk0NyAyMy44MjM5IDE0Ljc3OTEgMjMuMjA4M0wxMi41NDk4IDI1LjQzNzZaTTMzLjM1OTEgMjUuNDM3NkMzNS40MTcgMjMuMzc5OCAzNi44MTg0IDIwLjc1NzkgMzcuMzg2MiAxNy45MDM2TDM0LjI5NCAxNy4yODg2QzMzLjg0NzkgMTkuNTMxMyAzMi43NDY4IDIxLjU5MTQgMzEuMTI5OCAyMy4yMDgzTDMzLjM1OTEgMjUuNDM3NlpNMzcuMzg2MiAxNy45MDM2QzM3Ljk1MzkgMTUuMDQ5MyAzNy42NjI1IDEyLjA5MDcgMzYuNTQ4OCA5LjQwMjAyTDMzLjYzNjEgMTAuNjA4NUMzNC41MTEyIDEyLjcyMTEgMzQuNzQwMSAxNS4wNDU4IDM0LjI5NCAxNy4yODg2TDM3LjM4NjIgMTcuOTAzNlpNMzYuNTQ4OCA5LjQwMjAyQzM1LjQzNTEgNi43MTMzMSAzMy41NDkxIDQuNDE1MjMgMzEuMTI5NCAyLjc5ODM5TDI5LjM3NzggNS40MTk3N0MzMS4yNzkxIDYuNjkwMTkgMzIuNzYxIDguNDk1ODggMzMuNjM2MSAxMC42MDg1TDM2LjU0ODggOS40MDIwMlpNMzEuMTI5NCAyLjc5ODM5QzI4LjcwOTYgMS4xODE1NSAyNS44NjQ3IDAuMzE4NTY1IDIyLjk1NDUgMC4zMTg1NjVWMy40NzEyN0MyNS4yNDEyIDMuNDcxMjcgMjcuNDc2NSA0LjE0OTM2IDI5LjM3NzggNS40MTk3N0wzMS4xMjk0IDIuNzk4MzlaTTIyLjk1NDUgMC4zMTg1NjVDMjAuMDQ0MiAwLjMxODU2NSAxNy4xOTk0IDEuMTgxNTUgMTQuNzc5NiAyLjc5ODM5TDE2LjUzMTEgNS40MTk3N0MxOC40MzI0IDQuMTQ5MzYgMjAuNjY3OCAzLjQ3MTI3IDIyLjk1NDUgMy40NzEyN1YwLjMxODU2NVpNMTQuNzc5NiAyLjc5ODM5QzEyLjM1OTggNC40MTUyMyAxMC40NzM4IDYuNzEzMzEgOS4zNjAxMyA5LjQwMjAyTDEyLjI3MjggMTAuNjA4NUMxMy4xNDc5IDguNDk1ODggMTQuNjI5OCA2LjY5MDE5IDE2LjUzMTEgNS40MTk3N0wxNC43Nzk2IDIuNzk4MzlaTTkuMzYwMTMgOS40MDIwMkM4LjI0NjQzIDEyLjA5MDcgNy45NTUwMyAxNS4wNDkzIDguNTIyNzkgMTcuOTAzNkwxMS42MTQ5IDE3LjI4ODZDMTEuMTY4OCAxNS4wNDU4IDExLjM5NzggMTIuNzIxMSAxMi4yNzI4IDEwLjYwODVMOS4zNjAxMyA5LjQwMjAyWk04LjUyMjc5IDE3LjkwMzZDOS4wOTA1NSAyMC43NTc5IDEwLjQ5MiAyMy4zNzk4IDEyLjU0OTggMjUuNDM3NkwxNC43NzkxIDIzLjIwODNDMTMuMTYyMiAyMS41OTE0IDEyLjA2MSAxOS41MzEzIDExLjYxNDkgMTcuMjg4Nkw4LjUyMjc5IDE3LjkwMzZaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yOC41OTM0IDQzLjE5NzNWMjQuNzczNkMyOC41OTM0IDIzLjMzNjUgMjguMDIyNSAyMS45NTgyIDI3LjAwNjMgMjAuOTQyQzI1Ljk5MDEgMTkuOTI1OCAyNC42MTE4IDE5LjM1NDkgMjMuMTc0NyAxOS4zNTQ5QzIxLjczNzYgMTkuMzU0OSAyMC4zNTkzIDE5LjkyNTggMTkuMzQzMSAyMC45NDJDMTguMzI2OSAyMS45NTgyIDE3Ljc1NiAyMy4zMzY1IDE3Ljc1NiAyNC43NzM2VjU3LjYyOUwxMS44MTUgNDcuMzM4OUMxMS40NTk2IDQ2LjcyMiAxMC45ODYgNDYuMTgxMyAxMC40MjE0IDQ1Ljc0NzVDOS44NTY4NCA0NS4zMTM3IDkuMjEyMzEgNDQuOTk1NCA4LjUyNDY3IDQ0LjgxMDlDNy44MzcwMyA0NC42MjYzIDcuMTE5NzYgNDQuNTc5MSA2LjQxMzg1IDQ0LjY3MTlDNS43MDc5NSA0NC43NjQ2IDUuMDI3MjQgNDQuOTk1NiA0LjQxMDY1IDQ1LjM1MTZDMy43OTQwNiA0NS43MDc2IDMuMjUzNjcgNDYuMTgxNiAyLjgyMDM2IDQ2Ljc0NjZDMi4zODcwNiA0Ny4zMTE1IDIuMDY5MzMgNDcuOTU2MyAxLjg4NTM1IDQ4LjY0NDFDMS43MDEzNiA0OS4zMzE5IDEuNjU0NzIgNTAuMDQ5MiAxLjc0ODEgNTAuNzU1QzEuODQxNDcgNTEuNDYwOCAyLjA3MzAzIDUyLjE0MTQgMi40Mjk1MyA1Mi43NTc2QzExLjI1MzUgNzEuMzc0NiAxNi42MjI3IDc3Ljg3NzEgMjguNTkzNCA3Ny44NzcxQzMxLjQzOTggNzcuODc3MSAzNC4yNTgzIDc3LjMxNjQgMzYuODg4IDc2LjIyNzJDMzkuNTE3OCA3NS4xMzc5IDQxLjkwNzIgNzMuNTQxMyA0My45MTk5IDcxLjUyODZDNDUuOTMyNiA2OS41MTU5IDQ3LjUyOTEgNjcuMTI2NSA0OC42MTg0IDY0LjQ5NjhDNDkuNzA3NyA2MS44NjcxIDUwLjI2ODMgNTkuMDQ4NiA1MC4yNjgzIDU2LjIwMjJWNDUuMzY0OEM1MC4yNjgzIDQzLjkyNzYgNDkuNjk3NCA0Mi41NDkzIDQ4LjY4MTIgNDEuNTMzMUM0Ny42NjUgNDAuNTE2OSA0Ni4yODY3IDM5Ljk0NiA0NC44NDk2IDM5Ljk0NkM0My40MTI0IDM5Ljk0NiA0Mi4wMzQyIDQwLjUxNjkgNDEuMDE4IDQxLjUzMzFDNDAuMDAxOCA0Mi41NDkzIDM5LjQzMDkgNDMuOTI3NiAzOS40MzA5IDQ1LjM2NDgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM5LjQzMDggNDUuMzY0N1Y0Mi4xMTM1QzM5LjQzMDggNDAuNjc2NCAzOC44NTk5IDM5LjI5ODEgMzcuODQzNyAzOC4yODE5QzM2LjgyNzUgMzcuMjY1NyAzNS40NDkyIDM2LjY5NDggMzQuMDEyMSAzNi42OTQ4QzMyLjU3NSAzNi42OTQ4IDMxLjE5NjcgMzcuMjY1NyAzMC4xODA1IDM4LjI4MTlDMjkuMTY0MyAzOS4yOTgxIDI4LjU5MzQgNDAuNjc2NCAyOC41OTM0IDQyLjExMzVWNDMuMTk3MyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzg1NF84MjMzIj4KPHJlY3Qgd2lkdGg9IjUyIiBoZWlnaHQ9IjgwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMC4wMDAzMzA0NDgpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==", k_ = WN(()=>((0, t.useEffect)(()=>{
                LN.setAutoRotateState(Ci.autoRotatePanarama);
            }, []), t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--rotation",
                onClick: ()=>LN.toggleAutoRotate()
            }, t.createElement("img", {
                src: LN.currentAutoRotateIcon,
                alt: "rotation-icon"
            })))), B_ = WN(()=>{
            const [e1, n] = (0, t.useState)(Ci.config.scales[0]), i = Ci.config.scaleButtonType;
            return t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--scale",
                onClick: ()=>{
                    LN.toggleFov();
                    const e1 = Object.entries(LN.cameraFovValues).find((e1)=>{
                        let [t, n] = e1;
                        return n === LN.cameraFov;
                    });
                    if (e1) {
                        const [t] = e1;
                        n(t);
                    }
                }
            }, "img" === i && t.createElement("img", {
                src: LN.currentFovIcon,
                className: `widget-tab__panorama-controls-button widget-tab__panorama-controls-button--scale-${e1}`,
                alt: "scale-icon"
            }), "img" !== i && t.createElement("span", null, LN.currentFovText));
        }), F_ = WN((e1)=>{
            let { onClick: n } = e1;
            const i = [
                "widget-tab__panorama-controls-button",
                "widget-tab__panorama-controls-button--ruler"
            ];
            return LN.rulerModeEnabled && i.push("widget-tab__panorama-controls-button--ruler-active"), t.createElement("button", {
                className: i.join(" "),
                disabled: !LN.rulerButtonEnabled,
                onClick: n
            }, t.createElement("img", {
                src: LN.currentRulerIcon,
                alt: "ruler-icon"
            }));
        }), H_ = (e1)=>{
            let { onClick: n, type: i } = e1;
            return "button" === i ? t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--furniture",
                onClick: n
            }, t.createElement("img", {
                src: LN.bareshell ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC4yIj4KPHJlY3QgeD0iOC41MzEyNSIgeT0iOC40Nzk0OSIgd2lkdGg9IjEwLjkzOTMiIGhlaWdodD0iNC42MTk2NCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuMzEyNSIvPgo8cmVjdCB4PSI4LjUzMTI1IiB5PSIxMy4zNjYyIiB3aWR0aD0iMTAuOTM5MyIgaGVpZ2h0PSI0LjYxOTY0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS4zMTI1Ii8+CjxwYXRoIGQ9Ik0xMi41MDk4IDE1LjgwOTZIMTUuNDg0NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuMzEyNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNTA5OCAxMC43ODkxSDE1LjQ4NDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjMyMjMgMjAuMTc2OEwxOC4zMjIzIDE4LjY0MjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNjgxNjQgMjAuMTc2OEw5LjY4MTY0IDE4LjY0MjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8cGF0aCBkPSJNMTkuNjg5OSA4LjMxMDU1TDguMzEwNTUgMTkuNjg5OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNjU1MTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuNjg5OSAxOS42ODk5TDguMzEwNTUgOC4zMTA1NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNjU1MTciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iOC41MzEyNSIgeT0iOC40Nzk0OSIgd2lkdGg9IjEwLjkzOTMiIGhlaWdodD0iNC42MTk2NCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuMzEyNSIvPgo8cmVjdCB4PSI4LjUzMTI1IiB5PSIxMy4zNjYyIiB3aWR0aD0iMTAuOTM5MyIgaGVpZ2h0PSI0LjYxOTY0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS4zMTI1Ii8+CjxwYXRoIGQ9Ik0xMi41MDk4IDE1LjgwOTZIMTUuNDg0NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuMzEyNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTIuNTA5OCAxMC43ODkxSDE1LjQ4NDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjMyMjMgMjAuMTc2OEwxOC4zMjIzIDE4LjY0MjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNjgxNjQgMjAuMTc2OEw5LjY4MTY0IDE4LjY0MjEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjMxMjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "furniture-icon"
            })) : t.createElement("button", {
                onClick: n,
                className: "widget-tab__panorama-controls-button--bareshell"
            }, t.createElement("p", {
                className: "widget-tab__panorama-controls-button--bareshell-text"
            }, LN.bareshell ? "Bareshell" : "Furnished"), t.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch"
            }, t.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-label",
                htmlFor: "bareshell-switch"
            }, t.createElement("span", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-button " + (LN.bareshell ? "checked" : "")
            }))));
        }, G_ = WN((e1)=>{
            let { items: n, type: i, disabled: r, showRulerInstructions: a, setRulerInstructionsState: s, bottomButtons: o } = e1;
            const l = [
                {
                    icon: o_,
                    text: Pi("rotate-plan")
                },
                {
                    icon: j_,
                    text: Pi("research-plan")
                }
            ], c = [
                {
                    icon: o_,
                    text: Pi("create-points")
                },
                {
                    icon: j_,
                    text: Pi("delete-points")
                }
            ], [u, h] = (0, t.useState)(Ci.instructionVisible), d = ()=>LN.updateWindowSize(Ci.config.width, Ci.config.height), p = async ()=>{
                LN.setBareshell(!LN.bareshell), LN.currentPanorama && (LN.setLoadingState(!0), await LN.currentPanorama.fadeOut(), await LN.currentPanorama.createMaterial(), await LN.currentPanorama.fadeIn(), LN.setLoadingState(!1));
            }, f = "standard" === Ci.configParams.designType && Cy.isCapable("hidden_furniture"), g = "custom" === Ci.configParams.designType && Cy.isCapable("hidden_furniture") && o.includes("furniture"), m = Cy.isCapable("ruler") && o.includes("ruler");
            (0, t.useEffect)(()=>{
                performance.mark("opening panorama mode"), LN.enableRender();
                const e1 = document.querySelector(".widget-tab__panorama-overlay");
                return e1.appendChild(LN.renderer.domElement), ()=>{
                    LN.setInitialCurrentPanorama(), LN.camera.deviceOrientationControls.disable(), LN.setCameraFov(LN.cameraFovValues[Ci.scales[0]]), LN.camera.controls.setDefaultPosition(), LN.setAutoRotateState(!1), LN.setRulerMode(!1), LN.disableRender(), e1.innerHTML = "";
                };
            }, []), (0, t.useEffect)(()=>{
                const e1 = LN.floorsGroup.children.some((e1)=>e1.floorIndex === Ci.currentFloorIndex);
                return LN.initialized ? e1 ? (LN.setCurrentPanoramasGroup(Ci.currentFloorIndex), void LN.setInitialCurrentPanorama()) : (LN.setLoadingState(!0), void LN.createPanoramasGroup(n, i, Ci.currentFloorIndex).finally(()=>LN.setLoadingState(!1))) : (LN.setLoadingState(!0), performance.mark("start PanaramaStore Init"), void LN.init(n, i, Ci.currentFloorIndex).finally(()=>LN.setLoadingState(!1)));
            }, [
                Ci.currentFloorIndex
            ]), (0, t.useEffect)(d, [
                Ci.config.width,
                Ci.config.height
            ]);
            const A = "circle" === Ci.config.cursorType ? "circle" : "pointer", M = Ci.config.enableCursorPulse ? A : "";
            return t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama"
            }, LN.loading && t.createElement(c_, {
                absolute: !0
            }), t.createElement("div", {
                className: "widget-tab__panorama-overlay",
                onContextMenu: zi
            }, !gx.isMobile && !gx.isTablet && t.createElement("div", {
                className: "cursor",
                id: "cursor"
            }, t.createElement("img", {
                src: "circle" === Ci.config.cursorType ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MSA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM3NjBfNzQ1MCkiPgo8ZyBvcGFjaXR5PSIwLjgiPgo8Y2lyY2xlIGN4PSIyNS41IiBjeT0iMjUiIHI9IjI0LjM5MDIiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjIxOTUxIi8+CjxjaXJjbGUgY3g9IjI1LjQ5OTUiIGN5PSIyNS4wMDE0IiByPSI4LjUzNjU5IiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzc2MF83NDUwIj4KPHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1Ljc0ODUgMTAuNVY5LjM3NUMxNS43NDg1IDguODc3NzIgMTUuNTUwOSA4LjQwMDgxIDE1LjE5OTMgOC4wNDkxN0MxNC44NDc3IDcuNjk3NTQgMTQuMzcwOCA3LjUgMTMuODczNSA3LjVDMTMuMzc2MiA3LjUgMTIuODk5MyA3LjY5NzU0IDEyLjU0NzcgOC4wNDkxN0MxMi4xOTYgOC40MDA4MSAxMS45OTg1IDguODc3NzIgMTEuOTk4NSA5LjM3NVYzLjM3NUMxMS45OTg1IDIuODc3NzIgMTEuODAwOSAyLjQwMDgxIDExLjQ0OTMgMi4wNDkxN0MxMS4wOTc3IDEuNjk3NTQgMTAuNjIwOCAxLjUgMTAuMTIzNSAxLjVDOS42MjYyMSAxLjUgOS4xNDkzIDEuNjk3NTQgOC43OTc2NyAyLjA0OTE3QzguNDQ2MDQgMi40MDA4MSA4LjI0ODQ5IDIuODc3NzIgOC4yNDg0OSAzLjM3NVYxNC43NDY5TDYuMTk1MzcgMTEuMTg0NEM1Ljk0NjczIDEwLjc1MyA1LjUzNjkgMTAuNDM4IDUuMDU2MDUgMTAuMzA4OEM0LjU3NTE5IDEwLjE3OTYgNC4wNjI3IDEwLjI0NjcgMy42MzEzMSAxMC40OTUzQzMuMTk5OTEgMTAuNzQ0IDIuODg0OTYgMTEuMTUzOCAyLjc1NTc0IDExLjYzNDZDMi42MjY1MiAxMi4xMTU1IDIuNjkzNiAxMi42MjggMi45NDIyNCAxMy4wNTk0QzUuOTk4NDkgMTkuNSA3Ljg1NDc0IDIxLjc1IDExLjk5ODUgMjEuNzVDMTIuOTgzNCAyMS43NSAxMy45NTg3IDIxLjU1NiAxNC44Njg2IDIxLjE3OTFDMTUuNzc4NiAyMC44MDIyIDE2LjYwNTQgMjAuMjQ5NyAxNy4zMDE4IDE5LjU1MzNDMTcuOTk4MiAxOC44NTY5IDE4LjU1MDcgMTguMDMwMSAxOC45Mjc2IDE3LjEyMDFDMTkuMzA0NSAxNi4yMTAyIDE5LjQ5ODUgMTUuMjM0OSAxOS40OTg1IDE0LjI1VjEwLjVDMTkuNDk4NSAxMC4wMDI3IDE5LjMwMDkgOS41MjU4MSAxOC45NDkzIDkuMTc0MTdDMTguNTk3NyA4LjgyMjU0IDE4LjEyMDggOC42MjUgMTcuNjIzNSA4LjYyNUMxNy4xMjYyIDguNjI1IDE2LjY0OTMgOC44MjI1NCAxNi4yOTc3IDkuMTc0MTdDMTUuOTQ2IDkuNTI1ODEgMTUuNzQ4NSAxMC4wMDI3IDE1Ljc0ODUgMTAuNVoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNFREVERUQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K",
                className: M,
                alt: "cursor"
            }))), LN.currentPanorama && t.createElement(U_, {
                disabled: r
            }), LN.currentPanorama && "sidebar" !== Ci.config.designType && t.createElement("div", {
                className: Cy.isCapable("hidden_furniture") ? "widget-tab__panorama-controls-container" : ""
            }, t.createElement("div", {
                className: "widget-tab__panorama-controls"
            }, m && t.createElement(F_, {
                onClick: ()=>{
                    LN.toggleRulerMode(), LN.rulerInstructionShown || s(!0);
                }
            }), o.includes("scale") && t.createElement(B_, null), o.includes("rotation") && t.createElement(k_, null), g && t.createElement(H_, {
                type: "button",
                onClick: p
            })), f && t.createElement("div", {
                className: "widget-tab__panorama-controls"
            }, t.createElement(H_, {
                onClick: p,
                type: "switch"
            })))), u && t.createElement(wD, {
                disabled: r,
                steps: l,
                onClick: async ()=>{
                    if (h(!1), d(), !gx.isMobile && !gx.isTablet) return;
                    if (!Ci.configParams.enableGyroscope) return;
                    if (LN.camera.deviceOrientationControls.connected) return LN.camera.deviceOrientationControls.enable();
                    if ("granted" !== await gx.requestDeviceOrientation()) return;
                    const e1 = ()=>{
                        window.removeEventListener("deviceorientation", e1), LN.camera.deviceOrientationControls.connect(), setTimeout(()=>LN.camera.deviceOrientationControls.enable(), 250);
                    };
                    window.addEventListener("deviceorientation", e1);
                }
            }), a && t.createElement(wD, {
                steps: c,
                onClick: ()=>{
                    LN.setRulerInstructionShown(!0), s(!1);
                },
                isRuler: !0
            }));
        }), V_ = (e1)=>{
            let { planImage: n } = e1;
            const [, i] = (0, t.useState)(null);
            let r = {
                x: 0,
                y: 0
            };
            const a = ()=>r = {
                    x: 0,
                    y: 0
                };
            return (0, t.useEffect)(()=>{
                const e1 = document.querySelector(".widget-tab__isometry-container"), t = nD()(e1, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                i(t);
            }, []), t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__isometry"
            }, t.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: (e1)=>{
                    if (e1.touches.length > 1) return;
                    const t = e1.touches[0];
                    r = {
                        x: t.screenX
                    };
                },
                onTouchMove: (e1)=>{
                    if (e1.touches.length > 1) return;
                    e1.stopPropagation();
                    const t = e1.touches[0], n = r.x - t.screenX;
                    0 !== r.x && Math.abs(n) >= 100 && a();
                },
                onTouchEnd: a
            }, t.createElement("img", {
                className: "widget-tab__isometry--plan active",
                src: n,
                alt: "plan-view"
            }))));
        }, Q_ = "data:image/svg+xml;base64,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", W_ = "data:image/svg+xml;base64,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", Y_ = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjUyNzcgOS44MjM0MUwzNC4xODI0IDUuNDI3MzZDMzMuOTc2OSA1LjI1ODM5IDMzLjcxOTIgNS4xNjYwMiAzMy40NTMyIDUuMTY2MDJIMTMuMzMwMkMxMy4wNTcgNS4xNjYwMiAxMi43OTI4IDUuMjYzNDUgMTIuNTg1IDUuNDQwOEw3LjQ0NTg4IDkuODI2NzdDNy4yNDI5NyA5Ljk5OTk0IDcuMzY1NDQgMTAuMzMyMSA3LjYzMjIgMTAuMzMyMUgzOS4zNDU0QzM5LjYxNDcgMTAuMzMyMSAzOS43MzU3IDkuOTk0NSAzOS41Mjc3IDkuODIzNDFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4zNzk4IDIyLjM4NjdDMTAuMzc5OCAyMi44MDA5IDEwLjcxNTUgMjMuMTM2NyAxMS4xMjk4IDIzLjEzNjdDMTEuNTQ0IDIzLjEzNjcgMTEuODc5OCAyMi44MDA5IDExLjg3OTggMjIuMzg2N0wxMC4zNzk4IDIyLjM4NjdaTTExLjg3OTggMjIuMzg2N0wxMS44Nzk4IDEwLjMzMjZMMTAuMzc5OCAxMC4zMzI2TDEwLjM3OTggMjIuMzg2N0wxMS44Nzk4IDIyLjM4NjdaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0zNC40MjQzIDIyLjM4NjdDMzQuNDI0MyAyMi44MDA5IDM0Ljc2MDEgMjMuMTM2NyAzNS4xNzQzIDIzLjEzNjdDMzUuNTg4NSAyMy4xMzY3IDM1LjkyNDMgMjIuODAwOSAzNS45MjQzIDIyLjM4NjdMMzQuNDI0MyAyMi4zODY3Wk0zNS45MjQzIDIyLjM4NjdMMzUuOTI0MyAxMC4zMzI2TDM0LjQyNDMgMTAuMzMyNkwzNC40MjQzIDIyLjM4NjdMMzUuOTI0MyAyMi4zODY3WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMTQuNjk1NCAxNi45MDYyQzE0LjY5NTQgMTcuMzIwNSAxNS4wMzEyIDE3LjY1NjIgMTUuNDQ1NCAxNy42NTYyQzE1Ljg1OTYgMTcuNjU2MyAxNi4xOTU0IDE3LjMyMDUgMTYuMTk1NCAxNi45MDYzTDE0LjY5NTQgMTYuOTA2MlpNMTYuMTk1NCAxNi45MDYzTDE2LjE5NTQgMTAuMzMxM0wxNC42OTU0IDEwLjMzMTNMMTQuNjk1NCAxNi45MDYyTDE2LjE5NTQgMTYuOTA2M1oiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTMwLjEwODYgMTYuOTA2MkMzMC4xMDg2IDE3LjMyMDUgMzAuNDQ0NCAxNy42NTYyIDMwLjg1ODYgMTcuNjU2MkMzMS4yNzI4IDE3LjY1NjMgMzEuNjA4NiAxNy4zMjA1IDMxLjYwODYgMTYuOTA2M0wzMC4xMDg2IDE2LjkwNjJaTTMxLjYwODYgMTYuOTA2M0wzMS42MDg2IDEwLjMzMTNMMzAuMTA4NiAxMC4zMzEzTDMwLjEwODYgMTYuOTA2MkwzMS42MDg2IDE2LjkwNjNaIiBmaWxsPSIjNDEzRTNFIi8+Cjwvc3ZnPgo=", X_ = "data:image/svg+xml;base64,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", Z_ = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY4MDUgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzLjQ2ODkgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjcwODIgMTAuMDU0N1Y1Ljk5MjE5QzEwLjcwODIgNS40NTM0NyAxMC45Njc0IDQuOTM2ODEgMTEuNDI4OSA0LjU1NTg4QzExLjg5MDMgNC4xNzQ5NCAxMi41MTYyIDMuOTYwOTQgMTMuMTY4NyAzLjk2MDk0QzEzLjgyMTMgMy45NjA5NCAxNC40NDcxIDQuMTc0OTQgMTQuOTA4NiA0LjU1NTg4QzE1LjM3IDQuOTM2ODEgMTUuNjI5MyA1LjQ1MzQ3IDE1LjYyOTMgNS45OTIxOSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMy45NDIxIDkuMjQyMTlIMjUuNjU0NlYxNC4xMTcySDMzLjk0MjFWOS4yNDIxOVoiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuNzk5MyAxMC4wNTQ3SDM4LjczNjJDMzguOTk3MiAxMC4wNTQ3IDM5LjI0NzUgMTAuMTQwMyAzOS40MzIxIDEwLjI5MjdDMzkuNjE2NyAxMC40NDUgMzkuNzIwNCAxMC42NTE3IDM5LjcyMDQgMTAuODY3MlYxNC43MjY2QzM5LjcyMDQgMTYuMDE5NSAzOS4wOTgyIDE3LjI1OTUgMzcuOTkwOCAxOC4xNzM3QzM2Ljg4MzMgMTkuMDg3OSAzNS4zODEzIDE5LjYwMTYgMzMuODE1MSAxOS42MDE2SDEyLjMzMDNDMTAuNzY0MSAxOS42MDE2IDkuMjYyMDcgMTkuMDg3OSA4LjE1NDYxIDE4LjE3MzdDNy4wNDcxNiAxNy4yNTk1IDYuNDI1IDE2LjAxOTUgNi40MjUgMTQuNzI2NlYxMC44NjcyQzYuNDI1IDEwLjY1MTcgNi41Mjg3IDEwLjQ0NSA2LjcxMzI3IDEwLjI5MjdDNi44OTc4NSAxMC4xNDAzIDcuMTQ4MTggMTAuMDU0NyA3LjQwOTIxIDEwLjA1NDdIMjUuNjUwNyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", q_ = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ1OTYgMjMuNTMzNlYyLjQ2NzEzTDI0LjMxNTcgMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkgzMC4zOTYzTTE2LjQ1OTYgMjMuNTMzNkwyNC4zMTU3IDIwLjA1OTFWMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkg5Ljc2NjZNMzAuMzk2MyAyMy41MzM2VjIuNDY3MTNMMjQuMzE1NyAyLjQ2NjhNMzAuMzk2MyAyMy41MzM2SDM3Ljg0OTdNMjEuNTEwNiAxMS41MTM2TDE5LjgxNDYgMTIuMzgyMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", K_ = "data:image/svg+xml;base64,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", J_ = {
            Kitchen: {
                name: "Kitchen",
                img: Y_
            },
            BrownTilesKitchen: {
                name: "Kitchen",
                img: Y_
            },
            Living: {
                name: "Living",
                img: X_
            },
            KitchenLiving: {
                name: "KitchLiv",
                img: X_
            },
            Bedroom: {
                name: "Bedroom",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk1ODUgMjIuMzg1NVYxNS40OTc0QzM4Ljk1ODUgMTQuNTQ2NCAzOC4xODc1IDEzLjc3NTQgMzcuMjM2NCAxMy43NzU0SDEwLjI1ODFDOS4zMDcwOCAxMy43NzU0IDguNTM2MSAxNC41NDY0IDguNTM2MSAxNS40OTc0VjIyLjM4NTUiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEuNzM4MiAxMi42Mjc2VjEwLjMzMTZDMjEuNzM4MiA5LjY5NzU4IDIxLjIyNDMgOS4xODM1OSAyMC41OTAyIDkuMTgzNTlIMTYuNDkwOEMxNS45ODIgOS4xODM1OSAxNS41MzQgOS41MTg0MyAxNS4zODk4IDEwLjAwNjNMMTQuNzExNCAxMi4zMDI0QzE0LjQ5NDEgMTMuMDM3OSAxNS4wNDU0IDEzLjc3NTYgMTUuODEyNCAxMy43NzU2SDIwLjU5MDJDMjEuMjI0MyAxMy43NzU2IDIxLjczODIgMTMuMjYxNyAyMS43MzgyIDEyLjYyNzZaIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNS43NTYzIDEyLjYyNzZWMTAuMzMxNkMyNS43NTYzIDkuNjk3NTggMjYuMjcwMyA5LjE4MzU5IDI2LjkwNDMgOS4xODM1OUgzMS4wMDM4QzMxLjUxMjUgOS4xODM1OSAzMS45NjA2IDkuNTE4NDMgMzIuMTA0NyAxMC4wMDYzTDMyLjc4MzEgMTIuMzAyNEMzMy4wMDA0IDEzLjAzNzkgMzIuNDQ5MSAxMy43NzU2IDMxLjY4MjEgMTMuNzc1NkgyNi45MDQzQzI2LjI3MDMgMTMuNzc1NiAyNS43NTYzIDEzLjI2MTcgMjUuNzU2MyAxMi42Mjc2WiIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNOC41MzYxIDIwLjA4OThIMzguOTU4NSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMzUuNTE0NCAxMy4yMDIzVjguMDM2MjZDMzUuNTE0NCA2Ljc2ODIgMzQuNDg2NSA1Ljc0MDIzIDMzLjIxODQgNS43NDAyM0gxNC4yNzYyQzEzLjAwODEgNS43NDAyMyAxMS45ODAxIDYuNzY4MiAxMS45ODAxIDguMDM2MjZWMTMuMjAyMyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Kid_room: {
                name: "Kid room",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjI0ODIgMjIuNzVDMjguNjMyNSAyMi43NSAzMi45OTc0IDE4LjM4NDggMzIuOTk3NCAxM0MzMi45OTc0IDcuNjE1MjIgMjguNjMyNSAzLjI1IDIzLjI0ODIgMy4yNUMxNy44NjM4IDMuMjUgMTMuNDk5IDcuNjE1MjIgMTMuNDk5IDEzQzEzLjQ5OSAxOC4zODQ4IDE3Ljg2MzggMjIuNzUgMjMuMjQ4MiAyMi43NVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuNTkyMiAxNC4yMTg4QzIwLjI2NTIgMTQuMjE4OCAyMC44MTA4IDEzLjY3MzEgMjAuODEwOCAxM0MyMC44MTA4IDEyLjMyNjkgMjAuMjY1MiAxMS43ODEyIDE5LjU5MjIgMTEuNzgxMkMxOC45MTkxIDExLjc4MTIgMTguMzczNSAxMi4zMjY5IDE4LjM3MzUgMTNDMTguMzczNSAxMy42NzMxIDE4LjkxOTEgMTQuMjE4OCAxOS41OTIyIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNi45MDQxIDE0LjIxODhDMjcuNTc3MSAxNC4yMTg4IDI4LjEyMjcgMTMuNjczMSAyOC4xMjI3IDEzQzI4LjEyMjcgMTIuMzI2OSAyNy41NzcxIDExLjc4MTIgMjYuOTA0MSAxMS43ODEyQzI2LjIzMSAxMS43ODEyIDI1LjY4NTQgMTIuMzI2OSAyNS42ODU0IDEzQzI1LjY4NTQgMTMuNjczMSAyNi4yMzEgMTQuMjE4OCAyNi45MDQxIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNS45MzkzIDE3LjA2MjVDMjUuMTQxNyAxNy41OTIyIDI0LjIwNTYgMTcuODc0OCAyMy4yNDgxIDE3Ljg3NDhDMjIuMjkwNyAxNy44NzQ4IDIxLjM1NDUgMTcuNTkyMiAyMC41NTY5IDE3LjA2MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuMjQ4MiAzLjI1QzIxLjYyMzMgNS4yODEyNSAyMS42MjMzIDcuMzEyNSAyMS42MjMzIDcuMzEyNUMyMS42MjMzIDcuNzQzNDggMjEuNzk0NSA4LjE1NjggMjIuMDk5MiA4LjQ2MTU1QzIyLjQwMzkgOC43NjYyOSAyMi44MTcyIDguOTM3NSAyMy4yNDgyIDguOTM3NUMyMy42NzkxIDguOTM3NSAyNC4wOTI0IDguNzY2MjkgMjQuMzk3MSA4LjQ2MTU1QzI0LjcwMTggOC4xNTY4IDI0Ljg3MyA3Ljc0MzQ4IDI0Ljg3MyA3LjMxMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Hall: {
                name: "Hall",
                img: q_
            },
            Bathroom: {
                name: "Bathroom",
                img: Z_
            },
            BathLaminate: {
                name: "Bathroom",
                img: Z_
            },
            CombinedBathroom: {
                name: "CombBath",
                img: Z_
            },
            LightWoodBath: {
                name: "Bathroom",
                img: Z_
            },
            BrownTilesBath: {
                name: "Bathroom",
                img: Z_
            },
            Toilet: {
                name: "Toilet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2Ljc1IDExLjM3NVY0LjA2MjVDMTYuNzUgMy44NDcwMSAxNi44MzU2IDMuNjQwMzUgMTYuOTg4IDMuNDg3OThDMTcuMTQwMyAzLjMzNTYgMTcuMzQ3IDMuMjUgMTcuNTYyNSAzLjI1SDI4LjkzNzVDMjkuMTUzIDMuMjUgMjkuMzU5NyAzLjMzNTYgMjkuNTEyIDMuNDg3OThDMjkuNjY0NCAzLjY0MDM1IDI5Ljc1IDMuODQ3MDEgMjkuNzUgNC4wNjI1VjExLjM3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCA2LjVIMjEuNjI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMyLjE4NzUgMTEuMzc1QzMyLjE4NzUgMTMuNzQ1NCAzMS4yNDU5IDE2LjAxODcgMjkuNTY5OCAxNy42OTQ4QzI3Ljg5MzcgMTkuMzcwOSAyNS42MjA0IDIwLjMxMjUgMjMuMjUgMjAuMzEyNUMyMC44Nzk2IDIwLjMxMjUgMTguNjA2MyAxOS4zNzA5IDE2LjkzMDIgMTcuNjk0OEMxNS4yNTQxIDE2LjAxODcgMTQuMzEyNSAxMy43NDU0IDE0LjMxMjUgMTEuMzc1SDMyLjE4NzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5Ljc1NjMgMTkuNjAxNkwxOS4zMTk1IDIyLjYzODNDMTkuMzAzNiAyMi43NTMxIDE5LjMxMjQgMjIuODcgMTkuMzQ1NCAyMi45ODEyQzE5LjM3ODQgMjMuMDkyMyAxOS40MzQ4IDIzLjE5NTEgMTkuNTEwOCAyMy4yODI2QzE5LjU4NjggMjMuMzcwMiAxOS42ODA2IDIzLjQ0MDUgMTkuNzg2IDIzLjQ4ODdDMTkuODkxNCAyMy41MzcgMjAuMDA2IDIzLjU2MjIgMjAuMTIxOSAyMy41NjI1SDI2LjM3ODFDMjYuNDk0MSAyMy41NjIyIDI2LjYwODYgMjMuNTM3IDI2LjcxNCAyMy40ODg3QzI2LjgxOTQgMjMuNDQwNSAyNi45MTMzIDIzLjM3MDIgMjYuOTg5MyAyMy4yODI2QzI3LjA2NTMgMjMuMTk1MSAyNy4xMjE2IDIzLjA5MjMgMjcuMTU0NiAyMi45ODEyQzI3LjE4NzYgMjIuODcgMjcuMTk2NCAyMi43NTMxIDI3LjE4MDUgMjIuNjM4M0wyNi43NDM4IDE5LjYwMTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Balcony: {
                name: "Balcony",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA1NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI0MzIgMTUuOTgwN1YxNS40ODc4QzE1LjI0MzIgMTQuMzgzMyAxNi4xMzg2IDEzLjQ4NzggMTcuMjQzMiAxMy40ODc4SDE5LjM3OTNNNDAuNDM5MyAxNS45ODA3VjE1LjQ4NzhDNDAuNDM5MyAxNC4zODMzIDM5LjU0MzkgMTMuNDg3OCAzOC40MzkzIDEzLjQ4NzhIMzYuMzAzMU0zNi4zMDMxIDEwLjg1NTdWMy4zMjIyN0gyNy44NDEyTTE5LjM3OTMgMTAuODU1N1YzLjMyMjI3SDI3Ljg0MTJNMjcuODQxMiAzLjMyMjI3VjEwLjg1NTdNMTYuMzQ2MSAyMi4xMTRIMTkuMzc5M00zOS4zMzYzIDIyLjExNEgzNi4zMDMxTTI3Ljg0MTIgMjIuMTE0VjEzLjQ4NzhNMjcuODQxMiAyMi4xMTRIMzIuMDI5MU0yNy44NDEyIDIyLjExNEgyMy42MTAyTTI3Ljg0MTIgMTMuNDg3OEgzMi4wMjkxTTI3Ljg0MTIgMTMuNDg3OEgxOS4zNzkzTTMyLjAyOTEgMTMuNDg3OFYyMi4xMTRNMzIuMDI5MSAxMy40ODc4SDM2LjMwMzFNMzIuMDI5MSAyMi4xMTRIMzYuMzAzMU0zNi4zMDMxIDIyLjExNFYxMy40ODc4TTE5LjM3OTMgMTMuNDg3OFYyMi4xMTRNMTkuMzc5MyAyMi4xMTRIMjMuNjEwMk0yMy42MTAyIDIyLjExNFYxMy42Mjg0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
            },
            Hallway: {
                name: "Hallway",
                img: q_
            },
            Cabinet: {
                name: "Cabinet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCA1NyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5IDkuNzI2NTZIMTdDMTYuNDQ3NyA5LjcyNjU2IDE2IDEwLjE3NDMgMTYgMTAuNzI2NlYyNi43MjY2QzE2IDI3LjI3ODggMTYuNDQ3NyAyNy43MjY2IDE3IDI3LjcyNjZIMzlDMzkuNTUyMyAyNy43MjY2IDQwIDI3LjI3ODggNDAgMjYuNzI2NlYxMC43MjY2QzQwIDEwLjE3NDMgMzkuNTUyMyA5LjcyNjU2IDM5IDkuNzI2NTZaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzIDkuNzI2NTZWNy43MjY1NkMzMyA3LjE5NjEzIDMyLjc4OTMgNi42ODc0MiAzMi40MTQyIDYuMzEyMzVDMzIuMDM5MSA1LjkzNzI4IDMxLjUzMDQgNS43MjY1NiAzMSA1LjcyNjU2SDI1QzI0LjQ2OTYgNS43MjY1NiAyMy45NjA5IDUuOTM3MjggMjMuNTg1OCA2LjMxMjM1QzIzLjIxMDcgNi42ODc0MiAyMyA3LjE5NjEzIDIzIDcuNzI2NTZWOS43MjY1NiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00MCAxNi41MTM3QzM2LjM1MjkgMTguNjIzIDMyLjIxMzIgMTkuNzMxMiAyOCAxOS43MjYyQzIzLjc4NjEgMTkuNzM3MSAxOS42NDQ4IDE4LjYyODUgMTYgMTYuNTEzNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDE1LjcyNjZIMjkuNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Wardrobe: {
                name: "Wardrobe",
                img: "data:image/svg+xml;base64,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"
            },
            Terrace: {
                name: "Terrace",
                img: K_
            },
            Terrace_2: {
                name: "Terrace",
                img: K_
            },
            Garage: {
                name: "Garage",
                img: "data:image/svg+xml;base64,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"
            },
            Gym: {
                name: "Gym",
                img: "data:image/svg+xml;base64,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"
            },
            Carpet: {
                name: "Pooja Room",
                img: Y_
            }
        }, $_ = WN(()=>{
            const e1 = (0, t.useRef)(null), n = e1.current, [i, r] = (0, t.useState)(!1), a = Ci.config.json.Floors[Ci.currentFloorIndex].Units[0].Rooms, s = [];
            Object.keys(J_).forEach((e1)=>{
                const t = a.filter((t)=>t.Type === e1 && "Flipped" !== t.WallsState && "Gap" !== t.CeilingState);
                t.length > 1 && t.forEach((e1, n)=>t[n].Numeric = n + 1), s.push(...t);
            });
            const o = function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = e1.getAttribute("data-test-id") ?? e1.closest("div").getAttribute("data-test-id");
                n && (t ? i_.setFixedColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }) : i_.setCurrentColor({
                    R: Number(n),
                    G: 0,
                    B: 0,
                    A: 0
                }));
            }, l = (e1)=>{
                const t = Object.entries(J_).find((t)=>{
                    let [n, i] = t;
                    return n === e1;
                })?.[1].img;
                return t;
            };
            return (0, t.useEffect)(()=>{
                n && n.addEventListener("mousedown", (e1)=>{
                    const t = e1.screenX, i = n.scrollLeft;
                    let r = !0;
                    const a = (e1)=>{
                        if (r) {
                            const r = t - e1.screenX;
                            n.scrollLeft = i + r;
                        }
                    }, s = ()=>{
                        r = !1, n.removeEventListener("mousemove", a), n.removeEventListener("mouseup", s), n.removeEventListener("mouseleave", o);
                    }, o = ()=>{
                        r = !1, n.removeEventListener("mousemove", a), n.removeEventListener("mouseup", s), n.removeEventListener("mouseleave", o);
                    };
                    n.addEventListener("mousemove", a), n.addEventListener("mouseup", s), n.addEventListener("mouseleave", o);
                });
            }, [
                n
            ]), (0, t.useEffect)(()=>{
                const e1 = s.findIndex((e1)=>e1.ColorID);
                e1 >= 0 && i_.setFixedColor(s[e1].ColorID);
            }, []), t.createElement(t.Fragment, null, t.createElement("div", {
                ref: e1,
                className: "widget-tab-rooms",
                onClick: (e1)=>o(e1.target, !0),
                onMouseMove: (e1)=>o(e1.target)
            }, t.createElement("div", {
                className: "widget-tab-rooms-switch"
            }, t.createElement("input", {
                onChange: ()=>{
                    r((e1)=>!e1);
                },
                className: "widget-tab-rooms-switch-checkbox",
                id: "area-type-switch",
                type: "checkbox"
            }), t.createElement("label", {
                className: "widget-tab-rooms-switch-label",
                htmlFor: "area-type-switch"
            }, t.createElement("span", {
                className: "widget-tab-rooms-switch-button"
            }, i ? "Meters" : "Feet"))), t.createElement("div", {
                className: "widget-tab-rooms-container"
            }, s.map((e1)=>{
                var n;
                return t.createElement("div", {
                    "data-test-id": e1.ColorID?.R,
                    className: "widget-tab-rooms-item " + (n = e1.ColorID?.R, n === i_.currentColor.R || n === i_.fixedColor.R ? "widget-tab-rooms-item-active" : ""),
                    key: e1.ID
                }, t.createElement("img", {
                    className: "widget-tab-rooms-item-img",
                    src: l(e1.Type),
                    alt: "icon"
                }), t.createElement("p", {
                    className: "widget-tab-rooms-item-type"
                }, ((e1, t)=>{
                    const n = Object.entries(J_).find((t)=>{
                        let [n, i] = t;
                        return n === e1;
                    })?.[1].name;
                    return t ? `${n} ${t}` : n;
                })(e1.Type, e1.Numeric)), t.createElement("p", {
                    className: "widget-tab-rooms-item-area"
                }, ((e1)=>{
                    const t = e1.Length * e1.Width;
                    return Math.abs(t / e1.Area - 1) >= .15 ? i ? `${e1.Area.toFixed(1)}m\xb2` : `${((e1)=>{
                        const t = Math.floor(e1 * Math.pow(Li, 2)), n = 144 * (e1 * Math.pow(Li, 2) - t);
                        return `${t}'${Math.round(n)}"`;
                    })(e1.Area)}` : i ? `${e1.Width?.toFixed(1)}m x ${e1.Length?.toFixed(1)}m` : `${Ui(e1.Width)} x ${Ui(e1.Length)}`;
                })(e1)));
            }))));
        }), eC = WN((e1)=>{
            let { currentTab: n, buttons: i, setRulerInstructionsState: r } = e1;
            const [a, s] = (0, t.useState)(!1), [o, l] = (0, t.useState)([]), [c, u] = (0, t.useState)(!0), [h, d] = (0, t.useState)(!1), [p, f] = (0, t.useState)(Ci.autoRotatePanarama), [g, m] = (0, t.useState)(!0), A = (0, t.useRef)(null), M = A.current, v = ()=>{
                l([]), s(!1);
            }, y = async ()=>{
                h && LN.toggleRulerMode(), d(!1), u((e1)=>!e1), LN.setBareshell(!LN.bareshell), LN.currentPanorama && (LN.setLoadingState(!0), await LN.currentPanorama.fadeOut(), await LN.currentPanorama.createMaterial(), await LN.currentPanorama.fadeIn(), LN.setLoadingState(!1));
            }, x = [
                {
                    isVisible: Cy.isCapable("hidden_furniture") && i.includes("furniture"),
                    click: ()=>y(),
                    buttonActivity: !c,
                    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9InBhdGgtMi1pbnNpZGUtMV8zNTA2XzgyOTUiIGZpbGw9IndoaXRlIj4KPHJlY3QgeD0iOS42MjEwOSIgeT0iOS42MjUiIHdpZHRoPSIyNC43NSIgaGVpZ2h0PSIxMS45ODI3IiByeD0iMS40Njc5MSIvPgo8L21hc2s+CjxyZWN0IHg9IjkuNjIxMDkiIHk9IjkuNjI1IiB3aWR0aD0iMjQuNzUiIGhlaWdodD0iMTEuOTgyNyIgcng9IjEuNDY3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjk4NzUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIG1hc2s9InVybCgjcGF0aC0yLWluc2lkZS0xXzM1MDZfODI5NSkiLz4KPG1hc2sgaWQ9InBhdGgtMy1pbnNpZGUtMl8zNTA2XzgyOTUiIGZpbGw9IndoaXRlIj4KPHJlY3QgeD0iOS42MjEwOSIgeT0iMTkuNDk2MSIgd2lkdGg9IjI0Ljc1IiBoZWlnaHQ9IjExLjk4MjciIHJ4PSIxLjQ2NzkxIi8+CjwvbWFzaz4KPHJlY3QgeD0iOS42MjEwOSIgeT0iMTkuNDk2MSIgd2lkdGg9IjI0Ljc1IiBoZWlnaHQ9IjExLjk4MjciIHJ4PSIxLjQ2NzkxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy45ODc1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBtYXNrPSJ1cmwoI3BhdGgtMy1pbnNpZGUtMl8zNTA2XzgyOTUpIi8+CjxwYXRoIGQ9Ik0xOC45ODYzIDI1Ljc1NzhIMjQuOTk1MyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguOTg2MyAxNS42MTcyTDI0Ljk5NTMgMTUuNjE3MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzAuNzI2NiAzNC41NzgxTDMwLjcyNjYgMzEuNDc4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuMjY3NiAzNC41NzgxTDEzLjI2NzYgMzEuNDc4MiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTkzNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
                },
                {
                    isVisible: Cy.isCapable("ruler") && i.includes("ruler"),
                    click: ()=>(LN.bareshell && y(), d((e1)=>!e1), LN.toggleRulerMode(), void (LN.rulerInstructionShown || r(!0))),
                    buttonActivity: h,
                    icon: NN
                },
                {
                    isVisible: i.includes("scale"),
                    click: ()=>{
                        LN.toggleFov();
                    },
                    buttonActivity: !1,
                    icon: LN.currentFovIcon
                },
                {
                    isVisible: i.includes("rotation"),
                    click: ()=>(f((e1)=>!e1), void LN.toggleAutoRotate()),
                    buttonActivity: p,
                    icon: "data:image/svg+xml;base64,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"
                }
            ], b = "rotation" === n, w = Cy.isCapable("interactive_top_view"), E = x.some((e1)=>e1.isVisible), T = (!b || Ci.isMultiFloor || w) && (E || Ci.isMultiFloor);
            return (0, t.useEffect)(()=>{
                m(i_.roomsVisible), LN.setAutoRotateState(Ci.autoRotatePanarama);
            }, []), T ? t.createElement("div", {
                className: "panel"
            }, t.createElement("div", {
                className: "panel-sidebar"
            }, t.createElement("div", {
                ref: A,
                onWheel: (e1)=>{
                    const t = Math.sign(e1.deltaY);
                    M.scrollTo({
                        top: M.scrollTop + 90 * t,
                        left: 0,
                        behavior: "smooth"
                    });
                },
                className: "panel-sidebar-select-wrapper " + (o.length > 0 ? "panel-sidebar-select-wrapper-visible" : "")
            }, t.createElement("div", {
                className: "panel-sidebar-select"
            }, o.map((e1)=>t.createElement("div", {
                    key: e1.value,
                    className: "panel-sidebar-select-item " + (e1.active ? "panel-sidebar-select-item-active" : ""),
                    onClick: e1.click
                }, e1.label)))), t.createElement("div", {
                className: "panel-sidebar-menu " + (a ? "panel-sidebar-menu-visible" : "")
            }, Ci.isMultiFloor && i.includes("floors") && t.createElement("button", {
                className: "panel-sidebar-menu-item " + (o.length > 0 ? "panel-sidebar-menu-item-active" : ""),
                onClick: ()=>{
                    l(Ci.config.floors.map((e1, t)=>({
                            label: Pi("floor", t + 1),
                            value: t,
                            active: t === Ci.currentFloorIndex,
                            click: ()=>{
                                Ci.setCurrentFloorIndex(t), v();
                            }
                        })));
                }
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM1MDZfODEwNSkiPgo8cGF0aCBkPSJNMTAuOTk4IDI3LjcxNDhMMjIuNDIxMSAzNC4zNzgzTDMzLjg0NDIgMjcuNzE0OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuOTAzODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuOTk4IDIyTDIyLjQyMTEgMjguNjYzNUwzMy44NDQyIDIyIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45MDM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC45OTggMTYuMjg4NUwyMi40MjExIDIyLjk1MTlMMzMuODQ0MiAxNi4yODg1TDIyLjQyMTEgOS42MjVMMTAuOTk4IDE2LjI4ODVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS45MDM4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzUwNl84MTA1Ij4KPHJlY3Qgd2lkdGg9IjQ0IiBoZWlnaHQ9IjQ0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuMDAxOTUzMTIpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==",
                alt: "icon"
            })), Ci.isMultiFloor && t.createElement("div", {
                className: "panel-sidebar-menu-line"
            }), "panorama" === n && x.map((e1, n)=>e1.isVisible && t.createElement("button", {
                    key: n,
                    className: "panel-sidebar-menu-item " + (e1.buttonActivity ? "panel-sidebar-menu-item-active" : ""),
                    onClick: e1.click
                }, t.createElement("img", {
                    src: e1.icon,
                    alt: "icon"
                }))), "rotation" === n && Cy.isCapable("interactive_top_view") && t.createElement("button", {
                className: "panel-sidebar-menu-item " + (g ? "panel-sidebar-menu-item-active" : ""),
                onClick: ()=>{
                    i_.setRoomsVisible(!g), m((e1)=>!e1);
                }
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjUxODggMTguNTA5NlYzNC4zNzUyTTMxLjUxODggMzQuMzc1MkwzNC42OTE5IDMxLjEzTTMxLjUxODggMzQuMzc1MkwyOC4zNDU3IDMxLjEzTTMxLjUxODggMzEuMjAyMUwzMS41MTg4IDE3Ljg3NU0zMS41MTg4IDE3Ljg3NUwyOC4zNDU3IDIxLjAzMTRNMzEuNTE4OCAxNy44NzVMMzQuNjkxOSAyMS4wMzE0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS42NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljk0MzIyIDEyLjc5ODFMMjUuODA4OCAxMi43OTgxTTI1LjgwODggMTIuNzk4MUwyMi41NjM1IDkuNjI1TTI1LjgwODggMTIuNzk4MUwyMi41NjM1IDE1Ljk3MTJNMjIuNjM1NyAxMi43OTgxSDkuMzA4NTlNOS4zMDg1OSAxMi43OTgxTDEyLjQ2NSAxNS45NzEyTTkuMzA4NTkgMTIuNzk4MUwxMi40NjUgOS42MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjY1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI0LjYxNTcgMzQuMDYwN0g5Ljk0MzM1QzkuODAzMTUgMzQuMDYwNyA5LjY4OTUgMzMuOTQ3MSA5LjY4OTUgMzMuODA2OUw5LjY4OTQ1IDE5LjM5NDVDOS42ODk0NSAxOS4yNTQzIDkuODAzMSAxOS4xNDA2IDkuOTQzMyAxOS4xNDA2SDI0LjYxNTdDMjQuNzU1OSAxOS4xNDA2IDI0Ljg2OTUgMTkuMjU0MyAyNC44Njk1IDE5LjM5NDVWMzMuODA2OUMyNC44Njk1IDMzLjk0NzEgMjQuNzU1OSAzNC4wNjA3IDI0LjYxNTcgMzQuMDYwN1oiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjY1Ii8+Cjwvc3ZnPgo=",
                alt: "icon"
            })), "rotation" === n && Cy.isCapable("interactive_top_view") && t.createElement("div", {
                className: "panel-sidebar-menu-line"
            }), t.createElement("button", {
                className: "panel-sidebar-menu-item",
                onClick: v
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTYwNTUgNC4xMjg5MUwxNC40MzU1IDExLjAwMzlMNy41NjA1NSAxNy44Nzg5IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi4wNjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "icon"
            }))), t.createElement("button", {
                className: "panel-sidebar-menu-toggle " + (a ? "" : "panel-sidebar-menu-toggle-visible"),
                onClick: ()=>{
                    s(!0);
                }
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjQzNzUgMTcuODc1TDcuNTYyNSAxMUwxNC40Mzc1IDQuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi4wNjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "icon"
            })))) : null;
        }), tC = eC, nC = WN(()=>{
            const [e1, n] = (0, t.useState)(!1), i = (e1)=>Pi("floor", e1), r = Ci.config.floors.map((e1, t)=>({
                    label: i(t + 1),
                    value: t,
                    class: "floors-select--block-item",
                    classActive: "floors-select--block-item floors-select--block-item--active"
                }));
            return (0, t.useEffect)(()=>{
                document.addEventListener("click", (e1)=>{
                    e1.target.closest(".floors-select") || n(!1);
                });
            }, []), r.length <= 1 ? null : t.createElement("div", {
                id: "floors-select",
                onClick: ()=>n(!e1),
                className: "floors-select"
            }, t.createElement("div", {
                className: "floors-select--text"
            }, i(Ci.currentFloorIndex + 1)), e1 && t.createElement("div", {
                className: "floors-select--block"
            }, r.map((e1)=>t.createElement("div", {
                    key: e1.value,
                    onClick: ()=>((e1)=>{
                            let { value: t } = e1;
                            Ci.setCurrentFloorIndex(t), n(!1);
                        })(e1),
                    className: Ci.currentFloorIndex === e1.value ? e1.classActive : e1.class
                }, e1.label))));
        }), iC = nC, rC = WN(()=>{
            const { config: e1 } = Ci, n = {
                width: e1.width,
                height: e1.height,
                "--main-color": e1.colors.main,
                "--main-text": e1.colors.mainText
            }, [i, r] = (0, t.useState)(e1.tabs[0]), [a, s] = (0, t.useState)(!1), o = (()=>{
                switch(Ci.config.designType){
                    case "standard":
                        return [];
                    case "sidebar":
                        return [
                            "floors",
                            "ruler",
                            "scale",
                            "rotation",
                            "furniture"
                        ];
                    default:
                        return Ci.config.sidebarContent;
                }
            })(), l = (()=>{
                switch(Ci.config.designType){
                    case "standard":
                        return [
                            "floors",
                            "ruler",
                            "scale",
                            "rotation",
                            "furniture"
                        ];
                    case "sidebar":
                        return [];
                    default:
                        return Ci.config.bottombarContent;
                }
            })(), c = {
                plan: t.createElement(V_, {
                    planImage: e1.planImage,
                    key: "plan"
                }),
                panorama: t.createElement(G_, {
                    disabled: !e1.panoramaData || !e1.panoramaData.items.length,
                    items: e1.panoramaData?.items || [],
                    type: e1.panoramaData?.type || "sphere",
                    showRulerInstructions: a,
                    setRulerInstructionsState: s,
                    bottomButtons: l
                }),
                rotation: t.createElement(l_, {
                    disabled: !e1.rotationData || !e1.rotationData.items.length,
                    planImage: e1.planImage,
                    topView: e1.topViewImage,
                    images: (h = e1.rotationData?.items || [], h.find((e1)=>Rx(e1)) ? h.filter((e1)=>Rx(e1)) : h),
                    masks: (u = e1.rotationData?.items || [], Cy.isCapable("interactive_top_view") ? [
                        e1.topViewImage,
                        ...u.filter((e1)=>!Rx(e1))
                    ].map((e1)=>e1.replace(/\.(png|jpe?g|webp)/, "_RoomIDs.exr")) : []),
                    type: e1.rotationData?.type || "top_down",
                    mode: e1.rotationMode,
                    key: "area"
                })
            };
            var u, h;
            const d = [
                {
                    tab: "rotation",
                    img: "three" === Ci.config.tabsButtonsDesign ? W_ : Q_
                },
                {
                    tab: "panorama",
                    img: "three" === Ci.config.tabsButtonsDesign ? "data:image/svg+xml;base64,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" : W_
                }
            ];
            "three" === Ci.config.tabsButtonsDesign && d.unshift({
                tab: "plan",
                img: Q_
            }), (0, t.useEffect)(()=>{
                Zi.init(), null == i_.roomsVisible && i_.setRoomsVisible(Cy.isCapable("interactive_top_view"));
            }, []), (0, t.useEffect)(()=>{
                e1.tabs.some((e1)=>e1 === i) || r(e1.tabs[0]);
            }, [
                e1,
                i
            ]);
            const p = !!l?.includes("floors");
            var f;
            return t.createElement("main", {
                className: (f = e1.width, XN.keys(ZN).filter((e1)=>f <= ZN[e1])).reduce((e1, t)=>e1 + ` widget-application--${t}`, `widget-application widget-application--${e1.tabsButtonsDesign} widget-application--${e1.designType}`),
                id: "widget-application",
                style: n
            }, t.createElement("section", {
                className: `widget-tab widget-tab--${i}`
            }, c[i], "standard" !== Ci.config.designType && 0 !== o.length && t.createElement(tC, {
                currentTab: i,
                buttons: o,
                setRulerInstructionsState: s
            })), e1.logo && t.createElement("a", {
                href: e1.branding?.url || e1.logoUrl,
                className: "widget-logo",
                target: "_blank",
                rel: "noreferrer"
            }, t.createElement("img", {
                src: e1.logo,
                alt: "logo"
            })), Ci.controlsVisible && t.createElement(KN, null), t.createElement("div", {
                className: "widget-tab-buttons"
            }, d.map((n, a)=>!Ci.isTabIncluded(n.tab) || e1.tabs.length < 2 ? null : Ci.controlsVisible ? t.createElement($N, {
                    key: a,
                    img: n.img,
                    active: i === n.tab,
                    onClick: ()=>r(n.tab)
                }) : null), "panorama" === i && LN.vrSessionSupported && LN.currentPanorama && !gx.isMobileDevice && t.createElement(JN, null)), "rotation" === i && i_.roomsVisible && "three" === Ci.config.tabsButtonsDesign && t.createElement($_, null), t.createElement("div", {
                className: "widget-watermark-button"
            }, t.createElement(eD, {
                href: e1.branding ? e1.branding.url : (()=>{
                    const e1 = Pi("made-by-link");
                    return "en" === Di.currentLocale ? e1 + "?utm_source=widget&utm_medium=widget" : e1;
                })(),
                text: e1.branding ? e1.branding.name : Pi("made-by-text")
            })), p && t.createElement(iC, null));
        }), aC = "8.34.0", sC = globalThis;
        function oC(e1, t, n) {
            const i = n || sC, r = i.__SENTRY__ = i.__SENTRY__ || {}, a = r[aC] = r[aC] || {};
            return a[e1] || (a[e1] = t());
        }
        const lC = "production";
        function cC() {
            return uC(sC), sC;
        }
        function uC(e1) {
            const t = e1.__SENTRY__ = e1.__SENTRY__ || {};
            return t.version = t.version || aC, t[aC] = t[aC] || {};
        }
        const hC = Object.prototype.toString;
        function dC(e1) {
            switch(hC.call(e1)){
                case "[object Error]":
                case "[object Exception]":
                case "[object DOMException]":
                case "[object WebAssembly.Exception]":
                    return !0;
                default:
                    return bC(e1, Error);
            }
        }
        function pC(e1, t) {
            return hC.call(e1) === `[object ${t}]`;
        }
        function fC(e1) {
            return pC(e1, "ErrorEvent");
        }
        function gC(e1) {
            return pC(e1, "DOMError");
        }
        function mC(e1) {
            return pC(e1, "String");
        }
        function AC(e1) {
            return "object" == typeof e1 && null !== e1 && "__sentry_template_string__" in e1 && "__sentry_template_values__" in e1;
        }
        function MC(e1) {
            return null === e1 || AC(e1) || "object" != typeof e1 && "function" != typeof e1;
        }
        function vC(e1) {
            return pC(e1, "Object");
        }
        function yC(e1) {
            return "undefined" != typeof Event && bC(e1, Event);
        }
        function xC(e1) {
            return Boolean(e1 && e1.then && "function" == typeof e1.then);
        }
        function bC(e1, t) {
            try {
                return e1 instanceof t;
            } catch (e1) {
                return !1;
            }
        }
        function wC(e1) {
            return !("object" != typeof e1 || null === e1 || !e1.__isVue && !e1._isVue);
        }
        const EC = sC, TC = 80;
        function SC(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!e1) return "<unknown>";
            try {
                let n = e1;
                const i = 5, r = [];
                let a = 0, s = 0;
                const o = " > ", l = o.length;
                let c;
                const u = Array.isArray(t) ? t : t.keyAttrs, h = !Array.isArray(t) && t.maxStringLength || TC;
                for(; n && a++ < i && (c = IC(n, u), !("html" === c || a > 1 && s + r.length * l + c.length >= h));)r.push(c), s += c.length, n = n.parentNode;
                return r.reverse().join(o);
            } catch (e1) {
                return "<unknown>";
            }
        }
        function IC(e1, t) {
            const n = e1, i = [];
            if (!n || !n.tagName) return "";
            if (EC.HTMLElement && n instanceof HTMLElement && n.dataset) {
                if (n.dataset.sentryComponent) return n.dataset.sentryComponent;
                if (n.dataset.sentryElement) return n.dataset.sentryElement;
            }
            i.push(n.tagName.toLowerCase());
            const r = t && t.length ? t.filter((e1)=>n.getAttribute(e1)).map((e1)=>[
                    e1,
                    n.getAttribute(e1)
                ]) : null;
            if (r && r.length) r.forEach((e1)=>{
                i.push(`[${e1[0]}="${e1[1]}"]`);
            });
            else {
                n.id && i.push(`#${n.id}`);
                const e1 = n.className;
                if (e1 && mC(e1)) {
                    const t = e1.split(/\s+/);
                    for (const e1 of t)i.push(`.${e1}`);
                }
            }
            const a = [
                "aria-label",
                "type",
                "name",
                "title",
                "alt"
            ];
            for (const e1 of a){
                const t = n.getAttribute(e1);
                t && i.push(`[${e1}="${t}"]`);
            }
            return i.join("");
        }
        const NC = "undefined" == typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__, DC = [
            "debug",
            "info",
            "warn",
            "error",
            "log",
            "assert",
            "trace"
        ], _C = {};
        function CC(e1) {
            if (!("console" in sC)) return e1();
            const t = sC.console, n = {}, i = Object.keys(_C);
            i.forEach((e1)=>{
                const i = _C[e1];
                n[e1] = t[e1], t[e1] = i;
            });
            try {
                return e1();
            } finally{
                i.forEach((e1)=>{
                    t[e1] = n[e1];
                });
            }
        }
        const LC = oC("logger", function() {
            let e1 = !1;
            const t = {
                enable: ()=>{
                    e1 = !0;
                },
                disable: ()=>{
                    e1 = !1;
                },
                isEnabled: ()=>e1
            };
            return NC ? DC.forEach((n)=>{
                t[n] = function() {
                    for(var t = arguments.length, i = new Array(t), r = 0; r < t; r++)i[r] = arguments[r];
                    e1 && CC(()=>{
                        sC.console[n](`Sentry Logger [${n}]:`, ...i);
                    });
                };
            }) : DC.forEach((e1)=>{
                t[e1] = ()=>{};
            }), t;
        });
        function zC(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return "string" != typeof e1 || 0 === t || e1.length <= t ? e1 : `${e1.slice(0, t)}...`;
        }
        function OC(e1, t) {
            if (!Array.isArray(e1)) return "";
            const n = [];
            for(let t = 0; t < e1.length; t++){
                const i = e1[t];
                try {
                    wC(i) ? n.push("[VueViewModel]") : n.push(String(i));
                } catch (e1) {
                    n.push("[value cannot be serialized]");
                }
            }
            return n.join(t);
        }
        function RC(e1) {
            let t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : []).some((n)=>(function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    return !!mC(e1) && (pC(t, "RegExp") ? t.test(e1) : !!mC(t) && (n ? e1 === t : e1.includes(t)));
                })(e1, n, t));
        }
        function PC(e1, t, n) {
            if (!(t in e1)) return;
            const i = e1[t], r = n(i);
            "function" == typeof r && jC(r, i), e1[t] = r;
        }
        function UC(e1, t, n) {
            try {
                Object.defineProperty(e1, t, {
                    value: n,
                    writable: !0,
                    configurable: !0
                });
            } catch (n) {
                NC && LC.log(`Failed to add non-enumerable property "${t}" to object`, e1);
            }
        }
        function jC(e1, t) {
            try {
                const n = t.prototype || {};
                e1.prototype = t.prototype = n, UC(e1, "__sentry_original__", t);
            } catch (e1) {}
        }
        function kC(e1) {
            return e1.__sentry_original__;
        }
        function BC(e1) {
            if (dC(e1)) return {
                message: e1.message,
                name: e1.name,
                stack: e1.stack,
                ...HC(e1)
            };
            if (yC(e1)) {
                const t = {
                    type: e1.type,
                    target: FC(e1.target),
                    currentTarget: FC(e1.currentTarget),
                    ...HC(e1)
                };
                return "undefined" != typeof CustomEvent && bC(e1, CustomEvent) && (t.detail = e1.detail), t;
            }
            return e1;
        }
        function FC(e1) {
            try {
                return "undefined" != typeof Element && bC(e1, Element) ? SC(e1) : Object.prototype.toString.call(e1);
            } catch (e1) {
                return "<unknown>";
            }
        }
        function HC(e1) {
            if ("object" == typeof e1 && null !== e1) {
                const t = {};
                for(const n in e1)Object.prototype.hasOwnProperty.call(e1, n) && (t[n] = e1[n]);
                return t;
            }
            return {};
        }
        function GC(e1) {
            return VC(e1, new Map);
        }
        function VC(e1, t) {
            if (function(e1) {
                if (!vC(e1)) return !1;
                try {
                    const t = Object.getPrototypeOf(e1).constructor.name;
                    return !t || "Object" === t;
                } catch (e1) {
                    return !0;
                }
            }(e1)) {
                const n = t.get(e1);
                if (void 0 !== n) return n;
                const i = {};
                t.set(e1, i);
                for (const n of Object.getOwnPropertyNames(e1))void 0 !== e1[n] && (i[n] = VC(e1[n], t));
                return i;
            }
            if (Array.isArray(e1)) {
                const n = t.get(e1);
                if (void 0 !== n) return n;
                const i = [];
                return t.set(e1, i), e1.forEach((e1)=>{
                    i.push(VC(e1, t));
                }), i;
            }
            return e1;
        }
        function QC() {
            const e1 = sC, t = e1.crypto || e1.msCrypto;
            let n = ()=>16 * Math.random();
            try {
                if (t && t.randomUUID) return t.randomUUID().replace(/-/g, "");
                t && t.getRandomValues && (n = ()=>{
                    const e1 = new Uint8Array(1);
                    return t.getRandomValues(e1), e1[0];
                });
            } catch (e1) {}
            return "10000000100040008000100000000000".replace(/[018]/g, (e1)=>(e1 ^ (15 & n()) >> e1 / 4).toString(16));
        }
        function WC(e1) {
            return e1.exception && e1.exception.values ? e1.exception.values[0] : void 0;
        }
        function YC(e1) {
            const { message: t, event_id: n } = e1;
            if (t) return t;
            const i = WC(e1);
            return i ? i.type && i.value ? `${i.type}: ${i.value}` : i.type || i.value || n || "<unknown>" : n || "<unknown>";
        }
        function XC(e1, t, n) {
            const i = e1.exception = e1.exception || {}, r = i.values = i.values || [], a = r[0] = r[0] || {};
            a.value || (a.value = t || ""), a.type || (a.type = n || "Error");
        }
        function ZC(e1, t) {
            const n = WC(e1);
            if (!n) return;
            const i = n.mechanism;
            if (n.mechanism = {
                type: "generic",
                handled: !0,
                ...i,
                ...t
            }, t && "data" in t) {
                const e1 = {
                    ...i && i.data,
                    ...t.data
                };
                n.mechanism.data = e1;
            }
        }
        function qC(e1) {
            if (e1 && e1.__sentry_captured__) return !0;
            try {
                UC(e1, "__sentry_captured__", !0);
            } catch (e1) {}
            return !1;
        }
        function KC(e1) {
            return Array.isArray(e1) ? e1 : [
                e1
            ];
        }
        function JC() {
            return {
                traceId: QC(),
                spanId: QC().substring(16)
            };
        }
        const $C = 1e3;
        function eL() {
            return Date.now() / $C;
        }
        const tL = function() {
            const { performance: e1 } = sC;
            if (!e1 || !e1.now) return eL;
            const t = Date.now() - e1.now(), n = null == e1.timeOrigin ? t : e1.timeOrigin;
            return ()=>(n + e1.now()) / $C;
        }();
        let nL;
        function iL(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (t.user && (!e1.ipAddress && t.user.ip_address && (e1.ipAddress = t.user.ip_address), e1.did || t.did || (e1.did = t.user.id || t.user.email || t.user.username)), e1.timestamp = t.timestamp || tL(), t.abnormal_mechanism && (e1.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e1.ignoreDuration = t.ignoreDuration), t.sid && (e1.sid = 32 === t.sid.length ? t.sid : QC()), void 0 !== t.init && (e1.init = t.init), !e1.did && t.did && (e1.did = `${t.did}`), "number" == typeof t.started && (e1.started = t.started), e1.ignoreDuration) e1.duration = void 0;
            else if ("number" == typeof t.duration) e1.duration = t.duration;
            else {
                const t = e1.timestamp - e1.started;
                e1.duration = t >= 0 ? t : 0;
            }
            t.release && (e1.release = t.release), t.environment && (e1.environment = t.environment), !e1.ipAddress && t.ipAddress && (e1.ipAddress = t.ipAddress), !e1.userAgent && t.userAgent && (e1.userAgent = t.userAgent), "number" == typeof t.errors && (e1.errors = t.errors), t.status && (e1.status = t.status);
        }
        (()=>{
            const { performance: e1 } = sC;
            if (!e1 || !e1.now) return void (nL = "none");
            const t = 36e5, n = e1.now(), i = Date.now(), r = e1.timeOrigin ? Math.abs(e1.timeOrigin + n - i) : t, a = r < t, s = e1.timing && e1.timing.navigationStart, o = "number" == typeof s ? Math.abs(s + n - i) : t;
            a || o < t ? r <= o ? (nL = "timeOrigin", e1.timeOrigin) : nL = "navigationStart" : nL = "dateNow";
        })();
        const rL = "_sentrySpan";
        function aL(e1, t) {
            t ? UC(e1, rL, t) : delete e1[rL];
        }
        function sL(e1) {
            return e1[rL];
        }
        class oL {
            constructor(){
                this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = JC();
            }
            clone() {
                const e1 = new oL;
                return e1._breadcrumbs = [
                    ...this._breadcrumbs
                ], e1._tags = {
                    ...this._tags
                }, e1._extra = {
                    ...this._extra
                }, e1._contexts = {
                    ...this._contexts
                }, e1._user = this._user, e1._level = this._level, e1._session = this._session, e1._transactionName = this._transactionName, e1._fingerprint = this._fingerprint, e1._eventProcessors = [
                    ...this._eventProcessors
                ], e1._requestSession = this._requestSession, e1._attachments = [
                    ...this._attachments
                ], e1._sdkProcessingMetadata = {
                    ...this._sdkProcessingMetadata
                }, e1._propagationContext = {
                    ...this._propagationContext
                }, e1._client = this._client, e1._lastEventId = this._lastEventId, aL(e1, sL(this)), e1;
            }
            setClient(e1) {
                this._client = e1;
            }
            setLastEventId(e1) {
                this._lastEventId = e1;
            }
            getClient() {
                return this._client;
            }
            lastEventId() {
                return this._lastEventId;
            }
            addScopeListener(e1) {
                this._scopeListeners.push(e1);
            }
            addEventProcessor(e1) {
                return this._eventProcessors.push(e1), this;
            }
            setUser(e1) {
                return this._user = e1 || {
                    email: void 0,
                    id: void 0,
                    ip_address: void 0,
                    username: void 0
                }, this._session && iL(this._session, {
                    user: e1
                }), this._notifyScopeListeners(), this;
            }
            getUser() {
                return this._user;
            }
            getRequestSession() {
                return this._requestSession;
            }
            setRequestSession(e1) {
                return this._requestSession = e1, this;
            }
            setTags(e1) {
                return this._tags = {
                    ...this._tags,
                    ...e1
                }, this._notifyScopeListeners(), this;
            }
            setTag(e1, t) {
                return this._tags = {
                    ...this._tags,
                    [e1]: t
                }, this._notifyScopeListeners(), this;
            }
            setExtras(e1) {
                return this._extra = {
                    ...this._extra,
                    ...e1
                }, this._notifyScopeListeners(), this;
            }
            setExtra(e1, t) {
                return this._extra = {
                    ...this._extra,
                    [e1]: t
                }, this._notifyScopeListeners(), this;
            }
            setFingerprint(e1) {
                return this._fingerprint = e1, this._notifyScopeListeners(), this;
            }
            setLevel(e1) {
                return this._level = e1, this._notifyScopeListeners(), this;
            }
            setTransactionName(e1) {
                return this._transactionName = e1, this._notifyScopeListeners(), this;
            }
            setContext(e1, t) {
                return null === t ? delete this._contexts[e1] : this._contexts[e1] = t, this._notifyScopeListeners(), this;
            }
            setSession(e1) {
                return e1 ? this._session = e1 : delete this._session, this._notifyScopeListeners(), this;
            }
            getSession() {
                return this._session;
            }
            update(e1) {
                if (!e1) return this;
                const t = "function" == typeof e1 ? e1(this) : e1, [n, i] = t instanceof lL ? [
                    t.getScopeData(),
                    t.getRequestSession()
                ] : vC(t) ? [
                    e1,
                    e1.requestSession
                ] : [], { tags: r, extra: a, user: s, contexts: o, level: l, fingerprint: c = [], propagationContext: u } = n || {};
                return this._tags = {
                    ...this._tags,
                    ...r
                }, this._extra = {
                    ...this._extra,
                    ...a
                }, this._contexts = {
                    ...this._contexts,
                    ...o
                }, s && Object.keys(s).length && (this._user = s), l && (this._level = l), c.length && (this._fingerprint = c), u && (this._propagationContext = u), i && (this._requestSession = i), this;
            }
            clear() {
                return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, aL(this, void 0), this._attachments = [], this._propagationContext = JC(), this._notifyScopeListeners(), this;
            }
            addBreadcrumb(e1, t) {
                const n = "number" == typeof t ? t : 100;
                if (n <= 0) return this;
                const i = {
                    timestamp: eL(),
                    ...e1
                }, r = this._breadcrumbs;
                return r.push(i), this._breadcrumbs = r.length > n ? r.slice(-n) : r, this._notifyScopeListeners(), this;
            }
            getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
            clearBreadcrumbs() {
                return this._breadcrumbs = [], this._notifyScopeListeners(), this;
            }
            addAttachment(e1) {
                return this._attachments.push(e1), this;
            }
            clearAttachments() {
                return this._attachments = [], this;
            }
            getScopeData() {
                return {
                    breadcrumbs: this._breadcrumbs,
                    attachments: this._attachments,
                    contexts: this._contexts,
                    tags: this._tags,
                    extra: this._extra,
                    user: this._user,
                    level: this._level,
                    fingerprint: this._fingerprint || [],
                    eventProcessors: this._eventProcessors,
                    propagationContext: this._propagationContext,
                    sdkProcessingMetadata: this._sdkProcessingMetadata,
                    transactionName: this._transactionName,
                    span: sL(this)
                };
            }
            setSDKProcessingMetadata(e1) {
                return this._sdkProcessingMetadata = {
                    ...this._sdkProcessingMetadata,
                    ...e1
                }, this;
            }
            setPropagationContext(e1) {
                return this._propagationContext = e1, this;
            }
            getPropagationContext() {
                return this._propagationContext;
            }
            captureException(e1, t) {
                const n = t && t.event_id ? t.event_id : QC();
                if (!this._client) return LC.warn("No client configured on scope - will not capture exception!"), n;
                const i = new Error("Sentry syntheticException");
                return this._client.captureException(e1, {
                    originalException: e1,
                    syntheticException: i,
                    ...t,
                    event_id: n
                }, this), n;
            }
            captureMessage(e1, t, n) {
                const i = n && n.event_id ? n.event_id : QC();
                if (!this._client) return LC.warn("No client configured on scope - will not capture message!"), i;
                const r = new Error(e1);
                return this._client.captureMessage(e1, t, {
                    originalException: e1,
                    syntheticException: r,
                    ...n,
                    event_id: i
                }, this), i;
            }
            captureEvent(e1, t) {
                const n = t && t.event_id ? t.event_id : QC();
                return this._client ? (this._client.captureEvent(e1, {
                    ...t,
                    event_id: n
                }, this), n) : (LC.warn("No client configured on scope - will not capture event!"), n);
            }
            _notifyScopeListeners() {
                this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e1)=>{
                    e1(this);
                }), this._notifyingListeners = !1);
            }
        }
        const lL = oL;
        class cL {
            constructor(e1, t){
                let n, i;
                n = e1 || new lL, i = t || new lL, this._stack = [
                    {
                        scope: n
                    }
                ], this._isolationScope = i;
            }
            withScope(e1) {
                const t = this._pushScope();
                let n;
                try {
                    n = e1(t);
                } catch (e1) {
                    throw this._popScope(), e1;
                }
                return xC(n) ? n.then((e1)=>(this._popScope(), e1), (e1)=>{
                    throw this._popScope(), e1;
                }) : (this._popScope(), n);
            }
            getClient() {
                return this.getStackTop().client;
            }
            getScope() {
                return this.getStackTop().scope;
            }
            getIsolationScope() {
                return this._isolationScope;
            }
            getStackTop() {
                return this._stack[this._stack.length - 1];
            }
            _pushScope() {
                const e1 = this.getScope().clone();
                return this._stack.push({
                    client: this.getClient(),
                    scope: e1
                }), e1;
            }
            _popScope() {
                return !(this._stack.length <= 1 || !this._stack.pop());
            }
        }
        function uL() {
            const e1 = uC(cC());
            return e1.stack = e1.stack || new cL(oC("defaultCurrentScope", ()=>new lL), oC("defaultIsolationScope", ()=>new lL));
        }
        function hL(e1) {
            return uL().withScope(e1);
        }
        function dL(e1, t) {
            const n = uL();
            return n.withScope(()=>(n.getStackTop().scope = e1, t(e1)));
        }
        function pL(e1) {
            return uL().withScope(()=>e1(uL().getIsolationScope()));
        }
        function fL(e1) {
            const t = uC(e1);
            return t.acs ? t.acs : {
                withIsolationScope: pL,
                withScope: hL,
                withSetScope: dL,
                withSetIsolationScope: (e1, t)=>pL(t),
                getCurrentScope: ()=>uL().getScope(),
                getIsolationScope: ()=>uL().getIsolationScope()
            };
        }
        function gL() {
            return fL(cC()).getCurrentScope();
        }
        function mL() {
            return fL(cC()).getIsolationScope();
        }
        function AL() {
            return gL().getClient();
        }
        const ML = 50, vL = "?", yL = /\(error: (.*)\)/, xL = /captureMessage|captureException/;
        function bL() {
            for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
            const i = t.sort((e1, t)=>e1[0] - t[0]).map((e1)=>e1[1]);
            return function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                const r = [], a = e1.split("\n");
                for(let e1 = t; e1 < a.length; e1++){
                    const t = a[e1];
                    if (t.length > 1024) continue;
                    const s = yL.test(t) ? t.replace(yL, "$1") : t;
                    if (!s.match(/\S*Error: /)) {
                        for (const e1 of i){
                            const t = e1(s);
                            if (t) {
                                r.push(t);
                                break;
                            }
                        }
                        if (r.length >= ML + n) break;
                    }
                }
                return function(e1) {
                    if (!e1.length) return [];
                    const t = Array.from(e1);
                    return /sentryWrapped/.test(wL(t).function || "") && t.pop(), t.reverse(), xL.test(wL(t).function || "") && (t.pop(), xL.test(wL(t).function || "") && t.pop()), t.slice(0, ML).map((e1)=>({
                            ...e1,
                            filename: e1.filename || wL(t).filename,
                            function: e1.function || vL
                        }));
                }(r.slice(n));
            };
        }
        function wL(e1) {
            return e1[e1.length - 1] || {};
        }
        const EL = "<anonymous>";
        function TL(e1) {
            try {
                return e1 && "function" == typeof e1 && e1.name || EL;
            } catch (e1) {
                return EL;
            }
        }
        function SL(e1) {
            const t = e1.exception;
            if (t) {
                const e1 = [];
                try {
                    return t.values.forEach((t)=>{
                        t.stacktrace.frames && e1.push(...t.stacktrace.frames);
                    }), e1;
                } catch (e1) {
                    return;
                }
            }
        }
        function IL(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0;
            try {
                return DL("", e1, t, n);
            } catch (e1) {
                return {
                    ERROR: `**non-serializable** (${e1})`
                };
            }
        }
        function NL(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 102400;
            const i = IL(e1, t);
            var r;
            return r = i, function(e1) {
                return ~-encodeURI(e1).split(/%..|./).length;
            }(JSON.stringify(r)) > n ? NL(e1, t - 1, n) : i;
        }
        function DL(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : function() {
                const e1 = "function" == typeof WeakSet, t = e1 ? new WeakSet : [];
                return [
                    function(n) {
                        if (e1) return !!t.has(n) || (t.add(n), !1);
                        for(let e1 = 0; e1 < t.length; e1++)if (t[e1] === n) return !0;
                        return t.push(n), !1;
                    },
                    function(n) {
                        if (e1) t.delete(n);
                        else for(let e1 = 0; e1 < t.length; e1++)if (t[e1] === n) {
                            t.splice(e1, 1);
                            break;
                        }
                    }
                ];
            }();
            const [a, s] = r;
            if (null == t || [
                "boolean",
                "string"
            ].includes(typeof t) || "number" == typeof t && Number.isFinite(t)) return t;
            const o = function(e1, t) {
                try {
                    if ("domain" === e1 && t && "object" == typeof t && t._events) return "[Domain]";
                    if ("domainEmitter" === e1) return "[DomainEmitter]";
                    if ("undefined" != typeof $parcel$global && t === $parcel$global) return "[Global]";
                    if ("undefined" != typeof window && t === window) return "[Window]";
                    if ("undefined" != typeof document && t === document) return "[Document]";
                    if (wC(t)) return "[VueViewModel]";
                    if (vC(n = t) && "nativeEvent" in n && "preventDefault" in n && "stopPropagation" in n) return "[SyntheticEvent]";
                    if ("number" == typeof t && !Number.isFinite(t)) return `[${t}]`;
                    if ("function" == typeof t) return `[Function: ${TL(t)}]`;
                    if ("symbol" == typeof t) return `[${String(t)}]`;
                    if ("bigint" == typeof t) return `[BigInt: ${String(t)}]`;
                    const i = function(e1) {
                        const t = Object.getPrototypeOf(e1);
                        return t ? t.constructor.name : "null prototype";
                    }(t);
                    return /^HTML(\w*)Element$/.test(i) ? `[HTMLElement: ${i}]` : `[object ${i}]`;
                } catch (e1) {
                    return `**non-serializable** (${e1})`;
                }
                var n;
            }(e1, t);
            if (!o.startsWith("[object ")) return o;
            if (t.__sentry_skip_normalization__) return t;
            const l = "number" == typeof t.__sentry_override_normalization_depth__ ? t.__sentry_override_normalization_depth__ : n;
            if (0 === l) return o.replace("object ", "");
            if (a(t)) return "[Circular ~]";
            const c = t;
            if (c && "function" == typeof c.toJSON) try {
                return DL("", c.toJSON(), l - 1, i, r);
            } catch (e1) {}
            const u = Array.isArray(t) ? [] : {};
            let h = 0;
            const d = BC(t);
            for(const e1 in d){
                if (!Object.prototype.hasOwnProperty.call(d, e1)) continue;
                if (h >= i) {
                    u[e1] = "[MaxProperties ~]";
                    break;
                }
                const t = d[e1];
                u[e1] = DL(e1, t, l - 1, i, r), h++;
            }
            return s(t), u;
        }
        var _L;
        function CL(e1) {
            return new zL((t)=>{
                t(e1);
            });
        }
        function LL(e1) {
            return new zL((t, n)=>{
                n(e1);
            });
        }
        !function(e1) {
            e1[e1.PENDING = 0] = "PENDING", e1[e1.RESOLVED = 1] = "RESOLVED", e1[e1.REJECTED = 2] = "REJECTED";
        }(_L || (_L = {}));
        class zL {
            constructor(e1){
                zL.prototype.__init.call(this), zL.prototype.__init2.call(this), zL.prototype.__init3.call(this), zL.prototype.__init4.call(this), this._state = _L.PENDING, this._handlers = [];
                try {
                    e1(this._resolve, this._reject);
                } catch (e1) {
                    this._reject(e1);
                }
            }
            then(e1, t) {
                return new zL((n, i)=>{
                    this._handlers.push([
                        !1,
                        (t)=>{
                            if (e1) try {
                                n(e1(t));
                            } catch (e1) {
                                i(e1);
                            }
                            else n(t);
                        },
                        (e1)=>{
                            if (t) try {
                                n(t(e1));
                            } catch (e1) {
                                i(e1);
                            }
                            else i(e1);
                        }
                    ]), this._executeHandlers();
                });
            }
            catch(e1) {
                return this.then((e1)=>e1, e1);
            }
            finally(e1) {
                return new zL((t, n)=>{
                    let i, r;
                    return this.then((t)=>{
                        r = !1, i = t, e1 && e1();
                    }, (t)=>{
                        r = !0, i = t, e1 && e1();
                    }).then(()=>{
                        r ? n(i) : t(i);
                    });
                });
            }
            __init() {
                this._resolve = (e1)=>{
                    this._setResult(_L.RESOLVED, e1);
                };
            }
            __init2() {
                this._reject = (e1)=>{
                    this._setResult(_L.REJECTED, e1);
                };
            }
            __init3() {
                this._setResult = (e1, t)=>{
                    this._state === _L.PENDING && (xC(t) ? t.then(this._resolve, this._reject) : (this._state = e1, this._value = t, this._executeHandlers()));
                };
            }
            __init4() {
                this._executeHandlers = ()=>{
                    if (this._state === _L.PENDING) return;
                    const e1 = this._handlers.slice();
                    this._handlers = [], e1.forEach((e1)=>{
                        e1[0] || (this._state === _L.RESOLVED && e1[1](this._value), this._state === _L.REJECTED && e1[2](this._value), e1[0] = !0);
                    });
                };
            }
        }
        const OL = "undefined" == typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__;
        function RL(e1, t, n) {
            let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
            return new zL((r, a)=>{
                const s = e1[i];
                if (null === t || "function" != typeof s) r(t);
                else {
                    const o = s({
                        ...t
                    }, n);
                    OL && s.id && null === o && LC.log(`Event processor "${s.id}" dropped event`), xC(o) ? o.then((t)=>RL(e1, t, n, i + 1).then(r)).then(null, a) : RL(e1, o, n, i + 1).then(r).then(null, a);
                }
            });
        }
        const PL = "sentry-", UL = /^sentry-/;
        function jL(e1) {
            return e1.split(",").map((e1)=>e1.split("=").map((e1)=>decodeURIComponent(e1.trim()))).reduce((e1, t)=>{
                let [n, i] = t;
                return n && i && (e1[n] = i), e1;
            }, {});
        }
        const kL = "sentry.source", BL = "sentry.sample_rate", FL = "sentry.op", HL = "sentry.origin", GL = "_sentryMetrics";
        function VL(e1) {
            const t = e1[GL];
            if (!t) return;
            const n = {};
            for (const [, [e1, i]] of t)(n[e1] || (n[e1] = [])).push(GC(i));
            return n;
        }
        const QL = 0, WL = 1, YL = 1;
        function XL(e1) {
            const { spanId: t, traceId: n } = e1.spanContext(), { parent_span_id: i } = KL(e1);
            return GC({
                parent_span_id: i,
                span_id: t,
                trace_id: n
            });
        }
        function ZL(e1) {
            return "number" == typeof e1 ? qL(e1) : Array.isArray(e1) ? e1[0] + e1[1] / 1e9 : e1 instanceof Date ? qL(e1.getTime()) : tL();
        }
        function qL(e1) {
            return e1 > 9999999999 ? e1 / 1e3 : e1;
        }
        function KL(e1) {
            if (function(e1) {
                return "function" == typeof e1.getSpanJSON;
            }(e1)) return e1.getSpanJSON();
            try {
                const { spanId: t, traceId: n } = e1.spanContext();
                if (function(e1) {
                    const t = e1;
                    return !!(t.attributes && t.startTime && t.name && t.endTime && t.status);
                }(e1)) {
                    const { attributes: i, startTime: r, name: a, endTime: s, parentSpanId: o, status: l } = e1;
                    return GC({
                        span_id: t,
                        trace_id: n,
                        data: i,
                        description: a,
                        parent_span_id: o,
                        start_timestamp: ZL(r),
                        timestamp: ZL(s) || void 0,
                        status: JL(l),
                        op: i[FL],
                        origin: i[HL],
                        _metrics_summary: VL(e1)
                    });
                }
                return {
                    span_id: t,
                    trace_id: n
                };
            } catch (e1) {
                return {};
            }
        }
        function JL(e1) {
            if (e1 && e1.code !== QL) return e1.code === WL ? "ok" : e1.message || "unknown_error";
        }
        const $L = "_sentryRootSpan";
        function ez(e1) {
            return e1[$L] || e1;
        }
        const tz = "_frozenDsc";
        function nz(e1, t) {
            const n = t.getOptions(), { publicKey: i } = t.getDsn() || {}, r = GC({
                environment: n.environment || lC,
                release: n.release,
                public_key: i,
                trace_id: e1
            });
            return t.emit("createDsc", r), r;
        }
        function iz(e1) {
            const t = AL();
            if (!t) return {};
            const n = nz(KL(e1).trace_id || "", t), i = ez(e1), r = i[tz];
            if (r) return r;
            const a = i.spanContext().traceState, s = a && a.get("sentry.dsc"), o = s && function(e1) {
                const t = function(e1) {
                    if (e1 && (mC(e1) || Array.isArray(e1))) return Array.isArray(e1) ? e1.reduce((e1, t)=>{
                        const n = jL(t);
                        return Object.entries(n).forEach((t)=>{
                            let [n, i] = t;
                            e1[n] = i;
                        }), e1;
                    }, {}) : jL(e1);
                }(e1);
                if (!t) return;
                const n = Object.entries(t).reduce((e1, t)=>{
                    let [n, i] = t;
                    return n.match(UL) && (e1[n.slice(PL.length)] = i), e1;
                }, {});
                return Object.keys(n).length > 0 ? n : void 0;
            }(s);
            if (o) return o;
            const l = KL(i), c = l.data || {}, u = c[BL];
            null != u && (n.sample_rate = `${u}`);
            const h = c[kL], d = l.description;
            return "url" !== h && d && (n.transaction = d), function() {
                if ("boolean" == typeof __SENTRY_TRACING__ && !__SENTRY_TRACING__) return !1;
                const e1 = AL(), t = e1 && e1.getOptions();
                return !!t && (t.enableTracing || "tracesSampleRate" in t || "tracesSampler" in t);
            }() && (n.sampled = String(function(e1) {
                const { traceFlags: t } = e1.spanContext();
                return t === YL;
            }(i))), t.emit("createDsc", n, i), n;
        }
        function rz(e1, t) {
            const { extra: n, tags: i, user: r, contexts: a, level: s, sdkProcessingMetadata: o, breadcrumbs: l, fingerprint: c, eventProcessors: u, attachments: h, propagationContext: d, transactionName: p, span: f } = t;
            az(e1, "extra", n), az(e1, "tags", i), az(e1, "user", r), az(e1, "contexts", a), az(e1, "sdkProcessingMetadata", o), s && (e1.level = s), p && (e1.transactionName = p), f && (e1.span = f), l.length && (e1.breadcrumbs = [
                ...e1.breadcrumbs,
                ...l
            ]), c.length && (e1.fingerprint = [
                ...e1.fingerprint,
                ...c
            ]), u.length && (e1.eventProcessors = [
                ...e1.eventProcessors,
                ...u
            ]), h.length && (e1.attachments = [
                ...e1.attachments,
                ...h
            ]), e1.propagationContext = {
                ...e1.propagationContext,
                ...d
            };
        }
        function az(e1, t, n) {
            if (n && Object.keys(n).length) {
                e1[t] = {
                    ...e1[t]
                };
                for(const i in n)Object.prototype.hasOwnProperty.call(n, i) && (e1[t][i] = n[i]);
            }
        }
        function sz(e1, t, n, i, r, a) {
            const { normalizeDepth: s = 3, normalizeMaxBreadth: o = 1e3 } = e1, l = {
                ...t,
                event_id: t.event_id || n.event_id || QC(),
                timestamp: t.timestamp || eL()
            }, c = n.integrations || e1.integrations.map((e1)=>e1.name);
            !function(e1, t) {
                const { environment: n, release: i, dist: r, maxValueLength: a = 250 } = t;
                "environment" in e1 || (e1.environment = "environment" in t ? n : lC), void 0 === e1.release && void 0 !== i && (e1.release = i), void 0 === e1.dist && void 0 !== r && (e1.dist = r), e1.message && (e1.message = zC(e1.message, a));
                const s = e1.exception && e1.exception.values && e1.exception.values[0];
                s && s.value && (s.value = zC(s.value, a));
                const o = e1.request;
                o && o.url && (o.url = zC(o.url, a));
            }(l, e1), function(e1, t) {
                t.length > 0 && (e1.sdk = e1.sdk || {}, e1.sdk.integrations = [
                    ...e1.sdk.integrations || [],
                    ...t
                ]);
            }(l, c), r && r.emit("applyFrameMetadata", t), void 0 === t.type && function(e1, t) {
                const n = sC._sentryDebugIds;
                if (!n) return;
                let i;
                const r = oz.get(t);
                r ? i = r : (i = new Map, oz.set(t, i));
                const a = Object.entries(n).reduce((e1, n)=>{
                    let r, [a, s] = n;
                    const o = i.get(a);
                    o ? r = o : (r = t(a), i.set(a, r));
                    for(let t = r.length - 1; t >= 0; t--){
                        const n = r[t];
                        if (n.filename) {
                            e1[n.filename] = s;
                            break;
                        }
                    }
                    return e1;
                }, {});
                try {
                    e1.exception.values.forEach((e1)=>{
                        e1.stacktrace.frames.forEach((e1)=>{
                            e1.filename && (e1.debug_id = a[e1.filename]);
                        });
                    });
                } catch (e1) {}
            }(l, e1.stackParser);
            const u = function(e1, t) {
                if (!t) return e1;
                const n = e1 ? e1.clone() : new lL;
                return n.update(t), n;
            }(i, n.captureContext);
            n.mechanism && ZC(l, n.mechanism);
            const h = r ? r.getEventProcessors() : [], d = oC("globalScope", ()=>new lL).getScopeData();
            a && rz(d, a.getScopeData()), u && rz(d, u.getScopeData());
            const p = [
                ...n.attachments || [],
                ...d.attachments
            ];
            return p.length && (n.attachments = p), function(e1, t) {
                const { fingerprint: n, span: i, breadcrumbs: r, sdkProcessingMetadata: a } = t;
                !function(e1, t) {
                    const { extra: n, tags: i, user: r, contexts: a, level: s, transactionName: o } = t, l = GC(n);
                    l && Object.keys(l).length && (e1.extra = {
                        ...l,
                        ...e1.extra
                    });
                    const c = GC(i);
                    c && Object.keys(c).length && (e1.tags = {
                        ...c,
                        ...e1.tags
                    });
                    const u = GC(r);
                    u && Object.keys(u).length && (e1.user = {
                        ...u,
                        ...e1.user
                    });
                    const h = GC(a);
                    h && Object.keys(h).length && (e1.contexts = {
                        ...h,
                        ...e1.contexts
                    }), s && (e1.level = s), o && "transaction" !== e1.type && (e1.transaction = o);
                }(e1, t), i && function(e1, t) {
                    e1.contexts = {
                        trace: XL(t),
                        ...e1.contexts
                    }, e1.sdkProcessingMetadata = {
                        dynamicSamplingContext: iz(t),
                        ...e1.sdkProcessingMetadata
                    };
                    const n = KL(ez(t)).description;
                    n && !e1.transaction && "transaction" === e1.type && (e1.transaction = n);
                }(e1, i), function(e1, t) {
                    e1.fingerprint = e1.fingerprint ? KC(e1.fingerprint) : [], t && (e1.fingerprint = e1.fingerprint.concat(t)), e1.fingerprint && !e1.fingerprint.length && delete e1.fingerprint;
                }(e1, n), function(e1, t) {
                    const n = [
                        ...e1.breadcrumbs || [],
                        ...t
                    ];
                    e1.breadcrumbs = n.length ? n : void 0;
                }(e1, r), function(e1, t) {
                    e1.sdkProcessingMetadata = {
                        ...e1.sdkProcessingMetadata,
                        ...t
                    };
                }(e1, a);
            }(l, d), RL([
                ...h,
                ...d.eventProcessors
            ], l, n).then((e1)=>(e1 && function(e1) {
                    const t = {};
                    try {
                        e1.exception.values.forEach((e1)=>{
                            e1.stacktrace.frames.forEach((e1)=>{
                                e1.debug_id && (e1.abs_path ? t[e1.abs_path] = e1.debug_id : e1.filename && (t[e1.filename] = e1.debug_id), delete e1.debug_id);
                            });
                        });
                    } catch (e1) {}
                    if (0 === Object.keys(t).length) return;
                    e1.debug_meta = e1.debug_meta || {}, e1.debug_meta.images = e1.debug_meta.images || [];
                    const n = e1.debug_meta.images;
                    Object.entries(t).forEach((e1)=>{
                        let [t, i] = e1;
                        n.push({
                            type: "sourcemap",
                            code_file: t,
                            debug_id: i
                        });
                    });
                }(e1), "number" == typeof s && s > 0 ? function(e1, t, n) {
                    if (!e1) return null;
                    const i = {
                        ...e1,
                        ...e1.breadcrumbs && {
                            breadcrumbs: e1.breadcrumbs.map((e1)=>({
                                    ...e1,
                                    ...e1.data && {
                                        data: IL(e1.data, t, n)
                                    }
                                }))
                        },
                        ...e1.user && {
                            user: IL(e1.user, t, n)
                        },
                        ...e1.contexts && {
                            contexts: IL(e1.contexts, t, n)
                        },
                        ...e1.extra && {
                            extra: IL(e1.extra, t, n)
                        }
                    };
                    return e1.contexts && e1.contexts.trace && i.contexts && (i.contexts.trace = e1.contexts.trace, e1.contexts.trace.data && (i.contexts.trace.data = IL(e1.contexts.trace.data, t, n))), e1.spans && (i.spans = e1.spans.map((e1)=>({
                            ...e1,
                            ...e1.data && {
                                data: IL(e1.data, t, n)
                            }
                        }))), i;
                }(e1, s, o) : e1));
        }
        const oz = new WeakMap;
        const lz = [
            "user",
            "level",
            "extra",
            "contexts",
            "tags",
            "fingerprint",
            "requestSession",
            "propagationContext"
        ];
        function cz(e1, t) {
            return gL().captureEvent(e1, t);
        }
        function uz(e1) {
            const t = AL(), n = mL(), i = gL(), { release: r, environment: a = lC } = t && t.getOptions() || {}, { userAgent: s } = sC.navigator || {}, o = function(e1) {
                const t = tL(), n = {
                    sid: QC(),
                    init: !0,
                    timestamp: t,
                    started: t,
                    duration: 0,
                    status: "ok",
                    errors: 0,
                    ignoreDuration: !1,
                    toJSON: ()=>(function(e1) {
                            return GC({
                                sid: `${e1.sid}`,
                                init: e1.init,
                                started: new Date(1e3 * e1.started).toISOString(),
                                timestamp: new Date(1e3 * e1.timestamp).toISOString(),
                                status: e1.status,
                                errors: e1.errors,
                                did: "number" == typeof e1.did || "string" == typeof e1.did ? `${e1.did}` : void 0,
                                duration: e1.duration,
                                abnormal_mechanism: e1.abnormal_mechanism,
                                attrs: {
                                    release: e1.release,
                                    environment: e1.environment,
                                    ip_address: e1.ipAddress,
                                    user_agent: e1.userAgent
                                }
                            });
                        })(n)
                };
                return e1 && iL(n, e1), n;
            }({
                release: r,
                environment: a,
                user: i.getUser() || n.getUser(),
                ...s && {
                    userAgent: s
                },
                ...e1
            }), l = n.getSession();
            return l && "ok" === l.status && iL(l, {
                status: "exited"
            }), hz(), n.setSession(o), i.setSession(o), o;
        }
        function hz() {
            const e1 = mL(), t = gL(), n = t.getSession() || e1.getSession();
            n && function(e1) {
                let t = {};
                "ok" === e1.status && (t = {
                    status: "exited"
                }), iL(e1, t);
            }(n), dz(), e1.setSession(), t.setSession();
        }
        function dz() {
            const e1 = mL(), t = gL(), n = AL(), i = t.getSession() || e1.getSession();
            i && n && n.captureSession(i);
        }
        function pz() {
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? hz() : dz();
        }
        const fz = [];
        function gz(e1) {
            const t = e1.defaultIntegrations || [], n = e1.integrations;
            let i;
            t.forEach((e1)=>{
                e1.isDefaultInstance = !0;
            }), i = Array.isArray(n) ? [
                ...t,
                ...n
            ] : "function" == typeof n ? KC(n(t)) : t;
            const r = function(e1) {
                const t = {};
                return e1.forEach((e1)=>{
                    const { name: n } = e1, i = t[n];
                    i && !i.isDefaultInstance && e1.isDefaultInstance || (t[n] = e1);
                }), Object.values(t);
            }(i), a = r.findIndex((e1)=>"Debug" === e1.name);
            if (a > -1) {
                const [e1] = r.splice(a, 1);
                r.push(e1);
            }
            return r;
        }
        function mz(e1, t) {
            for (const n of t)n && n.afterAllSetup && n.afterAllSetup(e1);
        }
        function Az(e1, t, n) {
            if (n[t.name]) OL && LC.log(`Integration skipped because it was already installed: ${t.name}`);
            else {
                if (n[t.name] = t, -1 === fz.indexOf(t.name) && "function" == typeof t.setupOnce && (t.setupOnce(), fz.push(t.name)), t.setup && "function" == typeof t.setup && t.setup(e1), "function" == typeof t.preprocessEvent) {
                    const n = t.preprocessEvent.bind(t);
                    e1.on("preprocessEvent", (t, i)=>n(t, i, e1));
                }
                if ("function" == typeof t.processEvent) {
                    const n = t.processEvent.bind(t), i = Object.assign((t, i)=>n(t, i, e1), {
                        id: t.name
                    });
                    e1.addEventProcessor(i);
                }
                OL && LC.log(`Integration installed: ${t.name}`);
            }
        }
        const Mz = [
            /^Script error\.?$/,
            /^Javascript error: Script error\.? on line 0$/,
            /^ResizeObserver loop completed with undelivered notifications.$/,
            /^Cannot redefine property: googletag$/,
            "undefined is not an object (evaluating 'a.L')",
            'can\'t redefine non-configurable property "solana"',
            "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
            "Can't find variable: _AutofillCallbackHandler"
        ], vz = function() {
            let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return {
                name: "InboundFilters",
                processEvent (t, n, i) {
                    const r = i.getOptions(), a = function() {
                        let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return {
                            allowUrls: [
                                ...e1.allowUrls || [],
                                ...t.allowUrls || []
                            ],
                            denyUrls: [
                                ...e1.denyUrls || [],
                                ...t.denyUrls || []
                            ],
                            ignoreErrors: [
                                ...e1.ignoreErrors || [],
                                ...t.ignoreErrors || [],
                                ...e1.disableErrorDefaults ? [] : Mz
                            ],
                            ignoreTransactions: [
                                ...e1.ignoreTransactions || [],
                                ...t.ignoreTransactions || []
                            ],
                            ignoreInternal: void 0 === e1.ignoreInternal || e1.ignoreInternal
                        };
                    }(e1, r);
                    return function(e1, t) {
                        return t.ignoreInternal && function(e1) {
                            try {
                                return "SentryError" === e1.exception.values[0].type;
                            } catch (e1) {}
                            return !1;
                        }(e1) ? (OL && LC.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${YC(e1)}`), !0) : function(e1, t) {
                            return !(e1.type || !t || !t.length) && (function(e1) {
                                const t = [];
                                let n;
                                e1.message && t.push(e1.message);
                                try {
                                    n = e1.exception.values[e1.exception.values.length - 1];
                                } catch (e1) {}
                                return n && n.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`)), t;
                            })(e1).some((e1)=>RC(e1, t));
                        }(e1, t.ignoreErrors) ? (OL && LC.warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${YC(e1)}`), !0) : function(e1) {
                            return !e1.type && !(!e1.exception || !e1.exception.values || 0 === e1.exception.values.length) && !e1.message && !e1.exception.values.some((e1)=>e1.stacktrace || e1.type && "Error" !== e1.type || e1.value);
                        }(e1) ? (OL && LC.warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${YC(e1)}`), !0) : function(e1, t) {
                            if ("transaction" !== e1.type || !t || !t.length) return !1;
                            const n = e1.transaction;
                            return !!n && RC(n, t);
                        }(e1, t.ignoreTransactions) ? (OL && LC.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${YC(e1)}`), !0) : function(e1, t) {
                            if (!t || !t.length) return !1;
                            const n = yz(e1);
                            return !!n && RC(n, t);
                        }(e1, t.denyUrls) ? (OL && LC.warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${YC(e1)}.\nUrl: ${yz(e1)}`), !0) : !function(e1, t) {
                            if (!t || !t.length) return !0;
                            const n = yz(e1);
                            return !n || RC(n, t);
                        }(e1, t.allowUrls) && (OL && LC.warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${YC(e1)}.\nUrl: ${yz(e1)}`), !0);
                    }(t, a) ? null : t;
                }
            };
        };
        function yz(e1) {
            try {
                let t;
                try {
                    t = e1.exception.values[0].stacktrace.frames;
                } catch (e1) {}
                return t ? function() {
                    let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                    for(let t = e1.length - 1; t >= 0; t--){
                        const n = e1[t];
                        if (n && "<anonymous>" !== n.filename && "[native code]" !== n.filename) return n.filename || null;
                    }
                    return null;
                }(t) : null;
            } catch (t) {
                return OL && LC.error(`Cannot extract url for event ${YC(e1)}`), null;
            }
        }
        let xz;
        const bz = new WeakMap, wz = ()=>({
                name: "FunctionToString",
                setupOnce () {
                    xz = Function.prototype.toString;
                    try {
                        Function.prototype.toString = function() {
                            const e1 = kC(this), t = bz.has(AL()) && void 0 !== e1 ? e1 : this;
                            for(var n = arguments.length, i = new Array(n), r = 0; r < n; r++)i[r] = arguments[r];
                            return xz.apply(t, i);
                        };
                    } catch (e1) {}
                },
                setup (e1) {
                    bz.set(e1, !0);
                }
            }), Ez = ()=>{
            let e1;
            return {
                name: "Dedupe",
                processEvent (t) {
                    if (t.type) return t;
                    try {
                        if (function(e1, t) {
                            return !!t && (!!function(e1, t) {
                                const n = e1.message, i = t.message;
                                return !(!n && !i) && !(n && !i || !n && i) && n === i && !!Sz(e1, t) && !!Tz(e1, t);
                            }(e1, t) || !!function(e1, t) {
                                const n = Iz(t), i = Iz(e1);
                                return !(!n || !i) && n.type === i.type && n.value === i.value && !!Sz(e1, t) && !!Tz(e1, t);
                            }(e1, t));
                        }(t, e1)) return OL && LC.warn("Event dropped due to being a duplicate of previously captured event."), null;
                    } catch (e1) {}
                    return e1 = t;
                }
            };
        };
        function Tz(e1, t) {
            let n = SL(e1), i = SL(t);
            if (!n && !i) return !0;
            if (n && !i || !n && i) return !1;
            if (i.length !== n.length) return !1;
            for(let e1 = 0; e1 < i.length; e1++){
                const t = i[e1], r = n[e1];
                if (t.filename !== r.filename || t.lineno !== r.lineno || t.colno !== r.colno || t.function !== r.function) return !1;
            }
            return !0;
        }
        function Sz(e1, t) {
            let n = e1.fingerprint, i = t.fingerprint;
            if (!n && !i) return !0;
            if (n && !i || !n && i) return !1;
            try {
                return !(n.join("") !== i.join(""));
            } catch (e1) {
                return !1;
            }
        }
        function Iz(e1) {
            return e1.exception && e1.exception.values && e1.exception.values[0];
        }
        const Nz = sC;
        function Dz() {
            if (!("fetch" in Nz)) return !1;
            try {
                return new Headers, new Request("http://www.example.com"), new Response, !0;
            } catch (e1) {
                return !1;
            }
        }
        function _z(e1) {
            return e1 && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e1.toString());
        }
        const Cz = {}, Lz = {};
        function zz(e1, t) {
            Cz[e1] = Cz[e1] || [], Cz[e1].push(t);
        }
        function Oz(e1, t) {
            Lz[e1] || (t(), Lz[e1] = !0);
        }
        function Rz(e1, t) {
            const n = e1 && Cz[e1];
            if (n) for (const i of n)try {
                i(t);
            } catch (t) {
                NC && LC.error(`Error while triggering instrumentation handler.\nType: ${e1}\nName: ${TL(i)}\nError:`, t);
            }
        }
        const Pz = sC, Uz = sC;
        let jz;
        function kz(e1) {
            const t = "history";
            zz(t, e1), Oz(t, Bz);
        }
        function Bz() {
            if (!function() {
                const e1 = Pz.chrome, t = e1 && e1.app && e1.app.runtime, n = "history" in Pz && !!Pz.history.pushState && !!Pz.history.replaceState;
                return !t && n;
            }()) return;
            const e1 = Uz.onpopstate;
            function t(e1) {
                return function() {
                    for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                    const r = n.length > 2 ? n[2] : void 0;
                    if (r) {
                        const e1 = jz, t = String(r);
                        jz = t, Rz("history", {
                            from: e1,
                            to: t
                        });
                    }
                    return e1.apply(this, n);
                };
            }
            Uz.onpopstate = function() {
                const t = Uz.location.href, n = jz;
                if (jz = t, Rz("history", {
                    from: n,
                    to: t
                }), e1) try {
                    for(var i = arguments.length, r = new Array(i), a = 0; a < i; a++)r[a] = arguments[a];
                    return e1.apply(this, r);
                } catch (e1) {}
            }, PC(Uz.history, "pushState", t), PC(Uz.history, "replaceState", t);
        }
        const Fz = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
        function Hz(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            const { host: n, path: i, pass: r, port: a, projectId: s, protocol: o, publicKey: l } = e1;
            return `${o}://${l}${t && r ? `:${r}` : ""}@${n}${a ? `:${a}` : ""}/${i ? `${i}/` : i}${s}`;
        }
        function Gz(e1) {
            return {
                protocol: e1.protocol,
                publicKey: e1.publicKey || "",
                pass: e1.pass || "",
                host: e1.host,
                port: e1.port || "",
                path: e1.path || "",
                projectId: e1.projectId
            };
        }
        function Vz(e1) {
            return [
                e1,
                arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : []
            ];
        }
        function Qz(e1, t) {
            const [n, i] = e1;
            return [
                n,
                [
                    ...i,
                    t
                ]
            ];
        }
        function Wz(e1, t) {
            const n = e1[1];
            for (const e1 of n)if (t(e1, e1[0].type)) return !0;
            return !1;
        }
        function Yz(e1) {
            return sC.__SENTRY__ && sC.__SENTRY__.encodePolyfill ? sC.__SENTRY__.encodePolyfill(e1) : (new TextEncoder).encode(e1);
        }
        function Xz(e1) {
            const [t, n] = e1;
            let i = JSON.stringify(t);
            function r(e1) {
                "string" == typeof i ? i = "string" == typeof e1 ? i + e1 : [
                    Yz(i),
                    e1
                ] : i.push("string" == typeof e1 ? Yz(e1) : e1);
            }
            for (const e1 of n){
                const [t, n] = e1;
                if (r(`\n${JSON.stringify(t)}\n`), "string" == typeof n || n instanceof Uint8Array) r(n);
                else {
                    let e1;
                    try {
                        e1 = JSON.stringify(n);
                    } catch (t) {
                        e1 = JSON.stringify(IL(n));
                    }
                    r(e1);
                }
            }
            return "string" == typeof i ? i : function(e1) {
                const t = e1.reduce((e1, t)=>e1 + t.length, 0), n = new Uint8Array(t);
                let i = 0;
                for (const t of e1)n.set(t, i), i += t.length;
                return n;
            }(i);
        }
        function Zz(e1) {
            const t = "string" == typeof e1.data ? Yz(e1.data) : e1.data;
            return [
                GC({
                    type: "attachment",
                    length: t.length,
                    filename: e1.filename,
                    content_type: e1.contentType,
                    attachment_type: e1.attachmentType
                }),
                t
            ];
        }
        const qz = {
            session: "session",
            sessions: "session",
            attachment: "attachment",
            transaction: "transaction",
            event: "error",
            client_report: "internal",
            user_report: "default",
            profile: "profile",
            profile_chunk: "profile",
            replay_event: "replay",
            replay_recording: "replay",
            check_in: "monitor",
            feedback: "feedback",
            span: "span",
            statsd: "metric_bucket"
        };
        function Kz(e1) {
            return qz[e1];
        }
        function Jz(e1) {
            if (!e1 || !e1.sdk) return;
            const { name: t, version: n } = e1.sdk;
            return {
                name: t,
                version: n
            };
        }
        class $z extends Error {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "warn";
                super(e1), this.message = e1, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = t;
            }
        }
        const eO = "7";
        function tO(e1, t, n) {
            return t || `${function(e1) {
                return `${function(e1) {
                    const t = e1.protocol ? `${e1.protocol}:` : "", n = e1.port ? `:${e1.port}` : "";
                    return `${t}//${e1.host}${n}${e1.path ? `/${e1.path}` : ""}/api/`;
                }(e1)}${e1.projectId}/envelope/`;
            }(e1)}?${function(e1, t) {
                var n;
                return n = {
                    sentry_key: e1.publicKey,
                    sentry_version: eO,
                    ...t && {
                        sentry_client: `${t.name}/${t.version}`
                    }
                }, Object.keys(n).map((e1)=>`${encodeURIComponent(e1)}=${encodeURIComponent(n[e1])}`).join("&");
            }(e1, n)}`;
        }
        const nO = "Not capturing exception because it's already been captured.";
        class iO {
            constructor(e1){
                if (this._options = e1, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], e1.dsn ? this._dsn = function(e1) {
                    const t = "string" == typeof e1 ? function(e1) {
                        const t = Fz.exec(e1);
                        if (!t) return void CC(()=>{
                            console.error(`Invalid Sentry Dsn: ${e1}`);
                        });
                        const [n, i, r = "", a = "", s = "", o = ""] = t.slice(1);
                        let l = "", c = o;
                        const u = c.split("/");
                        if (u.length > 1 && (l = u.slice(0, -1).join("/"), c = u.pop()), c) {
                            const e1 = c.match(/^\d+/);
                            e1 && (c = e1[0]);
                        }
                        return Gz({
                            host: a,
                            pass: r,
                            path: l,
                            projectId: c,
                            port: s,
                            protocol: n,
                            publicKey: i
                        });
                    }(e1) : Gz(e1);
                    if (t && function(e1) {
                        if (!NC) return !0;
                        const { port: t, projectId: n, protocol: i } = e1;
                        return !([
                            "protocol",
                            "publicKey",
                            "host",
                            "projectId"
                        ].find((t)=>!e1[t] && (LC.error(`Invalid Sentry Dsn: ${t} missing`), !0)) || (n.match(/^\d+$/) ? function(e1) {
                            return "http" === e1 || "https" === e1;
                        }(i) ? t && isNaN(parseInt(t, 10)) && (LC.error(`Invalid Sentry Dsn: Invalid port ${t}`), 1) : (LC.error(`Invalid Sentry Dsn: Invalid protocol ${i}`), 1) : (LC.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), 1)));
                    }(t)) return t;
                }(e1.dsn) : OL && LC.warn("No DSN provided, client will not send events."), this._dsn) {
                    const t = tO(this._dsn, e1.tunnel, e1._metadata ? e1._metadata.sdk : void 0);
                    this._transport = e1.transport({
                        tunnel: this._options.tunnel,
                        recordDroppedEvent: this.recordDroppedEvent.bind(this),
                        ...e1.transportOptions,
                        url: t
                    });
                }
            }
            captureException(e1, t, n) {
                const i = QC();
                if (qC(e1)) return OL && LC.log(nO), i;
                const r = {
                    event_id: i,
                    ...t
                };
                return this._process(this.eventFromException(e1, r).then((e1)=>this._captureEvent(e1, r, n))), r.event_id;
            }
            captureMessage(e1, t, n, i) {
                const r = {
                    event_id: QC(),
                    ...n
                }, a = AC(e1) ? e1 : String(e1), s = MC(e1) ? this.eventFromMessage(a, t, r) : this.eventFromException(e1, r);
                return this._process(s.then((e1)=>this._captureEvent(e1, r, i))), r.event_id;
            }
            captureEvent(e1, t, n) {
                const i = QC();
                if (t && t.originalException && qC(t.originalException)) return OL && LC.log(nO), i;
                const r = {
                    event_id: i,
                    ...t
                }, a = (e1.sdkProcessingMetadata || {}).capturedSpanScope;
                return this._process(this._captureEvent(e1, r, a || n)), r.event_id;
            }
            captureSession(e1) {
                "string" != typeof e1.release ? OL && LC.warn("Discarded session because of missing or non-string release") : (this.sendSession(e1), iL(e1, {
                    init: !1
                }));
            }
            getDsn() {
                return this._dsn;
            }
            getOptions() {
                return this._options;
            }
            getSdkMetadata() {
                return this._options._metadata;
            }
            getTransport() {
                return this._transport;
            }
            flush(e1) {
                const t = this._transport;
                return t ? (this.emit("flush"), this._isClientDoneProcessing(e1).then((n)=>t.flush(e1).then((e1)=>n && e1))) : CL(!0);
            }
            close(e1) {
                return this.flush(e1).then((e1)=>(this.getOptions().enabled = !1, this.emit("close"), e1));
            }
            getEventProcessors() {
                return this._eventProcessors;
            }
            addEventProcessor(e1) {
                this._eventProcessors.push(e1);
            }
            init() {
                (this._isEnabled() || this._options.integrations.some((e1)=>{
                    let { name: t } = e1;
                    return t.startsWith("Spotlight");
                })) && this._setupIntegrations();
            }
            getIntegrationByName(e1) {
                return this._integrations[e1];
            }
            addIntegration(e1) {
                const t = this._integrations[e1.name];
                Az(this, e1, this._integrations), t || mz(this, [
                    e1
                ]);
            }
            sendEvent(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                this.emit("beforeSendEvent", e1, t);
                let n = function(e1, t, n, i) {
                    const r = Jz(n), a = e1.type && "replay_event" !== e1.type ? e1.type : "event";
                    !function(e1, t) {
                        t && (e1.sdk = e1.sdk || {}, e1.sdk.name = e1.sdk.name || t.name, e1.sdk.version = e1.sdk.version || t.version, e1.sdk.integrations = [
                            ...e1.sdk.integrations || [],
                            ...t.integrations || []
                        ], e1.sdk.packages = [
                            ...e1.sdk.packages || [],
                            ...t.packages || []
                        ]);
                    }(e1, n && n.sdk);
                    const s = function(e1, t, n, i) {
                        const r = e1.sdkProcessingMetadata && e1.sdkProcessingMetadata.dynamicSamplingContext;
                        return {
                            event_id: e1.event_id,
                            sent_at: (new Date).toISOString(),
                            ...t && {
                                sdk: t
                            },
                            ...!!n && i && {
                                dsn: Hz(i)
                            },
                            ...r && {
                                trace: GC({
                                    ...r
                                })
                            }
                        };
                    }(e1, r, i, t);
                    return delete e1.sdkProcessingMetadata, Vz(s, [
                        [
                            {
                                type: a
                            },
                            e1
                        ]
                    ]);
                }(e1, this._dsn, this._options._metadata, this._options.tunnel);
                for (const e1 of t.attachments || [])n = Qz(n, Zz(e1));
                const i = this.sendEnvelope(n);
                i && i.then((t)=>this.emit("afterSendEvent", e1, t), null);
            }
            sendSession(e1) {
                const t = function(e1, t, n, i) {
                    const r = Jz(n);
                    return Vz({
                        sent_at: (new Date).toISOString(),
                        ...r && {
                            sdk: r
                        },
                        ...!!i && t && {
                            dsn: Hz(t)
                        }
                    }, [
                        "aggregates" in e1 ? [
                            {
                                type: "sessions"
                            },
                            e1
                        ] : [
                            {
                                type: "session"
                            },
                            e1.toJSON()
                        ]
                    ]);
                }(e1, this._dsn, this._options._metadata, this._options.tunnel);
                this.sendEnvelope(t);
            }
            recordDroppedEvent(e1, t, n) {
                if (this._options.sendClientReports) {
                    const i = "number" == typeof n ? n : 1, r = `${e1}:${t}`;
                    OL && LC.log(`Recording outcome: "${r}"${i > 1 ? ` (${i} times)` : ""}`), this._outcomes[r] = (this._outcomes[r] || 0) + i;
                }
            }
            on(e1, t) {
                const n = this._hooks[e1] = this._hooks[e1] || [];
                return n.push(t), ()=>{
                    const e1 = n.indexOf(t);
                    e1 > -1 && n.splice(e1, 1);
                };
            }
            emit(e1) {
                for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                const r = this._hooks[e1];
                r && r.forEach((e1)=>e1(...n));
            }
            sendEnvelope(e1) {
                return this.emit("beforeEnvelope", e1), this._isEnabled() && this._transport ? this._transport.send(e1).then(null, (e1)=>(OL && LC.error("Error while sending event:", e1), e1)) : (OL && LC.error("Transport disabled"), CL({}));
            }
            _setupIntegrations() {
                const { integrations: e1 } = this._options;
                this._integrations = function(e1, t) {
                    const n = {};
                    return t.forEach((t)=>{
                        t && Az(e1, t, n);
                    }), n;
                }(this, e1), mz(this, e1);
            }
            _updateSessionFromEvent(e1, t) {
                let n = !1, i = !1;
                const r = t.exception && t.exception.values;
                if (r) {
                    i = !0;
                    for (const e1 of r){
                        const t = e1.mechanism;
                        if (t && !1 === t.handled) {
                            n = !0;
                            break;
                        }
                    }
                }
                const a = "ok" === e1.status;
                (a && 0 === e1.errors || a && n) && (iL(e1, {
                    ...n && {
                        status: "crashed"
                    },
                    errors: e1.errors || Number(i || n)
                }), this.captureSession(e1));
            }
            _isClientDoneProcessing(e1) {
                return new zL((t)=>{
                    let n = 0;
                    const i = setInterval(()=>{
                        0 == this._numProcessing ? (clearInterval(i), t(!0)) : (n += 1, e1 && n >= e1 && (clearInterval(i), t(!1)));
                    }, 1);
                });
            }
            _isEnabled() {
                return !1 !== this.getOptions().enabled && void 0 !== this._transport;
            }
            _prepareEvent(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : mL();
                const r = this.getOptions(), a = Object.keys(this._integrations);
                return !t.integrations && a.length > 0 && (t.integrations = a), this.emit("preprocessEvent", e1, t), e1.type || i.setLastEventId(e1.event_id || t.event_id), sz(r, e1, t, n, this, i).then((e1)=>{
                    if (null === e1) return e1;
                    const t = {
                        ...i.getPropagationContext(),
                        ...n ? n.getPropagationContext() : void 0
                    };
                    if ((!e1.contexts || !e1.contexts.trace) && t) {
                        const { traceId: n, spanId: i, parentSpanId: r, dsc: a } = t;
                        e1.contexts = {
                            trace: GC({
                                trace_id: n,
                                span_id: i,
                                parent_span_id: r
                            }),
                            ...e1.contexts
                        };
                        const s = a || nz(n, this);
                        e1.sdkProcessingMetadata = {
                            dynamicSamplingContext: s,
                            ...e1.sdkProcessingMetadata
                        };
                    }
                    return e1;
                });
            }
            _captureEvent(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(e1, t, n).then((e1)=>e1.event_id, (e1)=>{
                    if (OL) {
                        const t = e1;
                        "log" === t.logLevel ? LC.log(t.message) : LC.warn(t);
                    }
                });
            }
            _processEvent(e1, t, n) {
                const i = this.getOptions(), { sampleRate: r } = i, a = aO(e1), s = rO(e1), o = e1.type || "error", l = `before send for type \`${o}\``, c = void 0 === r ? void 0 : function(e1) {
                    if ("boolean" == typeof e1) return Number(e1);
                    const t = "string" == typeof e1 ? parseFloat(e1) : e1;
                    if (!("number" != typeof t || isNaN(t) || t < 0 || t > 1)) return t;
                    OL && LC.warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(e1)} of type ${JSON.stringify(typeof e1)}.`);
                }(r);
                if (s && "number" == typeof c && Math.random() > c) return this.recordDroppedEvent("sample_rate", "error", e1), LL(new $z(`Discarding event because it's not included in the random sample (sampling rate = ${r})`, "log"));
                const u = "replay_event" === o ? "replay" : o, h = (e1.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
                return this._prepareEvent(e1, t, n, h).then((n)=>{
                    if (null === n) throw this.recordDroppedEvent("event_processor", u, e1), new $z("An event processor returned `null`, will not send event.", "log");
                    if (t.data && !0 === t.data.__sentry__) return n;
                    const r = function(e1, t, n, i) {
                        const { beforeSend: r, beforeSendTransaction: a, beforeSendSpan: s } = t;
                        if (rO(n) && r) return r(n, i);
                        if (aO(n)) {
                            if (n.spans && s) {
                                const t = [];
                                for (const i of n.spans){
                                    const n = s(i);
                                    n ? t.push(n) : e1.recordDroppedEvent("before_send", "span");
                                }
                                n.spans = t;
                            }
                            if (a) {
                                if (n.spans) {
                                    const e1 = n.spans.length;
                                    n.sdkProcessingMetadata = {
                                        ...n.sdkProcessingMetadata,
                                        spanCountBeforeProcessing: e1
                                    };
                                }
                                return a(n, i);
                            }
                        }
                        return n;
                    }(this, i, n, t);
                    return function(e1, t) {
                        const n = `${t} must return \`null\` or a valid event.`;
                        if (xC(e1)) return e1.then((e1)=>{
                            if (!vC(e1) && null !== e1) throw new $z(n);
                            return e1;
                        }, (e1)=>{
                            throw new $z(`${t} rejected with ${e1}`);
                        });
                        if (!vC(e1) && null !== e1) throw new $z(n);
                        return e1;
                    }(r, l);
                }).then((i)=>{
                    if (null === i) {
                        if (this.recordDroppedEvent("before_send", u, e1), a) {
                            const t = 1 + (e1.spans || []).length;
                            this.recordDroppedEvent("before_send", "span", t);
                        }
                        throw new $z(`${l} returned \`null\`, will not send event.`, "log");
                    }
                    const r = n && n.getSession();
                    if (!a && r && this._updateSessionFromEvent(r, i), a) {
                        const e1 = (i.sdkProcessingMetadata && i.sdkProcessingMetadata.spanCountBeforeProcessing || 0) - (i.spans ? i.spans.length : 0);
                        e1 > 0 && this.recordDroppedEvent("before_send", "span", e1);
                    }
                    const s = i.transaction_info;
                    if (a && s && i.transaction !== e1.transaction) {
                        const e1 = "custom";
                        i.transaction_info = {
                            ...s,
                            source: e1
                        };
                    }
                    return this.sendEvent(i, t), i;
                }).then(null, (e1)=>{
                    if (e1 instanceof $z) throw e1;
                    throw this.captureException(e1, {
                        data: {
                            __sentry__: !0
                        },
                        originalException: e1
                    }), new $z(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${e1}`);
                });
            }
            _process(e1) {
                this._numProcessing++, e1.then((e1)=>(this._numProcessing--, e1), (e1)=>(this._numProcessing--, e1));
            }
            _clearOutcomes() {
                const e1 = this._outcomes;
                return this._outcomes = {}, Object.entries(e1).map((e1)=>{
                    let [t, n] = e1;
                    const [i, r] = t.split(":");
                    return {
                        reason: i,
                        category: r,
                        quantity: n
                    };
                });
            }
            _flushOutcomes() {
                OL && LC.log("Flushing outcomes...");
                const e1 = this._clearOutcomes();
                if (0 === e1.length) return void (OL && LC.log("No outcomes to send"));
                if (!this._dsn) return void (OL && LC.log("No dsn provided, will not send outcomes"));
                OL && LC.log("Sending outcomes:", e1);
                const t = (n = e1, Vz((i = this._options.tunnel && Hz(this._dsn)) ? {
                    dsn: i
                } : {}, [
                    [
                        {
                            type: "client_report"
                        },
                        {
                            timestamp: eL(),
                            discarded_events: n
                        }
                    ]
                ]));
                var n, i;
                this.sendEnvelope(t);
            }
        }
        function rO(e1) {
            return void 0 === e1.type;
        }
        function aO(e1) {
            return "transaction" === e1.type;
        }
        function sO(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [
                t
            ], i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "npm";
            const r = e1._metadata || {};
            r.sdk || (r.sdk = {
                name: `sentry.javascript.${t}`,
                packages: n.map((e1)=>({
                        name: `${i}:@sentry/${e1}`,
                        version: aC
                    })),
                version: aC
            }), e1._metadata = r;
        }
        const oO = "undefined" == typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__;
        function lO(e1, t) {
            const n = uO(e1, t), i = {
                type: pO(t),
                value: fO(t)
            };
            return n.length && (i.stacktrace = {
                frames: n
            }), void 0 === i.type && "" === i.value && (i.value = "Unrecoverable error caught"), i;
        }
        function cO(e1, t) {
            return {
                exception: {
                    values: [
                        lO(e1, t)
                    ]
                }
            };
        }
        function uO(e1, t) {
            const n = t.stacktrace || t.stack || "", i = function(e1) {
                return e1 && hO.test(e1.message) ? 1 : 0;
            }(t), r = function(e1) {
                return "number" == typeof e1.framesToPop ? e1.framesToPop : 0;
            }(t);
            try {
                return e1(n, i, r);
            } catch (e1) {}
            return [];
        }
        const hO = /Minified React error #\d+;/i;
        function dO(e1) {
            return "undefined" != typeof WebAssembly && void 0 !== WebAssembly.Exception && e1 instanceof WebAssembly.Exception;
        }
        function pO(e1) {
            const t = e1 && e1.name;
            return !t && dO(e1) ? e1.message && Array.isArray(e1.message) && 2 == e1.message.length ? e1.message[0] : "WebAssembly.Exception" : t;
        }
        function fO(e1) {
            const t = e1 && e1.message;
            return t ? t.error && "string" == typeof t.error.message ? t.error.message : dO(e1) && Array.isArray(e1.message) && 2 == e1.message.length ? e1.message[1] : t : "No error message";
        }
        function gO(e1, t, n, i, r) {
            let a;
            if (fC(t) && t.error) return cO(e1, t.error);
            if (gC(t) || pC(t, "DOMException")) {
                const r = t;
                if ("stack" in t) a = cO(e1, t);
                else {
                    const t = r.name || (gC(r) ? "DOMError" : "DOMException"), s = r.message ? `${t}: ${r.message}` : t;
                    a = mO(e1, s, n, i), XC(a, s);
                }
                return "code" in r && (a.tags = {
                    ...a.tags,
                    "DOMException.code": `${r.code}`
                }), a;
            }
            return dC(t) ? cO(e1, t) : vC(t) || yC(t) ? (a = function(e1, t, n, i) {
                const r = AL(), a = r && r.getOptions().normalizeDepth, s = function(e1) {
                    for(const t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                        const n = e1[t];
                        if (n instanceof Error) return n;
                    }
                }(t), o = {
                    __serialized__: NL(t, a)
                };
                if (s) return {
                    exception: {
                        values: [
                            lO(e1, s)
                        ]
                    },
                    extra: o
                };
                const l = {
                    exception: {
                        values: [
                            {
                                type: yC(t) ? t.constructor.name : i ? "UnhandledRejection" : "Error",
                                value: AO(t, {
                                    isUnhandledRejection: i
                                })
                            }
                        ]
                    },
                    extra: o
                };
                if (n) {
                    const t = uO(e1, n);
                    t.length && (l.exception.values[0].stacktrace = {
                        frames: t
                    });
                }
                return l;
            }(e1, t, n, r), ZC(a, {
                synthetic: !0
            }), a) : (a = mO(e1, t, n, i), XC(a, `${t}`, void 0), ZC(a, {
                synthetic: !0
            }), a);
        }
        function mO(e1, t, n, i) {
            const r = {};
            if (i && n) {
                const i = uO(e1, n);
                i.length && (r.exception = {
                    values: [
                        {
                            value: t,
                            stacktrace: {
                                frames: i
                            }
                        }
                    ]
                });
            }
            if (AC(t)) {
                const { __sentry_template_string__: e1, __sentry_template_values__: n } = t;
                return r.logentry = {
                    message: e1,
                    params: n
                }, r;
            }
            return r.message = t, r;
        }
        function AO(e1, t) {
            let { isUnhandledRejection: n } = t;
            const i = function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 40;
                const n = Object.keys(BC(e1));
                n.sort();
                const i = n[0];
                if (!i) return "[object has no keys]";
                if (i.length >= t) return zC(i, t);
                for(let e1 = n.length; e1 > 0; e1--){
                    const i = n.slice(0, e1).join(", ");
                    if (!(i.length > t)) return e1 === n.length ? i : zC(i, t);
                }
                return "";
            }(e1), r = n ? "promise rejection" : "exception";
            return fC(e1) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e1.message}\`` : yC(e1) ? `Event \`${function(e1) {
                try {
                    const t = Object.getPrototypeOf(e1);
                    return t ? t.constructor.name : void 0;
                } catch (e1) {}
            }(e1)}\` (type=${e1.type}) captured as ${r}` : `Object captured as ${r} with keys: ${i}`;
        }
        const MO = sC;
        let vO = 0;
        function yO() {
            return vO > 0;
        }
        function xO(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
            if ("function" != typeof e1) return e1;
            try {
                const t = e1.__sentry_wrapped__;
                if (t) return "function" == typeof t ? t : e1;
                if (kC(e1)) return e1;
            } catch (t) {
                return e1;
            }
            const i = function() {
                const i = Array.prototype.slice.call(arguments);
                try {
                    n && "function" == typeof n && n.apply(this, arguments);
                    const r = i.map((e1)=>xO(e1, t));
                    return e1.apply(this, r);
                } catch (e1) {
                    throw vO++, setTimeout(()=>{
                        vO--;
                    }), function() {
                        const e1 = fL(cC());
                        for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                        if (2 === n.length) {
                            const [t, i] = n;
                            return t ? e1.withSetScope(t, i) : e1.withScope(i);
                        }
                        e1.withScope(n[0]);
                    }((n)=>{
                        var r;
                        n.addEventProcessor((e1)=>(t.mechanism && (XC(e1, void 0, void 0), ZC(e1, t.mechanism)), e1.extra = {
                                ...e1.extra,
                                arguments: i
                            }, e1)), r = e1, gL().captureException(r, function(e1) {
                            if (e1) return function(e1) {
                                return e1 instanceof lL || "function" == typeof e1;
                            }(e1) || function(e1) {
                                return Object.keys(e1).some((e1)=>lz.includes(e1));
                            }(e1) ? {
                                captureContext: e1
                            } : e1;
                        }(undefined));
                    }), e1;
                }
            };
            try {
                for(const t in e1)Object.prototype.hasOwnProperty.call(e1, t) && (i[t] = e1[t]);
            } catch (e1) {}
            jC(i, e1), UC(e1, "__sentry_wrapped__", i);
            try {
                Object.getOwnPropertyDescriptor(i, "name").configurable && Object.defineProperty(i, "name", {
                    get: ()=>e1.name
                });
            } catch (e1) {}
            return i;
        }
        class bO extends iO {
            constructor(e1){
                const t = {
                    parentSpanIsAlwaysRootSpan: !0,
                    ...e1
                };
                sO(t, "browser", [
                    "browser"
                ], MO.SENTRY_SDK_SOURCE || "npm"), super(t), t.sendClientReports && MO.document && MO.document.addEventListener("visibilitychange", ()=>{
                    "hidden" === MO.document.visibilityState && this._flushOutcomes();
                });
            }
            eventFromException(e1, t) {
                return function(e1, t, n, i) {
                    const r = gO(e1, t, n && n.syntheticException || void 0, i);
                    return ZC(r), r.level = "error", n && n.event_id && (r.event_id = n.event_id), CL(r);
                }(this._options.stackParser, e1, t, this._options.attachStacktrace);
            }
            eventFromMessage(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "info", n = arguments.length > 2 ? arguments[2] : void 0;
                return function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "info", i = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 ? arguments[4] : void 0;
                    const a = mO(e1, t, i && i.syntheticException || void 0, r);
                    return a.level = n, i && i.event_id && (a.event_id = i.event_id), CL(a);
                }(this._options.stackParser, e1, t, n, this._options.attachStacktrace);
            }
            captureUserFeedback(e1) {
                if (!this._isEnabled()) return void (oO && LC.warn("SDK not enabled, will not capture user feedback."));
                const t = function(e1, t) {
                    let { metadata: n, tunnel: i, dsn: r } = t;
                    const a = {
                        event_id: e1.event_id,
                        sent_at: (new Date).toISOString(),
                        ...n && n.sdk && {
                            sdk: {
                                name: n.sdk.name,
                                version: n.sdk.version
                            }
                        },
                        ...!!i && !!r && {
                            dsn: Hz(r)
                        }
                    }, s = function(e1) {
                        return [
                            {
                                type: "user_report"
                            },
                            e1
                        ];
                    }(e1);
                    return Vz(a, [
                        s
                    ]);
                }(e1, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                this.sendEnvelope(t);
            }
            _prepareEvent(e1, t, n) {
                return e1.platform = e1.platform || "javascript", super._prepareEvent(e1, t, n);
            }
        }
        const wO = 1e3;
        let EO, TO, SO;
        function IO() {
            if (!Uz.document) return;
            const e1 = Rz.bind(null, "dom"), t = NO(e1, !0);
            Uz.document.addEventListener("click", t, !1), Uz.document.addEventListener("keypress", t, !1), [
                "EventTarget",
                "Node"
            ].forEach((t)=>{
                const n = Uz[t] && Uz[t].prototype;
                n && n.hasOwnProperty && n.hasOwnProperty("addEventListener") && (PC(n, "addEventListener", function(t) {
                    return function(n, i, r) {
                        if ("click" === n || "keypress" == n) try {
                            const i = this, a = i.__sentry_instrumentation_handlers__ = i.__sentry_instrumentation_handlers__ || {}, s = a[n] = a[n] || {
                                refCount: 0
                            };
                            if (!s.handler) {
                                const i = NO(e1);
                                s.handler = i, t.call(this, n, i, r);
                            }
                            s.refCount++;
                        } catch (e1) {}
                        return t.call(this, n, i, r);
                    };
                }), PC(n, "removeEventListener", function(e1) {
                    return function(t, n, i) {
                        if ("click" === t || "keypress" == t) try {
                            const n = this, r = n.__sentry_instrumentation_handlers__ || {}, a = r[t];
                            a && (a.refCount--, a.refCount <= 0 && (e1.call(this, t, a.handler, i), a.handler = void 0, delete r[t]), 0 === Object.keys(r).length && delete n.__sentry_instrumentation_handlers__);
                        } catch (e1) {}
                        return e1.call(this, t, n, i);
                    };
                }));
            });
        }
        function NO(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return (n)=>{
                if (!n || n._sentryCaptured) return;
                const i = function(e1) {
                    try {
                        return e1.target;
                    } catch (e1) {
                        return null;
                    }
                }(n);
                if (function(e1, t) {
                    return "keypress" === e1 && (!t || !t.tagName || "INPUT" !== t.tagName && "TEXTAREA" !== t.tagName && !t.isContentEditable);
                }(n.type, i)) return;
                UC(n, "_sentryCaptured", !0), i && !i._sentryId && UC(i, "_sentryId", QC());
                const r = "keypress" === n.type ? "input" : n.type;
                (function(e1) {
                    if (e1.type !== TO) return !1;
                    try {
                        if (!e1.target || e1.target._sentryId !== SO) return !1;
                    } catch (e1) {}
                    return !0;
                })(n) || (e1({
                    event: n,
                    name: r,
                    global: t
                }), TO = n.type, SO = i ? i._sentryId : void 0), clearTimeout(EO), EO = Uz.setTimeout(()=>{
                    SO = void 0, TO = void 0;
                }, wO);
            };
        }
        const DO = "__sentry_xhr_v3__";
        function _O() {
            if (!Uz.XMLHttpRequest) return;
            const e1 = XMLHttpRequest.prototype;
            e1.open = new Proxy(e1.open, {
                apply (e1, t, n) {
                    const i = 1e3 * tL(), r = mC(n[0]) ? n[0].toUpperCase() : void 0, a = function(e1) {
                        if (mC(e1)) return e1;
                        try {
                            return e1.toString();
                        } catch (e1) {}
                    }(n[1]);
                    if (!r || !a) return e1.apply(t, n);
                    t[DO] = {
                        method: r,
                        url: a,
                        request_headers: {}
                    }, "POST" === r && a.match(/sentry_key/) && (t.__sentry_own_request__ = !0);
                    const s = ()=>{
                        const e1 = t[DO];
                        if (e1 && 4 === t.readyState) {
                            try {
                                e1.status_code = t.status;
                            } catch (e1) {}
                            Rz("xhr", {
                                endTimestamp: 1e3 * tL(),
                                startTimestamp: i,
                                xhr: t
                            });
                        }
                    };
                    return "onreadystatechange" in t && "function" == typeof t.onreadystatechange ? t.onreadystatechange = new Proxy(t.onreadystatechange, {
                        apply: (e1, t, n)=>(s(), e1.apply(t, n))
                    }) : t.addEventListener("readystatechange", s), t.setRequestHeader = new Proxy(t.setRequestHeader, {
                        apply (e1, t, n) {
                            const [i, r] = n, a = t[DO];
                            return a && mC(i) && mC(r) && (a.request_headers[i.toLowerCase()] = r), e1.apply(t, n);
                        }
                    }), e1.apply(t, n);
                }
            }), e1.send = new Proxy(e1.send, {
                apply (e1, t, n) {
                    const i = t[DO];
                    return i ? (void 0 !== n[0] && (i.body = n[0]), Rz("xhr", {
                        startTimestamp: 1e3 * tL(),
                        xhr: t
                    }), e1.apply(t, n)) : e1.apply(t, n);
                }
            });
        }
        const CO = 100;
        function LO(e1, t) {
            const n = AL(), i = mL();
            if (!n) return;
            const { beforeBreadcrumb: r = null, maxBreadcrumbs: a = CO } = n.getOptions();
            if (a <= 0) return;
            const s = {
                timestamp: eL(),
                ...e1
            }, o = r ? CC(()=>r(s, t)) : s;
            null !== o && (n.emit && n.emit("beforeAddBreadcrumb", o, t), i.addBreadcrumb(o, a));
        }
        function zO() {
            "console" in sC && DC.forEach(function(e1) {
                e1 in sC.console && PC(sC.console, e1, function(t) {
                    return _C[e1] = t, function() {
                        for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                        Rz("console", {
                            args: n,
                            level: e1
                        });
                        const r = _C[e1];
                        r && r.apply(sC.console, n);
                    };
                });
            });
        }
        function OO(e1, t) {
            return !!e1 && "object" == typeof e1 && !!e1[t];
        }
        function RO(e1) {
            return "string" == typeof e1 ? e1 : e1 ? OO(e1, "url") ? e1.url : e1.toString ? e1.toString() : "" : "";
        }
        const PO = [
            "fatal",
            "error",
            "warning",
            "log",
            "info",
            "debug"
        ];
        function UO(e1) {
            return void 0 === e1 ? void 0 : e1 >= 400 && e1 < 500 ? "warning" : e1 >= 500 ? "error" : void 0;
        }
        function jO(e1) {
            if (!e1) return {};
            const t = e1.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
            if (!t) return {};
            const n = t[6] || "", i = t[8] || "";
            return {
                host: t[4],
                path: t[5],
                protocol: t[2],
                search: n,
                hash: i,
                relative: t[5] + n + i
            };
        }
        const kO = function() {
            const e1 = {
                console: !0,
                dom: !0,
                fetch: !0,
                history: !0,
                sentry: !0,
                xhr: !0,
                ...arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
            };
            return {
                name: "Breadcrumbs",
                setup (t) {
                    var n;
                    e1.console && function(e1) {
                        const t = "console";
                        zz(t, e1), Oz(t, zO);
                    }(function(e1) {
                        return function(t) {
                            if (AL() !== e1) return;
                            const n = {
                                category: "console",
                                data: {
                                    arguments: t.args,
                                    logger: "console"
                                },
                                level: (i = t.level, "warn" === i ? "warning" : PO.includes(i) ? i : "log"),
                                message: OC(t.args, " ")
                            };
                            var i;
                            if ("assert" === t.level) {
                                if (!1 !== t.args[0]) return;
                                n.message = `Assertion failed: ${OC(t.args.slice(1), " ") || "console.assert"}`, n.data.arguments = t.args.slice(1);
                            }
                            LO(n, {
                                input: t.args,
                                level: t.level
                            });
                        };
                    }(t)), e1.dom && (n = function(e1, t) {
                        return function(n) {
                            if (AL() !== e1) return;
                            let i, r, a = "object" == typeof t ? t.serializeAttribute : void 0, s = "object" == typeof t && "number" == typeof t.maxStringLength ? t.maxStringLength : void 0;
                            s && s > 1024 && (oO && LC.warn(`\`dom.maxStringLength\` cannot exceed 1024, but a value of ${s} was configured. Sentry will use 1024 instead.`), s = 1024), "string" == typeof a && (a = [
                                a
                            ]);
                            try {
                                const e1 = n.event, t = function(e1) {
                                    return !!e1 && !!e1.target;
                                }(e1) ? e1.target : e1;
                                i = SC(t, {
                                    keyAttrs: a,
                                    maxStringLength: s
                                }), r = function(e1) {
                                    if (!EC.HTMLElement) return null;
                                    let t = e1;
                                    for(let e1 = 0; e1 < 5; e1++){
                                        if (!t) return null;
                                        if (t instanceof HTMLElement) {
                                            if (t.dataset.sentryComponent) return t.dataset.sentryComponent;
                                            if (t.dataset.sentryElement) return t.dataset.sentryElement;
                                        }
                                        t = t.parentNode;
                                    }
                                    return null;
                                }(t);
                            } catch (e1) {
                                i = "<unknown>";
                            }
                            if (0 === i.length) return;
                            const o = {
                                category: `ui.${n.name}`,
                                message: i
                            };
                            r && (o.data = {
                                "ui.component_name": r
                            }), LO(o, {
                                event: n.event,
                                name: n.name,
                                global: n.global
                            });
                        };
                    }(t, e1.dom), zz("dom", n), Oz("dom", IO)), e1.xhr && function(e1) {
                        zz("xhr", e1), Oz("xhr", _O);
                    }(function(e1) {
                        return function(t) {
                            if (AL() !== e1) return;
                            const { startTimestamp: n, endTimestamp: i } = t, r = t.xhr[DO];
                            if (!n || !i || !r) return;
                            const { method: a, url: s, status_code: o, body: l } = r, c = {
                                method: a,
                                url: s,
                                status_code: o
                            }, u = {
                                xhr: t.xhr,
                                input: l,
                                startTimestamp: n,
                                endTimestamp: i
                            };
                            LO({
                                category: "xhr",
                                data: c,
                                type: "http",
                                level: UO(o)
                            }, u);
                        };
                    }(t)), e1.fetch && function(e1) {
                        const t = "fetch";
                        zz(t, e1), Oz(t, ()=>(function(e1) {
                                arguments.length > 1 && void 0 !== arguments[1] && arguments[1] && !function() {
                                    if ("string" == typeof EdgeRuntime) return !0;
                                    if (!Dz()) return !1;
                                    if (_z(Nz.fetch)) return !0;
                                    let e1 = !1;
                                    const t = Nz.document;
                                    if (t && "function" == typeof t.createElement) try {
                                        const n = t.createElement("iframe");
                                        n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e1 = _z(n.contentWindow.fetch)), t.head.removeChild(n);
                                    } catch (e1) {
                                        NC && LC.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e1);
                                    }
                                    return e1;
                                }() || PC(sC, "fetch", function(t) {
                                    return function() {
                                        for(var n = arguments.length, i = new Array(n), r = 0; r < n; r++)i[r] = arguments[r];
                                        const { method: a, url: s } = function(e1) {
                                            if (0 === e1.length) return {
                                                method: "GET",
                                                url: ""
                                            };
                                            if (2 === e1.length) {
                                                const [t, n] = e1;
                                                return {
                                                    url: RO(t),
                                                    method: OO(n, "method") ? String(n.method).toUpperCase() : "GET"
                                                };
                                            }
                                            const t = e1[0];
                                            return {
                                                url: RO(t),
                                                method: OO(t, "method") ? String(t.method).toUpperCase() : "GET"
                                            };
                                        }(i), o = {
                                            args: i,
                                            fetchData: {
                                                method: a,
                                                url: s
                                            },
                                            startTimestamp: 1e3 * tL()
                                        };
                                        e1 || Rz("fetch", {
                                            ...o
                                        });
                                        const l = (new Error).stack;
                                        return t.apply(sC, i).then(async (t)=>(e1 ? e1(t) : Rz("fetch", {
                                                ...o,
                                                endTimestamp: 1e3 * tL(),
                                                response: t
                                            }), t), (e1)=>{
                                            throw Rz("fetch", {
                                                ...o,
                                                endTimestamp: 1e3 * tL(),
                                                error: e1
                                            }), dC(e1) && void 0 === e1.stack && (e1.stack = l, UC(e1, "framesToPop", 1)), e1;
                                        });
                                    };
                                });
                            })(void 0, undefined));
                    }(function(e1) {
                        return function(t) {
                            if (AL() !== e1) return;
                            const { startTimestamp: n, endTimestamp: i } = t;
                            if (i && (!t.fetchData.url.match(/sentry_key/) || "POST" !== t.fetchData.method)) {
                                if (t.error) LO({
                                    category: "fetch",
                                    data: t.fetchData,
                                    level: "error",
                                    type: "http"
                                }, {
                                    data: t.error,
                                    input: t.args,
                                    startTimestamp: n,
                                    endTimestamp: i
                                });
                                else {
                                    const e1 = t.response, r = {
                                        ...t.fetchData,
                                        status_code: e1 && e1.status
                                    }, a = {
                                        input: t.args,
                                        response: e1,
                                        startTimestamp: n,
                                        endTimestamp: i
                                    };
                                    LO({
                                        category: "fetch",
                                        data: r,
                                        type: "http",
                                        level: UO(r.status_code)
                                    }, a);
                                }
                            }
                        };
                    }(t)), e1.history && kz(function(e1) {
                        return function(t) {
                            if (AL() !== e1) return;
                            let n = t.from, i = t.to;
                            const r = jO(MO.location.href);
                            let a = n ? jO(n) : void 0;
                            const s = jO(i);
                            a && a.path || (a = r), r.protocol === s.protocol && r.host === s.host && (i = s.relative), r.protocol === a.protocol && r.host === a.host && (n = a.relative), LO({
                                category: "navigation",
                                data: {
                                    from: n,
                                    to: i
                                }
                            });
                        };
                    }(t)), e1.sentry && t.on("beforeSendEvent", function(e1) {
                        return function(t) {
                            AL() === e1 && LO({
                                category: "sentry." + ("transaction" === t.type ? "transaction" : "event"),
                                event_id: t.event_id,
                                level: t.level,
                                message: YC(t)
                            }, {
                                event: t
                            });
                        };
                    }(t));
                }
            };
        }, BO = [
            "EventTarget",
            "Window",
            "Node",
            "ApplicationCache",
            "AudioTrackList",
            "BroadcastChannel",
            "ChannelMergerNode",
            "CryptoOperation",
            "EventSource",
            "FileReader",
            "HTMLUnknownElement",
            "IDBDatabase",
            "IDBRequest",
            "IDBTransaction",
            "KeyOperation",
            "MediaController",
            "MessagePort",
            "ModalWindow",
            "Notification",
            "SVGElementInstance",
            "Screen",
            "SharedWorker",
            "TextTrack",
            "TextTrackCue",
            "TextTrackList",
            "WebSocket",
            "WebSocketWorker",
            "Worker",
            "XMLHttpRequest",
            "XMLHttpRequestEventTarget",
            "XMLHttpRequestUpload"
        ], FO = function() {
            const e1 = {
                XMLHttpRequest: !0,
                eventTarget: !0,
                requestAnimationFrame: !0,
                setInterval: !0,
                setTimeout: !0,
                ...arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
            };
            return {
                name: "BrowserApiErrors",
                setupOnce () {
                    e1.setTimeout && PC(MO, "setTimeout", HO), e1.setInterval && PC(MO, "setInterval", HO), e1.requestAnimationFrame && PC(MO, "requestAnimationFrame", GO), e1.XMLHttpRequest && "XMLHttpRequest" in MO && PC(XMLHttpRequest.prototype, "send", VO);
                    const t = e1.eventTarget;
                    t && (Array.isArray(t) ? t : BO).forEach(QO);
                }
            };
        };
        function HO(e1) {
            return function() {
                for(var t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                const r = n[0];
                return n[0] = xO(r, {
                    mechanism: {
                        data: {
                            function: TL(e1)
                        },
                        handled: !1,
                        type: "instrument"
                    }
                }), e1.apply(this, n);
            };
        }
        function GO(e1) {
            return function(t) {
                return e1.apply(this, [
                    xO(t, {
                        mechanism: {
                            data: {
                                function: "requestAnimationFrame",
                                handler: TL(e1)
                            },
                            handled: !1,
                            type: "instrument"
                        }
                    })
                ]);
            };
        }
        function VO(e1) {
            return function() {
                const t = this;
                [
                    "onload",
                    "onerror",
                    "onprogress",
                    "onreadystatechange"
                ].forEach((e1)=>{
                    e1 in t && "function" == typeof t[e1] && PC(t, e1, function(t) {
                        const n = {
                            mechanism: {
                                data: {
                                    function: e1,
                                    handler: TL(t)
                                },
                                handled: !1,
                                type: "instrument"
                            }
                        }, i = kC(t);
                        return i && (n.mechanism.data.handler = TL(i)), xO(t, n);
                    });
                });
                for(var n = arguments.length, i = new Array(n), r = 0; r < n; r++)i[r] = arguments[r];
                return e1.apply(this, i);
            };
        }
        function QO(e1) {
            const t = MO, n = t[e1] && t[e1].prototype;
            n && n.hasOwnProperty && n.hasOwnProperty("addEventListener") && (PC(n, "addEventListener", function(t) {
                return function(n, i, r) {
                    try {
                        "function" == typeof i.handleEvent && (i.handleEvent = xO(i.handleEvent, {
                            mechanism: {
                                data: {
                                    function: "handleEvent",
                                    handler: TL(i),
                                    target: e1
                                },
                                handled: !1,
                                type: "instrument"
                            }
                        }));
                    } catch (e1) {}
                    return t.apply(this, [
                        n,
                        xO(i, {
                            mechanism: {
                                data: {
                                    function: "addEventListener",
                                    handler: TL(i),
                                    target: e1
                                },
                                handled: !1,
                                type: "instrument"
                            }
                        }),
                        r
                    ]);
                };
            }), PC(n, "removeEventListener", function(e1) {
                return function(t, n, i) {
                    const r = n;
                    try {
                        const n = r && r.__sentry_wrapped__;
                        n && e1.call(this, t, n, i);
                    } catch (e1) {}
                    return e1.call(this, t, r, i);
                };
            }));
        }
        let WO = null;
        function YO() {
            WO = sC.onerror, sC.onerror = function(e1, t, n, i, r) {
                return Rz("error", {
                    column: i,
                    error: r,
                    line: n,
                    msg: e1,
                    url: t
                }), !(!WO || WO.__SENTRY_LOADER__) && WO.apply(this, arguments);
            }, sC.onerror.__SENTRY_INSTRUMENTED__ = !0;
        }
        let XO = null;
        function ZO() {
            XO = sC.onunhandledrejection, sC.onunhandledrejection = function(e1) {
                return Rz("unhandledrejection", e1), !(XO && !XO.__SENTRY_LOADER__) || XO.apply(this, arguments);
            }, sC.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
        }
        const qO = function() {
            const e1 = {
                onerror: !0,
                onunhandledrejection: !0,
                ...arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
            };
            return {
                name: "GlobalHandlers",
                setupOnce () {
                    Error.stackTraceLimit = 50;
                },
                setup (t) {
                    e1.onerror && (function(e1) {
                        !function() {
                            const t = "error";
                            zz(t, (t)=>{
                                const { stackParser: n, attachStacktrace: i } = JO();
                                if (AL() !== e1 || yO()) return;
                                const { msg: r, url: a, line: s, column: o, error: l } = t, c = function(e1, t, n, i) {
                                    const r = e1.exception = e1.exception || {}, a = r.values = r.values || [], s = a[0] = a[0] || {}, o = s.stacktrace = s.stacktrace || {}, l = o.frames = o.frames || [], c = isNaN(parseInt(i, 10)) ? void 0 : i, u = isNaN(parseInt(n, 10)) ? void 0 : n, h = mC(t) && t.length > 0 ? t : function() {
                                        try {
                                            return EC.document.location.href;
                                        } catch (e1) {
                                            return "";
                                        }
                                    }();
                                    return 0 === l.length && l.push({
                                        colno: c,
                                        filename: h,
                                        function: vL,
                                        in_app: !0,
                                        lineno: u
                                    }), e1;
                                }(gO(n, l || r, void 0, i, !1), a, s, o);
                                c.level = "error", cz(c, {
                                    originalException: l,
                                    mechanism: {
                                        handled: !1,
                                        type: "onerror"
                                    }
                                });
                            }), Oz(t, YO);
                        }();
                    }(t), KO("onerror")), e1.onunhandledrejection && (function(e1) {
                        !function() {
                            const t = "unhandledrejection";
                            zz(t, (t)=>{
                                const { stackParser: n, attachStacktrace: i } = JO();
                                if (AL() !== e1 || yO()) return;
                                const r = function(e1) {
                                    if (MC(e1)) return e1;
                                    try {
                                        if ("reason" in e1) return e1.reason;
                                        if ("detail" in e1 && "reason" in e1.detail) return e1.detail.reason;
                                    } catch (e1) {}
                                    return e1;
                                }(t), a = MC(r) ? {
                                    exception: {
                                        values: [
                                            {
                                                type: "UnhandledRejection",
                                                value: `Non-Error promise rejection captured with value: ${String(r)}`
                                            }
                                        ]
                                    }
                                } : gO(n, r, void 0, i, !0);
                                a.level = "error", cz(a, {
                                    originalException: r,
                                    mechanism: {
                                        handled: !1,
                                        type: "onunhandledrejection"
                                    }
                                });
                            }), Oz(t, ZO);
                        }();
                    }(t), KO("onunhandledrejection"));
                }
            };
        };
        function KO(e1) {
            oO && LC.log(`Global Handler attached: ${e1}`);
        }
        function JO() {
            const e1 = AL();
            return e1 && e1.getOptions() || {
                stackParser: ()=>[],
                attachStacktrace: !1
            };
        }
        const $O = ()=>({
                name: "HttpContext",
                preprocessEvent (e1) {
                    if (!MO.navigator && !MO.location && !MO.document) return;
                    const t = e1.request && e1.request.url || MO.location && MO.location.href, { referrer: n } = MO.document || {}, { userAgent: i } = MO.navigator || {}, r = {
                        ...e1.request && e1.request.headers,
                        ...n && {
                            Referer: n
                        },
                        ...i && {
                            "User-Agent": i
                        }
                    }, a = {
                        ...e1.request,
                        ...t && {
                            url: t
                        },
                        headers: r
                    };
                    e1.request = a;
                }
            });
        function eR(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 250, i = arguments.length > 3 ? arguments[3] : void 0, r = arguments.length > 4 ? arguments[4] : void 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 ? arguments[6] : void 0;
            if (!(a.exception && a.exception.values && s && bC(s.originalException, Error))) return;
            const o = a.exception.values.length > 0 ? a.exception.values[a.exception.values.length - 1] : void 0;
            var l, c;
            o && (a.exception.values = (l = tR(e1, t, r, s.originalException, i, a.exception.values, o, 0), c = n, l.map((e1)=>(e1.value && (e1.value = zC(e1.value, c)), e1))));
        }
        function tR(e1, t, n, i, r, a, s, o) {
            if (a.length >= n + 1) return a;
            let l = [
                ...a
            ];
            if (bC(i[r], Error)) {
                nR(s, o);
                const a = e1(t, i[r]), c = l.length;
                iR(a, r, c, o), l = tR(e1, t, n, i[r], r, [
                    a,
                    ...l
                ], a, c);
            }
            return Array.isArray(i.errors) && i.errors.forEach((i, a)=>{
                if (bC(i, Error)) {
                    nR(s, o);
                    const c = e1(t, i), u = l.length;
                    iR(c, `errors[${a}]`, u, o), l = tR(e1, t, n, i, r, [
                        c,
                        ...l
                    ], c, u);
                }
            }), l;
        }
        function nR(e1, t) {
            e1.mechanism = e1.mechanism || {
                type: "generic",
                handled: !0
            }, e1.mechanism = {
                ...e1.mechanism,
                ..."AggregateError" === e1.type && {
                    is_exception_group: !0
                },
                exception_id: t
            };
        }
        function iR(e1, t, n, i) {
            e1.mechanism = e1.mechanism || {
                type: "generic",
                handled: !0
            }, e1.mechanism = {
                ...e1.mechanism,
                type: "chained",
                source: t,
                exception_id: n,
                parent_id: i
            };
        }
        const rR = function() {
            let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            const t = e1.limit || 5, n = e1.key || "cause";
            return {
                name: "LinkedErrors",
                preprocessEvent (e1, i, r) {
                    const a = r.getOptions();
                    eR(lO, a.stackParser, a.maxValueLength, n, t, e1, i);
                }
            };
        };
        function aR(e1, t, n, i) {
            const r = {
                filename: e1,
                function: "<anonymous>" === t ? vL : t,
                in_app: !0
            };
            return void 0 !== n && (r.lineno = n), void 0 !== i && (r.colno = i), r;
        }
        const sR = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, oR = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, lR = /\((\S*)(?::(\d+))(?::(\d+))\)/, cR = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, uR = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, hR = bL([
            30,
            (e1)=>{
                const t = sR.exec(e1);
                if (t) {
                    const [, e1, n, i] = t;
                    return aR(e1, vL, +n, +i);
                }
                const n = oR.exec(e1);
                if (n) {
                    if (n[2] && 0 === n[2].indexOf("eval")) {
                        const e1 = lR.exec(n[2]);
                        e1 && (n[2] = e1[1], n[3] = e1[2], n[4] = e1[3]);
                    }
                    const [e1, t] = dR(n[1] || vL, n[2]);
                    return aR(t, e1, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
                }
            }
        ], [
            50,
            (e1)=>{
                const t = cR.exec(e1);
                if (t) {
                    if (t[3] && t[3].indexOf(" > eval") > -1) {
                        const e1 = uR.exec(t[3]);
                        e1 && (t[1] = t[1] || "eval", t[3] = e1[1], t[4] = e1[2], t[5] = "");
                    }
                    let e1 = t[3], n = t[1] || vL;
                    return [n, e1] = dR(n, e1), aR(e1, n, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
                }
            }
        ]), dR = (e1, t)=>{
            const n = -1 !== e1.indexOf("safari-extension"), i = -1 !== e1.indexOf("safari-web-extension");
            return n || i ? [
                -1 !== e1.indexOf("@") ? e1.split("@")[0] : vL,
                n ? `safari-extension:${t}` : `safari-web-extension:${t}`
            ] : [
                e1,
                t
            ];
        }, pR = "undefined" == typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__, fR = {};
        function gR(e1) {
            fR[e1] = void 0;
        }
        const mR = 6e4;
        const AR = 64;
        function MR(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e1) {
                const t = [];
                function n(e1) {
                    return t.splice(t.indexOf(e1), 1)[0] || Promise.resolve(void 0);
                }
                return {
                    $: t,
                    add: function(i) {
                        if (!(void 0 === e1 || t.length < e1)) return LL(new $z("Not adding Promise because buffer limit was reached."));
                        const r = i();
                        return -1 === t.indexOf(r) && t.push(r), r.then(()=>n(r)).then(null, ()=>n(r).then(null, ()=>{})), r;
                    },
                    drain: function(e1) {
                        return new zL((n, i)=>{
                            let r = t.length;
                            if (!r) return n(!0);
                            const a = setTimeout(()=>{
                                e1 && e1 > 0 && n(!1);
                            }, e1);
                            t.forEach((e1)=>{
                                CL(e1).then(()=>{
                                    --r || (clearTimeout(a), n(!0));
                                }, i);
                            });
                        });
                    }
                };
            }(e1.bufferSize || AR), i = {};
            return {
                send: function(r) {
                    const a = [];
                    if (Wz(r, (t, n)=>{
                        const r = Kz(n);
                        if (function(e1, t) {
                            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Date.now();
                            return function(e1, t) {
                                return e1[t] || e1.all || 0;
                            }(e1, t) > n;
                        }(i, r)) {
                            const i = vR(t, n);
                            e1.recordDroppedEvent("ratelimit_backoff", r, i);
                        } else a.push(t);
                    }), 0 === a.length) return CL({});
                    const s = Vz(r[0], a), o = (t)=>{
                        Wz(s, (n, i)=>{
                            const r = vR(n, i);
                            e1.recordDroppedEvent(t, Kz(i), r);
                        });
                    };
                    return n.add(()=>t({
                            body: Xz(s)
                        }).then((e1)=>(void 0 !== e1.statusCode && (e1.statusCode < 200 || e1.statusCode >= 300) && OL && LC.warn(`Sentry responded with status code ${e1.statusCode} to sent event.`), i = function(e1, t) {
                                let { statusCode: n, headers: i } = t, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Date.now();
                                const a = {
                                    ...e1
                                }, s = i && i["x-sentry-rate-limits"], o = i && i["retry-after"];
                                if (s) for (const e1 of s.trim().split(",")){
                                    const [t, n, , , i] = e1.split(":", 5), s = parseInt(t, 10), o = 1e3 * (isNaN(s) ? 60 : s);
                                    if (n) for (const e1 of n.split(";"))"metric_bucket" === e1 && i && !i.split(";").includes("custom") || (a[e1] = r + o);
                                    else a.all = r + o;
                                }
                                else o ? a.all = r + function(e1) {
                                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Date.now();
                                    const n = parseInt(`${e1}`, 10);
                                    if (!isNaN(n)) return 1e3 * n;
                                    const i = Date.parse(`${e1}`);
                                    return isNaN(i) ? mR : i - t;
                                }(o, r) : 429 === n && (a.all = r + 6e4);
                                return a;
                            }(i, e1), e1), (e1)=>{
                            throw o("network_error"), e1;
                        })).then((e1)=>e1, (e1)=>{
                        if (e1 instanceof $z) return OL && LC.error("Skipped sending event because buffer is full."), o("queue_overflow"), CL({});
                        throw e1;
                    });
                },
                flush: (e1)=>n.drain(e1)
            };
        }
        function vR(e1, t) {
            if ("event" === t || "transaction" === t) return Array.isArray(e1) ? e1[1] : void 0;
        }
        function yR(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(e1) {
                const t = fR[e1];
                if (t) return t;
                let n = Uz[e1];
                if (_z(n)) return fR[e1] = n.bind(Uz);
                const i = Uz.document;
                if (i && "function" == typeof i.createElement) try {
                    const t = i.createElement("iframe");
                    t.hidden = !0, i.head.appendChild(t);
                    const r = t.contentWindow;
                    r && r[e1] && (n = r[e1]), i.head.removeChild(t);
                } catch (t) {
                    pR && LC.warn(`Could not create sandbox iframe for ${e1} check, bailing to window.${e1}: `, t);
                }
                return n ? fR[e1] = n.bind(Uz) : n;
            }("fetch"), n = 0, i = 0;
            return MR(e1, function(r) {
                const a = r.body.length;
                n += a, i++;
                const s = {
                    body: r.body,
                    method: "POST",
                    referrerPolicy: "origin",
                    headers: e1.headers,
                    keepalive: n <= 6e4 && i < 15,
                    ...e1.fetchOptions
                };
                if (!t) return gR("fetch"), LL("No fetch implementation available");
                try {
                    return t(e1.url, s).then((e1)=>(n -= a, i--, {
                            statusCode: e1.status,
                            headers: {
                                "x-sentry-rate-limits": e1.headers.get("X-Sentry-Rate-Limits"),
                                "retry-after": e1.headers.get("Retry-After")
                            }
                        }));
                } catch (e1) {
                    return gR("fetch"), n -= a, i--, LL(e1);
                }
            });
        }
        function xR() {
            const e1 = function() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const t = {
                    defaultIntegrations: [
                        vz(),
                        wz(),
                        FO(),
                        kO(),
                        qO(),
                        rR(),
                        Ez(),
                        $O()
                    ],
                    release: "string" == typeof __SENTRY_RELEASE__ ? __SENTRY_RELEASE__ : MO.SENTRY_RELEASE && MO.SENTRY_RELEASE.id ? MO.SENTRY_RELEASE.id : void 0,
                    autoSessionTracking: !0,
                    sendClientReports: !0
                };
                return null == e1.defaultIntegrations && delete e1.defaultIntegrations, {
                    ...t,
                    ...e1
                };
            }(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
            if (function() {
                const e1 = void 0 !== MO.window && MO;
                if (!e1) return !1;
                const t = e1[e1.chrome ? "chrome" : "browser"], n = t && t.runtime && t.runtime.id, i = MO.location && MO.location.href || "", r = !!n && MO === MO.top && [
                    "chrome-extension:",
                    "moz-extension:",
                    "ms-browser-extension:",
                    "safari-web-extension:"
                ].some((e1)=>i.startsWith(`${e1}//`)), a = void 0 !== e1.nw;
                return !!n && !r && !a;
            }()) return void CC(()=>{
                console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
            });
            oO && (Dz() || LC.warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill."));
            const t = {
                ...e1,
                stackParser: (n = e1.stackParser || hR, Array.isArray(n) ? bL(...n) : n),
                integrations: gz(e1),
                transport: e1.transport || yR
            };
            var n;
            const i = function(e1, t) {
                !0 === t.debug && (OL ? LC.enable() : CC(()=>{
                    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
                })), gL().update(t.initialScope);
                const n = new e1(t);
                return function(e1) {
                    gL().setClient(e1);
                }(n), n.init(), n;
            }(bO, t);
            return e1.autoSessionTracking && (void 0 !== MO.document ? (uz({
                ignoreDuration: !0
            }), pz(), kz((e1)=>{
                let { from: t, to: n } = e1;
                void 0 !== t && t !== n && (uz({
                    ignoreDuration: !0
                }), pz());
            })) : oO && LC.warn("Session tracking in non-browser environment with @sentry/browser is not supported.")), i;
        }
        const bR = class {
            constructor(e1){
                let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const i = {
                    ...Ji,
                    ...n
                };
                ((e1)=>{
                    e1?.dsn && function(e1) {
                        const n = {
                            ...e1
                        };
                        var i;
                        sO(n, "react"), i = {
                            version: t.version
                        }, mL().setContext("react", i), xR(n);
                    }({
                        tracesSampleRate: 1,
                        replaysSessionSampleRate: .1,
                        replaysOnErrorSampleRate: 1,
                        ...e1
                    });
                })(i.integrations?.sentry);
                const r = document.querySelector(e1);
                if (!r) throw new Error(`\u{41D}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}: ${e1}`);
                r.addEventListener("wheel", (e1)=>e1.preventDefault()), n.width || (i.width = r.offsetWidth), n.height || (i.height = r.offsetHeight), n.panoramaFov && "number" == typeof n.panoramaFov || (i.panoramaFov = Ji.panoramaFov), n.panoramaIcons && "object" == typeof n.panoramaIcons ? i.panoramaIcons = {
                    ...Ji.panoramaIcons,
                    ...n.panoramaIcons
                } : i.panoramaIcons = {
                    ...Ji.panoramaIcons
                }, i.containerElement = r, Ci.setConfig(i), Zi.resize(i), Cy.setCapabilities(i.capabilities), i.resizable && new ResizeObserver(()=>this.onResize()).observe(r), xi.render(t.createElement(rC, null), r);
            }
            get options() {
                return Ci.config;
            }
            get panoramaStore() {
                return LN;
            }
            updateSize(e1) {
                const t = {
                    ...this.options,
                    ...e1
                };
                Ci.setConfig(t), Zi.resize(t);
            }
            onResize() {
                const { offsetWidth: e1, offsetHeight: t } = this.options.containerElement;
                this.updateSize({
                    width: e1,
                    height: t
                });
            }
            on(e1, t) {
                Ci.addEventListener(e1, t);
            }
        };
    })(), $a5056a6656605403$exports = i;
})();



const $8f6a480bb40b134f$var$getScaleButton = ()=>document.querySelector('.widget-tab__panorama-controls-button--scale');
const $8f6a480bb40b134f$var$getRulerButton = ()=>document.querySelector('.widget-tab__panorama-controls-button--ruler');
const $8f6a480bb40b134f$var$getFloorsSelect = ()=>document.querySelector('.floors-select');
const $8f6a480bb40b134f$var$getTabButtons = ()=>document.querySelector('.widget-tab-buttons');
const $8f6a480bb40b134f$var$getButton2D = ()=>document.querySelectorAll('.widget-tab-button')[0];
const $8f6a480bb40b134f$var$getButton3D = ()=>document.querySelectorAll('.widget-tab-button')[1];
const $8f6a480bb40b134f$var$Config = {
    urls: {
        production: 'https://backend.estate.hart-digital.com',
        stage: 'https://backend-stage.estate.hart-digital.com'
    },
    hidePreloaderDelay: 500
};
const $8f6a480bb40b134f$var$hidePreloader = ()=>document.querySelector('.widget-preloader-frame').classList.add('hidden');
const $8f6a480bb40b134f$var$removeButtonsAndHideContainer = ()=>{
    const controlsContainer = document.querySelector('.widget-tab__panorama-controls');
    controlsContainer.style.display = 'none';
};
const $8f6a480bb40b134f$var$start3DTime = ()=>{
    const onUpdate = ()=>{
        const buttons = $8f6a480bb40b134f$var$getTabButtons();
        const floorsSelect = $8f6a480bb40b134f$var$getFloorsSelect();
        const scale = $8f6a480bb40b134f$var$getScaleButton();
        const ruler = $8f6a480bb40b134f$var$getRulerButton();
        console.log(buttons, floorsSelect, scale, ruler);
        if (scale && buttons) {
            buttons.append(scale);
            if (ruler) buttons.append(ruler);
            if (floorsSelect) buttons.append(floorsSelect);
            clearInterval(timer);
        }
    };
    const timer = setInterval(onUpdate, 100);
};
const $8f6a480bb40b134f$var$start2DTime = ()=>{
    const onUpdate = ()=>{
        const buttons = $8f6a480bb40b134f$var$getTabButtons();
        const arrows = document.querySelector('.widget-tab__isometry-arrows');
        if (buttons && arrows) {
            buttons.append(arrows.cloneNode(true));
            $8f6a480bb40b134f$var$copyWidgetEvents();
            clearInterval(timer);
        }
    };
    const timer = setInterval(onUpdate, 100);
};
const $8f6a480bb40b134f$var$copyWidgetEvents = ()=>{
    document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrow--prev').addEventListener('click', ()=>{
        document.querySelector('.widget-tab__rotation .widget-tab__isometry-arrow--prev').click();
        document.querySelector('.widget-tab-buttons span').innerHTML = document.querySelector('.widget-tab__rotation span').innerHTML;
    });
    document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrow--next').addEventListener('click', ()=>{
        document.querySelector('.widget-tab__rotation .widget-tab__isometry-arrow--next').click();
        document.querySelector('.widget-tab-buttons span').innerHTML = document.querySelector('.widget-tab__rotation span').innerHTML;
    });
    document.querySelector('.widget-tab__isometry-button').addEventListener('click', ()=>{
        document.querySelector('.widget-tab-buttons .widget-tab__isometry-arrows').remove();
        $8f6a480bb40b134f$var$start2DTime();
    });
};
const $8f6a480bb40b134f$var$redesignButtons = ()=>{
    $8f6a480bb40b134f$var$start3DTime();
    $8f6a480bb40b134f$var$start2DTime();
    $8f6a480bb40b134f$var$getButton2D().innerHTML = '2D';
    $8f6a480bb40b134f$var$getButton3D().innerHTML = '3D';
    document.addEventListener('click', (e)=>{
        if (e.target.innerHTML === '2D') {
            const buttons = $8f6a480bb40b134f$var$getTabButtons();
            const ruler = $8f6a480bb40b134f$var$getRulerButton();
            const scale = $8f6a480bb40b134f$var$getScaleButton();
            if (ruler) buttons.removeChild(ruler);
            if (scale) buttons.removeChild(scale);
            $8f6a480bb40b134f$var$start3DTime();
        } else if (e.target.innerHTML === '3D') {
            const buttons = $8f6a480bb40b134f$var$getTabButtons();
            const arrows = document.querySelector('.widget-tab__isometry-arrows');
            buttons.removeChild(arrows);
            $8f6a480bb40b134f$var$start2DTime();
        }
    });
};
const $8f6a480bb40b134f$var$getParams = ()=>{
    const { searchParams: searchParams } = new URL(document.location);
    return {
        planId: searchParams.get('id'),
        crmPlanId: searchParams.get('crmPlanId'),
        env: (searchParams.get('env') || 'production').toLowerCase(),
        lang: (searchParams.get('lang') || 'en').toLowerCase(),
        primaryCameraPointId: searchParams.get('primaryCameraPointId')
    };
};
const $8f6a480bb40b134f$var$createWidget = async ()=>{
    const { planId: planId, crmPlanId: crmPlanId, env: env, lang: lang, primaryCameraPointId: primaryCameraPointId } = $8f6a480bb40b134f$var$getParams();
    const apiUrl = $8f6a480bb40b134f$var$Config.urls[env] || $8f6a480bb40b134f$var$Config.urls['production'];
    const widgetApiHandler = new (0, $a5056a6656605403$exports.ApiStore)(apiUrl);
    const planData = crmPlanId ? await widgetApiHandler.loadCrmWidgetData(crmPlanId) : await widgetApiHandler.loadWidgetData(planId);
    const isRuLang = lang === 'ru';
    if (isRuLang) document.getElementById('widget').classList.add('widget-ru');
    const defaultRulerFontSize = 38;
    const options = {
        ...planData.parsed,
        API_URL: apiUrl,
        rotationMode: (0, $a5056a6656605403$exports.rotationModes).DEFAULT,
        tabs: [
            'panorama',
            'rotation'
        ],
        locale: isRuLang ? 'evometaRu' : 'evometa',
        colors: {
            main: '#FFD180',
            mainText: '#252525'
        },
        dictionaryOverrides: {
            floor: '$0',
            floorNumberEndings: {
                1: 'Ground Floor',
                2: 'First Floor',
                3: 'Second Floor'
            },
            'instructions-hint-text': 'The 3D tours are for illustrative purposes only; actual design and measurements may slightly vary'
        },
        floorNumberEndingsVisible: true,
        scales: [
            'x05',
            'x1'
        ],
        scaleButtonType: 'text',
        forceTopViewOnMap: false,
        primaryCameraPointId: primaryCameraPointId,
        designType: 'custom',
        bottombarContent: [
            'ruler',
            'scale',
            'floors'
        ],
        sidebarContent: [],
        tabsButtonsDesign: 'two',
        cursorType: 'circle',
        enableCursorPulse: false,
        pointHoverScale: 1.5,
        movementType: 'intraroom',
        enableDoorVisibility: true,
        rulerOptions: {
            fontSize: defaultRulerFontSize * 2
        },
        linkOptions: {
            enablePulse: true,
            pulseSpeed: 0.6
        },
        integrations: {
            sentry: {
                dsn: 'https://62f653a9fc5368353dd83fba4017f1dd@sentry.hart-digital.com/16'
            }
        }
    };
    new (0, $a5056a6656605403$exports.Widget)('#widget', options);
};
$8f6a480bb40b134f$var$createWidget().then(()=>{
    $8f6a480bb40b134f$var$redesignButtons();
    setTimeout($8f6a480bb40b134f$var$hidePreloader, $8f6a480bb40b134f$var$Config.hidePreloaderDelay);
}).catch((e)=>{
    $8f6a480bb40b134f$var$hidePreloader();
    const errorMessage = document.querySelector('.error-message');
    if (errorMessage) errorMessage.innerHTML = e.message;
});


//# sourceMappingURL=index.95e6e749.js.map
